﻿// START NOSONAR
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.6.2.0 (NJsonSchema v10.1.23.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// @ts-nocheck

import { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IApplicationAreasClient {
    getApplicationAreasByIds(ids: string[], cancelToken?: CancelToken): Promise<ApplicationArea[]>;
}

export class ApplicationAreasClient implements IApplicationAreasClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    getApplicationAreasByIds(ids: string[], cancelToken?: CancelToken): Promise<ApplicationArea[]> {
        const $url = `${this.baseUrl}/api/ApplicationAreas/GetByIds`;

        const options_: AxiosRequestConfig = {
            data: ids,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IChartClient {
    searchPost(data: any, cancelToken?: CancelToken): Promise<FileResponse>;
    getById(data: any, cancelToken?: CancelToken): Promise<ChartResponse>;
    searchById(data: any, cancelToken?: CancelToken): Promise<ChartResponse>;
}

export class ChartClient implements IChartClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    searchPost(data: any, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/Chart`;

        const options_: AxiosRequestConfig = {
            data: data,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    getById(data: any, cancelToken?: CancelToken): Promise<ChartResponse> {
        const $url = `${this.baseUrl}/api/Chart/getById`;

        const options_: AxiosRequestConfig = {
            data: data,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    searchById(data: any, cancelToken?: CancelToken): Promise<ChartResponse> {
        const $url = `${this.baseUrl}/api/Chart/searchById`;

        const options_: AxiosRequestConfig = {
            data: data,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IMultiSelectEntityLookupClient {
    getResultByLookupEntity(universe: string, entity: string, query: string, maxResultSize: number, cancelToken?: CancelToken): Promise<MultiSelectEntityLookup[]>;
    getResultByLookupEntityWithTeamType(universe: string, entity: string, query: string, maxResultSize: number, teamType: TeamType | null | undefined, cancelToken?: CancelToken): Promise<MultiSelectEntityLookup[]>;
    getResultByLookupEntityWithTeamTypeActiveOnly(universe: string, entity: string, query: string, maxResultSize: number, teamType: TeamType | null | undefined, cancelToken?: CancelToken): Promise<MultiSelectEntityLookup[]>;
    getResultByEntityIds(universe: string, entity: string, entityIds: string[], cancelToken?: CancelToken): Promise<MultiSelectEntityLookup[]>;
}

export class MultiSelectEntityLookupClient implements IMultiSelectEntityLookupClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    getResultByLookupEntity(universe: string, entity: string, query: string, maxResultSize: number, cancelToken?: CancelToken): Promise<MultiSelectEntityLookup[]> {
        if (universe === undefined || universe === null) {
            throw new Error("The parameter 'universe' must be defined.");
        }
        if (entity === undefined || entity === null) {
            throw new Error("The parameter 'entity' must be defined.");
        }
        if (query === undefined || query === null) {
            throw new Error("The parameter 'query' must be defined.");
        }
        if (maxResultSize === undefined || maxResultSize === null) {
            throw new Error("The parameter 'maxResultSize' must be defined.");
        }
        
        const $url = `${this.baseUrl}/api/MultiSelectEntityLookup/GetResultByLookupEntity/${encodeURIComponent(universe)}/${encodeURIComponent(entity)}/${encodeURIComponent(query)}/${encodeURIComponent(maxResultSize)}`;

        const options_: AxiosRequestConfig = {
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    getResultByLookupEntityWithTeamType(universe: string, entity: string, query: string, maxResultSize: number, teamType: TeamType | null | undefined, cancelToken?: CancelToken): Promise<MultiSelectEntityLookup[]> {
        if (universe === undefined || universe === null) {
            throw new Error("The parameter 'universe' must be defined.");
        }
        if (entity === undefined || entity === null) {
            throw new Error("The parameter 'entity' must be defined.");
        }
        if (query === undefined || query === null) {
            throw new Error("The parameter 'query' must be defined.");
        }
        if (maxResultSize === undefined || maxResultSize === null) {
            throw new Error("The parameter 'maxResultSize' must be defined.");
        }
        
        
        const $url = `${this.baseUrl}/api/MultiSelectEntityLookup/GetResultByLookupEntityWithTeamType/${encodeURIComponent(universe)}/${encodeURIComponent(entity)}/${encodeURIComponent(query)}/${encodeURIComponent(maxResultSize)}`;
        
        const params = {
            teamType,
        }

        const options_: AxiosRequestConfig = {
            params,
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    getResultByLookupEntityWithTeamTypeActiveOnly(universe: string, entity: string, query: string, maxResultSize: number, teamType: TeamType | null | undefined, cancelToken?: CancelToken): Promise<MultiSelectEntityLookup[]> {
        if (universe === undefined || universe === null) {
            throw new Error("The parameter 'universe' must be defined.");
        }
        if (entity === undefined || entity === null) {
            throw new Error("The parameter 'entity' must be defined.");
        }
        if (query === undefined || query === null) {
            throw new Error("The parameter 'query' must be defined.");
        }
        if (maxResultSize === undefined || maxResultSize === null) {
            throw new Error("The parameter 'maxResultSize' must be defined.");
        }
        
        
        const $url = `${this.baseUrl}/api/MultiSelectEntityLookup/GetResultByLookupEntityWithTeamTypeActiveOnly/${encodeURIComponent(universe)}/${encodeURIComponent(entity)}/${encodeURIComponent(query)}/${encodeURIComponent(maxResultSize)}`;
        
        const params = {
            teamType,
        }

        const options_: AxiosRequestConfig = {
            params,
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    getResultByEntityIds(universe: string, entity: string, entityIds: string[], cancelToken?: CancelToken): Promise<MultiSelectEntityLookup[]> {
        if (universe === undefined || universe === null) {
            throw new Error("The parameter 'universe' must be defined.");
        }
        if (entity === undefined || entity === null) {
            throw new Error("The parameter 'entity' must be defined.");
        }
        
        const $url = `${this.baseUrl}/api/MultiSelectEntityLookup/GetResultByEntityIds/${encodeURIComponent(universe)}/${encodeURIComponent(entity)}`;

        const options_: AxiosRequestConfig = {
            data: entityIds,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ISavedChartClient {
    getAll(cancelToken?: CancelToken): Promise<FileResponse>;
    create(data: any, cancelToken?: CancelToken): Promise<void>;
    getAllFormatted(cancelToken?: CancelToken): Promise<SavedChartFormatted[]>;
    get(id: string, cancelToken?: CancelToken): Promise<FileResponse>;
    update(id: string, data: any, cancelToken?: CancelToken): Promise<void>;
    delete(id: string, cancelToken?: CancelToken): Promise<void>;
    getOmitAccessControl(id: string, source: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse>;
    getSavedChartsByIndex(universe: string, dataType: string | null | undefined, take: number | undefined, currentSelectedItems: number | undefined, value: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse>;
}

export class SavedChartClient implements ISavedChartClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    getAll(cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/SavedChart`;

        const options_: AxiosRequestConfig = {
            responseType: 'blob',
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    create(data: any, cancelToken?: CancelToken): Promise<void> {
        const $url = `${this.baseUrl}/api/SavedChart`;

        const options_: AxiosRequestConfig = {
            data: data,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    getAllFormatted(cancelToken?: CancelToken): Promise<SavedChartFormatted[]> {
        const $url = `${this.baseUrl}/api/SavedChart/GetAllFormatted`;

        const options_: AxiosRequestConfig = {
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    get(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        if (id === undefined || id === null) {
            throw new Error("The parameter 'id' must be defined.");
        }
        
        const $url = `${this.baseUrl}/api/SavedChart/${encodeURIComponent(id)}`;

        const options_: AxiosRequestConfig = {
            responseType: 'blob',
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    update(id: string, data: any, cancelToken?: CancelToken): Promise<void> {
        if (id === undefined || id === null) {
            throw new Error("The parameter 'id' must be defined.");
        }
        
        const $url = `${this.baseUrl}/api/SavedChart/${encodeURIComponent(id)}`;

        const options_: AxiosRequestConfig = {
            data: data,
            method: 'PUT',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    delete(id: string, cancelToken?: CancelToken): Promise<void> {
        if (id === undefined || id === null) {
            throw new Error("The parameter 'id' must be defined.");
        }
        
        const $url = `${this.baseUrl}/api/SavedChart/${encodeURIComponent(id)}`;

        const options_: AxiosRequestConfig = {
            method: 'DELETE',
            url: $url,
            headers: {
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    getOmitAccessControl(id: string, source: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        if (id === undefined || id === null) {
            throw new Error("The parameter 'id' must be defined.");
        }
        
        
        const $url = `${this.baseUrl}/api/SavedChart/GetOmitAccessControl/${encodeURIComponent(id)}`;
        
        const params = {
            source,
        }

        const options_: AxiosRequestConfig = {
            params,
            responseType: 'blob',
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    getSavedChartsByIndex(universe: string, dataType: string | null | undefined, take: number | undefined, currentSelectedItems: number | undefined, value: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        if (universe === undefined || universe === null) {
            throw new Error("The parameter 'universe' must be defined.");
        }
        
        if (take === null) {
            throw new Error("The parameter 'take' cannot be null.");
        }
        if (currentSelectedItems === null) {
            throw new Error("The parameter 'currentSelectedItems' cannot be null.");
        }
        
        const $url = `${this.baseUrl}/api/SavedChart/GetSavedChartsByIndex/${encodeURIComponent(universe)}`;
        
        const params = {
            dataType,
            take,
            currentSelectedItems,
            value,
        }

        const options_: AxiosRequestConfig = {
            params,
            responseType: 'blob',
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }
}

export interface ISavedQueryClient {
    getAll(cancelToken?: CancelToken): Promise<FileResponse>;
    create(data: any, cancelToken?: CancelToken): Promise<void>;
    getAllFormatted(cancelToken?: CancelToken): Promise<SavedQueryFormatted[]>;
    get(id: string, cancelToken?: CancelToken): Promise<FileResponse>;
    update(id: string, data: any, cancelToken?: CancelToken): Promise<void>;
    delete(id: string, cancelToken?: CancelToken): Promise<void>;
    getOmitAccessControl(id: string, source: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse>;
    getSavedQueries(universe: string, resultType: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param resultType (optional) 
     * @param take (optional) 
     * @param currentSelectedItems (optional) 
     * @param value (optional) 
     * @param applicationArea (optional) 
     * @deprecated
     */
    getSavedQueriesByIndex(universe: string, resultType: string | null | undefined, take: number | undefined, currentSelectedItems: number | undefined, value: string | null | undefined, applicationArea: string | null | undefined, cancelToken?: CancelToken): Promise<SavedQueryResult[]>;
    getSavedQueriesByApplicationAreaIndex(universe: string, resultType: string | null | undefined, take: number | undefined, currentSelectedItems: number | undefined, value: string | null | undefined, applicationAreaId: string | null | undefined, cancelToken?: CancelToken): Promise<SavedQueryResult[]>;
    getDefaultStartPageSystemSavedQuery(universe: string, resultType: string, applicationAreaName: string, cancelToken?: CancelToken): Promise<DefaultStartPageSystemSavedQuery>;
    getSavedQueriesByApplicationAreaId(applicationAreaId: string, cancelToken?: CancelToken): Promise<FileResponse>;
}

export class SavedQueryClient implements ISavedQueryClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    getAll(cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/SavedQuery`;

        const options_: AxiosRequestConfig = {
            responseType: 'blob',
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    create(data: any, cancelToken?: CancelToken): Promise<void> {
        const $url = `${this.baseUrl}/api/SavedQuery`;

        const options_: AxiosRequestConfig = {
            data: data,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    getAllFormatted(cancelToken?: CancelToken): Promise<SavedQueryFormatted[]> {
        const $url = `${this.baseUrl}/api/SavedQuery/GetAllFormatted`;

        const options_: AxiosRequestConfig = {
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    get(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        if (id === undefined || id === null) {
            throw new Error("The parameter 'id' must be defined.");
        }
        
        const $url = `${this.baseUrl}/api/SavedQuery/${encodeURIComponent(id)}`;

        const options_: AxiosRequestConfig = {
            responseType: 'blob',
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    update(id: string, data: any, cancelToken?: CancelToken): Promise<void> {
        if (id === undefined || id === null) {
            throw new Error("The parameter 'id' must be defined.");
        }
        
        const $url = `${this.baseUrl}/api/SavedQuery/${encodeURIComponent(id)}`;

        const options_: AxiosRequestConfig = {
            data: data,
            method: 'PUT',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    delete(id: string, cancelToken?: CancelToken): Promise<void> {
        if (id === undefined || id === null) {
            throw new Error("The parameter 'id' must be defined.");
        }
        
        const $url = `${this.baseUrl}/api/SavedQuery/${encodeURIComponent(id)}`;

        const options_: AxiosRequestConfig = {
            method: 'DELETE',
            url: $url,
            headers: {
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    getOmitAccessControl(id: string, source: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        if (id === undefined || id === null) {
            throw new Error("The parameter 'id' must be defined.");
        }
        
        
        const $url = `${this.baseUrl}/api/SavedQuery/GetOmitAccessControl/${encodeURIComponent(id)}`;
        
        const params = {
            source,
        }

        const options_: AxiosRequestConfig = {
            params,
            responseType: 'blob',
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    getSavedQueries(universe: string, resultType: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        if (universe === undefined || universe === null) {
            throw new Error("The parameter 'universe' must be defined.");
        }
        
        
        const $url = `${this.baseUrl}/api/SavedQuery/GetSavedQueries/${encodeURIComponent(universe)}`;
        
        const params = {
            resultType,
        }

        const options_: AxiosRequestConfig = {
            params,
            responseType: 'blob',
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param resultType (optional) 
     * @param take (optional) 
     * @param currentSelectedItems (optional) 
     * @param value (optional) 
     * @param applicationArea (optional) 
     * @deprecated
     */
    getSavedQueriesByIndex(universe: string, resultType: string | null | undefined, take: number | undefined, currentSelectedItems: number | undefined, value: string | null | undefined, applicationArea: string | null | undefined, cancelToken?: CancelToken): Promise<SavedQueryResult[]> {
        if (universe === undefined || universe === null) {
            throw new Error("The parameter 'universe' must be defined.");
        }
        
        if (take === null) {
            throw new Error("The parameter 'take' cannot be null.");
        }
        if (currentSelectedItems === null) {
            throw new Error("The parameter 'currentSelectedItems' cannot be null.");
        }
        
        const $url = `${this.baseUrl}/api/SavedQuery/GetSavedQueriesByIndex/${encodeURIComponent(universe)}`;
        
        const params = {
            resultType,
            take,
            currentSelectedItems,
            value,
            applicationArea,
        }

        const options_: AxiosRequestConfig = {
            params,
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    getSavedQueriesByApplicationAreaIndex(universe: string, resultType: string | null | undefined, take: number | undefined, currentSelectedItems: number | undefined, value: string | null | undefined, applicationAreaId: string | null | undefined, cancelToken?: CancelToken): Promise<SavedQueryResult[]> {
        if (universe === undefined || universe === null) {
            throw new Error("The parameter 'universe' must be defined.");
        }
        
        if (take === null) {
            throw new Error("The parameter 'take' cannot be null.");
        }
        if (currentSelectedItems === null) {
            throw new Error("The parameter 'currentSelectedItems' cannot be null.");
        }
        
        const $url = `${this.baseUrl}/api/SavedQuery/GetSavedQueriesByIndexByApplicationId/${encodeURIComponent(universe)}`;
        
        const params = {
            resultType,
            take,
            currentSelectedItems,
            value,
            applicationAreaId,
        }

        const options_: AxiosRequestConfig = {
            params,
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    getDefaultStartPageSystemSavedQuery(universe: string, resultType: string, applicationAreaName: string, cancelToken?: CancelToken): Promise<DefaultStartPageSystemSavedQuery> {
        if (universe === undefined || universe === null) {
            throw new Error("The parameter 'universe' must be defined.");
        }
        if (resultType === undefined || resultType === null) {
            throw new Error("The parameter 'resultType' must be defined.");
        }
        if (applicationAreaName === undefined || applicationAreaName === null) {
            throw new Error("The parameter 'applicationAreaName' must be defined.");
        }
        
        const $url = `${this.baseUrl}/api/SavedQuery/GetDefaultStartPageSystemSavedQuery/${encodeURIComponent(universe)}/${encodeURIComponent(resultType)}/${encodeURIComponent(applicationAreaName)}`;

        const options_: AxiosRequestConfig = {
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    getSavedQueriesByApplicationAreaId(applicationAreaId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        if (applicationAreaId === undefined || applicationAreaId === null) {
            throw new Error("The parameter 'applicationAreaId' must be defined.");
        }
        
        const $url = `${this.baseUrl}/api/SavedQuery/GetSavedQueriesByApplicationAreaId/${encodeURIComponent(applicationAreaId)}`;

        const options_: AxiosRequestConfig = {
            responseType: 'blob',
            method: 'GET',
            url: $url,
            headers: {
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }
}

export interface ITranscriptionClient {
    /**
     * @param command QueuePartialTranscriptionRequestV2
     * @return QueuePartialTranscriptionResponseV2
     */
    queuePartialTranscription(command: QueuePartialTranscriptionRequestV2, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetTranscriptionRequest
     * @return GetTranscriptionResponse
     */
    getTranscription(query: GetTranscriptionRequest, cancelToken?: CancelToken): Promise<GetTranscriptionResponse>;
    /**
     * @param query GetTranscriptionStatusRequest
     * @return GetTranscriptionStatusResponse
     */
    getTranscriptionStatus(query: GetTranscriptionStatusRequest, cancelToken?: CancelToken): Promise<GetTranscriptionStatusResponse>;
}

export class TranscriptionClient implements ITranscriptionClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command QueuePartialTranscriptionRequestV2
     * @return QueuePartialTranscriptionResponseV2
     */
    queuePartialTranscription(command: QueuePartialTranscriptionRequestV2, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/transcription/commands/queuepartialtranscription`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTranscriptionRequest
     * @return GetTranscriptionResponse
     */
    getTranscription(query: GetTranscriptionRequest, cancelToken?: CancelToken): Promise<GetTranscriptionResponse> {
        const $url = `${this.baseUrl}/api/transcription/queries/gettranscription`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTranscriptionStatusRequest
     * @return GetTranscriptionStatusResponse
     */
    getTranscriptionStatus(query: GetTranscriptionStatusRequest, cancelToken?: CancelToken): Promise<GetTranscriptionStatusResponse> {
        const $url = `${this.baseUrl}/api/transcription/queries/gettranscriptionstatus`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ISurveyClient {
    /**
     * @param command CreateQuestionnaireForFasitEntityRequest
     * @return CreateQuestionnaireForFasitEntityResponse
     */
    createQuestionnaireForFasitEntity(command: CreateQuestionnaireForFasitEntityRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @return GetAllQuestionnairesResponse
     */
    getAllQuestionnaires(cancelToken?: CancelToken): Promise<GetAllQuestionnairesResponse>;
    /**
     * @param query GetQuestionnairesForOfferIdRequest
     * @return GetQuestionnairesForOfferIdResponse
     */
    getQuestionnairesForOfferId(query: GetQuestionnairesForOfferIdRequest, cancelToken?: CancelToken): Promise<GetQuestionnairesForOfferIdResponse>;
}

export class SurveyClient implements ISurveyClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateQuestionnaireForFasitEntityRequest
     * @return CreateQuestionnaireForFasitEntityResponse
     */
    createQuestionnaireForFasitEntity(command: CreateQuestionnaireForFasitEntityRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/survey/commands/createquestionnaireforfasitentity`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAllQuestionnairesResponse
     */
    getAllQuestionnaires(cancelToken?: CancelToken): Promise<GetAllQuestionnairesResponse> {
        const $url = `${this.baseUrl}/api/survey/queries/getallquestionnaires`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetQuestionnairesForOfferIdRequest
     * @return GetQuestionnairesForOfferIdResponse
     */
    getQuestionnairesForOfferId(query: GetQuestionnairesForOfferIdRequest, cancelToken?: CancelToken): Promise<GetQuestionnairesForOfferIdResponse> {
        const $url = `${this.baseUrl}/api/survey/queries/getquestionnairesforofferid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IServiceProviderUnitUseOfForceClient {
    /**
     * @param command AttachUseOfForceReportActionPlanRequest
     * @return AttachUseOfForceReportActionPlanResponse
     */
    attachUseOfForceReportActionPlan(command: AttachUseOfForceReportActionPlanRequest, cancelToken?: CancelToken): Promise<AttachUseOfForceReportActionPlanResponse>;
    /**
     * @param command CreateUseOfForceReportRequest
     * @return CreateUseOfForceReportResponse
     */
    createUseOfForceReport(command: CreateUseOfForceReportRequest, cancelToken?: CancelToken): Promise<CreateUseOfForceReportResponse>;
    /**
     * @param command DeleteUseOfForceReportDraftRequest
     * @return DeleteUseOfForceReportDraftResponse
     */
    deleteUseOfForceReportDraft(command: DeleteUseOfForceReportDraftRequest, cancelToken?: CancelToken): Promise<DeleteUseOfForceReportDraftResponse>;
    /**
     * @param command RegisterUseOfForceReportSendingRequest
     * @return RegisterUseOfForceReportSendingResponse
     */
    registerUseOfForceReportSending(command: RegisterUseOfForceReportSendingRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceReportSendingResponse>;
    /**
     * @param command RemoveUseOfForceReportActionPlanRequest
     * @return RemoveUseOfForceReportActionPlanResponse
     */
    removeUseOfForceReportActionPlan(command: RemoveUseOfForceReportActionPlanRequest, cancelToken?: CancelToken): Promise<RemoveUseOfForceReportActionPlanResponse>;
    /**
     * @param command UpdateUseOfForceReportRequest
     * @return UpdateUseOfForceReportResponse
     */
    updateUseOfForceReport(command: UpdateUseOfForceReportRequest, cancelToken?: CancelToken): Promise<UpdateUseOfForceReportResponse>;
    /**
     * @param query GetUseOfForceIncidentsForServiceProviderUnitRequest
     * @return GetUseOfForceIncidentsForServiceProviderUnitResponse
     */
    getUseOfForceIncidentsForServiceProviderUnit(query: GetUseOfForceIncidentsForServiceProviderUnitRequest, cancelToken?: CancelToken): Promise<GetUseOfForceIncidentsForServiceProviderUnitResponse>;
    /**
     * @param query GetUseOfForceReportActionPlanRequest
     * @return FileResponse
     */
    getUseOfForceReportActionPlan(query: GetUseOfForceReportActionPlanRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetUseOfForceReportForServiceProviderUnitRequest
     * @return GetUseOfForceReportForServiceProviderUnitResponse
     */
    getUseOfForceReportForServiceProviderUnit(query: GetUseOfForceReportForServiceProviderUnitRequest, cancelToken?: CancelToken): Promise<GetUseOfForceReportForServiceProviderUnitResponse>;
    /**
     * @param query GetUseOfForceReportPdfRequest
     * @return FileResponse
     */
    getUseOfForceReportPdf(query: GetUseOfForceReportPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
}

export class ServiceProviderUnitUseOfForceClient implements IServiceProviderUnitUseOfForceClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command AttachUseOfForceReportActionPlanRequest
     * @return AttachUseOfForceReportActionPlanResponse
     */
    attachUseOfForceReportActionPlan(command: AttachUseOfForceReportActionPlanRequest, cancelToken?: CancelToken): Promise<AttachUseOfForceReportActionPlanResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/useofforce/commands/attachuseofforcereportactionplan`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateUseOfForceReportRequest
     * @return CreateUseOfForceReportResponse
     */
    createUseOfForceReport(command: CreateUseOfForceReportRequest, cancelToken?: CancelToken): Promise<CreateUseOfForceReportResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/useofforce/commands/createuseofforcereport`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteUseOfForceReportDraftRequest
     * @return DeleteUseOfForceReportDraftResponse
     */
    deleteUseOfForceReportDraft(command: DeleteUseOfForceReportDraftRequest, cancelToken?: CancelToken): Promise<DeleteUseOfForceReportDraftResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/useofforce/commands/deleteuseofforcereportdraft`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterUseOfForceReportSendingRequest
     * @return RegisterUseOfForceReportSendingResponse
     */
    registerUseOfForceReportSending(command: RegisterUseOfForceReportSendingRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceReportSendingResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/useofforce/commands/registeruseofforcereportsending`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RemoveUseOfForceReportActionPlanRequest
     * @return RemoveUseOfForceReportActionPlanResponse
     */
    removeUseOfForceReportActionPlan(command: RemoveUseOfForceReportActionPlanRequest, cancelToken?: CancelToken): Promise<RemoveUseOfForceReportActionPlanResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/useofforce/commands/removeuseofforcereportactionplan`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateUseOfForceReportRequest
     * @return UpdateUseOfForceReportResponse
     */
    updateUseOfForceReport(command: UpdateUseOfForceReportRequest, cancelToken?: CancelToken): Promise<UpdateUseOfForceReportResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/useofforce/commands/updateuseofforcereport`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceIncidentsForServiceProviderUnitRequest
     * @return GetUseOfForceIncidentsForServiceProviderUnitResponse
     */
    getUseOfForceIncidentsForServiceProviderUnit(query: GetUseOfForceIncidentsForServiceProviderUnitRequest, cancelToken?: CancelToken): Promise<GetUseOfForceIncidentsForServiceProviderUnitResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/useofforce/queries/getuseofforceincidentsforserviceproviderunit`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceReportActionPlanRequest
     * @return FileResponse
     */
    getUseOfForceReportActionPlan(query: GetUseOfForceReportActionPlanRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/useofforce/queries/getuseofforcereportactionplan`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceReportForServiceProviderUnitRequest
     * @return GetUseOfForceReportForServiceProviderUnitResponse
     */
    getUseOfForceReportForServiceProviderUnit(query: GetUseOfForceReportForServiceProviderUnitRequest, cancelToken?: CancelToken): Promise<GetUseOfForceReportForServiceProviderUnitResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/useofforce/queries/getuseofforcereportforserviceproviderunit`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceReportPdfRequest
     * @return FileResponse
     */
    getUseOfForceReportPdf(query: GetUseOfForceReportPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/useofforce/queries/getuseofforcereportpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }
}

export interface IServiceProviderUnitCalendarClient {
    /**
     * @param command CancelServiceProviderUnitCalendarEventRequest
     * @return CancelServiceProviderUnitCalendarEventResponse
     */
    cancelServiceProviderUnitCalendarEvent(command: CancelServiceProviderUnitCalendarEventRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CancelServiceProviderUnitCalendarSeriesOccurrenceRequest
     * @return CancelServiceProviderUnitCalendarSeriesOccurrenceResponse
     */
    cancelServiceProviderUnitCalendarSeriesOccurrence(command: CancelServiceProviderUnitCalendarSeriesOccurrenceRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateServiceProviderUnitCalendarEventRequest
     * @return CreateServiceProviderUnitCalendarEventResponse
     */
    createServiceProviderUnitCalendarEvent(command: CreateServiceProviderUnitCalendarEventRequest, cancelToken?: CancelToken): Promise<CreateServiceProviderUnitCalendarEventResponse>;
    /**
     * @param command DeleteServiceProviderUnitCalendarEventRequest
     * @return DeleteServiceProviderUnitCalendarEventResponse
     */
    deleteServiceProviderUnitCalendarEvent(command: DeleteServiceProviderUnitCalendarEventRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteServiceProviderUnitCalendarSeriesOccurrenceRequest
     * @return DeleteServiceProviderUnitCalendarSeriesOccurrenceResponse
     */
    deleteServiceProviderUnitCalendarSeriesOccurrence(command: DeleteServiceProviderUnitCalendarSeriesOccurrenceRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command MarkServiceProviderUnitCalendarEventDoneRequest
     * @return MarkServiceProviderUnitCalendarEventDoneResponse
     */
    markServiceProviderUnitCalendarEventDone(command: MarkServiceProviderUnitCalendarEventDoneRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command MarkServiceProviderUnitCalendarSeriesOccurrenceDoneRequest
     * @return MarkServiceProviderUnitCalendarSeriesOccurrenceDoneResponse
     */
    markServiceProviderUnitCalendarSeriesOccurrenceDone(command: MarkServiceProviderUnitCalendarSeriesOccurrenceDoneRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UnmarkServiceProviderUnitCalendarEventRequest
     * @return UnmarkServiceProviderUnitCalendarEventResponse
     */
    unmarkServiceProviderUnitCalendarEvent(command: UnmarkServiceProviderUnitCalendarEventRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateServiceProviderUnitCalendarEventRequest
     * @return UpdateServiceProviderUnitCalendarEventResponse
     */
    updateServiceProviderUnitCalendarEvent(command: UpdateServiceProviderUnitCalendarEventRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateServiceProviderUnitCalendarSeriesOccurrenceRequest
     * @return UpdateServiceProviderUnitCalendarSeriesOccurrenceResponse
     */
    updateServiceProviderUnitCalendarSeriesOccurrence(command: UpdateServiceProviderUnitCalendarSeriesOccurrenceRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetServiceProviderUnitCalendarEventsRequest
     * @return GetServiceProviderUnitCalendarEventsResponse
     */
    getServiceProviderUnitCalendarEvents(query: GetServiceProviderUnitCalendarEventsRequest, cancelToken?: CancelToken): Promise<GetServiceProviderUnitCalendarEventsResponse>;
}

export class ServiceProviderUnitCalendarClient implements IServiceProviderUnitCalendarClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CancelServiceProviderUnitCalendarEventRequest
     * @return CancelServiceProviderUnitCalendarEventResponse
     */
    cancelServiceProviderUnitCalendarEvent(command: CancelServiceProviderUnitCalendarEventRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/calendar/commands/cancelserviceproviderunitcalendarevent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CancelServiceProviderUnitCalendarSeriesOccurrenceRequest
     * @return CancelServiceProviderUnitCalendarSeriesOccurrenceResponse
     */
    cancelServiceProviderUnitCalendarSeriesOccurrence(command: CancelServiceProviderUnitCalendarSeriesOccurrenceRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/calendar/commands/cancelserviceproviderunitcalendarseriesoccurrence`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateServiceProviderUnitCalendarEventRequest
     * @return CreateServiceProviderUnitCalendarEventResponse
     */
    createServiceProviderUnitCalendarEvent(command: CreateServiceProviderUnitCalendarEventRequest, cancelToken?: CancelToken): Promise<CreateServiceProviderUnitCalendarEventResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/calendar/commands/createserviceproviderunitcalendarevent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteServiceProviderUnitCalendarEventRequest
     * @return DeleteServiceProviderUnitCalendarEventResponse
     */
    deleteServiceProviderUnitCalendarEvent(command: DeleteServiceProviderUnitCalendarEventRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/calendar/commands/deleteserviceproviderunitcalendarevent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteServiceProviderUnitCalendarSeriesOccurrenceRequest
     * @return DeleteServiceProviderUnitCalendarSeriesOccurrenceResponse
     */
    deleteServiceProviderUnitCalendarSeriesOccurrence(command: DeleteServiceProviderUnitCalendarSeriesOccurrenceRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/calendar/commands/deleteserviceproviderunitcalendarseriesoccurrence`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command MarkServiceProviderUnitCalendarEventDoneRequest
     * @return MarkServiceProviderUnitCalendarEventDoneResponse
     */
    markServiceProviderUnitCalendarEventDone(command: MarkServiceProviderUnitCalendarEventDoneRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/calendar/commands/markserviceproviderunitcalendareventdone`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command MarkServiceProviderUnitCalendarSeriesOccurrenceDoneRequest
     * @return MarkServiceProviderUnitCalendarSeriesOccurrenceDoneResponse
     */
    markServiceProviderUnitCalendarSeriesOccurrenceDone(command: MarkServiceProviderUnitCalendarSeriesOccurrenceDoneRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/calendar/commands/markserviceproviderunitcalendarseriesoccurrencedone`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UnmarkServiceProviderUnitCalendarEventRequest
     * @return UnmarkServiceProviderUnitCalendarEventResponse
     */
    unmarkServiceProviderUnitCalendarEvent(command: UnmarkServiceProviderUnitCalendarEventRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/calendar/commands/unmarkserviceproviderunitcalendarevent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateServiceProviderUnitCalendarEventRequest
     * @return UpdateServiceProviderUnitCalendarEventResponse
     */
    updateServiceProviderUnitCalendarEvent(command: UpdateServiceProviderUnitCalendarEventRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/calendar/commands/updateserviceproviderunitcalendarevent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateServiceProviderUnitCalendarSeriesOccurrenceRequest
     * @return UpdateServiceProviderUnitCalendarSeriesOccurrenceResponse
     */
    updateServiceProviderUnitCalendarSeriesOccurrence(command: UpdateServiceProviderUnitCalendarSeriesOccurrenceRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/calendar/commands/updateserviceproviderunitcalendarseriesoccurrence`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderUnitCalendarEventsRequest
     * @return GetServiceProviderUnitCalendarEventsResponse
     */
    getServiceProviderUnitCalendarEvents(query: GetServiceProviderUnitCalendarEventsRequest, cancelToken?: CancelToken): Promise<GetServiceProviderUnitCalendarEventsResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/calendar/queries/getserviceproviderunitcalendarevents`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IOutboxClient {
    /**
     * @param command CancelOutboxItemsRequest
     * @return CancelOutboxItemsResponse
     */
    cancelOutboxItems(command: CancelOutboxItemsRequest, cancelToken?: CancelToken): Promise<CancelOutboxItemsResponse>;
    /**
     * @param command ManuallySentOutboxItemsRequest
     * @return ManuallySentOutboxItemsResponse
     */
    manuallySentOutboxItems(command: ManuallySentOutboxItemsRequest, cancelToken?: CancelToken): Promise<ManuallySentOutboxItemsResponse>;
    /**
     * @param command ResendOutboxItemsRequest
     * @return ResendOutboxItemsResponse
     */
    resendOutboxItems(command: ResendOutboxItemsRequest, cancelToken?: CancelToken): Promise<ResendOutboxItemsResponse>;
    /**
     * @param query GetAttachmentsRequest
     * @return GetAttachmentsResponse
     */
    getAttachments(query: GetAttachmentsRequest, cancelToken?: CancelToken): Promise<GetAttachmentsResponse>;
    /**
     * @param query GetCitizenOutboxItemsRequest
     * @return GetCitizenOutboxItemsResponse
     */
    getCitizenOutboxItems(query: GetCitizenOutboxItemsRequest, cancelToken?: CancelToken): Promise<GetCitizenOutboxItemsResponse>;
    /**
     * @param query GetCitizenOutboxItemsForMedicalCollaboratorRequest
     * @return GetCitizenOutboxItemsForMedicalCollaboratorResponse
     */
    getCitizenOutboxItemsForMedicalCollaborator(query: GetCitizenOutboxItemsForMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<GetCitizenOutboxItemsForMedicalCollaboratorResponse>;
    /**
     * @param query GetCitizenOutboxItemsForServiceProviderRequest
     * @return GetCitizenOutboxItemsForServiceProviderResponse
     */
    getCitizenOutboxItemsForServiceProvider(query: GetCitizenOutboxItemsForServiceProviderRequest, cancelToken?: CancelToken): Promise<GetCitizenOutboxItemsForServiceProviderResponse>;
    /**
     * @param query GetCompanyOutboxItemsRequest
     * @return GetCompanyOutboxItemsResponse
     */
    getCompanyOutboxItems(query: GetCompanyOutboxItemsRequest, cancelToken?: CancelToken): Promise<GetCompanyOutboxItemsResponse>;
    /**
     * @param query GetDocumentContentRequest
     * @return GetDocumentContentResponse
     */
    getDocumentContent(query: GetDocumentContentRequest, cancelToken?: CancelToken): Promise<GetDocumentContentResponse>;
    /**
     * @param query GetOutboxItemsRequest
     * @return GetOutboxItemsResponse
     */
    getOutboxItems(query: GetOutboxItemsRequest, cancelToken?: CancelToken): Promise<GetOutboxItemsResponse>;
}

export class OutboxClient implements IOutboxClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CancelOutboxItemsRequest
     * @return CancelOutboxItemsResponse
     */
    cancelOutboxItems(command: CancelOutboxItemsRequest, cancelToken?: CancelToken): Promise<CancelOutboxItemsResponse> {
        const $url = `${this.baseUrl}/api/outbox/commands/canceloutboxitems`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ManuallySentOutboxItemsRequest
     * @return ManuallySentOutboxItemsResponse
     */
    manuallySentOutboxItems(command: ManuallySentOutboxItemsRequest, cancelToken?: CancelToken): Promise<ManuallySentOutboxItemsResponse> {
        const $url = `${this.baseUrl}/api/outbox/commands/manuallysentoutboxitems`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ResendOutboxItemsRequest
     * @return ResendOutboxItemsResponse
     */
    resendOutboxItems(command: ResendOutboxItemsRequest, cancelToken?: CancelToken): Promise<ResendOutboxItemsResponse> {
        const $url = `${this.baseUrl}/api/outbox/commands/resendoutboxitems`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAttachmentsRequest
     * @return GetAttachmentsResponse
     */
    getAttachments(query: GetAttachmentsRequest, cancelToken?: CancelToken): Promise<GetAttachmentsResponse> {
        const $url = `${this.baseUrl}/api/outbox/queries/getattachments`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenOutboxItemsRequest
     * @return GetCitizenOutboxItemsResponse
     */
    getCitizenOutboxItems(query: GetCitizenOutboxItemsRequest, cancelToken?: CancelToken): Promise<GetCitizenOutboxItemsResponse> {
        const $url = `${this.baseUrl}/api/outbox/queries/getcitizenoutboxitems`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenOutboxItemsForMedicalCollaboratorRequest
     * @return GetCitizenOutboxItemsForMedicalCollaboratorResponse
     */
    getCitizenOutboxItemsForMedicalCollaborator(query: GetCitizenOutboxItemsForMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<GetCitizenOutboxItemsForMedicalCollaboratorResponse> {
        const $url = `${this.baseUrl}/api/outbox/queries/getcitizenoutboxitemsformedicalcollaborator`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenOutboxItemsForServiceProviderRequest
     * @return GetCitizenOutboxItemsForServiceProviderResponse
     */
    getCitizenOutboxItemsForServiceProvider(query: GetCitizenOutboxItemsForServiceProviderRequest, cancelToken?: CancelToken): Promise<GetCitizenOutboxItemsForServiceProviderResponse> {
        const $url = `${this.baseUrl}/api/outbox/queries/getcitizenoutboxitemsforserviceprovider`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyOutboxItemsRequest
     * @return GetCompanyOutboxItemsResponse
     */
    getCompanyOutboxItems(query: GetCompanyOutboxItemsRequest, cancelToken?: CancelToken): Promise<GetCompanyOutboxItemsResponse> {
        const $url = `${this.baseUrl}/api/outbox/queries/getcompanyoutboxitems`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDocumentContentRequest
     * @return GetDocumentContentResponse
     */
    getDocumentContent(query: GetDocumentContentRequest, cancelToken?: CancelToken): Promise<GetDocumentContentResponse> {
        const $url = `${this.baseUrl}/api/outbox/queries/getdocumentcontent`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOutboxItemsRequest
     * @return GetOutboxItemsResponse
     */
    getOutboxItems(query: GetOutboxItemsRequest, cancelToken?: CancelToken): Promise<GetOutboxItemsResponse> {
        const $url = `${this.baseUrl}/api/outbox/queries/getoutboxitems`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IOrganizationClient {
    /**
     * @param command CreateTeamRequest
     * @return CreateTeamResponse
     */
    createTeam(command: CreateTeamRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SetTeamStateRequest
     * @return SetTeamStateResponse
     */
    setTeamState(command: SetTeamStateRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateTeamRequest
     * @return UpdateTeamResponse
     */
    updateTeam(command: UpdateTeamRequest, cancelToken?: CancelToken): Promise<UpdateTeamResponse>;
    /**
     * @return GetCountriesResponse
     */
    getCountries(cancelToken?: CancelToken): Promise<GetCountriesResponse>;
    /**
     * @return GetSelectableSubJobcentersResponse
     */
    getSelectableSubJobcenters(cancelToken?: CancelToken): Promise<GetSelectableSubJobcentersResponse>;
    /**
     * @param query GetTeamByIdRequest
     * @return GetTeamByIdResponse
     */
    getTeamById(query: GetTeamByIdRequest, cancelToken?: CancelToken): Promise<GetTeamByIdResponse>;
    /**
     * @return GetTeamFkoConfigurationResponse
     */
    getTeamFkoConfiguration(cancelToken?: CancelToken): Promise<GetTeamFkoConfigurationResponse>;
    /**
     * @param query GetTeamInformationFromFkoRequest
     * @return GetTeamInformationFromFkoResponse
     */
    getTeamInformationFromFko(query: GetTeamInformationFromFkoRequest, cancelToken?: CancelToken): Promise<GetTeamInformationFromFkoResponse>;
    /**
     * @param query GetTeamNameFromFkoRequest
     * @return GetTeamNameFromFkoResponse
     */
    getTeamNameFromFko(query: GetTeamNameFromFkoRequest, cancelToken?: CancelToken): Promise<GetTeamNameFromFkoResponse>;
    /**
     * @return FileResponse
     */
    getTeamReport(cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return GetTeamsResponse
     */
    getTeams(cancelToken?: CancelToken): Promise<GetTeamsResponse>;
    /**
     * @param query GetTeamUsersRequest
     * @return GetTeamUsersResponse
     */
    getTeamUsers(query: GetTeamUsersRequest, cancelToken?: CancelToken): Promise<GetTeamUsersResponse>;
    /**
     * @param query GetUserByIdRequest
     * @return GetUserByIdResponse
     */
    getUserById(query: GetUserByIdRequest, cancelToken?: CancelToken): Promise<GetUserByIdResponse>;
}

export class OrganizationClient implements IOrganizationClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateTeamRequest
     * @return CreateTeamResponse
     */
    createTeam(command: CreateTeamRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/organization/commands/createteam`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetTeamStateRequest
     * @return SetTeamStateResponse
     */
    setTeamState(command: SetTeamStateRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/organization/commands/setteamstate`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateTeamRequest
     * @return UpdateTeamResponse
     */
    updateTeam(command: UpdateTeamRequest, cancelToken?: CancelToken): Promise<UpdateTeamResponse> {
        const $url = `${this.baseUrl}/api/organization/commands/updateteam`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCountriesResponse
     */
    getCountries(cancelToken?: CancelToken): Promise<GetCountriesResponse> {
        const $url = `${this.baseUrl}/api/organization/queries/getcountries`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSelectableSubJobcentersResponse
     */
    getSelectableSubJobcenters(cancelToken?: CancelToken): Promise<GetSelectableSubJobcentersResponse> {
        const $url = `${this.baseUrl}/api/organization/queries/getselectablesubjobcenters`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTeamByIdRequest
     * @return GetTeamByIdResponse
     */
    getTeamById(query: GetTeamByIdRequest, cancelToken?: CancelToken): Promise<GetTeamByIdResponse> {
        const $url = `${this.baseUrl}/api/organization/queries/getteambyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTeamFkoConfigurationResponse
     */
    getTeamFkoConfiguration(cancelToken?: CancelToken): Promise<GetTeamFkoConfigurationResponse> {
        const $url = `${this.baseUrl}/api/organization/queries/getteamfkoconfiguration`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTeamInformationFromFkoRequest
     * @return GetTeamInformationFromFkoResponse
     */
    getTeamInformationFromFko(query: GetTeamInformationFromFkoRequest, cancelToken?: CancelToken): Promise<GetTeamInformationFromFkoResponse> {
        const $url = `${this.baseUrl}/api/organization/queries/getteaminformationfromfko`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTeamNameFromFkoRequest
     * @return GetTeamNameFromFkoResponse
     */
    getTeamNameFromFko(query: GetTeamNameFromFkoRequest, cancelToken?: CancelToken): Promise<GetTeamNameFromFkoResponse> {
        const $url = `${this.baseUrl}/api/organization/queries/getteamnamefromfko`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return FileResponse
     */
    getTeamReport(cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/organization/queries/getteamreport`;

        const options_: AxiosRequestConfig = {
            data: {},
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @return GetTeamsResponse
     */
    getTeams(cancelToken?: CancelToken): Promise<GetTeamsResponse> {
        const $url = `${this.baseUrl}/api/organization/queries/getteams`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTeamUsersRequest
     * @return GetTeamUsersResponse
     */
    getTeamUsers(query: GetTeamUsersRequest, cancelToken?: CancelToken): Promise<GetTeamUsersResponse> {
        const $url = `${this.baseUrl}/api/organization/queries/getteamusers`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUserByIdRequest
     * @return GetUserByIdResponse
     */
    getUserById(query: GetUserByIdRequest, cancelToken?: CancelToken): Promise<GetUserByIdResponse> {
        const $url = `${this.baseUrl}/api/organization/queries/getuserbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IOfferAndActivityCoPaymentClient {
    /**
     * @param command CreateCoPaymentRequest
     * @return CreateCoPaymentResponse
     */
    createCoPayment(command: CreateCoPaymentRequest, cancelToken?: CancelToken): Promise<CreateCoPaymentResponse>;
    /**
     * @param command RectifyCoPaymentRequest
     * @return RectifyCoPaymentResponse
     */
    rectifyCoPayment(command: RectifyCoPaymentRequest, cancelToken?: CancelToken): Promise<RectifyCoPaymentResponse>;
    /**
     * @param query CalculateCoPaymentParagraph107Request
     * @return CalculateCoPaymentParagraph107Response
     */
    calculateCoPaymentParagraph107(query: CalculateCoPaymentParagraph107Request, cancelToken?: CancelToken): Promise<CalculateCoPaymentParagraph107Response>;
    /**
     * @param query CalculateCoPaymentParagraph108Request
     * @return CalculateCoPaymentParagraph108Response
     */
    calculateCoPaymentParagraph108(query: CalculateCoPaymentParagraph108Request, cancelToken?: CancelToken): Promise<CalculateCoPaymentParagraph108Response>;
    /**
     * @param query CalculateCoPaymentParagraph108IncomeBasisRequest
     * @return CalculateCoPaymentParagraph108IncomeBasisResponse
     */
    calculateCoPaymentParagraph108IncomeBasis(query: CalculateCoPaymentParagraph108IncomeBasisRequest, cancelToken?: CancelToken): Promise<CalculateCoPaymentParagraph108IncomeBasisResponse>;
    /**
     * @param query ClassifyCoPaymentRectificationRequest
     * @return ClassifyCoPaymentRectificationResponse
     */
    classifyCoPaymentRectification(query: ClassifyCoPaymentRectificationRequest, cancelToken?: CancelToken): Promise<ClassifyCoPaymentRectificationResponse>;
    /**
     * @param query GetCoPaymentByIdRequest
     * @return GetCoPaymentByIdResponse
     */
    getCoPaymentById(query: GetCoPaymentByIdRequest, cancelToken?: CancelToken): Promise<GetCoPaymentByIdResponse>;
    /**
     * @return GetCoPaymentConfigurationResponse
     */
    getCoPaymentConfiguration(cancelToken?: CancelToken): Promise<GetCoPaymentConfigurationResponse>;
    /**
     * @return GetCoPaymentDocumentTemplatesResponse
     */
    getCoPaymentDocumentTemplates(cancelToken?: CancelToken): Promise<GetCoPaymentDocumentTemplatesResponse>;
    /**
     * @return GetCoPaymentEnumOptionsResponse
     */
    getCoPaymentEnumOptions(cancelToken?: CancelToken): Promise<GetCoPaymentEnumOptionsResponse>;
    /**
     * @param query GetCoPaymentInitialDataRequest
     * @return GetCoPaymentInitialDataResponse
     */
    getCoPaymentInitialData(query: GetCoPaymentInitialDataRequest, cancelToken?: CancelToken): Promise<GetCoPaymentInitialDataResponse>;
    /**
     * @param query GetCoPaymentPdfRequest
     * @return FileResponse
     */
    getCoPaymentPdf(query: GetCoPaymentPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetCoPaymentReceivablesRequest
     * @return GetCoPaymentReceivablesResponse
     */
    getCoPaymentReceivables(query: GetCoPaymentReceivablesRequest, cancelToken?: CancelToken): Promise<GetCoPaymentReceivablesResponse>;
    /**
     * @param query GetCoPaymentRedirectPropertiesRequest
     * @return GetCoPaymentRedirectPropertiesResponse
     */
    getCoPaymentRedirectProperties(query: GetCoPaymentRedirectPropertiesRequest, cancelToken?: CancelToken): Promise<GetCoPaymentRedirectPropertiesResponse>;
    /**
     * @param query GetCoPaymentsByActivityIdRequest
     * @return GetCoPaymentsByActivityIdResponse
     */
    getCoPaymentsByActivityId(query: GetCoPaymentsByActivityIdRequest, cancelToken?: CancelToken): Promise<GetCoPaymentsByActivityIdResponse>;
    /**
     * @param query GetCoPaymentTypesByOfferTypeRequest
     * @return GetCoPaymentTypesByOfferTypeResponse
     */
    getCoPaymentTypesByOfferType(query: GetCoPaymentTypesByOfferTypeRequest, cancelToken?: CancelToken): Promise<GetCoPaymentTypesByOfferTypeResponse>;
    /**
     * @return GetDebitorRegistrationErrorCodesResponse
     */
    getDebitorRegistrationErrorCodes(cancelToken?: CancelToken): Promise<GetDebitorRegistrationErrorCodesResponse>;
}

export class OfferAndActivityCoPaymentClient implements IOfferAndActivityCoPaymentClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateCoPaymentRequest
     * @return CreateCoPaymentResponse
     */
    createCoPayment(command: CreateCoPaymentRequest, cancelToken?: CancelToken): Promise<CreateCoPaymentResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/commands/createcopayment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RectifyCoPaymentRequest
     * @return RectifyCoPaymentResponse
     */
    rectifyCoPayment(command: RectifyCoPaymentRequest, cancelToken?: CancelToken): Promise<RectifyCoPaymentResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/commands/rectifycopayment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query CalculateCoPaymentParagraph107Request
     * @return CalculateCoPaymentParagraph107Response
     */
    calculateCoPaymentParagraph107(query: CalculateCoPaymentParagraph107Request, cancelToken?: CancelToken): Promise<CalculateCoPaymentParagraph107Response> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/calculatecopaymentparagraph107`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query CalculateCoPaymentParagraph108Request
     * @return CalculateCoPaymentParagraph108Response
     */
    calculateCoPaymentParagraph108(query: CalculateCoPaymentParagraph108Request, cancelToken?: CancelToken): Promise<CalculateCoPaymentParagraph108Response> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/calculatecopaymentparagraph108`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query CalculateCoPaymentParagraph108IncomeBasisRequest
     * @return CalculateCoPaymentParagraph108IncomeBasisResponse
     */
    calculateCoPaymentParagraph108IncomeBasis(query: CalculateCoPaymentParagraph108IncomeBasisRequest, cancelToken?: CancelToken): Promise<CalculateCoPaymentParagraph108IncomeBasisResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/calculatecopaymentparagraph108incomebasis`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query ClassifyCoPaymentRectificationRequest
     * @return ClassifyCoPaymentRectificationResponse
     */
    classifyCoPaymentRectification(query: ClassifyCoPaymentRectificationRequest, cancelToken?: CancelToken): Promise<ClassifyCoPaymentRectificationResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/classifycopaymentrectification`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCoPaymentByIdRequest
     * @return GetCoPaymentByIdResponse
     */
    getCoPaymentById(query: GetCoPaymentByIdRequest, cancelToken?: CancelToken): Promise<GetCoPaymentByIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/getcopaymentbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCoPaymentConfigurationResponse
     */
    getCoPaymentConfiguration(cancelToken?: CancelToken): Promise<GetCoPaymentConfigurationResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/getcopaymentconfiguration`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCoPaymentDocumentTemplatesResponse
     */
    getCoPaymentDocumentTemplates(cancelToken?: CancelToken): Promise<GetCoPaymentDocumentTemplatesResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/getcopaymentdocumenttemplates`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCoPaymentEnumOptionsResponse
     */
    getCoPaymentEnumOptions(cancelToken?: CancelToken): Promise<GetCoPaymentEnumOptionsResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/getcopaymentenumoptions`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCoPaymentInitialDataRequest
     * @return GetCoPaymentInitialDataResponse
     */
    getCoPaymentInitialData(query: GetCoPaymentInitialDataRequest, cancelToken?: CancelToken): Promise<GetCoPaymentInitialDataResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/getcopaymentinitialdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCoPaymentPdfRequest
     * @return FileResponse
     */
    getCoPaymentPdf(query: GetCoPaymentPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/getcopaymentpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCoPaymentReceivablesRequest
     * @return GetCoPaymentReceivablesResponse
     */
    getCoPaymentReceivables(query: GetCoPaymentReceivablesRequest, cancelToken?: CancelToken): Promise<GetCoPaymentReceivablesResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/getcopaymentreceivables`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCoPaymentRedirectPropertiesRequest
     * @return GetCoPaymentRedirectPropertiesResponse
     */
    getCoPaymentRedirectProperties(query: GetCoPaymentRedirectPropertiesRequest, cancelToken?: CancelToken): Promise<GetCoPaymentRedirectPropertiesResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/getcopaymentredirectproperties`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCoPaymentsByActivityIdRequest
     * @return GetCoPaymentsByActivityIdResponse
     */
    getCoPaymentsByActivityId(query: GetCoPaymentsByActivityIdRequest, cancelToken?: CancelToken): Promise<GetCoPaymentsByActivityIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/getcopaymentsbyactivityid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCoPaymentTypesByOfferTypeRequest
     * @return GetCoPaymentTypesByOfferTypeResponse
     */
    getCoPaymentTypesByOfferType(query: GetCoPaymentTypesByOfferTypeRequest, cancelToken?: CancelToken): Promise<GetCoPaymentTypesByOfferTypeResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/getcopaymenttypesbyoffertype`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetDebitorRegistrationErrorCodesResponse
     */
    getDebitorRegistrationErrorCodes(cancelToken?: CancelToken): Promise<GetDebitorRegistrationErrorCodesResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/copayment/queries/getdebitorregistrationerrorcodes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IOfferAndActivityClient {
    /**
     * @param command AddCitizenToWaitingListRequest
     * @return AddCitizenToWaitingListResponse
     */
    addCitizenToWaitingList(command: AddCitizenToWaitingListRequest, cancelToken?: CancelToken): Promise<AddCitizenToWaitingListResponse>;
    /**
     * @param command ApproveActivityRequest
     * @return ApproveActivityResponse
     */
    approveActivity(command: ApproveActivityRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command AssignResponsibleCaseworkerRequest
     * @return AssignResponsibleCaseworkerResponse
     */
    assignResponsibleCaseworker(command: AssignResponsibleCaseworkerRequest, cancelToken?: CancelToken): Promise<AssignResponsibleCaseworkerResponse>;
    /**
     * @param command AttachVitasAllocationRequest
     * @return AttachVitasAllocationResponse
     */
    attachVitasAllocation(command: AttachVitasAllocationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CancelActivityRequest
     * @return CancelActivityResponse
     */
    cancelActivity(command: CancelActivityRequest, cancelToken?: CancelToken): Promise<CancelActivityResponse>;
    /**
     * @param command CitizenJobcenterTransferRequest
     * @return CitizenJobcenterTransferResponse
     */
    citizenJobcenterTransfer(command: CitizenJobcenterTransferRequest, cancelToken?: CancelToken): Promise<CitizenJobcenterTransferResponse>;
    /**
     * @param command CreateActivationLevelRequest
     * @return CreateActivationLevelResponse
     */
    createActivationLevel(command: CreateActivationLevelRequest, cancelToken?: CancelToken): Promise<CreateActivationLevelResponse>;
    /**
     * @param command CreateActivityRequest
     * @return CreateActivityResponse
     */
    createActivity(command: CreateActivityRequest, cancelToken?: CancelToken): Promise<CreateActivityResponse>;
    /**
     * @param command CreateActivityPriceCorrectionRequest
     * @return CreateActivityPriceCorrectionResponse
     */
    createActivityPriceCorrection(command: CreateActivityPriceCorrectionRequest, cancelToken?: CancelToken): Promise<CreateActivityPriceCorrectionResponse>;
    /**
     * @param command CreateEvaluationRequest
     * @return CreateEvaluationResponse
     */
    createEvaluation(command: CreateEvaluationRequest, cancelToken?: CancelToken): Promise<CreateEvaluationResponse>;
    /**
     * @param command CreateOfferRequest
     * @return CreateOfferResponse
     */
    createOffer(command: CreateOfferRequest, cancelToken?: CancelToken): Promise<CreateOfferResponse>;
    /**
     * @param command CreateOfferGroupRequest
     * @return CreateOfferGroupResponse
     */
    createOfferGroup(command: CreateOfferGroupRequest, cancelToken?: CancelToken): Promise<CreateOfferGroupResponse>;
    /**
     * @param command CreateOfferResourceRequest
     * @return CreateOfferResourceResponse
     */
    createOfferResource(command: CreateOfferResourceRequest, cancelToken?: CancelToken): Promise<CreateOfferResourceResponse>;
    /**
     * @param command CreateReimbursementRequest
     * @return CreateReimbursementResponse
     */
    createReimbursement(command: CreateReimbursementRequest, cancelToken?: CancelToken): Promise<CreateReimbursementResponse>;
    /**
     * @param command DeleteActivationLevelRequest
     * @return DeleteActivationLevelResponse
     */
    deleteActivationLevel(command: DeleteActivationLevelRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteActivityRequest
     * @return DeleteActivityResponse
     */
    deleteActivity(command: DeleteActivityRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteActivityPriceCorrectionRequest
     * @return DeleteActivityPriceCorrectionResponse
     */
    deleteActivityPriceCorrection(command: DeleteActivityPriceCorrectionRequest, cancelToken?: CancelToken): Promise<DeleteActivityPriceCorrectionResponse>;
    /**
     * @param command DeleteEvaluationRequest
     * @return DeleteEvaluationResponse
     */
    deleteEvaluation(command: DeleteEvaluationRequest, cancelToken?: CancelToken): Promise<DeleteEvaluationResponse>;
    /**
     * @param command DeleteOfferDraftByIdRequest
     * @return DeleteOfferDraftByIdResponse
     */
    deleteOfferDraftById(command: DeleteOfferDraftByIdRequest, cancelToken?: CancelToken): Promise<DeleteOfferDraftByIdResponse>;
    /**
     * @param command DeleteOfferResourceRequest
     * @return DeleteOfferResourceResponse
     */
    deleteOfferResource(command: DeleteOfferResourceRequest, cancelToken?: CancelToken): Promise<DeleteOfferResourceResponse>;
    /**
     * @param command DeleteReimbursementRequest
     * @return DeleteReimbursementResponse
     */
    deleteReimbursement(command: DeleteReimbursementRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteUpcomingOfferPriceRequest
     * @return DeleteUpcomingOfferPriceResponse
     */
    deleteUpcomingOfferPrice(command: DeleteUpcomingOfferPriceRequest, cancelToken?: CancelToken): Promise<DeleteUpcomingOfferPriceResponse>;
    /**
     * @param command SendActivityLetterRequest
     * @return SendActivityLetterResponse
     */
    sendActivityFormLetters(command: SendActivityLetterRequest, cancelToken?: CancelToken): Promise<SendActivityLetterResponse>;
    /**
     * @param command UpsertActivityResourceAllocationsRequest
     * @return UpsertActivityResourceAllocationsResponse
     */
    syncActivityResourceAllocations(command: UpsertActivityResourceAllocationsRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateActivationLevelRequest
     * @return UpdateActivationLevelResponse
     */
    updateActivationLevel(command: UpdateActivationLevelRequest, cancelToken?: CancelToken): Promise<UpdateActivationLevelResponse>;
    /**
     * @param command UpdateActivityRequest
     * @return UpdateActivityResponse
     */
    updateActivity(command: UpdateActivityRequest, cancelToken?: CancelToken): Promise<UpdateActivityResponse>;
    /**
     * @param command UpdatePlacementPriceRequest
     * @return UpdatePlacementPriceResponse
     */
    updateActivityPrice(command: UpdatePlacementPriceRequest, cancelToken?: CancelToken): Promise<UpdatePlacementPriceResponse>;
    /**
     * @param command UpdateActivityPriceCorrectionRequest
     * @return UpdateActivityPriceCorrectionResponse
     */
    updateActivityPriceCorrection(command: UpdateActivityPriceCorrectionRequest, cancelToken?: CancelToken): Promise<UpdateActivityPriceCorrectionResponse>;
    /**
     * @param command UpdateEvaluationRequest
     * @return UpdateEvaluationResponse
     */
    updateEvaluation(command: UpdateEvaluationRequest, cancelToken?: CancelToken): Promise<UpdateEvaluationResponse>;
    /**
     * @param command UpdateOfferRequest
     * @return UpdateOfferResponse
     */
    updateOffer(command: UpdateOfferRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateOfferGroupRequest
     * @return UpdateOfferGroupResponse
     */
    updateOfferGroup(command: UpdateOfferGroupRequest, cancelToken?: CancelToken): Promise<UpdateOfferGroupResponse>;
    /**
     * @param command UpdateOfferPriceRequest
     * @return UpdateOfferPriceResponse
     */
    updateOfferPrice(command: UpdateOfferPriceRequest, cancelToken?: CancelToken): Promise<UpdateOfferPriceResponse>;
    /**
     * @param command UpdateOfferResourceRequest
     * @return UpdateOfferResourceResponse
     */
    updateOfferResource(command: UpdateOfferResourceRequest, cancelToken?: CancelToken): Promise<UpdateOfferResourceResponse>;
    /**
     * @param command UpdateOfferStatusRequest
     * @return UpdateOfferStatusResponse
     */
    updateOfferStatus(command: UpdateOfferStatusRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateReimbursementRequest
     * @return UpdateReimbursementResponse
     */
    updateReimbursement(command: UpdateReimbursementRequest, cancelToken?: CancelToken): Promise<UpdateReimbursementResponse>;
    /**
     * @param command UpdateReimbursementEndDatesRequest
     * @return UpdateReimbursementEndDatesResponse
     */
    updateReimbursementEndDates(command: UpdateReimbursementEndDatesRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateUpcomingOfferPriceRequest
     * @return UpdateUpcomingOfferPriceResponse
     */
    updateUpcomingOfferPrice(command: UpdateUpcomingOfferPriceRequest, cancelToken?: CancelToken): Promise<UpdateUpcomingOfferPriceResponse>;
    /**
     * @param command UpdateWaitingListSeatRequest
     * @return UpdateWaitingListSeatResponse
     */
    updateWaitingListSeat(command: UpdateWaitingListSeatRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query CalculateReimbursementRequest
     * @return CalculateReimbursementResponse
     */
    calculateReimbursement(query: CalculateReimbursementRequest, cancelToken?: CancelToken): Promise<CalculateReimbursementResponse>;
    /**
     * @return CanApproveActivityResponse
     */
    canApproveActivity(cancelToken?: CancelToken): Promise<CanApproveActivityResponse>;
    /**
     * @param query GetActivationLevelByCitizenIdRequest
     * @return GetActivationLevelByCitizenIdResponse
     */
    getActivationLevelByCitizenId(query: GetActivationLevelByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetActivationLevelByCitizenIdResponse>;
    /**
     * @return GetActiveMethodTypesResponse
     */
    getActiveMethodTypes(cancelToken?: CancelToken): Promise<GetActiveMethodTypesResponse>;
    /**
     * @param query GetActivitiesAggregatedByCompanyIdRequest
     * @return GetActivitiesAggregatedByCompanyIdResponse
     */
    getActivitiesAggregatedByCompanyId(query: GetActivitiesAggregatedByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetActivitiesAggregatedByCompanyIdResponse>;
    /**
     * @param query GetActivitiesBasicInfoRequest
     * @return GetActivitiesBasicInfoResponse
     */
    getActivitiesBasicInfo(query: GetActivitiesBasicInfoRequest, cancelToken?: CancelToken): Promise<GetActivitiesBasicInfoResponse>;
    /**
     * @param query GetActivitiesByCitizenIdRequest
     * @return GetActivitiesByCitizenIdResponse
     */
    getActivitiesByCitizenId(query: GetActivitiesByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetActivitiesByCitizenIdResponse>;
    /**
     * @param query GetActivitiesByCompanyIdRequest
     * @return GetActivitiesByCompanyIdResponse
     */
    getActivitiesByCompanyId(query: GetActivitiesByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetActivitiesByCompanyIdResponse>;
    /**
     * @param query GetActivitiesByGrantIdRequest
     * @return GetActivitiesByGrantIdResponse
     */
    getActivitiesByGrantId(query: GetActivitiesByGrantIdRequest, cancelToken?: CancelToken): Promise<GetActivitiesByGrantIdResponse>;
    /**
     * @param query GetActivitiesForNegativeEventRequest
     * @return GetActivitiesForNegativeEventResponse
     */
    getActivitiesForNegativeEvent(query: GetActivitiesForNegativeEventRequest, cancelToken?: CancelToken): Promise<GetActivitiesForNegativeEventResponse>;
    /**
     * @param query GetActivitiesForNuphRequest
     * @return GetActivitiesForNuphResponse
     */
    getActivitiesForNuph(query: GetActivitiesForNuphRequest, cancelToken?: CancelToken): Promise<GetActivitiesForNuphResponse>;
    /**
     * @param query GetActivitiesSummaryBoxDataRequest
     * @return GetActivitiesSummaryBoxDataResponse
     */
    getActivitiesSummaryBoxData(query: GetActivitiesSummaryBoxDataRequest, cancelToken?: CancelToken): Promise<GetActivitiesSummaryBoxDataResponse>;
    /**
     * @param query GetActivityApprovalRejectDetailsRequest
     * @return GetActivityApprovalRejectDetailsResponse
     */
    getActivityApprovalRejectDetails(query: GetActivityApprovalRejectDetailsRequest, cancelToken?: CancelToken): Promise<GetActivityApprovalRejectDetailsResponse>;
    /**
     * @param query GetActivityBasicInfoRequest
     * @return GetActivityBasicInfoResponse
     */
    getActivityBasicInfo(query: GetActivityBasicInfoRequest, cancelToken?: CancelToken): Promise<GetActivityBasicInfoResponse>;
    /**
     * @param query GetActivityForCommunicationRequest
     * @return GetActivityForCommunicationResponse
     */
    getActivityByActivityIdForCommunication(query: GetActivityForCommunicationRequest, cancelToken?: CancelToken): Promise<GetActivityForCommunicationResponse>;
    /**
     * @param query GetActivityDetailsByIdRequest
     * @return GetActivityDetailsByIdResponse
     */
    getActivityDetailsById(query: GetActivityDetailsByIdRequest, cancelToken?: CancelToken): Promise<GetActivityDetailsByIdResponse>;
    /**
     * @param query GetActivityDetailsByOfferIdRequest
     * @return GetActivityDetailsByOfferIdResponse
     */
    getActivityDetailsByOfferId(query: GetActivityDetailsByOfferIdRequest, cancelToken?: CancelToken): Promise<GetActivityDetailsByOfferIdResponse>;
    /**
     * @param query GetActivityListByCitizenIdRequest
     * @return GetActivityListByCitizenIdResponse
     */
    getActivityListByCitizenId(query: GetActivityListByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetActivityListByCitizenIdResponse>;
    /**
     * @return GetActivityPdfFormsResponse
     */
    getActivityPdfForms(cancelToken?: CancelToken): Promise<GetActivityPdfFormsResponse>;
    /**
     * @param query GetActivityPdfFormSubmittedRequest
     * @return GetActivityPdfFormSubmittedResponse
     */
    getActivityPdfFormSubmitted(query: GetActivityPdfFormSubmittedRequest, cancelToken?: CancelToken): Promise<GetActivityPdfFormSubmittedResponse>;
    /**
     * @param query GetActivityPeriodTotalPriceRequest
     * @return GetActivityPeriodTotalPriceResponse
     */
    getActivityPeriodTotalPrice(query: GetActivityPeriodTotalPriceRequest, cancelToken?: CancelToken): Promise<GetActivityPeriodTotalPriceResponse>;
    /**
     * @param query GetActivityPriceCalculationHistoryRequest
     * @return GetActivityPriceCalculationHistoryResponse
     */
    getActivityPriceCalculationHistory(query: GetActivityPriceCalculationHistoryRequest, cancelToken?: CancelToken): Promise<GetActivityPriceCalculationHistoryResponse>;
    /**
     * @param query GetActivityPriceCorrectionsRequest
     * @return GetActivityPriceCorrectionsResponse
     */
    getActivityPriceCorrections(query: GetActivityPriceCorrectionsRequest, cancelToken?: CancelToken): Promise<GetActivityPriceCorrectionsResponse>;
    /**
     * @param query GetActivityResourcesRequest
     * @return GetActivityResourcesResponse
     */
    getActivityResources(query: GetActivityResourcesRequest, cancelToken?: CancelToken): Promise<GetActivityResourcesResponse>;
    /**
     * @param query GetActivityTotalPlacementHoursRequest
     * @return GetActivityTotalPlacementHoursResponse
     */
    getActivityTotalPlacementHours(query: GetActivityTotalPlacementHoursRequest, cancelToken?: CancelToken): Promise<GetActivityTotalPlacementHoursResponse>;
    /**
     * @return GetGetApprovalUsersResponse
     */
    getApprovalUsers(cancelToken?: CancelToken): Promise<GetGetApprovalUsersResponse>;
    /**
     * @param query GetCalculatedEndDateByStartDateRequest
     * @return GetCalculatedEndDateByStartDateResponse
     */
    getCalculatedEndDateByStartDate(query: GetCalculatedEndDateByStartDateRequest, cancelToken?: CancelToken): Promise<GetCalculatedEndDateByStartDateResponse>;
    /**
     * @param query GetCitizenGrantListRequest
     * @return GetCitizenGrantListResponse
     */
    getCitizenGrantList(query: GetCitizenGrantListRequest, cancelToken?: CancelToken): Promise<GetCitizenGrantListResponse>;
    /**
     * @param query GetCitizenHeaderInfoRequest
     * @return GetCitizenHeaderInfoResponse
     */
    getCitizenHeaderInfo(query: GetCitizenHeaderInfoRequest, cancelToken?: CancelToken): Promise<GetCitizenHeaderInfoResponse>;
    /**
     * @param query GetCompanyContactPersonsByCompanyIdForActivityRequest
     * @return GetCompanyContactPersonsByCompanyIdForActivityResponse
     */
    getCompanyContactPersonsByCompanyIdForActivity(query: GetCompanyContactPersonsByCompanyIdForActivityRequest, cancelToken?: CancelToken): Promise<GetCompanyContactPersonsByCompanyIdForActivityResponse>;
    /**
     * @param query GetCompanyContactPersonsByCompanyIdForOfferRequest
     * @return GetCompanyContactPersonsByCompanyIdForOfferResponse
     */
    getCompanyContactPersonsByCompanyIdForOffer(query: GetCompanyContactPersonsByCompanyIdForOfferRequest, cancelToken?: CancelToken): Promise<GetCompanyContactPersonsByCompanyIdForOfferResponse>;
    /**
     * @param query GetCompanyInfoByIdRequest
     * @return GetCompanyInfoByIdResponse
     */
    getCompanyInfoById(query: GetCompanyInfoByIdRequest, cancelToken?: CancelToken): Promise<GetCompanyInfoByIdResponse>;
    /**
     * @param query GetSpecialCircumstanceByCompanyIdRequest
     * @return GetSpecialCircumstanceByCompanyIdResponse
     */
    getCompanySpecialCircumstances(query: GetSpecialCircumstanceByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetSpecialCircumstanceByCompanyIdResponse>;
    /**
     * @param query GetCreateOfferCompanyByIdRequest
     * @return GetCreateOfferCompanyByIdResponse
     */
    getCreateOfferCompanyById(query: GetCreateOfferCompanyByIdRequest, cancelToken?: CancelToken): Promise<GetCreateOfferCompanyByIdResponse>;
    /**
     * @param query GetDfdgActivitiesByCitizenIdRequest
     * @return GetDfdgActivitiesByCitizenIdResponse
     */
    getDfdgActivitiesByCitizenId(query: GetDfdgActivitiesByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetDfdgActivitiesByCitizenIdResponse>;
    /**
     * @param query GetDfdgActivityByIdRequest
     * @return GetDfdgActivityByIdResponse
     */
    getDfdgActivityById(query: GetDfdgActivityByIdRequest, cancelToken?: CancelToken): Promise<GetDfdgActivityByIdResponse>;
    /**
     * @param query GetEvaluationRequest
     * @return GetEvaluationResponse
     */
    getEvaluation(query: GetEvaluationRequest, cancelToken?: CancelToken): Promise<GetEvaluationResponse>;
    /**
     * @param query GetEvaluationsByActivityIdRequest
     * @return GetEvaluationsByActivityIdResponse
     */
    getEvaluationsByActivityId(query: GetEvaluationsByActivityIdRequest, cancelToken?: CancelToken): Promise<GetEvaluationsByActivityIdResponse>;
    /**
     * @param query GetMissingWorkDutyHoursRequest
     * @return GetMissingWorkDutyHoursResponse
     */
    getMissingWorkDutyHours(query: GetMissingWorkDutyHoursRequest, cancelToken?: CancelToken): Promise<GetMissingWorkDutyHoursResponse>;
    /**
     * @param query GetOccupationsByLookupRequest
     * @return GetOccupationsByLookupResponse
     */
    getOccupationsByLookupQuery(query: GetOccupationsByLookupRequest, cancelToken?: CancelToken): Promise<GetOccupationsByLookupResponse>;
    /**
     * @return GetOfferAndActivityConfigurationResponse
     */
    getOfferAndActivityConfiguration(cancelToken?: CancelToken): Promise<GetOfferAndActivityConfigurationResponse>;
    /**
     * @param query GetOfferByIdRequest
     * @return GetOfferByIdResponse
     */
    getOfferById(query: GetOfferByIdRequest, cancelToken?: CancelToken): Promise<GetOfferByIdResponse>;
    /**
     * @param query GetOfferDetailsByIdRequest
     * @return GetOfferDetailsByIdResponse
     */
    getOfferDetailsById(query: GetOfferDetailsByIdRequest, cancelToken?: CancelToken): Promise<GetOfferDetailsByIdResponse>;
    /**
     * @return GetOfferDetailsCodeListDataResponse
     */
    getOfferDetailsCodeListData(cancelToken?: CancelToken): Promise<GetOfferDetailsCodeListDataResponse>;
    /**
     * @param query GetOfferDetailsForActivityByIdRequest
     * @return GetOfferDetailsForActivityByIdResponse
     */
    getOfferDetailsForActivityById(query: GetOfferDetailsForActivityByIdRequest, cancelToken?: CancelToken): Promise<GetOfferDetailsForActivityByIdResponse>;
    /**
     * @param query GetOfferSimpleDetailsByOfferIdRequest
     * @return GetOfferSimpleDetailsByOfferIdResponse
     */
    getOfferSimpleDetailsByOfferId(query: GetOfferSimpleDetailsByOfferIdRequest, cancelToken?: CancelToken): Promise<GetOfferSimpleDetailsByOfferIdResponse>;
    /**
     * @param query GetOfferGroupByIdRequest
     * @return GetOfferGroupByIdResponse
     */
    getOfferGroupById(query: GetOfferGroupByIdRequest, cancelToken?: CancelToken): Promise<GetOfferGroupByIdResponse>;
    /**
     * @return GetOfferGroupsResponse
     */
    getOfferGroups(cancelToken?: CancelToken): Promise<GetOfferGroupsResponse>;
    /**
     * @return GetOfferGroupsForAdministrationResponse
     */
    getOfferGroupsForAdministration(cancelToken?: CancelToken): Promise<GetOfferGroupsForAdministrationResponse>;
    /**
     * @param query GetOfferHasAvailableSeatsOnDateRequest
     * @return GetOfferHasAvailableSeatsOnDateResponse
     */
    getOfferHasAvailableSeatsOnDate(query: GetOfferHasAvailableSeatsOnDateRequest, cancelToken?: CancelToken): Promise<GetOfferHasAvailableSeatsOnDateResponse>;
    /**
     * @param query GetOfferIdByOfferResourceIdRequest
     * @return GetOfferIdByOfferResourceIdResponse
     */
    getOfferIdByOfferResourceId(query: GetOfferIdByOfferResourceIdRequest, cancelToken?: CancelToken): Promise<GetOfferIdByOfferResourceIdResponse>;
    /**
     * @param query GetOfferIdsByGrantIdRequest
     * @return GetOfferIdsByGrantIdResponse
     */
    getOfferIdsByGrantId(query: GetOfferIdsByGrantIdRequest, cancelToken?: CancelToken): Promise<GetOfferIdsByGrantIdResponse>;
    /**
     * @param query GetOfferPriceGuideInfoRequest
     * @return GetOfferPriceGuideInfoResponse
     */
    getOfferPriceGuideInfo(query: GetOfferPriceGuideInfoRequest, cancelToken?: CancelToken): Promise<GetOfferPriceGuideInfoResponse>;
    /**
     * @return GetOfferPriceModelsResponse
     */
    getOfferPriceModels(cancelToken?: CancelToken): Promise<GetOfferPriceModelsResponse>;
    /**
     * @param query GetOfferPricesRequest
     * @return GetOfferPricesResponse
     */
    getOfferPrices(query: GetOfferPricesRequest, cancelToken?: CancelToken): Promise<GetOfferPricesResponse>;
    /**
     * @param query GetOfferResourceByIdRequest
     * @return GetOfferResourceByIdResponse
     */
    getOfferResourceById(query: GetOfferResourceByIdRequest, cancelToken?: CancelToken): Promise<GetOfferResourceByIdResponse>;
    /**
     * @param query GetOfferResourcesByOfferIdRequest
     * @return GetOfferResourcesByOfferIdResponse
     */
    getOfferResourcesByOfferId(query: GetOfferResourcesByOfferIdRequest, cancelToken?: CancelToken): Promise<GetOfferResourcesByOfferIdResponse>;
    /**
     * @param query GetOffersByCompanyIdRequest
     * @return GetOffersByCompanyIdResponse
     */
    getOffersByCompanyId(query: GetOffersByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetOffersByCompanyIdResponse>;
    /**
     * @param query GetOffersEarmarkedToCitizenRequest
     * @return GetOffersEarmarkedToCitizenResponse
     */
    getOffersEarmarkedToCitizen(query: GetOffersEarmarkedToCitizenRequest, cancelToken?: CancelToken): Promise<GetOffersEarmarkedToCitizenResponse>;
    /**
     * @return GetOfferTypesResponse
     */
    getOfferTypes(cancelToken?: CancelToken): Promise<GetOfferTypesResponse>;
    /**
     * @return GetPersonalAssistanceTypesResponse
     */
    getPersonalAssistanceTypes(cancelToken?: CancelToken): Promise<GetPersonalAssistanceTypesResponse>;
    /**
     * @param query GetReimbursementRequest
     * @return GetReimbursementResponse
     */
    getReimbursement(query: GetReimbursementRequest, cancelToken?: CancelToken): Promise<GetReimbursementResponse>;
    /**
     * @param query GetReimbursementsByActivityIdRequest
     * @return GetReimbursementsByActivityIdResponse
     */
    getReimbursementsByActivityId(query: GetReimbursementsByActivityIdRequest, cancelToken?: CancelToken): Promise<GetReimbursementsByActivityIdResponse>;
    /**
     * @param query GetReimbursementOfferCategoryRequest
     * @return GetReimbursementsRedirectPropertiesResponse
     */
    getReimbursementsRedirectProperties(query: GetReimbursementOfferCategoryRequest, cancelToken?: CancelToken): Promise<GetReimbursementsRedirectPropertiesResponse>;
    /**
     * @param query GetSchultzConnectUrlRequest
     * @return GetSchultzConnectUrlResponse
     */
    getSchultzConnectUrl(query: GetSchultzConnectUrlRequest, cancelToken?: CancelToken): Promise<GetSchultzConnectUrlResponse>;
    /**
     * @param query GetSuggestedVitasDataForCancelActivityRequest
     * @return GetSuggestedVitasDataForCancelActivityResponse
     */
    getSuggestedVitasDataForCancelActivity(query: GetSuggestedVitasDataForCancelActivityRequest, cancelToken?: CancelToken): Promise<GetSuggestedVitasDataForCancelActivityResponse>;
    /**
     * @param query GetSuggestNextAvailablePeriodsRequest
     * @return GetSuggestNextAvailablePeriodsResponse
     */
    getSuggestionForNextAvailablePeriods(query: GetSuggestNextAvailablePeriodsRequest, cancelToken?: CancelToken): Promise<GetSuggestNextAvailablePeriodsResponse>;
    /**
     * @param query GetTeamByUserIdRequest
     * @return GetTeamByUserIdResponse
     */
    getTeamByUserId(query: GetTeamByUserIdRequest, cancelToken?: CancelToken): Promise<GetTeamByUserIdResponse>;
    /**
     * @param query GetWaitingListActivityValidationRequest
     * @return GetWaitingListActivityValidationResponse
     */
    getWaitingListActivityValidation(query: GetWaitingListActivityValidationRequest, cancelToken?: CancelToken): Promise<GetWaitingListActivityValidationResponse>;
    /**
     * @param query GetWaitingListSeatByIdRequest
     * @return GetWaitingListSeatByIdResponse
     */
    getWaitingListSeatById(query: GetWaitingListSeatByIdRequest, cancelToken?: CancelToken): Promise<GetWaitingListSeatByIdResponse>;
    /**
     * @param query GetWaitingListSeatRoutingInfoByIdRequest
     * @return GetWaitingListSeatRoutingInfoByIdResponse
     */
    getWaitingListSeatRoutingInfoById(query: GetWaitingListSeatRoutingInfoByIdRequest, cancelToken?: CancelToken): Promise<GetWaitingListSeatRoutingInfoByIdResponse>;
    /**
     * @param query GetWaitingListSeatsByCitizenIdRequest
     * @return GetWaitingListSeatsByCitizenIdResponse
     */
    getWaitingListSeatsByCitizenId(query: GetWaitingListSeatsByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetWaitingListSeatsByCitizenIdResponse>;
    /**
     * @param query GetWaitingListSeatsByOfferIdRequest
     * @return GetWaitingListSeatsByOfferIdResponse
     */
    getWaitingListSeatsByOfferId(query: GetWaitingListSeatsByOfferIdRequest, cancelToken?: CancelToken): Promise<GetWaitingListSeatsByOfferIdResponse>;
    /**
     * @param query GetWizardDataForCancelActivityRequest
     * @return GetWizardDataForCancelActivityResponse
     */
    getWizardDataForCancelActivity(query: GetWizardDataForCancelActivityRequest, cancelToken?: CancelToken): Promise<GetWizardDataForCancelActivityResponse>;
    /**
     * @param query GetWizardDataForReimbursementRequest
     * @return GetWizardDataForReimbursementResponse
     */
    getWizardDataForReimbursement(query: GetWizardDataForReimbursementRequest, cancelToken?: CancelToken): Promise<GetWizardDataForReimbursementResponse>;
    /**
     * @param query HasActiveActivityByOfferCategoryRequest
     * @return HasActiveActivityByOfferCategoryResponse
     */
    hasActiveActivityByOfferCategory(query: HasActiveActivityByOfferCategoryRequest, cancelToken?: CancelToken): Promise<HasActiveActivityByOfferCategoryResponse>;
    /**
     * @return IsActivityDraftEnabledResponse
     */
    isActivityDraftEnabled(cancelToken?: CancelToken): Promise<IsActivityDraftEnabledResponse>;
    /**
     * @param query IsCreateEvaluationAvailableRequest
     * @return IsCreateEvaluationAvailableResponse
     */
    isCreateEvaluationAvailable(query: IsCreateEvaluationAvailableRequest, cancelToken?: CancelToken): Promise<IsCreateEvaluationAvailableResponse>;
    /**
     * @param query IsReimbursementAvailableRequest
     * @return IsReimbursementAvailableResponse
     */
    isReimbursementAvailable(query: IsReimbursementAvailableRequest, cancelToken?: CancelToken): Promise<IsReimbursementAvailableResponse>;
    /**
     * @param query ValidateCreateActivityRequest
     * @return ValidateCreateActivityResponse
     */
    validateCreateActivity(query: ValidateCreateActivityRequest, cancelToken?: CancelToken): Promise<ValidateCreateActivityResponse>;
    /**
     * @param query ValidateCreateOfferRequest
     * @return ValidateCreateOfferResponse
     */
    validateCreateOffer(query: ValidateCreateOfferRequest, cancelToken?: CancelToken): Promise<ValidateCreateOfferResponse>;
    /**
     * @param query ValidateUpdateActivityRequest
     * @return ValidateUpdateActivityResponse
     */
    validateUpdateActivity(query: ValidateUpdateActivityRequest, cancelToken?: CancelToken): Promise<ValidateUpdateActivityResponse>;
    /**
     * @param query ValidateUpdateOfferRequest
     * @return ValidateUpdateOfferResponse
     */
    validateUpdateOffer(query: ValidateUpdateOfferRequest, cancelToken?: CancelToken): Promise<ValidateUpdateOfferResponse>;
}

export class OfferAndActivityClient implements IOfferAndActivityClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command AddCitizenToWaitingListRequest
     * @return AddCitizenToWaitingListResponse
     */
    addCitizenToWaitingList(command: AddCitizenToWaitingListRequest, cancelToken?: CancelToken): Promise<AddCitizenToWaitingListResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/addcitizentowaitinglist`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ApproveActivityRequest
     * @return ApproveActivityResponse
     */
    approveActivity(command: ApproveActivityRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/approveactivity`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command AssignResponsibleCaseworkerRequest
     * @return AssignResponsibleCaseworkerResponse
     */
    assignResponsibleCaseworker(command: AssignResponsibleCaseworkerRequest, cancelToken?: CancelToken): Promise<AssignResponsibleCaseworkerResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/assignresponsiblecaseworker`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command AttachVitasAllocationRequest
     * @return AttachVitasAllocationResponse
     */
    attachVitasAllocation(command: AttachVitasAllocationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/attachvitasallocation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CancelActivityRequest
     * @return CancelActivityResponse
     */
    cancelActivity(command: CancelActivityRequest, cancelToken?: CancelToken): Promise<CancelActivityResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/cancelactivity`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CitizenJobcenterTransferRequest
     * @return CitizenJobcenterTransferResponse
     */
    citizenJobcenterTransfer(command: CitizenJobcenterTransferRequest, cancelToken?: CancelToken): Promise<CitizenJobcenterTransferResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/citizenjobcentertransfer`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateActivationLevelRequest
     * @return CreateActivationLevelResponse
     */
    createActivationLevel(command: CreateActivationLevelRequest, cancelToken?: CancelToken): Promise<CreateActivationLevelResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/createactivationlevel`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateActivityRequest
     * @return CreateActivityResponse
     */
    createActivity(command: CreateActivityRequest, cancelToken?: CancelToken): Promise<CreateActivityResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/createactivity`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateActivityPriceCorrectionRequest
     * @return CreateActivityPriceCorrectionResponse
     */
    createActivityPriceCorrection(command: CreateActivityPriceCorrectionRequest, cancelToken?: CancelToken): Promise<CreateActivityPriceCorrectionResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/createactivitypricecorrection`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateEvaluationRequest
     * @return CreateEvaluationResponse
     */
    createEvaluation(command: CreateEvaluationRequest, cancelToken?: CancelToken): Promise<CreateEvaluationResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/createevaluation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateOfferRequest
     * @return CreateOfferResponse
     */
    createOffer(command: CreateOfferRequest, cancelToken?: CancelToken): Promise<CreateOfferResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/createoffer`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateOfferGroupRequest
     * @return CreateOfferGroupResponse
     */
    createOfferGroup(command: CreateOfferGroupRequest, cancelToken?: CancelToken): Promise<CreateOfferGroupResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/createoffergroup`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateOfferResourceRequest
     * @return CreateOfferResourceResponse
     */
    createOfferResource(command: CreateOfferResourceRequest, cancelToken?: CancelToken): Promise<CreateOfferResourceResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/createofferresource`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateReimbursementRequest
     * @return CreateReimbursementResponse
     */
    createReimbursement(command: CreateReimbursementRequest, cancelToken?: CancelToken): Promise<CreateReimbursementResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/createreimbursement`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteActivationLevelRequest
     * @return DeleteActivationLevelResponse
     */
    deleteActivationLevel(command: DeleteActivationLevelRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/deleteactivationlevel`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteActivityRequest
     * @return DeleteActivityResponse
     */
    deleteActivity(command: DeleteActivityRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/deleteactivity`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteActivityPriceCorrectionRequest
     * @return DeleteActivityPriceCorrectionResponse
     */
    deleteActivityPriceCorrection(command: DeleteActivityPriceCorrectionRequest, cancelToken?: CancelToken): Promise<DeleteActivityPriceCorrectionResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/deleteactivitypricecorrection`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteEvaluationRequest
     * @return DeleteEvaluationResponse
     */
    deleteEvaluation(command: DeleteEvaluationRequest, cancelToken?: CancelToken): Promise<DeleteEvaluationResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/deleteevaluation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteOfferDraftByIdRequest
     * @return DeleteOfferDraftByIdResponse
     */
    deleteOfferDraftById(command: DeleteOfferDraftByIdRequest, cancelToken?: CancelToken): Promise<DeleteOfferDraftByIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/deleteofferdraftbyid`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteOfferResourceRequest
     * @return DeleteOfferResourceResponse
     */
    deleteOfferResource(command: DeleteOfferResourceRequest, cancelToken?: CancelToken): Promise<DeleteOfferResourceResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/deleteofferresource`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteReimbursementRequest
     * @return DeleteReimbursementResponse
     */
    deleteReimbursement(command: DeleteReimbursementRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/deletereimbursement`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteUpcomingOfferPriceRequest
     * @return DeleteUpcomingOfferPriceResponse
     */
    deleteUpcomingOfferPrice(command: DeleteUpcomingOfferPriceRequest, cancelToken?: CancelToken): Promise<DeleteUpcomingOfferPriceResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/deleteupcomingofferprice`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendActivityLetterRequest
     * @return SendActivityLetterResponse
     */
    sendActivityFormLetters(command: SendActivityLetterRequest, cancelToken?: CancelToken): Promise<SendActivityLetterResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/sendactivityformletters`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpsertActivityResourceAllocationsRequest
     * @return UpsertActivityResourceAllocationsResponse
     */
    syncActivityResourceAllocations(command: UpsertActivityResourceAllocationsRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/syncactivityresourceallocations`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateActivationLevelRequest
     * @return UpdateActivationLevelResponse
     */
    updateActivationLevel(command: UpdateActivationLevelRequest, cancelToken?: CancelToken): Promise<UpdateActivationLevelResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/updateactivationlevel`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateActivityRequest
     * @return UpdateActivityResponse
     */
    updateActivity(command: UpdateActivityRequest, cancelToken?: CancelToken): Promise<UpdateActivityResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/updateactivity`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdatePlacementPriceRequest
     * @return UpdatePlacementPriceResponse
     */
    updateActivityPrice(command: UpdatePlacementPriceRequest, cancelToken?: CancelToken): Promise<UpdatePlacementPriceResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/updateactivityprice`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateActivityPriceCorrectionRequest
     * @return UpdateActivityPriceCorrectionResponse
     */
    updateActivityPriceCorrection(command: UpdateActivityPriceCorrectionRequest, cancelToken?: CancelToken): Promise<UpdateActivityPriceCorrectionResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/updateactivitypricecorrection`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateEvaluationRequest
     * @return UpdateEvaluationResponse
     */
    updateEvaluation(command: UpdateEvaluationRequest, cancelToken?: CancelToken): Promise<UpdateEvaluationResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/updateevaluation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateOfferRequest
     * @return UpdateOfferResponse
     */
    updateOffer(command: UpdateOfferRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/updateoffer`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateOfferGroupRequest
     * @return UpdateOfferGroupResponse
     */
    updateOfferGroup(command: UpdateOfferGroupRequest, cancelToken?: CancelToken): Promise<UpdateOfferGroupResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/updateoffergroup`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateOfferPriceRequest
     * @return UpdateOfferPriceResponse
     */
    updateOfferPrice(command: UpdateOfferPriceRequest, cancelToken?: CancelToken): Promise<UpdateOfferPriceResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/updateofferprice`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateOfferResourceRequest
     * @return UpdateOfferResourceResponse
     */
    updateOfferResource(command: UpdateOfferResourceRequest, cancelToken?: CancelToken): Promise<UpdateOfferResourceResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/updateofferresource`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateOfferStatusRequest
     * @return UpdateOfferStatusResponse
     */
    updateOfferStatus(command: UpdateOfferStatusRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/updateofferstatus`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateReimbursementRequest
     * @return UpdateReimbursementResponse
     */
    updateReimbursement(command: UpdateReimbursementRequest, cancelToken?: CancelToken): Promise<UpdateReimbursementResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/updatereimbursement`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateReimbursementEndDatesRequest
     * @return UpdateReimbursementEndDatesResponse
     */
    updateReimbursementEndDates(command: UpdateReimbursementEndDatesRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/updatereimbursementenddates`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateUpcomingOfferPriceRequest
     * @return UpdateUpcomingOfferPriceResponse
     */
    updateUpcomingOfferPrice(command: UpdateUpcomingOfferPriceRequest, cancelToken?: CancelToken): Promise<UpdateUpcomingOfferPriceResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/updateupcomingofferprice`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateWaitingListSeatRequest
     * @return UpdateWaitingListSeatResponse
     */
    updateWaitingListSeat(command: UpdateWaitingListSeatRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/offerandactivity/commands/updatewaitinglistseat`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query CalculateReimbursementRequest
     * @return CalculateReimbursementResponse
     */
    calculateReimbursement(query: CalculateReimbursementRequest, cancelToken?: CancelToken): Promise<CalculateReimbursementResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/calculatereimbursement`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return CanApproveActivityResponse
     */
    canApproveActivity(cancelToken?: CancelToken): Promise<CanApproveActivityResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/canapproveactivity`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivationLevelByCitizenIdRequest
     * @return GetActivationLevelByCitizenIdResponse
     */
    getActivationLevelByCitizenId(query: GetActivationLevelByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetActivationLevelByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivationlevelbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetActiveMethodTypesResponse
     */
    getActiveMethodTypes(cancelToken?: CancelToken): Promise<GetActiveMethodTypesResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivemethodtypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivitiesAggregatedByCompanyIdRequest
     * @return GetActivitiesAggregatedByCompanyIdResponse
     */
    getActivitiesAggregatedByCompanyId(query: GetActivitiesAggregatedByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetActivitiesAggregatedByCompanyIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitiesaggregatedbycompanyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivitiesBasicInfoRequest
     * @return GetActivitiesBasicInfoResponse
     */
    getActivitiesBasicInfo(query: GetActivitiesBasicInfoRequest, cancelToken?: CancelToken): Promise<GetActivitiesBasicInfoResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitiesbasicinfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivitiesByCitizenIdRequest
     * @return GetActivitiesByCitizenIdResponse
     */
    getActivitiesByCitizenId(query: GetActivitiesByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetActivitiesByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitiesbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivitiesByCompanyIdRequest
     * @return GetActivitiesByCompanyIdResponse
     */
    getActivitiesByCompanyId(query: GetActivitiesByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetActivitiesByCompanyIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitiesbycompanyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivitiesByGrantIdRequest
     * @return GetActivitiesByGrantIdResponse
     */
    getActivitiesByGrantId(query: GetActivitiesByGrantIdRequest, cancelToken?: CancelToken): Promise<GetActivitiesByGrantIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitiesbygrantid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivitiesForNegativeEventRequest
     * @return GetActivitiesForNegativeEventResponse
     */
    getActivitiesForNegativeEvent(query: GetActivitiesForNegativeEventRequest, cancelToken?: CancelToken): Promise<GetActivitiesForNegativeEventResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitiesfornegativeevent`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivitiesForNuphRequest
     * @return GetActivitiesForNuphResponse
     */
    getActivitiesForNuph(query: GetActivitiesForNuphRequest, cancelToken?: CancelToken): Promise<GetActivitiesForNuphResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitiesfornuph`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivitiesSummaryBoxDataRequest
     * @return GetActivitiesSummaryBoxDataResponse
     */
    getActivitiesSummaryBoxData(query: GetActivitiesSummaryBoxDataRequest, cancelToken?: CancelToken): Promise<GetActivitiesSummaryBoxDataResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitiessummaryboxdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivityApprovalRejectDetailsRequest
     * @return GetActivityApprovalRejectDetailsResponse
     */
    getActivityApprovalRejectDetails(query: GetActivityApprovalRejectDetailsRequest, cancelToken?: CancelToken): Promise<GetActivityApprovalRejectDetailsResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivityapprovalrejectdetails`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivityBasicInfoRequest
     * @return GetActivityBasicInfoResponse
     */
    getActivityBasicInfo(query: GetActivityBasicInfoRequest, cancelToken?: CancelToken): Promise<GetActivityBasicInfoResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitybasicinfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivityForCommunicationRequest
     * @return GetActivityForCommunicationResponse
     */
    getActivityByActivityIdForCommunication(query: GetActivityForCommunicationRequest, cancelToken?: CancelToken): Promise<GetActivityForCommunicationResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitybyactivityidforcommunication`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivityDetailsByIdRequest
     * @return GetActivityDetailsByIdResponse
     */
    getActivityDetailsById(query: GetActivityDetailsByIdRequest, cancelToken?: CancelToken): Promise<GetActivityDetailsByIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitydetailsbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivityDetailsByOfferIdRequest
     * @return GetActivityDetailsByOfferIdResponse
     */
    getActivityDetailsByOfferId(query: GetActivityDetailsByOfferIdRequest, cancelToken?: CancelToken): Promise<GetActivityDetailsByOfferIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitydetailsbyofferid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivityListByCitizenIdRequest
     * @return GetActivityListByCitizenIdResponse
     */
    getActivityListByCitizenId(query: GetActivityListByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetActivityListByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitylistbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetActivityPdfFormsResponse
     */
    getActivityPdfForms(cancelToken?: CancelToken): Promise<GetActivityPdfFormsResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitypdfforms`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivityPdfFormSubmittedRequest
     * @return GetActivityPdfFormSubmittedResponse
     */
    getActivityPdfFormSubmitted(query: GetActivityPdfFormSubmittedRequest, cancelToken?: CancelToken): Promise<GetActivityPdfFormSubmittedResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitypdfformsubmitted`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivityPeriodTotalPriceRequest
     * @return GetActivityPeriodTotalPriceResponse
     */
    getActivityPeriodTotalPrice(query: GetActivityPeriodTotalPriceRequest, cancelToken?: CancelToken): Promise<GetActivityPeriodTotalPriceResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivityperiodtotalprice`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivityPriceCalculationHistoryRequest
     * @return GetActivityPriceCalculationHistoryResponse
     */
    getActivityPriceCalculationHistory(query: GetActivityPriceCalculationHistoryRequest, cancelToken?: CancelToken): Promise<GetActivityPriceCalculationHistoryResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitypricecalculationhistory`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivityPriceCorrectionsRequest
     * @return GetActivityPriceCorrectionsResponse
     */
    getActivityPriceCorrections(query: GetActivityPriceCorrectionsRequest, cancelToken?: CancelToken): Promise<GetActivityPriceCorrectionsResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitypricecorrections`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivityResourcesRequest
     * @return GetActivityResourcesResponse
     */
    getActivityResources(query: GetActivityResourcesRequest, cancelToken?: CancelToken): Promise<GetActivityResourcesResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivityresources`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivityTotalPlacementHoursRequest
     * @return GetActivityTotalPlacementHoursResponse
     */
    getActivityTotalPlacementHours(query: GetActivityTotalPlacementHoursRequest, cancelToken?: CancelToken): Promise<GetActivityTotalPlacementHoursResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getactivitytotalplacementhours`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetGetApprovalUsersResponse
     */
    getApprovalUsers(cancelToken?: CancelToken): Promise<GetGetApprovalUsersResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getapprovalusers`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCalculatedEndDateByStartDateRequest
     * @return GetCalculatedEndDateByStartDateResponse
     */
    getCalculatedEndDateByStartDate(query: GetCalculatedEndDateByStartDateRequest, cancelToken?: CancelToken): Promise<GetCalculatedEndDateByStartDateResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getcalculatedenddatebystartdate`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenGrantListRequest
     * @return GetCitizenGrantListResponse
     */
    getCitizenGrantList(query: GetCitizenGrantListRequest, cancelToken?: CancelToken): Promise<GetCitizenGrantListResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getcitizengrantlist`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenHeaderInfoRequest
     * @return GetCitizenHeaderInfoResponse
     */
    getCitizenHeaderInfo(query: GetCitizenHeaderInfoRequest, cancelToken?: CancelToken): Promise<GetCitizenHeaderInfoResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getcitizenheaderinfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyContactPersonsByCompanyIdForActivityRequest
     * @return GetCompanyContactPersonsByCompanyIdForActivityResponse
     */
    getCompanyContactPersonsByCompanyIdForActivity(query: GetCompanyContactPersonsByCompanyIdForActivityRequest, cancelToken?: CancelToken): Promise<GetCompanyContactPersonsByCompanyIdForActivityResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getcompanycontactpersonsbycompanyidforactivity`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyContactPersonsByCompanyIdForOfferRequest
     * @return GetCompanyContactPersonsByCompanyIdForOfferResponse
     */
    getCompanyContactPersonsByCompanyIdForOffer(query: GetCompanyContactPersonsByCompanyIdForOfferRequest, cancelToken?: CancelToken): Promise<GetCompanyContactPersonsByCompanyIdForOfferResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getcompanycontactpersonsbycompanyidforoffer`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyInfoByIdRequest
     * @return GetCompanyInfoByIdResponse
     */
    getCompanyInfoById(query: GetCompanyInfoByIdRequest, cancelToken?: CancelToken): Promise<GetCompanyInfoByIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getcompanyinfobyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSpecialCircumstanceByCompanyIdRequest
     * @return GetSpecialCircumstanceByCompanyIdResponse
     */
    getCompanySpecialCircumstances(query: GetSpecialCircumstanceByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetSpecialCircumstanceByCompanyIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getcompanyspecialcircumstances`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCreateOfferCompanyByIdRequest
     * @return GetCreateOfferCompanyByIdResponse
     */
    getCreateOfferCompanyById(query: GetCreateOfferCompanyByIdRequest, cancelToken?: CancelToken): Promise<GetCreateOfferCompanyByIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getcreateoffercompanybyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDfdgActivitiesByCitizenIdRequest
     * @return GetDfdgActivitiesByCitizenIdResponse
     */
    getDfdgActivitiesByCitizenId(query: GetDfdgActivitiesByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetDfdgActivitiesByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getdfdgactivitiesbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDfdgActivityByIdRequest
     * @return GetDfdgActivityByIdResponse
     */
    getDfdgActivityById(query: GetDfdgActivityByIdRequest, cancelToken?: CancelToken): Promise<GetDfdgActivityByIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getdfdgactivitybyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEvaluationRequest
     * @return GetEvaluationResponse
     */
    getEvaluation(query: GetEvaluationRequest, cancelToken?: CancelToken): Promise<GetEvaluationResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getevaluation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEvaluationsByActivityIdRequest
     * @return GetEvaluationsByActivityIdResponse
     */
    getEvaluationsByActivityId(query: GetEvaluationsByActivityIdRequest, cancelToken?: CancelToken): Promise<GetEvaluationsByActivityIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getevaluationsbyactivityid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMissingWorkDutyHoursRequest
     * @return GetMissingWorkDutyHoursResponse
     */
    getMissingWorkDutyHours(query: GetMissingWorkDutyHoursRequest, cancelToken?: CancelToken): Promise<GetMissingWorkDutyHoursResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getmissingworkdutyhours`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOccupationsByLookupRequest
     * @return GetOccupationsByLookupResponse
     */
    getOccupationsByLookupQuery(query: GetOccupationsByLookupRequest, cancelToken?: CancelToken): Promise<GetOccupationsByLookupResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getoccupationsbylookupquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOfferAndActivityConfigurationResponse
     */
    getOfferAndActivityConfiguration(cancelToken?: CancelToken): Promise<GetOfferAndActivityConfigurationResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getofferandactivityconfiguration`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferByIdRequest
     * @return GetOfferByIdResponse
     */
    getOfferById(query: GetOfferByIdRequest, cancelToken?: CancelToken): Promise<GetOfferByIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getofferbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferDetailsByIdRequest
     * @return GetOfferDetailsByIdResponse
     */
    getOfferDetailsById(query: GetOfferDetailsByIdRequest, cancelToken?: CancelToken): Promise<GetOfferDetailsByIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getofferdetailsbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOfferDetailsCodeListDataResponse
     */
    getOfferDetailsCodeListData(cancelToken?: CancelToken): Promise<GetOfferDetailsCodeListDataResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getofferdetailscodelistdata`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferDetailsForActivityByIdRequest
     * @return GetOfferDetailsForActivityByIdResponse
     */
    getOfferDetailsForActivityById(query: GetOfferDetailsForActivityByIdRequest, cancelToken?: CancelToken): Promise<GetOfferDetailsForActivityByIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getofferdetailsforactivitybyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferSimpleDetailsByOfferIdRequest
     * @return GetOfferSimpleDetailsByOfferIdResponse
     */
    getOfferSimpleDetailsByOfferId(query: GetOfferSimpleDetailsByOfferIdRequest, cancelToken?: CancelToken): Promise<GetOfferSimpleDetailsByOfferIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getoffersimpledetailsbyofferid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferGroupByIdRequest
     * @return GetOfferGroupByIdResponse
     */
    getOfferGroupById(query: GetOfferGroupByIdRequest, cancelToken?: CancelToken): Promise<GetOfferGroupByIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getoffergroupbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOfferGroupsResponse
     */
    getOfferGroups(cancelToken?: CancelToken): Promise<GetOfferGroupsResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getoffergroups`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOfferGroupsForAdministrationResponse
     */
    getOfferGroupsForAdministration(cancelToken?: CancelToken): Promise<GetOfferGroupsForAdministrationResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getoffergroupsforadministration`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferHasAvailableSeatsOnDateRequest
     * @return GetOfferHasAvailableSeatsOnDateResponse
     */
    getOfferHasAvailableSeatsOnDate(query: GetOfferHasAvailableSeatsOnDateRequest, cancelToken?: CancelToken): Promise<GetOfferHasAvailableSeatsOnDateResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getofferhasavailableseatsondate`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferIdByOfferResourceIdRequest
     * @return GetOfferIdByOfferResourceIdResponse
     */
    getOfferIdByOfferResourceId(query: GetOfferIdByOfferResourceIdRequest, cancelToken?: CancelToken): Promise<GetOfferIdByOfferResourceIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getofferidbyofferresourceid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferIdsByGrantIdRequest
     * @return GetOfferIdsByGrantIdResponse
     */
    getOfferIdsByGrantId(query: GetOfferIdsByGrantIdRequest, cancelToken?: CancelToken): Promise<GetOfferIdsByGrantIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getofferidsbygrantid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferPriceGuideInfoRequest
     * @return GetOfferPriceGuideInfoResponse
     */
    getOfferPriceGuideInfo(query: GetOfferPriceGuideInfoRequest, cancelToken?: CancelToken): Promise<GetOfferPriceGuideInfoResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getofferpriceguideinfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOfferPriceModelsResponse
     */
    getOfferPriceModels(cancelToken?: CancelToken): Promise<GetOfferPriceModelsResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getofferpricemodels`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferPricesRequest
     * @return GetOfferPricesResponse
     */
    getOfferPrices(query: GetOfferPricesRequest, cancelToken?: CancelToken): Promise<GetOfferPricesResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getofferprices`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferResourceByIdRequest
     * @return GetOfferResourceByIdResponse
     */
    getOfferResourceById(query: GetOfferResourceByIdRequest, cancelToken?: CancelToken): Promise<GetOfferResourceByIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getofferresourcebyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferResourcesByOfferIdRequest
     * @return GetOfferResourcesByOfferIdResponse
     */
    getOfferResourcesByOfferId(query: GetOfferResourcesByOfferIdRequest, cancelToken?: CancelToken): Promise<GetOfferResourcesByOfferIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getofferresourcesbyofferid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOffersByCompanyIdRequest
     * @return GetOffersByCompanyIdResponse
     */
    getOffersByCompanyId(query: GetOffersByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetOffersByCompanyIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getoffersbycompanyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOffersEarmarkedToCitizenRequest
     * @return GetOffersEarmarkedToCitizenResponse
     */
    getOffersEarmarkedToCitizen(query: GetOffersEarmarkedToCitizenRequest, cancelToken?: CancelToken): Promise<GetOffersEarmarkedToCitizenResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getoffersearmarkedtocitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOfferTypesResponse
     */
    getOfferTypes(cancelToken?: CancelToken): Promise<GetOfferTypesResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getoffertypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetPersonalAssistanceTypesResponse
     */
    getPersonalAssistanceTypes(cancelToken?: CancelToken): Promise<GetPersonalAssistanceTypesResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getpersonalassistancetypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetReimbursementRequest
     * @return GetReimbursementResponse
     */
    getReimbursement(query: GetReimbursementRequest, cancelToken?: CancelToken): Promise<GetReimbursementResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getreimbursement`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetReimbursementsByActivityIdRequest
     * @return GetReimbursementsByActivityIdResponse
     */
    getReimbursementsByActivityId(query: GetReimbursementsByActivityIdRequest, cancelToken?: CancelToken): Promise<GetReimbursementsByActivityIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getreimbursementsbyactivityid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetReimbursementOfferCategoryRequest
     * @return GetReimbursementsRedirectPropertiesResponse
     */
    getReimbursementsRedirectProperties(query: GetReimbursementOfferCategoryRequest, cancelToken?: CancelToken): Promise<GetReimbursementsRedirectPropertiesResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getreimbursementsredirectproperties`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSchultzConnectUrlRequest
     * @return GetSchultzConnectUrlResponse
     */
    getSchultzConnectUrl(query: GetSchultzConnectUrlRequest, cancelToken?: CancelToken): Promise<GetSchultzConnectUrlResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getschultzconnecturl`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSuggestedVitasDataForCancelActivityRequest
     * @return GetSuggestedVitasDataForCancelActivityResponse
     */
    getSuggestedVitasDataForCancelActivity(query: GetSuggestedVitasDataForCancelActivityRequest, cancelToken?: CancelToken): Promise<GetSuggestedVitasDataForCancelActivityResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getsuggestedvitasdataforcancelactivity`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSuggestNextAvailablePeriodsRequest
     * @return GetSuggestNextAvailablePeriodsResponse
     */
    getSuggestionForNextAvailablePeriods(query: GetSuggestNextAvailablePeriodsRequest, cancelToken?: CancelToken): Promise<GetSuggestNextAvailablePeriodsResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getsuggestionfornextavailableperiods`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTeamByUserIdRequest
     * @return GetTeamByUserIdResponse
     */
    getTeamByUserId(query: GetTeamByUserIdRequest, cancelToken?: CancelToken): Promise<GetTeamByUserIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getteambyuserid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetWaitingListActivityValidationRequest
     * @return GetWaitingListActivityValidationResponse
     */
    getWaitingListActivityValidation(query: GetWaitingListActivityValidationRequest, cancelToken?: CancelToken): Promise<GetWaitingListActivityValidationResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getwaitinglistactivityvalidation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetWaitingListSeatByIdRequest
     * @return GetWaitingListSeatByIdResponse
     */
    getWaitingListSeatById(query: GetWaitingListSeatByIdRequest, cancelToken?: CancelToken): Promise<GetWaitingListSeatByIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getwaitinglistseatbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetWaitingListSeatRoutingInfoByIdRequest
     * @return GetWaitingListSeatRoutingInfoByIdResponse
     */
    getWaitingListSeatRoutingInfoById(query: GetWaitingListSeatRoutingInfoByIdRequest, cancelToken?: CancelToken): Promise<GetWaitingListSeatRoutingInfoByIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getwaitinglistseatroutinginfobyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetWaitingListSeatsByCitizenIdRequest
     * @return GetWaitingListSeatsByCitizenIdResponse
     */
    getWaitingListSeatsByCitizenId(query: GetWaitingListSeatsByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetWaitingListSeatsByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getwaitinglistseatsbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetWaitingListSeatsByOfferIdRequest
     * @return GetWaitingListSeatsByOfferIdResponse
     */
    getWaitingListSeatsByOfferId(query: GetWaitingListSeatsByOfferIdRequest, cancelToken?: CancelToken): Promise<GetWaitingListSeatsByOfferIdResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getwaitinglistseatsbyofferid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetWizardDataForCancelActivityRequest
     * @return GetWizardDataForCancelActivityResponse
     */
    getWizardDataForCancelActivity(query: GetWizardDataForCancelActivityRequest, cancelToken?: CancelToken): Promise<GetWizardDataForCancelActivityResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getwizarddataforcancelactivity`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetWizardDataForReimbursementRequest
     * @return GetWizardDataForReimbursementResponse
     */
    getWizardDataForReimbursement(query: GetWizardDataForReimbursementRequest, cancelToken?: CancelToken): Promise<GetWizardDataForReimbursementResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/getwizarddataforreimbursement`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query HasActiveActivityByOfferCategoryRequest
     * @return HasActiveActivityByOfferCategoryResponse
     */
    hasActiveActivityByOfferCategory(query: HasActiveActivityByOfferCategoryRequest, cancelToken?: CancelToken): Promise<HasActiveActivityByOfferCategoryResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/hasactiveactivitybyoffercategory`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return IsActivityDraftEnabledResponse
     */
    isActivityDraftEnabled(cancelToken?: CancelToken): Promise<IsActivityDraftEnabledResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/isactivitydraftenabled`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query IsCreateEvaluationAvailableRequest
     * @return IsCreateEvaluationAvailableResponse
     */
    isCreateEvaluationAvailable(query: IsCreateEvaluationAvailableRequest, cancelToken?: CancelToken): Promise<IsCreateEvaluationAvailableResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/iscreateevaluationavailable`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query IsReimbursementAvailableRequest
     * @return IsReimbursementAvailableResponse
     */
    isReimbursementAvailable(query: IsReimbursementAvailableRequest, cancelToken?: CancelToken): Promise<IsReimbursementAvailableResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/isreimbursementavailable`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query ValidateCreateActivityRequest
     * @return ValidateCreateActivityResponse
     */
    validateCreateActivity(query: ValidateCreateActivityRequest, cancelToken?: CancelToken): Promise<ValidateCreateActivityResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/validatecreateactivity`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query ValidateCreateOfferRequest
     * @return ValidateCreateOfferResponse
     */
    validateCreateOffer(query: ValidateCreateOfferRequest, cancelToken?: CancelToken): Promise<ValidateCreateOfferResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/validatecreateoffer`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query ValidateUpdateActivityRequest
     * @return ValidateUpdateActivityResponse
     */
    validateUpdateActivity(query: ValidateUpdateActivityRequest, cancelToken?: CancelToken): Promise<ValidateUpdateActivityResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/validateupdateactivity`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query ValidateUpdateOfferRequest
     * @return ValidateUpdateOfferResponse
     */
    validateUpdateOffer(query: ValidateUpdateOfferRequest, cancelToken?: CancelToken): Promise<ValidateUpdateOfferResponse> {
        const $url = `${this.baseUrl}/api/offerandactivity/queries/validateupdateoffer`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IJobcenterTaskIncomingMailTasksClient {
    /**
     * @param command JournalizeIncomingMailByCitizenRequest
     * @return JournalizeIncomingMailByCitizenResponse
     */
    journalizeIncomingMailByCitizen(command: JournalizeIncomingMailByCitizenRequest, cancelToken?: CancelToken): Promise<JournalizeIncomingMailByCitizenResponse>;
    /**
     * @param command JournalizeIncomingMailByCompanyRequest
     * @return JournalizeIncomingMailByCompanyResponse
     */
    journalizeIncomingMailByCompany(command: JournalizeIncomingMailByCompanyRequest, cancelToken?: CancelToken): Promise<JournalizeIncomingMailByCompanyResponse>;
    /**
     * @param command RejectedIncomingMailTaskRequest
     * @return RejectIncomingMailTaskResponse
     */
    rejectIncomingMailTask(command: RejectedIncomingMailTaskRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query DownloadIncomingMailTaskAttachmentRequest
     * @return FileResponse
     */
    downloadIncomingMailTaskAttachment(query: DownloadIncomingMailTaskAttachmentRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetIncomingMailTaskRequest
     * @return GetIncomingMailTaskResponse
     */
    getIncomingMailTask(query: GetIncomingMailTaskRequest, cancelToken?: CancelToken): Promise<GetIncomingMailTaskResponse>;
    /**
     * @param query GetIncomingMailAttachmentsRequest
     * @return GetIncomingMailAttachmentsResponse
     */
    getIncomingMailTaskAttachments(query: GetIncomingMailAttachmentsRequest, cancelToken?: CancelToken): Promise<GetIncomingMailAttachmentsResponse>;
}

export class JobcenterTaskIncomingMailTasksClient implements IJobcenterTaskIncomingMailTasksClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command JournalizeIncomingMailByCitizenRequest
     * @return JournalizeIncomingMailByCitizenResponse
     */
    journalizeIncomingMailByCitizen(command: JournalizeIncomingMailByCitizenRequest, cancelToken?: CancelToken): Promise<JournalizeIncomingMailByCitizenResponse> {
        const $url = `${this.baseUrl}/api/jobcentertask/incomingmailtasks/commands/journalizeincomingmailbycitizen`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command JournalizeIncomingMailByCompanyRequest
     * @return JournalizeIncomingMailByCompanyResponse
     */
    journalizeIncomingMailByCompany(command: JournalizeIncomingMailByCompanyRequest, cancelToken?: CancelToken): Promise<JournalizeIncomingMailByCompanyResponse> {
        const $url = `${this.baseUrl}/api/jobcentertask/incomingmailtasks/commands/journalizeincomingmailbycompany`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RejectedIncomingMailTaskRequest
     * @return RejectIncomingMailTaskResponse
     */
    rejectIncomingMailTask(command: RejectedIncomingMailTaskRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/jobcentertask/incomingmailtasks/commands/rejectincomingmailtask`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DownloadIncomingMailTaskAttachmentRequest
     * @return FileResponse
     */
    downloadIncomingMailTaskAttachment(query: DownloadIncomingMailTaskAttachmentRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/jobcentertask/incomingmailtasks/queries/downloadincomingmailtaskattachment`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetIncomingMailTaskRequest
     * @return GetIncomingMailTaskResponse
     */
    getIncomingMailTask(query: GetIncomingMailTaskRequest, cancelToken?: CancelToken): Promise<GetIncomingMailTaskResponse> {
        const $url = `${this.baseUrl}/api/jobcentertask/incomingmailtasks/queries/getincomingmailtask`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetIncomingMailAttachmentsRequest
     * @return GetIncomingMailAttachmentsResponse
     */
    getIncomingMailTaskAttachments(query: GetIncomingMailAttachmentsRequest, cancelToken?: CancelToken): Promise<GetIncomingMailAttachmentsResponse> {
        const $url = `${this.baseUrl}/api/jobcentertask/incomingmailtasks/queries/getincomingmailtaskattachments`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IJobcenterTaskGeneralTaskClient {
    /**
     * @param command CompleteGeneralTaskRequest
     * @return CompleteGeneralTaskResponse
     */
    completeGeneralTask(command: CompleteGeneralTaskRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command JournalizeGeneralTaskOnCitizenRequest
     * @return JournalizeGeneralTaskOnCitizenResponse
     */
    journalizeGeneralTaskOnCitizen(command: JournalizeGeneralTaskOnCitizenRequest, cancelToken?: CancelToken): Promise<JournalizeGeneralTaskOnCitizenResponse>;
    /**
     * @param command JournalizeGeneralTaskOnCompanyRequest
     * @return JournalizeGeneralTaskOnCompanyResponse
     */
    journalizeGeneralTaskOnCompany(command: JournalizeGeneralTaskOnCompanyRequest, cancelToken?: CancelToken): Promise<JournalizeGeneralTaskOnCompanyResponse>;
    /**
     * @param command ReopenGeneralTaskRequest
     * @return ReopenGeneralTaskResponse
     */
    reopenGeneralTask(command: ReopenGeneralTaskRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateGeneralTaskRequest
     * @return UpdateGeneralTaskResponse
     */
    updateGeneralTask(command: UpdateGeneralTaskRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetGeneralTaskRequest
     * @return GetGeneralTaskResponse
     */
    getGeneralTask(query: GetGeneralTaskRequest, cancelToken?: CancelToken): Promise<GetGeneralTaskResponse>;
}

export class JobcenterTaskGeneralTaskClient implements IJobcenterTaskGeneralTaskClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CompleteGeneralTaskRequest
     * @return CompleteGeneralTaskResponse
     */
    completeGeneralTask(command: CompleteGeneralTaskRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/jobcentertask/generaltask/commands/completegeneraltask`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command JournalizeGeneralTaskOnCitizenRequest
     * @return JournalizeGeneralTaskOnCitizenResponse
     */
    journalizeGeneralTaskOnCitizen(command: JournalizeGeneralTaskOnCitizenRequest, cancelToken?: CancelToken): Promise<JournalizeGeneralTaskOnCitizenResponse> {
        const $url = `${this.baseUrl}/api/jobcentertask/generaltask/commands/journalizegeneraltaskoncitizen`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command JournalizeGeneralTaskOnCompanyRequest
     * @return JournalizeGeneralTaskOnCompanyResponse
     */
    journalizeGeneralTaskOnCompany(command: JournalizeGeneralTaskOnCompanyRequest, cancelToken?: CancelToken): Promise<JournalizeGeneralTaskOnCompanyResponse> {
        const $url = `${this.baseUrl}/api/jobcentertask/generaltask/commands/journalizegeneraltaskoncompany`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReopenGeneralTaskRequest
     * @return ReopenGeneralTaskResponse
     */
    reopenGeneralTask(command: ReopenGeneralTaskRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/jobcentertask/generaltask/commands/reopengeneraltask`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateGeneralTaskRequest
     * @return UpdateGeneralTaskResponse
     */
    updateGeneralTask(command: UpdateGeneralTaskRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/jobcentertask/generaltask/commands/updategeneraltask`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetGeneralTaskRequest
     * @return GetGeneralTaskResponse
     */
    getGeneralTask(query: GetGeneralTaskRequest, cancelToken?: CancelToken): Promise<GetGeneralTaskResponse> {
        const $url = `${this.baseUrl}/api/jobcentertask/generaltask/queries/getgeneraltask`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IJobcenterTaskClient {
    /**
     * @param command CompleteTasksRequest
     * @return CompleteTasksResponse
     */
    completeTasks(command: CompleteTasksRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ReassignTasksRequest
     * @return ReassignTasksResponse
     */
    reassignTasks(command: ReassignTasksRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetCompanyNoteJournalizationIdRequest
     * @return GetCompanyNoteJournalizationIdResponse
     */
    getCompanyNoteJournalizationId(query: GetCompanyNoteJournalizationIdRequest, cancelToken?: CancelToken): Promise<GetCompanyNoteJournalizationIdResponse>;
    /**
     * @param query GetJournalizationIdRequest
     * @return GetJournalizationIdResponse
     */
    getJournalizationId(query: GetJournalizationIdRequest, cancelToken?: CancelToken): Promise<GetJournalizationIdResponse>;
    /**
     * @param query GetTaskContextRequest
     * @return GetTaskContextResponse
     */
    getTaskContext(query: GetTaskContextRequest, cancelToken?: CancelToken): Promise<GetTaskContextResponse>;
}

export class JobcenterTaskClient implements IJobcenterTaskClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CompleteTasksRequest
     * @return CompleteTasksResponse
     */
    completeTasks(command: CompleteTasksRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/jobcentertask/commands/completetasks`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReassignTasksRequest
     * @return ReassignTasksResponse
     */
    reassignTasks(command: ReassignTasksRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/jobcentertask/commands/reassigntasks`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyNoteJournalizationIdRequest
     * @return GetCompanyNoteJournalizationIdResponse
     */
    getCompanyNoteJournalizationId(query: GetCompanyNoteJournalizationIdRequest, cancelToken?: CancelToken): Promise<GetCompanyNoteJournalizationIdResponse> {
        const $url = `${this.baseUrl}/api/jobcentertask/queries/getcompanynotejournalizationid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalizationIdRequest
     * @return GetJournalizationIdResponse
     */
    getJournalizationId(query: GetJournalizationIdRequest, cancelToken?: CancelToken): Promise<GetJournalizationIdResponse> {
        const $url = `${this.baseUrl}/api/jobcentertask/queries/getjournalizationid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTaskContextRequest
     * @return GetTaskContextResponse
     */
    getTaskContext(query: GetTaskContextRequest, cancelToken?: CancelToken): Promise<GetTaskContextResponse> {
        const $url = `${this.baseUrl}/api/jobcentertask/queries/gettaskcontext`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IJobAdsClient {
    /**
     * @param command CloseJobAdRequestV2
     * @return CloseJobAdResponse
     */
    closeJobAd(command: CloseJobAdRequestV2, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateJobAdRequestV2
     * @return CreateJobAdResponseV2
     */
    createJobAd(command: CreateJobAdRequestV2, cancelToken?: CancelToken): Promise<CreateJobAdResponseV2>;
    /**
     * @param command DeleteJobAdRequestV2
     * @return DeleteJobAdResponse
     */
    deleteJobAd(command: DeleteJobAdRequestV2, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateJobAdRequestV2
     * @return UpdateJobAdResponse
     */
    updateJobAd(command: UpdateJobAdRequestV2, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetCompanyMunicipalityByCompanyIdRequest
     * @return GetCompanyMunicipalityByCompanyIdResponse
     */
    getCompanyMunicipalityByCompanyId(query: GetCompanyMunicipalityByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetCompanyMunicipalityByCompanyIdResponse>;
    /**
     * @return GetCountriesResponse
     */
    getCountries(cancelToken?: CancelToken): Promise<GetCountriesResponse2>;
    /**
     * @param query GetExternalJobAdIdRequest
     * @return GetExternalJobAdIdResponse
     */
    getExternalJobAdId(query: GetExternalJobAdIdRequest, cancelToken?: CancelToken): Promise<GetExternalJobAdIdResponse>;
    /**
     * @param query GetJobAdRequestV2
     * @return GetJobAdResponseV2
     */
    getJobAd(query: GetJobAdRequestV2, cancelToken?: CancelToken): Promise<GetJobAdResponseV2>;
    /**
     * @return GetMunicipalitiesResponse
     */
    getMunicipalities(cancelToken?: CancelToken): Promise<GetMunicipalitiesResponse>;
}

export class JobAdsClient implements IJobAdsClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CloseJobAdRequestV2
     * @return CloseJobAdResponse
     */
    closeJobAd(command: CloseJobAdRequestV2, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/jobads/commands/closejobad`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateJobAdRequestV2
     * @return CreateJobAdResponseV2
     */
    createJobAd(command: CreateJobAdRequestV2, cancelToken?: CancelToken): Promise<CreateJobAdResponseV2> {
        const $url = `${this.baseUrl}/api/jobads/commands/createjobad`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteJobAdRequestV2
     * @return DeleteJobAdResponse
     */
    deleteJobAd(command: DeleteJobAdRequestV2, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/jobads/commands/deletejobad`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateJobAdRequestV2
     * @return UpdateJobAdResponse
     */
    updateJobAd(command: UpdateJobAdRequestV2, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/jobads/commands/updatejobad`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyMunicipalityByCompanyIdRequest
     * @return GetCompanyMunicipalityByCompanyIdResponse
     */
    getCompanyMunicipalityByCompanyId(query: GetCompanyMunicipalityByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetCompanyMunicipalityByCompanyIdResponse> {
        const $url = `${this.baseUrl}/api/jobads/queries/getcompanymunicipalitybycompanyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCountriesResponse
     */
    getCountries(cancelToken?: CancelToken): Promise<GetCountriesResponse2> {
        const $url = `${this.baseUrl}/api/jobads/queries/getcountries`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetExternalJobAdIdRequest
     * @return GetExternalJobAdIdResponse
     */
    getExternalJobAdId(query: GetExternalJobAdIdRequest, cancelToken?: CancelToken): Promise<GetExternalJobAdIdResponse> {
        const $url = `${this.baseUrl}/api/jobads/queries/getexternaljobadid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJobAdRequestV2
     * @return GetJobAdResponseV2
     */
    getJobAd(query: GetJobAdRequestV2, cancelToken?: CancelToken): Promise<GetJobAdResponseV2> {
        const $url = `${this.baseUrl}/api/jobads/queries/getjobad`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetMunicipalitiesResponse
     */
    getMunicipalities(cancelToken?: CancelToken): Promise<GetMunicipalitiesResponse> {
        const $url = `${this.baseUrl}/api/jobads/queries/getmunicipalities`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IForumCaseworkerClient {
    /**
     * @param command AddChatRequest
     * @return AddChatResponse
     */
    addChat(command: AddChatRequest, cancelToken?: CancelToken): Promise<AddChatResponse>;
    /**
     * @param command AddNewsItemRecipientsRequest
     * @return AddNewsItemRecipientsResponse
     */
    addNewsItemRecipients(command: AddNewsItemRecipientsRequest, cancelToken?: CancelToken): Promise<AddNewsItemRecipientsResponse>;
    /**
     * @param command CloseChatRequest
     * @return CloseChatResponse
     */
    closeChat(command: CloseChatRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CloseNewsItemRequest
     * @return CloseNewsItemResponse
     */
    closeNewsItem(command: CloseNewsItemRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateCaseworkerAbsenceRequest
     * @return CreateCaseworkerAbsenceResponse
     */
    createCaseworkerAbsence(command: CreateCaseworkerAbsenceRequest, cancelToken?: CancelToken): Promise<CreateCaseworkerAbsenceResponse>;
    /**
     * @param command CreateChatMessageRequest
     * @return CreateChatMessageResponse
     */
    createChatMessage(command: CreateChatMessageRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateNewsItemRequest
     * @return CreateNewsItemResponse
     */
    createNewsItem(command: CreateNewsItemRequest, cancelToken?: CancelToken): Promise<CreateNewsItemResponse>;
    /**
     * @param command DeleteCaseworkerAbsenceRequest
     * @return DeleteCaseworkerAbsenceResponse
     */
    deleteCaseworkerAbsence(command: DeleteCaseworkerAbsenceRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteChatMessageRequest
     * @return DeleteChatMessageResponse
     */
    deleteChatMessage(command: DeleteChatMessageRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteNewsItemRequest
     * @return DeleteNewsItemResponse
     */
    deleteNewsItem(command: DeleteNewsItemRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command JournalizeChatRequest
     * @return JournalizeChatResponse
     */
    journalizeChat(command: JournalizeChatRequest, cancelToken?: CancelToken): Promise<JournalizeChatResponse>;
    /**
     * @param command NudgeCitizensWithQuestionnaireRequest
     * @return NudgeCitizensWithQuestionnaireResponse
     */
    nudgeCitizensWithQuestionnaire(command: NudgeCitizensWithQuestionnaireRequest, cancelToken?: CancelToken): Promise<NudgeCitizensWithQuestionnaireResponse>;
    /**
     * @param command RenameChatMessageAttachmentRequest
     * @return RenameChatMessageAttachmentResponse
     */
    renameChatMessageAttachment(command: RenameChatMessageAttachmentRequest, cancelToken?: CancelToken): Promise<RenameChatMessageAttachmentResponse>;
    /**
     * @param command UpdateCaseworkerAbsenceRequest
     * @return UpdateCaseworkerAbsenceResponse
     */
    updateCaseworkerAbsence(command: UpdateCaseworkerAbsenceRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateChatTitleRequest
     * @return UpdateChatTitleResponse
     */
    updateChatTitle(command: UpdateChatTitleRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCitizenCanCreateChatsRequest
     * @return UpdateCitizenCanCreateChatsResponse
     */
    updateCitizenCanCreateChats(command: UpdateCitizenCanCreateChatsRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateNewsItemRequest
     * @return UpdateNewsItemResponse
     */
    updateNewsItem(command: UpdateNewsItemRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateNewsItemRecipientsRequest
     * @return UpdateNewsItemRecipientsResponse
     */
    updateNewsItemRecipients(command: UpdateNewsItemRecipientsRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetCaseworkerAbsencesRequest
     * @return GetCaseworkerAbsencesResponse
     */
    getCaseworkerAbsences(query: GetCaseworkerAbsencesRequest, cancelToken?: CancelToken): Promise<GetCaseworkerAbsencesResponse>;
    /**
     * @param query GetChatActivityRequest
     * @return GetChatActivityResponse
     */
    getChatActivity(query: GetChatActivityRequest, cancelToken?: CancelToken): Promise<GetChatActivityResponse>;
    /**
     * @param query GetChatAttachmentRequest
     * @return GetChatAttachmentResponse
     */
    getChatAttachment(query: GetChatAttachmentRequest, cancelToken?: CancelToken): Promise<GetChatAttachmentResponse>;
    /**
     * @param query GetChatByIdRequest
     * @return GetChatByIdResponse
     */
    getChatById(query: GetChatByIdRequest, cancelToken?: CancelToken): Promise<GetChatByIdResponse>;
    /**
     * @param query GetChatCountRequest
     * @return GetChatCountResponse
     */
    getChatCount(query: GetChatCountRequest, cancelToken?: CancelToken): Promise<GetChatCountResponse>;
    /**
     * @param query GetChatCreationOptionsRequest
     * @return GetChatCreationOptionsResponse
     */
    getChatCreationOptions(query: GetChatCreationOptionsRequest, cancelToken?: CancelToken): Promise<GetChatCreationOptionsResponse>;
    /**
     * @param query GetChatMessageDeleteInfoRequest
     * @return GetChatMessageDeleteInfoResponse
     */
    getChatMessageDeleteInfo(query: GetChatMessageDeleteInfoRequest, cancelToken?: CancelToken): Promise<GetChatMessageDeleteInfoResponse>;
    /**
     * @param query GetChatsPaginatedRequest
     * @return GetChatsPaginatedResponse
     */
    getChatsPaginated(query: GetChatsPaginatedRequest, cancelToken?: CancelToken): Promise<GetChatsPaginatedResponse>;
    /**
     * @param query GetCitizenByExternalIdRequest
     * @return GetCitizenByExternalIdResponse
     */
    getCitizenByExternalId(query: GetCitizenByExternalIdRequest, cancelToken?: CancelToken): Promise<GetCitizenByExternalIdResponse>;
    /**
     * @param query GetCitizenContextRequest
     * @return GetCitizenContextResponse
     */
    getCitizenContext(query: GetCitizenContextRequest, cancelToken?: CancelToken): Promise<GetCitizenContextResponse>;
    /**
     * @param query GetCitizensAppStatusRequest
     * @return GetCitizensAppStatusResponse
     */
    getCitizensAppStatus(query: GetCitizensAppStatusRequest, cancelToken?: CancelToken): Promise<GetCitizensAppStatusResponse>;
    /**
     * @return GetContextResponse
     */
    getContext(cancelToken?: CancelToken): Promise<GetContextResponse>;
    /**
     * @return GetForumCaseworkersResponse
     */
    getForumCaseworkers(cancelToken?: CancelToken): Promise<GetForumCaseworkersResponse>;
    /**
     * @param query GetNewChatMessagesRequest
     * @return GetNewChatMessagesResponse
     */
    getNewChatMessages(query: GetNewChatMessagesRequest, cancelToken?: CancelToken): Promise<GetNewChatMessagesResponse>;
    /**
     * @param query GetNewsItemRequest
     * @return GetNewsItemResponse
     */
    getNewsItem(query: GetNewsItemRequest, cancelToken?: CancelToken): Promise<GetNewsItemResponse>;
    /**
     * @param query GetNewsItemAttachmentRequest
     * @return GetNewsItemAttachmentResponse
     */
    getNewsItemAttachment(query: GetNewsItemAttachmentRequest, cancelToken?: CancelToken): Promise<GetNewsItemAttachmentResponse>;
    /**
     * @param query GetNewsItemRecipientsRequest
     * @return GetNewsItemRecipientsResponse
     */
    getNewsItemRecipients(query: GetNewsItemRecipientsRequest, cancelToken?: CancelToken): Promise<GetNewsItemRecipientsResponse>;
    /**
     * @return GetNewsItemsResponse
     */
    getNewsItems(cancelToken?: CancelToken): Promise<GetNewsItemsResponse>;
    /**
     * @param query GetNewsItemsForCitizenRequest
     * @return GetNewsItemsForCitizenResponse
     */
    getNewsItemsForCitizen(query: GetNewsItemsForCitizenRequest, cancelToken?: CancelToken): Promise<GetNewsItemsForCitizenResponse>;
    /**
     * @param query GetNewsItemStatisticsRequest
     * @return GetNewsItemStatisticsResponse
     */
    getNewsItemStatistics(query: GetNewsItemStatisticsRequest, cancelToken?: CancelToken): Promise<GetNewsItemStatisticsResponse>;
    /**
     * @param query GetNudgeCitizensRequest
     * @return GetNudgeCitizensResponse
     */
    getNudgeCitizens(query: GetNudgeCitizensRequest, cancelToken?: CancelToken): Promise<GetNudgeCitizensResponse>;
    /**
     * @param query GetNudgeQuestionnaireOffersRequest
     * @return GetNudgeQuestionnaireOffersResponse
     */
    getNudgeQuestionnaireOffers(query: GetNudgeQuestionnaireOffersRequest, cancelToken?: CancelToken): Promise<GetNudgeQuestionnaireOffersResponse>;
    /**
     * @return GetNudgeQuestionnairesResponse
     */
    getNudgeQuestionnaires(cancelToken?: CancelToken): Promise<GetNudgeQuestionnairesResponse>;
}

export class ForumCaseworkerClient implements IForumCaseworkerClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command AddChatRequest
     * @return AddChatResponse
     */
    addChat(command: AddChatRequest, cancelToken?: CancelToken): Promise<AddChatResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/addchat`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command AddNewsItemRecipientsRequest
     * @return AddNewsItemRecipientsResponse
     */
    addNewsItemRecipients(command: AddNewsItemRecipientsRequest, cancelToken?: CancelToken): Promise<AddNewsItemRecipientsResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/addnewsitemrecipients`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CloseChatRequest
     * @return CloseChatResponse
     */
    closeChat(command: CloseChatRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/closechat`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CloseNewsItemRequest
     * @return CloseNewsItemResponse
     */
    closeNewsItem(command: CloseNewsItemRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/closenewsitem`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCaseworkerAbsenceRequest
     * @return CreateCaseworkerAbsenceResponse
     */
    createCaseworkerAbsence(command: CreateCaseworkerAbsenceRequest, cancelToken?: CancelToken): Promise<CreateCaseworkerAbsenceResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/createcaseworkerabsence`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateChatMessageRequest
     * @return CreateChatMessageResponse
     */
    createChatMessage(command: CreateChatMessageRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/createchatmessage`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateNewsItemRequest
     * @return CreateNewsItemResponse
     */
    createNewsItem(command: CreateNewsItemRequest, cancelToken?: CancelToken): Promise<CreateNewsItemResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/createnewsitem`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteCaseworkerAbsenceRequest
     * @return DeleteCaseworkerAbsenceResponse
     */
    deleteCaseworkerAbsence(command: DeleteCaseworkerAbsenceRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/deletecaseworkerabsence`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteChatMessageRequest
     * @return DeleteChatMessageResponse
     */
    deleteChatMessage(command: DeleteChatMessageRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/deletechatmessage`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteNewsItemRequest
     * @return DeleteNewsItemResponse
     */
    deleteNewsItem(command: DeleteNewsItemRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/deletenewsitem`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command JournalizeChatRequest
     * @return JournalizeChatResponse
     */
    journalizeChat(command: JournalizeChatRequest, cancelToken?: CancelToken): Promise<JournalizeChatResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/journalizechat`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command NudgeCitizensWithQuestionnaireRequest
     * @return NudgeCitizensWithQuestionnaireResponse
     */
    nudgeCitizensWithQuestionnaire(command: NudgeCitizensWithQuestionnaireRequest, cancelToken?: CancelToken): Promise<NudgeCitizensWithQuestionnaireResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/nudgecitizenswithquestionnaire`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RenameChatMessageAttachmentRequest
     * @return RenameChatMessageAttachmentResponse
     */
    renameChatMessageAttachment(command: RenameChatMessageAttachmentRequest, cancelToken?: CancelToken): Promise<RenameChatMessageAttachmentResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/renamechatmessageattachment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCaseworkerAbsenceRequest
     * @return UpdateCaseworkerAbsenceResponse
     */
    updateCaseworkerAbsence(command: UpdateCaseworkerAbsenceRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/updatecaseworkerabsence`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateChatTitleRequest
     * @return UpdateChatTitleResponse
     */
    updateChatTitle(command: UpdateChatTitleRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/updatechattitle`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCitizenCanCreateChatsRequest
     * @return UpdateCitizenCanCreateChatsResponse
     */
    updateCitizenCanCreateChats(command: UpdateCitizenCanCreateChatsRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/updatecitizencancreatechats`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateNewsItemRequest
     * @return UpdateNewsItemResponse
     */
    updateNewsItem(command: UpdateNewsItemRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/updatenewsitem`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateNewsItemRecipientsRequest
     * @return UpdateNewsItemRecipientsResponse
     */
    updateNewsItemRecipients(command: UpdateNewsItemRecipientsRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/forum/caseworker/commands/updatenewsitemrecipients`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseworkerAbsencesRequest
     * @return GetCaseworkerAbsencesResponse
     */
    getCaseworkerAbsences(query: GetCaseworkerAbsencesRequest, cancelToken?: CancelToken): Promise<GetCaseworkerAbsencesResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getcaseworkerabsences`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetChatActivityRequest
     * @return GetChatActivityResponse
     */
    getChatActivity(query: GetChatActivityRequest, cancelToken?: CancelToken): Promise<GetChatActivityResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getchatactivity`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetChatAttachmentRequest
     * @return GetChatAttachmentResponse
     */
    getChatAttachment(query: GetChatAttachmentRequest, cancelToken?: CancelToken): Promise<GetChatAttachmentResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getchatattachment`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetChatByIdRequest
     * @return GetChatByIdResponse
     */
    getChatById(query: GetChatByIdRequest, cancelToken?: CancelToken): Promise<GetChatByIdResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getchatbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetChatCountRequest
     * @return GetChatCountResponse
     */
    getChatCount(query: GetChatCountRequest, cancelToken?: CancelToken): Promise<GetChatCountResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getchatcount`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetChatCreationOptionsRequest
     * @return GetChatCreationOptionsResponse
     */
    getChatCreationOptions(query: GetChatCreationOptionsRequest, cancelToken?: CancelToken): Promise<GetChatCreationOptionsResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getchatcreationoptions`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetChatMessageDeleteInfoRequest
     * @return GetChatMessageDeleteInfoResponse
     */
    getChatMessageDeleteInfo(query: GetChatMessageDeleteInfoRequest, cancelToken?: CancelToken): Promise<GetChatMessageDeleteInfoResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getchatmessagedeleteinfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetChatsPaginatedRequest
     * @return GetChatsPaginatedResponse
     */
    getChatsPaginated(query: GetChatsPaginatedRequest, cancelToken?: CancelToken): Promise<GetChatsPaginatedResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getchatspaginated`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenByExternalIdRequest
     * @return GetCitizenByExternalIdResponse
     */
    getCitizenByExternalId(query: GetCitizenByExternalIdRequest, cancelToken?: CancelToken): Promise<GetCitizenByExternalIdResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getcitizenbyexternalid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenContextRequest
     * @return GetCitizenContextResponse
     */
    getCitizenContext(query: GetCitizenContextRequest, cancelToken?: CancelToken): Promise<GetCitizenContextResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getcitizencontext`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizensAppStatusRequest
     * @return GetCitizensAppStatusResponse
     */
    getCitizensAppStatus(query: GetCitizensAppStatusRequest, cancelToken?: CancelToken): Promise<GetCitizensAppStatusResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getcitizensappstatus`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetContextResponse
     */
    getContext(cancelToken?: CancelToken): Promise<GetContextResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getcontext`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetForumCaseworkersResponse
     */
    getForumCaseworkers(cancelToken?: CancelToken): Promise<GetForumCaseworkersResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getforumcaseworkers`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNewChatMessagesRequest
     * @return GetNewChatMessagesResponse
     */
    getNewChatMessages(query: GetNewChatMessagesRequest, cancelToken?: CancelToken): Promise<GetNewChatMessagesResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getnewchatmessages`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNewsItemRequest
     * @return GetNewsItemResponse
     */
    getNewsItem(query: GetNewsItemRequest, cancelToken?: CancelToken): Promise<GetNewsItemResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getnewsitem`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNewsItemAttachmentRequest
     * @return GetNewsItemAttachmentResponse
     */
    getNewsItemAttachment(query: GetNewsItemAttachmentRequest, cancelToken?: CancelToken): Promise<GetNewsItemAttachmentResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getnewsitemattachment`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNewsItemRecipientsRequest
     * @return GetNewsItemRecipientsResponse
     */
    getNewsItemRecipients(query: GetNewsItemRecipientsRequest, cancelToken?: CancelToken): Promise<GetNewsItemRecipientsResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getnewsitemrecipients`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetNewsItemsResponse
     */
    getNewsItems(cancelToken?: CancelToken): Promise<GetNewsItemsResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getnewsitems`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNewsItemsForCitizenRequest
     * @return GetNewsItemsForCitizenResponse
     */
    getNewsItemsForCitizen(query: GetNewsItemsForCitizenRequest, cancelToken?: CancelToken): Promise<GetNewsItemsForCitizenResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getnewsitemsforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNewsItemStatisticsRequest
     * @return GetNewsItemStatisticsResponse
     */
    getNewsItemStatistics(query: GetNewsItemStatisticsRequest, cancelToken?: CancelToken): Promise<GetNewsItemStatisticsResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getnewsitemstatistics`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNudgeCitizensRequest
     * @return GetNudgeCitizensResponse
     */
    getNudgeCitizens(query: GetNudgeCitizensRequest, cancelToken?: CancelToken): Promise<GetNudgeCitizensResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getnudgecitizens`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNudgeQuestionnaireOffersRequest
     * @return GetNudgeQuestionnaireOffersResponse
     */
    getNudgeQuestionnaireOffers(query: GetNudgeQuestionnaireOffersRequest, cancelToken?: CancelToken): Promise<GetNudgeQuestionnaireOffersResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getnudgequestionnaireoffers`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetNudgeQuestionnairesResponse
     */
    getNudgeQuestionnaires(cancelToken?: CancelToken): Promise<GetNudgeQuestionnairesResponse> {
        const $url = `${this.baseUrl}/api/forum/caseworker/queries/getnudgequestionnaires`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IExternalOperatorClient {
    /**
     * @param command ActivateOrDeactivateExternalOperatorCompanyRequest
     * @return ActivateOrDeactivateExternalOperatorCompanyResponse
     */
    activateOrDeactivateExternalOperatorCompany(command: ActivateOrDeactivateExternalOperatorCompanyRequest, cancelToken?: CancelToken): Promise<ActivateOrDeactivateExternalOperatorCompanyResponse>;
    /**
     * @param command CancelReferralRequest
     * @return CancelReferralResponse
     */
    cancelReferral(command: CancelReferralRequest, cancelToken?: CancelToken): Promise<CancelReferralResponse>;
    /**
     * @param command CreateAgreementRequest
     * @return CreateAgreementResponse
     */
    createAgreement(command: CreateAgreementRequest, cancelToken?: CancelToken): Promise<CreateAgreementResponse>;
    /**
     * @param command CreateExternalOperatorCompanyRequest
     * @return CreateExternalOperatorCompanyResponse
     */
    createExternalOperatorCompany(command: CreateExternalOperatorCompanyRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateReferralRequest
     * @return CreateReferralResponse
     */
    createReferral(command: CreateReferralRequest, cancelToken?: CancelToken): Promise<CreateReferralResponse>;
    /**
     * @param command UpdateAgreementRequest
     * @return UpdateAgreementResponse
     */
    updateAgreement(command: UpdateAgreementRequest, cancelToken?: CancelToken): Promise<UpdateAgreementResponse>;
    /**
     * @param command UpdateAgreementCompanyRequest
     * @return UpdateAgreementCompanyResponse
     */
    updateAgreementCompany(command: UpdateAgreementCompanyRequest, cancelToken?: CancelToken): Promise<UpdateAgreementCompanyResponse>;
    /**
     * @param command UpdateAgreementResponsibilityAreasRequest
     * @return UpdateAgreementResponsibilityAreasResponse
     */
    updateAgreementResponsibilityAreas(command: UpdateAgreementResponsibilityAreasRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateExternalOperatorCompanyRequest
     * @return UpdateExternalOperatorCompanyResponse
     */
    updateExternalOperatorCompany(command: UpdateExternalOperatorCompanyRequest, cancelToken?: CancelToken): Promise<UpdateExternalOperatorCompanyResponse>;
    /**
     * @param command UpdateReferralRequest
     * @return UpdateReferralResponse
     */
    updateReferral(command: UpdateReferralRequest, cancelToken?: CancelToken): Promise<UpdateReferralResponse>;
    /**
     * @param query GetAgreementByIdRequest
     * @return GetAgreementByIdResponse
     */
    getAgreementById(query: GetAgreementByIdRequest, cancelToken?: CancelToken): Promise<GetAgreementByIdResponse>;
    /**
     * @return GetExternalOperatorAgreementsResponse
     */
    getExternalOperatorAgreements(cancelToken?: CancelToken): Promise<GetExternalOperatorAgreementsResponse>;
    /**
     * @return GetExternalOperatorAgreementsForListViewResponse
     */
    getExternalOperatorAgreementsForListView(cancelToken?: CancelToken): Promise<GetExternalOperatorAgreementsForListViewResponse>;
    /**
     * @return GetExternalOperatorAgreementsForReferralResponse
     */
    getExternalOperatorAgreementsForReferral(cancelToken?: CancelToken): Promise<GetExternalOperatorAgreementsForReferralResponse>;
    /**
     * @return GetExternalOperatorCompaniesResponse
     */
    getExternalOperatorCompanies(cancelToken?: CancelToken): Promise<GetExternalOperatorCompaniesResponse>;
    /**
     * @param query GetInitialCaseWorkerIdForCreateReferralRequest
     * @return GetInitialCaseWorkerIdForCreateReferralResponse
     */
    getInitialCaseWorkerIdForCreateReferral(query: GetInitialCaseWorkerIdForCreateReferralRequest, cancelToken?: CancelToken): Promise<GetInitialCaseWorkerIdForCreateReferralResponse>;
    /**
     * @param query GetLetterContentForExternalOperatorReferralRequest
     * @return GetLetterContentForExternalOperatorReferralResponse
     */
    getLetterContentForExternalOperatorReferral(query: GetLetterContentForExternalOperatorReferralRequest, cancelToken?: CancelToken): Promise<GetLetterContentForExternalOperatorReferralResponse>;
    /**
     * @param query GetLetterPreviewForExternalOperatorReferralRequest
     * @return FileResponse
     */
    getLetterPreviewForExternalOperatorReferral(query: GetLetterPreviewForExternalOperatorReferralRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return GetOutgoingDocumentTypesForExternalOperatorReferralResponse
     */
    getOutgoingDocumentTypesForExternalOperatorReferral(cancelToken?: CancelToken): Promise<GetOutgoingDocumentTypesForExternalOperatorReferralResponse>;
    /**
     * @param query GetReferralByIdRequest
     * @return GetReferralByIdResponse
     */
    getReferralById(query: GetReferralByIdRequest, cancelToken?: CancelToken): Promise<GetReferralByIdResponse>;
    /**
     * @param query GetReferralsByAgreementForListViewRequest
     * @return GetReferralsByAgreementForListViewResponse
     */
    getReferralsByAgreementForListView(query: GetReferralsByAgreementForListViewRequest, cancelToken?: CancelToken): Promise<GetReferralsByAgreementForListViewResponse>;
    /**
     * @param query GetReferralsForListViewRequest
     * @return GetReferralsForListViewResponse
     */
    getReferralsForListView(query: GetReferralsForListViewRequest, cancelToken?: CancelToken): Promise<GetReferralsForListViewResponse>;
    /**
     * @return GetResponsibilityAreasResponse
     */
    getResponsibilityAreas(cancelToken?: CancelToken): Promise<GetResponsibilityAreasResponse>;
}

export class ExternalOperatorClient implements IExternalOperatorClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command ActivateOrDeactivateExternalOperatorCompanyRequest
     * @return ActivateOrDeactivateExternalOperatorCompanyResponse
     */
    activateOrDeactivateExternalOperatorCompany(command: ActivateOrDeactivateExternalOperatorCompanyRequest, cancelToken?: CancelToken): Promise<ActivateOrDeactivateExternalOperatorCompanyResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/commands/activateordeactivateexternaloperatorcompany`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CancelReferralRequest
     * @return CancelReferralResponse
     */
    cancelReferral(command: CancelReferralRequest, cancelToken?: CancelToken): Promise<CancelReferralResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/commands/cancelreferral`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAgreementRequest
     * @return CreateAgreementResponse
     */
    createAgreement(command: CreateAgreementRequest, cancelToken?: CancelToken): Promise<CreateAgreementResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/commands/createagreement`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateExternalOperatorCompanyRequest
     * @return CreateExternalOperatorCompanyResponse
     */
    createExternalOperatorCompany(command: CreateExternalOperatorCompanyRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/externaloperator/commands/createexternaloperatorcompany`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateReferralRequest
     * @return CreateReferralResponse
     */
    createReferral(command: CreateReferralRequest, cancelToken?: CancelToken): Promise<CreateReferralResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/commands/createreferral`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAgreementRequest
     * @return UpdateAgreementResponse
     */
    updateAgreement(command: UpdateAgreementRequest, cancelToken?: CancelToken): Promise<UpdateAgreementResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/commands/updateagreement`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAgreementCompanyRequest
     * @return UpdateAgreementCompanyResponse
     */
    updateAgreementCompany(command: UpdateAgreementCompanyRequest, cancelToken?: CancelToken): Promise<UpdateAgreementCompanyResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/commands/updateagreementcompany`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAgreementResponsibilityAreasRequest
     * @return UpdateAgreementResponsibilityAreasResponse
     */
    updateAgreementResponsibilityAreas(command: UpdateAgreementResponsibilityAreasRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/externaloperator/commands/updateagreementresponsibilityareas`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateExternalOperatorCompanyRequest
     * @return UpdateExternalOperatorCompanyResponse
     */
    updateExternalOperatorCompany(command: UpdateExternalOperatorCompanyRequest, cancelToken?: CancelToken): Promise<UpdateExternalOperatorCompanyResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/commands/updateexternaloperatorcompany`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateReferralRequest
     * @return UpdateReferralResponse
     */
    updateReferral(command: UpdateReferralRequest, cancelToken?: CancelToken): Promise<UpdateReferralResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/commands/updatereferral`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAgreementByIdRequest
     * @return GetAgreementByIdResponse
     */
    getAgreementById(query: GetAgreementByIdRequest, cancelToken?: CancelToken): Promise<GetAgreementByIdResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/queries/getagreementbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetExternalOperatorAgreementsResponse
     */
    getExternalOperatorAgreements(cancelToken?: CancelToken): Promise<GetExternalOperatorAgreementsResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/queries/getexternaloperatoragreements`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetExternalOperatorAgreementsForListViewResponse
     */
    getExternalOperatorAgreementsForListView(cancelToken?: CancelToken): Promise<GetExternalOperatorAgreementsForListViewResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/queries/getexternaloperatoragreementsforlistview`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetExternalOperatorAgreementsForReferralResponse
     */
    getExternalOperatorAgreementsForReferral(cancelToken?: CancelToken): Promise<GetExternalOperatorAgreementsForReferralResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/queries/getexternaloperatoragreementsforreferral`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetExternalOperatorCompaniesResponse
     */
    getExternalOperatorCompanies(cancelToken?: CancelToken): Promise<GetExternalOperatorCompaniesResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/queries/getexternaloperatorcompanies`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInitialCaseWorkerIdForCreateReferralRequest
     * @return GetInitialCaseWorkerIdForCreateReferralResponse
     */
    getInitialCaseWorkerIdForCreateReferral(query: GetInitialCaseWorkerIdForCreateReferralRequest, cancelToken?: CancelToken): Promise<GetInitialCaseWorkerIdForCreateReferralResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/queries/getinitialcaseworkeridforcreatereferral`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLetterContentForExternalOperatorReferralRequest
     * @return GetLetterContentForExternalOperatorReferralResponse
     */
    getLetterContentForExternalOperatorReferral(query: GetLetterContentForExternalOperatorReferralRequest, cancelToken?: CancelToken): Promise<GetLetterContentForExternalOperatorReferralResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/queries/getlettercontentforexternaloperatorreferral`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLetterPreviewForExternalOperatorReferralRequest
     * @return FileResponse
     */
    getLetterPreviewForExternalOperatorReferral(query: GetLetterPreviewForExternalOperatorReferralRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/queries/getletterpreviewforexternaloperatorreferral`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @return GetOutgoingDocumentTypesForExternalOperatorReferralResponse
     */
    getOutgoingDocumentTypesForExternalOperatorReferral(cancelToken?: CancelToken): Promise<GetOutgoingDocumentTypesForExternalOperatorReferralResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/queries/getoutgoingdocumenttypesforexternaloperatorreferral`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetReferralByIdRequest
     * @return GetReferralByIdResponse
     */
    getReferralById(query: GetReferralByIdRequest, cancelToken?: CancelToken): Promise<GetReferralByIdResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/queries/getreferralbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetReferralsByAgreementForListViewRequest
     * @return GetReferralsByAgreementForListViewResponse
     */
    getReferralsByAgreementForListView(query: GetReferralsByAgreementForListViewRequest, cancelToken?: CancelToken): Promise<GetReferralsByAgreementForListViewResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/queries/getreferralsbyagreementforlistview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetReferralsForListViewRequest
     * @return GetReferralsForListViewResponse
     */
    getReferralsForListView(query: GetReferralsForListViewRequest, cancelToken?: CancelToken): Promise<GetReferralsForListViewResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/queries/getreferralsforlistview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetResponsibilityAreasResponse
     */
    getResponsibilityAreas(cancelToken?: CancelToken): Promise<GetResponsibilityAreasResponse> {
        const $url = `${this.baseUrl}/api/externaloperator/queries/getresponsibilityareas`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IDstIntegrationClient {
    /**
     * @param command ShipFilingDeliveryRequest
     * @return ShipFilingDeliveryResponse
     */
    shipFilingDelivery(command: ShipFilingDeliveryRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command StartFilingDeliveryRequest
     * @return StartFilingDeliveryResponse
     */
    startFilingDelivery(command: StartFilingDeliveryRequest, cancelToken?: CancelToken): Promise<StartFilingDeliveryResponse>;
    /**
     * @param query DownloadGeneratedFileRequest
     * @return FileResponse
     */
    downloadGeneratedFile(query: DownloadGeneratedFileRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return GetFilingDeliveriesResponse
     */
    getFilingDeliveries(cancelToken?: CancelToken): Promise<GetFilingDeliveriesResponse>;
    /**
     * @param query GetFilingDeliveryRequest
     * @return GetFilingDeliveryResponse
     */
    getFilingDelivery(query: GetFilingDeliveryRequest, cancelToken?: CancelToken): Promise<GetFilingDeliveryResponse>;
    /**
     * @param query GetHandicapDeliveryRequest
     * @return GetHandicapDeliveryResponse
     */
    getHandicapDelivery(query: GetHandicapDeliveryRequest, cancelToken?: CancelToken): Promise<GetHandicapDeliveryResponse>;
}

export class DstIntegrationClient implements IDstIntegrationClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command ShipFilingDeliveryRequest
     * @return ShipFilingDeliveryResponse
     */
    shipFilingDelivery(command: ShipFilingDeliveryRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/dstintegration/commands/shipfilingdelivery`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command StartFilingDeliveryRequest
     * @return StartFilingDeliveryResponse
     */
    startFilingDelivery(command: StartFilingDeliveryRequest, cancelToken?: CancelToken): Promise<StartFilingDeliveryResponse> {
        const $url = `${this.baseUrl}/api/dstintegration/commands/startfilingdelivery`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DownloadGeneratedFileRequest
     * @return FileResponse
     */
    downloadGeneratedFile(query: DownloadGeneratedFileRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/dstintegration/queries/downloadgeneratedfile`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @return GetFilingDeliveriesResponse
     */
    getFilingDeliveries(cancelToken?: CancelToken): Promise<GetFilingDeliveriesResponse> {
        const $url = `${this.baseUrl}/api/dstintegration/queries/getfilingdeliveries`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetFilingDeliveryRequest
     * @return GetFilingDeliveryResponse
     */
    getFilingDelivery(query: GetFilingDeliveryRequest, cancelToken?: CancelToken): Promise<GetFilingDeliveryResponse> {
        const $url = `${this.baseUrl}/api/dstintegration/queries/getfilingdelivery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHandicapDeliveryRequest
     * @return GetHandicapDeliveryResponse
     */
    getHandicapDelivery(query: GetHandicapDeliveryRequest, cancelToken?: CancelToken): Promise<GetHandicapDeliveryResponse> {
        const $url = `${this.baseUrl}/api/dstintegration/queries/gethandicapdelivery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyTradeCodesClient {
    /**
     * @param command DeleteTradeCodesRequest
     * @return DeleteTradeCodesResponse
     */
    deleteTradeCodes(command: DeleteTradeCodesRequest, cancelToken?: CancelToken): Promise<DeleteTradeCodesResponse>;
    /**
     * @param command UpsertTradeCodesRequest
     * @return UpsertTradeCodesResponse
     */
    upsertTradeCodes(command: UpsertTradeCodesRequest, cancelToken?: CancelToken): Promise<UpsertTradeCodesResponse>;
    /**
     * @return GetTradeCodeOptionsResponse
     */
    getTradeCodeOptions(cancelToken?: CancelToken): Promise<GetTradeCodeOptionsResponse>;
    /**
     * @param query GetTradeCodesRequest
     * @return GetTradeCodesResponse
     */
    getTradeCodes(query: GetTradeCodesRequest, cancelToken?: CancelToken): Promise<GetTradeCodesResponse>;
}

export class CompanyTradeCodesClient implements ICompanyTradeCodesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command DeleteTradeCodesRequest
     * @return DeleteTradeCodesResponse
     */
    deleteTradeCodes(command: DeleteTradeCodesRequest, cancelToken?: CancelToken): Promise<DeleteTradeCodesResponse> {
        const $url = `${this.baseUrl}/api/company/tradecodes/commands/deletetradecodes`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpsertTradeCodesRequest
     * @return UpsertTradeCodesResponse
     */
    upsertTradeCodes(command: UpsertTradeCodesRequest, cancelToken?: CancelToken): Promise<UpsertTradeCodesResponse> {
        const $url = `${this.baseUrl}/api/company/tradecodes/commands/upserttradecodes`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTradeCodeOptionsResponse
     */
    getTradeCodeOptions(cancelToken?: CancelToken): Promise<GetTradeCodeOptionsResponse> {
        const $url = `${this.baseUrl}/api/company/tradecodes/queries/gettradecodeoptions`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTradeCodesRequest
     * @return GetTradeCodesResponse
     */
    getTradeCodes(query: GetTradeCodesRequest, cancelToken?: CancelToken): Promise<GetTradeCodesResponse> {
        const $url = `${this.baseUrl}/api/company/tradecodes/queries/gettradecodes`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyTagsClient {
    /**
     * @param command DeleteTagRequest
     * @return DeleteTagResponse
     */
    deleteTag(command: DeleteTagRequest, cancelToken?: CancelToken): Promise<DeleteTagResponse>;
    /**
     * @param command UpsertTagRequest
     * @return UpsertTagResponse
     */
    upsertTag(command: UpsertTagRequest, cancelToken?: CancelToken): Promise<UpsertTagResponse>;
    /**
     * @param command UpsertTagsRequest
     * @return UpsertTagsResponse
     */
    upsertTags(command: UpsertTagsRequest, cancelToken?: CancelToken): Promise<UpsertTagsResponse>;
    /**
     * @param query GetCompanyIdByTagIdRequest
     * @return GetCompanyIdByTagIdResponse
     */
    getCompanyIdByTagId(query: GetCompanyIdByTagIdRequest, cancelToken?: CancelToken): Promise<GetCompanyIdByTagIdResponse>;
    /**
     * @param query GetTagRequest
     * @return GetTagResponse
     */
    getTag(query: GetTagRequest, cancelToken?: CancelToken): Promise<GetTagResponse>;
    /**
     * @param query GetTagsRequest
     * @return GetTagsResponse
     */
    getTags(query: GetTagsRequest, cancelToken?: CancelToken): Promise<GetTagsResponse>;
    /**
     * @return GetTagTypeOptionsResponse
     */
    getTagTypeOptions(cancelToken?: CancelToken): Promise<GetTagTypeOptionsResponse>;
}

export class CompanyTagsClient implements ICompanyTagsClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command DeleteTagRequest
     * @return DeleteTagResponse
     */
    deleteTag(command: DeleteTagRequest, cancelToken?: CancelToken): Promise<DeleteTagResponse> {
        const $url = `${this.baseUrl}/api/company/tags/commands/deletetag`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpsertTagRequest
     * @return UpsertTagResponse
     */
    upsertTag(command: UpsertTagRequest, cancelToken?: CancelToken): Promise<UpsertTagResponse> {
        const $url = `${this.baseUrl}/api/company/tags/commands/upserttag`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpsertTagsRequest
     * @return UpsertTagsResponse
     */
    upsertTags(command: UpsertTagsRequest, cancelToken?: CancelToken): Promise<UpsertTagsResponse> {
        const $url = `${this.baseUrl}/api/company/tags/commands/upserttags`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyIdByTagIdRequest
     * @return GetCompanyIdByTagIdResponse
     */
    getCompanyIdByTagId(query: GetCompanyIdByTagIdRequest, cancelToken?: CancelToken): Promise<GetCompanyIdByTagIdResponse> {
        const $url = `${this.baseUrl}/api/company/tags/queries/getcompanyidbytagid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTagRequest
     * @return GetTagResponse
     */
    getTag(query: GetTagRequest, cancelToken?: CancelToken): Promise<GetTagResponse> {
        const $url = `${this.baseUrl}/api/company/tags/queries/gettag`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTagsRequest
     * @return GetTagsResponse
     */
    getTags(query: GetTagsRequest, cancelToken?: CancelToken): Promise<GetTagsResponse> {
        const $url = `${this.baseUrl}/api/company/tags/queries/gettags`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTagTypeOptionsResponse
     */
    getTagTypeOptions(cancelToken?: CancelToken): Promise<GetTagTypeOptionsResponse> {
        const $url = `${this.baseUrl}/api/company/tags/queries/gettagtypeoptions`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanySpecialCircumstanceClient {
    /**
     * @param command DeleteSpecialCircumstanceRequest
     * @return DeleteSpecialCircumstanceResponse
     */
    deleteSpecialCircumstance(command: DeleteSpecialCircumstanceRequest, cancelToken?: CancelToken): Promise<DeleteSpecialCircumstanceResponse>;
    /**
     * @param command DeleteSpecialCircumstanceTargetGroupRequest
     * @return DeleteSpecialCircumstanceTargetGroupResponse
     */
    deleteSpecialCircumstanceTargetGroup(command: DeleteSpecialCircumstanceTargetGroupRequest, cancelToken?: CancelToken): Promise<DeleteSpecialCircumstanceTargetGroupResponse>;
    /**
     * @param command UpsertTaskSpecialCircumstanceRequest
     * @return UpsertTaskSpecialCircumstanceResponse
     */
    upsertSpecialCircumstance(command: UpsertTaskSpecialCircumstanceRequest, cancelToken?: CancelToken): Promise<UpsertTaskSpecialCircumstanceResponse>;
    /**
     * @param command UpsertSpecialCircumstanceTargetGroupRequest
     * @return UpsertSpecialCircumstanceTargetGroupResponse
     */
    upsertSpecialCircumstanceTargetGroup(command: UpsertSpecialCircumstanceTargetGroupRequest, cancelToken?: CancelToken): Promise<UpsertSpecialCircumstanceTargetGroupResponse>;
    /**
     * @param command UpsertSpecialCircumstanceTargetGroupsRequest
     * @return UpsertSpecialCircumstanceTargetGroupsResponse
     */
    upsertSpecialCircumstanceTargetGroups(command: UpsertSpecialCircumstanceTargetGroupsRequest, cancelToken?: CancelToken): Promise<UpsertSpecialCircumstanceTargetGroupsResponse>;
    /**
     * @param query CheckSpecialCircumstanceForOverlapRequest
     * @return CheckSpecialCircumstanceForOverlapResponse
     */
    checkSpecialCircumstanceForOverlap(query: CheckSpecialCircumstanceForOverlapRequest, cancelToken?: CancelToken): Promise<CheckSpecialCircumstanceForOverlapResponse>;
    /**
     * @param query GetCompanyIdBySpecialCircumstanceIdRequest
     * @return GetCompanyIdBySpecialCircumstanceIdResponse
     */
    getCompanyIdBySpecialCircumstanceId(query: GetCompanyIdBySpecialCircumstanceIdRequest, cancelToken?: CancelToken): Promise<GetCompanyIdBySpecialCircumstanceIdResponse>;
    /**
     * @return GetCrmHostResponse
     */
    getCrmHost(cancelToken?: CancelToken): Promise<GetCrmHostResponse>;
    /**
     * @param query GetSpecialCircumstanceRequest
     * @return GetSpecialCircumstanceResponse
     */
    getSpecialCircumstance(query: GetSpecialCircumstanceRequest, cancelToken?: CancelToken): Promise<GetSpecialCircumstanceResponse>;
    /**
     * @return GetSpecialCircumstanceContactGroupAndTargetGroupOptionsResponse
     */
    getSpecialCircumstanceContactGroupAndTargetGroupOptions(cancelToken?: CancelToken): Promise<GetSpecialCircumstanceContactGroupAndTargetGroupOptionsResponse>;
    /**
     * @param query GetSpecialCircumstanceDocumentsFromDocumentArchiveRequest
     * @return GetSpecialCircumstanceDocumentsFromDocumentArchiveResponse
     */
    getSpecialCircumstanceDocumentsFromDocumentArchive(query: GetSpecialCircumstanceDocumentsFromDocumentArchiveRequest, cancelToken?: CancelToken): Promise<GetSpecialCircumstanceDocumentsFromDocumentArchiveResponse>;
    /**
     * @param query GetSpecialCircumstanceDocumentsFromShelfInDocumentArchiveRequest
     * @return GetSpecialCircumstanceDocumentsFromShelfInDocumentArchiveResponse
     */
    getSpecialCircumstanceDocumentsFromShelfInDocumentArchive(query: GetSpecialCircumstanceDocumentsFromShelfInDocumentArchiveRequest, cancelToken?: CancelToken): Promise<GetSpecialCircumstanceDocumentsFromShelfInDocumentArchiveResponse>;
    /**
     * @param query GetSpecialCircumstancesRequest
     * @return GetSpecialCircumstancesResponse
     */
    getSpecialCircumstances(query: GetSpecialCircumstancesRequest, cancelToken?: CancelToken): Promise<GetSpecialCircumstancesResponse>;
    /**
     * @param query GetSpecialCircumstanceTargetGroupRequest
     * @return GetSpecialCircumstanceTargetGroupResponse
     */
    getSpecialCircumstanceTargetGroup(query: GetSpecialCircumstanceTargetGroupRequest, cancelToken?: CancelToken): Promise<GetSpecialCircumstanceTargetGroupResponse>;
    /**
     * @param query GetSpecialCircumstanceTargetGroupsRequest
     * @return GetSpecialCircumstanceTargetGroupsResponse
     */
    getSpecialCircumstanceTargetGroups(query: GetSpecialCircumstanceTargetGroupsRequest, cancelToken?: CancelToken): Promise<GetSpecialCircumstanceTargetGroupsResponse>;
    /**
     * @param query ValidateCircumstanceForOverlapRequest
     * @return ValidateCircumstanceForOverlapResponse
     */
    validateCircumstanceForOverlap(query: ValidateCircumstanceForOverlapRequest, cancelToken?: CancelToken): Promise<ValidateCircumstanceForOverlapResponse>;
}

export class CompanySpecialCircumstanceClient implements ICompanySpecialCircumstanceClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command DeleteSpecialCircumstanceRequest
     * @return DeleteSpecialCircumstanceResponse
     */
    deleteSpecialCircumstance(command: DeleteSpecialCircumstanceRequest, cancelToken?: CancelToken): Promise<DeleteSpecialCircumstanceResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/commands/deletespecialcircumstance`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteSpecialCircumstanceTargetGroupRequest
     * @return DeleteSpecialCircumstanceTargetGroupResponse
     */
    deleteSpecialCircumstanceTargetGroup(command: DeleteSpecialCircumstanceTargetGroupRequest, cancelToken?: CancelToken): Promise<DeleteSpecialCircumstanceTargetGroupResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/commands/deletespecialcircumstancetargetgroup`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpsertTaskSpecialCircumstanceRequest
     * @return UpsertTaskSpecialCircumstanceResponse
     */
    upsertSpecialCircumstance(command: UpsertTaskSpecialCircumstanceRequest, cancelToken?: CancelToken): Promise<UpsertTaskSpecialCircumstanceResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/commands/upsertspecialcircumstance`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpsertSpecialCircumstanceTargetGroupRequest
     * @return UpsertSpecialCircumstanceTargetGroupResponse
     */
    upsertSpecialCircumstanceTargetGroup(command: UpsertSpecialCircumstanceTargetGroupRequest, cancelToken?: CancelToken): Promise<UpsertSpecialCircumstanceTargetGroupResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/commands/upsertspecialcircumstancetargetgroup`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpsertSpecialCircumstanceTargetGroupsRequest
     * @return UpsertSpecialCircumstanceTargetGroupsResponse
     */
    upsertSpecialCircumstanceTargetGroups(command: UpsertSpecialCircumstanceTargetGroupsRequest, cancelToken?: CancelToken): Promise<UpsertSpecialCircumstanceTargetGroupsResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/commands/upsertspecialcircumstancetargetgroups`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query CheckSpecialCircumstanceForOverlapRequest
     * @return CheckSpecialCircumstanceForOverlapResponse
     */
    checkSpecialCircumstanceForOverlap(query: CheckSpecialCircumstanceForOverlapRequest, cancelToken?: CancelToken): Promise<CheckSpecialCircumstanceForOverlapResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/queries/checkspecialcircumstanceforoverlap`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyIdBySpecialCircumstanceIdRequest
     * @return GetCompanyIdBySpecialCircumstanceIdResponse
     */
    getCompanyIdBySpecialCircumstanceId(query: GetCompanyIdBySpecialCircumstanceIdRequest, cancelToken?: CancelToken): Promise<GetCompanyIdBySpecialCircumstanceIdResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/queries/getcompanyidbyspecialcircumstanceid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCrmHostResponse
     */
    getCrmHost(cancelToken?: CancelToken): Promise<GetCrmHostResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/queries/getcrmhost`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSpecialCircumstanceRequest
     * @return GetSpecialCircumstanceResponse
     */
    getSpecialCircumstance(query: GetSpecialCircumstanceRequest, cancelToken?: CancelToken): Promise<GetSpecialCircumstanceResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/queries/getspecialcircumstance`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSpecialCircumstanceContactGroupAndTargetGroupOptionsResponse
     */
    getSpecialCircumstanceContactGroupAndTargetGroupOptions(cancelToken?: CancelToken): Promise<GetSpecialCircumstanceContactGroupAndTargetGroupOptionsResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/queries/getspecialcircumstancecontactgroupandtargetgroupoptions`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSpecialCircumstanceDocumentsFromDocumentArchiveRequest
     * @return GetSpecialCircumstanceDocumentsFromDocumentArchiveResponse
     */
    getSpecialCircumstanceDocumentsFromDocumentArchive(query: GetSpecialCircumstanceDocumentsFromDocumentArchiveRequest, cancelToken?: CancelToken): Promise<GetSpecialCircumstanceDocumentsFromDocumentArchiveResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/queries/getspecialcircumstancedocumentsfromdocumentarchive`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSpecialCircumstanceDocumentsFromShelfInDocumentArchiveRequest
     * @return GetSpecialCircumstanceDocumentsFromShelfInDocumentArchiveResponse
     */
    getSpecialCircumstanceDocumentsFromShelfInDocumentArchive(query: GetSpecialCircumstanceDocumentsFromShelfInDocumentArchiveRequest, cancelToken?: CancelToken): Promise<GetSpecialCircumstanceDocumentsFromShelfInDocumentArchiveResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/queries/getspecialcircumstancedocumentsfromshelfindocumentarchive`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSpecialCircumstancesRequest
     * @return GetSpecialCircumstancesResponse
     */
    getSpecialCircumstances(query: GetSpecialCircumstancesRequest, cancelToken?: CancelToken): Promise<GetSpecialCircumstancesResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/queries/getspecialcircumstances`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSpecialCircumstanceTargetGroupRequest
     * @return GetSpecialCircumstanceTargetGroupResponse
     */
    getSpecialCircumstanceTargetGroup(query: GetSpecialCircumstanceTargetGroupRequest, cancelToken?: CancelToken): Promise<GetSpecialCircumstanceTargetGroupResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/queries/getspecialcircumstancetargetgroup`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSpecialCircumstanceTargetGroupsRequest
     * @return GetSpecialCircumstanceTargetGroupsResponse
     */
    getSpecialCircumstanceTargetGroups(query: GetSpecialCircumstanceTargetGroupsRequest, cancelToken?: CancelToken): Promise<GetSpecialCircumstanceTargetGroupsResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/queries/getspecialcircumstancetargetgroups`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query ValidateCircumstanceForOverlapRequest
     * @return ValidateCircumstanceForOverlapResponse
     */
    validateCircumstanceForOverlap(query: ValidateCircumstanceForOverlapRequest, cancelToken?: CancelToken): Promise<ValidateCircumstanceForOverlapResponse> {
        const $url = `${this.baseUrl}/api/company/specialcircumstance/queries/validatecircumstanceforoverlap`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyNotesClient {
    /**
     * @param command LinkCompanyNoteToJournalNoteRequest
     * @return LinkCompanyNoteToJournalNoteResponse
     */
    linkCompanyNoteToJournalNote(command: LinkCompanyNoteToJournalNoteRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command QueueCompanyDialogPartialTranscriptionRequest
     * @return QueueCompanyDialogPartialTranscriptionResponse
     */
    queueCompanyDialogPartialTranscription(command: QueueCompanyDialogPartialTranscriptionRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query DraftCompanyDialogCitizenNoteRequest
     * @return DraftCompanyDialogCitizenNoteResponse
     */
    draftCompanyDialogCitizenNote(query: DraftCompanyDialogCitizenNoteRequest, cancelToken?: CancelToken): Promise<DraftCompanyDialogCitizenNoteResponse>;
    /**
     * @param query EvaluateCompanyDialogDraftRequest
     * @return EvaluateCompanyDialogDraftResponse
     */
    evaluateCompanyDialogDraft(query: EvaluateCompanyDialogDraftRequest, cancelToken?: CancelToken): Promise<EvaluateCompanyDialogDraftResponse>;
    /**
     * @param query ExtractCompanyDialogTasksRequest
     * @return ExtractCompanyDialogTasksResponse
     */
    extractCompanyDialogTasks(query: ExtractCompanyDialogTasksRequest, cancelToken?: CancelToken): Promise<ExtractCompanyDialogTasksResponse>;
    /**
     * @param query GetAppointmentByIdForNoteRequest
     * @return GetAppointmentByIdForNoteResponse
     */
    getAppointmentByIdForNote(query: GetAppointmentByIdForNoteRequest, cancelToken?: CancelToken): Promise<GetAppointmentByIdForNoteResponse>;
    /**
     * @param query GetCompanyByCompanyNoteIdRequest
     * @return GetCompanyByCompanyNoteIdResponse
     */
    getCompanyByCompanyNoteId(query: GetCompanyByCompanyNoteIdRequest, cancelToken?: CancelToken): Promise<GetCompanyByCompanyNoteIdResponse>;
    /**
     * @param query GetCompanyDialogCitizenSuggestionsRequest
     * @return GetCompanyDialogCitizenSuggestionsResponse
     */
    getCompanyDialogCitizenSuggestions(query: GetCompanyDialogCitizenSuggestionsRequest, cancelToken?: CancelToken): Promise<GetCompanyDialogCitizenSuggestionsResponse>;
    /**
     * @return GetCompanyDialogPromptResponse
     */
    getCompanyDialogPrompt(cancelToken?: CancelToken): Promise<GetCompanyDialogPromptResponse>;
    /**
     * @param query GetCompanyDialogTranscriptionBySessionIdRequest
     * @return GetCompanyDialogTranscriptionBySessionIdResponse
     */
    getCompanyDialogTranscriptionBySessionId(query: GetCompanyDialogTranscriptionBySessionIdRequest, cancelToken?: CancelToken): Promise<GetCompanyDialogTranscriptionBySessionIdResponse>;
    /**
     * @param query GetCompanyNoteDataRequest
     * @return GetCompanyNoteDataResponse
     */
    getCompanyInteractionNoteById(query: GetCompanyNoteDataRequest, cancelToken?: CancelToken): Promise<GetCompanyNoteDataResponse>;
    /**
     * @param query GetCompanyInteractionNotesRequest
     * @return GetCompanyInteractionNotesResponse
     */
    getCompanyInteractionNotes(query: GetCompanyInteractionNotesRequest, cancelToken?: CancelToken): Promise<GetCompanyInteractionNotesResponse>;
    /**
     * @param query GetCompanyNoteDispatchStatusRequest
     * @return GetCompanyNoteDispatchStatusResponse
     */
    getCompanyNoteDispatchStatus(query: GetCompanyNoteDispatchStatusRequest, cancelToken?: CancelToken): Promise<GetCompanyNoteDispatchStatusResponse>;
    /**
     * @param query GetCompanyNoteDocumentsFromShelfInDocumentArchiveRequest
     * @return GetCompanyNoteDocumentsFromShelfInDocumentArchiveResponse
     */
    getCompanyNoteDocumentsFromShelfInDocumentArchive(query: GetCompanyNoteDocumentsFromShelfInDocumentArchiveRequest, cancelToken?: CancelToken): Promise<GetCompanyNoteDocumentsFromShelfInDocumentArchiveResponse>;
    /**
     * @param query GetCompanyNoteTitleRequest
     * @return GetCompanyNoteTitleResponse
     */
    getCompanyNoteTitle(query: GetCompanyNoteTitleRequest, cancelToken?: CancelToken): Promise<GetCompanyNoteTitleResponse>;
    /**
     * @param query GetCopanyNoteDocumentsFromDocumentArchiveRequest
     * @return GetCopanyNoteDocumentsFromDocumentArchiveResponse
     */
    getCopanyNoteDocumentsFromDocumentArchive(query: GetCopanyNoteDocumentsFromDocumentArchiveRequest, cancelToken?: CancelToken): Promise<GetCopanyNoteDocumentsFromDocumentArchiveResponse>;
    /**
     * @param query GetNoteFormDataRequest
     * @return GetNoteFormDataResponse
     */
    getNoteFormData(query: GetNoteFormDataRequest, cancelToken?: CancelToken): Promise<GetNoteFormDataResponse>;
    /**
     * @return GetWysiwygEditorTemplateContentResponse
     */
    getWysiwygEditorTemplateContent(cancelToken?: CancelToken): Promise<GetWysiwygEditorTemplateContentResponse>;
    /**
     * @param query SummarizeCompanyDialogRequest
     * @return SummarizeCompanyDialogResponse
     */
    summarizeCompanyDialog(query: SummarizeCompanyDialogRequest, cancelToken?: CancelToken): Promise<SummarizeCompanyDialogResponse>;
    /**
     * @param query DeleteCompanyInteractionNoteRequest
     * @return DeleteCompanyInteractionNoteResponse
     */
    deleteCompanyInteractionNote(query: DeleteCompanyInteractionNoteRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query UpsertCompanyInteractionNoteRequest
     * @return UpsertCompanyInteractionNoteResponse
     */
    upsertCompanyInteractionNote(query: UpsertCompanyInteractionNoteRequest, cancelToken?: CancelToken): Promise<UpsertCompanyInteractionNoteResponse>;
}

export class CompanyNotesClient implements ICompanyNotesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command LinkCompanyNoteToJournalNoteRequest
     * @return LinkCompanyNoteToJournalNoteResponse
     */
    linkCompanyNoteToJournalNote(command: LinkCompanyNoteToJournalNoteRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/company/notes/commands/linkcompanynotetojournalnote`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command QueueCompanyDialogPartialTranscriptionRequest
     * @return QueueCompanyDialogPartialTranscriptionResponse
     */
    queueCompanyDialogPartialTranscription(command: QueueCompanyDialogPartialTranscriptionRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/company/notes/commands/queuecompanydialogpartialtranscription`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DraftCompanyDialogCitizenNoteRequest
     * @return DraftCompanyDialogCitizenNoteResponse
     */
    draftCompanyDialogCitizenNote(query: DraftCompanyDialogCitizenNoteRequest, cancelToken?: CancelToken): Promise<DraftCompanyDialogCitizenNoteResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/draftcompanydialogcitizennote`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query EvaluateCompanyDialogDraftRequest
     * @return EvaluateCompanyDialogDraftResponse
     */
    evaluateCompanyDialogDraft(query: EvaluateCompanyDialogDraftRequest, cancelToken?: CancelToken): Promise<EvaluateCompanyDialogDraftResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/evaluatecompanydialogdraft`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query ExtractCompanyDialogTasksRequest
     * @return ExtractCompanyDialogTasksResponse
     */
    extractCompanyDialogTasks(query: ExtractCompanyDialogTasksRequest, cancelToken?: CancelToken): Promise<ExtractCompanyDialogTasksResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/extractcompanydialogtasks`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAppointmentByIdForNoteRequest
     * @return GetAppointmentByIdForNoteResponse
     */
    getAppointmentByIdForNote(query: GetAppointmentByIdForNoteRequest, cancelToken?: CancelToken): Promise<GetAppointmentByIdForNoteResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/getappointmentbyidfornote`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyByCompanyNoteIdRequest
     * @return GetCompanyByCompanyNoteIdResponse
     */
    getCompanyByCompanyNoteId(query: GetCompanyByCompanyNoteIdRequest, cancelToken?: CancelToken): Promise<GetCompanyByCompanyNoteIdResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/getcompanybycompanynoteid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyDialogCitizenSuggestionsRequest
     * @return GetCompanyDialogCitizenSuggestionsResponse
     */
    getCompanyDialogCitizenSuggestions(query: GetCompanyDialogCitizenSuggestionsRequest, cancelToken?: CancelToken): Promise<GetCompanyDialogCitizenSuggestionsResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/getcompanydialogcitizensuggestions`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCompanyDialogPromptResponse
     */
    getCompanyDialogPrompt(cancelToken?: CancelToken): Promise<GetCompanyDialogPromptResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/getcompanydialogprompt`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyDialogTranscriptionBySessionIdRequest
     * @return GetCompanyDialogTranscriptionBySessionIdResponse
     */
    getCompanyDialogTranscriptionBySessionId(query: GetCompanyDialogTranscriptionBySessionIdRequest, cancelToken?: CancelToken): Promise<GetCompanyDialogTranscriptionBySessionIdResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/getcompanydialogtranscriptionbysessionid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyNoteDataRequest
     * @return GetCompanyNoteDataResponse
     */
    getCompanyInteractionNoteById(query: GetCompanyNoteDataRequest, cancelToken?: CancelToken): Promise<GetCompanyNoteDataResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/getcompanyinteractionnotebyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyInteractionNotesRequest
     * @return GetCompanyInteractionNotesResponse
     */
    getCompanyInteractionNotes(query: GetCompanyInteractionNotesRequest, cancelToken?: CancelToken): Promise<GetCompanyInteractionNotesResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/getcompanyinteractionnotes`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyNoteDispatchStatusRequest
     * @return GetCompanyNoteDispatchStatusResponse
     */
    getCompanyNoteDispatchStatus(query: GetCompanyNoteDispatchStatusRequest, cancelToken?: CancelToken): Promise<GetCompanyNoteDispatchStatusResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/getcompanynotedispatchstatus`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyNoteDocumentsFromShelfInDocumentArchiveRequest
     * @return GetCompanyNoteDocumentsFromShelfInDocumentArchiveResponse
     */
    getCompanyNoteDocumentsFromShelfInDocumentArchive(query: GetCompanyNoteDocumentsFromShelfInDocumentArchiveRequest, cancelToken?: CancelToken): Promise<GetCompanyNoteDocumentsFromShelfInDocumentArchiveResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/getcompanynotedocumentsfromshelfindocumentarchive`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyNoteTitleRequest
     * @return GetCompanyNoteTitleResponse
     */
    getCompanyNoteTitle(query: GetCompanyNoteTitleRequest, cancelToken?: CancelToken): Promise<GetCompanyNoteTitleResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/getcompanynotetitle`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCopanyNoteDocumentsFromDocumentArchiveRequest
     * @return GetCopanyNoteDocumentsFromDocumentArchiveResponse
     */
    getCopanyNoteDocumentsFromDocumentArchive(query: GetCopanyNoteDocumentsFromDocumentArchiveRequest, cancelToken?: CancelToken): Promise<GetCopanyNoteDocumentsFromDocumentArchiveResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/getcopanynotedocumentsfromdocumentarchive`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNoteFormDataRequest
     * @return GetNoteFormDataResponse
     */
    getNoteFormData(query: GetNoteFormDataRequest, cancelToken?: CancelToken): Promise<GetNoteFormDataResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/getnoteformdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetWysiwygEditorTemplateContentResponse
     */
    getWysiwygEditorTemplateContent(cancelToken?: CancelToken): Promise<GetWysiwygEditorTemplateContentResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/getwysiwygeditortemplatecontent`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query SummarizeCompanyDialogRequest
     * @return SummarizeCompanyDialogResponse
     */
    summarizeCompanyDialog(query: SummarizeCompanyDialogRequest, cancelToken?: CancelToken): Promise<SummarizeCompanyDialogResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/summarizecompanydialog`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DeleteCompanyInteractionNoteRequest
     * @return DeleteCompanyInteractionNoteResponse
     */
    deleteCompanyInteractionNote(query: DeleteCompanyInteractionNoteRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/company/notes/queries/deletecompanyinteractionnote`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query UpsertCompanyInteractionNoteRequest
     * @return UpsertCompanyInteractionNoteResponse
     */
    upsertCompanyInteractionNote(query: UpsertCompanyInteractionNoteRequest, cancelToken?: CancelToken): Promise<UpsertCompanyInteractionNoteResponse> {
        const $url = `${this.baseUrl}/api/company/notes/queries/upsertcompanyinteractionnote`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyContactPersonClient {
    /**
     * @param command UpsertCompanyContactPersonRequest
     * @return UpsertCompanyContactPersonResponse
     */
    upsertCompanyContactPerson(command: UpsertCompanyContactPersonRequest, cancelToken?: CancelToken): Promise<UpsertCompanyContactPersonResponse>;
    /**
     * @param command UpsertPrivateContactPersonRequest
     * @return UpsertPrivateContactPersonResponse
     */
    upsertPrivateContactPerson(command: UpsertPrivateContactPersonRequest, cancelToken?: CancelToken): Promise<UpsertPrivateContactPersonResponse>;
    /**
     * @param query GetCompanyContactPersonDetailsByIdRequest
     * @return GetCompanyContactPersonDetailsByIdResponse
     */
    getCompanyContactPersonDetailsById(query: GetCompanyContactPersonDetailsByIdRequest, cancelToken?: CancelToken): Promise<GetCompanyContactPersonDetailsByIdResponse>;
    /**
     * @param query GetCompanyContactPersonsForOverviewRequest
     * @return GetCompanyContactPersonsForOverviewResponse
     */
    getCompanyContactPersonsForOverview(query: GetCompanyContactPersonsForOverviewRequest, cancelToken?: CancelToken): Promise<GetCompanyContactPersonsForOverviewResponse>;
    /**
     * @param query GetCompanyIdByCompanyContactPersonIdRequest
     * @return GetCompanyIdByCompanyContactPersonIdResponse
     */
    getCompanyIdByCompanyContactPersonId(query: GetCompanyIdByCompanyContactPersonIdRequest, cancelToken?: CancelToken): Promise<GetCompanyIdByCompanyContactPersonIdResponse>;
    /**
     * @param query GetPrivateContactPersonDetailsByIdRequest
     * @return GetPrivateContactPersonDetailsByIdResponse
     */
    getPrivateContactPersonDetailsById(query: GetPrivateContactPersonDetailsByIdRequest, cancelToken?: CancelToken): Promise<GetPrivateContactPersonDetailsByIdResponse>;
    /**
     * @param query GetPrivateContactPersonsByEmailOrPhoneRequest
     * @return GetPrivateContactPersonsByEmailOrPhoneResponse
     */
    getPrivateContactPersonsByEmailOrPhone(query: GetPrivateContactPersonsByEmailOrPhoneRequest, cancelToken?: CancelToken): Promise<GetPrivateContactPersonsByEmailOrPhoneResponse>;
    /**
     * @return GetPrivateContactPersonsForOverviewResponse
     */
    getPrivateContactPersonsForOverview(cancelToken?: CancelToken): Promise<GetPrivateContactPersonsForOverviewResponse>;
}

export class CompanyContactPersonClient implements ICompanyContactPersonClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command UpsertCompanyContactPersonRequest
     * @return UpsertCompanyContactPersonResponse
     */
    upsertCompanyContactPerson(command: UpsertCompanyContactPersonRequest, cancelToken?: CancelToken): Promise<UpsertCompanyContactPersonResponse> {
        const $url = `${this.baseUrl}/api/company/contactperson/commands/upsertcompanycontactperson`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpsertPrivateContactPersonRequest
     * @return UpsertPrivateContactPersonResponse
     */
    upsertPrivateContactPerson(command: UpsertPrivateContactPersonRequest, cancelToken?: CancelToken): Promise<UpsertPrivateContactPersonResponse> {
        const $url = `${this.baseUrl}/api/company/contactperson/commands/upsertprivatecontactperson`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyContactPersonDetailsByIdRequest
     * @return GetCompanyContactPersonDetailsByIdResponse
     */
    getCompanyContactPersonDetailsById(query: GetCompanyContactPersonDetailsByIdRequest, cancelToken?: CancelToken): Promise<GetCompanyContactPersonDetailsByIdResponse> {
        const $url = `${this.baseUrl}/api/company/contactperson/queries/getcompanycontactpersondetailsbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyContactPersonsForOverviewRequest
     * @return GetCompanyContactPersonsForOverviewResponse
     */
    getCompanyContactPersonsForOverview(query: GetCompanyContactPersonsForOverviewRequest, cancelToken?: CancelToken): Promise<GetCompanyContactPersonsForOverviewResponse> {
        const $url = `${this.baseUrl}/api/company/contactperson/queries/getcompanycontactpersonsforoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyIdByCompanyContactPersonIdRequest
     * @return GetCompanyIdByCompanyContactPersonIdResponse
     */
    getCompanyIdByCompanyContactPersonId(query: GetCompanyIdByCompanyContactPersonIdRequest, cancelToken?: CancelToken): Promise<GetCompanyIdByCompanyContactPersonIdResponse> {
        const $url = `${this.baseUrl}/api/company/contactperson/queries/getcompanyidbycompanycontactpersonid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPrivateContactPersonDetailsByIdRequest
     * @return GetPrivateContactPersonDetailsByIdResponse
     */
    getPrivateContactPersonDetailsById(query: GetPrivateContactPersonDetailsByIdRequest, cancelToken?: CancelToken): Promise<GetPrivateContactPersonDetailsByIdResponse> {
        const $url = `${this.baseUrl}/api/company/contactperson/queries/getprivatecontactpersondetailsbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPrivateContactPersonsByEmailOrPhoneRequest
     * @return GetPrivateContactPersonsByEmailOrPhoneResponse
     */
    getPrivateContactPersonsByEmailOrPhone(query: GetPrivateContactPersonsByEmailOrPhoneRequest, cancelToken?: CancelToken): Promise<GetPrivateContactPersonsByEmailOrPhoneResponse> {
        const $url = `${this.baseUrl}/api/company/contactperson/queries/getprivatecontactpersonsbyemailorphone`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetPrivateContactPersonsForOverviewResponse
     */
    getPrivateContactPersonsForOverview(cancelToken?: CancelToken): Promise<GetPrivateContactPersonsForOverviewResponse> {
        const $url = `${this.baseUrl}/api/company/contactperson/queries/getprivatecontactpersonsforoverview`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyCompanyTaskClient {
    /**
     * @param command CompleteCompanyTaskRequest
     * @return CompleteCompanyTaskResponse
     */
    completeCompanyTask(command: CompleteCompanyTaskRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CompleteCompanyTasksRequest
     * @return CompleteCompanyTasksResponse
     */
    completeCompanyTasks(command: CompleteCompanyTasksRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateCompanyTaskRequest
     * @return CreateCompanyTaskResponse
     */
    createCompanyTask(command: CreateCompanyTaskRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command JournalizeCompanyTaskOnCitizenRequest
     * @return JournalizeCompanyTaskOnCitizenResponse
     */
    journalizeCompanyTaskOnCitizen(command: JournalizeCompanyTaskOnCitizenRequest, cancelToken?: CancelToken): Promise<JournalizeCompanyTaskOnCitizenResponse>;
    /**
     * @param command JournalizeCompanyTaskOnCompanyRequest
     * @return JournalizeCompanyTaskOnCompanyResponse
     */
    journalizeCompanyTaskOnCompany(command: JournalizeCompanyTaskOnCompanyRequest, cancelToken?: CancelToken): Promise<JournalizeCompanyTaskOnCompanyResponse>;
    /**
     * @param command ReassignCompanyTasksRequest
     * @return ReassignCompanyTasksResponse
     */
    reassignCompanyTasks(command: ReassignCompanyTasksRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ReopenCompanyTaskRequest
     * @return ReopenCompanyTaskResponse
     */
    reopenCompanyTask(command: ReopenCompanyTaskRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCompanyTaskRequest
     * @return UpdateCompanyTaskResponse
     */
    updateCompanyTask(command: UpdateCompanyTaskRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query FindCitizenCasesRequest
     * @return FindCitizenCasesResponse
     */
    findCitizenCases(query: FindCitizenCasesRequest, cancelToken?: CancelToken): Promise<FindCitizenCasesResponse>;
    /**
     * @param query GetCompanyTaskRequest
     * @return GetCompanyTaskResponse
     */
    getCompanyTask(query: GetCompanyTaskRequest, cancelToken?: CancelToken): Promise<GetCompanyTaskResponse>;
    /**
     * @param query GetCompanyTasksMetaDataRequest
     * @return GetCompanyTasksMetaDataResponse
     */
    getCompanyTasksMetaData(query: GetCompanyTasksMetaDataRequest, cancelToken?: CancelToken): Promise<GetCompanyTasksMetaDataResponse>;
    /**
     * @param query LoadCitizenCaseRequest
     * @return LoadCitizenCaseResponse
     */
    loadCitizenCase(query: LoadCitizenCaseRequest, cancelToken?: CancelToken): Promise<LoadCitizenCaseResponse>;
}

export class CompanyCompanyTaskClient implements ICompanyCompanyTaskClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CompleteCompanyTaskRequest
     * @return CompleteCompanyTaskResponse
     */
    completeCompanyTask(command: CompleteCompanyTaskRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/company/companytask/commands/completecompanytask`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CompleteCompanyTasksRequest
     * @return CompleteCompanyTasksResponse
     */
    completeCompanyTasks(command: CompleteCompanyTasksRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/company/companytask/commands/completecompanytasks`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCompanyTaskRequest
     * @return CreateCompanyTaskResponse
     */
    createCompanyTask(command: CreateCompanyTaskRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/company/companytask/commands/createcompanytask`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command JournalizeCompanyTaskOnCitizenRequest
     * @return JournalizeCompanyTaskOnCitizenResponse
     */
    journalizeCompanyTaskOnCitizen(command: JournalizeCompanyTaskOnCitizenRequest, cancelToken?: CancelToken): Promise<JournalizeCompanyTaskOnCitizenResponse> {
        const $url = `${this.baseUrl}/api/company/companytask/commands/journalizecompanytaskoncitizen`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command JournalizeCompanyTaskOnCompanyRequest
     * @return JournalizeCompanyTaskOnCompanyResponse
     */
    journalizeCompanyTaskOnCompany(command: JournalizeCompanyTaskOnCompanyRequest, cancelToken?: CancelToken): Promise<JournalizeCompanyTaskOnCompanyResponse> {
        const $url = `${this.baseUrl}/api/company/companytask/commands/journalizecompanytaskoncompany`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReassignCompanyTasksRequest
     * @return ReassignCompanyTasksResponse
     */
    reassignCompanyTasks(command: ReassignCompanyTasksRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/company/companytask/commands/reassigncompanytasks`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReopenCompanyTaskRequest
     * @return ReopenCompanyTaskResponse
     */
    reopenCompanyTask(command: ReopenCompanyTaskRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/company/companytask/commands/reopencompanytask`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCompanyTaskRequest
     * @return UpdateCompanyTaskResponse
     */
    updateCompanyTask(command: UpdateCompanyTaskRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/company/companytask/commands/updatecompanytask`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query FindCitizenCasesRequest
     * @return FindCitizenCasesResponse
     */
    findCitizenCases(query: FindCitizenCasesRequest, cancelToken?: CancelToken): Promise<FindCitizenCasesResponse> {
        const $url = `${this.baseUrl}/api/company/companytask/queries/findcitizencases`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyTaskRequest
     * @return GetCompanyTaskResponse
     */
    getCompanyTask(query: GetCompanyTaskRequest, cancelToken?: CancelToken): Promise<GetCompanyTaskResponse> {
        const $url = `${this.baseUrl}/api/company/companytask/queries/getcompanytask`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyTasksMetaDataRequest
     * @return GetCompanyTasksMetaDataResponse
     */
    getCompanyTasksMetaData(query: GetCompanyTasksMetaDataRequest, cancelToken?: CancelToken): Promise<GetCompanyTasksMetaDataResponse> {
        const $url = `${this.baseUrl}/api/company/companytask/queries/getcompanytasksmetadata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query LoadCitizenCaseRequest
     * @return LoadCitizenCaseResponse
     */
    loadCitizenCase(query: LoadCitizenCaseRequest, cancelToken?: CancelToken): Promise<LoadCitizenCaseResponse> {
        const $url = `${this.baseUrl}/api/company/companytask/queries/loadcitizencase`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyCommunicationCrowdLetterClient {
    /**
     * @param command SendLetterToCompaniesRequest
     * @return SendLetterToCompaniesResponse
     */
    sendCompanyLetterToCrowd(command: SendLetterToCompaniesRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetCompanyCrowdLetterPreviewAsPdfRequest
     * @return FileResponse
     */
    getCompanyCrowdLetterPreviewAsPdf(query: GetCompanyCrowdLetterPreviewAsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
}

export class CompanyCommunicationCrowdLetterClient implements ICompanyCommunicationCrowdLetterClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command SendLetterToCompaniesRequest
     * @return SendLetterToCompaniesResponse
     */
    sendCompanyLetterToCrowd(command: SendLetterToCompaniesRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/company/communication/crowdletter/commands/sendcompanylettertocrowd`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyCrowdLetterPreviewAsPdfRequest
     * @return FileResponse
     */
    getCompanyCrowdLetterPreviewAsPdf(query: GetCompanyCrowdLetterPreviewAsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/company/communication/crowdletter/queries/getcompanycrowdletterpreviewaspdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }
}

export interface ICompanyCommunicationClient {
    /**
     * @param command SendCompanyLetterRequest
     * @return SendCompanyLetterResponse
     */
    sendCompanyLetter(command: SendCompanyLetterRequest, cancelToken?: CancelToken): Promise<SendCompanyLetterResponse>;
    /**
     * @return GetAccountInteractionPurposeResponse
     */
    getAccountInteractionPurpose(cancelToken?: CancelToken): Promise<GetAccountInteractionPurposeResponse>;
    /**
     * @param query GetCompanyInfoRequest
     * @return GetCompanyInfoResponse
     */
    getCompanyAddressInfo(query: GetCompanyInfoRequest, cancelToken?: CancelToken): Promise<GetCompanyInfoResponse>;
    /**
     * @param query GetCompanyPdfFormLinkRequest
     * @return GetCompanyPdfFormLinkResponse
     */
    getCompanyPdfFormLink(query: GetCompanyPdfFormLinkRequest, cancelToken?: CancelToken): Promise<GetCompanyPdfFormLinkResponse>;
    /**
     * @return GetCompanyPdfFormsResponse
     */
    getCompanyPdfForms(cancelToken?: CancelToken): Promise<GetCompanyPdfFormsResponse>;
    /**
     * @param query GetCompanyPdfFormSubmittedRequest
     * @return GetCompanyPdfFormSubmittedResponse
     */
    getCompanyPdfFormSubmitted(query: GetCompanyPdfFormSubmittedRequest, cancelToken?: CancelToken): Promise<GetCompanyPdfFormSubmittedResponse>;
    /**
     * @param query GetContactPersonsCompanyRequest
     * @return GetContactPersonsCompanyResponse
     */
    getContactPersonsCompany(query: GetContactPersonsCompanyRequest, cancelToken?: CancelToken): Promise<GetContactPersonsCompanyResponse>;
    /**
     * @param query GetCompanyEditableContentForPdfFormsRequest
     * @return GetCompanyEditableContentForPdfFormsResponse
     */
    getCompanyEditableContentForPdfForms(query: GetCompanyEditableContentForPdfFormsRequest, cancelToken?: CancelToken): Promise<GetCompanyEditableContentForPdfFormsResponse>;
    /**
     * @param query GetGeneratedPdfRequest
     * @return FileResponse
     */
    getGeneratedPdf(query: GetGeneratedPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return GetInteractionResultResponse
     */
    getInteractionResult(cancelToken?: CancelToken): Promise<GetInteractionResultResponse>;
    /**
     * @return GetOutgoingDocumentTypesResponse
     */
    getOutgoingDocumentTypes(cancelToken?: CancelToken): Promise<GetOutgoingDocumentTypesResponse>;
    /**
     * @param query GetStandardAttachmentsForCompanyRequest
     * @return GetStandardAttachmentsForCompanyResponse
     */
    getStandardAttachmentsForCompany(query: GetStandardAttachmentsForCompanyRequest, cancelToken?: CancelToken): Promise<GetStandardAttachmentsForCompanyResponse>;
}

export class CompanyCommunicationClient implements ICompanyCommunicationClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command SendCompanyLetterRequest
     * @return SendCompanyLetterResponse
     */
    sendCompanyLetter(command: SendCompanyLetterRequest, cancelToken?: CancelToken): Promise<SendCompanyLetterResponse> {
        const $url = `${this.baseUrl}/api/company/communication/commands/sendcompanyletter`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAccountInteractionPurposeResponse
     */
    getAccountInteractionPurpose(cancelToken?: CancelToken): Promise<GetAccountInteractionPurposeResponse> {
        const $url = `${this.baseUrl}/api/company/communication/queries/getaccountinteractionpurpose`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyInfoRequest
     * @return GetCompanyInfoResponse
     */
    getCompanyAddressInfo(query: GetCompanyInfoRequest, cancelToken?: CancelToken): Promise<GetCompanyInfoResponse> {
        const $url = `${this.baseUrl}/api/company/communication/queries/getcompanyaddressinfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyPdfFormLinkRequest
     * @return GetCompanyPdfFormLinkResponse
     */
    getCompanyPdfFormLink(query: GetCompanyPdfFormLinkRequest, cancelToken?: CancelToken): Promise<GetCompanyPdfFormLinkResponse> {
        const $url = `${this.baseUrl}/api/company/communication/queries/getcompanypdfformlink`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCompanyPdfFormsResponse
     */
    getCompanyPdfForms(cancelToken?: CancelToken): Promise<GetCompanyPdfFormsResponse> {
        const $url = `${this.baseUrl}/api/company/communication/queries/getcompanypdfforms`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyPdfFormSubmittedRequest
     * @return GetCompanyPdfFormSubmittedResponse
     */
    getCompanyPdfFormSubmitted(query: GetCompanyPdfFormSubmittedRequest, cancelToken?: CancelToken): Promise<GetCompanyPdfFormSubmittedResponse> {
        const $url = `${this.baseUrl}/api/company/communication/queries/getcompanypdfformsubmitted`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetContactPersonsCompanyRequest
     * @return GetContactPersonsCompanyResponse
     */
    getContactPersonsCompany(query: GetContactPersonsCompanyRequest, cancelToken?: CancelToken): Promise<GetContactPersonsCompanyResponse> {
        const $url = `${this.baseUrl}/api/company/communication/queries/getcontactpersonscompany`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyEditableContentForPdfFormsRequest
     * @return GetCompanyEditableContentForPdfFormsResponse
     */
    getCompanyEditableContentForPdfForms(query: GetCompanyEditableContentForPdfFormsRequest, cancelToken?: CancelToken): Promise<GetCompanyEditableContentForPdfFormsResponse> {
        const $url = `${this.baseUrl}/api/company/communication/queries/getcompanyeditablecontentforpdfforms`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetGeneratedPdfRequest
     * @return FileResponse
     */
    getGeneratedPdf(query: GetGeneratedPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/company/communication/queries/getgeneratedpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @return GetInteractionResultResponse
     */
    getInteractionResult(cancelToken?: CancelToken): Promise<GetInteractionResultResponse> {
        const $url = `${this.baseUrl}/api/company/communication/queries/getinteractionresult`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOutgoingDocumentTypesResponse
     */
    getOutgoingDocumentTypes(cancelToken?: CancelToken): Promise<GetOutgoingDocumentTypesResponse> {
        const $url = `${this.baseUrl}/api/company/communication/queries/getoutgoingdocumenttypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetStandardAttachmentsForCompanyRequest
     * @return GetStandardAttachmentsForCompanyResponse
     */
    getStandardAttachmentsForCompany(query: GetStandardAttachmentsForCompanyRequest, cancelToken?: CancelToken): Promise<GetStandardAttachmentsForCompanyResponse> {
        const $url = `${this.baseUrl}/api/company/communication/queries/getstandardattachmentsforcompany`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyAssociatedCaseWorkerClient {
    /**
     * @param command DeleteAssociatedCaseWorkerForCompanyRequest
     * @return DeleteAssociatedCaseWorkerForCompanyResponse
     */
    deleteAssociatedCaseWorker(command: DeleteAssociatedCaseWorkerForCompanyRequest, cancelToken?: CancelToken): Promise<DeleteAssociatedCaseWorkerForCompanyResponse>;
    /**
     * @param command UpsertAssociatedCaseWorkerRequest
     * @return UpsertAssociatedCaseWorkerResponse
     */
    upsertAssociatedCaseWorker(command: UpsertAssociatedCaseWorkerRequest, cancelToken?: CancelToken): Promise<UpsertAssociatedCaseWorkerResponse>;
    /**
     * @param query GetAssociatedCaseWorkerForCompanyRequest
     * @return GetAssociatedCaseWorkerForCompanyResponse
     */
    getAssociatedCaseWorkerForCompany(query: GetAssociatedCaseWorkerForCompanyRequest, cancelToken?: CancelToken): Promise<GetAssociatedCaseWorkerForCompanyResponse>;
    /**
     * @param query GetAssociatedCaseWorkersForCompanyRequest
     * @return GetAssociatedCaseWorkersForCompanyResponse
     */
    getAssociatedCaseWorkersForCompany(query: GetAssociatedCaseWorkersForCompanyRequest, cancelToken?: CancelToken): Promise<GetAssociatedCaseWorkersForCompanyResponse>;
    /**
     * @return GetAssociateUserRolesCompanyResponse
     */
    getAssociateUserRolesForCompany(cancelToken?: CancelToken): Promise<GetAssociateUserRolesCompanyResponse>;
    /**
     * @param query GetResponsibleCaseWorkerForCompanyRequest
     * @return GetResponsibleCaseWorkerForCompanyResponse
     */
    getResponsibleCaseWorkerForCompany(query: GetResponsibleCaseWorkerForCompanyRequest, cancelToken?: CancelToken): Promise<GetResponsibleCaseWorkerForCompanyResponse>;
}

export class CompanyAssociatedCaseWorkerClient implements ICompanyAssociatedCaseWorkerClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command DeleteAssociatedCaseWorkerForCompanyRequest
     * @return DeleteAssociatedCaseWorkerForCompanyResponse
     */
    deleteAssociatedCaseWorker(command: DeleteAssociatedCaseWorkerForCompanyRequest, cancelToken?: CancelToken): Promise<DeleteAssociatedCaseWorkerForCompanyResponse> {
        const $url = `${this.baseUrl}/api/company/associatedcaseworker/commands/deleteassociatedcaseworker`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpsertAssociatedCaseWorkerRequest
     * @return UpsertAssociatedCaseWorkerResponse
     */
    upsertAssociatedCaseWorker(command: UpsertAssociatedCaseWorkerRequest, cancelToken?: CancelToken): Promise<UpsertAssociatedCaseWorkerResponse> {
        const $url = `${this.baseUrl}/api/company/associatedcaseworker/commands/upsertassociatedcaseworker`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssociatedCaseWorkerForCompanyRequest
     * @return GetAssociatedCaseWorkerForCompanyResponse
     */
    getAssociatedCaseWorkerForCompany(query: GetAssociatedCaseWorkerForCompanyRequest, cancelToken?: CancelToken): Promise<GetAssociatedCaseWorkerForCompanyResponse> {
        const $url = `${this.baseUrl}/api/company/associatedcaseworker/queries/getassociatedcaseworkerforcompany`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssociatedCaseWorkersForCompanyRequest
     * @return GetAssociatedCaseWorkersForCompanyResponse
     */
    getAssociatedCaseWorkersForCompany(query: GetAssociatedCaseWorkersForCompanyRequest, cancelToken?: CancelToken): Promise<GetAssociatedCaseWorkersForCompanyResponse> {
        const $url = `${this.baseUrl}/api/company/associatedcaseworker/queries/getassociatedcaseworkersforcompany`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAssociateUserRolesCompanyResponse
     */
    getAssociateUserRolesForCompany(cancelToken?: CancelToken): Promise<GetAssociateUserRolesCompanyResponse> {
        const $url = `${this.baseUrl}/api/company/associatedcaseworker/queries/getassociateuserrolesforcompany`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetResponsibleCaseWorkerForCompanyRequest
     * @return GetResponsibleCaseWorkerForCompanyResponse
     */
    getResponsibleCaseWorkerForCompany(query: GetResponsibleCaseWorkerForCompanyRequest, cancelToken?: CancelToken): Promise<GetResponsibleCaseWorkerForCompanyResponse> {
        const $url = `${this.baseUrl}/api/company/associatedcaseworker/queries/getresponsiblecaseworkerforcompany`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyAppointmentClient {
    /**
     * @param command BulkCompleteAppointmentsRequest
     * @return BulkCompleteAppointmentsResponse
     */
    bulkCompleteAppointments(command: BulkCompleteAppointmentsRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command AssignCaseWorkerToCompanyAppointmentsRequest
     * @return AssignCaseWorkerToCompanyAppointmentsResponse
     */
    assignCaseWorkerToCompanyAppointments(command: AssignCaseWorkerToCompanyAppointmentsRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetAppointmentByIdRequest
     * @return GetAppointmentByIdResponse
     */
    getAppointmentById(query: GetAppointmentByIdRequest, cancelToken?: CancelToken): Promise<GetAppointmentByIdResponse>;
    /**
     * @param query GetAppointmentFormDataRequest
     * @return GetAppointmentFormDataResponse
     */
    getAppointmentFormData(query: GetAppointmentFormDataRequest, cancelToken?: CancelToken): Promise<GetAppointmentFormDataResponse>;
    /**
     * @param query GetAppointmentsForListViewRequest
     * @return GetAppointmentsForListViewResponse
     */
    getAppointmentsForListView(query: GetAppointmentsForListViewRequest, cancelToken?: CancelToken): Promise<GetAppointmentsForListViewResponse>;
    /**
     * @param query GetCompanyByAppointmentIdRequest
     * @return GetCompanyByAppointmentIdResponse
     */
    getCompanyByAppointmentId(query: GetCompanyByAppointmentIdRequest, cancelToken?: CancelToken): Promise<GetCompanyByAppointmentIdResponse>;
    /**
     * @param query DeleteCompanyAppointmentRequest
     * @return DeleteCompanyAppointmentResponse
     */
    deleteCompanyAppointment(query: DeleteCompanyAppointmentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query UpsertCompanyAppointmentRequest
     * @return UpsertCompanyAppointmentResponse
     */
    upsertCompanyAppointment(query: UpsertCompanyAppointmentRequest, cancelToken?: CancelToken): Promise<UpsertCompanyAppointmentResponse>;
}

export class CompanyAppointmentClient implements ICompanyAppointmentClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command BulkCompleteAppointmentsRequest
     * @return BulkCompleteAppointmentsResponse
     */
    bulkCompleteAppointments(command: BulkCompleteAppointmentsRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/company/appointment/commands/bulkcompleteappointments`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command AssignCaseWorkerToCompanyAppointmentsRequest
     * @return AssignCaseWorkerToCompanyAppointmentsResponse
     */
    assignCaseWorkerToCompanyAppointments(command: AssignCaseWorkerToCompanyAppointmentsRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/company/appointment/commands/assigncaseworkertocompanyappointments`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAppointmentByIdRequest
     * @return GetAppointmentByIdResponse
     */
    getAppointmentById(query: GetAppointmentByIdRequest, cancelToken?: CancelToken): Promise<GetAppointmentByIdResponse> {
        const $url = `${this.baseUrl}/api/company/appointment/queries/getappointmentbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAppointmentFormDataRequest
     * @return GetAppointmentFormDataResponse
     */
    getAppointmentFormData(query: GetAppointmentFormDataRequest, cancelToken?: CancelToken): Promise<GetAppointmentFormDataResponse> {
        const $url = `${this.baseUrl}/api/company/appointment/queries/getappointmentformdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAppointmentsForListViewRequest
     * @return GetAppointmentsForListViewResponse
     */
    getAppointmentsForListView(query: GetAppointmentsForListViewRequest, cancelToken?: CancelToken): Promise<GetAppointmentsForListViewResponse> {
        const $url = `${this.baseUrl}/api/company/appointment/queries/getappointmentsforlistview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyByAppointmentIdRequest
     * @return GetCompanyByAppointmentIdResponse
     */
    getCompanyByAppointmentId(query: GetCompanyByAppointmentIdRequest, cancelToken?: CancelToken): Promise<GetCompanyByAppointmentIdResponse> {
        const $url = `${this.baseUrl}/api/company/appointment/queries/getcompanybyappointmentid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DeleteCompanyAppointmentRequest
     * @return DeleteCompanyAppointmentResponse
     */
    deleteCompanyAppointment(query: DeleteCompanyAppointmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/company/appointment/queries/deletecompanyappointment`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query UpsertCompanyAppointmentRequest
     * @return UpsertCompanyAppointmentResponse
     */
    upsertCompanyAppointment(query: UpsertCompanyAppointmentRequest, cancelToken?: CancelToken): Promise<UpsertCompanyAppointmentResponse> {
        const $url = `${this.baseUrl}/api/company/appointment/queries/upsertcompanyappointment`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyRecruitmentsClient {
    /**
     * @param command CreateAttachmentsRequest
     * @return CreateAttachmentsResponse
     */
    createAttachments(command: CreateAttachmentsRequest, cancelToken?: CancelToken): Promise<CreateAttachmentsResponse>;
    /**
     * @param command CreateCandidateRequest
     * @return CreateCandidateResponse
     */
    createCandidate(command: CreateCandidateRequest, cancelToken?: CancelToken): Promise<CreateCandidateResponse>;
    /**
     * @param command CreateCandidateReferralsRequest
     * @return CreateCandidateReferralsResponse
     */
    createCandidateReferrals(command: CreateCandidateReferralsRequest, cancelToken?: CancelToken): Promise<CreateCandidateReferralsResponse>;
    /**
     * @param command CreateCandidatesFromSmartMatchRequest
     * @return CreateCandidatesFromSmartMatchResponse
     */
    createCandidatesFromSmartMatch(command: CreateCandidatesFromSmartMatchRequest, cancelToken?: CancelToken): Promise<CreateCandidatesFromSmartMatchResponse>;
    /**
     * @param command CreateCompanyRecruitmentRequest
     * @return CreateCompanyRecruitmentResponse
     */
    createCompanyRecruitment(command: CreateCompanyRecruitmentRequest, cancelToken?: CancelToken): Promise<CreateCompanyRecruitmentResponse>;
    /**
     * @param command DeleteAttachmentsRequest
     * @return DeleteAttachmentsResponse
     */
    deleteAttachments(command: DeleteAttachmentsRequest, cancelToken?: CancelToken): Promise<DeleteAttachmentsResponse>;
    /**
     * @param command SynchronizeCompanyRecruitmentFromDfdgRequest
     * @return SynchronizeCompanyRecruitmentFromDfdgResponse
     */
    synchronizeCompanyRecruitmentFromDfdg(command: SynchronizeCompanyRecruitmentFromDfdgRequest, cancelToken?: CancelToken): Promise<SynchronizeCompanyRecruitmentFromDfdgResponse>;
    /**
     * @param command UpdateCandidateRequest
     * @return UpdateCandidateResponse
     */
    updateCandidate(command: UpdateCandidateRequest, cancelToken?: CancelToken): Promise<UpdateCandidateResponse>;
    /**
     * @param command UpdateCandidatesRequest
     * @return UpdateCandidatesResponse
     */
    updateCandidates(command: UpdateCandidatesRequest, cancelToken?: CancelToken): Promise<UpdateCandidatesResponse>;
    /**
     * @param command UpdateCompanyRecruitmentRequest
     * @return UpdateCompanyRecruitmentResponse
     */
    updateCompanyRecruitment(command: UpdateCompanyRecruitmentRequest, cancelToken?: CancelToken): Promise<UpdateCompanyRecruitmentResponse>;
    /**
     * @return GetActiveClosureCausesResponse
     */
    getActiveClosureCauses(cancelToken?: CancelToken): Promise<GetActiveClosureCausesResponse>;
    /**
     * @return GetAttachmentSettingsForCompanyRecruitmentResponse
     */
    getAttachmentSettingsForCompanyRecruitment(cancelToken?: CancelToken): Promise<GetAttachmentSettingsForCompanyRecruitmentResponse>;
    /**
     * @param query GetCalculatedDueDateRequest
     * @return GetCalculatedDueDateResponse
     */
    getCalculatedDueDate(query: GetCalculatedDueDateRequest, cancelToken?: CancelToken): Promise<GetCalculatedDueDateResponse>;
    /**
     * @param query GetCitizenHasTargetGroupThatSupportJobReferralsRequest
     * @return GetCitizenHasTargetGroupThatSupportJobReferralsResponse
     */
    getCitizenHasTargetGroupThatSupportJobReferrals(query: GetCitizenHasTargetGroupThatSupportJobReferralsRequest, cancelToken?: CancelToken): Promise<GetCitizenHasTargetGroupThatSupportJobReferralsResponse>;
    /**
     * @param query GetCompaniesInfoRequest
     * @return GetCompaniesInfoResponse
     */
    getCompanies(query: GetCompaniesInfoRequest, cancelToken?: CancelToken): Promise<GetCompaniesInfoResponse>;
    /**
     * @param query GetCompanyContactPersonsRequest
     * @return GetCompanyContactPersonsResponse
     */
    getCompanyContactPersons(query: GetCompanyContactPersonsRequest, cancelToken?: CancelToken): Promise<GetCompanyContactPersonsResponse>;
    /**
     * @param query GetCompanyInfoRequest
     * @return GetCompanyInfoResponse
     */
    getCompanyInfo(query: GetCompanyInfoRequest2, cancelToken?: CancelToken): Promise<GetCompanyInfoResponse2>;
    /**
     * @param query GetCompanyNotesRequest
     * @return GetCompanyNotesResponse
     */
    getCompanyNotes(query: GetCompanyNotesRequest, cancelToken?: CancelToken): Promise<GetCompanyNotesResponse>;
    /**
     * @param query GetCompanyRecruitmentCandidateRequest
     * @return GetCompanyRecruitmentCandidateResponse
     */
    getCompanyRecruitmentCandidate(query: GetCompanyRecruitmentCandidateRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentCandidateResponse>;
    /**
     * @param query GetCompanyRecruitmentDetailsRequest
     * @return GetCompanyRecruitmentDetailsResponse
     */
    getCompanyRecruitmentDetails(query: GetCompanyRecruitmentDetailsRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentDetailsResponse>;
    /**
     * @param query GetCompanyRecruitmentJobMatchesRequest
     * @return GetCompanyRecruitmentJobMatchesResponse
     */
    getCompanyRecruitmentJobMatches(query: GetCompanyRecruitmentJobMatchesRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentJobMatchesResponse>;
    /**
     * @param query GetCompanyRecruitmentPdfRequest
     * @return FileResponse
     */
    getCompanyRecruitmentPdf(query: GetCompanyRecruitmentPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetCompanyRecruitmentsByCompanyIdRequest
     * @return GetCompanyRecruitmentsByCompanyIdResponse
     */
    getCompanyRecruitmentsByCompanyId(query: GetCompanyRecruitmentsByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentsByCompanyIdResponse>;
    /**
     * @param query GetCompanyRecruitmentsForCandidateReferralRequest
     * @return GetCompanyRecruitmentsForCandidateReferralResponse
     */
    getCompanyRecruitmentsForCandidateReferral(query: GetCompanyRecruitmentsForCandidateReferralRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentsForCandidateReferralResponse>;
    /**
     * @param query GetCompanyRecruitmentsFromSkillsRelinkRequest
     * @return GetCompanyRecruitmentsFromSkillsRelinkResponse
     */
    getCompanyRecruitmentsFromSkillsRelink(query: GetCompanyRecruitmentsFromSkillsRelinkRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentsFromSkillsRelinkResponse>;
    /**
     * @param query GetCompetenciesRecommendationRequest
     * @return GetCompetenciesRecommendationResponse
     */
    getCompetenciesRecommendation(query: GetCompetenciesRecommendationRequest, cancelToken?: CancelToken): Promise<GetCompetenciesRecommendationResponse>;
    /**
     * @return GetCrmHostResponse
     */
    getCrmHost(cancelToken?: CancelToken): Promise<GetCrmHostResponse2>;
    /**
     * @param query GetDocumentsFromDocumentArchiveForCompanyRecruitmentRequest
     * @return GetDocumentsFromDocumentArchiveForCompanyRecruitmentResponse
     */
    getDocumentsFromDocumentArchiveForCompanyRecruitment(query: GetDocumentsFromDocumentArchiveForCompanyRecruitmentRequest, cancelToken?: CancelToken): Promise<GetDocumentsFromDocumentArchiveForCompanyRecruitmentResponse>;
    /**
     * @return GetJobcentersResponse
     */
    getJobcenters(cancelToken?: CancelToken): Promise<GetJobcentersResponse>;
    /**
     * @param query GetNumberOfCandidatesRequest
     * @return GetNumberOfCandidatesResponse
     */
    getNumberOfCandidates(query: GetNumberOfCandidatesRequest, cancelToken?: CancelToken): Promise<GetNumberOfCandidatesResponse>;
    /**
     * @return GetOccupationsResponse
     */
    getOccupations(cancelToken?: CancelToken): Promise<GetOccupationsResponse>;
    /**
     * @param query GetOfferInfoForNewRecruitmentRequest
     * @return GetOfferInfoForNewRecruitmentReponse
     */
    getOfferInfoForNewRecruitment(query: GetOfferInfoForNewRecruitmentRequest, cancelToken?: CancelToken): Promise<GetOfferInfoForNewRecruitmentReponse>;
    /**
     * @return GetOfferTypesResponse
     */
    getOfferTypes(cancelToken?: CancelToken): Promise<GetOfferTypesResponse2>;
    /**
     * @return GetPlacementPurposeTypesResponse
     */
    getPlacementPurposeTypes(cancelToken?: CancelToken): Promise<GetPlacementPurposeTypesResponse>;
    /**
     * @param query GetQualificationRecommendationRequest
     * @return GetQualificationRecommendationResponse
     */
    getQualificationRecommendation(query: GetQualificationRecommendationRequest, cancelToken?: CancelToken): Promise<GetQualificationRecommendationResponse>;
    /**
     * @return GetQualificationsResponse
     */
    getQualifications(cancelToken?: CancelToken): Promise<GetQualificationsResponse>;
    /**
     * @return GetRecruitmentCollaborationsResponse
     */
    getRecruitmentCollaborations(cancelToken?: CancelToken): Promise<GetRecruitmentCollaborationsResponse>;
    /**
     * @param query GetRecruitmentCompanyInformationRequest
     * @return GetRecruitmentCompanyInformationResponse
     */
    getRecruitmentCompanyInformation(query: GetRecruitmentCompanyInformationRequest, cancelToken?: CancelToken): Promise<GetRecruitmentCompanyInformationResponse>;
    /**
     * @return GetRecruitmentInformationTypesResponse
     */
    getRecruitmentInformationTypes(cancelToken?: CancelToken): Promise<GetRecruitmentInformationTypesResponse>;
    /**
     * @return GetSearchInOwnCitizensUrlResponse
     */
    getSearchInOwnCitizensUrl(cancelToken?: CancelToken): Promise<GetSearchInOwnCitizensUrlResponse>;
    /**
     * @return GetServiceTargetTypesResponse
     */
    getServiceTargetTypes(cancelToken?: CancelToken): Promise<GetServiceTargetTypesResponse>;
    /**
     * @return GetSettingsResponse
     */
    getSettings(cancelToken?: CancelToken): Promise<GetSettingsResponse>;
    /**
     * @param query GetSmartMatchCvSuggestionsRequest
     * @return GetSmartMatchCvSuggestionsResponse
     */
    getSmartMatchCvSuggestions(query: GetSmartMatchCvSuggestionsRequest, cancelToken?: CancelToken): Promise<GetSmartMatchCvSuggestionsResponse>;
    /**
     * @param query GetTargetGroupByCitizenIdRequest
     * @return GetTargetGroupByCitizenIdResponse
     */
    getTargetGroupByCitizenId(query: GetTargetGroupByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetTargetGroupByCitizenIdResponse>;
    /**
     * @return GetTargetGroupsResponse
     */
    getTargetGroups(cancelToken?: CancelToken): Promise<GetTargetGroupsResponse>;
    /**
     * @return GetTeamsWithUsersHavingFormidlingsansvarligRoleResponse
     */
    getTeamsWithUsersHavingFormidlingsansvarligRole(cancelToken?: CancelToken): Promise<GetTeamsWithUsersHavingFormidlingsansvarligRoleResponse>;
    /**
     * @return GetTeamsWithUsersHavingJobEjerRoleResponse
     */
    getTeamsWithUsersHavingJobEjerRole(cancelToken?: CancelToken): Promise<GetTeamsWithUsersHavingJobEjerRoleResponse>;
    /**
     * @return GetTenantJobcenterResponse
     */
    getTenantJobcenter(cancelToken?: CancelToken): Promise<GetTenantJobcenterResponse>;
    /**
     * @return GetUnemploymentFundsResponse
     */
    getUnemploymentFunds(cancelToken?: CancelToken): Promise<GetUnemploymentFundsResponse>;
    /**
     * @return GetUsersWithFormidlingsansvarligRoleResponse
     */
    getUsersWithFormidlingsansvarligRole(cancelToken?: CancelToken): Promise<GetUsersWithFormidlingsansvarligRoleResponse>;
    /**
     * @return GetUsersWithJobEjerRoleResponse
     */
    getUsersWithJobEjerRole(cancelToken?: CancelToken): Promise<GetUsersWithJobEjerRoleResponse>;
}

export class CompanyRecruitmentsClient implements ICompanyRecruitmentsClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateAttachmentsRequest
     * @return CreateAttachmentsResponse
     */
    createAttachments(command: CreateAttachmentsRequest, cancelToken?: CancelToken): Promise<CreateAttachmentsResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/commands/createattachments`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCandidateRequest
     * @return CreateCandidateResponse
     */
    createCandidate(command: CreateCandidateRequest, cancelToken?: CancelToken): Promise<CreateCandidateResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/commands/createcandidate`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCandidateReferralsRequest
     * @return CreateCandidateReferralsResponse
     */
    createCandidateReferrals(command: CreateCandidateReferralsRequest, cancelToken?: CancelToken): Promise<CreateCandidateReferralsResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/commands/createcandidatereferrals`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCandidatesFromSmartMatchRequest
     * @return CreateCandidatesFromSmartMatchResponse
     */
    createCandidatesFromSmartMatch(command: CreateCandidatesFromSmartMatchRequest, cancelToken?: CancelToken): Promise<CreateCandidatesFromSmartMatchResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/commands/createcandidatesfromsmartmatch`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCompanyRecruitmentRequest
     * @return CreateCompanyRecruitmentResponse
     */
    createCompanyRecruitment(command: CreateCompanyRecruitmentRequest, cancelToken?: CancelToken): Promise<CreateCompanyRecruitmentResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/commands/createcompanyrecruitment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteAttachmentsRequest
     * @return DeleteAttachmentsResponse
     */
    deleteAttachments(command: DeleteAttachmentsRequest, cancelToken?: CancelToken): Promise<DeleteAttachmentsResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/commands/deleteattachments`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SynchronizeCompanyRecruitmentFromDfdgRequest
     * @return SynchronizeCompanyRecruitmentFromDfdgResponse
     */
    synchronizeCompanyRecruitmentFromDfdg(command: SynchronizeCompanyRecruitmentFromDfdgRequest, cancelToken?: CancelToken): Promise<SynchronizeCompanyRecruitmentFromDfdgResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/commands/synchronizecompanyrecruitmentfromdfdg`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCandidateRequest
     * @return UpdateCandidateResponse
     */
    updateCandidate(command: UpdateCandidateRequest, cancelToken?: CancelToken): Promise<UpdateCandidateResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/commands/updatecandidate`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCandidatesRequest
     * @return UpdateCandidatesResponse
     */
    updateCandidates(command: UpdateCandidatesRequest, cancelToken?: CancelToken): Promise<UpdateCandidatesResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/commands/updatecandidates`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCompanyRecruitmentRequest
     * @return UpdateCompanyRecruitmentResponse
     */
    updateCompanyRecruitment(command: UpdateCompanyRecruitmentRequest, cancelToken?: CancelToken): Promise<UpdateCompanyRecruitmentResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/commands/updatecompanyrecruitment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetActiveClosureCausesResponse
     */
    getActiveClosureCauses(cancelToken?: CancelToken): Promise<GetActiveClosureCausesResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getactiveclosurecauses`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAttachmentSettingsForCompanyRecruitmentResponse
     */
    getAttachmentSettingsForCompanyRecruitment(cancelToken?: CancelToken): Promise<GetAttachmentSettingsForCompanyRecruitmentResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getattachmentsettingsforcompanyrecruitment`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCalculatedDueDateRequest
     * @return GetCalculatedDueDateResponse
     */
    getCalculatedDueDate(query: GetCalculatedDueDateRequest, cancelToken?: CancelToken): Promise<GetCalculatedDueDateResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcalculatedduedate`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenHasTargetGroupThatSupportJobReferralsRequest
     * @return GetCitizenHasTargetGroupThatSupportJobReferralsResponse
     */
    getCitizenHasTargetGroupThatSupportJobReferrals(query: GetCitizenHasTargetGroupThatSupportJobReferralsRequest, cancelToken?: CancelToken): Promise<GetCitizenHasTargetGroupThatSupportJobReferralsResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcitizenhastargetgroupthatsupportjobreferrals`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompaniesInfoRequest
     * @return GetCompaniesInfoResponse
     */
    getCompanies(query: GetCompaniesInfoRequest, cancelToken?: CancelToken): Promise<GetCompaniesInfoResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcompanies`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyContactPersonsRequest
     * @return GetCompanyContactPersonsResponse
     */
    getCompanyContactPersons(query: GetCompanyContactPersonsRequest, cancelToken?: CancelToken): Promise<GetCompanyContactPersonsResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcompanycontactpersons`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyInfoRequest
     * @return GetCompanyInfoResponse
     */
    getCompanyInfo(query: GetCompanyInfoRequest2, cancelToken?: CancelToken): Promise<GetCompanyInfoResponse2> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcompanyinfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyNotesRequest
     * @return GetCompanyNotesResponse
     */
    getCompanyNotes(query: GetCompanyNotesRequest, cancelToken?: CancelToken): Promise<GetCompanyNotesResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcompanynotes`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyRecruitmentCandidateRequest
     * @return GetCompanyRecruitmentCandidateResponse
     */
    getCompanyRecruitmentCandidate(query: GetCompanyRecruitmentCandidateRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentCandidateResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcompanyrecruitmentcandidate`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyRecruitmentDetailsRequest
     * @return GetCompanyRecruitmentDetailsResponse
     */
    getCompanyRecruitmentDetails(query: GetCompanyRecruitmentDetailsRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentDetailsResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcompanyrecruitmentdetails`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyRecruitmentJobMatchesRequest
     * @return GetCompanyRecruitmentJobMatchesResponse
     */
    getCompanyRecruitmentJobMatches(query: GetCompanyRecruitmentJobMatchesRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentJobMatchesResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcompanyrecruitmentjobmatches`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyRecruitmentPdfRequest
     * @return FileResponse
     */
    getCompanyRecruitmentPdf(query: GetCompanyRecruitmentPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcompanyrecruitmentpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyRecruitmentsByCompanyIdRequest
     * @return GetCompanyRecruitmentsByCompanyIdResponse
     */
    getCompanyRecruitmentsByCompanyId(query: GetCompanyRecruitmentsByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentsByCompanyIdResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcompanyrecruitmentsbycompanyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyRecruitmentsForCandidateReferralRequest
     * @return GetCompanyRecruitmentsForCandidateReferralResponse
     */
    getCompanyRecruitmentsForCandidateReferral(query: GetCompanyRecruitmentsForCandidateReferralRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentsForCandidateReferralResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcompanyrecruitmentsforcandidatereferral`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyRecruitmentsFromSkillsRelinkRequest
     * @return GetCompanyRecruitmentsFromSkillsRelinkResponse
     */
    getCompanyRecruitmentsFromSkillsRelink(query: GetCompanyRecruitmentsFromSkillsRelinkRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentsFromSkillsRelinkResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcompanyrecruitmentsfromskillsrelink`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompetenciesRecommendationRequest
     * @return GetCompetenciesRecommendationResponse
     */
    getCompetenciesRecommendation(query: GetCompetenciesRecommendationRequest, cancelToken?: CancelToken): Promise<GetCompetenciesRecommendationResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcompetenciesrecommendation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCrmHostResponse
     */
    getCrmHost(cancelToken?: CancelToken): Promise<GetCrmHostResponse2> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getcrmhost`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDocumentsFromDocumentArchiveForCompanyRecruitmentRequest
     * @return GetDocumentsFromDocumentArchiveForCompanyRecruitmentResponse
     */
    getDocumentsFromDocumentArchiveForCompanyRecruitment(query: GetDocumentsFromDocumentArchiveForCompanyRecruitmentRequest, cancelToken?: CancelToken): Promise<GetDocumentsFromDocumentArchiveForCompanyRecruitmentResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getdocumentsfromdocumentarchiveforcompanyrecruitment`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetJobcentersResponse
     */
    getJobcenters(cancelToken?: CancelToken): Promise<GetJobcentersResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getjobcenters`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNumberOfCandidatesRequest
     * @return GetNumberOfCandidatesResponse
     */
    getNumberOfCandidates(query: GetNumberOfCandidatesRequest, cancelToken?: CancelToken): Promise<GetNumberOfCandidatesResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getnumberofcandidates`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOccupationsResponse
     */
    getOccupations(cancelToken?: CancelToken): Promise<GetOccupationsResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getoccupations`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferInfoForNewRecruitmentRequest
     * @return GetOfferInfoForNewRecruitmentReponse
     */
    getOfferInfoForNewRecruitment(query: GetOfferInfoForNewRecruitmentRequest, cancelToken?: CancelToken): Promise<GetOfferInfoForNewRecruitmentReponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getofferinfofornewrecruitment`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOfferTypesResponse
     */
    getOfferTypes(cancelToken?: CancelToken): Promise<GetOfferTypesResponse2> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getoffertypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetPlacementPurposeTypesResponse
     */
    getPlacementPurposeTypes(cancelToken?: CancelToken): Promise<GetPlacementPurposeTypesResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getplacementpurposetypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetQualificationRecommendationRequest
     * @return GetQualificationRecommendationResponse
     */
    getQualificationRecommendation(query: GetQualificationRecommendationRequest, cancelToken?: CancelToken): Promise<GetQualificationRecommendationResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getqualificationrecommendation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetQualificationsResponse
     */
    getQualifications(cancelToken?: CancelToken): Promise<GetQualificationsResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getqualifications`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetRecruitmentCollaborationsResponse
     */
    getRecruitmentCollaborations(cancelToken?: CancelToken): Promise<GetRecruitmentCollaborationsResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getrecruitmentcollaborations`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetRecruitmentCompanyInformationRequest
     * @return GetRecruitmentCompanyInformationResponse
     */
    getRecruitmentCompanyInformation(query: GetRecruitmentCompanyInformationRequest, cancelToken?: CancelToken): Promise<GetRecruitmentCompanyInformationResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getrecruitmentcompanyinformation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetRecruitmentInformationTypesResponse
     */
    getRecruitmentInformationTypes(cancelToken?: CancelToken): Promise<GetRecruitmentInformationTypesResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getrecruitmentinformationtypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSearchInOwnCitizensUrlResponse
     */
    getSearchInOwnCitizensUrl(cancelToken?: CancelToken): Promise<GetSearchInOwnCitizensUrlResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getsearchinowncitizensurl`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetServiceTargetTypesResponse
     */
    getServiceTargetTypes(cancelToken?: CancelToken): Promise<GetServiceTargetTypesResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getservicetargettypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSettingsResponse
     */
    getSettings(cancelToken?: CancelToken): Promise<GetSettingsResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getsettings`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSmartMatchCvSuggestionsRequest
     * @return GetSmartMatchCvSuggestionsResponse
     */
    getSmartMatchCvSuggestions(query: GetSmartMatchCvSuggestionsRequest, cancelToken?: CancelToken): Promise<GetSmartMatchCvSuggestionsResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getsmartmatchcvsuggestions`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTargetGroupByCitizenIdRequest
     * @return GetTargetGroupByCitizenIdResponse
     */
    getTargetGroupByCitizenId(query: GetTargetGroupByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetTargetGroupByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/gettargetgroupbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTargetGroupsResponse
     */
    getTargetGroups(cancelToken?: CancelToken): Promise<GetTargetGroupsResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/gettargetgroups`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTeamsWithUsersHavingFormidlingsansvarligRoleResponse
     */
    getTeamsWithUsersHavingFormidlingsansvarligRole(cancelToken?: CancelToken): Promise<GetTeamsWithUsersHavingFormidlingsansvarligRoleResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getteamswithusershavingformidlingsansvarligrole`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTeamsWithUsersHavingJobEjerRoleResponse
     */
    getTeamsWithUsersHavingJobEjerRole(cancelToken?: CancelToken): Promise<GetTeamsWithUsersHavingJobEjerRoleResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getteamswithusershavingjobejerrole`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTenantJobcenterResponse
     */
    getTenantJobcenter(cancelToken?: CancelToken): Promise<GetTenantJobcenterResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/gettenantjobcenter`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetUnemploymentFundsResponse
     */
    getUnemploymentFunds(cancelToken?: CancelToken): Promise<GetUnemploymentFundsResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getunemploymentfunds`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetUsersWithFormidlingsansvarligRoleResponse
     */
    getUsersWithFormidlingsansvarligRole(cancelToken?: CancelToken): Promise<GetUsersWithFormidlingsansvarligRoleResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getuserswithformidlingsansvarligrole`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetUsersWithJobEjerRoleResponse
     */
    getUsersWithJobEjerRole(cancelToken?: CancelToken): Promise<GetUsersWithJobEjerRoleResponse> {
        const $url = `${this.baseUrl}/api/companyrecruitments/queries/getuserswithjobejerrole`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ISearchClient {
    /**
     * @param command CreateCitizenRequest
     * @return CreateCitizenResponse
     */
    createCitizen(command: CreateCitizenRequest, cancelToken?: CancelToken): Promise<CreateCitizenResponse>;
    /**
     * @param command CreateCompanyRequest
     * @return CreateCompanyResponse
     */
    createCompany(command: CreateCompanyRequest, cancelToken?: CancelToken): Promise<CreateCompanyResponse>;
    /**
     * @param command CreateDashboardRequest
     * @return CreateDashboardResponse
     */
    createDashboard(command: CreateDashboardRequest, cancelToken?: CancelToken): Promise<CreateDashboardResponse>;
    /**
     * @param command CreateWorklistAccessControlRequest
     * @return CreateWorklistAccessControlResponse
     */
    createWorklistAccessControl(command: CreateWorklistAccessControlRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteDashboardRequest
     * @return DeleteDashboardResponse
     */
    deleteDashboard(command: DeleteDashboardRequest, cancelToken?: CancelToken): Promise<DeleteDashboardResponse>;
    /**
     * @return DeleteFavoriteDashboardResponse
     */
    deleteFavoriteDashboard(cancelToken?: CancelToken): Promise<DeleteFavoriteDashboardResponse>;
    /**
     * @param command DeleteWorklistAccessControlRequest
     * @return DeleteWorklistAccessControlResponse
     */
    deleteWorklistAccessControl(command: DeleteWorklistAccessControlRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteWorklistElementsRequest
     * @return DeleteWorklistElementsResponse
     */
    deleteWorklistElements(command: DeleteWorklistElementsRequest, cancelToken?: CancelToken): Promise<DeleteWorklistElementsResponse>;
    /**
     * @param command HandleFavoriteDashboardRequest
     * @return HandleFavoriteDashboardResponse
     */
    handleFavoriteDashboard(command: HandleFavoriteDashboardRequest, cancelToken?: CancelToken): Promise<HandleFavoriteDashboardResponse>;
    /**
     * @param command UpdateDashboardRequest
     * @return UpdateDashboardResponse
     */
    updateDashboard(command: UpdateDashboardRequest, cancelToken?: CancelToken): Promise<UpdateDashboardResponse>;
    /**
     * @param command UpdateDashboardStartpageRequest
     * @return UpdateDashboardStartpageResponse
     */
    updateDashboardStartpage(command: UpdateDashboardStartpageRequest, cancelToken?: CancelToken): Promise<UpdateDashboardStartpageResponse>;
    /**
     * @param command UpdateFavoriteDashboardRequest
     * @return UpdateFavoriteDashboardResponse
     */
    updateFavoriteDashboard(command: UpdateFavoriteDashboardRequest, cancelToken?: CancelToken): Promise<UpdateFavoriteDashboardResponse>;
    /**
     * @param command UpdateSavedChartOwnerRequest
     * @return UpdateSavedChartOwnerResponse
     */
    updateSavedChartOwner(command: UpdateSavedChartOwnerRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateSavedDashboardOwnerRequest
     * @return UpdateSavedDashboardOwnerResponse
     */
    updateSavedDashboardOwner(command: UpdateSavedDashboardOwnerRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateSavedQueryOwnerRequest
     * @return UpdateSavedQueryOwnerResponse
     */
    updateSavedQueryOwner(command: UpdateSavedQueryOwnerRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateWorklistAccessControlRequest
     * @return UpdateWorklistAccessControlResponse
     */
    updateWorklistAccessControl(command: UpdateWorklistAccessControlRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetApplicationAreasRequest
     * @return GetApplicationAreasResponse
     */
    applicationAreasQuery(query: GetApplicationAreasRequest, cancelToken?: CancelToken): Promise<GetApplicationAreasResponse>;
    /**
     * @param query SavedQueryRequestBody
     * @return FileResponse
     */
    excelDownloadBySavedQuery(query: SavedQueryRequestBody, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query SearchDownloadRequest
     * @return FileResponse
     */
    excelDownloadQuery(query: SearchDownloadRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return GetAllDashboardCategoriesResponse
     */
    getAllDashboardCategories(cancelToken?: CancelToken): Promise<GetAllDashboardCategoriesResponse>;
    /**
     * @return GetAllDashboardsResponse
     */
    getAllDashboards(cancelToken?: CancelToken): Promise<GetAllDashboardsResponse>;
    /**
     * @return GetAllDashboardTagsResponse
     */
    getAllDashboardTags(cancelToken?: CancelToken): Promise<GetAllDashboardTagsResponse>;
    /**
     * @param query GetAllPermissionsRequest
     * @return GetAllPermissionsResponse
     */
    getAllPermissions(query: GetAllPermissionsRequest, cancelToken?: CancelToken): Promise<GetAllPermissionsResponse>;
    /**
     * @param query GetCitizenByCprRequest
     * @return GetCitizenByCprResponse
     */
    getCitizenByCpr(query: GetCitizenByCprRequest, cancelToken?: CancelToken): Promise<GetCitizenByCprResponse>;
    /**
     * @param query GetCitizenFromDfdgRequest
     * @return GetCitizenFromDfdgResponse
     */
    getCitizenFromDfdg(query: GetCitizenFromDfdgRequest, cancelToken?: CancelToken): Promise<GetCitizenFromDfdgResponse>;
    /**
     * @param query GetCompanyByProductionUnitIdentifierRequest
     * @return GetCompanyByProductionUnitIdentifierResponse
     */
    getCompanyByProductionUnitIdentifier(query: GetCompanyByProductionUnitIdentifierRequest, cancelToken?: CancelToken): Promise<GetCompanyByProductionUnitIdentifierResponse>;
    /**
     * @param query GetCompanyFromCvrByProductionUnitIdentifierRequest
     * @return GetCompanyFromCvrByProductionUnitIdentifierResponse
     */
    getCompanyFromCvrByProductionUnitIdentifier(query: GetCompanyFromCvrByProductionUnitIdentifierRequest, cancelToken?: CancelToken): Promise<GetCompanyFromCvrByProductionUnitIdentifierResponse>;
    /**
     * @param query GetDashboardByIdRequest
     * @return GetDashboardByIdResponse
     */
    getDashboardById(query: GetDashboardByIdRequest, cancelToken?: CancelToken): Promise<GetDashboardByIdResponse>;
    /**
     * @param query GetDashboardCompositionRequest
     * @return GetDashboardCompositionResponse
     */
    getDashboardComposition(query: GetDashboardCompositionRequest, cancelToken?: CancelToken): Promise<GetDashboardCompositionResponse>;
    /**
     * @param query GetDashboardsRequest
     * @return GetDashboardsResponse
     */
    getDashboards(query: GetDashboardsRequest, cancelToken?: CancelToken): Promise<GetDashboardsResponse>;
    /**
     * @return GetDashboardStartPageIdResponse
     */
    getDashboardStartPageId(cancelToken?: CancelToken): Promise<GetDashboardStartPageIdResponse>;
    /**
     * @param query GetEmbeddedSearchRequest
     * @return GetEmbeddedSearchResponse
     */
    getEmbeddedSearch(query: GetEmbeddedSearchRequest, cancelToken?: CancelToken): Promise<GetEmbeddedSearchResponse>;
    /**
     * @param query GetUrlsFromFasitCrmUserFormBaseRequest
     * @return GetUrlsFromFasitCrmUserFormBaseResponse
     */
    getUrlsFromFasitCrmUserFormBase(query: GetUrlsFromFasitCrmUserFormBaseRequest, cancelToken?: CancelToken): Promise<GetUrlsFromFasitCrmUserFormBaseResponse>;
    /**
     * @param query GetWorklistElementUsageRequest
     * @return GetWorklistElementUsageResponse
     */
    getWorklistElementUsage(query: GetWorklistElementUsageRequest, cancelToken?: CancelToken): Promise<GetWorklistElementUsageResponse>;
    /**
     * @param query GetWorklistUsageOverviewRequest
     * @return GetWorklistUsageOverviewResponse
     */
    getWorklistUsageOverview(query: GetWorklistUsageOverviewRequest, cancelToken?: CancelToken): Promise<GetWorklistUsageOverviewResponse>;
    /**
     * @param query RankedSearchDslConfigurationNameRequest
     * @return RankedSearchDslConfigurationNameResponse
     */
    rankedSearchDslConfigurationNamesQuery(query: RankedSearchDslConfigurationNameRequest, cancelToken?: CancelToken): Promise<RankedSearchDslConfigurationNameResponse>;
    /**
     * @param query GetRankedSearchRequest
     * @return GetRankedSearchResponse
     */
    rankedSearchQuery(query: GetRankedSearchRequest, cancelToken?: CancelToken): Promise<GetRankedSearchResponse>;
    /**
     * @param query GetWorklistAccessControlRequest
     * @return GetWorklistAccessControlResponse
     */
    worklistAccessControlQuery(query: GetWorklistAccessControlRequest, cancelToken?: CancelToken): Promise<GetWorklistAccessControlResponse>;
}

export class SearchClient implements ISearchClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateCitizenRequest
     * @return CreateCitizenResponse
     */
    createCitizen(command: CreateCitizenRequest, cancelToken?: CancelToken): Promise<CreateCitizenResponse> {
        const $url = `${this.baseUrl}/api/search/commands/createcitizen`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCompanyRequest
     * @return CreateCompanyResponse
     */
    createCompany(command: CreateCompanyRequest, cancelToken?: CancelToken): Promise<CreateCompanyResponse> {
        const $url = `${this.baseUrl}/api/search/commands/createcompany`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateDashboardRequest
     * @return CreateDashboardResponse
     */
    createDashboard(command: CreateDashboardRequest, cancelToken?: CancelToken): Promise<CreateDashboardResponse> {
        const $url = `${this.baseUrl}/api/search/commands/createdashboard`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateWorklistAccessControlRequest
     * @return CreateWorklistAccessControlResponse
     */
    createWorklistAccessControl(command: CreateWorklistAccessControlRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/search/commands/createworklistaccesscontrol`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteDashboardRequest
     * @return DeleteDashboardResponse
     */
    deleteDashboard(command: DeleteDashboardRequest, cancelToken?: CancelToken): Promise<DeleteDashboardResponse> {
        const $url = `${this.baseUrl}/api/search/commands/deletedashboard`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return DeleteFavoriteDashboardResponse
     */
    deleteFavoriteDashboard(cancelToken?: CancelToken): Promise<DeleteFavoriteDashboardResponse> {
        const $url = `${this.baseUrl}/api/search/commands/deletefavoritedashboard`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteWorklistAccessControlRequest
     * @return DeleteWorklistAccessControlResponse
     */
    deleteWorklistAccessControl(command: DeleteWorklistAccessControlRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/search/commands/deleteworklistaccesscontrol`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteWorklistElementsRequest
     * @return DeleteWorklistElementsResponse
     */
    deleteWorklistElements(command: DeleteWorklistElementsRequest, cancelToken?: CancelToken): Promise<DeleteWorklistElementsResponse> {
        const $url = `${this.baseUrl}/api/search/commands/deleteworklistelements`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command HandleFavoriteDashboardRequest
     * @return HandleFavoriteDashboardResponse
     */
    handleFavoriteDashboard(command: HandleFavoriteDashboardRequest, cancelToken?: CancelToken): Promise<HandleFavoriteDashboardResponse> {
        const $url = `${this.baseUrl}/api/search/commands/handlefavoritedashboard`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateDashboardRequest
     * @return UpdateDashboardResponse
     */
    updateDashboard(command: UpdateDashboardRequest, cancelToken?: CancelToken): Promise<UpdateDashboardResponse> {
        const $url = `${this.baseUrl}/api/search/commands/updatedashboard`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateDashboardStartpageRequest
     * @return UpdateDashboardStartpageResponse
     */
    updateDashboardStartpage(command: UpdateDashboardStartpageRequest, cancelToken?: CancelToken): Promise<UpdateDashboardStartpageResponse> {
        const $url = `${this.baseUrl}/api/search/commands/updatedashboardstartpage`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateFavoriteDashboardRequest
     * @return UpdateFavoriteDashboardResponse
     */
    updateFavoriteDashboard(command: UpdateFavoriteDashboardRequest, cancelToken?: CancelToken): Promise<UpdateFavoriteDashboardResponse> {
        const $url = `${this.baseUrl}/api/search/commands/updatefavoritedashboard`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateSavedChartOwnerRequest
     * @return UpdateSavedChartOwnerResponse
     */
    updateSavedChartOwner(command: UpdateSavedChartOwnerRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/search/commands/updatesavedchartowner`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateSavedDashboardOwnerRequest
     * @return UpdateSavedDashboardOwnerResponse
     */
    updateSavedDashboardOwner(command: UpdateSavedDashboardOwnerRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/search/commands/updatesaveddashboardowner`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateSavedQueryOwnerRequest
     * @return UpdateSavedQueryOwnerResponse
     */
    updateSavedQueryOwner(command: UpdateSavedQueryOwnerRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/search/commands/updatesavedqueryowner`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateWorklistAccessControlRequest
     * @return UpdateWorklistAccessControlResponse
     */
    updateWorklistAccessControl(command: UpdateWorklistAccessControlRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/search/commands/updateworklistaccesscontrol`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetApplicationAreasRequest
     * @return GetApplicationAreasResponse
     */
    applicationAreasQuery(query: GetApplicationAreasRequest, cancelToken?: CancelToken): Promise<GetApplicationAreasResponse> {
        const $url = `${this.baseUrl}/api/search/queries/applicationareasquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query SavedQueryRequestBody
     * @return FileResponse
     */
    excelDownloadBySavedQuery(query: SavedQueryRequestBody, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/search/queries/exceldownloadbysavedquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query SearchDownloadRequest
     * @return FileResponse
     */
    excelDownloadQuery(query: SearchDownloadRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/search/queries/exceldownloadquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @return GetAllDashboardCategoriesResponse
     */
    getAllDashboardCategories(cancelToken?: CancelToken): Promise<GetAllDashboardCategoriesResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getalldashboardcategories`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAllDashboardsResponse
     */
    getAllDashboards(cancelToken?: CancelToken): Promise<GetAllDashboardsResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getalldashboards`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAllDashboardTagsResponse
     */
    getAllDashboardTags(cancelToken?: CancelToken): Promise<GetAllDashboardTagsResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getalldashboardtags`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAllPermissionsRequest
     * @return GetAllPermissionsResponse
     */
    getAllPermissions(query: GetAllPermissionsRequest, cancelToken?: CancelToken): Promise<GetAllPermissionsResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getallpermissions`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenByCprRequest
     * @return GetCitizenByCprResponse
     */
    getCitizenByCpr(query: GetCitizenByCprRequest, cancelToken?: CancelToken): Promise<GetCitizenByCprResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getcitizenbycpr`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenFromDfdgRequest
     * @return GetCitizenFromDfdgResponse
     */
    getCitizenFromDfdg(query: GetCitizenFromDfdgRequest, cancelToken?: CancelToken): Promise<GetCitizenFromDfdgResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getcitizenfromdfdg`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyByProductionUnitIdentifierRequest
     * @return GetCompanyByProductionUnitIdentifierResponse
     */
    getCompanyByProductionUnitIdentifier(query: GetCompanyByProductionUnitIdentifierRequest, cancelToken?: CancelToken): Promise<GetCompanyByProductionUnitIdentifierResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getcompanybyproductionunitidentifier`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyFromCvrByProductionUnitIdentifierRequest
     * @return GetCompanyFromCvrByProductionUnitIdentifierResponse
     */
    getCompanyFromCvrByProductionUnitIdentifier(query: GetCompanyFromCvrByProductionUnitIdentifierRequest, cancelToken?: CancelToken): Promise<GetCompanyFromCvrByProductionUnitIdentifierResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getcompanyfromcvrbyproductionunitidentifier`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDashboardByIdRequest
     * @return GetDashboardByIdResponse
     */
    getDashboardById(query: GetDashboardByIdRequest, cancelToken?: CancelToken): Promise<GetDashboardByIdResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getdashboardbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDashboardCompositionRequest
     * @return GetDashboardCompositionResponse
     */
    getDashboardComposition(query: GetDashboardCompositionRequest, cancelToken?: CancelToken): Promise<GetDashboardCompositionResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getdashboardcomposition`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDashboardsRequest
     * @return GetDashboardsResponse
     */
    getDashboards(query: GetDashboardsRequest, cancelToken?: CancelToken): Promise<GetDashboardsResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getdashboards`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetDashboardStartPageIdResponse
     */
    getDashboardStartPageId(cancelToken?: CancelToken): Promise<GetDashboardStartPageIdResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getdashboardstartpageid`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEmbeddedSearchRequest
     * @return GetEmbeddedSearchResponse
     */
    getEmbeddedSearch(query: GetEmbeddedSearchRequest, cancelToken?: CancelToken): Promise<GetEmbeddedSearchResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getembeddedsearch`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUrlsFromFasitCrmUserFormBaseRequest
     * @return GetUrlsFromFasitCrmUserFormBaseResponse
     */
    getUrlsFromFasitCrmUserFormBase(query: GetUrlsFromFasitCrmUserFormBaseRequest, cancelToken?: CancelToken): Promise<GetUrlsFromFasitCrmUserFormBaseResponse> {
        const $url = `${this.baseUrl}/api/search/queries/geturlsfromfasitcrmuserformbase`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetWorklistElementUsageRequest
     * @return GetWorklistElementUsageResponse
     */
    getWorklistElementUsage(query: GetWorklistElementUsageRequest, cancelToken?: CancelToken): Promise<GetWorklistElementUsageResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getworklistelementusage`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetWorklistUsageOverviewRequest
     * @return GetWorklistUsageOverviewResponse
     */
    getWorklistUsageOverview(query: GetWorklistUsageOverviewRequest, cancelToken?: CancelToken): Promise<GetWorklistUsageOverviewResponse> {
        const $url = `${this.baseUrl}/api/search/queries/getworklistusageoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query RankedSearchDslConfigurationNameRequest
     * @return RankedSearchDslConfigurationNameResponse
     */
    rankedSearchDslConfigurationNamesQuery(query: RankedSearchDslConfigurationNameRequest, cancelToken?: CancelToken): Promise<RankedSearchDslConfigurationNameResponse> {
        const $url = `${this.baseUrl}/api/search/queries/rankedsearchdslconfigurationnamesquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetRankedSearchRequest
     * @return GetRankedSearchResponse
     */
    rankedSearchQuery(query: GetRankedSearchRequest, cancelToken?: CancelToken): Promise<GetRankedSearchResponse> {
        const $url = `${this.baseUrl}/api/search/queries/rankedsearchquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetWorklistAccessControlRequest
     * @return GetWorklistAccessControlResponse
     */
    worklistAccessControlQuery(query: GetWorklistAccessControlRequest, cancelToken?: CancelToken): Promise<GetWorklistAccessControlResponse> {
        const $url = `${this.baseUrl}/api/search/queries/worklistaccesscontrolquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenVisitationAssistantClient {
    /**
     * @param command CreateClosedSdpCaseAnalysisRequest
     * @return CreateClosedSdpCaseAnalysisResponse
     */
    createClosedSdpCaseAnalysis(command: CreateClosedSdpCaseAnalysisRequest, cancelToken?: CancelToken): Promise<CreateClosedSdpCaseAnalysisResponse>;
    /**
     * @param query AnalyzeClosedSdpCaseStreamingRequest
     * @return FileResponse
     */
    analyzeClosedSdpCaseStreaming(query: AnalyzeClosedSdpCaseStreamingRequest, signal?: AbortSignal): Promise<NdjsonStreamResponse>;
    /**
     * @param query GetCaseEmployerRequest
     * @return GetCaseEmployerResponse
     */
    getCaseEmployer(query: GetCaseEmployerRequest, cancelToken?: CancelToken): Promise<GetCaseEmployerResponse>;
    /**
     * @param query GetStoredCaseAnalysisRequest
     * @return GetStoredCaseAnalysisResponse
     */
    getStoredCaseAnalysis(query: GetStoredCaseAnalysisRequest, cancelToken?: CancelToken): Promise<GetStoredCaseAnalysisResponse>;
    /**
     * @param query GetVisitationAssistantRequest
     * @return GetVisitationAssistantResponse
     */
    getVisitationAssistant(query: GetVisitationAssistantRequest, cancelToken?: CancelToken): Promise<GetVisitationAssistantResponse>;
    /**
     * @return GetVisitationGuideResponse
     */
    getVisitationGuide(cancelToken?: CancelToken): Promise<GetVisitationGuideResponse>;
}

export class CitizenVisitationAssistantClient implements ICitizenVisitationAssistantClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateClosedSdpCaseAnalysisRequest
     * @return CreateClosedSdpCaseAnalysisResponse
     */
    createClosedSdpCaseAnalysis(command: CreateClosedSdpCaseAnalysisRequest, cancelToken?: CancelToken): Promise<CreateClosedSdpCaseAnalysisResponse> {
        const $url = `${this.baseUrl}/api/citizen/visitationassistant/commands/createclosedsdpcaseanalysis`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query AnalyzeClosedSdpCaseStreamingRequest
     * @return FileResponse
     */
    analyzeClosedSdpCaseStreaming(query: AnalyzeClosedSdpCaseStreamingRequest, signal?: AbortSignal): Promise<NdjsonStreamResponse> {
        const $url = `${this.baseUrl}/api/citizen/visitationassistant/queries/analyzeclosedsdpcasestreaming`;

        const options_: AxiosRequestConfig = {
            data: query,
            adapter: 'fetch',
            responseType: 'stream',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/x-ndjson',
            },
            signal,
        };

        return handleStreamResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseEmployerRequest
     * @return GetCaseEmployerResponse
     */
    getCaseEmployer(query: GetCaseEmployerRequest, cancelToken?: CancelToken): Promise<GetCaseEmployerResponse> {
        const $url = `${this.baseUrl}/api/citizen/visitationassistant/queries/getcaseemployer`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetStoredCaseAnalysisRequest
     * @return GetStoredCaseAnalysisResponse
     */
    getStoredCaseAnalysis(query: GetStoredCaseAnalysisRequest, cancelToken?: CancelToken): Promise<GetStoredCaseAnalysisResponse> {
        const $url = `${this.baseUrl}/api/citizen/visitationassistant/queries/getstoredcaseanalysis`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetVisitationAssistantRequest
     * @return GetVisitationAssistantResponse
     */
    getVisitationAssistant(query: GetVisitationAssistantRequest, cancelToken?: CancelToken): Promise<GetVisitationAssistantResponse> {
        const $url = `${this.baseUrl}/api/citizen/visitationassistant/queries/getvisitationassistant`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetVisitationGuideResponse
     */
    getVisitationGuide(cancelToken?: CancelToken): Promise<GetVisitationGuideResponse> {
        const $url = `${this.baseUrl}/api/citizen/visitationassistant/queries/getvisitationguide`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenUseOfForceAuthorizationClient {
    /**
     * @param command GrantUseOfForceAuthorizationRequestRequest
     * @return GrantUseOfForceAuthorizationRequestResponse
     */
    grantUseOfForceAuthorizationRequest(command: GrantUseOfForceAuthorizationRequestRequest, cancelToken?: CancelToken): Promise<GrantUseOfForceAuthorizationRequestResponse>;
    /**
     * @param command RegisterUseOfForceAuthorizationRequest
     * @return RegisterUseOfForceAuthorizationResponse
     */
    registerUseOfForceAuthorization(command: RegisterUseOfForceAuthorizationRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceAuthorizationResponse>;
    /**
     * @param command RejectUseOfForceAuthorizationRequestRequest
     * @return RejectUseOfForceAuthorizationRequestResponse
     */
    rejectUseOfForceAuthorizationRequest(command: RejectUseOfForceAuthorizationRequestRequest, cancelToken?: CancelToken): Promise<RejectUseOfForceAuthorizationRequestResponse>;
    /**
     * @param command RevokeUseOfForceAuthorizationRequest
     * @return RevokeUseOfForceAuthorizationResponse
     */
    revokeUseOfForceAuthorization(command: RevokeUseOfForceAuthorizationRequest, cancelToken?: CancelToken): Promise<RevokeUseOfForceAuthorizationResponse>;
    /**
     * @param query GetReceivedUseOfForceAuthorizationRequestPdfRequest
     * @return FileResponse
     */
    getReceivedUseOfForceAuthorizationRequestPdf(query: GetReceivedUseOfForceAuthorizationRequestPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetReceivedUseOfForceAuthorizationRequestsRequest
     * @return GetReceivedUseOfForceAuthorizationRequestsResponse
     */
    getReceivedUseOfForceAuthorizationRequests(query: GetReceivedUseOfForceAuthorizationRequestsRequest, cancelToken?: CancelToken): Promise<GetReceivedUseOfForceAuthorizationRequestsResponse>;
    /**
     * @param query GetUseOfForceAuthorizationsForCitizenRequest
     * @return GetUseOfForceAuthorizationsForCitizenResponse
     */
    getUseOfForceAuthorizationsForCitizen(query: GetUseOfForceAuthorizationsForCitizenRequest, cancelToken?: CancelToken): Promise<GetUseOfForceAuthorizationsForCitizenResponse>;
}

export class CitizenUseOfForceAuthorizationClient implements ICitizenUseOfForceAuthorizationClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command GrantUseOfForceAuthorizationRequestRequest
     * @return GrantUseOfForceAuthorizationRequestResponse
     */
    grantUseOfForceAuthorizationRequest(command: GrantUseOfForceAuthorizationRequestRequest, cancelToken?: CancelToken): Promise<GrantUseOfForceAuthorizationRequestResponse> {
        const $url = `${this.baseUrl}/api/citizen/useofforceauthorization/commands/grantuseofforceauthorizationrequest`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterUseOfForceAuthorizationRequest
     * @return RegisterUseOfForceAuthorizationResponse
     */
    registerUseOfForceAuthorization(command: RegisterUseOfForceAuthorizationRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceAuthorizationResponse> {
        const $url = `${this.baseUrl}/api/citizen/useofforceauthorization/commands/registeruseofforceauthorization`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RejectUseOfForceAuthorizationRequestRequest
     * @return RejectUseOfForceAuthorizationRequestResponse
     */
    rejectUseOfForceAuthorizationRequest(command: RejectUseOfForceAuthorizationRequestRequest, cancelToken?: CancelToken): Promise<RejectUseOfForceAuthorizationRequestResponse> {
        const $url = `${this.baseUrl}/api/citizen/useofforceauthorization/commands/rejectuseofforceauthorizationrequest`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RevokeUseOfForceAuthorizationRequest
     * @return RevokeUseOfForceAuthorizationResponse
     */
    revokeUseOfForceAuthorization(command: RevokeUseOfForceAuthorizationRequest, cancelToken?: CancelToken): Promise<RevokeUseOfForceAuthorizationResponse> {
        const $url = `${this.baseUrl}/api/citizen/useofforceauthorization/commands/revokeuseofforceauthorization`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetReceivedUseOfForceAuthorizationRequestPdfRequest
     * @return FileResponse
     */
    getReceivedUseOfForceAuthorizationRequestPdf(query: GetReceivedUseOfForceAuthorizationRequestPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/useofforceauthorization/queries/getreceiveduseofforceauthorizationrequestpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetReceivedUseOfForceAuthorizationRequestsRequest
     * @return GetReceivedUseOfForceAuthorizationRequestsResponse
     */
    getReceivedUseOfForceAuthorizationRequests(query: GetReceivedUseOfForceAuthorizationRequestsRequest, cancelToken?: CancelToken): Promise<GetReceivedUseOfForceAuthorizationRequestsResponse> {
        const $url = `${this.baseUrl}/api/citizen/useofforceauthorization/queries/getreceiveduseofforceauthorizationrequests`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceAuthorizationsForCitizenRequest
     * @return GetUseOfForceAuthorizationsForCitizenResponse
     */
    getUseOfForceAuthorizationsForCitizen(query: GetUseOfForceAuthorizationsForCitizenRequest, cancelToken?: CancelToken): Promise<GetUseOfForceAuthorizationsForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/useofforceauthorization/queries/getuseofforceauthorizationsforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenUseOfForceAssessmentClient {
    /**
     * @param command AssessUseOfForceFormRequest
     * @return AssessUseOfForceFormResponse
     */
    assessUseOfForceForm(command: AssessUseOfForceFormRequest, cancelToken?: CancelToken): Promise<AssessUseOfForceFormResponse>;
    /**
     * @param query GetUseOfForceAssessmentFormPdfRequest
     * @return FileResponse
     */
    getUseOfForceAssessmentFormPdf(query: GetUseOfForceAssessmentFormPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetUseOfForceAssessmentsForCitizenRequest
     * @return GetUseOfForceAssessmentsForCitizenResponse
     */
    getUseOfForceAssessmentsForCitizen(query: GetUseOfForceAssessmentsForCitizenRequest, cancelToken?: CancelToken): Promise<GetUseOfForceAssessmentsForCitizenResponse>;
}

export class CitizenUseOfForceAssessmentClient implements ICitizenUseOfForceAssessmentClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command AssessUseOfForceFormRequest
     * @return AssessUseOfForceFormResponse
     */
    assessUseOfForceForm(command: AssessUseOfForceFormRequest, cancelToken?: CancelToken): Promise<AssessUseOfForceFormResponse> {
        const $url = `${this.baseUrl}/api/citizen/useofforceassessment/commands/assessuseofforceform`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceAssessmentFormPdfRequest
     * @return FileResponse
     */
    getUseOfForceAssessmentFormPdf(query: GetUseOfForceAssessmentFormPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/useofforceassessment/queries/getuseofforceassessmentformpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceAssessmentsForCitizenRequest
     * @return GetUseOfForceAssessmentsForCitizenResponse
     */
    getUseOfForceAssessmentsForCitizen(query: GetUseOfForceAssessmentsForCitizenRequest, cancelToken?: CancelToken): Promise<GetUseOfForceAssessmentsForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/useofforceassessment/queries/getuseofforceassessmentsforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenUnemploymentBenefitClient {
    /**
     * @param command CreateNuphRequest
     * @return CreateNuphResponse
     */
    createNuph(command: CreateNuphRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateNuphDocumentsRequest
     * @return CreateNuphDocumentsResponse
     */
    createNuphDocuments(command: CreateNuphDocumentsRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateNuphFollowUpRequest
     * @return CreateNuphFollowUpResponse
     */
    createNuphFollowUp(command: CreateNuphFollowUpRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCitizenParticipationChoiceCommand
     * @return UpdateCitizenParticipationChoiceResponse
     */
    updateCitizenParticipationChoice(command: UpdateCitizenParticipationChoiceCommand, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateNuphRequest
     * @return UpdateNuphResponse
     */
    updateNuph(command: UpdateNuphRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateUnemploymentParticipationFirstInterviewCommand
     * @return UpdateUnemploymentParticipationFirstInterviewResponse
     */
    updateUnemploymentParticipationFirstInterview(command: UpdateUnemploymentParticipationFirstInterviewCommand, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command WithdrawNuphRequest
     * @return WithdrawNuphResponse
     */
    withdrawNuph(command: WithdrawNuphRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command WithdrawNuphDocumentRequest
     * @return WithdrawNuphDocumentResponse
     */
    withdrawNuphDocument(command: WithdrawNuphDocumentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query DownloadNuphDocumentRequest
     * @return FileResponse
     */
    downloadNuphDocument(query: DownloadNuphDocumentRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetAccountInfoRequest
     * @return GetAccountInfoResponse
     */
    getAccountInfo(query: GetAccountInfoRequest, cancelToken?: CancelToken): Promise<GetAccountInfoResponse>;
    /**
     * @param query GetCitizenAndNuphIdByNuphResponseIdRequest
     * @return GetCitizenAndNuphIdByNuphResponseIdResponse
     */
    getCitizenAndNuphIdByNuphResponseId(query: GetCitizenAndNuphIdByNuphResponseIdRequest, cancelToken?: CancelToken): Promise<GetCitizenAndNuphIdByNuphResponseIdResponse>;
    /**
     * @param query GetCitizenIdByNuphIdRequest
     * @return GetCitizenIdByNuphIdResponse
     */
    getCitizenIdByNuphId(query: GetCitizenIdByNuphIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByNuphIdResponse>;
    /**
     * @param query GetNuphRequest
     * @return GetNuphResponse
     */
    getNuph(query: GetNuphRequest, cancelToken?: CancelToken): Promise<GetNuphResponse>;
    /**
     * @param query GetNuphAdditionalInformationRequest
     * @return GetNuphAdditionalInformationResponse
     */
    getNuphAdditionalInformation(query: GetNuphAdditionalInformationRequest, cancelToken?: CancelToken): Promise<GetNuphAdditionalInformationResponse>;
    /**
     * @param query GetNuphDocumentsRequest
     * @return GetNuphDocumentsResponse
     */
    getNuphDocuments(query: GetNuphDocumentsRequest, cancelToken?: CancelToken): Promise<GetNuphDocumentsResponse>;
    /**
     * @param query GetNuphResponsesRequest
     * @return GetNuphResponsesResponse
     */
    getNuphResponses(query: GetNuphResponsesRequest, cancelToken?: CancelToken): Promise<GetNuphResponsesResponse>;
    /**
     * @param query GetNuphsRequest
     * @return GetNuphsResponse
     */
    getNuphs(query: GetNuphsRequest, cancelToken?: CancelToken): Promise<GetNuphsResponse>;
    /**
     * @return GetNuphTypesResponse
     */
    getNuphTypes(cancelToken?: CancelToken): Promise<GetNuphTypesResponse>;
    /**
     * @param query GetPayoutsRequest
     * @return GetPayoutsResponse
     */
    getPayouts(query: GetPayoutsRequest, cancelToken?: CancelToken): Promise<GetPayoutsResponse>;
    /**
     * @param query GetUnemploymentFundRequest
     * @return GetUnemploymentFundResponse
     */
    getUnemploymentFund(query: GetUnemploymentFundRequest, cancelToken?: CancelToken): Promise<GetUnemploymentFundResponse>;
    /**
     * @param query GetUnemploymentSummaryDetailsRequest
     * @return GetUnemploymentSummaryDetailsResponse
     */
    getUnemploymentSummaryDetails(query: GetUnemploymentSummaryDetailsRequest, cancelToken?: CancelToken): Promise<GetUnemploymentSummaryDetailsResponse>;
}

export class CitizenUnemploymentBenefitClient implements ICitizenUnemploymentBenefitClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateNuphRequest
     * @return CreateNuphResponse
     */
    createNuph(command: CreateNuphRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/commands/createnuph`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateNuphDocumentsRequest
     * @return CreateNuphDocumentsResponse
     */
    createNuphDocuments(command: CreateNuphDocumentsRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/commands/createnuphdocuments`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateNuphFollowUpRequest
     * @return CreateNuphFollowUpResponse
     */
    createNuphFollowUp(command: CreateNuphFollowUpRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/commands/createnuphfollowup`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCitizenParticipationChoiceCommand
     * @return UpdateCitizenParticipationChoiceResponse
     */
    updateCitizenParticipationChoice(command: UpdateCitizenParticipationChoiceCommand, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/commands/updatecitizenparticipationchoice`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateNuphRequest
     * @return UpdateNuphResponse
     */
    updateNuph(command: UpdateNuphRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/commands/updatenuph`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateUnemploymentParticipationFirstInterviewCommand
     * @return UpdateUnemploymentParticipationFirstInterviewResponse
     */
    updateUnemploymentParticipationFirstInterview(command: UpdateUnemploymentParticipationFirstInterviewCommand, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/commands/updateunemploymentparticipationfirstinterview`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command WithdrawNuphRequest
     * @return WithdrawNuphResponse
     */
    withdrawNuph(command: WithdrawNuphRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/commands/withdrawnuph`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command WithdrawNuphDocumentRequest
     * @return WithdrawNuphDocumentResponse
     */
    withdrawNuphDocument(command: WithdrawNuphDocumentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/commands/withdrawnuphdocument`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DownloadNuphDocumentRequest
     * @return FileResponse
     */
    downloadNuphDocument(query: DownloadNuphDocumentRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/queries/downloadnuphdocument`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAccountInfoRequest
     * @return GetAccountInfoResponse
     */
    getAccountInfo(query: GetAccountInfoRequest, cancelToken?: CancelToken): Promise<GetAccountInfoResponse> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/queries/getaccountinfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenAndNuphIdByNuphResponseIdRequest
     * @return GetCitizenAndNuphIdByNuphResponseIdResponse
     */
    getCitizenAndNuphIdByNuphResponseId(query: GetCitizenAndNuphIdByNuphResponseIdRequest, cancelToken?: CancelToken): Promise<GetCitizenAndNuphIdByNuphResponseIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/queries/getcitizenandnuphidbynuphresponseid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenIdByNuphIdRequest
     * @return GetCitizenIdByNuphIdResponse
     */
    getCitizenIdByNuphId(query: GetCitizenIdByNuphIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByNuphIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/queries/getcitizenidbynuphid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNuphRequest
     * @return GetNuphResponse
     */
    getNuph(query: GetNuphRequest, cancelToken?: CancelToken): Promise<GetNuphResponse> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/queries/getnuph`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNuphAdditionalInformationRequest
     * @return GetNuphAdditionalInformationResponse
     */
    getNuphAdditionalInformation(query: GetNuphAdditionalInformationRequest, cancelToken?: CancelToken): Promise<GetNuphAdditionalInformationResponse> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/queries/getnuphadditionalinformation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNuphDocumentsRequest
     * @return GetNuphDocumentsResponse
     */
    getNuphDocuments(query: GetNuphDocumentsRequest, cancelToken?: CancelToken): Promise<GetNuphDocumentsResponse> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/queries/getnuphdocuments`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNuphResponsesRequest
     * @return GetNuphResponsesResponse
     */
    getNuphResponses(query: GetNuphResponsesRequest, cancelToken?: CancelToken): Promise<GetNuphResponsesResponse> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/queries/getnuphresponses`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNuphsRequest
     * @return GetNuphsResponse
     */
    getNuphs(query: GetNuphsRequest, cancelToken?: CancelToken): Promise<GetNuphsResponse> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/queries/getnuphs`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetNuphTypesResponse
     */
    getNuphTypes(cancelToken?: CancelToken): Promise<GetNuphTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/queries/getnuphtypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPayoutsRequest
     * @return GetPayoutsResponse
     */
    getPayouts(query: GetPayoutsRequest, cancelToken?: CancelToken): Promise<GetPayoutsResponse> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/queries/getpayouts`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUnemploymentFundRequest
     * @return GetUnemploymentFundResponse
     */
    getUnemploymentFund(query: GetUnemploymentFundRequest, cancelToken?: CancelToken): Promise<GetUnemploymentFundResponse> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/queries/getunemploymentfund`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUnemploymentSummaryDetailsRequest
     * @return GetUnemploymentSummaryDetailsResponse
     */
    getUnemploymentSummaryDetails(query: GetUnemploymentSummaryDetailsRequest, cancelToken?: CancelToken): Promise<GetUnemploymentSummaryDetailsResponse> {
        const $url = `${this.baseUrl}/api/citizen/unemploymentbenefit/queries/getunemploymentsummarydetails`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenSurveysScreeningsClient {
    /**
     * @param command CancelScreeningRequest
     * @return CancelScreeningResponse
     */
    cancelScreening(command: CancelScreeningRequest, cancelToken?: CancelToken): Promise<CancelScreeningResponse>;
    /**
     * @param command StartScreeningRequest
     * @return StartScreeningResponse
     */
    startScreening(command: StartScreeningRequest, cancelToken?: CancelToken): Promise<StartScreeningResponse>;
    /**
     * @return GetAvailableScreeningsResponse
     */
    getAvailableScreenings(cancelToken?: CancelToken): Promise<GetAvailableScreeningsResponse>;
    /**
     * @param query GetCitizenSurveysRequest
     * @return GetCitizenSurveysResponse
     */
    getCitizenSurveys(query: GetCitizenSurveysRequest, cancelToken?: CancelToken): Promise<GetCitizenSurveysResponse>;
    /**
     * @param query GetScreeningValidationValuesRequest
     * @return GetScreeningValidationValuesResponse
     */
    getScreeningValidationValues(query: GetScreeningValidationValuesRequest, cancelToken?: CancelToken): Promise<GetScreeningValidationValuesResponse>;
}

export class CitizenSurveysScreeningsClient implements ICitizenSurveysScreeningsClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CancelScreeningRequest
     * @return CancelScreeningResponse
     */
    cancelScreening(command: CancelScreeningRequest, cancelToken?: CancelToken): Promise<CancelScreeningResponse> {
        const $url = `${this.baseUrl}/api/citizen/surveys/screenings/commands/cancelscreening`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command StartScreeningRequest
     * @return StartScreeningResponse
     */
    startScreening(command: StartScreeningRequest, cancelToken?: CancelToken): Promise<StartScreeningResponse> {
        const $url = `${this.baseUrl}/api/citizen/surveys/screenings/commands/startscreening`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAvailableScreeningsResponse
     */
    getAvailableScreenings(cancelToken?: CancelToken): Promise<GetAvailableScreeningsResponse> {
        const $url = `${this.baseUrl}/api/citizen/surveys/screenings/queries/getavailablescreenings`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenSurveysRequest
     * @return GetCitizenSurveysResponse
     */
    getCitizenSurveys(query: GetCitizenSurveysRequest, cancelToken?: CancelToken): Promise<GetCitizenSurveysResponse> {
        const $url = `${this.baseUrl}/api/citizen/surveys/screenings/queries/getcitizensurveys`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetScreeningValidationValuesRequest
     * @return GetScreeningValidationValuesResponse
     */
    getScreeningValidationValues(query: GetScreeningValidationValuesRequest, cancelToken?: CancelToken): Promise<GetScreeningValidationValuesResponse> {
        const $url = `${this.baseUrl}/api/citizen/surveys/screenings/queries/getscreeningvalidationvalues`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenSurveysProgressionClient {
    /**
     * @param command CloseProgressionSurveyRequest
     * @return CloseProgressionSurveyResponse
     */
    closeProgressionSurvey(command: CloseProgressionSurveyRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetAnsweredProgressionSurveysRequest
     * @return GetAnsweredProgressionSurveysResponse
     */
    getAnsweredProgressionSurveys(query: GetAnsweredProgressionSurveysRequest, cancelToken?: CancelToken): Promise<GetAnsweredProgressionSurveysResponse>;
}

export class CitizenSurveysProgressionClient implements ICitizenSurveysProgressionClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CloseProgressionSurveyRequest
     * @return CloseProgressionSurveyResponse
     */
    closeProgressionSurvey(command: CloseProgressionSurveyRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/surveys/progression/commands/closeprogressionsurvey`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAnsweredProgressionSurveysRequest
     * @return GetAnsweredProgressionSurveysResponse
     */
    getAnsweredProgressionSurveys(query: GetAnsweredProgressionSurveysRequest, cancelToken?: CancelToken): Promise<GetAnsweredProgressionSurveysResponse> {
        const $url = `${this.baseUrl}/api/citizen/surveys/progression/queries/getansweredprogressionsurveys`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenSocialIntegrationClient {
    /**
     * @param command GetHoiPrimaryTeamForCitizenRequest
     * @return GetHoiPrimaryTeamForCitizenResponse
     */
    getHoiPrimaryTeamForCitizen(command: GetHoiPrimaryTeamForCitizenRequest, cancelToken?: CancelToken): Promise<GetHoiPrimaryTeamForCitizenResponse>;
    /**
     * @param command GetHoiActivitiesForCitizenRequest
     * @return GetHoiActivitiesForCitizenResponse
     */
    getHoiActivitiesForCitizen(command: GetHoiActivitiesForCitizenRequest, cancelToken?: CancelToken): Promise<GetHoiActivitiesForCitizenResponse>;
    /**
     * @param command GetHoiTeamByUserIdRequest
     * @return GetHoiTeamByUserIdResponse
     */
    getHoiTeamByUserId(command: GetHoiTeamByUserIdRequest, cancelToken?: CancelToken): Promise<GetHoiTeamByUserIdResponse>;
    /**
     * @param command ExecuteNexusImportRequest
     * @return ExecuteNexusImportResponse
     */
    executeNexusImport(command: ExecuteNexusImportRequest, cancelToken?: CancelToken): Promise<ExecuteNexusImportResponse>;
    /**
     * @param command ExecuteNexusServiceProviderImportRequest
     * @return ExecuteNexusServiceProviderImportResponse
     */
    executeNexusServiceProviderImport(command: ExecuteNexusServiceProviderImportRequest, cancelToken?: CancelToken): Promise<ExecuteNexusServiceProviderImportResponse>;
    /**
     * @param command StartHoiRequest
     * @return StartHoiResponse
     */
    startHoi(command: StartHoiRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetHoiCaseMainDataRequest
     * @return GetHoiCaseMainDataResponse
     */
    getHoiCaseMainData(query: GetHoiCaseMainDataRequest, cancelToken?: CancelToken): Promise<GetHoiCaseMainDataResponse>;
    /**
     * @param query GetHoiCompanyContactPersonsRequest
     * @return GetHoiCompanyContactPersonsResponse
     */
    getHoiCompanyContactPersons(query: GetHoiCompanyContactPersonsRequest, cancelToken?: CancelToken): Promise<GetHoiCompanyContactPersonsResponse>;
    /**
     * @param query GetHoiDataRequest
     * @return GetHoiDataResponse
     */
    getHoiData(query: GetHoiDataRequest, cancelToken?: CancelToken): Promise<GetHoiDataResponse>;
    /**
     * @return GetHoiGuideConfigurationResponse
     */
    getHoiGuideConfiguration(cancelToken?: CancelToken): Promise<GetHoiGuideConfigurationResponse>;
    /**
     * @param query GetHoiLetterEditableContentRequest
     * @return GetHoiLetterEditableContentResponse
     */
    getHoiLetterEditableContent(query: GetHoiLetterEditableContentRequest, cancelToken?: CancelToken): Promise<GetHoiLetterEditableContentResponse>;
    /**
     * @param query GetHoiLetterPdfPreviewRequest
     * @return FileResponse
     */
    getHoiLetterPdfPreview(query: GetHoiLetterPdfPreviewRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetHoiPrivateContactPersonsRequest
     * @return GetHoiPrivateContactPersonsResponse
     */
    getHoiPrivateContactPersons(query: GetHoiPrivateContactPersonsRequest, cancelToken?: CancelToken): Promise<GetHoiPrivateContactPersonsResponse>;
    /**
     * @param query GetHoiSummaryRequest
     * @return GetHoiSummaryResponse
     */
    getHoiSummary(query: GetHoiSummaryRequest, cancelToken?: CancelToken): Promise<GetHoiSummaryResponse>;
    /**
     * @param query GetNexusCitizenExistsRequest
     * @return GetNexusCitizenExistsResponse
     */
    getNexusCitizenExists(query: GetNexusCitizenExistsRequest, cancelToken?: CancelToken): Promise<GetNexusCitizenExistsResponse>;
    /**
     * @param query GetNexusImportDocumentRequest
     * @return GetNexusImportDocumentResponse
     */
    getNexusImportDocument(query: GetNexusImportDocumentRequest, cancelToken?: CancelToken): Promise<GetNexusImportDocumentResponse>;
    /**
     * @param query GetNexusImportEntryContentRequest
     * @return GetNexusImportEntryContentResponse
     */
    getNexusImportEntryContent(query: GetNexusImportEntryContentRequest, cancelToken?: CancelToken): Promise<GetNexusImportEntryContentResponse>;
    /**
     * @param query GetNexusImportLetterRequest
     * @return GetNexusImportLetterResponse
     */
    getNexusImportLetter(query: GetNexusImportLetterRequest, cancelToken?: CancelToken): Promise<GetNexusImportLetterResponse>;
    /**
     * @param query GetNexusImportPreviewRequest
     * @return GetNexusImportPreviewResponse
     */
    getNexusImportPreview(query: GetNexusImportPreviewRequest, cancelToken?: CancelToken): Promise<GetNexusImportPreviewResponse>;
    /**
     * @param query GetNexusImportProgressRequest
     * @return GetNexusImportProgressResponse
     */
    getNexusImportProgress(query: GetNexusImportProgressRequest, cancelToken?: CancelToken): Promise<GetNexusImportProgressResponse>;
    /**
     * @param query GetNexusServiceProviderImportPreviewRequest
     * @return GetNexusServiceProviderImportPreviewResponse
     */
    getNexusServiceProviderImportPreview(query: GetNexusServiceProviderImportPreviewRequest, cancelToken?: CancelToken): Promise<GetNexusServiceProviderImportPreviewResponse>;
}

export class CitizenSocialIntegrationClient implements ICitizenSocialIntegrationClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command GetHoiPrimaryTeamForCitizenRequest
     * @return GetHoiPrimaryTeamForCitizenResponse
     */
    getHoiPrimaryTeamForCitizen(command: GetHoiPrimaryTeamForCitizenRequest, cancelToken?: CancelToken): Promise<GetHoiPrimaryTeamForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/commands/gethoiprimaryteamforcitizen`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command GetHoiActivitiesForCitizenRequest
     * @return GetHoiActivitiesForCitizenResponse
     */
    getHoiActivitiesForCitizen(command: GetHoiActivitiesForCitizenRequest, cancelToken?: CancelToken): Promise<GetHoiActivitiesForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/commands/gethoiactivitiesforcitizen`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command GetHoiTeamByUserIdRequest
     * @return GetHoiTeamByUserIdResponse
     */
    getHoiTeamByUserId(command: GetHoiTeamByUserIdRequest, cancelToken?: CancelToken): Promise<GetHoiTeamByUserIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/commands/gethoiteambyuserid`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ExecuteNexusImportRequest
     * @return ExecuteNexusImportResponse
     */
    executeNexusImport(command: ExecuteNexusImportRequest, cancelToken?: CancelToken): Promise<ExecuteNexusImportResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/commands/executenexusimport`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ExecuteNexusServiceProviderImportRequest
     * @return ExecuteNexusServiceProviderImportResponse
     */
    executeNexusServiceProviderImport(command: ExecuteNexusServiceProviderImportRequest, cancelToken?: CancelToken): Promise<ExecuteNexusServiceProviderImportResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/commands/executenexusserviceproviderimport`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command StartHoiRequest
     * @return StartHoiResponse
     */
    startHoi(command: StartHoiRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/commands/starthoi`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHoiCaseMainDataRequest
     * @return GetHoiCaseMainDataResponse
     */
    getHoiCaseMainData(query: GetHoiCaseMainDataRequest, cancelToken?: CancelToken): Promise<GetHoiCaseMainDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/gethoicasemaindata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHoiCompanyContactPersonsRequest
     * @return GetHoiCompanyContactPersonsResponse
     */
    getHoiCompanyContactPersons(query: GetHoiCompanyContactPersonsRequest, cancelToken?: CancelToken): Promise<GetHoiCompanyContactPersonsResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/gethoicompanycontactpersons`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHoiDataRequest
     * @return GetHoiDataResponse
     */
    getHoiData(query: GetHoiDataRequest, cancelToken?: CancelToken): Promise<GetHoiDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/gethoidata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetHoiGuideConfigurationResponse
     */
    getHoiGuideConfiguration(cancelToken?: CancelToken): Promise<GetHoiGuideConfigurationResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/gethoiguideconfiguration`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHoiLetterEditableContentRequest
     * @return GetHoiLetterEditableContentResponse
     */
    getHoiLetterEditableContent(query: GetHoiLetterEditableContentRequest, cancelToken?: CancelToken): Promise<GetHoiLetterEditableContentResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/gethoilettereditablecontent`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHoiLetterPdfPreviewRequest
     * @return FileResponse
     */
    getHoiLetterPdfPreview(query: GetHoiLetterPdfPreviewRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/gethoiletterpdfpreview`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHoiPrivateContactPersonsRequest
     * @return GetHoiPrivateContactPersonsResponse
     */
    getHoiPrivateContactPersons(query: GetHoiPrivateContactPersonsRequest, cancelToken?: CancelToken): Promise<GetHoiPrivateContactPersonsResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/gethoiprivatecontactpersons`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHoiSummaryRequest
     * @return GetHoiSummaryResponse
     */
    getHoiSummary(query: GetHoiSummaryRequest, cancelToken?: CancelToken): Promise<GetHoiSummaryResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/gethoisummary`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNexusCitizenExistsRequest
     * @return GetNexusCitizenExistsResponse
     */
    getNexusCitizenExists(query: GetNexusCitizenExistsRequest, cancelToken?: CancelToken): Promise<GetNexusCitizenExistsResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/getnexuscitizenexists`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNexusImportDocumentRequest
     * @return GetNexusImportDocumentResponse
     */
    getNexusImportDocument(query: GetNexusImportDocumentRequest, cancelToken?: CancelToken): Promise<GetNexusImportDocumentResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/getnexusimportdocument`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNexusImportEntryContentRequest
     * @return GetNexusImportEntryContentResponse
     */
    getNexusImportEntryContent(query: GetNexusImportEntryContentRequest, cancelToken?: CancelToken): Promise<GetNexusImportEntryContentResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/getnexusimportentrycontent`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNexusImportLetterRequest
     * @return GetNexusImportLetterResponse
     */
    getNexusImportLetter(query: GetNexusImportLetterRequest, cancelToken?: CancelToken): Promise<GetNexusImportLetterResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/getnexusimportletter`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNexusImportPreviewRequest
     * @return GetNexusImportPreviewResponse
     */
    getNexusImportPreview(query: GetNexusImportPreviewRequest, cancelToken?: CancelToken): Promise<GetNexusImportPreviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/getnexusimportpreview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNexusImportProgressRequest
     * @return GetNexusImportProgressResponse
     */
    getNexusImportProgress(query: GetNexusImportProgressRequest, cancelToken?: CancelToken): Promise<GetNexusImportProgressResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/getnexusimportprogress`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNexusServiceProviderImportPreviewRequest
     * @return GetNexusServiceProviderImportPreviewResponse
     */
    getNexusServiceProviderImportPreview(query: GetNexusServiceProviderImportPreviewRequest, cancelToken?: CancelToken): Promise<GetNexusServiceProviderImportPreviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/socialintegration/queries/getnexusserviceproviderimportpreview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenSicknessBenefitPartialRecoveryClient {
    /**
     * @param command CreatePartialRecoveryRequest
     * @return CreatePartialRecoveryResponse
     */
    createPartialRecovery(command: CreatePartialRecoveryRequest, cancelToken?: CancelToken): Promise<CreatePartialRecoveryResponse>;
    /**
     * @param command DeletePartialRecoveryRequest
     * @return DeletePartialRecoveryResponse
     */
    deletePartialRecovery(command: DeletePartialRecoveryRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdatePartialRecoveryRequest
     * @return UpdatePartialRecoveryResponse
     */
    updatePartialRecovery(command: UpdatePartialRecoveryRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetPartialRecoveriesByAbsenceIdRequest
     * @return GetPartialRecoveriesByAbsenceIdResponse
     */
    getPartialRecoveriesByAbsenceId(query: GetPartialRecoveriesByAbsenceIdRequest, cancelToken?: CancelToken): Promise<GetPartialRecoveriesByAbsenceIdResponse>;
    /**
     * @param query GetPartialRecoveriesByCaseIdRequest
     * @return GetPartialRecoveriesByCaseIdResponse
     */
    getPartialRecoveriesByCaseId(query: GetPartialRecoveriesByCaseIdRequest, cancelToken?: CancelToken): Promise<GetPartialRecoveriesByCaseIdResponse>;
    /**
     * @param query GetPartialRecoveryByIdRequest
     * @return GetPartialRecoveryByIdResponse
     */
    getPartialRecoveryById(query: GetPartialRecoveryByIdRequest, cancelToken?: CancelToken): Promise<GetPartialRecoveryByIdResponse>;
}

export class CitizenSicknessBenefitPartialRecoveryClient implements ICitizenSicknessBenefitPartialRecoveryClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreatePartialRecoveryRequest
     * @return CreatePartialRecoveryResponse
     */
    createPartialRecovery(command: CreatePartialRecoveryRequest, cancelToken?: CancelToken): Promise<CreatePartialRecoveryResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/partialrecovery/commands/createpartialrecovery`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeletePartialRecoveryRequest
     * @return DeletePartialRecoveryResponse
     */
    deletePartialRecovery(command: DeletePartialRecoveryRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/partialrecovery/commands/deletepartialrecovery`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdatePartialRecoveryRequest
     * @return UpdatePartialRecoveryResponse
     */
    updatePartialRecovery(command: UpdatePartialRecoveryRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/partialrecovery/commands/updatepartialrecovery`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPartialRecoveriesByAbsenceIdRequest
     * @return GetPartialRecoveriesByAbsenceIdResponse
     */
    getPartialRecoveriesByAbsenceId(query: GetPartialRecoveriesByAbsenceIdRequest, cancelToken?: CancelToken): Promise<GetPartialRecoveriesByAbsenceIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/partialrecovery/queries/getpartialrecoveriesbyabsenceid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPartialRecoveriesByCaseIdRequest
     * @return GetPartialRecoveriesByCaseIdResponse
     */
    getPartialRecoveriesByCaseId(query: GetPartialRecoveriesByCaseIdRequest, cancelToken?: CancelToken): Promise<GetPartialRecoveriesByCaseIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/partialrecovery/queries/getpartialrecoveriesbycaseid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPartialRecoveryByIdRequest
     * @return GetPartialRecoveryByIdResponse
     */
    getPartialRecoveryById(query: GetPartialRecoveryByIdRequest, cancelToken?: CancelToken): Promise<GetPartialRecoveryByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/partialrecovery/queries/getpartialrecoverybyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenSicknessBenefitMissingParticipationClient {
    /**
     * @param command CancelMissingParticipationRequest
     * @return CancelMissingParticipationResponse
     */
    cancelMissingParticipation(command: CancelMissingParticipationRequest, cancelToken?: CancelToken): Promise<CancelMissingParticipationResponse>;
    /**
     * @param command CreateMissingParticipationRequest
     * @return CreateMissingParticipationResponse
     */
    createMissingParticipation(command: CreateMissingParticipationRequest, cancelToken?: CancelToken): Promise<CreateMissingParticipationResponse>;
    /**
     * @param command FinishMissingParticipationRequest
     * @return FinishMissingParticipationResponse
     */
    finishMissingParticipation(command: FinishMissingParticipationRequest, cancelToken?: CancelToken): Promise<FinishMissingParticipationResponse>;
    /**
     * @param command SendMissingParticipationNotificationToKsdRequest
     * @return SendMissingParticipationNotificationToKsdResponse
     */
    sendMissingParticipationNotificationToKsd(command: SendMissingParticipationNotificationToKsdRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetLetterContentForMissingParticipationRequest
     * @return GetLetterContentForMissingParticipationResponse
     */
    getLetterContentForMissingParticipation(query: GetLetterContentForMissingParticipationRequest, cancelToken?: CancelToken): Promise<GetLetterContentForMissingParticipationResponse>;
    /**
     * @param query GetLetterPreviewForMissingParticipationRequest
     * @return FileResponse
     */
    getLetterPreviewForMissingParticipation(query: GetLetterPreviewForMissingParticipationRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetMissingParticipationByIdRequest
     * @return GetMissingParticipationByIdResponse
     */
    getMissingParticipationById(query: GetMissingParticipationByIdRequest, cancelToken?: CancelToken): Promise<GetMissingParticipationByIdResponse>;
    /**
     * @return GetMissingParticipationConfigurationsResponse
     */
    getMissingParticipationConfigurations(cancelToken?: CancelToken): Promise<GetMissingParticipationConfigurationsResponse>;
    /**
     * @param query GetMissingParticipationInStatusUnderPartyHearingByCaseIdRequest
     * @return GetMissingParticipationInStatusUnderPartyHearingByCaseIdResponse
     */
    getMissingParticipationInStatusUnderPartyHearingByCaseId(query: GetMissingParticipationInStatusUnderPartyHearingByCaseIdRequest, cancelToken?: CancelToken): Promise<GetMissingParticipationInStatusUnderPartyHearingByCaseIdResponse>;
    /**
     * @param query GetMissingParticipationsByCaseIdRequest
     * @return GetMissingParticipationsByCaseIdResponse
     */
    getMissingParticipationsByCaseId(query: GetMissingParticipationsByCaseIdRequest, cancelToken?: CancelToken): Promise<GetMissingParticipationsByCaseIdResponse>;
    /**
     * @return GetMissingParticipationTypesResponse
     */
    getMissingParticipationTypes(cancelToken?: CancelToken): Promise<GetMissingParticipationTypesResponse>;
    /**
     * @return GetOutgoingDocumentTypesResponse
     */
    getOutgoingDocumentTypes(cancelToken?: CancelToken): Promise<GetOutgoingDocumentTypesResponse2>;
}

export class CitizenSicknessBenefitMissingParticipationClient implements ICitizenSicknessBenefitMissingParticipationClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CancelMissingParticipationRequest
     * @return CancelMissingParticipationResponse
     */
    cancelMissingParticipation(command: CancelMissingParticipationRequest, cancelToken?: CancelToken): Promise<CancelMissingParticipationResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/missingparticipation/commands/cancelmissingparticipation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateMissingParticipationRequest
     * @return CreateMissingParticipationResponse
     */
    createMissingParticipation(command: CreateMissingParticipationRequest, cancelToken?: CancelToken): Promise<CreateMissingParticipationResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/missingparticipation/commands/createmissingparticipation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command FinishMissingParticipationRequest
     * @return FinishMissingParticipationResponse
     */
    finishMissingParticipation(command: FinishMissingParticipationRequest, cancelToken?: CancelToken): Promise<FinishMissingParticipationResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/missingparticipation/commands/finishmissingparticipation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendMissingParticipationNotificationToKsdRequest
     * @return SendMissingParticipationNotificationToKsdResponse
     */
    sendMissingParticipationNotificationToKsd(command: SendMissingParticipationNotificationToKsdRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/missingparticipation/commands/sendmissingparticipationnotificationtoksd`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLetterContentForMissingParticipationRequest
     * @return GetLetterContentForMissingParticipationResponse
     */
    getLetterContentForMissingParticipation(query: GetLetterContentForMissingParticipationRequest, cancelToken?: CancelToken): Promise<GetLetterContentForMissingParticipationResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/missingparticipation/queries/getlettercontentformissingparticipation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLetterPreviewForMissingParticipationRequest
     * @return FileResponse
     */
    getLetterPreviewForMissingParticipation(query: GetLetterPreviewForMissingParticipationRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/missingparticipation/queries/getletterpreviewformissingparticipation`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMissingParticipationByIdRequest
     * @return GetMissingParticipationByIdResponse
     */
    getMissingParticipationById(query: GetMissingParticipationByIdRequest, cancelToken?: CancelToken): Promise<GetMissingParticipationByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/missingparticipation/queries/getmissingparticipationbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetMissingParticipationConfigurationsResponse
     */
    getMissingParticipationConfigurations(cancelToken?: CancelToken): Promise<GetMissingParticipationConfigurationsResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/missingparticipation/queries/getmissingparticipationconfigurations`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMissingParticipationInStatusUnderPartyHearingByCaseIdRequest
     * @return GetMissingParticipationInStatusUnderPartyHearingByCaseIdResponse
     */
    getMissingParticipationInStatusUnderPartyHearingByCaseId(query: GetMissingParticipationInStatusUnderPartyHearingByCaseIdRequest, cancelToken?: CancelToken): Promise<GetMissingParticipationInStatusUnderPartyHearingByCaseIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/missingparticipation/queries/getmissingparticipationinstatusunderpartyhearingbycaseid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMissingParticipationsByCaseIdRequest
     * @return GetMissingParticipationsByCaseIdResponse
     */
    getMissingParticipationsByCaseId(query: GetMissingParticipationsByCaseIdRequest, cancelToken?: CancelToken): Promise<GetMissingParticipationsByCaseIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/missingparticipation/queries/getmissingparticipationsbycaseid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetMissingParticipationTypesResponse
     */
    getMissingParticipationTypes(cancelToken?: CancelToken): Promise<GetMissingParticipationTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/missingparticipation/queries/getmissingparticipationtypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOutgoingDocumentTypesResponse
     */
    getOutgoingDocumentTypes(cancelToken?: CancelToken): Promise<GetOutgoingDocumentTypesResponse2> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/missingparticipation/queries/getoutgoingdocumenttypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenSicknessBenefitExpectedJobResumptionClient {
    /**
     * @param command CreateExpectedJobResumptionRequest
     * @return CreateExpectedJobResumptionResponse
     */
    createExpectedJobResumption(command: CreateExpectedJobResumptionRequest, cancelToken?: CancelToken): Promise<CreateExpectedJobResumptionResponse>;
    /**
     * @param command DeleteExpectedJobResumptionRequest
     * @return DeleteExpectedJobResumptionResponse
     */
    deleteExpectedJobResumption(command: DeleteExpectedJobResumptionRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateExpectedJobResumptionRequest
     * @return UpdateExpectedJobResumptionResponse
     */
    updateExpectedJobResumption(command: UpdateExpectedJobResumptionRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetExpectedJobResumptionByIdRequest
     * @return GetExpectedJobResumptionByIdResponse
     */
    getExpectedJobResumptionById(query: GetExpectedJobResumptionByIdRequest, cancelToken?: CancelToken): Promise<GetExpectedJobResumptionByIdResponse>;
    /**
     * @param query GetExpectedJobResumptionsListRequest
     * @return GetExpectedJobResumptionsListResponse
     */
    getExpectedJobResumptionsList(query: GetExpectedJobResumptionsListRequest, cancelToken?: CancelToken): Promise<GetExpectedJobResumptionsListResponse>;
}

export class CitizenSicknessBenefitExpectedJobResumptionClient implements ICitizenSicknessBenefitExpectedJobResumptionClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateExpectedJobResumptionRequest
     * @return CreateExpectedJobResumptionResponse
     */
    createExpectedJobResumption(command: CreateExpectedJobResumptionRequest, cancelToken?: CancelToken): Promise<CreateExpectedJobResumptionResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/expectedjobresumption/commands/createexpectedjobresumption`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteExpectedJobResumptionRequest
     * @return DeleteExpectedJobResumptionResponse
     */
    deleteExpectedJobResumption(command: DeleteExpectedJobResumptionRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/expectedjobresumption/commands/deleteexpectedjobresumption`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateExpectedJobResumptionRequest
     * @return UpdateExpectedJobResumptionResponse
     */
    updateExpectedJobResumption(command: UpdateExpectedJobResumptionRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/expectedjobresumption/commands/updateexpectedjobresumption`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetExpectedJobResumptionByIdRequest
     * @return GetExpectedJobResumptionByIdResponse
     */
    getExpectedJobResumptionById(query: GetExpectedJobResumptionByIdRequest, cancelToken?: CancelToken): Promise<GetExpectedJobResumptionByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/expectedjobresumption/queries/getexpectedjobresumptionbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetExpectedJobResumptionsListRequest
     * @return GetExpectedJobResumptionsListResponse
     */
    getExpectedJobResumptionsList(query: GetExpectedJobResumptionsListRequest, cancelToken?: CancelToken): Promise<GetExpectedJobResumptionsListResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/expectedjobresumption/queries/getexpectedjobresumptionslist`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenSicknessBenefitClient {
    /**
     * @param command SyncSicknessBenefitInformationsRequest
     * @return SyncSicknessBenefitInformationsResponse
     */
    syncSicknessBenefitInformations(command: SyncSicknessBenefitInformationsRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetActiveSicknessAbsenceByCitizenIdRequest
     * @return GetActiveSicknessAbsenceByCitizenIdResponse
     */
    getActiveSicknessAbsenceByCitizenId(query: GetActiveSicknessAbsenceByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetActiveSicknessAbsenceByCitizenIdResponse>;
    /**
     * @param query GetCloseCaseGuideDataRequest
     * @return GetCloseCaseGuideDataResponse
     */
    getCloseCaseGuideData(query: GetCloseCaseGuideDataRequest, cancelToken?: CancelToken): Promise<GetCloseCaseGuideDataResponse>;
    /**
     * @param query GetContactGroupByCitizenIdRequest
     * @return GetContactGroupByCitizenIdResponse
     */
    getContactGroupByCitizenId(query: GetContactGroupByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetContactGroupByCitizenIdResponse>;
    /**
     * @param query GetSicknessAbsenceByCitizenIdRequest
     * @return GetSicknessAbsenceByCitizenIdResponse
     */
    getSicknessAbsenceByCitizenId(query: GetSicknessAbsenceByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetSicknessAbsenceByCitizenIdResponse>;
    /**
     * @param query SicknessBenefitVisitationRequest
     * @return SicknessBenefitVisitationResponse
     */
    getSicknessBenefitVisitation(query: SicknessBenefitVisitationRequest, cancelToken?: CancelToken): Promise<SicknessBenefitVisitationResponse>;
}

export class CitizenSicknessBenefitClient implements ICitizenSicknessBenefitClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command SyncSicknessBenefitInformationsRequest
     * @return SyncSicknessBenefitInformationsResponse
     */
    syncSicknessBenefitInformations(command: SyncSicknessBenefitInformationsRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/commands/syncsicknessbenefitinformations`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActiveSicknessAbsenceByCitizenIdRequest
     * @return GetActiveSicknessAbsenceByCitizenIdResponse
     */
    getActiveSicknessAbsenceByCitizenId(query: GetActiveSicknessAbsenceByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetActiveSicknessAbsenceByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/queries/getactivesicknessabsencebycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCloseCaseGuideDataRequest
     * @return GetCloseCaseGuideDataResponse
     */
    getCloseCaseGuideData(query: GetCloseCaseGuideDataRequest, cancelToken?: CancelToken): Promise<GetCloseCaseGuideDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/queries/getclosecaseguidedata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetContactGroupByCitizenIdRequest
     * @return GetContactGroupByCitizenIdResponse
     */
    getContactGroupByCitizenId(query: GetContactGroupByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetContactGroupByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/queries/getcontactgroupbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSicknessAbsenceByCitizenIdRequest
     * @return GetSicknessAbsenceByCitizenIdResponse
     */
    getSicknessAbsenceByCitizenId(query: GetSicknessAbsenceByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetSicknessAbsenceByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/queries/getsicknessabsencebycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query SicknessBenefitVisitationRequest
     * @return SicknessBenefitVisitationResponse
     */
    getSicknessBenefitVisitation(query: SicknessBenefitVisitationRequest, cancelToken?: CancelToken): Promise<SicknessBenefitVisitationResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/queries/getsicknessbenefitvisitation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenSicknessBenefitBenefitExtensionAssessmentClient {
    /**
     * @param command CancelBenefitExtensionAssessmentRequest
     * @return CancelBenefitExtensionAssessmentResponse
     */
    cancelBenefitExtensionAssessment(command: CancelBenefitExtensionAssessmentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateAssessmentRequest_
     * @return CreateAssessmentResponse_
     */
    createAssessment(command: CreateAssessmentRequest_, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateBenefitExtensionAssessmentRequest
     * @return CreateBenefitExtensionAssessmentResponse
     */
    createBenefitExtensionAssessment(command: CreateBenefitExtensionAssessmentRequest, cancelToken?: CancelToken): Promise<CreateBenefitExtensionAssessmentResponse>;
    /**
     * @param command FinishBenefitExtensionAssessmentHearingRequest
     * @return FinishBenefitExtensionAssessmentHearingResponse
     */
    finishBenefitExtensionAssessmentHearing(command: FinishBenefitExtensionAssessmentHearingRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command StartBenefitExtensionAssessmentHearingRequest
     * @return StartBenefitExtensionAssessmentHearingResponse
     */
    startBenefitExtensionAssessmentHearing(command: StartBenefitExtensionAssessmentHearingRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateBenefitExtensionAssessmentRequest
     * @return UpdateBenefitExtensionAssessmentResponse
     */
    updateBenefitExtensionAssessment(command: UpdateBenefitExtensionAssessmentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetBenefitExtensionAssessmentByCaseIdRequest
     * @return GetBenefitExtensionAssessmentByCaseIdResponse
     */
    getBenefitExtensionAssessmentByCaseId(query: GetBenefitExtensionAssessmentByCaseIdRequest, cancelToken?: CancelToken): Promise<GetBenefitExtensionAssessmentByCaseIdResponse>;
    /**
     * @param query GetBenefitExtensionAssessmentDataRequest
     * @return GetBenefitExtensionAssessmentDataResponse
     */
    getBenefitExtensionAssessmentData(query: GetBenefitExtensionAssessmentDataRequest, cancelToken?: CancelToken): Promise<GetBenefitExtensionAssessmentDataResponse>;
    /**
     * @return GetGuideDataResponse
     */
    getGuideData(cancelToken?: CancelToken): Promise<GetGuideDataResponse>;
    /**
     * @param query GetOpenBenefitExtensionAssessmentIdRequest
     * @return GetOpenBenefitExtensionAssessmentIdResponse
     */
    getOpenBenefitExtensionAssessmentId(query: GetOpenBenefitExtensionAssessmentIdRequest, cancelToken?: CancelToken): Promise<GetOpenBenefitExtensionAssessmentIdResponse>;
}

export class CitizenSicknessBenefitBenefitExtensionAssessmentClient implements ICitizenSicknessBenefitBenefitExtensionAssessmentClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CancelBenefitExtensionAssessmentRequest
     * @return CancelBenefitExtensionAssessmentResponse
     */
    cancelBenefitExtensionAssessment(command: CancelBenefitExtensionAssessmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/benefitextensionassessment/commands/cancelbenefitextensionassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAssessmentRequest_
     * @return CreateAssessmentResponse_
     */
    createAssessment(command: CreateAssessmentRequest_, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/benefitextensionassessment/commands/createassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateBenefitExtensionAssessmentRequest
     * @return CreateBenefitExtensionAssessmentResponse
     */
    createBenefitExtensionAssessment(command: CreateBenefitExtensionAssessmentRequest, cancelToken?: CancelToken): Promise<CreateBenefitExtensionAssessmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/benefitextensionassessment/commands/createbenefitextensionassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command FinishBenefitExtensionAssessmentHearingRequest
     * @return FinishBenefitExtensionAssessmentHearingResponse
     */
    finishBenefitExtensionAssessmentHearing(command: FinishBenefitExtensionAssessmentHearingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/benefitextensionassessment/commands/finishbenefitextensionassessmenthearing`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command StartBenefitExtensionAssessmentHearingRequest
     * @return StartBenefitExtensionAssessmentHearingResponse
     */
    startBenefitExtensionAssessmentHearing(command: StartBenefitExtensionAssessmentHearingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/benefitextensionassessment/commands/startbenefitextensionassessmenthearing`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateBenefitExtensionAssessmentRequest
     * @return UpdateBenefitExtensionAssessmentResponse
     */
    updateBenefitExtensionAssessment(command: UpdateBenefitExtensionAssessmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/benefitextensionassessment/commands/updatebenefitextensionassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetBenefitExtensionAssessmentByCaseIdRequest
     * @return GetBenefitExtensionAssessmentByCaseIdResponse
     */
    getBenefitExtensionAssessmentByCaseId(query: GetBenefitExtensionAssessmentByCaseIdRequest, cancelToken?: CancelToken): Promise<GetBenefitExtensionAssessmentByCaseIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/benefitextensionassessment/queries/getbenefitextensionassessmentbycaseid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetBenefitExtensionAssessmentDataRequest
     * @return GetBenefitExtensionAssessmentDataResponse
     */
    getBenefitExtensionAssessmentData(query: GetBenefitExtensionAssessmentDataRequest, cancelToken?: CancelToken): Promise<GetBenefitExtensionAssessmentDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/benefitextensionassessment/queries/getbenefitextensionassessmentdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetGuideDataResponse
     */
    getGuideData(cancelToken?: CancelToken): Promise<GetGuideDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/benefitextensionassessment/queries/getguidedata`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOpenBenefitExtensionAssessmentIdRequest
     * @return GetOpenBenefitExtensionAssessmentIdResponse
     */
    getOpenBenefitExtensionAssessmentId(query: GetOpenBenefitExtensionAssessmentIdRequest, cancelToken?: CancelToken): Promise<GetOpenBenefitExtensionAssessmentIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/benefitextensionassessment/queries/getopenbenefitextensionassessmentid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderUseOfForceClient {
    /**
     * @param command ApproveUseOfForceHygieneRestraintLogRequest
     * @return ApproveUseOfForceHygieneRestraintLogResponse
     */
    approveUseOfForceHygieneRestraintLog(command: ApproveUseOfForceHygieneRestraintLogRequest, cancelToken?: CancelToken): Promise<ApproveUseOfForceHygieneRestraintLogResponse>;
    /**
     * @param command ApproveUseOfForceIncidentRequest
     * @return ApproveUseOfForceIncidentResponse
     */
    approveUseOfForceIncident(command: ApproveUseOfForceIncidentRequest, cancelToken?: CancelToken): Promise<ApproveUseOfForceIncidentResponse>;
    /**
     * @param command ApproveUseOfForceSummaryRegistrationRequest
     * @return ApproveUseOfForceSummaryRegistrationResponse
     */
    approveUseOfForceSummaryRegistration(command: ApproveUseOfForceSummaryRegistrationRequest, cancelToken?: CancelToken): Promise<ApproveUseOfForceSummaryRegistrationResponse>;
    /**
     * @param command AttachUseOfForceCitizenStatementRequest
     * @return AttachUseOfForceCitizenStatementResponse
     */
    attachUseOfForceCitizenStatement(command: AttachUseOfForceCitizenStatementRequest, cancelToken?: CancelToken): Promise<AttachUseOfForceCitizenStatementResponse>;
    /**
     * @param command AttachUseOfForceSummaryRegistrationCitizenStatementRequest
     * @return AttachUseOfForceSummaryRegistrationCitizenStatementResponse
     */
    attachUseOfForceSummaryRegistrationCitizenStatement(command: AttachUseOfForceSummaryRegistrationCitizenStatementRequest, cancelToken?: CancelToken): Promise<AttachUseOfForceSummaryRegistrationCitizenStatementResponse>;
    /**
     * @param command CancelUseOfForceIncidentRequest
     * @return CancelUseOfForceIncidentResponse
     */
    cancelUseOfForceIncident(command: CancelUseOfForceIncidentRequest, cancelToken?: CancelToken): Promise<CancelUseOfForceIncidentResponse>;
    /**
     * @param command CorrectUseOfForceHygieneRestraintRequest
     * @return CorrectUseOfForceHygieneRestraintResponse
     */
    correctUseOfForceHygieneRestraint(command: CorrectUseOfForceHygieneRestraintRequest, cancelToken?: CancelToken): Promise<CorrectUseOfForceHygieneRestraintResponse>;
    /**
     * @param command CreateUseOfForceAuthorizationRequestRequest
     * @return CreateUseOfForceAuthorizationRequestResponse
     */
    createUseOfForceAuthorizationRequest(command: CreateUseOfForceAuthorizationRequestRequest, cancelToken?: CancelToken): Promise<CreateUseOfForceAuthorizationRequestResponse>;
    /**
     * @param command CreateUseOfForceIncidentRequest
     * @return CreateUseOfForceIncidentResponse
     */
    createUseOfForceIncident(command: CreateUseOfForceIncidentRequest, cancelToken?: CancelToken): Promise<CreateUseOfForceIncidentResponse>;
    /**
     * @param command CreateUseOfForceSummaryRegistrationRequest
     * @return CreateUseOfForceSummaryRegistrationResponse
     */
    createUseOfForceSummaryRegistration(command: CreateUseOfForceSummaryRegistrationRequest, cancelToken?: CancelToken): Promise<CreateUseOfForceSummaryRegistrationResponse>;
    /**
     * @param command DeleteUseOfForceAuthorizationRequestDraftRequest
     * @return DeleteUseOfForceAuthorizationRequestDraftResponse
     */
    deleteUseOfForceAuthorizationRequestDraft(command: DeleteUseOfForceAuthorizationRequestDraftRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteUseOfForceIncidentDraftRequest
     * @return DeleteUseOfForceIncidentDraftResponse
     */
    deleteUseOfForceIncidentDraft(command: DeleteUseOfForceIncidentDraftRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteUseOfForceSummaryRegistrationDraftRequest
     * @return DeleteUseOfForceSummaryRegistrationDraftResponse
     */
    deleteUseOfForceSummaryRegistrationDraft(command: DeleteUseOfForceSummaryRegistrationDraftRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command RegisterServiceProviderUseOfForceAuthorizationRequest
     * @return RegisterServiceProviderUseOfForceAuthorizationResponse
     */
    registerServiceProviderUseOfForceAuthorization(command: RegisterServiceProviderUseOfForceAuthorizationRequest, cancelToken?: CancelToken): Promise<RegisterServiceProviderUseOfForceAuthorizationResponse>;
    /**
     * @param command RegisterUseOfForceAuthorizationRequestDecisionRequest
     * @return RegisterUseOfForceAuthorizationRequestDecisionResponse
     */
    registerUseOfForceAuthorizationRequestDecision(command: RegisterUseOfForceAuthorizationRequestDecisionRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceAuthorizationRequestDecisionResponse>;
    /**
     * @param command RegisterUseOfForceAuthorizationRequestMunicipalitySendingRequest
     * @return RegisterUseOfForceAuthorizationRequestMunicipalitySendingResponse
     */
    registerUseOfForceAuthorizationRequestMunicipalitySending(command: RegisterUseOfForceAuthorizationRequestMunicipalitySendingRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceAuthorizationRequestMunicipalitySendingResponse>;
    /**
     * @param command RegisterUseOfForceHygieneRestraintRequest
     * @return RegisterUseOfForceHygieneRestraintResponse
     */
    registerUseOfForceHygieneRestraint(command: RegisterUseOfForceHygieneRestraintRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceHygieneRestraintResponse>;
    /**
     * @param command RegisterUseOfForceHygieneRestraintLogMunicipalitySendingRequest
     * @return RegisterUseOfForceHygieneRestraintLogMunicipalitySendingResponse
     */
    registerUseOfForceHygieneRestraintLogMunicipalitySending(command: RegisterUseOfForceHygieneRestraintLogMunicipalitySendingRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceHygieneRestraintLogMunicipalitySendingResponse>;
    /**
     * @param command RegisterUseOfForceRelativesInformationRequest
     * @return RegisterUseOfForceRelativesInformationResponse
     */
    registerUseOfForceRelativesInformation(command: RegisterUseOfForceRelativesInformationRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceRelativesInformationResponse>;
    /**
     * @param command RegisterUseOfForceResponsibleMunicipalitySendingRequest
     * @return RegisterUseOfForceResponsibleMunicipalitySendingResponse
     */
    registerUseOfForceResponsibleMunicipalitySending(command: RegisterUseOfForceResponsibleMunicipalitySendingRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceResponsibleMunicipalitySendingResponse>;
    /**
     * @param command RegisterUseOfForceSummaryRegistrationMunicipalitySendingRequest
     * @return RegisterUseOfForceSummaryRegistrationMunicipalitySendingResponse
     */
    registerUseOfForceSummaryRegistrationMunicipalitySending(command: RegisterUseOfForceSummaryRegistrationMunicipalitySendingRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceSummaryRegistrationMunicipalitySendingResponse>;
    /**
     * @param command RegisterUseOfForceSummaryRegistrationOperatorInformationRequest
     * @return RegisterUseOfForceSummaryRegistrationOperatorInformationResponse
     */
    registerUseOfForceSummaryRegistrationOperatorInformation(command: RegisterUseOfForceSummaryRegistrationOperatorInformationRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceSummaryRegistrationOperatorInformationResponse>;
    /**
     * @param command RegisterUseOfForceSummaryRegistrationRelativesInformationRequest
     * @return RegisterUseOfForceSummaryRegistrationRelativesInformationResponse
     */
    registerUseOfForceSummaryRegistrationRelativesInformation(command: RegisterUseOfForceSummaryRegistrationRelativesInformationRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceSummaryRegistrationRelativesInformationResponse>;
    /**
     * @param command RegisterUseOfForceSummaryRegistrationSupervisionSendingRequest
     * @return RegisterUseOfForceSummaryRegistrationSupervisionSendingResponse
     */
    registerUseOfForceSummaryRegistrationSupervisionSending(command: RegisterUseOfForceSummaryRegistrationSupervisionSendingRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceSummaryRegistrationSupervisionSendingResponse>;
    /**
     * @param command RemoveUseOfForceCitizenStatementRequest
     * @return RemoveUseOfForceCitizenStatementResponse
     */
    removeUseOfForceCitizenStatement(command: RemoveUseOfForceCitizenStatementRequest, cancelToken?: CancelToken): Promise<RemoveUseOfForceCitizenStatementResponse>;
    /**
     * @param command RemoveUseOfForceHygieneRestraintRequest
     * @return RemoveUseOfForceHygieneRestraintResponse
     */
    removeUseOfForceHygieneRestraint(command: RemoveUseOfForceHygieneRestraintRequest, cancelToken?: CancelToken): Promise<RemoveUseOfForceHygieneRestraintResponse>;
    /**
     * @param command RemoveUseOfForceSummaryRegistrationCitizenStatementRequest
     * @return RemoveUseOfForceSummaryRegistrationCitizenStatementResponse
     */
    removeUseOfForceSummaryRegistrationCitizenStatement(command: RemoveUseOfForceSummaryRegistrationCitizenStatementRequest, cancelToken?: CancelToken): Promise<RemoveUseOfForceSummaryRegistrationCitizenStatementResponse>;
    /**
     * @param command ReturnUseOfForceIncidentRequest
     * @return ReturnUseOfForceIncidentResponse
     */
    returnUseOfForceIncident(command: ReturnUseOfForceIncidentRequest, cancelToken?: CancelToken): Promise<ReturnUseOfForceIncidentResponse>;
    /**
     * @param command RevokeServiceProviderUseOfForceAuthorizationRequest
     * @return RevokeServiceProviderUseOfForceAuthorizationResponse
     */
    revokeServiceProviderUseOfForceAuthorization(command: RevokeServiceProviderUseOfForceAuthorizationRequest, cancelToken?: CancelToken): Promise<RevokeServiceProviderUseOfForceAuthorizationResponse>;
    /**
     * @param command SendUseOfForceAuthorizationRequestRequest
     * @return SendUseOfForceAuthorizationRequestResponse
     */
    sendUseOfForceAuthorizationRequest(command: SendUseOfForceAuthorizationRequestRequest, cancelToken?: CancelToken): Promise<SendUseOfForceAuthorizationRequestResponse>;
    /**
     * @param command SubmitUseOfForceIncidentRequest
     * @return SubmitUseOfForceIncidentResponse
     */
    submitUseOfForceIncident(command: SubmitUseOfForceIncidentRequest, cancelToken?: CancelToken): Promise<SubmitUseOfForceIncidentResponse>;
    /**
     * @param command UpdateUseOfForceAuthorizationRequestDraftRequest
     * @return UpdateUseOfForceAuthorizationRequestDraftResponse
     */
    updateUseOfForceAuthorizationRequestDraft(command: UpdateUseOfForceAuthorizationRequestDraftRequest, cancelToken?: CancelToken): Promise<UpdateUseOfForceAuthorizationRequestDraftResponse>;
    /**
     * @param command UpdateUseOfForceIncidentDraftRequest
     * @return UpdateUseOfForceIncidentDraftResponse
     */
    updateUseOfForceIncidentDraft(command: UpdateUseOfForceIncidentDraftRequest, cancelToken?: CancelToken): Promise<UpdateUseOfForceIncidentDraftResponse>;
    /**
     * @param command UpdateUseOfForceIncidentLeaderSectionRequest
     * @return UpdateUseOfForceIncidentLeaderSectionResponse
     */
    updateUseOfForceIncidentLeaderSection(command: UpdateUseOfForceIncidentLeaderSectionRequest, cancelToken?: CancelToken): Promise<UpdateUseOfForceIncidentLeaderSectionResponse>;
    /**
     * @param command UpdateUseOfForceSummaryRegistrationDraftRequest
     * @return UpdateUseOfForceSummaryRegistrationDraftResponse
     */
    updateUseOfForceSummaryRegistrationDraft(command: UpdateUseOfForceSummaryRegistrationDraftRequest, cancelToken?: CancelToken): Promise<UpdateUseOfForceSummaryRegistrationDraftResponse>;
    /**
     * @param query GetUseOfForceAssignmentOptionsRequest
     * @return GetUseOfForceAssignmentOptionsResponse
     */
    getUseOfForceAssignmentOptions(query: GetUseOfForceAssignmentOptionsRequest, cancelToken?: CancelToken): Promise<GetUseOfForceAssignmentOptionsResponse>;
    /**
     * @param query GetUseOfForceAuthorizationRequestRequest
     * @return GetUseOfForceAuthorizationRequestResponse
     */
    getUseOfForceAuthorizationRequest(query: GetUseOfForceAuthorizationRequestRequest, cancelToken?: CancelToken): Promise<GetUseOfForceAuthorizationRequestResponse>;
    /**
     * @param query GetUseOfForceAuthorizationRequestPdfRequest
     * @return FileResponse
     */
    getUseOfForceAuthorizationRequestPdf(query: GetUseOfForceAuthorizationRequestPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetUseOfForceAuthorizationRequestsForCitizenRequest
     * @return GetUseOfForceAuthorizationRequestsForCitizenResponse
     */
    getUseOfForceAuthorizationRequestsForCitizen(query: GetUseOfForceAuthorizationRequestsForCitizenRequest, cancelToken?: CancelToken): Promise<GetUseOfForceAuthorizationRequestsForCitizenResponse>;
    /**
     * @param query GetUseOfForceAuthorizationsForServiceProviderUnitRequest
     * @return GetUseOfForceAuthorizationsForServiceProviderUnitResponse
     */
    getUseOfForceAuthorizationsForServiceProviderUnit(query: GetUseOfForceAuthorizationsForServiceProviderUnitRequest, cancelToken?: CancelToken): Promise<GetUseOfForceAuthorizationsForServiceProviderUnitResponse>;
    /**
     * @param query GetUseOfForceCitizenStatementRequest
     * @return FileResponse
     */
    getUseOfForceCitizenStatement(query: GetUseOfForceCitizenStatementRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetUseOfForceHygieneRestraintLogPdfRequest
     * @return FileResponse
     */
    getUseOfForceHygieneRestraintLogPdf(query: GetUseOfForceHygieneRestraintLogPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetUseOfForceHygieneRestraintLogsForCitizenRequest
     * @return GetUseOfForceHygieneRestraintLogsForCitizenResponse
     */
    getUseOfForceHygieneRestraintLogsForCitizen(query: GetUseOfForceHygieneRestraintLogsForCitizenRequest, cancelToken?: CancelToken): Promise<GetUseOfForceHygieneRestraintLogsForCitizenResponse>;
    /**
     * @param query GetUseOfForceIncidentRequest
     * @return GetUseOfForceIncidentResponse
     */
    getUseOfForceIncident(query: GetUseOfForceIncidentRequest, cancelToken?: CancelToken): Promise<GetUseOfForceIncidentResponse>;
    /**
     * @param query GetUseOfForceIncidentPdfRequest
     * @return FileResponse
     */
    getUseOfForceIncidentPdf(query: GetUseOfForceIncidentPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetUseOfForceIncidentsForCitizenRequest
     * @return GetUseOfForceIncidentsForCitizenResponse
     */
    getUseOfForceIncidentsForCitizen(query: GetUseOfForceIncidentsForCitizenRequest, cancelToken?: CancelToken): Promise<GetUseOfForceIncidentsForCitizenResponse>;
    /**
     * @param query GetUseOfForceSummaryRegistrationRequest
     * @return GetUseOfForceSummaryRegistrationResponse
     */
    getUseOfForceSummaryRegistration(query: GetUseOfForceSummaryRegistrationRequest, cancelToken?: CancelToken): Promise<GetUseOfForceSummaryRegistrationResponse>;
    /**
     * @param query GetUseOfForceSummaryRegistrationCitizenStatementRequest
     * @return FileResponse
     */
    getUseOfForceSummaryRegistrationCitizenStatement(query: GetUseOfForceSummaryRegistrationCitizenStatementRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetUseOfForceSummaryRegistrationPdfRequest
     * @return FileResponse
     */
    getUseOfForceSummaryRegistrationPdf(query: GetUseOfForceSummaryRegistrationPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetUseOfForceSummaryRegistrationsForCitizenRequest
     * @return GetUseOfForceSummaryRegistrationsForCitizenResponse
     */
    getUseOfForceSummaryRegistrationsForCitizen(query: GetUseOfForceSummaryRegistrationsForCitizenRequest, cancelToken?: CancelToken): Promise<GetUseOfForceSummaryRegistrationsForCitizenResponse>;
}

export class CitizenServiceProviderUseOfForceClient implements ICitizenServiceProviderUseOfForceClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command ApproveUseOfForceHygieneRestraintLogRequest
     * @return ApproveUseOfForceHygieneRestraintLogResponse
     */
    approveUseOfForceHygieneRestraintLog(command: ApproveUseOfForceHygieneRestraintLogRequest, cancelToken?: CancelToken): Promise<ApproveUseOfForceHygieneRestraintLogResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/approveuseofforcehygienerestraintlog`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ApproveUseOfForceIncidentRequest
     * @return ApproveUseOfForceIncidentResponse
     */
    approveUseOfForceIncident(command: ApproveUseOfForceIncidentRequest, cancelToken?: CancelToken): Promise<ApproveUseOfForceIncidentResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/approveuseofforceincident`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ApproveUseOfForceSummaryRegistrationRequest
     * @return ApproveUseOfForceSummaryRegistrationResponse
     */
    approveUseOfForceSummaryRegistration(command: ApproveUseOfForceSummaryRegistrationRequest, cancelToken?: CancelToken): Promise<ApproveUseOfForceSummaryRegistrationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/approveuseofforcesummaryregistration`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command AttachUseOfForceCitizenStatementRequest
     * @return AttachUseOfForceCitizenStatementResponse
     */
    attachUseOfForceCitizenStatement(command: AttachUseOfForceCitizenStatementRequest, cancelToken?: CancelToken): Promise<AttachUseOfForceCitizenStatementResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/attachuseofforcecitizenstatement`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command AttachUseOfForceSummaryRegistrationCitizenStatementRequest
     * @return AttachUseOfForceSummaryRegistrationCitizenStatementResponse
     */
    attachUseOfForceSummaryRegistrationCitizenStatement(command: AttachUseOfForceSummaryRegistrationCitizenStatementRequest, cancelToken?: CancelToken): Promise<AttachUseOfForceSummaryRegistrationCitizenStatementResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/attachuseofforcesummaryregistrationcitizenstatement`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CancelUseOfForceIncidentRequest
     * @return CancelUseOfForceIncidentResponse
     */
    cancelUseOfForceIncident(command: CancelUseOfForceIncidentRequest, cancelToken?: CancelToken): Promise<CancelUseOfForceIncidentResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/canceluseofforceincident`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CorrectUseOfForceHygieneRestraintRequest
     * @return CorrectUseOfForceHygieneRestraintResponse
     */
    correctUseOfForceHygieneRestraint(command: CorrectUseOfForceHygieneRestraintRequest, cancelToken?: CancelToken): Promise<CorrectUseOfForceHygieneRestraintResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/correctuseofforcehygienerestraint`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateUseOfForceAuthorizationRequestRequest
     * @return CreateUseOfForceAuthorizationRequestResponse
     */
    createUseOfForceAuthorizationRequest(command: CreateUseOfForceAuthorizationRequestRequest, cancelToken?: CancelToken): Promise<CreateUseOfForceAuthorizationRequestResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/createuseofforceauthorizationrequest`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateUseOfForceIncidentRequest
     * @return CreateUseOfForceIncidentResponse
     */
    createUseOfForceIncident(command: CreateUseOfForceIncidentRequest, cancelToken?: CancelToken): Promise<CreateUseOfForceIncidentResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/createuseofforceincident`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateUseOfForceSummaryRegistrationRequest
     * @return CreateUseOfForceSummaryRegistrationResponse
     */
    createUseOfForceSummaryRegistration(command: CreateUseOfForceSummaryRegistrationRequest, cancelToken?: CancelToken): Promise<CreateUseOfForceSummaryRegistrationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/createuseofforcesummaryregistration`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteUseOfForceAuthorizationRequestDraftRequest
     * @return DeleteUseOfForceAuthorizationRequestDraftResponse
     */
    deleteUseOfForceAuthorizationRequestDraft(command: DeleteUseOfForceAuthorizationRequestDraftRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/deleteuseofforceauthorizationrequestdraft`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteUseOfForceIncidentDraftRequest
     * @return DeleteUseOfForceIncidentDraftResponse
     */
    deleteUseOfForceIncidentDraft(command: DeleteUseOfForceIncidentDraftRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/deleteuseofforceincidentdraft`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteUseOfForceSummaryRegistrationDraftRequest
     * @return DeleteUseOfForceSummaryRegistrationDraftResponse
     */
    deleteUseOfForceSummaryRegistrationDraft(command: DeleteUseOfForceSummaryRegistrationDraftRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/deleteuseofforcesummaryregistrationdraft`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterServiceProviderUseOfForceAuthorizationRequest
     * @return RegisterServiceProviderUseOfForceAuthorizationResponse
     */
    registerServiceProviderUseOfForceAuthorization(command: RegisterServiceProviderUseOfForceAuthorizationRequest, cancelToken?: CancelToken): Promise<RegisterServiceProviderUseOfForceAuthorizationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/registerserviceprovideruseofforceauthorization`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterUseOfForceAuthorizationRequestDecisionRequest
     * @return RegisterUseOfForceAuthorizationRequestDecisionResponse
     */
    registerUseOfForceAuthorizationRequestDecision(command: RegisterUseOfForceAuthorizationRequestDecisionRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceAuthorizationRequestDecisionResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/registeruseofforceauthorizationrequestdecision`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterUseOfForceAuthorizationRequestMunicipalitySendingRequest
     * @return RegisterUseOfForceAuthorizationRequestMunicipalitySendingResponse
     */
    registerUseOfForceAuthorizationRequestMunicipalitySending(command: RegisterUseOfForceAuthorizationRequestMunicipalitySendingRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceAuthorizationRequestMunicipalitySendingResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/registeruseofforceauthorizationrequestmunicipalitysending`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterUseOfForceHygieneRestraintRequest
     * @return RegisterUseOfForceHygieneRestraintResponse
     */
    registerUseOfForceHygieneRestraint(command: RegisterUseOfForceHygieneRestraintRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceHygieneRestraintResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/registeruseofforcehygienerestraint`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterUseOfForceHygieneRestraintLogMunicipalitySendingRequest
     * @return RegisterUseOfForceHygieneRestraintLogMunicipalitySendingResponse
     */
    registerUseOfForceHygieneRestraintLogMunicipalitySending(command: RegisterUseOfForceHygieneRestraintLogMunicipalitySendingRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceHygieneRestraintLogMunicipalitySendingResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/registeruseofforcehygienerestraintlogmunicipalitysending`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterUseOfForceRelativesInformationRequest
     * @return RegisterUseOfForceRelativesInformationResponse
     */
    registerUseOfForceRelativesInformation(command: RegisterUseOfForceRelativesInformationRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceRelativesInformationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/registeruseofforcerelativesinformation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterUseOfForceResponsibleMunicipalitySendingRequest
     * @return RegisterUseOfForceResponsibleMunicipalitySendingResponse
     */
    registerUseOfForceResponsibleMunicipalitySending(command: RegisterUseOfForceResponsibleMunicipalitySendingRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceResponsibleMunicipalitySendingResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/registeruseofforceresponsiblemunicipalitysending`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterUseOfForceSummaryRegistrationMunicipalitySendingRequest
     * @return RegisterUseOfForceSummaryRegistrationMunicipalitySendingResponse
     */
    registerUseOfForceSummaryRegistrationMunicipalitySending(command: RegisterUseOfForceSummaryRegistrationMunicipalitySendingRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceSummaryRegistrationMunicipalitySendingResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/registeruseofforcesummaryregistrationmunicipalitysending`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterUseOfForceSummaryRegistrationOperatorInformationRequest
     * @return RegisterUseOfForceSummaryRegistrationOperatorInformationResponse
     */
    registerUseOfForceSummaryRegistrationOperatorInformation(command: RegisterUseOfForceSummaryRegistrationOperatorInformationRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceSummaryRegistrationOperatorInformationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/registeruseofforcesummaryregistrationoperatorinformation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterUseOfForceSummaryRegistrationRelativesInformationRequest
     * @return RegisterUseOfForceSummaryRegistrationRelativesInformationResponse
     */
    registerUseOfForceSummaryRegistrationRelativesInformation(command: RegisterUseOfForceSummaryRegistrationRelativesInformationRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceSummaryRegistrationRelativesInformationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/registeruseofforcesummaryregistrationrelativesinformation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterUseOfForceSummaryRegistrationSupervisionSendingRequest
     * @return RegisterUseOfForceSummaryRegistrationSupervisionSendingResponse
     */
    registerUseOfForceSummaryRegistrationSupervisionSending(command: RegisterUseOfForceSummaryRegistrationSupervisionSendingRequest, cancelToken?: CancelToken): Promise<RegisterUseOfForceSummaryRegistrationSupervisionSendingResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/registeruseofforcesummaryregistrationsupervisionsending`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RemoveUseOfForceCitizenStatementRequest
     * @return RemoveUseOfForceCitizenStatementResponse
     */
    removeUseOfForceCitizenStatement(command: RemoveUseOfForceCitizenStatementRequest, cancelToken?: CancelToken): Promise<RemoveUseOfForceCitizenStatementResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/removeuseofforcecitizenstatement`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RemoveUseOfForceHygieneRestraintRequest
     * @return RemoveUseOfForceHygieneRestraintResponse
     */
    removeUseOfForceHygieneRestraint(command: RemoveUseOfForceHygieneRestraintRequest, cancelToken?: CancelToken): Promise<RemoveUseOfForceHygieneRestraintResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/removeuseofforcehygienerestraint`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RemoveUseOfForceSummaryRegistrationCitizenStatementRequest
     * @return RemoveUseOfForceSummaryRegistrationCitizenStatementResponse
     */
    removeUseOfForceSummaryRegistrationCitizenStatement(command: RemoveUseOfForceSummaryRegistrationCitizenStatementRequest, cancelToken?: CancelToken): Promise<RemoveUseOfForceSummaryRegistrationCitizenStatementResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/removeuseofforcesummaryregistrationcitizenstatement`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReturnUseOfForceIncidentRequest
     * @return ReturnUseOfForceIncidentResponse
     */
    returnUseOfForceIncident(command: ReturnUseOfForceIncidentRequest, cancelToken?: CancelToken): Promise<ReturnUseOfForceIncidentResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/returnuseofforceincident`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RevokeServiceProviderUseOfForceAuthorizationRequest
     * @return RevokeServiceProviderUseOfForceAuthorizationResponse
     */
    revokeServiceProviderUseOfForceAuthorization(command: RevokeServiceProviderUseOfForceAuthorizationRequest, cancelToken?: CancelToken): Promise<RevokeServiceProviderUseOfForceAuthorizationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/revokeserviceprovideruseofforceauthorization`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendUseOfForceAuthorizationRequestRequest
     * @return SendUseOfForceAuthorizationRequestResponse
     */
    sendUseOfForceAuthorizationRequest(command: SendUseOfForceAuthorizationRequestRequest, cancelToken?: CancelToken): Promise<SendUseOfForceAuthorizationRequestResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/senduseofforceauthorizationrequest`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SubmitUseOfForceIncidentRequest
     * @return SubmitUseOfForceIncidentResponse
     */
    submitUseOfForceIncident(command: SubmitUseOfForceIncidentRequest, cancelToken?: CancelToken): Promise<SubmitUseOfForceIncidentResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/submituseofforceincident`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateUseOfForceAuthorizationRequestDraftRequest
     * @return UpdateUseOfForceAuthorizationRequestDraftResponse
     */
    updateUseOfForceAuthorizationRequestDraft(command: UpdateUseOfForceAuthorizationRequestDraftRequest, cancelToken?: CancelToken): Promise<UpdateUseOfForceAuthorizationRequestDraftResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/updateuseofforceauthorizationrequestdraft`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateUseOfForceIncidentDraftRequest
     * @return UpdateUseOfForceIncidentDraftResponse
     */
    updateUseOfForceIncidentDraft(command: UpdateUseOfForceIncidentDraftRequest, cancelToken?: CancelToken): Promise<UpdateUseOfForceIncidentDraftResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/updateuseofforceincidentdraft`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateUseOfForceIncidentLeaderSectionRequest
     * @return UpdateUseOfForceIncidentLeaderSectionResponse
     */
    updateUseOfForceIncidentLeaderSection(command: UpdateUseOfForceIncidentLeaderSectionRequest, cancelToken?: CancelToken): Promise<UpdateUseOfForceIncidentLeaderSectionResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/updateuseofforceincidentleadersection`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateUseOfForceSummaryRegistrationDraftRequest
     * @return UpdateUseOfForceSummaryRegistrationDraftResponse
     */
    updateUseOfForceSummaryRegistrationDraft(command: UpdateUseOfForceSummaryRegistrationDraftRequest, cancelToken?: CancelToken): Promise<UpdateUseOfForceSummaryRegistrationDraftResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/commands/updateuseofforcesummaryregistrationdraft`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceAssignmentOptionsRequest
     * @return GetUseOfForceAssignmentOptionsResponse
     */
    getUseOfForceAssignmentOptions(query: GetUseOfForceAssignmentOptionsRequest, cancelToken?: CancelToken): Promise<GetUseOfForceAssignmentOptionsResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforceassignmentoptions`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceAuthorizationRequestRequest
     * @return GetUseOfForceAuthorizationRequestResponse
     */
    getUseOfForceAuthorizationRequest(query: GetUseOfForceAuthorizationRequestRequest, cancelToken?: CancelToken): Promise<GetUseOfForceAuthorizationRequestResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforceauthorizationrequest`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceAuthorizationRequestPdfRequest
     * @return FileResponse
     */
    getUseOfForceAuthorizationRequestPdf(query: GetUseOfForceAuthorizationRequestPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforceauthorizationrequestpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceAuthorizationRequestsForCitizenRequest
     * @return GetUseOfForceAuthorizationRequestsForCitizenResponse
     */
    getUseOfForceAuthorizationRequestsForCitizen(query: GetUseOfForceAuthorizationRequestsForCitizenRequest, cancelToken?: CancelToken): Promise<GetUseOfForceAuthorizationRequestsForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforceauthorizationrequestsforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceAuthorizationsForServiceProviderUnitRequest
     * @return GetUseOfForceAuthorizationsForServiceProviderUnitResponse
     */
    getUseOfForceAuthorizationsForServiceProviderUnit(query: GetUseOfForceAuthorizationsForServiceProviderUnitRequest, cancelToken?: CancelToken): Promise<GetUseOfForceAuthorizationsForServiceProviderUnitResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforceauthorizationsforserviceproviderunit`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceCitizenStatementRequest
     * @return FileResponse
     */
    getUseOfForceCitizenStatement(query: GetUseOfForceCitizenStatementRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforcecitizenstatement`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceHygieneRestraintLogPdfRequest
     * @return FileResponse
     */
    getUseOfForceHygieneRestraintLogPdf(query: GetUseOfForceHygieneRestraintLogPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforcehygienerestraintlogpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceHygieneRestraintLogsForCitizenRequest
     * @return GetUseOfForceHygieneRestraintLogsForCitizenResponse
     */
    getUseOfForceHygieneRestraintLogsForCitizen(query: GetUseOfForceHygieneRestraintLogsForCitizenRequest, cancelToken?: CancelToken): Promise<GetUseOfForceHygieneRestraintLogsForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforcehygienerestraintlogsforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceIncidentRequest
     * @return GetUseOfForceIncidentResponse
     */
    getUseOfForceIncident(query: GetUseOfForceIncidentRequest, cancelToken?: CancelToken): Promise<GetUseOfForceIncidentResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforceincident`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceIncidentPdfRequest
     * @return FileResponse
     */
    getUseOfForceIncidentPdf(query: GetUseOfForceIncidentPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforceincidentpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceIncidentsForCitizenRequest
     * @return GetUseOfForceIncidentsForCitizenResponse
     */
    getUseOfForceIncidentsForCitizen(query: GetUseOfForceIncidentsForCitizenRequest, cancelToken?: CancelToken): Promise<GetUseOfForceIncidentsForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforceincidentsforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceSummaryRegistrationRequest
     * @return GetUseOfForceSummaryRegistrationResponse
     */
    getUseOfForceSummaryRegistration(query: GetUseOfForceSummaryRegistrationRequest, cancelToken?: CancelToken): Promise<GetUseOfForceSummaryRegistrationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforcesummaryregistration`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceSummaryRegistrationCitizenStatementRequest
     * @return FileResponse
     */
    getUseOfForceSummaryRegistrationCitizenStatement(query: GetUseOfForceSummaryRegistrationCitizenStatementRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforcesummaryregistrationcitizenstatement`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceSummaryRegistrationPdfRequest
     * @return FileResponse
     */
    getUseOfForceSummaryRegistrationPdf(query: GetUseOfForceSummaryRegistrationPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforcesummaryregistrationpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUseOfForceSummaryRegistrationsForCitizenRequest
     * @return GetUseOfForceSummaryRegistrationsForCitizenResponse
     */
    getUseOfForceSummaryRegistrationsForCitizen(query: GetUseOfForceSummaryRegistrationsForCitizenRequest, cancelToken?: CancelToken): Promise<GetUseOfForceSummaryRegistrationsForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/useofforce/queries/getuseofforcesummaryregistrationsforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderTrafficLightsClient {
    /**
     * @param command UpsertTrafficLightAssessmentRequest
     * @return UpsertTrafficLightAssessmentResponse
     */
    upsertTrafficLightAssessment(command: UpsertTrafficLightAssessmentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpsertTrafficLightCitizenInvolvementRequest
     * @return UpsertTrafficLightCitizenInvolvementResponse
     */
    upsertTrafficLightCitizenInvolvement(command: UpsertTrafficLightCitizenInvolvementRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpsertTrafficLightGreenZoneRequest
     * @return UpsertTrafficLightGreenZoneResponse
     */
    upsertTrafficLightGreenZone(command: UpsertTrafficLightGreenZoneRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpsertTrafficLightRedZoneRequest
     * @return UpsertTrafficLightRedZoneResponse
     */
    upsertTrafficLightRedZone(command: UpsertTrafficLightRedZoneRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpsertTrafficLightYellowZoneRequest
     * @return UpsertTrafficLightYellowZoneResponse
     */
    upsertTrafficLightYellowZone(command: UpsertTrafficLightYellowZoneRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetTrafficLightRequest
     * @return GetTrafficLightResponse
     */
    getTrafficLight(query: GetTrafficLightRequest, cancelToken?: CancelToken): Promise<GetTrafficLightResponse>;
    /**
     * @param query GetTrafficLightHistoryRequest
     * @return GetTrafficLightHistoryResponse
     */
    getTrafficLightHistory(query: GetTrafficLightHistoryRequest, cancelToken?: CancelToken): Promise<GetTrafficLightHistoryResponse>;
}

export class CitizenServiceProviderTrafficLightsClient implements ICitizenServiceProviderTrafficLightsClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command UpsertTrafficLightAssessmentRequest
     * @return UpsertTrafficLightAssessmentResponse
     */
    upsertTrafficLightAssessment(command: UpsertTrafficLightAssessmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/trafficlights/commands/upserttrafficlightassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpsertTrafficLightCitizenInvolvementRequest
     * @return UpsertTrafficLightCitizenInvolvementResponse
     */
    upsertTrafficLightCitizenInvolvement(command: UpsertTrafficLightCitizenInvolvementRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/trafficlights/commands/upserttrafficlightcitizeninvolvement`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpsertTrafficLightGreenZoneRequest
     * @return UpsertTrafficLightGreenZoneResponse
     */
    upsertTrafficLightGreenZone(command: UpsertTrafficLightGreenZoneRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/trafficlights/commands/upserttrafficlightgreenzone`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpsertTrafficLightRedZoneRequest
     * @return UpsertTrafficLightRedZoneResponse
     */
    upsertTrafficLightRedZone(command: UpsertTrafficLightRedZoneRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/trafficlights/commands/upserttrafficlightredzone`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpsertTrafficLightYellowZoneRequest
     * @return UpsertTrafficLightYellowZoneResponse
     */
    upsertTrafficLightYellowZone(command: UpsertTrafficLightYellowZoneRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/trafficlights/commands/upserttrafficlightyellowzone`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTrafficLightRequest
     * @return GetTrafficLightResponse
     */
    getTrafficLight(query: GetTrafficLightRequest, cancelToken?: CancelToken): Promise<GetTrafficLightResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/trafficlights/queries/gettrafficlight`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTrafficLightHistoryRequest
     * @return GetTrafficLightHistoryResponse
     */
    getTrafficLightHistory(query: GetTrafficLightHistoryRequest, cancelToken?: CancelToken): Promise<GetTrafficLightHistoryResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/trafficlights/queries/gettrafficlighthistory`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderSendMessageToAuthorityClient {
    /**
     * @param command SendMessageToAuthorityRequest
     * @return SendMessageToAuthorityResponse
     */
    sendMessageToAuthority(command: SendMessageToAuthorityRequest, cancelToken?: CancelToken): Promise<any>;
}

export class CitizenServiceProviderSendMessageToAuthorityClient implements ICitizenServiceProviderSendMessageToAuthorityClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command SendMessageToAuthorityRequest
     * @return SendMessageToAuthorityResponse
     */
    sendMessageToAuthority(command: SendMessageToAuthorityRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/sendmessagetoauthority/commands/sendmessagetoauthority`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderReceiveCitizenClient {
    /**
     * @param command CreateActivityForAssignmentRequest
     * @return CreateActivityForAssignmentResponse
     */
    createActivityForAssignment(command: CreateActivityForAssignmentRequest, cancelToken?: CancelToken): Promise<CreateActivityForAssignmentResponse>;
    /**
     * @param command CreateAssignmentAsServiceProviderRequest
     * @return CreateAssignmentAsServiceProviderResponse
     */
    createAssignmentAsServiceProvider(command: CreateAssignmentAsServiceProviderRequest, cancelToken?: CancelToken): Promise<CreateAssignmentAsServiceProviderResponse>;
    /**
     * @param command CreateServiceProviderAssignmentRequest
     * @return CreateServiceProviderAssignmentResponse
     */
    createServiceProviderAssignment(command: CreateServiceProviderAssignmentRequest, cancelToken?: CancelToken): Promise<CreateServiceProviderAssignmentResponse>;
    /**
     * @param command EnsureCitizenForAssignmentRequest
     * @return EnsureCitizenForAssignmentResponse
     */
    ensureCitizenForAssignment(command: EnsureCitizenForAssignmentRequest, cancelToken?: CancelToken): Promise<EnsureCitizenForAssignmentResponse>;
    /**
     * @param query GetCitizenFromFasitOrExternalSourceRequest
     * @return GetCitizenFromFasitOrExternalSourceResponse
     */
    getCitizenFromFasitOrExternalSource(query: GetCitizenFromFasitOrExternalSourceRequest, cancelToken?: CancelToken): Promise<GetCitizenFromFasitOrExternalSourceResponse>;
    /**
     * @param query GetServiceProviderUnitRequest
     * @return GetServiceProviderUnitResponse
     */
    getServiceProviderUnit(query: GetServiceProviderUnitRequest, cancelToken?: CancelToken): Promise<GetServiceProviderUnitResponse>;
}

export class CitizenServiceProviderReceiveCitizenClient implements ICitizenServiceProviderReceiveCitizenClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateActivityForAssignmentRequest
     * @return CreateActivityForAssignmentResponse
     */
    createActivityForAssignment(command: CreateActivityForAssignmentRequest, cancelToken?: CancelToken): Promise<CreateActivityForAssignmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/receivecitizen/commands/createactivityforassignment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAssignmentAsServiceProviderRequest
     * @return CreateAssignmentAsServiceProviderResponse
     */
    createAssignmentAsServiceProvider(command: CreateAssignmentAsServiceProviderRequest, cancelToken?: CancelToken): Promise<CreateAssignmentAsServiceProviderResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/receivecitizen/commands/createassignmentasserviceprovider`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateServiceProviderAssignmentRequest
     * @return CreateServiceProviderAssignmentResponse
     */
    createServiceProviderAssignment(command: CreateServiceProviderAssignmentRequest, cancelToken?: CancelToken): Promise<CreateServiceProviderAssignmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/receivecitizen/commands/createserviceproviderassignment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command EnsureCitizenForAssignmentRequest
     * @return EnsureCitizenForAssignmentResponse
     */
    ensureCitizenForAssignment(command: EnsureCitizenForAssignmentRequest, cancelToken?: CancelToken): Promise<EnsureCitizenForAssignmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/receivecitizen/commands/ensurecitizenforassignment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenFromFasitOrExternalSourceRequest
     * @return GetCitizenFromFasitOrExternalSourceResponse
     */
    getCitizenFromFasitOrExternalSource(query: GetCitizenFromFasitOrExternalSourceRequest, cancelToken?: CancelToken): Promise<GetCitizenFromFasitOrExternalSourceResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/receivecitizen/queries/getcitizenfromfasitorexternalsource`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderUnitRequest
     * @return GetServiceProviderUnitResponse
     */
    getServiceProviderUnit(query: GetServiceProviderUnitRequest, cancelToken?: CancelToken): Promise<GetServiceProviderUnitResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/receivecitizen/queries/getserviceproviderunit`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderReceiveAssignmentClient {
    /**
     * @param command ReceiveAssignmentRequest
     * @return ReceiveAssignmentResponse
     */
    receiveAssignment(command: ReceiveAssignmentRequest, cancelToken?: CancelToken): Promise<any>;
}

export class CitizenServiceProviderReceiveAssignmentClient implements ICitizenServiceProviderReceiveAssignmentClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command ReceiveAssignmentRequest
     * @return ReceiveAssignmentResponse
     */
    receiveAssignment(command: ReceiveAssignmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/receiveassignment/commands/receiveassignment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderObservationsClient {
    /**
     * @param command CreateObservationRequest
     * @return CreateObservationResponse
     */
    createObservation(command: CreateObservationRequest, cancelToken?: CancelToken): Promise<CreateObservationResponse>;
    /**
     * @param command DeleteObservationRequest
     * @return DeleteObservationResponse
     */
    deleteObservation(command: DeleteObservationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateObservationRequest
     * @return UpdateObservationResponse
     */
    updateObservation(command: UpdateObservationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetObservationsRequest
     * @return GetObservationsResponse
     */
    getObservations(query: GetObservationsRequest, cancelToken?: CancelToken): Promise<GetObservationsResponse>;
}

export class CitizenServiceProviderObservationsClient implements ICitizenServiceProviderObservationsClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateObservationRequest
     * @return CreateObservationResponse
     */
    createObservation(command: CreateObservationRequest, cancelToken?: CancelToken): Promise<CreateObservationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/observations/commands/createobservation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteObservationRequest
     * @return DeleteObservationResponse
     */
    deleteObservation(command: DeleteObservationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/observations/commands/deleteobservation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateObservationRequest
     * @return UpdateObservationResponse
     */
    updateObservation(command: UpdateObservationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/observations/commands/updateobservation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetObservationsRequest
     * @return GetObservationsResponse
     */
    getObservations(query: GetObservationsRequest, cancelToken?: CancelToken): Promise<GetObservationsResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/observations/queries/getobservations`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderMedicineInventoryClient {
    /**
     * @param command ApproveDoubleControlRequest
     * @return ApproveDoubleControlResponse
     */
    approveDoubleControl(command: ApproveDoubleControlRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ApproveMedicineInventoryMovementDoubleControlRequest
     * @return ApproveMedicineInventoryMovementDoubleControlResponse
     */
    approveMedicineInventoryMovementDoubleControl(command: ApproveMedicineInventoryMovementDoubleControlRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ChangeMedicineInventoryPackageStatusRequest
     * @return ChangeMedicineInventoryPackageStatusResponse
     */
    changeMedicineInventoryPackageStatus(command: ChangeMedicineInventoryPackageStatusRequest, cancelToken?: CancelToken): Promise<ChangeMedicineInventoryPackageStatusResponse>;
    /**
     * @param command CountMedicineInventoryRequest
     * @return CountMedicineInventoryResponse
     */
    countMedicineInventory(command: CountMedicineInventoryRequest, cancelToken?: CancelToken): Promise<CountMedicineInventoryResponse>;
    /**
     * @param command DiscardFromMedicineInventoryPackageRequest
     * @return DiscardFromMedicineInventoryPackageResponse
     */
    discardFromMedicineInventoryPackage(command: DiscardFromMedicineInventoryPackageRequest, cancelToken?: CancelToken): Promise<DiscardFromMedicineInventoryPackageResponse>;
    /**
     * @param command RecordPnEffectAssessmentRequest
     * @return RecordPnEffectAssessmentResponse
     */
    recordPnEffectAssessment(command: RecordPnEffectAssessmentRequest, cancelToken?: CancelToken): Promise<RecordPnEffectAssessmentResponse>;
    /**
     * @param command RegisterMedicineAdministrationRequest
     * @return RegisterMedicineAdministrationResponse
     */
    registerMedicineAdministration(command: RegisterMedicineAdministrationRequest, cancelToken?: CancelToken): Promise<RegisterMedicineAdministrationResponse>;
    /**
     * @param command RegisterMedicineInventoryControlSheetDownloadRequest
     * @return RegisterMedicineInventoryControlSheetDownloadResponse
     */
    registerMedicineInventoryControlSheetDownload(command: RegisterMedicineInventoryControlSheetDownloadRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ReturnFromMedicineInventoryPackageRequest
     * @return ReturnFromMedicineInventoryPackageResponse
     */
    returnFromMedicineInventoryPackage(command: ReturnFromMedicineInventoryPackageRequest, cancelToken?: CancelToken): Promise<ReturnFromMedicineInventoryPackageResponse>;
    /**
     * @param command SetMedicineInventoryPackageBatchAndExpiryRequest
     * @return SetMedicineInventoryPackageBatchAndExpiryResponse
     */
    setMedicineInventoryPackageBatchAndExpiry(command: SetMedicineInventoryPackageBatchAndExpiryRequest, cancelToken?: CancelToken): Promise<SetMedicineInventoryPackageBatchAndExpiryResponse>;
    /**
     * @param command SetMedicineInventoryPackageLocationRequest
     * @return SetMedicineInventoryPackageLocationResponse
     */
    setMedicineInventoryPackageLocation(command: SetMedicineInventoryPackageLocationRequest, cancelToken?: CancelToken): Promise<SetMedicineInventoryPackageLocationResponse>;
    /**
     * @param query GetCountDoubleControlDeclarationRequest
     * @return GetCountDoubleControlDeclarationResponse
     */
    getCountDoubleControlDeclaration(query: GetCountDoubleControlDeclarationRequest, cancelToken?: CancelToken): Promise<GetCountDoubleControlDeclarationResponse>;
    /**
     * @param query GetDisposalDoubleControlDeclarationRequest
     * @return GetDisposalDoubleControlDeclarationResponse
     */
    getDisposalDoubleControlDeclaration(query: GetDisposalDoubleControlDeclarationRequest, cancelToken?: CancelToken): Promise<GetDisposalDoubleControlDeclarationResponse>;
    /**
     * @param query GetDoubleControlDeclarationRequest
     * @return GetDoubleControlDeclarationResponse
     */
    getDoubleControlDeclaration(query: GetDoubleControlDeclarationRequest, cancelToken?: CancelToken): Promise<GetDoubleControlDeclarationResponse>;
    /**
     * @param query GetLatestPnAdministrationRequest
     * @return GetLatestPnAdministrationResponse
     */
    getLatestPnAdministration(query: GetLatestPnAdministrationRequest, cancelToken?: CancelToken): Promise<GetLatestPnAdministrationResponse>;
    /**
     * @param query GetMedicineAdministrationsAwaitingDoubleControlRequest
     * @return GetMedicineAdministrationsAwaitingDoubleControlResponse
     */
    getMedicineAdministrationsAwaitingDoubleControl(query: GetMedicineAdministrationsAwaitingDoubleControlRequest, cancelToken?: CancelToken): Promise<GetMedicineAdministrationsAwaitingDoubleControlResponse>;
    /**
     * @param query GetMedicineAdministrationsForPeriodRequest
     * @return GetMedicineAdministrationsForPeriodResponse
     */
    getMedicineAdministrationsForPeriod(query: GetMedicineAdministrationsForPeriodRequest, cancelToken?: CancelToken): Promise<GetMedicineAdministrationsForPeriodResponse>;
    /**
     * @param query GetMedicineInventoryControlSheetRequest
     * @return GetMedicineInventoryControlSheetResponse
     */
    getMedicineInventoryControlSheet(query: GetMedicineInventoryControlSheetRequest, cancelToken?: CancelToken): Promise<GetMedicineInventoryControlSheetResponse>;
    /**
     * @param query GetMedicineInventoryForCitizenRequest
     * @return GetMedicineInventoryForCitizenResponse
     */
    getMedicineInventoryForCitizen(query: GetMedicineInventoryForCitizenRequest, cancelToken?: CancelToken): Promise<GetMedicineInventoryForCitizenResponse>;
    /**
     * @param query GetMedicineInventoryMovementsAwaitingDoubleControlRequest
     * @return GetMedicineInventoryMovementsAwaitingDoubleControlResponse
     */
    getMedicineInventoryMovementsAwaitingDoubleControl(query: GetMedicineInventoryMovementsAwaitingDoubleControlRequest, cancelToken?: CancelToken): Promise<GetMedicineInventoryMovementsAwaitingDoubleControlResponse>;
    /**
     * @param query GetReturnDoubleControlDeclarationRequest
     * @return GetReturnDoubleControlDeclarationResponse
     */
    getReturnDoubleControlDeclaration(query: GetReturnDoubleControlDeclarationRequest, cancelToken?: CancelToken): Promise<GetReturnDoubleControlDeclarationResponse>;
}

export class CitizenServiceProviderMedicineInventoryClient implements ICitizenServiceProviderMedicineInventoryClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command ApproveDoubleControlRequest
     * @return ApproveDoubleControlResponse
     */
    approveDoubleControl(command: ApproveDoubleControlRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/commands/approvedoublecontrol`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ApproveMedicineInventoryMovementDoubleControlRequest
     * @return ApproveMedicineInventoryMovementDoubleControlResponse
     */
    approveMedicineInventoryMovementDoubleControl(command: ApproveMedicineInventoryMovementDoubleControlRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/commands/approvemedicineinventorymovementdoublecontrol`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ChangeMedicineInventoryPackageStatusRequest
     * @return ChangeMedicineInventoryPackageStatusResponse
     */
    changeMedicineInventoryPackageStatus(command: ChangeMedicineInventoryPackageStatusRequest, cancelToken?: CancelToken): Promise<ChangeMedicineInventoryPackageStatusResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/commands/changemedicineinventorypackagestatus`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CountMedicineInventoryRequest
     * @return CountMedicineInventoryResponse
     */
    countMedicineInventory(command: CountMedicineInventoryRequest, cancelToken?: CancelToken): Promise<CountMedicineInventoryResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/commands/countmedicineinventory`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DiscardFromMedicineInventoryPackageRequest
     * @return DiscardFromMedicineInventoryPackageResponse
     */
    discardFromMedicineInventoryPackage(command: DiscardFromMedicineInventoryPackageRequest, cancelToken?: CancelToken): Promise<DiscardFromMedicineInventoryPackageResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/commands/discardfrommedicineinventorypackage`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RecordPnEffectAssessmentRequest
     * @return RecordPnEffectAssessmentResponse
     */
    recordPnEffectAssessment(command: RecordPnEffectAssessmentRequest, cancelToken?: CancelToken): Promise<RecordPnEffectAssessmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/commands/recordpneffectassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterMedicineAdministrationRequest
     * @return RegisterMedicineAdministrationResponse
     */
    registerMedicineAdministration(command: RegisterMedicineAdministrationRequest, cancelToken?: CancelToken): Promise<RegisterMedicineAdministrationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/commands/registermedicineadministration`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterMedicineInventoryControlSheetDownloadRequest
     * @return RegisterMedicineInventoryControlSheetDownloadResponse
     */
    registerMedicineInventoryControlSheetDownload(command: RegisterMedicineInventoryControlSheetDownloadRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/commands/registermedicineinventorycontrolsheetdownload`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReturnFromMedicineInventoryPackageRequest
     * @return ReturnFromMedicineInventoryPackageResponse
     */
    returnFromMedicineInventoryPackage(command: ReturnFromMedicineInventoryPackageRequest, cancelToken?: CancelToken): Promise<ReturnFromMedicineInventoryPackageResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/commands/returnfrommedicineinventorypackage`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetMedicineInventoryPackageBatchAndExpiryRequest
     * @return SetMedicineInventoryPackageBatchAndExpiryResponse
     */
    setMedicineInventoryPackageBatchAndExpiry(command: SetMedicineInventoryPackageBatchAndExpiryRequest, cancelToken?: CancelToken): Promise<SetMedicineInventoryPackageBatchAndExpiryResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/commands/setmedicineinventorypackagebatchandexpiry`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetMedicineInventoryPackageLocationRequest
     * @return SetMedicineInventoryPackageLocationResponse
     */
    setMedicineInventoryPackageLocation(command: SetMedicineInventoryPackageLocationRequest, cancelToken?: CancelToken): Promise<SetMedicineInventoryPackageLocationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/commands/setmedicineinventorypackagelocation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCountDoubleControlDeclarationRequest
     * @return GetCountDoubleControlDeclarationResponse
     */
    getCountDoubleControlDeclaration(query: GetCountDoubleControlDeclarationRequest, cancelToken?: CancelToken): Promise<GetCountDoubleControlDeclarationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/queries/getcountdoublecontroldeclaration`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDisposalDoubleControlDeclarationRequest
     * @return GetDisposalDoubleControlDeclarationResponse
     */
    getDisposalDoubleControlDeclaration(query: GetDisposalDoubleControlDeclarationRequest, cancelToken?: CancelToken): Promise<GetDisposalDoubleControlDeclarationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/queries/getdisposaldoublecontroldeclaration`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDoubleControlDeclarationRequest
     * @return GetDoubleControlDeclarationResponse
     */
    getDoubleControlDeclaration(query: GetDoubleControlDeclarationRequest, cancelToken?: CancelToken): Promise<GetDoubleControlDeclarationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/queries/getdoublecontroldeclaration`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLatestPnAdministrationRequest
     * @return GetLatestPnAdministrationResponse
     */
    getLatestPnAdministration(query: GetLatestPnAdministrationRequest, cancelToken?: CancelToken): Promise<GetLatestPnAdministrationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/queries/getlatestpnadministration`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicineAdministrationsAwaitingDoubleControlRequest
     * @return GetMedicineAdministrationsAwaitingDoubleControlResponse
     */
    getMedicineAdministrationsAwaitingDoubleControl(query: GetMedicineAdministrationsAwaitingDoubleControlRequest, cancelToken?: CancelToken): Promise<GetMedicineAdministrationsAwaitingDoubleControlResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/queries/getmedicineadministrationsawaitingdoublecontrol`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicineAdministrationsForPeriodRequest
     * @return GetMedicineAdministrationsForPeriodResponse
     */
    getMedicineAdministrationsForPeriod(query: GetMedicineAdministrationsForPeriodRequest, cancelToken?: CancelToken): Promise<GetMedicineAdministrationsForPeriodResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/queries/getmedicineadministrationsforperiod`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicineInventoryControlSheetRequest
     * @return GetMedicineInventoryControlSheetResponse
     */
    getMedicineInventoryControlSheet(query: GetMedicineInventoryControlSheetRequest, cancelToken?: CancelToken): Promise<GetMedicineInventoryControlSheetResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/queries/getmedicineinventorycontrolsheet`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicineInventoryForCitizenRequest
     * @return GetMedicineInventoryForCitizenResponse
     */
    getMedicineInventoryForCitizen(query: GetMedicineInventoryForCitizenRequest, cancelToken?: CancelToken): Promise<GetMedicineInventoryForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/queries/getmedicineinventoryforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicineInventoryMovementsAwaitingDoubleControlRequest
     * @return GetMedicineInventoryMovementsAwaitingDoubleControlResponse
     */
    getMedicineInventoryMovementsAwaitingDoubleControl(query: GetMedicineInventoryMovementsAwaitingDoubleControlRequest, cancelToken?: CancelToken): Promise<GetMedicineInventoryMovementsAwaitingDoubleControlResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/queries/getmedicineinventorymovementsawaitingdoublecontrol`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetReturnDoubleControlDeclarationRequest
     * @return GetReturnDoubleControlDeclarationResponse
     */
    getReturnDoubleControlDeclaration(query: GetReturnDoubleControlDeclarationRequest, cancelToken?: CancelToken): Promise<GetReturnDoubleControlDeclarationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineinventory/queries/getreturndoublecontroldeclaration`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderMedicineCardClient {
    /**
     * @param command AddOtcMedicationRequest
     * @return AddOtcMedicationResponse
     */
    addOtcMedication(command: AddOtcMedicationRequest, cancelToken?: CancelToken): Promise<AddOtcMedicationResponse>;
    /**
     * @param command CreateMedicineCardForCitizenRequest
     * @return CreateMedicineCardForCitizenResponse
     */
    createMedicineCardForCitizen(command: CreateMedicineCardForCitizenRequest, cancelToken?: CancelToken): Promise<CreateMedicineCardForCitizenResponse>;
    /**
     * @param command DeleteMedicineCardForCitizenRequest
     * @return DeleteMedicineCardForCitizenResponse
     */
    deleteMedicineCardForCitizen(command: DeleteMedicineCardForCitizenRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command RegisterMedicineCardPrivacyConsentRequest
     * @return RegisterMedicineCardPrivacyConsentResponse
     */
    registerMedicineCardPrivacyConsent(command: RegisterMedicineCardPrivacyConsentRequest, cancelToken?: CancelToken): Promise<RegisterMedicineCardPrivacyConsentResponse>;
    /**
     * @param command RevokeMedicineCardPrivacyConsentRequest
     * @return RevokeMedicineCardPrivacyConsentResponse
     */
    revokeMedicineCardPrivacyConsent(command: RevokeMedicineCardPrivacyConsentRequest, cancelToken?: CancelToken): Promise<RevokeMedicineCardPrivacyConsentResponse>;
    /**
     * @param command SeponerOtcMedicationRequest
     * @return SeponerOtcMedicationResponse
     */
    seponerOtcMedication(command: SeponerOtcMedicationRequest, cancelToken?: CancelToken): Promise<SeponerOtcMedicationResponse>;
    /**
     * @param command SynchronizeMedicineCardFromFmkRequest
     * @return SynchronizeMedicineCardFromFmkResponse
     */
    synchronizeMedicineCardFromFmk(command: SynchronizeMedicineCardFromFmkRequest, cancelToken?: CancelToken): Promise<SynchronizeMedicineCardFromFmkResponse>;
    /**
     * @param command UpdateOperationalDetailsRequest
     * @return UpdateOperationalDetailsResponse
     */
    updateOperationalDetails(command: UpdateOperationalDetailsRequest, cancelToken?: CancelToken): Promise<UpdateOperationalDetailsResponse>;
    /**
     * @param query GetDoseDispensingCardPdfRequest
     * @return FileResponse
     */
    getDoseDispensingCardPdf(query: GetDoseDispensingCardPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetMedicineCardForCitizenRequest
     * @return GetMedicineCardForCitizenResponse
     */
    getMedicineCardForCitizen(query: GetMedicineCardForCitizenRequest, cancelToken?: CancelToken): Promise<GetMedicineCardForCitizenResponse>;
    /**
     * @param query GetMedicineCardPrintPdfRequest
     * @return FileResponse
     */
    getMedicineCardPrintPdf(query: GetMedicineCardPrintPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
}

export class CitizenServiceProviderMedicineCardClient implements ICitizenServiceProviderMedicineCardClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command AddOtcMedicationRequest
     * @return AddOtcMedicationResponse
     */
    addOtcMedication(command: AddOtcMedicationRequest, cancelToken?: CancelToken): Promise<AddOtcMedicationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicinecard/commands/addotcmedication`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateMedicineCardForCitizenRequest
     * @return CreateMedicineCardForCitizenResponse
     */
    createMedicineCardForCitizen(command: CreateMedicineCardForCitizenRequest, cancelToken?: CancelToken): Promise<CreateMedicineCardForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicinecard/commands/createmedicinecardforcitizen`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteMedicineCardForCitizenRequest
     * @return DeleteMedicineCardForCitizenResponse
     */
    deleteMedicineCardForCitizen(command: DeleteMedicineCardForCitizenRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicinecard/commands/deletemedicinecardforcitizen`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterMedicineCardPrivacyConsentRequest
     * @return RegisterMedicineCardPrivacyConsentResponse
     */
    registerMedicineCardPrivacyConsent(command: RegisterMedicineCardPrivacyConsentRequest, cancelToken?: CancelToken): Promise<RegisterMedicineCardPrivacyConsentResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicinecard/commands/registermedicinecardprivacyconsent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RevokeMedicineCardPrivacyConsentRequest
     * @return RevokeMedicineCardPrivacyConsentResponse
     */
    revokeMedicineCardPrivacyConsent(command: RevokeMedicineCardPrivacyConsentRequest, cancelToken?: CancelToken): Promise<RevokeMedicineCardPrivacyConsentResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicinecard/commands/revokemedicinecardprivacyconsent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SeponerOtcMedicationRequest
     * @return SeponerOtcMedicationResponse
     */
    seponerOtcMedication(command: SeponerOtcMedicationRequest, cancelToken?: CancelToken): Promise<SeponerOtcMedicationResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicinecard/commands/seponerotcmedication`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SynchronizeMedicineCardFromFmkRequest
     * @return SynchronizeMedicineCardFromFmkResponse
     */
    synchronizeMedicineCardFromFmk(command: SynchronizeMedicineCardFromFmkRequest, cancelToken?: CancelToken): Promise<SynchronizeMedicineCardFromFmkResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicinecard/commands/synchronizemedicinecardfromfmk`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateOperationalDetailsRequest
     * @return UpdateOperationalDetailsResponse
     */
    updateOperationalDetails(command: UpdateOperationalDetailsRequest, cancelToken?: CancelToken): Promise<UpdateOperationalDetailsResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicinecard/commands/updateoperationaldetails`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDoseDispensingCardPdfRequest
     * @return FileResponse
     */
    getDoseDispensingCardPdf(query: GetDoseDispensingCardPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicinecard/queries/getdosedispensingcardpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicineCardForCitizenRequest
     * @return GetMedicineCardForCitizenResponse
     */
    getMedicineCardForCitizen(query: GetMedicineCardForCitizenRequest, cancelToken?: CancelToken): Promise<GetMedicineCardForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicinecard/queries/getmedicinecardforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicineCardPrintPdfRequest
     * @return FileResponse
     */
    getMedicineCardPrintPdf(query: GetMedicineCardPrintPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicinecard/queries/getmedicinecardprintpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderInterventionObjectiveStatusClient {
    /**
     * @param command CreateInterventionObjectiveStatusRequest
     * @return CreateInterventionObjectiveStatusResponse
     */
    createInterventionObjectiveStatus(command: CreateInterventionObjectiveStatusRequest, cancelToken?: CancelToken): Promise<CreateInterventionObjectiveStatusResponse>;
    /**
     * @param query GenerateInterventionObjectiveStatusDraftRequest
     * @return GenerateInterventionObjectiveStatusDraftResponse
     */
    generateInterventionObjectiveStatusDraft(query: GenerateInterventionObjectiveStatusDraftRequest, cancelToken?: CancelToken): Promise<GenerateInterventionObjectiveStatusDraftResponse>;
    /**
     * @param query GetInterventionObjectiveStatusByStatusIdRequest
     * @return GetInterventionObjectiveStatusByStatusIdResponse
     */
    getInterventionObjectiveStatusByStatusId(query: GetInterventionObjectiveStatusByStatusIdRequest, cancelToken?: CancelToken): Promise<GetInterventionObjectiveStatusByStatusIdResponse>;
    /**
     * @param query GetInterventionObjectiveStatusesByAssignmentIdRequest
     * @return GetInterventionObjectiveStatusesByAssignmentIdResponse
     */
    getInterventionObjectiveStatusesByAssignmentId(query: GetInterventionObjectiveStatusesByAssignmentIdRequest, cancelToken?: CancelToken): Promise<GetInterventionObjectiveStatusesByAssignmentIdResponse>;
}

export class CitizenServiceProviderInterventionObjectiveStatusClient implements ICitizenServiceProviderInterventionObjectiveStatusClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateInterventionObjectiveStatusRequest
     * @return CreateInterventionObjectiveStatusResponse
     */
    createInterventionObjectiveStatus(command: CreateInterventionObjectiveStatusRequest, cancelToken?: CancelToken): Promise<CreateInterventionObjectiveStatusResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/interventionobjectivestatus/commands/createinterventionobjectivestatus`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GenerateInterventionObjectiveStatusDraftRequest
     * @return GenerateInterventionObjectiveStatusDraftResponse
     */
    generateInterventionObjectiveStatusDraft(query: GenerateInterventionObjectiveStatusDraftRequest, cancelToken?: CancelToken): Promise<GenerateInterventionObjectiveStatusDraftResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/interventionobjectivestatus/queries/generateinterventionobjectivestatusdraft`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterventionObjectiveStatusByStatusIdRequest
     * @return GetInterventionObjectiveStatusByStatusIdResponse
     */
    getInterventionObjectiveStatusByStatusId(query: GetInterventionObjectiveStatusByStatusIdRequest, cancelToken?: CancelToken): Promise<GetInterventionObjectiveStatusByStatusIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/interventionobjectivestatus/queries/getinterventionobjectivestatusbystatusid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterventionObjectiveStatusesByAssignmentIdRequest
     * @return GetInterventionObjectiveStatusesByAssignmentIdResponse
     */
    getInterventionObjectiveStatusesByAssignmentId(query: GetInterventionObjectiveStatusesByAssignmentIdRequest, cancelToken?: CancelToken): Promise<GetInterventionObjectiveStatusesByAssignmentIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/interventionobjectivestatus/queries/getinterventionobjectivestatusesbyassignmentid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderHealthOverviewClient {
    /**
     * @param command AssessHealthConditionRequest
     * @return AssessHealthConditionResponse
     */
    assessHealthCondition(command: AssessHealthConditionRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command AssessProblemAreaRequest
     * @return AssessProblemAreaResponse
     */
    assessProblemArea(command: AssessProblemAreaRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetHealthConditionHistoryRequest
     * @return GetHealthConditionHistoryResponse
     */
    getHealthConditionHistory(query: GetHealthConditionHistoryRequest, cancelToken?: CancelToken): Promise<GetHealthConditionHistoryResponse>;
    /**
     * @param query GetHealthOverviewRequest
     * @return GetHealthOverviewResponse
     */
    getHealthOverview(query: GetHealthOverviewRequest, cancelToken?: CancelToken): Promise<GetHealthOverviewResponse>;
    /**
     * @param query GetProblemAreaHistoryRequest
     * @return GetProblemAreaHistoryResponse
     */
    getProblemAreaHistory(query: GetProblemAreaHistoryRequest, cancelToken?: CancelToken): Promise<GetProblemAreaHistoryResponse>;
}

export class CitizenServiceProviderHealthOverviewClient implements ICitizenServiceProviderHealthOverviewClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command AssessHealthConditionRequest
     * @return AssessHealthConditionResponse
     */
    assessHealthCondition(command: AssessHealthConditionRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/healthoverview/commands/assesshealthcondition`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command AssessProblemAreaRequest
     * @return AssessProblemAreaResponse
     */
    assessProblemArea(command: AssessProblemAreaRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/healthoverview/commands/assessproblemarea`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHealthConditionHistoryRequest
     * @return GetHealthConditionHistoryResponse
     */
    getHealthConditionHistory(query: GetHealthConditionHistoryRequest, cancelToken?: CancelToken): Promise<GetHealthConditionHistoryResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/healthoverview/queries/gethealthconditionhistory`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHealthOverviewRequest
     * @return GetHealthOverviewResponse
     */
    getHealthOverview(query: GetHealthOverviewRequest, cancelToken?: CancelToken): Promise<GetHealthOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/healthoverview/queries/gethealthoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetProblemAreaHistoryRequest
     * @return GetProblemAreaHistoryResponse
     */
    getProblemAreaHistory(query: GetProblemAreaHistoryRequest, cancelToken?: CancelToken): Promise<GetProblemAreaHistoryResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/healthoverview/queries/getproblemareahistory`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderFordelingClient {
    /**
     * @param command SetAssignmentDistributionRequest
     * @return SetAssignmentDistributionResponse
     */
    setAssignmentDistribution(command: SetAssignmentDistributionRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetAssignmentDistributionRequest
     * @return GetAssignmentDistributionResponse
     */
    getAssignmentDistribution(query: GetAssignmentDistributionRequest, cancelToken?: CancelToken): Promise<GetAssignmentDistributionResponse>;
}

export class CitizenServiceProviderFordelingClient implements ICitizenServiceProviderFordelingClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command SetAssignmentDistributionRequest
     * @return SetAssignmentDistributionResponse
     */
    setAssignmentDistribution(command: SetAssignmentDistributionRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/fordeling/commands/setassignmentdistribution`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssignmentDistributionRequest
     * @return GetAssignmentDistributionResponse
     */
    getAssignmentDistribution(query: GetAssignmentDistributionRequest, cancelToken?: CancelToken): Promise<GetAssignmentDistributionResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/fordeling/queries/getassignmentdistribution`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderCitizenNotesClient {
    /**
     * @param command UpdateServiceProviderCitizenNotesRequest
     * @return UpdateServiceProviderCitizenNotesResponse
     */
    updateServiceProviderCitizenNotes(command: UpdateServiceProviderCitizenNotesRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetServiceProviderCitizenNotesRequest
     * @return GetServiceProviderCitizenNotesResponse
     */
    getServiceProviderCitizenNotes(query: GetServiceProviderCitizenNotesRequest, cancelToken?: CancelToken): Promise<GetServiceProviderCitizenNotesResponse>;
}

export class CitizenServiceProviderCitizenNotesClient implements ICitizenServiceProviderCitizenNotesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command UpdateServiceProviderCitizenNotesRequest
     * @return UpdateServiceProviderCitizenNotesResponse
     */
    updateServiceProviderCitizenNotes(command: UpdateServiceProviderCitizenNotesRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/citizennotes/commands/updateserviceprovidercitizennotes`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderCitizenNotesRequest
     * @return GetServiceProviderCitizenNotesResponse
     */
    getServiceProviderCitizenNotes(query: GetServiceProviderCitizenNotesRequest, cancelToken?: CancelToken): Promise<GetServiceProviderCitizenNotesResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/citizennotes/queries/getserviceprovidercitizennotes`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderCitizenDescriptionClient {
    /**
     * @param command SetServiceProviderCitizenDescriptionRequest
     * @return SetServiceProviderCitizenDescriptionResponse
     */
    setServiceProviderCitizenDescription(command: SetServiceProviderCitizenDescriptionRequest, cancelToken?: CancelToken): Promise<SetServiceProviderCitizenDescriptionResponse>;
    /**
     * @param query GetServiceProviderCitizenDescriptionRequest
     * @return GetServiceProviderCitizenDescriptionResponse
     */
    getServiceProviderCitizenDescription(query: GetServiceProviderCitizenDescriptionRequest, cancelToken?: CancelToken): Promise<GetServiceProviderCitizenDescriptionResponse>;
}

export class CitizenServiceProviderCitizenDescriptionClient implements ICitizenServiceProviderCitizenDescriptionClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command SetServiceProviderCitizenDescriptionRequest
     * @return SetServiceProviderCitizenDescriptionResponse
     */
    setServiceProviderCitizenDescription(command: SetServiceProviderCitizenDescriptionRequest, cancelToken?: CancelToken): Promise<SetServiceProviderCitizenDescriptionResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/citizendescription/commands/setserviceprovidercitizendescription`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderCitizenDescriptionRequest
     * @return GetServiceProviderCitizenDescriptionResponse
     */
    getServiceProviderCitizenDescription(query: GetServiceProviderCitizenDescriptionRequest, cancelToken?: CancelToken): Promise<GetServiceProviderCitizenDescriptionResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/citizendescription/queries/getserviceprovidercitizendescription`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderCalendarClient {
    /**
     * @param command CancelServiceProviderCalendarEventRequest
     * @return CancelServiceProviderCalendarEventResponse
     */
    cancelServiceProviderCalendarEvent(command: CancelServiceProviderCalendarEventRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CancelServiceProviderCalendarSeriesOccurrenceRequest
     * @return CancelServiceProviderCalendarSeriesOccurrenceResponse
     */
    cancelServiceProviderCalendarSeriesOccurrence(command: CancelServiceProviderCalendarSeriesOccurrenceRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateServiceProviderCalendarEventRequest
     * @return CreateServiceProviderCalendarEventResponse
     */
    createServiceProviderCalendarEvent(command: CreateServiceProviderCalendarEventRequest, cancelToken?: CancelToken): Promise<CreateServiceProviderCalendarEventResponse>;
    /**
     * @param command CreateServiceProviderFollowupFromEventRequest
     * @return CreateServiceProviderFollowupFromEventResponse
     */
    createServiceProviderFollowupFromEvent(command: CreateServiceProviderFollowupFromEventRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteServiceProviderCalendarEventRequest
     * @return DeleteServiceProviderCalendarEventResponse
     */
    deleteServiceProviderCalendarEvent(command: DeleteServiceProviderCalendarEventRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteServiceProviderCalendarSeriesOccurrenceRequest
     * @return DeleteServiceProviderCalendarSeriesOccurrenceResponse
     */
    deleteServiceProviderCalendarSeriesOccurrence(command: DeleteServiceProviderCalendarSeriesOccurrenceRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command MarkServiceProviderCalendarEventDoneRequest
     * @return MarkServiceProviderCalendarEventDoneResponse
     */
    markServiceProviderCalendarEventDone(command: MarkServiceProviderCalendarEventDoneRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command MarkServiceProviderCalendarSeriesOccurrenceDoneRequest
     * @return MarkServiceProviderCalendarSeriesOccurrenceDoneResponse
     */
    markServiceProviderCalendarSeriesOccurrenceDone(command: MarkServiceProviderCalendarSeriesOccurrenceDoneRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UnmarkServiceProviderCalendarEventRequest
     * @return UnmarkServiceProviderCalendarEventResponse
     */
    unmarkServiceProviderCalendarEvent(command: UnmarkServiceProviderCalendarEventRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateServiceProviderCalendarEventRequest
     * @return UpdateServiceProviderCalendarEventResponse
     */
    updateServiceProviderCalendarEvent(command: UpdateServiceProviderCalendarEventRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateServiceProviderCalendarSeriesOccurrenceRequest
     * @return UpdateServiceProviderCalendarSeriesOccurrenceResponse
     */
    updateServiceProviderCalendarSeriesOccurrence(command: UpdateServiceProviderCalendarSeriesOccurrenceRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetServiceProviderCitizenCalendarEventsRequest
     * @return GetServiceProviderCitizenCalendarEventsResponse
     */
    getServiceProviderCitizenCalendarEvents(query: GetServiceProviderCitizenCalendarEventsRequest, cancelToken?: CancelToken): Promise<GetServiceProviderCitizenCalendarEventsResponse>;
    /**
     * @param query Request
     * @return Response
     */
    getServiceProviderCitizenNexusCalendarEvents(query: Request, cancelToken?: CancelToken): Promise<Response>;
}

export class CitizenServiceProviderCalendarClient implements ICitizenServiceProviderCalendarClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CancelServiceProviderCalendarEventRequest
     * @return CancelServiceProviderCalendarEventResponse
     */
    cancelServiceProviderCalendarEvent(command: CancelServiceProviderCalendarEventRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/calendar/commands/cancelserviceprovidercalendarevent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CancelServiceProviderCalendarSeriesOccurrenceRequest
     * @return CancelServiceProviderCalendarSeriesOccurrenceResponse
     */
    cancelServiceProviderCalendarSeriesOccurrence(command: CancelServiceProviderCalendarSeriesOccurrenceRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/calendar/commands/cancelserviceprovidercalendarseriesoccurrence`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateServiceProviderCalendarEventRequest
     * @return CreateServiceProviderCalendarEventResponse
     */
    createServiceProviderCalendarEvent(command: CreateServiceProviderCalendarEventRequest, cancelToken?: CancelToken): Promise<CreateServiceProviderCalendarEventResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/calendar/commands/createserviceprovidercalendarevent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateServiceProviderFollowupFromEventRequest
     * @return CreateServiceProviderFollowupFromEventResponse
     */
    createServiceProviderFollowupFromEvent(command: CreateServiceProviderFollowupFromEventRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/calendar/commands/createserviceproviderfollowupfromevent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteServiceProviderCalendarEventRequest
     * @return DeleteServiceProviderCalendarEventResponse
     */
    deleteServiceProviderCalendarEvent(command: DeleteServiceProviderCalendarEventRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/calendar/commands/deleteserviceprovidercalendarevent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteServiceProviderCalendarSeriesOccurrenceRequest
     * @return DeleteServiceProviderCalendarSeriesOccurrenceResponse
     */
    deleteServiceProviderCalendarSeriesOccurrence(command: DeleteServiceProviderCalendarSeriesOccurrenceRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/calendar/commands/deleteserviceprovidercalendarseriesoccurrence`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command MarkServiceProviderCalendarEventDoneRequest
     * @return MarkServiceProviderCalendarEventDoneResponse
     */
    markServiceProviderCalendarEventDone(command: MarkServiceProviderCalendarEventDoneRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/calendar/commands/markserviceprovidercalendareventdone`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command MarkServiceProviderCalendarSeriesOccurrenceDoneRequest
     * @return MarkServiceProviderCalendarSeriesOccurrenceDoneResponse
     */
    markServiceProviderCalendarSeriesOccurrenceDone(command: MarkServiceProviderCalendarSeriesOccurrenceDoneRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/calendar/commands/markserviceprovidercalendarseriesoccurrencedone`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UnmarkServiceProviderCalendarEventRequest
     * @return UnmarkServiceProviderCalendarEventResponse
     */
    unmarkServiceProviderCalendarEvent(command: UnmarkServiceProviderCalendarEventRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/calendar/commands/unmarkserviceprovidercalendarevent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateServiceProviderCalendarEventRequest
     * @return UpdateServiceProviderCalendarEventResponse
     */
    updateServiceProviderCalendarEvent(command: UpdateServiceProviderCalendarEventRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/calendar/commands/updateserviceprovidercalendarevent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateServiceProviderCalendarSeriesOccurrenceRequest
     * @return UpdateServiceProviderCalendarSeriesOccurrenceResponse
     */
    updateServiceProviderCalendarSeriesOccurrence(command: UpdateServiceProviderCalendarSeriesOccurrenceRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/calendar/commands/updateserviceprovidercalendarseriesoccurrence`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderCitizenCalendarEventsRequest
     * @return GetServiceProviderCitizenCalendarEventsResponse
     */
    getServiceProviderCitizenCalendarEvents(query: GetServiceProviderCitizenCalendarEventsRequest, cancelToken?: CancelToken): Promise<GetServiceProviderCitizenCalendarEventsResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/calendar/queries/getserviceprovidercitizencalendarevents`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query Request
     * @return Response
     */
    getServiceProviderCitizenNexusCalendarEvents(query: Request, cancelToken?: CancelToken): Promise<Response> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/calendar/queries/getserviceprovidercitizennexuscalendarevents`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderAiDemoClient {
    /**
     * @param command AddPartialObjectiveFollowupFromStoryRequest
     * @return AddPartialObjectiveFollowupFromStoryResponse
     */
    addPartialObjectiveFollowupFromStory(command: AddPartialObjectiveFollowupFromStoryRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GenerateServiceProviderCitizenBriefRequest
     * @return GenerateServiceProviderCitizenBriefResponse
     */
    generateServiceProviderCitizenBrief(query: GenerateServiceProviderCitizenBriefRequest, cancelToken?: CancelToken): Promise<GenerateServiceProviderCitizenBriefResponse>;
    /**
     * @param query GetStoryRemindersRequest
     * @return GetStoryRemindersResponse
     */
    getStoryReminders(query: GetStoryRemindersRequest, cancelToken?: CancelToken): Promise<GetStoryRemindersResponse>;
    /**
     * @param query ProposeRegistrationsFromStoryRequest
     * @return ProposeRegistrationsFromStoryResponse
     */
    proposeRegistrationsFromStory(query: ProposeRegistrationsFromStoryRequest, cancelToken?: CancelToken): Promise<ProposeRegistrationsFromStoryResponse>;
    /**
     * @param query ScreenCitizenDiaryForUseOfForceRequest
     * @return ScreenCitizenDiaryForUseOfForceResponse
     */
    screenCitizenDiaryForUseOfForce(query: ScreenCitizenDiaryForUseOfForceRequest, cancelToken?: CancelToken): Promise<ScreenCitizenDiaryForUseOfForceResponse>;
}

export class CitizenServiceProviderAiDemoClient implements ICitizenServiceProviderAiDemoClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command AddPartialObjectiveFollowupFromStoryRequest
     * @return AddPartialObjectiveFollowupFromStoryResponse
     */
    addPartialObjectiveFollowupFromStory(command: AddPartialObjectiveFollowupFromStoryRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/aidemo/commands/addpartialobjectivefollowupfromstory`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GenerateServiceProviderCitizenBriefRequest
     * @return GenerateServiceProviderCitizenBriefResponse
     */
    generateServiceProviderCitizenBrief(query: GenerateServiceProviderCitizenBriefRequest, cancelToken?: CancelToken): Promise<GenerateServiceProviderCitizenBriefResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/aidemo/queries/generateserviceprovidercitizenbrief`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetStoryRemindersRequest
     * @return GetStoryRemindersResponse
     */
    getStoryReminders(query: GetStoryRemindersRequest, cancelToken?: CancelToken): Promise<GetStoryRemindersResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/aidemo/queries/getstoryreminders`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query ProposeRegistrationsFromStoryRequest
     * @return ProposeRegistrationsFromStoryResponse
     */
    proposeRegistrationsFromStory(query: ProposeRegistrationsFromStoryRequest, cancelToken?: CancelToken): Promise<ProposeRegistrationsFromStoryResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/aidemo/queries/proposeregistrationsfromstory`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query ScreenCitizenDiaryForUseOfForceRequest
     * @return ScreenCitizenDiaryForUseOfForceResponse
     */
    screenCitizenDiaryForUseOfForce(query: ScreenCitizenDiaryForUseOfForceRequest, cancelToken?: CancelToken): Promise<ScreenCitizenDiaryForUseOfForceResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/aidemo/queries/screencitizendiaryforuseofforce`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenRulingComplaintClient {
    /**
     * @param command RegisterAppealsBoardReplyRequest
     * @return RegisterAppealsBoardReplyResponse
     */
    registerAppealsBoardReply(command: RegisterAppealsBoardReplyRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command RegisterComplaintRequest
     * @return RegisterComplaintResponse
     */
    registerComplaint(command: RegisterComplaintRequest, cancelToken?: CancelToken): Promise<RegisterComplaintResponse>;
    /**
     * @param command RegisterForwardToAppealsBoardRequest
     * @return RegisterForwardToAppealsBoardResponse
     */
    registerForwardToAppealsBoard(command: RegisterForwardToAppealsBoardRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command RegisterReassessmentOutcomeRequest
     * @return RegisterReassessmentOutcomeResponse
     */
    registerReassessmentOutcome(command: RegisterReassessmentOutcomeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command RegisterWithdrawalRequest
     * @return RegisterWithdrawalResponse
     */
    registerWithdrawal(command: RegisterWithdrawalRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetAppealFormRequest
     * @return GetAppealFormResponse
     */
    getAppealForm(query: GetAppealFormRequest, cancelToken?: CancelToken): Promise<GetAppealFormResponse>;
}

export class CitizenRulingComplaintClient implements ICitizenRulingComplaintClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command RegisterAppealsBoardReplyRequest
     * @return RegisterAppealsBoardReplyResponse
     */
    registerAppealsBoardReply(command: RegisterAppealsBoardReplyRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/complaint/commands/registerappealsboardreply`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterComplaintRequest
     * @return RegisterComplaintResponse
     */
    registerComplaint(command: RegisterComplaintRequest, cancelToken?: CancelToken): Promise<RegisterComplaintResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/complaint/commands/registercomplaint`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterForwardToAppealsBoardRequest
     * @return RegisterForwardToAppealsBoardResponse
     */
    registerForwardToAppealsBoard(command: RegisterForwardToAppealsBoardRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/complaint/commands/registerforwardtoappealsboard`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterReassessmentOutcomeRequest
     * @return RegisterReassessmentOutcomeResponse
     */
    registerReassessmentOutcome(command: RegisterReassessmentOutcomeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/complaint/commands/registerreassessmentoutcome`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterWithdrawalRequest
     * @return RegisterWithdrawalResponse
     */
    registerWithdrawal(command: RegisterWithdrawalRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/complaint/commands/registerwithdrawal`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAppealFormRequest
     * @return GetAppealFormResponse
     */
    getAppealForm(query: GetAppealFormRequest, cancelToken?: CancelToken): Promise<GetAppealFormResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/complaint/queries/getappealform`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenRulingClient {
    /**
     * @param command CancelRulingContinuationRequest
     * @return CancelRulingContinuationResponse
     */
    cancelRulingContinuation(command: CancelRulingContinuationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CancelRulingVisitationBookingRequest
     * @return CancelRulingVisitationBookingResponse
     */
    cancelRulingVisitationBooking(command: CancelRulingVisitationBookingRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CompleteHearingRequest
     * @return CompleteHearingResponse
     */
    completeHearing(command: CompleteHearingRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CompleteRulingContinuationRequest
     * @return CompleteRulingContinuationResponse
     */
    completeRulingContinuation(command: CompleteRulingContinuationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateRecommendationRequest
     * @return CreateRecommendationResponse
     */
    createRecommendation(command: CreateRecommendationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateRulingContinuationRequest
     * @return CreateRulingContinuationResponse
     */
    createRulingContinuation(command: CreateRulingContinuationRequest, cancelToken?: CancelToken): Promise<CreateRulingContinuationResponse>;
    /**
     * @param command CreatingRulingRequest
     * @return CreatingRulingResponse
     */
    creatingRuling(command: CreatingRulingRequest, cancelToken?: CancelToken): Promise<CreatingRulingResponse>;
    /**
     * @param command DecideRulingRequest
     * @return DecideRulingResponse
     */
    decideRuling(command: DecideRulingRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command MoveRulingVisitationBookingRequest
     * @return MoveRulingVisitationBookingResponse
     */
    moveRulingVisitationBooking(command: MoveRulingVisitationBookingRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command RegisterContinuationVisitationAssessmentRequest
     * @return RegisterContinuationVisitationAssessmentResponse
     */
    registerContinuationVisitationAssessment(command: RegisterContinuationVisitationAssessmentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SetContinuationLetterSentRequest
     * @return SetContinuationLetterSentResponse
     */
    setContinuationLetterSent(command: SetContinuationLetterSentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SetRulingDecisionLetterSentRequest
     * @return SetRulingDecisionLetterSentResponse
     */
    setRulingDecisionLetterSent(command: SetRulingDecisionLetterSentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SetRulingHearingLetterSentRequest
     * @return SetRulingHearingLetterSentResponse
     */
    setRulingHearingLetterSent(command: SetRulingHearingLetterSentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SetRulingNotificationLetterSentRequest
     * @return SetRulingNotificationLetterSentResponse
     */
    setRulingNotificationLetterSent(command: SetRulingNotificationLetterSentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command StartHearingRequest
     * @return StartHearingResponse
     */
    startHearing(command: StartHearingRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SubmitContinuationToVisitationRequest
     * @return SubmitContinuationToVisitationResponse
     */
    submitContinuationToVisitation(command: SubmitContinuationToVisitationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command TerminateRulingRequest
     * @return TerminateRulingResponse
     */
    terminateRuling(command: TerminateRulingRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateRulingRequest
     * @return UpdateRulingResponse
     */
    updateRuling(command: UpdateRulingRequest, cancelToken?: CancelToken): Promise<UpdateRulingResponse>;
    /**
     * @param command UpdateRulingContinuationRequest
     * @return UpdateRulingContinuationResponse
     */
    updateRulingContinuation(command: UpdateRulingContinuationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ValidateRulingFunctionRequest
     * @return ValidateRulingFunctionResponse
     */
    validateRulingFunction(command: ValidateRulingFunctionRequest, cancelToken?: CancelToken): Promise<ValidateRulingFunctionResponse>;
    /**
     * @param query GetAssessmentDataForRecommendationRequest
     * @return GetAssessmentDataForRecommendationResponse
     */
    getAssessmentDataForRecommendation(query: GetAssessmentDataForRecommendationRequest, cancelToken?: CancelToken): Promise<GetAssessmentDataForRecommendationResponse>;
    /**
     * @param query GetAssessmentDataForRulingImportRequest
     * @return GetAssessmentDataForRulingImportResponse
     */
    getAssessmentDataForRulingImport(query: GetAssessmentDataForRulingImportRequest, cancelToken?: CancelToken): Promise<GetAssessmentDataForRulingImportResponse>;
    /**
     * @param query GetAssessmentsForRulingRequest
     * @return GetAssessmentsForRulingResponse
     */
    getAssessmentsForRuling(query: GetAssessmentsForRulingRequest, cancelToken?: CancelToken): Promise<GetAssessmentsForRulingResponse>;
    /**
     * @param query GetCasesForRulingRequest
     * @return GetCasesForRulingResponse
     */
    getCasesForRuling(query: GetCasesForRulingRequest, cancelToken?: CancelToken): Promise<GetCasesForRulingResponse>;
    /**
     * @param query GetCitizenPersonContactsForRulingRequest
     * @return GetCitizenPersonContactsForRulingResponse
     */
    getCitizenPersonContactsForRuling(query: GetCitizenPersonContactsForRulingRequest, cancelToken?: CancelToken): Promise<GetCitizenPersonContactsForRulingResponse>;
    /**
     * @param query GetConductedInterviewsForRulingContinuationRequest
     * @return GetConductedInterviewsForRulingContinuationResponse
     */
    getConductedInterviewsForRulingContinuation(query: GetConductedInterviewsForRulingContinuationRequest, cancelToken?: CancelToken): Promise<GetConductedInterviewsForRulingContinuationResponse>;
    /**
     * @param query GetDocumentsForRulingRequest
     * @return GetDocumentsForRulingResponse
     */
    getDocumentsForRuling(query: GetDocumentsForRulingRequest, cancelToken?: CancelToken): Promise<GetDocumentsForRulingResponse>;
    /**
     * @param query GetGrantsForRulingRequest
     * @return GetGrantsForRulingResponse
     */
    getGrantsForRuling(query: GetGrantsForRulingRequest, cancelToken?: CancelToken): Promise<GetGrantsForRulingResponse>;
    /**
     * @param query GetJournalNotesForRulingRequest
     * @return GetJournalNotesForRulingResponse
     */
    getJournalNotesForRuling(query: GetJournalNotesForRulingRequest, cancelToken?: CancelToken): Promise<GetJournalNotesForRulingResponse>;
    /**
     * @param query GetRulingRequest
     * @return GetRulingResponse
     */
    getRuling(query: GetRulingRequest, cancelToken?: CancelToken): Promise<GetRulingResponse>;
    /**
     * @param query GetRulingsForCaseRequest
     * @return GetRulingsForCaseResponse
     */
    getRulingsForCase(query: GetRulingsForCaseRequest, cancelToken?: CancelToken): Promise<GetRulingsForCaseResponse>;
    /**
     * @param query GetRulingVisitationBookingRequest
     * @return GetRulingVisitationBookingResponse
     */
    getRulingVisitationBooking(query: GetRulingVisitationBookingRequest, cancelToken?: CancelToken): Promise<GetRulingVisitationBookingResponse>;
    /**
     * @param query GetRulingVisitationBookingOptionsRequest
     * @return GetRulingVisitationBookingOptionsResponse
     */
    getRulingVisitationBookingOptions(query: GetRulingVisitationBookingOptionsRequest, cancelToken?: CancelToken): Promise<GetRulingVisitationBookingOptionsResponse>;
}

export class CitizenRulingClient implements ICitizenRulingClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CancelRulingContinuationRequest
     * @return CancelRulingContinuationResponse
     */
    cancelRulingContinuation(command: CancelRulingContinuationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/cancelrulingcontinuation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CancelRulingVisitationBookingRequest
     * @return CancelRulingVisitationBookingResponse
     */
    cancelRulingVisitationBooking(command: CancelRulingVisitationBookingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/cancelrulingvisitationbooking`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CompleteHearingRequest
     * @return CompleteHearingResponse
     */
    completeHearing(command: CompleteHearingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/completehearing`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CompleteRulingContinuationRequest
     * @return CompleteRulingContinuationResponse
     */
    completeRulingContinuation(command: CompleteRulingContinuationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/completerulingcontinuation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateRecommendationRequest
     * @return CreateRecommendationResponse
     */
    createRecommendation(command: CreateRecommendationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/createrecommendation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateRulingContinuationRequest
     * @return CreateRulingContinuationResponse
     */
    createRulingContinuation(command: CreateRulingContinuationRequest, cancelToken?: CancelToken): Promise<CreateRulingContinuationResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/createrulingcontinuation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreatingRulingRequest
     * @return CreatingRulingResponse
     */
    creatingRuling(command: CreatingRulingRequest, cancelToken?: CancelToken): Promise<CreatingRulingResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/creatingruling`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DecideRulingRequest
     * @return DecideRulingResponse
     */
    decideRuling(command: DecideRulingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/decideruling`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command MoveRulingVisitationBookingRequest
     * @return MoveRulingVisitationBookingResponse
     */
    moveRulingVisitationBooking(command: MoveRulingVisitationBookingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/moverulingvisitationbooking`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterContinuationVisitationAssessmentRequest
     * @return RegisterContinuationVisitationAssessmentResponse
     */
    registerContinuationVisitationAssessment(command: RegisterContinuationVisitationAssessmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/registercontinuationvisitationassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetContinuationLetterSentRequest
     * @return SetContinuationLetterSentResponse
     */
    setContinuationLetterSent(command: SetContinuationLetterSentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/setcontinuationlettersent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetRulingDecisionLetterSentRequest
     * @return SetRulingDecisionLetterSentResponse
     */
    setRulingDecisionLetterSent(command: SetRulingDecisionLetterSentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/setrulingdecisionlettersent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetRulingHearingLetterSentRequest
     * @return SetRulingHearingLetterSentResponse
     */
    setRulingHearingLetterSent(command: SetRulingHearingLetterSentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/setrulinghearinglettersent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetRulingNotificationLetterSentRequest
     * @return SetRulingNotificationLetterSentResponse
     */
    setRulingNotificationLetterSent(command: SetRulingNotificationLetterSentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/setrulingnotificationlettersent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command StartHearingRequest
     * @return StartHearingResponse
     */
    startHearing(command: StartHearingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/starthearing`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SubmitContinuationToVisitationRequest
     * @return SubmitContinuationToVisitationResponse
     */
    submitContinuationToVisitation(command: SubmitContinuationToVisitationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/submitcontinuationtovisitation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command TerminateRulingRequest
     * @return TerminateRulingResponse
     */
    terminateRuling(command: TerminateRulingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/terminateruling`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateRulingRequest
     * @return UpdateRulingResponse
     */
    updateRuling(command: UpdateRulingRequest, cancelToken?: CancelToken): Promise<UpdateRulingResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/updateruling`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateRulingContinuationRequest
     * @return UpdateRulingContinuationResponse
     */
    updateRulingContinuation(command: UpdateRulingContinuationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/updaterulingcontinuation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ValidateRulingFunctionRequest
     * @return ValidateRulingFunctionResponse
     */
    validateRulingFunction(command: ValidateRulingFunctionRequest, cancelToken?: CancelToken): Promise<ValidateRulingFunctionResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/commands/validaterulingfunction`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssessmentDataForRecommendationRequest
     * @return GetAssessmentDataForRecommendationResponse
     */
    getAssessmentDataForRecommendation(query: GetAssessmentDataForRecommendationRequest, cancelToken?: CancelToken): Promise<GetAssessmentDataForRecommendationResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/queries/getassessmentdataforrecommendation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssessmentDataForRulingImportRequest
     * @return GetAssessmentDataForRulingImportResponse
     */
    getAssessmentDataForRulingImport(query: GetAssessmentDataForRulingImportRequest, cancelToken?: CancelToken): Promise<GetAssessmentDataForRulingImportResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/queries/getassessmentdataforrulingimport`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssessmentsForRulingRequest
     * @return GetAssessmentsForRulingResponse
     */
    getAssessmentsForRuling(query: GetAssessmentsForRulingRequest, cancelToken?: CancelToken): Promise<GetAssessmentsForRulingResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/queries/getassessmentsforruling`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCasesForRulingRequest
     * @return GetCasesForRulingResponse
     */
    getCasesForRuling(query: GetCasesForRulingRequest, cancelToken?: CancelToken): Promise<GetCasesForRulingResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/queries/getcasesforruling`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenPersonContactsForRulingRequest
     * @return GetCitizenPersonContactsForRulingResponse
     */
    getCitizenPersonContactsForRuling(query: GetCitizenPersonContactsForRulingRequest, cancelToken?: CancelToken): Promise<GetCitizenPersonContactsForRulingResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/queries/getcitizenpersoncontactsforruling`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetConductedInterviewsForRulingContinuationRequest
     * @return GetConductedInterviewsForRulingContinuationResponse
     */
    getConductedInterviewsForRulingContinuation(query: GetConductedInterviewsForRulingContinuationRequest, cancelToken?: CancelToken): Promise<GetConductedInterviewsForRulingContinuationResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/queries/getconductedinterviewsforrulingcontinuation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDocumentsForRulingRequest
     * @return GetDocumentsForRulingResponse
     */
    getDocumentsForRuling(query: GetDocumentsForRulingRequest, cancelToken?: CancelToken): Promise<GetDocumentsForRulingResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/queries/getdocumentsforruling`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetGrantsForRulingRequest
     * @return GetGrantsForRulingResponse
     */
    getGrantsForRuling(query: GetGrantsForRulingRequest, cancelToken?: CancelToken): Promise<GetGrantsForRulingResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/queries/getgrantsforruling`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalNotesForRulingRequest
     * @return GetJournalNotesForRulingResponse
     */
    getJournalNotesForRuling(query: GetJournalNotesForRulingRequest, cancelToken?: CancelToken): Promise<GetJournalNotesForRulingResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/queries/getjournalnotesforruling`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetRulingRequest
     * @return GetRulingResponse
     */
    getRuling(query: GetRulingRequest, cancelToken?: CancelToken): Promise<GetRulingResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/queries/getruling`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetRulingsForCaseRequest
     * @return GetRulingsForCaseResponse
     */
    getRulingsForCase(query: GetRulingsForCaseRequest, cancelToken?: CancelToken): Promise<GetRulingsForCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/queries/getrulingsforcase`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetRulingVisitationBookingRequest
     * @return GetRulingVisitationBookingResponse
     */
    getRulingVisitationBooking(query: GetRulingVisitationBookingRequest, cancelToken?: CancelToken): Promise<GetRulingVisitationBookingResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/queries/getrulingvisitationbooking`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetRulingVisitationBookingOptionsRequest
     * @return GetRulingVisitationBookingOptionsResponse
     */
    getRulingVisitationBookingOptions(query: GetRulingVisitationBookingOptionsRequest, cancelToken?: CancelToken): Promise<GetRulingVisitationBookingOptionsResponse> {
        const $url = `${this.baseUrl}/api/citizen/ruling/queries/getrulingvisitationbookingoptions`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenPlanAndActivitiesClient {
    /**
     * @param command CreateJobSearchDefinitionRequest
     * @return CreateJobSearchDefinitionResponse
     */
    createJobSearchDefinition(command: CreateJobSearchDefinitionRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command PublishEducationImpositionRequest
     * @return PublishEducationImpositionResponse
     */
    publishEducationImposition(command: PublishEducationImpositionRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command TerminateContractRequest
     * @return TerminateContractResponse
     */
    terminateContract(command: TerminateContractRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command TransferLetAsylDataRequest
     * @return TransferLetAsylDataResponse
     */
    transferLetAsylData(command: TransferLetAsylDataRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query DownloadPlanPdfPreviewRequest
     * @return FileResponse
     */
    downloadPlanPdfPreview(query: DownloadPlanPdfPreviewRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetActivePlanRequest
     * @return GetActivePlanResponse
     */
    getActivePlan(query: GetActivePlanRequest, cancelToken?: CancelToken): Promise<GetActivePlanResponse>;
    /**
     * @param query GetAllowedPlanTypesRequest
     * @return GetAllowedPlanTypesResponse
     */
    getAllowedPlanTypes(query: GetAllowedPlanTypesRequest, cancelToken?: CancelToken): Promise<GetAllowedPlanTypesResponse>;
    /**
     * @param query GetCitizenIdByContractIdRequest
     * @return GetCitizenIdByContractIdResponse
     */
    getCitizenIdByContractId(query: GetCitizenIdByContractIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByContractIdResponse>;
    /**
     * @param query GetCitizenIdByPlanIdRequest
     * @return GetCitizenIdByPlanIdResponse
     */
    getCitizenIdByPlanId(query: GetCitizenIdByPlanIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByPlanIdResponse>;
    /**
     * @param query GetContactForCitizenRequest
     * @return GetContactForCitizenResponse
     */
    getContactForCitizen(query: GetContactForCitizenRequest, cancelToken?: CancelToken): Promise<GetContactForCitizenResponse>;
    /**
     * @param query GetContractRequest
     * @return GetContractResponse
     */
    getContract(query: GetContractRequest, cancelToken?: CancelToken): Promise<GetContractResponse>;
    /**
     * @return GetDanishGoalsResponse
     */
    getDanishGoals(cancelToken?: CancelToken): Promise<GetDanishGoalsResponse>;
    /**
     * @param query GetEditableContractRequest
     * @return GetEditableContractResponse
     */
    getEditableContract(query: GetEditableContractRequest, cancelToken?: CancelToken): Promise<GetEditableContractResponse>;
    /**
     * @param query GetEditablePlanRequest
     * @return GetEditablePlanResponse
     */
    getEditablePlan(query: GetEditablePlanRequest, cancelToken?: CancelToken): Promise<GetEditablePlanResponse>;
    /**
     * @param query GetEducationImpositionRequest
     * @return GetEducationImpositionResponse
     */
    getEducationImposition(query: GetEducationImpositionRequest, cancelToken?: CancelToken): Promise<GetEducationImpositionResponse>;
    /**
     * @return GetGeographicalAreasResponse
     */
    getGeographicalAreas(cancelToken?: CancelToken): Promise<GetGeographicalAreasResponse>;
    /**
     * @param query GetJobSearchDefinitionRequest
     * @return GetJobSearchDefinitionResponse
     */
    getJobSearchDefinition(query: GetJobSearchDefinitionRequest, cancelToken?: CancelToken): Promise<GetJobSearchDefinitionResponse>;
    /**
     * @return GetLanguagesResponse
     */
    getLanguages(cancelToken?: CancelToken): Promise<GetLanguagesResponse>;
    /**
     * @param query GetLetAsylPdfDataRequest
     * @return FileResponse
     */
    getLetAsylPdfData(query: GetLetAsylPdfDataRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return GetMunicipalitiesResponse
     */
    getMunicipalities(cancelToken?: CancelToken): Promise<GetMunicipalitiesResponse2>;
    /**
     * @return GetOccupationsResponse
     */
    getOccupations(cancelToken?: CancelToken): Promise<GetOccupationsResponse2>;
    /**
     * @param query GetPlanInfoRequest
     * @return GetPlanInfoResponse
     */
    getPlanInfo(query: GetPlanInfoRequest, cancelToken?: CancelToken): Promise<GetPlanInfoResponse>;
    /**
     * @param query GetPlanVersionPdfRequest
     * @return FileResponse
     */
    getPlanVersionPdf(query: GetPlanVersionPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetPlanVersionsRequest
     * @return GetPlanVersionsResponse
     */
    getPlanVersions(query: GetPlanVersionsRequest, cancelToken?: CancelToken): Promise<GetPlanVersionsResponse>;
    /**
     * @param query GetSelectableGoalsRequest
     * @return GetSelectableGoalsResponse
     */
    getSelectableGoals(query: GetSelectableGoalsRequest, cancelToken?: CancelToken): Promise<GetSelectableGoalsResponse>;
    /**
     * @param query HasLegalContractRequest
     * @return HasLegalContractResponse
     */
    hasLegalContract(query: HasLegalContractRequest, cancelToken?: CancelToken): Promise<HasLegalContractResponse>;
    /**
     * @param query MayEditPlanRequest
     * @return MayEditPlanResponse
     */
    mayEditPlan(query: MayEditPlanRequest, cancelToken?: CancelToken): Promise<MayEditPlanResponse>;
    /**
     * @param query MayRegisterJobSearchDefinitionRequest
     * @return MayRegisterJobSearchDefinitionResponse
     */
    mayRegisterJobSearchDefinition(query: MayRegisterJobSearchDefinitionRequest, cancelToken?: CancelToken): Promise<MayRegisterJobSearchDefinitionResponse>;
    /**
     * @param query ChangePlanTypeRequest
     * @return ChangePlanTypeResponse
     */
    changePlanType(query: ChangePlanTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query PrintMyPlanRequest
     * @return FileResponse
     */
    printMyPlan(query: PrintMyPlanRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query PublishContractRequest
     * @return PublishContractResponse
     */
    publishContract(query: PublishContractRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query PublishPlanRequest
     * @return PublishPlanResponse
     */
    publishPlan(query: PublishPlanRequest, cancelToken?: CancelToken): Promise<PublishPlanResponse>;
    /**
     * @param query ReactivatePlanRequest
     * @return ReactivatePlanResponse
     */
    reactivatePlan(query: ReactivatePlanRequest, cancelToken?: CancelToken): Promise<ReactivatePlanResponse>;
    /**
     * @param query SaveContractDraftRequest
     * @return SaveContractDraftResponse
     */
    saveContractDraft(query: SaveContractDraftRequest, cancelToken?: CancelToken): Promise<SaveContractDraftResponse>;
    /**
     * @param query SaveDraftEducationPlanRequest
     * @return SaveDraftEducationPlanResponse
     */
    saveDraftEducationPlan(query: SaveDraftEducationPlanRequest, cancelToken?: CancelToken): Promise<SaveDraftEducationPlanResponse>;
    /**
     * @param query SavePlanDraftRequest
     * @return SavePlanDraftResponse
     */
    savePlanDraft(query: SavePlanDraftRequest, cancelToken?: CancelToken): Promise<SavePlanDraftResponse>;
    /**
     * @param query SendMyPlanAsLetterRequest
     * @return SendMyPlanAsLetterResponse
     */
    sendMyPlanAsLetter(query: SendMyPlanAsLetterRequest, cancelToken?: CancelToken): Promise<SendMyPlanAsLetterResponse>;
}

export class CitizenPlanAndActivitiesClient implements ICitizenPlanAndActivitiesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateJobSearchDefinitionRequest
     * @return CreateJobSearchDefinitionResponse
     */
    createJobSearchDefinition(command: CreateJobSearchDefinitionRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/commands/createjobsearchdefinition`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command PublishEducationImpositionRequest
     * @return PublishEducationImpositionResponse
     */
    publishEducationImposition(command: PublishEducationImpositionRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/commands/publisheducationimposition`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command TerminateContractRequest
     * @return TerminateContractResponse
     */
    terminateContract(command: TerminateContractRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/commands/terminatecontract`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command TransferLetAsylDataRequest
     * @return TransferLetAsylDataResponse
     */
    transferLetAsylData(command: TransferLetAsylDataRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/commands/transferletasyldata`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DownloadPlanPdfPreviewRequest
     * @return FileResponse
     */
    downloadPlanPdfPreview(query: DownloadPlanPdfPreviewRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/downloadplanpdfpreview`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActivePlanRequest
     * @return GetActivePlanResponse
     */
    getActivePlan(query: GetActivePlanRequest, cancelToken?: CancelToken): Promise<GetActivePlanResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getactiveplan`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAllowedPlanTypesRequest
     * @return GetAllowedPlanTypesResponse
     */
    getAllowedPlanTypes(query: GetAllowedPlanTypesRequest, cancelToken?: CancelToken): Promise<GetAllowedPlanTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getallowedplantypes`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenIdByContractIdRequest
     * @return GetCitizenIdByContractIdResponse
     */
    getCitizenIdByContractId(query: GetCitizenIdByContractIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByContractIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getcitizenidbycontractid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenIdByPlanIdRequest
     * @return GetCitizenIdByPlanIdResponse
     */
    getCitizenIdByPlanId(query: GetCitizenIdByPlanIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByPlanIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getcitizenidbyplanid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetContactForCitizenRequest
     * @return GetContactForCitizenResponse
     */
    getContactForCitizen(query: GetContactForCitizenRequest, cancelToken?: CancelToken): Promise<GetContactForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getcontactforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetContractRequest
     * @return GetContractResponse
     */
    getContract(query: GetContractRequest, cancelToken?: CancelToken): Promise<GetContractResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getcontract`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetDanishGoalsResponse
     */
    getDanishGoals(cancelToken?: CancelToken): Promise<GetDanishGoalsResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getdanishgoals`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEditableContractRequest
     * @return GetEditableContractResponse
     */
    getEditableContract(query: GetEditableContractRequest, cancelToken?: CancelToken): Promise<GetEditableContractResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/geteditablecontract`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEditablePlanRequest
     * @return GetEditablePlanResponse
     */
    getEditablePlan(query: GetEditablePlanRequest, cancelToken?: CancelToken): Promise<GetEditablePlanResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/geteditableplan`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEducationImpositionRequest
     * @return GetEducationImpositionResponse
     */
    getEducationImposition(query: GetEducationImpositionRequest, cancelToken?: CancelToken): Promise<GetEducationImpositionResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/geteducationimposition`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetGeographicalAreasResponse
     */
    getGeographicalAreas(cancelToken?: CancelToken): Promise<GetGeographicalAreasResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getgeographicalareas`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJobSearchDefinitionRequest
     * @return GetJobSearchDefinitionResponse
     */
    getJobSearchDefinition(query: GetJobSearchDefinitionRequest, cancelToken?: CancelToken): Promise<GetJobSearchDefinitionResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getjobsearchdefinition`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetLanguagesResponse
     */
    getLanguages(cancelToken?: CancelToken): Promise<GetLanguagesResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getlanguages`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLetAsylPdfDataRequest
     * @return FileResponse
     */
    getLetAsylPdfData(query: GetLetAsylPdfDataRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getletasylpdfdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @return GetMunicipalitiesResponse
     */
    getMunicipalities(cancelToken?: CancelToken): Promise<GetMunicipalitiesResponse2> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getmunicipalities`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOccupationsResponse
     */
    getOccupations(cancelToken?: CancelToken): Promise<GetOccupationsResponse2> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getoccupations`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPlanInfoRequest
     * @return GetPlanInfoResponse
     */
    getPlanInfo(query: GetPlanInfoRequest, cancelToken?: CancelToken): Promise<GetPlanInfoResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getplaninfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPlanVersionPdfRequest
     * @return FileResponse
     */
    getPlanVersionPdf(query: GetPlanVersionPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getplanversionpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPlanVersionsRequest
     * @return GetPlanVersionsResponse
     */
    getPlanVersions(query: GetPlanVersionsRequest, cancelToken?: CancelToken): Promise<GetPlanVersionsResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getplanversions`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSelectableGoalsRequest
     * @return GetSelectableGoalsResponse
     */
    getSelectableGoals(query: GetSelectableGoalsRequest, cancelToken?: CancelToken): Promise<GetSelectableGoalsResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/getselectablegoals`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query HasLegalContractRequest
     * @return HasLegalContractResponse
     */
    hasLegalContract(query: HasLegalContractRequest, cancelToken?: CancelToken): Promise<HasLegalContractResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/haslegalcontract`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query MayEditPlanRequest
     * @return MayEditPlanResponse
     */
    mayEditPlan(query: MayEditPlanRequest, cancelToken?: CancelToken): Promise<MayEditPlanResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/mayeditplan`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query MayRegisterJobSearchDefinitionRequest
     * @return MayRegisterJobSearchDefinitionResponse
     */
    mayRegisterJobSearchDefinition(query: MayRegisterJobSearchDefinitionRequest, cancelToken?: CancelToken): Promise<MayRegisterJobSearchDefinitionResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/mayregisterjobsearchdefinition`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query ChangePlanTypeRequest
     * @return ChangePlanTypeResponse
     */
    changePlanType(query: ChangePlanTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/changeplantype`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query PrintMyPlanRequest
     * @return FileResponse
     */
    printMyPlan(query: PrintMyPlanRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/printmyplan`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query PublishContractRequest
     * @return PublishContractResponse
     */
    publishContract(query: PublishContractRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/publishcontract`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query PublishPlanRequest
     * @return PublishPlanResponse
     */
    publishPlan(query: PublishPlanRequest, cancelToken?: CancelToken): Promise<PublishPlanResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/publishplan`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query ReactivatePlanRequest
     * @return ReactivatePlanResponse
     */
    reactivatePlan(query: ReactivatePlanRequest, cancelToken?: CancelToken): Promise<ReactivatePlanResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/reactivateplan`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query SaveContractDraftRequest
     * @return SaveContractDraftResponse
     */
    saveContractDraft(query: SaveContractDraftRequest, cancelToken?: CancelToken): Promise<SaveContractDraftResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/savecontractdraft`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query SaveDraftEducationPlanRequest
     * @return SaveDraftEducationPlanResponse
     */
    saveDraftEducationPlan(query: SaveDraftEducationPlanRequest, cancelToken?: CancelToken): Promise<SaveDraftEducationPlanResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/savedrafteducationplan`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query SavePlanDraftRequest
     * @return SavePlanDraftResponse
     */
    savePlanDraft(query: SavePlanDraftRequest, cancelToken?: CancelToken): Promise<SavePlanDraftResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/saveplandraft`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query SendMyPlanAsLetterRequest
     * @return SendMyPlanAsLetterResponse
     */
    sendMyPlanAsLetter(query: SendMyPlanAsLetterRequest, cancelToken?: CancelToken): Promise<SendMyPlanAsLetterResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/queries/sendmyplanasletter`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenMedicalCollaborationClient {
    /**
     * @param command CancelMedicalRequestRequest
     * @return CancelMedicalRequestResponse
     */
    cancelMedicalRequest(command: CancelMedicalRequestRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CancelMedicalRequestForMedicalCollaboratorRequest
     * @return CancelMedicalRequestForMedicalCollaboratorResponse
     */
    cancelMedicalRequestForMedicalCollaborator(command: CancelMedicalRequestForMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ChangeMedicalRequestStatusRequest
     * @return ChangeMedicalRequestStatusResponse
     */
    changeMedicalRequestStatus(command: ChangeMedicalRequestStatusRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ChangeMedicalRequestStatusForMedicalCollaboratorRequest
     * @return ChangeMedicalRequestStatusForMedicalCollaboratorResponse
     */
    changeMedicalRequestStatusForMedicalCollaborator(command: ChangeMedicalRequestStatusForMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateCorrespondenceMessageRequest
     * @return CreateCorrespondenceMessageResponse
     */
    createCorrespondenceMessage(command: CreateCorrespondenceMessageRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateCorrespondenceMessageForServiceProviderRequest
     * @return CreateCorrespondenceMessageForServiceProviderResponse
     */
    createCorrespondenceMessageForServiceProvider(command: CreateCorrespondenceMessageForServiceProviderRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateMedicalCollaborationCitizenRequest
     * @return CreateMedicalCollaborationCitizenResponse
     */
    createMedicalCollaborationCitizen(command: CreateMedicalCollaborationCitizenRequest, cancelToken?: CancelToken): Promise<CreateMedicalCollaborationCitizenResponse>;
    /**
     * @param command CreateMedicalRequestRequest
     * @return CreateMedicalRequestResponse
     */
    createMedicalRequest(command: CreateMedicalRequestRequest, cancelToken?: CancelToken): Promise<CreateMedicalRequestResponse>;
    /**
     * @param command CreateMedicalRequestForMedicalCollaboratorRequest
     * @return CreateMedicalRequestForMedicalCollaboratorResponse
     */
    createMedicalRequestForMedicalCollaborator(command: CreateMedicalRequestForMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<CreateMedicalRequestForMedicalCollaboratorResponse>;
    /**
     * @param command GenerateMedicalRequestAttachmentPdfRequest
     * @return GenerateMedicalRequestAttachmentPdfResponse
     */
    generateMedicalRequestAttachmentPdf(command: GenerateMedicalRequestAttachmentPdfRequest, cancelToken?: CancelToken): Promise<GenerateMedicalRequestAttachmentPdfResponse>;
    /**
     * @param command SetCitizenLetterShippedRequest
     * @return SetCitizenLetterShippedResponse
     */
    setCitizenLetterShipped(command: SetCitizenLetterShippedRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SimulateRejectRequest
     * @return SimulateRejectResponse
     */
    simulateReject(command: SimulateRejectRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SimulateResponseRequest
     * @return SimulateResponseResponse
     */
    simulateResponse(command: SimulateResponseRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCorrespondenceOptionsRequest
     * @return UpdateCorrespondenceOptionsResponse
     */
    updateCorrespondenceOptions(command: UpdateCorrespondenceOptionsRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateMedicalOptionsRequest
     * @return UpdateMedicalOptionsResponse
     */
    updateMedicalOptions(command: UpdateMedicalOptionsRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query DownloadCorrespondenceDocumentRequest
     * @return DownloadCorrespondenceDocumentResponse
     */
    downloadCorrespondenceDocument(query: DownloadCorrespondenceDocumentRequest, cancelToken?: CancelToken): Promise<DownloadCorrespondenceDocumentResponse>;
    /**
     * @param query DownloadCorrespondenceDocumentForServiceProviderRequest
     * @return DownloadCorrespondenceDocumentForServiceProviderResponse
     */
    downloadCorrespondenceDocumentForServiceProvider(query: DownloadCorrespondenceDocumentForServiceProviderRequest, cancelToken?: CancelToken): Promise<DownloadCorrespondenceDocumentForServiceProviderResponse>;
    /**
     * @param query DownloadMedicalDocumentRequest
     * @return DownloadMedicalDocumentResponse
     */
    downloadMedicalDocument(query: DownloadMedicalDocumentRequest, cancelToken?: CancelToken): Promise<DownloadMedicalDocumentResponse>;
    /**
     * @param query DownloadMedicalDocumentForMedicalCollaboratorRequest
     * @return DownloadMedicalDocumentForMedicalCollaboratorResponse
     */
    downloadMedicalDocumentForMedicalCollaborator(query: DownloadMedicalDocumentForMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<DownloadMedicalDocumentForMedicalCollaboratorResponse>;
    /**
     * @return GetAllowedCorrespondenceAttachmentExtensionsResponse
     */
    getAllowedCorrespondenceAttachmentExtensions(cancelToken?: CancelToken): Promise<GetAllowedCorrespondenceAttachmentExtensionsResponse>;
    /**
     * @param query GetCaseTargetGroupTypeRequest
     * @return GetCaseTargetGroupTypeResponse
     */
    getCaseTargetGroupType(query: GetCaseTargetGroupTypeRequest, cancelToken?: CancelToken): Promise<GetCaseTargetGroupTypeResponse>;
    /**
     * @param query GetCitizenCasesMedicalRequest
     * @return GetCitizenCasesMedicalResponse
     */
    getCitizenCasesMedical(query: GetCitizenCasesMedicalRequest, cancelToken?: CancelToken): Promise<GetCitizenCasesMedicalResponse>;
    /**
     * @param query GetCitizenContactInfoRequest
     * @return GetCitizenContactInfoResponse
     */
    getCitizenContactInfo(query: GetCitizenContactInfoRequest, cancelToken?: CancelToken): Promise<GetCitizenContactInfoResponse>;
    /**
     * @param query GetCitizenDoctorAsCorrespondenceReceiverRequest
     * @return GetCitizenDoctorAsCorrespondenceReceiverResponse
     */
    getCitizenDoctorAsCorrespondenceReceiver(query: GetCitizenDoctorAsCorrespondenceReceiverRequest, cancelToken?: CancelToken): Promise<GetCitizenDoctorAsCorrespondenceReceiverResponse>;
    /**
     * @param query GetCitizenDoctorInfoRequest
     * @return GetCitizenDoctorInfoResponse
     */
    getCitizenDoctorInfo(query: GetCitizenDoctorInfoRequest, cancelToken?: CancelToken): Promise<GetCitizenDoctorInfoResponse>;
    /**
     * @param query GetCitizenFormCodeRequest
     * @return GetCitizenFormCodeResponse
     */
    getCitizenFormCode(query: GetCitizenFormCodeRequest, cancelToken?: CancelToken): Promise<GetCitizenFormCodeResponse>;
    /**
     * @param query GetCitizenForMedicalCollaborationRequest
     * @return GetCitizenForMedicalCollaborationResponse
     */
    getCitizenForMedicalCollaboration(query: GetCitizenForMedicalCollaborationRequest, cancelToken?: CancelToken): Promise<GetCitizenForMedicalCollaborationResponse>;
    /**
     * @param query GetCitizenHospitalStaysRequest
     * @return GetCitizenHospitalStaysResponse
     */
    getCitizenHospitalStays(query: GetCitizenHospitalStaysRequest, cancelToken?: CancelToken): Promise<GetCitizenHospitalStaysResponse>;
    /**
     * @param query GetCitizenIdByCorrespondenceMessageIdRequest
     * @return GetCitizenIdByCorrespondenceMessageIdResponse
     */
    getCitizenIdByCorrespondenceMessageId(query: GetCitizenIdByCorrespondenceMessageIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByCorrespondenceMessageIdResponse>;
    /**
     * @param query GetCitizenIdByRequestFormIdRequest
     * @return GetCitizenIdByRequestFormIdResponse
     */
    getCitizenIdByRequestFormId(query: GetCitizenIdByRequestFormIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByRequestFormIdResponse>;
    /**
     * @param query GetCitizenLetterJournalNoteRequest
     * @return GetCitizenLetterJournalNoteResponse
     */
    getCitizenLetterJournalNote(query: GetCitizenLetterJournalNoteRequest, cancelToken?: CancelToken): Promise<GetCitizenLetterJournalNoteResponse>;
    /**
     * @param query GetCitizenPatientInfoRequest
     * @return GetCitizenPatientInfoResponse
     */
    getCitizenPatientInfo(query: GetCitizenPatientInfoRequest, cancelToken?: CancelToken): Promise<GetCitizenPatientInfoResponse>;
    /**
     * @param query GetContactShortNameRequest
     * @return GetContactShortNameResponse
     */
    getContactShortName(query: GetContactShortNameRequest, cancelToken?: CancelToken): Promise<GetContactShortNameResponse>;
    /**
     * @param query GetCorrespondenceMessageRequest
     * @return GetCorrespondenceMessageResponse
     */
    getCorrespondenceMessage(query: GetCorrespondenceMessageRequest, cancelToken?: CancelToken): Promise<GetCorrespondenceMessageResponse>;
    /**
     * @param query GetCorrespondenceMessageForServiceProviderRequest
     * @return GetCorrespondenceMessageForServiceProviderResponse
     */
    getCorrespondenceMessageForServiceProvider(query: GetCorrespondenceMessageForServiceProviderRequest, cancelToken?: CancelToken): Promise<GetCorrespondenceMessageForServiceProviderResponse>;
    /**
     * @param query GetCorrespondenceMessagesRequest
     * @return GetCorrespondenceMessagesResponse
     */
    getCorrespondenceMessages(query: GetCorrespondenceMessagesRequest, cancelToken?: CancelToken): Promise<GetCorrespondenceMessagesResponse>;
    /**
     * @param query GetCorrespondenceMessagesForServiceProviderRequest
     * @return GetCorrespondenceMessagesForServiceProviderResponse
     */
    getCorrespondenceMessagesForServiceProvider(query: GetCorrespondenceMessagesForServiceProviderRequest, cancelToken?: CancelToken): Promise<GetCorrespondenceMessagesForServiceProviderResponse>;
    /**
     * @param query GetCorrespondenceMessageSignatureRequest
     * @return GetCorrespondenceMessageSignatureResponse
     */
    getCorrespondenceMessageSignature(query: GetCorrespondenceMessageSignatureRequest, cancelToken?: CancelToken): Promise<GetCorrespondenceMessageSignatureResponse>;
    /**
     * @param query GetDoctorResponseDeadlineEnabledRequest
     * @return GetDoctorResponseDeadlineEnabledResponse
     */
    getDoctorResponseDeadlineEnabled(query: GetDoctorResponseDeadlineEnabledRequest, cancelToken?: CancelToken): Promise<GetDoctorResponseDeadlineEnabledResponse>;
    /**
     * @param query GetMedicalCollaboratorMedicalRequestsRequest
     * @return GetMedicalCollaboratorMedicalRequestsResponse
     */
    getMedicalCollaboratorMedicalRequests(query: GetMedicalCollaboratorMedicalRequestsRequest, cancelToken?: CancelToken): Promise<GetMedicalCollaboratorMedicalRequestsResponse>;
    /**
     * @param query GetMedicalRequestRequest
     * @return GetMedicalRequestResponse
     */
    getMedicalRequest(query: GetMedicalRequestRequest, cancelToken?: CancelToken): Promise<GetMedicalRequestResponse>;
    /**
     * @param query GetMedicalRequestForMedicalCollaboratorRequest
     * @return GetMedicalRequestForMedicalCollaboratorResponse
     */
    getMedicalRequestForMedicalCollaborator(query: GetMedicalRequestForMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<GetMedicalRequestForMedicalCollaboratorResponse>;
    /**
     * @param query GetMedicalRequestsRequest
     * @return GetMedicalRequestsResponse
     */
    getMedicalRequests(query: GetMedicalRequestsRequest, cancelToken?: CancelToken): Promise<GetMedicalRequestsResponse>;
    /**
     * @return GetMedicalRequestTypesResponse
     */
    getMedicalRequestTypes(cancelToken?: CancelToken): Promise<GetMedicalRequestTypesResponse>;
    /**
     * @param query GetRequestFormCodeByRequestFormIdRequest
     * @return GetRequestFormCodeByRequestFormIdResponse
     */
    getRequestFormCodeByRequestFormId(query: GetRequestFormCodeByRequestFormIdRequest, cancelToken?: CancelToken): Promise<GetRequestFormCodeByRequestFormIdResponse>;
    /**
     * @param query GetSorNodesQueryRequest
     * @return GetSorNodesQueryResponse
     */
    getSorNodes(query: GetSorNodesQueryRequest, cancelToken?: CancelToken): Promise<GetSorNodesQueryResponse>;
    /**
     * @param query GetSorSearchResultByLookupQueryRequest
     * @return GetSorSearchResultByLookupQueryResponse
     */
    getSorSearchResultByLookupQuery(query: GetSorSearchResultByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetSorSearchResultByLookupQueryResponse>;
    /**
     * @param query GetSorTreeSearchResultByLookupQueryRequest
     * @return GetSorTreeSearchResultByLookupQueryResponse
     */
    getSorTreeSearchResultByLookupQuery(query: GetSorTreeSearchResultByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetSorTreeSearchResultByLookupQueryResponse>;
    /**
     * @param query ValidateCorrespondenceAttachmentsRequest
     * @return ValidateCorrespondenceAttachmentsResponse
     */
    validateCorrespondenceAttachments(query: ValidateCorrespondenceAttachmentsRequest, cancelToken?: CancelToken): Promise<ValidateCorrespondenceAttachmentsResponse>;
}

export class CitizenMedicalCollaborationClient implements ICitizenMedicalCollaborationClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CancelMedicalRequestRequest
     * @return CancelMedicalRequestResponse
     */
    cancelMedicalRequest(command: CancelMedicalRequestRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/cancelmedicalrequest`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CancelMedicalRequestForMedicalCollaboratorRequest
     * @return CancelMedicalRequestForMedicalCollaboratorResponse
     */
    cancelMedicalRequestForMedicalCollaborator(command: CancelMedicalRequestForMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/cancelmedicalrequestformedicalcollaborator`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ChangeMedicalRequestStatusRequest
     * @return ChangeMedicalRequestStatusResponse
     */
    changeMedicalRequestStatus(command: ChangeMedicalRequestStatusRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/changemedicalrequeststatus`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ChangeMedicalRequestStatusForMedicalCollaboratorRequest
     * @return ChangeMedicalRequestStatusForMedicalCollaboratorResponse
     */
    changeMedicalRequestStatusForMedicalCollaborator(command: ChangeMedicalRequestStatusForMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/changemedicalrequeststatusformedicalcollaborator`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCorrespondenceMessageRequest
     * @return CreateCorrespondenceMessageResponse
     */
    createCorrespondenceMessage(command: CreateCorrespondenceMessageRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/createcorrespondencemessage`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCorrespondenceMessageForServiceProviderRequest
     * @return CreateCorrespondenceMessageForServiceProviderResponse
     */
    createCorrespondenceMessageForServiceProvider(command: CreateCorrespondenceMessageForServiceProviderRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/createcorrespondencemessageforserviceprovider`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateMedicalCollaborationCitizenRequest
     * @return CreateMedicalCollaborationCitizenResponse
     */
    createMedicalCollaborationCitizen(command: CreateMedicalCollaborationCitizenRequest, cancelToken?: CancelToken): Promise<CreateMedicalCollaborationCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/createmedicalcollaborationcitizen`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateMedicalRequestRequest
     * @return CreateMedicalRequestResponse
     */
    createMedicalRequest(command: CreateMedicalRequestRequest, cancelToken?: CancelToken): Promise<CreateMedicalRequestResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/createmedicalrequest`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateMedicalRequestForMedicalCollaboratorRequest
     * @return CreateMedicalRequestForMedicalCollaboratorResponse
     */
    createMedicalRequestForMedicalCollaborator(command: CreateMedicalRequestForMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<CreateMedicalRequestForMedicalCollaboratorResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/createmedicalrequestformedicalcollaborator`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command GenerateMedicalRequestAttachmentPdfRequest
     * @return GenerateMedicalRequestAttachmentPdfResponse
     */
    generateMedicalRequestAttachmentPdf(command: GenerateMedicalRequestAttachmentPdfRequest, cancelToken?: CancelToken): Promise<GenerateMedicalRequestAttachmentPdfResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/generatemedicalrequestattachmentpdf`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetCitizenLetterShippedRequest
     * @return SetCitizenLetterShippedResponse
     */
    setCitizenLetterShipped(command: SetCitizenLetterShippedRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/setcitizenlettershipped`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SimulateRejectRequest
     * @return SimulateRejectResponse
     */
    simulateReject(command: SimulateRejectRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/simulatereject`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SimulateResponseRequest
     * @return SimulateResponseResponse
     */
    simulateResponse(command: SimulateResponseRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/simulateresponse`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCorrespondenceOptionsRequest
     * @return UpdateCorrespondenceOptionsResponse
     */
    updateCorrespondenceOptions(command: UpdateCorrespondenceOptionsRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/updatecorrespondenceoptions`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateMedicalOptionsRequest
     * @return UpdateMedicalOptionsResponse
     */
    updateMedicalOptions(command: UpdateMedicalOptionsRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/commands/updatemedicaloptions`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DownloadCorrespondenceDocumentRequest
     * @return DownloadCorrespondenceDocumentResponse
     */
    downloadCorrespondenceDocument(query: DownloadCorrespondenceDocumentRequest, cancelToken?: CancelToken): Promise<DownloadCorrespondenceDocumentResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/downloadcorrespondencedocument`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DownloadCorrespondenceDocumentForServiceProviderRequest
     * @return DownloadCorrespondenceDocumentForServiceProviderResponse
     */
    downloadCorrespondenceDocumentForServiceProvider(query: DownloadCorrespondenceDocumentForServiceProviderRequest, cancelToken?: CancelToken): Promise<DownloadCorrespondenceDocumentForServiceProviderResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/downloadcorrespondencedocumentforserviceprovider`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DownloadMedicalDocumentRequest
     * @return DownloadMedicalDocumentResponse
     */
    downloadMedicalDocument(query: DownloadMedicalDocumentRequest, cancelToken?: CancelToken): Promise<DownloadMedicalDocumentResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/downloadmedicaldocument`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DownloadMedicalDocumentForMedicalCollaboratorRequest
     * @return DownloadMedicalDocumentForMedicalCollaboratorResponse
     */
    downloadMedicalDocumentForMedicalCollaborator(query: DownloadMedicalDocumentForMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<DownloadMedicalDocumentForMedicalCollaboratorResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/downloadmedicaldocumentformedicalcollaborator`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAllowedCorrespondenceAttachmentExtensionsResponse
     */
    getAllowedCorrespondenceAttachmentExtensions(cancelToken?: CancelToken): Promise<GetAllowedCorrespondenceAttachmentExtensionsResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getallowedcorrespondenceattachmentextensions`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseTargetGroupTypeRequest
     * @return GetCaseTargetGroupTypeResponse
     */
    getCaseTargetGroupType(query: GetCaseTargetGroupTypeRequest, cancelToken?: CancelToken): Promise<GetCaseTargetGroupTypeResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcasetargetgrouptype`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenCasesMedicalRequest
     * @return GetCitizenCasesMedicalResponse
     */
    getCitizenCasesMedical(query: GetCitizenCasesMedicalRequest, cancelToken?: CancelToken): Promise<GetCitizenCasesMedicalResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcitizencasesmedical`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenContactInfoRequest
     * @return GetCitizenContactInfoResponse
     */
    getCitizenContactInfo(query: GetCitizenContactInfoRequest, cancelToken?: CancelToken): Promise<GetCitizenContactInfoResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcitizencontactinfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenDoctorAsCorrespondenceReceiverRequest
     * @return GetCitizenDoctorAsCorrespondenceReceiverResponse
     */
    getCitizenDoctorAsCorrespondenceReceiver(query: GetCitizenDoctorAsCorrespondenceReceiverRequest, cancelToken?: CancelToken): Promise<GetCitizenDoctorAsCorrespondenceReceiverResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcitizendoctorascorrespondencereceiver`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenDoctorInfoRequest
     * @return GetCitizenDoctorInfoResponse
     */
    getCitizenDoctorInfo(query: GetCitizenDoctorInfoRequest, cancelToken?: CancelToken): Promise<GetCitizenDoctorInfoResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcitizendoctorinfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenFormCodeRequest
     * @return GetCitizenFormCodeResponse
     */
    getCitizenFormCode(query: GetCitizenFormCodeRequest, cancelToken?: CancelToken): Promise<GetCitizenFormCodeResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcitizenformcode`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenForMedicalCollaborationRequest
     * @return GetCitizenForMedicalCollaborationResponse
     */
    getCitizenForMedicalCollaboration(query: GetCitizenForMedicalCollaborationRequest, cancelToken?: CancelToken): Promise<GetCitizenForMedicalCollaborationResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcitizenformedicalcollaboration`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenHospitalStaysRequest
     * @return GetCitizenHospitalStaysResponse
     */
    getCitizenHospitalStays(query: GetCitizenHospitalStaysRequest, cancelToken?: CancelToken): Promise<GetCitizenHospitalStaysResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcitizenhospitalstays`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenIdByCorrespondenceMessageIdRequest
     * @return GetCitizenIdByCorrespondenceMessageIdResponse
     */
    getCitizenIdByCorrespondenceMessageId(query: GetCitizenIdByCorrespondenceMessageIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByCorrespondenceMessageIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcitizenidbycorrespondencemessageid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenIdByRequestFormIdRequest
     * @return GetCitizenIdByRequestFormIdResponse
     */
    getCitizenIdByRequestFormId(query: GetCitizenIdByRequestFormIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByRequestFormIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcitizenidbyrequestformid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenLetterJournalNoteRequest
     * @return GetCitizenLetterJournalNoteResponse
     */
    getCitizenLetterJournalNote(query: GetCitizenLetterJournalNoteRequest, cancelToken?: CancelToken): Promise<GetCitizenLetterJournalNoteResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcitizenletterjournalnote`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenPatientInfoRequest
     * @return GetCitizenPatientInfoResponse
     */
    getCitizenPatientInfo(query: GetCitizenPatientInfoRequest, cancelToken?: CancelToken): Promise<GetCitizenPatientInfoResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcitizenpatientinfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetContactShortNameRequest
     * @return GetContactShortNameResponse
     */
    getContactShortName(query: GetContactShortNameRequest, cancelToken?: CancelToken): Promise<GetContactShortNameResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcontactshortname`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCorrespondenceMessageRequest
     * @return GetCorrespondenceMessageResponse
     */
    getCorrespondenceMessage(query: GetCorrespondenceMessageRequest, cancelToken?: CancelToken): Promise<GetCorrespondenceMessageResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcorrespondencemessage`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCorrespondenceMessageForServiceProviderRequest
     * @return GetCorrespondenceMessageForServiceProviderResponse
     */
    getCorrespondenceMessageForServiceProvider(query: GetCorrespondenceMessageForServiceProviderRequest, cancelToken?: CancelToken): Promise<GetCorrespondenceMessageForServiceProviderResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcorrespondencemessageforserviceprovider`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCorrespondenceMessagesRequest
     * @return GetCorrespondenceMessagesResponse
     */
    getCorrespondenceMessages(query: GetCorrespondenceMessagesRequest, cancelToken?: CancelToken): Promise<GetCorrespondenceMessagesResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcorrespondencemessages`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCorrespondenceMessagesForServiceProviderRequest
     * @return GetCorrespondenceMessagesForServiceProviderResponse
     */
    getCorrespondenceMessagesForServiceProvider(query: GetCorrespondenceMessagesForServiceProviderRequest, cancelToken?: CancelToken): Promise<GetCorrespondenceMessagesForServiceProviderResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcorrespondencemessagesforserviceprovider`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCorrespondenceMessageSignatureRequest
     * @return GetCorrespondenceMessageSignatureResponse
     */
    getCorrespondenceMessageSignature(query: GetCorrespondenceMessageSignatureRequest, cancelToken?: CancelToken): Promise<GetCorrespondenceMessageSignatureResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getcorrespondencemessagesignature`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDoctorResponseDeadlineEnabledRequest
     * @return GetDoctorResponseDeadlineEnabledResponse
     */
    getDoctorResponseDeadlineEnabled(query: GetDoctorResponseDeadlineEnabledRequest, cancelToken?: CancelToken): Promise<GetDoctorResponseDeadlineEnabledResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getdoctorresponsedeadlineenabled`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicalCollaboratorMedicalRequestsRequest
     * @return GetMedicalCollaboratorMedicalRequestsResponse
     */
    getMedicalCollaboratorMedicalRequests(query: GetMedicalCollaboratorMedicalRequestsRequest, cancelToken?: CancelToken): Promise<GetMedicalCollaboratorMedicalRequestsResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getmedicalcollaboratormedicalrequests`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicalRequestRequest
     * @return GetMedicalRequestResponse
     */
    getMedicalRequest(query: GetMedicalRequestRequest, cancelToken?: CancelToken): Promise<GetMedicalRequestResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getmedicalrequest`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicalRequestForMedicalCollaboratorRequest
     * @return GetMedicalRequestForMedicalCollaboratorResponse
     */
    getMedicalRequestForMedicalCollaborator(query: GetMedicalRequestForMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<GetMedicalRequestForMedicalCollaboratorResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getmedicalrequestformedicalcollaborator`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicalRequestsRequest
     * @return GetMedicalRequestsResponse
     */
    getMedicalRequests(query: GetMedicalRequestsRequest, cancelToken?: CancelToken): Promise<GetMedicalRequestsResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getmedicalrequests`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetMedicalRequestTypesResponse
     */
    getMedicalRequestTypes(cancelToken?: CancelToken): Promise<GetMedicalRequestTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getmedicalrequesttypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetRequestFormCodeByRequestFormIdRequest
     * @return GetRequestFormCodeByRequestFormIdResponse
     */
    getRequestFormCodeByRequestFormId(query: GetRequestFormCodeByRequestFormIdRequest, cancelToken?: CancelToken): Promise<GetRequestFormCodeByRequestFormIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getrequestformcodebyrequestformid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSorNodesQueryRequest
     * @return GetSorNodesQueryResponse
     */
    getSorNodes(query: GetSorNodesQueryRequest, cancelToken?: CancelToken): Promise<GetSorNodesQueryResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getsornodes`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSorSearchResultByLookupQueryRequest
     * @return GetSorSearchResultByLookupQueryResponse
     */
    getSorSearchResultByLookupQuery(query: GetSorSearchResultByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetSorSearchResultByLookupQueryResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getsorsearchresultbylookupquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSorTreeSearchResultByLookupQueryRequest
     * @return GetSorTreeSearchResultByLookupQueryResponse
     */
    getSorTreeSearchResultByLookupQuery(query: GetSorTreeSearchResultByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetSorTreeSearchResultByLookupQueryResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/getsortreesearchresultbylookupquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query ValidateCorrespondenceAttachmentsRequest
     * @return ValidateCorrespondenceAttachmentsResponse
     */
    validateCorrespondenceAttachments(query: ValidateCorrespondenceAttachmentsRequest, cancelToken?: CancelToken): Promise<ValidateCorrespondenceAttachmentsResponse> {
        const $url = `${this.baseUrl}/api/citizen/medicalcollaboration/queries/validatecorrespondenceattachments`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenJournalReportClient {
    /**
     * @param command CreateJournalReportRequest
     * @return CreateJournalReportResponse
     */
    createJournalReport(command: CreateJournalReportRequest, cancelToken?: CancelToken): Promise<CreateJournalReportResponse>;
    /**
     * @param query GetInitalDataForJournalReportRequest
     * @return GetInitalDataForJournalReportResponse
     */
    getInitalDataForJournalReport(query: GetInitalDataForJournalReportRequest, cancelToken?: CancelToken): Promise<GetInitalDataForJournalReportResponse>;
    /**
     * @param query GetJournalNotesByCaseIdsAndPeriodRequest
     * @return GetJournalNotesByCaseIdsAndPeriodResponse
     */
    getJournalNotesByCaseIdsAndPeriod(query: GetJournalNotesByCaseIdsAndPeriodRequest, cancelToken?: CancelToken): Promise<GetJournalNotesByCaseIdsAndPeriodResponse>;
    /**
     * @param query GetJournalReportProgressByIdRequest
     * @return GetJournalReportProgressByIdResponse
     */
    getJournalReportProgressById(query: GetJournalReportProgressByIdRequest, cancelToken?: CancelToken): Promise<GetJournalReportProgressByIdResponse>;
    /**
     * @param query GetScannedJournalNoteResultsRequest
     * @return GetScannedJournalNoteResultsResponse
     */
    getScannedJournalNoteResults(query: GetScannedJournalNoteResultsRequest, cancelToken?: CancelToken): Promise<GetScannedJournalNoteResultsResponse>;
}

export class CitizenJournalReportClient implements ICitizenJournalReportClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateJournalReportRequest
     * @return CreateJournalReportResponse
     */
    createJournalReport(command: CreateJournalReportRequest, cancelToken?: CancelToken): Promise<CreateJournalReportResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/report/commands/createjournalreport`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInitalDataForJournalReportRequest
     * @return GetInitalDataForJournalReportResponse
     */
    getInitalDataForJournalReport(query: GetInitalDataForJournalReportRequest, cancelToken?: CancelToken): Promise<GetInitalDataForJournalReportResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/report/queries/getinitaldataforjournalreport`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalNotesByCaseIdsAndPeriodRequest
     * @return GetJournalNotesByCaseIdsAndPeriodResponse
     */
    getJournalNotesByCaseIdsAndPeriod(query: GetJournalNotesByCaseIdsAndPeriodRequest, cancelToken?: CancelToken): Promise<GetJournalNotesByCaseIdsAndPeriodResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/report/queries/getjournalnotesbycaseidsandperiod`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalReportProgressByIdRequest
     * @return GetJournalReportProgressByIdResponse
     */
    getJournalReportProgressById(query: GetJournalReportProgressByIdRequest, cancelToken?: CancelToken): Promise<GetJournalReportProgressByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/report/queries/getjournalreportprogressbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetScannedJournalNoteResultsRequest
     * @return GetScannedJournalNoteResultsResponse
     */
    getScannedJournalNoteResults(query: GetScannedJournalNoteResultsRequest, cancelToken?: CancelToken): Promise<GetScannedJournalNoteResultsResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/report/queries/getscannedjournalnoteresults`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenJournalDocumentClient {
    /**
     * @param command DeleteDocumentRequest
     * @return DeleteDocumentResponse
     */
    deleteDocument(command: DeleteDocumentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command OpenFinishedDocumentForEditingRequest
     * @return OpenFinishedDocumentForEditingResponse
     */
    openFinishedDocumentForEditing(command: OpenFinishedDocumentForEditingRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SaveDraftDocumentRequest
     * @return SaveDraftDocumentResponse
     */
    saveDraftDocument(command: SaveDraftDocumentRequest, cancelToken?: CancelToken): Promise<SaveDraftDocumentResponse>;
    /**
     * @param command SaveFinishedDocumentRequest
     * @return SaveFinishedDocumentResponse
     */
    saveFinishedDocument(command: SaveFinishedDocumentRequest, cancelToken?: CancelToken): Promise<SaveFinishedDocumentResponse>;
    /**
     * @param command UploadDraftAttachmentRequest
     * @return UploadDraftAttachmentResponse
     */
    uploadDraftAttachment(command: UploadDraftAttachmentRequest, cancelToken?: CancelToken): Promise<UploadDraftAttachmentResponse>;
    /**
     * @param query DownloadDocumentAttachmentRequest
     * @return FileResponse
     */
    downloadDocumentAttachment(query: DownloadDocumentAttachmentRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetCitizenCasesRequest
     * @return GetCitizenCasesResponse
     */
    getCitizenCases(query: GetCitizenCasesRequest, cancelToken?: CancelToken): Promise<GetCitizenCasesResponse>;
    /**
     * @param query GetCitizenCvRequest
     * @return GetCitizenCvResponse
     */
    getCitizenCv(query: GetCitizenCvRequest, cancelToken?: CancelToken): Promise<GetCitizenCvResponse>;
    /**
     * @param query GetCitizenIdByDocumentIdRequest
     * @return GetCitizenIdByDocumentIdResponse
     */
    getCitizenIdByDocumentId(query: GetCitizenIdByDocumentIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByDocumentIdResponse>;
    /**
     * @param query GetDocumentAsPdfRequest
     * @return FileResponse
     */
    getDocumentAsPdf(query: GetDocumentAsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetDocumentByIdRequest
     * @return GetDocumentByIdResponse
     */
    getDocumentById(query: GetDocumentByIdRequest, cancelToken?: CancelToken): Promise<GetDocumentByIdResponse>;
    /**
     * @param query Request
     * @return FileResponse
     */
    getDocumentPreviewById(query: Request2, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetDocumentsForCitizenIdRequest
     * @return GetDocumentsForCitizenIdResponse
     */
    getDocumentsForCitizenId(query: GetDocumentsForCitizenIdRequest, cancelToken?: CancelToken): Promise<GetDocumentsForCitizenIdResponse>;
    /**
     * @param query GetDocumentTemplatesRequest
     * @return GetDocumentTemplatesResponse
     */
    getDocumentTemplates(query: GetDocumentTemplatesRequest, cancelToken?: CancelToken): Promise<GetDocumentTemplatesResponse>;
    /**
     * @return GetPDFConversionSettingResponse
     */
    getPDFConversionSetting(cancelToken?: CancelToken): Promise<GetPDFConversionSettingResponse>;
    /**
     * @param query GetRenderedTemplateRequest
     * @return GetRenderedTemplateResponse
     */
    getRenderedTemplate(query: GetRenderedTemplateRequest, cancelToken?: CancelToken): Promise<GetRenderedTemplateResponse>;
    /**
     * @param query GetServiceProviderDocumentsForCitizenIdRequest
     * @return GetServiceProviderDocumentsForCitizenIdResponse
     */
    getServiceProviderDocumentsForCitizenId(query: GetServiceProviderDocumentsForCitizenIdRequest, cancelToken?: CancelToken): Promise<GetServiceProviderDocumentsForCitizenIdResponse>;
    /**
     * @param query GetStandardAttachmentDocumentsRequest
     * @return GetStandardAttachmentDocumentsResponse
     */
    getStandardAttachmentDocuments(query: GetStandardAttachmentDocumentsRequest, cancelToken?: CancelToken): Promise<GetStandardAttachmentDocumentsResponse>;
    /**
     * @return Int32
     */
    getStandardAttachmentObjectTypeCode(cancelToken?: CancelToken): Promise<number>;
    /**
     * @return GetAttachmentSettingsResponse
     */
    getStandardAttachmentSetting(cancelToken?: CancelToken): Promise<GetAttachmentSettingsResponse>;
}

export class CitizenJournalDocumentClient implements ICitizenJournalDocumentClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command DeleteDocumentRequest
     * @return DeleteDocumentResponse
     */
    deleteDocument(command: DeleteDocumentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/commands/deletedocument`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command OpenFinishedDocumentForEditingRequest
     * @return OpenFinishedDocumentForEditingResponse
     */
    openFinishedDocumentForEditing(command: OpenFinishedDocumentForEditingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/commands/openfinisheddocumentforediting`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SaveDraftDocumentRequest
     * @return SaveDraftDocumentResponse
     */
    saveDraftDocument(command: SaveDraftDocumentRequest, cancelToken?: CancelToken): Promise<SaveDraftDocumentResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/commands/savedraftdocument`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SaveFinishedDocumentRequest
     * @return SaveFinishedDocumentResponse
     */
    saveFinishedDocument(command: SaveFinishedDocumentRequest, cancelToken?: CancelToken): Promise<SaveFinishedDocumentResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/commands/savefinisheddocument`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UploadDraftAttachmentRequest
     * @return UploadDraftAttachmentResponse
     */
    uploadDraftAttachment(command: UploadDraftAttachmentRequest, cancelToken?: CancelToken): Promise<UploadDraftAttachmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/commands/uploaddraftattachment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DownloadDocumentAttachmentRequest
     * @return FileResponse
     */
    downloadDocumentAttachment(query: DownloadDocumentAttachmentRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/downloaddocumentattachment`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenCasesRequest
     * @return GetCitizenCasesResponse
     */
    getCitizenCases(query: GetCitizenCasesRequest, cancelToken?: CancelToken): Promise<GetCitizenCasesResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/getcitizencases`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenCvRequest
     * @return GetCitizenCvResponse
     */
    getCitizenCv(query: GetCitizenCvRequest, cancelToken?: CancelToken): Promise<GetCitizenCvResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/getcitizencv`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenIdByDocumentIdRequest
     * @return GetCitizenIdByDocumentIdResponse
     */
    getCitizenIdByDocumentId(query: GetCitizenIdByDocumentIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByDocumentIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/getcitizenidbydocumentid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDocumentAsPdfRequest
     * @return FileResponse
     */
    getDocumentAsPdf(query: GetDocumentAsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/getdocumentaspdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDocumentByIdRequest
     * @return GetDocumentByIdResponse
     */
    getDocumentById(query: GetDocumentByIdRequest, cancelToken?: CancelToken): Promise<GetDocumentByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/getdocumentbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query Request
     * @return FileResponse
     */
    getDocumentPreviewById(query: Request2, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/getdocumentpreviewbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDocumentsForCitizenIdRequest
     * @return GetDocumentsForCitizenIdResponse
     */
    getDocumentsForCitizenId(query: GetDocumentsForCitizenIdRequest, cancelToken?: CancelToken): Promise<GetDocumentsForCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/getdocumentsforcitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDocumentTemplatesRequest
     * @return GetDocumentTemplatesResponse
     */
    getDocumentTemplates(query: GetDocumentTemplatesRequest, cancelToken?: CancelToken): Promise<GetDocumentTemplatesResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/getdocumenttemplates`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetPDFConversionSettingResponse
     */
    getPDFConversionSetting(cancelToken?: CancelToken): Promise<GetPDFConversionSettingResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/getpdfconversionsetting`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetRenderedTemplateRequest
     * @return GetRenderedTemplateResponse
     */
    getRenderedTemplate(query: GetRenderedTemplateRequest, cancelToken?: CancelToken): Promise<GetRenderedTemplateResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/getrenderedtemplate`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderDocumentsForCitizenIdRequest
     * @return GetServiceProviderDocumentsForCitizenIdResponse
     */
    getServiceProviderDocumentsForCitizenId(query: GetServiceProviderDocumentsForCitizenIdRequest, cancelToken?: CancelToken): Promise<GetServiceProviderDocumentsForCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/getserviceproviderdocumentsforcitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetStandardAttachmentDocumentsRequest
     * @return GetStandardAttachmentDocumentsResponse
     */
    getStandardAttachmentDocuments(query: GetStandardAttachmentDocumentsRequest, cancelToken?: CancelToken): Promise<GetStandardAttachmentDocumentsResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/getstandardattachmentdocuments`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return Int32
     */
    getStandardAttachmentObjectTypeCode(cancelToken?: CancelToken): Promise<number> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/getstandardattachmentobjecttypecode`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAttachmentSettingsResponse
     */
    getStandardAttachmentSetting(cancelToken?: CancelToken): Promise<GetAttachmentSettingsResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/document/queries/getstandardattachmentsetting`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenJournalClient {
    /**
     * @param command MarkJournalNotesAsReadRequest
     * @return MarkJournalNotesAsReadResponse
     */
    markJournalNotesAsRead(command: MarkJournalNotesAsReadRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ReviseJournalNoteRequest
     * @return ReviseJournalNoteResponse
     */
    reviseJournalNote(command: ReviseJournalNoteRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ReviseStatusJournalNoteRequest
     * @return ReviseStatusJournalNoteResponse
     */
    reviseStatusJournalNote(command: ReviseStatusJournalNoteRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateJournalNoteMetadataRequest
     * @return UpdateJournalNoteMetadataResponse
     */
    updateJournalNoteMetadata(command: UpdateJournalNoteMetadataRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateJournalReportDetailsRequest
     * @return UpdateJournalReportDetailsResponse
     */
    updateJournalReportDetails(command: UpdateJournalReportDetailsRequest, cancelToken?: CancelToken): Promise<UpdateJournalReportDetailsResponse>;
    /**
     * @param query DownloadDocumentFromBffRequest
     * @return FileResponse
     */
    downloadDocumentFromBff(query: DownloadDocumentFromBffRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query DownloadDocumentFromDocumentArchiveRequest
     * @return FileResponse
     */
    downloadDocumentFromDocumentArchive(query: DownloadDocumentFromDocumentArchiveRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query DownloadJournalNoteAttachmentRequest
     * @return FileResponse
     */
    downloadJournalNoteAttachment(query: DownloadJournalNoteAttachmentRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query DownloadJournalReportFileRequest
     * @return FileResponse
     */
    downloadJournalReportFile(query: DownloadJournalReportFileRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetCasesForCitizenRequest
     * @return GetCasesForCitizenResponse
     */
    getCasesForCitizen(query: GetCasesForCitizenRequest, cancelToken?: CancelToken): Promise<GetCasesForCitizenResponse>;
    /**
     * @param query GetCaseTargetGroupRequest
     * @return GetCaseTargetGroupResponse
     */
    getCaseTargetGroup(query: GetCaseTargetGroupRequest, cancelToken?: CancelToken): Promise<GetCaseTargetGroupResponse>;
    /**
     * @param query GetCaseworkerRequest
     * @return GetCaseworkerResponse
     */
    getCaseworker(query: GetCaseworkerRequest, cancelToken?: CancelToken): Promise<GetCaseworkerResponse>;
    /**
     * @param query GetCitizenIdByJournalNoteIdRequest
     * @return GetCitizenIdByJournalNoteIdResponse
     */
    getCitizenIdByJournalNoteId(query: GetCitizenIdByJournalNoteIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByJournalNoteIdResponse>;
    /**
     * @return GetContentTypesResponse
     */
    getContentTypes(cancelToken?: CancelToken): Promise<GetContentTypesResponse>;
    /**
     * @param query GetCrmFeatureSettingRequest
     * @return GetCrmFeatureSettingResponse
     */
    getCrmFeatureSetting(query: GetCrmFeatureSettingRequest, cancelToken?: CancelToken): Promise<GetCrmFeatureSettingResponse>;
    /**
     * @param query GetJournalNoteRequest
     * @return GetJournalNoteResponse
     */
    getJournalNote(query: GetJournalNoteRequest, cancelToken?: CancelToken): Promise<GetJournalNoteResponse>;
    /**
     * @param query GetJournalNoteDetailsForCitizenIdRequest
     * @return GetJournalNoteDetailsForCitizenIdResponse
     */
    getJournalNoteDetailsForCitizenId(query: GetJournalNoteDetailsForCitizenIdRequest, cancelToken?: CancelToken): Promise<GetJournalNoteDetailsForCitizenIdResponse>;
    /**
     * @param query GetJournalNotePageForCitizenIdRequest
     * @return GetJournalNotePageForCitizenIdResponse
     */
    getJournalNotePageForCitizenId(query: GetJournalNotePageForCitizenIdRequest, cancelToken?: CancelToken): Promise<GetJournalNotePageForCitizenIdResponse>;
    /**
     * @return GetJournalNoteReadMarkingConfigurationResponse
     */
    getJournalNoteReadMarkingConfiguration(cancelToken?: CancelToken): Promise<GetJournalNoteReadMarkingConfigurationResponse>;
    /**
     * @param query GetJournalNotesForCitizenIdRequest
     * @return GetJournalNotesForCitizenIdResponse
     */
    getJournalNotesForCitizenId(query: GetJournalNotesForCitizenIdRequest, cancelToken?: CancelToken): Promise<GetJournalNotesForCitizenIdResponse>;
    /**
     * @param query GetJournalReportByIdRequest
     * @return GetJournalReportByIdResponse
     */
    getJournalReportById(query: GetJournalReportByIdRequest, cancelToken?: CancelToken): Promise<GetJournalReportByIdResponse>;
    /**
     * @param query GetJournalReportJobStatusRequest
     * @return GetJournalReportJobStatusResponse
     */
    getJournalReportJobStatus(query: GetJournalReportJobStatusRequest, cancelToken?: CancelToken): Promise<GetJournalReportJobStatusResponse>;
    /**
     * @param query GetJournalReportLinkRequest
     * @return GetJournalReportLinkResponse
     */
    getJournalReportLink(query: GetJournalReportLinkRequest, cancelToken?: CancelToken): Promise<GetJournalReportLinkResponse>;
    /**
     * @param query GetJournalReportsForCitizenIdRequest
     * @return GetJournalReportsForCitizenIdResponse
     */
    getJournalReportsForCitizenId(query: GetJournalReportsForCitizenIdRequest, cancelToken?: CancelToken): Promise<GetJournalReportsForCitizenIdResponse>;
    /**
     * @return GetSourcesResponse
     */
    getSources(cancelToken?: CancelToken): Promise<GetSourcesResponse>;
    /**
     * @param query SearchJournalNotesForCitizenPersonContactRequest
     * @return SearchJournalNotesForCitizenPersonContactResponse
     */
    searchJournalNotesForCitizenPersonContact(query: SearchJournalNotesForCitizenPersonContactRequest, cancelToken?: CancelToken): Promise<SearchJournalNotesForCitizenPersonContactResponse>;
    /**
     * @param query CreateJournalNoteRequest
     * @return CreateJournalNoteResponse
     */
    createJournalNote(query: CreateJournalNoteRequest, cancelToken?: CancelToken): Promise<CreateJournalNoteResponse>;
    /**
     * @param query GenerateSummaryForJournalNoteTranscriptionRequest
     * @return GenerateSummaryForJournalNoteTranscriptionResponse
     */
    generateSummaryForJournalNoteTranscription(query: GenerateSummaryForJournalNoteTranscriptionRequest, cancelToken?: CancelToken): Promise<GenerateSummaryForJournalNoteTranscriptionResponse>;
    /**
     * @param query RemoveJournalReportRequest
     * @return RemoveJournalReportResponse
     */
    removeJournalReport(query: RemoveJournalReportRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query UpdateJournalReportCommentRequest
     * @return UpdateJournalReportCommentResponse
     */
    updateJournalReportComment(query: UpdateJournalReportCommentRequest, cancelToken?: CancelToken): Promise<UpdateJournalReportCommentResponse>;
}

export class CitizenJournalClient implements ICitizenJournalClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command MarkJournalNotesAsReadRequest
     * @return MarkJournalNotesAsReadResponse
     */
    markJournalNotesAsRead(command: MarkJournalNotesAsReadRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/journal/commands/markjournalnotesasread`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReviseJournalNoteRequest
     * @return ReviseJournalNoteResponse
     */
    reviseJournalNote(command: ReviseJournalNoteRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/journal/commands/revisejournalnote`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReviseStatusJournalNoteRequest
     * @return ReviseStatusJournalNoteResponse
     */
    reviseStatusJournalNote(command: ReviseStatusJournalNoteRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/journal/commands/revisestatusjournalnote`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateJournalNoteMetadataRequest
     * @return UpdateJournalNoteMetadataResponse
     */
    updateJournalNoteMetadata(command: UpdateJournalNoteMetadataRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/journal/commands/updatejournalnotemetadata`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateJournalReportDetailsRequest
     * @return UpdateJournalReportDetailsResponse
     */
    updateJournalReportDetails(command: UpdateJournalReportDetailsRequest, cancelToken?: CancelToken): Promise<UpdateJournalReportDetailsResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/commands/updatejournalreportdetails`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DownloadDocumentFromBffRequest
     * @return FileResponse
     */
    downloadDocumentFromBff(query: DownloadDocumentFromBffRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/downloaddocumentfrombff`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query DownloadDocumentFromDocumentArchiveRequest
     * @return FileResponse
     */
    downloadDocumentFromDocumentArchive(query: DownloadDocumentFromDocumentArchiveRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/downloaddocumentfromdocumentarchive`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query DownloadJournalNoteAttachmentRequest
     * @return FileResponse
     */
    downloadJournalNoteAttachment(query: DownloadJournalNoteAttachmentRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/downloadjournalnoteattachment`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query DownloadJournalReportFileRequest
     * @return FileResponse
     */
    downloadJournalReportFile(query: DownloadJournalReportFileRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/downloadjournalreportfile`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCasesForCitizenRequest
     * @return GetCasesForCitizenResponse
     */
    getCasesForCitizen(query: GetCasesForCitizenRequest, cancelToken?: CancelToken): Promise<GetCasesForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getcasesforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseTargetGroupRequest
     * @return GetCaseTargetGroupResponse
     */
    getCaseTargetGroup(query: GetCaseTargetGroupRequest, cancelToken?: CancelToken): Promise<GetCaseTargetGroupResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getcasetargetgroup`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseworkerRequest
     * @return GetCaseworkerResponse
     */
    getCaseworker(query: GetCaseworkerRequest, cancelToken?: CancelToken): Promise<GetCaseworkerResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getcaseworker`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenIdByJournalNoteIdRequest
     * @return GetCitizenIdByJournalNoteIdResponse
     */
    getCitizenIdByJournalNoteId(query: GetCitizenIdByJournalNoteIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByJournalNoteIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getcitizenidbyjournalnoteid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetContentTypesResponse
     */
    getContentTypes(cancelToken?: CancelToken): Promise<GetContentTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getcontenttypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCrmFeatureSettingRequest
     * @return GetCrmFeatureSettingResponse
     */
    getCrmFeatureSetting(query: GetCrmFeatureSettingRequest, cancelToken?: CancelToken): Promise<GetCrmFeatureSettingResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getcrmfeaturesetting`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalNoteRequest
     * @return GetJournalNoteResponse
     */
    getJournalNote(query: GetJournalNoteRequest, cancelToken?: CancelToken): Promise<GetJournalNoteResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getjournalnote`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalNoteDetailsForCitizenIdRequest
     * @return GetJournalNoteDetailsForCitizenIdResponse
     */
    getJournalNoteDetailsForCitizenId(query: GetJournalNoteDetailsForCitizenIdRequest, cancelToken?: CancelToken): Promise<GetJournalNoteDetailsForCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getjournalnotedetailsforcitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalNotePageForCitizenIdRequest
     * @return GetJournalNotePageForCitizenIdResponse
     */
    getJournalNotePageForCitizenId(query: GetJournalNotePageForCitizenIdRequest, cancelToken?: CancelToken): Promise<GetJournalNotePageForCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getjournalnotepageforcitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetJournalNoteReadMarkingConfigurationResponse
     */
    getJournalNoteReadMarkingConfiguration(cancelToken?: CancelToken): Promise<GetJournalNoteReadMarkingConfigurationResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getjournalnotereadmarkingconfiguration`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalNotesForCitizenIdRequest
     * @return GetJournalNotesForCitizenIdResponse
     */
    getJournalNotesForCitizenId(query: GetJournalNotesForCitizenIdRequest, cancelToken?: CancelToken): Promise<GetJournalNotesForCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getjournalnotesforcitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalReportByIdRequest
     * @return GetJournalReportByIdResponse
     */
    getJournalReportById(query: GetJournalReportByIdRequest, cancelToken?: CancelToken): Promise<GetJournalReportByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getjournalreportbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalReportJobStatusRequest
     * @return GetJournalReportJobStatusResponse
     */
    getJournalReportJobStatus(query: GetJournalReportJobStatusRequest, cancelToken?: CancelToken): Promise<GetJournalReportJobStatusResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getjournalreportjobstatus`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalReportLinkRequest
     * @return GetJournalReportLinkResponse
     */
    getJournalReportLink(query: GetJournalReportLinkRequest, cancelToken?: CancelToken): Promise<GetJournalReportLinkResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getjournalreportlink`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalReportsForCitizenIdRequest
     * @return GetJournalReportsForCitizenIdResponse
     */
    getJournalReportsForCitizenId(query: GetJournalReportsForCitizenIdRequest, cancelToken?: CancelToken): Promise<GetJournalReportsForCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getjournalreportsforcitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSourcesResponse
     */
    getSources(cancelToken?: CancelToken): Promise<GetSourcesResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/getsources`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query SearchJournalNotesForCitizenPersonContactRequest
     * @return SearchJournalNotesForCitizenPersonContactResponse
     */
    searchJournalNotesForCitizenPersonContact(query: SearchJournalNotesForCitizenPersonContactRequest, cancelToken?: CancelToken): Promise<SearchJournalNotesForCitizenPersonContactResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/searchjournalnotesforcitizenpersoncontact`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query CreateJournalNoteRequest
     * @return CreateJournalNoteResponse
     */
    createJournalNote(query: CreateJournalNoteRequest, cancelToken?: CancelToken): Promise<CreateJournalNoteResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/createjournalnote`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GenerateSummaryForJournalNoteTranscriptionRequest
     * @return GenerateSummaryForJournalNoteTranscriptionResponse
     */
    generateSummaryForJournalNoteTranscription(query: GenerateSummaryForJournalNoteTranscriptionRequest, cancelToken?: CancelToken): Promise<GenerateSummaryForJournalNoteTranscriptionResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/generatesummaryforjournalnotetranscription`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query RemoveJournalReportRequest
     * @return RemoveJournalReportResponse
     */
    removeJournalReport(query: RemoveJournalReportRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/removejournalreport`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query UpdateJournalReportCommentRequest
     * @return UpdateJournalReportCommentResponse
     */
    updateJournalReportComment(query: UpdateJournalReportCommentRequest, cancelToken?: CancelToken): Promise<UpdateJournalReportCommentResponse> {
        const $url = `${this.baseUrl}/api/citizen/journal/queries/updatejournalreportcomment`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenJobReferralClient {
    /**
     * @param command GetCitizenIdByJobReferralIdRequest
     * @return GetCitizenIdByJobReferralIdResponse
     */
    getCitizenIdByJobReferralId(command: GetCitizenIdByJobReferralIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByJobReferralIdResponse>;
    /**
     * @param command GetJobReferralRequest
     * @return GetJobReferralResponse
     */
    getJobReferral(command: GetJobReferralRequest, cancelToken?: CancelToken): Promise<GetJobReferralResponse>;
    /**
     * @param command GetJobReferralsRequest
     * @return GetJobReferralsResponse
     */
    getJobReferrals(command: GetJobReferralsRequest, cancelToken?: CancelToken): Promise<GetJobReferralsResponse>;
    /**
     * @param command CancelJobReferralRequest
     * @return CancelJobReferralResponse
     */
    cancelJobReferral(command: CancelJobReferralRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateFollowUpJobReferralRequest
     * @return CreateFollowUpJobReferralResponse
     */
    createFollowUpJobReferral(command: CreateFollowUpJobReferralRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateJobReferralRequest
     * @return CreateJobReferralResponse
     */
    createJobReferral(command: CreateJobReferralRequest, cancelToken?: CancelToken): Promise<CreateJobReferralResponse>;
    /**
     * @param command MarkJobReferralSentRequest
     * @return MarkJobReferralSentResponse
     */
    markJobReferralSent(command: MarkJobReferralSentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query CitizenAllowJobReferralsRequest
     * @return CitizenAllowJobReferralsResponse
     */
    citizenAllowJobReferrals(query: CitizenAllowJobReferralsRequest, cancelToken?: CancelToken): Promise<CitizenAllowJobReferralsResponse>;
    /**
     * @param query GetCompanyRecruitmentForJobReferralRequest
     * @return GetCompanyRecruitmentForJobReferralResponse
     */
    getCompanyRecruitmentForJobReferral(query: GetCompanyRecruitmentForJobReferralRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentForJobReferralResponse>;
    /**
     * @param query GetCompanyRecruitmentsByLookupQueryRequest
     * @return GetCompanyRecruitmentsByLookupQueryResponse
     */
    getCompanyRecruitmentsByLookupQuery(query: GetCompanyRecruitmentsByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentsByLookupQueryResponse>;
    /**
     * @param query GetCompanyContactPersonsByCompanyIdForJobReferralRequest
     * @return GetCompanyContactPersonsByCompanyIdForJobReferralResponse
     */
    getContactPersonsByCompanyIdForJobReferral(query: GetCompanyContactPersonsByCompanyIdForJobReferralRequest, cancelToken?: CancelToken): Promise<GetCompanyContactPersonsByCompanyIdForJobReferralResponse>;
    /**
     * @return GetJobReferralCodeListDataResponse
     */
    getJobReferralCodeListData(cancelToken?: CancelToken): Promise<GetJobReferralCodeListDataResponse>;
    /**
     * @param query GetTargetGroupCodeByCitizenIdRequest
     * @return GetTargetGroupCodeByCitizenIdResponse
     */
    getTargetGroupCodeByCitizenId(query: GetTargetGroupCodeByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetTargetGroupCodeByCitizenIdResponse>;
}

export class CitizenJobReferralClient implements ICitizenJobReferralClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command GetCitizenIdByJobReferralIdRequest
     * @return GetCitizenIdByJobReferralIdResponse
     */
    getCitizenIdByJobReferralId(command: GetCitizenIdByJobReferralIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByJobReferralIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobreferral/commands/getcitizenidbyjobreferralid`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command GetJobReferralRequest
     * @return GetJobReferralResponse
     */
    getJobReferral(command: GetJobReferralRequest, cancelToken?: CancelToken): Promise<GetJobReferralResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobreferral/commands/getjobreferral`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command GetJobReferralsRequest
     * @return GetJobReferralsResponse
     */
    getJobReferrals(command: GetJobReferralsRequest, cancelToken?: CancelToken): Promise<GetJobReferralsResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobreferral/commands/getjobreferrals`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CancelJobReferralRequest
     * @return CancelJobReferralResponse
     */
    cancelJobReferral(command: CancelJobReferralRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/jobreferral/commands/canceljobreferral`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateFollowUpJobReferralRequest
     * @return CreateFollowUpJobReferralResponse
     */
    createFollowUpJobReferral(command: CreateFollowUpJobReferralRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/jobreferral/commands/createfollowupjobreferral`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateJobReferralRequest
     * @return CreateJobReferralResponse
     */
    createJobReferral(command: CreateJobReferralRequest, cancelToken?: CancelToken): Promise<CreateJobReferralResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobreferral/commands/createjobreferral`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command MarkJobReferralSentRequest
     * @return MarkJobReferralSentResponse
     */
    markJobReferralSent(command: MarkJobReferralSentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/jobreferral/commands/markjobreferralsent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query CitizenAllowJobReferralsRequest
     * @return CitizenAllowJobReferralsResponse
     */
    citizenAllowJobReferrals(query: CitizenAllowJobReferralsRequest, cancelToken?: CancelToken): Promise<CitizenAllowJobReferralsResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobreferral/queries/citizenallowjobreferrals`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyRecruitmentForJobReferralRequest
     * @return GetCompanyRecruitmentForJobReferralResponse
     */
    getCompanyRecruitmentForJobReferral(query: GetCompanyRecruitmentForJobReferralRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentForJobReferralResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobreferral/queries/getcompanyrecruitmentforjobreferral`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyRecruitmentsByLookupQueryRequest
     * @return GetCompanyRecruitmentsByLookupQueryResponse
     */
    getCompanyRecruitmentsByLookupQuery(query: GetCompanyRecruitmentsByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetCompanyRecruitmentsByLookupQueryResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobreferral/queries/getcompanyrecruitmentsbylookupquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyContactPersonsByCompanyIdForJobReferralRequest
     * @return GetCompanyContactPersonsByCompanyIdForJobReferralResponse
     */
    getContactPersonsByCompanyIdForJobReferral(query: GetCompanyContactPersonsByCompanyIdForJobReferralRequest, cancelToken?: CancelToken): Promise<GetCompanyContactPersonsByCompanyIdForJobReferralResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobreferral/queries/getcontactpersonsbycompanyidforjobreferral`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetJobReferralCodeListDataResponse
     */
    getJobReferralCodeListData(cancelToken?: CancelToken): Promise<GetJobReferralCodeListDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobreferral/queries/getjobreferralcodelistdata`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTargetGroupCodeByCitizenIdRequest
     * @return GetTargetGroupCodeByCitizenIdResponse
     */
    getTargetGroupCodeByCitizenId(query: GetTargetGroupCodeByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetTargetGroupCodeByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobreferral/queries/gettargetgroupcodebycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenJobnetRelationsJobnetClient {
    /**
     * @param command CreateCredentialsRequest
     * @return CreateCredentialsResponse
     */
    createCredentials(command: CreateCredentialsRequest, cancelToken?: CancelToken): Promise<CreateCredentialsResponse>;
}

export class CitizenJobnetRelationsJobnetClient implements ICitizenJobnetRelationsJobnetClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateCredentialsRequest
     * @return CreateCredentialsResponse
     */
    createCredentials(command: CreateCredentialsRequest, cancelToken?: CancelToken): Promise<CreateCredentialsResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/jobnet/commands/createcredentials`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenJobnetRelationsJobcenterClient {
    /**
     * @param command UpdateJobcenterAssociationRequest
     * @return UpdateJobcenterAssociationResponse
     */
    updateJobcenterAssociation(command: UpdateJobcenterAssociationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @return GetChangeJobcenterDataResponse
     */
    getChangeJobcenterData(cancelToken?: CancelToken): Promise<GetChangeJobcenterDataResponse>;
}

export class CitizenJobnetRelationsJobcenterClient implements ICitizenJobnetRelationsJobcenterClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command UpdateJobcenterAssociationRequest
     * @return UpdateJobcenterAssociationResponse
     */
    updateJobcenterAssociation(command: UpdateJobcenterAssociationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/jobcenter/commands/updatejobcenterassociation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetChangeJobcenterDataResponse
     */
    getChangeJobcenterData(cancelToken?: CancelToken): Promise<GetChangeJobcenterDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/jobcenter/queries/getchangejobcenterdata`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenJobnetRelationsEnrollmentClient {
    /**
     * @param command CancelEnrollmentRequest
     * @return CancelEnrollmentResponse
     */
    cancelEnrollment(command: CancelEnrollmentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateEnrollmentRequest
     * @return CreateEnrollmentResponse
     */
    createEnrollment(command: CreateEnrollmentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetActiveEnrollmentRequest
     * @return GetActiveEnrollmentResponse
     */
    getActiveEnrollment(query: GetActiveEnrollmentRequest, cancelToken?: CancelToken): Promise<GetActiveEnrollmentResponse>;
    /**
     * @param query GetEnrollmentByIdRequest
     * @return GetEnrollmentByIdResponse
     */
    getEnrollmentById(query: GetEnrollmentByIdRequest, cancelToken?: CancelToken): Promise<GetEnrollmentByIdResponse>;
    /**
     * @param query GetEnrollmentCancellationDataRequest
     * @return GetEnrollmentCancellationDataResponse
     */
    getEnrollmentCancellationData(query: GetEnrollmentCancellationDataRequest, cancelToken?: CancelToken): Promise<GetEnrollmentCancellationDataResponse>;
    /**
     * @param query GetEnrollmentCreationDataRequest
     * @return GetEnrollmentCreationDataResponse
     */
    getEnrollmentCreationData(query: GetEnrollmentCreationDataRequest, cancelToken?: CancelToken): Promise<GetEnrollmentCreationDataResponse>;
    /**
     * @param query GetEnrollmentsForCitizenRequest
     * @return GetEnrollmentsForCitizenResponse
     */
    getEnrollmentsForCitizen(query: GetEnrollmentsForCitizenRequest, cancelToken?: CancelToken): Promise<GetEnrollmentsForCitizenResponse>;
}

export class CitizenJobnetRelationsEnrollmentClient implements ICitizenJobnetRelationsEnrollmentClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CancelEnrollmentRequest
     * @return CancelEnrollmentResponse
     */
    cancelEnrollment(command: CancelEnrollmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/enrollment/commands/cancelenrollment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateEnrollmentRequest
     * @return CreateEnrollmentResponse
     */
    createEnrollment(command: CreateEnrollmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/enrollment/commands/createenrollment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActiveEnrollmentRequest
     * @return GetActiveEnrollmentResponse
     */
    getActiveEnrollment(query: GetActiveEnrollmentRequest, cancelToken?: CancelToken): Promise<GetActiveEnrollmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/enrollment/queries/getactiveenrollment`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEnrollmentByIdRequest
     * @return GetEnrollmentByIdResponse
     */
    getEnrollmentById(query: GetEnrollmentByIdRequest, cancelToken?: CancelToken): Promise<GetEnrollmentByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/enrollment/queries/getenrollmentbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEnrollmentCancellationDataRequest
     * @return GetEnrollmentCancellationDataResponse
     */
    getEnrollmentCancellationData(query: GetEnrollmentCancellationDataRequest, cancelToken?: CancelToken): Promise<GetEnrollmentCancellationDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/enrollment/queries/getenrollmentcancellationdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEnrollmentCreationDataRequest
     * @return GetEnrollmentCreationDataResponse
     */
    getEnrollmentCreationData(query: GetEnrollmentCreationDataRequest, cancelToken?: CancelToken): Promise<GetEnrollmentCreationDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/enrollment/queries/getenrollmentcreationdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEnrollmentsForCitizenRequest
     * @return GetEnrollmentsForCitizenResponse
     */
    getEnrollmentsForCitizen(query: GetEnrollmentsForCitizenRequest, cancelToken?: CancelToken): Promise<GetEnrollmentsForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/enrollment/queries/getenrollmentsforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenJobnetRelationsContactGroupClient {
    /**
     * @param command CreateContactGroupRequest
     * @return CreateContactGroupResponse
     */
    createContactGroup(command: CreateContactGroupRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateContactGroupRequest
     * @return UpdateContactGroupResponse
     */
    updateContactGroup(command: UpdateContactGroupRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetCitizenIdByContactGroupIdRequest
     * @return GetCitizenIdByContactGroupIdResponse
     */
    getCitizenIdByContactGroupId(query: GetCitizenIdByContactGroupIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByContactGroupIdResponse>;
    /**
     * @param query GetContactGroupCreateDataRequest
     * @return GetContactGroupCreateDataResponse
     */
    getContactGroupCreateData(query: GetContactGroupCreateDataRequest, cancelToken?: CancelToken): Promise<GetContactGroupCreateDataResponse>;
    /**
     * @param query GetContactGroupEditViewDataRequest
     * @return GetContactGroupEditViewDataResponse
     */
    getContactGroupEditViewData(query: GetContactGroupEditViewDataRequest, cancelToken?: CancelToken): Promise<GetContactGroupEditViewDataResponse>;
    /**
     * @param query GetContactGroupsForCitizenRequest
     * @return GetContactGroupsForCitizenResponse
     */
    getContactGroupsForCitizen(query: GetContactGroupsForCitizenRequest, cancelToken?: CancelToken): Promise<GetContactGroupsForCitizenResponse>;
}

export class CitizenJobnetRelationsContactGroupClient implements ICitizenJobnetRelationsContactGroupClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateContactGroupRequest
     * @return CreateContactGroupResponse
     */
    createContactGroup(command: CreateContactGroupRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/contactgroup/commands/createcontactgroup`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateContactGroupRequest
     * @return UpdateContactGroupResponse
     */
    updateContactGroup(command: UpdateContactGroupRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/contactgroup/commands/updatecontactgroup`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenIdByContactGroupIdRequest
     * @return GetCitizenIdByContactGroupIdResponse
     */
    getCitizenIdByContactGroupId(query: GetCitizenIdByContactGroupIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByContactGroupIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/contactgroup/queries/getcitizenidbycontactgroupid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetContactGroupCreateDataRequest
     * @return GetContactGroupCreateDataResponse
     */
    getContactGroupCreateData(query: GetContactGroupCreateDataRequest, cancelToken?: CancelToken): Promise<GetContactGroupCreateDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/contactgroup/queries/getcontactgroupcreatedata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetContactGroupEditViewDataRequest
     * @return GetContactGroupEditViewDataResponse
     */
    getContactGroupEditViewData(query: GetContactGroupEditViewDataRequest, cancelToken?: CancelToken): Promise<GetContactGroupEditViewDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/contactgroup/queries/getcontactgroupeditviewdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetContactGroupsForCitizenRequest
     * @return GetContactGroupsForCitizenResponse
     */
    getContactGroupsForCitizen(query: GetContactGroupsForCitizenRequest, cancelToken?: CancelToken): Promise<GetContactGroupsForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/contactgroup/queries/getcontactgroupsforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenInterviewClient {
    /**
     * @param command AbortInterviewGuideDraftRequest
     * @return AbortInterviewGuideDraftResponse
     */
    abortInterviewGuideDraft(command: AbortInterviewGuideDraftRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CancelBookingRequest
     * @return CancelBookingResponse
     */
    cancelBooking(command: CancelBookingRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CancelBookingsForCaseRequest
     * @return CancelBookingsForCaseResponse
     */
    cancelBookingsForCase(command: CancelBookingsForCaseRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CompleteBookingRequest
     * @return CompleteBookingResponse
     */
    completeBooking(command: CompleteBookingRequest, cancelToken?: CancelToken): Promise<CompleteBookingResponse>;
    /**
     * @param command CompleteCrowdBookingRequest
     * @return CompleteCrowdBookingResponse
     */
    completeCrowdBooking(command: CompleteCrowdBookingRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CompleteInterviewRequest
     * @return CompleteInterviewResponse
     */
    completeInterview(command: CompleteInterviewRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateCvAttachmentRequest
     * @return CreateCvAttachmentResponse
     */
    createCvAttachment(command: CreateCvAttachmentRequest, cancelToken?: CancelToken): Promise<CreateCvAttachmentResponse>;
    /**
     * @param command CreateNextInterviewReminderRequest
     * @return CreateNextInterviewReminderResponse
     */
    createNextInterviewReminder(command: CreateNextInterviewReminderRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreatePersonCategoryRequest
     * @return CreatePersonCategoryResponse
     */
    createPersonCategory(command: CreatePersonCategoryRequest, cancelToken?: CancelToken): Promise<CreatePersonCategoryResponse>;
    /**
     * @param command DeleteBookingDraftRequest
     * @return DeleteBookingDraftResponse
     */
    deleteBookingDraft(command: DeleteBookingDraftRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteInterviewDraftRequest
     * @return DeleteInterviewDraftResponse
     */
    deleteInterviewDraft(command: DeleteInterviewDraftRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command EvaluateSummaryRequest
     * @return EvaluateSummaryResponse
     */
    evaluateSummary(command: EvaluateSummaryRequest, cancelToken?: CancelToken): Promise<EvaluateSummaryResponse>;
    /**
     * @param command ImportBookingsFromDfdgRequest
     * @return ImportBookingsFromDfdgResponse
     */
    importBookingsFromDfdg(command: ImportBookingsFromDfdgRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command MassReassignBookingsRequest
     * @return MassReassignBookingsResponse
     */
    massReassignBookings(command: MassReassignBookingsRequest, cancelToken?: CancelToken): Promise<MassReassignBookingsResponse>;
    /**
     * @param command QueuePartialTranscriptionRequest
     * @return QueuePartialTranscriptionResponse
     */
    queuePartialTranscription(command: QueuePartialTranscriptionRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SetBookingRequest
     * @return SetBookingResponse
     */
    setBooking(command: SetBookingRequest, cancelToken?: CancelToken): Promise<SetBookingResponse>;
    /**
     * @param command SetInterviewRequest
     * @return SetInterviewResponse
     */
    setInterview(command: SetInterviewRequest, cancelToken?: CancelToken): Promise<SetInterviewResponse>;
    /**
     * @param command SetInterviewBookingDeadlineRequest
     * @return SetInterviewBookingDeadlineResponse
     */
    setInterviewBookingDeadline(command: SetInterviewBookingDeadlineRequest, cancelToken?: CancelToken): Promise<SetInterviewBookingDeadlineResponse>;
    /**
     * @param command StartInterpretingSessionRequest
     * @return StartInterpretingSessionResponse
     */
    startInterpretingSession(command: StartInterpretingSessionRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command TranscriptionSummaryRequest
     * @return TranscriptionSummaryResponse
     */
    transcriptionSummary(command: TranscriptionSummaryRequest, cancelToken?: CancelToken): Promise<TranscriptionSummaryResponse>;
    /**
     * @param command UpdateBookingRequest
     * @return UpdateBookingResponse
     */
    updateBooking(command: UpdateBookingRequest, cancelToken?: CancelToken): Promise<UpdateBookingResponse>;
    /**
     * @param command UpdateInterviewRequest
     * @return UpdateInterviewResponse
     */
    updateInterview(command: UpdateInterviewRequest, cancelToken?: CancelToken): Promise<UpdateInterviewResponse>;
    /**
     * @param command UpdateInterviewDeadlineRequest
     * @return UpdateInterviewDeadlineResponse
     */
    updateInterviewDeadline(command: UpdateInterviewDeadlineRequest, cancelToken?: CancelToken): Promise<UpdateInterviewDeadlineResponse>;
    /**
     * @param query GetActiveBookingsForCaseRequest
     * @return GetActiveBookingsForCaseResponse
     */
    getActiveBookingsForCase(query: GetActiveBookingsForCaseRequest, cancelToken?: CancelToken): Promise<GetActiveBookingsForCaseResponse>;
    /**
     * @return GetAttachmentSettingsResponse
     */
    getAttachmentSettings(cancelToken?: CancelToken): Promise<GetAttachmentSettingsResponse2>;
    /**
     * @param query GetBookingRequest
     * @return GetBookingResponse
     */
    getBooking(query: GetBookingRequest, cancelToken?: CancelToken): Promise<GetBookingResponse>;
    /**
     * @param query GetBookingLetterEditableContentRequest
     * @return GetBookingLetterEditableContentResponse
     */
    getBookingLetterEditableContent(query: GetBookingLetterEditableContentRequest, cancelToken?: CancelToken): Promise<GetBookingLetterEditableContentResponse>;
    /**
     * @param query GetBookingsByCitizenIdRequest
     * @return GetBookingsByCitizenIdResponse
     */
    getBookingsByCitizenId(query: GetBookingsByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetBookingsByCitizenIdResponse>;
    /**
     * @param query GetBookingsForCitizenRequest
     * @return GetBookingsForCitizenResponse
     */
    getBookingsForCitizen(query: GetBookingsForCitizenRequest, cancelToken?: CancelToken): Promise<GetBookingsForCitizenResponse>;
    /**
     * @param query GetBookingsForNuphRequest
     * @return GetBookingsForNuphResponse
     */
    getBookingsForNuph(query: GetBookingsForNuphRequest, cancelToken?: CancelToken): Promise<GetBookingsForNuphResponse>;
    /**
     * @param query GetBookInterviewGuideDataRequest
     * @return GetBookInterviewGuideDataResponse
     */
    getBookInterviewGuideData(query: GetBookInterviewGuideDataRequest, cancelToken?: CancelToken): Promise<GetBookInterviewGuideDataResponse>;
    /**
     * @return GetCancellationCauseTypesResponse
     */
    getCancellationCauseTypes(cancelToken?: CancelToken): Promise<GetCancellationCauseTypesResponse>;
    /**
     * @param query GetCaseworkerMeetingLocationDetailsRequest
     * @return GetCaseworkerMeetingLocationDetailsResponse
     */
    getCaseworkerMeetingLocationDetails(query: GetCaseworkerMeetingLocationDetailsRequest, cancelToken?: CancelToken): Promise<GetCaseworkerMeetingLocationDetailsResponse>;
    /**
     * @param query GetCompaniesRequest
     * @return GetCompaniesResponse
     */
    getCompanies(query: GetCompaniesRequest, cancelToken?: CancelToken): Promise<GetCompaniesResponse>;
    /**
     * @param query GetConductInterviewGuideDataRequest
     * @return GetConductInterviewGuideDataResponse
     */
    getConductInterviewGuideData(query: GetConductInterviewGuideDataRequest, cancelToken?: CancelToken): Promise<GetConductInterviewGuideDataResponse>;
    /**
     * @param query GetContactPersonsForCompanyRequest
     * @return GetContactPersonsForCompanyResponse
     */
    getContactPersonsForCompany(query: GetContactPersonsForCompanyRequest, cancelToken?: CancelToken): Promise<GetContactPersonsForCompanyResponse>;
    /**
     * @param query GetCrowdBookingGuideDataRequest
     * @return GetCrowdBookingGuideDataResponse
     */
    getCrowdBookingGuideData(query: GetCrowdBookingGuideDataRequest, cancelToken?: CancelToken): Promise<GetCrowdBookingGuideDataResponse>;
    /**
     * @param query GetCurrentPersonCategoryRequest
     * @return GetCurrentPersonCategoryResponse
     */
    getCurrentPersonCategory(query: GetCurrentPersonCategoryRequest, cancelToken?: CancelToken): Promise<GetCurrentPersonCategoryResponse>;
    /**
     * @param query GetDialogSupportInterviewConfigurationRequest
     * @return GetDialogSupportInterviewConfigurationResponse
     */
    getDialogSupportInterviewConfiguration(query: GetDialogSupportInterviewConfigurationRequest, cancelToken?: CancelToken): Promise<GetDialogSupportInterviewConfigurationResponse>;
    /**
     * @param query GetDialogSupportPromptsRequest
     * @return GetDialogSupportPromptsResponse
     */
    getDialogSupportPrompts(query: GetDialogSupportPromptsRequest, cancelToken?: CancelToken): Promise<GetDialogSupportPromptsResponse>;
    /**
     * @param query GetDocumentsForAliasesFromDocumentArchiveRequest
     * @return GetDocumentsForAliasesFromDocumentArchiveResponse
     */
    getDocumentsForAliasesFromDocumentArchive(query: GetDocumentsForAliasesFromDocumentArchiveRequest, cancelToken?: CancelToken): Promise<GetDocumentsForAliasesFromDocumentArchiveResponse>;
    /**
     * @param query GetDocumentsFromDocumentArchiveRequest
     * @return GetDocumentsFromDocumentArchiveResponse
     */
    getDocumentsFromDocumentArchive(query: GetDocumentsFromDocumentArchiveRequest, cancelToken?: CancelToken): Promise<GetDocumentsFromDocumentArchiveResponse>;
    /**
     * @param query GetInterpreterDataForConductingInterviewRequest
     * @return GetInterpreterDataForConductingInterviewResponse
     */
    getInterpreterDataForConductingInterview(query: GetInterpreterDataForConductingInterviewRequest, cancelToken?: CancelToken): Promise<GetInterpreterDataForConductingInterviewResponse>;
    /**
     * @param query GetInterviewRequest
     * @return GetInterviewResponse
     */
    getInterview(query: GetInterviewRequest, cancelToken?: CancelToken): Promise<GetInterviewResponse>;
    /**
     * @param query GetInterviewAgreementTemplateRequest
     * @return GetInterviewAgreementTemplateResponse
     */
    getInterviewAgreementTemplate(query: GetInterviewAgreementTemplateRequest, cancelToken?: CancelToken): Promise<GetInterviewAgreementTemplateResponse>;
    /**
     * @param query GetInterviewBookingDeadlineRequest
     * @return GetInterviewBookingDeadlineResponse
     */
    getInterviewBookingDeadline(query: GetInterviewBookingDeadlineRequest, cancelToken?: CancelToken): Promise<GetInterviewBookingDeadlineResponse>;
    /**
     * @return GetInterviewContactTypesResponse
     */
    getInterviewContactTypes(cancelToken?: CancelToken): Promise<GetInterviewContactTypesResponse>;
    /**
     * @param query GetJournalNoteIdRequest
     * @return GetInterviewCorrectableStatusResponse
     */
    getInterviewCorrectableStatus(query: GetJournalNoteIdRequest, cancelToken?: CancelToken): Promise<GetInterviewCorrectableStatusResponse>;
    /**
     * @param query GetInterviewOverviewStatRequest
     * @return GetInterviewOverviewStatResponse
     */
    getInterviewOverviewStat(query: GetInterviewOverviewStatRequest, cancelToken?: CancelToken): Promise<GetInterviewOverviewStatResponse>;
    /**
     * @param query GetInterviewsForCitizenRequest
     * @return GetInterviewsForCitizenResponse
     */
    getInterviewsForCitizen(query: GetInterviewsForCitizenRequest, cancelToken?: CancelToken): Promise<GetInterviewsForCitizenResponse>;
    /**
     * @param query GetInterviewSummaryRequest
     * @return GetInterviewSummaryResponse
     */
    getInterviewSummary(query: GetInterviewSummaryRequest, cancelToken?: CancelToken): Promise<GetInterviewSummaryResponse>;
    /**
     * @param query GetInterviewTypesForTargetGroupRequest
     * @return GetInterviewTypesForTargetGroupResponse
     */
    getInterviewTypesForTargetGroup(query: GetInterviewTypesForTargetGroupRequest, cancelToken?: CancelToken): Promise<GetInterviewTypesForTargetGroupResponse>;
    /**
     * @param query GetInterviewUnemploymentForCitizenRequest
     * @return GetInterviewUnemploymentForCitizenResponse
     */
    getInterviewUnemploymentForCitizen(query: GetInterviewUnemploymentForCitizenRequest, cancelToken?: CancelToken): Promise<GetInterviewUnemploymentForCitizenResponse>;
    /**
     * @return GetMedComVdxSettingsResponse
     */
    getMedComVdxSettings(cancelToken?: CancelToken): Promise<GetMedComVdxSettingsResponse>;
    /**
     * @param query GetNextInterviewDataRequest
     * @return GetNextInterviewDataResponse
     */
    getNextInterviewData(query: GetNextInterviewDataRequest, cancelToken?: CancelToken): Promise<GetNextInterviewDataResponse>;
    /**
     * @param query GetOverviewMenuActionDataRequest
     * @return GetOverviewMenuActionDataResponse
     */
    getOverviewMenuActionData(query: GetOverviewMenuActionDataRequest, cancelToken?: CancelToken): Promise<GetOverviewMenuActionDataResponse>;
    /**
     * @param query GetPdfPreviewRequest
     * @return FileResponse
     */
    getPdfPreview(query: GetPdfPreviewRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetPersonCategoryGuideDataRequest
     * @return GetPersonCategoryGuideDataResponse
     */
    getPersonCategoryGuideData(query: GetPersonCategoryGuideDataRequest, cancelToken?: CancelToken): Promise<GetPersonCategoryGuideDataResponse>;
    /**
     * @param query GetPreviousInterviewAgreementRequest
     * @return GetPreviousInterviewAgreementResponse
     */
    getPreviousInterviewAgreement(query: GetPreviousInterviewAgreementRequest, cancelToken?: CancelToken): Promise<GetPreviousInterviewAgreementResponse>;
    /**
     * @param query GetPrivateContactPersonsRequest
     * @return GetPrivateContactPersonsResponse
     */
    getPrivateContactPersons(query: GetPrivateContactPersonsRequest, cancelToken?: CancelToken): Promise<GetPrivateContactPersonsResponse>;
    /**
     * @param query GetRankedCasesForInterviewJournalizationRequest
     * @return GetRankedCasesForInterviewJournalizationResponse
     */
    getRankedCasesForInterviewJournalization(query: GetRankedCasesForInterviewJournalizationRequest, cancelToken?: CancelToken): Promise<GetRankedCasesForInterviewJournalizationResponse>;
    /**
     * @param query GetStandardAttachmentDocumentsFromArchiveRequest
     * @return GetStandardAttachmentDocumentsFromArchiveResponse
     */
    getStandardAttachmentDocumentsFromArchive(query: GetStandardAttachmentDocumentsFromArchiveRequest, cancelToken?: CancelToken): Promise<GetStandardAttachmentDocumentsFromArchiveResponse>;
    /**
     * @return Int32
     */
    getStandardAttachmentObjectTypeCode(cancelToken?: CancelToken): Promise<number>;
    /**
     * @param query GetTranscriptionBySessionIdRequest
     * @return GetTranscriptionBySessionIdResponse
     */
    getTranscriptionBySessionId(query: GetTranscriptionBySessionIdRequest, cancelToken?: CancelToken): Promise<GetTranscriptionBySessionIdResponse>;
    /**
     * @param query IsCitizenCprActiveRequest
     * @return IsCitizenCprActiveResponse
     */
    isCitizenCprActive(query: IsCitizenCprActiveRequest, cancelToken?: CancelToken): Promise<IsCitizenCprActiveResponse>;
    /**
     * @param query IsCitizenInTargetGroupRequest
     * @return IsCitizenInTargetGroupResponse
     */
    isCitizenInTargetGroup(query: IsCitizenInTargetGroupRequest, cancelToken?: CancelToken): Promise<IsCitizenInTargetGroupResponse>;
    /**
     * @param query RecalculateInterviewOverviewRequest
     * @return RecalculateInterviewOverviewResponse
     */
    recalculateInterviewOverview(query: RecalculateInterviewOverviewRequest, cancelToken?: CancelToken): Promise<RecalculateInterviewOverviewResponse>;
}

export class CitizenInterviewClient implements ICitizenInterviewClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command AbortInterviewGuideDraftRequest
     * @return AbortInterviewGuideDraftResponse
     */
    abortInterviewGuideDraft(command: AbortInterviewGuideDraftRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/abortinterviewguidedraft`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CancelBookingRequest
     * @return CancelBookingResponse
     */
    cancelBooking(command: CancelBookingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/cancelbooking`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CancelBookingsForCaseRequest
     * @return CancelBookingsForCaseResponse
     */
    cancelBookingsForCase(command: CancelBookingsForCaseRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/cancelbookingsforcase`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CompleteBookingRequest
     * @return CompleteBookingResponse
     */
    completeBooking(command: CompleteBookingRequest, cancelToken?: CancelToken): Promise<CompleteBookingResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/completebooking`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CompleteCrowdBookingRequest
     * @return CompleteCrowdBookingResponse
     */
    completeCrowdBooking(command: CompleteCrowdBookingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/completecrowdbooking`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CompleteInterviewRequest
     * @return CompleteInterviewResponse
     */
    completeInterview(command: CompleteInterviewRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/completeinterview`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCvAttachmentRequest
     * @return CreateCvAttachmentResponse
     */
    createCvAttachment(command: CreateCvAttachmentRequest, cancelToken?: CancelToken): Promise<CreateCvAttachmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/createcvattachment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateNextInterviewReminderRequest
     * @return CreateNextInterviewReminderResponse
     */
    createNextInterviewReminder(command: CreateNextInterviewReminderRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/createnextinterviewreminder`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreatePersonCategoryRequest
     * @return CreatePersonCategoryResponse
     */
    createPersonCategory(command: CreatePersonCategoryRequest, cancelToken?: CancelToken): Promise<CreatePersonCategoryResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/createpersoncategory`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteBookingDraftRequest
     * @return DeleteBookingDraftResponse
     */
    deleteBookingDraft(command: DeleteBookingDraftRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/deletebookingdraft`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteInterviewDraftRequest
     * @return DeleteInterviewDraftResponse
     */
    deleteInterviewDraft(command: DeleteInterviewDraftRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/deleteinterviewdraft`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command EvaluateSummaryRequest
     * @return EvaluateSummaryResponse
     */
    evaluateSummary(command: EvaluateSummaryRequest, cancelToken?: CancelToken): Promise<EvaluateSummaryResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/evaluatesummary`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ImportBookingsFromDfdgRequest
     * @return ImportBookingsFromDfdgResponse
     */
    importBookingsFromDfdg(command: ImportBookingsFromDfdgRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/importbookingsfromdfdg`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command MassReassignBookingsRequest
     * @return MassReassignBookingsResponse
     */
    massReassignBookings(command: MassReassignBookingsRequest, cancelToken?: CancelToken): Promise<MassReassignBookingsResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/massreassignbookings`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command QueuePartialTranscriptionRequest
     * @return QueuePartialTranscriptionResponse
     */
    queuePartialTranscription(command: QueuePartialTranscriptionRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/queuepartialtranscription`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetBookingRequest
     * @return SetBookingResponse
     */
    setBooking(command: SetBookingRequest, cancelToken?: CancelToken): Promise<SetBookingResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/setbooking`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetInterviewRequest
     * @return SetInterviewResponse
     */
    setInterview(command: SetInterviewRequest, cancelToken?: CancelToken): Promise<SetInterviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/setinterview`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetInterviewBookingDeadlineRequest
     * @return SetInterviewBookingDeadlineResponse
     */
    setInterviewBookingDeadline(command: SetInterviewBookingDeadlineRequest, cancelToken?: CancelToken): Promise<SetInterviewBookingDeadlineResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/setinterviewbookingdeadline`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command StartInterpretingSessionRequest
     * @return StartInterpretingSessionResponse
     */
    startInterpretingSession(command: StartInterpretingSessionRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/startinterpretingsession`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command TranscriptionSummaryRequest
     * @return TranscriptionSummaryResponse
     */
    transcriptionSummary(command: TranscriptionSummaryRequest, cancelToken?: CancelToken): Promise<TranscriptionSummaryResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/transcriptionsummary`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateBookingRequest
     * @return UpdateBookingResponse
     */
    updateBooking(command: UpdateBookingRequest, cancelToken?: CancelToken): Promise<UpdateBookingResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/updatebooking`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateInterviewRequest
     * @return UpdateInterviewResponse
     */
    updateInterview(command: UpdateInterviewRequest, cancelToken?: CancelToken): Promise<UpdateInterviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/updateinterview`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateInterviewDeadlineRequest
     * @return UpdateInterviewDeadlineResponse
     */
    updateInterviewDeadline(command: UpdateInterviewDeadlineRequest, cancelToken?: CancelToken): Promise<UpdateInterviewDeadlineResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/commands/updateinterviewdeadline`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActiveBookingsForCaseRequest
     * @return GetActiveBookingsForCaseResponse
     */
    getActiveBookingsForCase(query: GetActiveBookingsForCaseRequest, cancelToken?: CancelToken): Promise<GetActiveBookingsForCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getactivebookingsforcase`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAttachmentSettingsResponse
     */
    getAttachmentSettings(cancelToken?: CancelToken): Promise<GetAttachmentSettingsResponse2> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getattachmentsettings`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetBookingRequest
     * @return GetBookingResponse
     */
    getBooking(query: GetBookingRequest, cancelToken?: CancelToken): Promise<GetBookingResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getbooking`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetBookingLetterEditableContentRequest
     * @return GetBookingLetterEditableContentResponse
     */
    getBookingLetterEditableContent(query: GetBookingLetterEditableContentRequest, cancelToken?: CancelToken): Promise<GetBookingLetterEditableContentResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getbookinglettereditablecontent`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetBookingsByCitizenIdRequest
     * @return GetBookingsByCitizenIdResponse
     */
    getBookingsByCitizenId(query: GetBookingsByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetBookingsByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getbookingsbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetBookingsForCitizenRequest
     * @return GetBookingsForCitizenResponse
     */
    getBookingsForCitizen(query: GetBookingsForCitizenRequest, cancelToken?: CancelToken): Promise<GetBookingsForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getbookingsforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetBookingsForNuphRequest
     * @return GetBookingsForNuphResponse
     */
    getBookingsForNuph(query: GetBookingsForNuphRequest, cancelToken?: CancelToken): Promise<GetBookingsForNuphResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getbookingsfornuph`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetBookInterviewGuideDataRequest
     * @return GetBookInterviewGuideDataResponse
     */
    getBookInterviewGuideData(query: GetBookInterviewGuideDataRequest, cancelToken?: CancelToken): Promise<GetBookInterviewGuideDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getbookinterviewguidedata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCancellationCauseTypesResponse
     */
    getCancellationCauseTypes(cancelToken?: CancelToken): Promise<GetCancellationCauseTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getcancellationcausetypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseworkerMeetingLocationDetailsRequest
     * @return GetCaseworkerMeetingLocationDetailsResponse
     */
    getCaseworkerMeetingLocationDetails(query: GetCaseworkerMeetingLocationDetailsRequest, cancelToken?: CancelToken): Promise<GetCaseworkerMeetingLocationDetailsResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getcaseworkermeetinglocationdetails`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompaniesRequest
     * @return GetCompaniesResponse
     */
    getCompanies(query: GetCompaniesRequest, cancelToken?: CancelToken): Promise<GetCompaniesResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getcompanies`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetConductInterviewGuideDataRequest
     * @return GetConductInterviewGuideDataResponse
     */
    getConductInterviewGuideData(query: GetConductInterviewGuideDataRequest, cancelToken?: CancelToken): Promise<GetConductInterviewGuideDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getconductinterviewguidedata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetContactPersonsForCompanyRequest
     * @return GetContactPersonsForCompanyResponse
     */
    getContactPersonsForCompany(query: GetContactPersonsForCompanyRequest, cancelToken?: CancelToken): Promise<GetContactPersonsForCompanyResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getcontactpersonsforcompany`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCrowdBookingGuideDataRequest
     * @return GetCrowdBookingGuideDataResponse
     */
    getCrowdBookingGuideData(query: GetCrowdBookingGuideDataRequest, cancelToken?: CancelToken): Promise<GetCrowdBookingGuideDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getcrowdbookingguidedata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCurrentPersonCategoryRequest
     * @return GetCurrentPersonCategoryResponse
     */
    getCurrentPersonCategory(query: GetCurrentPersonCategoryRequest, cancelToken?: CancelToken): Promise<GetCurrentPersonCategoryResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getcurrentpersoncategory`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDialogSupportInterviewConfigurationRequest
     * @return GetDialogSupportInterviewConfigurationResponse
     */
    getDialogSupportInterviewConfiguration(query: GetDialogSupportInterviewConfigurationRequest, cancelToken?: CancelToken): Promise<GetDialogSupportInterviewConfigurationResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getdialogsupportinterviewconfiguration`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDialogSupportPromptsRequest
     * @return GetDialogSupportPromptsResponse
     */
    getDialogSupportPrompts(query: GetDialogSupportPromptsRequest, cancelToken?: CancelToken): Promise<GetDialogSupportPromptsResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getdialogsupportprompts`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDocumentsForAliasesFromDocumentArchiveRequest
     * @return GetDocumentsForAliasesFromDocumentArchiveResponse
     */
    getDocumentsForAliasesFromDocumentArchive(query: GetDocumentsForAliasesFromDocumentArchiveRequest, cancelToken?: CancelToken): Promise<GetDocumentsForAliasesFromDocumentArchiveResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getdocumentsforaliasesfromdocumentarchive`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDocumentsFromDocumentArchiveRequest
     * @return GetDocumentsFromDocumentArchiveResponse
     */
    getDocumentsFromDocumentArchive(query: GetDocumentsFromDocumentArchiveRequest, cancelToken?: CancelToken): Promise<GetDocumentsFromDocumentArchiveResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getdocumentsfromdocumentarchive`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterpreterDataForConductingInterviewRequest
     * @return GetInterpreterDataForConductingInterviewResponse
     */
    getInterpreterDataForConductingInterview(query: GetInterpreterDataForConductingInterviewRequest, cancelToken?: CancelToken): Promise<GetInterpreterDataForConductingInterviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getinterpreterdataforconductinginterview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterviewRequest
     * @return GetInterviewResponse
     */
    getInterview(query: GetInterviewRequest, cancelToken?: CancelToken): Promise<GetInterviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getinterview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterviewAgreementTemplateRequest
     * @return GetInterviewAgreementTemplateResponse
     */
    getInterviewAgreementTemplate(query: GetInterviewAgreementTemplateRequest, cancelToken?: CancelToken): Promise<GetInterviewAgreementTemplateResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getinterviewagreementtemplate`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterviewBookingDeadlineRequest
     * @return GetInterviewBookingDeadlineResponse
     */
    getInterviewBookingDeadline(query: GetInterviewBookingDeadlineRequest, cancelToken?: CancelToken): Promise<GetInterviewBookingDeadlineResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getinterviewbookingdeadline`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetInterviewContactTypesResponse
     */
    getInterviewContactTypes(cancelToken?: CancelToken): Promise<GetInterviewContactTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getinterviewcontacttypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalNoteIdRequest
     * @return GetInterviewCorrectableStatusResponse
     */
    getInterviewCorrectableStatus(query: GetJournalNoteIdRequest, cancelToken?: CancelToken): Promise<GetInterviewCorrectableStatusResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getinterviewcorrectablestatus`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterviewOverviewStatRequest
     * @return GetInterviewOverviewStatResponse
     */
    getInterviewOverviewStat(query: GetInterviewOverviewStatRequest, cancelToken?: CancelToken): Promise<GetInterviewOverviewStatResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getinterviewoverviewstat`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterviewsForCitizenRequest
     * @return GetInterviewsForCitizenResponse
     */
    getInterviewsForCitizen(query: GetInterviewsForCitizenRequest, cancelToken?: CancelToken): Promise<GetInterviewsForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getinterviewsforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterviewSummaryRequest
     * @return GetInterviewSummaryResponse
     */
    getInterviewSummary(query: GetInterviewSummaryRequest, cancelToken?: CancelToken): Promise<GetInterviewSummaryResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getinterviewsummary`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterviewTypesForTargetGroupRequest
     * @return GetInterviewTypesForTargetGroupResponse
     */
    getInterviewTypesForTargetGroup(query: GetInterviewTypesForTargetGroupRequest, cancelToken?: CancelToken): Promise<GetInterviewTypesForTargetGroupResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getinterviewtypesfortargetgroup`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterviewUnemploymentForCitizenRequest
     * @return GetInterviewUnemploymentForCitizenResponse
     */
    getInterviewUnemploymentForCitizen(query: GetInterviewUnemploymentForCitizenRequest, cancelToken?: CancelToken): Promise<GetInterviewUnemploymentForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getinterviewunemploymentforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetMedComVdxSettingsResponse
     */
    getMedComVdxSettings(cancelToken?: CancelToken): Promise<GetMedComVdxSettingsResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getmedcomvdxsettings`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNextInterviewDataRequest
     * @return GetNextInterviewDataResponse
     */
    getNextInterviewData(query: GetNextInterviewDataRequest, cancelToken?: CancelToken): Promise<GetNextInterviewDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getnextinterviewdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOverviewMenuActionDataRequest
     * @return GetOverviewMenuActionDataResponse
     */
    getOverviewMenuActionData(query: GetOverviewMenuActionDataRequest, cancelToken?: CancelToken): Promise<GetOverviewMenuActionDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getoverviewmenuactiondata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPdfPreviewRequest
     * @return FileResponse
     */
    getPdfPreview(query: GetPdfPreviewRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getpdfpreview`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPersonCategoryGuideDataRequest
     * @return GetPersonCategoryGuideDataResponse
     */
    getPersonCategoryGuideData(query: GetPersonCategoryGuideDataRequest, cancelToken?: CancelToken): Promise<GetPersonCategoryGuideDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getpersoncategoryguidedata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPreviousInterviewAgreementRequest
     * @return GetPreviousInterviewAgreementResponse
     */
    getPreviousInterviewAgreement(query: GetPreviousInterviewAgreementRequest, cancelToken?: CancelToken): Promise<GetPreviousInterviewAgreementResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getpreviousinterviewagreement`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPrivateContactPersonsRequest
     * @return GetPrivateContactPersonsResponse
     */
    getPrivateContactPersons(query: GetPrivateContactPersonsRequest, cancelToken?: CancelToken): Promise<GetPrivateContactPersonsResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getprivatecontactpersons`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetRankedCasesForInterviewJournalizationRequest
     * @return GetRankedCasesForInterviewJournalizationResponse
     */
    getRankedCasesForInterviewJournalization(query: GetRankedCasesForInterviewJournalizationRequest, cancelToken?: CancelToken): Promise<GetRankedCasesForInterviewJournalizationResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getrankedcasesforinterviewjournalization`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetStandardAttachmentDocumentsFromArchiveRequest
     * @return GetStandardAttachmentDocumentsFromArchiveResponse
     */
    getStandardAttachmentDocumentsFromArchive(query: GetStandardAttachmentDocumentsFromArchiveRequest, cancelToken?: CancelToken): Promise<GetStandardAttachmentDocumentsFromArchiveResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getstandardattachmentdocumentsfromarchive`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return Int32
     */
    getStandardAttachmentObjectTypeCode(cancelToken?: CancelToken): Promise<number> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/getstandardattachmentobjecttypecode`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTranscriptionBySessionIdRequest
     * @return GetTranscriptionBySessionIdResponse
     */
    getTranscriptionBySessionId(query: GetTranscriptionBySessionIdRequest, cancelToken?: CancelToken): Promise<GetTranscriptionBySessionIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/gettranscriptionbysessionid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query IsCitizenCprActiveRequest
     * @return IsCitizenCprActiveResponse
     */
    isCitizenCprActive(query: IsCitizenCprActiveRequest, cancelToken?: CancelToken): Promise<IsCitizenCprActiveResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/iscitizencpractive`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query IsCitizenInTargetGroupRequest
     * @return IsCitizenInTargetGroupResponse
     */
    isCitizenInTargetGroup(query: IsCitizenInTargetGroupRequest, cancelToken?: CancelToken): Promise<IsCitizenInTargetGroupResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/iscitizenintargetgroup`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query RecalculateInterviewOverviewRequest
     * @return RecalculateInterviewOverviewResponse
     */
    recalculateInterviewOverview(query: RecalculateInterviewOverviewRequest, cancelToken?: CancelToken): Promise<RecalculateInterviewOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/interview/queries/recalculateinterviewoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenGrantClient {
    /**
     * @param command CreateGrantRequest
     * @return CreateGrantResponse
     */
    createGrant(command: CreateGrantRequest, cancelToken?: CancelToken): Promise<CreateGrantResponse>;
    /**
     * @param command DeleteGrantRequest
     * @return DeleteGrantResponse
     */
    deleteGrant(command: DeleteGrantRequest, cancelToken?: CancelToken): Promise<DeleteGrantResponse>;
    /**
     * @param command ExtendGrantRequest
     * @return ExtendGrantResponse
     */
    extendGrant(command: ExtendGrantRequest, cancelToken?: CancelToken): Promise<ExtendGrantResponse>;
    /**
     * @param command TerminateGrantRequest
     * @return TerminateGrantResponse
     */
    terminateGrant(command: TerminateGrantRequest, cancelToken?: CancelToken): Promise<TerminateGrantResponse>;
    /**
     * @param command UpdateGrantRequest
     * @return UpdateGrantResponse
     */
    updateGrant(command: UpdateGrantRequest, cancelToken?: CancelToken): Promise<UpdateGrantResponse>;
    /**
     * @return GetBenefitFFBTypesResponse
     */
    getBenefitFFBTypes(cancelToken?: CancelToken): Promise<GetBenefitFFBTypesResponse>;
    /**
     * @return GetBenefitTypesResponse
     */
    getBenefitTypes(cancelToken?: CancelToken): Promise<GetBenefitTypesResponse>;
    /**
     * @param query GetCasesForGrantRequest
     * @return GetCasesForGrantResponse
     */
    getCasesForGrant(query: GetCasesForGrantRequest, cancelToken?: CancelToken): Promise<GetCasesForGrantResponse>;
    /**
     * @param query GetCitizenIdByGrantIdRequest
     * @return GetCitizenIdByGrantIdResponse
     */
    getCitizenIdByGrantId(query: GetCitizenIdByGrantIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByGrantIdResponse>;
    /**
     * @param query GetGrantByIdRequest
     * @return GetGrantByIdResponse
     */
    getGrantById(query: GetGrantByIdRequest, cancelToken?: CancelToken): Promise<GetGrantByIdResponse>;
    /**
     * @param query GetGrantsByCaseIdRequest
     * @return GetGrantsByCaseIdResponse
     */
    getGrantsByCaseId(query: GetGrantsByCaseIdRequest, cancelToken?: CancelToken): Promise<GetGrantsByCaseIdResponse>;
    /**
     * @return GetGrantTypesResponse
     */
    getGrantTypes(cancelToken?: CancelToken): Promise<GetGrantTypesResponse>;
    /**
     * @param query GetOfferByIdForGrantSelectionRequest
     * @return GetOfferByIdForGrantSelectionResponse
     */
    getOfferByIdForGrantSelection(query: GetOfferByIdForGrantSelectionRequest, cancelToken?: CancelToken): Promise<GetOfferByIdForGrantSelectionResponse>;
    /**
     * @param query GetOffersForGrantSelectionRequest
     * @return GetOffersForGrantSelectionResponse
     */
    getOffersForGrantSelection(query: GetOffersForGrantSelectionRequest, cancelToken?: CancelToken): Promise<GetOffersForGrantSelectionResponse>;
}

export class CitizenGrantClient implements ICitizenGrantClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateGrantRequest
     * @return CreateGrantResponse
     */
    createGrant(command: CreateGrantRequest, cancelToken?: CancelToken): Promise<CreateGrantResponse> {
        const $url = `${this.baseUrl}/api/citizen/grant/commands/creategrant`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteGrantRequest
     * @return DeleteGrantResponse
     */
    deleteGrant(command: DeleteGrantRequest, cancelToken?: CancelToken): Promise<DeleteGrantResponse> {
        const $url = `${this.baseUrl}/api/citizen/grant/commands/deletegrant`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ExtendGrantRequest
     * @return ExtendGrantResponse
     */
    extendGrant(command: ExtendGrantRequest, cancelToken?: CancelToken): Promise<ExtendGrantResponse> {
        const $url = `${this.baseUrl}/api/citizen/grant/commands/extendgrant`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command TerminateGrantRequest
     * @return TerminateGrantResponse
     */
    terminateGrant(command: TerminateGrantRequest, cancelToken?: CancelToken): Promise<TerminateGrantResponse> {
        const $url = `${this.baseUrl}/api/citizen/grant/commands/terminategrant`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateGrantRequest
     * @return UpdateGrantResponse
     */
    updateGrant(command: UpdateGrantRequest, cancelToken?: CancelToken): Promise<UpdateGrantResponse> {
        const $url = `${this.baseUrl}/api/citizen/grant/commands/updategrant`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetBenefitFFBTypesResponse
     */
    getBenefitFFBTypes(cancelToken?: CancelToken): Promise<GetBenefitFFBTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/grant/queries/getbenefitffbtypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetBenefitTypesResponse
     */
    getBenefitTypes(cancelToken?: CancelToken): Promise<GetBenefitTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/grant/queries/getbenefittypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCasesForGrantRequest
     * @return GetCasesForGrantResponse
     */
    getCasesForGrant(query: GetCasesForGrantRequest, cancelToken?: CancelToken): Promise<GetCasesForGrantResponse> {
        const $url = `${this.baseUrl}/api/citizen/grant/queries/getcasesforgrant`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenIdByGrantIdRequest
     * @return GetCitizenIdByGrantIdResponse
     */
    getCitizenIdByGrantId(query: GetCitizenIdByGrantIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdByGrantIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/grant/queries/getcitizenidbygrantid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetGrantByIdRequest
     * @return GetGrantByIdResponse
     */
    getGrantById(query: GetGrantByIdRequest, cancelToken?: CancelToken): Promise<GetGrantByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/grant/queries/getgrantbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetGrantsByCaseIdRequest
     * @return GetGrantsByCaseIdResponse
     */
    getGrantsByCaseId(query: GetGrantsByCaseIdRequest, cancelToken?: CancelToken): Promise<GetGrantsByCaseIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/grant/queries/getgrantsbycaseid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetGrantTypesResponse
     */
    getGrantTypes(cancelToken?: CancelToken): Promise<GetGrantTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/grant/queries/getgranttypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferByIdForGrantSelectionRequest
     * @return GetOfferByIdForGrantSelectionResponse
     */
    getOfferByIdForGrantSelection(query: GetOfferByIdForGrantSelectionRequest, cancelToken?: CancelToken): Promise<GetOfferByIdForGrantSelectionResponse> {
        const $url = `${this.baseUrl}/api/citizen/grant/queries/getofferbyidforgrantselection`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOffersForGrantSelectionRequest
     * @return GetOffersForGrantSelectionResponse
     */
    getOffersForGrantSelection(query: GetOffersForGrantSelectionRequest, cancelToken?: CancelToken): Promise<GetOffersForGrantSelectionResponse> {
        const $url = `${this.baseUrl}/api/citizen/grant/queries/getoffersforgrantselection`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenEducationEventClient {
    /**
     * @param command CancelEducationSubscriptionRequest
     * @return CancelEducationSubscriptionResponse
     */
    cancelEducationSubscription(command: CancelEducationSubscriptionRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateEducationSubscriptionRequest
     * @return CreateEducationSubscriptionResponse
     */
    createEducationSubscription(command: CreateEducationSubscriptionRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetEducationEventsByCitizenIdRequest
     * @return GetEducationEventsByCitizenIdResponse
     */
    getEducationEventsByCitizenId(query: GetEducationEventsByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetEducationEventsByCitizenIdResponse>;
    /**
     * @param query GetEducationSubscriptionByCitizenIdRequest
     * @return GetEducationSubscriptionByCitizenIdResponse
     */
    getEducationSubscriptionByCitizenId(query: GetEducationSubscriptionByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetEducationSubscriptionByCitizenIdResponse>;
}

export class CitizenEducationEventClient implements ICitizenEducationEventClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CancelEducationSubscriptionRequest
     * @return CancelEducationSubscriptionResponse
     */
    cancelEducationSubscription(command: CancelEducationSubscriptionRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/educationevent/commands/canceleducationsubscription`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateEducationSubscriptionRequest
     * @return CreateEducationSubscriptionResponse
     */
    createEducationSubscription(command: CreateEducationSubscriptionRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/educationevent/commands/createeducationsubscription`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEducationEventsByCitizenIdRequest
     * @return GetEducationEventsByCitizenIdResponse
     */
    getEducationEventsByCitizenId(query: GetEducationEventsByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetEducationEventsByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/educationevent/queries/geteducationeventsbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEducationSubscriptionByCitizenIdRequest
     * @return GetEducationSubscriptionByCitizenIdResponse
     */
    getEducationSubscriptionByCitizenId(query: GetEducationSubscriptionByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetEducationSubscriptionByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/educationevent/queries/geteducationsubscriptionbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenDiaryClient {
    /**
     * @param command MarkDiaryNotesAsReadRequest
     * @return MarkDiaryNotesAsReadResponse
     */
    markDiaryNotesAsRead(command: MarkDiaryNotesAsReadRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ReviseDiaryNoteRequest
     * @return ReviseDiaryNoteResponse
     */
    reviseDiaryNote(command: ReviseDiaryNoteRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ReviseStatusDiaryNoteRequest
     * @return ReviseStatusDiaryNoteResponse
     */
    reviseStatusDiaryNote(command: ReviseStatusDiaryNoteRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateDiaryNoteMetadataRequest
     * @return UpdateDiaryNoteMetadataResponse
     */
    updateDiaryNoteMetadata(command: UpdateDiaryNoteMetadataRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query DownloadDiaryNoteAttachmentRequest
     * @return FileResponse
     */
    downloadDiaryNoteAttachment(query: DownloadDiaryNoteAttachmentRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetDiaryNoteRequest
     * @return GetDiaryNoteResponse
     */
    getDiaryNote(query: GetDiaryNoteRequest, cancelToken?: CancelToken): Promise<GetDiaryNoteResponse>;
    /**
     * @param query GetDiaryNotesForCitizenIdRequest
     * @return GetDiaryNotesForCitizenIdResponse
     */
    getDiaryNotesForCitizenId(query: GetDiaryNotesForCitizenIdRequest, cancelToken?: CancelToken): Promise<GetDiaryNotesForCitizenIdResponse>;
    /**
     * @param query HasUnreadDiaryNotesRequest
     * @return HasUnreadDiaryNotesResponse
     */
    hasUnreadDiaryNotes(query: HasUnreadDiaryNotesRequest, cancelToken?: CancelToken): Promise<HasUnreadDiaryNotesResponse>;
    /**
     * @param query CreateDiaryNoteRequest
     * @return CreateDiaryNoteResponse
     */
    createDiaryNote(query: CreateDiaryNoteRequest, cancelToken?: CancelToken): Promise<CreateDiaryNoteResponse>;
    /**
     * @param query GenerateSummaryForDiaryNoteTranscriptionRequest
     * @return GenerateSummaryForDiaryNoteTranscriptionResponse
     */
    generateSummaryForDiaryNoteTranscription(query: GenerateSummaryForDiaryNoteTranscriptionRequest, cancelToken?: CancelToken): Promise<GenerateSummaryForDiaryNoteTranscriptionResponse>;
}

export class CitizenDiaryClient implements ICitizenDiaryClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command MarkDiaryNotesAsReadRequest
     * @return MarkDiaryNotesAsReadResponse
     */
    markDiaryNotesAsRead(command: MarkDiaryNotesAsReadRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/diary/commands/markdiarynotesasread`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReviseDiaryNoteRequest
     * @return ReviseDiaryNoteResponse
     */
    reviseDiaryNote(command: ReviseDiaryNoteRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/diary/commands/revisediarynote`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReviseStatusDiaryNoteRequest
     * @return ReviseStatusDiaryNoteResponse
     */
    reviseStatusDiaryNote(command: ReviseStatusDiaryNoteRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/diary/commands/revisestatusdiarynote`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateDiaryNoteMetadataRequest
     * @return UpdateDiaryNoteMetadataResponse
     */
    updateDiaryNoteMetadata(command: UpdateDiaryNoteMetadataRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/diary/commands/updatediarynotemetadata`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DownloadDiaryNoteAttachmentRequest
     * @return FileResponse
     */
    downloadDiaryNoteAttachment(query: DownloadDiaryNoteAttachmentRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/diary/queries/downloaddiarynoteattachment`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDiaryNoteRequest
     * @return GetDiaryNoteResponse
     */
    getDiaryNote(query: GetDiaryNoteRequest, cancelToken?: CancelToken): Promise<GetDiaryNoteResponse> {
        const $url = `${this.baseUrl}/api/citizen/diary/queries/getdiarynote`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDiaryNotesForCitizenIdRequest
     * @return GetDiaryNotesForCitizenIdResponse
     */
    getDiaryNotesForCitizenId(query: GetDiaryNotesForCitizenIdRequest, cancelToken?: CancelToken): Promise<GetDiaryNotesForCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/diary/queries/getdiarynotesforcitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query HasUnreadDiaryNotesRequest
     * @return HasUnreadDiaryNotesResponse
     */
    hasUnreadDiaryNotes(query: HasUnreadDiaryNotesRequest, cancelToken?: CancelToken): Promise<HasUnreadDiaryNotesResponse> {
        const $url = `${this.baseUrl}/api/citizen/diary/queries/hasunreaddiarynotes`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query CreateDiaryNoteRequest
     * @return CreateDiaryNoteResponse
     */
    createDiaryNote(query: CreateDiaryNoteRequest, cancelToken?: CancelToken): Promise<CreateDiaryNoteResponse> {
        const $url = `${this.baseUrl}/api/citizen/diary/queries/creatediarynote`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GenerateSummaryForDiaryNoteTranscriptionRequest
     * @return GenerateSummaryForDiaryNoteTranscriptionResponse
     */
    generateSummaryForDiaryNoteTranscription(query: GenerateSummaryForDiaryNoteTranscriptionRequest, cancelToken?: CancelToken): Promise<GenerateSummaryForDiaryNoteTranscriptionResponse> {
        const $url = `${this.baseUrl}/api/citizen/diary/queries/generatesummaryfordiarynotetranscription`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenDialogClient {
    /**
     * @param command CloseCitizenMessageRequest
     * @return CloseCitizenMessageResponse
     */
    closeCitizenMessage(command: CloseCitizenMessageRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateUnemploymentFundCitizenMessageRequest
     * @return CreateUnemploymentFundCitizenMessageResponse
     */
    createUnemploymentFundCitizenMessage(command: CreateUnemploymentFundCitizenMessageRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ReplyCitizenMessageRequest
     * @return ReplyCitizenMessageResponse
     */
    replyCitizenMessage(command: ReplyCitizenMessageRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetCitizenMessageAttachmentRequest
     * @return FileResponse
     */
    getCitizenMessageAttachment(query: GetCitizenMessageAttachmentRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetCitizenMessageByIdRequest
     * @return GetCitizenMessageByIdResponse
     */
    getCitizenMessageById(query: GetCitizenMessageByIdRequest, cancelToken?: CancelToken): Promise<GetCitizenMessageByIdResponse>;
    /**
     * @param query GetCitizenMessagesRequest
     * @return GetCitizenMessagesResponse
     */
    getCitizenMessages(query: GetCitizenMessagesRequest, cancelToken?: CancelToken): Promise<GetCitizenMessagesResponse>;
    /**
     * @param query GetUnemploymentFundMessagesRequest
     * @return GetUnemploymentFundMessagesResponse
     */
    getUnemploymentFundMessages(query: GetUnemploymentFundMessagesRequest, cancelToken?: CancelToken): Promise<GetUnemploymentFundMessagesResponse>;
}

export class CitizenDialogClient implements ICitizenDialogClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CloseCitizenMessageRequest
     * @return CloseCitizenMessageResponse
     */
    closeCitizenMessage(command: CloseCitizenMessageRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/dialog/commands/closecitizenmessage`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateUnemploymentFundCitizenMessageRequest
     * @return CreateUnemploymentFundCitizenMessageResponse
     */
    createUnemploymentFundCitizenMessage(command: CreateUnemploymentFundCitizenMessageRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/dialog/commands/createunemploymentfundcitizenmessage`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReplyCitizenMessageRequest
     * @return ReplyCitizenMessageResponse
     */
    replyCitizenMessage(command: ReplyCitizenMessageRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/dialog/commands/replycitizenmessage`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenMessageAttachmentRequest
     * @return FileResponse
     */
    getCitizenMessageAttachment(query: GetCitizenMessageAttachmentRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/dialog/queries/getcitizenmessageattachment`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenMessageByIdRequest
     * @return GetCitizenMessageByIdResponse
     */
    getCitizenMessageById(query: GetCitizenMessageByIdRequest, cancelToken?: CancelToken): Promise<GetCitizenMessageByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/dialog/queries/getcitizenmessagebyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenMessagesRequest
     * @return GetCitizenMessagesResponse
     */
    getCitizenMessages(query: GetCitizenMessagesRequest, cancelToken?: CancelToken): Promise<GetCitizenMessagesResponse> {
        const $url = `${this.baseUrl}/api/citizen/dialog/queries/getcitizenmessages`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUnemploymentFundMessagesRequest
     * @return GetUnemploymentFundMessagesResponse
     */
    getUnemploymentFundMessages(query: GetUnemploymentFundMessagesRequest, cancelToken?: CancelToken): Promise<GetUnemploymentFundMessagesResponse> {
        const $url = `${this.baseUrl}/api/citizen/dialog/queries/getunemploymentfundmessages`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenCVClient {
    /**
     * @param command UpdateCvStatusRequest
     * @return UpdateCvStatusResponse
     */
    updateCvStatus(command: UpdateCvStatusRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetCandidateReferralsByCitizenIdRequest
     * @return GetCandidateReferralsByCitizenIdResponse
     */
    getCandidateReferralsByCitizenId(query: GetCandidateReferralsByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetCandidateReferralsByCitizenIdResponse>;
    /**
     * @param query GetCitizenCvAsPdfRequest
     * @return FileResponse
     */
    getCitizenCvAsPdf(query: GetCitizenCvAsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetCitizenCvBasicRequest
     * @return GetCitizenCvBasicResponse
     */
    getCitizenCvBasic(query: GetCitizenCvBasicRequest, cancelToken?: CancelToken): Promise<GetCitizenCvBasicResponse>;
    /**
     * @param query GetCitizenCvJobTargetsRequest
     * @return GetCitizenCvJobTargetsResponse
     */
    getCitizenCvJobTargets(query: GetCitizenCvJobTargetsRequest, cancelToken?: CancelToken): Promise<GetCitizenCvJobTargetsResponse>;
    /**
     * @param query GetCitizenCvStatusRequest
     * @return GetCitizenCvStatusResponse
     */
    getCitizenCvStatus(query: GetCitizenCvStatusRequest, cancelToken?: CancelToken): Promise<GetCitizenCvStatusResponse>;
    /**
     * @param query GetCitizenCvStatusInfoRequest
     * @return GetCitizenCvStatusInfoResponse
     */
    getCitizenCvStatusForReview(query: GetCitizenCvStatusInfoRequest, cancelToken?: CancelToken): Promise<GetCitizenCvStatusInfoResponse>;
    /**
     * @param query GetCitizenExemptionRequest
     * @return GetCitizenExemptionResponse
     */
    getCitizenExemptionOverview(query: GetCitizenExemptionRequest, cancelToken?: CancelToken): Promise<GetCitizenExemptionResponse>;
    /**
     * @param query GetCitizenIdRequest
     * @return GetCitizenIdResponse
     */
    getCitizenId(query: GetCitizenIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdResponse>;
    /**
     * @param query GetCitizenJobMatchLinkRequest
     * @return GetCitizenJobMatchLinkResponse
     */
    getCitizenJobMatchLink(query: GetCitizenJobMatchLinkRequest, cancelToken?: CancelToken): Promise<GetCitizenJobMatchLinkResponse>;
    /**
     * @param query GetSmartMatchCitizenCvAsPdfByCprRequest
     * @return FileResponse
     */
    getSmartMatchCitizenCvAsPdfByCpr(query: GetSmartMatchCitizenCvAsPdfByCprRequest, cancelToken?: CancelToken): Promise<FileResponse>;
}

export class CitizenCVClient implements ICitizenCVClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command UpdateCvStatusRequest
     * @return UpdateCvStatusResponse
     */
    updateCvStatus(command: UpdateCvStatusRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/cv/commands/updatecvstatus`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCandidateReferralsByCitizenIdRequest
     * @return GetCandidateReferralsByCitizenIdResponse
     */
    getCandidateReferralsByCitizenId(query: GetCandidateReferralsByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetCandidateReferralsByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/cv/queries/getcandidatereferralsbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenCvAsPdfRequest
     * @return FileResponse
     */
    getCitizenCvAsPdf(query: GetCitizenCvAsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/cv/queries/getcitizencvaspdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenCvBasicRequest
     * @return GetCitizenCvBasicResponse
     */
    getCitizenCvBasic(query: GetCitizenCvBasicRequest, cancelToken?: CancelToken): Promise<GetCitizenCvBasicResponse> {
        const $url = `${this.baseUrl}/api/citizen/cv/queries/getcitizencvbasic`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenCvJobTargetsRequest
     * @return GetCitizenCvJobTargetsResponse
     */
    getCitizenCvJobTargets(query: GetCitizenCvJobTargetsRequest, cancelToken?: CancelToken): Promise<GetCitizenCvJobTargetsResponse> {
        const $url = `${this.baseUrl}/api/citizen/cv/queries/getcitizencvjobtargets`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenCvStatusRequest
     * @return GetCitizenCvStatusResponse
     */
    getCitizenCvStatus(query: GetCitizenCvStatusRequest, cancelToken?: CancelToken): Promise<GetCitizenCvStatusResponse> {
        const $url = `${this.baseUrl}/api/citizen/cv/queries/getcitizencvstatus`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenCvStatusInfoRequest
     * @return GetCitizenCvStatusInfoResponse
     */
    getCitizenCvStatusForReview(query: GetCitizenCvStatusInfoRequest, cancelToken?: CancelToken): Promise<GetCitizenCvStatusInfoResponse> {
        const $url = `${this.baseUrl}/api/citizen/cv/queries/getcitizencvstatusforreview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenExemptionRequest
     * @return GetCitizenExemptionResponse
     */
    getCitizenExemptionOverview(query: GetCitizenExemptionRequest, cancelToken?: CancelToken): Promise<GetCitizenExemptionResponse> {
        const $url = `${this.baseUrl}/api/citizen/cv/queries/getcitizenexemptionoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenIdRequest
     * @return GetCitizenIdResponse
     */
    getCitizenId(query: GetCitizenIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/cv/queries/getcitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenJobMatchLinkRequest
     * @return GetCitizenJobMatchLinkResponse
     */
    getCitizenJobMatchLink(query: GetCitizenJobMatchLinkRequest, cancelToken?: CancelToken): Promise<GetCitizenJobMatchLinkResponse> {
        const $url = `${this.baseUrl}/api/citizen/cv/queries/getcitizenjobmatchlink`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSmartMatchCitizenCvAsPdfByCprRequest
     * @return FileResponse
     */
    getSmartMatchCitizenCvAsPdfByCpr(query: GetSmartMatchCitizenCvAsPdfByCprRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/cv/queries/getsmartmatchcitizencvaspdfbycpr`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }
}

export interface ICitizenCounselingInquiriesClient {
    /**
     * @param command CompleteCounselingInquiryForCitizenRequest
     * @return CompleteCounselingInquiryForCitizenResponse
     */
    completeCounselingInquiry(command: CompleteCounselingInquiryForCitizenRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CompleteCounselingInquiryWithCaseRequest
     * @return CompleteCounselingInquiryWithCaseResponse
     */
    completeCounselingInquiryWithCase(command: CompleteCounselingInquiryWithCaseRequest, cancelToken?: CancelToken): Promise<CompleteCounselingInquiryWithCaseResponse>;
    /**
     * @param command CreateCounselingInquiryForCitizenRequest
     * @return CreateCounselingInquiryForCitizenResponse
     */
    createCounselingInquiry(command: CreateCounselingInquiryForCitizenRequest, cancelToken?: CancelToken): Promise<CreateCounselingInquiryForCitizenResponse>;
    /**
     * @param command UpdateCounselingInquiryForCitizenRequest
     * @return UpdateCounselingInquiryForCitizenResponse
     */
    updateCounselingInquiry(command: UpdateCounselingInquiryForCitizenRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetActiveSocialCasesForCounselingInquiryRequest
     * @return GetActiveSocialCasesForCounselingInquiryResponse
     */
    getActiveSocialCasesForCounselingInquiry(query: GetActiveSocialCasesForCounselingInquiryRequest, cancelToken?: CancelToken): Promise<GetActiveSocialCasesForCounselingInquiryResponse>;
    /**
     * @param query GetCompletedCounselingInquiriesForServiceProviderRequest
     * @return GetCompletedCounselingInquiriesForServiceProviderResponse
     */
    getCompletedCounselingInquiriesForServiceProvider(query: GetCompletedCounselingInquiriesForServiceProviderRequest, cancelToken?: CancelToken): Promise<GetCompletedCounselingInquiriesForServiceProviderResponse>;
    /**
     * @param query GetCompletedCounselingInquiryForServiceProviderRequest
     * @return GetCompletedCounselingInquiryForServiceProviderResponse
     */
    getCompletedCounselingInquiryForServiceProvider(query: GetCompletedCounselingInquiryForServiceProviderRequest, cancelToken?: CancelToken): Promise<GetCompletedCounselingInquiryForServiceProviderResponse>;
    /**
     * @param query GetCounselingInquiriesForCitizenRequest
     * @return GetCounselingInquiriesForCitizenResponse
     */
    getCounselingInquiriesForCitizen(query: GetCounselingInquiriesForCitizenRequest, cancelToken?: CancelToken): Promise<GetCounselingInquiriesForCitizenResponse>;
    /**
     * @param query GetCounselingInquiryForCitizenRequest
     * @return GetCounselingInquiryForCitizenResponse
     */
    getCounselingInquiry(query: GetCounselingInquiryForCitizenRequest, cancelToken?: CancelToken): Promise<GetCounselingInquiryForCitizenResponse>;
    /**
     * @return GetCounselingInquiryCaseDefaultsResponse
     */
    getCounselingInquiryCaseDefaults(cancelToken?: CancelToken): Promise<GetCounselingInquiryCaseDefaultsResponse>;
    /**
     * @param query GetCounselingInquiryPdfRequest
     * @return FileResponse
     */
    getCounselingInquiryPdf(query: GetCounselingInquiryPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return GetSocialCaseTypesForCounselingInquiryResponse
     */
    getSocialCaseTypesForCounselingInquiry(cancelToken?: CancelToken): Promise<GetSocialCaseTypesForCounselingInquiryResponse>;
    /**
     * @return GetTemporaryHomeSupportOptionsResponse
     */
    getTemporaryHomeSupportOptions(cancelToken?: CancelToken): Promise<GetTemporaryHomeSupportOptionsResponse>;
    /**
     * @param query GetTemporaryHomeSupportReuseForCaseRequest
     * @return GetTemporaryHomeSupportReuseForCaseResponse
     */
    getTemporaryHomeSupportReuseForCase(query: GetTemporaryHomeSupportReuseForCaseRequest, cancelToken?: CancelToken): Promise<GetTemporaryHomeSupportReuseForCaseResponse>;
}

export class CitizenCounselingInquiriesClient implements ICitizenCounselingInquiriesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CompleteCounselingInquiryForCitizenRequest
     * @return CompleteCounselingInquiryForCitizenResponse
     */
    completeCounselingInquiry(command: CompleteCounselingInquiryForCitizenRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/counselinginquiries/commands/completecounselinginquiry`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CompleteCounselingInquiryWithCaseRequest
     * @return CompleteCounselingInquiryWithCaseResponse
     */
    completeCounselingInquiryWithCase(command: CompleteCounselingInquiryWithCaseRequest, cancelToken?: CancelToken): Promise<CompleteCounselingInquiryWithCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/counselinginquiries/commands/completecounselinginquirywithcase`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCounselingInquiryForCitizenRequest
     * @return CreateCounselingInquiryForCitizenResponse
     */
    createCounselingInquiry(command: CreateCounselingInquiryForCitizenRequest, cancelToken?: CancelToken): Promise<CreateCounselingInquiryForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/counselinginquiries/commands/createcounselinginquiry`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCounselingInquiryForCitizenRequest
     * @return UpdateCounselingInquiryForCitizenResponse
     */
    updateCounselingInquiry(command: UpdateCounselingInquiryForCitizenRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/counselinginquiries/commands/updatecounselinginquiry`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActiveSocialCasesForCounselingInquiryRequest
     * @return GetActiveSocialCasesForCounselingInquiryResponse
     */
    getActiveSocialCasesForCounselingInquiry(query: GetActiveSocialCasesForCounselingInquiryRequest, cancelToken?: CancelToken): Promise<GetActiveSocialCasesForCounselingInquiryResponse> {
        const $url = `${this.baseUrl}/api/citizen/counselinginquiries/queries/getactivesocialcasesforcounselinginquiry`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompletedCounselingInquiriesForServiceProviderRequest
     * @return GetCompletedCounselingInquiriesForServiceProviderResponse
     */
    getCompletedCounselingInquiriesForServiceProvider(query: GetCompletedCounselingInquiriesForServiceProviderRequest, cancelToken?: CancelToken): Promise<GetCompletedCounselingInquiriesForServiceProviderResponse> {
        const $url = `${this.baseUrl}/api/citizen/counselinginquiries/queries/getcompletedcounselinginquiriesforserviceprovider`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompletedCounselingInquiryForServiceProviderRequest
     * @return GetCompletedCounselingInquiryForServiceProviderResponse
     */
    getCompletedCounselingInquiryForServiceProvider(query: GetCompletedCounselingInquiryForServiceProviderRequest, cancelToken?: CancelToken): Promise<GetCompletedCounselingInquiryForServiceProviderResponse> {
        const $url = `${this.baseUrl}/api/citizen/counselinginquiries/queries/getcompletedcounselinginquiryforserviceprovider`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCounselingInquiriesForCitizenRequest
     * @return GetCounselingInquiriesForCitizenResponse
     */
    getCounselingInquiriesForCitizen(query: GetCounselingInquiriesForCitizenRequest, cancelToken?: CancelToken): Promise<GetCounselingInquiriesForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/counselinginquiries/queries/getcounselinginquiriesforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCounselingInquiryForCitizenRequest
     * @return GetCounselingInquiryForCitizenResponse
     */
    getCounselingInquiry(query: GetCounselingInquiryForCitizenRequest, cancelToken?: CancelToken): Promise<GetCounselingInquiryForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/counselinginquiries/queries/getcounselinginquiry`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCounselingInquiryCaseDefaultsResponse
     */
    getCounselingInquiryCaseDefaults(cancelToken?: CancelToken): Promise<GetCounselingInquiryCaseDefaultsResponse> {
        const $url = `${this.baseUrl}/api/citizen/counselinginquiries/queries/getcounselinginquirycasedefaults`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCounselingInquiryPdfRequest
     * @return FileResponse
     */
    getCounselingInquiryPdf(query: GetCounselingInquiryPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/counselinginquiries/queries/getcounselinginquirypdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @return GetSocialCaseTypesForCounselingInquiryResponse
     */
    getSocialCaseTypesForCounselingInquiry(cancelToken?: CancelToken): Promise<GetSocialCaseTypesForCounselingInquiryResponse> {
        const $url = `${this.baseUrl}/api/citizen/counselinginquiries/queries/getsocialcasetypesforcounselinginquiry`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTemporaryHomeSupportOptionsResponse
     */
    getTemporaryHomeSupportOptions(cancelToken?: CancelToken): Promise<GetTemporaryHomeSupportOptionsResponse> {
        const $url = `${this.baseUrl}/api/citizen/counselinginquiries/queries/gettemporaryhomesupportoptions`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTemporaryHomeSupportReuseForCaseRequest
     * @return GetTemporaryHomeSupportReuseForCaseResponse
     */
    getTemporaryHomeSupportReuseForCase(query: GetTemporaryHomeSupportReuseForCaseRequest, cancelToken?: CancelToken): Promise<GetTemporaryHomeSupportReuseForCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/counselinginquiries/queries/gettemporaryhomesupportreuseforcase`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenCommunicationCrowdLetterClient {
    /**
     * @param command SendLetterToCrowdRequest
     * @return SendLetterToCrowdResponse
     */
    sendCitizenLetterToCrowd(command: SendLetterToCrowdRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetCrowdLetterPreviewAsPdfRequest
     * @return FileResponse
     */
    getCrowdLetterPreviewAsPdf(query: GetCrowdLetterPreviewAsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
}

export class CitizenCommunicationCrowdLetterClient implements ICitizenCommunicationCrowdLetterClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command SendLetterToCrowdRequest
     * @return SendLetterToCrowdResponse
     */
    sendCitizenLetterToCrowd(command: SendLetterToCrowdRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/communication/crowdletter/commands/sendcitizenlettertocrowd`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCrowdLetterPreviewAsPdfRequest
     * @return FileResponse
     */
    getCrowdLetterPreviewAsPdf(query: GetCrowdLetterPreviewAsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/crowdletter/queries/getcrowdletterpreviewaspdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }
}

export interface ICitizenCommunicationClient {
    /**
     * @param command CreateCvAttachmentRequest
     * @return CreateCvAttachmentResponse
     */
    createCvAttachment(command: CreateCvAttachmentRequest2, cancelToken?: CancelToken): Promise<CreateCvAttachmentResponse2>;
    /**
     * @param command SendLetterToCitizenRequest
     * @return SendLetterToCitizenResponse
     */
    sendLetterToCitizen(command: SendLetterToCitizenRequest, cancelToken?: CancelToken): Promise<SendLetterToCitizenResponse>;
    /**
     * @param command SendLetterToCitizenAsMedicalCollaboratorRequest
     * @return SendLetterToCitizenAsMedicalCollaboratorResponse
     */
    sendLetterToCitizenAsMedicalCollaborator(command: SendLetterToCitizenAsMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<SendLetterToCitizenAsMedicalCollaboratorResponse>;
    /**
     * @param command SendLetterToCitizenAsServiceProviderRequest
     * @return SendLetterToCitizenAsServiceProviderResponse
     */
    sendLetterToCitizenAsServiceProvider(command: SendLetterToCitizenAsServiceProviderRequest, cancelToken?: CancelToken): Promise<SendLetterToCitizenAsServiceProviderResponse>;
    /**
     * @param command SendLetterToCompanyRequest
     * @return SendLetterToCompanyResponse
     */
    sendLetterToCompany(command: SendLetterToCompanyRequest, cancelToken?: CancelToken): Promise<SendLetterToCompanyResponse>;
    /**
     * @param command SendLetterToCompanyAsMedicalCollaboratorRequest
     * @return SendLetterToCompanyAsMedicalCollaboratorResponse
     */
    sendLetterToCompanyAsMedicalCollaborator(command: SendLetterToCompanyAsMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<SendLetterToCompanyAsMedicalCollaboratorResponse>;
    /**
     * @param command SendLetterToCompanyAsServiceProviderRequest
     * @return SendLetterToCompanyAsServiceProviderResponse
     */
    sendLetterToCompanyAsServiceProvider(command: SendLetterToCompanyAsServiceProviderRequest, cancelToken?: CancelToken): Promise<SendLetterToCompanyAsServiceProviderResponse>;
    /**
     * @param command SendLetterToMultipleRecipientsRequest
     * @return SendLetterToMultipleRecipientsResponse
     */
    sendLetterToMultipleRecipients(command: SendLetterToMultipleRecipientsRequest, cancelToken?: CancelToken): Promise<SendLetterToMultipleRecipientsResponse>;
    /**
     * @param command SendLetterToMultipleRecipientsAsMedicalCollaboratorRequest
     * @return SendLetterToMultipleRecipientsAsMedicalCollaboratorResponse
     */
    sendLetterToMultipleRecipientsAsMedicalCollaborator(command: SendLetterToMultipleRecipientsAsMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<SendLetterToMultipleRecipientsAsMedicalCollaboratorResponse>;
    /**
     * @param command SendLetterToMultipleRecipientsAsServiceProviderRequest
     * @return SendLetterToMultipleRecipientsAsServiceProviderResponse
     */
    sendLetterToMultipleRecipientsAsServiceProvider(command: SendLetterToMultipleRecipientsAsServiceProviderRequest, cancelToken?: CancelToken): Promise<SendLetterToMultipleRecipientsAsServiceProviderResponse>;
    /**
     * @param command SendLetterToPrivatePersonRequest
     * @return SendLetterToPrivatePersonResponse
     */
    sendLetterToPrivatePerson(command: SendLetterToPrivatePersonRequest, cancelToken?: CancelToken): Promise<SendLetterToPrivatePersonResponse>;
    /**
     * @param command SendLetterToPrivatePersonAsMedicalCollaboratorRequest
     * @return SendLetterToPrivatePersonAsMedicalCollaboratorResponse
     */
    sendLetterToPrivatePersonAsMedicalCollaborator(command: SendLetterToPrivatePersonAsMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<SendLetterToPrivatePersonAsMedicalCollaboratorResponse>;
    /**
     * @param command SendLetterToPrivatePersonAsServiceProviderRequest
     * @return SendLetterToPrivatePersonAsServiceProviderResponse
     */
    sendLetterToPrivatePersonAsServiceProvider(command: SendLetterToPrivatePersonAsServiceProviderRequest, cancelToken?: CancelToken): Promise<SendLetterToPrivatePersonAsServiceProviderResponse>;
    /**
     * @param command SendLetterToSupplierPlatformRequest
     * @return SendLetterToSupplierPlatformResponse
     */
    sendLetterToSupplierPlatform(command: SendLetterToSupplierPlatformRequest, cancelToken?: CancelToken): Promise<SendLetterToSupplierPlatformResponse>;
    /**
     * @param command UploadFileAttachmentRequest
     * @return UploadFileAttachmentResponse
     */
    uploadFileAttachment(command: UploadFileAttachmentRequest, cancelToken?: CancelToken): Promise<UploadFileAttachmentResponse>;
    /**
     * @param query FillLetterUserInputsRequest
     * @return FillLetterUserInputsResponse
     */
    fillLetterUserInputs(query: FillLetterUserInputsRequest, cancelToken?: CancelToken): Promise<FillLetterUserInputsResponse>;
    /**
     * @return GetAttachmentSettingsResponse
     */
    getAttachmentSettings(cancelToken?: CancelToken): Promise<GetAttachmentSettingsResponse3>;
    /**
     * @param query GetCitizenCasesRequest
     * @return GetCitizenCasesResponse
     */
    getCitizenCases(query: GetCitizenCasesRequest2, cancelToken?: CancelToken): Promise<GetCitizenCasesResponse2>;
    /**
     * @param query GetCitizenCompaniesRequest
     * @return GetCitizenCompaniesResponse
     */
    getCitizenCompanies(query: GetCitizenCompaniesRequest, cancelToken?: CancelToken): Promise<GetCitizenCompaniesResponse>;
    /**
     * @param query GetCitizenCompaniesForLookupRequest
     * @return GetCitizenCompaniesForLookupResponse
     */
    getCitizenCompaniesForLookup(query: GetCitizenCompaniesForLookupRequest, cancelToken?: CancelToken): Promise<GetCitizenCompaniesForLookupResponse>;
    /**
     * @param query GetCitizenInfoRequest
     * @return GetCitizenInfoResponse
     */
    getCitizenInfo(query: GetCitizenInfoRequest, cancelToken?: CancelToken): Promise<GetCitizenInfoResponse>;
    /**
     * @param query GetCitizenPrivateContactPersonsRequest
     * @return GetCitizenPrivateContactPersonsResponse
     */
    getCitizenPrivateContactPersons(query: GetCitizenPrivateContactPersonsRequest, cancelToken?: CancelToken): Promise<GetCitizenPrivateContactPersonsResponse>;
    /**
     * @param query GetCitizensPrimaryOrLatestCaseRequest
     * @return GetCitizensPrimaryOrLatestCaseResponse
     */
    getCitizensPrimaryOrLatestCase(query: GetCitizensPrimaryOrLatestCaseRequest, cancelToken?: CancelToken): Promise<GetCitizensPrimaryOrLatestCaseResponse>;
    /**
     * @param query GetCompaniesRequest
     * @return GetCompaniesResponse
     */
    getCompanies(query: GetCompaniesRequest2, cancelToken?: CancelToken): Promise<GetCompaniesResponse2>;
    /**
     * @param query GetCompanyRequest
     * @return GetCompanyResponse
     */
    getCompany(query: GetCompanyRequest, cancelToken?: CancelToken): Promise<GetCompanyResponse>;
    /**
     * @param query GetCompanyContactPersonsRequest
     * @return GetCompanyContactPersonsResponse
     */
    getCompanyContactPersons(query: GetCompanyContactPersonsRequest2, cancelToken?: CancelToken): Promise<GetCompanyContactPersonsResponse2>;
    /**
     * @return GetCaseworkersResponse
     */
    getCurrentCaseWorker(cancelToken?: CancelToken): Promise<GetCaseworkersResponse>;
    /**
     * @param query GetDocumentsForAliasesFromDocumentArchiveRequest
     * @return GetDocumentsForAliasesFromDocumentArchiveResponse
     */
    getDocumentsForAliasesFromDocumentArchive(query: GetDocumentsForAliasesFromDocumentArchiveRequest2, cancelToken?: CancelToken): Promise<GetDocumentsForAliasesFromDocumentArchiveResponse2>;
    /**
     * @param query GetDocumentsFromDocumentArchiveRequest
     * @return GetDocumentsFromDocumentArchiveResponse
     */
    getDocumentsFromDocumentArchive(query: GetDocumentsFromDocumentArchiveRequest2, cancelToken?: CancelToken): Promise<GetDocumentsFromDocumentArchiveResponse2>;
    /**
     * @param query GetEditableContentForPdfFormsRequest
     * @return GetEditableContentForPdfFormsResponse
     */
    getEditableContentForPdfForms(query: GetEditableContentForPdfFormsRequest, cancelToken?: CancelToken): Promise<GetEditableContentForPdfFormsResponse>;
    /**
     * @param query GetHeaderRequest
     * @return GetHeaderResponse
     */
    getHeader(query: GetHeaderRequest, cancelToken?: CancelToken): Promise<GetHeaderResponse>;
    /**
     * @param query GetIsPrivateContactPersonCprEmptyRequest
     * @return GetIsPrivateContactPersonCprEmptyResponse
     */
    getIsPrivateContactPersonCprEmpty(query: GetIsPrivateContactPersonCprEmptyRequest, cancelToken?: CancelToken): Promise<GetIsPrivateContactPersonCprEmptyResponse>;
    /**
     * @param query GetMedicalRequestPdfFormLinkRequest
     * @return GetMedicalRequestPdfFormLinkResponse
     */
    getMedicalRequestPdfFormLink(query: GetMedicalRequestPdfFormLinkRequest, cancelToken?: CancelToken): Promise<GetMedicalRequestPdfFormLinkResponse>;
    /**
     * @return GetOutgoingDocumentTypesResponse
     */
    getOutgoingDocumentTypes(cancelToken?: CancelToken): Promise<GetOutgoingDocumentTypesResponse3>;
    /**
     * @return GetPdfFormResponse
     */
    getPdfForm(cancelToken?: CancelToken): Promise<GetPdfFormResponse>;
    /**
     * @return GetPdfFormActivityResponse
     */
    getPdfFormActivity(cancelToken?: CancelToken): Promise<GetPdfFormActivityResponse>;
    /**
     * @param query GetPdfFormActivityLinkRequest
     * @return GetPdfFormActivityLinkResponse
     */
    getPdfFormActivityLink(query: GetPdfFormActivityLinkRequest, cancelToken?: CancelToken): Promise<GetPdfFormActivityLinkResponse>;
    /**
     * @param query GetPdfFormLinkRequest
     * @return GetPdfFormLinkResponse
     */
    getPdfFormLink(query: GetPdfFormLinkRequest, cancelToken?: CancelToken): Promise<GetPdfFormLinkResponse>;
    /**
     * @param query GetPdfFormSubmittedRequest
     * @return GetPdfFormSubmittedResponse
     */
    getPdfFormSubmitted(query: GetPdfFormSubmittedRequest, cancelToken?: CancelToken): Promise<GetPdfFormSubmittedResponse>;
    /**
     * @param query GetPreviewPdfFormRequest
     * @return FileResponse
     */
    getPreviewPdfForm(query: GetPreviewPdfFormRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetPrivateContactPersonsRequest
     * @return GetPrivateContactPersonsResponse
     */
    getPrivateContactPersons(query: GetPrivateContactPersonsRequest2, cancelToken?: CancelToken): Promise<GetPrivateContactPersonsResponse2>;
    /**
     * @return GetServiceProviderUnitsForCurrentUserResponse
     */
    getServiceProviderUnitsForCurrentUser(cancelToken?: CancelToken): Promise<GetServiceProviderUnitsForCurrentUserResponse>;
    /**
     * @return GetStandardAppendixResponse
     */
    getStandardAppendix(cancelToken?: CancelToken): Promise<GetStandardAppendixResponse>;
    /**
     * @param query GetStandardAttachmentDocumentsFromArchiveRequest
     * @return GetStandardAttachmentDocumentsFromArchiveResponse
     */
    getStandardAttachmentDocumentsFromArchive(query: GetStandardAttachmentDocumentsFromArchiveRequest2, cancelToken?: CancelToken): Promise<GetStandardAttachmentDocumentsFromArchiveResponse2>;
    /**
     * @return Int32
     */
    getStandardAttachmentObjectTypeCode(cancelToken?: CancelToken): Promise<number>;
    /**
     * @param query GetStandardAttachmentsRequest
     * @return GetStandardAttachmentsResponse
     */
    getStandardAttachments(query: GetStandardAttachmentsRequest, cancelToken?: CancelToken): Promise<GetStandardAttachmentsResponse>;
    /**
     * @return GetSystemUserUrlResponse
     */
    getSystemUserUrl(cancelToken?: CancelToken): Promise<GetSystemUserUrlResponse>;
    /**
     * @return GetUserOutgoingDocumentTypeResponse
     */
    getUserOutgoingDocumentType(cancelToken?: CancelToken): Promise<GetUserOutgoingDocumentTypeResponse>;
    /**
     * @param query PreviewFileAttachmentAsPdfRequest
     * @return FileResponse
     */
    previewFileAttachmentAsPdf(query: PreviewFileAttachmentAsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
}

export class CitizenCommunicationClient implements ICitizenCommunicationClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateCvAttachmentRequest
     * @return CreateCvAttachmentResponse
     */
    createCvAttachment(command: CreateCvAttachmentRequest2, cancelToken?: CancelToken): Promise<CreateCvAttachmentResponse2> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/createcvattachment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendLetterToCitizenRequest
     * @return SendLetterToCitizenResponse
     */
    sendLetterToCitizen(command: SendLetterToCitizenRequest, cancelToken?: CancelToken): Promise<SendLetterToCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/sendlettertocitizen`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendLetterToCitizenAsMedicalCollaboratorRequest
     * @return SendLetterToCitizenAsMedicalCollaboratorResponse
     */
    sendLetterToCitizenAsMedicalCollaborator(command: SendLetterToCitizenAsMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<SendLetterToCitizenAsMedicalCollaboratorResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/sendlettertocitizenasmedicalcollaborator`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendLetterToCitizenAsServiceProviderRequest
     * @return SendLetterToCitizenAsServiceProviderResponse
     */
    sendLetterToCitizenAsServiceProvider(command: SendLetterToCitizenAsServiceProviderRequest, cancelToken?: CancelToken): Promise<SendLetterToCitizenAsServiceProviderResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/sendlettertocitizenasserviceprovider`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendLetterToCompanyRequest
     * @return SendLetterToCompanyResponse
     */
    sendLetterToCompany(command: SendLetterToCompanyRequest, cancelToken?: CancelToken): Promise<SendLetterToCompanyResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/sendlettertocompany`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendLetterToCompanyAsMedicalCollaboratorRequest
     * @return SendLetterToCompanyAsMedicalCollaboratorResponse
     */
    sendLetterToCompanyAsMedicalCollaborator(command: SendLetterToCompanyAsMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<SendLetterToCompanyAsMedicalCollaboratorResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/sendlettertocompanyasmedicalcollaborator`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendLetterToCompanyAsServiceProviderRequest
     * @return SendLetterToCompanyAsServiceProviderResponse
     */
    sendLetterToCompanyAsServiceProvider(command: SendLetterToCompanyAsServiceProviderRequest, cancelToken?: CancelToken): Promise<SendLetterToCompanyAsServiceProviderResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/sendlettertocompanyasserviceprovider`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendLetterToMultipleRecipientsRequest
     * @return SendLetterToMultipleRecipientsResponse
     */
    sendLetterToMultipleRecipients(command: SendLetterToMultipleRecipientsRequest, cancelToken?: CancelToken): Promise<SendLetterToMultipleRecipientsResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/sendlettertomultiplerecipients`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendLetterToMultipleRecipientsAsMedicalCollaboratorRequest
     * @return SendLetterToMultipleRecipientsAsMedicalCollaboratorResponse
     */
    sendLetterToMultipleRecipientsAsMedicalCollaborator(command: SendLetterToMultipleRecipientsAsMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<SendLetterToMultipleRecipientsAsMedicalCollaboratorResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/sendlettertomultiplerecipientsasmedicalcollaborator`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendLetterToMultipleRecipientsAsServiceProviderRequest
     * @return SendLetterToMultipleRecipientsAsServiceProviderResponse
     */
    sendLetterToMultipleRecipientsAsServiceProvider(command: SendLetterToMultipleRecipientsAsServiceProviderRequest, cancelToken?: CancelToken): Promise<SendLetterToMultipleRecipientsAsServiceProviderResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/sendlettertomultiplerecipientsasserviceprovider`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendLetterToPrivatePersonRequest
     * @return SendLetterToPrivatePersonResponse
     */
    sendLetterToPrivatePerson(command: SendLetterToPrivatePersonRequest, cancelToken?: CancelToken): Promise<SendLetterToPrivatePersonResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/sendlettertoprivateperson`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendLetterToPrivatePersonAsMedicalCollaboratorRequest
     * @return SendLetterToPrivatePersonAsMedicalCollaboratorResponse
     */
    sendLetterToPrivatePersonAsMedicalCollaborator(command: SendLetterToPrivatePersonAsMedicalCollaboratorRequest, cancelToken?: CancelToken): Promise<SendLetterToPrivatePersonAsMedicalCollaboratorResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/sendlettertoprivatepersonasmedicalcollaborator`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendLetterToPrivatePersonAsServiceProviderRequest
     * @return SendLetterToPrivatePersonAsServiceProviderResponse
     */
    sendLetterToPrivatePersonAsServiceProvider(command: SendLetterToPrivatePersonAsServiceProviderRequest, cancelToken?: CancelToken): Promise<SendLetterToPrivatePersonAsServiceProviderResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/sendlettertoprivatepersonasserviceprovider`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendLetterToSupplierPlatformRequest
     * @return SendLetterToSupplierPlatformResponse
     */
    sendLetterToSupplierPlatform(command: SendLetterToSupplierPlatformRequest, cancelToken?: CancelToken): Promise<SendLetterToSupplierPlatformResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/sendlettertosupplierplatform`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UploadFileAttachmentRequest
     * @return UploadFileAttachmentResponse
     */
    uploadFileAttachment(command: UploadFileAttachmentRequest, cancelToken?: CancelToken): Promise<UploadFileAttachmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/commands/uploadfileattachment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query FillLetterUserInputsRequest
     * @return FillLetterUserInputsResponse
     */
    fillLetterUserInputs(query: FillLetterUserInputsRequest, cancelToken?: CancelToken): Promise<FillLetterUserInputsResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/fillletteruserinputs`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAttachmentSettingsResponse
     */
    getAttachmentSettings(cancelToken?: CancelToken): Promise<GetAttachmentSettingsResponse3> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getattachmentsettings`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenCasesRequest
     * @return GetCitizenCasesResponse
     */
    getCitizenCases(query: GetCitizenCasesRequest2, cancelToken?: CancelToken): Promise<GetCitizenCasesResponse2> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getcitizencases`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenCompaniesRequest
     * @return GetCitizenCompaniesResponse
     */
    getCitizenCompanies(query: GetCitizenCompaniesRequest, cancelToken?: CancelToken): Promise<GetCitizenCompaniesResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getcitizencompanies`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenCompaniesForLookupRequest
     * @return GetCitizenCompaniesForLookupResponse
     */
    getCitizenCompaniesForLookup(query: GetCitizenCompaniesForLookupRequest, cancelToken?: CancelToken): Promise<GetCitizenCompaniesForLookupResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getcitizencompaniesforlookup`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenInfoRequest
     * @return GetCitizenInfoResponse
     */
    getCitizenInfo(query: GetCitizenInfoRequest, cancelToken?: CancelToken): Promise<GetCitizenInfoResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getcitizeninfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenPrivateContactPersonsRequest
     * @return GetCitizenPrivateContactPersonsResponse
     */
    getCitizenPrivateContactPersons(query: GetCitizenPrivateContactPersonsRequest, cancelToken?: CancelToken): Promise<GetCitizenPrivateContactPersonsResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getcitizenprivatecontactpersons`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizensPrimaryOrLatestCaseRequest
     * @return GetCitizensPrimaryOrLatestCaseResponse
     */
    getCitizensPrimaryOrLatestCase(query: GetCitizensPrimaryOrLatestCaseRequest, cancelToken?: CancelToken): Promise<GetCitizensPrimaryOrLatestCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getcitizensprimaryorlatestcase`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompaniesRequest
     * @return GetCompaniesResponse
     */
    getCompanies(query: GetCompaniesRequest2, cancelToken?: CancelToken): Promise<GetCompaniesResponse2> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getcompanies`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyRequest
     * @return GetCompanyResponse
     */
    getCompany(query: GetCompanyRequest, cancelToken?: CancelToken): Promise<GetCompanyResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getcompany`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyContactPersonsRequest
     * @return GetCompanyContactPersonsResponse
     */
    getCompanyContactPersons(query: GetCompanyContactPersonsRequest2, cancelToken?: CancelToken): Promise<GetCompanyContactPersonsResponse2> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getcompanycontactpersons`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCaseworkersResponse
     */
    getCurrentCaseWorker(cancelToken?: CancelToken): Promise<GetCaseworkersResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getcurrentcaseworker`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDocumentsForAliasesFromDocumentArchiveRequest
     * @return GetDocumentsForAliasesFromDocumentArchiveResponse
     */
    getDocumentsForAliasesFromDocumentArchive(query: GetDocumentsForAliasesFromDocumentArchiveRequest2, cancelToken?: CancelToken): Promise<GetDocumentsForAliasesFromDocumentArchiveResponse2> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getdocumentsforaliasesfromdocumentarchive`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDocumentsFromDocumentArchiveRequest
     * @return GetDocumentsFromDocumentArchiveResponse
     */
    getDocumentsFromDocumentArchive(query: GetDocumentsFromDocumentArchiveRequest2, cancelToken?: CancelToken): Promise<GetDocumentsFromDocumentArchiveResponse2> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getdocumentsfromdocumentarchive`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEditableContentForPdfFormsRequest
     * @return GetEditableContentForPdfFormsResponse
     */
    getEditableContentForPdfForms(query: GetEditableContentForPdfFormsRequest, cancelToken?: CancelToken): Promise<GetEditableContentForPdfFormsResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/geteditablecontentforpdfforms`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHeaderRequest
     * @return GetHeaderResponse
     */
    getHeader(query: GetHeaderRequest, cancelToken?: CancelToken): Promise<GetHeaderResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getheader`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetIsPrivateContactPersonCprEmptyRequest
     * @return GetIsPrivateContactPersonCprEmptyResponse
     */
    getIsPrivateContactPersonCprEmpty(query: GetIsPrivateContactPersonCprEmptyRequest, cancelToken?: CancelToken): Promise<GetIsPrivateContactPersonCprEmptyResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getisprivatecontactpersoncprempty`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicalRequestPdfFormLinkRequest
     * @return GetMedicalRequestPdfFormLinkResponse
     */
    getMedicalRequestPdfFormLink(query: GetMedicalRequestPdfFormLinkRequest, cancelToken?: CancelToken): Promise<GetMedicalRequestPdfFormLinkResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getmedicalrequestpdfformlink`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOutgoingDocumentTypesResponse
     */
    getOutgoingDocumentTypes(cancelToken?: CancelToken): Promise<GetOutgoingDocumentTypesResponse3> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getoutgoingdocumenttypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetPdfFormResponse
     */
    getPdfForm(cancelToken?: CancelToken): Promise<GetPdfFormResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getpdfform`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetPdfFormActivityResponse
     */
    getPdfFormActivity(cancelToken?: CancelToken): Promise<GetPdfFormActivityResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getpdfformactivity`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPdfFormActivityLinkRequest
     * @return GetPdfFormActivityLinkResponse
     */
    getPdfFormActivityLink(query: GetPdfFormActivityLinkRequest, cancelToken?: CancelToken): Promise<GetPdfFormActivityLinkResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getpdfformactivitylink`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPdfFormLinkRequest
     * @return GetPdfFormLinkResponse
     */
    getPdfFormLink(query: GetPdfFormLinkRequest, cancelToken?: CancelToken): Promise<GetPdfFormLinkResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getpdfformlink`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPdfFormSubmittedRequest
     * @return GetPdfFormSubmittedResponse
     */
    getPdfFormSubmitted(query: GetPdfFormSubmittedRequest, cancelToken?: CancelToken): Promise<GetPdfFormSubmittedResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getpdfformsubmitted`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPreviewPdfFormRequest
     * @return FileResponse
     */
    getPreviewPdfForm(query: GetPreviewPdfFormRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getpreviewpdfform`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPrivateContactPersonsRequest
     * @return GetPrivateContactPersonsResponse
     */
    getPrivateContactPersons(query: GetPrivateContactPersonsRequest2, cancelToken?: CancelToken): Promise<GetPrivateContactPersonsResponse2> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getprivatecontactpersons`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetServiceProviderUnitsForCurrentUserResponse
     */
    getServiceProviderUnitsForCurrentUser(cancelToken?: CancelToken): Promise<GetServiceProviderUnitsForCurrentUserResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getserviceproviderunitsforcurrentuser`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetStandardAppendixResponse
     */
    getStandardAppendix(cancelToken?: CancelToken): Promise<GetStandardAppendixResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getstandardappendix`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetStandardAttachmentDocumentsFromArchiveRequest
     * @return GetStandardAttachmentDocumentsFromArchiveResponse
     */
    getStandardAttachmentDocumentsFromArchive(query: GetStandardAttachmentDocumentsFromArchiveRequest2, cancelToken?: CancelToken): Promise<GetStandardAttachmentDocumentsFromArchiveResponse2> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getstandardattachmentdocumentsfromarchive`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return Int32
     */
    getStandardAttachmentObjectTypeCode(cancelToken?: CancelToken): Promise<number> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getstandardattachmentobjecttypecode`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetStandardAttachmentsRequest
     * @return GetStandardAttachmentsResponse
     */
    getStandardAttachments(query: GetStandardAttachmentsRequest, cancelToken?: CancelToken): Promise<GetStandardAttachmentsResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getstandardattachments`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSystemUserUrlResponse
     */
    getSystemUserUrl(cancelToken?: CancelToken): Promise<GetSystemUserUrlResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getsystemuserurl`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetUserOutgoingDocumentTypeResponse
     */
    getUserOutgoingDocumentType(cancelToken?: CancelToken): Promise<GetUserOutgoingDocumentTypeResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/getuseroutgoingdocumenttype`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query PreviewFileAttachmentAsPdfRequest
     * @return FileResponse
     */
    previewFileAttachmentAsPdf(query: PreviewFileAttachmentAsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/queries/previewfileattachmentaspdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }
}

export interface ICitizenClient {
    /**
     * @param command SyncCitizenInformationRequest
     * @return SyncCitizenInformationResponse
     */
    syncCitizenInformation(command: SyncCitizenInformationRequest, cancelToken?: CancelToken): Promise<SyncCitizenInformationResponse>;
    /**
     * @return CanViewCitizenIncomeFromDatabaseResponse
     */
    canViewCitizenIncomeFromDatabase(cancelToken?: CancelToken): Promise<CanViewCitizenIncomeFromDatabaseResponse>;
    /**
     * @param query GetAuthorityCitizenContextRequest
     * @return GetAuthorityCitizenContextResponse
     */
    getAuthorityCitizenContext(query: GetAuthorityCitizenContextRequest, cancelToken?: CancelToken): Promise<GetAuthorityCitizenContextResponse>;
    /**
     * @param query GetByCprRequest
     * @return GetByCprResponse
     */
    getByCpr(query: GetByCprRequest, cancelToken?: CancelToken): Promise<GetByCprResponse>;
    /**
     * @param query GetByIdsRequest
     * @return GetByIdsResponse
     */
    getByIds(query: GetByIdsRequest, cancelToken?: CancelToken): Promise<GetByIdsResponse>;
    /**
     * @param query GetCitizenDfdgWarningInfoRequest
     * @return GetCitizenDfdgWarningInfoResponse
     */
    getCitizenDfdgWarningInfo(query: GetCitizenDfdgWarningInfoRequest, cancelToken?: CancelToken): Promise<GetCitizenDfdgWarningInfoResponse>;
    /**
     * @param query GetCitizenDueDatesRequest
     * @return GetCitizenDueDatesResponse
     */
    getCitizenDueDates(query: GetCitizenDueDatesRequest, cancelToken?: CancelToken): Promise<GetCitizenDueDatesResponse>;
    /**
     * @param query GetCitizenHeaderRequest
     * @return GetCitizenHeaderResponse
     */
    getCitizenHeader(query: GetCitizenHeaderRequest, cancelToken?: CancelToken): Promise<GetCitizenHeaderResponse>;
    /**
     * @param query GetCitizenOverviewSummaryRequest
     * @return GetCitizenOverviewSummaryResponse
     */
    getCitizenOverviewSummary(query: GetCitizenOverviewSummaryRequest, cancelToken?: CancelToken): Promise<GetCitizenOverviewSummaryResponse>;
    /**
     * @param query GetCrmCitizenOverviewUrlRequest
     * @return GetCrmCitizenOverviewUrlResponse
     */
    getCrmCitizenOverviewUrl(query: GetCrmCitizenOverviewUrlRequest, cancelToken?: CancelToken): Promise<GetCrmCitizenOverviewUrlResponse>;
    /**
     * @param query GetExternalOperatorReferralTeamIdByCitizenIdRequest
     * @return GetExternalOperatorReferralTeamIdByCitizenIdResponse
     */
    getExternalOperatorReferralTeamIdByCitizenId(query: GetExternalOperatorReferralTeamIdByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetExternalOperatorReferralTeamIdByCitizenIdResponse>;
    /**
     * @param query GetMedicalCollaboratorCitizenContextRequest
     * @return GetMedicalCollaboratorCitizenContextResponse
     */
    getMedicalCollaboratorCitizenContext(query: GetMedicalCollaboratorCitizenContextRequest, cancelToken?: CancelToken): Promise<GetMedicalCollaboratorCitizenContextResponse>;
    /**
     * @param query GetMedicalCollaboratorCitizenHeaderRequest
     * @return GetMedicalCollaboratorCitizenHeaderResponse
     */
    getMedicalCollaboratorCitizenHeader(query: GetMedicalCollaboratorCitizenHeaderRequest, cancelToken?: CancelToken): Promise<GetMedicalCollaboratorCitizenHeaderResponse>;
    /**
     * @param query GetOrAddCitizenRequest
     * @return GetOrAddCitizenResponse
     */
    getOrAddCitizen(query: GetOrAddCitizenRequest, cancelToken?: CancelToken): Promise<GetOrAddCitizenResponse>;
    /**
     * @param query GetRestrictedFromPrimaryCaseRequest
     * @return GetRestrictedFromPrimaryCaseResponse
     */
    getRestrictedFromPrimaryCase(query: GetRestrictedFromPrimaryCaseRequest, cancelToken?: CancelToken): Promise<GetRestrictedFromPrimaryCaseResponse>;
    /**
     * @param query GetSocialProviderCitizenContextRequest
     * @return GetSocialProviderCitizenContextResponse
     */
    getSocialProviderCitizenContext(query: GetSocialProviderCitizenContextRequest, cancelToken?: CancelToken): Promise<GetSocialProviderCitizenContextResponse>;
    /**
     * @param query GetSocialProviderCitizenHeaderRequest
     * @return GetSocialProviderCitizenHeaderResponse
     */
    getSocialProviderCitizenHeader(query: GetSocialProviderCitizenHeaderRequest, cancelToken?: CancelToken): Promise<GetSocialProviderCitizenHeaderResponse>;
    /**
     * @return IsCurrentUserSchultzUserResponse
     */
    isCurrentUserSchultzUser(cancelToken?: CancelToken): Promise<IsCurrentUserSchultzUserResponse>;
}

export class CitizenClient implements ICitizenClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command SyncCitizenInformationRequest
     * @return SyncCitizenInformationResponse
     */
    syncCitizenInformation(command: SyncCitizenInformationRequest, cancelToken?: CancelToken): Promise<SyncCitizenInformationResponse> {
        const $url = `${this.baseUrl}/api/citizen/commands/synccitizeninformation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return CanViewCitizenIncomeFromDatabaseResponse
     */
    canViewCitizenIncomeFromDatabase(cancelToken?: CancelToken): Promise<CanViewCitizenIncomeFromDatabaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/canviewcitizenincomefromdatabase`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAuthorityCitizenContextRequest
     * @return GetAuthorityCitizenContextResponse
     */
    getAuthorityCitizenContext(query: GetAuthorityCitizenContextRequest, cancelToken?: CancelToken): Promise<GetAuthorityCitizenContextResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getauthoritycitizencontext`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetByCprRequest
     * @return GetByCprResponse
     */
    getByCpr(query: GetByCprRequest, cancelToken?: CancelToken): Promise<GetByCprResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getbycpr`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetByIdsRequest
     * @return GetByIdsResponse
     */
    getByIds(query: GetByIdsRequest, cancelToken?: CancelToken): Promise<GetByIdsResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getbyids`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenDfdgWarningInfoRequest
     * @return GetCitizenDfdgWarningInfoResponse
     */
    getCitizenDfdgWarningInfo(query: GetCitizenDfdgWarningInfoRequest, cancelToken?: CancelToken): Promise<GetCitizenDfdgWarningInfoResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getcitizendfdgwarninginfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenDueDatesRequest
     * @return GetCitizenDueDatesResponse
     */
    getCitizenDueDates(query: GetCitizenDueDatesRequest, cancelToken?: CancelToken): Promise<GetCitizenDueDatesResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getcitizenduedates`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenHeaderRequest
     * @return GetCitizenHeaderResponse
     */
    getCitizenHeader(query: GetCitizenHeaderRequest, cancelToken?: CancelToken): Promise<GetCitizenHeaderResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getcitizenheader`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenOverviewSummaryRequest
     * @return GetCitizenOverviewSummaryResponse
     */
    getCitizenOverviewSummary(query: GetCitizenOverviewSummaryRequest, cancelToken?: CancelToken): Promise<GetCitizenOverviewSummaryResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getcitizenoverviewsummary`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCrmCitizenOverviewUrlRequest
     * @return GetCrmCitizenOverviewUrlResponse
     */
    getCrmCitizenOverviewUrl(query: GetCrmCitizenOverviewUrlRequest, cancelToken?: CancelToken): Promise<GetCrmCitizenOverviewUrlResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getcrmcitizenoverviewurl`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetExternalOperatorReferralTeamIdByCitizenIdRequest
     * @return GetExternalOperatorReferralTeamIdByCitizenIdResponse
     */
    getExternalOperatorReferralTeamIdByCitizenId(query: GetExternalOperatorReferralTeamIdByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetExternalOperatorReferralTeamIdByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getexternaloperatorreferralteamidbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicalCollaboratorCitizenContextRequest
     * @return GetMedicalCollaboratorCitizenContextResponse
     */
    getMedicalCollaboratorCitizenContext(query: GetMedicalCollaboratorCitizenContextRequest, cancelToken?: CancelToken): Promise<GetMedicalCollaboratorCitizenContextResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getmedicalcollaboratorcitizencontext`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicalCollaboratorCitizenHeaderRequest
     * @return GetMedicalCollaboratorCitizenHeaderResponse
     */
    getMedicalCollaboratorCitizenHeader(query: GetMedicalCollaboratorCitizenHeaderRequest, cancelToken?: CancelToken): Promise<GetMedicalCollaboratorCitizenHeaderResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getmedicalcollaboratorcitizenheader`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOrAddCitizenRequest
     * @return GetOrAddCitizenResponse
     */
    getOrAddCitizen(query: GetOrAddCitizenRequest, cancelToken?: CancelToken): Promise<GetOrAddCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getoraddcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetRestrictedFromPrimaryCaseRequest
     * @return GetRestrictedFromPrimaryCaseResponse
     */
    getRestrictedFromPrimaryCase(query: GetRestrictedFromPrimaryCaseRequest, cancelToken?: CancelToken): Promise<GetRestrictedFromPrimaryCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getrestrictedfromprimarycase`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSocialProviderCitizenContextRequest
     * @return GetSocialProviderCitizenContextResponse
     */
    getSocialProviderCitizenContext(query: GetSocialProviderCitizenContextRequest, cancelToken?: CancelToken): Promise<GetSocialProviderCitizenContextResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getsocialprovidercitizencontext`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSocialProviderCitizenHeaderRequest
     * @return GetSocialProviderCitizenHeaderResponse
     */
    getSocialProviderCitizenHeader(query: GetSocialProviderCitizenHeaderRequest, cancelToken?: CancelToken): Promise<GetSocialProviderCitizenHeaderResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/getsocialprovidercitizenheader`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return IsCurrentUserSchultzUserResponse
     */
    isCurrentUserSchultzUser(cancelToken?: CancelToken): Promise<IsCurrentUserSchultzUserResponse> {
        const $url = `${this.baseUrl}/api/citizen/queries/iscurrentuserschultzuser`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenClarificationRightClient {
    /**
     * @param command CreateClarificationRightRequest
     * @return CreateClarificationRightResponse
     */
    createClarificationRight(command: CreateClarificationRightRequest, cancelToken?: CancelToken): Promise<CreateClarificationRightResponse>;
    /**
     * @param command DeleteClarificationRightRequest
     * @return DeleteClarificationRightResponse
     */
    deleteClarificationRight(command: DeleteClarificationRightRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateClarificationRightRequest
     * @return UpdateClarificationRightResponse
     */
    updateClarificationRight(command: UpdateClarificationRightRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetClarificationRightByIdRequest
     * @return GetClarificationRightByIdResponse
     */
    getClarificationRightById(query: GetClarificationRightByIdRequest, cancelToken?: CancelToken): Promise<GetClarificationRightByIdResponse>;
    /**
     * @param query GetClarificationRightsListRequest
     * @return GetClarificationRightsListResponse
     */
    getClarificationRightsList(query: GetClarificationRightsListRequest, cancelToken?: CancelToken): Promise<GetClarificationRightsListResponse>;
}

export class CitizenClarificationRightClient implements ICitizenClarificationRightClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateClarificationRightRequest
     * @return CreateClarificationRightResponse
     */
    createClarificationRight(command: CreateClarificationRightRequest, cancelToken?: CancelToken): Promise<CreateClarificationRightResponse> {
        const $url = `${this.baseUrl}/api/citizen/clarificationright/commands/createclarificationright`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteClarificationRightRequest
     * @return DeleteClarificationRightResponse
     */
    deleteClarificationRight(command: DeleteClarificationRightRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/clarificationright/commands/deleteclarificationright`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateClarificationRightRequest
     * @return UpdateClarificationRightResponse
     */
    updateClarificationRight(command: UpdateClarificationRightRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/clarificationright/commands/updateclarificationright`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetClarificationRightByIdRequest
     * @return GetClarificationRightByIdResponse
     */
    getClarificationRightById(query: GetClarificationRightByIdRequest, cancelToken?: CancelToken): Promise<GetClarificationRightByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/clarificationright/queries/getclarificationrightbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetClarificationRightsListRequest
     * @return GetClarificationRightsListResponse
     */
    getClarificationRightsList(query: GetClarificationRightsListRequest, cancelToken?: CancelToken): Promise<GetClarificationRightsListResponse> {
        const $url = `${this.baseUrl}/api/citizen/clarificationright/queries/getclarificationrightslist`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenCitizenTaskClient {
    /**
     * @param command GetCitizenTaskRequest
     * @return GetCitizenTaskResponse
     */
    getCitizenTask(command: GetCitizenTaskRequest, cancelToken?: CancelToken): Promise<GetCitizenTaskResponse>;
    /**
     * @param command CompleteCitizenTaskRequest
     * @return CompleteCitizenTaskResponse
     */
    completeCitizenTask(command: CompleteCitizenTaskRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateCitizenAdvisRequest
     * @return CreateCitizenAdvisResponse
     */
    createCitizenAdvis(command: CreateCitizenAdvisRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateCitizenTaskRequest
     * @return CreateCitizenTaskResponse
     */
    createCitizenTask(command: CreateCitizenTaskRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command JournalizeCitizenTaskOnCitizenRequest
     * @return JournalizeCitizenTaskOnCitizenResponse
     */
    journalizeCitizenTaskOnCitizen(command: JournalizeCitizenTaskOnCitizenRequest, cancelToken?: CancelToken): Promise<JournalizeCitizenTaskOnCitizenResponse>;
    /**
     * @param command JournalizeCitizenTaskOnCompanyRequest
     * @return JournalizeCitizenTaskOnCompanyResponse
     */
    journalizeCitizenTaskOnCompany(command: JournalizeCitizenTaskOnCompanyRequest, cancelToken?: CancelToken): Promise<JournalizeCitizenTaskOnCompanyResponse>;
    /**
     * @param command ReopenCitizenTaskRequest
     * @return ReopenCitizenTaskResponse
     */
    reopenCitizenTask(command: ReopenCitizenTaskRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SetCitizenTaskStatusIgangRequest
     * @return SetCitizenTaskStatusIgangResponse
     */
    setCitizenTaskStatusIgang(command: SetCitizenTaskStatusIgangRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SetCitizenTaskStatusPlanlagtRequest
     * @return SetCitizenTaskStatusPlanlagtResponse
     */
    setCitizenTaskStatusPlanlagt(command: SetCitizenTaskStatusPlanlagtRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCitizenTaskRequest
     * @return UpdateCitizenTaskResponse
     */
    updateCitizenTask(command: UpdateCitizenTaskRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetCitizenCasesRequest
     * @return GetCitizenCasesResponse
     */
    getCitizenCases(query: GetCitizenCasesRequest3, cancelToken?: CancelToken): Promise<GetCitizenCasesResponse3>;
    /**
     * @param query GetCitizenTaskCreationDataRequest
     * @return GetCitizenTaskCreationDataResponse
     */
    getCitizenTaskCreationData(query: GetCitizenTaskCreationDataRequest, cancelToken?: CancelToken): Promise<GetCitizenTaskCreationDataResponse>;
    /**
     * @param query GetCitizenTasksMetaDataRequest
     * @return GetCitizenTasksMetaDataResponse
     */
    getCitizenTasksMetaData(query: GetCitizenTasksMetaDataRequest, cancelToken?: CancelToken): Promise<GetCitizenTasksMetaDataResponse>;
    /**
     * @param query CompleteCitizenTasksRequest
     * @return CompleteCitizenTasksResponse
     */
    completeCitizenTasks(query: CompleteCitizenTasksRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query ReassignCitizenTasksRequest
     * @return ReassignCitizenTasksResponse
     */
    reassignCitizenTasks(query: ReassignCitizenTasksRequest, cancelToken?: CancelToken): Promise<any>;
}

export class CitizenCitizenTaskClient implements ICitizenCitizenTaskClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command GetCitizenTaskRequest
     * @return GetCitizenTaskResponse
     */
    getCitizenTask(command: GetCitizenTaskRequest, cancelToken?: CancelToken): Promise<GetCitizenTaskResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/commands/getcitizentask`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CompleteCitizenTaskRequest
     * @return CompleteCitizenTaskResponse
     */
    completeCitizenTask(command: CompleteCitizenTaskRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/commands/completecitizentask`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCitizenAdvisRequest
     * @return CreateCitizenAdvisResponse
     */
    createCitizenAdvis(command: CreateCitizenAdvisRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/commands/createcitizenadvis`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCitizenTaskRequest
     * @return CreateCitizenTaskResponse
     */
    createCitizenTask(command: CreateCitizenTaskRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/commands/createcitizentask`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command JournalizeCitizenTaskOnCitizenRequest
     * @return JournalizeCitizenTaskOnCitizenResponse
     */
    journalizeCitizenTaskOnCitizen(command: JournalizeCitizenTaskOnCitizenRequest, cancelToken?: CancelToken): Promise<JournalizeCitizenTaskOnCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/commands/journalizecitizentaskoncitizen`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command JournalizeCitizenTaskOnCompanyRequest
     * @return JournalizeCitizenTaskOnCompanyResponse
     */
    journalizeCitizenTaskOnCompany(command: JournalizeCitizenTaskOnCompanyRequest, cancelToken?: CancelToken): Promise<JournalizeCitizenTaskOnCompanyResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/commands/journalizecitizentaskoncompany`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReopenCitizenTaskRequest
     * @return ReopenCitizenTaskResponse
     */
    reopenCitizenTask(command: ReopenCitizenTaskRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/commands/reopencitizentask`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetCitizenTaskStatusIgangRequest
     * @return SetCitizenTaskStatusIgangResponse
     */
    setCitizenTaskStatusIgang(command: SetCitizenTaskStatusIgangRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/commands/setcitizentaskstatusigang`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetCitizenTaskStatusPlanlagtRequest
     * @return SetCitizenTaskStatusPlanlagtResponse
     */
    setCitizenTaskStatusPlanlagt(command: SetCitizenTaskStatusPlanlagtRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/commands/setcitizentaskstatusplanlagt`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCitizenTaskRequest
     * @return UpdateCitizenTaskResponse
     */
    updateCitizenTask(command: UpdateCitizenTaskRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/commands/updatecitizentask`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenCasesRequest
     * @return GetCitizenCasesResponse
     */
    getCitizenCases(query: GetCitizenCasesRequest3, cancelToken?: CancelToken): Promise<GetCitizenCasesResponse3> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/queries/getcitizencases`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenTaskCreationDataRequest
     * @return GetCitizenTaskCreationDataResponse
     */
    getCitizenTaskCreationData(query: GetCitizenTaskCreationDataRequest, cancelToken?: CancelToken): Promise<GetCitizenTaskCreationDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/queries/getcitizentaskcreationdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenTasksMetaDataRequest
     * @return GetCitizenTasksMetaDataResponse
     */
    getCitizenTasksMetaData(query: GetCitizenTasksMetaDataRequest, cancelToken?: CancelToken): Promise<GetCitizenTasksMetaDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/queries/getcitizentasksmetadata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query CompleteCitizenTasksRequest
     * @return CompleteCitizenTasksResponse
     */
    completeCitizenTasks(query: CompleteCitizenTasksRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/queries/completecitizentasks`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query ReassignCitizenTasksRequest
     * @return ReassignCitizenTasksResponse
     */
    reassignCitizenTasks(query: ReassignCitizenTasksRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizentask/queries/reassigncitizentasks`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenCitizenMasterDataPersonGroupClient {
    /**
     * @param command CreatePersonGroupRequest
     * @return CreatePersonGroupResponse
     */
    createPersonGroup(command: CreatePersonGroupRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeletePersonGroupRequest
     * @return DeletePersonGroupResponse
     */
    deletePersonGroup(command: DeletePersonGroupRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdatePersonGroupRequest
     * @return UpdatePersonGroupResponse
     */
    updatePersonGroup(command: UpdatePersonGroupRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetCitizenIdFromPersonGroupMarkingIdRequest
     * @return GetCitizenIdFromPersonGroupMarkingIdResponse
     */
    getCitizenIdFromPersonGroupMarkingId(query: GetCitizenIdFromPersonGroupMarkingIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdFromPersonGroupMarkingIdResponse>;
    /**
     * @param query GetPersonGroupMarkingsForCitizenRequest
     * @return GetPersonGroupMarkingsForCitizenResponse
     */
    getPersonGroupMarkingsForCitizen(query: GetPersonGroupMarkingsForCitizenRequest, cancelToken?: CancelToken): Promise<GetPersonGroupMarkingsForCitizenResponse>;
    /**
     * @param query GetPersonGroupMarkingStatisticsRequest
     * @return GetPersonGroupMarkingStatisticsResponse
     */
    getPersonGroupMarkingStatistics(query: GetPersonGroupMarkingStatisticsRequest, cancelToken?: CancelToken): Promise<GetPersonGroupMarkingStatisticsResponse>;
    /**
     * @return GetPersonGroupsResponse
     */
    getPersonGroups(cancelToken?: CancelToken): Promise<GetPersonGroupsResponse>;
    /**
     * @param query CreatePersonGroupMarkingRequest
     * @return CreatePersonGroupMarkingResponse
     */
    createPersonGroupMarking(query: CreatePersonGroupMarkingRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query DeletePersonGroupMarkingRequest
     * @return DeletePersonGroupMarkingResponse
     */
    deletePersonGroupMarking(query: DeletePersonGroupMarkingRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query UpdatePersonGroupMarkingRequest
     * @return UpdatePersonGroupMarkingResponse
     */
    updatePersonGroupMarking(query: UpdatePersonGroupMarkingRequest, cancelToken?: CancelToken): Promise<any>;
}

export class CitizenCitizenMasterDataPersonGroupClient implements ICitizenCitizenMasterDataPersonGroupClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreatePersonGroupRequest
     * @return CreatePersonGroupResponse
     */
    createPersonGroup(command: CreatePersonGroupRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/persongroup/commands/createpersongroup`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeletePersonGroupRequest
     * @return DeletePersonGroupResponse
     */
    deletePersonGroup(command: DeletePersonGroupRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/persongroup/commands/deletepersongroup`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdatePersonGroupRequest
     * @return UpdatePersonGroupResponse
     */
    updatePersonGroup(command: UpdatePersonGroupRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/persongroup/commands/updatepersongroup`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenIdFromPersonGroupMarkingIdRequest
     * @return GetCitizenIdFromPersonGroupMarkingIdResponse
     */
    getCitizenIdFromPersonGroupMarkingId(query: GetCitizenIdFromPersonGroupMarkingIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdFromPersonGroupMarkingIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/persongroup/queries/getcitizenidfrompersongroupmarkingid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPersonGroupMarkingsForCitizenRequest
     * @return GetPersonGroupMarkingsForCitizenResponse
     */
    getPersonGroupMarkingsForCitizen(query: GetPersonGroupMarkingsForCitizenRequest, cancelToken?: CancelToken): Promise<GetPersonGroupMarkingsForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/persongroup/queries/getpersongroupmarkingsforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPersonGroupMarkingStatisticsRequest
     * @return GetPersonGroupMarkingStatisticsResponse
     */
    getPersonGroupMarkingStatistics(query: GetPersonGroupMarkingStatisticsRequest, cancelToken?: CancelToken): Promise<GetPersonGroupMarkingStatisticsResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/persongroup/queries/getpersongroupmarkingstatistics`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetPersonGroupsResponse
     */
    getPersonGroups(cancelToken?: CancelToken): Promise<GetPersonGroupsResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/persongroup/queries/getpersongroups`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query CreatePersonGroupMarkingRequest
     * @return CreatePersonGroupMarkingResponse
     */
    createPersonGroupMarking(query: CreatePersonGroupMarkingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/persongroup/queries/createpersongroupmarking`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DeletePersonGroupMarkingRequest
     * @return DeletePersonGroupMarkingResponse
     */
    deletePersonGroupMarking(query: DeletePersonGroupMarkingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/persongroup/queries/deletepersongroupmarking`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query UpdatePersonGroupMarkingRequest
     * @return UpdatePersonGroupMarkingResponse
     */
    updatePersonGroupMarking(query: UpdatePersonGroupMarkingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/persongroup/queries/updatepersongroupmarking`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenCitizenMasterDataParticularitiesClient {
    /**
     * @param command UpdatePersonNotificationSettingsRequest
     * @return UpdatePersonNotificationSettingsResponse
     */
    updatePersonNotificationSettings(command: UpdatePersonNotificationSettingsRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetParticularitiesDataRequest
     * @return GetParticularitiesDataResponse
     */
    getParticularitiesData(query: GetParticularitiesDataRequest, cancelToken?: CancelToken): Promise<GetParticularitiesDataResponse>;
}

export class CitizenCitizenMasterDataParticularitiesClient implements ICitizenCitizenMasterDataParticularitiesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command UpdatePersonNotificationSettingsRequest
     * @return UpdatePersonNotificationSettingsResponse
     */
    updatePersonNotificationSettings(command: UpdatePersonNotificationSettingsRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/particularities/commands/updatepersonnotificationsettings`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetParticularitiesDataRequest
     * @return GetParticularitiesDataResponse
     */
    getParticularitiesData(query: GetParticularitiesDataRequest, cancelToken?: CancelToken): Promise<GetParticularitiesDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/particularities/queries/getparticularitiesdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenCitizenMasterDataCitizenPersonContactClient {
    /**
     * @param command CreateCitizenPersonContactRequest
     * @return CreateCitizenPersonContactResponse
     */
    createCitizenPersonContact(command: CreateCitizenPersonContactRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SyncMissingCitizenPersonContactsRequest
     * @return SyncMissingCitizenPersonContactsResponse
     */
    syncMissingCitizenPersonContacts(command: SyncMissingCitizenPersonContactsRequest, cancelToken?: CancelToken): Promise<SyncMissingCitizenPersonContactsResponse>;
    /**
     * @param command UpdateCitizenPersonContactRequest
     * @return UpdateCitizenPersonContactResponse
     */
    updateCitizenPersonContact(command: UpdateCitizenPersonContactRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command VerifyAndSyncCitizenPersonContactWithDfdgRequest
     * @return VerifyAndSyncCitizenPersonContactWithDfdgResponse
     */
    verifyAndSyncCitizenPersonContactWithDfdg(command: VerifyAndSyncCitizenPersonContactWithDfdgRequest, cancelToken?: CancelToken): Promise<VerifyAndSyncCitizenPersonContactWithDfdgResponse>;
    /**
     * @param query GetCitizenIdForCitizenPersonContactRequest
     * @return GetCitizenIdForCitizenPersonContactResponse
     */
    getCitizenIdForCitizenPersonContact(query: GetCitizenIdForCitizenPersonContactRequest, cancelToken?: CancelToken): Promise<GetCitizenIdForCitizenPersonContactResponse>;
    /**
     * @param query GetCitizenPersonContactsForOverviewRequest
     * @return GetCitizenPersonContactsForOverviewResponse
     */
    getCitizenPersonContactsForOverview(query: GetCitizenPersonContactsForOverviewRequest, cancelToken?: CancelToken): Promise<GetCitizenPersonContactsForOverviewResponse>;
    /**
     * @param query GetCitizenPersonContactsForPrivateContactPersonRequest
     * @return GetCitizenPersonContactsForPrivateContactPersonResponse
     */
    getCitizenPersonContactsForPrivateContactPerson(query: GetCitizenPersonContactsForPrivateContactPersonRequest, cancelToken?: CancelToken): Promise<GetCitizenPersonContactsForPrivateContactPersonResponse>;
    /**
     * @param query GetEditableCitizenPersonContactRequest
     * @return GetEditableCitizenPersonContactResponse
     */
    getEditableCitizenPersonContact(query: GetEditableCitizenPersonContactRequest, cancelToken?: CancelToken): Promise<GetEditableCitizenPersonContactResponse>;
    /**
     * @return GetPersonContactTypesResponse
     */
    getPersonContactTypes(cancelToken?: CancelToken): Promise<GetPersonContactTypesResponse>;
}

export class CitizenCitizenMasterDataCitizenPersonContactClient implements ICitizenCitizenMasterDataCitizenPersonContactClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateCitizenPersonContactRequest
     * @return CreateCitizenPersonContactResponse
     */
    createCitizenPersonContact(command: CreateCitizenPersonContactRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizenpersoncontact/commands/createcitizenpersoncontact`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SyncMissingCitizenPersonContactsRequest
     * @return SyncMissingCitizenPersonContactsResponse
     */
    syncMissingCitizenPersonContacts(command: SyncMissingCitizenPersonContactsRequest, cancelToken?: CancelToken): Promise<SyncMissingCitizenPersonContactsResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizenpersoncontact/commands/syncmissingcitizenpersoncontacts`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCitizenPersonContactRequest
     * @return UpdateCitizenPersonContactResponse
     */
    updateCitizenPersonContact(command: UpdateCitizenPersonContactRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizenpersoncontact/commands/updatecitizenpersoncontact`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command VerifyAndSyncCitizenPersonContactWithDfdgRequest
     * @return VerifyAndSyncCitizenPersonContactWithDfdgResponse
     */
    verifyAndSyncCitizenPersonContactWithDfdg(command: VerifyAndSyncCitizenPersonContactWithDfdgRequest, cancelToken?: CancelToken): Promise<VerifyAndSyncCitizenPersonContactWithDfdgResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizenpersoncontact/commands/verifyandsynccitizenpersoncontactwithdfdg`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenIdForCitizenPersonContactRequest
     * @return GetCitizenIdForCitizenPersonContactResponse
     */
    getCitizenIdForCitizenPersonContact(query: GetCitizenIdForCitizenPersonContactRequest, cancelToken?: CancelToken): Promise<GetCitizenIdForCitizenPersonContactResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizenpersoncontact/queries/getcitizenidforcitizenpersoncontact`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenPersonContactsForOverviewRequest
     * @return GetCitizenPersonContactsForOverviewResponse
     */
    getCitizenPersonContactsForOverview(query: GetCitizenPersonContactsForOverviewRequest, cancelToken?: CancelToken): Promise<GetCitizenPersonContactsForOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizenpersoncontact/queries/getcitizenpersoncontactsforoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenPersonContactsForPrivateContactPersonRequest
     * @return GetCitizenPersonContactsForPrivateContactPersonResponse
     */
    getCitizenPersonContactsForPrivateContactPerson(query: GetCitizenPersonContactsForPrivateContactPersonRequest, cancelToken?: CancelToken): Promise<GetCitizenPersonContactsForPrivateContactPersonResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizenpersoncontact/queries/getcitizenpersoncontactsforprivatecontactperson`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEditableCitizenPersonContactRequest
     * @return GetEditableCitizenPersonContactResponse
     */
    getEditableCitizenPersonContact(query: GetEditableCitizenPersonContactRequest, cancelToken?: CancelToken): Promise<GetEditableCitizenPersonContactResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizenpersoncontact/queries/geteditablecitizenpersoncontact`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetPersonContactTypesResponse
     */
    getPersonContactTypes(cancelToken?: CancelToken): Promise<GetPersonContactTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizenpersoncontact/queries/getpersoncontacttypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenCitizenMasterDataCitizenCoreClient {
    /**
     * @param command CreateCitizenCommentRequest
     * @return CreateCitizenCommentResponse
     */
    createCitizenComment(command: CreateCitizenCommentRequest, cancelToken?: CancelToken): Promise<CreateCitizenCommentResponse>;
    /**
     * @param command SaveCaveInformationRequest
     * @return SaveCaveInformationResponse
     */
    saveCaveInformation(command: SaveCaveInformationRequest, cancelToken?: CancelToken): Promise<SaveCaveInformationResponse>;
    /**
     * @param command SaveCitizenCoreEditableFieldsRequest
     * @return SaveCitizenCoreEditableFieldsResponse
     */
    saveCitizenCoreEditableFields(command: SaveCitizenCoreEditableFieldsRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateNotesRequest
     * @return UpdateNotesResponse
     */
    updateNotes(command: UpdateNotesRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateTemporaryAddressRequest
     * @return UpdateTemporaryAddressResponse
     */
    updateTemporaryAddress(command: UpdateTemporaryAddressRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetCaveInformationByCitizenIdRequest
     * @return GetCaveInformationByCitizenIdResponse
     */
    getCaveInformationByCitizenId(query: GetCaveInformationByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetCaveInformationByCitizenIdResponse>;
    /**
     * @param query GetCitizenAddressHistoryRequest
     * @return GetCitizenAddressHistoryResponse
     */
    getCitizenAddressHistory(query: GetCitizenAddressHistoryRequest, cancelToken?: CancelToken): Promise<GetCitizenAddressHistoryResponse>;
    /**
     * @param query GetCitizenCommentsRequest
     * @return GetCitizenCommentsResponse
     */
    getCitizenComments(query: GetCitizenCommentsRequest, cancelToken?: CancelToken): Promise<GetCitizenCommentsResponse>;
    /**
     * @return GetCitizenCoreListsResponse
     */
    getCitizenCoreLists(cancelToken?: CancelToken): Promise<GetCitizenCoreListsResponse>;
    /**
     * @param query GetCitizenCoreViewModelByCitizenIdRequest
     * @return GetCitizenCoreViewModelByCitizenIdResponse
     */
    getCitizenCoreViewModelByCitizenId(query: GetCitizenCoreViewModelByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetCitizenCoreViewModelByCitizenIdResponse>;
    /**
     * @param query GetNotesForCitizenRequest
     * @return GetNotesForCitizenResponse
     */
    getNotesForCitizen(query: GetNotesForCitizenRequest, cancelToken?: CancelToken): Promise<GetNotesForCitizenResponse>;
    /**
     * @param query GetTemporaryAddressGuideDataRequest
     * @return GetTemporaryAddressGuideDataResponse
     */
    getTemporaryAddressGuideData(query: GetTemporaryAddressGuideDataRequest, cancelToken?: CancelToken): Promise<GetTemporaryAddressGuideDataResponse>;
}

export class CitizenCitizenMasterDataCitizenCoreClient implements ICitizenCitizenMasterDataCitizenCoreClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateCitizenCommentRequest
     * @return CreateCitizenCommentResponse
     */
    createCitizenComment(command: CreateCitizenCommentRequest, cancelToken?: CancelToken): Promise<CreateCitizenCommentResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizencore/commands/createcitizencomment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SaveCaveInformationRequest
     * @return SaveCaveInformationResponse
     */
    saveCaveInformation(command: SaveCaveInformationRequest, cancelToken?: CancelToken): Promise<SaveCaveInformationResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizencore/commands/savecaveinformation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SaveCitizenCoreEditableFieldsRequest
     * @return SaveCitizenCoreEditableFieldsResponse
     */
    saveCitizenCoreEditableFields(command: SaveCitizenCoreEditableFieldsRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizencore/commands/savecitizencoreeditablefields`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateNotesRequest
     * @return UpdateNotesResponse
     */
    updateNotes(command: UpdateNotesRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizencore/commands/updatenotes`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateTemporaryAddressRequest
     * @return UpdateTemporaryAddressResponse
     */
    updateTemporaryAddress(command: UpdateTemporaryAddressRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizencore/commands/updatetemporaryaddress`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaveInformationByCitizenIdRequest
     * @return GetCaveInformationByCitizenIdResponse
     */
    getCaveInformationByCitizenId(query: GetCaveInformationByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetCaveInformationByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizencore/queries/getcaveinformationbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenAddressHistoryRequest
     * @return GetCitizenAddressHistoryResponse
     */
    getCitizenAddressHistory(query: GetCitizenAddressHistoryRequest, cancelToken?: CancelToken): Promise<GetCitizenAddressHistoryResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizencore/queries/getcitizenaddresshistory`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenCommentsRequest
     * @return GetCitizenCommentsResponse
     */
    getCitizenComments(query: GetCitizenCommentsRequest, cancelToken?: CancelToken): Promise<GetCitizenCommentsResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizencore/queries/getcitizencomments`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCitizenCoreListsResponse
     */
    getCitizenCoreLists(cancelToken?: CancelToken): Promise<GetCitizenCoreListsResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizencore/queries/getcitizencorelists`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenCoreViewModelByCitizenIdRequest
     * @return GetCitizenCoreViewModelByCitizenIdResponse
     */
    getCitizenCoreViewModelByCitizenId(query: GetCitizenCoreViewModelByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetCitizenCoreViewModelByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizencore/queries/getcitizencoreviewmodelbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNotesForCitizenRequest
     * @return GetNotesForCitizenResponse
     */
    getNotesForCitizen(query: GetNotesForCitizenRequest, cancelToken?: CancelToken): Promise<GetNotesForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizencore/queries/getnotesforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTemporaryAddressGuideDataRequest
     * @return GetTemporaryAddressGuideDataResponse
     */
    getTemporaryAddressGuideData(query: GetTemporaryAddressGuideDataRequest, cancelToken?: CancelToken): Promise<GetTemporaryAddressGuideDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/citizencore/queries/gettemporaryaddressguidedata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenCaseClient {
    /**
     * @param command CloseCaseRequest
     * @return CloseCaseResponse
     */
    closeCase(command: CloseCaseRequest, cancelToken?: CancelToken): Promise<CloseCaseResponse>;
    /**
     * @param command CreateAndTerminateCaseRequest
     * @return CreateAndTerminateCaseResponse
     */
    createAndTerminateCase(command: CreateAndTerminateCaseRequest, cancelToken?: CancelToken): Promise<CreateAndTerminateCaseResponse>;
    /**
     * @param command CreateAssociatedCaseWorkerRequest
     * @return CreateAssociatedCaseWorkerResponse
     */
    createAssociatedCaseWorker(command: CreateAssociatedCaseWorkerRequest, cancelToken?: CancelToken): Promise<CreateAssociatedCaseWorkerResponse>;
    /**
     * @param command UpdateAssociatedCaseWorkerOnCasesRequest
     * @return UpdateAssociatedCaseWorkerOnCasesResponse
     */
    createAssociatedCaseWorkerOnCases(command: UpdateAssociatedCaseWorkerOnCasesRequest, cancelToken?: CancelToken): Promise<UpdateAssociatedCaseWorkerOnCasesResponse>;
    /**
     * @param command CreateCaseRequest
     * @return CreateCaseResponse
     */
    createCase(command: CreateCaseRequest, cancelToken?: CancelToken): Promise<CreateCaseResponse>;
    /**
     * @param command DeleteAssociatedCaseWorkerRequest
     * @return DeleteAssociatedCaseWorkerResponse
     */
    deleteAssociatedCaseWorker(command: DeleteAssociatedCaseWorkerRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DocumentRehabSendToDfdgRequest
     * @return DocumentRehabSendToDfdgResponse
     */
    documentRehabSendToDfdg(command: DocumentRehabSendToDfdgRequest, cancelToken?: CancelToken): Promise<DocumentRehabSendToDfdgResponse>;
    /**
     * @param command GenerateAutomaticLetterByIdRequest
     * @return GenerateAutomaticLetterByIdResponse
     */
    generateAutomaticLetterById(command: GenerateAutomaticLetterByIdRequest, cancelToken?: CancelToken): Promise<GenerateAutomaticLetterByIdResponse>;
    /**
     * @param command ReassignCasesRequest
     * @return ReassignCasesResponse
     */
    reassignCases(command: ReassignCasesRequest, cancelToken?: CancelToken): Promise<ReassignCasesResponse>;
    /**
     * @param command ReassignCasesSyncroneRequest
     * @return ReassignCasesSyncroneResponse
     */
    reassignCasesSyncrone(command: ReassignCasesSyncroneRequest, cancelToken?: CancelToken): Promise<ReassignCasesSyncroneResponse>;
    /**
     * @param command ReassignCaseworkerOnCaseRequest
     * @return ReassignCaseworkerOnCaseResponse
     */
    reassignCaseworkerOnCase(command: ReassignCaseworkerOnCaseRequest, cancelToken?: CancelToken): Promise<ReassignCaseworkerOnCaseResponse>;
    /**
     * @param command ReopenCaseRequest
     * @return ReopenCaseResponse
     */
    reopenCase(command: ReopenCaseRequest, cancelToken?: CancelToken): Promise<ReopenCaseResponse>;
    /**
     * @param command SaveSicknessBenefitVisitationRequest
     * @return SaveSicknessBenefitVisitationResponse
     */
    saveSicknessBenefitVisitation(command: SaveSicknessBenefitVisitationRequest, cancelToken?: CancelToken): Promise<SaveSicknessBenefitVisitationResponse>;
    /**
     * @param command UpdateAssociatedCaseWorkerRequest
     * @return UpdateAssociatedCaseWorkerResponse
     */
    updateAssociatedCaseWorker(command: UpdateAssociatedCaseWorkerRequest, cancelToken?: CancelToken): Promise<UpdateAssociatedCaseWorkerResponse>;
    /**
     * @param command UpdateCaseRequest
     * @return UpdateCaseResponse
     */
    updateCase(command: UpdateCaseRequest, cancelToken?: CancelToken): Promise<UpdateCaseResponse>;
    /**
     * @param command UpdateCaseRehabStatusRequest
     * @return UpdateCaseRehabStatusResponse
     */
    updateCaseRehabStatus(command: UpdateCaseRehabStatusRequest, cancelToken?: CancelToken): Promise<UpdateCaseRehabStatusResponse>;
    /**
     * @param command UpdateCaseTypeRequest
     * @return UpdateCaseTypeResponse
     */
    updateCaseType(command: UpdateCaseTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateRehabCaseRequest
     * @return UpdateRehabCaseResponse
     */
    updateRehabCase(command: UpdateRehabCaseRequest, cancelToken?: CancelToken): Promise<UpdateRehabCaseResponse>;
    /**
     * @param query AnalyzeSicknessBenefitVisitationStreamingRequest
     * @return FileResponse
     */
    analyzeSicknessBenefitVisitationStreaming(query: AnalyzeSicknessBenefitVisitationStreamingRequest, signal?: AbortSignal): Promise<NdjsonStreamResponse>;
    /**
     * @param query GetActiveSicknessAbsenceByCitizenIdRequest
     * @return GetActiveSicknessAbsenceByCitizenIdResponse
     */
    getActiveSicknessAbsenceByCitizenId(query: GetActiveSicknessAbsenceByCitizenIdRequest2, cancelToken?: CancelToken): Promise<GetActiveSicknessAbsenceByCitizenIdResponse2>;
    /**
     * @param query GetAssociatedCaseWorkerRequest
     * @return GetAssociatedCaseWorkerResponse
     */
    getAssociatedCaseWorker(query: GetAssociatedCaseWorkerRequest, cancelToken?: CancelToken): Promise<GetAssociatedCaseWorkerResponse>;
    /**
     * @return GetAssociateUserRolesResponse
     */
    getAssociateUserRoles(cancelToken?: CancelToken): Promise<GetAssociateUserRolesResponse>;
    /**
     * @param query GetAssociateUsersByCaseIdRequest
     * @return GetAssociateUsersByCaseIdResponse
     */
    getAssociateUsersByCaseId(query: GetAssociateUsersByCaseIdRequest, cancelToken?: CancelToken): Promise<GetAssociateUsersByCaseIdResponse>;
    /**
     * @param query GetCaseDetailsByIdRequest
     * @return GetCaseDetailsByIdResponse
     */
    getCaseDetailsById(query: GetCaseDetailsByIdRequest, cancelToken?: CancelToken): Promise<GetCaseDetailsByIdResponse>;
    /**
     * @return GetCaseClosureReasonsResponse
     */
    getCaseClosureReasons(cancelToken?: CancelToken): Promise<GetCaseClosureReasonsResponse>;
    /**
     * @param query GetCaseClosureReasonsFilterOnCaseTypeRequest
     * @return GetCaseClosureReasonsFilterOnCaseTypeResponse
     */
    getCaseClosureReasonsFilterOnCaseType(query: GetCaseClosureReasonsFilterOnCaseTypeRequest, cancelToken?: CancelToken): Promise<GetCaseClosureReasonsFilterOnCaseTypeResponse>;
    /**
     * @return GetCaseContactReasonsResponse
     */
    getCaseContactReasons(cancelToken?: CancelToken): Promise<GetCaseContactReasonsResponse>;
    /**
     * @param query GetCaseContactReasonsFilterOnCaseTypeRequest
     * @return GetCaseContactReasonsFilterOnCaseTypeResponse
     */
    getCaseContactReasonsFilterOnCaseType(query: GetCaseContactReasonsFilterOnCaseTypeRequest, cancelToken?: CancelToken): Promise<GetCaseContactReasonsFilterOnCaseTypeResponse>;
    /**
     * @return GetCaseGroupsResponse
     */
    getCaseGroups(cancelToken?: CancelToken): Promise<GetCaseGroupsResponse>;
    /**
     * @param query GetCaseGroupsFilterOnCaseTypeRequest
     * @return GetCaseGroupsFilterOnCaseTypeResponse
     */
    getCaseGroupsFilterOnCaseType(query: GetCaseGroupsFilterOnCaseTypeRequest, cancelToken?: CancelToken): Promise<GetCaseGroupsFilterOnCaseTypeResponse>;
    /**
     * @param query GetCaseInfoForLinkRequest
     * @return GetCaseInfoForLinkResponse
     */
    getCaseInfoForLink(query: GetCaseInfoForLinkRequest, cancelToken?: CancelToken): Promise<GetCaseInfoForLinkResponse>;
    /**
     * @return GetCaseRestrictionOptionsResponse
     */
    getCaseRestrictionOptions(cancelToken?: CancelToken): Promise<GetCaseRestrictionOptionsResponse>;
    /**
     * @param query GetCasesRequest
     * @return GetCasesResponse
     */
    getCases(query: GetCasesRequest, cancelToken?: CancelToken): Promise<GetCasesResponse>;
    /**
     * @param query GetCaseTypeByCaseIdRequest
     * @return GetCaseTypeByCaseIdResponse
     */
    getCaseTypeByCaseId(query: GetCaseTypeByCaseIdRequest, cancelToken?: CancelToken): Promise<GetCaseTypeByCaseIdResponse>;
    /**
     * @param query GetCaseTypeByIdRequest
     * @return GetCaseTypeByIdResponse
     */
    getCaseTypeById(query: GetCaseTypeByIdRequest, cancelToken?: CancelToken): Promise<GetCaseTypeByIdResponse>;
    /**
     * @param query GetCaseTypesByTargetGroupIdRequest
     * @return GetCaseTypesByTargetGroupIdResponse
     */
    getCaseTypesByTargetGroupId(query: GetCaseTypesByTargetGroupIdRequest, cancelToken?: CancelToken): Promise<GetCaseTypesByTargetGroupIdResponse>;
    /**
     * @return GetCaseTypesForCreateCaseResponse
     */
    getCaseTypesForCreateCase(cancelToken?: CancelToken): Promise<GetCaseTypesForCreateCaseResponse>;
    /**
     * @param query GetCaseTypeValidationValuesRequest
     * @return GetCaseTypeValidationValuesResponse
     */
    getCaseTypeValidationValues(query: GetCaseTypeValidationValuesRequest, cancelToken?: CancelToken): Promise<GetCaseTypeValidationValuesResponse>;
    /**
     * @param query GetEffortGroupByIdRequest
     * @return GetEffortGroupByIdResponse
     */
    getEffortGroupById(query: GetEffortGroupByIdRequest, cancelToken?: CancelToken): Promise<GetEffortGroupByIdResponse>;
    /**
     * @param query GetHasActiveAbsenceByCitizenIdRequest
     * @return GetHasActiveAbsenceByCitizenIdResponse
     */
    getHasActiveAbsenceByCitizenId(query: GetHasActiveAbsenceByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetHasActiveAbsenceByCitizenIdResponse>;
    /**
     * @param query GetHasActiveContactPersonRequest
     * @return GetHasActiveContactPersonResponse
     */
    getHasActiveContactPersonByCitizenId(query: GetHasActiveContactPersonRequest, cancelToken?: CancelToken): Promise<GetHasActiveContactPersonResponse>;
    /**
     * @param query GetHasActiveEnrollmentsRequest
     * @return GetHasActiveEnrollmentsResponse
     */
    getHasActiveEnrollments(query: GetHasActiveEnrollmentsRequest, cancelToken?: CancelToken): Promise<GetHasActiveEnrollmentsResponse>;
    /**
     * @param query GetHasActivitiesByCitizenIdRequest
     * @return GetHasActivitiesByCitizenIdResponse
     */
    getHasActivitiesByCitizenId(query: GetHasActivitiesByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetHasActivitiesByCitizenIdResponse>;
    /**
     * @param query GetHasContactGroupDiscrepancyRequest
     * @return GetHasContactGroupDiscrepancyResponse
     */
    getHasContactGroupDiscrepancy(query: GetHasContactGroupDiscrepancyRequest, cancelToken?: CancelToken): Promise<GetHasContactGroupDiscrepancyResponse>;
    /**
     * @param query GetHasHistoricRegistrationRequest
     * @return GetHasHistoricRegistrationResponse
     */
    getHasHistoricRegistration(query: GetHasHistoricRegistrationRequest, cancelToken?: CancelToken): Promise<GetHasHistoricRegistrationResponse>;
    /**
     * @return GetInterviewCalculationsStartDateConfigurationResponse
     */
    getInterviewCalculationsStartDateConfiguration(cancelToken?: CancelToken): Promise<GetInterviewCalculationsStartDateConfigurationResponse>;
    /**
     * @param query GetMinAndMAxDateFromCasesRequest
     * @return GetMinAndMAxDateFromCasesResponse
     */
    getMinAndMAxDateFromCases(query: GetMinAndMAxDateFromCasesRequest, cancelToken?: CancelToken): Promise<GetMinAndMAxDateFromCasesResponse>;
    /**
     * @param query GetMostRelevantSocialCaseRequest
     * @return GetMostRelevantSocialCaseResponse
     */
    getMostRelevantSocialCase(query: GetMostRelevantSocialCaseRequest, cancelToken?: CancelToken): Promise<GetMostRelevantSocialCaseResponse>;
    /**
     * @return GetMunicipalitiesResponse
     */
    getMunicipalities(cancelToken?: CancelToken): Promise<GetMunicipalitiesResponse3>;
    /**
     * @param query GetOpenCasesRequest
     * @return GetOpenCasesResponse
     */
    getOpenCases(query: GetOpenCasesRequest, cancelToken?: CancelToken): Promise<GetOpenCasesResponse>;
    /**
     * @param query GetPayingAndResponsibleMunicipalityInfoRequest
     * @return GetPayingAndResponsibleMunicipalityInfoResponse
     */
    getPayingAndResponsibleMunicipalityInfo(query: GetPayingAndResponsibleMunicipalityInfoRequest, cancelToken?: CancelToken): Promise<GetPayingAndResponsibleMunicipalityInfoResponse>;
    /**
     * @param query GetPersonCategoryNameByIdRequest
     * @return GetPersonCategoryNameByIdResponse
     */
    getPersonCategoryNameById(query: GetPersonCategoryNameByIdRequest, cancelToken?: CancelToken): Promise<GetPersonCategoryNameByIdResponse>;
    /**
     * @param query GetPrimaryCaseSummaryBoxDataRequest
     * @return GetPrimaryCaseSummaryBoxDataResponse
     */
    getPrimaryCaseSummaryBoxData(query: GetPrimaryCaseSummaryBoxDataRequest, cancelToken?: CancelToken): Promise<GetPrimaryCaseSummaryBoxDataResponse>;
    /**
     * @return GetRehabilitationProcessStatusTypesResponse
     */
    getRehabilitationProcessStatusTypes(cancelToken?: CancelToken): Promise<GetRehabilitationProcessStatusTypesResponse>;
    /**
     * @return GetRemovalCauseTypeResponse
     */
    getRemovalCauseTypes(cancelToken?: CancelToken): Promise<GetRemovalCauseTypeResponse>;
    /**
     * @param query GetScreeningPdfByCitizenIdRequest
     * @return FileResponse
     */
    getScreeningPdfByCitizenId(query: GetScreeningPdfByCitizenIdRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetSdpCaseDetailsByCitizenIdRequest
     * @return GetSdpCaseDetailsByCitizenIdResponse
     */
    getSdpCaseDetailsByCitizenId(query: GetSdpCaseDetailsByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetSdpCaseDetailsByCitizenIdResponse>;
    /**
     * @param query GetSelfScreeningRequest
     * @return GetSelfScreeningResponse
     */
    getSelfScreening(query: GetSelfScreeningRequest, cancelToken?: CancelToken): Promise<GetSelfScreeningResponse>;
    /**
     * @return GetSicknessBenefitOptionsResponse
     */
    getSicknessBenefitOptions(cancelToken?: CancelToken): Promise<GetSicknessBenefitOptionsResponse>;
    /**
     * @param query GetSicknessBenefitVisitationRequest
     * @return GetSicknessBenefitVisitationResponse
     */
    getSicknessBenefitVisitation(query: GetSicknessBenefitVisitationRequest, cancelToken?: CancelToken): Promise<GetSicknessBenefitVisitationResponse>;
    /**
     * @param query GetTargetGroupByCaseIdRequest
     * @return GetTargetGroupByCaseIdResponse
     */
    getTargetGroupByCaseId(query: GetTargetGroupByCaseIdRequest, cancelToken?: CancelToken): Promise<GetTargetGroupByCaseIdResponse>;
    /**
     * @param query HasAnyActiveCasesRequest
     * @return HasAnyActiveCasesResponse
     */
    hasAnyActiveCases(query: HasAnyActiveCasesRequest, cancelToken?: CancelToken): Promise<HasAnyActiveCasesResponse>;
    /**
     * @param query HasAnyOpenRehabCasesRequest
     * @return HasAnyOpenRehabCasesResponse
     */
    hasAnyOpenRehabCases(query: HasAnyOpenRehabCasesRequest, cancelToken?: CancelToken): Promise<HasAnyOpenRehabCasesResponse>;
    /**
     * @param query HasAnyOpenSicknessBenifitOrJobClarificationCasesRequest
     * @return HasAnyOpenSicknessBenifitOrJobClarificationCasesResponse
     */
    hasAnyOpenSicknessBenifitOrJobClarificationCases(query: HasAnyOpenSicknessBenifitOrJobClarificationCasesRequest, cancelToken?: CancelToken): Promise<HasAnyOpenSicknessBenifitOrJobClarificationCasesResponse>;
}

export class CitizenCaseClient implements ICitizenCaseClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CloseCaseRequest
     * @return CloseCaseResponse
     */
    closeCase(command: CloseCaseRequest, cancelToken?: CancelToken): Promise<CloseCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/closecase`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAndTerminateCaseRequest
     * @return CreateAndTerminateCaseResponse
     */
    createAndTerminateCase(command: CreateAndTerminateCaseRequest, cancelToken?: CancelToken): Promise<CreateAndTerminateCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/createandterminatecase`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAssociatedCaseWorkerRequest
     * @return CreateAssociatedCaseWorkerResponse
     */
    createAssociatedCaseWorker(command: CreateAssociatedCaseWorkerRequest, cancelToken?: CancelToken): Promise<CreateAssociatedCaseWorkerResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/createassociatedcaseworker`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAssociatedCaseWorkerOnCasesRequest
     * @return UpdateAssociatedCaseWorkerOnCasesResponse
     */
    createAssociatedCaseWorkerOnCases(command: UpdateAssociatedCaseWorkerOnCasesRequest, cancelToken?: CancelToken): Promise<UpdateAssociatedCaseWorkerOnCasesResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/createassociatedcaseworkeroncases`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCaseRequest
     * @return CreateCaseResponse
     */
    createCase(command: CreateCaseRequest, cancelToken?: CancelToken): Promise<CreateCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/createcase`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteAssociatedCaseWorkerRequest
     * @return DeleteAssociatedCaseWorkerResponse
     */
    deleteAssociatedCaseWorker(command: DeleteAssociatedCaseWorkerRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/deleteassociatedcaseworker`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DocumentRehabSendToDfdgRequest
     * @return DocumentRehabSendToDfdgResponse
     */
    documentRehabSendToDfdg(command: DocumentRehabSendToDfdgRequest, cancelToken?: CancelToken): Promise<DocumentRehabSendToDfdgResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/documentrehabsendtodfdg`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command GenerateAutomaticLetterByIdRequest
     * @return GenerateAutomaticLetterByIdResponse
     */
    generateAutomaticLetterById(command: GenerateAutomaticLetterByIdRequest, cancelToken?: CancelToken): Promise<GenerateAutomaticLetterByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/generateautomaticletterbyid`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReassignCasesRequest
     * @return ReassignCasesResponse
     */
    reassignCases(command: ReassignCasesRequest, cancelToken?: CancelToken): Promise<ReassignCasesResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/reassigncases`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReassignCasesSyncroneRequest
     * @return ReassignCasesSyncroneResponse
     */
    reassignCasesSyncrone(command: ReassignCasesSyncroneRequest, cancelToken?: CancelToken): Promise<ReassignCasesSyncroneResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/reassigncasessyncrone`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReassignCaseworkerOnCaseRequest
     * @return ReassignCaseworkerOnCaseResponse
     */
    reassignCaseworkerOnCase(command: ReassignCaseworkerOnCaseRequest, cancelToken?: CancelToken): Promise<ReassignCaseworkerOnCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/reassigncaseworkeroncase`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReopenCaseRequest
     * @return ReopenCaseResponse
     */
    reopenCase(command: ReopenCaseRequest, cancelToken?: CancelToken): Promise<ReopenCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/reopencase`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SaveSicknessBenefitVisitationRequest
     * @return SaveSicknessBenefitVisitationResponse
     */
    saveSicknessBenefitVisitation(command: SaveSicknessBenefitVisitationRequest, cancelToken?: CancelToken): Promise<SaveSicknessBenefitVisitationResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/savesicknessbenefitvisitation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAssociatedCaseWorkerRequest
     * @return UpdateAssociatedCaseWorkerResponse
     */
    updateAssociatedCaseWorker(command: UpdateAssociatedCaseWorkerRequest, cancelToken?: CancelToken): Promise<UpdateAssociatedCaseWorkerResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/updateassociatedcaseworker`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCaseRequest
     * @return UpdateCaseResponse
     */
    updateCase(command: UpdateCaseRequest, cancelToken?: CancelToken): Promise<UpdateCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/updatecase`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCaseRehabStatusRequest
     * @return UpdateCaseRehabStatusResponse
     */
    updateCaseRehabStatus(command: UpdateCaseRehabStatusRequest, cancelToken?: CancelToken): Promise<UpdateCaseRehabStatusResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/updatecaserehabstatus`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCaseTypeRequest
     * @return UpdateCaseTypeResponse
     */
    updateCaseType(command: UpdateCaseTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/updatecasetype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateRehabCaseRequest
     * @return UpdateRehabCaseResponse
     */
    updateRehabCase(command: UpdateRehabCaseRequest, cancelToken?: CancelToken): Promise<UpdateRehabCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/commands/updaterehabcase`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query AnalyzeSicknessBenefitVisitationStreamingRequest
     * @return FileResponse
     */
    analyzeSicknessBenefitVisitationStreaming(query: AnalyzeSicknessBenefitVisitationStreamingRequest, signal?: AbortSignal): Promise<NdjsonStreamResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/analyzesicknessbenefitvisitationstreaming`;

        const options_: AxiosRequestConfig = {
            data: query,
            adapter: 'fetch',
            responseType: 'stream',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/x-ndjson',
            },
            signal,
        };

        return handleStreamResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActiveSicknessAbsenceByCitizenIdRequest
     * @return GetActiveSicknessAbsenceByCitizenIdResponse
     */
    getActiveSicknessAbsenceByCitizenId(query: GetActiveSicknessAbsenceByCitizenIdRequest2, cancelToken?: CancelToken): Promise<GetActiveSicknessAbsenceByCitizenIdResponse2> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getactivesicknessabsencebycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssociatedCaseWorkerRequest
     * @return GetAssociatedCaseWorkerResponse
     */
    getAssociatedCaseWorker(query: GetAssociatedCaseWorkerRequest, cancelToken?: CancelToken): Promise<GetAssociatedCaseWorkerResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getassociatedcaseworker`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAssociateUserRolesResponse
     */
    getAssociateUserRoles(cancelToken?: CancelToken): Promise<GetAssociateUserRolesResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getassociateuserroles`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssociateUsersByCaseIdRequest
     * @return GetAssociateUsersByCaseIdResponse
     */
    getAssociateUsersByCaseId(query: GetAssociateUsersByCaseIdRequest, cancelToken?: CancelToken): Promise<GetAssociateUsersByCaseIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getassociateusersbycaseid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseDetailsByIdRequest
     * @return GetCaseDetailsByIdResponse
     */
    getCaseDetailsById(query: GetCaseDetailsByIdRequest, cancelToken?: CancelToken): Promise<GetCaseDetailsByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcasedetailsbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCaseClosureReasonsResponse
     */
    getCaseClosureReasons(cancelToken?: CancelToken): Promise<GetCaseClosureReasonsResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcaseclosurereasons`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseClosureReasonsFilterOnCaseTypeRequest
     * @return GetCaseClosureReasonsFilterOnCaseTypeResponse
     */
    getCaseClosureReasonsFilterOnCaseType(query: GetCaseClosureReasonsFilterOnCaseTypeRequest, cancelToken?: CancelToken): Promise<GetCaseClosureReasonsFilterOnCaseTypeResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcaseclosurereasonsfilteroncasetype`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCaseContactReasonsResponse
     */
    getCaseContactReasons(cancelToken?: CancelToken): Promise<GetCaseContactReasonsResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcasecontactreasons`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseContactReasonsFilterOnCaseTypeRequest
     * @return GetCaseContactReasonsFilterOnCaseTypeResponse
     */
    getCaseContactReasonsFilterOnCaseType(query: GetCaseContactReasonsFilterOnCaseTypeRequest, cancelToken?: CancelToken): Promise<GetCaseContactReasonsFilterOnCaseTypeResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcasecontactreasonsfilteroncasetype`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCaseGroupsResponse
     */
    getCaseGroups(cancelToken?: CancelToken): Promise<GetCaseGroupsResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcasegroups`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseGroupsFilterOnCaseTypeRequest
     * @return GetCaseGroupsFilterOnCaseTypeResponse
     */
    getCaseGroupsFilterOnCaseType(query: GetCaseGroupsFilterOnCaseTypeRequest, cancelToken?: CancelToken): Promise<GetCaseGroupsFilterOnCaseTypeResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcasegroupsfilteroncasetype`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseInfoForLinkRequest
     * @return GetCaseInfoForLinkResponse
     */
    getCaseInfoForLink(query: GetCaseInfoForLinkRequest, cancelToken?: CancelToken): Promise<GetCaseInfoForLinkResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcaseinfoforlink`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCaseRestrictionOptionsResponse
     */
    getCaseRestrictionOptions(cancelToken?: CancelToken): Promise<GetCaseRestrictionOptionsResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcaserestrictionoptions`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCasesRequest
     * @return GetCasesResponse
     */
    getCases(query: GetCasesRequest, cancelToken?: CancelToken): Promise<GetCasesResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcases`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseTypeByCaseIdRequest
     * @return GetCaseTypeByCaseIdResponse
     */
    getCaseTypeByCaseId(query: GetCaseTypeByCaseIdRequest, cancelToken?: CancelToken): Promise<GetCaseTypeByCaseIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcasetypebycaseid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseTypeByIdRequest
     * @return GetCaseTypeByIdResponse
     */
    getCaseTypeById(query: GetCaseTypeByIdRequest, cancelToken?: CancelToken): Promise<GetCaseTypeByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcasetypebyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseTypesByTargetGroupIdRequest
     * @return GetCaseTypesByTargetGroupIdResponse
     */
    getCaseTypesByTargetGroupId(query: GetCaseTypesByTargetGroupIdRequest, cancelToken?: CancelToken): Promise<GetCaseTypesByTargetGroupIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcasetypesbytargetgroupid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCaseTypesForCreateCaseResponse
     */
    getCaseTypesForCreateCase(cancelToken?: CancelToken): Promise<GetCaseTypesForCreateCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcasetypesforcreatecase`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseTypeValidationValuesRequest
     * @return GetCaseTypeValidationValuesResponse
     */
    getCaseTypeValidationValues(query: GetCaseTypeValidationValuesRequest, cancelToken?: CancelToken): Promise<GetCaseTypeValidationValuesResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getcasetypevalidationvalues`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEffortGroupByIdRequest
     * @return GetEffortGroupByIdResponse
     */
    getEffortGroupById(query: GetEffortGroupByIdRequest, cancelToken?: CancelToken): Promise<GetEffortGroupByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/geteffortgroupbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHasActiveAbsenceByCitizenIdRequest
     * @return GetHasActiveAbsenceByCitizenIdResponse
     */
    getHasActiveAbsenceByCitizenId(query: GetHasActiveAbsenceByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetHasActiveAbsenceByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/gethasactiveabsencebycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHasActiveContactPersonRequest
     * @return GetHasActiveContactPersonResponse
     */
    getHasActiveContactPersonByCitizenId(query: GetHasActiveContactPersonRequest, cancelToken?: CancelToken): Promise<GetHasActiveContactPersonResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/gethasactivecontactpersonbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHasActiveEnrollmentsRequest
     * @return GetHasActiveEnrollmentsResponse
     */
    getHasActiveEnrollments(query: GetHasActiveEnrollmentsRequest, cancelToken?: CancelToken): Promise<GetHasActiveEnrollmentsResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/gethasactiveenrollments`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHasActivitiesByCitizenIdRequest
     * @return GetHasActivitiesByCitizenIdResponse
     */
    getHasActivitiesByCitizenId(query: GetHasActivitiesByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetHasActivitiesByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/gethasactivitiesbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHasContactGroupDiscrepancyRequest
     * @return GetHasContactGroupDiscrepancyResponse
     */
    getHasContactGroupDiscrepancy(query: GetHasContactGroupDiscrepancyRequest, cancelToken?: CancelToken): Promise<GetHasContactGroupDiscrepancyResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/gethascontactgroupdiscrepancy`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHasHistoricRegistrationRequest
     * @return GetHasHistoricRegistrationResponse
     */
    getHasHistoricRegistration(query: GetHasHistoricRegistrationRequest, cancelToken?: CancelToken): Promise<GetHasHistoricRegistrationResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/gethashistoricregistration`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetInterviewCalculationsStartDateConfigurationResponse
     */
    getInterviewCalculationsStartDateConfiguration(cancelToken?: CancelToken): Promise<GetInterviewCalculationsStartDateConfigurationResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getinterviewcalculationsstartdateconfiguration`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMinAndMAxDateFromCasesRequest
     * @return GetMinAndMAxDateFromCasesResponse
     */
    getMinAndMAxDateFromCases(query: GetMinAndMAxDateFromCasesRequest, cancelToken?: CancelToken): Promise<GetMinAndMAxDateFromCasesResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getminandmaxdatefromcases`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMostRelevantSocialCaseRequest
     * @return GetMostRelevantSocialCaseResponse
     */
    getMostRelevantSocialCase(query: GetMostRelevantSocialCaseRequest, cancelToken?: CancelToken): Promise<GetMostRelevantSocialCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getmostrelevantsocialcase`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetMunicipalitiesResponse
     */
    getMunicipalities(cancelToken?: CancelToken): Promise<GetMunicipalitiesResponse3> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getmunicipalities`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOpenCasesRequest
     * @return GetOpenCasesResponse
     */
    getOpenCases(query: GetOpenCasesRequest, cancelToken?: CancelToken): Promise<GetOpenCasesResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getopencases`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPayingAndResponsibleMunicipalityInfoRequest
     * @return GetPayingAndResponsibleMunicipalityInfoResponse
     */
    getPayingAndResponsibleMunicipalityInfo(query: GetPayingAndResponsibleMunicipalityInfoRequest, cancelToken?: CancelToken): Promise<GetPayingAndResponsibleMunicipalityInfoResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getpayingandresponsiblemunicipalityinfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPersonCategoryNameByIdRequest
     * @return GetPersonCategoryNameByIdResponse
     */
    getPersonCategoryNameById(query: GetPersonCategoryNameByIdRequest, cancelToken?: CancelToken): Promise<GetPersonCategoryNameByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getpersoncategorynamebyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPrimaryCaseSummaryBoxDataRequest
     * @return GetPrimaryCaseSummaryBoxDataResponse
     */
    getPrimaryCaseSummaryBoxData(query: GetPrimaryCaseSummaryBoxDataRequest, cancelToken?: CancelToken): Promise<GetPrimaryCaseSummaryBoxDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getprimarycasesummaryboxdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetRehabilitationProcessStatusTypesResponse
     */
    getRehabilitationProcessStatusTypes(cancelToken?: CancelToken): Promise<GetRehabilitationProcessStatusTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getrehabilitationprocessstatustypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetRemovalCauseTypeResponse
     */
    getRemovalCauseTypes(cancelToken?: CancelToken): Promise<GetRemovalCauseTypeResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getremovalcausetypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetScreeningPdfByCitizenIdRequest
     * @return FileResponse
     */
    getScreeningPdfByCitizenId(query: GetScreeningPdfByCitizenIdRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getscreeningpdfbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSdpCaseDetailsByCitizenIdRequest
     * @return GetSdpCaseDetailsByCitizenIdResponse
     */
    getSdpCaseDetailsByCitizenId(query: GetSdpCaseDetailsByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetSdpCaseDetailsByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getsdpcasedetailsbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSelfScreeningRequest
     * @return GetSelfScreeningResponse
     */
    getSelfScreening(query: GetSelfScreeningRequest, cancelToken?: CancelToken): Promise<GetSelfScreeningResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getselfscreening`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSicknessBenefitOptionsResponse
     */
    getSicknessBenefitOptions(cancelToken?: CancelToken): Promise<GetSicknessBenefitOptionsResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getsicknessbenefitoptions`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSicknessBenefitVisitationRequest
     * @return GetSicknessBenefitVisitationResponse
     */
    getSicknessBenefitVisitation(query: GetSicknessBenefitVisitationRequest, cancelToken?: CancelToken): Promise<GetSicknessBenefitVisitationResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/getsicknessbenefitvisitation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTargetGroupByCaseIdRequest
     * @return GetTargetGroupByCaseIdResponse
     */
    getTargetGroupByCaseId(query: GetTargetGroupByCaseIdRequest, cancelToken?: CancelToken): Promise<GetTargetGroupByCaseIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/gettargetgroupbycaseid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query HasAnyActiveCasesRequest
     * @return HasAnyActiveCasesResponse
     */
    hasAnyActiveCases(query: HasAnyActiveCasesRequest, cancelToken?: CancelToken): Promise<HasAnyActiveCasesResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/hasanyactivecases`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query HasAnyOpenRehabCasesRequest
     * @return HasAnyOpenRehabCasesResponse
     */
    hasAnyOpenRehabCases(query: HasAnyOpenRehabCasesRequest, cancelToken?: CancelToken): Promise<HasAnyOpenRehabCasesResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/hasanyopenrehabcases`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query HasAnyOpenSicknessBenifitOrJobClarificationCasesRequest
     * @return HasAnyOpenSicknessBenifitOrJobClarificationCasesResponse
     */
    hasAnyOpenSicknessBenifitOrJobClarificationCases(query: HasAnyOpenSicknessBenifitOrJobClarificationCasesRequest, cancelToken?: CancelToken): Promise<HasAnyOpenSicknessBenifitOrJobClarificationCasesResponse> {
        const $url = `${this.baseUrl}/api/citizen/case/queries/hasanyopensicknessbenifitorjobclarificationcases`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenAvailabilityClient {
    /**
     * @param command CloseAvailabilityAssessmentRequest
     * @return CloseAvailabilityAssessmentResponse
     */
    closeAvailabilityAssessment(command: CloseAvailabilityAssessmentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateAbsenceRequest
     * @return CreateAbsenceResponse
     */
    createAbsence(command: CreateAbsenceRequest, cancelToken?: CancelToken): Promise<CreateAbsenceResponse>;
    /**
     * @param command CreateAssessmentRequest
     * @return CreateAssessmentResponse
     */
    createAssessment(command: CreateAssessmentRequest, cancelToken?: CancelToken): Promise<CreateAssessmentResponse>;
    /**
     * @param command CreateCitizenHealthLimitationRequest
     * @return CreateCitizenHealthLimitationResponse
     */
    createCitizenHealthLimitation(command: CreateCitizenHealthLimitationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateIllnessRequest
     * @return CreateIllnessResponse
     */
    createIllness(command: CreateIllnessRequest, cancelToken?: CancelToken): Promise<CreateIllnessResponse>;
    /**
     * @param command CreateNegativeEventRequest
     * @return CreateNegativeEventResponse
     */
    createNegativeEvent(command: CreateNegativeEventRequest, cancelToken?: CancelToken): Promise<CreateNegativeEventResponse>;
    /**
     * @param command DeleteAbsenceRequest
     * @return DeleteAbsenceResponse
     */
    deleteAbsence(command: DeleteAbsenceRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteCitizenHealthLimitationRequest
     * @return DeleteCitizenHealthLimitationResponse
     */
    deleteCitizenHealthLimitation(command: DeleteCitizenHealthLimitationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateAbsenceRequest
     * @return UpdateAbsenceResponse
     */
    updateAbsence(command: UpdateAbsenceRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateAssessmentDecisionLetterCreatedRequest
     * @return UpdateAssessmentDecisionLetterCreatedResponse
     */
    updateAssessmentDecisionLetterCreated(command: UpdateAssessmentDecisionLetterCreatedRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCitizenHealthLimitationRequest
     * @return UpdateCitizenHealthLimitationResponse
     */
    updateCitizenHealthLimitation(command: UpdateCitizenHealthLimitationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateIllnessRequest
     * @return UpdateIllnessResponse
     */
    updateIllness(command: UpdateIllnessRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateNegativeEventRequest
     * @return UpdateNegativeEventResponse
     */
    updateNegativeEvent(command: UpdateNegativeEventRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetAbsenceRequest
     * @return GetAbsenceResponse
     */
    getAbsence(query: GetAbsenceRequest, cancelToken?: CancelToken): Promise<GetAbsenceResponse>;
    /**
     * @param query GetAbsenceCauseTypesFilteredByAbsenceTypeRequest
     * @return GetAbsenceCauseTypesFilteredByAbsenceTypeResponse
     */
    getAbsenceCauseTypesFilteredByAbsenceType(query: GetAbsenceCauseTypesFilteredByAbsenceTypeRequest, cancelToken?: CancelToken): Promise<GetAbsenceCauseTypesFilteredByAbsenceTypeResponse>;
    /**
     * @param query GetAbsenceHistoryRequest
     * @return GetAbsenceHistoryResponse
     */
    getAbsenceHistory(query: GetAbsenceHistoryRequest, cancelToken?: CancelToken): Promise<GetAbsenceHistoryResponse>;
    /**
     * @param query GetAbsencesRequest
     * @return GetAbsencesResponse
     */
    getAbsences(query: GetAbsencesRequest, cancelToken?: CancelToken): Promise<GetAbsencesResponse>;
    /**
     * @param query GetAbsencesSimpleByCitizenIdRequest
     * @return GetAbsencesSimpleByCitizenIdResponse
     */
    getAbsencesSimpleByCitizenId(query: GetAbsencesSimpleByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetAbsencesSimpleByCitizenIdResponse>;
    /**
     * @param query GetAbsenceTypesFilteredByCitizensContractGroupAndVisitationCategoryRequest
     * @return GetAbsenceTypesFilteredByCitizensContractGroupAndVisitationCategoryResponse
     */
    getAbsenceTypesFilteredByCitizensContractGroupAndVisitationCategory(query: GetAbsenceTypesFilteredByCitizensContractGroupAndVisitationCategoryRequest, cancelToken?: CancelToken): Promise<GetAbsenceTypesFilteredByCitizensContractGroupAndVisitationCategoryResponse>;
    /**
     * @param query GetAbsenceUrlRequest
     * @return GetAbsenceUrlResponse
     */
    getAbsenceUrl(query: GetAbsenceUrlRequest, cancelToken?: CancelToken): Promise<GetAbsenceUrlResponse>;
    /**
     * @param query GetAssessmentCaseWorkerCommentTemplateRequest
     * @return GetAssessmentCaseWorkerCommentTemplateResponse
     */
    getAssessmentCaseWorkerCommentTemplate(query: GetAssessmentCaseWorkerCommentTemplateRequest, cancelToken?: CancelToken): Promise<GetAssessmentCaseWorkerCommentTemplateResponse>;
    /**
     * @param query GetAssessmentDetailsRequest
     * @return GetAssessmentDetailsResponse
     */
    getAssessmentDetails(query: GetAssessmentDetailsRequest, cancelToken?: CancelToken): Promise<GetAssessmentDetailsResponse>;
    /**
     * @param query GetAssessmentsRequest
     * @return GetAssessmentsResponse
     */
    getAssessments(query: GetAssessmentsRequest, cancelToken?: CancelToken): Promise<GetAssessmentsResponse>;
    /**
     * @param query GetAssessmentUrlRequest
     * @return GetAssessmentUrlResponse
     */
    getAssessmentUrl(query: GetAssessmentUrlRequest, cancelToken?: CancelToken): Promise<GetAssessmentUrlResponse>;
    /**
     * @param query GetAvailabilityOverviewRequest
     * @return GetAvailabilityOverviewResponse
     */
    getAvailabilityOverview(query: GetAvailabilityOverviewRequest, cancelToken?: CancelToken): Promise<GetAvailabilityOverviewResponse>;
    /**
     * @param query GetCaseRelatedIllnessAbsencesRequest
     * @return GetCaseRelatedIllnessAbsencesResponse
     */
    getCaseRelatedIllnessAbsences(query: GetCaseRelatedIllnessAbsencesRequest, cancelToken?: CancelToken): Promise<GetCaseRelatedIllnessAbsencesResponse>;
    /**
     * @param query GetCitizenHealthLimitationRequest
     * @return GetCitizenHealthLimitationResponse
     */
    getCitizenHealthLimitation(query: GetCitizenHealthLimitationRequest, cancelToken?: CancelToken): Promise<GetCitizenHealthLimitationResponse>;
    /**
     * @param query GetCitizenHealthLimitationsRequest
     * @return GetCitizenHealthLimitationsResponse
     */
    getCitizenHealthLimitations(query: GetCitizenHealthLimitationsRequest, cancelToken?: CancelToken): Promise<GetCitizenHealthLimitationsResponse>;
    /**
     * @param query GetCompanyContactPersonsRequest
     * @return GetCompanyContactPersonsResponse
     */
    getCompanyContactPersons(query: GetCompanyContactPersonsRequest3, cancelToken?: CancelToken): Promise<GetCompanyContactPersonsResponse3>;
    /**
     * @param query GetEventTypesRequest
     * @return GetEventTypesResponse
     */
    getEventTypes(query: GetEventTypesRequest, cancelToken?: CancelToken): Promise<GetEventTypesResponse>;
    /**
     * @param query GetNegativeEventRequest
     * @return GetNegativeEventResponse
     */
    getNegativeEvent(query: GetNegativeEventRequest, cancelToken?: CancelToken): Promise<GetNegativeEventResponse>;
    /**
     * @param query GetNegativeEventsRequest
     * @return GetNegativeEventsResponse
     */
    getNegativeEvents(query: GetNegativeEventsRequest, cancelToken?: CancelToken): Promise<GetNegativeEventsResponse>;
    /**
     * @param query GetNegativeEventsForAssessmentRequest
     * @return GetNegativeEventsForAssessmentResponse
     */
    getNegativeEventsForAssessment(query: GetNegativeEventsForAssessmentRequest, cancelToken?: CancelToken): Promise<GetNegativeEventsForAssessmentResponse>;
    /**
     * @param query GetNegativeEventUrlRequest
     * @return GetNegativeEventUrlResponse
     */
    getNegativeEventUrl(query: GetNegativeEventUrlRequest, cancelToken?: CancelToken): Promise<GetNegativeEventUrlResponse>;
    /**
     * @param query GetPrimaryCaseWorkerRequest
     * @return GetPrimaryCaseWorkerResponse
     */
    getPrimaryCaseWorker(query: GetPrimaryCaseWorkerRequest, cancelToken?: CancelToken): Promise<GetPrimaryCaseWorkerResponse>;
    /**
     * @param query GetPrivateContactPersonsRequest
     * @return GetPrivateContactPersonsResponse
     */
    getPrivateContactPersons(query: GetPrivateContactPersonsRequest3, cancelToken?: CancelToken): Promise<GetPrivateContactPersonsResponse3>;
    /**
     * @return GetReasonableCauseTypesResponse
     */
    getReasonableCauseTypes(cancelToken?: CancelToken): Promise<GetReasonableCauseTypesResponse>;
    /**
     * @param query GetRelatedNegativeEventsRequest
     * @return GetRelatedNegativeEventsResponse
     */
    getRelatedNegativeEvents(query: GetRelatedNegativeEventsRequest, cancelToken?: CancelToken): Promise<GetRelatedNegativeEventsResponse>;
    /**
     * @param query GetServiceConfigurationRequest
     * @return GetServiceConfigurationResponse
     */
    getServiceConfiguration(query: GetServiceConfigurationRequest, cancelToken?: CancelToken): Promise<GetServiceConfigurationResponse>;
    /**
     * @return GetUnemploymentStatusesResponse
     */
    getUnemploymentStatuses(cancelToken?: CancelToken): Promise<GetUnemploymentStatusesResponse>;
}

export class CitizenAvailabilityClient implements ICitizenAvailabilityClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CloseAvailabilityAssessmentRequest
     * @return CloseAvailabilityAssessmentResponse
     */
    closeAvailabilityAssessment(command: CloseAvailabilityAssessmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/availability/commands/closeavailabilityassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAbsenceRequest
     * @return CreateAbsenceResponse
     */
    createAbsence(command: CreateAbsenceRequest, cancelToken?: CancelToken): Promise<CreateAbsenceResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/commands/createabsence`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAssessmentRequest
     * @return CreateAssessmentResponse
     */
    createAssessment(command: CreateAssessmentRequest, cancelToken?: CancelToken): Promise<CreateAssessmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/commands/createassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCitizenHealthLimitationRequest
     * @return CreateCitizenHealthLimitationResponse
     */
    createCitizenHealthLimitation(command: CreateCitizenHealthLimitationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/availability/commands/createcitizenhealthlimitation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateIllnessRequest
     * @return CreateIllnessResponse
     */
    createIllness(command: CreateIllnessRequest, cancelToken?: CancelToken): Promise<CreateIllnessResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/commands/createillness`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateNegativeEventRequest
     * @return CreateNegativeEventResponse
     */
    createNegativeEvent(command: CreateNegativeEventRequest, cancelToken?: CancelToken): Promise<CreateNegativeEventResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/commands/createnegativeevent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteAbsenceRequest
     * @return DeleteAbsenceResponse
     */
    deleteAbsence(command: DeleteAbsenceRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/availability/commands/deleteabsence`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteCitizenHealthLimitationRequest
     * @return DeleteCitizenHealthLimitationResponse
     */
    deleteCitizenHealthLimitation(command: DeleteCitizenHealthLimitationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/availability/commands/deletecitizenhealthlimitation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAbsenceRequest
     * @return UpdateAbsenceResponse
     */
    updateAbsence(command: UpdateAbsenceRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/availability/commands/updateabsence`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAssessmentDecisionLetterCreatedRequest
     * @return UpdateAssessmentDecisionLetterCreatedResponse
     */
    updateAssessmentDecisionLetterCreated(command: UpdateAssessmentDecisionLetterCreatedRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/availability/commands/updateassessmentdecisionlettercreated`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCitizenHealthLimitationRequest
     * @return UpdateCitizenHealthLimitationResponse
     */
    updateCitizenHealthLimitation(command: UpdateCitizenHealthLimitationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/availability/commands/updatecitizenhealthlimitation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateIllnessRequest
     * @return UpdateIllnessResponse
     */
    updateIllness(command: UpdateIllnessRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/availability/commands/updateillness`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateNegativeEventRequest
     * @return UpdateNegativeEventResponse
     */
    updateNegativeEvent(command: UpdateNegativeEventRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/availability/commands/updatenegativeevent`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAbsenceRequest
     * @return GetAbsenceResponse
     */
    getAbsence(query: GetAbsenceRequest, cancelToken?: CancelToken): Promise<GetAbsenceResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getabsence`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAbsenceCauseTypesFilteredByAbsenceTypeRequest
     * @return GetAbsenceCauseTypesFilteredByAbsenceTypeResponse
     */
    getAbsenceCauseTypesFilteredByAbsenceType(query: GetAbsenceCauseTypesFilteredByAbsenceTypeRequest, cancelToken?: CancelToken): Promise<GetAbsenceCauseTypesFilteredByAbsenceTypeResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getabsencecausetypesfilteredbyabsencetype`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAbsenceHistoryRequest
     * @return GetAbsenceHistoryResponse
     */
    getAbsenceHistory(query: GetAbsenceHistoryRequest, cancelToken?: CancelToken): Promise<GetAbsenceHistoryResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getabsencehistory`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAbsencesRequest
     * @return GetAbsencesResponse
     */
    getAbsences(query: GetAbsencesRequest, cancelToken?: CancelToken): Promise<GetAbsencesResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getabsences`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAbsencesSimpleByCitizenIdRequest
     * @return GetAbsencesSimpleByCitizenIdResponse
     */
    getAbsencesSimpleByCitizenId(query: GetAbsencesSimpleByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetAbsencesSimpleByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getabsencessimplebycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAbsenceTypesFilteredByCitizensContractGroupAndVisitationCategoryRequest
     * @return GetAbsenceTypesFilteredByCitizensContractGroupAndVisitationCategoryResponse
     */
    getAbsenceTypesFilteredByCitizensContractGroupAndVisitationCategory(query: GetAbsenceTypesFilteredByCitizensContractGroupAndVisitationCategoryRequest, cancelToken?: CancelToken): Promise<GetAbsenceTypesFilteredByCitizensContractGroupAndVisitationCategoryResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getabsencetypesfilteredbycitizenscontractgroupandvisitationcategory`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAbsenceUrlRequest
     * @return GetAbsenceUrlResponse
     */
    getAbsenceUrl(query: GetAbsenceUrlRequest, cancelToken?: CancelToken): Promise<GetAbsenceUrlResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getabsenceurl`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssessmentCaseWorkerCommentTemplateRequest
     * @return GetAssessmentCaseWorkerCommentTemplateResponse
     */
    getAssessmentCaseWorkerCommentTemplate(query: GetAssessmentCaseWorkerCommentTemplateRequest, cancelToken?: CancelToken): Promise<GetAssessmentCaseWorkerCommentTemplateResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getassessmentcaseworkercommenttemplate`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssessmentDetailsRequest
     * @return GetAssessmentDetailsResponse
     */
    getAssessmentDetails(query: GetAssessmentDetailsRequest, cancelToken?: CancelToken): Promise<GetAssessmentDetailsResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getassessmentdetails`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssessmentsRequest
     * @return GetAssessmentsResponse
     */
    getAssessments(query: GetAssessmentsRequest, cancelToken?: CancelToken): Promise<GetAssessmentsResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getassessments`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssessmentUrlRequest
     * @return GetAssessmentUrlResponse
     */
    getAssessmentUrl(query: GetAssessmentUrlRequest, cancelToken?: CancelToken): Promise<GetAssessmentUrlResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getassessmenturl`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAvailabilityOverviewRequest
     * @return GetAvailabilityOverviewResponse
     */
    getAvailabilityOverview(query: GetAvailabilityOverviewRequest, cancelToken?: CancelToken): Promise<GetAvailabilityOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getavailabilityoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCaseRelatedIllnessAbsencesRequest
     * @return GetCaseRelatedIllnessAbsencesResponse
     */
    getCaseRelatedIllnessAbsences(query: GetCaseRelatedIllnessAbsencesRequest, cancelToken?: CancelToken): Promise<GetCaseRelatedIllnessAbsencesResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getcaserelatedillnessabsences`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenHealthLimitationRequest
     * @return GetCitizenHealthLimitationResponse
     */
    getCitizenHealthLimitation(query: GetCitizenHealthLimitationRequest, cancelToken?: CancelToken): Promise<GetCitizenHealthLimitationResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getcitizenhealthlimitation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenHealthLimitationsRequest
     * @return GetCitizenHealthLimitationsResponse
     */
    getCitizenHealthLimitations(query: GetCitizenHealthLimitationsRequest, cancelToken?: CancelToken): Promise<GetCitizenHealthLimitationsResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getcitizenhealthlimitations`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyContactPersonsRequest
     * @return GetCompanyContactPersonsResponse
     */
    getCompanyContactPersons(query: GetCompanyContactPersonsRequest3, cancelToken?: CancelToken): Promise<GetCompanyContactPersonsResponse3> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getcompanycontactpersons`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEventTypesRequest
     * @return GetEventTypesResponse
     */
    getEventTypes(query: GetEventTypesRequest, cancelToken?: CancelToken): Promise<GetEventTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/geteventtypes`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNegativeEventRequest
     * @return GetNegativeEventResponse
     */
    getNegativeEvent(query: GetNegativeEventRequest, cancelToken?: CancelToken): Promise<GetNegativeEventResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getnegativeevent`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNegativeEventsRequest
     * @return GetNegativeEventsResponse
     */
    getNegativeEvents(query: GetNegativeEventsRequest, cancelToken?: CancelToken): Promise<GetNegativeEventsResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getnegativeevents`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNegativeEventsForAssessmentRequest
     * @return GetNegativeEventsForAssessmentResponse
     */
    getNegativeEventsForAssessment(query: GetNegativeEventsForAssessmentRequest, cancelToken?: CancelToken): Promise<GetNegativeEventsForAssessmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getnegativeeventsforassessment`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNegativeEventUrlRequest
     * @return GetNegativeEventUrlResponse
     */
    getNegativeEventUrl(query: GetNegativeEventUrlRequest, cancelToken?: CancelToken): Promise<GetNegativeEventUrlResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getnegativeeventurl`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPrimaryCaseWorkerRequest
     * @return GetPrimaryCaseWorkerResponse
     */
    getPrimaryCaseWorker(query: GetPrimaryCaseWorkerRequest, cancelToken?: CancelToken): Promise<GetPrimaryCaseWorkerResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getprimarycaseworker`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPrivateContactPersonsRequest
     * @return GetPrivateContactPersonsResponse
     */
    getPrivateContactPersons(query: GetPrivateContactPersonsRequest3, cancelToken?: CancelToken): Promise<GetPrivateContactPersonsResponse3> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getprivatecontactpersons`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetReasonableCauseTypesResponse
     */
    getReasonableCauseTypes(cancelToken?: CancelToken): Promise<GetReasonableCauseTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getreasonablecausetypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetRelatedNegativeEventsRequest
     * @return GetRelatedNegativeEventsResponse
     */
    getRelatedNegativeEvents(query: GetRelatedNegativeEventsRequest, cancelToken?: CancelToken): Promise<GetRelatedNegativeEventsResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getrelatednegativeevents`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceConfigurationRequest
     * @return GetServiceConfigurationResponse
     */
    getServiceConfiguration(query: GetServiceConfigurationRequest, cancelToken?: CancelToken): Promise<GetServiceConfigurationResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getserviceconfiguration`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetUnemploymentStatusesResponse
     */
    getUnemploymentStatuses(cancelToken?: CancelToken): Promise<GetUnemploymentStatusesResponse> {
        const $url = `${this.baseUrl}/api/citizen/availability/queries/getunemploymentstatuses`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenAsylumClient {
    /**
     * @param command SaveDanishTestSettingRequest
     * @return SaveDanishTestSettingResponse
     */
    saveDanishTestSetting(command: SaveDanishTestSettingRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SaveEducationFollowUpRequest
     * @return SaveEducationFollowUpResponse
     */
    saveEducationFollowUp(command: SaveEducationFollowUpRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SaveEducationStartRequest
     * @return SaveEducationStartResponse
     */
    saveEducationStart(command: SaveEducationStartRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SaveEmploymentFollowUpRequest
     * @return SaveEmploymentFollowUpResponse
     */
    saveEmploymentFollowUp(command: SaveEmploymentFollowUpRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SaveEmploymentStartRequest
     * @return SaveEmploymentStartResponse
     */
    saveEmploymentStart(command: SaveEmploymentStartRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SaveIntegrationInfoRequest
     * @return SaveIntegrationInfoResponse
     */
    saveIntegrationInfo(command: SaveIntegrationInfoRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetAsylumCvFilesRequest
     * @return GetAsylumCvFilesResponse
     */
    getAsylumCvFiles(query: GetAsylumCvFilesRequest, cancelToken?: CancelToken): Promise<GetAsylumCvFilesResponse>;
    /**
     * @param query GetAsylumDataRequest
     * @return GetAsylumDataResponse
     */
    getAsylumData(query: GetAsylumDataRequest, cancelToken?: CancelToken): Promise<GetAsylumDataResponse>;
    /**
     * @param query GetBasicSubsidyReportRequest
     * @return GetBasicSubsidyReportResponse
     */
    getBasicSubsidyReport(query: GetBasicSubsidyReportRequest, cancelToken?: CancelToken): Promise<GetBasicSubsidyReportResponse>;
    /**
     * @return GetBasicSubsidyReportDefaultParamsResponse
     */
    getBasicSubsidyReportDefaultParams(cancelToken?: CancelToken): Promise<GetBasicSubsidyReportDefaultParamsResponse>;
    /**
     * @param query GetDfdgTransitionRequest
     * @return GetDfdgTransitionResponse
     */
    getDfdgTransition(query: GetDfdgTransitionRequest, cancelToken?: CancelToken): Promise<GetDfdgTransitionResponse>;
    /**
     * @return GetMunicipalityListResponse
     */
    getMunicipalityList(cancelToken?: CancelToken): Promise<GetMunicipalityListResponse>;
    /**
     * @param query GetOverviewRequest
     * @return GetOverviewResponse
     */
    getOverview(query: GetOverviewRequest, cancelToken?: CancelToken): Promise<GetOverviewResponse>;
    /**
     * @param query GetResultSubsidyReportRequest
     * @return GetResultSubsidyReportResponse
     */
    getResultSubsidyReport(query: GetResultSubsidyReportRequest, cancelToken?: CancelToken): Promise<GetResultSubsidyReportResponse>;
    /**
     * @return GetResultSubsidyReportDefaultParamsResponse
     */
    getResultSubsidyReportDefaultParams(cancelToken?: CancelToken): Promise<GetResultSubsidyReportDefaultParamsResponse>;
    /**
     * @param query SaveDanishTestResultRequest
     * @return SaveDanishTestResultResponse
     */
    saveDanishTestResult(query: SaveDanishTestResultRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query TransferCvFromAsylumOperatorRequest
     * @return TransferCvFromAsylumOperatorResponse
     */
    transferCvFromAsylumOperator(query: TransferCvFromAsylumOperatorRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query TransferIntegrationResponsibilityRequest
     * @return TransferIntegrationResponsibilityResponse
     */
    transferIntegrationResponsibility(query: TransferIntegrationResponsibilityRequest, cancelToken?: CancelToken): Promise<any>;
}

export class CitizenAsylumClient implements ICitizenAsylumClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command SaveDanishTestSettingRequest
     * @return SaveDanishTestSettingResponse
     */
    saveDanishTestSetting(command: SaveDanishTestSettingRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/asylum/commands/savedanishtestsetting`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SaveEducationFollowUpRequest
     * @return SaveEducationFollowUpResponse
     */
    saveEducationFollowUp(command: SaveEducationFollowUpRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/asylum/commands/saveeducationfollowup`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SaveEducationStartRequest
     * @return SaveEducationStartResponse
     */
    saveEducationStart(command: SaveEducationStartRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/asylum/commands/saveeducationstart`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SaveEmploymentFollowUpRequest
     * @return SaveEmploymentFollowUpResponse
     */
    saveEmploymentFollowUp(command: SaveEmploymentFollowUpRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/asylum/commands/saveemploymentfollowup`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SaveEmploymentStartRequest
     * @return SaveEmploymentStartResponse
     */
    saveEmploymentStart(command: SaveEmploymentStartRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/asylum/commands/saveemploymentstart`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SaveIntegrationInfoRequest
     * @return SaveIntegrationInfoResponse
     */
    saveIntegrationInfo(command: SaveIntegrationInfoRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/asylum/commands/saveintegrationinfo`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAsylumCvFilesRequest
     * @return GetAsylumCvFilesResponse
     */
    getAsylumCvFiles(query: GetAsylumCvFilesRequest, cancelToken?: CancelToken): Promise<GetAsylumCvFilesResponse> {
        const $url = `${this.baseUrl}/api/citizen/asylum/queries/getasylumcvfiles`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAsylumDataRequest
     * @return GetAsylumDataResponse
     */
    getAsylumData(query: GetAsylumDataRequest, cancelToken?: CancelToken): Promise<GetAsylumDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/asylum/queries/getasylumdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetBasicSubsidyReportRequest
     * @return GetBasicSubsidyReportResponse
     */
    getBasicSubsidyReport(query: GetBasicSubsidyReportRequest, cancelToken?: CancelToken): Promise<GetBasicSubsidyReportResponse> {
        const $url = `${this.baseUrl}/api/citizen/asylum/queries/getbasicsubsidyreport`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetBasicSubsidyReportDefaultParamsResponse
     */
    getBasicSubsidyReportDefaultParams(cancelToken?: CancelToken): Promise<GetBasicSubsidyReportDefaultParamsResponse> {
        const $url = `${this.baseUrl}/api/citizen/asylum/queries/getbasicsubsidyreportdefaultparams`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDfdgTransitionRequest
     * @return GetDfdgTransitionResponse
     */
    getDfdgTransition(query: GetDfdgTransitionRequest, cancelToken?: CancelToken): Promise<GetDfdgTransitionResponse> {
        const $url = `${this.baseUrl}/api/citizen/asylum/queries/getdfdgtransition`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetMunicipalityListResponse
     */
    getMunicipalityList(cancelToken?: CancelToken): Promise<GetMunicipalityListResponse> {
        const $url = `${this.baseUrl}/api/citizen/asylum/queries/getmunicipalitylist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOverviewRequest
     * @return GetOverviewResponse
     */
    getOverview(query: GetOverviewRequest, cancelToken?: CancelToken): Promise<GetOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/asylum/queries/getoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetResultSubsidyReportRequest
     * @return GetResultSubsidyReportResponse
     */
    getResultSubsidyReport(query: GetResultSubsidyReportRequest, cancelToken?: CancelToken): Promise<GetResultSubsidyReportResponse> {
        const $url = `${this.baseUrl}/api/citizen/asylum/queries/getresultsubsidyreport`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetResultSubsidyReportDefaultParamsResponse
     */
    getResultSubsidyReportDefaultParams(cancelToken?: CancelToken): Promise<GetResultSubsidyReportDefaultParamsResponse> {
        const $url = `${this.baseUrl}/api/citizen/asylum/queries/getresultsubsidyreportdefaultparams`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query SaveDanishTestResultRequest
     * @return SaveDanishTestResultResponse
     */
    saveDanishTestResult(query: SaveDanishTestResultRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/asylum/queries/savedanishtestresult`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query TransferCvFromAsylumOperatorRequest
     * @return TransferCvFromAsylumOperatorResponse
     */
    transferCvFromAsylumOperator(query: TransferCvFromAsylumOperatorRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/asylum/queries/transfercvfromasylumoperator`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query TransferIntegrationResponsibilityRequest
     * @return TransferIntegrationResponsibilityResponse
     */
    transferIntegrationResponsibility(query: TransferIntegrationResponsibilityRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/asylum/queries/transferintegrationresponsibility`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenAssignmentClient {
    /**
     * @param command CopyAssessmentInterventionObjectivesRequest
     * @return CopyAssessmentInterventionObjectivesResponse
     */
    copyAssessmentInterventionObjectives(command: CopyAssessmentInterventionObjectivesRequest, cancelToken?: CancelToken): Promise<CopyAssessmentInterventionObjectivesResponse>;
    /**
     * @param command CopyAssignmentRequest
     * @return CopyAssignmentResponse
     */
    copyAssignment(command: CopyAssignmentRequest, cancelToken?: CancelToken): Promise<CopyAssignmentResponse>;
    /**
     * @param command CopyCurrentAssignmentRequest
     * @return CopyCurrentAssignmentResponse
     */
    copyCurrentAssignment(command: CopyCurrentAssignmentRequest, cancelToken?: CancelToken): Promise<CopyCurrentAssignmentResponse>;
    /**
     * @param command CreateAssignmentRequest
     * @return CreateAssignmentResponse
     */
    createAssignment(command: CreateAssignmentRequest, cancelToken?: CancelToken): Promise<CreateAssignmentResponse>;
    /**
     * @param command CreateInterventionObjectiveRequest
     * @return CreateInterventionObjectiveResponse
     */
    createInterventionObjective(command: CreateInterventionObjectiveRequest, cancelToken?: CancelToken): Promise<CreateInterventionObjectiveResponse>;
    /**
     * @param command DeleteAssignmentRequest
     * @return DeleteAssignmentResponse
     */
    deleteAssignment(command: DeleteAssignmentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteInterventionObjectiveRequest
     * @return DeleteInterventionObjectiveResponse
     */
    deleteInterventionObjective(command: DeleteInterventionObjectiveRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command EndCurrentAssignmentsForActivityRequest
     * @return EndCurrentAssignmentsForActivityResponse
     */
    endCurrentAssignmentsForActivity(command: EndCurrentAssignmentsForActivityRequest, cancelToken?: CancelToken): Promise<EndCurrentAssignmentsForActivityResponse>;
    /**
     * @param command SetAssignmentStatusRequest
     * @return SetAssignmentStatusResponse
     */
    setAssignmentStatus(command: SetAssignmentStatusRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateAssignmentRequest
     * @return UpdateAssignmentResponse
     */
    updateAssignment(command: UpdateAssignmentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateInterventionObjectiveRequest
     * @return UpdateInterventionObjectiveResponse
     */
    updateInterventionObjective(command: UpdateInterventionObjectiveRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateServiceProviderObjectiveInfoRequest
     * @return UpdateServiceProviderObjectiveInfoResponse
     */
    updateServiceProviderObjectiveInfo(command: UpdateServiceProviderObjectiveInfoRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetAssignmentRequest
     * @return GetAssignmentResponse
     */
    getAssignment(query: GetAssignmentRequest, cancelToken?: CancelToken): Promise<GetAssignmentResponse>;
    /**
     * @param query GetAssignmentCountsPerServiceProviderUnitRequest
     * @return GetAssignmentCountsPerServiceProviderUnitResponse
     */
    getAssignmentCountsPerServiceProviderUnit(query: GetAssignmentCountsPerServiceProviderUnitRequest, cancelToken?: CancelToken): Promise<GetAssignmentCountsPerServiceProviderUnitResponse>;
    /**
     * @param query GetAssignmentHtmlRequest
     * @return GetAssignmentHtmlResponse
     */
    getAssignmentHtml(query: GetAssignmentHtmlRequest, cancelToken?: CancelToken): Promise<GetAssignmentHtmlResponse>;
    /**
     * @param query GetAssignmentIdFromInterventionObjectiveIdRequest
     * @return GetAssignmentIdFromInterventionObjectiveIdResponse
     */
    getAssignmentIdFromInterventionObjectiveId(query: GetAssignmentIdFromInterventionObjectiveIdRequest, cancelToken?: CancelToken): Promise<GetAssignmentIdFromInterventionObjectiveIdResponse>;
    /**
     * @param query GetAssignmentPdfRequest
     * @return FileResponse
     */
    getAssignmentPdf(query: GetAssignmentPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetAssignmentsForActivityRequest
     * @return GetAssignmentsForActivityResponse
     */
    getAssignmentsForActivity(query: GetAssignmentsForActivityRequest, cancelToken?: CancelToken): Promise<GetAssignmentsForActivityResponse>;
    /**
     * @param query GetAssignmentsForCaseRequest
     * @return GetAssignmentsForCaseResponse
     */
    getAssignmentsForCase(query: GetAssignmentsForCaseRequest, cancelToken?: CancelToken): Promise<GetAssignmentsForCaseResponse>;
    /**
     * @param query GetDraftAssignmentForActivityRequest
     * @return GetDraftAssignmentForActivityResponse
     */
    getDraftAssignmentForActivity(query: GetDraftAssignmentForActivityRequest, cancelToken?: CancelToken): Promise<GetDraftAssignmentForActivityResponse>;
    /**
     * @param query GetGrantTypeOfferCombinationsForCompanyRequest
     * @return GetGrantTypeOfferCombinationsForCompanyResponse
     */
    getGrantTypeOfferCombinationsForCompany(query: GetGrantTypeOfferCombinationsForCompanyRequest, cancelToken?: CancelToken): Promise<GetGrantTypeOfferCombinationsForCompanyResponse>;
    /**
     * @param query GetInitialAssignmentDataRequest
     * @return GetInitialAssignmentDataResponse
     */
    getInitialAssignmentData(query: GetInitialAssignmentDataRequest, cancelToken?: CancelToken): Promise<GetInitialAssignmentDataResponse>;
    /**
     * @param query GetInterventionObjectiveRequest
     * @return GetInterventionObjectiveResponse
     */
    getInterventionObjective(query: GetInterventionObjectiveRequest, cancelToken?: CancelToken): Promise<GetInterventionObjectiveResponse>;
    /**
     * @param query GetInterventionObjectivesByAssignmentIdRequest
     * @return GetInterventionObjectivesByAssignmentIdResponse
     */
    getInterventionObjectivesByAssignmentId(query: GetInterventionObjectivesByAssignmentIdRequest, cancelToken?: CancelToken): Promise<GetInterventionObjectivesByAssignmentIdResponse>;
    /**
     * @param query GetJournalNoteAttachmentIdByStatusNoteIdRequest
     * @return GetJournalNoteAttachmentIdByStatusNoteIdResponse
     */
    getJournalNoteAttachmentIdByStatusNoteId(query: GetJournalNoteAttachmentIdByStatusNoteIdRequest, cancelToken?: CancelToken): Promise<GetJournalNoteAttachmentIdByStatusNoteIdResponse>;
    /**
     * @param query GetServiceProviderAssignmentsForCitizenRequest
     * @return GetServiceProviderAssignmentsForCitizenResponse
     */
    getServiceProviderAssignmentsForCitizen(query: GetServiceProviderAssignmentsForCitizenRequest, cancelToken?: CancelToken): Promise<GetServiceProviderAssignmentsForCitizenResponse>;
    /**
     * @param query GetServiceProviderByPartialObjectiveIdRequest
     * @return GetServiceProviderByPartialObjectiveIdResponse
     */
    getServiceProviderByPartialObjectiveId(query: GetServiceProviderByPartialObjectiveIdRequest, cancelToken?: CancelToken): Promise<GetServiceProviderByPartialObjectiveIdResponse>;
    /**
     * @param query GetServiceProviderByStatusNoteIdRequest
     * @return GetServiceProviderByStatusNoteIdResponse
     */
    getServiceProviderByStatusNoteId(query: GetServiceProviderByStatusNoteIdRequest, cancelToken?: CancelToken): Promise<GetServiceProviderByStatusNoteIdResponse>;
    /**
     * @param query GetServiceProviderLookupAssignmentsRequest
     * @return GetServiceProviderLookupAssignmentsResponse
     */
    getServiceProviderLookupAssignments(query: GetServiceProviderLookupAssignmentsRequest, cancelToken?: CancelToken): Promise<GetServiceProviderLookupAssignmentsResponse>;
    /**
     * @param query GetServiceProviderObjectiveInfoRequest
     * @return GetServiceProviderObjectiveInfoResponse
     */
    getServiceProviderObjectiveInfo(query: GetServiceProviderObjectiveInfoRequest, cancelToken?: CancelToken): Promise<GetServiceProviderObjectiveInfoResponse>;
    /**
     * @param query GetServiceProviderPartialObjectiveRequest
     * @return GetServiceProviderPartialObjectiveResponse
     */
    getServiceProviderPartialObjective(query: GetServiceProviderPartialObjectiveRequest, cancelToken?: CancelToken): Promise<GetServiceProviderPartialObjectiveResponse>;
    /**
     * @param query GetServiceProviderUnitRequest
     * @return GetSocialProviderUnitResponse
     */
    getServiceProviderUnit(query: GetServiceProviderUnitRequest2, cancelToken?: CancelToken): Promise<GetSocialProviderUnitResponse>;
    /**
     * @param query GetServiceProviderUnitsRequest
     * @return GetServiceProviderUnitsResponse
     */
    getServiceProviderUnits(query: GetServiceProviderUnitsRequest, cancelToken?: CancelToken): Promise<GetServiceProviderUnitsResponse>;
    /**
     * @param query GetSharedSupportAssessmentRequest
     * @return GetSharedSupportAssessmentResponse
     */
    getSharedSupportAssessment(query: GetSharedSupportAssessmentRequest, cancelToken?: CancelToken): Promise<GetSharedSupportAssessmentResponse>;
    /**
     * @param query RewriteAssignmentForProviderRequest
     * @return RewriteAssignmentForProviderResponse
     */
    rewriteAssignmentForProvider(query: RewriteAssignmentForProviderRequest, cancelToken?: CancelToken): Promise<RewriteAssignmentForProviderResponse>;
}

export class CitizenAssignmentClient implements ICitizenAssignmentClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CopyAssessmentInterventionObjectivesRequest
     * @return CopyAssessmentInterventionObjectivesResponse
     */
    copyAssessmentInterventionObjectives(command: CopyAssessmentInterventionObjectivesRequest, cancelToken?: CancelToken): Promise<CopyAssessmentInterventionObjectivesResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/commands/copyassessmentinterventionobjectives`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CopyAssignmentRequest
     * @return CopyAssignmentResponse
     */
    copyAssignment(command: CopyAssignmentRequest, cancelToken?: CancelToken): Promise<CopyAssignmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/commands/copyassignment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CopyCurrentAssignmentRequest
     * @return CopyCurrentAssignmentResponse
     */
    copyCurrentAssignment(command: CopyCurrentAssignmentRequest, cancelToken?: CancelToken): Promise<CopyCurrentAssignmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/commands/copycurrentassignment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAssignmentRequest
     * @return CreateAssignmentResponse
     */
    createAssignment(command: CreateAssignmentRequest, cancelToken?: CancelToken): Promise<CreateAssignmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/commands/createassignment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateInterventionObjectiveRequest
     * @return CreateInterventionObjectiveResponse
     */
    createInterventionObjective(command: CreateInterventionObjectiveRequest, cancelToken?: CancelToken): Promise<CreateInterventionObjectiveResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/commands/createinterventionobjective`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteAssignmentRequest
     * @return DeleteAssignmentResponse
     */
    deleteAssignment(command: DeleteAssignmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/assignment/commands/deleteassignment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteInterventionObjectiveRequest
     * @return DeleteInterventionObjectiveResponse
     */
    deleteInterventionObjective(command: DeleteInterventionObjectiveRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/assignment/commands/deleteinterventionobjective`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command EndCurrentAssignmentsForActivityRequest
     * @return EndCurrentAssignmentsForActivityResponse
     */
    endCurrentAssignmentsForActivity(command: EndCurrentAssignmentsForActivityRequest, cancelToken?: CancelToken): Promise<EndCurrentAssignmentsForActivityResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/commands/endcurrentassignmentsforactivity`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetAssignmentStatusRequest
     * @return SetAssignmentStatusResponse
     */
    setAssignmentStatus(command: SetAssignmentStatusRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/assignment/commands/setassignmentstatus`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAssignmentRequest
     * @return UpdateAssignmentResponse
     */
    updateAssignment(command: UpdateAssignmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/assignment/commands/updateassignment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateInterventionObjectiveRequest
     * @return UpdateInterventionObjectiveResponse
     */
    updateInterventionObjective(command: UpdateInterventionObjectiveRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/assignment/commands/updateinterventionobjective`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateServiceProviderObjectiveInfoRequest
     * @return UpdateServiceProviderObjectiveInfoResponse
     */
    updateServiceProviderObjectiveInfo(command: UpdateServiceProviderObjectiveInfoRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/assignment/commands/updateserviceproviderobjectiveinfo`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssignmentRequest
     * @return GetAssignmentResponse
     */
    getAssignment(query: GetAssignmentRequest, cancelToken?: CancelToken): Promise<GetAssignmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getassignment`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssignmentCountsPerServiceProviderUnitRequest
     * @return GetAssignmentCountsPerServiceProviderUnitResponse
     */
    getAssignmentCountsPerServiceProviderUnit(query: GetAssignmentCountsPerServiceProviderUnitRequest, cancelToken?: CancelToken): Promise<GetAssignmentCountsPerServiceProviderUnitResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getassignmentcountsperserviceproviderunit`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssignmentHtmlRequest
     * @return GetAssignmentHtmlResponse
     */
    getAssignmentHtml(query: GetAssignmentHtmlRequest, cancelToken?: CancelToken): Promise<GetAssignmentHtmlResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getassignmenthtml`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssignmentIdFromInterventionObjectiveIdRequest
     * @return GetAssignmentIdFromInterventionObjectiveIdResponse
     */
    getAssignmentIdFromInterventionObjectiveId(query: GetAssignmentIdFromInterventionObjectiveIdRequest, cancelToken?: CancelToken): Promise<GetAssignmentIdFromInterventionObjectiveIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getassignmentidfrominterventionobjectiveid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssignmentPdfRequest
     * @return FileResponse
     */
    getAssignmentPdf(query: GetAssignmentPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getassignmentpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssignmentsForActivityRequest
     * @return GetAssignmentsForActivityResponse
     */
    getAssignmentsForActivity(query: GetAssignmentsForActivityRequest, cancelToken?: CancelToken): Promise<GetAssignmentsForActivityResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getassignmentsforactivity`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssignmentsForCaseRequest
     * @return GetAssignmentsForCaseResponse
     */
    getAssignmentsForCase(query: GetAssignmentsForCaseRequest, cancelToken?: CancelToken): Promise<GetAssignmentsForCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getassignmentsforcase`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDraftAssignmentForActivityRequest
     * @return GetDraftAssignmentForActivityResponse
     */
    getDraftAssignmentForActivity(query: GetDraftAssignmentForActivityRequest, cancelToken?: CancelToken): Promise<GetDraftAssignmentForActivityResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getdraftassignmentforactivity`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetGrantTypeOfferCombinationsForCompanyRequest
     * @return GetGrantTypeOfferCombinationsForCompanyResponse
     */
    getGrantTypeOfferCombinationsForCompany(query: GetGrantTypeOfferCombinationsForCompanyRequest, cancelToken?: CancelToken): Promise<GetGrantTypeOfferCombinationsForCompanyResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getgranttypeoffercombinationsforcompany`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInitialAssignmentDataRequest
     * @return GetInitialAssignmentDataResponse
     */
    getInitialAssignmentData(query: GetInitialAssignmentDataRequest, cancelToken?: CancelToken): Promise<GetInitialAssignmentDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getinitialassignmentdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterventionObjectiveRequest
     * @return GetInterventionObjectiveResponse
     */
    getInterventionObjective(query: GetInterventionObjectiveRequest, cancelToken?: CancelToken): Promise<GetInterventionObjectiveResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getinterventionobjective`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterventionObjectivesByAssignmentIdRequest
     * @return GetInterventionObjectivesByAssignmentIdResponse
     */
    getInterventionObjectivesByAssignmentId(query: GetInterventionObjectivesByAssignmentIdRequest, cancelToken?: CancelToken): Promise<GetInterventionObjectivesByAssignmentIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getinterventionobjectivesbyassignmentid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalNoteAttachmentIdByStatusNoteIdRequest
     * @return GetJournalNoteAttachmentIdByStatusNoteIdResponse
     */
    getJournalNoteAttachmentIdByStatusNoteId(query: GetJournalNoteAttachmentIdByStatusNoteIdRequest, cancelToken?: CancelToken): Promise<GetJournalNoteAttachmentIdByStatusNoteIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getjournalnoteattachmentidbystatusnoteid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderAssignmentsForCitizenRequest
     * @return GetServiceProviderAssignmentsForCitizenResponse
     */
    getServiceProviderAssignmentsForCitizen(query: GetServiceProviderAssignmentsForCitizenRequest, cancelToken?: CancelToken): Promise<GetServiceProviderAssignmentsForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getserviceproviderassignmentsforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderByPartialObjectiveIdRequest
     * @return GetServiceProviderByPartialObjectiveIdResponse
     */
    getServiceProviderByPartialObjectiveId(query: GetServiceProviderByPartialObjectiveIdRequest, cancelToken?: CancelToken): Promise<GetServiceProviderByPartialObjectiveIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getserviceproviderbypartialobjectiveid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderByStatusNoteIdRequest
     * @return GetServiceProviderByStatusNoteIdResponse
     */
    getServiceProviderByStatusNoteId(query: GetServiceProviderByStatusNoteIdRequest, cancelToken?: CancelToken): Promise<GetServiceProviderByStatusNoteIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getserviceproviderbystatusnoteid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderLookupAssignmentsRequest
     * @return GetServiceProviderLookupAssignmentsResponse
     */
    getServiceProviderLookupAssignments(query: GetServiceProviderLookupAssignmentsRequest, cancelToken?: CancelToken): Promise<GetServiceProviderLookupAssignmentsResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getserviceproviderlookupassignments`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderObjectiveInfoRequest
     * @return GetServiceProviderObjectiveInfoResponse
     */
    getServiceProviderObjectiveInfo(query: GetServiceProviderObjectiveInfoRequest, cancelToken?: CancelToken): Promise<GetServiceProviderObjectiveInfoResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getserviceproviderobjectiveinfo`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderPartialObjectiveRequest
     * @return GetServiceProviderPartialObjectiveResponse
     */
    getServiceProviderPartialObjective(query: GetServiceProviderPartialObjectiveRequest, cancelToken?: CancelToken): Promise<GetServiceProviderPartialObjectiveResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getserviceproviderpartialobjective`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderUnitRequest
     * @return GetSocialProviderUnitResponse
     */
    getServiceProviderUnit(query: GetServiceProviderUnitRequest2, cancelToken?: CancelToken): Promise<GetSocialProviderUnitResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getserviceproviderunit`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderUnitsRequest
     * @return GetServiceProviderUnitsResponse
     */
    getServiceProviderUnits(query: GetServiceProviderUnitsRequest, cancelToken?: CancelToken): Promise<GetServiceProviderUnitsResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getserviceproviderunits`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSharedSupportAssessmentRequest
     * @return GetSharedSupportAssessmentResponse
     */
    getSharedSupportAssessment(query: GetSharedSupportAssessmentRequest, cancelToken?: CancelToken): Promise<GetSharedSupportAssessmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/getsharedsupportassessment`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query RewriteAssignmentForProviderRequest
     * @return RewriteAssignmentForProviderResponse
     */
    rewriteAssignmentForProvider(query: RewriteAssignmentForProviderRequest, cancelToken?: CancelToken): Promise<RewriteAssignmentForProviderResponse> {
        const $url = `${this.baseUrl}/api/citizen/assignment/queries/rewriteassignmentforprovider`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenAssessmentClient {
    /**
     * @param command CopyAssessmentRequest
     * @return CopyAssessmentResponse
     */
    copyAssessment(command: CopyAssessmentRequest, cancelToken?: CancelToken): Promise<CopyAssessmentResponse>;
    /**
     * @param command CopyCurrentAssessmentRequest
     * @return CopyCurrentAssessmentResponse
     */
    copyCurrentAssessment(command: CopyCurrentAssessmentRequest, cancelToken?: CancelToken): Promise<CopyCurrentAssessmentResponse>;
    /**
     * @param command CreateAssessmentInterventionObjectiveRequest
     * @return CreateAssessmentInterventionObjectiveResponse
     */
    createAssessmentInterventionObjective(command: CreateAssessmentInterventionObjectiveRequest, cancelToken?: CancelToken): Promise<CreateAssessmentInterventionObjectiveResponse>;
    /**
     * @param command CreateAssessmentInterventionObjectiveForDraftRequest
     * @return CreateAssessmentInterventionObjectiveForDraftResponse
     */
    createAssessmentInterventionObjectiveForDraft(command: CreateAssessmentInterventionObjectiveForDraftRequest, cancelToken?: CancelToken): Promise<CreateAssessmentInterventionObjectiveForDraftResponse>;
    /**
     * @param command DeleteAssessmentRequest
     * @return DeleteAssessmentResponse
     */
    deleteAssessment(command: DeleteAssessmentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command FinalizeAssessmentRequest
     * @return FinalizeAssessmentResponse
     */
    finalizeAssessment(command: FinalizeAssessmentRequest, cancelToken?: CancelToken): Promise<FinalizeAssessmentResponse>;
    /**
     * @param command FinalizeAssessmentVersionedRequest
     * @return FinalizeAssessmentVersionedResponse
     */
    finalizeAssessmentVersioned(command: FinalizeAssessmentVersionedRequest, cancelToken?: CancelToken): Promise<FinalizeAssessmentVersionedResponse>;
    /**
     * @param command QueuePartialAssessmentTranscriptionRequest
     * @return QueuePartialAssessmentTranscriptionResponse
     */
    queuePartialAssessmentTranscription(command: QueuePartialAssessmentTranscriptionRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ReopenAssessmentRequest
     * @return ReopenAssessmentResponse
     */
    reopenAssessment(command: ReopenAssessmentRequest, cancelToken?: CancelToken): Promise<ReopenAssessmentResponse>;
    /**
     * @param command SaveAssessmentRequest
     * @return SaveAssessmentResponse
     */
    saveAssessment(command: SaveAssessmentRequest, cancelToken?: CancelToken): Promise<SaveAssessmentResponse>;
    /**
     * @param command UpdateAssessmentInterventionObjectiveRequest
     * @return UpdateAssessmentInterventionObjectiveResponse
     */
    updateAssessmentInterventionObjective(command: UpdateAssessmentInterventionObjectiveRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateAssessmentInterventionObjectiveForDraftRequest
     * @return UpdateAssessmentInterventionObjectiveForDraftResponse
     */
    updateAssessmentInterventionObjectiveForDraft(command: UpdateAssessmentInterventionObjectiveForDraftRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GenerateAssessmentFollowupAnalysisRequest
     * @return FileResponse
     */
    generateAssessmentFollowupAnalysis(query: GenerateAssessmentFollowupAnalysisRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GenerateAssessmentGroupFieldsRequest
     * @return FileResponse
     */
    generateAssessmentGroupFields(query: GenerateAssessmentGroupFieldsRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GenerateAssessmentGroupSummaryRequest
     * @return FileResponse
     */
    generateAssessmentGroupSummary(query: GenerateAssessmentGroupSummaryRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetAssessmentByIdRequest
     * @return GetAssessmentByIdResponse
     */
    getAssessmentById(query: GetAssessmentByIdRequest, cancelToken?: CancelToken): Promise<GetAssessmentByIdResponse>;
    /**
     * @return GetAssessmentGenerationFieldsResponse
     */
    getAssessmentGenerationFields(cancelToken?: CancelToken): Promise<GetAssessmentGenerationFieldsResponse>;
    /**
     * @param query GetAssessmentInterventionObjectiveRequest
     * @return GetAssessmentInterventionObjectiveResponse
     */
    getAssessmentInterventionObjective(query: GetAssessmentInterventionObjectiveRequest, cancelToken?: CancelToken): Promise<GetAssessmentInterventionObjectiveResponse>;
    /**
     * @param query GetAssessmentInterventionObjectivesByAssessmentIdRequest
     * @return GetAssessmentInterventionObjectivesByAssessmentIdResponse
     */
    getAssessmentInterventionObjectivesByAssessmentId(query: GetAssessmentInterventionObjectivesByAssessmentIdRequest, cancelToken?: CancelToken): Promise<GetAssessmentInterventionObjectivesByAssessmentIdResponse>;
    /**
     * @return GetAssessmentPromptDefaultsResponse
     */
    getAssessmentPromptDefaults(cancelToken?: CancelToken): Promise<GetAssessmentPromptDefaultsResponse>;
    /**
     * @param query GetAssessmentsByCaseIdRequest
     * @return GetAssessmentsByCaseIdResponse
     */
    getAssessmentsByCaseId(query: GetAssessmentsByCaseIdRequest, cancelToken?: CancelToken): Promise<GetAssessmentsByCaseIdResponse>;
    /**
     * @param query GetAssessmentTranscriptionBySessionIdRequest
     * @return GetAssessmentTranscriptionBySessionIdResponse
     */
    getAssessmentTranscriptionBySessionId(query: GetAssessmentTranscriptionBySessionIdRequest, cancelToken?: CancelToken): Promise<GetAssessmentTranscriptionBySessionIdResponse>;
    /**
     * @return GetBenefitFFBTypesResponse
     */
    getBenefitFFBTypes(cancelToken?: CancelToken): Promise<GetBenefitFFBTypesResponse2>;
    /**
     * @param query GetCurrentAssessmentInterventionObjectivesByActivityIdRequest
     * @return GetCurrentAssessmentInterventionObjectivesByActivityIdResponse
     */
    getCurrentAssessmentInterventionObjectivesByActivityId(query: GetCurrentAssessmentInterventionObjectivesByActivityIdRequest, cancelToken?: CancelToken): Promise<GetCurrentAssessmentInterventionObjectivesByActivityIdResponse>;
    /**
     * @param query GetDraftAssessmentForCaseRequest
     * @return GetDraftAssessmentForCaseResponse
     */
    getDraftAssessmentForCase(query: GetDraftAssessmentForCaseRequest, cancelToken?: CancelToken): Promise<GetDraftAssessmentForCaseResponse>;
    /**
     * @return GetFunctionalAbilityCatalogItemsResponse
     */
    getFunctionalAbilityCatalogItems(cancelToken?: CancelToken): Promise<GetFunctionalAbilityCatalogItemsResponse>;
}

export class CitizenAssessmentClient implements ICitizenAssessmentClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CopyAssessmentRequest
     * @return CopyAssessmentResponse
     */
    copyAssessment(command: CopyAssessmentRequest, cancelToken?: CancelToken): Promise<CopyAssessmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/commands/copyassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CopyCurrentAssessmentRequest
     * @return CopyCurrentAssessmentResponse
     */
    copyCurrentAssessment(command: CopyCurrentAssessmentRequest, cancelToken?: CancelToken): Promise<CopyCurrentAssessmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/commands/copycurrentassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAssessmentInterventionObjectiveRequest
     * @return CreateAssessmentInterventionObjectiveResponse
     */
    createAssessmentInterventionObjective(command: CreateAssessmentInterventionObjectiveRequest, cancelToken?: CancelToken): Promise<CreateAssessmentInterventionObjectiveResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/commands/createassessmentinterventionobjective`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAssessmentInterventionObjectiveForDraftRequest
     * @return CreateAssessmentInterventionObjectiveForDraftResponse
     */
    createAssessmentInterventionObjectiveForDraft(command: CreateAssessmentInterventionObjectiveForDraftRequest, cancelToken?: CancelToken): Promise<CreateAssessmentInterventionObjectiveForDraftResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/commands/createassessmentinterventionobjectivefordraft`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteAssessmentRequest
     * @return DeleteAssessmentResponse
     */
    deleteAssessment(command: DeleteAssessmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/assessment/commands/deleteassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command FinalizeAssessmentRequest
     * @return FinalizeAssessmentResponse
     */
    finalizeAssessment(command: FinalizeAssessmentRequest, cancelToken?: CancelToken): Promise<FinalizeAssessmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/commands/finalizeassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command FinalizeAssessmentVersionedRequest
     * @return FinalizeAssessmentVersionedResponse
     */
    finalizeAssessmentVersioned(command: FinalizeAssessmentVersionedRequest, cancelToken?: CancelToken): Promise<FinalizeAssessmentVersionedResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/commands/finalizeassessmentversioned`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command QueuePartialAssessmentTranscriptionRequest
     * @return QueuePartialAssessmentTranscriptionResponse
     */
    queuePartialAssessmentTranscription(command: QueuePartialAssessmentTranscriptionRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/assessment/commands/queuepartialassessmenttranscription`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReopenAssessmentRequest
     * @return ReopenAssessmentResponse
     */
    reopenAssessment(command: ReopenAssessmentRequest, cancelToken?: CancelToken): Promise<ReopenAssessmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/commands/reopenassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SaveAssessmentRequest
     * @return SaveAssessmentResponse
     */
    saveAssessment(command: SaveAssessmentRequest, cancelToken?: CancelToken): Promise<SaveAssessmentResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/commands/saveassessment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAssessmentInterventionObjectiveRequest
     * @return UpdateAssessmentInterventionObjectiveResponse
     */
    updateAssessmentInterventionObjective(command: UpdateAssessmentInterventionObjectiveRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/assessment/commands/updateassessmentinterventionobjective`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAssessmentInterventionObjectiveForDraftRequest
     * @return UpdateAssessmentInterventionObjectiveForDraftResponse
     */
    updateAssessmentInterventionObjectiveForDraft(command: UpdateAssessmentInterventionObjectiveForDraftRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/citizen/assessment/commands/updateassessmentinterventionobjectivefordraft`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GenerateAssessmentFollowupAnalysisRequest
     * @return FileResponse
     */
    generateAssessmentFollowupAnalysis(query: GenerateAssessmentFollowupAnalysisRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/queries/generateassessmentfollowupanalysis`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GenerateAssessmentGroupFieldsRequest
     * @return FileResponse
     */
    generateAssessmentGroupFields(query: GenerateAssessmentGroupFieldsRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/queries/generateassessmentgroupfields`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GenerateAssessmentGroupSummaryRequest
     * @return FileResponse
     */
    generateAssessmentGroupSummary(query: GenerateAssessmentGroupSummaryRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/queries/generateassessmentgroupsummary`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssessmentByIdRequest
     * @return GetAssessmentByIdResponse
     */
    getAssessmentById(query: GetAssessmentByIdRequest, cancelToken?: CancelToken): Promise<GetAssessmentByIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/queries/getassessmentbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAssessmentGenerationFieldsResponse
     */
    getAssessmentGenerationFields(cancelToken?: CancelToken): Promise<GetAssessmentGenerationFieldsResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/queries/getassessmentgenerationfields`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssessmentInterventionObjectiveRequest
     * @return GetAssessmentInterventionObjectiveResponse
     */
    getAssessmentInterventionObjective(query: GetAssessmentInterventionObjectiveRequest, cancelToken?: CancelToken): Promise<GetAssessmentInterventionObjectiveResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/queries/getassessmentinterventionobjective`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssessmentInterventionObjectivesByAssessmentIdRequest
     * @return GetAssessmentInterventionObjectivesByAssessmentIdResponse
     */
    getAssessmentInterventionObjectivesByAssessmentId(query: GetAssessmentInterventionObjectivesByAssessmentIdRequest, cancelToken?: CancelToken): Promise<GetAssessmentInterventionObjectivesByAssessmentIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/queries/getassessmentinterventionobjectivesbyassessmentid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAssessmentPromptDefaultsResponse
     */
    getAssessmentPromptDefaults(cancelToken?: CancelToken): Promise<GetAssessmentPromptDefaultsResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/queries/getassessmentpromptdefaults`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssessmentsByCaseIdRequest
     * @return GetAssessmentsByCaseIdResponse
     */
    getAssessmentsByCaseId(query: GetAssessmentsByCaseIdRequest, cancelToken?: CancelToken): Promise<GetAssessmentsByCaseIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/queries/getassessmentsbycaseid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAssessmentTranscriptionBySessionIdRequest
     * @return GetAssessmentTranscriptionBySessionIdResponse
     */
    getAssessmentTranscriptionBySessionId(query: GetAssessmentTranscriptionBySessionIdRequest, cancelToken?: CancelToken): Promise<GetAssessmentTranscriptionBySessionIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/queries/getassessmenttranscriptionbysessionid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetBenefitFFBTypesResponse
     */
    getBenefitFFBTypes(cancelToken?: CancelToken): Promise<GetBenefitFFBTypesResponse2> {
        const $url = `${this.baseUrl}/api/citizen/assessment/queries/getbenefitffbtypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCurrentAssessmentInterventionObjectivesByActivityIdRequest
     * @return GetCurrentAssessmentInterventionObjectivesByActivityIdResponse
     */
    getCurrentAssessmentInterventionObjectivesByActivityId(query: GetCurrentAssessmentInterventionObjectivesByActivityIdRequest, cancelToken?: CancelToken): Promise<GetCurrentAssessmentInterventionObjectivesByActivityIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/queries/getcurrentassessmentinterventionobjectivesbyactivityid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDraftAssessmentForCaseRequest
     * @return GetDraftAssessmentForCaseResponse
     */
    getDraftAssessmentForCase(query: GetDraftAssessmentForCaseRequest, cancelToken?: CancelToken): Promise<GetDraftAssessmentForCaseResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/queries/getdraftassessmentforcase`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetFunctionalAbilityCatalogItemsResponse
     */
    getFunctionalAbilityCatalogItems(cancelToken?: CancelToken): Promise<GetFunctionalAbilityCatalogItemsResponse> {
        const $url = `${this.baseUrl}/api/citizen/assessment/queries/getfunctionalabilitycatalogitems`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenAgendaClient {
    /**
     * @param command SaveAgendaForCitizenRequest
     * @return SaveAgendaForCitizenResponse
     */
    saveAgendaForCitizen(command: SaveAgendaForCitizenRequest, cancelToken?: CancelToken): Promise<SaveAgendaForCitizenResponse>;
    /**
     * @param query GenerateAgendaForCitizenRequest
     * @return GenerateAgendaForCitizenResponse
     */
    generateAgendaForCitizen(query: GenerateAgendaForCitizenRequest, cancelToken?: CancelToken): Promise<GenerateAgendaForCitizenResponse>;
    /**
     * @param query GetAgendaOptionsRequest
     * @return GetAgendaOptionsResponse
     */
    getAgendaOptions(query: GetAgendaOptionsRequest, cancelToken?: CancelToken): Promise<GetAgendaOptionsResponse>;
    /**
     * @param query GetSavedAgendaForCitizenRequest
     * @return GetSavedAgendaForCitizenResponse
     */
    getSavedAgendaForCitizen(query: GetSavedAgendaForCitizenRequest, cancelToken?: CancelToken): Promise<GetSavedAgendaForCitizenResponse>;
}

export class CitizenAgendaClient implements ICitizenAgendaClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command SaveAgendaForCitizenRequest
     * @return SaveAgendaForCitizenResponse
     */
    saveAgendaForCitizen(command: SaveAgendaForCitizenRequest, cancelToken?: CancelToken): Promise<SaveAgendaForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/agenda/commands/saveagendaforcitizen`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GenerateAgendaForCitizenRequest
     * @return GenerateAgendaForCitizenResponse
     */
    generateAgendaForCitizen(query: GenerateAgendaForCitizenRequest, cancelToken?: CancelToken): Promise<GenerateAgendaForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/agenda/queries/generateagendaforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAgendaOptionsRequest
     * @return GetAgendaOptionsResponse
     */
    getAgendaOptions(query: GetAgendaOptionsRequest, cancelToken?: CancelToken): Promise<GetAgendaOptionsResponse> {
        const $url = `${this.baseUrl}/api/citizen/agenda/queries/getagendaoptions`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSavedAgendaForCitizenRequest
     * @return GetSavedAgendaForCitizenResponse
     */
    getSavedAgendaForCitizen(query: GetSavedAgendaForCitizenRequest, cancelToken?: CancelToken): Promise<GetSavedAgendaForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/agenda/queries/getsavedagendaforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAttendanceProtocolClient {
    /**
     * @param command AddAttendanceRegistrationRequest
     * @return AddAttendanceRegistrationResponse
     */
    addAttendanceRegistrations(command: AddAttendanceRegistrationRequest, cancelToken?: CancelToken): Promise<AddAttendanceRegistrationResponse>;
    /**
     * @param command ApproveAttendanceProtocolRequest
     * @return ApproveAttendanceProtocolResponse
     */
    approveAttendanceProtocol(command: ApproveAttendanceProtocolRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteAttendanceRegistrationRequest
     * @return DeleteAttendanceRegistrationResponse
     */
    deleteAttendanceRegistration(command: DeleteAttendanceRegistrationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command RegisterNoShowsRequest
     * @return RegisterNoShowsResponse
     */
    registerNoShows(command: RegisterNoShowsRequest, cancelToken?: CancelToken): Promise<RegisterNoShowsResponse>;
    /**
     * @param command SubmitAttendanceProtocolRequest
     * @return SubmitAttendanceProtocolResponse
     */
    submitAttendanceProtocol(command: SubmitAttendanceProtocolRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateAttendanceRegistrationRequest
     * @return UpdateAttendanceRegistrationResponse
     */
    updateAttendanceRegistration(command: UpdateAttendanceRegistrationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetAttendanceProtocolPdfRequest
     * @return FileResponse
     */
    getAttendanceProtocolPdf(query: GetAttendanceProtocolPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetCitizenLessonAttendancesByLessonIdRequest
     * @return GetCitizenLessonAttendancesByLessonIdResponse
     */
    getCitizenLessonAttendancesByLessonId(query: GetCitizenLessonAttendancesByLessonIdRequest, cancelToken?: CancelToken): Promise<GetCitizenLessonAttendancesByLessonIdResponse>;
    /**
     * @return GetCoursesForAttendanceProtocolResponse
     */
    getCoursesForAttendanceProtocol(cancelToken?: CancelToken): Promise<GetCoursesForAttendanceProtocolResponse>;
    /**
     * @param query GetLessonsForAttendanceProtocolRequest
     * @return GetLessonsForAttendanceProtocolResponse
     */
    getLessonsForAttendanceProtocol(query: GetLessonsForAttendanceProtocolRequest, cancelToken?: CancelToken): Promise<GetLessonsForAttendanceProtocolResponse>;
}

export class AttendanceProtocolClient implements IAttendanceProtocolClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command AddAttendanceRegistrationRequest
     * @return AddAttendanceRegistrationResponse
     */
    addAttendanceRegistrations(command: AddAttendanceRegistrationRequest, cancelToken?: CancelToken): Promise<AddAttendanceRegistrationResponse> {
        const $url = `${this.baseUrl}/api/attendance/protocol/commands/addattendanceregistrations`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ApproveAttendanceProtocolRequest
     * @return ApproveAttendanceProtocolResponse
     */
    approveAttendanceProtocol(command: ApproveAttendanceProtocolRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/protocol/commands/approveattendanceprotocol`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteAttendanceRegistrationRequest
     * @return DeleteAttendanceRegistrationResponse
     */
    deleteAttendanceRegistration(command: DeleteAttendanceRegistrationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/protocol/commands/deleteattendanceregistration`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RegisterNoShowsRequest
     * @return RegisterNoShowsResponse
     */
    registerNoShows(command: RegisterNoShowsRequest, cancelToken?: CancelToken): Promise<RegisterNoShowsResponse> {
        const $url = `${this.baseUrl}/api/attendance/protocol/commands/registernoshows`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SubmitAttendanceProtocolRequest
     * @return SubmitAttendanceProtocolResponse
     */
    submitAttendanceProtocol(command: SubmitAttendanceProtocolRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/protocol/commands/submitattendanceprotocol`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAttendanceRegistrationRequest
     * @return UpdateAttendanceRegistrationResponse
     */
    updateAttendanceRegistration(command: UpdateAttendanceRegistrationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/protocol/commands/updateattendanceregistration`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAttendanceProtocolPdfRequest
     * @return FileResponse
     */
    getAttendanceProtocolPdf(query: GetAttendanceProtocolPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/attendance/protocol/queries/getattendanceprotocolpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenLessonAttendancesByLessonIdRequest
     * @return GetCitizenLessonAttendancesByLessonIdResponse
     */
    getCitizenLessonAttendancesByLessonId(query: GetCitizenLessonAttendancesByLessonIdRequest, cancelToken?: CancelToken): Promise<GetCitizenLessonAttendancesByLessonIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/protocol/queries/getcitizenlessonattendancesbylessonid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCoursesForAttendanceProtocolResponse
     */
    getCoursesForAttendanceProtocol(cancelToken?: CancelToken): Promise<GetCoursesForAttendanceProtocolResponse> {
        const $url = `${this.baseUrl}/api/attendance/protocol/queries/getcoursesforattendanceprotocol`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLessonsForAttendanceProtocolRequest
     * @return GetLessonsForAttendanceProtocolResponse
     */
    getLessonsForAttendanceProtocol(query: GetLessonsForAttendanceProtocolRequest, cancelToken?: CancelToken): Promise<GetLessonsForAttendanceProtocolResponse> {
        const $url = `${this.baseUrl}/api/attendance/protocol/queries/getlessonsforattendanceprotocol`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAttendanceClient {
    /**
     * @param command AddAndRemoveCourseEducatorsCommandRequest
     * @return AddAndRemoveCourseEducatorsCommandResponse
     */
    addAndRemoveCourseEducators(command: AddAndRemoveCourseEducatorsCommandRequest, cancelToken?: CancelToken): Promise<AddAndRemoveCourseEducatorsCommandResponse>;
    /**
     * @param command AddAndRemoveLessonEducatorsCommandRequest
     * @return AddAndRemoveLessonEducatorsCommandResponse
     */
    addAndRemoveLessonEducators(command: AddAndRemoveLessonEducatorsCommandRequest, cancelToken?: CancelToken): Promise<AddAndRemoveLessonEducatorsCommandResponse>;
    /**
     * @param command AdjustCourseCapacitiesByOfferIdCommandRequest
     * @return AdjustCourseCapacitiesByOfferIdCommandResponse
     */
    adjustCourseCapacitiesByOfferId(command: AdjustCourseCapacitiesByOfferIdCommandRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command AssignResponsibleCaseworkerToCoursesRequest
     * @return AssignResponsibleCaseworkerToCoursesResponse
     */
    assignResponsibleCaseworkerToCourses(command: AssignResponsibleCaseworkerToCoursesRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command AttendanceImportRequest
     * @return AttendanceImportResponse
     */
    attendanceImport(command: AttendanceImportRequest, cancelToken?: CancelToken): Promise<AttendanceImportResponse>;
    /**
     * @param command CancelCourseEnrollmentRequest
     * @return CancelCourseEnrollmentResponse
     */
    cancelCourseEnrollment(command: CancelCourseEnrollmentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CancelLessonRequest
     * @return CancelLessonResponse
     */
    cancelLesson(command: CancelLessonRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CancelLessonsCommandRequest
     * @return CancelLessonsCommandResponse
     */
    cancelLessons(command: CancelLessonsCommandRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ChangeCourseClassroomCommandRequest
     * @return ChangeCourseClassroomCommandResponse
     */
    changeCourseClassroom(command: ChangeCourseClassroomCommandRequest, cancelToken?: CancelToken): Promise<ChangeCourseClassroomCommandResponse>;
    /**
     * @param command ChangeLessonClassroomCommandRequest
     * @return ChangeLessonClassroomCommandResponse
     */
    changeLessonClassroom(command: ChangeLessonClassroomCommandRequest, cancelToken?: CancelToken): Promise<ChangeLessonClassroomCommandResponse>;
    /**
     * @param command CreateCitizenLessonDeviationRequest
     * @return CreateCitizenLessonDeviationResponse
     */
    createCitizenLessonDeviation(command: CreateCitizenLessonDeviationRequest, cancelToken?: CancelToken): Promise<CreateCitizenLessonDeviationResponse>;
    /**
     * @param command CreateCitizenScheduleLetterAttachmentRequest
     * @return CreateCitizenScheduleLetterAttachmentResponse
     */
    createCitizenScheduleLetterAttachment(command: CreateCitizenScheduleLetterAttachmentRequest, cancelToken?: CancelToken): Promise<CreateCitizenScheduleLetterAttachmentResponse>;
    /**
     * @param command CreateClassRoomRequest
     * @return CreateClassRoomResponse
     */
    createClassRoom(command: CreateClassRoomRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateCourseRequest
     * @return CreateCourseResponse
     */
    createCourse(command: CreateCourseRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateCourseEnrollmentRequest
     * @return CreateCourseEnrollmentResponse
     */
    createCourseEnrollment(command: CreateCourseEnrollmentRequest, cancelToken?: CancelToken): Promise<CreateCourseEnrollmentResponse>;
    /**
     * @param command CreateCourseEnrollmentsRequest
     * @return CreateCourseEnrollmentsResponse
     */
    createCourseEnrollments(command: CreateCourseEnrollmentsRequest, cancelToken?: CancelToken): Promise<CreateCourseEnrollmentsResponse>;
    /**
     * @param command CreateEducatorRequest
     * @return CreateEducatorResponse
     */
    createEducator(command: CreateEducatorRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateLessonRequest
     * @return CreateLessonResponse
     */
    createLesson(command: CreateLessonRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateRegistrationCounterRequest
     * @return CreateRegistrationCounterResponse
     */
    createRegistrationCounter(command: CreateRegistrationCounterRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateReoccuringLessonsRequest
     * @return CreateReoccuringLessonsResponse
     */
    createReoccuringLessons(command: CreateReoccuringLessonsRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteCitizenAttendanceNoteRequest
     * @return DeleteCitizenAttendanceNoteResponse
     */
    deleteCitizenAttendanceNote(command: DeleteCitizenAttendanceNoteRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteCitizenLessonDeviationRequest
     * @return DeleteCitizenLessonDeviationResponse
     */
    deleteCitizenLessonDeviation(command: DeleteCitizenLessonDeviationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteCourseRequest
     * @return DeleteCourseResponse
     */
    deleteCourse(command: DeleteCourseRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteCourseEnrollmentRequest
     * @return DeleteCourseEnrollmentResponse
     */
    deleteCourseEnrollment(command: DeleteCourseEnrollmentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteEducatorRequest
     * @return DeleteEducatorResponse
     */
    deleteEducator(command: DeleteEducatorRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteLessonCommandRequest
     * @return DeleteLessonCommandResponse
     */
    deleteLesson(command: DeleteLessonCommandRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteLessonsCommandRequest
     * @return DeleteLessonsCommandResponse
     */
    deleteLessons(command: DeleteLessonsCommandRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteRegistrationCounterRequest
     * @return DeleteRegistrationCounterResponse
     */
    deleteRegistrationCounter(command: DeleteRegistrationCounterRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command GenerateActivationKeyRequest
     * @return GenerateActivationKeyResponse
     */
    generateActivationKey(command: GenerateActivationKeyRequest, cancelToken?: CancelToken): Promise<GenerateActivationKeyResponse>;
    /**
     * @param command GenerateEducatorActivationKeyRequest
     * @return GenerateEducatorActivationKeyResponse
     */
    generateEducatorActivationKey(command: GenerateEducatorActivationKeyRequest, cancelToken?: CancelToken): Promise<GenerateEducatorActivationKeyResponse>;
    /**
     * @param command PublishLessonCommandRequest
     * @return PublishLessonCommandResponse
     */
    publishLesson(command: PublishLessonCommandRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command PublishLessonsCommandRequest
     * @return PublishLessonsCommandResponse
     */
    publishLessons(command: PublishLessonsCommandRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command RevokeEducatorActivationKeyRequest
     * @return RevokeEducatorActivationKeyResponse
     */
    revokeEducatorActivationKey(command: RevokeEducatorActivationKeyRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SaveCitizenAttendanceNoteRequest
     * @return SaveCitizenAttendanceNoteResponse
     */
    saveCitizenAttendanceNote(command: SaveCitizenAttendanceNoteRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCitizenLessonDeviationRequest
     * @return UpdateCitizenLessonDeviationResponse
     */
    updateCitizenLessonDeviation(command: UpdateCitizenLessonDeviationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateClassRoomRequest
     * @return UpdateClassRoomResponse
     */
    updateClassRoom(command: UpdateClassRoomRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCourseRequest
     * @return UpdateCourseResponse
     */
    updateCourse(command: UpdateCourseRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCourseEnrollmentRequest
     * @return UpdateCourseEnrollmentResponse
     */
    updateCourseEnrollment(command: UpdateCourseEnrollmentRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCoursesRequestStatus
     * @return UpdateCoursesResponseStatus
     */
    updateCoursesStatus(command: UpdateCoursesRequestStatus, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCourseRequestStatus
     * @return UpdateCourseResponseStatus
     */
    updateCourseStatus(command: UpdateCourseRequestStatus, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateEducatorRequest
     * @return UpdateEducatorResponse
     */
    updateEducator(command: UpdateEducatorRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateLessonRequest
     * @return UpdateLessonResponse
     */
    updateLesson(command: UpdateLessonRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateRegistrationCounterRequest
     * @return UpdateRegistrationCounterResponse
     */
    updateRegistrationCounter(command: UpdateRegistrationCounterRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query AttendanceCsvParserRequest
     * @return AttendanceCsvParserResponse
     */
    attendanceCsvParser(query: AttendanceCsvParserRequest, cancelToken?: CancelToken): Promise<AttendanceCsvParserResponse>;
    /**
     * @param query GetActiveCoursesRequest
     * @return GetActiveCoursesResponse
     */
    getActiveCourses(query: GetActiveCoursesRequest, cancelToken?: CancelToken): Promise<GetActiveCoursesResponse>;
    /**
     * @param query GetCitizenAttendanceNoteRequest
     * @return GetCitizenAttendanceNoteResponse
     */
    getCitizenAttendanceNote(query: GetCitizenAttendanceNoteRequest, cancelToken?: CancelToken): Promise<GetCitizenAttendanceNoteResponse>;
    /**
     * @param query GetCitizenAttendanceStatisticsRequest
     * @return GetCitizenAttendanceStatisticsResponse
     */
    getCitizenAttendanceStatistics(query: GetCitizenAttendanceStatisticsRequest, cancelToken?: CancelToken): Promise<GetCitizenAttendanceStatisticsResponse>;
    /**
     * @param query GetCitizenAttendanceStatisticsPdfRequest
     * @return FileResponse
     */
    getCitizenAttendanceStatisticsPdf(query: GetCitizenAttendanceStatisticsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetCitizenLessonByIdRequest
     * @return GetCitizenLessonByIdResponse
     */
    getCitizenLessonById(query: GetCitizenLessonByIdRequest, cancelToken?: CancelToken): Promise<GetCitizenLessonByIdResponse>;
    /**
     * @param query GetCitizenLessonDeviationByIdRequest
     * @return GetCitizenLessonDeviationByIdResponse
     */
    getCitizenLessonDeviationById(query: GetCitizenLessonDeviationByIdRequest, cancelToken?: CancelToken): Promise<GetCitizenLessonDeviationByIdResponse>;
    /**
     * @param query GetCitizenSchedulePdfRequest
     * @return FileResponse
     */
    getCitizenSchedulePdf(query: GetCitizenSchedulePdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetClassRoomByIdRequest
     * @return GetClassRoomByIdResponse
     */
    getClassRoomById(query: GetClassRoomByIdRequest, cancelToken?: CancelToken): Promise<GetClassRoomByIdResponse>;
    /**
     * @return GetClassRoomsResponse
     */
    getClassRooms(cancelToken?: CancelToken): Promise<GetClassRoomsResponse>;
    /**
     * @param query GetClassRoomsByCompanyIdRequest
     * @return GetClassRoomsByCompanyIdResponse
     */
    getClassRoomsByCompanyId(query: GetClassRoomsByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetClassRoomsByCompanyIdResponse>;
    /**
     * @param query GetCourseAttendanceStatisticsRequest
     * @return GetCourseAttendanceStatisticsResponse
     */
    getCourseAttendanceStatistics(query: GetCourseAttendanceStatisticsRequest, cancelToken?: CancelToken): Promise<GetCourseAttendanceStatisticsResponse>;
    /**
     * @param query GetCourseAttendanceStatisticsPdfRequest
     * @return FileResponse
     */
    getCourseAttendanceStatisticsPdf(query: GetCourseAttendanceStatisticsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetCourseByIdRequest
     * @return GetCourseByIdResponse
     */
    getCourseById(query: GetCourseByIdRequest, cancelToken?: CancelToken): Promise<GetCourseByIdResponse>;
    /**
     * @param query GetCourseDeletabilityRequest
     * @return GetCourseDeletabilityResponse
     */
    getCourseDeletability(query: GetCourseDeletabilityRequest, cancelToken?: CancelToken): Promise<GetCourseDeletabilityResponse>;
    /**
     * @param query GetCourseEnrollmentByIdRequest
     * @return GetCourseEnrollmentByIdResponse
     */
    getCourseEnrollmentById(query: GetCourseEnrollmentByIdRequest, cancelToken?: CancelToken): Promise<GetCourseEnrollmentByIdResponse>;
    /**
     * @param query GetCourseEnrollmentContextRequest
     * @return GetCourseEnrollmentContextResponse
     */
    getCourseEnrollmentContext(query: GetCourseEnrollmentContextRequest, cancelToken?: CancelToken): Promise<GetCourseEnrollmentContextResponse>;
    /**
     * @param query GetCourseEnrollmentsByCitizenIdRequest
     * @return GetCourseEnrollmentsByCitizenIdResponse
     */
    getCourseEnrollmentsByCitizenId(query: GetCourseEnrollmentsByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetCourseEnrollmentsByCitizenIdResponse>;
    /**
     * @param query GetCourseEnrollmentsByCourseIdRequest
     * @return GetCourseEnrollmentsByCourseIdResponse
     */
    getCourseEnrollmentsByCourseId(query: GetCourseEnrollmentsByCourseIdRequest, cancelToken?: CancelToken): Promise<GetCourseEnrollmentsByCourseIdResponse>;
    /**
     * @param query GetCourseEnrollmentLessonsByCitizenIdRequest
     * @return GetCourseEnrollmentLessonsByCitizenIdResponse
     */
    getCourseEnrollmentLessonsByCitizenId(query: GetCourseEnrollmentLessonsByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetCourseEnrollmentLessonsByCitizenIdResponse>;
    /**
     * @param query GetCoursesRequest
     * @return GetCoursesResponse
     */
    getCourses(query: GetCoursesRequest, cancelToken?: CancelToken): Promise<GetCoursesResponse>;
    /**
     * @param query GetCoursesByCompanyIdRequest
     * @return GetCoursesByCompanyIdResponse
     */
    getCoursesByCompanyId(query: GetCoursesByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetCoursesByCompanyIdResponse>;
    /**
     * @param query GetCoursesByOfferIdRequest
     * @return GetCoursesByOfferIdResponse
     */
    getCoursesByOfferId(query: GetCoursesByOfferIdRequest, cancelToken?: CancelToken): Promise<GetCoursesByOfferIdResponse>;
    /**
     * @return GetCoursesFromConnectResponse
     */
    getCoursesFromConnect(cancelToken?: CancelToken): Promise<GetCoursesFromConnectResponse>;
    /**
     * @param query GetEducatorByIdRequest
     * @return GetEducatorByIdResponse
     */
    getEducatorById(query: GetEducatorByIdRequest, cancelToken?: CancelToken): Promise<GetEducatorByIdResponse>;
    /**
     * @param query GetEducatorIdByCourseEducatorIdRequest
     * @return GetEducatorIdByCourseEducatorIdResponse
     */
    getEducatorIdByCourseEducatorId(query: GetEducatorIdByCourseEducatorIdRequest, cancelToken?: CancelToken): Promise<GetEducatorIdByCourseEducatorIdResponse>;
    /**
     * @param query GetEducatorIdByLessonEducatorIdRequest
     * @return GetEducatorIdByLessonEducatorIdResponse
     */
    getEducatorIdByLessonEducatorId(query: GetEducatorIdByLessonEducatorIdRequest, cancelToken?: CancelToken): Promise<GetEducatorIdByLessonEducatorIdResponse>;
    /**
     * @return GetEducatorsResponse
     */
    getEducators(cancelToken?: CancelToken): Promise<GetEducatorsResponse>;
    /**
     * @param query GetEducatorsByCompanyIdRequest
     * @return GetEducatorsByCompanyIdResponse
     */
    getEducatorsByCompanyId(query: GetEducatorsByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetEducatorsByCompanyIdResponse>;
    /**
     * @return GetIncludeFutureLessonsTenantConfigurationResponse
     */
    getIncludeFutureLessonsTenantConfiguration(cancelToken?: CancelToken): Promise<GetIncludeFutureLessonsTenantConfigurationResponse>;
    /**
     * @param query GetLessonByIdRequest
     * @return GetLessonByIdResponse
     */
    getLessonById(query: GetLessonByIdRequest, cancelToken?: CancelToken): Promise<GetLessonByIdResponse>;
    /**
     * @param query GetLessonsByCourseIdRequest
     * @return GetLessonsByCourseIdResponse
     */
    getLessonsByCourseId(query: GetLessonsByCourseIdRequest, cancelToken?: CancelToken): Promise<GetLessonsByCourseIdResponse>;
    /**
     * @param query GetLessonsDateRangeByOfferIdRequest
     * @return GetLessonsDateRangeByOfferIdResponse
     */
    getLessonsDateRangeByOfferId(query: GetLessonsDateRangeByOfferIdRequest, cancelToken?: CancelToken): Promise<GetLessonsDateRangeByOfferIdResponse>;
    /**
     * @param query GetLessonsWithoutFreeSeatsRequest
     * @return GetLessonsWithoutFreeSeatsResponse
     */
    getLessonsWithoutFreeSeats(query: GetLessonsWithoutFreeSeatsRequest, cancelToken?: CancelToken): Promise<GetLessonsWithoutFreeSeatsResponse>;
    /**
     * @param query GetOccupiedDatesRequest
     * @return GetOccupiedDatesResponse
     */
    getOccupiedDates(query: GetOccupiedDatesRequest, cancelToken?: CancelToken): Promise<GetOccupiedDatesResponse>;
    /**
     * @param query GetOfferPeriodByOfferIdRequest
     * @return GetOfferPeriodByOfferIdResponse
     */
    getOfferPeriodByOfferId(query: GetOfferPeriodByOfferIdRequest, cancelToken?: CancelToken): Promise<GetOfferPeriodByOfferIdResponse>;
    /**
     * @param query GetRegistrationCounterByIdRequest
     * @return GetRegistrationCounterByIdResponse
     */
    getRegistrationCounterById(query: GetRegistrationCounterByIdRequest, cancelToken?: CancelToken): Promise<GetRegistrationCounterByIdResponse>;
    /**
     * @return GetRegistrationCountersResponse
     */
    getRegistrationCounters(cancelToken?: CancelToken): Promise<GetRegistrationCountersResponse>;
}

export class AttendanceClient implements IAttendanceClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command AddAndRemoveCourseEducatorsCommandRequest
     * @return AddAndRemoveCourseEducatorsCommandResponse
     */
    addAndRemoveCourseEducators(command: AddAndRemoveCourseEducatorsCommandRequest, cancelToken?: CancelToken): Promise<AddAndRemoveCourseEducatorsCommandResponse> {
        const $url = `${this.baseUrl}/api/attendance/commands/addandremovecourseeducators`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command AddAndRemoveLessonEducatorsCommandRequest
     * @return AddAndRemoveLessonEducatorsCommandResponse
     */
    addAndRemoveLessonEducators(command: AddAndRemoveLessonEducatorsCommandRequest, cancelToken?: CancelToken): Promise<AddAndRemoveLessonEducatorsCommandResponse> {
        const $url = `${this.baseUrl}/api/attendance/commands/addandremovelessoneducators`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command AdjustCourseCapacitiesByOfferIdCommandRequest
     * @return AdjustCourseCapacitiesByOfferIdCommandResponse
     */
    adjustCourseCapacitiesByOfferId(command: AdjustCourseCapacitiesByOfferIdCommandRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/adjustcoursecapacitiesbyofferid`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command AssignResponsibleCaseworkerToCoursesRequest
     * @return AssignResponsibleCaseworkerToCoursesResponse
     */
    assignResponsibleCaseworkerToCourses(command: AssignResponsibleCaseworkerToCoursesRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/assignresponsiblecaseworkertocourses`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command AttendanceImportRequest
     * @return AttendanceImportResponse
     */
    attendanceImport(command: AttendanceImportRequest, cancelToken?: CancelToken): Promise<AttendanceImportResponse> {
        const $url = `${this.baseUrl}/api/attendance/commands/attendanceimport`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CancelCourseEnrollmentRequest
     * @return CancelCourseEnrollmentResponse
     */
    cancelCourseEnrollment(command: CancelCourseEnrollmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/cancelcourseenrollment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CancelLessonRequest
     * @return CancelLessonResponse
     */
    cancelLesson(command: CancelLessonRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/cancellesson`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CancelLessonsCommandRequest
     * @return CancelLessonsCommandResponse
     */
    cancelLessons(command: CancelLessonsCommandRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/cancellessons`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ChangeCourseClassroomCommandRequest
     * @return ChangeCourseClassroomCommandResponse
     */
    changeCourseClassroom(command: ChangeCourseClassroomCommandRequest, cancelToken?: CancelToken): Promise<ChangeCourseClassroomCommandResponse> {
        const $url = `${this.baseUrl}/api/attendance/commands/changecourseclassroom`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ChangeLessonClassroomCommandRequest
     * @return ChangeLessonClassroomCommandResponse
     */
    changeLessonClassroom(command: ChangeLessonClassroomCommandRequest, cancelToken?: CancelToken): Promise<ChangeLessonClassroomCommandResponse> {
        const $url = `${this.baseUrl}/api/attendance/commands/changelessonclassroom`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCitizenLessonDeviationRequest
     * @return CreateCitizenLessonDeviationResponse
     */
    createCitizenLessonDeviation(command: CreateCitizenLessonDeviationRequest, cancelToken?: CancelToken): Promise<CreateCitizenLessonDeviationResponse> {
        const $url = `${this.baseUrl}/api/attendance/commands/createcitizenlessondeviation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCitizenScheduleLetterAttachmentRequest
     * @return CreateCitizenScheduleLetterAttachmentResponse
     */
    createCitizenScheduleLetterAttachment(command: CreateCitizenScheduleLetterAttachmentRequest, cancelToken?: CancelToken): Promise<CreateCitizenScheduleLetterAttachmentResponse> {
        const $url = `${this.baseUrl}/api/attendance/commands/createcitizenscheduleletterattachment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateClassRoomRequest
     * @return CreateClassRoomResponse
     */
    createClassRoom(command: CreateClassRoomRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/createclassroom`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCourseRequest
     * @return CreateCourseResponse
     */
    createCourse(command: CreateCourseRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/createcourse`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCourseEnrollmentRequest
     * @return CreateCourseEnrollmentResponse
     */
    createCourseEnrollment(command: CreateCourseEnrollmentRequest, cancelToken?: CancelToken): Promise<CreateCourseEnrollmentResponse> {
        const $url = `${this.baseUrl}/api/attendance/commands/createcourseenrollment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCourseEnrollmentsRequest
     * @return CreateCourseEnrollmentsResponse
     */
    createCourseEnrollments(command: CreateCourseEnrollmentsRequest, cancelToken?: CancelToken): Promise<CreateCourseEnrollmentsResponse> {
        const $url = `${this.baseUrl}/api/attendance/commands/createcourseenrollments`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateEducatorRequest
     * @return CreateEducatorResponse
     */
    createEducator(command: CreateEducatorRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/createeducator`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateLessonRequest
     * @return CreateLessonResponse
     */
    createLesson(command: CreateLessonRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/createlesson`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateRegistrationCounterRequest
     * @return CreateRegistrationCounterResponse
     */
    createRegistrationCounter(command: CreateRegistrationCounterRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/createregistrationcounter`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateReoccuringLessonsRequest
     * @return CreateReoccuringLessonsResponse
     */
    createReoccuringLessons(command: CreateReoccuringLessonsRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/createreoccuringlessons`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteCitizenAttendanceNoteRequest
     * @return DeleteCitizenAttendanceNoteResponse
     */
    deleteCitizenAttendanceNote(command: DeleteCitizenAttendanceNoteRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/deletecitizenattendancenote`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteCitizenLessonDeviationRequest
     * @return DeleteCitizenLessonDeviationResponse
     */
    deleteCitizenLessonDeviation(command: DeleteCitizenLessonDeviationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/deletecitizenlessondeviation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteCourseRequest
     * @return DeleteCourseResponse
     */
    deleteCourse(command: DeleteCourseRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/deletecourse`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteCourseEnrollmentRequest
     * @return DeleteCourseEnrollmentResponse
     */
    deleteCourseEnrollment(command: DeleteCourseEnrollmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/deletecourseenrollment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteEducatorRequest
     * @return DeleteEducatorResponse
     */
    deleteEducator(command: DeleteEducatorRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/deleteeducator`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteLessonCommandRequest
     * @return DeleteLessonCommandResponse
     */
    deleteLesson(command: DeleteLessonCommandRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/deletelesson`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteLessonsCommandRequest
     * @return DeleteLessonsCommandResponse
     */
    deleteLessons(command: DeleteLessonsCommandRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/deletelessons`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteRegistrationCounterRequest
     * @return DeleteRegistrationCounterResponse
     */
    deleteRegistrationCounter(command: DeleteRegistrationCounterRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/deleteregistrationcounter`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command GenerateActivationKeyRequest
     * @return GenerateActivationKeyResponse
     */
    generateActivationKey(command: GenerateActivationKeyRequest, cancelToken?: CancelToken): Promise<GenerateActivationKeyResponse> {
        const $url = `${this.baseUrl}/api/attendance/commands/generateactivationkey`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command GenerateEducatorActivationKeyRequest
     * @return GenerateEducatorActivationKeyResponse
     */
    generateEducatorActivationKey(command: GenerateEducatorActivationKeyRequest, cancelToken?: CancelToken): Promise<GenerateEducatorActivationKeyResponse> {
        const $url = `${this.baseUrl}/api/attendance/commands/generateeducatoractivationkey`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command PublishLessonCommandRequest
     * @return PublishLessonCommandResponse
     */
    publishLesson(command: PublishLessonCommandRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/publishlesson`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command PublishLessonsCommandRequest
     * @return PublishLessonsCommandResponse
     */
    publishLessons(command: PublishLessonsCommandRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/publishlessons`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RevokeEducatorActivationKeyRequest
     * @return RevokeEducatorActivationKeyResponse
     */
    revokeEducatorActivationKey(command: RevokeEducatorActivationKeyRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/revokeeducatoractivationkey`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SaveCitizenAttendanceNoteRequest
     * @return SaveCitizenAttendanceNoteResponse
     */
    saveCitizenAttendanceNote(command: SaveCitizenAttendanceNoteRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/savecitizenattendancenote`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCitizenLessonDeviationRequest
     * @return UpdateCitizenLessonDeviationResponse
     */
    updateCitizenLessonDeviation(command: UpdateCitizenLessonDeviationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/updatecitizenlessondeviation`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateClassRoomRequest
     * @return UpdateClassRoomResponse
     */
    updateClassRoom(command: UpdateClassRoomRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/updateclassroom`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCourseRequest
     * @return UpdateCourseResponse
     */
    updateCourse(command: UpdateCourseRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/updatecourse`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCourseEnrollmentRequest
     * @return UpdateCourseEnrollmentResponse
     */
    updateCourseEnrollment(command: UpdateCourseEnrollmentRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/updatecourseenrollment`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCoursesRequestStatus
     * @return UpdateCoursesResponseStatus
     */
    updateCoursesStatus(command: UpdateCoursesRequestStatus, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/updatecoursesstatus`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCourseRequestStatus
     * @return UpdateCourseResponseStatus
     */
    updateCourseStatus(command: UpdateCourseRequestStatus, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/updatecoursestatus`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateEducatorRequest
     * @return UpdateEducatorResponse
     */
    updateEducator(command: UpdateEducatorRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/updateeducator`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateLessonRequest
     * @return UpdateLessonResponse
     */
    updateLesson(command: UpdateLessonRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/updatelesson`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateRegistrationCounterRequest
     * @return UpdateRegistrationCounterResponse
     */
    updateRegistrationCounter(command: UpdateRegistrationCounterRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/attendance/commands/updateregistrationcounter`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query AttendanceCsvParserRequest
     * @return AttendanceCsvParserResponse
     */
    attendanceCsvParser(query: AttendanceCsvParserRequest, cancelToken?: CancelToken): Promise<AttendanceCsvParserResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/attendancecsvparser`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetActiveCoursesRequest
     * @return GetActiveCoursesResponse
     */
    getActiveCourses(query: GetActiveCoursesRequest, cancelToken?: CancelToken): Promise<GetActiveCoursesResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getactivecourses`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenAttendanceNoteRequest
     * @return GetCitizenAttendanceNoteResponse
     */
    getCitizenAttendanceNote(query: GetCitizenAttendanceNoteRequest, cancelToken?: CancelToken): Promise<GetCitizenAttendanceNoteResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcitizenattendancenote`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenAttendanceStatisticsRequest
     * @return GetCitizenAttendanceStatisticsResponse
     */
    getCitizenAttendanceStatistics(query: GetCitizenAttendanceStatisticsRequest, cancelToken?: CancelToken): Promise<GetCitizenAttendanceStatisticsResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcitizenattendancestatistics`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenAttendanceStatisticsPdfRequest
     * @return FileResponse
     */
    getCitizenAttendanceStatisticsPdf(query: GetCitizenAttendanceStatisticsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcitizenattendancestatisticspdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenLessonByIdRequest
     * @return GetCitizenLessonByIdResponse
     */
    getCitizenLessonById(query: GetCitizenLessonByIdRequest, cancelToken?: CancelToken): Promise<GetCitizenLessonByIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcitizenlessonbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenLessonDeviationByIdRequest
     * @return GetCitizenLessonDeviationByIdResponse
     */
    getCitizenLessonDeviationById(query: GetCitizenLessonDeviationByIdRequest, cancelToken?: CancelToken): Promise<GetCitizenLessonDeviationByIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcitizenlessondeviationbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenSchedulePdfRequest
     * @return FileResponse
     */
    getCitizenSchedulePdf(query: GetCitizenSchedulePdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcitizenschedulepdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetClassRoomByIdRequest
     * @return GetClassRoomByIdResponse
     */
    getClassRoomById(query: GetClassRoomByIdRequest, cancelToken?: CancelToken): Promise<GetClassRoomByIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getclassroombyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetClassRoomsResponse
     */
    getClassRooms(cancelToken?: CancelToken): Promise<GetClassRoomsResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getclassrooms`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetClassRoomsByCompanyIdRequest
     * @return GetClassRoomsByCompanyIdResponse
     */
    getClassRoomsByCompanyId(query: GetClassRoomsByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetClassRoomsByCompanyIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getclassroomsbycompanyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCourseAttendanceStatisticsRequest
     * @return GetCourseAttendanceStatisticsResponse
     */
    getCourseAttendanceStatistics(query: GetCourseAttendanceStatisticsRequest, cancelToken?: CancelToken): Promise<GetCourseAttendanceStatisticsResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcourseattendancestatistics`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCourseAttendanceStatisticsPdfRequest
     * @return FileResponse
     */
    getCourseAttendanceStatisticsPdf(query: GetCourseAttendanceStatisticsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcourseattendancestatisticspdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCourseByIdRequest
     * @return GetCourseByIdResponse
     */
    getCourseById(query: GetCourseByIdRequest, cancelToken?: CancelToken): Promise<GetCourseByIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcoursebyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCourseDeletabilityRequest
     * @return GetCourseDeletabilityResponse
     */
    getCourseDeletability(query: GetCourseDeletabilityRequest, cancelToken?: CancelToken): Promise<GetCourseDeletabilityResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcoursedeletability`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCourseEnrollmentByIdRequest
     * @return GetCourseEnrollmentByIdResponse
     */
    getCourseEnrollmentById(query: GetCourseEnrollmentByIdRequest, cancelToken?: CancelToken): Promise<GetCourseEnrollmentByIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcourseenrollmentbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCourseEnrollmentContextRequest
     * @return GetCourseEnrollmentContextResponse
     */
    getCourseEnrollmentContext(query: GetCourseEnrollmentContextRequest, cancelToken?: CancelToken): Promise<GetCourseEnrollmentContextResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcourseenrollmentcontext`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCourseEnrollmentsByCitizenIdRequest
     * @return GetCourseEnrollmentsByCitizenIdResponse
     */
    getCourseEnrollmentsByCitizenId(query: GetCourseEnrollmentsByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetCourseEnrollmentsByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcourseenrollmentsbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCourseEnrollmentsByCourseIdRequest
     * @return GetCourseEnrollmentsByCourseIdResponse
     */
    getCourseEnrollmentsByCourseId(query: GetCourseEnrollmentsByCourseIdRequest, cancelToken?: CancelToken): Promise<GetCourseEnrollmentsByCourseIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcourseenrollmentsbycourseid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCourseEnrollmentLessonsByCitizenIdRequest
     * @return GetCourseEnrollmentLessonsByCitizenIdResponse
     */
    getCourseEnrollmentLessonsByCitizenId(query: GetCourseEnrollmentLessonsByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetCourseEnrollmentLessonsByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcourseenrollmentlessonsbycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCoursesRequest
     * @return GetCoursesResponse
     */
    getCourses(query: GetCoursesRequest, cancelToken?: CancelToken): Promise<GetCoursesResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcourses`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCoursesByCompanyIdRequest
     * @return GetCoursesByCompanyIdResponse
     */
    getCoursesByCompanyId(query: GetCoursesByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetCoursesByCompanyIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcoursesbycompanyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCoursesByOfferIdRequest
     * @return GetCoursesByOfferIdResponse
     */
    getCoursesByOfferId(query: GetCoursesByOfferIdRequest, cancelToken?: CancelToken): Promise<GetCoursesByOfferIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcoursesbyofferid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCoursesFromConnectResponse
     */
    getCoursesFromConnect(cancelToken?: CancelToken): Promise<GetCoursesFromConnectResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getcoursesfromconnect`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEducatorByIdRequest
     * @return GetEducatorByIdResponse
     */
    getEducatorById(query: GetEducatorByIdRequest, cancelToken?: CancelToken): Promise<GetEducatorByIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/geteducatorbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEducatorIdByCourseEducatorIdRequest
     * @return GetEducatorIdByCourseEducatorIdResponse
     */
    getEducatorIdByCourseEducatorId(query: GetEducatorIdByCourseEducatorIdRequest, cancelToken?: CancelToken): Promise<GetEducatorIdByCourseEducatorIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/geteducatoridbycourseeducatorid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEducatorIdByLessonEducatorIdRequest
     * @return GetEducatorIdByLessonEducatorIdResponse
     */
    getEducatorIdByLessonEducatorId(query: GetEducatorIdByLessonEducatorIdRequest, cancelToken?: CancelToken): Promise<GetEducatorIdByLessonEducatorIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/geteducatoridbylessoneducatorid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetEducatorsResponse
     */
    getEducators(cancelToken?: CancelToken): Promise<GetEducatorsResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/geteducators`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEducatorsByCompanyIdRequest
     * @return GetEducatorsByCompanyIdResponse
     */
    getEducatorsByCompanyId(query: GetEducatorsByCompanyIdRequest, cancelToken?: CancelToken): Promise<GetEducatorsByCompanyIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/geteducatorsbycompanyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetIncludeFutureLessonsTenantConfigurationResponse
     */
    getIncludeFutureLessonsTenantConfiguration(cancelToken?: CancelToken): Promise<GetIncludeFutureLessonsTenantConfigurationResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getincludefuturelessonstenantconfiguration`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLessonByIdRequest
     * @return GetLessonByIdResponse
     */
    getLessonById(query: GetLessonByIdRequest, cancelToken?: CancelToken): Promise<GetLessonByIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getlessonbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLessonsByCourseIdRequest
     * @return GetLessonsByCourseIdResponse
     */
    getLessonsByCourseId(query: GetLessonsByCourseIdRequest, cancelToken?: CancelToken): Promise<GetLessonsByCourseIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getlessonsbycourseid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLessonsDateRangeByOfferIdRequest
     * @return GetLessonsDateRangeByOfferIdResponse
     */
    getLessonsDateRangeByOfferId(query: GetLessonsDateRangeByOfferIdRequest, cancelToken?: CancelToken): Promise<GetLessonsDateRangeByOfferIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getlessonsdaterangebyofferid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLessonsWithoutFreeSeatsRequest
     * @return GetLessonsWithoutFreeSeatsResponse
     */
    getLessonsWithoutFreeSeats(query: GetLessonsWithoutFreeSeatsRequest, cancelToken?: CancelToken): Promise<GetLessonsWithoutFreeSeatsResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getlessonswithoutfreeseats`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOccupiedDatesRequest
     * @return GetOccupiedDatesResponse
     */
    getOccupiedDates(query: GetOccupiedDatesRequest, cancelToken?: CancelToken): Promise<GetOccupiedDatesResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getoccupieddates`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferPeriodByOfferIdRequest
     * @return GetOfferPeriodByOfferIdResponse
     */
    getOfferPeriodByOfferId(query: GetOfferPeriodByOfferIdRequest, cancelToken?: CancelToken): Promise<GetOfferPeriodByOfferIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getofferperiodbyofferid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetRegistrationCounterByIdRequest
     * @return GetRegistrationCounterByIdResponse
     */
    getRegistrationCounterById(query: GetRegistrationCounterByIdRequest, cancelToken?: CancelToken): Promise<GetRegistrationCounterByIdResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getregistrationcounterbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetRegistrationCountersResponse
     */
    getRegistrationCounters(cancelToken?: CancelToken): Promise<GetRegistrationCountersResponse> {
        const $url = `${this.baseUrl}/api/attendance/queries/getregistrationcounters`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAiSearchClient {
    /**
     * @param command CreateOrUpdateUserChatMessageRequest
     * @return CreateOrUpdateUserChatMessageResponse
     */
    createOrUpdateUserChatMessage(command: CreateOrUpdateUserChatMessageRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ReportSpeechUsageRequest
     * @return ReportSpeechUsageResponse
     */
    reportSpeechUsage(command: ReportSpeechUsageRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetAiStandardQuestionsRequest
     * @return GetAiStandardQuestionsResponse
     */
    getAiStandardQuestions(query: GetAiStandardQuestionsRequest, cancelToken?: CancelToken): Promise<GetAiStandardQuestionsResponse>;
    /**
     * @return GetAvailableCitationContentTypesForFasitAssistantResponse
     */
    getAvailableCitationContentTypesForFasitAssistant(cancelToken?: CancelToken): Promise<GetAvailableCitationContentTypesForFasitAssistantResponse>;
    /**
     * @param query GetCitizenAssistantPromptRequest
     * @return FileResponse
     */
    getCitizenAssistantPrompt(query: GetCitizenAssistantPromptRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetInterpretingAssistanceCitizenGuideRequest
     * @return GetInterpretingAssistanceCitizenGuideResponse
     */
    getInterpretingAssistanceCitizenGuide(query: GetInterpretingAssistanceCitizenGuideRequest, cancelToken?: CancelToken): Promise<GetInterpretingAssistanceCitizenGuideResponse>;
    /**
     * @param query GetInterpretingRecognitionHintsRequest
     * @return GetInterpretingRecognitionHintsResponse
     */
    getInterpretingRecognitionHints(query: GetInterpretingRecognitionHintsRequest, cancelToken?: CancelToken): Promise<GetInterpretingRecognitionHintsResponse>;
    /**
     * @param query GetLanguageAssistRequest
     * @return GetLanguageAssistResponse
     */
    getLanguageAssist(query: GetLanguageAssistRequest, cancelToken?: CancelToken): Promise<GetLanguageAssistResponse>;
    /**
     * @param query GetLegalDocumentFileByIdentifierRequest
     * @return FileResponse
     */
    getLegalDocumentFileByIdentifier(query: GetLegalDocumentFileByIdentifierRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetMunicipalityAssistantDocumentFileByIdentifierRequest
     * @return FileResponse
     */
    getMunicipalityAssistantDocumentFileByIdentifier(query: GetMunicipalityAssistantDocumentFileByIdentifierRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetPromptRequest
     * @return FileResponse
     */
    getPrompt(query: GetPromptRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetPromptRequest
     * @return FileResponse
     */
    getPromptTemplate(query: GetPromptRequest2, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetSmartGoalSuggestionRequest
     * @return GetSmartGoalSuggestionResponse
     */
    getSmartGoalSuggestion(query: GetSmartGoalSuggestionRequest, cancelToken?: CancelToken): Promise<GetSmartGoalSuggestionResponse>;
    /**
     * @return GetSummaPreviewModelResponse
     */
    getSummaPreviewModel(cancelToken?: CancelToken): Promise<GetSummaPreviewModelResponse>;
    /**
     * @return GetSupportedLanguagesResponse
     */
    getSupportedLanguages(cancelToken?: CancelToken): Promise<GetSupportedLanguagesResponse>;
    /**
     * @param query GetTranslateTokenRequest
     * @return GetTranslateTokenResponse
     */
    getTranslateToken(query: GetTranslateTokenRequest, cancelToken?: CancelToken): Promise<GetTranslateTokenResponse>;
    /**
     * @param query GetTranslationReviewRequest
     * @return GetTranslationReviewResponse
     */
    getTranslationReview(query: GetTranslationReviewRequest, cancelToken?: CancelToken): Promise<GetTranslationReviewResponse>;
    /**
     * @return GetUserApprovedAiProductsResponse
     */
    getUserApprovedAiProducts(cancelToken?: CancelToken): Promise<GetUserApprovedAiProductsResponse>;
    /**
     * @param query RewriteLetterToneRequest
     * @return RewriteLetterToneResponse
     */
    rewriteLetterTone(query: RewriteLetterToneRequest, cancelToken?: CancelToken): Promise<RewriteLetterToneResponse>;
}

export class AiSearchClient implements IAiSearchClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateOrUpdateUserChatMessageRequest
     * @return CreateOrUpdateUserChatMessageResponse
     */
    createOrUpdateUserChatMessage(command: CreateOrUpdateUserChatMessageRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/aisearch/commands/createorupdateuserchatmessage`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ReportSpeechUsageRequest
     * @return ReportSpeechUsageResponse
     */
    reportSpeechUsage(command: ReportSpeechUsageRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/aisearch/commands/reportspeechusage`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAiStandardQuestionsRequest
     * @return GetAiStandardQuestionsResponse
     */
    getAiStandardQuestions(query: GetAiStandardQuestionsRequest, cancelToken?: CancelToken): Promise<GetAiStandardQuestionsResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/getaistandardquestions`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAvailableCitationContentTypesForFasitAssistantResponse
     */
    getAvailableCitationContentTypesForFasitAssistant(cancelToken?: CancelToken): Promise<GetAvailableCitationContentTypesForFasitAssistantResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/getavailablecitationcontenttypesforfasitassistant`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenAssistantPromptRequest
     * @return FileResponse
     */
    getCitizenAssistantPrompt(query: GetCitizenAssistantPromptRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/getcitizenassistantprompt`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterpretingAssistanceCitizenGuideRequest
     * @return GetInterpretingAssistanceCitizenGuideResponse
     */
    getInterpretingAssistanceCitizenGuide(query: GetInterpretingAssistanceCitizenGuideRequest, cancelToken?: CancelToken): Promise<GetInterpretingAssistanceCitizenGuideResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/getinterpretingassistancecitizenguide`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterpretingRecognitionHintsRequest
     * @return GetInterpretingRecognitionHintsResponse
     */
    getInterpretingRecognitionHints(query: GetInterpretingRecognitionHintsRequest, cancelToken?: CancelToken): Promise<GetInterpretingRecognitionHintsResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/getinterpretingrecognitionhints`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLanguageAssistRequest
     * @return GetLanguageAssistResponse
     */
    getLanguageAssist(query: GetLanguageAssistRequest, cancelToken?: CancelToken): Promise<GetLanguageAssistResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/getlanguageassist`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLegalDocumentFileByIdentifierRequest
     * @return FileResponse
     */
    getLegalDocumentFileByIdentifier(query: GetLegalDocumentFileByIdentifierRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/getlegaldocumentfilebyidentifier`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMunicipalityAssistantDocumentFileByIdentifierRequest
     * @return FileResponse
     */
    getMunicipalityAssistantDocumentFileByIdentifier(query: GetMunicipalityAssistantDocumentFileByIdentifierRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/getmunicipalityassistantdocumentfilebyidentifier`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPromptRequest
     * @return FileResponse
     */
    getPrompt(query: GetPromptRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/getprompt`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPromptRequest
     * @return FileResponse
     */
    getPromptTemplate(query: GetPromptRequest2, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/getprompttemplate`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSmartGoalSuggestionRequest
     * @return GetSmartGoalSuggestionResponse
     */
    getSmartGoalSuggestion(query: GetSmartGoalSuggestionRequest, cancelToken?: CancelToken): Promise<GetSmartGoalSuggestionResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/getsmartgoalsuggestion`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSummaPreviewModelResponse
     */
    getSummaPreviewModel(cancelToken?: CancelToken): Promise<GetSummaPreviewModelResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/getsummapreviewmodel`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSupportedLanguagesResponse
     */
    getSupportedLanguages(cancelToken?: CancelToken): Promise<GetSupportedLanguagesResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/getsupportedlanguages`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTranslateTokenRequest
     * @return GetTranslateTokenResponse
     */
    getTranslateToken(query: GetTranslateTokenRequest, cancelToken?: CancelToken): Promise<GetTranslateTokenResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/gettranslatetoken`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTranslationReviewRequest
     * @return GetTranslationReviewResponse
     */
    getTranslationReview(query: GetTranslationReviewRequest, cancelToken?: CancelToken): Promise<GetTranslationReviewResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/gettranslationreview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetUserApprovedAiProductsResponse
     */
    getUserApprovedAiProducts(cancelToken?: CancelToken): Promise<GetUserApprovedAiProductsResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/getuserapprovedaiproducts`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query RewriteLetterToneRequest
     * @return RewriteLetterToneResponse
     */
    rewriteLetterTone(query: RewriteLetterToneRequest, cancelToken?: CancelToken): Promise<RewriteLetterToneResponse> {
        const $url = `${this.baseUrl}/api/aisearch/queries/rewritelettertone`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminCitizenDeletionClient {
    /**
     * @param command ApproveCitizenDeletionOrderRequest
     * @return ApproveCitizenDeletionOrderResponse
     */
    approveCitizenDeletionOrder(command: ApproveCitizenDeletionOrderRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command ArchiveCitizenDeletionOrderRequest
     * @return ArchiveCitizenDeletionOrderResponse
     */
    archiveCitizenDeletionOrder(command: ArchiveCitizenDeletionOrderRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CancelCitizenDeletionOrderRequest
     * @return CancelCitizenDeletionOrderResponse
     */
    cancelCitizenDeletionOrder(command: CancelCitizenDeletionOrderRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateCitizenDeletionOrderRequest
     * @return CreateCitizenDeletionOrderResponse
     */
    createCitizenDeletionOrder(command: CreateCitizenDeletionOrderRequest, cancelToken?: CancelToken): Promise<CreateCitizenDeletionOrderResponse>;
    /**
     * @param command DeleteCitizenRequest
     * @return DeleteCitizenResponse
     */
    deleteCitizen(command: DeleteCitizenRequest, cancelToken?: CancelToken): Promise<DeleteCitizenResponse>;
    /**
     * @param command DryRunDeleteCitizenRequest
     * @return DryRunDeleteCitizenResponse
     */
    dryRunDeleteCitizen(command: DryRunDeleteCitizenRequest, cancelToken?: CancelToken): Promise<DryRunDeleteCitizenResponse>;
    /**
     * @param command SendCitizenDeletionOrderToApprovalRequest
     * @return SendCitizenDeletionOrderToApprovalResponse
     */
    sendCitizenDeletionOrderToApproval(command: SendCitizenDeletionOrderToApprovalRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCitizenDeletionOrderRequest
     * @return UpdateCitizenDeletionOrderResponse
     */
    updateCitizenDeletionOrder(command: UpdateCitizenDeletionOrderRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetCitizenDeletionEligibilityRequest
     * @return GetCitizenDeletionEligibilityResponse
     */
    getCitizenDeletionEligibility(query: GetCitizenDeletionEligibilityRequest, cancelToken?: CancelToken): Promise<GetCitizenDeletionEligibilityResponse>;
    /**
     * @param query GetCitizenDeletionOrderRequest
     * @return GetCitizenDeletionOrderResponse
     */
    getCitizenDeletionOrder(query: GetCitizenDeletionOrderRequest, cancelToken?: CancelToken): Promise<GetCitizenDeletionOrderResponse>;
    /**
     * @param query GetCitizenDeletionOrdersRequest
     * @return GetCitizenDeletionOrdersResponse
     */
    getCitizenDeletionOrders(query: GetCitizenDeletionOrdersRequest, cancelToken?: CancelToken): Promise<GetCitizenDeletionOrdersResponse>;
    /**
     * @param query GetCitizenForDeletionRequest
     * @return GetCitizenForDeletionResponse
     */
    getCitizenForDeletion(query: GetCitizenForDeletionRequest, cancelToken?: CancelToken): Promise<GetCitizenForDeletionResponse>;
}

export class AdminCitizenDeletionClient implements IAdminCitizenDeletionClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command ApproveCitizenDeletionOrderRequest
     * @return ApproveCitizenDeletionOrderResponse
     */
    approveCitizenDeletionOrder(command: ApproveCitizenDeletionOrderRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/citizendeletion/commands/approvecitizendeletionorder`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command ArchiveCitizenDeletionOrderRequest
     * @return ArchiveCitizenDeletionOrderResponse
     */
    archiveCitizenDeletionOrder(command: ArchiveCitizenDeletionOrderRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/citizendeletion/commands/archivecitizendeletionorder`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CancelCitizenDeletionOrderRequest
     * @return CancelCitizenDeletionOrderResponse
     */
    cancelCitizenDeletionOrder(command: CancelCitizenDeletionOrderRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/citizendeletion/commands/cancelcitizendeletionorder`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCitizenDeletionOrderRequest
     * @return CreateCitizenDeletionOrderResponse
     */
    createCitizenDeletionOrder(command: CreateCitizenDeletionOrderRequest, cancelToken?: CancelToken): Promise<CreateCitizenDeletionOrderResponse> {
        const $url = `${this.baseUrl}/api/admin/citizendeletion/commands/createcitizendeletionorder`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteCitizenRequest
     * @return DeleteCitizenResponse
     */
    deleteCitizen(command: DeleteCitizenRequest, cancelToken?: CancelToken): Promise<DeleteCitizenResponse> {
        const $url = `${this.baseUrl}/api/admin/citizendeletion/commands/deletecitizen`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DryRunDeleteCitizenRequest
     * @return DryRunDeleteCitizenResponse
     */
    dryRunDeleteCitizen(command: DryRunDeleteCitizenRequest, cancelToken?: CancelToken): Promise<DryRunDeleteCitizenResponse> {
        const $url = `${this.baseUrl}/api/admin/citizendeletion/commands/dryrundeletecitizen`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SendCitizenDeletionOrderToApprovalRequest
     * @return SendCitizenDeletionOrderToApprovalResponse
     */
    sendCitizenDeletionOrderToApproval(command: SendCitizenDeletionOrderToApprovalRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/citizendeletion/commands/sendcitizendeletionordertoapproval`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCitizenDeletionOrderRequest
     * @return UpdateCitizenDeletionOrderResponse
     */
    updateCitizenDeletionOrder(command: UpdateCitizenDeletionOrderRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/citizendeletion/commands/updatecitizendeletionorder`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenDeletionEligibilityRequest
     * @return GetCitizenDeletionEligibilityResponse
     */
    getCitizenDeletionEligibility(query: GetCitizenDeletionEligibilityRequest, cancelToken?: CancelToken): Promise<GetCitizenDeletionEligibilityResponse> {
        const $url = `${this.baseUrl}/api/admin/citizendeletion/queries/getcitizendeletioneligibility`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenDeletionOrderRequest
     * @return GetCitizenDeletionOrderResponse
     */
    getCitizenDeletionOrder(query: GetCitizenDeletionOrderRequest, cancelToken?: CancelToken): Promise<GetCitizenDeletionOrderResponse> {
        const $url = `${this.baseUrl}/api/admin/citizendeletion/queries/getcitizendeletionorder`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenDeletionOrdersRequest
     * @return GetCitizenDeletionOrdersResponse
     */
    getCitizenDeletionOrders(query: GetCitizenDeletionOrdersRequest, cancelToken?: CancelToken): Promise<GetCitizenDeletionOrdersResponse> {
        const $url = `${this.baseUrl}/api/admin/citizendeletion/queries/getcitizendeletionorders`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenForDeletionRequest
     * @return GetCitizenForDeletionResponse
     */
    getCitizenForDeletion(query: GetCitizenForDeletionRequest, cancelToken?: CancelToken): Promise<GetCitizenForDeletionResponse> {
        const $url = `${this.baseUrl}/api/admin/citizendeletion/queries/getcitizenfordeletion`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminAuditLogClient {
    /**
     * @param command GenerateReportRequest
     * @return GenerateReportResponse
     */
    generateReport(command: GenerateReportRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @return GetAreasResponse
     */
    getAreas(cancelToken?: CancelToken): Promise<GetAreasResponse>;
    /**
     * @param query GetAuditLogsRequest
     * @return GetAuditLogsResponse
     */
    getAuditLogs(query: GetAuditLogsRequest, cancelToken?: CancelToken): Promise<GetAuditLogsResponse>;
    /**
     * @return GetJustificationWhitelistResponse
     */
    getJustificationWhitelist(cancelToken?: CancelToken): Promise<GetJustificationWhitelistResponse>;
    /**
     * @return GetOperationsResponse
     */
    getOperations(cancelToken?: CancelToken): Promise<GetOperationsResponse>;
    /**
     * @return GetOrganizationalUnitsResponse
     */
    getOrganizationalUnits(cancelToken?: CancelToken): Promise<GetOrganizationalUnitsResponse>;
    /**
     * @param query GetReportRequest
     * @return FileResponse
     */
    getReport(query: GetReportRequest, cancelToken?: CancelToken): Promise<FileResponse>;
}

export class AdminAuditLogClient implements IAdminAuditLogClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command GenerateReportRequest
     * @return GenerateReportResponse
     */
    generateReport(command: GenerateReportRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/auditlog/commands/generatereport`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAreasResponse
     */
    getAreas(cancelToken?: CancelToken): Promise<GetAreasResponse> {
        const $url = `${this.baseUrl}/api/admin/auditlog/queries/getareas`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAuditLogsRequest
     * @return GetAuditLogsResponse
     */
    getAuditLogs(query: GetAuditLogsRequest, cancelToken?: CancelToken): Promise<GetAuditLogsResponse> {
        const $url = `${this.baseUrl}/api/admin/auditlog/queries/getauditlogs`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetJustificationWhitelistResponse
     */
    getJustificationWhitelist(cancelToken?: CancelToken): Promise<GetJustificationWhitelistResponse> {
        const $url = `${this.baseUrl}/api/admin/auditlog/queries/getjustificationwhitelist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOperationsResponse
     */
    getOperations(cancelToken?: CancelToken): Promise<GetOperationsResponse> {
        const $url = `${this.baseUrl}/api/admin/auditlog/queries/getoperations`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOrganizationalUnitsResponse
     */
    getOrganizationalUnits(cancelToken?: CancelToken): Promise<GetOrganizationalUnitsResponse> {
        const $url = `${this.baseUrl}/api/admin/auditlog/queries/getorganizationalunits`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetReportRequest
     * @return FileResponse
     */
    getReport(query: GetReportRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/admin/auditlog/queries/getreport`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }
}

export interface IAdminAdminUIVisitationTeamsClient {
    /**
     * @param command CreateVisitationTeamRequest
     * @return CreateVisitationTeamResponse
     */
    createVisitationTeam(command: CreateVisitationTeamRequest, cancelToken?: CancelToken): Promise<CreateVisitationTeamResponse>;
    /**
     * @param command UpdateVisitationTeamRequest
     * @return UpdateVisitationTeamResponse
     */
    updateVisitationTeam(command: UpdateVisitationTeamRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetVisitationTeamDetailsRequest
     * @return GetVisitationTeamDetailsResponse
     */
    getVisitationTeamDetails(query: GetVisitationTeamDetailsRequest, cancelToken?: CancelToken): Promise<GetVisitationTeamDetailsResponse>;
    /**
     * @return GetVisitationTeamsInitialDataResponse
     */
    getVisitationTeamsInitialData(cancelToken?: CancelToken): Promise<GetVisitationTeamsInitialDataResponse>;
    /**
     * @return GetVisitationTeamsListResponse
     */
    getVisitationTeamsList(cancelToken?: CancelToken): Promise<GetVisitationTeamsListResponse>;
}

export class AdminAdminUIVisitationTeamsClient implements IAdminAdminUIVisitationTeamsClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateVisitationTeamRequest
     * @return CreateVisitationTeamResponse
     */
    createVisitationTeam(command: CreateVisitationTeamRequest, cancelToken?: CancelToken): Promise<CreateVisitationTeamResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/visitationteams/commands/createvisitationteam`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateVisitationTeamRequest
     * @return UpdateVisitationTeamResponse
     */
    updateVisitationTeam(command: UpdateVisitationTeamRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/visitationteams/commands/updatevisitationteam`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetVisitationTeamDetailsRequest
     * @return GetVisitationTeamDetailsResponse
     */
    getVisitationTeamDetails(query: GetVisitationTeamDetailsRequest, cancelToken?: CancelToken): Promise<GetVisitationTeamDetailsResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/visitationteams/queries/getvisitationteamdetails`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetVisitationTeamsInitialDataResponse
     */
    getVisitationTeamsInitialData(cancelToken?: CancelToken): Promise<GetVisitationTeamsInitialDataResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/visitationteams/queries/getvisitationteamsinitialdata`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetVisitationTeamsListResponse
     */
    getVisitationTeamsList(cancelToken?: CancelToken): Promise<GetVisitationTeamsListResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/visitationteams/queries/getvisitationteamslist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminAdminUIUsersClient {
    /**
     * @param command ActivateUsersRequest
     * @return ActivateUsersResponse
     */
    activateUsers(command: ActivateUsersRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateUserRequest
     * @return CreateUserResponse
     */
    createUser(command: CreateUserRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeactivateUsersRequest
     * @return DeactivateUsersResponse
     */
    deactivateUsers(command: DeactivateUsersRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command EditUserRequest
     * @return EditUserResponse
     */
    editUser(command: EditUserRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SetUserAtaTimeRequest
     * @return SetUserAtaTimeResponse
     */
    setUserAtaTime(command: SetUserAtaTimeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SetUserCprRequest
     * @return SetUserCprResponse
     */
    setUserCpr(command: SetUserCprRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetEditableUserRequest
     * @return GetEditableUserResponse
     */
    getEditableUser(query: GetEditableUserRequest, cancelToken?: CancelToken): Promise<GetEditableUserResponse>;
    /**
     * @return GetExternalOperatorCompaniesForEditUserResponse
     */
    getExternalOperatorCompaniesForEditUser(cancelToken?: CancelToken): Promise<GetExternalOperatorCompaniesForEditUserResponse>;
    /**
     * @param query GetUserAtaTimeRequest
     * @return GetUserAtaTimeResponse
     */
    getUserAtaTime(query: GetUserAtaTimeRequest, cancelToken?: CancelToken): Promise<GetUserAtaTimeResponse>;
    /**
     * @return FileResponse
     */
    getUserReport(cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query ListUsersRequest
     * @return ListUsersResponse
     */
    listUsers(query: ListUsersRequest, cancelToken?: CancelToken): Promise<ListUsersResponse>;
}

export class AdminAdminUIUsersClient implements IAdminAdminUIUsersClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command ActivateUsersRequest
     * @return ActivateUsersResponse
     */
    activateUsers(command: ActivateUsersRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/users/commands/activateusers`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateUserRequest
     * @return CreateUserResponse
     */
    createUser(command: CreateUserRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/users/commands/createuser`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeactivateUsersRequest
     * @return DeactivateUsersResponse
     */
    deactivateUsers(command: DeactivateUsersRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/users/commands/deactivateusers`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command EditUserRequest
     * @return EditUserResponse
     */
    editUser(command: EditUserRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/users/commands/edituser`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetUserAtaTimeRequest
     * @return SetUserAtaTimeResponse
     */
    setUserAtaTime(command: SetUserAtaTimeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/users/commands/setuseratatime`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetUserCprRequest
     * @return SetUserCprResponse
     */
    setUserCpr(command: SetUserCprRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/users/commands/setusercpr`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEditableUserRequest
     * @return GetEditableUserResponse
     */
    getEditableUser(query: GetEditableUserRequest, cancelToken?: CancelToken): Promise<GetEditableUserResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/users/queries/geteditableuser`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetExternalOperatorCompaniesForEditUserResponse
     */
    getExternalOperatorCompaniesForEditUser(cancelToken?: CancelToken): Promise<GetExternalOperatorCompaniesForEditUserResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/users/queries/getexternaloperatorcompaniesforedituser`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUserAtaTimeRequest
     * @return GetUserAtaTimeResponse
     */
    getUserAtaTime(query: GetUserAtaTimeRequest, cancelToken?: CancelToken): Promise<GetUserAtaTimeResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/users/queries/getuseratatime`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return FileResponse
     */
    getUserReport(cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/users/queries/getuserreport`;

        const options_: AxiosRequestConfig = {
            data: {},
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query ListUsersRequest
     * @return ListUsersResponse
     */
    listUsers(query: ListUsersRequest, cancelToken?: CancelToken): Promise<ListUsersResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/users/queries/listusers`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminAdminUIUserProfilesClient {
    /**
     * @param command CreateUserProfileRequest
     * @return CreateUserProfileResponse
     */
    createUserProfile(command: CreateUserProfileRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteUserProfileRequest
     * @return DeleteUserProfileResponse
     */
    deleteUserProfile(command: DeleteUserProfileRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateUserProfileRequest
     * @return UpdateUserProfileResponse
     */
    updateUserProfile(command: UpdateUserProfileRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @return GetSelectableRolesResponse
     */
    getSelectableRoles(cancelToken?: CancelToken): Promise<GetSelectableRolesResponse>;
    /**
     * @return GetUserProfilesResponse
     */
    getUserProfiles(cancelToken?: CancelToken): Promise<GetUserProfilesResponse>;
}

export class AdminAdminUIUserProfilesClient implements IAdminAdminUIUserProfilesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateUserProfileRequest
     * @return CreateUserProfileResponse
     */
    createUserProfile(command: CreateUserProfileRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/userprofiles/commands/createuserprofile`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteUserProfileRequest
     * @return DeleteUserProfileResponse
     */
    deleteUserProfile(command: DeleteUserProfileRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/userprofiles/commands/deleteuserprofile`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateUserProfileRequest
     * @return UpdateUserProfileResponse
     */
    updateUserProfile(command: UpdateUserProfileRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/userprofiles/commands/updateuserprofile`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSelectableRolesResponse
     */
    getSelectableRoles(cancelToken?: CancelToken): Promise<GetSelectableRolesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/userprofiles/queries/getselectableroles`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetUserProfilesResponse
     */
    getUserProfiles(cancelToken?: CancelToken): Promise<GetUserProfilesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/userprofiles/queries/getuserprofiles`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminAdminUISurveyClient {
    /**
     * @param command CreateQuestionnaireRequest
     * @return CreateQuestionnaireResponse
     */
    createQuestionnaire(command: CreateQuestionnaireRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeactivateQuestionnaireRequest
     * @return DeactivateQuestionnaireResponse
     */
    deactivateQuestionnaire(command: DeactivateQuestionnaireRequest, cancelToken?: CancelToken): Promise<DeactivateQuestionnaireResponse>;
    /**
     * @param command UpdateQuestionnaireRequest
     * @return UpdateQuestionnaireResponse
     */
    updateQuestionnaire(command: UpdateQuestionnaireRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetQuestionnaireDetailsRequest
     * @return GetQuestionnaireDetailsResponse
     */
    getQuestionnaireDetails(query: GetQuestionnaireDetailsRequest, cancelToken?: CancelToken): Promise<GetQuestionnaireDetailsResponse>;
    /**
     * @return GetQuestionnaireInitialDataResponse
     */
    getQuestionnaireInitialData(cancelToken?: CancelToken): Promise<GetQuestionnaireInitialDataResponse>;
    /**
     * @param query GetQuestionnaireRepliesAsExcelRequest
     * @return FileResponse
     */
    getQuestionnaireRepliesAsExcel(query: GetQuestionnaireRepliesAsExcelRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return GetQuestionnairesResponse
     */
    getQuestionnaires(cancelToken?: CancelToken): Promise<GetQuestionnairesResponse>;
}

export class AdminAdminUISurveyClient implements IAdminAdminUISurveyClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateQuestionnaireRequest
     * @return CreateQuestionnaireResponse
     */
    createQuestionnaire(command: CreateQuestionnaireRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/survey/commands/createquestionnaire`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeactivateQuestionnaireRequest
     * @return DeactivateQuestionnaireResponse
     */
    deactivateQuestionnaire(command: DeactivateQuestionnaireRequest, cancelToken?: CancelToken): Promise<DeactivateQuestionnaireResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/survey/commands/deactivatequestionnaire`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateQuestionnaireRequest
     * @return UpdateQuestionnaireResponse
     */
    updateQuestionnaire(command: UpdateQuestionnaireRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/survey/commands/updatequestionnaire`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetQuestionnaireDetailsRequest
     * @return GetQuestionnaireDetailsResponse
     */
    getQuestionnaireDetails(query: GetQuestionnaireDetailsRequest, cancelToken?: CancelToken): Promise<GetQuestionnaireDetailsResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/survey/queries/getquestionnairedetails`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetQuestionnaireInitialDataResponse
     */
    getQuestionnaireInitialData(cancelToken?: CancelToken): Promise<GetQuestionnaireInitialDataResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/survey/queries/getquestionnaireinitialdata`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetQuestionnaireRepliesAsExcelRequest
     * @return FileResponse
     */
    getQuestionnaireRepliesAsExcel(query: GetQuestionnaireRepliesAsExcelRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/survey/queries/getquestionnairerepliesasexcel`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @return GetQuestionnairesResponse
     */
    getQuestionnaires(cancelToken?: CancelToken): Promise<GetQuestionnairesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/survey/queries/getquestionnaires`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminAdminUISubJobcentersClient {
    /**
     * @param command SaveSubJobcenterClosedDaysRequest
     * @return SaveSubJobcenterClosedDaysResponse
     */
    saveSubJobcenterClosedDays(command: SaveSubJobcenterClosedDaysRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @return GetSubJobcenterCodeListItemsResponse
     */
    getSelectableSubJobcenterCodeListItems(cancelToken?: CancelToken): Promise<GetSubJobcenterCodeListItemsResponse>;
    /**
     * @param query GetSubJobcenterRequest
     * @return GetSubJobcenterResponse
     */
    getSubJobcenter(query: GetSubJobcenterRequest, cancelToken?: CancelToken): Promise<GetSubJobcenterResponse>;
    /**
     * @return GetSubJobcentersResponse
     */
    getSubJobcenters(cancelToken?: CancelToken): Promise<GetSubJobcentersResponse>;
    /**
     * @param query CreateSubJobcenterRequest
     * @return CreateSubJobcenterResponse
     */
    createSubJobcenter(query: CreateSubJobcenterRequest, cancelToken?: CancelToken): Promise<CreateSubJobcenterResponse>;
    /**
     * @param query UpdateSubJobcenterRequest
     * @return UpdateSubJobcenterResponse
     */
    updateSubJobcenter(query: UpdateSubJobcenterRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query UpdateSubJobcenterStateRequest
     * @return UpdateSubJobcenterStateResponse
     */
    updateSubJobcenterState(query: UpdateSubJobcenterStateRequest, cancelToken?: CancelToken): Promise<any>;
}

export class AdminAdminUISubJobcentersClient implements IAdminAdminUISubJobcentersClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command SaveSubJobcenterClosedDaysRequest
     * @return SaveSubJobcenterClosedDaysResponse
     */
    saveSubJobcenterClosedDays(command: SaveSubJobcenterClosedDaysRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/subjobcenters/commands/savesubjobcentercloseddays`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSubJobcenterCodeListItemsResponse
     */
    getSelectableSubJobcenterCodeListItems(cancelToken?: CancelToken): Promise<GetSubJobcenterCodeListItemsResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/subjobcenters/queries/getselectablesubjobcentercodelistitems`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSubJobcenterRequest
     * @return GetSubJobcenterResponse
     */
    getSubJobcenter(query: GetSubJobcenterRequest, cancelToken?: CancelToken): Promise<GetSubJobcenterResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/subjobcenters/queries/getsubjobcenter`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSubJobcentersResponse
     */
    getSubJobcenters(cancelToken?: CancelToken): Promise<GetSubJobcentersResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/subjobcenters/queries/getsubjobcenters`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query CreateSubJobcenterRequest
     * @return CreateSubJobcenterResponse
     */
    createSubJobcenter(query: CreateSubJobcenterRequest, cancelToken?: CancelToken): Promise<CreateSubJobcenterResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/subjobcenters/queries/createsubjobcenter`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query UpdateSubJobcenterRequest
     * @return UpdateSubJobcenterResponse
     */
    updateSubJobcenter(query: UpdateSubJobcenterRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/subjobcenters/queries/updatesubjobcenter`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query UpdateSubJobcenterStateRequest
     * @return UpdateSubJobcenterStateResponse
     */
    updateSubJobcenterState(query: UpdateSubJobcenterStateRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/subjobcenters/queries/updatesubjobcenterstate`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminAdminUIObservationTypesClient {
    /**
     * @param command CreateObservationTypeRequest
     * @return CreateObservationTypeResponse
     */
    createObservationType(command: CreateObservationTypeRequest, cancelToken?: CancelToken): Promise<CreateObservationTypeResponse>;
    /**
     * @param command UpdateObservationTypeRequest
     * @return UpdateObservationTypeResponse
     */
    updateObservationType(command: UpdateObservationTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @return GetObservationTypesResponse
     */
    getObservationTypes(cancelToken?: CancelToken): Promise<GetObservationTypesResponse>;
}

export class AdminAdminUIObservationTypesClient implements IAdminAdminUIObservationTypesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateObservationTypeRequest
     * @return CreateObservationTypeResponse
     */
    createObservationType(command: CreateObservationTypeRequest, cancelToken?: CancelToken): Promise<CreateObservationTypeResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/observationtypes/commands/createobservationtype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateObservationTypeRequest
     * @return UpdateObservationTypeResponse
     */
    updateObservationType(command: UpdateObservationTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/observationtypes/commands/updateobservationtype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetObservationTypesResponse
     */
    getObservationTypes(cancelToken?: CancelToken): Promise<GetObservationTypesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/observationtypes/queries/getobservationtypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminAdminUIMethodTypesClient {
    /**
     * @param command CreateMethodTypeRequest
     * @return CreateMethodTypeResponse
     */
    createMethodType(command: CreateMethodTypeRequest, cancelToken?: CancelToken): Promise<CreateMethodTypeResponse>;
    /**
     * @param command UpdateMethodTypeRequest
     * @return UpdateMethodTypeResponse
     */
    updateMethodType(command: UpdateMethodTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @return GetMethodTypesResponse
     */
    getMethodTypes(cancelToken?: CancelToken): Promise<GetMethodTypesResponse>;
}

export class AdminAdminUIMethodTypesClient implements IAdminAdminUIMethodTypesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateMethodTypeRequest
     * @return CreateMethodTypeResponse
     */
    createMethodType(command: CreateMethodTypeRequest, cancelToken?: CancelToken): Promise<CreateMethodTypeResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/methodtypes/commands/createmethodtype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateMethodTypeRequest
     * @return UpdateMethodTypeResponse
     */
    updateMethodType(command: UpdateMethodTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/methodtypes/commands/updatemethodtype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetMethodTypesResponse
     */
    getMethodTypes(cancelToken?: CancelToken): Promise<GetMethodTypesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/methodtypes/queries/getmethodtypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminAdminUIJournalNoteContentTypesClient {
    /**
     * @param command CreateJournalNoteContentTypeRequest
     * @return CreateJournalNoteContentTypeResponse
     */
    createJournalNoteContentTypeV3(command: CreateJournalNoteContentTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateJournalNoteContentTypeRequest
     * @return UpdateJournalNoteContentTypeResponse
     */
    updateJournalNoteContentTypeV3(command: UpdateJournalNoteContentTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @return GetJournalNoteContentTypesResponse
     */
    getJournalNoteContentTypesV3(cancelToken?: CancelToken): Promise<GetJournalNoteContentTypesResponse>;
}

export class AdminAdminUIJournalNoteContentTypesClient implements IAdminAdminUIJournalNoteContentTypesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateJournalNoteContentTypeRequest
     * @return CreateJournalNoteContentTypeResponse
     */
    createJournalNoteContentTypeV3(command: CreateJournalNoteContentTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/journalnotecontenttypes/commands/createjournalnotecontenttypev3`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateJournalNoteContentTypeRequest
     * @return UpdateJournalNoteContentTypeResponse
     */
    updateJournalNoteContentTypeV3(command: UpdateJournalNoteContentTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/journalnotecontenttypes/commands/updatejournalnotecontenttypev3`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetJournalNoteContentTypesResponse
     */
    getJournalNoteContentTypesV3(cancelToken?: CancelToken): Promise<GetJournalNoteContentTypesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/journalnotecontenttypes/queries/getjournalnotecontenttypesv3`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminAdminUIInterviewTypesClient {
    /**
     * @param command CreateInterviewTypeRequest
     * @return CreateInterviewTypeResponse
     */
    createInterviewType(command: CreateInterviewTypeRequest, cancelToken?: CancelToken): Promise<CreateInterviewTypeResponse>;
    /**
     * @param command UpdateInterviewTypeRequest
     * @return UpdateInterviewTypeResponse
     */
    updateInterviewType(command: UpdateInterviewTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @return GetInterviewTypesResponse
     */
    getInterviewTypes(cancelToken?: CancelToken): Promise<GetInterviewTypesResponse>;
}

export class AdminAdminUIInterviewTypesClient implements IAdminAdminUIInterviewTypesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateInterviewTypeRequest
     * @return CreateInterviewTypeResponse
     */
    createInterviewType(command: CreateInterviewTypeRequest, cancelToken?: CancelToken): Promise<CreateInterviewTypeResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/interviewtypes/commands/createinterviewtype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateInterviewTypeRequest
     * @return UpdateInterviewTypeResponse
     */
    updateInterviewType(command: UpdateInterviewTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/interviewtypes/commands/updateinterviewtype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetInterviewTypesResponse
     */
    getInterviewTypes(cancelToken?: CancelToken): Promise<GetInterviewTypesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/interviewtypes/queries/getinterviewtypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminAdminUIGrantTypesClient {
    /**
     * @param command CreateGrantTypeRequest
     * @return CreateGrantTypeResponse
     */
    createGrantType(command: CreateGrantTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateGrantTypeRequest
     * @return UpdateGrantTypeResponse
     */
    updateGrantType(command: UpdateGrantTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query GetGrantTypeDetailsRequest
     * @return GetGrantTypeDetailsResponse
     */
    getGrantTypeDetails(query: GetGrantTypeDetailsRequest, cancelToken?: CancelToken): Promise<GetGrantTypeDetailsResponse>;
    /**
     * @param query GetGrantTypeOfferDetailsRequest
     * @return GetGrantTypeOfferDetailsResponse
     */
    getGrantTypeOfferDetails(query: GetGrantTypeOfferDetailsRequest, cancelToken?: CancelToken): Promise<GetGrantTypeOfferDetailsResponse>;
    /**
     * @return GetGrantTypesInitialDataResponse
     */
    getGrantTypesInitialData(cancelToken?: CancelToken): Promise<GetGrantTypesInitialDataResponse>;
    /**
     * @return GetGrantTypesListResponse
     */
    getGrantTypesList(cancelToken?: CancelToken): Promise<GetGrantTypesListResponse>;
    /**
     * @return GetOffersListResponse
     */
    getOffersList(cancelToken?: CancelToken): Promise<GetOffersListResponse>;
}

export class AdminAdminUIGrantTypesClient implements IAdminAdminUIGrantTypesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateGrantTypeRequest
     * @return CreateGrantTypeResponse
     */
    createGrantType(command: CreateGrantTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/granttypes/commands/creategranttype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateGrantTypeRequest
     * @return UpdateGrantTypeResponse
     */
    updateGrantType(command: UpdateGrantTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/granttypes/commands/updategranttype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetGrantTypeDetailsRequest
     * @return GetGrantTypeDetailsResponse
     */
    getGrantTypeDetails(query: GetGrantTypeDetailsRequest, cancelToken?: CancelToken): Promise<GetGrantTypeDetailsResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/granttypes/queries/getgranttypedetails`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetGrantTypeOfferDetailsRequest
     * @return GetGrantTypeOfferDetailsResponse
     */
    getGrantTypeOfferDetails(query: GetGrantTypeOfferDetailsRequest, cancelToken?: CancelToken): Promise<GetGrantTypeOfferDetailsResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/granttypes/queries/getgranttypeofferdetails`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetGrantTypesInitialDataResponse
     */
    getGrantTypesInitialData(cancelToken?: CancelToken): Promise<GetGrantTypesInitialDataResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/granttypes/queries/getgranttypesinitialdata`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetGrantTypesListResponse
     */
    getGrantTypesList(cancelToken?: CancelToken): Promise<GetGrantTypesListResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/granttypes/queries/getgranttypeslist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOffersListResponse
     */
    getOffersList(cancelToken?: CancelToken): Promise<GetOffersListResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/granttypes/queries/getofferslist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminAdminUICoPaymentClient {
    /**
     * @param command AdjustReceivableRequest
     * @return AdjustReceivableResponse
     */
    adjustReceivable(command: AdjustReceivableRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateCoPaymentDebitorRunRequest
     * @return CreateCoPaymentDebitorRunResponse
     */
    createCoPaymentDebitorRun(command: CreateCoPaymentDebitorRunRequest, cancelToken?: CancelToken): Promise<CreateCoPaymentDebitorRunResponse>;
    /**
     * @param command CreateFinanceTestReceiptRequest
     * @return CreateFinanceTestReceiptResponse
     */
    createFinanceTestReceipt(command: CreateFinanceTestReceiptRequest, cancelToken?: CancelToken): Promise<CreateFinanceTestReceiptResponse>;
    /**
     * @param command DeleteCoPaymentGroupFromDebitorRunRequest
     * @return DeleteCoPaymentGroupFromDebitorRunResponse
     */
    deleteCoPaymentGroupFromDebitorRun(command: DeleteCoPaymentGroupFromDebitorRunRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteReceivablesRequest
     * @return DeleteReceivablesResponse
     */
    deleteReceivables(command: DeleteReceivablesRequest, cancelToken?: CancelToken): Promise<DeleteReceivablesResponse>;
    /**
     * @param command DispatchCoPaymentDebitorRunRequest
     * @return DispatchCoPaymentDebitorRunResponse
     */
    dispatchCoPaymentDebitorRun(command: DispatchCoPaymentDebitorRunRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DispatchReceivablesRequest
     * @return DispatchReceivablesResponse
     */
    dispatchReceivables(command: DispatchReceivablesRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command RedeliverReceivablesToFinanceRequest
     * @return RedeliverReceivablesToFinanceResponse
     */
    redeliverReceivablesToFinance(command: RedeliverReceivablesToFinanceRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command RetryCoPaymentDebitorRunDispatchRequest
     * @return RetryCoPaymentDebitorRunDispatchResponse
     */
    retryCoPaymentDebitorRunDispatch(command: RetryCoPaymentDebitorRunDispatchRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command SetCoPaymentGroupProcessingInstructionRequest
     * @return SetCoPaymentGroupProcessingInstructionResponse
     */
    setCoPaymentGroupProcessingInstruction(command: SetCoPaymentGroupProcessingInstructionRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @return TriggerFinanceReceiptPollResponse
     */
    triggerFinanceReceiptPoll(cancelToken?: CancelToken): Promise<TriggerFinanceReceiptPollResponse>;
    /**
     * @return GetActiveCoPaymentCitizensResponse
     */
    getActiveCoPaymentCitizens(cancelToken?: CancelToken): Promise<GetActiveCoPaymentCitizensResponse>;
    /**
     * @param query GetAdjustmentDetailsRequest
     * @return GetAdjustmentDetailsResponse
     */
    getAdjustmentDetails(query: GetAdjustmentDetailsRequest, cancelToken?: CancelToken): Promise<GetAdjustmentDetailsResponse>;
    /**
     * @param query GetCoPaymentDebitorRunRequest
     * @return GetCoPaymentDebitorRunResponse
     */
    getCoPaymentDebitorRun(query: GetCoPaymentDebitorRunRequest, cancelToken?: CancelToken): Promise<GetCoPaymentDebitorRunResponse>;
    /**
     * @return GetCoPaymentDebitorRunsResponse
     */
    getCoPaymentDebitorRuns(cancelToken?: CancelToken): Promise<GetCoPaymentDebitorRunsResponse>;
    /**
     * @return GetCoPaymentDispatchOverviewResponse
     */
    getCoPaymentDispatchOverview(cancelToken?: CancelToken): Promise<GetCoPaymentDispatchOverviewResponse>;
    /**
     * @param query GetCoPaymentReceivablesByDispatchStateRequest
     * @return GetCoPaymentReceivablesByDispatchStateResponse
     */
    getCoPaymentReceivablesByDispatchState(query: GetCoPaymentReceivablesByDispatchStateRequest, cancelToken?: CancelToken): Promise<GetCoPaymentReceivablesByDispatchStateResponse>;
    /**
     * @return GetCoPaymentsForOverviewResponse
     */
    getCoPaymentsForOverview(cancelToken?: CancelToken): Promise<GetCoPaymentsForOverviewResponse>;
    /**
     * @param query GetDebitorRegistrationContentRequest
     * @return GetDebitorRegistrationContentResponse
     */
    getDebitorRegistrationContent(query: GetDebitorRegistrationContentRequest, cancelToken?: CancelToken): Promise<GetDebitorRegistrationContentResponse>;
    /**
     * @param query GetFinanceDeliveryContentRequest
     * @return GetFinanceDeliveryContentResponse
     */
    getFinanceDeliveryContent(query: GetFinanceDeliveryContentRequest, cancelToken?: CancelToken): Promise<GetFinanceDeliveryContentResponse>;
    /**
     * @param query GetFinanceDeliveryDataFileRequest
     * @return GetFinanceDeliveryDataFileResponse
     */
    getFinanceDeliveryDataFile(query: GetFinanceDeliveryDataFileRequest, cancelToken?: CancelToken): Promise<GetFinanceDeliveryDataFileResponse>;
    /**
     * @param query GetReceivableDetailsRequest
     * @return GetReceivableDetailsResponse
     */
    getReceivableDetails(query: GetReceivableDetailsRequest, cancelToken?: CancelToken): Promise<GetReceivableDetailsResponse>;
    /**
     * @param query GetReceivableDispatchAttemptsRequest
     * @return GetReceivableDispatchAttemptsResponse
     */
    getReceivableDispatchAttempts(query: GetReceivableDispatchAttemptsRequest, cancelToken?: CancelToken): Promise<GetReceivableDispatchAttemptsResponse>;
}

export class AdminAdminUICoPaymentClient implements IAdminAdminUICoPaymentClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command AdjustReceivableRequest
     * @return AdjustReceivableResponse
     */
    adjustReceivable(command: AdjustReceivableRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/commands/adjustreceivable`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCoPaymentDebitorRunRequest
     * @return CreateCoPaymentDebitorRunResponse
     */
    createCoPaymentDebitorRun(command: CreateCoPaymentDebitorRunRequest, cancelToken?: CancelToken): Promise<CreateCoPaymentDebitorRunResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/commands/createcopaymentdebitorrun`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateFinanceTestReceiptRequest
     * @return CreateFinanceTestReceiptResponse
     */
    createFinanceTestReceipt(command: CreateFinanceTestReceiptRequest, cancelToken?: CancelToken): Promise<CreateFinanceTestReceiptResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/commands/createfinancetestreceipt`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteCoPaymentGroupFromDebitorRunRequest
     * @return DeleteCoPaymentGroupFromDebitorRunResponse
     */
    deleteCoPaymentGroupFromDebitorRun(command: DeleteCoPaymentGroupFromDebitorRunRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/commands/deletecopaymentgroupfromdebitorrun`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteReceivablesRequest
     * @return DeleteReceivablesResponse
     */
    deleteReceivables(command: DeleteReceivablesRequest, cancelToken?: CancelToken): Promise<DeleteReceivablesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/commands/deletereceivables`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DispatchCoPaymentDebitorRunRequest
     * @return DispatchCoPaymentDebitorRunResponse
     */
    dispatchCoPaymentDebitorRun(command: DispatchCoPaymentDebitorRunRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/commands/dispatchcopaymentdebitorrun`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DispatchReceivablesRequest
     * @return DispatchReceivablesResponse
     */
    dispatchReceivables(command: DispatchReceivablesRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/commands/dispatchreceivables`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RedeliverReceivablesToFinanceRequest
     * @return RedeliverReceivablesToFinanceResponse
     */
    redeliverReceivablesToFinance(command: RedeliverReceivablesToFinanceRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/commands/redeliverreceivablestofinance`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command RetryCoPaymentDebitorRunDispatchRequest
     * @return RetryCoPaymentDebitorRunDispatchResponse
     */
    retryCoPaymentDebitorRunDispatch(command: RetryCoPaymentDebitorRunDispatchRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/commands/retrycopaymentdebitorrundispatch`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SetCoPaymentGroupProcessingInstructionRequest
     * @return SetCoPaymentGroupProcessingInstructionResponse
     */
    setCoPaymentGroupProcessingInstruction(command: SetCoPaymentGroupProcessingInstructionRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/commands/setcopaymentgroupprocessinginstruction`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return TriggerFinanceReceiptPollResponse
     */
    triggerFinanceReceiptPoll(cancelToken?: CancelToken): Promise<TriggerFinanceReceiptPollResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/commands/triggerfinancereceiptpoll`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetActiveCoPaymentCitizensResponse
     */
    getActiveCoPaymentCitizens(cancelToken?: CancelToken): Promise<GetActiveCoPaymentCitizensResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/queries/getactivecopaymentcitizens`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAdjustmentDetailsRequest
     * @return GetAdjustmentDetailsResponse
     */
    getAdjustmentDetails(query: GetAdjustmentDetailsRequest, cancelToken?: CancelToken): Promise<GetAdjustmentDetailsResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/queries/getadjustmentdetails`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCoPaymentDebitorRunRequest
     * @return GetCoPaymentDebitorRunResponse
     */
    getCoPaymentDebitorRun(query: GetCoPaymentDebitorRunRequest, cancelToken?: CancelToken): Promise<GetCoPaymentDebitorRunResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/queries/getcopaymentdebitorrun`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCoPaymentDebitorRunsResponse
     */
    getCoPaymentDebitorRuns(cancelToken?: CancelToken): Promise<GetCoPaymentDebitorRunsResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/queries/getcopaymentdebitorruns`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCoPaymentDispatchOverviewResponse
     */
    getCoPaymentDispatchOverview(cancelToken?: CancelToken): Promise<GetCoPaymentDispatchOverviewResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/queries/getcopaymentdispatchoverview`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCoPaymentReceivablesByDispatchStateRequest
     * @return GetCoPaymentReceivablesByDispatchStateResponse
     */
    getCoPaymentReceivablesByDispatchState(query: GetCoPaymentReceivablesByDispatchStateRequest, cancelToken?: CancelToken): Promise<GetCoPaymentReceivablesByDispatchStateResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/queries/getcopaymentreceivablesbydispatchstate`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCoPaymentsForOverviewResponse
     */
    getCoPaymentsForOverview(cancelToken?: CancelToken): Promise<GetCoPaymentsForOverviewResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/queries/getcopaymentsforoverview`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDebitorRegistrationContentRequest
     * @return GetDebitorRegistrationContentResponse
     */
    getDebitorRegistrationContent(query: GetDebitorRegistrationContentRequest, cancelToken?: CancelToken): Promise<GetDebitorRegistrationContentResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/queries/getdebitorregistrationcontent`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetFinanceDeliveryContentRequest
     * @return GetFinanceDeliveryContentResponse
     */
    getFinanceDeliveryContent(query: GetFinanceDeliveryContentRequest, cancelToken?: CancelToken): Promise<GetFinanceDeliveryContentResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/queries/getfinancedeliverycontent`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetFinanceDeliveryDataFileRequest
     * @return GetFinanceDeliveryDataFileResponse
     */
    getFinanceDeliveryDataFile(query: GetFinanceDeliveryDataFileRequest, cancelToken?: CancelToken): Promise<GetFinanceDeliveryDataFileResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/queries/getfinancedeliverydatafile`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetReceivableDetailsRequest
     * @return GetReceivableDetailsResponse
     */
    getReceivableDetails(query: GetReceivableDetailsRequest, cancelToken?: CancelToken): Promise<GetReceivableDetailsResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/queries/getreceivabledetails`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetReceivableDispatchAttemptsRequest
     * @return GetReceivableDispatchAttemptsResponse
     */
    getReceivableDispatchAttempts(query: GetReceivableDispatchAttemptsRequest, cancelToken?: CancelToken): Promise<GetReceivableDispatchAttemptsResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/copayment/queries/getreceivabledispatchattempts`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminAdminUIClient {
    /**
     * @param command ChangeAiStandardQuestionsStatusRequest
     * @return ChangeAiStandardQuestionsStatusResponse
     */
    changeAiStandardQuestionsStatus(command: ChangeAiStandardQuestionsStatusRequest, cancelToken?: CancelToken): Promise<ChangeAiStandardQuestionsStatusResponse>;
    /**
     * @param command CopyAiStandardQuestionsAsDraftsRequest
     * @return CopyAiStandardQuestionsAsDraftsResponse
     */
    copyAiStandardQuestionsAsDrafts(command: CopyAiStandardQuestionsAsDraftsRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateAccountGroupsForAdminUiRequest
     * @return CreateAccountGroupsForAdminUiResponse
     */
    createAccountGroup(command: CreateAccountGroupsForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateAccountGroupsForAdminUiResponse>;
    /**
     * @param command CreateAccountInteractionPurposesForAdminUiRequest
     * @return CreateAccountInteractionPurposesForAdminUiResponse
     */
    createAccountInteractionPurpose(command: CreateAccountInteractionPurposesForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateAccountInteractionPurposesForAdminUiResponse>;
    /**
     * @param command CreateAccountInteractionResultsForAdminUiRequest
     * @return CreateAccountInteractionResultsForAdminUiResponse
     */
    createAccountInteractionResult(command: CreateAccountInteractionResultsForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateAccountInteractionResultsForAdminUiResponse>;
    /**
     * @param command CreateAccountSpecialCircumstancesTypesForAdminUiRequest
     * @return CreateAccountSpecialCircumstancesTypesForAdminUiResponse
     */
    createAccountSpecialCircumstancesType(command: CreateAccountSpecialCircumstancesTypesForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateAccountSpecialCircumstancesTypesForAdminUiResponse>;
    /**
     * @param command CreateAccountTagTypesForAdminUiRequest
     * @return CreateAccountTagTypesForAdminUiResponse
     */
    createAccountTagType(command: CreateAccountTagTypesForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateAccountTagTypesForAdminUiResponse>;
    /**
     * @param command CreateAdminAbsenceTypeRequest
     * @return CreateAdminAbsenceTypeResponse
     */
    createAdminAbsenceType(command: CreateAdminAbsenceTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateAdminCaseTypeRequest
     * @return CreateAdminCaseTypeResponse
     */
    createAdminCaseType(command: CreateAdminCaseTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateAdminPlanTypeRequest
     * @return CreateAdminPlanTypeResponse
     */
    createAdminPlanType(command: CreateAdminPlanTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateAiStandardQuestionForAdminUiRequest
     * @return CreateAiStandardQuestionForAdminUiResponse
     */
    createAiStandardQuestion(command: CreateAiStandardQuestionForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateAiStandardQuestionForAdminUiResponse>;
    /**
     * @param command CreateAssociateUserRoleRequest
     * @return CreateAssociateUserRoleResponse
     */
    createAssociateUserRole(command: CreateAssociateUserRoleRequest, cancelToken?: CancelToken): Promise<CreateAssociateUserRoleResponse>;
    /**
     * @param command CreateCaseClosureReasonRequest
     * @return CreateCaseClosureReasonResponse
     */
    createCaseClosureReason(command: CreateCaseClosureReasonRequest, cancelToken?: CancelToken): Promise<CreateCaseClosureReasonResponse>;
    /**
     * @param command CreateCaseContactReasonRequest
     * @return CreateCaseContactReasonResponse
     */
    createCaseContactReason(command: CreateCaseContactReasonRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateCaseGroupsForAdminUiRequest
     * @return CreateCaseGroupsForAdminUiResponse
     */
    createCaseGroup(command: CreateCaseGroupsForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateCaseGroupsForAdminUiResponse>;
    /**
     * @param command CreateCaseRestrictionsForAdminUiRequest
     * @return CreateCaseRestrictionsForAdminUiResponse
     */
    createCaseRestriction(command: CreateCaseRestrictionsForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateCaseRestrictionsForAdminUiResponse>;
    /**
     * @param command CreateClosureCausesForAdminUiRequest
     * @return CreateClosureCausesForAdminUiResponse
     */
    createClosureCause(command: CreateClosureCausesForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateClosureCausesForAdminUiResponse>;
    /**
     * @param command CreateCoPaymentTypeForAdminUiRequest
     * @return CreateCoPaymentTypeForAdminUiResponse
     */
    createCoPaymentType(command: CreateCoPaymentTypeForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateCoPaymentTypeForAdminUiResponse>;
    /**
     * @param command CreateExternalOperatorResponsibilityAreaRequest
     * @return CreateExternalOperatorResponsibilityAreaResponse
     */
    createExternalOperatorResponsibilityArea(command: CreateExternalOperatorResponsibilityAreaRequest, cancelToken?: CancelToken): Promise<CreateExternalOperatorResponsibilityAreaResponse>;
    /**
     * @param command CreateFollowUpRulesForAdminUiRequest
     * @return CreateFollowUpRulesForAdminUiResponse
     */
    createFollowUpRule(command: CreateFollowUpRulesForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateFollowUpRulesForAdminUiResponse>;
    /**
     * @param command CreateGuideLinkRequest
     * @return CreateGuideLinkResponse
     */
    createGuideLink(command: CreateGuideLinkRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateOutgoingDocumentTypesForAdminUiRequest
     * @return CreateOutgoingDocumentTypesForAdminUiResponse
     */
    createOutgoingDocumentType(command: CreateOutgoingDocumentTypesForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateOutgoingDocumentTypesForAdminUiResponse>;
    /**
     * @param command CreatePlacementPurposeRequest
     * @return CreatePlacementPurposeResponse
     */
    createPlacementPurpose(command: CreatePlacementPurposeRequest, cancelToken?: CancelToken): Promise<CreatePlacementPurposeResponse>;
    /**
     * @param command CreateReasonForReadWriteMathTestsForAdminUiRequest
     * @return CreateReasonForReadWriteMathTestsForAdminUiResponse
     */
    createReasonForReadWriteMathTest(command: CreateReasonForReadWriteMathTestsForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateReasonForReadWriteMathTestsForAdminUiResponse>;
    /**
     * @param command CreateRecruitmentCollaborationRequest
     * @return CreateRecruitmentCollaborationResponse
     */
    createRecruitmentCollaboration(command: CreateRecruitmentCollaborationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateRecruitmentRequestInformationTypeRequest
     * @return CreateRecruitmentRequestInformationTypeResponse
     */
    createRecruitmentRequestInformationType(command: CreateRecruitmentRequestInformationTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateServiceTargetTypesForAdminUiRequest
     * @return CreateServiceTargetTypesForAdminUiResponse
     */
    createServiceTargetType(command: CreateServiceTargetTypesForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateServiceTargetTypesForAdminUiResponse>;
    /**
     * @param command CreateSocialProviderUnitRequest
     * @return CreateSocialProviderUnitResponse
     */
    createSocialProviderUnit(command: CreateSocialProviderUnitRequest, cancelToken?: CancelToken): Promise<CreateSocialProviderUnitResponse>;
    /**
     * @param command CreateStandardAppendixRequest
     * @return CreateStandardAppendixResponse
     */
    createStandardAppendix(command: CreateStandardAppendixRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateStandardAppendixRuleRequest
     * @return CreateStandardAppendixRuleResponse
     */
    createStandardAppendixRule(command: CreateStandardAppendixRuleRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command CreateStandardPhraseRequest
     * @return CreateStandardPhraseResponse
     */
    createStandardPhrase(command: CreateStandardPhraseRequest, cancelToken?: CancelToken): Promise<CreateStandardPhraseResponse>;
    /**
     * @param command CreateTaskConfigurationRequest
     * @return CreateTaskConfigurationResponse
     */
    createTaskConfiguration(command: CreateTaskConfigurationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteAiStandardQuestionsRequest
     * @return DeleteAiStandardQuestionsResponse
     */
    deleteAiStandardQuestions(command: DeleteAiStandardQuestionsRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteStandardPhraseRequest
     * @return DeleteStandardPhraseResponse
     */
    deleteStandardPhrase(command: DeleteStandardPhraseRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateAccountGroupRequest
     * @return UpdateAccountGroupResponse
     */
    updateAccountGroups(command: UpdateAccountGroupRequest, cancelToken?: CancelToken): Promise<UpdateAccountGroupResponse>;
    /**
     * @param command UpdateAccountInteractionPurposeRequest
     * @return UpdateAccountInteractionPurposeResponse
     */
    updateAccountInteractionPurposes(command: UpdateAccountInteractionPurposeRequest, cancelToken?: CancelToken): Promise<UpdateAccountInteractionPurposeResponse>;
    /**
     * @param command UpdateAccountInteractionResultRequest
     * @return UpdateAccountInteractionResultResponse
     */
    updateAccountInteractionResults(command: UpdateAccountInteractionResultRequest, cancelToken?: CancelToken): Promise<UpdateAccountInteractionResultResponse>;
    /**
     * @param command UpdateAccountSpecialCircumstancesTypeRequest
     * @return UpdateAccountSpecialCircumstancesTypeResponse
     */
    updateAccountSpecialCircumstancesTypes(command: UpdateAccountSpecialCircumstancesTypeRequest, cancelToken?: CancelToken): Promise<UpdateAccountSpecialCircumstancesTypeResponse>;
    /**
     * @param command UpdateAccountTagTypeRequest
     * @return UpdateAccountTagTypeResponse
     */
    updateAccountTagTypes(command: UpdateAccountTagTypeRequest, cancelToken?: CancelToken): Promise<UpdateAccountTagTypeResponse>;
    /**
     * @param command UpdateAdminAbsenceTypeRequest
     * @return UpdateAdminAbsenceTypeResponse
     */
    updateAdminAbsenceType(command: UpdateAdminAbsenceTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateAdminPlanTypeRequest
     * @return UpdateAdminPlanTypeResponse
     */
    updateAdminPlanType(command: UpdateAdminPlanTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateAiStandardQuestionForAdminUiRequest
     * @return UpdateAiStandardQuestionForAdminUiResponse
     */
    updateAiStandardQuestion(command: UpdateAiStandardQuestionForAdminUiRequest, cancelToken?: CancelToken): Promise<UpdateAiStandardQuestionForAdminUiResponse>;
    /**
     * @param command UpdateAiStandardQuestionRequest
     * @return UpdateAiStandardQuestionResponse
     */
    updateAIStandardQuestions(command: UpdateAiStandardQuestionRequest, cancelToken?: CancelToken): Promise<UpdateAiStandardQuestionResponse>;
    /**
     * @param command UpdateCaseContactRequest
     * @return UpdateCaseContactResponse
     */
    updateAssociateUserRole(command: UpdateCaseContactRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCaseClosureReasonRequest
     * @return UpdateCaseClosureReasonResponse
     */
    updateCaseClosureReason(command: UpdateCaseClosureReasonRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCaseContactRequest
     * @return UpdateCaseContactResponse
     */
    updateCaseContactReason(command: UpdateCaseContactRequest2, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateCaseGroupRequest
     * @return UpdateCaseGroupResponse
     */
    updateCaseGroups(command: UpdateCaseGroupRequest, cancelToken?: CancelToken): Promise<UpdateCaseGroupResponse>;
    /**
     * @param command UpdateCaseRestrictionsRequest
     * @return UpdateCaseRestrictionsResponse
     */
    updateCaseRestrictions(command: UpdateCaseRestrictionsRequest, cancelToken?: CancelToken): Promise<UpdateCaseRestrictionsResponse>;
    /**
     * @param command UpdateAdminCaseTypeRequest
     * @return UpdateAdminCaseTypeResponse
     */
    updateAdminCaseType(command: UpdateAdminCaseTypeRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateClosureCauseRequest
     * @return UpdateClosureCauseResponse
     */
    updateClosureCauses(command: UpdateClosureCauseRequest, cancelToken?: CancelToken): Promise<UpdateClosureCauseResponse>;
    /**
     * @param command UpdateCoPaymentTypeForAdminUiRequest
     * @return UpdateCoPaymentTypeForAdminUiResponse
     */
    updateCoPaymentType(command: UpdateCoPaymentTypeForAdminUiRequest, cancelToken?: CancelToken): Promise<UpdateCoPaymentTypeForAdminUiResponse>;
    /**
     * @param command UpdateExternalOperatorResponsibilityAreaRequest
     * @return UpdateExternalOperatorResponsibilityAreaResponse
     */
    updateExternalOperatorResponsibilityArea(command: UpdateExternalOperatorResponsibilityAreaRequest, cancelToken?: CancelToken): Promise<UpdateExternalOperatorResponsibilityAreaResponse>;
    /**
     * @param command UpdateFollowUpRulesForAdminUiRequest
     * @return UpdateFollowUpRulesForAdminUiResponse
     */
    updateFollowUpRules(command: UpdateFollowUpRulesForAdminUiRequest, cancelToken?: CancelToken): Promise<UpdateFollowUpRulesForAdminUiResponse>;
    /**
     * @param command UpdateGuideLinkRequest
     * @return UpdateGuideLinkResponse
     */
    updateGuideLink(command: UpdateGuideLinkRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateOutgoingDocumentTypesForAdminUiRequest
     * @return UpdateOutgoingDocumentTypesForAdminUiResponse
     */
    updateOutgoingDocumentTypes(command: UpdateOutgoingDocumentTypesForAdminUiRequest, cancelToken?: CancelToken): Promise<UpdateOutgoingDocumentTypesForAdminUiResponse>;
    /**
     * @param command UpdateCaseContactRequest
     * @return UpdateCaseContactResponse
     */
    updatePlacementPurpose(command: UpdateCaseContactRequest3, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateReasonForReadWriteMathTestRequest
     * @return UpdateReasonForReadWriteMathTestResponse
     */
    updateReasonForReadWriteMathTests(command: UpdateReasonForReadWriteMathTestRequest, cancelToken?: CancelToken): Promise<UpdateReasonForReadWriteMathTestResponse>;
    /**
     * @param command UpdateRecruitmentCollaborationRequest
     * @return UpdateRecruitmentCollaborationResponse
     */
    updateRecruitmentCollaboration(command: UpdateRecruitmentCollaborationRequest, cancelToken?: CancelToken): Promise<UpdateRecruitmentCollaborationResponse>;
    /**
     * @param command UpdateRecruitmentRequestInformationTypeRequest
     * @return UpdateRecruitmentRequestInformationTypeResponse
     */
    updateRecruitmentRequestInformationType(command: UpdateRecruitmentRequestInformationTypeRequest, cancelToken?: CancelToken): Promise<UpdateRecruitmentRequestInformationTypeResponse>;
    /**
     * @param command UpdateServiceTargetTypeRequest
     * @return UpdateServiceTargetTypeResponse
     */
    updateServiceTargetTypes(command: UpdateServiceTargetTypeRequest, cancelToken?: CancelToken): Promise<UpdateServiceTargetTypeResponse>;
    /**
     * @param command UpdateSocialProviderUnitRequest
     * @return UpdateSocialProviderUnitResponse
     */
    updateSocialProviderUnit(command: UpdateSocialProviderUnitRequest, cancelToken?: CancelToken): Promise<UpdateSocialProviderUnitResponse>;
    /**
     * @param command UpdateStandardAppendixRequest
     * @return UpdateStandardAppendixResponse
     */
    updateStandardAppendix(command: UpdateStandardAppendixRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateStandardAppendixRuleRequest
     * @return UpdateStandardAppendixRuleResponse
     */
    updateStandardAppendixRule(command: UpdateStandardAppendixRuleRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateStandardPhraseRequest
     * @return UpdateStandardPhraseResponse
     */
    updateStandardPhrase(command: UpdateStandardPhraseRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateTaskConfigurationRequest
     * @return UpdateTaskConfigurationResponse
     */
    updateTaskConfiguration(command: UpdateTaskConfigurationRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @return GetAccountGroupResponse
     */
    getAccountGroups(cancelToken?: CancelToken): Promise<GetAccountGroupResponse>;
    /**
     * @return GetAccountInteractionPurposeResponse
     */
    getAccountInteractionPurposes(cancelToken?: CancelToken): Promise<GetAccountInteractionPurposeResponse2>;
    /**
     * @return GetAccountInteractionResultResponse
     */
    getAccountInteractionResults(cancelToken?: CancelToken): Promise<GetAccountInteractionResultResponse>;
    /**
     * @return GetAccountSpecialCircumstancesTypeResponse
     */
    getAccountSpecialCircumstancesTypes(cancelToken?: CancelToken): Promise<GetAccountSpecialCircumstancesTypeResponse>;
    /**
     * @return GetAccountTagTypeResponse
     */
    getAccountTagTypes(cancelToken?: CancelToken): Promise<GetAccountTagTypeResponse>;
    /**
     * @return GetActivationTypeCodeListResponse
     */
    getActivationTypeCodeList(cancelToken?: CancelToken): Promise<GetActivationTypeCodeListResponse>;
    /**
     * @return GetAdminAbsenceTypesResponse
     */
    getAdminAbsenceTypes(cancelToken?: CancelToken): Promise<GetAdminAbsenceTypesResponse>;
    /**
     * @return GetAiStandardQuestionsResponse
     */
    getAiStandardQuestions(cancelToken?: CancelToken): Promise<GetAiStandardQuestionsResponse2>;
    /**
     * @return GetAssociatedUserRolesResponse
     */
    getAssociatedUserRoles(cancelToken?: CancelToken): Promise<GetAssociatedUserRolesResponse>;
    /**
     * @return GetAssociatedUserRolesCodeListResponse
     */
    getAssociatedUserRolesCodeList(cancelToken?: CancelToken): Promise<GetAssociatedUserRolesCodeListResponse>;
    /**
     * @return GetCaseClosureReasonsResponse
     */
    getCaseClosureReasons(cancelToken?: CancelToken): Promise<GetCaseClosureReasonsResponse2>;
    /**
     * @return CaseContactReasonResponse
     */
    getCaseContactReason(cancelToken?: CancelToken): Promise<CaseContactReasonResponse>;
    /**
     * @return GetCaseGroupResponse
     */
    getCaseGroups(cancelToken?: CancelToken): Promise<GetCaseGroupResponse>;
    /**
     * @return GetCaseRestrictionsResponse
     */
    getCaseRestrictions(cancelToken?: CancelToken): Promise<GetCaseRestrictionsResponse>;
    /**
     * @return GetCaseTypesResponse
     */
    getCaseTypes(cancelToken?: CancelToken): Promise<GetCaseTypesResponse>;
    /**
     * @return GetClosureCauseResponse
     */
    getClosureCauses(cancelToken?: CancelToken): Promise<GetClosureCauseResponse>;
    /**
     * @return GetCoPaymentTypesResponse
     */
    getCoPaymentTypes(cancelToken?: CancelToken): Promise<GetCoPaymentTypesResponse>;
    /**
     * @return GetCourseTypeCodeListResponse
     */
    getCourseTypeCodeList(cancelToken?: CancelToken): Promise<GetCourseTypeCodeListResponse>;
    /**
     * @return GetDebitorAccountTypesResponse
     */
    getDebitorAccountTypes(cancelToken?: CancelToken): Promise<GetDebitorAccountTypesResponse>;
    /**
     * @param query GetDocumentsFromDocumentArchiveRequest
     * @return GetDocumentsFromDocumentArchiveResponse
     */
    getDocumentsFromDocumentArchive(query: GetDocumentsFromDocumentArchiveRequest3, cancelToken?: CancelToken): Promise<GetDocumentsFromDocumentArchiveResponse3>;
    /**
     * @param query GetDocumentTemplatesByCategoryRequest
     * @return GetDocumentTemplatesByCategoryResponse
     */
    getDocumentTemplatesByCategory(query: GetDocumentTemplatesByCategoryRequest, cancelToken?: CancelToken): Promise<GetDocumentTemplatesByCategoryResponse>;
    /**
     * @return GetExternalOperatorResponsibilityAreasResponse
     */
    getExternalOperatorResponsibilityAreas(cancelToken?: CancelToken): Promise<GetExternalOperatorResponsibilityAreasResponse>;
    /**
     * @return GetFollowUpRulesForAdminUiResponse
     */
    getFollowUpRules(cancelToken?: CancelToken): Promise<GetFollowUpRulesForAdminUiResponse>;
    /**
     * @return GetGuideLinksResponse
     */
    getGuideLinks(cancelToken?: CancelToken): Promise<GetGuideLinksResponse>;
    /**
     * @return GetJobcentersResponse
     */
    getJobcenters(cancelToken?: CancelToken): Promise<GetJobcentersResponse2>;
    /**
     * @return GetMetadataEntityConfigurationResponse
     */
    getMetadataEntityCodeList(cancelToken?: CancelToken): Promise<GetMetadataEntityConfigurationResponse>;
    /**
     * @return GetOfferTypeCodeListResponse
     */
    getOfferTypeCodeList(cancelToken?: CancelToken): Promise<GetOfferTypeCodeListResponse>;
    /**
     * @return GetOutgoingDocumentTypesForAdminUiResponse
     */
    getOutgoingDocumentTypes(cancelToken?: CancelToken): Promise<GetOutgoingDocumentTypesForAdminUiResponse>;
    /**
     * @return GetPlacementPurposeResponse
     */
    getPlacementPurpose(cancelToken?: CancelToken): Promise<GetPlacementPurposeResponse>;
    /**
     * @return GetPlanTypesResponse
     */
    getPlanTypes(cancelToken?: CancelToken): Promise<GetPlanTypesResponse>;
    /**
     * @return GetPurposeOfCompanyInternshipTypeCodeListResponse
     */
    getPurposeOfCompanyInternshipTypeCodeList(cancelToken?: CancelToken): Promise<GetPurposeOfCompanyInternshipTypeCodeListResponse>;
    /**
     * @return GetReasonForReadWriteMathTestResponse
     */
    getReasonForReadWriteMathTests(cancelToken?: CancelToken): Promise<GetReasonForReadWriteMathTestResponse>;
    /**
     * @return GetRecruitmentCollaborationsResponse
     */
    getRecruitmentCollaborations(cancelToken?: CancelToken): Promise<GetRecruitmentCollaborationsResponse2>;
    /**
     * @return GetRecruitmentRequestInformationTypesResponse
     */
    getRecruitmentRequestInformationTypes(cancelToken?: CancelToken): Promise<GetRecruitmentRequestInformationTypesResponse>;
    /**
     * @return GetRemovalCauseTypesResponse
     */
    getRemovalCauseTypes(cancelToken?: CancelToken): Promise<GetRemovalCauseTypesResponse>;
    /**
     * @return GetResponsibilityAreaResponse
     */
    getResponsibilityArea(cancelToken?: CancelToken): Promise<GetResponsibilityAreaResponse>;
    /**
     * @return GetServiceTargetTypeResponse
     */
    getServiceTargetTypes(cancelToken?: CancelToken): Promise<GetServiceTargetTypeResponse>;
    /**
     * @return GetSocialProviderUnitsResponse
     */
    getSocialProviderUnits(cancelToken?: CancelToken): Promise<GetSocialProviderUnitsResponse>;
    /**
     * @return GetStandardAppendixesResponse
     */
    getStandardAppendixes(cancelToken?: CancelToken): Promise<GetStandardAppendixesResponse>;
    /**
     * @return GetStandardAppendixesForLookupResponse
     */
    getStandardAppendixesForLookup(cancelToken?: CancelToken): Promise<GetStandardAppendixesForLookupResponse>;
    /**
     * @return GetStandardAppendixRulesResponse
     */
    getStandardAppendixRules(cancelToken?: CancelToken): Promise<GetStandardAppendixRulesResponse>;
    /**
     * @param query GetStandardPhrasesRequest
     * @return GetStandardPhrasesResponse
     */
    getStandardPhrases(query: GetStandardPhrasesRequest2, cancelToken?: CancelToken): Promise<GetStandardPhrasesResponse>;
    /**
     * @return GetTargetGroupCodeListResponse
     */
    getTargetGroupCodeList(cancelToken?: CancelToken): Promise<GetTargetGroupCodeListResponse>;
    /**
     * @return GetTaskCategoryCodeListResponse
     */
    getTaskCategoryCodeList(cancelToken?: CancelToken): Promise<GetTaskCategoryCodeListResponse>;
    /**
     * @return GetTaskConfigurationResponse
     */
    getTaskConfiguration(cancelToken?: CancelToken): Promise<GetTaskConfigurationResponse>;
    /**
     * @return GetTaskConfigurationCodeListResponse
     */
    getTaskConfigurationCodeList(cancelToken?: CancelToken): Promise<GetTaskConfigurationCodeListResponse>;
}

export class AdminAdminUIClient implements IAdminAdminUIClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command ChangeAiStandardQuestionsStatusRequest
     * @return ChangeAiStandardQuestionsStatusResponse
     */
    changeAiStandardQuestionsStatus(command: ChangeAiStandardQuestionsStatusRequest, cancelToken?: CancelToken): Promise<ChangeAiStandardQuestionsStatusResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/changeaistandardquestionsstatus`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CopyAiStandardQuestionsAsDraftsRequest
     * @return CopyAiStandardQuestionsAsDraftsResponse
     */
    copyAiStandardQuestionsAsDrafts(command: CopyAiStandardQuestionsAsDraftsRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/copyaistandardquestionsasdrafts`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAccountGroupsForAdminUiRequest
     * @return CreateAccountGroupsForAdminUiResponse
     */
    createAccountGroup(command: CreateAccountGroupsForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateAccountGroupsForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createaccountgroup`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAccountInteractionPurposesForAdminUiRequest
     * @return CreateAccountInteractionPurposesForAdminUiResponse
     */
    createAccountInteractionPurpose(command: CreateAccountInteractionPurposesForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateAccountInteractionPurposesForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createaccountinteractionpurpose`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAccountInteractionResultsForAdminUiRequest
     * @return CreateAccountInteractionResultsForAdminUiResponse
     */
    createAccountInteractionResult(command: CreateAccountInteractionResultsForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateAccountInteractionResultsForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createaccountinteractionresult`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAccountSpecialCircumstancesTypesForAdminUiRequest
     * @return CreateAccountSpecialCircumstancesTypesForAdminUiResponse
     */
    createAccountSpecialCircumstancesType(command: CreateAccountSpecialCircumstancesTypesForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateAccountSpecialCircumstancesTypesForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createaccountspecialcircumstancestype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAccountTagTypesForAdminUiRequest
     * @return CreateAccountTagTypesForAdminUiResponse
     */
    createAccountTagType(command: CreateAccountTagTypesForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateAccountTagTypesForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createaccounttagtype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAdminAbsenceTypeRequest
     * @return CreateAdminAbsenceTypeResponse
     */
    createAdminAbsenceType(command: CreateAdminAbsenceTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createadminabsencetype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAdminCaseTypeRequest
     * @return CreateAdminCaseTypeResponse
     */
    createAdminCaseType(command: CreateAdminCaseTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createadmincasetype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAdminPlanTypeRequest
     * @return CreateAdminPlanTypeResponse
     */
    createAdminPlanType(command: CreateAdminPlanTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createadminplantype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAiStandardQuestionForAdminUiRequest
     * @return CreateAiStandardQuestionForAdminUiResponse
     */
    createAiStandardQuestion(command: CreateAiStandardQuestionForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateAiStandardQuestionForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createaistandardquestion`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateAssociateUserRoleRequest
     * @return CreateAssociateUserRoleResponse
     */
    createAssociateUserRole(command: CreateAssociateUserRoleRequest, cancelToken?: CancelToken): Promise<CreateAssociateUserRoleResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createassociateuserrole`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCaseClosureReasonRequest
     * @return CreateCaseClosureReasonResponse
     */
    createCaseClosureReason(command: CreateCaseClosureReasonRequest, cancelToken?: CancelToken): Promise<CreateCaseClosureReasonResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createcaseclosurereason`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCaseContactReasonRequest
     * @return CreateCaseContactReasonResponse
     */
    createCaseContactReason(command: CreateCaseContactReasonRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createcasecontactreason`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCaseGroupsForAdminUiRequest
     * @return CreateCaseGroupsForAdminUiResponse
     */
    createCaseGroup(command: CreateCaseGroupsForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateCaseGroupsForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createcasegroup`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCaseRestrictionsForAdminUiRequest
     * @return CreateCaseRestrictionsForAdminUiResponse
     */
    createCaseRestriction(command: CreateCaseRestrictionsForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateCaseRestrictionsForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createcaserestriction`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateClosureCausesForAdminUiRequest
     * @return CreateClosureCausesForAdminUiResponse
     */
    createClosureCause(command: CreateClosureCausesForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateClosureCausesForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createclosurecause`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateCoPaymentTypeForAdminUiRequest
     * @return CreateCoPaymentTypeForAdminUiResponse
     */
    createCoPaymentType(command: CreateCoPaymentTypeForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateCoPaymentTypeForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createcopaymenttype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateExternalOperatorResponsibilityAreaRequest
     * @return CreateExternalOperatorResponsibilityAreaResponse
     */
    createExternalOperatorResponsibilityArea(command: CreateExternalOperatorResponsibilityAreaRequest, cancelToken?: CancelToken): Promise<CreateExternalOperatorResponsibilityAreaResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createexternaloperatorresponsibilityarea`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateFollowUpRulesForAdminUiRequest
     * @return CreateFollowUpRulesForAdminUiResponse
     */
    createFollowUpRule(command: CreateFollowUpRulesForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateFollowUpRulesForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createfollowuprule`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateGuideLinkRequest
     * @return CreateGuideLinkResponse
     */
    createGuideLink(command: CreateGuideLinkRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createguidelink`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateOutgoingDocumentTypesForAdminUiRequest
     * @return CreateOutgoingDocumentTypesForAdminUiResponse
     */
    createOutgoingDocumentType(command: CreateOutgoingDocumentTypesForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateOutgoingDocumentTypesForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createoutgoingdocumenttype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreatePlacementPurposeRequest
     * @return CreatePlacementPurposeResponse
     */
    createPlacementPurpose(command: CreatePlacementPurposeRequest, cancelToken?: CancelToken): Promise<CreatePlacementPurposeResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createplacementpurpose`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateReasonForReadWriteMathTestsForAdminUiRequest
     * @return CreateReasonForReadWriteMathTestsForAdminUiResponse
     */
    createReasonForReadWriteMathTest(command: CreateReasonForReadWriteMathTestsForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateReasonForReadWriteMathTestsForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createreasonforreadwritemathtest`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateRecruitmentCollaborationRequest
     * @return CreateRecruitmentCollaborationResponse
     */
    createRecruitmentCollaboration(command: CreateRecruitmentCollaborationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createrecruitmentcollaboration`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateRecruitmentRequestInformationTypeRequest
     * @return CreateRecruitmentRequestInformationTypeResponse
     */
    createRecruitmentRequestInformationType(command: CreateRecruitmentRequestInformationTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createrecruitmentrequestinformationtype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateServiceTargetTypesForAdminUiRequest
     * @return CreateServiceTargetTypesForAdminUiResponse
     */
    createServiceTargetType(command: CreateServiceTargetTypesForAdminUiRequest, cancelToken?: CancelToken): Promise<CreateServiceTargetTypesForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createservicetargettype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateSocialProviderUnitRequest
     * @return CreateSocialProviderUnitResponse
     */
    createSocialProviderUnit(command: CreateSocialProviderUnitRequest, cancelToken?: CancelToken): Promise<CreateSocialProviderUnitResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createsocialproviderunit`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateStandardAppendixRequest
     * @return CreateStandardAppendixResponse
     */
    createStandardAppendix(command: CreateStandardAppendixRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createstandardappendix`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateStandardAppendixRuleRequest
     * @return CreateStandardAppendixRuleResponse
     */
    createStandardAppendixRule(command: CreateStandardAppendixRuleRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createstandardappendixrule`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateStandardPhraseRequest
     * @return CreateStandardPhraseResponse
     */
    createStandardPhrase(command: CreateStandardPhraseRequest, cancelToken?: CancelToken): Promise<CreateStandardPhraseResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createstandardphrase`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateTaskConfigurationRequest
     * @return CreateTaskConfigurationResponse
     */
    createTaskConfiguration(command: CreateTaskConfigurationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/createtaskconfiguration`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteAiStandardQuestionsRequest
     * @return DeleteAiStandardQuestionsResponse
     */
    deleteAiStandardQuestions(command: DeleteAiStandardQuestionsRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/deleteaistandardquestions`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteStandardPhraseRequest
     * @return DeleteStandardPhraseResponse
     */
    deleteStandardPhrase(command: DeleteStandardPhraseRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/deletestandardphrase`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAccountGroupRequest
     * @return UpdateAccountGroupResponse
     */
    updateAccountGroups(command: UpdateAccountGroupRequest, cancelToken?: CancelToken): Promise<UpdateAccountGroupResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateaccountgroups`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAccountInteractionPurposeRequest
     * @return UpdateAccountInteractionPurposeResponse
     */
    updateAccountInteractionPurposes(command: UpdateAccountInteractionPurposeRequest, cancelToken?: CancelToken): Promise<UpdateAccountInteractionPurposeResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateaccountinteractionpurposes`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAccountInteractionResultRequest
     * @return UpdateAccountInteractionResultResponse
     */
    updateAccountInteractionResults(command: UpdateAccountInteractionResultRequest, cancelToken?: CancelToken): Promise<UpdateAccountInteractionResultResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateaccountinteractionresults`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAccountSpecialCircumstancesTypeRequest
     * @return UpdateAccountSpecialCircumstancesTypeResponse
     */
    updateAccountSpecialCircumstancesTypes(command: UpdateAccountSpecialCircumstancesTypeRequest, cancelToken?: CancelToken): Promise<UpdateAccountSpecialCircumstancesTypeResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateaccountspecialcircumstancestypes`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAccountTagTypeRequest
     * @return UpdateAccountTagTypeResponse
     */
    updateAccountTagTypes(command: UpdateAccountTagTypeRequest, cancelToken?: CancelToken): Promise<UpdateAccountTagTypeResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateaccounttagtypes`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAdminAbsenceTypeRequest
     * @return UpdateAdminAbsenceTypeResponse
     */
    updateAdminAbsenceType(command: UpdateAdminAbsenceTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateadminabsencetype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAdminPlanTypeRequest
     * @return UpdateAdminPlanTypeResponse
     */
    updateAdminPlanType(command: UpdateAdminPlanTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateadminplantype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAiStandardQuestionForAdminUiRequest
     * @return UpdateAiStandardQuestionForAdminUiResponse
     */
    updateAiStandardQuestion(command: UpdateAiStandardQuestionForAdminUiRequest, cancelToken?: CancelToken): Promise<UpdateAiStandardQuestionForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateaistandardquestion`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAiStandardQuestionRequest
     * @return UpdateAiStandardQuestionResponse
     */
    updateAIStandardQuestions(command: UpdateAiStandardQuestionRequest, cancelToken?: CancelToken): Promise<UpdateAiStandardQuestionResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateaistandardquestions`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCaseContactRequest
     * @return UpdateCaseContactResponse
     */
    updateAssociateUserRole(command: UpdateCaseContactRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateassociateuserrole`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCaseClosureReasonRequest
     * @return UpdateCaseClosureReasonResponse
     */
    updateCaseClosureReason(command: UpdateCaseClosureReasonRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updatecaseclosurereason`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCaseContactRequest
     * @return UpdateCaseContactResponse
     */
    updateCaseContactReason(command: UpdateCaseContactRequest2, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updatecasecontactreason`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCaseGroupRequest
     * @return UpdateCaseGroupResponse
     */
    updateCaseGroups(command: UpdateCaseGroupRequest, cancelToken?: CancelToken): Promise<UpdateCaseGroupResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updatecasegroups`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCaseRestrictionsRequest
     * @return UpdateCaseRestrictionsResponse
     */
    updateCaseRestrictions(command: UpdateCaseRestrictionsRequest, cancelToken?: CancelToken): Promise<UpdateCaseRestrictionsResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updatecaserestrictions`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateAdminCaseTypeRequest
     * @return UpdateAdminCaseTypeResponse
     */
    updateAdminCaseType(command: UpdateAdminCaseTypeRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateadmincasetype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateClosureCauseRequest
     * @return UpdateClosureCauseResponse
     */
    updateClosureCauses(command: UpdateClosureCauseRequest, cancelToken?: CancelToken): Promise<UpdateClosureCauseResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateclosurecauses`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCoPaymentTypeForAdminUiRequest
     * @return UpdateCoPaymentTypeForAdminUiResponse
     */
    updateCoPaymentType(command: UpdateCoPaymentTypeForAdminUiRequest, cancelToken?: CancelToken): Promise<UpdateCoPaymentTypeForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updatecopaymenttype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateExternalOperatorResponsibilityAreaRequest
     * @return UpdateExternalOperatorResponsibilityAreaResponse
     */
    updateExternalOperatorResponsibilityArea(command: UpdateExternalOperatorResponsibilityAreaRequest, cancelToken?: CancelToken): Promise<UpdateExternalOperatorResponsibilityAreaResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateexternaloperatorresponsibilityarea`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateFollowUpRulesForAdminUiRequest
     * @return UpdateFollowUpRulesForAdminUiResponse
     */
    updateFollowUpRules(command: UpdateFollowUpRulesForAdminUiRequest, cancelToken?: CancelToken): Promise<UpdateFollowUpRulesForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updatefollowuprules`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateGuideLinkRequest
     * @return UpdateGuideLinkResponse
     */
    updateGuideLink(command: UpdateGuideLinkRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateguidelink`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateOutgoingDocumentTypesForAdminUiRequest
     * @return UpdateOutgoingDocumentTypesForAdminUiResponse
     */
    updateOutgoingDocumentTypes(command: UpdateOutgoingDocumentTypesForAdminUiRequest, cancelToken?: CancelToken): Promise<UpdateOutgoingDocumentTypesForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateoutgoingdocumenttypes`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateCaseContactRequest
     * @return UpdateCaseContactResponse
     */
    updatePlacementPurpose(command: UpdateCaseContactRequest3, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateplacementpurpose`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateReasonForReadWriteMathTestRequest
     * @return UpdateReasonForReadWriteMathTestResponse
     */
    updateReasonForReadWriteMathTests(command: UpdateReasonForReadWriteMathTestRequest, cancelToken?: CancelToken): Promise<UpdateReasonForReadWriteMathTestResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updatereasonforreadwritemathtests`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateRecruitmentCollaborationRequest
     * @return UpdateRecruitmentCollaborationResponse
     */
    updateRecruitmentCollaboration(command: UpdateRecruitmentCollaborationRequest, cancelToken?: CancelToken): Promise<UpdateRecruitmentCollaborationResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updaterecruitmentcollaboration`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateRecruitmentRequestInformationTypeRequest
     * @return UpdateRecruitmentRequestInformationTypeResponse
     */
    updateRecruitmentRequestInformationType(command: UpdateRecruitmentRequestInformationTypeRequest, cancelToken?: CancelToken): Promise<UpdateRecruitmentRequestInformationTypeResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updaterecruitmentrequestinformationtype`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateServiceTargetTypeRequest
     * @return UpdateServiceTargetTypeResponse
     */
    updateServiceTargetTypes(command: UpdateServiceTargetTypeRequest, cancelToken?: CancelToken): Promise<UpdateServiceTargetTypeResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updateservicetargettypes`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateSocialProviderUnitRequest
     * @return UpdateSocialProviderUnitResponse
     */
    updateSocialProviderUnit(command: UpdateSocialProviderUnitRequest, cancelToken?: CancelToken): Promise<UpdateSocialProviderUnitResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updatesocialproviderunit`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateStandardAppendixRequest
     * @return UpdateStandardAppendixResponse
     */
    updateStandardAppendix(command: UpdateStandardAppendixRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updatestandardappendix`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateStandardAppendixRuleRequest
     * @return UpdateStandardAppendixRuleResponse
     */
    updateStandardAppendixRule(command: UpdateStandardAppendixRuleRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updatestandardappendixrule`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateStandardPhraseRequest
     * @return UpdateStandardPhraseResponse
     */
    updateStandardPhrase(command: UpdateStandardPhraseRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updatestandardphrase`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateTaskConfigurationRequest
     * @return UpdateTaskConfigurationResponse
     */
    updateTaskConfiguration(command: UpdateTaskConfigurationRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/commands/updatetaskconfiguration`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAccountGroupResponse
     */
    getAccountGroups(cancelToken?: CancelToken): Promise<GetAccountGroupResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getaccountgroups`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAccountInteractionPurposeResponse
     */
    getAccountInteractionPurposes(cancelToken?: CancelToken): Promise<GetAccountInteractionPurposeResponse2> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getaccountinteractionpurposes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAccountInteractionResultResponse
     */
    getAccountInteractionResults(cancelToken?: CancelToken): Promise<GetAccountInteractionResultResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getaccountinteractionresults`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAccountSpecialCircumstancesTypeResponse
     */
    getAccountSpecialCircumstancesTypes(cancelToken?: CancelToken): Promise<GetAccountSpecialCircumstancesTypeResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getaccountspecialcircumstancestypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAccountTagTypeResponse
     */
    getAccountTagTypes(cancelToken?: CancelToken): Promise<GetAccountTagTypeResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getaccounttagtypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetActivationTypeCodeListResponse
     */
    getActivationTypeCodeList(cancelToken?: CancelToken): Promise<GetActivationTypeCodeListResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getactivationtypecodelist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAdminAbsenceTypesResponse
     */
    getAdminAbsenceTypes(cancelToken?: CancelToken): Promise<GetAdminAbsenceTypesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getadminabsencetypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAiStandardQuestionsResponse
     */
    getAiStandardQuestions(cancelToken?: CancelToken): Promise<GetAiStandardQuestionsResponse2> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getaistandardquestions`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAssociatedUserRolesResponse
     */
    getAssociatedUserRoles(cancelToken?: CancelToken): Promise<GetAssociatedUserRolesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getassociateduserroles`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAssociatedUserRolesCodeListResponse
     */
    getAssociatedUserRolesCodeList(cancelToken?: CancelToken): Promise<GetAssociatedUserRolesCodeListResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getassociateduserrolescodelist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCaseClosureReasonsResponse
     */
    getCaseClosureReasons(cancelToken?: CancelToken): Promise<GetCaseClosureReasonsResponse2> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getcaseclosurereasons`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return CaseContactReasonResponse
     */
    getCaseContactReason(cancelToken?: CancelToken): Promise<CaseContactReasonResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getcasecontactreason`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCaseGroupResponse
     */
    getCaseGroups(cancelToken?: CancelToken): Promise<GetCaseGroupResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getcasegroups`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCaseRestrictionsResponse
     */
    getCaseRestrictions(cancelToken?: CancelToken): Promise<GetCaseRestrictionsResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getcaserestrictions`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCaseTypesResponse
     */
    getCaseTypes(cancelToken?: CancelToken): Promise<GetCaseTypesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getcasetypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetClosureCauseResponse
     */
    getClosureCauses(cancelToken?: CancelToken): Promise<GetClosureCauseResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getclosurecauses`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCoPaymentTypesResponse
     */
    getCoPaymentTypes(cancelToken?: CancelToken): Promise<GetCoPaymentTypesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getcopaymenttypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCourseTypeCodeListResponse
     */
    getCourseTypeCodeList(cancelToken?: CancelToken): Promise<GetCourseTypeCodeListResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getcoursetypecodelist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetDebitorAccountTypesResponse
     */
    getDebitorAccountTypes(cancelToken?: CancelToken): Promise<GetDebitorAccountTypesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getdebitoraccounttypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDocumentsFromDocumentArchiveRequest
     * @return GetDocumentsFromDocumentArchiveResponse
     */
    getDocumentsFromDocumentArchive(query: GetDocumentsFromDocumentArchiveRequest3, cancelToken?: CancelToken): Promise<GetDocumentsFromDocumentArchiveResponse3> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getdocumentsfromdocumentarchive`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDocumentTemplatesByCategoryRequest
     * @return GetDocumentTemplatesByCategoryResponse
     */
    getDocumentTemplatesByCategory(query: GetDocumentTemplatesByCategoryRequest, cancelToken?: CancelToken): Promise<GetDocumentTemplatesByCategoryResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getdocumenttemplatesbycategory`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetExternalOperatorResponsibilityAreasResponse
     */
    getExternalOperatorResponsibilityAreas(cancelToken?: CancelToken): Promise<GetExternalOperatorResponsibilityAreasResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getexternaloperatorresponsibilityareas`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetFollowUpRulesForAdminUiResponse
     */
    getFollowUpRules(cancelToken?: CancelToken): Promise<GetFollowUpRulesForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getfollowuprules`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetGuideLinksResponse
     */
    getGuideLinks(cancelToken?: CancelToken): Promise<GetGuideLinksResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getguidelinks`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetJobcentersResponse
     */
    getJobcenters(cancelToken?: CancelToken): Promise<GetJobcentersResponse2> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getjobcenters`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetMetadataEntityConfigurationResponse
     */
    getMetadataEntityCodeList(cancelToken?: CancelToken): Promise<GetMetadataEntityConfigurationResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getmetadataentitycodelist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOfferTypeCodeListResponse
     */
    getOfferTypeCodeList(cancelToken?: CancelToken): Promise<GetOfferTypeCodeListResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getoffertypecodelist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOutgoingDocumentTypesForAdminUiResponse
     */
    getOutgoingDocumentTypes(cancelToken?: CancelToken): Promise<GetOutgoingDocumentTypesForAdminUiResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getoutgoingdocumenttypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetPlacementPurposeResponse
     */
    getPlacementPurpose(cancelToken?: CancelToken): Promise<GetPlacementPurposeResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getplacementpurpose`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetPlanTypesResponse
     */
    getPlanTypes(cancelToken?: CancelToken): Promise<GetPlanTypesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getplantypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetPurposeOfCompanyInternshipTypeCodeListResponse
     */
    getPurposeOfCompanyInternshipTypeCodeList(cancelToken?: CancelToken): Promise<GetPurposeOfCompanyInternshipTypeCodeListResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getpurposeofcompanyinternshiptypecodelist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetReasonForReadWriteMathTestResponse
     */
    getReasonForReadWriteMathTests(cancelToken?: CancelToken): Promise<GetReasonForReadWriteMathTestResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getreasonforreadwritemathtests`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetRecruitmentCollaborationsResponse
     */
    getRecruitmentCollaborations(cancelToken?: CancelToken): Promise<GetRecruitmentCollaborationsResponse2> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getrecruitmentcollaborations`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetRecruitmentRequestInformationTypesResponse
     */
    getRecruitmentRequestInformationTypes(cancelToken?: CancelToken): Promise<GetRecruitmentRequestInformationTypesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getrecruitmentrequestinformationtypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetRemovalCauseTypesResponse
     */
    getRemovalCauseTypes(cancelToken?: CancelToken): Promise<GetRemovalCauseTypesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getremovalcausetypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetResponsibilityAreaResponse
     */
    getResponsibilityArea(cancelToken?: CancelToken): Promise<GetResponsibilityAreaResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getresponsibilityarea`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetServiceTargetTypeResponse
     */
    getServiceTargetTypes(cancelToken?: CancelToken): Promise<GetServiceTargetTypeResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getservicetargettypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSocialProviderUnitsResponse
     */
    getSocialProviderUnits(cancelToken?: CancelToken): Promise<GetSocialProviderUnitsResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getsocialproviderunits`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetStandardAppendixesResponse
     */
    getStandardAppendixes(cancelToken?: CancelToken): Promise<GetStandardAppendixesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getstandardappendixes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetStandardAppendixesForLookupResponse
     */
    getStandardAppendixesForLookup(cancelToken?: CancelToken): Promise<GetStandardAppendixesForLookupResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getstandardappendixesforlookup`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetStandardAppendixRulesResponse
     */
    getStandardAppendixRules(cancelToken?: CancelToken): Promise<GetStandardAppendixRulesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getstandardappendixrules`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetStandardPhrasesRequest
     * @return GetStandardPhrasesResponse
     */
    getStandardPhrases(query: GetStandardPhrasesRequest2, cancelToken?: CancelToken): Promise<GetStandardPhrasesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/getstandardphrases`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTargetGroupCodeListResponse
     */
    getTargetGroupCodeList(cancelToken?: CancelToken): Promise<GetTargetGroupCodeListResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/gettargetgroupcodelist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTaskCategoryCodeListResponse
     */
    getTaskCategoryCodeList(cancelToken?: CancelToken): Promise<GetTaskCategoryCodeListResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/gettaskcategorycodelist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTaskConfigurationResponse
     */
    getTaskConfiguration(cancelToken?: CancelToken): Promise<GetTaskConfigurationResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/gettaskconfiguration`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTaskConfigurationCodeListResponse
     */
    getTaskConfigurationCodeList(cancelToken?: CancelToken): Promise<GetTaskConfigurationCodeListResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/queries/gettaskconfigurationcodelist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminAdminUIAIClient {
    /**
     * @param command CreateGlossaryTermRequest
     * @return CreateGlossaryTermResponse
     */
    createGlossaryTerm(command: CreateGlossaryTermRequest, cancelToken?: CancelToken): Promise<CreateGlossaryTermResponse>;
    /**
     * @param command CreateMunicipalityAssistantDocumentRequest
     * @return CreateMunicipalityAssistantDocumentResponse
     */
    createMunicipalityAssistantDocument(command: CreateMunicipalityAssistantDocumentRequest, cancelToken?: CancelToken): Promise<CreateMunicipalityAssistantDocumentResponse>;
    /**
     * @param command DeleteDialogSupportPromptRequest
     * @return DeleteDialogSupportPromptResponse
     */
    deleteDialogSupportPrompt(command: DeleteDialogSupportPromptRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteGlossaryTermRequest
     * @return DeleteGlossaryTermResponse
     */
    deleteGlossaryTerm(command: DeleteGlossaryTermRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command DeleteMunicipalityAssistantDocumentRequest
     * @return DeleteMunicipalityAssistantDocumentResponse
     */
    deleteMunicipalityAssistantDocument(command: DeleteMunicipalityAssistantDocumentRequest, cancelToken?: CancelToken): Promise<DeleteMunicipalityAssistantDocumentResponse>;
    /**
     * @param command SaveAssessmentPromptRequest
     * @return SaveAssessmentPromptResponse
     */
    saveAssessmentPrompt(command: SaveAssessmentPromptRequest, cancelToken?: CancelToken): Promise<SaveAssessmentPromptResponse>;
    /**
     * @param command SaveDialogSupportInstructionRequest
     * @return SaveDialogSupportInstructionResponse
     */
    saveDialogSupportInstruction(command: SaveDialogSupportInstructionRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateGlossaryTermRequest
     * @return UpdateGlossaryTermResponse
     */
    updateGlossaryTerm(command: UpdateGlossaryTermRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param command UpdateMunicipalityAssistantDocumentRequest
     * @return UpdateMunicipalityAssistantDocumentResponse
     */
    updateMunicipalityAssistantDocument(command: UpdateMunicipalityAssistantDocumentRequest, cancelToken?: CancelToken): Promise<UpdateMunicipalityAssistantDocumentResponse>;
    /**
     * @param command UploadDraftMunicipalityDocumentRequest
     * @return UploadDraftMunicipalityDocumentResponse
     */
    uploadDraftMunicipalityDocument(command: UploadDraftMunicipalityDocumentRequest, cancelToken?: CancelToken): Promise<UploadDraftMunicipalityDocumentResponse>;
    /**
     * @param command UpsertMunicipalityAssistantDocumentRequest
     * @return UpsertMunicipalityAssistantDocumentResponse
     */
    upsertMunicipalityAssistantDocument(command: UpsertMunicipalityAssistantDocumentRequest, cancelToken?: CancelToken): Promise<UpsertMunicipalityAssistantDocumentResponse>;
    /**
     * @param query CheckExistingMunicipalityDocumentFilesRequest
     * @return CheckExistingMunicipalityDocumentFilesResponse
     */
    checkExistingMunicipalityDocumentFiles(query: CheckExistingMunicipalityDocumentFilesRequest, cancelToken?: CancelToken): Promise<CheckExistingMunicipalityDocumentFilesResponse>;
    /**
     * @return GetAssessmentPromptsForAdminResponse
     */
    getAssessmentPromptsForAdmin(cancelToken?: CancelToken): Promise<GetAssessmentPromptsForAdminResponse>;
    /**
     * @param query GetDialogSupportInstructionForAdminRequest
     * @return GetDialogSupportInstructionForAdminResponse
     */
    getDialogSupportInstructionForAdmin(query: GetDialogSupportInstructionForAdminRequest, cancelToken?: CancelToken): Promise<GetDialogSupportInstructionForAdminResponse>;
    /**
     * @return GetDialogSupportPromptOptionsResponse
     */
    getDialogSupportPromptOptions(cancelToken?: CancelToken): Promise<GetDialogSupportPromptOptionsResponse>;
    /**
     * @return GetDialogSupportPromptsForAdminResponse
     */
    getDialogSupportPromptsForAdmin(cancelToken?: CancelToken): Promise<GetDialogSupportPromptsForAdminResponse>;
    /**
     * @return GetGlossaryForAdminResponse
     */
    getGlossaryForAdmin(cancelToken?: CancelToken): Promise<GetGlossaryForAdminResponse>;
    /**
     * @return GetMunicipalityAssistantDocumentsResponse
     */
    getMunicipalityAssistantDocuments(cancelToken?: CancelToken): Promise<GetMunicipalityAssistantDocumentsResponse>;
}

export class AdminAdminUIAIClient implements IAdminAdminUIAIClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param command CreateGlossaryTermRequest
     * @return CreateGlossaryTermResponse
     */
    createGlossaryTerm(command: CreateGlossaryTermRequest, cancelToken?: CancelToken): Promise<CreateGlossaryTermResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/commands/createglossaryterm`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command CreateMunicipalityAssistantDocumentRequest
     * @return CreateMunicipalityAssistantDocumentResponse
     */
    createMunicipalityAssistantDocument(command: CreateMunicipalityAssistantDocumentRequest, cancelToken?: CancelToken): Promise<CreateMunicipalityAssistantDocumentResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/commands/createmunicipalityassistantdocument`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteDialogSupportPromptRequest
     * @return DeleteDialogSupportPromptResponse
     */
    deleteDialogSupportPrompt(command: DeleteDialogSupportPromptRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/commands/deletedialogsupportprompt`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteGlossaryTermRequest
     * @return DeleteGlossaryTermResponse
     */
    deleteGlossaryTerm(command: DeleteGlossaryTermRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/commands/deleteglossaryterm`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command DeleteMunicipalityAssistantDocumentRequest
     * @return DeleteMunicipalityAssistantDocumentResponse
     */
    deleteMunicipalityAssistantDocument(command: DeleteMunicipalityAssistantDocumentRequest, cancelToken?: CancelToken): Promise<DeleteMunicipalityAssistantDocumentResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/commands/deletemunicipalityassistantdocument`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SaveAssessmentPromptRequest
     * @return SaveAssessmentPromptResponse
     */
    saveAssessmentPrompt(command: SaveAssessmentPromptRequest, cancelToken?: CancelToken): Promise<SaveAssessmentPromptResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/commands/saveassessmentprompt`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command SaveDialogSupportInstructionRequest
     * @return SaveDialogSupportInstructionResponse
     */
    saveDialogSupportInstruction(command: SaveDialogSupportInstructionRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/commands/savedialogsupportinstruction`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateGlossaryTermRequest
     * @return UpdateGlossaryTermResponse
     */
    updateGlossaryTerm(command: UpdateGlossaryTermRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/commands/updateglossaryterm`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpdateMunicipalityAssistantDocumentRequest
     * @return UpdateMunicipalityAssistantDocumentResponse
     */
    updateMunicipalityAssistantDocument(command: UpdateMunicipalityAssistantDocumentRequest, cancelToken?: CancelToken): Promise<UpdateMunicipalityAssistantDocumentResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/commands/updatemunicipalityassistantdocument`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UploadDraftMunicipalityDocumentRequest
     * @return UploadDraftMunicipalityDocumentResponse
     */
    uploadDraftMunicipalityDocument(command: UploadDraftMunicipalityDocumentRequest, cancelToken?: CancelToken): Promise<UploadDraftMunicipalityDocumentResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/commands/uploaddraftmunicipalitydocument`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param command UpsertMunicipalityAssistantDocumentRequest
     * @return UpsertMunicipalityAssistantDocumentResponse
     */
    upsertMunicipalityAssistantDocument(command: UpsertMunicipalityAssistantDocumentRequest, cancelToken?: CancelToken): Promise<UpsertMunicipalityAssistantDocumentResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/commands/upsertmunicipalityassistantdocument`;

        const options_: AxiosRequestConfig = {
            data: command,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query CheckExistingMunicipalityDocumentFilesRequest
     * @return CheckExistingMunicipalityDocumentFilesResponse
     */
    checkExistingMunicipalityDocumentFiles(query: CheckExistingMunicipalityDocumentFilesRequest, cancelToken?: CancelToken): Promise<CheckExistingMunicipalityDocumentFilesResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/queries/checkexistingmunicipalitydocumentfiles`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetAssessmentPromptsForAdminResponse
     */
    getAssessmentPromptsForAdmin(cancelToken?: CancelToken): Promise<GetAssessmentPromptsForAdminResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/queries/getassessmentpromptsforadmin`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDialogSupportInstructionForAdminRequest
     * @return GetDialogSupportInstructionForAdminResponse
     */
    getDialogSupportInstructionForAdmin(query: GetDialogSupportInstructionForAdminRequest, cancelToken?: CancelToken): Promise<GetDialogSupportInstructionForAdminResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/queries/getdialogsupportinstructionforadmin`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetDialogSupportPromptOptionsResponse
     */
    getDialogSupportPromptOptions(cancelToken?: CancelToken): Promise<GetDialogSupportPromptOptionsResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/queries/getdialogsupportpromptoptions`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetDialogSupportPromptsForAdminResponse
     */
    getDialogSupportPromptsForAdmin(cancelToken?: CancelToken): Promise<GetDialogSupportPromptsForAdminResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/queries/getdialogsupportpromptsforadmin`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetGlossaryForAdminResponse
     */
    getGlossaryForAdmin(cancelToken?: CancelToken): Promise<GetGlossaryForAdminResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/queries/getglossaryforadmin`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetMunicipalityAssistantDocumentsResponse
     */
    getMunicipalityAssistantDocuments(cancelToken?: CancelToken): Promise<GetMunicipalityAssistantDocumentsResponse> {
        const $url = `${this.baseUrl}/api/admin/adminui/ai/queries/getmunicipalityassistantdocuments`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ITransactionLogClient {
    /**
     * @param query GetTransactionLogItemDetailsRequest
     * @return GetTransactionLogItemDetailsResponse
     */
    getTransactionLogItemDetails(query: GetTransactionLogItemDetailsRequest, cancelToken?: CancelToken): Promise<GetTransactionLogItemDetailsResponse>;
    /**
     * @param query SearchTransactionLogRequest
     * @return SearchTransactionLogResponse
     */
    searchTransactionLogs(query: SearchTransactionLogRequest, cancelToken?: CancelToken): Promise<SearchTransactionLogResponse>;
}

export class TransactionLogClient implements ITransactionLogClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetTransactionLogItemDetailsRequest
     * @return GetTransactionLogItemDetailsResponse
     */
    getTransactionLogItemDetails(query: GetTransactionLogItemDetailsRequest, cancelToken?: CancelToken): Promise<GetTransactionLogItemDetailsResponse> {
        const $url = `${this.baseUrl}/api/transactionlog/queries/gettransactionlogitemdetails`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query SearchTransactionLogRequest
     * @return SearchTransactionLogResponse
     */
    searchTransactionLogs(query: SearchTransactionLogRequest, cancelToken?: CancelToken): Promise<SearchTransactionLogResponse> {
        const $url = `${this.baseUrl}/api/transactionlog/queries/searchtransactionlogs`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ITenantAddonsClient {
    /**
     * @return GetEnabledTenantAddonConfigurationsResponse
     */
    getEnabledTenantAddonConfigurations(cancelToken?: CancelToken): Promise<GetEnabledTenantAddonConfigurationsResponse>;
    /**
     * @return GetEnabledTenantAddonsResponse
     */
    getEnabledTenantAddons(cancelToken?: CancelToken): Promise<GetEnabledTenantAddonsResponse>;
}

export class TenantAddonsClient implements ITenantAddonsClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @return GetEnabledTenantAddonConfigurationsResponse
     */
    getEnabledTenantAddonConfigurations(cancelToken?: CancelToken): Promise<GetEnabledTenantAddonConfigurationsResponse> {
        const $url = `${this.baseUrl}/api/tenantaddons/queries/getenabledtenantaddonconfigurations`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetEnabledTenantAddonsResponse
     */
    getEnabledTenantAddons(cancelToken?: CancelToken): Promise<GetEnabledTenantAddonsResponse> {
        const $url = `${this.baseUrl}/api/tenantaddons/queries/getenabledtenantaddons`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IServiceProviderUnitResourceUtilizationClient {
    /**
     * @param query GetResourceUtilizationRequest
     * @return GetResourceUtilizationResponse
     */
    getResourceUtilization(query: GetResourceUtilizationRequest, cancelToken?: CancelToken): Promise<GetResourceUtilizationResponse>;
}

export class ServiceProviderUnitResourceUtilizationClient implements IServiceProviderUnitResourceUtilizationClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetResourceUtilizationRequest
     * @return GetResourceUtilizationResponse
     */
    getResourceUtilization(query: GetResourceUtilizationRequest, cancelToken?: CancelToken): Promise<GetResourceUtilizationResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/resourceutilization/queries/getresourceutilization`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IServiceProviderUnitOverviewClient {
    /**
     * @param query AnalyzeServiceProviderUnitPatternsRequest
     * @return AnalyzeServiceProviderUnitPatternsResponse
     */
    analyzeServiceProviderUnitPatterns(query: AnalyzeServiceProviderUnitPatternsRequest, cancelToken?: CancelToken): Promise<AnalyzeServiceProviderUnitPatternsResponse>;
    /**
     * @param query GetServiceProviderUnitOverviewRequest
     * @return GetServiceProviderUnitOverviewResponse
     */
    getServiceProviderUnitOverview(query: GetServiceProviderUnitOverviewRequest, cancelToken?: CancelToken): Promise<GetServiceProviderUnitOverviewResponse>;
}

export class ServiceProviderUnitOverviewClient implements IServiceProviderUnitOverviewClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query AnalyzeServiceProviderUnitPatternsRequest
     * @return AnalyzeServiceProviderUnitPatternsResponse
     */
    analyzeServiceProviderUnitPatterns(query: AnalyzeServiceProviderUnitPatternsRequest, cancelToken?: CancelToken): Promise<AnalyzeServiceProviderUnitPatternsResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/overview/queries/analyzeserviceproviderunitpatterns`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderUnitOverviewRequest
     * @return GetServiceProviderUnitOverviewResponse
     */
    getServiceProviderUnitOverview(query: GetServiceProviderUnitOverviewRequest, cancelToken?: CancelToken): Promise<GetServiceProviderUnitOverviewResponse> {
        const $url = `${this.baseUrl}/api/serviceproviderunit/overview/queries/getserviceproviderunitoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IManagementInformationInterventionLadderClient {
    /**
     * @param query GetInterventionCostsRequest
     * @return GetInterventionCostsResponse
     */
    getInterventionCosts(query: GetInterventionCostsRequest, cancelToken?: CancelToken): Promise<GetInterventionCostsResponse>;
    /**
     * @param query GetInterventionLadderRequest
     * @return GetInterventionLadderResponse
     */
    getInterventionLadder(query: GetInterventionLadderRequest, cancelToken?: CancelToken): Promise<GetInterventionLadderResponse>;
    /**
     * @param query GetInterventionLengthsRequest
     * @return GetInterventionLengthsResponse
     */
    getInterventionLengths(query: GetInterventionLengthsRequest, cancelToken?: CancelToken): Promise<GetInterventionLengthsResponse>;
}

export class ManagementInformationInterventionLadderClient implements IManagementInformationInterventionLadderClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetInterventionCostsRequest
     * @return GetInterventionCostsResponse
     */
    getInterventionCosts(query: GetInterventionCostsRequest, cancelToken?: CancelToken): Promise<GetInterventionCostsResponse> {
        const $url = `${this.baseUrl}/api/managementinformation/interventionladder/queries/getinterventioncosts`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterventionLadderRequest
     * @return GetInterventionLadderResponse
     */
    getInterventionLadder(query: GetInterventionLadderRequest, cancelToken?: CancelToken): Promise<GetInterventionLadderResponse> {
        const $url = `${this.baseUrl}/api/managementinformation/interventionladder/queries/getinterventionladder`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInterventionLengthsRequest
     * @return GetInterventionLengthsResponse
     */
    getInterventionLengths(query: GetInterventionLengthsRequest, cancelToken?: CancelToken): Promise<GetInterventionLengthsResponse> {
        const $url = `${this.baseUrl}/api/managementinformation/interventionladder/queries/getinterventionlengths`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ILookupUserClient {
    /**
     * @param query GetTeamUsersByLookupQueryRequest
     * @return GetTeamUsersByLookupQueryResponse
     */
    getTeamUsersByLookupQuery(query: GetTeamUsersByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetTeamUsersByLookupQueryResponse>;
    /**
     * @param query GetUserByIdRequest
     * @return GetUserByIdResponse
     */
    getUserById(query: GetUserByIdRequest2, cancelToken?: CancelToken): Promise<GetUserByIdResponse2>;
    /**
     * @param query GetUsersByLookupQueryRequest
     * @return GetUsersByLookupQueryResponse
     */
    getUsersByLookupQuery(query: GetUsersByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetUsersByLookupQueryResponse>;
}

export class LookupUserClient implements ILookupUserClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetTeamUsersByLookupQueryRequest
     * @return GetTeamUsersByLookupQueryResponse
     */
    getTeamUsersByLookupQuery(query: GetTeamUsersByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetTeamUsersByLookupQueryResponse> {
        const $url = `${this.baseUrl}/api/lookup/user/queries/getteamusersbylookupquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUserByIdRequest
     * @return GetUserByIdResponse
     */
    getUserById(query: GetUserByIdRequest2, cancelToken?: CancelToken): Promise<GetUserByIdResponse2> {
        const $url = `${this.baseUrl}/api/lookup/user/queries/getuserbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetUsersByLookupQueryRequest
     * @return GetUsersByLookupQueryResponse
     */
    getUsersByLookupQuery(query: GetUsersByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetUsersByLookupQueryResponse> {
        const $url = `${this.baseUrl}/api/lookup/user/queries/getusersbylookupquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ILookupTeamClient {
    /**
     * @param query GetTeamByIdRequest
     * @return GetTeamByIdResponse
     */
    getTeamById(query: GetTeamByIdRequest2, cancelToken?: CancelToken): Promise<GetTeamByIdResponse2>;
    /**
     * @param query GetTeamsByLookupQueryRequest
     * @return GetTeamsByLookupQueryResponse
     */
    getTeamsByLookupQuery(query: GetTeamsByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetTeamsByLookupQueryResponse>;
}

export class LookupTeamClient implements ILookupTeamClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetTeamByIdRequest
     * @return GetTeamByIdResponse
     */
    getTeamById(query: GetTeamByIdRequest2, cancelToken?: CancelToken): Promise<GetTeamByIdResponse2> {
        const $url = `${this.baseUrl}/api/lookup/team/queries/getteambyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTeamsByLookupQueryRequest
     * @return GetTeamsByLookupQueryResponse
     */
    getTeamsByLookupQuery(query: GetTeamsByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetTeamsByLookupQueryResponse> {
        const $url = `${this.baseUrl}/api/lookup/team/queries/getteamsbylookupquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ILookupOfferClient {
    /**
     * @param query GetOfferByIdRequest
     * @return GetOfferByIdResponse
     */
    getOfferById(query: GetOfferByIdRequest2, cancelToken?: CancelToken): Promise<GetOfferByIdResponse2>;
    /**
     * @param query GetOfferLookupOptionsRequest
     * @return GetOfferLookupOptionsResponse
     */
    getOfferLookupOptions(query: GetOfferLookupOptionsRequest, cancelToken?: CancelToken): Promise<GetOfferLookupOptionsResponse>;
    /**
     * @param query GetOffersByLookupQueryRequest
     * @return GetOffersByLookupQueryResponse
     */
    getOffersByLookupQuery(query: GetOffersByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetOffersByLookupQueryResponse>;
    /**
     * @param query GetOffersForOfferTypeByLookupQueryRequest
     * @return GetOffersForOfferTypeByLookupQueryResponse
     */
    getOffersForOfferTypeByLookupQuery(query: GetOffersForOfferTypeByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetOffersForOfferTypeByLookupQueryResponse>;
}

export class LookupOfferClient implements ILookupOfferClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetOfferByIdRequest
     * @return GetOfferByIdResponse
     */
    getOfferById(query: GetOfferByIdRequest2, cancelToken?: CancelToken): Promise<GetOfferByIdResponse2> {
        const $url = `${this.baseUrl}/api/lookup/offer/queries/getofferbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOfferLookupOptionsRequest
     * @return GetOfferLookupOptionsResponse
     */
    getOfferLookupOptions(query: GetOfferLookupOptionsRequest, cancelToken?: CancelToken): Promise<GetOfferLookupOptionsResponse> {
        const $url = `${this.baseUrl}/api/lookup/offer/queries/getofferlookupoptions`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOffersByLookupQueryRequest
     * @return GetOffersByLookupQueryResponse
     */
    getOffersByLookupQuery(query: GetOffersByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetOffersByLookupQueryResponse> {
        const $url = `${this.baseUrl}/api/lookup/offer/queries/getoffersbylookupquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetOffersForOfferTypeByLookupQueryRequest
     * @return GetOffersForOfferTypeByLookupQueryResponse
     */
    getOffersForOfferTypeByLookupQuery(query: GetOffersForOfferTypeByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetOffersForOfferTypeByLookupQueryResponse> {
        const $url = `${this.baseUrl}/api/lookup/offer/queries/getoffersforoffertypebylookupquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ILookupContactPersonClient {
    /**
     * @param query GetContactPersonByIdRequest
     * @return GetContactPersonByIdResponse
     */
    getContactPersonById(query: GetContactPersonByIdRequest, cancelToken?: CancelToken): Promise<GetContactPersonByIdResponse>;
    /**
     * @param query GetContactPersonsByLookupQueryRequest
     * @return GetContactPersonsByLookupQueryResponse
     */
    getContactPersonsByLookupQuery(query: GetContactPersonsByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetContactPersonsByLookupQueryResponse>;
}

export class LookupContactPersonClient implements ILookupContactPersonClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetContactPersonByIdRequest
     * @return GetContactPersonByIdResponse
     */
    getContactPersonById(query: GetContactPersonByIdRequest, cancelToken?: CancelToken): Promise<GetContactPersonByIdResponse> {
        const $url = `${this.baseUrl}/api/lookup/contactperson/queries/getcontactpersonbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetContactPersonsByLookupQueryRequest
     * @return GetContactPersonsByLookupQueryResponse
     */
    getContactPersonsByLookupQuery(query: GetContactPersonsByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetContactPersonsByLookupQueryResponse> {
        const $url = `${this.baseUrl}/api/lookup/contactperson/queries/getcontactpersonsbylookupquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ILookupCompanyClient {
    /**
     * @param query GetCompaniesByLookupQueryRequest
     * @return GetCompaniesByLookupQueryResponse
     */
    getCompaniesByLookupQuery(query: GetCompaniesByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetCompaniesByLookupQueryResponse>;
    /**
     * @param query GetCompanyByIdRequest
     * @return GetCompanyByIdResponse
     */
    getCompanyById(query: GetCompanyByIdRequest, cancelToken?: CancelToken): Promise<GetCompanyByIdResponse>;
    /**
     * @param query GetCompanyByIdForLookupRequest
     * @return GetCompanyByIdForLookupResponse
     */
    getCompanyByIdForLookup(query: GetCompanyByIdForLookupRequest, cancelToken?: CancelToken): Promise<GetCompanyByIdForLookupResponse>;
}

export class LookupCompanyClient implements ILookupCompanyClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetCompaniesByLookupQueryRequest
     * @return GetCompaniesByLookupQueryResponse
     */
    getCompaniesByLookupQuery(query: GetCompaniesByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetCompaniesByLookupQueryResponse> {
        const $url = `${this.baseUrl}/api/lookup/company/queries/getcompaniesbylookupquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyByIdRequest
     * @return GetCompanyByIdResponse
     */
    getCompanyById(query: GetCompanyByIdRequest, cancelToken?: CancelToken): Promise<GetCompanyByIdResponse> {
        const $url = `${this.baseUrl}/api/lookup/company/queries/getcompanybyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyByIdForLookupRequest
     * @return GetCompanyByIdForLookupResponse
     */
    getCompanyByIdForLookup(query: GetCompanyByIdForLookupRequest, cancelToken?: CancelToken): Promise<GetCompanyByIdForLookupResponse> {
        const $url = `${this.baseUrl}/api/lookup/company/queries/getcompanybyidforlookup`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ILookupCitizenClient {
    /**
     * @param query GetCitizenLookupByIdRequest
     * @return GetCitizenLookupByIdResponse
     */
    getCitizenLookupById(query: GetCitizenLookupByIdRequest, cancelToken?: CancelToken): Promise<GetCitizenLookupByIdResponse>;
    /**
     * @param query GetCitizensByLookupQueryRequest
     * @return GetCitizensByLookupQueryResponse
     */
    getCitizensByLookupQuery(query: GetCitizensByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetCitizensByLookupQueryResponse>;
}

export class LookupCitizenClient implements ILookupCitizenClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetCitizenLookupByIdRequest
     * @return GetCitizenLookupByIdResponse
     */
    getCitizenLookupById(query: GetCitizenLookupByIdRequest, cancelToken?: CancelToken): Promise<GetCitizenLookupByIdResponse> {
        const $url = `${this.baseUrl}/api/lookup/citizen/queries/getcitizenlookupbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizensByLookupQueryRequest
     * @return GetCitizensByLookupQueryResponse
     */
    getCitizensByLookupQuery(query: GetCitizensByLookupQueryRequest, cancelToken?: CancelToken): Promise<GetCitizensByLookupQueryResponse> {
        const $url = `${this.baseUrl}/api/lookup/citizen/queries/getcitizensbylookupquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ILookupCaseClient {
    /**
     * @param query GetCitizenCasesLookupRequest
     * @return GetCitizenCasesLookupResponse
     */
    getCitizenCasesLookup(query: GetCitizenCasesLookupRequest, cancelToken?: CancelToken): Promise<GetCitizenCasesLookupResponse>;
}

export class LookupCaseClient implements ILookupCaseClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetCitizenCasesLookupRequest
     * @return GetCitizenCasesLookupResponse
     */
    getCitizenCasesLookup(query: GetCitizenCasesLookupRequest, cancelToken?: CancelToken): Promise<GetCitizenCasesLookupResponse> {
        const $url = `${this.baseUrl}/api/lookup/case/queries/getcitizencaseslookup`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IFeatureTogglesClient {
    /**
     * @return GetAllFeatureTogglesResponse
     */
    getAllFeatureToggles(cancelToken?: CancelToken): Promise<GetAllFeatureTogglesResponse>;
}

export class FeatureTogglesClient implements IFeatureTogglesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @return GetAllFeatureTogglesResponse
     */
    getAllFeatureToggles(cancelToken?: CancelToken): Promise<GetAllFeatureTogglesResponse> {
        const $url = `${this.baseUrl}/api/featuretoggles/queries/getallfeaturetoggles`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IDynamicLinksClient {
    /**
     * @return ConfiguredResourceTypesResponse
     */
    getConfiguredResourceTypes(cancelToken?: CancelToken): Promise<ConfiguredResourceTypesResponse>;
    /**
     * @param query DynamicLinksRequest
     * @return DynamicLinksResponse
     */
    getDynamicLinks(query: DynamicLinksRequest, cancelToken?: CancelToken): Promise<DynamicLinksResponse>;
    /**
     * @param query GetPostRequestParametersRequest
     * @return GetPostRequestParametersResponse
     */
    getPostRequestParameters(query: GetPostRequestParametersRequest, cancelToken?: CancelToken): Promise<GetPostRequestParametersResponse>;
}

export class DynamicLinksClient implements IDynamicLinksClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @return ConfiguredResourceTypesResponse
     */
    getConfiguredResourceTypes(cancelToken?: CancelToken): Promise<ConfiguredResourceTypesResponse> {
        const $url = `${this.baseUrl}/api/dynamiclinks/queries/getconfiguredresourcetypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DynamicLinksRequest
     * @return DynamicLinksResponse
     */
    getDynamicLinks(query: DynamicLinksRequest, cancelToken?: CancelToken): Promise<DynamicLinksResponse> {
        const $url = `${this.baseUrl}/api/dynamiclinks/queries/getdynamiclinks`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPostRequestParametersRequest
     * @return GetPostRequestParametersResponse
     */
    getPostRequestParameters(query: GetPostRequestParametersRequest, cancelToken?: CancelToken): Promise<GetPostRequestParametersResponse> {
        const $url = `${this.baseUrl}/api/dynamiclinks/queries/getpostrequestparameters`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IConfigurationClient {
    /**
     * @return GetAvailabilityTenantPropertiesResponse
     */
    getAvailabilityTenantProperties(cancelToken?: CancelToken): Promise<GetAvailabilityTenantPropertiesResponse>;
    /**
     * @return GetCrmHostUrlResponse
     */
    getCrmHostUrl(cancelToken?: CancelToken): Promise<GetCrmHostUrlResponse>;
    /**
     * @return GetCrTenantPropertiesResponse
     */
    getCrTenantProperties(cancelToken?: CancelToken): Promise<GetCrTenantPropertiesResponse>;
    /**
     * @return GetDfdgMaintenanceModeStatusResponse
     */
    getDfdgMaintenanceModeStatus(cancelToken?: CancelToken): Promise<GetDfdgMaintenanceModeStatusResponse>;
    /**
     * @return GetDteUrlResponse
     */
    getDteUrl(cancelToken?: CancelToken): Promise<GetDteUrlResponse>;
    /**
     * @return GetFormbricksSystemWideDisableStatusResponse
     */
    getFormbricksSystemWideDisableStatus(cancelToken?: CancelToken): Promise<GetFormbricksSystemWideDisableStatusResponse>;
    /**
     * @return GetIsAiDemoEmailDomainAllowedResponse
     */
    getIsAiDemoEmailDomainAllowed(cancelToken?: CancelToken): Promise<GetIsAiDemoEmailDomainAllowedResponse>;
    /**
     * @return GetOaTenantPropertiesResponse
     */
    getOaTenantProperties(cancelToken?: CancelToken): Promise<GetOaTenantPropertiesResponse>;
    /**
     * @return GetSchultzCaseConfigurationResponse
     */
    getSchultzCaseConfiguration(cancelToken?: CancelToken): Promise<GetSchultzCaseConfigurationResponse>;
    /**
     * @return GetSystemConfigurationResponse
     */
    getSystemConfiguration(cancelToken?: CancelToken): Promise<GetSystemConfigurationResponse>;
    /**
     * @return GetTenantConfigurationResponse
     */
    getTenantConfiguration(cancelToken?: CancelToken): Promise<GetTenantConfigurationResponse>;
    /**
     * @return GetTenantDisplayNameResponse
     */
    getTenantDisplayName(cancelToken?: CancelToken): Promise<GetTenantDisplayNameResponse>;
}

export class ConfigurationClient implements IConfigurationClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @return GetAvailabilityTenantPropertiesResponse
     */
    getAvailabilityTenantProperties(cancelToken?: CancelToken): Promise<GetAvailabilityTenantPropertiesResponse> {
        const $url = `${this.baseUrl}/api/configuration/queries/getavailabilitytenantproperties`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCrmHostUrlResponse
     */
    getCrmHostUrl(cancelToken?: CancelToken): Promise<GetCrmHostUrlResponse> {
        const $url = `${this.baseUrl}/api/configuration/queries/getcrmhosturl`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCrTenantPropertiesResponse
     */
    getCrTenantProperties(cancelToken?: CancelToken): Promise<GetCrTenantPropertiesResponse> {
        const $url = `${this.baseUrl}/api/configuration/queries/getcrtenantproperties`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetDfdgMaintenanceModeStatusResponse
     */
    getDfdgMaintenanceModeStatus(cancelToken?: CancelToken): Promise<GetDfdgMaintenanceModeStatusResponse> {
        const $url = `${this.baseUrl}/api/configuration/queries/getdfdgmaintenancemodestatus`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetDteUrlResponse
     */
    getDteUrl(cancelToken?: CancelToken): Promise<GetDteUrlResponse> {
        const $url = `${this.baseUrl}/api/configuration/queries/getdteurl`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetFormbricksSystemWideDisableStatusResponse
     */
    getFormbricksSystemWideDisableStatus(cancelToken?: CancelToken): Promise<GetFormbricksSystemWideDisableStatusResponse> {
        const $url = `${this.baseUrl}/api/configuration/queries/getformbrickssystemwidedisablestatus`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetIsAiDemoEmailDomainAllowedResponse
     */
    getIsAiDemoEmailDomainAllowed(cancelToken?: CancelToken): Promise<GetIsAiDemoEmailDomainAllowedResponse> {
        const $url = `${this.baseUrl}/api/configuration/queries/getisaidemoemaildomainallowed`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOaTenantPropertiesResponse
     */
    getOaTenantProperties(cancelToken?: CancelToken): Promise<GetOaTenantPropertiesResponse> {
        const $url = `${this.baseUrl}/api/configuration/queries/getoatenantproperties`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSchultzCaseConfigurationResponse
     */
    getSchultzCaseConfiguration(cancelToken?: CancelToken): Promise<GetSchultzCaseConfigurationResponse> {
        const $url = `${this.baseUrl}/api/configuration/queries/getschultzcaseconfiguration`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetSystemConfigurationResponse
     */
    getSystemConfiguration(cancelToken?: CancelToken): Promise<GetSystemConfigurationResponse> {
        const $url = `${this.baseUrl}/api/configuration/queries/getsystemconfiguration`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTenantConfigurationResponse
     */
    getTenantConfiguration(cancelToken?: CancelToken): Promise<GetTenantConfigurationResponse> {
        const $url = `${this.baseUrl}/api/configuration/queries/gettenantconfiguration`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTenantDisplayNameResponse
     */
    getTenantDisplayName(cancelToken?: CancelToken): Promise<GetTenantDisplayNameResponse> {
        const $url = `${this.baseUrl}/api/configuration/queries/gettenantdisplayname`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyClient {
    /**
     * @return GetAccountGroupsResponse
     */
    getAccountGroups(cancelToken?: CancelToken): Promise<GetAccountGroupsResponse>;
    /**
     * @param query GetCompaniesBasicRequest
     * @return GetCompaniesBasicResponse
     */
    getCompaniesBasicInformation(query: GetCompaniesBasicRequest, cancelToken?: CancelToken): Promise<GetCompaniesBasicResponse>;
    /**
     * @param query GetCompanyAttentionNotesRequest
     * @return GetCompanyAttentionNotesResponse
     */
    getCompanyAttentionNotes(query: GetCompanyAttentionNotesRequest, cancelToken?: CancelToken): Promise<GetCompanyAttentionNotesResponse>;
    /**
     * @param query GetCompanyBasicRequest
     * @return GetCompanyBasicResponse
     */
    getCompanyBasicInformation(query: GetCompanyBasicRequest, cancelToken?: CancelToken): Promise<GetCompanyBasicResponse>;
    /**
     * @param query GetCompanyIdByAssociatedCaseWorkerIdRequest
     * @return GetCompanyIdByAssociatedCaseWorkerIdResponse
     */
    getCompanyIdByAssociatedCaseWorkerId(query: GetCompanyIdByAssociatedCaseWorkerIdRequest, cancelToken?: CancelToken): Promise<GetCompanyIdByAssociatedCaseWorkerIdResponse>;
    /**
     * @param query GetCompanyIdByLabourNeedIdRequest
     * @return GetCompanyIdByLabourNeedIdResponse
     */
    getCompanyIdByLabourNeedId(query: GetCompanyIdByLabourNeedIdRequest, cancelToken?: CancelToken): Promise<GetCompanyIdByLabourNeedIdResponse>;
    /**
     * @param query GetCompanyCrmFeatureSettingRequest
     * @return GetCompanyCrmFeatureSettingResponse
     */
    getCrmFeatureSetting(query: GetCompanyCrmFeatureSettingRequest, cancelToken?: CancelToken): Promise<GetCompanyCrmFeatureSettingResponse>;
}

export class CompanyClient implements ICompanyClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @return GetAccountGroupsResponse
     */
    getAccountGroups(cancelToken?: CancelToken): Promise<GetAccountGroupsResponse> {
        const $url = `${this.baseUrl}/api/company/queries/getaccountgroups`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompaniesBasicRequest
     * @return GetCompaniesBasicResponse
     */
    getCompaniesBasicInformation(query: GetCompaniesBasicRequest, cancelToken?: CancelToken): Promise<GetCompaniesBasicResponse> {
        const $url = `${this.baseUrl}/api/company/queries/getcompaniesbasicinformation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyAttentionNotesRequest
     * @return GetCompanyAttentionNotesResponse
     */
    getCompanyAttentionNotes(query: GetCompanyAttentionNotesRequest, cancelToken?: CancelToken): Promise<GetCompanyAttentionNotesResponse> {
        const $url = `${this.baseUrl}/api/company/queries/getcompanyattentionnotes`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyBasicRequest
     * @return GetCompanyBasicResponse
     */
    getCompanyBasicInformation(query: GetCompanyBasicRequest, cancelToken?: CancelToken): Promise<GetCompanyBasicResponse> {
        const $url = `${this.baseUrl}/api/company/queries/getcompanybasicinformation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyIdByAssociatedCaseWorkerIdRequest
     * @return GetCompanyIdByAssociatedCaseWorkerIdResponse
     */
    getCompanyIdByAssociatedCaseWorkerId(query: GetCompanyIdByAssociatedCaseWorkerIdRequest, cancelToken?: CancelToken): Promise<GetCompanyIdByAssociatedCaseWorkerIdResponse> {
        const $url = `${this.baseUrl}/api/company/queries/getcompanyidbyassociatedcaseworkerid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyIdByLabourNeedIdRequest
     * @return GetCompanyIdByLabourNeedIdResponse
     */
    getCompanyIdByLabourNeedId(query: GetCompanyIdByLabourNeedIdRequest, cancelToken?: CancelToken): Promise<GetCompanyIdByLabourNeedIdResponse> {
        const $url = `${this.baseUrl}/api/company/queries/getcompanyidbylabourneedid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyCrmFeatureSettingRequest
     * @return GetCompanyCrmFeatureSettingResponse
     */
    getCrmFeatureSetting(query: GetCompanyCrmFeatureSettingRequest, cancelToken?: CancelToken): Promise<GetCompanyCrmFeatureSettingResponse> {
        const $url = `${this.baseUrl}/api/company/queries/getcrmfeaturesetting`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyFvdbClient {
    /**
     * @param query GetFvdbContactsRequest
     * @return GetFvdbContactsResponse
     */
    getFvdbContacts(query: GetFvdbContactsRequest, cancelToken?: CancelToken): Promise<GetFvdbContactsResponse>;
}

export class CompanyFvdbClient implements ICompanyFvdbClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetFvdbContactsRequest
     * @return GetFvdbContactsResponse
     */
    getFvdbContacts(query: GetFvdbContactsRequest, cancelToken?: CancelToken): Promise<GetFvdbContactsResponse> {
        const $url = `${this.baseUrl}/api/company/fvdb/queries/getfvdbcontacts`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyDetailsClient {
    /**
     * @param query GetCompanyDetailsByIdRequest
     * @return GetCompanyDetailsByIdResponse
     */
    getCompanyDetailsById(query: GetCompanyDetailsByIdRequest, cancelToken?: CancelToken): Promise<GetCompanyDetailsByIdResponse>;
    /**
     * @param query GetCompanyNoteRequest
     * @return GetCompanyNoteResponse
     */
    getCompanyNote(query: GetCompanyNoteRequest, cancelToken?: CancelToken): Promise<GetCompanyNoteResponse>;
    /**
     * @param query GetEmploymentOverviewRequest
     * @return GetEmploymentOverviewResponse
     */
    getEmploymentOverview(query: GetEmploymentOverviewRequest, cancelToken?: CancelToken): Promise<GetEmploymentOverviewResponse>;
    /**
     * @param query GetLabourNeedByIdRequest
     * @return GetLabourNeedByIdResponse
     */
    getLabourNeedById(query: GetLabourNeedByIdRequest, cancelToken?: CancelToken): Promise<GetLabourNeedByIdResponse>;
    /**
     * @param query GetLabourNeedsForCompanyRequest
     * @return GetLabourNeedsForCompanyResponse
     */
    getLabourNeedsForCompany(query: GetLabourNeedsForCompanyRequest, cancelToken?: CancelToken): Promise<GetLabourNeedsForCompanyResponse>;
    /**
     * @param query GetLatestAccountNoteRequest
     * @return GetLatestAccountNoteResponse
     */
    getLatestAccountNote(query: GetLatestAccountNoteRequest, cancelToken?: CancelToken): Promise<GetLatestAccountNoteResponse>;
    /**
     * @param query GetNextAppointmentRequest
     * @return GetNextAppointmentResponse
     */
    getNextAppointment(query: GetNextAppointmentRequest, cancelToken?: CancelToken): Promise<GetNextAppointmentResponse>;
    /**
     * @param query GetNumberOfActiveSickLeaveAbsencesRequest
     * @return GetNumberOfActiveSickLeaveAbsencesResponse
     */
    getNumberOfActiveSickLeaveAbsences(query: GetNumberOfActiveSickLeaveAbsencesRequest, cancelToken?: CancelToken): Promise<GetNumberOfActiveSickLeaveAbsencesResponse>;
    /**
     * @return GetOccupationListResponse
     */
    getOccupationList(cancelToken?: CancelToken): Promise<GetOccupationListResponse>;
    /**
     * @return GetOccupationQualificationsListResponse
     */
    getOccupationQualificationList(cancelToken?: CancelToken): Promise<GetOccupationQualificationsListResponse>;
    /**
     * @param query GetPrimaryCompanyContactPersonRequest
     * @return GetPrimaryCompanyContactPersonResponse
     */
    getPrimaryCompanyContactPerson(query: GetPrimaryCompanyContactPersonRequest, cancelToken?: CancelToken): Promise<GetPrimaryCompanyContactPersonResponse>;
    /**
     * @return GetTargetGroupListResponse
     */
    getTargetGroupList(cancelToken?: CancelToken): Promise<GetTargetGroupListResponse>;
    /**
     * @return GetTradeCodeListResponse
     */
    getTradeCodeList(cancelToken?: CancelToken): Promise<GetTradeCodeListResponse>;
    /**
     * @param query DeleteLabourNeedRequest
     * @return DeleteLabourNeedResponse
     */
    deleteLabourNeed(query: DeleteLabourNeedRequest, cancelToken?: CancelToken): Promise<DeleteLabourNeedResponse>;
    /**
     * @param query SetPrimaryCompanyContactPersonRequest
     * @return SetPrimaryCompanyContactPersonResponse
     */
    setPrimaryCompanyContactPerson(query: SetPrimaryCompanyContactPersonRequest, cancelToken?: CancelToken): Promise<any>;
    /**
     * @param query UpsertCompanyNoteRequest
     * @return UpsertCompanyNoteResponse
     */
    upsertCompanyNote(query: UpsertCompanyNoteRequest, cancelToken?: CancelToken): Promise<UpsertCompanyNoteResponse>;
    /**
     * @param query UpsertLabourNeedsRequest
     * @return UpsertLabourNeedsResponse
     */
    upsertLabourNeeds(query: UpsertLabourNeedsRequest, cancelToken?: CancelToken): Promise<UpsertLabourNeedsResponse>;
    /**
     * @param query UpsertResponsibleCaseWorkerOrTeamRequest
     * @return UpsertResponsibleCaseWorkerOrTeamResponse
     */
    upsertResponsibleCaseWorkerOrTeam(query: UpsertResponsibleCaseWorkerOrTeamRequest, cancelToken?: CancelToken): Promise<UpsertResponsibleCaseWorkerOrTeamResponse>;
}

export class CompanyDetailsClient implements ICompanyDetailsClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetCompanyDetailsByIdRequest
     * @return GetCompanyDetailsByIdResponse
     */
    getCompanyDetailsById(query: GetCompanyDetailsByIdRequest, cancelToken?: CancelToken): Promise<GetCompanyDetailsByIdResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/getcompanydetailsbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyNoteRequest
     * @return GetCompanyNoteResponse
     */
    getCompanyNote(query: GetCompanyNoteRequest, cancelToken?: CancelToken): Promise<GetCompanyNoteResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/getcompanynote`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEmploymentOverviewRequest
     * @return GetEmploymentOverviewResponse
     */
    getEmploymentOverview(query: GetEmploymentOverviewRequest, cancelToken?: CancelToken): Promise<GetEmploymentOverviewResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/getemploymentoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLabourNeedByIdRequest
     * @return GetLabourNeedByIdResponse
     */
    getLabourNeedById(query: GetLabourNeedByIdRequest, cancelToken?: CancelToken): Promise<GetLabourNeedByIdResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/getlabourneedbyid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLabourNeedsForCompanyRequest
     * @return GetLabourNeedsForCompanyResponse
     */
    getLabourNeedsForCompany(query: GetLabourNeedsForCompanyRequest, cancelToken?: CancelToken): Promise<GetLabourNeedsForCompanyResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/getlabourneedsforcompany`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetLatestAccountNoteRequest
     * @return GetLatestAccountNoteResponse
     */
    getLatestAccountNote(query: GetLatestAccountNoteRequest, cancelToken?: CancelToken): Promise<GetLatestAccountNoteResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/getlatestaccountnote`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNextAppointmentRequest
     * @return GetNextAppointmentResponse
     */
    getNextAppointment(query: GetNextAppointmentRequest, cancelToken?: CancelToken): Promise<GetNextAppointmentResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/getnextappointment`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNumberOfActiveSickLeaveAbsencesRequest
     * @return GetNumberOfActiveSickLeaveAbsencesResponse
     */
    getNumberOfActiveSickLeaveAbsences(query: GetNumberOfActiveSickLeaveAbsencesRequest, cancelToken?: CancelToken): Promise<GetNumberOfActiveSickLeaveAbsencesResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/getnumberofactivesickleaveabsences`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOccupationListResponse
     */
    getOccupationList(cancelToken?: CancelToken): Promise<GetOccupationListResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/getoccupationlist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetOccupationQualificationsListResponse
     */
    getOccupationQualificationList(cancelToken?: CancelToken): Promise<GetOccupationQualificationsListResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/getoccupationqualificationlist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPrimaryCompanyContactPersonRequest
     * @return GetPrimaryCompanyContactPersonResponse
     */
    getPrimaryCompanyContactPerson(query: GetPrimaryCompanyContactPersonRequest, cancelToken?: CancelToken): Promise<GetPrimaryCompanyContactPersonResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/getprimarycompanycontactperson`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTargetGroupListResponse
     */
    getTargetGroupList(cancelToken?: CancelToken): Promise<GetTargetGroupListResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/gettargetgrouplist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetTradeCodeListResponse
     */
    getTradeCodeList(cancelToken?: CancelToken): Promise<GetTradeCodeListResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/gettradecodelist`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query DeleteLabourNeedRequest
     * @return DeleteLabourNeedResponse
     */
    deleteLabourNeed(query: DeleteLabourNeedRequest, cancelToken?: CancelToken): Promise<DeleteLabourNeedResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/deletelabourneed`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query SetPrimaryCompanyContactPersonRequest
     * @return SetPrimaryCompanyContactPersonResponse
     */
    setPrimaryCompanyContactPerson(query: SetPrimaryCompanyContactPersonRequest, cancelToken?: CancelToken): Promise<any> {
        const $url = `${this.baseUrl}/api/company/details/queries/setprimarycompanycontactperson`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query UpsertCompanyNoteRequest
     * @return UpsertCompanyNoteResponse
     */
    upsertCompanyNote(query: UpsertCompanyNoteRequest, cancelToken?: CancelToken): Promise<UpsertCompanyNoteResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/upsertcompanynote`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query UpsertLabourNeedsRequest
     * @return UpsertLabourNeedsResponse
     */
    upsertLabourNeeds(query: UpsertLabourNeedsRequest, cancelToken?: CancelToken): Promise<UpsertLabourNeedsResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/upsertlabourneeds`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query UpsertResponsibleCaseWorkerOrTeamRequest
     * @return UpsertResponsibleCaseWorkerOrTeamResponse
     */
    upsertResponsibleCaseWorkerOrTeam(query: UpsertResponsibleCaseWorkerOrTeamRequest, cancelToken?: CancelToken): Promise<UpsertResponsibleCaseWorkerOrTeamResponse> {
        const $url = `${this.baseUrl}/api/company/details/queries/upsertresponsiblecaseworkerorteam`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyCompanyVisitPreparationClient {
    /**
     * @param query GetCompanyVisitActivitiesRequest
     * @return GetCompanyVisitActivitiesResponse
     */
    getCompanyVisitActivities(query: GetCompanyVisitActivitiesRequest, cancelToken?: CancelToken): Promise<GetCompanyVisitActivitiesResponse>;
    /**
     * @param query GetCompanyVisitCompanyInfoExtendedRequest
     * @return GetCompanyVisitCompanyInfoExtendedResponse
     */
    getCompanyVisitCompanyInfoExtended(query: GetCompanyVisitCompanyInfoExtendedRequest, cancelToken?: CancelToken): Promise<GetCompanyVisitCompanyInfoExtendedResponse>;
    /**
     * @param query GetCompanyVisitRecruitmentsRequest
     * @return GetCompanyVisitRecruitmentsResponse
     */
    getCompanyVisitRecruitments(query: GetCompanyVisitRecruitmentsRequest, cancelToken?: CancelToken): Promise<GetCompanyVisitRecruitmentsResponse>;
    /**
     * @param query CompanyVisitPreparationHighlightOverviewRequest
     * @return CompanyVisitPreparationHighlightOverviewResponse
     */
    companyVisitPreparationHighlightOverview(query: CompanyVisitPreparationHighlightOverviewRequest, cancelToken?: CancelToken): Promise<CompanyVisitPreparationHighlightOverviewResponse>;
    /**
     * @param query GetNotesAndTasksOverviewRequest
     * @return GetNotesAndTasksOverviewResponse
     */
    getNotesAndTasksOverview(query: GetNotesAndTasksOverviewRequest, cancelToken?: CancelToken): Promise<GetNotesAndTasksOverviewResponse>;
}

export class CompanyCompanyVisitPreparationClient implements ICompanyCompanyVisitPreparationClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetCompanyVisitActivitiesRequest
     * @return GetCompanyVisitActivitiesResponse
     */
    getCompanyVisitActivities(query: GetCompanyVisitActivitiesRequest, cancelToken?: CancelToken): Promise<GetCompanyVisitActivitiesResponse> {
        const $url = `${this.baseUrl}/api/company/companyvisitpreparation/queries/getcompanyvisitactivities`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyVisitCompanyInfoExtendedRequest
     * @return GetCompanyVisitCompanyInfoExtendedResponse
     */
    getCompanyVisitCompanyInfoExtended(query: GetCompanyVisitCompanyInfoExtendedRequest, cancelToken?: CancelToken): Promise<GetCompanyVisitCompanyInfoExtendedResponse> {
        const $url = `${this.baseUrl}/api/company/companyvisitpreparation/queries/getcompanyvisitcompanyinfoextended`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCompanyVisitRecruitmentsRequest
     * @return GetCompanyVisitRecruitmentsResponse
     */
    getCompanyVisitRecruitments(query: GetCompanyVisitRecruitmentsRequest, cancelToken?: CancelToken): Promise<GetCompanyVisitRecruitmentsResponse> {
        const $url = `${this.baseUrl}/api/company/companyvisitpreparation/queries/getcompanyvisitrecruitments`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query CompanyVisitPreparationHighlightOverviewRequest
     * @return CompanyVisitPreparationHighlightOverviewResponse
     */
    companyVisitPreparationHighlightOverview(query: CompanyVisitPreparationHighlightOverviewRequest, cancelToken?: CancelToken): Promise<CompanyVisitPreparationHighlightOverviewResponse> {
        const $url = `${this.baseUrl}/api/company/companyvisitpreparation/queries/companyvisitpreparationhighlightoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNotesAndTasksOverviewRequest
     * @return GetNotesAndTasksOverviewResponse
     */
    getNotesAndTasksOverview(query: GetNotesAndTasksOverviewRequest, cancelToken?: CancelToken): Promise<GetNotesAndTasksOverviewResponse> {
        const $url = `${this.baseUrl}/api/company/companyvisitpreparation/queries/getnotesandtasksoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyCommunicationTemplatesClient {
    /**
     * @return GetCompanyCrowdLetterTemplatesResponse
     */
    getCrowdLetterTemplates(cancelToken?: CancelToken): Promise<GetCompanyCrowdLetterTemplatesResponse>;
    /**
     * @return GetCompanyTemplatesResponse
     */
    getCompanyTemplates(cancelToken?: CancelToken): Promise<GetCompanyTemplatesResponse>;
    /**
     * @param query GetEditableContentRequest
     * @return GetEditableContentResponse
     */
    getEditableContent(query: GetEditableContentRequest, cancelToken?: CancelToken): Promise<GetEditableContentResponse>;
}

export class CompanyCommunicationTemplatesClient implements ICompanyCommunicationTemplatesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @return GetCompanyCrowdLetterTemplatesResponse
     */
    getCrowdLetterTemplates(cancelToken?: CancelToken): Promise<GetCompanyCrowdLetterTemplatesResponse> {
        const $url = `${this.baseUrl}/api/company/communication/templates/queries/getcrowdlettertemplates`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCompanyTemplatesResponse
     */
    getCompanyTemplates(cancelToken?: CancelToken): Promise<GetCompanyTemplatesResponse> {
        const $url = `${this.baseUrl}/api/company/communication/templates/queries/getcompanytemplates`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEditableContentRequest
     * @return GetEditableContentResponse
     */
    getEditableContent(query: GetEditableContentRequest, cancelToken?: CancelToken): Promise<GetEditableContentResponse> {
        const $url = `${this.baseUrl}/api/company/communication/templates/queries/geteditablecontent`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyChangeLogClient {
    /**
     * @param query GetCompanyChangeLogsByQueryRequest
     * @return GetCompanyChangeLogsByQueryResponse
     */
    getCompanyChangeLogsByQuery(query: GetCompanyChangeLogsByQueryRequest, cancelToken?: CancelToken): Promise<GetCompanyChangeLogsByQueryResponse>;
    /**
     * @return GetCompanyPostTypesResponse
     */
    getCompanyPostTypes(cancelToken?: CancelToken): Promise<GetCompanyPostTypesResponse>;
}

export class CompanyChangeLogClient implements ICompanyChangeLogClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetCompanyChangeLogsByQueryRequest
     * @return GetCompanyChangeLogsByQueryResponse
     */
    getCompanyChangeLogsByQuery(query: GetCompanyChangeLogsByQueryRequest, cancelToken?: CancelToken): Promise<GetCompanyChangeLogsByQueryResponse> {
        const $url = `${this.baseUrl}/api/company/changelog/queries/getcompanychangelogsbyquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCompanyPostTypesResponse
     */
    getCompanyPostTypes(cancelToken?: CancelToken): Promise<GetCompanyPostTypesResponse> {
        const $url = `${this.baseUrl}/api/company/changelog/queries/getcompanyposttypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICompanyAvailabilityClient {
    /**
     * @param query GetAbsencesForCompanyRequest
     * @return GetAbsencesForCompanyResponse
     */
    getAbsencesForCompany(query: GetAbsencesForCompanyRequest, cancelToken?: CancelToken): Promise<GetAbsencesForCompanyResponse>;
}

export class CompanyAvailabilityClient implements ICompanyAvailabilityClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetAbsencesForCompanyRequest
     * @return GetAbsencesForCompanyResponse
     */
    getAbsencesForCompany(query: GetAbsencesForCompanyRequest, cancelToken?: CancelToken): Promise<GetAbsencesForCompanyResponse> {
        const $url = `${this.baseUrl}/api/company/availability/queries/getabsencesforcompany`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenTimelineClient {
    /**
     * @param query GetTimelineDataByCitizenIdRequest
     * @return GetTimelineDataByCitizenIdResponse
     */
    getTimelineDataByCitizenId(query: GetTimelineDataByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetTimelineDataByCitizenIdResponse>;
}

export class CitizenTimelineClient implements ICitizenTimelineClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetTimelineDataByCitizenIdRequest
     * @return GetTimelineDataByCitizenIdResponse
     */
    getTimelineDataByCitizenId(query: GetTimelineDataByCitizenIdRequest, cancelToken?: CancelToken): Promise<GetTimelineDataByCitizenIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/timeline/queries/gettimelinedatabycitizenid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenSurveysForumFeedbackClient {
    /**
     * @param query GetForumFeedbackSurveysRequest
     * @return GetForumFeedbackSurveysResponse
     */
    getForumFeedbackSurveys(query: GetForumFeedbackSurveysRequest, cancelToken?: CancelToken): Promise<GetForumFeedbackSurveysResponse>;
}

export class CitizenSurveysForumFeedbackClient implements ICitizenSurveysForumFeedbackClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetForumFeedbackSurveysRequest
     * @return GetForumFeedbackSurveysResponse
     */
    getForumFeedbackSurveys(query: GetForumFeedbackSurveysRequest, cancelToken?: CancelToken): Promise<GetForumFeedbackSurveysResponse> {
        const $url = `${this.baseUrl}/api/citizen/surveys/forumfeedback/queries/getforumfeedbacksurveys`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenStandardPhrasesClient {
    /**
     * @param query GetStandardPhrasesRequest
     * @return GetStandardPhrasesResponse
     */
    getStandardPhrases(query: GetStandardPhrasesRequest, cancelToken?: CancelToken): Promise<GetStandardPhrasesResponse2>;
}

export class CitizenStandardPhrasesClient implements ICitizenStandardPhrasesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetStandardPhrasesRequest
     * @return GetStandardPhrasesResponse
     */
    getStandardPhrases(query: GetStandardPhrasesRequest, cancelToken?: CancelToken): Promise<GetStandardPhrasesResponse2> {
        const $url = `${this.baseUrl}/api/citizen/standardphrases/queries/getstandardphrases`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenSicknessBenefitResumedWorkClient {
    /**
     * @param query GetCitizenIdFromResumedWorkIdRequest
     * @return GetCitizenIdFromResumedWorkIdResponse
     */
    getCitizenIdFromResumedWorkId(query: GetCitizenIdFromResumedWorkIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdFromResumedWorkIdResponse>;
    /**
     * @param query GetResumedWorkByCaseIdRequest
     * @return GetResumedWorkByCaseIdResponse
     */
    getResumedWorkByCaseId(query: GetResumedWorkByCaseIdRequest, cancelToken?: CancelToken): Promise<GetResumedWorkByCaseIdResponse>;
}

export class CitizenSicknessBenefitResumedWorkClient implements ICitizenSicknessBenefitResumedWorkClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetCitizenIdFromResumedWorkIdRequest
     * @return GetCitizenIdFromResumedWorkIdResponse
     */
    getCitizenIdFromResumedWorkId(query: GetCitizenIdFromResumedWorkIdRequest, cancelToken?: CancelToken): Promise<GetCitizenIdFromResumedWorkIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/resumedwork/queries/getcitizenidfromresumedworkid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetResumedWorkByCaseIdRequest
     * @return GetResumedWorkByCaseIdResponse
     */
    getResumedWorkByCaseId(query: GetResumedWorkByCaseIdRequest, cancelToken?: CancelToken): Promise<GetResumedWorkByCaseIdResponse> {
        const $url = `${this.baseUrl}/api/citizen/sicknessbenefit/resumedwork/queries/getresumedworkbycaseid`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderSpLinkClient {
    /**
     * @param query GetSpLinkAvailabilityRequest
     * @return GetSpLinkAvailabilityResponse
     */
    getSpLinkAvailability(query: GetSpLinkAvailabilityRequest, cancelToken?: CancelToken): Promise<GetSpLinkAvailabilityResponse>;
    /**
     * @param query GetSpLinkUrlRequest
     * @return GetSpLinkUrlResponse
     */
    getSpLinkUrl(query: GetSpLinkUrlRequest, cancelToken?: CancelToken): Promise<GetSpLinkUrlResponse>;
}

export class CitizenServiceProviderSpLinkClient implements ICitizenServiceProviderSpLinkClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetSpLinkAvailabilityRequest
     * @return GetSpLinkAvailabilityResponse
     */
    getSpLinkAvailability(query: GetSpLinkAvailabilityRequest, cancelToken?: CancelToken): Promise<GetSpLinkAvailabilityResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/splink/queries/getsplinkavailability`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSpLinkUrlRequest
     * @return GetSpLinkUrlResponse
     */
    getSpLinkUrl(query: GetSpLinkUrlRequest, cancelToken?: CancelToken): Promise<GetSpLinkUrlResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/splink/queries/getsplinkurl`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderClient {
    /**
     * @param query GenerateSummaryForFollowupTranscriptionRequest
     * @return GenerateSummaryForFollowupTranscriptionResponse
     */
    generateSummaryForFollowupTranscription(query: GenerateSummaryForFollowupTranscriptionRequest, cancelToken?: CancelToken): Promise<GenerateSummaryForFollowupTranscriptionResponse>;
    /**
     * @return GetActiveMethodTypesResponse
     */
    getActiveMethodTypes(cancelToken?: CancelToken): Promise<GetActiveMethodTypesResponse2>;
    /**
     * @return GetActiveObservationTypesResponse
     */
    getActiveObservationTypes(cancelToken?: CancelToken): Promise<GetActiveObservationTypesResponse>;
    /**
     * @param query GetObservationTypeRequest
     * @return GetObservationTypeResponse
     */
    getObservationType(query: GetObservationTypeRequest, cancelToken?: CancelToken): Promise<GetObservationTypeResponse>;
}

export class CitizenServiceProviderClient implements ICitizenServiceProviderClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GenerateSummaryForFollowupTranscriptionRequest
     * @return GenerateSummaryForFollowupTranscriptionResponse
     */
    generateSummaryForFollowupTranscription(query: GenerateSummaryForFollowupTranscriptionRequest, cancelToken?: CancelToken): Promise<GenerateSummaryForFollowupTranscriptionResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/queries/generatesummaryforfollowuptranscription`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetActiveMethodTypesResponse
     */
    getActiveMethodTypes(cancelToken?: CancelToken): Promise<GetActiveMethodTypesResponse2> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/queries/getactivemethodtypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetActiveObservationTypesResponse
     */
    getActiveObservationTypes(cancelToken?: CancelToken): Promise<GetActiveObservationTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/queries/getactiveobservationtypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetObservationTypeRequest
     * @return GetObservationTypeResponse
     */
    getObservationType(query: GetObservationTypeRequest, cancelToken?: CancelToken): Promise<GetObservationTypeResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/queries/getobservationtype`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenServiceProviderMedicinePricesClient {
    /**
     * @param query GetMedicinePackageDetailsRequest
     * @return GetMedicinePackageDetailsResponse
     */
    getMedicinePackageDetails(query: GetMedicinePackageDetailsRequest, cancelToken?: CancelToken): Promise<GetMedicinePackageDetailsResponse>;
    /**
     * @param query SearchMedicinePackagesRequest
     * @return SearchMedicinePackagesResponse
     */
    searchMedicinePackages(query: SearchMedicinePackagesRequest, cancelToken?: CancelToken): Promise<SearchMedicinePackagesResponse>;
}

export class CitizenServiceProviderMedicinePricesClient implements ICitizenServiceProviderMedicinePricesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetMedicinePackageDetailsRequest
     * @return GetMedicinePackageDetailsResponse
     */
    getMedicinePackageDetails(query: GetMedicinePackageDetailsRequest, cancelToken?: CancelToken): Promise<GetMedicinePackageDetailsResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineprices/queries/getmedicinepackagedetails`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query SearchMedicinePackagesRequest
     * @return SearchMedicinePackagesResponse
     */
    searchMedicinePackages(query: SearchMedicinePackagesRequest, cancelToken?: CancelToken): Promise<SearchMedicinePackagesResponse> {
        const $url = `${this.baseUrl}/api/citizen/serviceprovider/medicineprices/queries/searchmedicinepackages`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenPlanAndActivitiesIncomeClient {
    /**
     * @param query GetCitizenIncomeRequest
     * @return GetCitizenIncomeResponse
     */
    getCitizenIncome(query: GetCitizenIncomeRequest, cancelToken?: CancelToken): Promise<GetCitizenIncomeResponse>;
    /**
     * @param query GetCitizenIncomeLiveDataRequest
     * @return GetCitizenIncomeLiveDataResponse
     */
    getCitizenIncomeLiveData(query: GetCitizenIncomeLiveDataRequest, cancelToken?: CancelToken): Promise<GetCitizenIncomeLiveDataResponse>;
}

export class CitizenPlanAndActivitiesIncomeClient implements ICitizenPlanAndActivitiesIncomeClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetCitizenIncomeRequest
     * @return GetCitizenIncomeResponse
     */
    getCitizenIncome(query: GetCitizenIncomeRequest, cancelToken?: CancelToken): Promise<GetCitizenIncomeResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/income/queries/getcitizenincome`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenIncomeLiveDataRequest
     * @return GetCitizenIncomeLiveDataResponse
     */
    getCitizenIncomeLiveData(query: GetCitizenIncomeLiveDataRequest, cancelToken?: CancelToken): Promise<GetCitizenIncomeLiveDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/planandactivities/income/queries/getcitizenincomelivedata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenJobnetRelationsBenefitDecisionClient {
    /**
     * @param query GetBenefitDecisionsForCitizenRequest
     * @return GetBenefitDecisionsForCitizenResponse
     */
    getBenefitDecisionsForCitizen(query: GetBenefitDecisionsForCitizenRequest, cancelToken?: CancelToken): Promise<GetBenefitDecisionsForCitizenResponse>;
}

export class CitizenJobnetRelationsBenefitDecisionClient implements ICitizenJobnetRelationsBenefitDecisionClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetBenefitDecisionsForCitizenRequest
     * @return GetBenefitDecisionsForCitizenResponse
     */
    getBenefitDecisionsForCitizen(query: GetBenefitDecisionsForCitizenRequest, cancelToken?: CancelToken): Promise<GetBenefitDecisionsForCitizenResponse> {
        const $url = `${this.baseUrl}/api/citizen/jobnetrelations/benefitdecision/queries/getbenefitdecisionsforcitizen`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenJoblogClient {
    /**
     * @param query GetJoblogDocumentRequest
     * @return FileResponse
     */
    getJoblogDocument(query: GetJoblogDocumentRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetJoblogEntriesRequest
     * @return GetJoblogEntriesResponse
     */
    getJoblogEntries(query: GetJoblogEntriesRequest, cancelToken?: CancelToken): Promise<GetJoblogEntriesResponse>;
    /**
     * @param query GetJoblogEntryRequest
     * @return GetJoblogEntryResponse
     */
    getJoblogEntry(query: GetJoblogEntryRequest, cancelToken?: CancelToken): Promise<GetJoblogEntryResponse>;
}

export class CitizenJoblogClient implements ICitizenJoblogClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetJoblogDocumentRequest
     * @return FileResponse
     */
    getJoblogDocument(query: GetJoblogDocumentRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/joblog/queries/getjoblogdocument`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJoblogEntriesRequest
     * @return GetJoblogEntriesResponse
     */
    getJoblogEntries(query: GetJoblogEntriesRequest, cancelToken?: CancelToken): Promise<GetJoblogEntriesResponse> {
        const $url = `${this.baseUrl}/api/citizen/joblog/queries/getjoblogentries`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJoblogEntryRequest
     * @return GetJoblogEntryResponse
     */
    getJoblogEntry(query: GetJoblogEntryRequest, cancelToken?: CancelToken): Promise<GetJoblogEntryResponse> {
        const $url = `${this.baseUrl}/api/citizen/joblog/queries/getjoblogentry`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenInterviewPreparationClient {
    /**
     * @param query GetAbsenceOverviewRequest
     * @return GetAbsenceOverviewResponse
     */
    getAbsenceOverview(query: GetAbsenceOverviewRequest, cancelToken?: CancelToken): Promise<GetAbsenceOverviewResponse>;
    /**
     * @param query GetCvOverviewRequest
     * @return GetCvOverviewResponse
     */
    getCvOverview(query: GetCvOverviewRequest, cancelToken?: CancelToken): Promise<GetCvOverviewResponse>;
    /**
     * @param query GetHeaderOverviewRequest
     * @return GetHeaderOverviewResponse
     */
    getHeaderOverview(query: GetHeaderOverviewRequest, cancelToken?: CancelToken): Promise<GetHeaderOverviewResponse>;
    /**
     * @param query GetHighlightOverviewRequest
     * @return GetHighlightOverviewResponse
     */
    getHighlightOverview(query: GetHighlightOverviewRequest, cancelToken?: CancelToken): Promise<GetHighlightOverviewResponse>;
    /**
     * @param query GetJobReadyCitizenProgressOverviewRequest
     * @return GetJobReadyCitizenProgressOverviewResponse
     */
    getJobReadyCitizenProgressOverview(query: GetJobReadyCitizenProgressOverviewRequest, cancelToken?: CancelToken): Promise<GetJobReadyCitizenProgressOverviewResponse>;
    /**
     * @param query GetJobReadyInformationRequest
     * @return GetJobReadyInformationResponse
     */
    getJobReadyInformation(query: GetJobReadyInformationRequest, cancelToken?: CancelToken): Promise<GetJobReadyInformationResponse>;
    /**
     * @param query GetJobReadySelfScreeningOverviewRequest
     * @return GetJobReadySelfScreeningOverviewResponse
     */
    getJobReadySelfScreeningOverview(query: GetJobReadySelfScreeningOverviewRequest, cancelToken?: CancelToken): Promise<GetJobReadySelfScreeningOverviewResponse>;
    /**
     * @param query GetJournalNotesRequest
     * @return GetJournalNotesResponse
     */
    getJournalNotes(query: GetJournalNotesRequest, cancelToken?: CancelToken): Promise<GetJournalNotesResponse>;
    /**
     * @param query GetProgressOverviewRequest
     * @return GetProgressOverviewResponse
     */
    getProgressOverview(query: GetProgressOverviewRequest, cancelToken?: CancelToken): Promise<GetProgressOverviewResponse>;
}

export class CitizenInterviewPreparationClient implements ICitizenInterviewPreparationClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetAbsenceOverviewRequest
     * @return GetAbsenceOverviewResponse
     */
    getAbsenceOverview(query: GetAbsenceOverviewRequest, cancelToken?: CancelToken): Promise<GetAbsenceOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/interviewpreparation/queries/getabsenceoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCvOverviewRequest
     * @return GetCvOverviewResponse
     */
    getCvOverview(query: GetCvOverviewRequest, cancelToken?: CancelToken): Promise<GetCvOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/interviewpreparation/queries/getcvoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHeaderOverviewRequest
     * @return GetHeaderOverviewResponse
     */
    getHeaderOverview(query: GetHeaderOverviewRequest, cancelToken?: CancelToken): Promise<GetHeaderOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/interviewpreparation/queries/getheaderoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetHighlightOverviewRequest
     * @return GetHighlightOverviewResponse
     */
    getHighlightOverview(query: GetHighlightOverviewRequest, cancelToken?: CancelToken): Promise<GetHighlightOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/interviewpreparation/queries/gethighlightoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJobReadyCitizenProgressOverviewRequest
     * @return GetJobReadyCitizenProgressOverviewResponse
     */
    getJobReadyCitizenProgressOverview(query: GetJobReadyCitizenProgressOverviewRequest, cancelToken?: CancelToken): Promise<GetJobReadyCitizenProgressOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/interviewpreparation/queries/getjobreadycitizenprogressoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJobReadyInformationRequest
     * @return GetJobReadyInformationResponse
     */
    getJobReadyInformation(query: GetJobReadyInformationRequest, cancelToken?: CancelToken): Promise<GetJobReadyInformationResponse> {
        const $url = `${this.baseUrl}/api/citizen/interviewpreparation/queries/getjobreadyinformation`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJobReadySelfScreeningOverviewRequest
     * @return GetJobReadySelfScreeningOverviewResponse
     */
    getJobReadySelfScreeningOverview(query: GetJobReadySelfScreeningOverviewRequest, cancelToken?: CancelToken): Promise<GetJobReadySelfScreeningOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/interviewpreparation/queries/getjobreadyselfscreeningoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetJournalNotesRequest
     * @return GetJournalNotesResponse
     */
    getJournalNotes(query: GetJournalNotesRequest, cancelToken?: CancelToken): Promise<GetJournalNotesResponse> {
        const $url = `${this.baseUrl}/api/citizen/interviewpreparation/queries/getjournalnotes`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetProgressOverviewRequest
     * @return GetProgressOverviewResponse
     */
    getProgressOverview(query: GetProgressOverviewRequest, cancelToken?: CancelToken): Promise<GetProgressOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/interviewpreparation/queries/getprogressoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenInterviewPreparationSickLeaveClient {
    /**
     * @param query GetCitizenProgressOverviewRequest
     * @return GetCitizenProgressOverviewResponse
     */
    getCitizenProgressOverview(query: GetCitizenProgressOverviewRequest, cancelToken?: CancelToken): Promise<GetCitizenProgressOverviewResponse>;
    /**
     * @param query GetInformationFormRequest
     * @return GetInformationFormResponse
     */
    getInformationForm(query: GetInformationFormRequest, cancelToken?: CancelToken): Promise<GetInformationFormResponse>;
    /**
     * @param query GetMedicalJournalNotesRequest
     * @return GetMedicalJournalNotesResponse
     */
    getMedicalJournalNotes(query: GetMedicalJournalNotesRequest, cancelToken?: CancelToken): Promise<GetMedicalJournalNotesResponse>;
    /**
     * @param query GetPersonalConditionsRequest
     * @return GetPersonalConditionsResponse
     */
    getPersonalConditions(query: GetPersonalConditionsRequest, cancelToken?: CancelToken): Promise<GetPersonalConditionsResponse>;
    /**
     * @param query GetSicknessBenefitCaseOverviewRequest
     * @return GetSicknessBenefitCaseOverviewResponse
     */
    getSicknessBenefitCaseOverview(query: GetSicknessBenefitCaseOverviewRequest, cancelToken?: CancelToken): Promise<GetSicknessBenefitCaseOverviewResponse>;
}

export class CitizenInterviewPreparationSickLeaveClient implements ICitizenInterviewPreparationSickLeaveClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetCitizenProgressOverviewRequest
     * @return GetCitizenProgressOverviewResponse
     */
    getCitizenProgressOverview(query: GetCitizenProgressOverviewRequest, cancelToken?: CancelToken): Promise<GetCitizenProgressOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/interviewpreparationsickleave/queries/getcitizenprogressoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetInformationFormRequest
     * @return GetInformationFormResponse
     */
    getInformationForm(query: GetInformationFormRequest, cancelToken?: CancelToken): Promise<GetInformationFormResponse> {
        const $url = `${this.baseUrl}/api/citizen/interviewpreparationsickleave/queries/getinformationform`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetMedicalJournalNotesRequest
     * @return GetMedicalJournalNotesResponse
     */
    getMedicalJournalNotes(query: GetMedicalJournalNotesRequest, cancelToken?: CancelToken): Promise<GetMedicalJournalNotesResponse> {
        const $url = `${this.baseUrl}/api/citizen/interviewpreparationsickleave/queries/getmedicaljournalnotes`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPersonalConditionsRequest
     * @return GetPersonalConditionsResponse
     */
    getPersonalConditions(query: GetPersonalConditionsRequest, cancelToken?: CancelToken): Promise<GetPersonalConditionsResponse> {
        const $url = `${this.baseUrl}/api/citizen/interviewpreparationsickleave/queries/getpersonalconditions`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSicknessBenefitCaseOverviewRequest
     * @return GetSicknessBenefitCaseOverviewResponse
     */
    getSicknessBenefitCaseOverview(query: GetSicknessBenefitCaseOverviewRequest, cancelToken?: CancelToken): Promise<GetSicknessBenefitCaseOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/interviewpreparationsickleave/queries/getsicknessbenefitcaseoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenGuideLinksClient {
    /**
     * @param query GetGuideLinksRequest
     * @return GetGuideLinksResponse
     */
    getGuideLinks(query: GetGuideLinksRequest, cancelToken?: CancelToken): Promise<GetGuideLinksResponse2>;
}

export class CitizenGuideLinksClient implements ICitizenGuideLinksClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetGuideLinksRequest
     * @return GetGuideLinksResponse
     */
    getGuideLinks(query: GetGuideLinksRequest, cancelToken?: CancelToken): Promise<GetGuideLinksResponse2> {
        const $url = `${this.baseUrl}/api/citizen/guidelinks/queries/getguidelinks`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenFlowOverviewClient {
    /**
     * @param query GetCitizenFlowOverviewRequest
     * @return GetCitizenFlowOverviewResponse
     */
    getCitizenFlowOverview(query: GetCitizenFlowOverviewRequest, cancelToken?: CancelToken): Promise<GetCitizenFlowOverviewResponse>;
}

export class CitizenFlowOverviewClient implements ICitizenFlowOverviewClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetCitizenFlowOverviewRequest
     * @return GetCitizenFlowOverviewResponse
     */
    getCitizenFlowOverview(query: GetCitizenFlowOverviewRequest, cancelToken?: CancelToken): Promise<GetCitizenFlowOverviewResponse> {
        const $url = `${this.baseUrl}/api/citizen/flowoverview/queries/getcitizenflowoverview`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenCvSearchClient {
    /**
     * @param query GetCvAsPdfByCprNumberRequest
     * @return FileResponse
     */
    getCvAsPdfByCprNumber(query: GetCvAsPdfByCprNumberRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return GetCvSearchOptionsResponse
     */
    getCvSearchOptions(cancelToken?: CancelToken): Promise<GetCvSearchOptionsResponse>;
    /**
     * @return GetMunicipalitiesResponse
     */
    getMunicipalities(cancelToken?: CancelToken): Promise<GetMunicipalitiesResponse4>;
    /**
     * @param query PerformCvSearchRequest
     * @return PerformCvSearchResponse
     */
    performCvSearch(query: PerformCvSearchRequest, cancelToken?: CancelToken): Promise<PerformCvSearchResponse>;
}

export class CitizenCvSearchClient implements ICitizenCvSearchClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetCvAsPdfByCprNumberRequest
     * @return FileResponse
     */
    getCvAsPdfByCprNumber(query: GetCvAsPdfByCprNumberRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/cvsearch/queries/getcvaspdfbycprnumber`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @return GetCvSearchOptionsResponse
     */
    getCvSearchOptions(cancelToken?: CancelToken): Promise<GetCvSearchOptionsResponse> {
        const $url = `${this.baseUrl}/api/citizen/cvsearch/queries/getcvsearchoptions`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetMunicipalitiesResponse
     */
    getMunicipalities(cancelToken?: CancelToken): Promise<GetMunicipalitiesResponse4> {
        const $url = `${this.baseUrl}/api/citizen/cvsearch/queries/getmunicipalities`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query PerformCvSearchRequest
     * @return PerformCvSearchResponse
     */
    performCvSearch(query: PerformCvSearchRequest, cancelToken?: CancelToken): Promise<PerformCvSearchResponse> {
        const $url = `${this.baseUrl}/api/citizen/cvsearch/queries/performcvsearch`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenCommunicationTemplatesClient {
    /**
     * @return GetActivityTemplatesResponse
     */
    getActivityTemplates(cancelToken?: CancelToken): Promise<GetActivityTemplatesResponse>;
    /**
     * @return GetCrowdLetterTemplatesResponse
     */
    getCrowdLetterTemplates(cancelToken?: CancelToken): Promise<GetCrowdLetterTemplatesResponse>;
    /**
     * @param query GetCitizenInterviewBookingTemplatesRequest
     * @return GetCitizenInterviewBookingTemplatesResponse
     */
    getCitizenInterviewBookingTemplates(query: GetCitizenInterviewBookingTemplatesRequest, cancelToken?: CancelToken): Promise<GetCitizenInterviewBookingTemplatesResponse>;
    /**
     * @param query GetCitizenInterviewCrowdBookingTemplatesRequest
     * @return GetCitizenInterviewCrowdBookingTemplatesResponse
     */
    getCitizenInterviewCrowdBookingTemplates(query: GetCitizenInterviewCrowdBookingTemplatesRequest, cancelToken?: CancelToken): Promise<GetCitizenInterviewCrowdBookingTemplatesResponse>;
    /**
     * @param query GetCitizenTemplatesRequest
     * @return GetCitizenTemplatesResponse
     */
    getCitizenTemplates(query: GetCitizenTemplatesRequest, cancelToken?: CancelToken): Promise<GetCitizenTemplatesResponse>;
    /**
     * @param query GetEditableContentRequest
     * @return GetEditableContentResponse
     */
    getEditableContent(query: GetEditableContentRequest2, cancelToken?: CancelToken): Promise<GetEditableContentResponse2>;
    /**
     * @param query GetPdfRequest
     * @return FileResponse
     */
    getPdf(query: GetPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @param query GetServiceProviderDocumentTemplatesRequest
     * @return GetServiceProviderDocumentTemplatesResponse
     */
    getServiceProviderDocumentTemplates(query: GetServiceProviderDocumentTemplatesRequest, cancelToken?: CancelToken): Promise<GetServiceProviderDocumentTemplatesResponse>;
    /**
     * @param query GetServiceProviderLetterTemplatesRequest
     * @return GetServiceProviderLetterTemplatesResponse
     */
    getServiceProviderLetterTemplates(query: GetServiceProviderLetterTemplatesRequest, cancelToken?: CancelToken): Promise<GetServiceProviderLetterTemplatesResponse>;
    /**
     * @param query GetTemplateByTemplateCodeRequest
     * @return GetTemplateByTemplateCodeResponse
     */
    getTemplateByTemplateCode(query: GetTemplateByTemplateCodeRequest, cancelToken?: CancelToken): Promise<GetTemplateByTemplateCodeResponse>;
    /**
     * @param query GetTemplatesByCategoriesRequest
     * @return GetTemplatesByCategoriesResponse
     */
    getTemplatesByCategories(query: GetTemplatesByCategoriesRequest, cancelToken?: CancelToken): Promise<GetTemplatesByCategoriesResponse>;
    /**
     * @param query GetTemplatesByCategoryRequest
     * @return GetTemplatesByCategoryResponse
     */
    getTemplatesByCategory(query: GetTemplatesByCategoryRequest, cancelToken?: CancelToken): Promise<GetTemplatesByCategoryResponse>;
}

export class CitizenCommunicationTemplatesClient implements ICitizenCommunicationTemplatesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @return GetActivityTemplatesResponse
     */
    getActivityTemplates(cancelToken?: CancelToken): Promise<GetActivityTemplatesResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/templates/queries/getactivitytemplates`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCrowdLetterTemplatesResponse
     */
    getCrowdLetterTemplates(cancelToken?: CancelToken): Promise<GetCrowdLetterTemplatesResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/templates/queries/getcrowdlettertemplates`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenInterviewBookingTemplatesRequest
     * @return GetCitizenInterviewBookingTemplatesResponse
     */
    getCitizenInterviewBookingTemplates(query: GetCitizenInterviewBookingTemplatesRequest, cancelToken?: CancelToken): Promise<GetCitizenInterviewBookingTemplatesResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/templates/queries/getcitizeninterviewbookingtemplates`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenInterviewCrowdBookingTemplatesRequest
     * @return GetCitizenInterviewCrowdBookingTemplatesResponse
     */
    getCitizenInterviewCrowdBookingTemplates(query: GetCitizenInterviewCrowdBookingTemplatesRequest, cancelToken?: CancelToken): Promise<GetCitizenInterviewCrowdBookingTemplatesResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/templates/queries/getcitizeninterviewcrowdbookingtemplates`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenTemplatesRequest
     * @return GetCitizenTemplatesResponse
     */
    getCitizenTemplates(query: GetCitizenTemplatesRequest, cancelToken?: CancelToken): Promise<GetCitizenTemplatesResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/templates/queries/getcitizentemplates`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetEditableContentRequest
     * @return GetEditableContentResponse
     */
    getEditableContent(query: GetEditableContentRequest2, cancelToken?: CancelToken): Promise<GetEditableContentResponse2> {
        const $url = `${this.baseUrl}/api/citizen/communication/templates/queries/geteditablecontent`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetPdfRequest
     * @return FileResponse
     */
    getPdf(query: GetPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/templates/queries/getpdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderDocumentTemplatesRequest
     * @return GetServiceProviderDocumentTemplatesResponse
     */
    getServiceProviderDocumentTemplates(query: GetServiceProviderDocumentTemplatesRequest, cancelToken?: CancelToken): Promise<GetServiceProviderDocumentTemplatesResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/templates/queries/getserviceproviderdocumenttemplates`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetServiceProviderLetterTemplatesRequest
     * @return GetServiceProviderLetterTemplatesResponse
     */
    getServiceProviderLetterTemplates(query: GetServiceProviderLetterTemplatesRequest, cancelToken?: CancelToken): Promise<GetServiceProviderLetterTemplatesResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/templates/queries/getserviceproviderlettertemplates`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTemplateByTemplateCodeRequest
     * @return GetTemplateByTemplateCodeResponse
     */
    getTemplateByTemplateCode(query: GetTemplateByTemplateCodeRequest, cancelToken?: CancelToken): Promise<GetTemplateByTemplateCodeResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/templates/queries/gettemplatebytemplatecode`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTemplatesByCategoriesRequest
     * @return GetTemplatesByCategoriesResponse
     */
    getTemplatesByCategories(query: GetTemplatesByCategoriesRequest, cancelToken?: CancelToken): Promise<GetTemplatesByCategoriesResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/templates/queries/gettemplatesbycategories`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetTemplatesByCategoryRequest
     * @return GetTemplatesByCategoryResponse
     */
    getTemplatesByCategory(query: GetTemplatesByCategoryRequest, cancelToken?: CancelToken): Promise<GetTemplatesByCategoryResponse> {
        const $url = `${this.baseUrl}/api/citizen/communication/templates/queries/gettemplatesbycategory`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenCitizenOverviewClient {
    /**
     * @param query GetCitizenOverviewDataRequest
     * @return GetCitizenOverviewDataResponse
     */
    getCitizenOverviewData(query: GetCitizenOverviewDataRequest, cancelToken?: CancelToken): Promise<GetCitizenOverviewDataResponse>;
    /**
     * @param query GetCitizenOverviewDataForBeskaeftigelseRequest
     * @return GetCitizenOverviewDataForBeskaeftigelseResponse
     */
    getCitizenOverviewDataForBeskaeftigelse(query: GetCitizenOverviewDataForBeskaeftigelseRequest, cancelToken?: CancelToken): Promise<GetCitizenOverviewDataForBeskaeftigelseResponse>;
    /**
     * @param query GetCitizenOverviewDataForServiceProviderRequest
     * @return GetCitizenOverviewDataForServiceProviderResponse
     */
    getCitizenOverviewDataForServiceProvider(query: GetCitizenOverviewDataForServiceProviderRequest, cancelToken?: CancelToken): Promise<GetCitizenOverviewDataForServiceProviderResponse>;
    /**
     * @param query GetCitizenOverviewDataForSocialRequest
     * @return GetCitizenOverviewDataForSocialResponse
     */
    getCitizenOverviewDataForSocial(query: GetCitizenOverviewDataForSocialRequest, cancelToken?: CancelToken): Promise<GetCitizenOverviewDataForSocialResponse>;
}

export class CitizenCitizenOverviewClient implements ICitizenCitizenOverviewClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetCitizenOverviewDataRequest
     * @return GetCitizenOverviewDataResponse
     */
    getCitizenOverviewData(query: GetCitizenOverviewDataRequest, cancelToken?: CancelToken): Promise<GetCitizenOverviewDataResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenoverview/queries/getcitizenoverviewdata`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenOverviewDataForBeskaeftigelseRequest
     * @return GetCitizenOverviewDataForBeskaeftigelseResponse
     */
    getCitizenOverviewDataForBeskaeftigelse(query: GetCitizenOverviewDataForBeskaeftigelseRequest, cancelToken?: CancelToken): Promise<GetCitizenOverviewDataForBeskaeftigelseResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenoverview/queries/getcitizenoverviewdataforbeskaeftigelse`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenOverviewDataForServiceProviderRequest
     * @return GetCitizenOverviewDataForServiceProviderResponse
     */
    getCitizenOverviewDataForServiceProvider(query: GetCitizenOverviewDataForServiceProviderRequest, cancelToken?: CancelToken): Promise<GetCitizenOverviewDataForServiceProviderResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenoverview/queries/getcitizenoverviewdataforserviceprovider`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetCitizenOverviewDataForSocialRequest
     * @return GetCitizenOverviewDataForSocialResponse
     */
    getCitizenOverviewDataForSocial(query: GetCitizenOverviewDataForSocialRequest, cancelToken?: CancelToken): Promise<GetCitizenOverviewDataForSocialResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenoverview/queries/getcitizenoverviewdataforsocial`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenCitizenMasterDataYouthEffortClient {
    /**
     * @param query GetYouthEffortAsPdfRequest
     * @return FileResponse
     */
    getYouthEffortAsPdf(query: GetYouthEffortAsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse>;
}

export class CitizenCitizenMasterDataYouthEffortClient implements ICitizenCitizenMasterDataYouthEffortClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetYouthEffortAsPdfRequest
     * @return FileResponse
     */
    getYouthEffortAsPdf(query: GetYouthEffortAsPdfRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/youtheffort/queries/getyoutheffortaspdf`;

        const options_: AxiosRequestConfig = {
            data: query,
            responseType: 'blob',
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            },
            cancelToken,
        };

        return handleFileResponse(this.instance.request(options_));
    }
}

export interface ICitizenCitizenMasterDataSustenanceHistoryClient {
    /**
     * @param query GetSustenanceHistoryMonthRequest
     * @return GetSustenanceHistoryMonthResponse
     */
    getSustenanceHistoryMonth(query: GetSustenanceHistoryMonthRequest, cancelToken?: CancelToken): Promise<GetSustenanceHistoryMonthResponse>;
    /**
     * @param query GetSustenanceHistoryYearRequest
     * @return GetSustenanceHistoryYearResponse
     */
    getSustenanceHistoryYear(query: GetSustenanceHistoryYearRequest, cancelToken?: CancelToken): Promise<GetSustenanceHistoryYearResponse>;
}

export class CitizenCitizenMasterDataSustenanceHistoryClient implements ICitizenCitizenMasterDataSustenanceHistoryClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetSustenanceHistoryMonthRequest
     * @return GetSustenanceHistoryMonthResponse
     */
    getSustenanceHistoryMonth(query: GetSustenanceHistoryMonthRequest, cancelToken?: CancelToken): Promise<GetSustenanceHistoryMonthResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/sustenancehistory/queries/getsustenancehistorymonth`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSustenanceHistoryYearRequest
     * @return GetSustenanceHistoryYearResponse
     */
    getSustenanceHistoryYear(query: GetSustenanceHistoryYearRequest, cancelToken?: CancelToken): Promise<GetSustenanceHistoryYearResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/sustenancehistory/queries/getsustenancehistoryyear`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenCitizenMasterDataDfdgHistoriesClient {
    /**
     * @param query GetDfdgHistoryRequest
     * @return GetDfdgHistoryResponse
     */
    getDfdgHistory(query: GetDfdgHistoryRequest, cancelToken?: CancelToken): Promise<GetDfdgHistoryResponse>;
    /**
     * @param query GetDfdgHistoryNamesRequest
     * @return GetDfdgHistoryNamesResponse
     */
    getDfdgHistoryNames(query: GetDfdgHistoryNamesRequest, cancelToken?: CancelToken): Promise<GetDfdgHistoryNamesResponse>;
}

export class CitizenCitizenMasterDataDfdgHistoriesClient implements ICitizenCitizenMasterDataDfdgHistoriesClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetDfdgHistoryRequest
     * @return GetDfdgHistoryResponse
     */
    getDfdgHistory(query: GetDfdgHistoryRequest, cancelToken?: CancelToken): Promise<GetDfdgHistoryResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/dfdghistories/queries/getdfdghistory`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetDfdgHistoryNamesRequest
     * @return GetDfdgHistoryNamesResponse
     */
    getDfdgHistoryNames(query: GetDfdgHistoryNamesRequest, cancelToken?: CancelToken): Promise<GetDfdgHistoryNamesResponse> {
        const $url = `${this.baseUrl}/api/citizen/citizenmasterdata/dfdghistories/queries/getdfdghistorynames`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ICitizenChangeLogClient {
    /**
     * @param query GetCitizenChangeLogsByQueryRequest
     * @return GetCitizenChangeLogsByQueryResponse
     */
    getCitizenChangeLogsByQuery(query: GetCitizenChangeLogsByQueryRequest, cancelToken?: CancelToken): Promise<GetCitizenChangeLogsByQueryResponse>;
    /**
     * @return GetCitizenPostTypesResponse
     */
    getCitizenPostTypes(cancelToken?: CancelToken): Promise<GetCitizenPostTypesResponse>;
}

export class CitizenChangeLogClient implements ICitizenChangeLogClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetCitizenChangeLogsByQueryRequest
     * @return GetCitizenChangeLogsByQueryResponse
     */
    getCitizenChangeLogsByQuery(query: GetCitizenChangeLogsByQueryRequest, cancelToken?: CancelToken): Promise<GetCitizenChangeLogsByQueryResponse> {
        const $url = `${this.baseUrl}/api/citizen/changelog/queries/getcitizenchangelogsbyquery`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetCitizenPostTypesResponse
     */
    getCitizenPostTypes(cancelToken?: CancelToken): Promise<GetCitizenPostTypesResponse> {
        const $url = `${this.baseUrl}/api/citizen/changelog/queries/getcitizenposttypes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAuthorizationClient {
    /**
     * @return GetAllowedActionsResponse
     */
    getAllowedActions(cancelToken?: CancelToken): Promise<GetAllowedActionsResponse>;
    /**
     * @param query GetAuthorizationResultRequest
     * @return GetAuthorizationResultResponse
     */
    getAuthorizationResult(query: GetAuthorizationResultRequest, cancelToken?: CancelToken): Promise<GetAuthorizationResultResponse>;
    /**
     * @param query GetSystemTestEndpointQueryUrlRequest
     * @return GetSystemTestEndpointQueryUrlResponse
     */
    getResultForSystemTestCheckingUnauthorizedAccess(query: GetSystemTestEndpointQueryUrlRequest, cancelToken?: CancelToken): Promise<GetSystemTestEndpointQueryUrlResponse>;
    /**
     * @return GetRoleThemesResponse
     */
    getRoleThemes(cancelToken?: CancelToken): Promise<GetRoleThemesResponse>;
}

export class AuthorizationClient implements IAuthorizationClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @return GetAllowedActionsResponse
     */
    getAllowedActions(cancelToken?: CancelToken): Promise<GetAllowedActionsResponse> {
        const $url = `${this.baseUrl}/api/authorization/queries/getallowedactions`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetAuthorizationResultRequest
     * @return GetAuthorizationResultResponse
     */
    getAuthorizationResult(query: GetAuthorizationResultRequest, cancelToken?: CancelToken): Promise<GetAuthorizationResultResponse> {
        const $url = `${this.baseUrl}/api/authorization/queries/getauthorizationresult`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetSystemTestEndpointQueryUrlRequest
     * @return GetSystemTestEndpointQueryUrlResponse
     */
    getResultForSystemTestCheckingUnauthorizedAccess(query: GetSystemTestEndpointQueryUrlRequest, cancelToken?: CancelToken): Promise<GetSystemTestEndpointQueryUrlResponse> {
        const $url = `${this.baseUrl}/api/authorization/queries/getresultforsystemtestcheckingunauthorizedaccess`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetRoleThemesResponse
     */
    getRoleThemes(cancelToken?: CancelToken): Promise<GetRoleThemesResponse> {
        const $url = `${this.baseUrl}/api/authorization/queries/getrolethemes`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminNotificationLogClient {
    /**
     * @param query GetNotificationLogRequest
     * @return GetNotificationLogResponse
     */
    getNotificationLog(query: GetNotificationLogRequest, cancelToken?: CancelToken): Promise<GetNotificationLogResponse>;
    /**
     * @param query GetNotificationLogSummaryRequest
     * @return GetNotificationLogSummaryResponse
     */
    getNotificationLogSummary(query: GetNotificationLogSummaryRequest, cancelToken?: CancelToken): Promise<GetNotificationLogSummaryResponse>;
}

export class AdminNotificationLogClient implements IAdminNotificationLogClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetNotificationLogRequest
     * @return GetNotificationLogResponse
     */
    getNotificationLog(query: GetNotificationLogRequest, cancelToken?: CancelToken): Promise<GetNotificationLogResponse> {
        const $url = `${this.baseUrl}/api/admin/notificationlog/queries/getnotificationlog`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @param query GetNotificationLogSummaryRequest
     * @return GetNotificationLogSummaryResponse
     */
    getNotificationLogSummary(query: GetNotificationLogSummaryRequest, cancelToken?: CancelToken): Promise<GetNotificationLogSummaryResponse> {
        const $url = `${this.baseUrl}/api/admin/notificationlog/queries/getnotificationlogsummary`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface IAdminConfigurationChangeLogClient {
    /**
     * @param query GetConfigurationChangelogsRequest
     * @return GetConfigurationChangelogsResponse
     */
    getConfigurationChangelogs(query: GetConfigurationChangelogsRequest, cancelToken?: CancelToken): Promise<GetConfigurationChangelogsResponse>;
    /**
     * @return GetConfigurationLogEntitiesResponse
     */
    getConfigurationLogEntities(cancelToken?: CancelToken): Promise<GetConfigurationLogEntitiesResponse>;
}

export class AdminConfigurationChangeLogClient implements IAdminConfigurationChangeLogClient {
    private readonly instance: AxiosInstance;
    private readonly baseUrl: string;

    constructor(baseUrl: string, instance: AxiosInstance) {
        this.instance = instance;
        this.baseUrl = baseUrl;
    }

    /**
     * @param query GetConfigurationChangelogsRequest
     * @return GetConfigurationChangelogsResponse
     */
    getConfigurationChangelogs(query: GetConfigurationChangelogsRequest, cancelToken?: CancelToken): Promise<GetConfigurationChangelogsResponse> {
        const $url = `${this.baseUrl}/api/admin/configurationchangelog/queries/getconfigurationchangelogs`;

        const options_: AxiosRequestConfig = {
            data: query,
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }

    /**
     * @return GetConfigurationLogEntitiesResponse
     */
    getConfigurationLogEntities(cancelToken?: CancelToken): Promise<GetConfigurationLogEntitiesResponse> {
        const $url = `${this.baseUrl}/api/admin/configurationchangelog/queries/getconfigurationlogentities`;

        const options_: AxiosRequestConfig = {
            data: {},
            method: 'POST',
            url: $url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            cancelToken,
        };

        return handleResponse(this.instance.request(options_));
    }
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };
}

export interface ApplicationArea {
    applicationAreaId: string;
    name?: string | undefined;
}

export interface ChartResponse {
    labels?: string[] | undefined;
    datasets?: ChartDataset[] | undefined;
    worklistHasBeenDeleted: boolean;
    chartDsl?: ChartDsl | undefined;
    name?: string | undefined;
    queryName?: string | undefined;
    docCount: number;
}

export interface ChartDataset {
    filterValue?: string | undefined;
    label?: string | undefined;
    data?: any[] | undefined;
}

export interface ChartDsl {
    universe?: string | undefined;
    chartType: ChartType;
    chartTitle?: string | undefined;
    dataType?: string | undefined;
    aggregations?: ChartAggregation[] | undefined;
    metric?: ChartMetric | undefined;
    savedQueryId?: string | undefined;
    groupOtherValuesInSeparateBucket: boolean;
    labelForOtherBucket?: string | undefined;
    groupMissingValuesInSeparateBucket: boolean;
    labelForMissingBucket?: string | undefined;
    label?: string | undefined;
    scaleMin?: number | undefined;
    scaleMax?: number | undefined;
}

export enum ChartType {
    VerticalBar = "verticalBar",
    VerticalBarStacked = "verticalBarStacked",
    HorizontalBar = "horizontalBar",
    Pie = "pie",
    Doughnut = "doughnut",
    Line = "line",
    Area = "area",
    Counter = "counter",
}

export interface ChartAggregation {
    field?: string | undefined;
    sourceField?: string | undefined;
    label?: string | undefined;
    orderBy: ChartAggregationOrderBy;
    sortOrder: ChartSortOrder;
    size: number;
    aggregationType: ChartAggregationType;
    calendarInterval: ChartDateHistogramInterval;
}

export enum ChartAggregationOrderBy {
    Count = "count",
    Alphabetic = "alphabetic",
    Date = "date",
    Numeric = "numeric",
}

export enum ChartSortOrder {
    Asc = "asc",
    Desc = "desc",
}

export enum ChartAggregationType {
    Term = "term",
    Histogram = "histogram",
    DateHistogram = "datehistogram",
}

export enum ChartDateHistogramInterval {
    Hour = "hour",
    Day = "day",
    Week = "week",
    Month = "month",
    Quarter = "quarter",
    Year = "year",
}

export interface ChartMetric {
    aggregationType: ChartMetricAggregationType;
    field?: string | undefined;
    label?: string | undefined;
    scaleMin?: number | undefined;
    scaleMax?: number | undefined;
}

export enum ChartMetricAggregationType {
    Unknown = "unknown",
    Count = "count",
    Sum = "sum",
    Avg = "avg",
    Max = "max",
    Min = "min",
}

export interface MultiSelectEntityLookup {
    value: string;
    label?: string | undefined;
    shortLabel?: string | undefined;
}

export enum TeamType {
    Organisatoriskenhed = "organisatoriskenhed",
    Rettighedsteam = "rettighedsteam",
    Ejerteam = "ejerteam",
}

export interface SavedChartFormatted {
    id?: string | undefined;
    savedQueryId?: string | undefined;
    savedQueryName?: string | undefined;
    name: string;
    description?: string | undefined;
    createdDate?: Date | string | undefined;
    createdById: string;
    createdByName?: string | undefined;
    modifiedDate?: Date | string | undefined;
    modifiedById: string;
    modifiedByName?: string | undefined;
    ownedById: string;
    ownedByName?: string | undefined;
    tags?: string | undefined;
    resultType?: string | undefined;
    universe?: string | undefined;
    accessRole: Access;
    universeDisplayName?: string | undefined;
    resultTypeDisplayName?: string | undefined;
    lastUsedDate?: Date | string | undefined;
    lastUsedById?: string | undefined;
    lastUsedByName?: string | undefined;
    usageCount?: number | undefined;
}

export enum Access {
    Read = "read",
    Write = "write",
}

export interface SavedQueryFormatted {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    createdDate?: Date | string | undefined;
    createdById: string;
    createdByName?: string | undefined;
    modifiedDate?: Date | string | undefined;
    modifiedById: string;
    modifiedByName?: string | undefined;
    ownedById: string;
    ownedByName?: string | undefined;
    tags?: string | undefined;
    universe?: string | undefined;
    resultType?: string | undefined;
    universeDisplayName?: string | undefined;
    resultTypeDisplayName?: string | undefined;
    accessRole: Access;
    applicationAreaIds?: string[] | undefined;
    lastUsedDate?: Date | string | undefined;
    lastUsedById?: string | undefined;
    lastUsedByName?: string | undefined;
    usageCount?: number | undefined;
}

export interface SavedQueryResult {
    name?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;
    isSystemType: boolean;
}

export interface DefaultStartPageSystemSavedQuery {
    savedQueryId: string;
    savedChartId?: string | undefined;
    savedQueryName?: string | undefined;
}

export interface ContentType {
    boundary?: string | undefined;
    charSet?: string | undefined;
    mediaType: string;
    name: string;
    parameters: Parameters[];
}

export interface ContentDisposition {
    dispositionType: string;
    parameters: Parameters2[];
    fileName?: string | undefined;
    creationDate: Date | string;
    modificationDate: Date | string;
    inline: boolean;
    readDate: Date | string;
    size: number;
}

export interface FasitProblemDetails extends ProblemDetails {
    correlationIdentifier?: string | undefined;
    systemName: OriginatingSystem;
    systemCode?: string | undefined;
    helpLink?: string | undefined;
    messageTitle?: string | undefined;
    timestamp: Date | string;
    severity: Severity;
    retry?: boolean | undefined;
    developerDetail?: string | undefined;
}

export enum OriginatingSystem {
    Fasit = "fasit",
    Dfdg = "dfdg",
    DocumentTemplateEngine = "documentTemplateEngine",
    JobAdService = "jobAdService",
    Nexus = "nexus",
    Vitas = "vitas",
    CprRegisterDatafordeler = "cprRegisterDatafordeler",
}

export enum Severity {
    Information = "information",
    Warning = "warning",
    Error = "error",
}

export enum PseudoFasitEntityDiscriminator {
    None = "none",
    Offer = "offer",
    ConsentDeclaration = "consentDeclaration",
    Conversation = "conversation",
    Progression = "progression",
}

export interface UseOfForceReportModel {
    id: string;
    header: UseOfForceReportHeaderModel;
    incidentIds: string[];
    citizenIds: string[];
    requiresOperator: boolean;
    missingForSending: string[];
    sentToSupervisionAt?: Date | string | undefined;
    operatorInformedAt?: Date | string | undefined;
    incidents: UseOfForceReportIncidentModel[];
    actionPlans: UseOfForceReportActionPlanModel[];
    supervisionMunicipalityName?: string | undefined;
    hygieneRestraintLogCount: number;
}

export interface UseOfForceReportHeaderModel {
    supervisor?: UseOfForceSupervisor | undefined;
    supervisionMunicipalityId?: string | undefined;
    operatorName?: string | undefined;
    operatorCvr?: string | undefined;
}

export enum UseOfForceSupervisor {
    SocialSupervisionNorth = "socialSupervisionNorth",
    SocialSupervisionCentral = "socialSupervisionCentral",
    SocialSupervisionSouth = "socialSupervisionSouth",
    SocialSupervisionEast = "socialSupervisionEast",
    SocialSupervisionCapital = "socialSupervisionCapital",
    Municipality = "municipality",
}

export interface UseOfForceReportIncidentModel {
    id: string;
    citizenId: string;
    citizenName?: string | undefined;
    citizenCpr?: string | undefined;
    interventionStartedAt?: Date | string | undefined;
    interventionType?: UseOfForceInterventionType | undefined;
}

export enum UseOfForceInterventionType {
    Section124c = "section124c",
    Section124dSubsection1 = "section124dSubsection1",
    Section124dSubsection2 = "section124dSubsection2",
    Section136a = "section136a",
    Section136c = "section136c",
    WithoutAuthority = "withoutAuthority",
    SelfDefence = "selfDefence",
    Necessity = "necessity",
}

export interface UseOfForceReportActionPlanModel {
    id: string;
    citizenId: string;
    fileName: string;
    contentType: string;
    size: number;
    uploadedAt: Date | string;
}

export interface UseOfForceUploadedFile {
    documentReference: string;
    owner: string;
    fileName: string;
    contentType: string;
}

export interface RecurrencePatternModel {
    freq: string;
    interval?: number | undefined;
    byweekday?: string[] | undefined;
    bymonthday?: number | undefined;
    count?: number | undefined;
    until?: Date | string | undefined;
    excludedDates?: Date | string[] | undefined;
}

export interface ValidationError {
    error: string;
}

export interface ValidationErrorOfGuid extends ValidationError {
    element: string;
}

export interface OutboxItemEntityInfoUpdateModel {
    outboxItemId: string;
    journalNoteId?: string | undefined;
    isApexEntity: boolean;
    status: OutboxItemSendStatus;
    isOldVersionOfOutboxItem: boolean;
}

export enum OutboxItemSendStatus {
    Pending = "pending",
    HandledManually = "handledManually",
    Cancelled = "cancelled",
    RequestSentToRemotePrint = "requestSentToRemotePrint",
    Failed = "failed",
    ConfirmedSentByRemotePrint = "confirmedSentByRemotePrint",
    TechnicalError = "technicalError",
    ReceivedBySupplierPlatform = "receivedBySupplierPlatform",
}

export interface TeamCreateModel {
    name?: string | undefined;
    externalOrganizationId?: string | undefined;
    fkOrganizationalUnitId?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
    isMainTeam: boolean;
    subJobcenter?: string | undefined;
    parentTeamId?: string | undefined;
    address?: TeamAdressViewModel | undefined;
    attendanceAddress?: TeamAdressViewModel | undefined;
    contactInfo?: ContactInfoViewModel | undefined;
    attendanceRoom?: string | undefined;
}

export interface TeamAdressViewModel {
    country?: CountryViewModel | undefined;
    districtName?: string | undefined;
    floorIdentifier?: string | undefined;
    postCodeIdentifier?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    streetName?: string | undefined;
    suiteIdentifier?: string | undefined;
}

export interface CountryViewModel {
    countryIdentificationCode: string;
    countryName?: string | undefined;
}

export interface ContactInfoViewModel {
    digitalPostBoxName?: string | undefined;
    digitalPostBoxUrl?: string | undefined;
    emailAddress?: string | undefined;
    faxNumber?: string | undefined;
    phoneNumber?: string | undefined;
    webAddress?: string | undefined;
}

export interface TeamUpdateModel extends TeamCreateModel {
    teamId: string;
}

export enum BillingType {
    Recurring = "recurring",
    Once = "once",
    None = "none",
}

export enum BillingPrinciple {
    Prepayment = "prepayment",
    PostPayment = "postPayment",
}

export interface CreateCoPaymentParagraph107Request {
    monthlyIncomeBasis: number;
    monthlyCostBasedCoPayment: number;
    necessaryExpenses: number;
    desiredMonthlyDisposableAmount: number;
    reductionRemark?: string | undefined;
}

export interface CreateCoPaymentParagraph108Request {
    annualIncomeBasis: number;
    monthlyCostBasedCoPayment: number;
    desiredMonthlyDisposableAmount: number;
    reductionRemark?: string | undefined;
    monthlyElectricityCost: number;
    electricityCostDetails?: string | undefined;
    monthlyHeatingCost: number;
    heatingCostDetails?: string | undefined;
}

export enum CoPaymentRectificationTier {
    SaveInPlace = "saveInPlace",
    CancelAndRegenerateReceivables = "cancelAndRegenerateReceivables",
    FullCorrection = "fullCorrection",
}

export interface CoPaymentRectificationPayload {
    description?: string | undefined;
    amount: number;
    billingType: BillingType;
    billingPrinciple?: BillingPrinciple | undefined;
    startDate: Date | string;
    endDate: Date | string;
    firstBillingAdjustment: number;
    lastBillingAdjustment: number;
    paragraph107?: CoPaymentRectificationParagraph107Payload | undefined;
    paragraph108?: CoPaymentRectificationParagraph108Payload | undefined;
}

export interface CoPaymentRectificationParagraph107Payload {
    monthlyIncomeBasis: number;
    monthlyCostBasedCoPayment: number;
    necessaryExpenses: number;
    desiredMonthlyDisposableAmount: number;
    reductionRemark?: string | undefined;
}

export interface CoPaymentRectificationParagraph108Payload {
    annualIncomeBasis: number;
    monthlyCostBasedCoPayment: number;
    desiredMonthlyDisposableAmount: number;
    reductionRemark?: string | undefined;
    monthlyElectricityCost: number;
    electricityCostDetails?: string | undefined;
    monthlyHeatingCost: number;
    heatingCostDetails?: string | undefined;
}

export interface ActivityStatusCauseTypeModel {
    id: string;
    externalId: number;
}

export interface ActivationLevelModel {
    id?: string | undefined;
    assessmentDate: Date | string;
    activationHours?: number | undefined;
    expectedHours?: number | undefined;
    comment?: string | undefined;
    isSubjectToWorkDuty: boolean;
    isDeleted?: boolean | undefined;
}

export interface ValidationMessage {
    title?: string | undefined;
    message?: string | undefined;
    severity: ValidationSeverity;
    propertyName?: string | undefined;
    link?: string | undefined;
}

export enum ValidationSeverity {
    Warning = "warning",
    Error = "error",
}

export interface CreateActivityRequestBase {
    ignoreWarnings: boolean;
    category: number;
    offerId?: string | undefined;
    offerTypeId: string;
    title?: string | undefined;
    activityDescription?: string | undefined;
    activityStatusTypeIdentifier: number;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
    caseId?: string | undefined;
    grantId?: string | undefined;
    caseworkerId?: string | undefined;
    citizenId: string;
    availabilityProving?: boolean | undefined;
    firstDayMeetingTime?: string | undefined;
    furtherInformationAttendance?: string | undefined;
    isOpenOffer: boolean;
    placementPurposeId?: string | undefined;
    plannedEndDate?: Date | string | undefined;
    precedingActivityId?: string | undefined;
    reasonForActivity?: string | undefined;
    kyOfferTypeId?: string | undefined;
    extendCitizenExternalOperatorReferrals: boolean;
    externalOperatorReferralId?: string | undefined;
    address?: ActivityAddressModel | undefined;
    approval?: ActivityApprovalModel | undefined;
    contactPerson?: ActivityContactPersonModel | undefined;
    activityPriceCalculation?: ActivityPriceCalculationModel | undefined;
    courseActivity?: CourseActivityModel | undefined;
    companyActivity?: CompanyActivityModel | undefined;
    mentorActivity?: MentorActivityModel | undefined;
    personalAssistanceActivity?: PersonalAssistanceActivityModel | undefined;
    helpingDeviceActivity?: HelpingDeviceActivityModel | undefined;
    socialEffortActivity?: SocialEffortActivityModel | undefined;
    highReimbursement: boolean;
    serviceProviderUnitId?: string | undefined;
}

export interface ActivityAddressModel {
    providerCompanyName?: string | undefined;
    countryId?: string | undefined;
    companyId?: string | undefined;
    cvr?: string | undefined;
    districtName?: string | undefined;
    districtSubdivisionIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    postalCode?: string | undefined;
    productionUnitIdentifier?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    streetName?: string | undefined;
    suiteIdentifier?: string | undefined;
}

export interface ActivityApprovalModel {
    approvalRefusalDate?: Date | string | undefined;
    citizenGoal?: string | undefined;
    citizenRemark?: string | undefined;
    daysBetweenProgressionMeasurements?: number | undefined;
    frequencyForProgressionMeasurement?: FrequencyForProgressionMeasurement | undefined;
    internalApprovalDate?: Date | string | undefined;
    internalApprovalDueDate?: Date | string | undefined;
    internalApproverUserId?: string | undefined;
}

export enum FrequencyForProgressionMeasurement {
    NoReportingMeasurement = "noReportingMeasurement",
    EveryWeek = "everyWeek",
    EveryOtherWeek = "everyOtherWeek",
    EveryMonth = "everyMonth",
    Quarterly = "quarterly",
    WithXDaysInBetween = "withXDaysInBetween",
    WhenCompletingActivity = "whenCompletingActivity",
    SemiAnnually = "semiAnnually",
    Annually = "annually",
    EveryOtherYear = "everyOtherYear",
}

export interface ActivityContactPersonModel {
    companyContactPersonId?: string | undefined;
    emailAddress?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface ActivityPriceCalculationModel {
    periodTotalPrice?: number | undefined;
    periodTotalPriceBase?: number | undefined;
    priceModel?: PriceModel | undefined;
    priceModelInitialRate?: number | undefined;
    priceModelInitialRateCorrection?: number | undefined;
    priceModelInitialRateBase?: number | undefined;
    unitPrice?: number | undefined;
    unitPriceCorrection?: number | undefined;
    unitPriceBase?: number | undefined;
    priceNotes?: string | undefined;
}

export enum PriceModel {
    PerHour = "perHour",
    PerDay = "perDay",
    PerWeek = "perWeek",
    PerMonth = "perMonth",
    PerProcess = "perProcess",
    PerHourWithStartTax = "perHourWithStartTax",
    PerDayWithStartTax = "perDayWithStartTax",
    PerWeekWithStartTax = "perWeekWithStartTax",
    PerMonthWithStartTax = "perMonthWithStartTax",
}

export interface CourseActivityModel {
    amuCode?: string | undefined;
    dunCode?: string | undefined;
    educationType?: OfferAndActivityEducationType | undefined;
    numberOfWeeksWithPracticalTraining?: number | undefined;
    hoursPerWeeksWithPracticalTraining?: number | undefined;
    minutesPerWeeksWithPracticalTraining?: number | undefined;
    practicalTraining: boolean;
    courseTypeCodeListId: string;
    courseAllocationTypeCodeListId: string;
}

export enum OfferAndActivityEducationType {
    DUN = "dun",
    AMU = "amu",
}

export interface CompanyActivityModel {
    efficientHoursPerWeek?: number | undefined;
    efficientMinutesPerWeek?: number | undefined;
    flexJobType?: number | undefined;
    hiringOrganisationType?: number | undefined;
    specialConsideration?: string | undefined;
    assessmentOfEmployabilityDescription?: string | undefined;
    occupationId?: string | undefined;
    jobAllocationId?: string | undefined;
    jobOrderPriceHourId?: string | undefined;
    purposeOfCompanyInternshipTypeId?: string | undefined;
    jobOfferTypeId?: string | undefined;
    authorityAreaTypeId?: string | undefined;
    activityVitas?: ActivityVitasModel | undefined;
}

export interface ActivityVitasModel {
    vitasJobAllocationId?: string | undefined;
    vitasAllocationUrl?: string | undefined;
    vitasCaseId?: string | undefined;
    vitasCreatedByUserId?: string | undefined;
    vitasCreatedByUserTeamId?: string | undefined;
    vitasCreatedOn?: Date | string | undefined;
    latestUpdateFromVitas?: Date | string | undefined;
}

export interface MentorActivityModel {
    activityVitas?: ActivityVitasModel | undefined;
}

export interface PersonalAssistanceActivityModel {
    personalAssistanceTypeId?: string | undefined;
    personalAssistanceKind: number;
    pricePerHourType?: number | undefined;
    pricePerHour?: number | undefined;
    otherPriceType?: number | undefined;
    otherPrice?: number | undefined;
    activityVitas?: ActivityVitasModel | undefined;
}

export interface HelpingDeviceActivityModel {
    price?: number | undefined;
    helpingDeviceIdentifier?: HelpingDeviceIdentifier | undefined;
    helpingDeviceTypeId?: string | undefined;
    ownershipType?: HelpingDeviceOwnershipDisposal | undefined;
    activityVitas?: ActivityVitasModel | undefined;
}

export enum HelpingDeviceIdentifier {
    Undervisningsmateriale = "undervisningsmateriale",
    Arbejdsredskaber = "arbejdsredskaber",
    Mindrearbejdspladsindretninger = "mindrearbejdspladsindretninger",
    Stttetilsrligeudgifter = "stttetilsrligeudgifter",
    Tilskudtilpersonligassistance = "tilskudtilpersonligassistance",
}

export enum HelpingDeviceOwnershipDisposal {
    Loan = "loan",
    Subsidy = "subsidy",
}

export interface SocialEffortActivityModel {
    socialEffortActivityTypeId: string;
}

export interface CreateOfferRequestBase {
    companyId?: string | undefined;
    category: number;
    suggestedActivityDescription?: string | undefined;
    endDate?: Date | string | undefined;
    externalOperatorAgreementId?: string | undefined;
    internalDescription?: string | undefined;
    name?: string | undefined;
    offerTypeId?: string | undefined;
    responsibleTeamId?: string | undefined;
    responsibleUserId?: string | undefined;
    startDate?: Date | string | undefined;
    targetAgeFrom?: number | undefined;
    targetAgeTo?: number | undefined;
    offerAddress?: OfferAddressModel | undefined;
    offerApproval?: OfferApprovalModel | undefined;
    offerFollowup?: OfferFollowupModel | undefined;
    offerContactPerson?: OfferContactPersonModel | undefined;
    offerTag?: OfferTagModel | undefined;
    importantTag?: ImportantTagModel | undefined;
    targetGroups?: string[] | undefined;
    seatCalculation?: SeatCalculationModel | undefined;
    offerGroupId?: string | undefined;
    companyOffer?: CompanyOfferModel | undefined;
    courseOffer?: CourseOfferModel | undefined;
    healthOffer?: HealthOfferModel | undefined;
    mentorOffer?: MentorOfferModel | undefined;
    personalAssistanceOffer?: PersonalAssistanceOfferModel | undefined;
    helpingDeviceOffer?: HelpingDeviceOfferModel | undefined;
    socialEffortOffer?: SocialEffortOfferModel | undefined;
    socialProviderUnitId?: string | undefined;
    departmentUuid?: string | undefined;
    precedingOfferId?: string | undefined;
    maxActiveResourcesPerActivity?: number | undefined;
    methodTypeIds?: string[] | undefined;
    hasWaitingList: boolean;
}

export interface OfferAddressModel {
    companyName?: string | undefined;
    companyPhoneNumber?: string | undefined;
    districtName?: string | undefined;
    districtSubdivisionIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    postalCode?: string | undefined;
    productionUnitIdentifier?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    streetName?: string | undefined;
    suiteIdentifier?: string | undefined;
    website?: string | undefined;
    countryId?: string | undefined;
}

export interface OfferApprovalModel {
    hasRelatedSupplierPlatformOffer: boolean;
    supplierPlatformProjectNumber?: string | undefined;
    isActivityApprovalRequired: boolean;
    minDaysToApprovePlacement?: number | undefined;
    monetaryTrivialityLimit?: number | undefined;
}

export interface OfferFollowupModel {
    daysBetweenProgressionMeasurements?: number | undefined;
    frequencyForProgressionMeasurement?: FrequencyForProgressionMeasurement | undefined;
}

export interface OfferContactPersonModel {
    phoneNumber?: string | undefined;
    email?: string | undefined;
    companyContactPersonId?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
}

export interface OfferTagModel {
    offerTag1?: string | undefined;
    offerTag2?: string | undefined;
    offerTag3?: string | undefined;
    offerTag4?: string | undefined;
    offerTag5?: string | undefined;
}

export interface ImportantTagModel {
    importantTag1?: string | undefined;
    importantTag2?: string | undefined;
}

export interface SeatCalculationModel {
    isSinglePlaceOffer: boolean;
    numberToFill?: number | undefined;
    allowOverlappingPlacementsForCitizen?: AllowOverlappingPlacementsForCitizenModel | undefined;
    allowOverbooking: boolean;
    reserveForExtensions: boolean;
    deadlineForPlacement?: Date | string | undefined;
    firstDayOfAvailableSeat?: Date | string | undefined;
    gracePeriodInDaysBetweenActivities?: number | undefined;
    numberOfOccupiedSeats?: number | undefined;
    numberOfAvailableSeats?: number | undefined;
    defaultPlacementDays?: number | undefined;
    defaultStartDateOffset?: number | undefined;
    maxDeviationFromDefaultDays?: number | undefined;
}

export interface AllowOverlappingPlacementsForCitizenModel {
    id: number;
    description?: string | undefined;
}

export interface CompanyOfferModel {
    openOffer: boolean;
    ownCarRequired: boolean;
    schedule?: number | undefined;
    availabilityProving: boolean;
    occupationId: string;
    hiringOrganisationType?: number | undefined;
    isAssociatedToRecruitmentRequest: boolean;
    offerVitas?: OfferVitasModel | undefined;
    acceptedDriversLicenses?: string[] | undefined;
    authorityAreaTypeId?: string | undefined;
}

export interface OfferVitasModel {
    vitasApprovedByUserId?: string | undefined;
    vitasApprovedByUserTeamId?: string | undefined;
    vitasApprovedOn?: Date | string | undefined;
    vitasCaseId: string;
    vitasEarmarkedToContactId?: string | undefined;
    vitasJobOfferId?: string | undefined;
    vitasJobOfferUrl?: string | undefined;
    vitasRegistrationDate?: Date | string | undefined;
    latestUpdateFromVitas?: Date | string | undefined;
}

export interface CourseOfferModel {
    hoursPerWeek?: number | undefined;
    amuCode?: string | undefined;
    availabilityProving?: boolean | undefined;
    dunCode?: string | undefined;
    educationtype?: number | undefined;
    openOffer?: boolean | undefined;
    priceCalculation?: OfferPriceCalculationModel | undefined;
}

export interface OfferPriceCalculationModel {
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
    priceModel?: PriceModel | undefined;
    priceModelInitialRate?: number | undefined;
    priceModelInitialRateBase?: number | undefined;
    unitPrice?: number | undefined;
    unitPriceBase?: number | undefined;
    allowActivityPriceChanges?: boolean | undefined;
    allowActivityPriceCorrections?: boolean | undefined;
}

export interface HealthOfferModel {
    priceCalculation?: OfferPriceCalculationModel | undefined;
}

export interface MentorOfferModel {
    priceCalculation?: OfferPriceCalculationModel | undefined;
}

export interface PersonalAssistanceOfferModel {
    pricePerHour?: number | undefined;
    actualPrice?: number | undefined;
}

export interface HelpingDeviceOfferModel {
    helpingDeviceIdentifier?: HelpingDeviceIdentifier | undefined;
    ownershipDisposal?: HelpingDeviceOwnershipDisposal | undefined;
    price?: number | undefined;
}

export interface SocialEffortOfferModel {
    priceCalculation?: OfferPriceCalculationModel | undefined;
}

export interface DeleteUpcomingOfferPriceRequestModel {
    offerPriceId: string;
    offerId: string;
}

export interface SendActivityLetterCitizenRequest {
    activityId: string;
    letterContent?: Content | undefined;
    template?: TemplateInfo | undefined;
    journalNote?: Journal | undefined;
    renderTemplateVariables?: ActivityLetterRenderTemplateVariablesDto | undefined;
    outgoingDocumentType?: ActivityLetterOutgoingDocument | undefined;
    journalInfoForCompanyAttachments?: CompanyAttachmentsInfo | undefined;
}

export interface Content {
    letterTitle?: string | undefined;
    letterText?: string | undefined;
    attachments?: string[] | undefined;
}

export interface TemplateInfo {
    templateId: number;
    variantId?: number | undefined;
}

export interface Journal {
    title?: string | undefined;
    journalContent?: string | undefined;
}

export interface ActivityLetterRenderTemplateVariablesDto {
    typedVariableIds?: ActivityLetterTypedVariableIdDto[] | undefined;
    untypedVariablesJson?: string | undefined;
}

export interface ActivityLetterTypedVariableIdDto {
    id?: string | undefined;
    variableType: ActivityLetterVariableTypeDto;
}

export enum ActivityLetterVariableTypeDto {
    Borger = "borger",
    Sagsbehandler = "sagsbehandler",
    Aftale = "aftale",
    Radighedsvurdering = "radighedsvurdering",
    Virksomhed = "virksomhed",
    Afdeling = "afdeling",
    Businessunit = "businessunit",
    Placements = "placements",
    AndenAktoerHenvisning = "andenAktoerHenvisning",
    Forlaengelsesvurdering = "forlaengelsesvurdering",
    Ressourceprofil = "ressourceprofil",
    Plan = "plan",
    Plantype = "plantype",
    Journalnotater = "journalnotater",
    Jobhenvisning = "jobhenvisning",
    Jobplan = "jobplan",
    Rekrutteringsanmodning = "rekrutteringsanmodning",
}

export interface ActivityLetterOutgoingDocument {
    typeId?: string | undefined;
    typeName?: string | undefined;
}

export interface CompanyAttachmentsInfo {
    journalNoteTitle?: string | undefined;
    journalNoteContent?: string | undefined;
    companyAttachmentIds?: string[] | undefined;
}

export interface SendAcitivityCompanyLetterRequest {
    templateId: number;
    outgoingDocumentTypeId?: string | undefined;
    outgoingDocumentTypeName?: string | undefined;
    attachments?: string[] | undefined;
    letterHeadline?: string | undefined;
    letterContent?: string | undefined;
    contactPersonId?: string | undefined;
    interactionResultId?: string | undefined;
    interactionPurposeId?: string | undefined;
    caseWorkerId: string;
    caseWorkerName?: string | undefined;
    recipientCompanyId: string;
    recipientName?: string | undefined;
    recipientAddress?: string | undefined;
    recipientCountryCode?: string | undefined;
    recipientAttention?: string | undefined;
    renderTemplateVariables?: RenderTemplateVariablesDto | undefined;
}

export interface RenderTemplateVariablesDto {
    typedVariableIds?: TypedVariableIdDto[] | undefined;
    untypedVariablesJson?: string | undefined;
    caseId?: string | undefined;
}

export interface TypedVariableIdDto {
    id?: string | undefined;
    variableType: VariableTypeDto;
}

export enum VariableTypeDto {
    Borger = "borger",
    Sagsbehandler = "sagsbehandler",
    Aftale = "aftale",
    Radighedsvurdering = "radighedsvurdering",
    Virksomhed = "virksomhed",
    Afdeling = "afdeling",
    Businessunit = "businessunit",
    Placements = "placements",
    AndenAktoerHenvisning = "andenAktoerHenvisning",
    Forlaengelsesvurdering = "forlaengelsesvurdering",
    Ressourceprofil = "ressourceprofil",
    Plan = "plan",
    Plantype = "plantype",
    Journalnotater = "journalnotater",
    Jobhenvisning = "jobhenvisning",
    Jobplan = "jobplan",
    Rekrutteringsanmodning = "rekrutteringsanmodning",
    Bestilling = "bestilling",
}

export interface ActivityResourceAllocationItem {
    offerResourceId: string;
    allocatedHoursPerWeek: number;
    allocatedMinutesPerWeek: number;
    allocationNote?: string | undefined;
}

export interface ActivationLevelDto {
    id: string;
    citizenId: string;
    assessmentDate: Date | string;
    activationHours?: number | undefined;
    expectedHours?: number | undefined;
    comment?: string | undefined;
    isDeleted: boolean;
    isSubjectToWorkDuty: boolean;
}

export interface UpdateActivityRequestBase {
    ignoreWarnings?: boolean | undefined;
    activityId: string;
    offerId?: string | undefined;
    offerTypeId: string;
    title?: string | undefined;
    activityDescription?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
    caseId?: string | undefined;
    grantId?: string | undefined;
    caseworkerId?: string | undefined;
    citizenId: string;
    availabilityProving?: boolean | undefined;
    firstDayMeetingTime?: string | undefined;
    furtherInformationAttendance?: string | undefined;
    isOpenOffer: boolean;
    placementPurposeId?: string | undefined;
    plannedEndDate?: Date | string | undefined;
    precedingActivityId?: string | undefined;
    reasonForActivity?: string | undefined;
    kyOfferTypeId?: string | undefined;
    extendCitizenExternalOperatorReferrals: boolean;
    address?: ActivityAddressModel | undefined;
    approval?: ActivityApprovalModel | undefined;
    contactPerson?: ActivityContactPersonModel | undefined;
    activityPriceCalculation?: ActivityPriceCalculationModel | undefined;
    courseActivity?: CourseActivityModel | undefined;
    companyActivity?: CompanyActivityModel | undefined;
    mentorActivity?: MentorActivityModel | undefined;
    personalAssistanceActivity?: PersonalAssistanceActivityModel | undefined;
    helpingDeviceActivity?: HelpingDeviceActivityModel | undefined;
    highReimbursement: boolean;
}

export interface UpdatePlacementPriceResponseModel {
    success: boolean;
    errorDetails?: UpdatePlacementErrorModel | undefined;
}

export interface UpdatePlacementErrorModel {
    placementId: string;
    placementUrl?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    title?: string | undefined;
    offerTypeName?: string | undefined;
    contactName?: string | undefined;
}

export interface UpdatePlacementPriceRequestModel {
    placementId: string;
    newUnitPrice: number;
    newPriceModelInitialRate?: number | undefined;
    newPriceModel?: OptionValue | undefined;
}

export interface OptionValue {
    value: number;
    text?: string | undefined;
}

export interface UpdateOfferRequestBase {
    offerId: string;
    companyId?: string | undefined;
    title?: string | undefined;
    internalDescription?: string | undefined;
    suggestedActivityDescription?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    externalOperatorAgreementId?: string | undefined;
    targetAgeFrom?: number | undefined;
    targetAgeTo?: number | undefined;
    responsibleTeamId?: string | undefined;
    responsibleUserId?: string | undefined;
    offerAddress?: OfferAddressModel | undefined;
    offerApproval?: OfferApprovalModel | undefined;
    offerFollowup?: OfferFollowupModel | undefined;
    offerContactPerson?: OfferContactPersonModel | undefined;
    offerTag?: OfferTagModel | undefined;
    importantTag?: ImportantTagModel | undefined;
    targetGroupIds?: string[] | undefined;
    seatCalculation?: SeatCalculationModel | undefined;
    companyOffer?: CompanyOfferModel | undefined;
    courseOffer?: CourseOfferModel | undefined;
    healthOffer?: HealthOfferModel | undefined;
    personalAssistanceOffer?: PersonalAssistanceOfferModel | undefined;
    socialEffortOffer?: SocialEffortOfferModel | undefined;
    helpingDeviceOffer?: HelpingDeviceOfferModel | undefined;
    mentorOffer?: MentorOfferModel | undefined;
    offerGroupId?: string | undefined;
    socialProviderUnitId?: string | undefined;
    departmentUuid?: string | undefined;
    maxActiveResourcesPerActivity?: number | undefined;
    methodTypeIds?: string[] | undefined;
    hasWaitingList: boolean;
}

export interface UpdateOfferPriceResponseModel {
    offerUpdatedSuccessfully: boolean;
    updateOfferErrorMessage?: string | undefined;
}

export interface UpdateOfferPriceRequestModel {
    offerId: string;
    newPriceModel?: OptionValue | undefined;
    newPriceModelInitialRate?: number | undefined;
    newUnitPrice: number;
    startDate?: Date | string | undefined;
    updateOngoingActivities: boolean;
    updateHistoricActivities: boolean;
}

export interface ValidationMessage2 {
    title?: string | undefined;
    message?: string | undefined;
    severity: ValidationSeverity2;
    propertyName?: string | undefined;
    link?: string | undefined;
}

export enum ValidationSeverity2 {
    Warning = "warning",
    Error = "error",
}

export interface UpdateUpcomingOfferPriceRequestModel {
    offerPriceId: string;
    offerId: string;
    newPriceModel?: OptionValueViewModel | undefined;
    newPriceModelInitialRate?: number | undefined;
    newUnitPrice: number;
    startDate: Date | string;
    updateOngoingActivities: boolean;
    updateHistoricActivities: boolean;
}

export interface OptionValueViewModel {
    value: number;
    text?: string | undefined;
}

export enum WaitingListSeatStatus {
    Active = "active",
    Paused = "paused",
    Utilized = "utilized",
    Deleted = "deleted",
}

export interface JobcenterTaskDocumentForIncomingMail {
    title?: string | undefined;
    owner?: string | undefined;
    blobReference?: string | undefined;
}

export interface JobAdEditViewModelV2 {
    externalJobAdId?: string | undefined;
    jobAdMetadata?: JobAdMetadataV2 | undefined;
    company?: JobAdCompanyViewModelV2 | undefined;
    applicationDetails?: JobAdApplicationDetailsViewModelV2 | undefined;
    jobDetails?: JobDetailsViewModelV2 | undefined;
    isAnonymousEmployer: boolean;
    description?: string | undefined;
    title?: string | undefined;
    publishStartDate: Date | string;
    publishEndDate: Date | string;
}

export interface JobAdMetadataV2 {
    status: number;
    statusName?: string | undefined;
    lastModified?: Date | string | undefined;
    postedByUserName?: string | undefined;
    numberOfViews: number;
}

export interface JobAdCompanyViewModelV2 {
    companyId: string;
    companyName?: string | undefined;
    address?: JobAdAddressViewModelV2 | undefined;
}

export interface JobAdAddressViewModelV2 {
    countryCode?: string | undefined;
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    suiteIdentifier?: string | undefined;
    municipalityId?: number | undefined;
    municipalityName?: string | undefined;
    postalCity?: string | undefined;
    postalCode?: string | undefined;
}

export interface JobAdApplicationDetailsViewModelV2 {
    emailAddress?: string | undefined;
    telephoneNumber?: string | undefined;
    applyOnlineUrl?: string | undefined;
    contact?: JobAdContactViewModelV2 | undefined;
    deadline: Date | string;
    numberOfPositions: number;
}

export interface JobAdContactViewModelV2 {
    title?: string | undefined;
    email?: string | undefined;
    telephoneNumber?: string | undefined;
    personGivenName?: string | undefined;
    personSurname?: string | undefined;
}

export interface JobDetailsViewModelV2 {
    employmentType: JobAdTypeV2;
    jobProperties?: JobPropertiesV2[] | undefined;
    driversLicenses?: number[] | undefined;
    isDisabilityFriendly?: boolean | undefined;
    employmentDate?: Date | string | undefined;
    occupationId: string;
    address?: JobAdAddressViewModelV2 | undefined;
    noLocalBusinessAddress?: boolean | undefined;
    minWorkHours?: number | undefined;
    maxWorkHours?: number | undefined;
    partTime: boolean;
    worktimeConditions?: WorkTimeConditionV2[] | undefined;
    limitedPeriod: boolean;
}

export enum JobAdTypeV2 {
    OrdinaryJob = "ordinaryJob",
    HotJob = "hotJob",
    WageSubsidy = "wageSubsidy",
    FlexJob = "flexJob",
    EarlyRetirement = "earlyRetirement",
    JobRotation = "jobRotation",
    EarlyRetiree = "earlyRetiree",
    CompanyInternship = "companyInternship",
    NormalAndEarlyRetiree = "normalAndEarlyRetiree",
    NormalAndEarlyRetireeWithHotJob = "normalAndEarlyRetireeWithHotJob",
}

export enum JobPropertiesV2 {
    Eures = "eures",
    WorkInDenmark = "workInDenmark",
    Municipality = "municipality",
    Region = "region",
    State = "state",
    OwnCar = "ownCar",
}

export enum WorkTimeConditionV2 {
    Daily = "daily",
    Morning = "morning",
    Evening = "evening",
    Nigth = "nigth",
    Weekend = "weekend",
    Varying = "varying",
}

export interface NewChatAttachmentModel {
    content?: string | undefined;
    fileName?: string | undefined;
    mimeType?: string | undefined;
}

export interface ChatMessageAttachmentModel {
    content?: string | undefined;
    fileName?: string | undefined;
    mimeType?: string | undefined;
}

export interface NewsAttachmentUploadModel {
    content?: string | undefined;
    fileName?: string | undefined;
    mimeType?: string | undefined;
}

export interface QuestionnaireNudgeResultModel {
    citizenId: string;
    outcome: QuestionnaireNudgeOutcome;
}

export enum QuestionnaireNudgeOutcome {
    Sent = "sent",
    SentTooRecently = "sentTooRecently",
    AlreadyAnsweredAndOpen = "alreadyAnsweredAndOpen",
}

export enum PseudoFasitEntityDiscriminatorEnum {
    None = "none",
    Offer = "offer",
    ConsentDeclaration = "consentDeclaration",
    Conversation = "conversation",
    Progression = "progression",
}

export interface AttachmentMetaDataModel {
    id: string;
    filename?: string | undefined;
    mimetype?: string | undefined;
    reference?: string | undefined;
    size: number;
}

export interface CreateAgreementModel {
    startDate: Date | string;
    endDate: Date | string;
    title?: string | undefined;
    description?: string | undefined;
    externalOperatorCompanyId: string;
    referralReason?: string | undefined;
    degreeOfAuthorityDelegation: DegreeOfAuthorityDelegation;
}

export enum DegreeOfAuthorityDelegation {
    FullAuthority = "fullAuthority",
    PartlyAuthority = "partlyAuthority",
    NoAuthority = "noAuthority",
}

export interface CreateReferralModel {
    startDate: Date | string;
    endDate: Date | string;
    justification?: string | undefined;
    citizenId: string;
    agreementId: string;
    responsibleCaseWorkerId: string;
    activityId?: string | undefined;
}

export interface LetterInformation {
    outgoingDocumentTypeId?: string | undefined;
    letterContent: string;
    companyId?: string | undefined;
    contactPersonId?: string | undefined;
    attention?: string | undefined;
    attachments?: ReferralAttachment[] | undefined;
}

export interface ReferralAttachment {
    aliasId?: string | undefined;
    id: string;
    documentId: string;
    title: string;
    name: string;
    size: string;
    sizeInBytes: number;
    mime: string;
    added: string;
}

export interface AgreementModel {
    id: string;
    createdById: string;
    createdOn: Date | string;
    title: string;
    description: string;
    startDate: Date | string;
    endDate: Date | string;
    referralReason?: string | undefined;
    externalOperatorCompanyId: string;
    pNumber: string;
    degreeOfAuthorityDelegation?: DegreeOfAuthorityDelegation | undefined;
    referrals?: string[] | undefined;
    responsibilityAreas?: string[] | undefined;
}

export interface ReferralModel {
    id: string;
    createdById: string;
    createdOn: Date | string;
    startDate: Date | string;
    endDate: Date | string;
    justification?: string | undefined;
    status?: ReferralStatus | undefined;
    citizenId: string;
    agreementId: string;
    responsibleCaseWorkerId: string;
    dfdgId?: string | undefined;
    activityId?: string | undefined;
}

export enum ReferralStatus {
    Planned = "planned",
    Ongoing = "ongoing",
    Cancelled = "cancelled",
    Closed = "closed",
}

export interface FilingStartInfo {
    filingDeliveryId: string;
    alreadyRunning: boolean;
}

export enum FilingType {
    Social_HandicappedAndVulnerableAdults = "social_HandicappedAndVulnerableAdults",
    Social_ExposedChildrenAndYoungPeople = "social_ExposedChildrenAndYoungPeople",
}

export enum TradeCodeOrigin {
    Cvr = "cvr",
    Fasit = "fasit",
}

export interface UpsertTagModel {
    id: string;
    companyId: string;
    tagTypeId: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
}

export interface UpsertTagsModel {
    tagTypeId: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
}

export interface SpecialCircumstanceDto {
    id: string;
    companyId: string;
    circumstanceTypeCode: CircumstanceTypeCode;
    endDate?: Date | string | undefined;
    startDate?: Date | string | undefined;
    primaryTargetGroupId?: string | undefined;
    specialCircumstanceAppointmentType?: string | undefined;
    title?: string | undefined;
}

export enum CircumstanceTypeCode {
    Aftale = "aftale",
    Blokade = "blokade",
    Varsling = "varsling",
    Arbejdsfordeling = "arbejdsfordeling",
}

export interface SpecialCircumstanceTargetGroupDto {
    id: string;
    specialCircumstanceId: string;
    targetGroupCodeListId: string;
}

export interface CompanyContactPersonDetailsDto {
    id: string;
    createdOn?: Date | string | undefined;
    isDisabled: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    personTitle?: string | undefined;
    responsibleCaseWorkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    floor?: string | undefined;
    suite?: string | undefined;
    postalCode?: string | undefined;
    districtName?: string | undefined;
    districtSubDivision?: string | undefined;
    countryId?: string | undefined;
    mobileNumber?: string | undefined;
    telephoneNumber?: string | undefined;
    directTelephoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    emailAddress?: string | undefined;
    note?: string | undefined;
    contactPersonTag1?: string | undefined;
    contactPersonTag2?: string | undefined;
    contactPersonTag3?: string | undefined;
    contactPersonTag4?: string | undefined;
    contactPersonTag5?: string | undefined;
    createdFromDfdg: boolean;
    companyId: string;
}

export interface PrivateContactPersonDetailsDto {
    id: string;
    isDisabled: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    personTitle?: string | undefined;
    responsibleCaseWorkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    floor?: string | undefined;
    suite?: string | undefined;
    postalCode?: string | undefined;
    districtName?: string | undefined;
    districtSubDivision?: string | undefined;
    countryId?: string | undefined;
    mobileNumber?: string | undefined;
    telephoneNumber?: string | undefined;
    directTelephoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    emailAddress?: string | undefined;
    note?: string | undefined;
    contactPersonTag1?: string | undefined;
    contactPersonTag2?: string | undefined;
    contactPersonTag3?: string | undefined;
    contactPersonTag4?: string | undefined;
    contactPersonTag5?: string | undefined;
    createdFromDfdg: boolean;
    cprNumber?: string | undefined;
}

export interface Repetition {
    repetitionUnit: RepetitionUnit;
    interval: number;
    maxRepetitions?: number | undefined;
}

export enum RepetitionUnit {
    Days = "days",
    Weeks = "weeks",
    Months = "months",
    Years = "years",
}

export interface CompanyRecruitmentDetailsAttachment {
    attachmentId: string;
    attachmentType: CompanyRecruitmentAttachmentType;
}

export enum CompanyRecruitmentAttachmentType {
    Bilag = "bilag",
}

export interface RecruitmentCandidateListItem {
    id: string;
    timeOfMediating?: Date | string | undefined;
    citizenId: string;
    citizenName?: string | undefined;
    civilRegistrationIdentifier?: string | undefined;
    mediatingEmployee?: string | undefined;
    timeOfApproval?: Date | string | undefined;
    status?: string | undefined;
    statusId: number;
    createdByJobcenterName?: string | undefined;
}

export interface CompanyRecruitmentReferralViewModel {
    id: string;
    title?: string | undefined;
    companyName?: string | undefined;
}

export interface FailedCandidateResponseItem {
    errorMessage?: string | undefined;
    candidate?: CreateCandidateListItem | undefined;
}

export interface CreateCandidateListItem {
    candidateName?: string | undefined;
    candidateCpr?: string | undefined;
}

export interface CompanyInformation {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    emailNotification: boolean;
    company?: CompanyDto | undefined;
    contactPerson?: ContactPersonDto | undefined;
}

export interface CompanyDto {
    id: string;
    name?: string | undefined;
    productionNumber?: string | undefined;
    cvr?: string | undefined;
    industry?: string | undefined;
    address?: CompanyAddress2 | undefined;
}

export interface CompanyAddress2 {
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    suiteIdentifier?: string | undefined;
    districtSubdivisionIdentifier?: string | undefined;
    postCodeIdentifier?: string | undefined;
    districtName?: string | undefined;
    countryIdentificationCode?: string | undefined;
}

export interface ContactPersonDto {
    id: string;
    firstName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    lastName?: string | undefined;
}

export interface BasicInformationJobOffer {
    offerType?: OfferTypeDto | undefined;
    status?: number | undefined;
    occupation?: OccupationDto | undefined;
    jobOrderOccupation?: string | undefined;
    companyNote?: CompanyNoteDto | undefined;
    title?: string | undefined;
    startDate?: Date | string | undefined;
    dueDate?: Date | string | undefined;
    numberOfJobs?: number | undefined;
    maximumNumberOfResponses?: number | undefined;
    weeklyHours?: number | undefined;
    jobDescription?: string | undefined;
    internalComment?: string | undefined;
    durationInDays?: number | undefined;
    weeklyWorkTimeType?: number | undefined;
    comment?: string | undefined;
    companyRecruitmentRespondType?: number | undefined;
    vitasCaseId?: string | undefined;
    placementPurposeId?: string | undefined;
    serviceTargetTypeId?: string | undefined;
    serviceTargetName?: string | undefined;
    numberOfWorkingDaysForDisseminationStart?: number | undefined;
    numberOfWorkingDaysForGrantCreation?: number | undefined;
    offerId?: string | undefined;
    recruitmentInformationType?: string | undefined;
    targetGroupIds?: string[] | undefined;
    workingHours?: number[] | undefined;
    longLasting?: boolean | undefined;
}

export interface OfferTypeDto {
    id: string;
    name?: string | undefined;
    typeCode: number;
    placementPurposeRequiredOnRecruitmentRequ?: boolean | undefined;
}

export interface OccupationDto {
    id: string;
    name?: string | undefined;
    conceptUriDa?: string | undefined;
    aliasIdentifier?: string | undefined;
}

export interface CompanyNoteDto {
    companyNoteId: string;
    name?: string | undefined;
    createdAt: Date | string;
    resultType?: string | undefined;
    createdBy?: string | undefined;
}

export interface JobPositionResponsibility {
    primaryJobOwner?: User | undefined;
    primaryJobOwnerTeam?: Team | undefined;
    secondaryJobOwner?: User | undefined;
    caseWorker?: User | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    caseWorkerId?: string | undefined;
    caseWorkerTeam?: Team | undefined;
    followUpDate?: Date | string | undefined;
    caseWorkerJobcenter?: JobcenterInfoDto | undefined;
}

export interface User {
    upn?: string | undefined;
    userIdentifier: string;
    caseWorkerFullName?: string | undefined;
    userEmail?: string | undefined;
    teamName?: string | undefined;
    teamId?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
}

export interface Team {
    id: string;
    name?: string | undefined;
}

export interface JobcenterInfoDto {
    id: string;
    code?: string | undefined;
    name?: string | undefined;
}

export interface UpdateCandidateResponseItem {
    isValid: boolean;
    errorMessage?: string | undefined;
    recruitmentCandidate: RecruitmentCandidateListItem;
}

export interface UpdateCandidateRequestItem {
    id: string;
    status: number;
    correctionComment?: string | undefined;
}

export interface CompanyRecruitmentDetailsViewModel {
    companyRecruitmentId: string;
    header?: CompanyRecruitmentDetailsHeader | undefined;
    general?: CompanyRecruitmentDetailsGeneral | undefined;
    referralEffort?: CompanyRecruitmentDetailsReferralEffort | undefined;
    caseWorker?: CompanyRecruitmentDetailsCaseWorker | undefined;
    companyContacts?: CompanyRecruitmentDetailsCompanyContacts | undefined;
    companyRecruitmentJobcenters?: CompanyRecruitmentDetailsJobcenter[] | undefined;
    companyRecruitmentCollaborations?: CompanyRecruitmentDetailsCollaboration[] | undefined;
    companyRecruitmentUnemploymentFunds?: CompanyRecruitmentDetailsUnemploymentFund[] | undefined;
    candidates?: RecruitmentCandidateListItem[] | undefined;
    responsibleJobcenter?: JobcenterInfoDto | undefined;
    companyRecruitmentDetailsHistory?: CompanyRecruitmentDetailsHistory | undefined;
    attachments?: CompanyRecruitmentDetailsAttachment[] | undefined;
    targetGroupIds?: string[] | undefined;
    isCandidateListHidden?: boolean | undefined;
}

export interface CompanyRecruitmentDetailsHeader {
    referenceNumber?: string | undefined;
    internalReferenceNumber?: number | undefined;
    mediatedPercent?: number | undefined;
    responsibilityStatus?: RecruitmentResponsibilityStatus | undefined;
    isCreatedByCompany?: boolean | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
}

export enum RecruitmentResponsibilityStatus {
    DoesNotHaveMediaManager = "doesNotHaveMediaManager",
    HasDisseminationManagerAtJobCenter = "hasDisseminationManagerAtJobCenter",
    HasDisseminationManagerAtAnotherJobCenter = "hasDisseminationManagerAtAnotherJobCenter",
}

export interface CompanyRecruitmentDetailsGeneral {
    offerType?: OfferTypeDto | undefined;
    title?: string | undefined;
    status: number;
    jobDescription?: string | undefined;
    internalComment?: string | undefined;
    startDate?: Date | string | undefined;
    dueDate?: Date | string | undefined;
    durationInDays?: number | undefined;
    maximumNumberOfResponses?: number | undefined;
    numberOfJobs?: number | undefined;
    companyRecruitmentRespondType?: RecruitmentRespondType | undefined;
    weeklyWorkTimeType?: WeeklyWorkTimeType | undefined;
    weeklyHours?: number | undefined;
    occupation?: OccupationDto | undefined;
    jobOrderOccupation?: string | undefined;
    closureCauseId?: string | undefined;
    closureCauseName?: string | undefined;
    placementPurposeType?: PlacementPurposeTypeDto | undefined;
    offer?: OfferDto | undefined;
    offerId?: string | undefined;
    vitasCaseId?: string | undefined;
    qualificationsAndSpecialCircumstances?: string | undefined;
    correctionComment?: string | undefined;
    recruitmentInformationType?: RecruitmentInformationType | undefined;
    showRecruitmentRequestOnCitizenPortal: boolean;
    longLasting: boolean;
    workingHours?: WorkingHours[] | undefined;
}

export enum RecruitmentRespondType {
    ResumeSubmitted = "resumeSubmitted",
    PersonalAttendance = "personalAttendance",
    TelephoneContactFromCitizen = "telephoneContactFromCitizen",
    TelephoneContactFromJobCenter = "telephoneContactFromJobCenter",
}

export enum WeeklyWorkTimeType {
    Fuldtid = "fuldtid",
    Deltid = "deltid",
    IkkeAngivet_DEPRECATED = "ikkeAngivet_DEPRECATED",
}

export interface PlacementPurposeTypeDto {
    id: string;
    name?: string | undefined;
}

export interface OfferDto {
    id: string;
    name?: string | undefined;
    vitasCaseId?: string | undefined;
    companyName?: string | undefined;
    startDate?: Date | string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    offerNo?: number | undefined;
}

export interface RecruitmentInformationType {
    id: string;
    name?: string | undefined;
}

export enum WorkingHours {
    Normal = "normal",
    Morning = "morning",
    Evening = "evening",
    Night = "night",
    Weekend = "weekend",
    Changing = "changing",
}

export interface CompanyRecruitmentDetailsReferralEffort {
    primaryJobOwner?: User | undefined;
    secondaryJobOwner?: User | undefined;
    currentServiceTargetType?: ServiceTargetTypeCodeListDto | undefined;
    serviceTargetHistory?: ServiceTargetDto[] | undefined;
    primaryJobOwnerTeam?: Team | undefined;
}

export interface ServiceTargetTypeCodeListDto {
    id: string;
    name?: string | undefined;
    numberOfWorkingDaysForDisseminationStart?: number | undefined;
    numberOfWorkingDaysForGrantStart?: number | undefined;
}

export interface ServiceTargetDto {
    id: string;
    name?: string | undefined;
    numberOfWorkingDaysForDisseminationStart?: number | undefined;
    numberOfWorkingDaysForGrantCreation?: number | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
}

export interface CompanyRecruitmentDetailsCaseWorker {
    caseWorkerId?: string | undefined;
    teamId?: string | undefined;
    followUpDate?: Date | string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    caseWorkerJobcenter?: JobcenterInfoDto | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    caseWorkerFullName?: string | undefined;
    teamName?: string | undefined;
    userId?: string | undefined;
}

export interface CompanyRecruitmentDetailsCompanyContacts {
    permanentComment?: string | undefined;
    contactPersonId?: string | undefined;
    contactPersonFirstname?: string | undefined;
    contactPersonLastname?: string | undefined;
    contactPersonEmail?: string | undefined;
    contactPersonPhone?: string | undefined;
    company?: CompanyDto | undefined;
    companyNoteInitiator?: CompanyNoteDto | undefined;
    companyNoteFollowUp?: CompanyNoteDto | undefined;
    companyNoteHire?: CompanyNoteDto | undefined;
}

export interface CompanyRecruitmentDetailsJobcenter {
    id: string;
    code?: string | undefined;
}

export interface CompanyRecruitmentDetailsCollaboration {
    id: string;
    name?: string | undefined;
}

export interface CompanyRecruitmentDetailsUnemploymentFund {
    id: string;
    code?: string | undefined;
}

export interface CompanyRecruitmentDetailsHistory {
    firstPrimaryJobOwner?: User | undefined;
    firstPrimaryJobOwnerTeam?: Team | undefined;
    timeOfFirstJobOwner?: Date | string | undefined;
    firstRecruitmentCaseWorker?: string | undefined;
    firstRecruitmentCaseWorkerTeam?: Team | undefined;
    timeOfFirstRecruitmentCaseWorker?: Date | string | undefined;
    firstCandidate?: string | undefined;
    timeOfCompletion?: Date | string | undefined;
    firstPlacementId?: string | undefined;
}

export interface SavedDashboardModel {
    id?: string | undefined;
    createdDate: Date | string;
    modifiedDate: Date | string;
    createdBy: string;
    createdByName?: string | undefined;
    modifiedBy: string;
    modifiedByName?: string | undefined;
    deleted: boolean;
    ownerId: string;
    type: WorklistSavedType;
    tags?: string[] | undefined;
    name?: string | undefined;
    description?: string | undefined;
    sections?: DashboardSection[] | undefined;
    dashboardCategory?: SavedDashboardCategory | undefined;
    isFavorite: boolean;
    accessRole?: Access | undefined;
    isSystemDashboard: boolean;
    lastUsedDate?: Date | string | undefined;
    lastUsedById?: string | undefined;
    usageCount?: number | undefined;
}

export enum WorklistSavedType {
    NotAvailable = "notAvailable",
    Manual = "manual",
    System = "system",
}

export interface DashboardSection {
    sectionId: string;
    sectionName?: string | undefined;
    isExpanded: boolean;
    worklistItems?: DashboardWorklistItem[] | undefined;
    textItems?: DashboardTextItem[] | undefined;
    layouts: DashboardLayout;
}

export interface DashboardWorklistItem {
    id: string;
    name?: string | undefined;
    chartId?: string | undefined;
    showChart: boolean;
    showChartSelector: boolean;
    showChartResizer: boolean;
    chartPresentationPercentage: number;
    showChartFull: boolean;
    queryId?: string | undefined;
    showQuery: boolean;
    showQuerySelector: boolean;
    type?: DashboardWorklistItemType | undefined;
}

export enum DashboardWorklistItemType {
    Worklist = "worklist",
    Chart = "chart",
}

export interface DashboardTextItem {
    id: string;
    name?: string | undefined;
    header?: string | undefined;
    text?: string | undefined;
}

export interface DashboardLayout {
    lg: DashboardItemLayout[];
}

export interface DashboardItemLayout {
    i: string;
    w: number;
    h: number;
    x: number;
    y: number;
}

export interface SavedDashboardCategory {
    savedDashboardCategoryId: string;
    name?: string | undefined;
}

export interface WorklistAccessControl {
    access: Access;
    objectId: string;
    objectType: ObjectType;
    principalId: string;
    principalType: PrincipalType;
}

export enum ObjectType {
    Query = "query",
    Chart = "chart",
    Dashboard = "dashboard",
}

export enum PrincipalType {
    Team = "team",
    User = "user",
}

export interface WorklistAccessControlToDelete {
    objectId: string;
    principalId: string;
}

export interface DeleteWorklistElementResult {
    objectType: ObjectType;
    objectId: string;
    deleted: boolean;
    reason?: string | undefined;
}

export interface WorklistElementToDelete {
    objectType: ObjectType;
    objectId: string;
}

export interface WorklistAccessControlToUpdate {
    access: Access;
    objectId: string;
    principalId: string;
}

export interface ReceivedUseOfForceAuthorizationRequestModel {
    id: string;
    status: UseOfForceAuthorizationRequestStatus;
    authorizationType?: UseOfForceAuthorizationType | undefined;
    requestedPeriodFrom?: Date | string | undefined;
    requestedPeriodTo?: Date | string | undefined;
    serviceProviderUnitName?: string | undefined;
    sentByName?: string | undefined;
    receivedAt?: Date | string | undefined;
    decisionMaker?: UseOfForceAuthorizationDecisionMaker | undefined;
    maxPeriodMonths?: number | undefined;
    decidedByName?: string | undefined;
    decidedAt?: Date | string | undefined;
    authorization?: UseOfForceAuthorizationModel | undefined;
}

export enum UseOfForceAuthorizationRequestStatus {
    Draft = "draft",
    Sent = "sent",
    Granted = "granted",
    Rejected = "rejected",
}

export enum UseOfForceAuthorizationType {
    Section125 = "section125",
    Section128 = "section128",
    Section128bSubsection1 = "section128bSubsection1",
    Section128bSubsection2 = "section128bSubsection2",
    Section128c = "section128c",
    Section128d = "section128d",
    Section128e = "section128e",
    Section128f = "section128f",
    Section128g = "section128g",
    Section128h = "section128h",
    Section136aSubsection3 = "section136aSubsection3",
}

export enum UseOfForceAuthorizationDecisionMaker {
    MunicipalCouncil = "municipalCouncil",
    SocialBoard = "socialBoard",
}

export interface UseOfForceAuthorizationModel {
    id: string;
    authorizationType: UseOfForceAuthorizationType;
    periodFrom: Date | string;
    periodTo: Date | string;
    decisionMaker: UseOfForceAuthorizationDecisionMaker;
    status: UseOfForceAuthorizationStatus;
    serviceProviderUnitName?: string | undefined;
    isFromRequest: boolean;
    registeredByServiceProvider: boolean;
    registeredByName?: string | undefined;
    registeredAt: Date | string;
    revokedByName?: string | undefined;
    revokedAt?: Date | string | undefined;
    awaitsSummaryRegistration: boolean;
}

export enum UseOfForceAuthorizationStatus {
    Active = "active",
    Expired = "expired",
    Revoked = "revoked",
}

export interface UseOfForceAssessmentModel {
    id: string;
    form: UseOfForceAssessedForm;
    status: UseOfForceAssessmentStatus;
    receivedAt: Date | string;
    interventionType?: UseOfForceInterventionType | undefined;
    interventionStartedAt?: Date | string | undefined;
    interventionEndedAt?: Date | string | undefined;
    authorizationType?: UseOfForceAuthorizationType | undefined;
    registrationPeriodFrom?: Date | string | undefined;
    registrationPeriodTo?: Date | string | undefined;
    serviceProviderUnitName?: string | undefined;
    approvedByName?: string | undefined;
    approvedAt?: Date | string | undefined;
    remarks?: string | undefined;
    requiresDecisionChange?: boolean | undefined;
    assessedByName?: string | undefined;
    assessedAt?: Date | string | undefined;
}

export enum UseOfForceAssessedForm {
    Incident = "incident",
    SummaryRegistration = "summaryRegistration",
}

export enum UseOfForceAssessmentStatus {
    Pending = "pending",
    Assessed = "assessed",
}

export interface NuphModel {
    nuphId?: string | undefined;
    citizenId: string;
    responsibleUnemploymentFundName?: string | undefined;
    nuphType?: NuphType | undefined;
    nuphProcessingStatusType?: NuphProcessingStatusType | undefined;
    eventStartDate: Date | string;
    eventEndDate?: Date | string | undefined;
    comment?: string | undefined;
    associatedWithTypeId?: string | undefined;
    associatedWithId?: string | undefined;
    isWithdrawn?: boolean | undefined;
    withdrawnDate?: Date | string | undefined;
    withdrawnComment?: string | undefined;
    externalIdentifier?: string | undefined;
    externalRegistrationInfo?: ExternalRegistrationInfoModel | undefined;
    auditInfo?: AuditInfoModel | undefined;
}

export interface CodeListItem {
    id: string;
    name?: string | undefined;
    isActive: boolean;
}

export interface StandardCodeList extends CodeListItem {
    description?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    externalId?: string | undefined;
    stateCode: number;
}

export interface NuphType extends StandardCodeList {
}

export interface NuphProcessingStatusType extends StandardCodeList {
}

export interface ExternalRegistrationInfoModel {
    userFullName?: string | undefined;
    authorityName?: string | undefined;
    registrationDate?: Date | string | undefined;
}

export interface AuditInfoModel {
    createdById: string;
    createdByName?: string | undefined;
    createdOn: Date | string;
    modifiedById?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedOn?: Date | string | undefined;
}

export interface DocumentArchiveDocument {
    id: string;
    documentId: string;
    shelf: string;
    title: string;
    name: string;
    added: string;
    aliasId?: string | undefined;
    size: string;
    sizeInBytes: number;
    mime: string;
}

export enum NuphAdditionalRequestResponseType {
    Request = "request",
    Response = "response",
}

export interface HoiActivity {
    offerTypeName?: string | undefined;
    activityTitle?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
    calendarDaysDifference?: number | undefined;
}

export interface NexusContactSelectionModel {
    nexusContactId: number;
    roleId: string;
}

export interface NexusImportResultItemModel {
    nexusReferenceId: number;
    nexusFormDataId: number;
    target: NexusImportTarget;
    outcome: NexusImportOutcome;
    title?: string | undefined;
    description?: string | undefined;
    plannedValues?: { [key: string]: string; } | undefined;
}

export enum NexusImportTarget {
    Unsupported = "unsupported",
    JournalNote = "journalNote",
    SupportAssessment = "supportAssessment",
    Caseworker = "caseworker",
    CitizenContact = "citizenContact",
    Document = "document",
    Letter = "letter",
    GrantOrOrder = "grantOrOrder",
    Effort = "effort",
    DiaryNote = "diaryNote",
    PartialObjective = "partialObjective",
}

export enum NexusImportOutcome {
    WouldCreate = "wouldCreate",
    Created = "created",
    Rejected = "rejected",
    Failed = "failed",
}

export interface NexusPartialObjectiveSelectionModel {
    nexusReferenceId: number;
    interventionObjectiveId: string;
    interventionObjectiveTitle?: string | undefined;
}

export interface CitizenConsentDto {
    hasGivenConsent: boolean;
    date?: Date | string | undefined;
    type?: ConsentType | undefined;
    remarks?: string | undefined;
}

export enum ConsentType {
    Verbally = "verbally",
    Written = "written",
}

export interface CitizenCurrentSituationDto {
    currentStatus?: string | undefined;
    improvedSuggestions?: string | undefined;
    currentAssistance?: string[] | undefined;
    otherAssistance?: string | undefined;
}

export interface AssessmentDto {
    coordinatingCaseWorkerId: string;
    coordinatingCaseWorkerName?: string | undefined;
    coordinatingCaseWorkerPhone?: string | undefined;
    coordinatingCaseWorkerEmail?: string | undefined;
    department?: string | undefined;
    citizenPhone?: string | undefined;
    citizenEmail?: string | undefined;
    incomeBasis?: string | undefined;
    address?: string | undefined;
    latestNetworkEffort?: string | undefined;
    previousNetworkAgreements?: string | undefined;
}

export interface JobCenterInformationDto {
    lastTwoYearsJobCenterActivitiesTried?: string | undefined;
    experience?: string | undefined;
    housing?: string | undefined;
    finances?: string | undefined;
    networkContacts?: string | undefined;
    healthInformation?: string | undefined;
}

export interface HoiCaseLetterDto {
    letter?: LetterDto | undefined;
    attachments?: string[] | undefined;
    letterRecipientCompanyId?: string | undefined;
    letterRecipientCompanyContactPersonId?: string | undefined;
    letterRecipientPrivateContactPersonId?: string | undefined;
}

export interface LetterDto {
    name?: string | undefined;
    attention?: string | undefined;
    address?: string | undefined;
    html?: string | undefined;
}

export interface CreatePartialRecoveryModel {
    citizenId: string;
    caseId: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    companyId?: string | undefined;
    hours?: number | undefined;
    absenceId?: string | undefined;
    note?: string | undefined;
}

export interface PartialRecoveryModel {
    id: string;
    caseId?: string | undefined;
    citizenId: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    companyId?: string | undefined;
    hours?: number | undefined;
    absenceId?: string | undefined;
    note?: string | undefined;
    createdOn: Date | string;
    deleted: boolean;
    deletedOn?: Date | string | undefined;
    dfdgId?: string | undefined;
}

export interface MissingParticipationCreateModel {
    comment?: string | undefined;
    deadlineForPartyReply: Date | string;
    employerGetsReimbursement: boolean;
    hearingStartDate: Date | string;
    paymentStopDate?: Date | string | undefined;
    caseId: string;
    missingParticipationTypeId: string;
    caseWorkerId: string;
}

export interface LetterInformation2 {
    companyId?: string | undefined;
    contactPersonId?: string | undefined;
    letterContent?: string | undefined;
    attention?: string | undefined;
    outgoingDocumentTypeId?: string | undefined;
    attachments?: MissingParticipationAttachment[] | undefined;
}

export interface MissingParticipationAttachment {
    id: string;
    documentId: string;
    title?: string | undefined;
    name?: string | undefined;
    size?: string | undefined;
    sizeInBytes: number;
    aliasId?: string | undefined;
    mime?: string | undefined;
    added?: string | undefined;
}

export interface RenderTemplateVariables {
    typedVariableIds?: TypedVariableId[] | undefined;
    untypedVariablesJson?: string | undefined;
    caseId?: string | undefined;
    serviceProviderUnitId?: string | undefined;
    isSocialOptic?: boolean | undefined;
}

export interface TypedVariableId {
    variableType: VariableType;
    id?: string | undefined;
}

export enum VariableType {
    Borger = "borger",
    Sagsbehandler = "sagsbehandler",
    Aftale = "aftale",
    Radighedsvurdering = "radighedsvurdering",
    Virksomhed = "virksomhed",
    Afdeling = "afdeling",
    Businessunit = "businessunit",
    Placements = "placements",
    AndenAktoerHenvisning = "andenAktoerHenvisning",
    Forlaengelsesvurdering = "forlaengelsesvurdering",
    Ressourceprofil = "ressourceprofil",
    Plan = "plan",
    Plantype = "plantype",
    Journalnotater = "journalnotater",
    Jobhenvisning = "jobhenvisning",
    Jobplan = "jobplan",
    Rekrutteringsanmodning = "rekrutteringsanmodning",
    PlanV2 = "planV2",
    Placering = "placering",
    Afgoerelse = "afgoerelse",
    Bestilling = "bestilling",
    Laegeanmodning = "laegeanmodning",
    Egenbetaling = "egenbetaling",
    Udfoererstatusnote = "udfoererstatusnote",
}

export interface MissingParticipationModel {
    id: string;
    assessmentAfterHearingReply?: string | undefined;
    cancellationReason?: string | undefined;
    comment?: string | undefined;
    commentFromCitizen?: string | undefined;
    completedDate?: Date | string | undefined;
    deadlineForPartyReply: Date | string;
    employerGetsReimbursement: boolean;
    hearingReplyDate?: Date | string | undefined;
    hearingStartDate: Date | string;
    paymentResumeDate?: Date | string | undefined;
    paymentStopDate?: Date | string | undefined;
    status: MissingParticipationStatus;
    caseId: string;
    missingParticipationTypeId: string;
    caseWorkerId: string;
    createdOn: Date | string;
    citizenId: string;
    maintainDecision: boolean;
}

export enum MissingParticipationStatus {
    UnderPartyHearing = "underPartyHearing",
    Finished = "finished",
    Cancelled = "cancelled",
}

export interface CreateExpectedJobResumptionModel {
    caseId: string;
    citizenId: string;
    absenceId: string;
    companyId?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    note?: string | undefined;
}

export interface UpdateExpectedJobResumptionModel {
    id: string;
    caseId?: string | undefined;
    citizenId: string;
    absenceId: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    note?: string | undefined;
}

export interface CreateBenefitExtensionAssessmentModel {
    citizenId: string;
    caseId: string;
    caseworkerId: string;
    followupDate?: Date | string | undefined;
    extensionStartDate: Date | string;
    status: BenefitExtensionAssessmentStatus;
    isRetired: boolean;
    employerGetsReimbursement: boolean;
    extensionReasonId?: string | undefined;
    description?: string | undefined;
    comment?: string | undefined;
    isSicknessPeriodExtended?: boolean | undefined;
}

export enum BenefitExtensionAssessmentStatus {
    Draft = "draft",
    UnderHearing = "underHearing",
    Completed = "completed",
    Cancelled = "cancelled",
}

export interface UseOfForceHygieneRestraintLogModel {
    id: string;
    incidentId: string;
    month: Date | string;
    status: UseOfForceHygieneRestraintLogStatus;
    restraints: UseOfForceHygieneRestraintModel[];
    missingForApprove: string[];
    approvedAt?: Date | string | undefined;
    responsibleMunicipalityName?: string | undefined;
    responsibleMunicipalityIsOwnMunicipality?: boolean | undefined;
    sentToResponsibleMunicipalityAt?: Date | string | undefined;
}

export enum UseOfForceHygieneRestraintLogStatus {
    Draft = "draft",
    Approved = "approved",
}

export interface UseOfForceHygieneRestraintModel {
    id: string;
    startedAt: Date | string;
    endedAt: Date | string;
    employeeName: string;
    isOwn: boolean;
}

export interface UseOfForceIncidentModel {
    id: string;
    assignmentId?: string | undefined;
    status: UseOfForceIncidentStatus;
    createdBy: string;
    createdAt: Date | string;
    firstSubmittedAt?: Date | string | undefined;
    isOwnDraft: boolean;
    responsibleMunicipalityId?: string | undefined;
    responsibleMunicipalityIsOwnMunicipality?: boolean | undefined;
    draft: UseOfForceIncidentDraftModel;
    citizenStatements: UseOfForceCitizenStatementModel[];
    missingForSubmit: string[];
    warnings: UseOfForceIncidentWarning[];
    createdByName?: string | undefined;
    canAdminister: boolean;
    leaderSection: UseOfForceLeaderSectionModel;
    missingForApprove: string[];
    approvedAt?: Date | string | undefined;
    approvedByName?: string | undefined;
    returnComment?: string | undefined;
    returnedAt?: Date | string | undefined;
    returnedByName?: string | undefined;
    cancellationReason?: string | undefined;
    cancelledAt?: Date | string | undefined;
    cancelledByName?: string | undefined;
    sentToResponsibleMunicipalityAt?: Date | string | undefined;
    reportId?: string | undefined;
    sentToSupervisionAt?: Date | string | undefined;
    operatorInformedAt?: Date | string | undefined;
    relativesInformedOn?: Date | string | undefined;
    relativesNotInformed: boolean;
    approvedResponsibleMunicipalityName?: string | undefined;
}

export enum UseOfForceIncidentStatus {
    Draft = "draft",
    SubmittedToLeader = "submittedToLeader",
    Approved = "approved",
    Cancelled = "cancelled",
    Reported = "reported",
}

export interface UseOfForceIncidentDraftModel {
    targetGroupDocumentation?: UseOfForceTargetGroupDocumentation | undefined;
    targetGroupNoneReason?: string | undefined;
    departmentName?: string | undefined;
    providerAddress?: string | undefined;
    serviceType?: UseOfForceServiceType | undefined;
    serviceTypeOtherText?: string | undefined;
    providerName?: string | undefined;
    operatorKind?: UseOfForceOperatorKind | undefined;
    leaderUserId?: string | undefined;
    leaderName?: string | undefined;
    participants: UseOfForceParticipantModel[];
    interventionStartedAt?: Date | string | undefined;
    interventionEndedAt?: Date | string | undefined;
    interventionType?: UseOfForceInterventionType | undefined;
    location?: UseOfForceLocation | undefined;
    locationOtherText?: string | undefined;
    whatPreceded?: string | undefined;
    pedagogicalApproachBefore?: string | undefined;
    intendedOutcome?: string | undefined;
    interventionDescription?: string | undefined;
    howKeptToMinimum?: string | undefined;
    citizenReactionAfter?: string | undefined;
    howSafetyRestored?: string | undefined;
    statementAttached?: boolean | undefined;
    informedOfPurpose?: boolean | undefined;
    informedOfPurposeNoReason?: string | undefined;
    complaintGuidanceGiven?: boolean | undefined;
    complaintGuidanceNoReason?: string | undefined;
}

export enum UseOfForceTargetGroupDocumentation {
    Section124a = "section124a",
    Section136 = "section136",
    Section136b = "section136b",
    None = "none",
}

export enum UseOfForceServiceType {
    Section84 = "section84",
    Section103 = "section103",
    Section104 = "section104",
    Section107 = "section107",
    Section108 = "section108",
    Section109 = "section109",
    Section110 = "section110",
    Section192NursingHome = "section192NursingHome",
    PublicNursingHousing = "publicNursingHousing",
    OwnHome = "ownHome",
    Other = "other",
}

export enum UseOfForceOperatorKind {
    Municipal = "municipal",
    Regional = "regional",
    Private = "private",
}

export interface UseOfForceParticipantModel {
    name: string;
    position?: string | undefined;
}

export enum UseOfForceLocation {
    CommonAreas = "commonAreas",
    OwnHomeBathroom = "ownHomeBathroom",
    OwnHomeKitchen = "ownHomeKitchen",
    OwnHomeOther = "ownHomeOther",
    Car = "car",
    OutdoorsOnPremises = "outdoorsOnPremises",
    OffPremises = "offPremises",
    Other = "other",
}

export interface UseOfForceCitizenStatementModel {
    id: string;
    fileName: string;
    contentType: string;
    size: number;
    uploadedAt: Date | string;
}

export enum UseOfForceIncidentWarning {
    RegistrationDeadlineExceeded = "registrationDeadlineExceeded",
    RepeatedSection136a = "repeatedSection136a",
    Section71NoticeRequired = "section71NoticeRequired",
}

export interface UseOfForceLeaderSectionModel {
    staffFollowUp?: string | undefined;
    preventiveMeasures?: string | undefined;
    additionalComments?: string | undefined;
    assessment?: string | undefined;
}

export interface UseOfForceSummaryRegistrationModel {
    id: string;
    authorizationId: string;
    status: UseOfForceSummaryRegistrationStatus;
    createdAt: Date | string;
    createdByName?: string | undefined;
    authorizationType: UseOfForceAuthorizationType;
    authorizationPeriodKind: UseOfForceAuthorizationPeriodKind;
    authorizationPeriodFrom: Date | string;
    authorizationPeriodTo: Date | string;
    responsibleMunicipalityName?: string | undefined;
    draft: UseOfForceSummaryRegistrationDraftModel;
    missingForApprove: string[];
    approvedAt?: Date | string | undefined;
    approvedByName?: string | undefined;
    responsibleMunicipalityIsOwnMunicipality?: boolean | undefined;
    sentToResponsibleMunicipalityAt?: Date | string | undefined;
    sentToSupervisionAt?: Date | string | undefined;
    requiresOperatorInformation: boolean;
    operatorInformedAt?: Date | string | undefined;
    relativesInformedOn?: Date | string | undefined;
    relativesNotInformed: boolean;
    citizenStatements: UseOfForceCitizenStatementModel[];
}

export enum UseOfForceSummaryRegistrationStatus {
    Draft = "draft",
    Approved = "approved",
}

export enum UseOfForceAuthorizationPeriodKind {
    UnderOneYear = "underOneYear",
    TwelveMonths = "twelveMonths",
    EighteenMonths = "eighteenMonths",
}

export interface UseOfForceSummaryRegistrationDraftModel {
    targetGroupDocumentation?: UseOfForceTargetGroupDocumentation | undefined;
    targetGroupNoneReason?: string | undefined;
    providerName?: string | undefined;
    departmentName?: string | undefined;
    providerAddress?: string | undefined;
    serviceType?: UseOfForceServiceType | undefined;
    serviceTypeOtherText?: string | undefined;
    operatorKind?: UseOfForceOperatorKind | undefined;
    leaderUserId?: string | undefined;
    leaderName?: string | undefined;
    participants: UseOfForceParticipantModel[];
    registrationPeriodFrom?: Date | string | undefined;
    registrationPeriodTo?: Date | string | undefined;
    frequency?: UseOfForceFrequency | undefined;
    frequencyComment?: string | undefined;
    location?: UseOfForceLocation | undefined;
    locationOtherText?: string | undefined;
    typicalIntervention?: string | undefined;
    intendedOutcome?: string | undefined;
    howKeptToMinimum?: string | undefined;
    citizenReactionAfter?: string | undefined;
    howSafetyRestored?: string | undefined;
    atypicalReactions?: string | undefined;
    staffFollowUp?: string | undefined;
    preventiveMeasures?: string | undefined;
    additionalComments?: string | undefined;
    statementAttached?: boolean | undefined;
    informedOfPurpose?: boolean | undefined;
    informedOfPurposeNoReason?: string | undefined;
    complaintGuidanceGiven?: boolean | undefined;
    complaintGuidanceNoReason?: string | undefined;
    leaderAssessment?: string | undefined;
}

export enum UseOfForceFrequency {
    Daily = "daily",
    Weekly = "weekly",
    Monthly = "monthly",
    Rarely = "rarely",
}

export interface UseOfForceAuthorizationRequestModel {
    id: string;
    status: UseOfForceAuthorizationRequestStatus;
    createdAt: Date | string;
    createdByName?: string | undefined;
    responsibleMunicipalityName?: string | undefined;
    draft: UseOfForceAuthorizationRequestDraftModel;
    missingForSend: string[];
    sentAt?: Date | string | undefined;
    sentByName?: string | undefined;
    responsibleMunicipalityIsOwnMunicipality?: boolean | undefined;
    sentToResponsibleMunicipalityAt?: Date | string | undefined;
}

export interface UseOfForceAuthorizationRequestDraftModel {
    targetGroupDocumentation?: UseOfForceTargetGroupDocumentation | undefined;
    targetGroupNoneReason?: string | undefined;
    providerName?: string | undefined;
    departmentName?: string | undefined;
    providerAddress?: string | undefined;
    serviceType?: UseOfForceServiceType | undefined;
    serviceTypeOtherText?: string | undefined;
    operatorKind?: UseOfForceOperatorKind | undefined;
    leaderUserId?: string | undefined;
    leaderName?: string | undefined;
    authorizationType?: UseOfForceAuthorizationType | undefined;
    periodKind?: UseOfForceAuthorizationPeriodKind | undefined;
    periodFrom?: Date | string | undefined;
    periodTo?: Date | string | undefined;
    purpose?: string | undefined;
    necessarySituation?: string | undefined;
    attemptsToAvoid?: string | undefined;
    futurePedagogicalEfforts?: string | undefined;
    citizenRemarks?: string | undefined;
    relativesRemarks?: string | undefined;
    additionalComments?: string | undefined;
    leaderAssessment?: string | undefined;
}

export interface IdentifierOfGuid {
    value: string;
}

export interface CitizenId extends IdentifierOfGuid {
}

export interface ServiceProviderUnitId extends IdentifierOfGuid {
}

export enum TrafficLightZone {
    Green = "green",
    Yellow = "yellow",
    Red = "red",
}

export interface AssignmentId extends IdentifierOfGuid {
}

export interface ActivityId extends IdentifierOfGuid {
}

export interface CreateAssignmentAsServiceProviderModel {
    citizenId?: CitizenId | undefined;
    backgroundInformation: CreateBackgroundInformationModel;
    coordinationDetails: CoordinationDetailsModel;
    assessmentInformation: AssessmentInformationModel;
    commissionedIntervention: CommissionedInterventionModel;
}

export interface CreateBackgroundInformationModel {
    name?: string | undefined;
    companyId?: CompanyId | undefined;
    serviceProviderUnitId?: string | undefined;
    responsibleUserId?: UserId | undefined;
    responsibleTeamId?: TeamId | undefined;
    citizenMedicalDiagnoses?: string | undefined;
    citizenMedicalDiagnosesRichText?: string | undefined;
    specialInformationAboutCitizen?: string | undefined;
    specialInformationAboutCitizenRichText?: string | undefined;
    hasGuardian?: boolean | undefined;
    guardianType?: GuardianTypeModel | undefined;
    guardianDetails?: string | undefined;
    isRepresented?: boolean | undefined;
    representationType?: RepresentationTypeModel | undefined;
    powersOfAttorney?: string | undefined;
}

export interface IdentifierOfGuid2 {
    value: string;
}

export interface CompanyId extends IdentifierOfGuid2 {
}

export interface UserId extends IdentifierOfGuid {
}

export interface TeamId extends IdentifierOfGuid {
}

export enum GuardianTypeModel {
    Guardianship = "guardianship",
    GuardianshipWithRevokedLegalCapacity = "guardianshipWithRevokedLegalCapacity",
    JointGuardianship = "jointGuardianship",
}

export enum RepresentationTypeModel {
    AccompanyingPerson = "accompanyingPerson",
    AuthorizedRepresentative = "authorizedRepresentative",
}

export interface CoordinationDetailsModel {
    descriptionOfOtherInterventions?: string | undefined;
    descriptionOfOtherInterventionsRichText?: string | undefined;
    agreementsBetweenCitizenAndRelatives?: string | undefined;
}

export interface AssessmentInformationModel {
    primaryAssessmentTopicId?: string | undefined;
    additionalAssessmentTopicIds?: string[] | undefined;
    assessmentSummary?: string | undefined;
    assessmentSummaryRichText?: string | undefined;
    citizenSupportNeedsAssessment?: string | undefined;
    citizenSupportNeedsAssessmentRichText?: string | undefined;
    citizenPerspectiveInfo?: string | undefined;
    citizenPerspectiveInfoRichText?: string | undefined;
    citizenAssessmentResourceInfo?: string | undefined;
    citizenAssessmentResourceInfoRichText?: string | undefined;
    citizenAssessmentPurposeInfo?: string | undefined;
    citizenAssessmentPurposeInfoRichText?: string | undefined;
    challengesAndNeedsInfo?: string | undefined;
    challengesAndNeedsInfoRichText?: string | undefined;
    citizenFutureAspirationsInfo?: string | undefined;
    citizenFutureAspirationsInfoRichText?: string | undefined;
}

export interface CommissionedInterventionModel {
    grantTypeId?: string | undefined;
    socialOfferFFBId?: string | undefined;
    benefitTypeIds?: string[] | undefined;
    reportingFrequency?: FrequencyForReportingModel | undefined;
    daysBetweenMeasurements?: number | undefined;
    followUpDate?: Date | string | undefined;
    agreementsBetweenAuthorityAndProvider?: string | undefined;
}

export enum FrequencyForReportingModel {
    NoReportingMeasurement = "noReportingMeasurement",
    EveryWeek = "everyWeek",
    EveryOtherWeek = "everyOtherWeek",
    EveryMonth = "everyMonth",
    Quarterly = "quarterly",
    WithXDaysInBetween = "withXDaysInBetween",
    WhenCompletingActivity = "whenCompletingActivity",
    SemiAnnually = "semiAnnually",
    Annually = "annually",
    EveryOtherYear = "everyOtherYear",
}

export enum AssignmentDistributionStatus {
    NotRelevant = "notRelevant",
    Awaiting = "awaiting",
    Distributed = "distributed",
}

export enum ProblemAreaCode {
    FunctionalLevel = "functionalLevel",
    MusculoskeletalSystem = "musculoskeletalSystem",
    Nutrition = "nutrition",
    SkinAndMucousMembranes = "skinAndMucousMembranes",
    Communication = "communication",
    PsychosocialConditions = "psychosocialConditions",
    RespirationAndCirculation = "respirationAndCirculation",
    SexualityGenderAndBodyImage = "sexualityGenderAndBodyImage",
    PainAndSensoryImpressions = "painAndSensoryImpressions",
    SleepAndRest = "sleepAndRest",
    KnowledgeAndDevelopment = "knowledgeAndDevelopment",
    Elimination = "elimination",
}

export interface MedicineInventoryViewModel {
    lines: MedicineInventoryLineViewModel[];
}

export interface MedicineInventoryLineViewModel {
    drugMedicationId: string;
    drugName?: string | undefined;
    strength?: string | undefined;
    controlledSubstance: boolean;
    balance: number;
    unit: MedicineUnit;
    packages: MedicineInventoryPackageViewModel[];
    movements: MedicineInventoryMovementViewModel[];
    packageIdsInFefoOrder: string[];
}

export enum MedicineUnit {
    Tablet = "tablet",
    Milliliter = "milliliter",
    Patch = "patch",
    DosePackage = "dosePackage",
    Piece = "piece",
}

export interface MedicineInventoryPackageViewModel {
    id: string;
    packageContent: number;
    remaining: number;
    unit: MedicineUnit;
    packageNumber?: string | undefined;
    receivedAt: Date | string;
    location?: string | undefined;
    status: PackageStatus;
    batchAndExpiry?: BatchAndExpiryViewModel | undefined;
    expiryMarker?: PackageExpiryMarker | undefined;
}

export enum PackageStatus {
    Active = "active",
    Reserved = "reserved",
    Quarantined = "quarantined",
    Expired = "expired",
    Discarded = "discarded",
    Returned = "returned",
}

export interface BatchAndExpiryViewModel {
    batchNumber: string;
    expiryYear: number;
    expiryMonth: number;
}

export enum PackageExpiryMarker {
    MissingBatchAndExpiry = "missingBatchAndExpiry",
    ExpiresThisMonth = "expiresThisMonth",
    Expired = "expired",
}

export interface MedicineInventoryMovementViewModel {
    occurredAt: Date | string;
    type: MovementType;
    quantity: number;
    packageSize?: number | undefined;
    unit: MedicineUnit;
    origin: MovementOrigin;
    packageNumber?: string | undefined;
    dispensingOrganisation?: string | undefined;
    effectuationMethod?: string | undefined;
    reference?: string | undefined;
    reason?: string | undefined;
    fromStatus?: PackageStatus | undefined;
    toStatus?: PackageStatus | undefined;
    id: string;
    sequenceNumber: number;
    packageId?: string | undefined;
    registeredAt?: Date | string | undefined;
    registeredByName?: string | undefined;
    administrationId?: string | undefined;
    doubleControl?: DoubleControlViewModel | undefined;
    controlledByName?: string | undefined;
    confirmedByName?: string | undefined;
    returnedTo?: string | undefined;
    countLines: MedicineInventoryCountLineViewModel[];
    referencedMovementId?: string | undefined;
}

export enum MovementType {
    Receipt = "receipt",
    Dispensing = "dispensing",
    Disposal = "disposal",
    Return = "return",
    StatusChange = "statusChange",
    Count = "count",
    Correction = "correction",
}

export enum MovementOrigin {
    Fmk = "fmk",
    Manual = "manual",
}

export interface DoubleControlViewModel {
    reasons: DoubleControlReason[];
    state: DoubleControlState;
    confirmedBy?: string | undefined;
    confirmedAt?: Date | string | undefined;
    controlledBy?: string | undefined;
    declaration?: string | undefined;
}

export enum DoubleControlReason {
    HighRiskMedication = "highRiskMedication",
    ControlledSubstance = "controlledSubstance",
    ManualMarking = "manualMarking",
    DoseDeviation = "doseDeviation",
}

export enum DoubleControlState {
    Awaiting = "awaiting",
    Confirmed = "confirmed",
    ColleaguePresent = "colleaguePresent",
}

export interface MedicineInventoryCountLineViewModel {
    packageId: string;
    expectedQuantity: number;
    countedQuantity: number;
}

export interface CountedPackage {
    packageId: string;
    expectedQuantity: number;
    countedQuantity: number;
}

export interface LatestPnAdministrationViewModel {
    administrationId: string;
    actualTime: Date | string;
    status: MedicineAdministrationStatus;
    actualDose?: number | undefined;
    pnReason?: string | undefined;
    effectAssessmentRequired: boolean;
    effectAssessment?: string | undefined;
    effectAssessedAt?: Date | string | undefined;
    effectAssessmentOutstanding: boolean;
    doubleControl?: DoubleControlViewModel | undefined;
}

export enum MedicineAdministrationStatus {
    Given = "given",
    RejectedByCitizen = "rejectedByCitizen",
    Postponed = "postponed",
    NotGiven = "notGiven",
}

export interface MedicineCardViewModel {
    fmkCardVersion: string;
    fmkVersionVerification?: FmkVersionVerification | undefined;
    patient?: FmkPatientViewModel | undefined;
    reviewed: boolean;
    reviewedAt?: Date | string | undefined;
    reviewedBy?: FmkModifierViewModel | undefined;
    notReviewedAt?: Date | string | undefined;
    notReviewedBy?: FmkModifierViewModel | undefined;
    isInvalid: boolean;
    orderedPrescriptionMedicationsExist: boolean;
    doseDispensingSummary?: DoseDispensingSummaryViewModel | undefined;
    patientOrganisationRelations: FmkPatientOrganisationRelationViewModel[];
    invalidatedDrugMedicationIdentifiers: string[];
    modifiedBy?: FmkModifierViewModel | undefined;
    modifiedAt?: Date | string | undefined;
    reportedBy?: FmkModifierViewModel | undefined;
    lastSynchronizedAt: Date | string;
    fmkChangedAt?: Date | string | undefined;
    drugMedications: DrugMedicationViewModel[];
    loosePrescriptions: PrescriptionViewModel[];
    openPrescriptionCount: number;
    invalidatedPrescriptionCount: number;
    hiddenDrugMedicationCount: number;
    privacyConsent?: MedicineCardPrivacyConsentViewModel | undefined;
}

export enum FmkVersionVerification {
    Verified = "verified",
    ChangedInFmk = "changedInFmk",
    Unverified = "unverified",
}

export interface FmkPatientViewModel {
    givenName?: string | undefined;
    middleName?: string | undefined;
    surname?: string | undefined;
    nameProtected: boolean;
    personIdentifier?: string | undefined;
    personIdentifierSource?: string | undefined;
}

export interface FmkModifierViewModel {
    name?: string | undefined;
    role?: string | undefined;
    authorisationIdentifier?: string | undefined;
    authorisedByName?: string | undefined;
    authorisedByAuthorisationIdentifier?: string | undefined;
    organisationName?: string | undefined;
    organisationType?: string | undefined;
    organisationIdentifier?: string | undefined;
    organisationIdentifierSource?: string | undefined;
    organisationAddress?: string | undefined;
    organisationTelephoneNumber?: string | undefined;
}

export interface DoseDispensingSummaryViewModel {
    latestDeliveryAt?: Date | string | undefined;
    latestDeliveryPharmacy?: string | undefined;
    latestDeliveryWithinThreeMonths: boolean;
    hasOpenPrescriptions: boolean;
    isOnHold: boolean;
    isInDoseDispensing: boolean;
}

export interface FmkPatientOrganisationRelationViewModel {
    identifier: string;
    type?: string | undefined;
    isAdmission: boolean;
    isActive: boolean;
    organisation?: FmkOrganisationViewModel | undefined;
    createdAt?: Date | string | undefined;
    createdBy?: FmkModifierViewModel | undefined;
    removedAt?: Date | string | undefined;
    reportedBy?: FmkModifierViewModel | undefined;
}

export interface FmkOrganisationViewModel {
    name?: string | undefined;
    type?: string | undefined;
    identifier?: string | undefined;
    identifierSource?: string | undefined;
    address?: string | undefined;
    telephoneNumber?: string | undefined;
}

export interface DrugMedicationViewModel {
    id: string;
    source: MedicationSource;
    medicineType: MedicineType;
    clinicalStatus: ClinicalStatus;
    needsLocalReconciliation: boolean;
    drugName?: string | undefined;
    strength?: string | undefined;
    form?: string | undefined;
    formCode?: string | undefined;
    atcCode?: string | undefined;
    atcText?: string | undefined;
    activeSubstances: string[];
    detailedDrugText?: string | undefined;
    articleNumber?: string | undefined;
    reimbursementClauseFulfilled: boolean;
    indication?: string | undefined;
    indicationCode?: string | undefined;
    dosageText?: string | undefined;
    dosageUnitText?: string | undefined;
    dosageKind?: DosageKind | undefined;
    dosageTypeNotSpecified: boolean;
    dosagePeriods: DosagePeriodViewModel[];
    pnInstruction?: string | undefined;
    dispensingForm?: DispensingForm | undefined;
    isDoseDispensed: boolean;
    isPrivacyMarked: boolean;
    highRiskMedication: boolean;
    riskSituationMedicineGroup?: RiskSituationMedicineGroupViewModel | undefined;
    controlledSubstance: boolean;
    markedForDoubleCheck: boolean;
    doubleControlRequiredBecause: DoubleControlReason[];
    drugMedicationIdentifier?: string | undefined;
    fmkVersion?: number | undefined;
    fmkLastSynchronizedAt?: Date | string | undefined;
    fmkUpdatedAt?: Date | string | undefined;
    administrationPeriods: AdministrationPeriodViewModel[];
    withdrawalReason?: string | undefined;
    withdrawnAt?: Date | string | undefined;
    treatmentStartDate?: Date | string | undefined;
    treatmentStartedPreviously: boolean;
    treatmentEndDate?: Date | string | undefined;
    pauseStartDate?: Date | string | undefined;
    pauseEndDate?: Date | string | undefined;
    pausedBy?: FmkModifierViewModel | undefined;
    pausedAt?: Date | string | undefined;
    followUpDates: Date | string[];
    routeOfAdministrationCode?: string | undefined;
    routeOfAdministrationText?: string | undefined;
    createdBy?: FmkModifierViewModel | undefined;
    createdAt?: Date | string | undefined;
    reportedBy?: FmkModifierViewModel | undefined;
    modifiedBy?: FmkModifierViewModel | undefined;
    modifiedAt?: Date | string | undefined;
    withdrawnBy?: FmkModifierViewModel | undefined;
    prescriptions: PrescriptionViewModel[];
    openPrescriptionCount: number;
    invalidatedPrescriptionCount: number;
    effectuations: EffectuationViewModel[];
    invalidEffectuationCount: number;
    moreEffectuationsAvailable: boolean;
}

export enum MedicationSource {
    Fmk = "fmk",
    Local = "local",
}

export enum MedicineType {
    Fast = "fast",
    Pn = "pn",
    Combined = "combined",
}

export enum ClinicalStatus {
    Active = "active",
    Paused = "paused",
    Withdrawn = "withdrawn",
}

export enum DosageKind {
    FreeText = "freeText",
    Structured = "structured",
    AccordingToSchemaInLocalSystem = "accordingToSchemaInLocalSystem",
}

export interface DosagePeriodViewModel {
    startDate?: Date | string | undefined;
    startedPreviously: boolean;
    endDate?: Date | string | undefined;
    endingUndetermined: boolean;
    isEmpty: boolean;
    text?: string | undefined;
    supplementaryText?: string | undefined;
    iterationInterval?: number | undefined;
    notIterated: boolean;
    days: DosageDayViewModel[];
}

export interface DosageDayViewModel {
    number?: number | undefined;
    doses: DosageDoseViewModel[];
}

export interface DosageDoseViewModel {
    time?: string | undefined;
    quantity?: number | undefined;
    minimalQuantity?: number | undefined;
    maximalQuantity?: number | undefined;
    isAccordingToNeed: boolean;
}

export enum DispensingForm {
    PillBox = "pillBox",
    AdministeredByStaff = "administeredByStaff",
    DoseDispensedByPharmacy = "doseDispensedByPharmacy",
    SelfAdministered = "selfAdministered",
}

export interface RiskSituationMedicineGroupViewModel {
    name: string;
    attentionPoints: string;
    source?: string | undefined;
    sourceUrl?: string | undefined;
}

export interface AdministrationPeriodViewModel {
    startDate: Date | string;
    administrationTimes: AdministrationTimeViewModel[];
    doseRecurrence?: RecurrencePatternModel | undefined;
}

export interface AdministrationTimeViewModel {
    time?: string | undefined;
    dose?: string | undefined;
}

export interface PrescriptionViewModel {
    fmkIdentifier: string;
    orderedEffectuationIdentifier?: string | undefined;
    status: PrescriptionStatus;
    isOpen: boolean;
    isFutureValid: boolean;
    isExpired: boolean;
    invalidationReasonText?: string | undefined;
    authorisedAt: Date | string;
    latestEffectuationAt?: Date | string | undefined;
    terminatedAt?: Date | string | undefined;
    deprecatedAt?: Date | string | undefined;
    validFrom: Date | string;
    validTo: Date | string;
    dispensing: PrescriptionDispensingViewModel;
    drug: PrescriptionDrugViewModel;
    indication?: string | undefined;
    indicationCode?: string | undefined;
    substitutionAllowed: boolean;
    supplementaryInformation?: string | undefined;
    receiverEan?: string | undefined;
    reimbursementClauseFulfilled: boolean;
    isPrivate: boolean;
    deliveryInformation: string[];
    orderInstructions: string[];
    delivery?: PrescriptionDeliveryViewModel | undefined;
    createdBy?: FmkModifierViewModel | undefined;
    createdAt?: Date | string | undefined;
    effectuationCount: number;
    effectuations: EffectuationViewModel[];
    invalidEffectuationCount: number;
    remainingQuantity?: number | undefined;
}

export enum PrescriptionStatus {
    Open = "open",
    PartiallyDispensed = "partiallyDispensed",
    InProgress = "inProgress",
    Completed = "completed",
    Cancelled = "cancelled",
    Invalidated = "invalidated",
    TransferredToDoseDispensing = "transferredToDoseDispensing",
    WebDispensed = "webDispensed",
    Draft = "draft",
    Inactive = "inactive",
    Unknown = "unknown",
}

export interface PrescriptionDispensingViewModel {
    kind: PrescriptionDispensingKind;
    packageNumber?: string | undefined;
    packageSize?: PrescriptionPackageSizeViewModel | undefined;
    packageQuantity?: string | undefined;
    reiterationNumber?: string | undefined;
    reiterationInterval?: string | undefined;
    reiterationIntervalUnit?: string | undefined;
    copyRequired?: boolean | undefined;
    doseDispensingStart?: Date | string | undefined;
    doseDispensingEnd?: Date | string | undefined;
    dosageCode?: string | undefined;
    dosageText?: string | undefined;
}

export enum PrescriptionDispensingKind {
    Single = "single",
    Reiterated = "reiterated",
    DoseDispensed = "doseDispensed",
}

export interface PrescriptionPackageSizeViewModel {
    value?: number | undefined;
    unitCode?: string | undefined;
    unitText?: string | undefined;
    text?: string | undefined;
}

export interface PrescriptionDrugViewModel {
    name?: string | undefined;
    detailedDrugText?: string | undefined;
    fmkDrugIdentifier?: string | undefined;
    strength?: string | undefined;
    form?: string | undefined;
    atcCode?: string | undefined;
    atcText?: string | undefined;
    activeSubstances: string[];
}

export interface PrescriptionDeliveryViewModel {
    priority?: string | undefined;
    address?: string | undefined;
    postCode?: string | undefined;
    contactName?: string | undefined;
}

export interface EffectuationViewModel {
    fmkIdentifier: string;
    occurredAt: Date | string;
    method?: string | undefined;
    packageQuantity?: string | undefined;
    packageNumber?: string | undefined;
    packageSize?: PrescriptionPackageSizeViewModel | undefined;
    doseQuantity?: number | undefined;
    doseUnitText?: string | undefined;
    isEffectuatedAccordingToDrugMedication?: boolean | undefined;
    drug?: PrescriptionDrugViewModel | undefined;
    dispensingOrganisation?: string | undefined;
    createdAt?: Date | string | undefined;
    createdBy?: FmkModifierViewModel | undefined;
    reportedBy?: FmkModifierViewModel | undefined;
    reportedByOrganisation?: string | undefined;
}

export interface MedicineCardPrivacyConsentViewModel {
    state: PrivacyConsentState;
    registeredAt: Date | string;
    registeredByDisplayName?: string | undefined;
    givenBy: PrivacyConsentGivenBy;
    form: PrivacyConsentForm;
    revokedAt?: Date | string | undefined;
    revokedByDisplayName?: string | undefined;
    revocationNote?: string | undefined;
}

export enum PrivacyConsentState {
    Registered = "registered",
    Revoked = "revoked",
}

export enum PrivacyConsentGivenBy {
    Citizen = "citizen",
    Guardian = "guardian",
}

export enum PrivacyConsentForm {
    Oral = "oral",
    Written = "written",
}

export interface AppliedFmkChangesViewModel {
    addedCount: number;
    changedCount: number;
    withdrawnCount: number;
    privacyMarkedCount: number;
    pendingLocalReviewCount: number;
    addedDrugMedicationIds: string[];
    synchronizedAt: Date | string;
    changes: FmkSynchronizationChangeViewModel[];
    prescriptionSummary: FmkPrescriptionSummaryViewModel;
}

export interface FmkSynchronizationChangeViewModel {
    kind: FmkSynchronizationChangeKind;
    drugName?: string | undefined;
    strength?: string | undefined;
    form?: string | undefined;
    fieldChanges: FmkFieldChangeViewModel[];
}

export enum FmkSynchronizationChangeKind {
    Added = "added",
    Changed = "changed",
    WithdrawnInFmk = "withdrawnInFmk",
    RemovedFromFmk = "removedFromFmk",
    PrivacyMarkedInFmk = "privacyMarkedInFmk",
}

export interface FmkFieldChangeViewModel {
    field: FmkChangedField;
    from?: string | undefined;
    to?: string | undefined;
}

export enum FmkChangedField {
    DrugName = "drugName",
    Strength = "strength",
    Form = "form",
    AtcCode = "atcCode",
    ActiveSubstance = "activeSubstance",
    ArticleNumber = "articleNumber",
    Indication = "indication",
    DosageText = "dosageText",
    DosageUnitText = "dosageUnitText",
    ClinicalStatus = "clinicalStatus",
    MedicineType = "medicineType",
    DetailedDrugText = "detailedDrugText",
    AtcText = "atcText",
    IndicationCode = "indicationCode",
    TreatmentStartDate = "treatmentStartDate",
    TreatmentEndDate = "treatmentEndDate",
    PauseStartDate = "pauseStartDate",
    PauseEndDate = "pauseEndDate",
    RouteOfAdministration = "routeOfAdministration",
    FollowUpDates = "followUpDates",
    DosagePeriods = "dosagePeriods",
    ReimbursementClause = "reimbursementClause",
    PrivacyMarking = "privacyMarking",
}

export interface FmkPrescriptionSummaryViewModel {
    added: number;
    completed: number;
    cancelled: number;
    removed: number;
    drugNames: string[];
}

export interface MarkedForDoubleCheckChangeViewModel {
    oldValue: boolean;
    newValue: boolean;
}

export interface InterventionObjectiveStatusModel {
    id: ServiceProviderInterventionObjectiveStatusId;
    assignmentId: AssignmentId;
    interventionObjectiveId?: InterventionObjectiveId | undefined;
    createdOn: Date | string;
    createdBy: UserId;
    statusText: string;
    statusRichText: string;
    shouldContinue: boolean;
    recommendNewAssessment: boolean;
    recommendationRemarks: string;
    journalNoteId?: string | undefined;
    selectionLabel: string;
    spuId?: ServiceProviderUnitId | undefined;
    createdByDisplayName: string;
    functionalAbilityIds?: string[] | undefined;
}

export interface ServiceProviderInterventionObjectiveStatusId extends IdentifierOfGuid {
}

export interface InterventionObjectiveId extends IdentifierOfGuid {
}

export enum HealthConditionCode {
    DailyActivities = "dailyActivities",
    MobilityAndMovement = "mobilityAndMovement",
    Nutrition = "nutrition",
    Weight = "weight",
    PressureUlcer = "pressureUlcer",
    DiabeticUlcer = "diabeticUlcer",
    OtherWounds = "otherWounds",
    SkinAndMucousMembranes = "skinAndMucousMembranes",
    Communication = "communication",
    SubstanceAbuse = "substanceAbuse",
    SocialInteraction = "socialInteraction",
    WellBeing = "wellBeing",
    Respiration = "respiration",
    Circulation = "circulation",
    SexualityGenderAndBodyImage = "sexualityGenderAndBodyImage",
    Pain = "pain",
    Senses = "senses",
    SleepAndRest = "sleepAndRest",
    Memory = "memory",
    Cognition = "cognition",
    HealthLiteracy = "healthLiteracy",
    Urination = "urination",
    BowelFunction = "bowelFunction",
}

export enum HealthConditionStatus {
    Current = "current",
    Resolved = "resolved",
}

export enum ProblemAreaStatus {
    NotAssessed = "notAssessed",
    NoCurrentProblems = "noCurrentProblems",
    NotRelevant = "notRelevant",
    Risk = "risk",
    Current = "current",
}

export interface AllocationItem {
    offerResourceId: string;
    allocatedHoursPerWeek: number;
    allocatedMinutesPerWeek: number;
    allocationNote?: string | undefined;
}

export enum AppealsBoardDecision {
    Remanded = "remanded",
    Affirmed = "affirmed",
    Reversed = "reversed",
    Dismissed = "dismissed",
}

export enum ComplaintReceivedForm {
    InWriting = "inWriting",
    Orally = "orally",
}

export enum ReassessmentOutcome {
    UpheldDecision = "upheldDecision",
    FullyGranted = "fullyGranted",
    PartiallyGranted = "partiallyGranted",
}

export enum HearingSubmissionReceivedOptions {
    NotReceived = "notReceived",
    InWriting = "inWriting",
    Orally = "orally",
}

export interface VisitationBookingTargetModel {
    visitationTeamId: string;
    visitationScheduleId: string;
    meetingStartAt: Date | string;
    overbook: boolean;
}

export interface CreateRulingDto {
    editModel: RulingEditModel;
}

export interface RulingEditModel {
    citizenId: string;
    caseId?: string | undefined;
    responsibleTeamId?: string | undefined;
    responsibleUserId?: string | undefined;
    rulingStartCause?: RulingStartCauseOptions | undefined;
    applicationReceivedAt?: Date | string | undefined;
    citizenContactPersonId?: string | undefined;
    contactPersonComment: string;
    rulingStartReasonRemark: string;
    relevantJournalNoteIds: string[];
    relevantDocumentIds: string[];
    assessmentId?: string | undefined;
    caseInformationSummary: string;
    caseInformationSummaryPlainText: string;
    hearingRelevant?: boolean | undefined;
    hearingDecisionRemark: string;
    hearingStartedAt?: Date | string | undefined;
    hearingSubmissionDeadlineAt?: Date | string | undefined;
    hearingSubmissionReceived?: HearingSubmissionReceivedOptions | undefined;
    hearingSubmissionReceivedAt?: Date | string | undefined;
    hearingSubmissionJournalNoteIds: string[];
    hearingCitizenComment?: string | undefined;
    recommendation?: string | undefined;
    recommendationPlainText?: string | undefined;
    internalRecommendation?: string | undefined;
    grantTypeIds: string[];
    grantTypeGrants: GrantTypeGrantInfo[];
    intakeTeamId?: string | undefined;
    intakeUserId?: string | undefined;
    intakePlannedAt?: Date | string | undefined;
    applicationOrRulingConcerning: string;
    overallRulingResult?: string | undefined;
    grantResult?: GrantResultOptions | undefined;
    rulingDecidedAt?: Date | string | undefined;
    rulingReasoning?: string | undefined;
    rulingReasoningPlainText?: string | undefined;
    processingDeadline?: Date | string | undefined;
    processingDeadlineRemark?: string | undefined;
}

export enum RulingStartCauseOptions {
    ApplicationReceivedFromCitizen = "applicationReceivedFromCitizen",
    ApplicationReceivedFromContactPerson = "applicationReceivedFromContactPerson",
    NoApplicationReceived = "noApplicationReceived",
    NotConcerningGrant = "notConcerningGrant",
}

export interface GrantTypeGrantInfo {
    grantTypeId: string;
    grantId?: string | undefined;
    requestedByCitizenOrOther?: boolean | undefined;
    visitationProposal?: VisitationProposal | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    followUpDate?: Date | string | undefined;
    visitationComment?: string | undefined;
    visitationDecision?: VisitationDecision | undefined;
    offerId?: string | undefined;
    priceCalculation?: GrantPriceCalculationDto | undefined;
    primaryAssessmentTopicId?: string | undefined;
    additionalAssessmentTopicIds: string[];
    socialOfferId?: string | undefined;
    benefitTypeIds: string[];
}

export enum VisitationProposal {
    Granted = "granted",
    Rejected = "rejected",
    NotAssessed = "notAssessed",
}

export enum VisitationDecision {
    Granted = "granted",
    Rejected = "rejected",
    NotAssessed = "notAssessed",
    Superseded = "superseded",
}

export interface GrantPriceCalculationDto {
    priceModel?: PriceModel2 | undefined;
    unitPrice?: number | undefined;
    priceModelInitialRate?: number | undefined;
    expectedUnitPriceCorrection?: number | undefined;
    expectedInitialRateCorrection?: number | undefined;
    expectedPricePerMonth?: number | undefined;
    expectedTotalPrice?: number | undefined;
    activityScope?: ActivityScopeDto | undefined;
    durationScope?: DurationScopeDto | undefined;
    formattedScope?: string | undefined;
}

export enum PriceModel2 {
    PerHour = "perHour",
    PerDay = "perDay",
    PerWeek = "perWeek",
    PerMonth = "perMonth",
    PerProcess = "perProcess",
    PerHourWithStartTax = "perHourWithStartTax",
    PerDayWithStartTax = "perDayWithStartTax",
    PerWeekWithStartTax = "perWeekWithStartTax",
    PerMonthWithStartTax = "perMonthWithStartTax",
}

export interface ActivityScopeDto {
    amount?: number | undefined;
    unit?: ActivityScopeUnit | undefined;
    frequency?: ActivityScopeFrequency | undefined;
}

export enum ActivityScopeUnit {
    Hours = "hours",
    Days = "days",
    Weeks = "weeks",
    Months = "months",
    Years = "years",
}

export enum ActivityScopeFrequency {
    Total = "total",
    PerDay = "perDay",
    PerWeek = "perWeek",
    PerMonth = "perMonth",
    PerYear = "perYear",
}

export interface DurationScopeDto {
    amount?: number | undefined;
    unit?: DurationScopeUnit | undefined;
}

export enum DurationScopeUnit {
    Days = "days",
    Weeks = "weeks",
    Months = "months",
    Years = "years",
}

export enum GrantResultOptions {
    Rejection = "rejection",
    PartialGrant = "partialGrant",
    FullGrant = "fullGrant",
}

export enum ReasonForTerminationOptions {
    CreatedByMistake = "createdByMistake",
    Other = "other",
}

export interface UpdateRulingDto {
    rulingId: string;
    editModel: RulingEditModel;
    isPartOfDecision: boolean;
}

export interface RulingFunctionValidationResult {
    message: string;
    type: ValidationType;
}

export enum ValidationType {
    Error = "error",
    Warning = "warning",
}

export enum RulingFunctionValidationType {
    StartHearing = "startHearing",
    CompleteHearing = "completeHearing",
    Terminate = "terminate",
    CreateRecommendation = "createRecommendation",
    DecideRuling = "decideRuling",
    CreateContinuation = "createContinuation",
    SubmitContinuationToVisitation = "submitContinuationToVisitation",
    RegisterContinuationVisitationAssessment = "registerContinuationVisitationAssessment",
    CompleteContinuation = "completeContinuation",
    CancelContinuation = "cancelContinuation",
}

export interface JobSearchDefinitionModel {
    geographicalAreas?: GeographicalArea[] | undefined;
    tradesForJobSearch?: TradeForJobSearch[] | undefined;
    otherTradeDescription?: string | undefined;
    otherExpectationsForJobSearch?: string | undefined;
    otherGeographicalAreaDescription?: string | undefined;
}

export interface GeographicalArea {
    geographicalAreaType: GeographicalAreaTypeIdentifier;
    employmentAreaIdentifier?: number | undefined;
    municipalityArea?: MunicipalityArea | undefined;
    geographicalAreaDescription?: string | undefined;
}

export enum GeographicalAreaTypeIdentifier {
    EmploymentArea = "employmentArea",
    MunicipalityArea = "municipalityArea",
    AreaDescription = "areaDescription",
}

export interface MunicipalityArea {
    municipalityName?: string | undefined;
    municipalityCode: number;
}

export interface TradeForJobSearch {
    tradeTypeIdentifier: TradeTypeIdentifier;
    conceptUri?: string | undefined;
    aliasIdentifier?: string | undefined;
    tradeDescription?: string | undefined;
}

export enum TradeTypeIdentifier {
    TradeDescription = "tradeDescription",
    Occupation = "occupation",
}

export enum EducationStepDto {
    Step1 = "step1",
    Step2 = "step2",
    Step3 = "step3",
    Step4 = "step4",
}

export interface EducationGoalDto {
    name: string;
    id: string;
    type: GoalTypeDto;
    educations: EducationDto[];
}

export enum GoalTypeDto {
    DUN = "dun",
    AMU = "amu",
    Custom = "custom",
    ESCO = "esco",
}

export interface EducationDto {
    companyId: string;
    applicationDeadline?: Date | string | undefined;
    startDate?: Date | string | undefined;
    applicationStatus: ApplicationStatusDto;
}

export enum ApplicationStatusDto {
    NotSet = "notSet",
    Applied = "applied",
    Enrolled = "enrolled",
    Rejected = "rejected",
    StandBy = "standBy",
}

export enum EducationRetentionTypeDto {
    NoNeedForRetention = "noNeedForRetention",
    NeedForRetention = "needForRetention",
    NeedForPersonalAssistance = "needForPersonalAssistance",
    HasDocumentedRetention = "hasDocumentedRetention",
    HasAdditionalPersonalAssistance = "hasAdditionalPersonalAssistance",
    EducationPlaceShouldContactJobcenter = "educationPlaceShouldContactJobcenter",
}

export enum ShipmentStatusTypeCode {
    ValidatingShipment = "validatingShipment",
    AwaitingShipment = "awaitingShipment",
    AwaitingResponse = "awaitingResponse",
    ResponseReceived = "responseReceived",
    Error = "error",
    Rejected = "rejected",
    Cancelled = "cancelled",
    ResponseAfterCancellation = "responseAfterCancellation",
    ResponseReceivedManually = "responseReceivedManually",
    RequestAvailable = "requestAvailable",
}

export enum CorrespondencePriority {
    Normal = "normal",
    High = "high",
}

export interface CreateMedicalRequestInput {
    medicalRequestTypeId: string;
    caseId?: string | undefined;
    serviceProviderUnitId?: string | undefined;
    sorCode?: string | undefined;
    providerType?: ProviderType | undefined;
    receiverName?: string | undefined;
    citizenPhoneNumber?: string | undefined;
    informationRequestReason?: string | undefined;
    informationRequestRestriction?: InformationRequestRestrictionType | undefined;
    contactInfo1?: ContactInfo | undefined;
    contactInfo2?: ContactInfo | undefined;
    requisitionNumber?: string | undefined;
    personReference?: string | undefined;
    doctorResponseDeadline?: Date | string | undefined;
    treatmentDepartment_101?: string | undefined;
    treatmentPeriod_101_111?: string | undefined;
    treatmentReason_101_111_221?: string | undefined;
    specialistArea_131_151?: string | undefined;
    refugeeLanguage_141f?: string | undefined;
    firstAbsenceDay_221_281?: Date | string | undefined;
    healthCoordinator?: HealthCoordinator | undefined;
    fields_261?: MedicalRequest261Fields | undefined;
    fields_271?: MedicalRequest271Fields | undefined;
    fields_281?: MedicalRequest281Fields | undefined;
    fields_221?: MedicalRequest221Fields | undefined;
    medicalNotification?: MedicalNotificationInput | undefined;
}

export enum ProviderType {
    Hospital = "hospital",
    PrivateDoctor = "privateDoctor",
}

export enum InformationRequestRestrictionType {
    RequestedWithConsent = "requestedWithConsent",
    RequestedAdheringToParagraph11c = "requestedAdheringToParagraph11c",
}

export interface ContactInfo {
    contactId: string;
    name?: string | undefined;
    position?: string | undefined;
    availabilityPeriod?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface HealthCoordinator {
    name?: string | undefined;
    phoneNumber?: string | undefined;
    availabilityPeriod?: string | undefined;
    mailAddress?: string | undefined;
}

export interface MedicalRequest261Fields {
    healthAssessmentType?: HealthAssessmentType | undefined;
    caseIdentifier?: string | undefined;
    futureGoals?: string | undefined;
    employmentSituation?: string | undefined;
    socialSituation?: string | undefined;
    healthSituation?: string | undefined;
    otherCircumstances?: string | undefined;
}

export enum HealthAssessmentType {
    NoHealthAssesment = "noHealthAssesment",
    ResourceProgram = "resourceProgram",
    JobClarification = "jobClarification",
}

export interface MedicalRequest271Fields {
    examinationType?: ExaminationType | undefined;
    examinationName?: string | undefined;
    examinationForCaseRegarding?: string | undefined;
    caseworkerNotificationAfterWeeks?: string | undefined;
}

export enum ExaminationType {
    General = "general",
    Specific = "specific",
}

export interface MedicalRequest281Fields {
    consultationBefore?: Date | string | undefined;
    latestFollowUpDate?: Date | string | undefined;
    workFunctionImpactAccordingToCitizen?: string | undefined;
    workFunctionImpactAccordingToEmployer?: string | undefined;
    illnessPeriodImpactAccordingToCitizen?: string | undefined;
    illnessPeriodImpactAccordingToEmployer?: string | undefined;
    workAdaptationAccordingToCitizen?: string | undefined;
    workAdaptationAccordingToEmployer?: string | undefined;
    workFunctionImpact?: string | undefined;
    illnessPeriodImpact?: string | undefined;
    workAdaptation?: string | undefined;
    caseIdentifier?: string | undefined;
    otherCircumstances?: string | undefined;
}

export interface MedicalRequest221Fields {
    regarding?: string | undefined;
    workType?: string | undefined;
}

export interface MedicalNotificationInput {
    createResponseReceivedTask: boolean;
    responseReceivedTaskUserId?: string | undefined;
    mailNotification: boolean;
    mailNotificationTo?: string | undefined;
}

export interface CorrespondenceProcessInput {
    processed: boolean;
    processedByUser?: string | undefined;
    processedDate?: Date | string | undefined;
}

export interface MedicalNotificationInput2 {
    createResponseReceivedTask: boolean;
    responseReceivedTaskUserId?: string | undefined;
    mailNotification: boolean;
    mailNotificationTo?: string | undefined;
}

export interface MedicalProcessInput {
    processedBy?: string | undefined;
    processed?: boolean | undefined;
    processedDate?: Date | string | undefined;
    processedRemark?: string | undefined;
}

export interface DocumentAttachmentModel {
    id?: string | undefined;
    title?: string | undefined;
    owner?: string | undefined;
    contentReference?: string | undefined;
    mimeType?: string | undefined;
    fileName?: string | undefined;
    fileSize: number;
}

export interface DocumentModel {
    id?: string | undefined;
    citizenId: string;
    caseId?: string | undefined;
    assignmentId?: string | undefined;
    serviceProviderUnitId?: string | undefined;
    title?: string | undefined;
    deadline?: Date | string | undefined;
    content?: string | undefined;
    comment?: string | undefined;
    isFinished: boolean;
    templateName: string;
    templateMappingCode: string;
    followupDate?: Date | string | undefined;
    responsibleCaseworkerId: string;
    createdOn?: Date | string | undefined;
    createdBy?: string | undefined;
    attachments?: DocumentAttachmentModel[] | undefined;
    remark?: string | undefined;
}

export interface DocumentAttachmentViewModel {
    id?: string | undefined;
    title?: string | undefined;
    owner?: string | undefined;
    contentReference?: string | undefined;
    mimeType?: string | undefined;
    fileName?: string | undefined;
    fileSize: number;
}

export enum RevisionType {
    Cancellation = "cancellation",
    Reactivation = "reactivation",
}

export interface JobReferralViewModel {
    id: string;
    offerType?: string | undefined;
    occupation?: string | undefined;
    responsibleCaseworkerId: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    referralDate: Date | string;
    followupDate?: Date | string | undefined;
    meetingDate?: Date | string | undefined;
    meetingTime?: TimeOfDay | undefined;
    hoursPerWeek: number;
    jobReferralStatus: number;
    referralType: number;
    weeklyWorkTimeType?: number | undefined;
    description?: string | undefined;
    company?: JrCompanyViewModel | undefined;
    companyRecruitment?: GetCompanyRecruitmentViewModel | undefined;
}

export interface TimeOfDay {
    hours: number;
    minutes: number;
}

export interface JrCompanyViewModel {
    id?: string | undefined;
    name?: string | undefined;
    telephoneNumber?: string | undefined;
    address?: JrAddressViewModel | undefined;
    contactPerson?: JrContactPersonViewModel | undefined;
}

export interface JrAddressViewModel {
    streetName?: string | undefined;
    streetBuilding?: string | undefined;
    floor?: string | undefined;
    suite?: string | undefined;
    postCode?: string | undefined;
    districtName?: string | undefined;
    countryCode?: string | undefined;
}

export interface JrContactPersonViewModel {
    id?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    telephoneNumber?: string | undefined;
    emailAddress?: string | undefined;
}

export interface GetCompanyRecruitmentViewModel {
    companyRecruitmentId: string;
    title?: string | undefined;
    internalReferenceNumber: number;
    companyId: string;
    companyName?: string | undefined;
}

export interface JobReferralListItemViewModel {
    jobReferralId: string;
    companyName?: string | undefined;
    occupationName?: string | undefined;
    statusId: number;
    referralTypeId: number;
    referralDate: Date | string;
}

export interface JrCompany {
    id: string;
    name?: string | undefined;
    telephoneNumber?: string | undefined;
    address?: JrAddress | undefined;
    contactPerson?: JrContactPerson | undefined;
}

export interface JrAddress {
    streetName?: string | undefined;
    streetBuilding?: string | undefined;
    floor?: string | undefined;
    suite?: string | undefined;
    postCode?: string | undefined;
    districtName?: string | undefined;
    countryCode?: string | undefined;
}

export interface JrContactPerson {
    id?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    telephoneNumber?: string | undefined;
    emailAddress?: string | undefined;
}

export interface CodeListItem2 {
    id: string;
    name?: string | undefined;
    isActive: boolean;
}

export interface ClientCategoryType extends CodeListItem2 {
    externalId?: string | undefined;
    stateCode: number;
}

export enum CurrentUnemploymentStatusType {
    FuldtLedig = "fuldtLedig",
    DelvisLedig = "delvisLedig",
    IkkeLedig = "ikkeLedig",
    Arbejdsfordeling = "arbejdsfordeling",
    Ledig = "ledig",
}

export interface DfdgProfession {
    conceptUriDa?: string | undefined;
    aliasIdentifier?: string | undefined;
    hasEducation: boolean;
    yearLastUsed?: number | undefined;
    monthsOfExperience?: number | undefined;
}

export interface ContactGroupEditingModel {
    contactGroupId?: string | undefined;
    contactGroupTypeId?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    eventDate?: Date | string | undefined;
    correctionComment?: string | undefined;
    authorityType?: string | undefined;
}

export enum CancellationType {
    Absence = "absence",
    Cancellation = "cancellation",
}

export enum CancellationCauseType {
    AfbudTilSamtalePgaSygdomAfUnder14DagesVarighed = "afbudTilSamtalePgaSygdomAfUnder14DagesVarighed",
    AfbudPgaStrafafsoning = "afbudPgaStrafafsoning",
    AfbudTilSamtaleMedGyldigEllerAcceptabelGrund = "afbudTilSamtaleMedGyldigEllerAcceptabelGrund",
    OmfattetAfSystematiskFormidling_DEPRECATED = "omfattetAfSystematiskFormidling_DEPRECATED",
    MyndighedAflyserSamtalen = "myndighedAflyserSamtalen",
    Fejloprettet = "fejloprettet",
    FlyttetBorger = "flyttetBorger",
    BorgerAflyserSamtalen = "borgerAflyserSamtalen",
    PersonenErAfgaaetVedDoeden = "personenErAfgaaetVedDoeden",
}

export enum CompleteBookingRecoverableError {
    PrimaryCaseIdNotFound = "primaryCaseIdNotFound",
    PrimaryCaseTypeIdNotFound = "primaryCaseTypeIdNotFound",
    CitizenTargetGroupNotFound = "citizenTargetGroupNotFound",
    CitizenTargetGroupHasNoInterviewTypes = "citizenTargetGroupHasNoInterviewTypes",
}

export interface BookingViewModelBase {
    interviewContactType?: SamtaleformType | undefined;
    externalId?: string | undefined;
    interviewId?: string | undefined;
    meetingDescription?: string | undefined;
    cancellationCauseTypeCodeListValue?: string | undefined;
    cancellationCauseType?: CancellationCauseType | undefined;
    cancellationType?: CancellationType | undefined;
    cancellationDeadlineDate?: Date | string | undefined;
    cancellationDeadlineTime?: TimeOfDay | undefined;
    cancellationPossible: boolean;
    contactDetailsDigitalContact?: string | undefined;
    contactDetailsPhoneNumber?: string | undefined;
    correctionComment?: string | undefined;
    externalCaseworkerFirstName?: string | undefined;
    externalCaseworkerId?: string | undefined;
    externalCaseworkerMiddleName?: string | undefined;
    externalCaseworkerLastName?: string | undefined;
    caseworkerId?: string | undefined;
    privateContactPersonId?: string | undefined;
    companyId?: string | undefined;
    interviewFormType?: InterviewFormType | undefined;
    reBookingDeadlineDate?: Date | string | undefined;
    reBookingDeadlineTime?: TimeOfDay | undefined;
    reBookingPossible: boolean;
    scheduledStartTime?: TimeOfDay | undefined;
    scheduledEndTime?: TimeOfDay | undefined;
    selfBooked: boolean;
    interviewType?: InterviewType | undefined;
    interviewTypeCode?: number | undefined;
    caller?: Caller | undefined;
    organizationCode?: number | undefined;
    organizationType?: OrganisationType | undefined;
    bookingAccepted: boolean;
    bookingAcceptedOn?: Date | string | undefined;
    citizenId: string;
    letter?: Letter | undefined;
    address?: Address | undefined;
    template?: Template | undefined;
    attachments?: BookingAttachmentViewModel[] | undefined;
    participants?: BookingParticipantViewModel[] | undefined;
    scheduledDate?: Date | string | undefined;
    caseId?: string | undefined;
    journalNoteComment?: string | undefined;
    isMedComVdxMeeting?: boolean | undefined;
    medComVdxMeetingLinkForHost?: string | undefined;
}

export interface BookingCreateUpdateViewModel extends BookingViewModelBase {
    id?: string | undefined;
    letterOtherRecipients?: BookingLetterOtherRecipientViewModel[] | undefined;
}

export interface BookingLetterOtherRecipientViewModel {
    recipientType: LetterOtherRecipientType;
    recipientId: string;
    name?: string | undefined;
    address?: string | undefined;
    attention?: string | undefined;
    contactPersonId?: string | undefined;
    contactPersonName?: string | undefined;
    outgoingDocumentTypeId?: string | undefined;
}

export enum LetterOtherRecipientType {
    Citizen = "citizen",
    Company = "company",
    PrivatePerson = "privatePerson",
}

export enum SamtaleformType {
    PersonligKontakt = "personligKontakt",
    Telefon = "telefon",
    Brev = "brev",
    Digitalt_DEPRECATED = "digitalt_DEPRECATED",
    Andet_DEPRECATED = "andet_DEPRECATED",
    MoedePaaArbejde_DEPRECATED = "moedePaaArbejde_DEPRECATED",
    TekniskReg_DEPRECATED = "tekniskReg_DEPRECATED",
    DigitaltMoede = "digitaltMoede",
    IngenDirekteBorgerkontakt = "ingenDirekteBorgerkontakt",
}

export enum InterviewFormType {
    IndividueltMoede = "individueltMoede",
    FaellesMoede = "faellesMoede",
}

export enum InterviewType {
    ContactMunicipality_DEPRECATED = "contactMunicipality_DEPRECATED",
    ExtraMeeting_DEPRECATED = "extraMeeting_DEPRECATED",
    Followup_DEPRECATED = "followup_DEPRECATED",
    Followup = "followup",
    FlexFollowup = "flexFollowup",
    SicknessFollowup_DEPRECATED = "sicknessFollowup_DEPRECATED",
    Job = "job",
    Referral_DEPRECATED = "referral_DEPRECATED",
    Information = "information",
    Resume = "resume",
    Intermediation_DEPRECATED = "intermediation_DEPRECATED",
    Other = "other",
    InformationWithCompulsoryAttendance = "informationWithCompulsoryAttendance",
    Other_DEPRECATED = "other_DEPRECATED",
    Availability = "availability",
    ContractAfterIntegrationLaw = "contractAfterIntegrationLaw",
    JoinedJob = "joinedJob",
    RehabilitationTeam = "rehabilitationTeam",
}

export enum Caller {
    Undecided = "undecided",
    Citizen = "citizen",
    Jobcenter = "jobcenter",
}

export enum OrganisationType {
    Arbejdsformidlingen_DEPRECATED = "arbejdsformidlingen_DEPRECATED",
    Akasse = "akasse",
    Kommuner_DEPRECATED = "kommuner_DEPRECATED",
    AndenAktoer = "andenAktoer",
    Star = "star",
    Driftsselskab = "driftsselskab",
    Kommune = "kommune",
    JobCenter = "jobCenter",
    Beskaeftigelsesregion_DEPRECATED = "beskaeftigelsesregion_DEPRECATED",
    Driftsregion_DEPRECATED = "driftsregion_DEPRECATED",
    Uddannelsesinstitution = "uddannelsesinstitution",
    Samarbejdspartner = "samarbejdspartner",
    Sygehusregion = "sygehusregion",
    Kriminalforsorgen = "kriminalforsorgen",
    StyrelsenForITOgLaering = "styrelsenForITOgLaering",
    UddannelsesOgForskningsstyrelsen = "uddannelsesOgForskningsstyrelsen",
    Fagforbund = "fagforbund",
    UDK = "udk",
    UIM = "uim",
    PrivatJobbankEllerVikarbureau = "privatJobbankEllerVikarbureau",
    AUB = "aub",
    Revisor = "revisor",
    Ministerie = "ministerie",
    Virksomhed = "virksomhed",
    Klientsystem = "klientsystem",
    AndenAktoerPaaVegneAfStaten = "andenAktoerPaaVegneAfStaten",
    AkasseSelvbetjeningssystem = "akasseSelvbetjeningssystem",
    KommuneSelvbetjeningssystem = "kommuneSelvbetjeningssystem",
}

export interface Letter {
    note?: string | undefined;
    name?: string | undefined;
    attention?: string | undefined;
    address?: string | undefined;
    companyId?: string | undefined;
    contactPersonId?: string | undefined;
    outgoingDocumentTypeId?: string | undefined;
    templateMappingId?: number | undefined;
    templateMappingVariantId?: number | undefined;
    html?: string | undefined;
}

export interface Address {
    room?: string | undefined;
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    suiteIdentifier?: string | undefined;
    postCodeIdentifier?: string | undefined;
    districtName?: string | undefined;
    countryIdentificationCode?: string | undefined;
}

export interface Template {
    codeName?: string | undefined;
    label?: string | undefined;
    name?: string | undefined;
}

export interface BookingAttachmentViewModel {
    attachmentId: string;
    attachmentType: BookingAttachmentType;
}

export enum BookingAttachmentType {
    Bilag = "bilag",
}

export interface BookingParticipantViewModel {
    id?: string | undefined;
    participantId?: string | undefined;
    name?: string | undefined;
    externalAuthorityParticipantId?: string | undefined;
    participantType: ParticipantType;
    contactDetails?: string | undefined;
    contactType?: SamtaleformType | undefined;
}

export enum ParticipantType {
    AKassekonsulent = "aKassekonsulent",
    Handicaphjaelper = "handicaphjaelper",
    Tolk = "tolk",
    Mentor = "mentor",
    Partsrepraesentant = "partsrepraesentant",
    Bisidder = "bisidder",
    StoetteKontaktPerson = "stoetteKontaktPerson",
    AndenDeltager = "andenDeltager",
    Sundhedskoordinator = "sundhedskoordinator",
    Arbejdsgiver = "arbejdsgiver",
    Virksomhedskonsulent = "virksomhedskonsulent",
    Sundhedsrepraesentant = "sundhedsrepraesentant",
    KoordinerendeSagsbehandler = "koordinerendeSagsbehandler",
    PersonligJobformidler = "personligJobformidler",
    JobkonsulentFraJobcenter = "jobkonsulentFraJobcenter",
    IpsKonsulent = "ipsKonsulent",
}

export interface CrowdBookingCitizenScheduleModel {
    citizenId: string;
    start: Date | string;
    end: Date | string;
}

export interface CrowdBookingInfoModel {
    interviewFormType?: KeyValuePairOfInterviewFormTypeAndCrowdBookingCodeListItem | undefined;
    interviewTypeCode: number;
    interviewContactType?: KeyValuePairOfSamtaleformTypeAndCrowdBookingCodeListItem | undefined;
    responsibleCaseworkerId?: string | undefined;
    meetingDescription?: string | undefined;
    caller?: Caller | undefined;
    contactDetailsPhoneNumber?: string | undefined;
    contactDetailsDigitalContact?: string | undefined;
}

export interface KeyValuePairOfInterviewFormTypeAndCrowdBookingCodeListItem {
    key: InterviewFormType;
    value?: CrowdBookingCodeListItem | undefined;
}

export interface CrowdBookingCodeListItem {
    name?: string | undefined;
    code: number;
}

export interface KeyValuePairOfSamtaleformTypeAndCrowdBookingCodeListItem {
    key: SamtaleformType;
    value?: CrowdBookingCodeListItem | undefined;
}

export interface CrowdBookingTemplateInfoModel {
    mappingId: number;
    mappingVariantId?: number | undefined;
    templateName?: string | undefined;
    templateCode?: string | undefined;
    attachments?: string[] | undefined;
}

export interface CrowdBookingMeetingAddressModel {
    room?: string | undefined;
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    suiteIdentifier?: string | undefined;
    postCodeIdentifier?: string | undefined;
    districtName?: string | undefined;
    countryIdentificationCode?: string | undefined;
}

export interface InterviewViewModelBase {
    interviewTimeOfDay?: TimeOfDay | undefined;
    interviewDate?: Date | string | undefined;
    interviewContactType?: SamtaleformType | undefined;
    agreement?: string | undefined;
    citizenId: string;
    bookingId?: string | undefined;
    interviewTypeUnion?: InterviewTypeUnion | undefined;
    caseId?: string | undefined;
    journalNoteTitleSupplement?: string | undefined;
    journalNoteComment?: string | undefined;
    caseworkerId?: string | undefined;
    externalId?: string | undefined;
    notifyOtherCaseworkerId?: string | undefined;
    attachments?: InterviewAttachmentViewModel[] | undefined;
    participants?: InterviewParticipantViewModel[] | undefined;
    participationStatus?: ParticipationStatusType | undefined;
    caseworkerDisplayName?: string | undefined;
    createdByDisplayName?: string | undefined;
    modifiedByDisplayName?: string | undefined;
    authorityName?: string | undefined;
    correctionComment?: string | undefined;
    period?: InterviewPeriod | undefined;
    interpreterParticipation?: boolean | undefined;
    interpreterLanguageId?: string | undefined;
    interpreterLanguageName?: string | undefined;
    interpreterContactFormId?: string | undefined;
    interpreterContactFormName?: string | undefined;
    interpreterComment?: string | undefined;
    dialogSupportUsedForAgreement: boolean;
    dialogSupportUsedForJournalNoteRemark: boolean;
    agreementAiTextApprovedByCaseworker: boolean;
    journalNoteRemarkAiTextApprovedByCaseworker: boolean;
    interpretingAssistanceUsed?: boolean | undefined;
    interpretingAssistanceCitizenLanguage?: string | undefined;
    dialogSupportId?: string | undefined;
}

export interface InterviewCompleteViewModel extends InterviewViewModelBase {
    id: string;
}

export interface InterviewTypeUnion {
    id?: string | undefined;
    name?: string | undefined;
    enumName?: string | undefined;
    isActive: boolean;
    description?: string | undefined;
    createdOn: Date | string;
    modifiedOn?: Date | string | undefined;
    createdBy: string;
    modifiedBy?: string | undefined;
    interviewTypeCode: number;
    templateMappingName?: string | undefined;
    reportAsDfdgSamtaleTypeCode?: number | undefined;
    reportAsDfdgSamtaleTypeName?: string | undefined;
    journalNoteContentTypeId?: string | undefined;
    isDfdgSamtaleType: boolean;
    caseTypeIds?: string[] | undefined;
}

export interface InterviewAttachmentViewModel {
    attachmentId: string;
    attachmentType: InterviewAttachmentType;
}

export enum InterviewAttachmentType {
    Bilag = "bilag",
}

export interface InterviewParticipantViewModel {
    id?: string | undefined;
    participantId?: string | undefined;
    name?: string | undefined;
    externalId?: string | undefined;
    contactType?: SamtaleformType | undefined;
    externalAuthorityParticipantId?: string | undefined;
    participantType?: ParticipantType | undefined;
}

export enum ParticipationStatusType {
    AKassenDeltog = "aKassenDeltog",
    BorgerOenskedeIkkeAKassensDeltagelse_DEPRECATED = "borgerOenskedeIkkeAKassensDeltagelse_DEPRECATED",
    AKassenDeltogIkke = "aKassenDeltogIkke",
    AKassenUdeblev_DEPRECATED = "aKassenUdeblev_DEPRECATED",
    BorgerDeltogIRehabiliteringssamtale = "borgerDeltogIRehabiliteringssamtale",
    BorgerDeltogIkkeIRehabiliteringssamtale = "borgerDeltogIkkeIRehabiliteringssamtale",
    JobcentretDeltog = "jobcentretDeltog",
    JobcentretDeltogIkke = "jobcentretDeltogIkke",
    JobcentretUdeblev_DEPRECATED = "jobcentretUdeblev_DEPRECATED",
}

export enum InterviewPeriod {
    FirstPeriod = "firstPeriod",
    OngoingPeriod = "ongoingPeriod",
}

export interface InterviewViewModel extends InterviewViewModelBase {
    id?: string | undefined;
}

export interface BookingUpdateViewModel {
    id: string;
    interviewContactType?: SamtaleformType | undefined;
    meetingDescription?: string | undefined;
    cancellationDeadlineDate?: Date | string | undefined;
    cancellationDeadlineTime?: TimeOfDay | undefined;
    cancellationPossible: boolean;
    contactDetailsDigitalContact?: string | undefined;
    contactDetailsPhoneNumber?: string | undefined;
    correctionComment?: string | undefined;
    caseworkerId: string;
    privateContactPersonId?: string | undefined;
    companyId?: string | undefined;
    interviewFormType?: InterviewFormType | undefined;
    reBookingDeadlineDate?: Date | string | undefined;
    reBookingDeadlineTime?: TimeOfDay | undefined;
    reBookingPossible: boolean;
    scheduledDate?: Date | string | undefined;
    scheduledStartTime?: TimeOfDay | undefined;
    scheduledEndTime?: TimeOfDay | undefined;
    caller?: Caller | undefined;
    letter?: Letter | undefined;
    address?: Address | undefined;
    journalNoteComment?: string | undefined;
    attachments?: BookingAttachmentViewModel[] | undefined;
    participants?: BookingParticipantViewModel[] | undefined;
    letterOtherRecipients?: BookingLetterOtherRecipientViewModel[] | undefined;
}

export interface UpdateInterviewResponse2 {
    success: boolean;
}

export interface UpdateInterviewRequest2 {
    interviewId: string;
    personCivilRegistrationNumber?: string | undefined;
    caseworkerIdentifier: string;
    correctionComment?: string | undefined;
    interviewContactTypeIdentifier: SamtaleformType;
    agreementDescription?: string | undefined;
}

export enum InterviewDeadlineStatusType {
    DeadlineActive = "deadlineActive",
    DeadlineMet = "deadlineMet",
    DeadlineOverdue = "deadlineOverdue",
    DeadlineAdministrativelyClosed = "deadlineAdministrativelyClosed",
    DeadlineMetHeld = "deadlineMetHeld",
    DeadlineNotActivated = "deadlineNotActivated",
}

export interface GrantDto {
    id: string;
    caseId: string;
    citizenId: string;
    grantTypeId: string;
    status: GrantStatus;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    followUpDate?: Date | string | undefined;
    description?: string | undefined;
    visitatorTeamId?: string | undefined;
    visitatorUserId?: string | undefined;
    visitationComment?: string | undefined;
    visitationDate?: Date | string | undefined;
    offerId?: string | undefined;
    isDeleted: boolean;
    socialGrant?: SocialGrantDto | undefined;
    priceCalculation?: GrantPriceCalculationDto | undefined;
    requestedByCitizenOrOther?: boolean | undefined;
    visitationProposal?: VisitationProposal | undefined;
    rulingId?: string | undefined;
    rulingStatus?: RulingStatus | undefined;
    applicationOrRulingConcerning?: string | undefined;
}

export enum GrantStatus {
    UnderPreparation = "underPreparation",
    ReadyForVisitation = "readyForVisitation",
    Granted = "granted",
    Rejected = "rejected",
    Superseded = "superseded",
}

export interface SocialGrantDto {
    primaryAssessmentTopicId?: string | undefined;
    additionalAssessmentTopicIds?: string[] | undefined;
    socialOfferId?: string | undefined;
    legacyCompanyId?: string | undefined;
    benefitTypeIds: string[];
}

export enum RulingStatus {
    Started = "started",
    CaseInformationInProgress = "caseInformationInProgress",
    HearingStarted = "hearingStarted",
    HearingCompleted = "hearingCompleted",
    RecommendationInProgress = "recommendationInProgress",
    Decided = "decided",
    TerminatedWithoutDecision = "terminatedWithoutDecision",
    Superseded = "superseded",
}

export interface CreateGrantDto {
    caseId: string;
    citizenId: string;
    grantTypeId: string;
    status: GrantStatus;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    followUpDate?: Date | string | undefined;
    description?: string | undefined;
    visitatorTeamId?: string | undefined;
    visitatorUserId?: string | undefined;
    visitationComment?: string | undefined;
    visitationDate?: Date | string | undefined;
    socialGrant?: CreateSocialGrantDto | undefined;
    offerId?: string | undefined;
    priceCalculation?: GrantPriceCalculationDto2 | undefined;
}

export interface CreateSocialGrantDto {
    primaryAssessmentTopicId?: string | undefined;
    additionalAssessmentTopicIds?: string[] | undefined;
    socialOfferId?: string | undefined;
    benefitTypeIds?: string[] | undefined;
}

export interface GrantPriceCalculationDto2 {
    priceModel?: PriceModel2 | undefined;
    unitPrice?: number | undefined;
    priceModelInitialRate?: number | undefined;
    expectedUnitPriceCorrection?: number | undefined;
    expectedInitialRateCorrection?: number | undefined;
    expectedPricePerMonth?: number | undefined;
    expectedTotalPrice?: number | undefined;
    activityScope?: ActivityScopeDto2 | undefined;
    durationScope?: DurationScopeDto2 | undefined;
    formattedScope?: string | undefined;
}

export interface ActivityScopeDto2 {
    amount?: number | undefined;
    unit?: ActivityScopeUnit | undefined;
    frequency?: ActivityScopeFrequency | undefined;
}

export interface DurationScopeDto2 {
    amount?: number | undefined;
    unit?: DurationScopeUnit | undefined;
}

export interface TerminatedActivityDto {
    activityId: string;
    title?: string | undefined;
    outcome: TerminatedActivityOutcome;
    errorMessage?: string | undefined;
}

export enum TerminatedActivityOutcome {
    NotAffected = "notAffected",
    Discontinued = "discontinued",
    Cancelled = "cancelled",
    EndDateUpdated = "endDateUpdated",
    Failed = "failed",
}

export interface CitizenMessageCreateModel {
    title?: string | undefined;
    text?: string | undefined;
    replyDeadline?: Date | string | undefined;
    attachments?: CitizenMessageAttachmentModel[] | undefined;
}

export interface CitizenMessageAttachmentModel {
    attachmentId: string;
    title?: string | undefined;
}

export enum CvStatusTypeCodeList {
    KlarTilGodkendelse = "klarTilGodkendelse",
    Godkendt = "godkendt",
    EjGodkendt = "ejGodkendt",
    JobcentretAnbefalerAtCVetOpdateres = "jobcentretAnbefalerAtCVetOpdateres",
    Pabegyndt = "pabegyndt",
}

export interface CounselingInquiryCaseModel {
    caseTypeId: string;
    targetGroupId: string;
    contactReasonId: string;
    startDate: Date | string;
    responsibleTeamId: string;
    responsibleCaseworkerId?: string | undefined;
}

export interface CounselingInquiryContent {
    administration: CounselingInquiryAdministration;
    otherAdministrationName?: string | undefined;
    otherAdministrationDescription?: string | undefined;
    inquiryDate: Date | string;
    channel?: CounselingInquiryChannel | undefined;
    inquirer?: CounselingInquirer | undefined;
    inquirerDescription?: string | undefined;
    meetingPlace?: string | undefined;
    citizenDescription?: string | undefined;
    employeeDescription?: string | undefined;
    focusAreas?: string | undefined;
    housing?: CounselingInquiryHousing | undefined;
    existingSupport?: string | undefined;
    network?: string | undefined;
    desiredFrequency?: string | undefined;
    preferredTimeOfDay?: string | undefined;
    contactBeforeVisit?: CounselingInquiryContactBeforeVisit | undefined;
    contactPersonGenderPreference?: ContactPersonGenderPreference | undefined;
    contactPersonPreferenceNote?: string | undefined;
    desiredSupportGoals: string[];
    citizenGuidedOnSupportOptions: boolean;
    outcome?: CounselingInquiryOutcome | undefined;
    recommendedGrantTypeId?: string | undefined;
    outcomeRemarks?: string | undefined;
    temporaryHomeSupport?: CounselingInquiryTemporaryHomeSupportAnswers | undefined;
}

export enum CounselingInquiryAdministration {
    Social = "social",
    Other = "other",
}

export enum CounselingInquiryChannel {
    Attendance = "attendance",
    Telephone = "telephone",
    HomeVisit = "homeVisit",
    Digital = "digital",
}

export enum CounselingInquirer {
    Citizen = "citizen",
    Relative = "relative",
    Professional = "professional",
    Other = "other",
}

export enum CounselingInquiryHousing {
    OwnerOccupied = "ownerOccupied",
    Rental = "rental",
    Cooperative = "cooperative",
    WithRelatives = "withRelatives",
    ResidentialFacility = "residentialFacility",
    Homeless = "homeless",
    Other = "other",
}

export enum CounselingInquiryContactBeforeVisit {
    Sms = "sms",
    PhoneCall = "phoneCall",
    NotNeeded = "notNeeded",
}

export enum ContactPersonGenderPreference {
    NoPreference = "noPreference",
    Male = "male",
    Female = "female",
}

export enum CounselingInquiryOutcome {
    ClosedWithCounseling = "closedWithCounseling",
    TemporaryHomeSupport = "temporaryHomeSupport",
    GrantRecommendation = "grantRecommendation",
    RegisteredForOtherAdministration = "registeredForOtherAdministration",
}

export interface CounselingInquiryTemporaryHomeSupportAnswers {
    primaryAssessmentTopicId?: string | undefined;
    additionalAssessmentTopicIds: string[];
    benefitTypeIds: string[];
    reportingFrequency?: string | undefined;
    followUpDate?: Date | string | undefined;
    activityHoursPerWeek?: number | undefined;
    activityMinutesPerWeek?: number | undefined;
    activityEndDate?: Date | string | undefined;
    interventionObjective?: CounselingInquiryInterventionObjectiveAnswers | undefined;
    interventionObjectives?: CounselingInquiryInterventionObjectiveAnswers[] | undefined;
}

export interface CounselingInquiryInterventionObjectiveAnswers {
    title?: string | undefined;
    description?: string | undefined;
    interventionObjectiveType?: string | undefined;
    functionalAbilityCatalogId?: string | undefined;
    currentFunctionalAbilityCatalogRating?: number | undefined;
    expectedFunctionalAbilityCatalogRating?: number | undefined;
    followUpDate?: Date | string | undefined;
    otherFunctionalAbilityCatalogIds: string[];
}

export interface SendLetterRenderTemplateVariables {
    typedVariableIds?: SendLetterTypedVariableId[] | undefined;
    untypedVariablesJson?: string | undefined;
    isSocialOptic?: boolean | undefined;
}

export interface SendLetterTypedVariableId {
    variableType: SendLetterVariableType;
    id?: string | undefined;
}

export enum SendLetterVariableType {
    Borger = "borger",
    Sagsbehandler = "sagsbehandler",
    Aftale = "aftale",
    Radighedsvurdering = "radighedsvurdering",
    Virksomhed = "virksomhed",
    Afdeling = "afdeling",
    Businessunit = "businessunit",
    Placements = "placements",
    AndenAktoerHenvisning = "andenAktoerHenvisning",
    Forlaengelsesvurdering = "forlaengelsesvurdering",
    Ressourceprofil = "ressourceprofil",
    Plan = "plan",
    Plantype = "plantype",
    Journalnotater = "journalnotater",
    Jobhenvisning = "jobhenvisning",
    Jobplan = "jobplan",
    Rekrutteringsanmodning = "rekrutteringsanmodning",
    PlanV2 = "planV2",
    Placering = "placering",
    Afgoerelse = "afgoerelse",
    Bestilling = "bestilling",
    Egenbetaling = "egenbetaling",
    Laegeanmodning = "laegeanmodning",
}

export interface SendLetterOfCitizenRecipient {
    template: TemplateInfo2;
    variantId?: string | undefined;
    renderTemplateVariables?: SendLetterRenderTemplateVariables | undefined;
    outgoingDocumentTypeId?: string | undefined;
    outgoingDocumentTypeName?: string | undefined;
    attachments?: string[] | undefined;
    availabilityAssessmentId?: string | undefined;
    content: LetterContent;
    letterCase?: LetterCase | undefined;
    journalNote?: JournalNote | undefined;
    recipient: CitizenRecipient;
    citizenId: string;
    createdBy: string;
    createdByUserName?: string | undefined;
    formatTitleAndContent: boolean;
    serviceProviderUnitId?: string | undefined;
    assignmentId?: string | undefined;
}

export interface TemplateInfo2 {
    templateId?: string | undefined;
    templateCode?: string | undefined;
    templateMappingName?: string | undefined;
}

export interface LetterContent {
    name: string;
    content: string;
}

export interface LetterCase {
    caseId: string;
    citizenId: string;
    caseWorkerId: string;
    caseWorkerName: string;
    notifyCaseWorker: boolean;
}

export interface JournalNote {
    title?: string | undefined;
    note?: string | undefined;
    entityJsonData?: string | undefined;
    type?: string | undefined;
}

export interface LetterRecipient {
    id: string;
    type: LetterRecipientType;
    name: string;
    address?: string | undefined;
}

export interface CitizenRecipient extends LetterRecipient {
}

export enum LetterRecipientType {
    Citizen = "citizen",
    Company = "company",
    PrivatePerson = "privatePerson",
    SupplierPlatform = "supplierPlatform",
}

export interface SendLetterOfCompanyRecipient {
    template: TemplateInfo2;
    variantId?: string | undefined;
    renderTemplateVariables?: SendLetterRenderTemplateVariables | undefined;
    outgoingDocumentTypeId?: string | undefined;
    outgoingDocumentTypeName?: string | undefined;
    attachments?: string[] | undefined;
    availabilityAssessmentId?: string | undefined;
    content: LetterContent;
    letterCase?: LetterCase | undefined;
    journalNote?: JournalNote | undefined;
    recipient: CompanyRecipient;
    citizenId: string;
    createdBy: string;
    createdByUserName?: string | undefined;
    formatTitleAndContent: boolean;
    serviceProviderUnitId?: string | undefined;
    assignmentId?: string | undefined;
}

export interface CompanyRecipient extends LetterRecipient {
    attentionName?: string | undefined;
    contactPerson?: ContactPerson | undefined;
}

export interface ContactPerson {
    id: string;
    name?: string | undefined;
}

export interface LetterRecipients {
    primaryRecipientId: string;
    primaryRecipientType: LetterRecipientType;
    citizenRecipients?: SendLetterOfCitizenRecipient[] | undefined;
    companyRecipients?: SendLetterOfCompanyRecipient[] | undefined;
    privatePersonRecipients?: SendLetterOfPrivatePersonRecipient[] | undefined;
    supplierPlatformRecipients?: SendLetterOfSupplierPlatformRecipient[] | undefined;
}

export interface SendLetterOfPrivatePersonRecipient {
    template: TemplateInfo2;
    variantId?: string | undefined;
    renderTemplateVariables?: SendLetterRenderTemplateVariables | undefined;
    outgoingDocumentTypeId?: string | undefined;
    outgoingDocumentTypeName?: string | undefined;
    attachments?: string[] | undefined;
    availabilityAssessmentId?: string | undefined;
    content: LetterContent;
    letterCase?: LetterCase | undefined;
    journalNote?: JournalNote | undefined;
    recipient: PrivatePersonRecipient;
    citizenId: string;
    createdBy: string;
    createdByUserName?: string | undefined;
    formatTitleAndContent: boolean;
    serviceProviderUnitId?: string | undefined;
    assignmentId?: string | undefined;
}

export interface PrivatePersonRecipient extends LetterRecipient {
}

export interface SendLetterOfSupplierPlatformRecipient {
    template: TemplateInfo2;
    variantId?: string | undefined;
    renderTemplateVariables?: SendLetterRenderTemplateVariables | undefined;
    outgoingDocumentTypeId?: string | undefined;
    outgoingDocumentTypeName?: string | undefined;
    attachments?: string[] | undefined;
    availabilityAssessmentId?: string | undefined;
    content: LetterContent;
    letterCase?: LetterCase | undefined;
    journalNote?: JournalNote | undefined;
    recipient: SupplierPlatformRecipient;
    citizenId: string;
    createdBy: string;
    createdByUserName?: string | undefined;
    formatTitleAndContent: boolean;
    serviceProviderUnitId?: string | undefined;
    assignmentId?: string | undefined;
}

export interface SupplierPlatformRecipient extends LetterRecipient {
    orderId: string;
}

export interface CitizenTask {
    id: string;
    taskType: CitizenTaskType;
    title?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | string | undefined;
    citizenId: string;
    relatedCompanyId?: string | undefined;
    responsibleCaseWorkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
    caseId?: string | undefined;
    repetition?: CitizenTaskRepetition | undefined;
    taskStatus: TaskStatus;
    relatedEntity?: CitizenTaskRelatedEntity | undefined;
    relatedEntityLink?: string | undefined;
    createdByUserId?: string | undefined;
    createdByTeamId?: string | undefined;
    category?: TaskCategory | undefined;
    vitasUrl?: string | undefined;
    taskActionsList?: TaskActionModel[] | undefined;
    metadata?: TaskMetadataDto | undefined;
    createdOn?: Date | string | undefined;
    closedOn?: Date | string | undefined;
    closedInDays?: number | undefined;
}

export enum CitizenTaskType {
    Opgave = "opgave",
    Advis = "advis",
}

export interface CitizenTaskRepetition {
    repetitionUnit: CitizenTaskRepetitionUnit;
    interval: number;
    maxRepetitions?: number | undefined;
    previousRepetitions?: number | undefined;
}

export enum CitizenTaskRepetitionUnit {
    Days = "days",
    Weeks = "weeks",
    Months = "months",
    Years = "years",
}

export enum TaskStatus {
    Planned = "planned",
    Cancelled = "cancelled",
    Closed = "closed",
    Ongoing = "ongoing",
}

export interface CitizenTaskRelatedEntity {
    id: string;
    name?: string | undefined;
}

export interface TaskCategory extends CodeListItem {
    identifier?: string | undefined;
}

export enum TaskActionModel {
    None = "none",
    Booking = "booking",
    Interview = "interview",
    IncomingMail = "incomingMail",
    JournalizeOnCitizen = "journalizeOnCitizen",
    JournalizeOnCompany = "journalizeOnCompany",
}

export interface TaskMetadataDto {
    type: TaskMetadataTypeDto;
    id?: string | undefined;
    user?: string | undefined;
    occuredAt?: Date | string | undefined;
    entityId?: string | undefined;
}

export enum TaskMetadataTypeDto {
    JournalNote = "journalNote",
    CompanyNote = "companyNote",
    Rejected = "rejected",
    Unknown = "unknown",
    DiaryNote = "diaryNote",
}

export interface PersonNotificationSettingsViewModel {
    allowEmail: boolean;
    allowText: boolean;
    notificationType: NotificationType;
    name?: string | undefined;
}

export enum NotificationType {
    PaamindelseOmTjekAfJobforslag_DEPRECATED = "paamindelseOmTjekAfJobforslag_DEPRECATED",
    Moedepåmindelse_DEPRECATED = "moedepåmindelse_DEPRECATED",
    AndenNotifikation_DEPRECATED = "andenNotifikation_DEPRECATED",
    JobnetBrugeroplysninger_DEPRECATED = "jobnetBrugeroplysninger_DEPRECATED",
    Bookingbekraeftelse_DEPRECATED = "bookingbekraeftelse_DEPRECATED",
    UddannelsespaalaegFrist_DEPRECATED = "uddannelsespaalaegFrist_DEPRECATED",
    PlanNotifikation_DEPRECATED = "planNotifikation_DEPRECATED",
    Fristnotifikation_DEPRECATED = "fristnotifikation_DEPRECATED",
    AlmenOrientering_DEPRECATED = "almenOrientering_DEPRECATED",
    Jobformidling_DEPRECATED = "jobformidling_DEPRECATED",
    InvitationTilArrangement_DEPRECATED = "invitationTilArrangement_DEPRECATED",
    HenvendelseFraArbejdsgiver_DEPRECATED = "henvendelseFraArbejdsgiver_DEPRECATED",
    SvarPaaHenvendelseFraArbejdsgiver_DEPRECATED = "svarPaaHenvendelseFraArbejdsgiver_DEPRECATED",
    CVPaamindelse_DEPRECATED = "cvPaamindelse_DEPRECATED",
    PaamindelseOmKvitteringsfrist_DEPRECATED = "paamindelseOmKvitteringsfrist_DEPRECATED",
    MoederOgPligter = "moederOgPligter",
    BeskederFraArbejdsgivereOgSagsbehandler = "beskederFraArbejdsgivereOgSagsbehandler",
    GodeRaadTilJobsoegningOgUddannelse = "godeRaadTilJobsoegningOgUddannelse",
    UndersoegelserOgFeedback = "undersoegelserOgFeedback",
}

export interface CitizenCommentModel {
    commentId: string;
    comment?: string | undefined;
    caseworkerName?: string | undefined;
    eventDate: Date | string;
}

export interface CitizenCoreEditableFields {
    phone?: string | undefined;
    mobile?: string | undefined;
    emailAddress?: string | undefined;
    nativeLanguage?: NativeLanguage | undefined;
    interpreterNeeded?: YesNo | undefined;
    interpreterNativeLanguage?: NativeLanguage | undefined;
    interpreterNote?: string | undefined;
    caveInformation?: string | undefined;
    occupationalEnablingEducation?: string | undefined;
    needReadWriteMathTest?: YesNo | undefined;
    readWriteMathTestReason?: string | undefined;
    readWriteMathTestReasonId?: string | undefined;
    preferredName?: string | undefined;
}

export interface NativeLanguage extends CodeListItem {
    comments?: string | undefined;
    iso6391?: string | undefined;
    iso6392?: string | undefined;
    ownLanguage?: string | undefined;
    externalId?: string | undefined;
    stateCode: number;
}

export enum YesNo {
    None = "none",
    Yes = "yes",
    No = "no",
}

export interface NotesViewModel {
    informalNote?: string | undefined;
    citizenTag1?: string | undefined;
    citizenTag2?: string | undefined;
    citizenTag3?: string | undefined;
    citizenTag4?: string | undefined;
    citizenTag5?: string | undefined;
    importantNote1?: string | undefined;
    importantNote1ExpiresOn?: Date | string | undefined;
    importantNote2?: string | undefined;
    importantNote2ExpiresOn?: Date | string | undefined;
    readWriteMathTest?: ReadWriteMathTestViewModel | undefined;
}

export interface ReadWriteMathTestViewModel {
    needReadWriteMathTest?: YesNo | undefined;
    readWriteMathTestReason?: string | undefined;
    readWriteMathTestReasonId?: string | undefined;
}

export interface ContactInfoTemporaryAddressViewModel {
    postalAddress?: ContactInfoPostalAddress | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
}

export interface ContactInfoPostalAddress {
    coName?: string | undefined;
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    suiteIdentifier?: string | undefined;
    postCodeIdentifier?: string | undefined;
    districtSubdivisionIdentifier?: string | undefined;
    districtName?: string | undefined;
    countryIdentificationCode?: string | undefined;
}

export interface CodeListItem3 {
    id: string;
    name?: string | undefined;
    isActive: boolean;
}

export interface RemovalCauseType extends CodeListItem3 {
    description?: string | undefined;
    externalId?: string | undefined;
    removalCauseTypeCategory?: number | undefined;
}

export interface AbsenceCauseTypeItem {
    id: string;
    name?: string | undefined;
}

export interface CreateCaseModel {
    citizenId: string;
    startDate: Date | string;
    contactReasonId?: string | undefined;
    caseTypeId?: string | undefined;
    targetGroupId?: string | undefined;
    responsibleTeamId?: string | undefined;
    responsibleCaseworkerId?: string | undefined;
    grantStartDate?: Date | string | undefined;
    grantEndDate?: Date | string | undefined;
    responsibleExternalOperatorCaseworkerId?: string | undefined;
    responsibleExternalOperatorTeamId?: string | undefined;
    companyId?: string | undefined;
    sicknessBenefitJobClarification?: SicknessBenefitJobClarificationModel | undefined;
    interviewCalculationsStartDate?: Date | string | undefined;
    approvedForFlexJobDate?: Date | string | undefined;
    caseRestrictionId?: string | undefined;
    responsibleMunicipalityId?: string | undefined;
    responsibleMunicipalityComment?: string | undefined;
    payingMunicipalityId?: string | undefined;
    payingMunicipalityComment?: string | undefined;
}

export interface SicknessBenefitJobClarificationModel {
    id?: string | undefined;
    firstDayOfAbsence?: Date | string | undefined;
    informationForm?: number | undefined;
    description?: string | undefined;
    additionalDescription?: string | undefined;
    diagnosis?: string | undefined;
    specialistDoctor?: string | undefined;
    treatment?: string | undefined;
    reevaluationDate?: Date | string | undefined;
    sicknessBenefitDurationDate?: Date | string | undefined;
    salaryFreezeDate?: Date | string | undefined;
    externalSicknessBenefitCaseNumber?: string | undefined;
    externalSicknessBenefitUserFacingKey?: string | undefined;
    companyContactPersonId?: string | undefined;
    dispatchOfInformationFormDate?: Date | string | undefined;
    deadlineForResponseToInformationForm?: Date | string | undefined;
    newDeadlineForResponseToInformationForm?: Date | string | undefined;
    receiptOfInformationFormDate?: Date | string | undefined;
    hearingType?: string | undefined;
    hearingDeadline?: Date | string | undefined;
    receiptOfHearingDate?: Date | string | undefined;
    dispensationForLateInformationForm?: boolean | undefined;
    hearingResponse?: string | undefined;
    informationFormValues?: InformationFormModel | undefined;
}

export interface InformationFormModel {
    expectedRecover?: YesNoUnknownAnswer | undefined;
    followupDesired?: YesNoAnswer | undefined;
}

export enum YesNoUnknownAnswer {
    Yes = "yes",
    No = "no",
    DontKnow = "dontKnow",
}

export enum YesNoAnswer {
    Yes = "yes",
    No = "no",
}

export interface AssociatedCaseWorkerModel {
    id?: string | undefined;
    caseWorkerId: string;
    caseId: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    description?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    isResponsibleCaseworker: boolean;
    isResponsibleExternalOperator: boolean;
}

export interface RehabilitationDocument {
    reference?: string | undefined;
    rehabilitationDocumentTypeIdentifier: number;
    owner?: string | undefined;
    documentTitle?: string | undefined;
}

export enum SaveSicknessBenefitVisitationOutcome {
    Created = "created",
    Updated = "updated",
}

export enum SicknessBenefitVisitationStatus {
    Contact = "contact",
    NoContact = "noContact",
}

export interface SicknessBenefitVisitationAiRun {
    promptSource?: SicknessBenefitVisitationPromptSource | undefined;
    promptHash?: string | undefined;
    instructionsHash?: string | undefined;
    modelName?: string | undefined;
    reasoningEffort?: string | undefined;
}

export enum SicknessBenefitVisitationPromptSource {
    Default = "default",
    Tenant = "tenant",
    Override = "override",
}

export interface CaseModel {
    caseId: string;
    createdById?: string | undefined;
    createdOn?: Date | string | undefined;
    citizenId: string;
    caseStatus: CaseStatus;
    companyId?: string | undefined;
    caseClosureReasonId?: string | undefined;
    caseContactReasonId?: string | undefined;
    caseGroupId?: string | undefined;
    caseTypeId?: string | undefined;
    responsibleExternalOperatorTeamId?: string | undefined;
    responsibleExternalOperatorCaseworkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
    responsibleCaseworkerId?: string | undefined;
    targetGroupId?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    grantStartDate?: Date | string | undefined;
    grantEndDate?: Date | string | undefined;
    otherMunicipalityId?: string | undefined;
    responsibleMunicipalityId?: string | undefined;
    responsibleMunicipalityComment?: string | undefined;
    payingMunicipalityId?: string | undefined;
    payingMunicipalityComment?: string | undefined;
    caseMarking?: CaseMarkingModel | undefined;
    associatedCaseWorkers?: AssociatedCaseWorkerModel[] | undefined;
    isCausedByMunicipalityMove: boolean;
    duePeriodId?: string | undefined;
    caseClosure?: CaseClosureModel | undefined;
    targetGroupChangedByCaseId?: string | undefined;
    effortGroupId?: string | undefined;
    personCategoryId?: string | undefined;
    rehabilitationProcessStatus?: number | undefined;
    rehabilitationProcessId?: string | undefined;
    sicknessBenefitJobClarification?: SicknessBenefitJobClarificationModel | undefined;
    isCreatedInSapa: boolean;
    interviewCalculationsStartDate?: Date | string | undefined;
    approvedForFlexJobDate?: Date | string | undefined;
    caseRestrictionId?: string | undefined;
}

export enum CaseStatus {
    Active = "active",
    Finished = "finished",
    NeedsToBeTerminated = "needsToBeTerminated",
}

export interface CaseMarkingModel {
    id?: string | undefined;
    caseTag1?: string | undefined;
    caseTag2?: string | undefined;
    caseTag3?: string | undefined;
    caseTag4?: string | undefined;
    caseTag5?: string | undefined;
}

export interface CaseClosureModel {
    id: string;
    removalCauseTypeId?: string | undefined;
    closedByCaseWorkerId?: string | undefined;
    closedByCaseWorkerDate?: Date | string | undefined;
    municipalityMoveDate?: Date | string | undefined;
    absenceCauseTypeId?: string | undefined;
}

export interface UpdateCaseSicknessBenefitVisitationModel {
    status: SicknessBenefitVisitationStatus;
    justification?: string | undefined;
}

export interface DfdgErrorInfo {
    dgdfHasRegisteredRehabCase: boolean;
    hasRegisteredRehabCase: boolean;
    rehabilitationProcessId: string;
    rehabilitationProcessStatus: number;
    startDate?: Date | string | undefined;
}

export interface AssessmentSanctionsViewModel {
    availabilityAssessmentId: string;
    hearingReceived: boolean;
    hearingReceivedDate?: Date | string | undefined;
    citizenId: string;
    citizenComment?: string | undefined;
    caseWorkerAssessment?: string | undefined;
    relevance: AssessmentRelevance;
    sanctionRequestComment?: string | undefined;
    reasonableCauseTypeId?: string | undefined;
    deadlineForPartyReply?: Date | string | undefined;
    sanction: boolean;
    status: AssessmentStatus;
}

export enum AssessmentRelevance {
    Relevant = "relevant",
    NotRelevantStartedJob = "notRelevantStartedJob",
    NotRelevantStartedEducation = "notRelevantStartedEducation",
    NotRelevantOther = "notRelevantOther",
}

export enum AssessmentStatus {
    Undefined = "undefined",
    Hearing = "hearing",
    Afsluttet = "afsluttet",
}

export interface AssessmentLetterDto {
    caseWorkerId: string;
    attachments?: string[] | undefined;
    letterRecipientCompanyId?: string | undefined;
    letterRecipientCompanyContactPersonId?: string | undefined;
    letterRecipientPrivateContactPersonId?: string | undefined;
    letter?: LetterDto2 | undefined;
}

export interface LetterDto2 {
    name?: string | undefined;
    attention?: string | undefined;
    address?: string | undefined;
    html?: string | undefined;
}

export interface HealthLimitationBaseModel {
    startDate: Date | string;
    endDate?: Date | string | undefined;
    description?: string | undefined;
    nonPossibleAssignments?: string | undefined;
    hasDocumenation: boolean;
}

export interface HealthLimitationCreateModel extends HealthLimitationBaseModel {
}

export interface AbsenceEditModel {
    citizenId: string;
    absenceTypeId: string;
    absenceCauseTypeId?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    notificationDate: Date | string;
    comment?: string | undefined;
    sickLeave?: AvailabilitySickLeaveModel | undefined;
}

export interface AvailabilitySickLeaveModel {
    availabilityDegree?: number | undefined;
    cvrNumber?: string | undefined;
    pNumber?: string | undefined;
    employerAccountId?: string | undefined;
    nemRefusionId?: string | undefined;
    inSubscription?: boolean | undefined;
}

export interface HealthLimitationViewUpdateModel extends HealthLimitationBaseModel {
    dfdgIdentifier: string;
    correctionComment?: string | undefined;
}

export interface DanishTestSettingDto {
    lastSettingDate?: Date | string | undefined;
}

export interface EducationFollowUpDto {
    incomeSubsidyForEducationRemitted?: Date | string | undefined;
    endDate?: Date | string | undefined;
}

export interface EducationDataDto {
    description?: string | undefined;
    startDate?: Date | string | undefined;
}

export interface EmploymentFollowUpDto {
    endDate?: Date | string | undefined;
    incomeSubsidyForEmploymentRemitted?: Date | string | undefined;
    remark?: string | undefined;
}

export interface EmploymentStartDto {
    startDate?: Date | string | undefined;
    description?: string | undefined;
    remark?: string | undefined;
}

export interface IntegrationInfoDto {
    periodStartDate?: Date | string | undefined;
    periodEndDate?: Date | string | undefined;
    responsibilityAcquisitionDate?: Date | string | undefined;
    reasonForResidencePermitType?: ReasonForResidencePermitType | undefined;
    additionalInformation?: string | undefined;
    permanentResidenceDate?: Date | string | undefined;
    idNumber?: string | undefined;
    basicSubsidyStartDate?: Date | string | undefined;
    basicSubsidyEndDate?: Date | string | undefined;
}

export enum ReasonForResidencePermitType {
    RefugeeInlParagraph2Stk2 = "refugeeInlParagraph2Stk2",
    FamilyReunifiedForeignerToARefugeeInlParagraph2Stk3 = "familyReunifiedForeignerToARefugeeInlParagraph2Stk3",
    OtherFamilyReunifiedForeignersInlParagraph2Stk4 = "otherFamilyReunifiedForeignersInlParagraph2Stk4",
    ImmigrantInlParagraph2Stk6 = "immigrantInlParagraph2Stk6",
}

export interface CreateAssignmentModel {
    activityId: ActivityId;
    citizenId: CitizenId;
    backgroundInformation: CreateBackgroundInformationModel;
    coordinationDetails: CoordinationDetailsModel;
    assessmentInformation: AssessmentInformationModel;
    commissionedIntervention: CommissionedInterventionModel;
    createdByServiceProvider?: boolean | undefined;
    shareSupportAssessment?: boolean | undefined;
}

export interface IdentifierOfInterventionObjective {
    value: string;
}

export interface InterventionObjectiveId2 extends IdentifierOfInterventionObjective {
}

export interface CreateInterventionObjectiveModel {
    assignmentId: AssignmentId;
    title: string;
    description: string;
    interventionObjectiveType: InterventionObjectiveType;
    functionalAbilityCatalogId: string;
    currentFunctionalAbilityCatalogRating: number;
    expectedFunctionalAbilityCatalogRating: number;
    followUpDate?: Date | string | undefined;
    otherFunctionalAbilityCatalogIds?: string[] | undefined;
}

export enum InterventionObjectiveType {
    Develop = "develop",
    Maintain = "maintain",
    LimitLoss = "limitLoss",
}

export enum AssignmentStatusType {
    Draft = "draft",
    Current = "current",
    Historic = "historic",
}

export interface UpdateAssignmentModel {
    assignmentId: AssignmentId;
    backgroundInformation: UpdateBackgroundInformationModel;
    coordinationDetails: CoordinationDetailsModel;
    assessmentInformation: AssessmentInformationModel;
    commissionedIntervention: CommissionedInterventionModel;
    shareSupportAssessment?: boolean | undefined;
}

export interface UpdateBackgroundInformationModel {
    name: string;
    companyId: CompanyId;
    serviceProviderUnitId?: ServiceProviderUnitId | undefined;
    responsibleUserId?: UserId | undefined;
    responsibleTeamId?: TeamId | undefined;
    citizenMedicalDiagnoses?: string | undefined;
    citizenMedicalDiagnosesRichText?: string | undefined;
    specialInformationAboutCitizen?: string | undefined;
    specialInformationAboutCitizenRichText?: string | undefined;
    hasGuardian?: boolean | undefined;
    guardianType?: GuardianTypeModel | undefined;
    guardianDetails?: string | undefined;
    isRepresented?: boolean | undefined;
    representationType?: RepresentationTypeModel | undefined;
    powersOfAttorney?: string | undefined;
}

export interface UpdateInterventionObjectiveModel {
    interventionObjectiveId: InterventionObjectiveId;
    assignmentId: AssignmentId;
    title: string;
    description: string;
    interventionObjectiveType: InterventionObjectiveType;
    functionalAbilityCatalogId: string;
    currentFunctionalAbilityCatalogRating: number;
    expectedFunctionalAbilityCatalogRating: number;
    followUpDate?: Date | string | undefined;
    otherFunctionalAbilityCatalogIds?: string[] | undefined;
}

export interface UpsertPartialObjectivesModel {
    interventionObjectiveId: InterventionObjectiveId;
    partialObjectives: PartialObjectiveUpsertModel[];
}

export interface PartialObjectiveUpsertModel {
    id?: PartialObjectiveId | undefined;
    title: string;
    description: string;
    methodType?: string | undefined;
    rank?: number | undefined;
    status: PartialObjectiveStatusType;
    statusRemark: string;
    followups: PartialObjectiveFollowupUpsertModel[];
}

export interface PartialObjectiveId extends IdentifierOfGuid {
}

export enum PartialObjectiveStatusType {
    Current = "current",
    Completed = "completed",
    Cancelled = "cancelled",
}

export interface PartialObjectiveFollowupUpsertModel {
    id?: PartialObjectiveFollowupId | undefined;
    progression: number;
    description: string;
    eventDate: Date | string;
    methodType?: string | undefined;
}

export interface PartialObjectiveFollowupId extends IdentifierOfGuid {
}

export interface CreateAssessmentInterventionObjectiveModel {
    assessmentId: string;
    title: string;
    description: string;
    interventionObjectiveType: InterventionObjectiveType2;
    functionalAbilityCatalogId: string;
    currentFunctionalAbilityCatalogRating: number;
    expectedFunctionalAbilityCatalogRating: number;
    followUpDate?: Date | string | undefined;
    otherFunctionalAbilityCatalogIds?: string[] | undefined;
}

export enum InterventionObjectiveType2 {
    Develop = "develop",
    Maintain = "maintain",
    LimitLoss = "limitLoss",
}

export interface SupportAssessmentDto {
    id?: string | undefined;
    citizenId: string;
    caseId: string;
    createdOn?: Date | string | undefined;
    createdBy?: string | undefined;
    status: AssessmentStatusDto;
    physicalFunctions?: AssessmentConditionDto | undefined;
    mentalFunctions?: AssessmentConditionDto | undefined;
    socialConditions?: AssessmentConditionDto | undefined;
    healthConditions?: AssessmentConditionDto | undefined;
    surroundings?: AssessmentConditionDto | undefined;
    relations?: AssessmentRatingDto | undefined;
    societalLife?: AssessmentRatingDto | undefined;
    communication?: AssessmentRatingDto | undefined;
    practicalAssignments?: AssessmentRatingDto | undefined;
    selfCare?: AssessmentRatingDto | undefined;
    mobility?: AssessmentRatingDto | undefined;
    functionsAndConditionInfo?: string | undefined;
    functionsAndConditionInfoRichText?: string | undefined;
    surroundingsInfo?: string | undefined;
    surroundingsInfoRichText?: string | undefined;
    activityAndParticipationInfo?: string | undefined;
    activityAndParticipationInfoRichText?: string | undefined;
    openingCause?: OpeningCauseDto | undefined;
    hasOtherInquiries?: boolean | undefined;
    otherInquiriesInfo?: string | undefined;
    otherInquiriesInfoRichText?: string | undefined;
    hasConsent?: boolean | undefined;
    consentType?: ConsentTypeDto | undefined;
    hasGuardian?: boolean | undefined;
    guardianType?: GuardianTypeDto | undefined;
    guardianTypeInfo?: string | undefined;
    isRepresented?: boolean | undefined;
    representationType?: RepresentationTypeDto | undefined;
    hasSpecialConditions?: boolean | undefined;
    specialConditionInfo?: string | undefined;
    specialConditionInfoRichText?: string | undefined;
    hasNeedForCaseFiles?: boolean | undefined;
    hasInformedAboutConsequences?: boolean | undefined;
    consentAndCaseFilesNote?: string | undefined;
    consentAndCaseFilesNoteRichText?: string | undefined;
    guardianAssessmentNeeded?: boolean | undefined;
    representationInformed?: boolean | undefined;
    powerOfAttorneyInfo?: string | undefined;
    powerOfAttorneyInfoRichText?: string | undefined;
    informedAboutElectronicRegistration?: boolean | undefined;
    informedAboutSupportOptions?: boolean | undefined;
    isCitizenConsenting?: boolean | undefined;
    challengesAndNeedsInfo?: string | undefined;
    challengesAndNeedsInfoRichText?: string | undefined;
    hasDiagnoses?: boolean | undefined;
    diagnosesInfo?: string | undefined;
    diagnosesInfoRichText?: string | undefined;
    hasExistingDocumentation?: boolean | undefined;
    previousDiagnosesInfo?: string | undefined;
    previousDiagnosesInfoRichText?: string | undefined;
    citizenFutureAspirationsInfo?: string | undefined;
    citizenFutureAspirationsInfoRichText?: string | undefined;
    shouldConductAssessmentForSupport?: boolean | undefined;
    assessmentPurposeInfo?: string | undefined;
    assessmentPurposeInfoRichText?: string | undefined;
    agreementInfo?: string | undefined;
    agreementInfoRichText?: string | undefined;
    primaryAssessmentTopicId?: string | undefined;
    additionalAssessmentTopicIds?: string[] | undefined;
    assessmentSummary?: string | undefined;
    assessmentSummaryRichText?: string | undefined;
    citizenSupportNeedsAssessment?: string | undefined;
    citizenSupportNeedsAssessmentRichText?: string | undefined;
    reasonForDecision?: string | undefined;
    reasonForDecisionRichText?: string | undefined;
    hasCommunityResources?: boolean | undefined;
    communityResourceInfo?: string | undefined;
    communityResourceInfoRichText?: string | undefined;
    citizenPerspectiveInfo?: string | undefined;
    citizenPerspectiveInfoRichText?: string | undefined;
    citizenAssessmentResourceInfo?: string | undefined;
    citizenAssessmentResourceInfoRichText?: string | undefined;
    citizenAssessmentPurposeInfo?: string | undefined;
    citizenAssessmentPurposeInfoRichText?: string | undefined;
    overallGoalFollowUpDate?: Date | string | undefined;
    overallSupportNeedScore?: number | undefined;
    actionPlanOffered?: ActionPlanOfferResponseDto | undefined;
    actionPlanStatus?: ActionPlanPreparationStatusDto | undefined;
    actionPlanNote?: string | undefined;
    actionPlanNoteRichText?: string | undefined;
    holisticPlanOffered?: HolisticPlanOfferResponseDto | undefined;
    holisticPlanStatus?: HolisticPlanPreparationStatusDto | undefined;
}

export enum AssessmentStatusDto {
    UnderPreparation = "underPreparation",
    Completed = "completed",
    Draft = "draft",
    Current = "current",
    Historic = "historic",
}

export interface AssessmentConditionDto {
    mainQuestion?: boolean | undefined;
    secondaryQuestion?: boolean | undefined;
    citizenInfo?: string | undefined;
    citizenInfoRichText?: string | undefined;
    othersInfo?: string | undefined;
    othersInfoRichText?: string | undefined;
    caseworkerInfo?: string | undefined;
    caseworkerInfoRichText?: string | undefined;
    subThemes?: string[] | undefined;
}

export interface AssessmentRatingDto {
    mainQuestion?: boolean | undefined;
    secondaryQuestion?: boolean | undefined;
    citizenInfo?: string | undefined;
    citizenInfoRichText?: string | undefined;
    othersInfo?: string | undefined;
    othersInfoRichText?: string | undefined;
    caseworkerInfo?: string | undefined;
    caseworkerInfoRichText?: string | undefined;
    subThemeRatings?: SubThemeRatingDto[] | undefined;
}

export interface SubThemeRatingDto {
    functionalEventCatalogId: string;
    rating?: number | undefined;
    ratingComment?: string | undefined;
}

export enum OpeningCauseDto {
    Citizen = "citizen",
    Relative = "relative",
    Doctor = "doctor",
    Hospital = "hospital",
    OtherAdministration = "otherAdministration",
    OngoingEffort = "ongoingEffort",
    OtherMunicipality = "otherMunicipality",
    Others = "others",
    FollowUpOnOngoingCase = "followUpOnOngoingCase",
    InitiatedByOwnAccord = "initiatedByOwnAccord",
}

export enum ConsentTypeDto {
    Verbal = "verbal",
    Written = "written",
}

export enum GuardianTypeDto {
    Guardianship = "guardianship",
    GuardianshipWithRevokedLegalCapacity = "guardianshipWithRevokedLegalCapacity",
    JointGuardianship = "jointGuardianship",
}

export enum RepresentationTypeDto {
    AccompanyingPerson = "accompanyingPerson",
    AuthorizedRepresentative = "authorizedRepresentative",
}

export enum ActionPlanOfferResponseDto {
    OfferedAndWanted = "offeredAndWanted",
    OfferedButNotWanted = "offeredButNotWanted",
    NotOffered = "notOffered",
}

export enum ActionPlanPreparationStatusDto {
    Prepared = "prepared",
    InProgress = "inProgress",
    NotPrepared = "notPrepared",
}

export enum HolisticPlanOfferResponseDto {
    OfferedAndWanted = "offeredAndWanted",
    OfferedButNotWanted = "offeredButNotWanted",
    NotOffered = "notOffered",
}

export enum HolisticPlanPreparationStatusDto {
    Prepared = "prepared",
    InProgress = "inProgress",
    NotPrepared = "notPrepared",
}

export interface UpdateAssessmentInterventionObjectiveModel {
    id: string;
    assessmentId: string;
    title: string;
    description: string;
    functionalAbilityCatalogId: string;
    currentFunctionalAbilityCatalogRating: number;
    expectedFunctionalAbilityCatalogRating: number;
    followUpDate?: Date | string | undefined;
    otherFunctionalAbilityCatalogIds?: string[] | undefined;
}

export interface AgendaPointInputModel {
    id?: string | undefined;
    text?: string | undefined;
    isGenerated: boolean;
    references?: AgendaReferenceModel[] | undefined;
}

export interface AgendaReferenceModel {
    label: string;
    entityName: string;
    entityId: string;
}

export interface CitizenAttendanceRegistrationId {
    citizenId: string;
    attendanceRegistrationId: string;
}

export interface CreateAttendanceRegistrationDto {
    lessonId: string;
    courseEnrollmentId: string;
    citizenId: string;
    status: AttendanceStateDto;
    attendanceRegistrationType: AttendanceRegistrationTypeDto;
    checkInTime?: Date | string | undefined;
    commentText?: string | undefined;
}

export enum AttendanceStateDto {
    OnTime = "onTime",
    NotOnTime = "notOnTime",
    NotShown = "notShown",
    NotRelevant = "notRelevant",
    AbsenceWithReason = "absenceWithReason",
}

export enum AttendanceRegistrationTypeDto {
    Start = "start",
    End = "end",
}

export interface NoShowRegistrationDto {
    citizenId: string;
    attendanceRegistrationId: string;
    status: AttendanceStateDto;
    attendanceRegistrationType: AttendanceRegistrationTypeDto;
}

export interface AttendanceRegistrationDto {
    attendanceRegistrationId: string;
    lessonId: string;
    courseEnrollmentId: string;
    citizenId: string;
    checkInTime?: Date | string | undefined;
    status: AttendanceStateDto;
    attendanceRegistrationType: AttendanceRegistrationTypeDto;
    commentText?: string | undefined;
    isDeleted: boolean;
}

export interface SkippedCourse {
    courseId: string;
    courseName: string;
    reason: string;
}

export interface SkippedLesson {
    lessonId: string;
    lessonName: string;
    reason: string;
}

export interface AttendanceValidationError {
    cpr: string;
    citizenName: string;
    errorMessage: string;
}

export interface CitizenAttendanceDto {
    cpr: string;
    citizenName: string;
    contactPerson: string;
    courseNumber: string;
    jobcenterCode: string;
    dailyAttendances: DailyAttendanceDto[];
    totalOfferedLessons: number;
    totalAbsentLessons: number;
    absencePercentage: number;
}

export interface DailyAttendanceDto {
    attendanceDate: string;
    offeredLessons: number;
    absentLessons: number;
    absenceReason: string;
}

export interface CreateLessonDeviationDto {
    courseEnrollmentId: string;
    lessonId: string;
    citizenId: string;
    beginAt?: Date | string | undefined;
    endAt?: Date | string | undefined;
    isExemptFromLesson: boolean;
    comment?: string | undefined;
    startCheck: boolean;
    endCheck: boolean;
}

export enum ScheduleDisplayMode {
    Day = "day",
    Week = "week",
    Month = "month",
    List = "list",
    WeekScheme = "weekScheme",
}

export interface CreateClassroomDto {
    companyId: string;
    name: string;
    isDeleted: boolean;
    isActive: boolean;
}

export interface CreateCourseDto {
    companyId: string;
    offerId?: string | undefined;
    responsibleCaseworkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
    educatorIds: string[];
    classroomId?: string | undefined;
    name: string;
    description?: string | undefined;
    capacity?: number | undefined;
    earliestArrivalOnTimeBeforeStart?: number | undefined;
    latestArrivalOnTimeAfterStart?: number | undefined;
    latestAttendanceRegistrationAfterStart?: number | undefined;
    earliestDepartureRegistrationBeforeEnd?: number | undefined;
    earliestDepartureOnTimeBeforeEnd?: number | undefined;
    latestDepartureOnTimeAfterEnd?: number | undefined;
    createNegativeEventOnMissingAttendance: boolean;
    createFollowUpAdvisOnMissingAttendance: boolean;
    createAdvisIfNotOnTime: boolean;
    hasDutyToWork: boolean;
    requiresAttendanceApproval: boolean;
    desiredReportType: ReportType;
    isCompleted: boolean;
    isDeleted: boolean;
}

export enum ReportType {
    Never = "never",
    Monthly = "monthly",
    Weekly = "weekly",
}

export interface CreateCourseEnrollmentDto {
    courseId: string;
    citizenId: string;
    caseId: string;
    beginAt: Date | string;
    endAt: Date | string;
    isActive: boolean;
    activityId?: string | undefined;
    followDfdgActivityPeriod: boolean;
    createNegativeEventOnMissingAttendance: boolean;
    createFollowUpAdvisOnMissingAttendance: boolean;
    createAdvisIfNotOnTime: boolean;
    hasDutyToWork: boolean;
    desiredReportType: ReportType;
    isDeleted: boolean;
}

export interface CitizenActivity {
    citizenId: string;
    activityId?: string | undefined;
    errorText?: string | undefined;
}

export interface CreateEducatorDto {
    companyId: string;
    caseworkerId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    isDeleted: boolean;
}

export interface CreateLessonDto {
    courseId: string;
    classroomId?: string | undefined;
    educatorIds: string[];
    beginAt: Date | string;
    endAt: Date | string;
    isReoccuringLesson: boolean;
    earliestArrivalOnTimeBeforeStart?: Date | string | undefined;
    latestArrivalOnTimeAfterStart?: Date | string | undefined;
    latestAttendanceRegistrationAfterStart?: Date | string | undefined;
    earliestDepartureRegistrationBeforeEnd?: Date | string | undefined;
    earliestDepartureOnTimeBeforeEnd?: Date | string | undefined;
    latestDepartureOnTimeAfterEnd?: Date | string | undefined;
    groupId?: string | undefined;
    isSubmitted: boolean;
    attendanceSubmittedOn?: Date | string | undefined;
    attendanceSubmittedBy?: string | undefined;
    isDeleted: boolean;
    lessonState: LessonStateDto;
}

export enum LessonStateDto {
    Draft = "draft",
    Published = "published",
    Cancelled = "cancelled",
}

export interface CreateRegistrationCounterDto {
    name: string;
    companyId: string;
    externalReference?: string | undefined;
}

export interface CitizenLessonDeviationDto {
    citizenLessonDeviationId: string;
    courseEnrollmentId: string;
    lessonId: string;
    citizenId: string;
    beginAt?: Date | string | undefined;
    endAt?: Date | string | undefined;
    isExemptFromLesson: boolean;
    isDeleted: boolean;
    comment?: string | undefined;
    startCheck: boolean;
    endCheck: boolean;
}

export interface ClassroomDto {
    classroomId: string;
    companyId: string;
    name: string;
    isDeleted: boolean;
    isActive: boolean;
}

export interface CourseDto {
    courseId: string;
    companyId: string;
    offerId?: string | undefined;
    responsibleCaseworkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
    educatorIds: string[];
    classroomId?: string | undefined;
    name: string;
    description?: string | undefined;
    capacity?: number | undefined;
    earliestArrivalOnTimeBeforeStart?: number | undefined;
    latestArrivalOnTimeAfterStart?: number | undefined;
    latestAttendanceRegistrationAfterStart?: number | undefined;
    earliestDepartureRegistrationBeforeEnd?: number | undefined;
    earliestDepartureOnTimeBeforeEnd?: number | undefined;
    latestDepartureOnTimeAfterEnd?: number | undefined;
    createNegativeEventOnMissingAttendance: boolean;
    createFollowUpAdvisOnMissingAttendance: boolean;
    createAdvisIfNotOnTime: boolean;
    hasDutyToWork: boolean;
    requiresAttendanceApproval: boolean;
    desiredReportType: ReportType;
    isCompleted: boolean;
    isDeleted: boolean;
}

export interface CourseEnrollmentDto {
    courseEnrollmentId: string;
    courseId: string;
    citizenId: string;
    caseId: string;
    beginAt: Date | string;
    endAt: Date | string;
    isActive: boolean;
    activityId?: string | undefined;
    followDfdgActivityPeriod: boolean;
    createNegativeEventOnMissingAttendance: boolean;
    createFollowUpAdvisOnMissingAttendance: boolean;
    createAdvisIfNotOnTime: boolean;
    hasDutyToWork: boolean;
    desiredReportType: ReportType;
    isDeleted: boolean;
}

export interface EducatorDto {
    educatorId: string;
    companyId: string;
    caseworkerId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    isDeleted: boolean;
    isDeviceEnrolled: boolean;
    hasPendingActivationKey: boolean;
    activationKeyGeneratedOn?: Date | string | undefined;
    activationKeyGeneratedBy?: string | undefined;
    activationKeyExpiresAt?: Date | string | undefined;
    deviceEnrolledOn?: Date | string | undefined;
}

export interface LessonDto {
    lessonId: string;
    courseId: string;
    classroomId?: string | undefined;
    educatorIds: string[];
    beginAt: Date | string;
    endAt: Date | string;
    isReoccuringLesson: boolean;
    earliestArrivalOnTimeBeforeStart?: Date | string | undefined;
    latestArrivalOnTimeAfterStart?: Date | string | undefined;
    latestAttendanceRegistrationAfterStart?: Date | string | undefined;
    earliestDepartureRegistrationBeforeEnd?: Date | string | undefined;
    earliestDepartureOnTimeBeforeEnd?: Date | string | undefined;
    latestDepartureOnTimeAfterEnd?: Date | string | undefined;
    groupId?: string | undefined;
    isSubmitted: boolean;
    attendanceSheetState: AttendanceSheetStateDto;
    attendanceSubmittedOn?: Date | string | undefined;
    attendanceSubmittedBy?: string | undefined;
    isDeleted: boolean;
    capacity?: number | undefined;
    occupiedSeats: number;
    educatorNames?: string[] | undefined;
    lessonState: LessonStateDto;
}

export enum AttendanceSheetStateDto {
    Open = "open",
    Submitted = "submitted",
    ReadyForApproval = "readyForApproval",
}

export interface RegistrationCounterDto {
    registrationCounterId: string;
    name: string;
    companyId: string;
    externalReference?: string | undefined;
}

export interface CreateUserChatMessageDto {
    id?: string | undefined;
    question?: string | undefined;
    response?: string | undefined;
    vote?: Vote | undefined;
    qualityComment?: string | undefined;
}

export enum Vote {
    Unknown = "unknown",
    Bad = "bad",
    Good = "good",
}

export interface DeletionStepResult {
    sourceSystem: SourceSystem;
    status: DeletionStepStatus;
    affectedCount: number;
    successfulOperations?: string[] | undefined;
    warnings?: string[] | undefined;
    failedOperations?: string[] | undefined;
}

export enum SourceSystem {
    DocumentContentStore = "documentContentStore",
    DocumentArchive = "documentArchive",
    ElasticsearchWorklist = "elasticsearchWorklist",
    ElasticsearchChangeLog = "elasticsearchChangeLog",
    FasitApex = "fasitApex",
    FasitClassic = "fasitClassic",
    Forum = "forum",
}

export enum DeletionStepStatus {
    Succeeded = "succeeded",
    SucceededWithWarnings = "succeededWithWarnings",
    Failed = "failed",
    NotEnabled = "notEnabled",
    NotAttempted = "notAttempted",
}

export interface AuditLogQueryRequest {
    from?: Date | string | undefined;
    to?: Date | string | undefined;
    operations?: AuditLogOperation[] | undefined;
    areas?: AuditLogArea[] | undefined;
    userId?: string[] | undefined;
    cpr?: string[] | undefined;
    citizenId?: string[] | undefined;
    organizationalUnitId?: string[] | undefined;
    teamId?: string[] | undefined;
    message?: string | undefined;
    citizenAccessJustification?: string | undefined;
    rows: number;
    sortColumns?: SortColumn[] | undefined;
}

export enum AuditLogOperation {
    None = "none",
    Login = "login",
    Create = "create",
    Update = "update",
    Delete = "delete",
    View = "view",
    Query = "query",
    Extract = "extract",
    Unauthorized = "unauthorized",
    Session = "session",
}

export enum AuditLogArea {
    None = "none",
    AuditLog = "auditLog",
    ChangeLog = "changeLog",
    Communication = "communication",
    UnemploymentFund = "unemploymentFund",
    Interview = "interview",
    Outbox = "outbox",
    Company = "company",
    Search = "search",
    Cv = "cv",
    InterviewPreparation = "interviewPreparation",
    Journal = "journal",
    FasitSearch = "fasitSearch",
    OfferAndActivity = "offerAndActivity",
    TransactionLog = "transactionLog",
    CitizenDetail = "citizenDetail",
    Citizen = "citizen",
    CitizenDeletion = "citizenDeletion",
    Case = "case",
    Ruling = "ruling",
    Diary = "diary",
    Document = "document",
    Availability = "availability",
    SocialIntegration = "socialIntegration",
    HealthLimitation = "healthLimitation",
    NegativeEvents = "negativeEvents",
    PlanAndActivities = "planAndActivities",
    Assessments = "assessments",
    Absences = "absences",
    ContactPerson = "contactPerson",
    CitizenTask = "citizenTask",
    AsylumAndIntegration = "asylumAndIntegration",
    AssociatedCaseWorker = "associatedCaseWorker",
    BenefitExtensionAssessment = "benefitExtensionAssessment",
    ExternalOperator = "externalOperator",
    CitizenDialog = "citizenDialog",
    CompanyRecruitment = "companyRecruitment",
    Course = "course",
    Lesson = "lesson",
    ClassRoom = "classRoom",
    RegistrationCounter = "registrationCounter",
    Educator = "educator",
    CourseEnrollment = "courseEnrollment",
    SocialCases = "socialCases",
    AiSearch = "aiSearch",
    Grants = "grants",
    Assignments = "assignments",
    SupportAssessments = "supportAssessments",
    Screenings = "screenings",
    CitizenPortal = "citizenPortal",
    PartialObjective = "partialObjective",
    Progression = "progression",
    ForumSurveys = "forumSurveys",
    CitizenIncome = "citizenIncome",
    CoPayment = "coPayment",
    ImportedAttendance = "importedAttendance",
    AttendanceProtocol = "attendanceProtocol",
    Forum = "forum",
}

export interface SortColumn {
    id: string;
    desc?: boolean | undefined;
}

export interface VisitationTeamDetails {
    id: string;
    teamId: string;
    description?: string | undefined;
    isActive: boolean;
    rules: VisitationTeamRulesModel;
    grantTypes: VisitationTeamGrantTypeModel[];
    schedules: VisitationScheduleModel[];
    nextMeetingStartAt?: Date | string | undefined;
    team?: VisitationTeamOrganizationInfo | undefined;
}

export interface VisitationTeamRulesModel {
    breakMinutesBetweenCases: number;
    bookingDeadlineWorkdays: number;
    bookingHorizonWeeks: number;
    allowOverbooking: boolean;
    allowLaterTimeChoice: boolean;
}

export interface VisitationTeamGrantTypeModel {
    grantTypeId: string;
    name?: string | undefined;
    standardMinutes: number;
}

export interface VisitationScheduleModel {
    id?: string | undefined;
    firstDate: Date | string;
    startTime: string;
    endTime: string;
    recurrence?: RecurrencePatternModel | undefined;
    excludedDates: Date | string[];
    location?: string | undefined;
}

export interface VisitationTeamOrganizationInfo {
    name: string;
    mainTeamName?: string | undefined;
    address?: string | undefined;
    attendanceAddress?: string | undefined;
    attendanceRoom?: string | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    members: VisitationTeamMember[];
}

export interface VisitationTeamMember {
    userId: string;
    fullName?: string | undefined;
    jobTitle?: string | undefined;
    isActive: boolean;
}

export interface UserProfileCreateModel {
    adGroup?: string | undefined;
    displayName?: string | undefined;
    roles?: UserProfileRoleViewModel[] | undefined;
}

export interface UserProfileRoleViewModel {
    roleDisplayName?: string | undefined;
    roleValue?: string | undefined;
    enabled: boolean;
}

export interface UserProfileUpdateModel {
    id: string;
    adGroup?: string | undefined;
    displayName?: string | undefined;
    roles?: UserProfileRoleViewModel[] | undefined;
}

export interface QuestionnaireDetails {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    citizenName?: string | undefined;
    citizenDescription?: string | undefined;
    welcomeText?: string | undefined;
    surveyValidForDays: number;
    minimumDaysBetweenSurveys: number;
    minimumDaysBetweenReminders: number;
    reminderDays?: number | undefined;
    questionnaireType?: QuestionnaireTypeViewModel | undefined;
    pseudoFasitEntityDiscriminator?: PseudoFasitEntityDiscriminatorViewModel | undefined;
    questions?: Question[] | undefined;
    isActive: boolean;
}

export interface QuestionnaireTypeViewModel {
    enumValue: QuestionnaireTypeEnum;
    text?: string | undefined;
    viewText?: string | undefined;
}

export enum QuestionnaireTypeEnum {
    Survey = "survey",
    JournalizedResponse = "journalizedResponse",
}

export interface PseudoFasitEntityDiscriminatorViewModel {
    enumValue: PseudoFasitEntityDiscriminatorEnum;
    text?: string | undefined;
    viewText?: string | undefined;
}

export interface Question {
    id: string;
    questionType?: QuestionTypeViewModel | undefined;
    rank: number;
    label?: string | undefined;
    required: boolean;
    showInDiagram: boolean;
    countInAverage: boolean;
    yesNoLayout?: YesNoLayoutViewModel | undefined;
    options?: QuestionOptionViewModel[] | undefined;
}

export interface QuestionTypeViewModel {
    enumValue: QuestionTypeEnum;
    text?: string | undefined;
    viewText?: string | undefined;
}

export enum QuestionTypeEnum {
    Rating = "rating",
    TextField = "textField",
    YesNo = "yesNo",
    RadioButton = "radioButton",
    RatingRadioButton = "ratingRadioButton",
}

export interface YesNoLayoutViewModel {
    enumValue: YesNoLayoutEnum;
    text?: string | undefined;
    viewText?: string | undefined;
}

export enum YesNoLayoutEnum {
    Thumbs = "thumbs",
    Smiley = "smiley",
    YesNo = "yesNo",
}

export interface QuestionOptionViewModel {
    rank: number;
    label?: string | undefined;
}

export interface SubJobcenterClosedDayModel {
    date: Date | string;
    name?: string | undefined;
    appliesTo?: ClosedDayAppliesTo[] | undefined;
}

export enum ClosedDayAppliesTo {
    None = "none",
    Attendance = "attendance",
}

export interface ObservationTypeCreateModel {
    name?: string | undefined;
    description?: string | undefined;
    category: ObservationCategory;
    dataType: ObservationDataType;
    unit?: string | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    reflectionFieldMode: ObservationFieldMode;
    timeFieldMode: ObservationFieldMode;
    standardTexts?: string[] | undefined;
    serviceProviderUnitIds?: string[] | undefined;
    isActive: boolean;
}

export enum ObservationCategory {
    General = "general",
    Social = "social",
    Health = "health",
}

export enum ObservationDataType {
    Integer = "integer",
    Boolean = "boolean",
    Text = "text",
    Decimal = "decimal",
    StandardTextDropdown = "standardTextDropdown",
}

export enum ObservationFieldMode {
    Hide = "hide",
    ShowOptional = "showOptional",
    ShowMandatory = "showMandatory",
}

export interface ObservationTypeUpdateModel {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    category: ObservationCategory;
    dataType: ObservationDataType;
    unit?: string | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    reflectionFieldMode: ObservationFieldMode;
    timeFieldMode: ObservationFieldMode;
    standardTexts?: string[] | undefined;
    serviceProviderUnitIds?: string[] | undefined;
    isActive: boolean;
}

export interface MethodTypeCreateModel {
    name?: string | undefined;
    isActive: boolean;
    description?: string | undefined;
    abbreviation?: string | undefined;
    classification?: string | undefined;
    classificationCode?: string | undefined;
}

export interface MethodTypeUpdateModel {
    id: string;
    name?: string | undefined;
    isActive: boolean;
    description?: string | undefined;
    abbreviation?: string | undefined;
    classification?: string | undefined;
    classificationCode?: string | undefined;
}

export interface JournalNoteContentTypeCreateModelV3 {
    name: string;
    isActive: boolean;
    noteTypes: JournalNoteContentTypeNoteType[];
    applicableToJournalNoteOptics?: string[] | undefined;
    municipalitySpecific?: boolean | undefined;
}

export enum JournalNoteContentTypeNoteType {
    Journal = "journal",
    Diary = "diary",
}

export interface JournalNoteContentTypeUpdateModelV3 {
    journalNoteContentTypeId: string;
    name: string;
    code?: number | undefined;
    isActive: boolean;
    noteTypes: JournalNoteContentTypeNoteType[];
    applicableToJournalNoteOptics?: string[] | undefined;
    municipalitySpecific?: boolean | undefined;
}

export interface InterviewTypeCreateModel {
    name?: string | undefined;
    isActive: boolean;
    description?: string | undefined;
    templateMappingName?: string | undefined;
    reportAsDfdgSamtaleTypeCode?: number | undefined;
    journalNoteContentTypeId?: string | undefined;
    caseTypeIds?: string[] | undefined;
}

export interface InterviewTypeUpdateModel {
    id: string;
    name?: string | undefined;
    isActive: boolean;
    description?: string | undefined;
    templateMappingName?: string | undefined;
    journalNoteContentTypeId?: string | undefined;
    caseTypeIds?: string[] | undefined;
}

export interface GrantTypeDetails {
    grantTypeId: string;
    isActive: boolean;
    name?: string | undefined;
    description?: string | undefined;
    category?: GrantTypeCategoryViewModel | undefined;
    reportAs?: GrantTypeReportAsViewModel | undefined;
    benefitTypes?: GrantTypeBenefitTypeViewModel[] | undefined;
    socialOffer?: GrantTypeSocialOfferFFBViewModel | undefined;
    offers?: GrantTypeOfferListViewItem[] | undefined;
    offerSelectionMode?: OfferSelectionModeViewModel | undefined;
    isMandatoryOfferSelection?: boolean | undefined;
    isMandatoryPriceCalculation?: boolean | undefined;
    displayName?: string | undefined;
    processingDeadlineDays?: number | undefined;
    lawReference?: GrantTypeLawReferenceViewModel | undefined;
    paragraph?: string | undefined;
    subsection?: number | undefined;
    articleNumber?: number | undefined;
    requiresHearing?: boolean | undefined;
    requiresAssessment?: boolean | undefined;
    canBeGrantedByServiceProvider?: boolean | undefined;
}

export interface GrantTypeCategoryViewModel {
    value: GrantTypeCategory;
    text?: string | undefined;
    viewText?: string | undefined;
}

export enum GrantTypeCategory {
    Social = "social",
    Employment = "employment",
}

export interface GrantTypeReportAsViewModel {
    value: GrantTypeReportAs;
    text?: string | undefined;
    viewText?: string | undefined;
}

export enum GrantTypeReportAs {
    Manual = "manual",
    SocialFFB = "socialFFB",
    SocialDST = "socialDST",
}

export interface GrantTypeBenefitTypeViewModel {
    value: string;
    viewText?: string | undefined;
}

export interface GrantTypeSocialOfferFFBViewModel {
    value: string;
    viewText?: string | undefined;
}

export interface GrantTypeOfferListViewItem {
    grantTypeOfferId?: string | undefined;
    offerId: string;
    offerNumber?: number | undefined;
    title?: string | undefined;
    type?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    companyName?: string | undefined;
    contactPerson?: string | undefined;
    availableSeats?: number | undefined;
    firstAvailableDate?: Date | string | undefined;
}

export interface OfferSelectionModeViewModel {
    value: OfferSelectionMode;
    text?: string | undefined;
    viewText?: string | undefined;
}

export enum OfferSelectionMode {
    AllOffers = "allOffers",
    ListOnly = "listOnly",
}

export interface GrantTypeLawReferenceViewModel {
    value?: string | undefined;
    displayName?: string | undefined;
}

export interface AdminCoPaymentDebitorRunModel {
    id: string;
    runTimestamp: Date | string;
    createdBy: string;
    createdByName?: string | undefined;
    citizenCount: number;
    rowCount: number;
    coPaymentDebitorRunDispatchStatus: CoPaymentDebitorRunDispatchStatus;
    debitorRunDispatchStatusTimestamp?: Date | string | undefined;
    receivables?: AdminCoPaymentReceivableModel[] | undefined;
    downwardAdjustments?: AdminCoPaymentDownwardAdjustmentModel[] | undefined;
    debitorRegistrationTransactions?: { [key: string]: AdminDebitorRegistrationTransactionModel[]; } | undefined;
    coPaymentInformation?: { [key: string]: AdminCoPaymentModel; } | undefined;
    processingInstructions?: { [key: string]: string; } | undefined;
}

export enum CoPaymentDebitorRunDispatchStatus {
    NotDispatched = "notDispatched",
    DispatchingInProgress = "dispatchingInProgress",
    DispatchingDone = "dispatchingDone",
    DispatchedWithFailures = "dispatchedWithFailures",
    NoDispatchNeeded = "noDispatchNeeded",
}

export interface AdminCoPaymentReceivableModel {
    id: string;
    coPaymentId: string;
    receivableIdentifier?: string | undefined;
    psrmReceivableType?: PsrmReceivableType | undefined;
    coPaymentDebitorRunId: string;
    activityId: string;
    cprNumber?: string | undefined;
    citizenName?: string | undefined;
    coPaymentTypeId: string;
    template: CoPaymentTemplate;
    startDate: Date | string;
    endDate: Date | string;
    month?: string | undefined;
    billableFrom: Date | string;
    billingType: BillingType;
    billingPrinciple?: BillingPrinciple | undefined;
    financeStatus?: FinanceDocumentStatus | undefined;
    totalMonthlyCoPayment: number;
    firstBillingAdjustment?: number | undefined;
    lastBillingAdjustment?: number | undefined;
    originationDate?: Date | string | undefined;
    dueDate?: Date | string | undefined;
    description?: string | undefined;
    accountNumber?: string | undefined;
    dispatchState: CoPaymentReceivableDispatchState;
    hasDownwardAdjustment: boolean;
    rowType: CoPaymentListRowType;
    adjustedReceivableId?: string | undefined;
}

export enum PsrmReceivableType {
    Kfbomse = "kfbomse",
    Kfbotlo = "kfbotlo",
    Kfevlbo = "kfevlbo",
    Kfregev = "kfregev",
    Kfbotmo = "kfbotmo",
    Kfybocf = "kfybocf",
    Kfebefv = "kfebefv",
    Kfebhuv = "kfebhuv",
    Kfmaphp = "kfmaphp",
    Kftakfy = "kftakfy",
    Kftilse = "kftilse",
    Kfbpatb = "kfbpatb",
    Kfetand = "kfetand",
}

export enum CoPaymentTemplate {
    Simple = "simple",
    Paragraph108 = "paragraph108",
    DailyPayment = "dailyPayment",
    Paragraph107 = "paragraph107",
}

export enum FinanceDocumentStatus {
    Generated = "generated",
    Sent = "sent",
    TransportFailed = "transportFailed",
    UnderProcessing = "underProcessing",
    Accepted = "accepted",
    Rejected = "rejected",
}

export enum CoPaymentReceivableDispatchState {
    Ready = "ready",
    Future = "future",
    Failed = "failed",
    BeingDispatched = "beingDispatched",
    Dispatched = "dispatched",
}

export enum CoPaymentListRowType {
    Receivable = "receivable",
    DownwardAdjustment = "downwardAdjustment",
}

export interface AdminCoPaymentDownwardAdjustmentModel {
    id: string;
    coPaymentId: string;
    correctedByCoPaymentId?: string | undefined;
    adjustedReceivableId: string;
    adjustedReceivableIdentifier: string;
    activityId: string;
    month?: string | undefined;
    amount: number;
    cprNumber?: string | undefined;
    citizenName?: string | undefined;
    template?: CoPaymentTemplate | undefined;
}

export interface AdminDebitorRegistrationTransactionModel {
    id: string;
    transactionIdentifier: string;
    status: DebitorRegistrationTransactionStatus;
    errorMessage?: string | undefined;
    statusTimestamp: Date | string;
    processingXml?: string | undefined;
}

export enum DebitorRegistrationTransactionStatus {
    Pending = "pending",
    DispatchSuccessful = "dispatchSuccessful",
    DispatchFailed = "dispatchFailed",
}

export interface AdminCoPaymentModel {
    citizenId: string;
    cprNumber?: string | undefined;
    citizenName?: string | undefined;
    coPaymentTypeId: string;
    template: CoPaymentTemplate;
    billingType: BillingType;
    billingPrinciple?: BillingPrinciple | undefined;
    description?: string | undefined;
    accountNumber?: string | undefined;
}

export interface FinanceTestReceiptSpec {
    kind: FinanceTestReceiptKind;
    transportFailure?: FinanceTestReceiptReasonDto | undefined;
    deliveryRejection?: FinanceTestReceiptReasonDto | undefined;
    documents?: FinanceTestDocumentReceiptDto[] | undefined;
}

export enum FinanceTestReceiptKind {
    Transport = "transport",
    Business = "business",
}

export interface FinanceTestReceiptReasonDto {
    reasonCode: string;
    text?: string | undefined;
}

export interface FinanceTestDocumentReceiptDto {
    financeDocumentId: string;
    result: FinanceTestReceiptResult;
    rejection?: FinanceTestReceiptReasonDto | undefined;
    entries?: FinanceTestEntryReceiptDto[] | undefined;
}

export enum FinanceTestReceiptResult {
    Accepted = "accepted",
    Rejected = "rejected",
    UnderProcessing = "underProcessing",
}

export interface FinanceTestEntryReceiptDto {
    ledgerEntryId: string;
    result: FinanceTestReceiptResult;
    rejection?: FinanceTestReceiptReasonDto | undefined;
    localErrorCode?: string | undefined;
    localErrorText?: string | undefined;
}

export interface ProcessingInstructionInput {
    coPaymentId: string;
    processingXml?: string | undefined;
}

export enum AiStandardQuestionStatus {
    Active = "active",
    Draft = "draft",
    Inactive = "inactive",
}

export interface AccountGroupModel {
    accountGroupId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface AccountInteractionPurposeModel {
    accountInteractionPurposeId?: string | undefined;
    name?: string | undefined;
    contactSubjectFVDB?: string | undefined;
    isActive: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface AccountInteractionResultModel {
    accountInteractionResultId?: string | undefined;
    name?: string | undefined;
    isActive: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface AccountSpecialCircumstancesTypeModel {
    accountSpecialCircumstancesTypeId?: string | undefined;
    name?: string | undefined;
    isActive: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface AccountTagTypeModel {
    accountTagTypeId?: string | undefined;
    name?: string | undefined;
    isActive: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface AdminAbsenceTypeModel {
    absenceTypeId?: string | undefined;
    name?: string | undefined;
    createNotification?: boolean | undefined;
    description?: string | undefined;
    endDate?: Date | string | undefined;
    endDateNoOfDaysInPast?: number | undefined;
    externalIdentifier?: string | undefined;
    isEndDateRequired?: boolean | undefined;
    kmdActiveDescription?: string | undefined;
    kmdActiveExternalIdentifier?: string | undefined;
    maximumDurationInDays?: number | undefined;
    startDate?: Date | string | undefined;
    startDateNoOfDaysInPast?: number | undefined;
    stateOnChangeToSicknessBenefit?: StateOnChangeToSicknessBenefit | undefined;
    absenceTypeCode?: string | undefined;
    jobcenterSpecificAbsenceType?: boolean | undefined;
    isActive: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export enum StateOnChangeToSicknessBenefit {
    MustBeStopped = "mustBeStopped",
    MadeInactive = "madeInactive",
    NoChange = "noChange",
}

export interface AdminCaseTypeModel {
    caseTypeId: string;
    name?: string | undefined;
    canGetBasicSubsidyAsUnaccompaniedFugitive?: boolean | undefined;
    createFirstMatchTask?: boolean | undefined;
    description?: string | undefined;
    eventFacet?: string | undefined;
    kleNumber?: string | undefined;
    maximumDaysToReopen?: number | undefined;
    targetGroupId?: string | undefined;
    targetGroupName?: string | undefined;
    reportAs?: ReportCaseAs | undefined;
    closingTimeLimit?: number | undefined;
    automaticInformationLetterTemplateCode?: string | undefined;
    stsClassification?: string | undefined;
    kleClassId?: string | undefined;
    isActive: boolean;
    createdBy: string;
    createdByName?: string | undefined;
    createdOn: Date | string;
    modifiedBy: string;
    modifiedByName?: string | undefined;
    modifiedOn?: Date | string | undefined;
    caseContactReasonListItems?: CaseContactReasonListItemModel[] | undefined;
    caseClosureReasonListItems?: CaseClosureReasonListItemModel[] | undefined;
    caseGroupListItems?: CaseGroupListItemModel[] | undefined;
}

export enum ReportCaseAs {
    RehabiliteRehabCaseToDfdg = "rehabiliteRehabCaseToDfdg",
    SocialCaseToDS = "socialCaseToDS",
}

export interface CaseContactReasonListItemModel {
    caseContactReasonId?: string | undefined;
    name?: string | undefined;
}

export interface CaseClosureReasonListItemModel {
    caseClosureReasonId?: string | undefined;
    name?: string | undefined;
}

export interface CaseGroupListItemModel {
    caseGroupId?: string | undefined;
    name?: string | undefined;
}

export interface AdminPlanTypeModel {
    planTypeId: string;
    name?: string | undefined;
    active?: boolean | undefined;
    goalAMU?: boolean | undefined;
    goalDiscoAms08?: boolean | undefined;
    goalDUN?: boolean | undefined;
    goalFreeText?: boolean | undefined;
    isGoalMandatory?: boolean | undefined;
    planTypeType?: PlanTypeEnum | undefined;
    sendToDFDG?: boolean | undefined;
    dfdgPlanTypeId?: string | undefined;
    templateCode?: string | undefined;
    alternativHeadlineForPlanDescription?: string | undefined;
    showFollowupDate?: boolean | undefined;
    showGoalsForPlan?: boolean | undefined;
    goalDiscoOccupationArea?: boolean | undefined;
    goalDiscoOccupationGroup?: boolean | undefined;
    showContentTemplateMappingId?: boolean | undefined;
    showPlanDescription?: boolean | undefined;
    targetGroupIds?: string[] | undefined;
    isActive: boolean;
    createdBy: string;
    createdByName?: string | undefined;
    createdOn: Date | string;
    modifiedBy: string;
    modifiedByName?: string | undefined;
    modifiedOn?: Date | string | undefined;
    dfdgPlanTypeName?: string | undefined;
}

export enum PlanTypeEnum {
    Basic = "basic",
    Education = "education",
}

export interface AiStandardQuestionModel {
    id?: string | undefined;
    name?: string | undefined;
    topic?: string | undefined;
    area: AiStandardQuestionArea;
    question?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedOn?: Date | string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    isActive: boolean;
    status?: AiStandardQuestionStatus | undefined;
}

export enum AiStandardQuestionArea {
    CitizenAssistant = "citizenAssistant",
    FasitAssistant = "fasitAssistant",
}

export interface AssociateUserRoleModel {
    associateUserRoleId?: string | undefined;
    name?: string | undefined;
    isActive?: boolean | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface CaseClosureReasonModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
    removalCauseTypeIds?: string[] | undefined;
    caseTypeListItems?: CaseTypeListItemModel[] | undefined;
}

export interface CaseTypeListItemModel {
    caseTypeId?: string | undefined;
    name?: string | undefined;
}

export interface CaseContactReasonModel {
    caseContactReasonId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
    caseTypeListItems?: CaseTypeListItemModel[] | undefined;
}

export interface CaseGroupModel {
    caseGroupId?: string | undefined;
    name?: string | undefined;
    isActive: boolean;
    description?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
    caseTypeListItems?: CaseTypeListItemModel[] | undefined;
}

export interface AdminCaseRestrictionModel {
    id?: string | undefined;
    name?: string | undefined;
    caseRestrictionFKAId?: string | undefined;
    isActive: boolean;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedOn?: Date | string | undefined;
}

export interface ClosureCauseModel {
    closureCauseId?: string | undefined;
    name?: string | undefined;
    isActive: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface AdminCoPaymentTypeModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
    coPaymentTemplate: CoPaymentTemplate;
    accountNumber?: string | undefined;
    helpText?: string | undefined;
    defaultBillingType: BillingType;
    defaultBillingPrinciple?: BillingPrinciple | undefined;
    offerTypeIds?: string[] | undefined;
    dailyRate?: number | undefined;
    documentTemplateCode?: string | undefined;
    psrmReceivableType?: PsrmReceivableType | undefined;
    debitorAccountTypeId?: string | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedOn?: Date | string | undefined;
}

export interface ExternalOperatorResponsibilityAreaModel {
    responsibilityAreaId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    createdOn?: Date | string | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedByName?: string | undefined;
    isActive: boolean;
}

export interface FollowUpRuleModel {
    followUpRuleId?: string | undefined;
    name?: string | undefined;
    active: boolean;
    description?: string | undefined;
    requirementFor?: string | undefined;
    taskConfiguration?: string | undefined;
    referenceDate?: string | undefined;
    workListFasitDsl?: string | undefined;
    workListFasitJournalDsl?: string | undefined;
    workListFasitCompanyDsl?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface AdminGuideLinkModel {
    guideLinkId: string;
    name?: string | undefined;
    text?: string | undefined;
    tooltip?: string | undefined;
    url?: string | undefined;
    responsibleUser: string;
    responsibleUserName?: string | undefined;
    guideId?: GuideIdType | undefined;
    excludedTargetGroupIds?: string[] | undefined;
    isActive: boolean;
    createdBy: string;
    createdOn: Date | string;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export enum GuideIdType {
    Masseindkaldelsetilsamtaler = "masseindkaldelsetilsamtaler",
    Opretsag = "opretsag",
    Gennemfrsamtale = "gennemfrsamtale",
    Indkaldtilsamtale = "indkaldtilsamtale",
    Udsteduddannelsesplg = "udsteduddannelsesplg",
    Fristforselvbooking = "fristforselvbooking",
    Findjob = "findjob",
    Danaktindsigt = "danaktindsigt",
    UdskrivMinplan = "udskrivMinplan",
    Nytdokument = "nytdokument",
    Srligeforhold = "srligeforhold",
    Godkendafvisplacering = "godkendafvisplacering",
    Danbreve = "danbreve",
}

export interface OutgoingDocumentTypeModel {
    name?: string | undefined;
    simplexDuplexType?: string | undefined;
    printColorType?: string | undefined;
    postalCategory?: string | undefined;
    envelopeType?: string | undefined;
    outgoingDocumentTypeId?: string | undefined;
    active: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface PlacementPurposeModel {
    placementPurposeId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    suggestedReasonForActivity?: string | undefined;
    codeListPurposeOfCompanyInternshipTypeId?: string | undefined;
    offerTypes?: string[] | undefined;
    isActive?: boolean | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface ReasonForReadWriteMathTestModel {
    reasonForReadWriteMathTestId?: string | undefined;
    name?: string | undefined;
    elaborationOfReasonRequired: boolean;
    isActive: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface RecruitmentCollaborationModel {
    recruitmentCollaborationId?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | string | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedOn?: Date | string | undefined;
    isActive: boolean;
    jobcenterIds?: string[] | undefined;
}

export interface RecruitmentRequestInformationTypeModel {
    recruitmentRequestInformationTypeId?: string | undefined;
    name?: string | undefined;
    isActive: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface ServiceTargetTypeModel {
    serviceTargetTypeId?: string | undefined;
    name?: string | undefined;
    numberOfWorkingDaysForDisseminationStart?: number | undefined;
    numberOfWorkingDaysForGrantCreation?: number | undefined;
    isActive: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface SocialProviderUnitModel {
    id: string;
    externalId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    companyId: string;
    departmentUuid?: string | undefined;
    contactPointId?: string | undefined;
    prefersAssignmentsAsLetter: boolean;
    abbreviation?: string | undefined;
    sorLocationNumber?: string | undefined;
    sorCode?: string | undefined;
    eanNumber?: string | undefined;
    eMailAddress?: string | undefined;
    eMailNotification?: boolean | undefined;
}

export interface AdminStandardAppendixModel {
    standardAppendixId?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    isActive: boolean;
    createdBy: string;
    createdByName?: string | undefined;
    createdOn: Date | string;
    modifiedBy: string;
    modifiedByName?: string | undefined;
    modifiedOn?: Date | string | undefined;
    documents?: StandardAppendixDocumentModel[] | undefined;
}

export interface StandardAppendixDocumentModel {
    id: string;
    title?: string | undefined;
    fileName?: string | undefined;
    fileSize: number;
    added?: string | undefined;
}

export interface StandardAppendixRuleModel {
    standardAppendixRuleId: string;
    name?: string | undefined;
    entityType?: number | undefined;
    standardAppendix?: string | undefined;
    templateCodeName?: string | undefined;
    worklistfasitdsl?: string | undefined;
    isActive: boolean;
    createdBy: string;
    createdByName?: string | undefined;
    createdOn: Date | string;
    modifiedBy: string;
    modifiedByName?: string | undefined;
    modifiedOn?: Date | string | undefined;
}

export interface AdminStandardPhraseModel {
    standardPhraseId?: string | undefined;
    name?: string | undefined;
    displayedOn?: string[] | undefined;
    visibleToTeamIds?: string[] | undefined;
    phraseRichText?: string | undefined;
    phrasePlainText?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface AdminTaskConfigurationModel {
    taskConfigurationId?: string | undefined;
    identifier?: string | undefined;
    active?: boolean | undefined;
    createDuplicates?: boolean | undefined;
    daysOffset?: number | undefined;
    description?: string | undefined;
    entityNameText?: string | undefined;
    jobcenterSpecificTask?: boolean | undefined;
    taskDescription?: string | undefined;
    taskTitle?: string | undefined;
    taskType?: number | undefined;
    entityName?: string | undefined;
    taskCategoryId?: string | undefined;
    activateRepetition?: boolean | undefined;
    interval?: number | undefined;
    numberOfRepetitions?: number | undefined;
    repetitionUnit?: number | undefined;
    externalOperatorAllocationManagement?: number | undefined;
    useAdditionalCaseworker: boolean;
    additionalCaseworkerUserRoleId?: string | undefined;
    selvbooking?: boolean | undefined;
    taskCreationSetting?: number | undefined;
    responsibilityAreas?: string[] | undefined;
    targetGroups?: string[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface InstructionPromptToSave {
    name?: string | undefined;
    content?: string | undefined;
    isActive: boolean;
}

export interface TransactionLogItemDetails {
    request?: TransactionLogRequestDetails | undefined;
    response?: TransactionLogResponseDetails | undefined;
    commonTransactionLogFields?: CommonTransactionLogFields | undefined;
}

export interface TransactionLogRequestDetails {
    timeStamp: Date | string;
    body?: string | undefined;
}

export interface TransactionLogResponseDetails {
    transactionStatus?: TransactionStatusType | undefined;
    timeStamp: Date | string;
    body?: string | undefined;
}

export enum TransactionStatusType {
    Success = "success",
    Failure = "failure",
}

export interface CommonTransactionLogFields {
    system: ExternalSystemType;
    action?: string | undefined;
    cpr?: string | undefined;
    pNumber?: string | undefined;
    elasticDocumentId?: string | undefined;
    transactionId?: string | undefined;
    correlationId?: string | undefined;
    transactionLogExternalId?: string | undefined;
}

export enum ExternalSystemType {
    Udbudsportalen = "udbudsportalen",
    LeverandoerPlatformen = "leverandoerPlatformen",
    Ky = "ky",
    Dfdg = "dfdg",
    Jobnet = "jobnet",
    Sapa = "sapa",
    Ksd = "ksd",
    FkOrg = "fkOrg",
    Vitas = "vitas",
    IntelligentMatch = "intelligentMatch",
    Nexus = "nexus",
    Fvdb = "fvdb",
    Synlab = "synlab",
    CprRegisterDatafordeler = "cprRegisterDatafordeler",
    Debitor = "debitor",
}

export interface SearchResponse {
    totalResults: number;
    items?: SearchResponseItem[] | undefined;
}

export interface SearchResponseItem {
    commonTransactionLogFields?: CommonTransactionLogFields | undefined;
    transactionStatus?: TransactionStatusType | undefined;
    timeStamp: Date | string;
    actionType: ActionType;
    body?: string | undefined;
}

export enum ActionType {
    Request = "request",
    Response = "response",
}

export interface TenantAddonConfigurationValue {
    configurationName?: string | undefined;
    value?: string | undefined;
}

export interface QuestionnaireListItem {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    citizenName?: string | undefined;
    citizenDescription?: string | undefined;
    questionnaireType: QuestionnaireType;
    pseudoFasitEntityDiscriminator: PseudoFasitEntityDiscriminator;
    numberOfCitizensSentTo: number;
    numberOfCitizensAnswered: number;
}

export enum QuestionnaireType {
    Survey = "survey",
    JournalizedResponse = "journalizedResponse",
}

export interface FeedbackViewModel {
    id: string;
    questionnaireId: string;
    title?: string | undefined;
    description?: string | undefined;
    createdBy?: string | undefined;
    createdOn: Date | string;
}

export interface UseOfForceUnitOverviewItemModel {
    citizenId: string;
    citizenName?: string | undefined;
    citizenCpr?: string | undefined;
    incident: UseOfForceIncidentModel;
    hygieneRestraintLogStatus?: UseOfForceHygieneRestraintLogStatus | undefined;
}

export interface UseOfForceUnitOverviewAuthorizationItemModel {
    citizenId: string;
    citizenName?: string | undefined;
    citizenCpr?: string | undefined;
    authorization: UseOfForceAuthorizationModel;
    draftRegistrationId?: string | undefined;
}

export interface ResourceUtilizationServiceProviderUnit {
    id: string;
    name: string;
}

export interface ResourceUtilizationOffer {
    id: string;
    name: string;
    serviceProviderUnitId: string;
}

export interface ResourceUtilizationGrantType {
    id: string;
    name: string;
    shortName: string;
}

export interface ResourceUtilizationEmployee {
    organizationUserId: string;
    name: string;
}

export interface ResourceUtilizationCapacity {
    organizationUserId: string;
    offerId: string;
    weeklyCapacityMinutes: number;
}

export interface ResourceUtilizationAllocation {
    organizationUserId: string;
    offerId: string;
    grantTypeId?: string | undefined;
    activityId: string;
    activityIdentifier: number;
    activityTitle?: string | undefined;
    citizenId: string;
    startDate: Date | string;
    allocatedMinutesPerWeek: number;
}

export interface UnitPatternModel {
    title: string;
    description: string;
    suggestion: string;
    citizenIds: string[];
    eventCount: number;
}

export interface ServiceProviderUnitCitizenModel {
    citizenId: string;
    citizenName?: string | undefined;
    citizenCpr?: string | undefined;
    zone?: TrafficLightZone | undefined;
    zoneSince?: Date | string | undefined;
    zoneEscalations: number;
    useOfForceIncidents: number;
    unfinishedUseOfForceIncidents: number;
    currentPartialObjectives: number;
    partialObjectivesWithoutRecentFollowup: number;
    activeObsNotes: number;
}

export interface ServiceProviderUnitCalendarEventModel {
    title: string;
    type: CalendarEventType;
    entityId?: string | undefined;
    serviceProviderUnitId?: string | undefined;
    citizenId?: string | undefined;
    partialObjectiveId?: string | undefined;
    citizenName?: string | undefined;
    citizenCpr?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    allDay: boolean;
    createdByUserId?: string | undefined;
    responsibleUserId?: string | undefined;
    responsibleUserFullName?: string | undefined;
    responsibleUserUsername?: string | undefined;
    locationAddress?: string | undefined;
    content?: string | undefined;
    plannedMinutes?: number | undefined;
    consumedMinutes?: number | undefined;
    eventStatus?: EventStatusType | undefined;
    doneComment?: string | undefined;
    cancelledComment?: string | undefined;
    canEdit: boolean;
    canCancel: boolean;
    canDelete: boolean;
    recurrence?: RecurrencePatternModel | undefined;
    seriesId?: string | undefined;
    noteTypeId?: string | undefined;
}

export enum CalendarEventType {
    Booking = "booking",
    AssignmentFollowUp = "assignmentFollowUp",
    Event = "event",
    Medicine = "medicine",
    Composite = "composite",
}

export enum EventStatusType {
    Planned = "planned",
    Done = "done",
    Cancelled = "cancelled",
}

export interface Document {
    fileName?: string | undefined;
    title?: string | undefined;
    id: string;
    fileSize: number;
}

export interface OutboxViewModel {
    id: string;
    title?: string | undefined;
    recipientType?: string | undefined;
    recipientName?: string | undefined;
    recipientIdentifier?: string | undefined;
    recipientDetails?: string | undefined;
    citizenId?: string | undefined;
    assignmentId?: string | undefined;
    socialProviderUnitId?: string | undefined;
    createdBy?: OutboxItemUser | undefined;
    onBehalfOf?: OutboxItemUser | undefined;
    outgoingDocumentTypeId?: string | undefined;
    outgoingDocumentTypeName?: string | undefined;
    lastSendDate?: Date | string | undefined;
    createdDate?: Date | string | undefined;
    journalNoteId?: string | undefined;
    journalNoteUrl?: string | undefined;
    diaryNoteId?: string | undefined;
    url?: string | undefined;
    isApexEntity: boolean;
    status: OutboxItemSendStatus;
    statusNote?: string | undefined;
    isOldVersionOfOutboxItem: boolean;
    companyId?: string | undefined;
    companyNoteId?: string | undefined;
    attachments?: string | undefined;
    companyNoteUrl?: string | undefined;
    isCompany: boolean;
    mainDocumentId: string;
}

export interface OutboxItemUser {
    id: string;
    name?: string | undefined;
}

export enum OutboxItemStatus {
    MyItems = "myItems",
    Failed = "failed",
    AllPending = "allPending",
    MyPending = "myPending",
    AllItems = "allItems",
}

export interface SubJobcenterListItemViewModel {
    id: string;
    name?: string | undefined;
}

export interface OrganizationTeamModel {
    fkOrganizationId?: string | undefined;
    isDisabled?: boolean | undefined;
    id?: string | undefined;
    mainTeamName?: string | undefined;
    name?: string | undefined;
    userFacingKey?: string | undefined;
}

export interface TeamFromFkoViewModel {
    name?: string | undefined;
    externalOrganizationId?: string | undefined;
    fkOrganizationalUnitId: string;
    fkOrganizationalUnitParentId?: string | undefined;
    fkOrganizationalUnitParentName?: string | undefined;
    address?: TeamAdressViewModel | undefined;
    attendanceAddress?: TeamAdressViewModel | undefined;
    contactInfo?: ContactInfoFromFkoViewModel | undefined;
}

export interface ContactInfoFromFkoViewModel {
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    webAddress?: string | undefined;
}

export interface TeamWithUserViewModel {
    teamId: string;
    name?: string | undefined;
    externalOrganizationId?: string | undefined;
    fkOrganizationalUnitId?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
    discriminator?: string | undefined;
    subJobcenter?: string | undefined;
    subJobcenterName?: string | undefined;
    subJobcenterCode?: string | undefined;
    parentTeamId?: string | undefined;
    address?: TeamAdressViewModel | undefined;
    attendanceAddress?: TeamAdressViewModel | undefined;
    contactInfo?: ContactInfoViewModel | undefined;
    attendanceRoom?: string | undefined;
    numberOfUsersInTeam: number;
}

export interface TeamUserViewModel {
    userId: string;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    jobTitle?: string | undefined;
    latestLoginAt?: Date | string | undefined;
    isActive: boolean;
}

export interface OrganizationUserModel {
    fkOrganizationId?: string | undefined;
    isDisabled?: boolean | undefined;
    id?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    teamName?: string | undefined;
    teamId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    displayName?: string | undefined;
    jobTitle?: string | undefined;
}

export interface MethodTypeModel {
    id?: string | undefined;
    name?: string | undefined;
}

export interface CompanyActivityListItemViewModel {
    id: string;
    activityId: string;
    name?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    state?: string | undefined;
    offerTypeName?: string | undefined;
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
    contactPersonFullName?: string | undefined;
    userId?: string | undefined;
    userFullName?: string | undefined;
    approvalState?: string | undefined;
    activityUrl?: string | undefined;
    categoryId: number;
}

export enum ActivityFilterType {
    NotSet = "notSet",
    ActiveAndFuture = "activeAndFuture",
    All = "all",
}

export interface GetActivitiesBasicInfoDto {
    activityId: string;
    caseId?: string | undefined;
    citizenId: string;
    title?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    status: ActivityStatusType;
}

export enum ActivityStatusType {
    Draft = "draft",
    Enrolled = "enrolled",
    Cancelled = "cancelled",
    Discontinued = "discontinued",
    Completed = "completed",
    Referred = "referred",
    Hired = "hired",
    Closed = "closed",
    Agreed = "agreed",
}

export interface ActivityListItemViewModel {
    activityId: string;
    title?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    state?: string | undefined;
    offerTypeName?: string | undefined;
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
    caseId?: string | undefined;
    caseName?: string | undefined;
    companyName?: string | undefined;
    contactPersonFullName?: string | undefined;
    userId?: string | undefined;
    userFullName?: string | undefined;
    approvalState?: string | undefined;
    categoryId: number;
    offerId?: string | undefined;
}

export enum CitizenActivityFilterType {
    NotSet = "notSet",
    ActiveAndFuture = "activeAndFuture",
    All = "all",
}

export interface ActivityPageRequest {
    pageSize: number;
    pageNumber: number;
}

export interface ActivitySortRequest {
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
}

export interface ActivityFilterRequest {
    field?: string | undefined;
    id?: string | undefined;
    operatorValue?: string | undefined;
    filterValue?: string | undefined;
}

export interface GrantActivityListItem {
    id: string;
    title?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    offerTypeName?: string | undefined;
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
    companyName?: string | undefined;
    status: ActivityStatusType;
    state?: string | undefined;
    approvalState?: string | undefined;
    contactPersonName?: string | undefined;
}

export interface ActivityForNegativeEventDto {
    activityId: string;
    title?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    caseId?: string | undefined;
}

export interface ActivityForNuphDto {
    externalId: string;
    title?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    caseId?: string | undefined;
}

export interface ActivitySummaryBoxModel {
    activityId: string;
    title?: string | undefined;
    offerCategory?: string | undefined;
    offerType?: string | undefined;
    startDate: Date | string;
    endDate: Date | string;
    hoursPerWeek: number;
    minutesPerWeek: number;
    userFullName?: string | undefined;
}

export interface ActivityApprovalRejectViewModel {
    activityId: string;
    offerTitle?: string | undefined;
    offerCategoryName?: string | undefined;
    offerType?: OfferTypeCodeListDto | undefined;
    responsibleCaseworkerName?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    totalHours?: number | undefined;
    priceModelName?: string | undefined;
    totalPrice?: number | undefined;
    activityStatus: number;
    description?: string | undefined;
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
    citizenId: string;
    activityTitle: string;
    offerIdentifier?: number | undefined;
    currentUserId: string;
    internalApproverUserId?: string | undefined;
    activityApprovalStatus: number;
    internalApproverName?: string | undefined;
    internalApprovalDate?: Date | string | undefined;
}

export interface OfferTypeCodeListDto {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    placementPurposeRequiredOnPlacement: boolean;
    category?: number | undefined;
    healthActivityTypeId?: string | undefined;
    active: boolean;
    code?: number | undefined;
    courseTypeId?: string | undefined;
    mentorTypeId?: string | undefined;
}

export interface CommunicationActivityViewModel {
    activityId: string;
    caseId?: string | undefined;
    citizen?: CitizenInfo | undefined;
    company?: Company | undefined;
    title?: string | undefined;
}

export interface CitizenInfo {
    id: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    currentAddress?: string | undefined;
    civilRegistrationIdentifier?: string | undefined;
    isCitizenDead: boolean;
    postalCode?: string | undefined;
    countryCode?: string | undefined;
}

export interface Company {
    id: string;
    name?: string | undefined;
    pNummer?: string | undefined;
    industry?: string | undefined;
    address?: CompanyAddress | undefined;
}

export interface CompanyAddress {
    streetAddress?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
}

export interface ActivityDetailsViewModel {
    activityId: string;
    categoryId: number;
    offerId?: string | undefined;
    offerSummaryHeader?: string | undefined;
    offerIdentifier?: number | undefined;
    citizenViewModel?: CitizenViewModel | undefined;
    citizenMunicipalityAtCreationTime?: string | undefined;
    activityStatus?: ActivityStatusViewModel | undefined;
    offerType?: OfferTypeViewModel | undefined;
    offerTypeName?: string | undefined;
    title?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
    totalHoursAndMinutes: number;
    precedingActivity?: PrecedingActivityViewModel | undefined;
    occupation?: OccupationViewModel | undefined;
    caseworker?: CaseWorkerViewModel | undefined;
    externalCaseWorker?: ExternalCaseWorkerModel | undefined;
    case?: CaseViewModel | undefined;
    grant?: GrantViewModel | undefined;
    description?: string | undefined;
    activityPurpose?: ActivityPurposeViewModel | undefined;
    reasonForActivity?: string | undefined;
    priceCalculation?: ActivityPriceCalculationViewModel | undefined;
    company?: CompanyViewModel | undefined;
    providerCompanyName?: string | undefined;
    address?: ActivityAddressViewModel | undefined;
    firstDayMeetingTime?: string | undefined;
    furtherInformationAttendance?: string | undefined;
    contactPerson?: ActivityContactPersonViewModel | undefined;
    approval?: ActivityApprovalViewModel | undefined;
    approvalRequired: boolean;
    allowActivityPriceChanges: boolean;
    allowActivityPriceCorrections: boolean;
    courseActivity?: CourseActivityDetailsDto | undefined;
    companyActivity?: CompanyActivityDetailsDto | undefined;
    cancellation?: ActivityCancellationViewModel | undefined;
    mentorActivity?: MentorActivityDetailsDto | undefined;
    personalAssistanceActivity?: PersonalAssistanceActivityDetailsDto | undefined;
    helpingDeviceActivity?: HelpingDeviceActivityDetailsDto | undefined;
    isOpenOffer: boolean;
    availabilityProving: boolean;
    kyOfferTypeId?: string | undefined;
    isDeleted: boolean;
    highReimbursement?: boolean | undefined;
    activityIdentifier: number;
    supplierPlatform?: SupplierPlatformDto | undefined;
    offerPortalIntegrationFailedDate?: Date | string | undefined;
    isUnderMonetaryTrivialityLimit: boolean;
    createdBy: string;
    serviceProviderUnit?: SocialProviderUnitDto | undefined;
    isVitasAttachable: boolean;
}

export interface CitizenViewModel {
    citizenId: string;
    fullName?: string | undefined;
    civilRegistrationIdentifier?: string | undefined;
    isAnonymous?: boolean | undefined;
}

export interface ActivityStatusViewModel {
    id: number;
    description?: string | undefined;
}

export interface OfferTypeViewModel {
    id: string;
    name?: string | undefined;
    placementPurposeRequiredOnPlacement: boolean;
    category?: number | undefined;
    active: boolean;
    courseTypeId?: string | undefined;
    mentorTypeId?: string | undefined;
}

export interface PrecedingActivityViewModel {
    id: string;
    name?: string | undefined;
}

export interface OccupationViewModel {
    id: string;
    name?: string | undefined;
    active: boolean;
}

export interface CaseWorkerViewModel {
    caseWorkerId?: string | undefined;
    caseWorkerName?: string | undefined;
}

export interface ExternalCaseWorkerModel {
    externalCaseWorkerName?: string | undefined;
}

export interface CaseViewModel {
    name?: string | undefined;
    caseId: string;
    caseTypeId?: string | undefined;
    startDate?: Date | string | undefined;
    isPrimaryCase?: boolean | undefined;
}

export interface GrantViewModel {
    id: string;
    name?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    caseId: string;
}

export interface ActivityPurposeViewModel {
    id?: string | undefined;
    name?: string | undefined;
}

export interface ActivityPriceCalculationViewModel {
    priceModel?: number | undefined;
    priceModelInitialRate?: number | undefined;
    priceModelInitialRateCorrection?: number | undefined;
    unitPrice?: number | undefined;
    unitPriceCorrection?: number | undefined;
    totalPrice?: number | undefined;
    priceNotes?: string | undefined;
}

export interface CompanyViewModel {
    companyId?: string | undefined;
    companyName?: string | undefined;
    cvrNumber?: string | undefined;
    pNumber?: string | undefined;
}

export interface ActivityAddressViewModel {
    districtName?: string | undefined;
    districtSubdivisionIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    postalCode?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    streetName?: string | undefined;
    suiteIdentifier?: string | undefined;
    country?: CountryViewModel2 | undefined;
}

export interface CountryViewModel2 {
    countryId: string;
    name?: string | undefined;
}

export interface ActivityContactPersonViewModel {
    givenName?: string | undefined;
    surname?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    companyContactPersonId?: string | undefined;
}

export interface ActivityApprovalViewModel {
    citizenGoal?: string | undefined;
    citizenRemark?: string | undefined;
    daysBetweenProgressionMeasurements?: number | undefined;
    frequencyForProgressionMeasurement?: number | undefined;
    internalApprovalDate?: Date | string | undefined;
    internalApprovalDueDate?: Date | string | undefined;
    internalApproverUser?: CaseWorkerViewModel | undefined;
    approvalStatus?: ApprovalStatusViewModel | undefined;
    hasRelatedSupplierPlatformOffer: boolean;
    approvalRefusalDate?: Date | string | undefined;
}

export interface ApprovalStatusViewModel {
    id: number;
    description?: string | undefined;
}

export interface CourseActivityDetailsDto {
    educationType?: OfferAndActivityEducationType | undefined;
    numberOfWeeksWithPracticalTraining?: number | undefined;
    hoursPerWeeksWithPracticalTraining?: number | undefined;
    minutesPerWeeksWithPracticalTraining?: number | undefined;
    practicalTraining: boolean;
    courseType?: CourseTypeListDto | undefined;
    courseAllocationType?: CourseAllocationCodeListDto | undefined;
    education?: EducationListDto | undefined;
}

export interface KyTypesListDtoBase {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    externalId?: number | undefined;
    kyOfferTypeId?: string | undefined;
}

export interface CourseTypeListDto extends KyTypesListDtoBase {
}

export interface CourseAllocationCodeListDto {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    externalId?: string | undefined;
}

export interface EducationListDto {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    externalId?: string | undefined;
}

export interface CompanyActivityDetailsDto {
    efficientHoursPerWeek?: number | undefined;
    efficientMinutesPerWeek?: number | undefined;
    flexJobType?: number | undefined;
    hiringOrganisationType?: HiringOrganisationType | undefined;
    specialConsideration?: string | undefined;
    assessmentOfEmployabilityDescription?: string | undefined;
    occupationId?: OccupationCodeListDto | undefined;
    jobAllocationId?: CodeListItem4 | undefined;
    jobOrderPriceHourId?: CodeListItem4 | undefined;
    purposeOfCompanyInternshipTypeId?: CodeListItem4 | undefined;
    activityVitas?: ActivityVitasDto | undefined;
    jobOfferTypeId?: CodeListItem4 | undefined;
    authorityAreaTypeId?: CodeListItem4 | undefined;
}

export enum HiringOrganisationType {
    Private = "private",
    Municipal = "municipal",
    Regional = "regional",
    State = "state",
    AssociationOrOrganisationOrSelfOwned = "associationOrOrganisationOrSelfOwned",
}

export interface OccupationCodeListDto {
    id: string;
    name?: string | undefined;
    active: boolean;
}

export interface CodeListItem4 {
    id: string;
    name?: string | undefined;
    isActive: boolean;
}

export interface ActivityVitasDto {
    vitasJobAllocationId?: string | undefined;
    vitasAllocationUrl?: string | undefined;
    vitasCreatedByUserId?: string | undefined;
    vitasCreatedByUserTeamId?: string | undefined;
    vitasCreatedOn?: Date | string | undefined;
    latestUpdateFromVitas?: Date | string | undefined;
    suggestedVitasUpdateEndDate?: Date | string | undefined;
}

export interface ActivityCancellationViewModel {
    causeRemark?: string | undefined;
    activityStatusCauseType?: ActivityStatusCauseCodeListDto | undefined;
}

export interface ActivityStatusCauseCodeListDto {
    id: string;
    name?: string | undefined;
    externalId?: string | undefined;
}

export interface MentorActivityDetailsDto {
    activityVitas?: ActivityVitasDto | undefined;
}

export interface PersonalAssistanceActivityDetailsDto {
    personalAssistanceType?: PersonalAssistanceTypeDto | undefined;
    personalAssistanceKind: number;
    pricePerHourType?: number | undefined;
    pricePerHour?: number | undefined;
    otherPriceType?: number | undefined;
    otherPrice?: number | undefined;
    activityVitas?: ActivityVitasDto | undefined;
}

export interface PersonalAssistanceTypeDto {
    id: string;
    name?: string | undefined;
}

export interface HelpingDeviceActivityDetailsDto {
    price?: number | undefined;
    helpingDeviceIdentifier?: HelpingDeviceIdentifier | undefined;
    helpingDeviceTypeId?: string | undefined;
    ownershipType?: HelpingDeviceOwnershipDisposal | undefined;
    activityVitas?: ActivityVitasDto | undefined;
}

export interface SupplierPlatformDto {
    externalKey1?: string | undefined;
    externalKey2?: string | undefined;
    externalKey3?: string | undefined;
    externalApprovalDate?: Date | string | undefined;
    externalApprovalDueDate?: Date | string | undefined;
    externalApprovalHandoverDate?: Date | string | undefined;
    offerPortalIntegrationFailedDate?: Date | string | undefined;
}

export interface SocialProviderUnitDto {
    id: string;
    name?: string | undefined;
    externalId?: string | undefined;
    description?: string | undefined;
    companyId?: string | undefined;
    departmentUuid?: string | undefined;
}

export interface ActivityListItemViewModel2 {
    id: string;
    name?: string | undefined;
    startDate: Date | string;
    endDate: Date | string;
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
    status?: string | undefined;
    contactPerson?: string | undefined;
    approvalStatus?: string | undefined;
    offerTypeName?: string | undefined;
}

export interface ActivityPdfFormModel {
    id?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    tag?: string | undefined;
}

export interface PdfFormAttachmentModel {
    id?: string | undefined;
    documentId?: string | undefined;
    title?: string | undefined;
    name?: string | undefined;
    size?: string | undefined;
    sizeInBytes?: string | undefined;
    aliasId?: string | undefined;
    mime?: string | undefined;
    added?: string | undefined;
    isCompanyForm?: boolean | undefined;
    isCitizenForm?: boolean | undefined;
}

export interface GetActivityPriceCalculationHistoryEntryViewModel {
    changedAt: Date | string;
    changedByName?: string | undefined;
    priceModel?: number | undefined;
    priceModelInitialRate?: number | undefined;
    priceModelInitialRateCorrection?: number | undefined;
    unitPrice?: number | undefined;
    unitPriceCorrection?: number | undefined;
    periodTotalPrice?: number | undefined;
    priceNotes?: string | undefined;
}

export interface GetActivityPriceCalculationHistoryCurrentValuesViewModel {
    priceModel?: number | undefined;
    priceModelInitialRate?: number | undefined;
    priceModelInitialRateCorrection?: number | undefined;
    unitPrice?: number | undefined;
    unitPriceCorrection?: number | undefined;
    periodTotalPrice?: number | undefined;
    priceNotes?: string | undefined;
}

export interface ActivityPriceCorrectionViewModel {
    activityPriceCorrectionId: string;
    amount: number;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    status: number;
    addedByName: string;
    addedOn: Date | string;
    note?: string | undefined;
}

export interface ActivityResourceViewModel {
    offerResourceId: string;
    activityId: string;
    offerResourceDisplayName?: string | undefined;
    allocatedHoursPerWeek: number;
    allocatedMinutesPerWeek: number;
    allocationNote?: string | undefined;
}

export interface UserWithApplicationRoleModel {
    upn?: string | undefined;
    id?: string | undefined;
    caseWorkerFullName?: string | undefined;
    email?: string | undefined;
    teamName?: string | undefined;
    teamId?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    displayName?: string | undefined;
    searchSubText?: string | undefined;
    isDisabled: boolean;
    userType: number;
}

export interface CitizenHeaderInfoViewModel {
    fullName?: string | undefined;
    civilRegistrationIdentifier?: string | undefined;
}

export interface ContactPersonViewModel {
    companyContactPersonId?: string | undefined;
    fullName?: string | undefined;
    givenName?: string | undefined;
    surname?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
}

export interface CompanySpecialCircumstanceViewModel {
    title?: string | undefined;
    type: number;
    startDate: Date | string;
    endDate?: Date | string | undefined;
}

export interface CreateOfferCompanyViewModel {
    name?: string | undefined;
    productionNumber?: string | undefined;
    cvr?: string | undefined;
    webSite?: string | undefined;
    phone?: string | undefined;
    address?: CompanyAddressViewModel | undefined;
    contactPerson?: ContactPersonViewModel | undefined;
}

export interface CompanyAddressViewModel {
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    suiteIdentifier?: string | undefined;
    postCodeIdentifier?: string | undefined;
    districtName?: string | undefined;
    country?: CountryViewModel2 | undefined;
}

export interface CitizenActivityViewModel {
    activityIdentifier: string;
    title?: string | undefined;
    status?: string | undefined;
    offerType?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
}

export interface DfdgActivityViewModel {
    startDate: Date | string;
    endDate?: Date | string | undefined;
    activityStatus: number;
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
    remarks?: string | undefined;
    activityProvider?: string | undefined;
    providerAddress?: string | undefined;
    contactPerson?: string | undefined;
    responsibleCaseWorker?: string | undefined;
    authorityCode?: string | undefined;
    published?: string | undefined;
    firstPublicationDate?: Date | string | undefined;
    revised?: string | undefined;
    description?: string | undefined;
    reason?: string | undefined;
    additionalData?: string | undefined;
}

export interface GetEvaluationViewModel {
    evaluationName?: string | undefined;
    evaluationText?: string | undefined;
    type?: EvaluationTypeItem | undefined;
    activityId: string;
}

export interface EvaluationTypeItem {
    id: number;
    name?: string | undefined;
}

export interface EvaluationListItemViewModel {
    evaluationId: string;
    evaluationName?: string | undefined;
    correctionComment?: string | undefined;
    evaluationText?: string | undefined;
    type?: EvaluationTypeItem | undefined;
    createdBy?: CreatedByViewModel | undefined;
    createdOn: Date | string;
    modifiedBy?: ModifiedByViewModel | undefined;
    modifiedOn: Date | string;
    externalDfdgId?: string | undefined;
}

export interface CreatedByViewModel {
    id: string;
    name?: string | undefined;
}

export interface ModifiedByViewModel {
    id: string;
    name?: string | undefined;
}

export interface MissingWorkDutyHoursModel {
    missingHours: number;
    missingMinutes: number;
}

export interface OfferAndActivityConfiguration {
    placementPeriodExact: boolean;
    preventPlacementOutsideOfferPeriod: boolean;
    placementValidationConfiguration?: PlacementValidationConfiguration | undefined;
    offerPortalOfferCategories?: number[] | undefined;
    disableOfferGuideForPriceCorrection: boolean;
    preventActivityOutsideOfferPeriod: boolean;
    offerCategoriesAllowingExternalOperatorAgreement?: number[] | undefined;
    offerReservationExtensionPeriod: number;
    transportReimbursementSettings?: string | undefined;
    placementLetterGuideLinkDefaultLetterTemplateCode?: string | undefined;
    enabledPriceModels?: number[] | undefined;
}

export interface PlacementValidationConfiguration {
    maxHoursPerWeek: number;
    validationLevel?: ValidationLevelEnum | undefined;
    offerCategoryValidation?: OfferCategoryValidation | undefined;
}

export enum ValidationLevelEnum {
    Warning = "warning",
    Error = "error",
}

export interface OfferCategoryValidation {
    warning?: number[] | undefined;
    alert?: number[] | undefined;
}

export interface OfferViewModel {
    offerId: string;
    company?: CompanyViewModel | undefined;
    category?: CategoryViewModel | undefined;
    offerIdentifier?: number | undefined;
    offerStatus?: OfferStatusViewModel | undefined;
    offerType?: OfferTypeViewModel | undefined;
    title?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    responsibleUser?: ResponsibleUserViewModel | undefined;
    responsibleTeam?: ResponsibleTeamViewModel | undefined;
    externalOperatorAgreementId?: string | undefined;
    externalOperatorAgreementName?: string | undefined;
    internalDescription?: string | undefined;
    suggestedActivityDescription?: string | undefined;
    offerApproval?: OfferApprovalViewModel | undefined;
    offerFollowup?: OfferFollowupViewModel | undefined;
    seatCalculation?: SeatCalculationViewModel | undefined;
    offerAddress?: OfferAddressViewModel | undefined;
    contactPerson?: OfferContactPersonViewModel | undefined;
    targetAgeFrom?: number | undefined;
    targetAgeTo?: number | undefined;
    targetGroups?: TargetGroupViewModel[] | undefined;
    importantTag?: ImportantTagViewModel | undefined;
    offerTag?: OfferTagViewModel | undefined;
    healthOffer?: HealthOfferViewModel | undefined;
    mentorOffer?: MentorOfferViewModel | undefined;
    courseOffer?: CourseOfferViewModel | undefined;
    companyOffer?: CompanyOfferViewModel | undefined;
    personalAssistanceOffer?: PersonalAssistanceOfferViewModel | undefined;
    socialEffortOffer?: SocialEffortOfferViewModel | undefined;
    helpingDeviceOffer?: HelpingDeviceOfferViewModel | undefined;
    offerGroup?: OfferGroupListItemViewModel | undefined;
    socialProviderUnit?: SocialProviderUnitViewModel | undefined;
    departmentUuid?: string | undefined;
    maxActiveResourcesPerActivity?: number | undefined;
    methodTypeIds?: string[] | undefined;
    hasWaitingList: boolean;
}

export interface CategoryViewModel {
    id: number;
    description?: string | undefined;
}

export interface OfferStatusViewModel {
    id: number;
    description?: string | undefined;
}

export interface ResponsibleUserViewModel {
    responsibleUserId?: string | undefined;
    responsibleUserName?: string | undefined;
}

export interface ResponsibleTeamViewModel {
    responsibleTeamId?: string | undefined;
    responsibleTeamName?: string | undefined;
}

export interface OfferApprovalViewModel {
    hasRelatedSupplierPlatformOffer: boolean;
    supplierPlatformProjectNumber?: string | undefined;
    isActivityApprovalRequired: boolean;
    minDaysToApprovePlacement?: number | undefined;
    monetaryTrivialityLimit?: number | undefined;
}

export interface OfferFollowupViewModel {
    daysBetweenProgressionMeasurements?: number | undefined;
    frequencyForProgressionMeasurement?: number | undefined;
}

export interface SeatCalculationViewModel {
    isSinglePlaceOffer: boolean;
    numberToFill?: number | undefined;
    allowOverlappingPlacementsForCitizen?: AllowOverlappingPlacementsForCitizenViewModel | undefined;
    allowOverbooking: boolean;
    reserveForExtensions: boolean;
    deadlineForPlacement?: Date | string | undefined;
    firstDayOfAvailableSeat?: Date | string | undefined;
    numberOfOccupiedSeats?: number | undefined;
    numberOfAvailableSeats?: number | undefined;
    gracePeriodInDaysBetweenActivities?: number | undefined;
    defaultPlacementDays?: number | undefined;
    defaultStartDateOffset?: number | undefined;
    maxDeviationFromDefaultDays?: number | undefined;
    availableSeatsInfo?: string | undefined;
}

export interface AllowOverlappingPlacementsForCitizenViewModel {
    id: number;
    description?: string | undefined;
}

export interface OfferAddressViewModel {
    offerAddressId: string;
    companyName?: string | undefined;
    companyPhoneNumber?: string | undefined;
    districtName?: string | undefined;
    districtSubdivisionIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    postalCode?: string | undefined;
    productionUnitIdentifier?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    streetName?: string | undefined;
    suiteIdentifier?: string | undefined;
    website?: string | undefined;
    country?: CountryViewModel2 | undefined;
}

export interface OfferContactPersonViewModel {
    givenName?: string | undefined;
    surname?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    companyContactPersonId?: string | undefined;
}

export interface TargetGroupViewModel {
    targetGroupId: string;
    name?: string | undefined;
}

export interface ImportantTagViewModel {
    importantTagId: string;
    importantTag1?: string | undefined;
    importantTag2?: string | undefined;
}

export interface OfferTagViewModel {
    offerTagId: string;
    offerTag1?: string | undefined;
    offerTag2?: string | undefined;
    offerTag3?: string | undefined;
    offerTag4?: string | undefined;
    offerTag5?: string | undefined;
}

export interface HealthOfferViewModel {
    offerPriceCalculation?: OfferPriceCalculationViewModel | undefined;
}

export interface OfferPriceCalculationViewModel {
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
    priceModel?: PriceModelViewModel | undefined;
    priceModelInitialRate?: number | undefined;
    priceModelInitialRateCorrection?: number | undefined;
    unitPrice?: number | undefined;
    unitPriceCorrection?: number | undefined;
    allowActivityPriceChanges: boolean;
    allowActivityPriceCorrections: boolean;
}

export enum PriceModelViewModel {
    PerHour = "perHour",
    PerDay = "perDay",
    PerWeek = "perWeek",
    PerMonth = "perMonth",
    PerProcess = "perProcess",
    PerHourWithStartTax = "perHourWithStartTax",
    PerDayWithStartTax = "perDayWithStartTax",
    PerWeekWithStartTax = "perWeekWithStartTax",
    PerMonthWithStartTax = "perMonthWithStartTax",
}

export interface MentorOfferViewModel {
    offerPriceCalculation?: OfferPriceCalculationViewModel | undefined;
}

export interface CourseOfferViewModel {
    offerPriceCalculation?: OfferPriceCalculationViewModel | undefined;
    amuCode?: string | undefined;
    availabilityProving?: boolean | undefined;
    dunCode?: string | undefined;
    educationtype?: number | undefined;
    openOffer?: boolean | undefined;
    education?: EducationViewModel | undefined;
}

export interface EducationViewModel {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    externalId?: string | undefined;
}

export interface CompanyOfferViewModel {
    openOffer: boolean;
    ownCarRequired: boolean;
    schedule?: number | undefined;
    availabilityProving: boolean;
    occupationId: string;
    hiringOrganisationType?: number | undefined;
    isAssociatedToRecruitmentRequest: boolean;
    acceptedDriversLicenses?: string[] | undefined;
    offerVitas?: OfferVitasViewModel | undefined;
    authorityAreaTypeId?: string | undefined;
    qualificationsAndSpecialCircumstances?: string | undefined;
}

export interface OfferVitasViewModel {
    vitasApprovedByUserId?: string | undefined;
    vitasApprovedByUserTeamId?: string | undefined;
    vitasApprovedOn?: Date | string | undefined;
    vitasCaseId?: string | undefined;
    vitasEarmarkedToContactId?: string | undefined;
    vitasJobOfferId?: string | undefined;
    vitasJobOfferUrl?: string | undefined;
    vitasRegistrationDate?: Date | string | undefined;
    latestUpdateFromVitas?: Date | string | undefined;
}

export interface PersonalAssistanceOfferViewModel {
    pricePerHour?: number | undefined;
    actualPrice?: number | undefined;
}

export interface SocialEffortOfferViewModel {
    offerPriceCalculation?: OfferPriceCalculationViewModel | undefined;
}

export interface HelpingDeviceOfferViewModel {
    price?: number | undefined;
    helpingDeviceIdentifier: HelpingDeviceIdentifier;
    ownershipType?: HelpingDeviceOwnershipDisposal | undefined;
}

export interface OfferGroupListItemViewModel {
    offerGroupId: string;
    name?: string | undefined;
    offerGroupIdentifier?: string | undefined;
    active: boolean;
    createdOn: Date | string;
    createdBy: string;
}

export interface SocialProviderUnitViewModel {
    id: string;
    name?: string | undefined;
    externalId?: string | undefined;
    description?: string | undefined;
    companyId?: string | undefined;
    departmentUuid?: string | undefined;
}

export interface OfferDetailsViewModel {
    offerId: string;
    company?: CompanyViewModel | undefined;
    category?: CategoryViewModel | undefined;
    offerIdentifier?: number | undefined;
    offerStatus?: OfferStatusViewModel | undefined;
    offerType?: OfferTypeViewModel | undefined;
    title?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    responsibleUser?: ResponsibleUserViewModel | undefined;
    responsibleTeam?: ResponsibleTeamViewModel | undefined;
    externalOperatorAgreementId?: string | undefined;
    externalOperatorAgreementName?: string | undefined;
    internalDescription?: string | undefined;
    suggestedActivityDescription?: string | undefined;
    offerApproval?: OfferApprovalViewModel | undefined;
    offerFollowup?: OfferFollowupViewModel | undefined;
    seatCalculation?: SeatCalculationViewModel | undefined;
    offerAddress?: OfferAddressViewModel | undefined;
    contactPerson?: OfferContactPersonViewModel | undefined;
    targetAgeFrom?: number | undefined;
    targetAgeTo?: number | undefined;
    targetGroups?: TargetGroupViewModel[] | undefined;
    importantTag?: ImportantTagViewModel | undefined;
    offerTag?: OfferTagViewModel | undefined;
    healthOffer?: HealthOfferViewModel | undefined;
    mentorOffer?: MentorOfferViewModel | undefined;
    courseOffer?: CourseOfferViewModel | undefined;
    companyOffer?: CompanyOfferViewModel | undefined;
    personalAssistanceOffer?: PersonalAssistanceOfferViewModel | undefined;
    socialEffortOffer?: SocialEffortOfferViewModel | undefined;
    helpingDeviceOffer?: HelpingDeviceOfferViewModel | undefined;
    activities?: ActivityListItemViewModel2[] | undefined;
    offerGroup?: OfferGroupListItemViewModel | undefined;
    socialProviderUnit?: SocialProviderUnitViewModel | undefined;
    departmentUuid?: string | undefined;
    maxActiveResourcesPerActivity?: number | undefined;
    hasWaitingList: boolean;
}

export interface CountryCodeListDto {
    id: string;
    name?: string | undefined;
}

export interface TargetGroupCodeListDto {
    id: string;
    name?: string | undefined;
}

export interface PlacementPurposeCodeListDto {
    id: string;
    name?: string | undefined;
    suggestedReasonForActivity?: string | undefined;
    offerTypeIds?: string[] | undefined;
    purposeOfCompanyInternshipTypeId?: string | undefined;
}

export interface DriversLicenseCodeListDto {
    id: string;
    name?: string | undefined;
    active: boolean;
    description?: string | undefined;
    externalId?: string | undefined;
}

export interface AmuCodeListDto {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    externalId?: string | undefined;
}

export interface DunCodeListDto {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    externalId?: string | undefined;
}

export interface KyOfferCodeListDto {
    id: string;
    name?: string | undefined;
    active: boolean;
    kyCode?: string | undefined;
}

export interface JobAllocationCodeListDto {
    id: string;
    name?: string | undefined;
    active: boolean;
}

export interface JobOrderPriceHourCodeListDto {
    id: string;
    name?: string | undefined;
    active: boolean;
    externalId?: string | undefined;
    description?: string | undefined;
}

export interface PurposeOfCompanyInternshipCodeListDto {
    id: string;
    name?: string | undefined;
    active: boolean;
    description?: string | undefined;
    externalId?: string | undefined;
}

export interface JobOrderCodeListDto {
    id: string;
    name?: string | undefined;
    externalId?: string | undefined;
    offerTypeId?: string | undefined;
    kyOfferType?: string | undefined;
    hiringOrganisationType?: number | undefined;
    jobAllocationIds?: string[] | undefined;
    isActive: boolean;
}

export interface MentorTypeListDto extends KyTypesListDtoBase {
}

export interface HelpingDeviceCodeListDto {
    id: string;
    name?: string | undefined;
    isActive: boolean;
    externalId?: string | undefined;
    description?: string | undefined;
}

export interface JobOfferTypeCodeListDto {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    isActive: boolean;
}

export interface AuthorityAreaTypeCodeListDto {
    id: string;
    name?: string | undefined;
    isActive: boolean;
    description?: string | undefined;
}

export interface JobOfferTypeAuthorityAreaTypeCodeListDto {
    id: string;
    name?: string | undefined;
    jobOfferTypeId: string;
    authorityAreaTypeId: string;
    offerTypeId: string;
    kyOfferTypeId?: string | undefined;
}

export interface JobOfferTypeJobAllocationTypeCodeListDto {
    id: string;
    name?: string | undefined;
    jobOfferTypeId: string;
    authorityAreaTypeId?: string | undefined;
    jobAllocationTypeId: string;
}

export interface SocialProviderUnitLookupDto {
    id: string;
    name?: string | undefined;
    externalId?: string | undefined;
    description?: string | undefined;
    companyId?: string | undefined;
    departmentUuid?: string | undefined;
}

export interface OfferDetailsForActivityViewModel {
    offerId: string;
    category?: CategoryViewModel | undefined;
    offerType?: OfferTypeViewModel | undefined;
    title?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    suggestedActivityDescription?: string | undefined;
    company?: CompanyViewModel | undefined;
    offerAddress?: OfferAddressViewModel | undefined;
    contactPerson?: OfferContactPersonViewModel | undefined;
    offerPriceCalculation?: OfferPriceCalculationViewModel | undefined;
    isActivityApprovalRequired: boolean;
    importantTag?: ImportantTagViewModel | undefined;
    companySpecialCircumstances?: CompanySpecialCircumstanceViewModel[] | undefined;
    educationType?: number | undefined;
    openOffer?: boolean | undefined;
    availabilityProving?: boolean | undefined;
    education?: EducationViewModel | undefined;
    companyOffer?: CompanyOfferViewModel | undefined;
    helpingDeviceOffer?: HelpingDeviceOfferViewModel | undefined;
    hasRelatedSupplierPlatformOffer?: boolean | undefined;
    allowActivityPriceChanges: boolean;
    allowActivityPriceCorrections: boolean;
    monetaryTrivialityLimit?: number | undefined;
    offerFollowup?: OfferFollowupViewModel | undefined;
    externalOperatorAgreementId?: string | undefined;
    offerStatus: number;
    serviceProviderUnit?: SocialProviderUnitViewModel | undefined;
    maxActiveResourcesPerActivity?: number | undefined;
    hasWaitingList?: boolean | undefined;
    defaultPlacementDays?: number | undefined;
    maxDeviationFromDefaultDays?: number | undefined;
}

export interface OfferSimpleDetailsDto {
    offerId: string;
    title?: string | undefined;
    offerType?: OfferTypeCodeListDto | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    category?: CategoryDto | undefined;
    status?: string | undefined;
    offerIdentifier?: number | undefined;
    companyName?: string | undefined;
    deadlineForPlacementExceeded?: boolean | undefined;
    vitasCaseId?: string | undefined;
    companyId?: string | undefined;
    responsibleTeamId?: string | undefined;
    responsibleUserId?: string | undefined;
    availableSeats?: number | undefined;
    internalDescription?: string | undefined;
    capacity?: number | undefined;
}

export interface CategoryDto {
    id: number;
    description?: string | undefined;
}

export interface OfferGroupViewModel {
    offerGroupId: string;
    name?: string | undefined;
    offerGroupIdentifier?: string | undefined;
    active: boolean;
}

export interface OfferPriceGuideInfoViewModel {
    offerId: string;
    offerIdentifier?: number | undefined;
    offerName?: string | undefined;
    offerCategory?: OptionValueViewModel | undefined;
    priceModel?: OptionValueViewModel | undefined;
    isPriceModelInitialRateEnabled: boolean;
    priceModelInitialRate?: number | undefined;
    unitPrice?: number | undefined;
    currentPriceStartDate?: Date | string | undefined;
    ongoingActivityIds?: string[] | undefined;
    historicActivityIds?: string[] | undefined;
}

export interface OptionValue2 {
    value: number;
    text?: string | undefined;
}

export interface OfferPriceViewModel {
    offerPriceId: string;
    priceModel?: OptionValueViewModel | undefined;
    priceModelInitialRate?: number | undefined;
    unitPrice?: number | undefined;
    startDate: Date | string;
    status: number;
    updateOngoingActivities: boolean;
    updateHistoricActivities: boolean;
}

export interface OfferResourceViewModel {
    offerResourceId: string;
    organizationUserId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    weeklyCapacityHours: number;
    weeklyCapacityMinutes: number;
    isActive: boolean;
    displayName?: string | undefined;
    createdOn?: Date | string | undefined;
    createdBy?: string | undefined;
    offerTitle?: string | undefined;
    offerIdentifier?: string | undefined;
    currentlyAllocatedHours: number;
    availableHours: number;
    activeAffectedActivities?: AffectedActivityViewModel[] | undefined;
}

export interface AffectedActivityViewModel {
    activityId: string;
    title?: string | undefined;
}

export interface OfferListItemViewModel {
    offerId: string;
    offerNumber?: number | undefined;
    title?: string | undefined;
    offerTypeName?: string | undefined;
    validFrom?: Date | string | undefined;
    validTo?: Date | string | undefined;
    category?: CategoryViewModel | undefined;
    status?: string | undefined;
    vitasCaseId?: string | undefined;
}

export interface ReimbursementViewModel {
    reimbursementId: string;
    activityId: string;
    title?: string | undefined;
    reimbursementType: number;
    startDate: Date | string;
    endDate: Date | string;
    actualExpense?: number | undefined;
    amount?: number | undefined;
    dailyTransportInKilometers?: number | undefined;
    description?: string | undefined;
    isTransportReimbursementManualEntered?: boolean | undefined;
    isExpenseDueToDisability?: boolean | undefined;
    isIncludingFerry?: boolean | undefined;
    periodic: boolean;
    prePayed: boolean;
    workDays?: number | undefined;
    totalReimbursement?: number | undefined;
}

export interface ReimbursementListItemViewModel {
    id: string;
    name?: string | undefined;
    reimbursementType?: string | undefined;
    startDate: Date | string;
    endDate: Date | string;
}

export interface SuggestedVitasFieldsForCancelActivityViewModel {
    suggestedVitasUpdateActivityStatusCause?: ActivityStatusCauseCodeListViewModel | undefined;
    suggestedVitasUpdateCauseOfDiscontinuationComment?: string | undefined;
    suggestedVitasUpdateEndDate?: Date | string | undefined;
}

export interface ActivityStatusCauseCodeListViewModel {
    id: string;
    name?: string | undefined;
    externalId?: string | undefined;
}

export interface SuggestedDatesAndDuration {
    startDate: Date | string;
    endDate: Date | string;
    duration: number;
}

export interface OaTeamViewModel {
    teamId: string;
    teamName?: string | undefined;
    businessUnitName?: string | undefined;
}

export interface WaitingListActivityValidationViewModel {
    isBlocked: boolean;
    isCurrentUserOfferResponsible: boolean;
    offerResponsibleUserName?: string | undefined;
    offerResponsibleUserEmail?: string | undefined;
    activeWaitingListSeatCount: number;
}

export interface WaitingListSeatDetailViewModel {
    waitingListSeatId: string;
    offerId: string;
    offerTitle?: string | undefined;
    citizenId: string;
    caseId: string;
    addedOn: Date | string;
    addedBy?: AddedByViewModel | undefined;
    status: WaitingListSeatStatus;
    comment?: string | undefined;
    relatedActivityId?: string | undefined;
    relatedActivityTitle?: string | undefined;
    createdOn: Date | string;
    createdBy?: WaitingListSeatCreatedByViewModel | undefined;
    modifiedOn: Date | string;
    modifiedBy?: WaitingListSeatModifiedByViewModel | undefined;
}

export interface AddedByViewModel {
    id: string;
    name?: string | undefined;
}

export interface WaitingListSeatCreatedByViewModel {
    id: string;
    name?: string | undefined;
}

export interface WaitingListSeatModifiedByViewModel {
    id: string;
    name?: string | undefined;
}

export interface CitizenWaitingListSeatViewModel {
    waitingListSeatId: string;
    offerId: string;
    offerTitle?: string | undefined;
    addedOn: Date | string;
    status: WaitingListSeatStatus;
}

export interface WaitingListSeatViewModel {
    waitingListSeatId: string;
    offerId: string;
    citizenId: string;
    addedOn: Date | string;
    addedBy?: AddedByViewModel | undefined;
    status: WaitingListSeatStatus;
    comment?: string | undefined;
    relatedActivityId?: string | undefined;
    relatedActivityTitle?: string | undefined;
    createdOn: Date | string;
    createdBy?: WaitingListSeatCreatedByViewModel | undefined;
    modifiedOn: Date | string;
    modifiedBy?: WaitingListSeatModifiedByViewModel | undefined;
}

export interface NegativeEventTypeViewModel {
    id: string;
    name?: string | undefined;
}

export interface ValidationResult {
    isValid: boolean;
    hasErrors: boolean;
    validationMessages?: ValidationMessage[] | undefined;
}

export enum CoPaymentAmountType {
    Monthly = "monthly",
    Daily = "daily",
}

export interface PrecedingCoPaymentSummary {
    coPaymentId: string;
    coPaymentTypeId: string;
    startDate: Date | string;
    endDate: Date | string;
}

export interface CoPaymentRevisionsSummary {
    count: number;
    latestRevision?: CoPaymentRevisionSummary | undefined;
}

export interface CoPaymentRevisionSummary {
    coPaymentId: string;
    startDate: Date | string;
    createdByName?: string | undefined;
}

export interface CoPaymentParagraph107Dto {
    monthlyIncomeBasis: number;
    monthlyCostBasedCoPayment: number;
    necessaryExpenses: number;
    desiredMonthlyDisposableAmount: number;
    monthlyCoPaymentReduction: number;
    reductionRemark?: string | undefined;
}

export interface CoPaymentParagraph108Dto {
    annualIncomeBasis: number;
    progressionLimit: number;
    monthlyIncomeBasedCoPayment: number;
    monthlyCostBasedCoPayment: number;
    calculatedMonthlyCoPayment: number;
    desiredMonthlyDisposableAmount: number;
    monthlyCoPaymentReduction: number;
    reductionRemark?: string | undefined;
    monthlyElectricityCost: number;
    electricityCostDetails?: string | undefined;
    monthlyHeatingCost: number;
    heatingCostDetails?: string | undefined;
}

export enum CoPaymentStatus {
    Active = "active",
    Cancelled = "cancelled",
}

export interface CoPaymentParagraph108Configuration {
    yearlyConfigurations?: YearlyConfigurationEntry[] | undefined;
}

export interface YearlyConfigurationEntry {
    year: number;
    progressionLimit: number;
    incomeProjection?: number | undefined;
    singlePersonDeduction?: number | undefined;
}

export interface TemplateListItemViewModel {
    codeName?: string | undefined;
    label?: string | undefined;
    name?: string | undefined;
    value?: TemplateListItemValue | undefined;
}

export interface TemplateListItemValue {
    templateId: number;
    variantId?: number | undefined;
}

export interface CoPaymentTemplateEnumDto {
    value: CoPaymentTemplate;
    name?: string | undefined;
}

export interface CoPaymentAmountTypeEnumDto {
    value: CoPaymentAmountType;
    name?: string | undefined;
}

export interface BillingPrincipleEnumDto {
    value: BillingPrinciple;
    name?: string | undefined;
}

export interface BillingTypeEnumDto {
    value: BillingType;
    name?: string | undefined;
}

export interface PsrmReceivableTypeEnumDto {
    value: PsrmReceivableType;
    name?: string | undefined;
}

export interface FinanceClassificationValueDto {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    externalId: string;
}

export interface CoPaymentTypeViewModel {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    coPaymentTemplate: CoPaymentTemplate;
    accountNumber?: string | undefined;
    helpText?: string | undefined;
    defaultBillingType: BillingType;
    defaultBillingPrinciple?: BillingPrinciple | undefined;
    dailyRate?: number | undefined;
    documentTemplateCode?: string | undefined;
}

export interface CoPaymentReceivableViewModel {
    id: string;
    coPaymentId: string;
    rowType: CoPaymentReceivableRowType;
    template: CoPaymentTemplate;
    startDate: Date | string;
    endDate: Date | string;
    month?: string | undefined;
    billingType: BillingType;
    billingPrinciple?: BillingPrinciple | undefined;
    receivableAmount: number;
    firstBillingAdjustment?: number | undefined;
    lastBillingAdjustment?: number | undefined;
    description?: string | undefined;
    accountNumber?: string | undefined;
    dispatchStatus: CoPaymentReceivableDispatchStatus;
}

export enum CoPaymentReceivableRowType {
    Receivable = "receivable",
    DownwardAdjustment = "downwardAdjustment",
}

export enum CoPaymentReceivableDispatchStatus {
    Pending = "pending",
    BeingDispatched = "beingDispatched",
    Dispatched = "dispatched",
}

export interface CoPaymentListItemDto {
    id: string;
    coPaymentTypeId: string;
    coPaymentTemplate: CoPaymentTemplate;
    description?: string | undefined;
    amount: number;
    amountType: CoPaymentAmountType;
    billingType: BillingType;
    billingPrinciple?: BillingPrinciple | undefined;
    startDate: Date | string;
    endDate: Date | string;
    firstBillingAdjustment: number;
    lastBillingAdjustment: number;
    createdBy: string;
    createdOn: Date | string;
    modifiedBy: string;
    modifiedOn: Date | string;
}

export interface DebitorRegistrationErrorCodeDto {
    code?: string | undefined;
    title?: string | undefined;
    objectReference?: string | undefined;
}

export interface InterventionCostParagraphModel {
    paragraph: string;
    name: string;
    years: InterventionCostYearModel[];
}

export interface InterventionCostYearModel {
    year: number;
    internal: number;
    external: number;
    total: number;
    activitiesWithoutPrice: number;
}

export interface InterventionLadderStepModel {
    step: number;
    title: string;
    grants: number;
    citizens: number;
    personYears: number;
    arrivals: number;
    departures: number;
    moves: InterventionLadderMovesModel;
    cost: InterventionLadderCostModel;
    suppliers: InterventionLadderSuppliersModel;
    paragraphs: InterventionLadderParagraphModel[];
}

export interface InterventionLadderMovesModel {
    stayed: number;
    down: number;
    up: number;
    ended: number;
}

export interface InterventionLadderCostModel {
    internal: number;
    external: number;
    total: number;
    activitiesWithoutPrice: number;
}

export interface InterventionLadderSuppliersModel {
    internal: number;
    external: number;
    total: number;
    activitiesWithUnknownSupplier: number;
}

export interface InterventionLadderParagraphModel {
    paragraph: string;
    name: string;
}

export interface InterventionLadderTotalModel {
    citizens: number;
    personYears: number;
    cost: InterventionLadderCostModel;
}

export enum InterventionLadderPeriod {
    Last12Months = "last12Months",
    ThisYear = "thisYear",
    LastYear = "lastYear",
    YearBefore = "yearBefore",
}

export enum InterventionLengthUnit {
    Months = "months",
    Years = "years",
}

export interface InterventionLengthParagraphModel {
    paragraph: string;
    name: string;
    years: InterventionLengthYearModel[];
}

export interface InterventionLengthYearModel {
    year: number;
    intervals: InterventionLengthIntervalModel[];
    averageDays?: number | undefined;
}

export interface InterventionLengthIntervalModel {
    from: number;
    to?: number | undefined;
    citizens: number;
}

export enum InterventionLengthCourses {
    Active = "active",
    Ended = "ended",
}

export interface UserViewModel {
    userIdentifier: string;
    displayName?: string | undefined;
    searchSubText?: string | undefined;
    isDisabled?: boolean | undefined;
    teamId?: string | undefined;
}

export interface TeamViewModel {
    id: string;
    displayName?: string | undefined;
    isDisabled?: boolean | undefined;
}

export interface OfferLookupDto {
    offerId: string;
    title?: string | undefined;
    offerType?: OfferTypeCodeListDto | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    category?: CategoryDto | undefined;
    status?: string | undefined;
    offerIdentifier?: number | undefined;
    companyName?: string | undefined;
    deadlineForPlacementExceeded?: boolean | undefined;
    vitasCaseId?: string | undefined;
    companyId?: string | undefined;
}

export interface OfferForOfferTypeLookupDto {
    offerId: string;
    title?: string | undefined;
    offerIdentifier?: number | undefined;
    companyName?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    category?: CategoryDto | undefined;
    vitasCaseId?: string | undefined;
}

export interface ContactPersonViewModel2 {
    id: string;
    name?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    accountName?: string | undefined;
    isPrivateContact?: boolean | undefined;
    companyId?: string | undefined;
}

export interface CompanyModel {
    id: string;
    name?: string | undefined;
    productionUnitIdentifier?: string | undefined;
    cvrNumber?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    floorIdentifier?: string | undefined;
    suiteIdentifier?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    phoneNumber?: string | undefined;
    primaryTradeCodeName?: string | undefined;
}

export interface CompanyLookupModel {
    id: string;
    name?: string | undefined;
    productionUnitIdentifier?: string | undefined;
    cvrNumber?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    floorIdentifier?: string | undefined;
    suiteIdentifier?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface CitizenLookup {
    citizenId: string;
    cpr?: string | undefined;
    fullName?: string | undefined;
}

export interface CitizenCaseLookup {
    caseName?: string | undefined;
    caseId: string;
    isPrimaryCase: boolean;
    caseStatus: CaseLookupStatus;
}

export enum CaseLookupStatus {
    Active = "active",
    Finished = "finished",
    NeedsToBeTerminated = "needsToBeTerminated",
}

export interface TaskContext {
    contextType: ContextType;
    contextId?: string | undefined;
}

export enum ContextType {
    Citizen = "citizen",
    Company = "company",
    IncomingMail = "incomingMail",
    Crm = "crm",
    General = "general",
}

export interface IncomingMailTask {
    createdOn?: Date | string | undefined;
    id: string;
    title?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | string | undefined;
    taskStatus: TaskStatus;
    createdByUserId?: string | undefined;
    createdByTeamId?: string | undefined;
    taskMetadataDto?: TaskMetadataDto | undefined;
    taskTypeDto: TaskTypeDto;
    categoryName?: string | undefined;
    responsibleCaseWorkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
}

export enum TaskTypeDto {
    Opgave = "opgave",
    Advis = "advis",
}

export interface IncomingMailAttachment {
    id: string;
    title?: string | undefined;
    fileName?: string | undefined;
    fileSize: number;
    dateAdded: Date | string;
    blobReference?: string | undefined;
    owner?: string | undefined;
}

export interface GeneralTask {
    createdOn?: Date | string | undefined;
    id: string;
    title?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | string | undefined;
    responsibleCaseWorkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
    taskType: TaskTypeDto;
    taskStatus: TaskStatus;
    relatedEntity?: DomainRelatedEntity | undefined;
    relatedEntityLink?: string | undefined;
    createdByUserId?: string | undefined;
    createdByTeamId?: string | undefined;
    vitasUrl?: string | undefined;
    categoryName?: string | undefined;
    categoryId?: string | undefined;
    taskMetadata?: TaskMetadataDto | undefined;
    taskActions?: TaskActionModel[] | undefined;
}

export interface DomainRelatedEntity {
    id: string;
    name?: string | undefined;
}

export interface JobAdsMunipalityModel {
    name?: string | undefined;
    externalIdentifier?: string | undefined;
}

export interface JobAdsCountryModel {
    name?: string | undefined;
    code?: string | undefined;
}

export interface CaseworkerAbsenceModel {
    absenceId: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    text?: string | undefined;
}

export enum ChatFilterType {
    None = "none",
    PartOf = "partOf",
    Inactive = "inactive",
    Active = "active",
    ContainsUnreadMessages = "containsUnreadMessages",
}

export interface ChatAttachmentModel {
    content?: string | undefined;
    contentType?: string | undefined;
    fileName?: string | undefined;
}

export interface ChatModel {
    id: string;
    currentUserId: string;
    isActive: boolean;
    title?: string | undefined;
    caseworker?: ForumCaseworkerModel | undefined;
    absenceStatus?: CaseworkerAbsenceStatusModel | undefined;
    citizen?: CitizenModel | undefined;
    contacts?: ContactModel[] | undefined;
    case?: CaseModel2 | undefined;
    creationDate: Date | string;
    lastActivityDate: Date | string;
    latestJournalizationDate?: Date | string | undefined;
    isConfidential: boolean;
    isPartOf: boolean;
    chatMessages?: ChatMessageModel[] | undefined;
    secondaryCaseworkers?: ForumCaseworkerModel[] | undefined;
}

export interface ForumCaseworkerModel {
    id: string;
    name?: string | undefined;
}

export interface CaseworkerAbsenceStatusModel {
    startDate: Date | string;
    endDate?: Date | string | undefined;
    text?: string | undefined;
}

export interface CitizenModel {
    id: string;
    externalId?: string | undefined;
    name?: string | undefined;
    cpr?: string | undefined;
    hasApp: boolean;
    latestAppActivity?: Date | string | undefined;
}

export interface ContactModel {
    id: string;
    externalId: string;
    name?: string | undefined;
    role?: string | undefined;
    cpr?: string | undefined;
    contactType?: string | undefined;
}

export interface CaseModel2 {
    id: string;
    title?: string | undefined;
}

export interface ChatMessageModel {
    id: string;
    writerUserId: string;
    content?: string | undefined;
    attachmentMetaData?: AttachmentMetaDataModel | undefined;
    isAttachmentUnavailable: boolean;
    seenByUserIds?: string[] | undefined;
    creationDate: Date | string;
}

export interface SelectableItemModel {
    id: string;
    title?: string | undefined;
}

export enum ChatSort {
    CreationDate = "creationDate",
    LatestActivityDate = "latestActivityDate",
    CitizenCpr = "citizenCpr",
    CitizenName = "citizenName",
}

export interface CitizenContextModel {
    id: string;
    externalId: string;
    name?: string | undefined;
    cpr?: string | undefined;
    creationDate: Date | string;
    hasApp: boolean;
    latestAppActivity?: Date | string | undefined;
    appCreationDate?: Date | string | undefined;
    canCreateChats: boolean;
}

export interface CitizenAppStatusModel {
    citizenId: string;
    hasApp: boolean;
}

export interface UserContextModel {
    fasitUserId?: string | undefined;
    displayName?: string | undefined;
    roles?: string[] | undefined;
    addons?: AddonModel | undefined;
}

export interface AddonModel {
    isConfidentialChatsEnabled: boolean;
    isCitizenChatCreationEnabled: boolean;
    isFileUploadEnabled: boolean;
    isFeedbackEnabled: boolean;
    isFileUploadEnabledForNewsItems: boolean;
}

export interface NewsItemModel {
    id: string;
    title?: string | undefined;
    content?: string | undefined;
    url?: string | undefined;
    creationDate: Date | string;
    modificationDate?: Date | string | undefined;
    showFromDate: Date | string;
    expirationDate?: Date | string | undefined;
    author?: string | undefined;
    citizenHasRead: boolean;
    showToAll: boolean;
    canDelete: boolean;
    attachments?: AttachmentMetaDataModel[] | undefined;
}

export interface NewsAttachmentModel {
    content?: string | undefined;
    contentType?: string | undefined;
}

export interface NewsCitizenModel {
    citizenId: string;
    name?: string | undefined;
    cpr?: string | undefined;
    date?: Date | string | undefined;
}

export interface NudgeCitizenModel {
    citizenId: string;
    name?: string | undefined;
    cpr?: string | undefined;
}

export interface NudgeQuestionnaireOfferModel {
    id: string;
    name?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
}

export interface NudgeQuestionnaireModel {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    pseudoFasitEntityDiscriminator: PseudoFasitEntityDiscriminatorEnum;
}

export interface ExternalOperatorAgreementViewModel {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    companyId?: string | undefined;
    companyName?: string | undefined;
}

export interface AgreementForListViewModel {
    id: string;
    title?: string | undefined;
    startDate: Date | string;
    endDate: Date | string;
    externalOperatorCompanyId: string;
    externalOperatorCompanyName?: string | undefined;
    teamId?: string | undefined;
    teamName?: string | undefined;
}

export interface AgreementForReferralModel {
    id: string;
    title?: string | undefined;
    startDate: Date | string;
    endDate: Date | string;
    externalOperatorCompanyId: string;
    externalOperatorCompanyName?: string | undefined;
    teamId?: string | undefined;
    teamName?: string | undefined;
    referralReason?: string | undefined;
    description?: string | undefined;
}

export interface ExternalOperatorCompany {
    id: string;
    companyId: string;
    companyName?: string | undefined;
    pNumber?: string | undefined;
    defaultResponsibleTeamId: string;
    teamName?: string | undefined;
    isActive: boolean;
}

export interface BusinessConfigurationItem {
    id: string;
    name?: string | undefined;
    isActive: boolean;
}

export interface OutgoingDocumentType extends BusinessConfigurationItem {
    envelopeType?: number | undefined;
    postalCategory?: number | undefined;
    printColorType?: number | undefined;
    simplexDuplexType?: number | undefined;
}

export interface ReferralForListViewModel {
    referralId: string;
    citizenId: string;
    createdOn: Date | string;
    createdById: string;
    createdByDisplayName?: string | undefined;
    caseWorkerName?: string | undefined;
    startDate: Date | string;
    endDate: Date | string;
    status: ReferralStatus;
    agreement?: AgreementForReferralListViewModel | undefined;
}

export interface AgreementForReferralListViewModel {
    agreementId: string;
    title: string;
}

export interface ResponsibilityArea extends BusinessConfigurationItem {
    description?: string | undefined;
}

export interface DynamicLink {
    resourceType?: string | undefined;
    text?: string | undefined;
    url?: string | undefined;
    tooltip?: string | undefined;
    disabled: boolean;
    postRequestType?: PostRequestType | undefined;
    autoSubmitPostRequest?: boolean | undefined;
}

export enum PostRequestType {
    Sapa = "sapa",
    Candeno = "candeno",
    UnoUng = "unoUng",
    Nova = "nova",
    NfsMediConnect = "nfsMediConnect",
    DigitalSamtykke = "digitalSamtykke",
}

export interface MergeData {
    key?: string | undefined;
    value?: string | undefined;
}

export interface FilingDeliveryDetails {
    id: string;
    filingIdentifier?: FilingIdentifier | undefined;
    fileName?: string | undefined;
    deliveryNumber: number;
    createdDate: Date | string;
    currentStatus?: FilingDeliveryStatusEntry | undefined;
    createdById: string;
    createdByName?: string | undefined;
    statuses?: FilingDeliveryStatusEntry[] | undefined;
}

export interface FilingIdentifier {
    filingType: FilingType;
    filingMonth?: FilingMonth | undefined;
}

export interface FilingMonth {
    yearMonth?: string | undefined;
    dstFormattedPeriod?: string | undefined;
}

export interface FilingDeliveryStatusEntry {
    timeStamp: Date | string;
    status: FilingDeliveryStatus;
    id: string;
    filingDeliveryId: string;
}

export enum FilingDeliveryStatus {
    Preparing = "preparing",
    ReadyToBeShipped = "readyToBeShipped",
    Shipping = "shipping",
    Shipped = "shipped",
    Failed = "failed",
}

export interface HandicapDelivery {
    metadataJson?: string | undefined;
    benefits?: HandicapBenefitRow[] | undefined;
    errors?: ErrorDto[] | undefined;
}

export interface HandicapBenefitRow {
    citizenId: string;
    personCivilRegistrationId?: string | undefined;
    benefitTypeDSTName?: string | undefined;
    benefitTypeFFBName?: string | undefined;
    benefitTypeFFBId?: string | undefined;
    primaryAssessmentTopicFFBName?: string | undefined;
    primaryAssessmentTopicFFBId?: string | undefined;
    socialOfferFFBName?: string | undefined;
    socialOfferFFBId?: string | undefined;
    departmentUuid?: string | undefined;
    additionalAssessmentTopicFFBNames?: string[] | undefined;
    id: string;
    grantId: string;
    reportAs?: string | undefined;
    activityId?: string | undefined;
    benefitTypeId?: string | undefined;
    benefitRecipientCode?: string | undefined;
    primaryAssessmentTopicId: string;
    primaryAssessmentTopicDSTCode?: string | undefined;
    socialOfferId?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    companyProductionUnitIdentifier?: string | undefined;
    additionalAssessmentTopicIds?: string[] | undefined;
}

export interface ErrorDto {
    category: ErrorCategory;
    message?: string | undefined;
}

export enum ErrorCategory {
    System = "system",
    Metadata = "metadata",
    Grant = "grant",
    Citizen = "citizen",
    Benefit = "benefit",
    DocumentStore = "documentStore",
    Xml = "xml",
}

export interface MessageCenterConfigurationModel {
    id: string;
    date?: Date | string | undefined;
    title: string;
    message: string;
    showFrom?: Date | string | undefined;
    showTo?: Date | string | undefined;
    urgent: boolean;
    updated?: Date | string | undefined;
    updateMessage?: string | undefined;
    solvedDate?: Date | string | undefined;
    severity?: string | undefined;
    type?: string | undefined;
    changedBy?: string | undefined;
    tags?: string[] | undefined;
    displayTargets?: DisplayTarget[] | undefined;
}

export enum DisplayTarget {
    Fasit = "Fasit",
    MinIndgang = "minindgang.dk",
    Forum = "Forum",
}

export interface SocialCaseConfiguration {
    municipalityFieldsRequired: MunicipalityFieldRequirement;
}

export enum MunicipalityFieldRequirement {
    AlwaysOptional = "alwaysOptional",
    AlwaysMandatory = "alwaysMandatory",
    MandatoryWhenDifferentMunicipality = "mandatoryWhenDifferentMunicipality",
}

export interface RulingConfiguration {
    validateHearingSubmissionJournalNoteIds?: boolean | undefined;
}

export interface AuthorityCitizenOpticSelection {
    enabled: boolean;
    availableOptics?: string[] | undefined;
    defaultOptic?: string | undefined;
    socialOpticInterviewTypeCodes?: number[] | undefined;
    opticBadgeLetters?: { [key: string]: string; } | undefined;
}

export interface FormbricksConfiguration {
    disabled: boolean;
    excludedUsers?: string[] | undefined;
}

export interface ServiceProviderCalendarBusinessHours {
    daysOfWeek?: number[] | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
}

export interface TradeCodeOptionModel {
    id: string;
    name?: string | undefined;
    code?: string | undefined;
}

export interface TradeCodeModel {
    id: string;
    companyId: string;
    tradeCode: string;
    origin: TradeCodeOrigin;
    name?: string | undefined;
    displayName?: string | undefined;
}

export interface TagModel {
    id: string;
    companyId: string;
    tagTypeId: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    name?: string | undefined;
}

export interface TagTypeOptionModel {
    id: string;
    name?: string | undefined;
}

export interface AccountGroup extends BusinessConfigurationItem {
    description?: string | undefined;
}

export interface CompanyBasicInfo {
    id: string;
    name?: string | undefined;
    cvrNumber?: string | undefined;
    productionUnitId?: string | undefined;
    primaryBusiness?: string | undefined;
    isIrrelevant: boolean;
}

export interface CompanyAttentionNoteModel {
    note?: string | undefined;
    changedOn?: Date | string | undefined;
    changedBy?: string | undefined;
    changedByDisplayName?: string | undefined;
    expiresOn?: Date | string | undefined;
}

export interface CompanyDialogTaskDto {
    type?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    followUpDate?: Date | string | undefined;
    appointmentDate?: Date | string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    contactPersonName?: string | undefined;
    quote?: string | undefined;
}

export interface CompanyAppointmentData {
    taskId: string;
    title?: string | undefined;
    appointmentDate?: Date | string | undefined;
    description?: string | undefined;
    scheduledStartTime?: string | undefined;
    scheduledEndTime?: string | undefined;
    interactionPurposeId?: string | undefined;
    contactPerson?: string | undefined;
    contactType?: ContactType | undefined;
}

export enum ContactType {
    Default = "Default",
    Telefon = "Telefon",
    Email = "Email",
    Brev = "Brev",
    Fax = "Fax",
    Andet = "Andet",
    Besoeg = "Besøg",
    Digitalt = "Digitalt",
}

export interface CompanyDialogCitizenSuggestion {
    citizenId: string;
    name?: string | undefined;
    offerTypeName?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
}

export interface CompanyDialogPartialTranscriptionDto {
    id: string;
    order: number;
    status?: string | undefined;
    transcriptionText?: string | undefined;
    createdAt: Date | string;
}

export interface CompanyInteractionNoteDto {
    id: string;
    companyId: string;
    companyContactPersonId?: string | undefined;
    contactPersonTitle?: string | undefined;
    companyNoteContactType: ContactType;
    interactionDate: Date | string;
    interactionPurposeId?: string | undefined;
    primaryInteractionResultTypeId?: string | undefined;
    title?: string | undefined;
    noteAsPlain?: string | undefined;
    noteAsHtml?: string | undefined;
    caseWorkerId: string;
    relatedJournalNoteId?: string | undefined;
    relatedCitizenId?: string | undefined;
    interactions?: CompanyNoteInteractionResultDto[] | undefined;
}

export interface CompanyNoteInteractionResultDto {
    id: string;
    companyNoteId: string;
    interactionResultTypeId: string;
}

export interface CompanyInteractionNoteListItemDto {
    id: string;
    companyId: string;
    interactionDate: Date | string;
    companyNoteContactType: ContactType;
    interactionPurpose?: string | undefined;
    primaryInteractionResult?: string | undefined;
    noteTitle?: string | undefined;
    caseWorkerName?: string | undefined;
    contactPersonTitle?: string | undefined;
    noteAsPlain?: string | undefined;
}

export interface CompanyContactPersonDto {
    label?: string | undefined;
    value: string;
    name?: string | undefined;
    email?: string | undefined;
}

export interface FvdbContactModel {
    virkKonId?: string | undefined;
    dataOwner?: string | undefined;
    dataOwnersId?: string | undefined;
    contactDate?: string | undefined;
    centerPNumber: number;
    centerPersonFirstName?: string | undefined;
    centerPersonLastName?: string | undefined;
    centerPersonPhone?: string | undefined;
    centerPersonEmail?: string | undefined;
    centerPersonTitle?: string | undefined;
    compPNumber: number;
    compPersonTitle?: string | undefined;
    contactType?: string | undefined;
    contactSubject?: string | undefined;
    compPersonFirstName?: string | undefined;
    compPersonLastName?: string | undefined;
    compPersonPhone?: string | undefined;
    compPersonEmail?: string | undefined;
    compCenterRelation?: string | undefined;
    compComment?: string | undefined;
}

export interface CompanyNoteModel {
    id: string;
    accountGroupId?: string | undefined;
    seNumberIdentifier?: string | undefined;
    note?: string | undefined;
    attentionNote1?: CompanyAttentionNoteModel2 | undefined;
    attentionNote2?: CompanyAttentionNoteModel2 | undefined;
    annotation1?: string | undefined;
    annotation2?: string | undefined;
    annotation3?: string | undefined;
    annotation4?: string | undefined;
    annotation5?: string | undefined;
    isIrrelevant?: boolean | undefined;
}

export interface CompanyAttentionNoteModel2 {
    note?: string | undefined;
    changedOn?: Date | string | undefined;
    changedBy?: string | undefined;
    expiresOn?: Date | string | undefined;
}

export interface MonthActivitySummaryModel {
    startDate: Date | string;
    endDate: Date | string;
    numberOfSubsidyEmployment: number;
    numberOfFlexJobs: number;
    numberOfInternships: number;
    numberOfMentor: number;
    numberOfGuidanceRetraining: number;
    headerTitle?: string | undefined;
}

export interface MonthRecruitmentSummaryModel {
    startDate: Date | string;
    endDate: Date | string;
    numberOfOrdinaryJobRecruitments: number;
    headerTitle?: string | undefined;
}

export interface CurrentMonthOfferSummaryModel {
    startDate: Date | string;
    endDate: Date | string;
    numberOfOpenSubsidyEmployment: number;
    numberOfOpenFlexJobs: number;
    numberOfOpenInternships: number;
    numberOfOpenMentor: number;
    numberOfOpenGuidanceRetraining: number;
    headerTitle?: string | undefined;
}

export interface CurrentMonthOpenJobOffersViewModel {
    startDate: Date | string;
    endDate: Date | string;
    headerTitle?: string | undefined;
    numberOfOpenJobOffers: number;
}

export interface CompanyLabourNeedModel {
    id?: string | undefined;
    companyId: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    occupationName?: string | undefined;
    jobCenterParticipationWanted?: boolean | undefined;
    positionsCount?: number | undefined;
    createdDate?: Date | string | undefined;
    createdByName?: string | undefined;
}

export interface AccountNoteModel {
    createdOn?: Date | string | undefined;
    purpose?: string | undefined;
    result?: string | undefined;
    responsibleCaseworker?: string | undefined;
    contactType?: number | undefined;
    contactTypeName?: string | undefined;
}

export interface AppointmentModel {
    id?: string | undefined;
    appointmentDate?: Date | string | undefined;
    purpose?: string | undefined;
    responsibleCaseworker?: string | undefined;
    contactTypeName?: string | undefined;
}

export interface OccupationModel {
    id: string;
    name?: string | undefined;
}

export interface OccupationQualificationModel {
    id: string;
    name?: string | undefined;
}

export interface TargetGroupModel {
    id: string;
    name?: string | undefined;
}

export interface TradeCodeModel2 {
    id: string;
    name?: string | undefined;
}

export interface ComapnyNoteModel {
    id: string;
    accountGroupId?: string | undefined;
    seNumberIdentifier?: string | undefined;
    note?: string | undefined;
    attentionNote1?: CompanyAttentionNoteModel3 | undefined;
    attentionNote2?: CompanyAttentionNoteModel3 | undefined;
    annotation1?: string | undefined;
    annotation2?: string | undefined;
    annotation3?: string | undefined;
    annotation4?: string | undefined;
    annotation5?: string | undefined;
    isIrrelevant: boolean;
}

export interface CompanyAttentionNoteModel3 {
    note?: string | undefined;
    changedOn?: Date | string | undefined;
    changedBy?: string | undefined;
    expiresOn?: Date | string | undefined;
}

export interface ContactPersonCountryCodeListDto {
    id: string;
    name?: string | undefined;
}

export interface CompanyContactPersonListItemDto {
    id: string;
    createdOn?: Date | string | undefined;
    name?: string | undefined;
    personTitle?: string | undefined;
    phoneNumber?: string | undefined;
    mobileNumber?: string | undefined;
    email?: string | undefined;
    teamName?: string | undefined;
    caseWorkerName?: string | undefined;
    isDisabled: boolean;
}

export interface PrivateContactPersonSearchResultDto {
    id: string;
    name?: string | undefined;
    personTitle?: string | undefined;
    phoneNumber?: string | undefined;
    mobileNumber?: string | undefined;
    email?: string | undefined;
    caseWorkerName?: string | undefined;
    isDisabled: boolean;
    districtName?: string | undefined;
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    postalCode?: string | undefined;
}

export interface PrivateContactPersonListItemDto {
    id: string;
    name?: string | undefined;
    personTitle?: string | undefined;
    phoneNumber?: string | undefined;
    mobileNumber?: string | undefined;
    email?: string | undefined;
    teamName?: string | undefined;
    caseWorkerName?: string | undefined;
    isDisabled: boolean;
    countryId?: string | undefined;
    districtName?: string | undefined;
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    postalCode?: string | undefined;
    countryName?: string | undefined;
}

export interface CompanyActivitiesOverviewModel {
    historyLengthInDays: number;
    futureLengthInDays: number;
    activeAndFutureActivities?: CompanyActivityModel2[] | undefined;
    historicActivities?: CompanyActivityModel2[] | undefined;
}

export interface CompanyActivityModel2 {
    id: string;
    name?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    offerType?: string | undefined;
    discoDescription?: string | undefined;
    contactGroupName?: string | undefined;
    isCreatedByJobcenter: boolean;
    responsibleAuthority?: string | undefined;
    citizenAge: number;
    url?: string | undefined;
}

export interface CompanyVisitCompanyInfoExtendedModel {
    companyName?: string | undefined;
    pNumber?: string | undefined;
    cvr?: string | undefined;
    primaryBusiness?: string | undefined;
    importantNotes?: string[] | undefined;
    specialCircumstances?: string[] | undefined;
}

export interface CompanyRecruitmentOverviewModel {
    historyLengthInDays: number;
    activeRecruitmentsNumberOfJobcenters: number;
    activeRecruitmentsInOwnJobcenter: number;
    activeRecruitments?: CompanyRecruitmentOnCompanyModel[] | undefined;
    closedRecruitmentSummary?: ClosedRecruitmentSummaryModel | undefined;
}

export interface CompanyRecruitmentOnCompanyModel {
    fasitId?: string | undefined;
    externalId?: string | undefined;
    isCreatedByOwnJobcenter: boolean;
    title?: string | undefined;
    deadline?: Date | string | undefined;
    mediationPercentage?: string | undefined;
    companyContactPerson?: string | undefined;
    responsibleJobcenter?: string | undefined;
    createdDate?: Date | string | undefined;
    mediationResponsibility?: string | undefined;
    link?: string | undefined;
    jobDescription?: string | undefined;
    responsibleCaseWorker?: string | undefined;
    responsibleCaseWorkerEmail?: string | undefined;
    responsibleCaseWorkerPhone?: string | undefined;
    internalAuthorityComment?: string | undefined;
    sharedWith?: string | undefined;
    maximumNumberOfResponses: number;
    numberOfCandidatesFromDfdg: number;
    numberOfCandidatesOfStatusActive: number;
}

export interface ClosedRecruitmentSummaryModel {
    mostRequestedOccupations?: string[] | undefined;
    hiringPercentageInJobCenter: number;
    hiringPercentage: number;
    numberOfHiringInMyJobCenter: number;
    numberOfCandidatesHired: number;
    numberOfClosedRecruitmentsInMyJobCenter: number;
    numberOfClosedRecruitments: number;
}

export interface CompanyContactModel {
    companyName?: string | undefined;
    companyAddress?: CompanyAddressModel | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    primaryContact?: CompanyPrimaryContactModel | undefined;
}

export interface CompanyAddressModel {
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    suiteIdentifier?: string | undefined;
    postalCode?: string | undefined;
    districtName?: string | undefined;
    country?: string | undefined;
}

export interface CompanyPrimaryContactModel {
    fullName?: string | undefined;
    primaryContactId: string;
    url?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
}

export interface CompanyDetailModel {
    companyGroupDescription?: string | undefined;
    primaryTradeCodeDescription?: string | undefined;
    numberOfEmployee?: string | undefined;
    numberOfEmployeesCurrentlyOnSickLeave: number;
    activeTags?: string[] | undefined;
}

export interface CompanySpecialCircumstanceModel {
    description?: string | undefined;
    specialCircumstanceId: string;
    url?: string | undefined;
}

export interface NoteAndTaskModel {
    id?: string | undefined;
    date?: Date | string | undefined;
    purpose?: string | undefined;
    descriptionTitle?: string | undefined;
    description?: string | undefined;
    contactPerson?: string | undefined;
    contactType?: string | undefined;
    responsibleCaseWorker?: string | undefined;
    responsibleCaseWorkerEmail?: string | undefined;
    responsibleCaseWorkerPhone?: string | undefined;
    isCreatedByJobcenter: boolean;
    type: NoteAndTaskType;
    primaryResult?: string | undefined;
    responsibleAuthority?: string | undefined;
    secondaryResults?: string[] | undefined;
    documents?: DocumentModel2[] | undefined;
    url?: string | undefined;
}

export enum NoteAndTaskType {
    Task = "task",
    Note = "note",
}

export interface DocumentModel2 {
    id: string;
    title?: string | undefined;
    url?: string | undefined;
}

export interface NotesAndTasksOverviewConfiguration {
    notesDaysToLookBack: number;
}

export interface CitizenCaseSearchResult {
    searchResult?: string | undefined;
    caseId: string;
}

export interface CompanyTask {
    createdOn?: Date | string | undefined;
    id: string;
    title?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | string | undefined;
    companyId: string;
    responsibleCaseWorkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
    caseId?: string | undefined;
    repetition?: Repetition2 | undefined;
    taskType: TaskType;
    taskStatus: TaskStatus;
    relatedEntity?: RelatedEntity | undefined;
    relatedEntityLink?: string | undefined;
    createdByUserId?: string | undefined;
    createdByTeamId?: string | undefined;
    vitasUrl?: string | undefined;
    categoryName?: string | undefined;
    categoryId?: string | undefined;
    taskActions?: TaskActionModel[] | undefined;
    metadata?: TaskMetadataDto | undefined;
    closedOn?: Date | string | undefined;
    closedInDays?: number | undefined;
}

export interface Repetition2 {
    repetitionUnit: RepetitionUnit2;
    interval: number;
    maxRepetitions?: number | undefined;
    previousRepetitions?: number | undefined;
}

export enum RepetitionUnit2 {
    Days = "days",
    Weeks = "weeks",
    Months = "months",
    Years = "years",
}

export enum TaskType {
    Opgave = "opgave",
    Advis = "advis",
}

export interface RelatedEntity {
    id: string;
    name?: string | undefined;
}

export interface CompanyTaskMetaData {
    id: string;
    title?: string | undefined;
    dueDate?: Date | string | undefined;
    responsibleCaseWorkerId?: string | undefined;
    responsibleCaseWorkerName?: string | undefined;
    responsibleTeamId?: string | undefined;
    responsibleTeamName?: string | undefined;
    taskType?: string | undefined;
    taskCategory?: string | undefined;
    taskStatus?: string | undefined;
}

export interface CompanyTaskFilter {
    allTasks: boolean;
}

export interface TemplateListCompanyItemViewModel {
    codeName?: string | undefined;
    label?: string | undefined;
    name?: string | undefined;
    value?: TemplateCompanyListItemValue | undefined;
}

export interface TemplateCompanyListItemValue {
    templateId: number;
    variantId?: number | undefined;
}

export interface TemplateListItemCompanyViewModel {
    id: number;
    name: string;
    codeName?: string | undefined;
}

export interface AccountInteractionPurposeViewModel {
    id: string;
    name: string;
}

export interface CompanyLetterAddressViewModel {
    streetAddress?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    name?: string | undefined;
}

export interface PdfFormModel {
    id?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    desciption?: string | undefined;
    tag?: string | undefined;
}

export interface InteractionResultViewModel {
    id: string;
    name: string;
}

export interface OutgoingDocumentTypeViewModel {
    id: string;
    name: string;
}

export interface AttachmentModelForCompany {
    id?: string | undefined;
    documentId?: string | undefined;
    title?: string | undefined;
    name?: string | undefined;
    size?: string | undefined;
    sizeInBytes: number;
    aliasId?: string | undefined;
    mime?: string | undefined;
    added?: string | undefined;
}

export interface RecipientEnvelopeAddress {
    name?: string | undefined;
    address?: string | undefined;
    attention?: string | undefined;
}

export interface CompanyChangeLogQueryViewModel {
    id: string;
    userName?: string | undefined;
    changes?: ChangeV2Dto[] | undefined;
    correlationIdentifier?: string | undefined;
    operation?: string | undefined;
    timestamp: Date | string;
    postType?: string | undefined;
    postId?: string | undefined;
}

export interface ChangeV2Dto {
    name?: string | undefined;
    displayName?: string | undefined;
    valueTranslatorName?: string | undefined;
    oldValue?: any | undefined;
    oldValueTranslated?: any | undefined;
    newValue?: any | undefined;
    newValueTranslated?: any | undefined;
}

export enum ChangeOperationV2 {
    Create = "create",
    Update = "update",
    Remove = "remove",
}

export interface SortColumnV2 {
    id: string;
    desc?: boolean | undefined;
}

export interface CompanyAbsenceViewModel {
    absenceId: string;
    citizenId: string;
    isActive?: boolean | undefined;
    absenceTypeName?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    notificationDate?: Date | string | undefined;
    sickLeaveInSubscription?: boolean | undefined;
    absenceCauseTypeName?: string | undefined;
    isDeleted?: boolean | undefined;
}

export interface AssociatedCaseWorkerTableModel {
    id?: string | undefined;
    caseWorkerId: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    description?: string | undefined;
    role?: string | undefined;
    roleName?: string | undefined;
    isResponsibleCaseworker: boolean;
    isResponsibleExternalOperator: boolean;
    companyId: string;
    companyName?: string | undefined;
    caseWorkerName?: string | undefined;
}

export interface AssociateUserRole extends BusinessConfigurationItem {
}

export interface CompanyAppointmentModel {
    id?: string | undefined;
    companyId: string;
    title?: string | undefined;
    description?: string | undefined;
    appointmentStatus?: AppointmentStatusType | undefined;
    appointmentDate?: Date | string | undefined;
    scheduledStartTime?: Date | string | undefined;
    scheduledEndTime?: Date | string | undefined;
    interactionPurposeId?: string | undefined;
    contactType?: ContactType | undefined;
    contactPersonId?: string | undefined;
    caseWorkerId?: string | undefined;
    teamId?: string | undefined;
}

export enum AppointmentStatusType {
    Planlagt = "planlagt",
    Aflyst = "aflyst",
    Afsluttet = "afsluttet",
}

export interface CompanyAppointmentListViewModel {
    id?: string | undefined;
    appointmentDate?: Date | string | undefined;
    title?: string | undefined;
    contactPersonName?: string | undefined;
    contactTypeName?: string | undefined;
    caseWorkerName?: string | undefined;
    teamName?: string | undefined;
    appointmentStatusType?: AppointmentStatusType | undefined;
}

export interface ClosureCause {
    id: string;
    name?: string | undefined;
}

export interface AttachmentSettings {
    disableLocalFileAttachment: boolean;
    standardBilagEnabled: boolean;
    crmHost?: string | undefined;
}

export interface CompanyInfo {
    id: string;
    name?: string | undefined;
    productionNumber?: string | undefined;
    cvr?: string | undefined;
    industry?: string | undefined;
    address?: CompanyAddressInfo | undefined;
}

export interface CompanyAddressInfo {
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    suiteIdentifier?: string | undefined;
    districtSubdivisionIdentifier?: string | undefined;
    postCodeIdentifier?: string | undefined;
    districtName?: string | undefined;
    countryIdentificationCode?: string | undefined;
}

export interface ContactPersonInfo {
    id: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export interface CompanyNoteDto2 {
    companyNoteId: string;
    name?: string | undefined;
    createdAt: Date | string;
    resultType?: string | undefined;
    createdBy?: string | undefined;
}

export interface RecruitmentCandidateDetailsViewModel {
    id: string;
    correctionComment?: string | undefined;
    comment?: string | undefined;
    url?: string | undefined;
    status: number;
    citizenNameCpr?: string | undefined;
    citizenId: string;
    recruitmentTitle?: string | undefined;
    mediatingDate?: Date | string | undefined;
    mediatingEmployee?: string | undefined;
    mediatingJobcenterName?: string | undefined;
    approvingDate?: Date | string | undefined;
    approvingEmployee?: string | undefined;
    approvingJobcenterName?: string | undefined;
    rejectingDate?: Date | string | undefined;
    rejectingEmployee?: string | undefined;
    rejectingJobcenterName?: string | undefined;
    recruitmentId: string;
    timeOfEmployment?: Date | string | undefined;
    mediatingUnemploymentFundName?: string | undefined;
    approvingUnemploymentFundName?: string | undefined;
    rejectingUnemploymentFundName?: string | undefined;
}

export interface CompanyRecruitmentJobMatchViewModel {
    id: string;
    name?: string | undefined;
    requestType?: string | undefined;
    requestStatus?: string | undefined;
    dueDate?: Date | string | undefined;
    mediatedPercent?: number | undefined;
    company?: string | undefined;
    companyAddress?: string | undefined;
    startDate?: Date | string | undefined;
    hoursPerWeek?: number | undefined;
    lastPublished?: Date | string | undefined;
    offerTypeName?: string | undefined;
    responsibleJobcenterName?: string | undefined;
}

export interface CompanyRecruitmentViewModel {
    id: string;
    title?: string | undefined;
    referenceNumber?: string | undefined;
    dueDate?: Date | string | undefined;
    numberOfJobs?: number | undefined;
    companyName?: string | undefined;
    origin?: string | undefined;
    respondType?: string | undefined;
    status?: string | undefined;
    startDate?: Date | string | undefined;
    durationInDays?: number | undefined;
    createdDate: Date | string;
    modifiedDate: Date | string;
}

export interface CompanyRecruitmentSearchResultDto {
    id: string;
    title?: string | undefined;
    status?: string | undefined;
    companyName?: string | undefined;
    createdOn?: Date | string | undefined;
    referenceNumber?: string | undefined;
    targetGroupIds?: string[] | undefined;
}

export interface CitizenIntelligentMatchInfo {
    civilRegistrationIdentifier?: string | undefined;
    fullName?: string | undefined;
}

export interface RecruitmentRequestFromSkillsViewModel {
    id: string;
    title?: string | undefined;
    requestType?: OfferTypeDto | undefined;
    startDate?: Date | string | undefined;
    maximumNumberOfResponses?: number | undefined;
    mediatedPercent?: number | undefined;
    contactPerson?: string | undefined;
    requestStatus: number;
    hoursPerWeek?: number | undefined;
    numberOfJobs?: number | undefined;
    respondType?: string | undefined;
    primaryJobOwnerId?: string | undefined;
    primaryJobOwnerName?: string | undefined;
    jobDescription?: string | undefined;
    internalAuthorityComment?: string | undefined;
    companyId: string;
    companyName?: string | undefined;
    numberOfCandidatesAvailableForCompany?: number | undefined;
    occupation?: OccupationDto | undefined;
    probability?: number | undefined;
}

export interface RelinkJobAdViewModel {
    id: string;
    title?: string | undefined;
    description?: string | undefined;
    score: number;
    jobAdLink?: string | undefined;
    postalCode: number;
    endDate?: Date | string | undefined;
}

export interface Competence {
    name?: string | undefined;
    origin: Origin;
    recommendation: Recommendation;
}

export enum Origin {
    JobPosition = "jobPosition",
    JobDescription = "jobDescription",
}

export enum Recommendation {
    ToAdd = "toAdd",
    ToKeep = "toKeep",
    ToRemove = "toRemove",
}

export interface DocumentArchiveDocumentForCompanyRecruitment {
    id: string;
    documentId: string;
    shelf: string;
    title: string;
    name: string;
    added: string;
    aliasId?: string | undefined;
    size: string;
    sizeInBytes: number;
    mime: string;
}

export interface CompanyRecruitmentsJobcenter {
    code?: string | undefined;
    id: string;
    name?: string | undefined;
}

export interface CompanyRecruitmentsOccupationDto {
    id?: string | undefined;
    aliasIdentifier?: string | undefined;
    conceptUriDa?: string | undefined;
    name?: string | undefined;
    title?: string | undefined;
}

export interface NewRecruitmentFromOfferViewModel {
    id: string;
    name?: string | undefined;
    vitasCaseId?: string | undefined;
    startDate?: Date | string | undefined;
    durationInDays?: number | undefined;
    description?: string | undefined;
    company?: CompanyDto2 | undefined;
    contactPerson?: ContactPersonDto2 | undefined;
    offerType?: OfferTypeDto2 | undefined;
    occupation?: CompanyRecruitmentsOccupationDto | undefined;
}

export interface CompanyDto2 {
    id?: string | undefined;
    districtName?: string | undefined;
    name?: string | undefined;
    countryIdentificationCode?: string | undefined;
    floorIdentifier?: string | undefined;
    productionNumber?: string | undefined;
    postCodeIdentifier?: string | undefined;
    streetName?: string | undefined;
    suiteIdentifier?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    districtSubdivisionIdentifier?: string | undefined;
    industry?: string | undefined;
    cvr?: string | undefined;
}

export interface ContactPersonDto2 {
    email?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    phone?: string | undefined;
}

export interface OfferTypeDto2 {
    id: string;
    code?: number | undefined;
    name?: string | undefined;
    placementPurposeRequiredOnRecruitmentRequ?: boolean | undefined;
}

export interface OfferTypeDto3 {
    id: string;
    name?: string | undefined;
    typeCode: number;
    placementPurposeRequiredOnRecruitmentRequ?: boolean | undefined;
}

export interface PlacementPurposeTypeDto2 {
    id: string;
    name?: string | undefined;
}

export interface CandidateJobSkill {
    title?: string | undefined;
    isMatching: boolean;
    id: string;
}

export interface QualificationDto {
    id: string;
    code?: string | undefined;
    name?: string | undefined;
}

export interface RecruitmentCollaborationDto {
    id: string;
    name?: string | undefined;
    jobcenterCodes?: string[] | undefined;
}

export interface RecruitmentRequestCompanyModel {
    companyId: string;
    postCode?: string | undefined;
    district?: string | undefined;
}

export interface RecruitmentInformationType2 {
    id: string;
    name?: string | undefined;
}

export interface ServiceTargetType {
    id: string;
    name?: string | undefined;
    numberOfWorkingDaysForDisseminationStart?: number | undefined;
    numberOfWorkingDaysForGrantStart?: number | undefined;
}

export interface CompanyRecruitmentSettings {
    recruitmentRequestDefaultPhrases?: string | undefined;
    recruitmentRequestExtraFieldsRequired: boolean;
    recruitmentRequestStartDateNotBeforeDueDate: boolean;
    serviceTargetMandatoryWhenDispatchingRecruitmentCaseWorker: boolean;
    requestStatusRequiringClosureCause?: number[] | undefined;
    recruitmentRequestCandidateStateValidation: boolean;
    isRecruitmentRequestStateValidationEnabled: boolean;
}

export interface WeightedCvSearchResultItem {
    id: string;
    civilRegistrationIdentifier?: string | undefined;
    occupations?: string[] | undefined;
    educations?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    name?: string | undefined;
    municipality?: string | undefined;
    jobcenterCode: number;
    isCvSearchable: boolean;
    hasNameAndAddressProtection: boolean;
    weightPercent: number;
    jobcenterName?: string | undefined;
}

export enum OccupationExpericeType {
    All = "all",
    TwoYears = "twoYears",
    FiveYears = "fiveYears",
}

export interface TargetGroupDto {
    id: string;
    name?: string | undefined;
}

export interface Team2 {
    id: string;
    name?: string | undefined;
}

export interface JobcenterInfoDto2 {
    id: string;
    code?: string | undefined;
    name?: string | undefined;
}

export interface CompanyRecruitmentUnemploymentFund {
    id: string;
    code?: string | undefined;
    name?: string | undefined;
}

export interface Column {
    name: string;
}

export interface SortColumn2 extends Column {
    desc: boolean;
}

export interface SearchColumnFilter extends Column {
    value?: string[] | undefined;
    operator: Operator;
}

export enum Operator {
    StartsWith = "startswith",
    NotStartsWith = "notstartswith",
    Contains = "contains",
    NotContains = "notcontains",
    Equal = "eq",
    NotEqual = "ne",
    LessThan = "lt",
    LessThanOrEqual = "le",
    GreaterThan = "gt",
    GreaterThanOrEqual = "ge",
    Between = "between",
    NotBetween = "notbetween",
    In = "in",
    WildCardIn = "wildcardin",
    NotIn = "notin",
    Empty = "empty",
    NotEmpty = "notempty",
    Relative = "relative",
    True = "true",
    False = "false",
    CodeListNameEqual = "codelistnameeq",
}

export interface SearchColumn extends Column {
    width?: number | undefined;
    format?: string | undefined;
}

export interface SavedDashboardFormatted {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    createdDate?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedDate?: Date | string | undefined;
    modifiedByName?: string | undefined;
    ownedByName?: string | undefined;
    ownerId: string;
    tags?: string[] | undefined;
    dashboardCategory?: SavedDashboardCategory | undefined;
    accessRole?: Access | undefined;
    lastUsedDate?: Date | string | undefined;
    lastUsedById?: string | undefined;
    lastUsedByName?: string | undefined;
    usageCount?: number | undefined;
}

export interface AccessControlViewModel {
    principalId: string;
    principalType: PrincipalType;
    objectId: string;
    objectName?: string | undefined;
    objectDescription?: string | undefined;
    objectType: ObjectType;
    type?: string | undefined;
    userName?: string | undefined;
    teamName?: string | undefined;
    access: Access;
    sharedOwnership: boolean;
    owner?: string | undefined;
    universe?: string | undefined;
}

export interface SharedPermissionFilterRequest {
    filterItems?: SharedPermissionFilterRequestItem[] | undefined;
    operatorLinkValue?: string | undefined;
}

export interface SharedPermissionFilterRequestItem {
    field?: string | undefined;
    operatorValue?: string | undefined;
    filterValue?: string[] | undefined;
}

export interface SharedPermissionSortRequest {
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
}

export interface SharedPermissionPageRequest {
    pageSize: number;
    pageNumber: number;
}

export interface RankedSearchModel {
    title?: string | undefined;
    description?: string | undefined;
    documentId?: string | undefined;
    documentType?: string | undefined;
}

export interface DashboardCompositionRow {
    sectionName?: string | undefined;
    widgetName?: string | undefined;
    query?: WorklistElementUsageRow | undefined;
    chart?: WorklistElementUsageRow | undefined;
}

export interface WorklistElementUsageRow {
    objectType: ObjectType;
    objectId: string;
    name?: string | undefined;
    exists: boolean;
    ownerId?: string | undefined;
    ownerName?: string | undefined;
    modifiedDate?: Date | string | undefined;
    lastUsedAt?: Date | string | undefined;
    totalCount: number;
    referencedByDashboardCount: number;
}

export interface SearchResponse2 {
    universe?: string | undefined;
    query?: any | undefined;
    searchResult?: SearchResult | undefined;
    workListTitle?: string | undefined;
    sortColumns?: SortColumn2[] | undefined;
    affectedCitizenIds?: string[] | undefined;
}

export interface SearchResult {
    columns?: SearchResultColumn[] | undefined;
    embeddedColumns?: SearchResultColumn[] | undefined;
    rows?: any[] | undefined;
    queryExecutionTime: number;
    totalResultsCount: number;
    numberOfResults: number;
    rowsCount: number;
    currentPageCount: number;
    rootResultsCount: number;
    resultsPagesCount: number;
    universeName?: string | undefined;
    resultType?: string | undefined;
    resultTypeName?: string | undefined;
    embeddedResultType?: string | undefined;
    embeddedResultTypeName?: string | undefined;
}

export interface SearchResultColumn extends SearchColumn {
    displayName?: string | undefined;
    localName?: string | undefined;
    type: SearchDataType;
    uiHint?: UIHint | undefined;
    codelistType?: string | undefined;
    isSortable: boolean;
    codeListName?: string | undefined;
    toBeDeleted: boolean;
}

export enum SearchDataType {
    Text = "text",
    Integer = "integer",
    Double = "double",
    Boolean = "boolean",
    Date = "date",
    Codelist = "codelist",
    User = "user",
    Picklist = "picklist",
    Largetext = "largetext",
}

export enum UIHint {
    Lookup = "lookup",
    Hide = "hide",
    Flatten = "flatten",
    Money = "money",
    Time = "time",
    MultipleSelectLookup = "multipleSelectLookup",
    TextCodeList = "textCodeList",
    Url = "url",
}

export interface MonthlyUsageCount {
    year: number;
    month: number;
    count: number;
}

export interface SourceUsageCount {
    source: WorklistUsageSource;
    count: number;
}

export enum WorklistUsageSource {
    Direct = "direct",
    Dashboard = "dashboard",
    Export = "export",
    Chart = "chart",
}

export interface UserUsageRow {
    userId: string;
    userName?: string | undefined;
    count: number;
    lastUsedAt: Date | string;
}

export interface WorklistElementReference {
    id: string;
    name?: string | undefined;
}

export interface WorklistUsageOverviewRow {
    objectType: ObjectType;
    objectId: string;
    name?: string | undefined;
    universe?: string | undefined;
    ownerId: string;
    ownerName?: string | undefined;
    createdDate: Date | string;
    modifiedDate?: Date | string | undefined;
    lastUsedAt?: Date | string | undefined;
    lastUsedByUserId?: string | undefined;
    lastUsedByName?: string | undefined;
    totalCount: number;
    countLast3Months: number;
    distinctUserCount: number;
    referencedByDashboardCount: number;
    referencedByChartCount: number;
}

export interface WorklistUsageSort {
    field?: string | undefined;
    descending: boolean;
}

export interface WorklistUsageFilter {
    field?: string | undefined;
    operator?: string | undefined;
    values?: string[] | undefined;
}

export interface RankedDocumentTypeModel {
    name?: string | undefined;
    displayName?: string | undefined;
    universe?: any | undefined;
    enabledByDefault: boolean;
}

export interface RankedSearchFilterField {
    name?: string | undefined;
    displayName?: string | undefined;
    values?: string[] | undefined;
    documentType?: string | undefined;
    fieldType?: string | undefined;
}

export interface RankedSearchDocumentTypesFilter {
    name?: string | undefined;
    esName?: string | undefined;
    values?: string[] | undefined;
    documentType?: string | undefined;
}

export interface WorklistAccessControlPrincipal {
    accessControl?: WorklistAccessControlModel | undefined;
    pricipalName?: string | undefined;
    tooltipDescription?: string | undefined;
}

export interface WorklistAccessControlModel {
    principalId: string;
    principalType: PrincipalType;
    objectId: string;
    objectType: ObjectType;
    access: Access;
}

export interface UseOfForceServiceProviderUnitModel {
    id: string;
    name?: string | undefined;
}

export enum NuphDocumentType {
    NuphDocument = "nuphDocument",
    NuphResponseDocument = "nuphResponseDocument",
}

export interface UnemploymentBenefitsAccountinfoModel {
    benefitsPeriod?: BenefitsPeriodModel | undefined;
    benefitsConsumption?: BenefitsConsumptionModel | undefined;
    benefitsRate?: BenefitsRateModel | undefined;
    employmentAccount?: EmploymentAccountModel | undefined;
    regradingAccount?: RegradingAccountModel | undefined;
    qualifyingHours?: QualifyingHoursModel | undefined;
    qualifyingHoursReport?: QualifyingHoursReportModel | undefined;
    shorteningReport?: ShorteningReportModel | undefined;
    supplementalAccount?: SupplementalAccountModel | undefined;
    benefitPeriodSummary?: UnemploymentBenefitPeriodSummary | undefined;
    referentialPeriod?: ReferentialPeriodModel | undefined;
}

export interface BenefitsPeriodModel {
    start?: Date | string | undefined;
    end?: Date | string | undefined;
    type?: CodeListItem22 | undefined;
    benefitsExpiryActualOrExpected?: CodeListItem22 | undefined;
    expiryCause?: CodeListItem22 | undefined;
}

export interface CodeListItem22 {
    description: string;
    deprecated?: boolean | undefined;
    code: number;
    type: string;
    name: string;
}

export interface BenefitsConsumptionModel {
    hoursConsumed: number;
    hoursRemaining: number;
    inventoryPaymentMonth?: YearAndMonthModel | undefined;
}

export interface YearAndMonthModel {
    year: number;
    month: number;
}

export interface BenefitsRateModel {
    ratePerMonth: number;
    ratePerHour: number;
    rateBasis: CodeListItem22;
    rateValidFrom: Date | string;
}

export interface EmploymentAccountModel {
    employmentHours?: number | undefined;
    potentialProlongationBenefitHours: number;
}

export interface RegradingAccountModel {
    hoursMissingToRegrade: number;
    hoursCompletionDeadline: Date | string;
}

export interface QualifyingHoursModel {
    start: Date | string;
    end: Date | string;
    employmentHours: number;
    qualifyingHoursMissing: number;
    qualifyingHoursPeriodNumber: number;
    calculationDate: Date | string;
}

export interface QualifyingHoursReportModel {
    decisionDate: Date | string;
    qualifyingHoursWithdrawalAmount: number;
    executionMonth?: YearAndMonthModel | undefined;
    qualifyingHoursPeriodNumber: number;
    calculationDate: Date | string;
}

export interface ShorteningReportModel {
    decisionDate: Date | string;
    obsoletionDate?: Date | string | undefined;
    executionDate?: Date | string | undefined;
    calculationDate: Date | string;
}

export interface SupplementalAccountModel {
    weeksConsumed: number;
    calculationWeek?: YearAndWeekModel | undefined;
    reobtainSupplementalBenefits?: CodeListItem22 | undefined;
    reobtainedRightWeeks?: number | undefined;
    ordinarySupplementalBenefitsStartWeek?: YearAndWeekModel | undefined;
    prolongedSupplementalBenefitsStartWeek?: YearAndWeekModel | undefined;
    ordinarySupplementalBenefitsEndDate?: Date | string | undefined;
    reobtainBasis?: CodeListItem22 | undefined;
    calculationDate: Date | string;
}

export interface YearAndWeekModel {
    year: number;
    week: number;
}

export interface UnemploymentBenefitPeriodSummary {
    benefitsPeriodType?: CodeListItem22 | undefined;
    benefitsPeriodStart?: Date | string | undefined;
    benefitsPeriodEnd?: Date | string | undefined;
    employmentAccountEmploymentHours?: number | undefined;
    grossBenefitWeeks?: number | undefined;
    halfYearBenefitReachedDate?: Date | string | undefined;
    referentialPeriodEndDate?: Date | string | undefined;
}

export interface ReferentialPeriodModel {
    referentialPeriodEndDate: Date | string;
}

export interface NuphAdditionalRequestResponseModel {
    id: string;
    createdOn: Date | string;
    text?: string | undefined;
    externalRegistrationInfo?: ExternalRegistrationInfoModel | undefined;
    type: NuphAdditionalRequestResponseType;
}

export interface NuphDocumentModel {
    id: string;
    type: NuphDocumentType;
    title?: string | undefined;
    createdOn: Date | string;
    externalRegistrationInfo?: ExternalRegistrationInfoModel | undefined;
}

export interface NuphResponseModel {
    id: string;
    unemploymentFundName?: string | undefined;
    nuphResponseTypeName?: string | undefined;
    nuphResponseCauseTypeName?: string | undefined;
    comment?: string | undefined;
    externalAbsenceIdentifier?: string | undefined;
    isWithdrawn?: boolean | undefined;
    withdrawnDate?: Date | string | undefined;
    withdrawnComment?: string | undefined;
    externalRegistrationInfo?: ExternalRegistrationInfoModel | undefined;
    createdOn: Date | string;
}

export interface CitizenPayoutsModel {
    retirement?: RetirementPayoutModel[] | undefined;
    unemployment?: UnemploymentPayoutModel[] | undefined;
}

export interface RetirementPayoutModel {
    id: string;
    reportingTime: Date | string;
    transitionDate: Date | string;
    organizationModel: OrganizationModel;
}

export interface OrganizationModel {
    name?: string | undefined;
    organizationType?: CodeListItem22 | undefined;
    organizationCode?: CodeListItem22 | undefined;
}

export interface UnemploymentPayoutModel {
    id: string;
    date: Date | string;
    reportingYearMonth: YearAndMonthModel;
    hoursPaid: number;
    hoursOfDeduction: number;
    causesForDeduction?: CauseForDeduction[] | undefined;
    organizationModel: OrganizationModel;
}

export interface CauseForDeduction {
    causeForDecuction?: string | undefined;
    hoursOfDeductionPrCause: number;
    deductions?: DeductionModel[] | undefined;
}

export interface DeductionModel {
    date: Date | string;
    hoursOfDeductionPrDay: number;
    causeForDeductionType?: CodeListItem22 | undefined;
}

export interface UnemploymentFundModel {
    unemploymentFund?: string | undefined;
    unemploymentFundBranch?: string | undefined;
    unemploymentCurrentFundBranch?: string | undefined;
    unemploymentFundCode?: string | undefined;
    unemploymentInsuranceCategory?: CodeListItem5 | undefined;
    unemploymentFundParticipation: boolean;
    unemploymentFundMeetingParticipation: boolean;
    unemploymentFundParticipationInFirstJobInterview: boolean;
    unemploymentFundBranchId?: string | undefined;
}

export interface CodeListItem5 {
    description?: string | undefined;
    deprecated: boolean;
    code: number;
    type?: string | undefined;
    name?: string | undefined;
}

export interface TimelineItem {
    citizenId: string;
    entityId: string;
    type: TimelineItemType;
    header?: string | undefined;
    description?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    timelineItemInfos?: TimelineItemInfo[] | undefined;
}

export enum TimelineItemType {
    Booking = "booking",
    ConductedInterview = "conductedInterview",
    Activity = "activity",
    Case = "case",
    Absence = "absence",
    NegativeEvent = "negativeEvent",
    Nuph = "nuph",
    Assignment = "assignment",
    Today = "today",
    Ruling = "ruling",
    Assessment = "assessment",
    VersionedAssessment = "versionedAssessment",
}

export interface TimelineItemInfo {
    header?: string | undefined;
    content?: string | undefined;
}

export interface ScreeningListModel {
    id: string;
    name?: string | undefined;
    screeningType: ScreeningType;
}

export enum ScreeningType {
    SelfServiceGuidance = "selfServiceGuidance",
    Screening = "screening",
}

export interface SurveyListDto {
    screeningId: string;
    name: string;
    status: ScreeningStatus;
    createdDate: Date | string;
    completedDate?: Date | string | undefined;
    category: string;
}

export enum ScreeningStatus {
    Available = "available",
    Answered = "answered",
    Unanswered = "unanswered",
    Cancelled = "cancelled",
}

export interface AnsweredProgressionSurveyViewModel {
    surveyId: string;
    questionnaireId: string;
    questionnaireName?: string | undefined;
    questionnaireDescription?: string | undefined;
    answeredOn?: Date | string | undefined;
    lastAnsweredDate?: Date | string | undefined;
    closedOn?: Date | string | undefined;
    answers?: AnsweredProgressionSurveyAnswerViewModel[] | undefined;
}

export interface AnsweredProgressionSurveyAnswerViewModel {
    questionId: string;
    questionLabel?: string | undefined;
    questionType?: string | undefined;
    questionRank: number;
    value?: string | undefined;
    round?: number | undefined;
    submittedOn?: Date | string | undefined;
    submittedByCaseworkerId?: string | undefined;
    showInDiagram: boolean;
    countInAverage: boolean;
}

export interface ForumFeedbackSurveyViewModel {
    surveyId: string;
    questionnaireId: string;
    questionnaireName?: string | undefined;
    type?: string | undefined;
    context?: string | undefined;
    offerName?: string | undefined;
    offerIdentifier?: number | undefined;
    answeredOn?: Date | string | undefined;
    lastAnsweredDate?: Date | string | undefined;
    closedOn?: Date | string | undefined;
    isJournalizedResponse: boolean;
    answers?: ForumFeedbackSurveyAnswerViewModel[] | undefined;
}

export interface ForumFeedbackSurveyAnswerViewModel {
    questionId: string;
    questionLabel?: string | undefined;
    questionType?: string | undefined;
    questionRank: number;
    value?: string | undefined;
    submittedOn?: Date | string | undefined;
}

export interface StandardPhraseModel {
    standardPhraseId: string;
    name?: string | undefined;
    phrasePlainText?: string | undefined;
    phraseRichText?: string | undefined;
    displayedOn?: string[] | undefined;
}

export interface HoiCompanyContactPersonModel {
    id: string;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export interface CitizenHoiInfo {
    id: string;
    fullName?: string | undefined;
    currentAddress?: string | undefined;
    postalCode?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    email?: string | undefined;
}

export interface HoiLetterContentViewModel {
    citizenId: string;
    caseworkerId?: string | undefined;
    hoiCaseGuideDataViewModel?: HoiCaseGuideDataViewModel | undefined;
}

export interface HoiCaseGuideDataViewModel {
    consent?: boolean | undefined;
    consentDate?: Date | string | undefined;
    consentType?: ConsentType | undefined;
    consentRemark?: string | undefined;
}

export interface HoiPrivateContactPersonModel {
    id: string;
    name?: string | undefined;
    address?: HoiPrivateContactPersonAddressModel | undefined;
}

export interface HoiPrivateContactPersonAddressModel {
    streetAddress?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
}

export interface VumStatus {
    statusDate?: Date | string | undefined;
    status?: string | undefined;
}

export interface NexusFormContentFieldModel {
    fieldId: number;
    fieldType?: string | undefined;
    label?: string | undefined;
    value?: string | undefined;
    conceptName?: string | undefined;
    isImportant: boolean;
    fields?: NexusFormContentFieldModel[] | undefined;
}

export interface NexusImportPreviewEntryModel {
    nexusReferenceId: number;
    nexusFormDataId?: number | undefined;
    formDefinitionId?: number | undefined;
    nexusDocumentId?: number | undefined;
    nexusLetterId?: number | undefined;
    parentPathwayId?: number | undefined;
    referenceType?: string | undefined;
    title?: string | undefined;
    subject?: string | undefined;
    additionalInfo?: { [key: string]: string; } | undefined;
    occurredAt?: Date | string | undefined;
    pathwayName?: string | undefined;
    status?: string | undefined;
    messageDirection?: string | undefined;
    messageStatusName?: string | undefined;
    isDraft: boolean;
    isDeleted: boolean;
    target: NexusImportTarget;
    hasContent: boolean;
    alreadyImported: boolean;
    unresolvedNoteTypeName?: string | undefined;
    isSelectedByDefault: boolean;
}

export interface NexusImportCaseworkerModel {
    nexusProfessionalId: number;
    name?: string | undefined;
    jobTitle?: string | undefined;
    organizationName?: string | undefined;
    pathwayName?: string | undefined;
    isResponsible: boolean;
}

export interface NexusImportContactModel {
    nexusContactId: number;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    contactTypeName?: string | undefined;
    contactCategory?: string | undefined;
}

export interface NexusImportNoteTypeWarningModel {
    noteTypeName?: string | undefined;
    description?: string | undefined;
}

export enum NexusImportJobStatus {
    Enqueued = "enqueued",
    InProgress = "inProgress",
    Completed = "completed",
    Failed = "failed",
}

export interface ResumedWorkModel {
    id: string;
    caseId: string;
    createdOn: Date | string;
    sicknessBenefitEmployerCvr?: string | undefined;
    sicknessBenefitEmployerPnumber?: string | undefined;
    sicknessBenefitEmployerPresentation?: string | undefined;
    sicknessBenefitReducedBenefitDate?: Date | string | undefined;
    sicknessBenefitReducedBenefitPercentage?: number | undefined;
    sicknessBenefitUpdatedByKsdDate?: Date | string | undefined;
    sicknessBenefitWeeklyHours?: number | undefined;
    sicknessBenefitWeeklyMinutes?: number | undefined;
    sicknessBenefitWeeklyNumber?: string | undefined;
    citizenId: string;
}

export interface AvailabilityAbsenceModel {
    absenceId: string;
    absenceType: AvailabilityAbsenceTypeModel;
    citizenId: string;
    absenceCauseType?: AvailabilityAbsenceCauseTypeModel | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    notificationDate: Date | string;
    isActive?: boolean | undefined;
    comment?: string | undefined;
    correctionComment?: string | undefined;
    sickLeave?: AvailabilitySickLeaveModel | undefined;
    createdById?: string | undefined;
    createdByTeamId?: string | undefined;
    isDeleted?: boolean | undefined;
    causedUnenrollment?: boolean | undefined;
    modifiedById?: string | undefined;
    externalMessageId?: string | undefined;
}

export interface AvailabilityAbsenceTypeModel {
    absenceTypeId: string;
    name: string;
    description?: string | undefined;
    externalIdentifier?: string | undefined;
    isJobcenterSpecific: boolean;
    startDateNoOfDaysInPast: number;
    isEndDateRequired: boolean;
    endDateNoOfDaysInPast: number;
}

export interface AvailabilityAbsenceCauseTypeModel {
    absenceCauseTypeId: string;
    name: string;
    description?: string | undefined;
    externalIdentifier?: string | undefined;
}

export interface RemovalCauseType2 extends CodeListItem {
    description?: string | undefined;
    externalId?: string | undefined;
    removalCauseTypeCategory?: number | undefined;
}

export interface ContactGroupItem {
    id: string;
    name?: string | undefined;
}

export interface ContactGroupModel {
    contactGroupId?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    citizenId: string;
    contactGroupTypeId: string;
    eventDate?: Date | string | undefined;
    correctionComment?: string | undefined;
    authorityType?: string | undefined;
    createdOn: Date | string;
    createdByUserId?: string | undefined;
    modifiedOn: Date | string;
    modifiedByUserId?: string | undefined;
}

export interface PartialRecoveryListModel {
    id: string;
    absenceId: string;
    companyId: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    companyName?: string | undefined;
    hours?: number | undefined;
    createdOn: Date | string;
}

export interface PartialRecoveryCaseModel {
    caseId: string;
    caseName?: string | undefined;
}

export interface MissingParticipationListModel {
    id: string;
    status: MissingParticipationStatus;
    hearingStartDate: Date | string;
    missingParticipationTypeName?: string | undefined;
}

export interface MissingParticipationType extends CodeListItem {
    description?: string | undefined;
    identifier?: string | undefined;
    jobClarificationCancelTemplateCode?: string | undefined;
    jobClarificationHearingLetterTemplateCode?: string | undefined;
    jobClarificationMaintainTemplateCode?: string | undefined;
    sicknessBenefitCancelTemplateCode?: string | undefined;
    sicknessBenefitHearingLetterTemplateCode?: string | undefined;
    sicknessBenefitMaintainTemplateCode?: string | undefined;
    hearingLetterTemplateName?: string | undefined;
    letterTemplateName?: string | undefined;
    stateCode: number;
}

export interface ExpectedJobResumptionModel {
    id: string;
    caseId?: string | undefined;
    citizenId: string;
    absenceId?: string | undefined;
    companyId?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    note?: string | undefined;
    createdOn: Date | string;
    deleted: boolean;
    deletedOn?: Date | string | undefined;
    dfdgId?: string | undefined;
}

export interface ExpectedJobResumptionCaseModel {
    caseId: string;
    caseName?: string | undefined;
}

export interface ExpectedJobResumptionListModel {
    id: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    companyName?: string | undefined;
    createdOn: Date | string;
}

export interface BenefitExtensionAssessmentViewModel {
    id: string;
    followupDate?: Date | string | undefined;
    status: BenefitExtensionAssessmentStatus;
    createdOn: Date | string;
    isRetired: boolean;
    extensionReason?: string | undefined;
    isSicknessPeriodExtended?: boolean | undefined;
    createdBy?: string | undefined;
}

export interface BenefitExtensionAssessmentEditModel {
    caseId: string;
    citizenId: string;
    caseworkerId?: string | undefined;
    followupDate?: Date | string | undefined;
    employerGetsReimbursement: boolean;
    extensionStartDate?: Date | string | undefined;
    hearingStartDate?: Date | string | undefined;
    status: BenefitExtensionAssessmentStatus;
    createdOn: Date | string;
    isHearingReplyReceived: boolean;
    isRetired: boolean;
    extensionReasonId?: string | undefined;
    description?: string | undefined;
    comment?: string | undefined;
    isSicknessPeriodExtended?: boolean | undefined;
    cancellationReason?: string | undefined;
    deadlineForPartyReplyDate?: Date | string | undefined;
}

export interface BenefitExtensionReason {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    letterTemplateVariantName?: string | undefined;
}

export interface UseOfForceAssignmentOptionModel {
    assignmentId: string;
    name?: string | undefined;
    startDate?: Date | string | undefined;
}

export interface TrafficLightModel {
    assessment: TrafficLightAssessmentModel;
    citizenInvolvement: TrafficLightCitizenInvolvementModel;
    green: TrafficLightGreenZoneModel;
    yellow: TrafficLightYellowZoneModel;
    red: TrafficLightRedZoneModel;
    createdOn: Date | string;
    modifiedOn: Date | string;
}

export interface TrafficLightAssessmentModel {
    zone: TrafficLightZone;
    observation: string;
}

export interface TrafficLightCitizenInvolvementModel {
    citizenInvolved: boolean;
    citizenWishesAndStrategies?: string | undefined;
}

export interface TrafficLightGreenZoneModel {
    citizenIndicators?: string | undefined;
    whatHelps?: string | undefined;
    staffShouldDo?: string | undefined;
    staffShouldAvoid?: string | undefined;
}

export interface TrafficLightYellowZoneModel {
    citizenIndicators?: string | undefined;
    whatHelps?: string | undefined;
    staffShouldDo?: string | undefined;
    staffShouldAvoid?: string | undefined;
    typicalTriggers?: string | undefined;
}

export interface TrafficLightRedZoneModel {
    citizenIndicators?: string | undefined;
    whatHelps?: string | undefined;
    staffShouldDo?: string | undefined;
    staffShouldAvoid?: string | undefined;
    typicalTriggers?: string | undefined;
    safetyMeasures?: string | undefined;
    whoToContact?: string | undefined;
    debrief?: string | undefined;
}

export interface TrafficLightHistoryEventModel {
    changedAt: Date | string;
    changedByName: string;
    section: TrafficLightHistorySection;
    assessment?: TrafficLightAssessmentChangeModel | undefined;
    citizenInvolvement?: TrafficLightCitizenInvolvementChangeModel | undefined;
    green?: TrafficLightGreenZoneChangeModel | undefined;
    yellow?: TrafficLightYellowZoneChangeModel | undefined;
    red?: TrafficLightRedZoneChangeModel | undefined;
}

export enum TrafficLightHistorySection {
    Assessment = "assessment",
    CitizenInvolvement = "citizenInvolvement",
    GreenZone = "greenZone",
    YellowZone = "yellowZone",
    RedZone = "redZone",
}

export interface TrafficLightAssessmentChangeModel {
    before: TrafficLightAssessmentModel;
    after: TrafficLightAssessmentModel;
}

export interface TrafficLightCitizenInvolvementChangeModel {
    before: TrafficLightCitizenInvolvementModel;
    after: TrafficLightCitizenInvolvementModel;
}

export interface TrafficLightGreenZoneChangeModel {
    before: TrafficLightGreenZoneModel;
    after: TrafficLightGreenZoneModel;
}

export interface TrafficLightYellowZoneChangeModel {
    before: TrafficLightYellowZoneModel;
    after: TrafficLightYellowZoneModel;
}

export interface TrafficLightRedZoneChangeModel {
    before: TrafficLightRedZoneModel;
    after: TrafficLightRedZoneModel;
}

export interface CitizenDto {
    citizenId: string;
    cpr?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    existsInDfdg: boolean;
}

export interface ServiceProviderUnitDto {
    id: string;
    name?: string | undefined;
}

export interface ServiceProviderUnitModel {
    serviceProviderUnitId?: ServiceProviderUnitId | undefined;
    externalId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    companyId: string;
    prefersAssignmentsAsLetter: boolean;
}

export interface MissingPartialsInfo {
    missingPartialsCount: number;
    totalPartialsCount: number;
}

export enum FollowupSummaryStatus {
    FullSummary = "fullSummary",
    PartialSummary = "partialSummary",
    NoSummary = "noSummary",
}

export interface MethodTypeModel2 {
    id?: string | undefined;
    name?: string | undefined;
}

export interface ServiceProviderObservationTypeModel {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    category: ObservationCategory;
    dataType: ObservationDataType;
    unit?: string | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    reflectionFieldMode: ObservationFieldMode;
    timeFieldMode: ObservationFieldMode;
    standardTexts?: string[] | undefined;
    serviceProviderUnitIds?: string[] | undefined;
}

export interface ServiceProviderObservationTypeModel2 {
    id: string;
    name: string;
    description: string;
    category: ObservationCategory;
    dataType: ObservationDataType;
    unit: string;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    reflectionFieldMode: ObservationFieldMode;
    timeFieldMode: ObservationFieldMode;
    standardTexts: string[];
    serviceProviderUnitIds: string[];
}

export interface ServiceProviderObservationModel {
    id: string;
    assignmentId?: string | undefined;
    serviceProviderUnitId: string;
    observationTypeId: string;
    observedOn: string;
    observedByUserId: string;
    observedByDisplayName: string;
    numericValue?: number | undefined;
    booleanValue?: boolean | undefined;
    textValue?: string | undefined;
    reflection?: string | undefined;
    isDeleted: boolean;
    problemAreaCodes: ProblemAreaCode[];
}

export interface MedicinePackageDetailsViewModel {
    name?: string | undefined;
    productNumber?: string | undefined;
    strength?: string | undefined;
    packaging?: string | undefined;
    activeSubstance?: string | undefined;
    company?: string | undefined;
    atcCode?: string | undefined;
    deliveryGroup?: string | undefined;
    indication?: string | undefined;
    dosage?: string | undefined;
    isOverTheCounter: boolean;
    hasTrafficWarning: boolean;
    canDoseDispense: boolean;
    isDiscontinued: boolean;
    highRiskMedication: boolean;
}

export interface MedicinePackageViewModel {
    name?: string | undefined;
    productNumber?: string | undefined;
    company?: string | undefined;
    strength?: string | undefined;
    packaging?: string | undefined;
    detailsPath?: string | undefined;
}

export enum MedicineSearchType {
    ProductName = "productName",
    ActiveSubstance = "activeSubstance",
}

export interface MedicineAdministrationViewModel {
    administrationId: string;
    drugMedicationId: string;
    plannedTime?: string | undefined;
    status: MedicineAdministrationStatus;
    actualTime: Date | string;
    actualDose?: number | undefined;
    waste?: number | undefined;
    pnReason?: string | undefined;
    deviationReason?: string | undefined;
    performedByName: string;
    registeredByExecutingUser: boolean;
    sevenRightsConfirmed: boolean;
    doubleControl?: DoubleControlViewModel | undefined;
    controlledByName?: string | undefined;
    canConfirmDoubleControl: boolean;
    packageDeviationReason?: string | undefined;
    dispensedFromPackages?: DispensedFromPackageViewModel[] | undefined;
}

export interface DispensedFromPackageViewModel {
    packageId: string;
    batchAndExpiry?: BatchAndExpiryViewModel | undefined;
}

export interface MedicineInventoryControlSheetViewModel {
    drugName?: string | undefined;
    strength?: string | undefined;
    controlledSubstance: boolean;
    unit: MedicineUnit;
    openingBalance: number;
    receipts: number;
    withdrawals: number;
    corrections: number;
    closingBalance: number;
    packages: MedicineInventoryPackageViewModel[];
    entries: MedicineInventoryControlSheetEntryViewModel[];
}

export interface MedicineInventoryControlSheetEntryViewModel {
    movement: MedicineInventoryMovementViewModel;
    quantity: number;
    balanceAfter: number;
    isWaste: boolean;
    deviationReason?: string | undefined;
}

export interface MedicineInventoryMovementAwaitingDoubleControlViewModel {
    drugMedicationId: string;
    movement: MedicineInventoryMovementViewModel;
    package?: MedicineInventoryPackageViewModel | undefined;
    remainingBefore?: number | undefined;
    countedPackages: MedicineInventoryPackageViewModel[];
    registeredByExecutingUser: boolean;
    canConfirmDoubleControl: boolean;
}

export interface HealthConditionHistoryEntryModel {
    changedAt: Date | string;
    changedByName: string;
    status: HealthConditionStatus;
    assessmentText?: string | undefined;
    assessmentDate: Date | string;
    followUpDate?: Date | string | undefined;
}

export interface HealthOverviewModel {
    problemAreas: ProblemAreaModel[];
}

export interface ProblemAreaModel {
    code: ProblemAreaCode;
    status: ProblemAreaStatus;
    areaStatus: ProblemAreaStatus;
    assessmentText?: string | undefined;
    assessmentDate?: Date | string | undefined;
    followUpDate?: Date | string | undefined;
    isFollowUpOverdue: boolean;
    isClosedRisk: boolean;
    assessedOn?: Date | string | undefined;
    assessedByName?: string | undefined;
    concurrencyStamp?: string | undefined;
    nextFollowUpDate?: Date | string | undefined;
    hasOverdueFollowUp: boolean;
    conditions: HealthConditionModel[];
}

export interface HealthConditionModel {
    code: HealthConditionCode;
    status: HealthConditionStatus;
    assessmentText?: string | undefined;
    assessmentDate: Date | string;
    followUpDate?: Date | string | undefined;
    isFollowUpOverdue: boolean;
    assessedOn: Date | string;
    assessedByName: string;
    concurrencyStamp: string;
}

export interface ProblemAreaHistoryEntryModel {
    changedAt: Date | string;
    changedByName: string;
    status: ProblemAreaStatus;
    assessmentText?: string | undefined;
    assessmentDate: Date | string;
    followUpDate?: Date | string | undefined;
}

export interface ServiceProviderCitizenNotesModel {
    note?: string | undefined;
    obsNote1?: string | undefined;
    obsNote1ExpiresOn?: Date | string | undefined;
    obsNote2?: string | undefined;
    obsNote2ExpiresOn?: Date | string | undefined;
}

export interface CalendarEventModel {
    title: string;
    type: CalendarEventType;
    entityId?: string | undefined;
    serviceProviderUnitId?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    allDay: boolean;
    createdByUserId?: string | undefined;
    responsibleUserId?: string | undefined;
    locationAddress?: string | undefined;
    content?: string | undefined;
    plannedMinutes?: number | undefined;
    consumedMinutes?: number | undefined;
    eventStatus?: EventStatusType | undefined;
    doneComment?: string | undefined;
    cancelledComment?: string | undefined;
    responsibleUserFullName?: string | undefined;
    responsibleUserUsername?: string | undefined;
    canEdit: boolean;
    canCancel: boolean;
    canDelete: boolean;
    partialObjectiveId?: string | undefined;
    recurrence?: RecurrencePatternModel | undefined;
    seriesId?: string | undefined;
    noteTypeId?: string | undefined;
    observationTypeId?: string | undefined;
    observationTypeName?: string | undefined;
}

export interface NexusCalendarEventModel {
    title: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    nexusEventType?: string | undefined;
    content?: string | undefined;
    locationAddress?: string | undefined;
}

export interface ServiceProviderCitizenBriefModel {
    periodStart: Date | string;
    obsNotes: string[];
    note?: string | undefined;
    cave?: string | undefined;
    trafficLight?: BriefTrafficLightModel | undefined;
    today: BriefTodayItemModel[];
    upcoming: BriefUpcomingItemModel[];
    objectives: BriefObjectiveModel[];
    useOfForceReminders: BriefUseOfForceReminderModel[];
    headline: string;
    points: BriefPointModel[];
    sources: BriefSourceModel[];
}

export interface BriefTrafficLightModel {
    zone: TrafficLightZone;
    observation: string;
    citizenIndicators?: string | undefined;
    whatHelps?: string | undefined;
    staffShouldDo?: string | undefined;
    staffShouldAvoid?: string | undefined;
    whoToContact?: string | undefined;
}

export interface BriefTodayItemModel {
    time: string;
    title: string;
    detail?: string | undefined;
    isMedicine: boolean;
    isDone: boolean;
}

export interface BriefUpcomingItemModel {
    date: Date | string;
    time: string;
    title: string;
}

export interface BriefObjectiveModel {
    title: string;
    description?: string | undefined;
    latestFollowupOn?: Date | string | undefined;
    latestFollowupProgression?: number | undefined;
    latestFollowupDescription?: string | undefined;
}

export interface BriefUseOfForceReminderModel {
    incidentId: string;
    interventionStartedAt?: Date | string | undefined;
    text: string;
    isOverdue: boolean;
}

export interface BriefPointModel {
    text: string;
    needsAttention: boolean;
    sourceRefs: string[];
}

export interface BriefSourceModel {
    ref: string;
    kind: string;
    occurredAt: Date | string;
    title?: string | undefined;
    text?: string | undefined;
    author?: string | undefined;
}

export interface StoryRemindersModel {
    observationTypes: StoryReminderObservationTypeModel[];
    obsNotes: string[];
    today: StoryReminderAppointmentModel[];
    partialObjectives: StoryPartialObjectiveModel[];
}

export interface StoryReminderObservationTypeModel {
    id: string;
    name: string;
    latestValue?: string | undefined;
    latestObservedOn?: Date | string | undefined;
}

export interface StoryReminderAppointmentModel {
    time: string;
    title: string;
}

export interface StoryPartialObjectiveModel {
    id: string;
    title: string;
}

export interface StoryRegistrationsModel {
    story: string;
    defaultAssignmentId?: string | undefined;
    diaryNote?: StoryDiaryNoteModel | undefined;
    observations: StoryObservationModel[];
    followups: StoryFollowupModel[];
    useOfForceHint?: StoryUseOfForceHintModel | undefined;
    questions: StoryQuestionModel[];
}

export interface StoryDiaryNoteModel {
    title: string;
    text: string;
}

export interface StoryObservationModel {
    observationTypeId: string;
    observationTypeName: string;
    unit?: string | undefined;
    numericValue?: number | undefined;
    booleanValue?: boolean | undefined;
    textValue?: string | undefined;
    observedOn: Date | string;
    quote: string;
}

export interface StoryFollowupModel {
    partialObjectiveId: string;
    partialObjectiveTitle: string;
    progression: number;
    description: string;
    quote: string;
}

export interface StoryUseOfForceHintModel {
    quote: string;
    reason: string;
}

export interface StoryQuestionModel {
    kind: StoryQuestionKind;
    observationTypeId: string;
    observationTypeName: string;
    answerType: StoryAnswerType;
    unit?: string | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    observedOn: Date | string;
    question: string;
    quote: string;
}

export enum StoryQuestionKind {
    ObservationValue = "observationValue",
    ObservationTime = "observationTime",
}

export enum StoryAnswerType {
    Integer = "integer",
    Decimal = "decimal",
    Boolean = "boolean",
    Text = "text",
}

export interface UseOfForceScreeningModel {
    periodStart: Date | string;
    notesScreened: number;
    findings: UseOfForceScreeningFindingModel[];
}

export interface UseOfForceScreeningFindingModel {
    diaryNoteId: string;
    occurredAt: Date | string;
    title?: string | undefined;
    author?: string | undefined;
    quote: string;
    reason: string;
    suggestedInterventionType?: UseOfForceInterventionType | undefined;
    isHighConfidence: boolean;
    matchingIncidentId?: string | undefined;
}

export interface RulingAssessmentModel {
    assessmentId: string;
    createdOn: Date | string;
    createdBy?: string | undefined;
    status: AssessmentStatusDto;
    caseId: string;
}

export interface RulingCaseInfo {
    caseId: string;
    caseTypeId: string;
    caseTypeName?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    isActive: boolean;
    isSocial: boolean;
}

export interface RulingPersonContactModel {
    id: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    contactName?: string | undefined;
    roleName?: string | undefined;
}

export interface ConductedInterviewModel {
    id: string;
    interviewTypeName?: string | undefined;
    interviewTime?: Date | string | undefined;
    caseworkerDisplayName?: string | undefined;
    agreement?: string | undefined;
}

export interface RulingDocumentModel {
    id: string;
    caseId?: string | undefined;
    title?: string | undefined;
    deadline?: Date | string | undefined;
    comment?: string | undefined;
    status?: string | undefined;
    isFinished: boolean;
    followupDate?: Date | string | undefined;
    responsibleName?: string | undefined;
    createdOn: Date | string;
    createdByName?: string | undefined;
    modifiedOn?: Date | string | undefined;
    modifiedByName?: string | undefined;
    caseName?: string | undefined;
    caseUrl?: string | undefined;
}

export interface RulingGrantModel {
    id: string;
    grantType?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    status: GrantStatus;
    followUpDate?: Date | string | undefined;
    description?: string | undefined;
    offerTitle?: string | undefined;
    expectedPricePerMonth?: number | undefined;
    expectedTotalPrice?: number | undefined;
    visitationComment?: string | undefined;
    priceCalculation?: GrantPriceCalculationDto | undefined;
}

export interface RulingJournalNoteModel {
    id: string;
    title?: string | undefined;
    sourceName?: string | undefined;
    contentTypeName?: string | undefined;
    createdByName?: string | undefined;
    createdAt: Date | string;
    eventDate: Date | string;
    caseId?: string | undefined;
    caseName?: string | undefined;
    hasAttachments?: string | undefined;
    attachments?: RulingJournalNoteAttachmentModel[] | undefined;
    content?: string | undefined;
    isCancelled: boolean;
    letterDate?: Date | string | undefined;
    createByTeamName?: string | undefined;
    revisionNote?: string | undefined;
    sendingStatus?: string | undefined;
    sendingStatusNote?: string | undefined;
    templateCodeName?: string | undefined;
    templateMappingName?: string | undefined;
    caseUrl?: string | undefined;
    journalNoteUrl?: string | undefined;
}

export interface RulingJournalNoteAttachmentModel {
    id: string;
    fileName?: string | undefined;
    titleWithFileSize?: string | undefined;
}

export interface GetRulingResponse2 {
    ruling?: GetRulingDto | undefined;
}

export interface GetRulingDto {
    rulingId: string;
    editModel: RulingEditModel;
    recordCreatedAt: Date | string;
    recordCreatedBy: string;
    rulingStatusDisplayName: string;
    rulingStatus: RulingStatus;
    replacesRulingId?: string | undefined;
    reasonForTerminationDisplayName?: string | undefined;
    terminationExplanation?: string | undefined;
    complaint?: ComplaintDto | undefined;
    continuations?: RulingContinuationDto[] | undefined;
}

export interface ComplaintDto {
    id: string;
    rulingId: string;
    citizenId: string;
    caseId?: string | undefined;
    status: ComplaintStatus;
    statusDisplayName: string;
    complaintGrantIds: string[];
    complaintSubjectRemark: string;
    receivedAt: Date | string;
    receivedForm: ComplaintReceivedForm;
    citizenComplaintJournalNoteId?: string | undefined;
    reassessmentOutcome?: ReassessmentOutcome | undefined;
    reassessmentDecidedAt?: Date | string | undefined;
    reassessmentReasoning?: string | undefined;
    forwardedToAppealsBoardAt?: Date | string | undefined;
    appealsBoardDecision?: AppealsBoardDecision | undefined;
    appealsBoardDecisionDisplayName?: string | undefined;
    appealsBoardDecisionReceivedAt?: Date | string | undefined;
    appealsBoardReplyJournalNoteId?: string | undefined;
    withdrawnAt?: Date | string | undefined;
    complaintDeadline?: Date | string | undefined;
    receivedAfterComplaintDeadline: boolean;
    reassessmentDeadline: Date | string;
}

export enum ComplaintStatus {
    ReassessmentInProgress = "reassessmentInProgress",
    Sustained = "sustained",
    DismissedByMunicipality = "dismissedByMunicipality",
    ForwardedToAppealsBoard = "forwardedToAppealsBoard",
    ReplyReceivedFromAppealsBoard = "replyReceivedFromAppealsBoard",
    Withdrawn = "withdrawn",
}

export interface RulingContinuationDto {
    id: string;
    rulingId: string;
    recordCreatedAt: Date | string;
    recordCreatedBy: string;
    status: RulingContinuationStatus;
    statusDisplayName: string;
    followUpPerformedAt?: Date | string | undefined;
    followUpSummary: string;
    followUpSummaryPlainText: string;
    relevantJournalNoteIds: string[];
    relevantDocumentIds: string[];
    followUpInterviewId?: string | undefined;
    continuationProposal?: string | undefined;
    continuationProposalPlainText?: string | undefined;
    intakeTeamId?: string | undefined;
    intakeUserId?: string | undefined;
    intakePlannedAt?: Date | string | undefined;
    visitationAssessment?: VisitationDecision | undefined;
    visitationComment?: string | undefined;
    visitationAssessedAt?: Date | string | undefined;
    visitationAssessedBy?: string | undefined;
    nextFollowUpDate?: Date | string | undefined;
    completedAt?: Date | string | undefined;
    completedBy?: string | undefined;
    continuationLetterSent: boolean;
}

export enum RulingContinuationStatus {
    InProgress = "inProgress",
    AwaitingVisitation = "awaitingVisitation",
    VisitationCompleted = "visitationCompleted",
    Completed = "completed",
    Cancelled = "cancelled",
}

export interface RulingDto {
    rulingId: string;
    rulingStatusDisplayName?: string | undefined;
    responsibleUserId?: string | undefined;
    responsibleUserFullname?: string | undefined;
    responsibleTeamId?: string | undefined;
    responsibleTeamName?: string | undefined;
    recordCreatedAt: Date | string;
    recordCreatedBy: string;
    recordCreatedByFullname?: string | undefined;
    rulingStartCause?: RulingStartCauseOptions | undefined;
    applicationReceivedAt?: Date | string | undefined;
    grants?: RulingGrantDto[] | undefined;
    citizenContactPersonName?: string | undefined;
    citizenContactPersonRole?: string | undefined;
    rulingStartReasonRemark?: string | undefined;
    caseInformationSummary?: string | undefined;
    recommendation?: string | undefined;
    intakeTeamName?: string | undefined;
    intakeUserFullname?: string | undefined;
    intakePlannedAt?: Date | string | undefined;
    hearingRelevant?: boolean | undefined;
    rulingNotificationLetterSent: boolean;
    hearingLetterSent: boolean;
    rulingDecisionLetterSent: boolean;
    grantResultDisplayName?: string | undefined;
    applicationOrRulingConcerning?: string | undefined;
    reasonForTerminationDisplayName?: string | undefined;
    terminationExplanation?: string | undefined;
}

export interface RulingGrantDto {
    id: string;
    grantType?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    status: GrantStatus;
    followUpDate?: Date | string | undefined;
    description?: string | undefined;
}

export interface RulingVisitationBookingModel {
    visitationTeamId: string;
    teamName: string;
    startAt: Date | string;
    endAt: Date | string;
    reservedMinutes: number;
    determiningGrantTypeName?: string | undefined;
    isOverbooked: boolean;
}

export interface VisitationTeamOptionModel {
    visitationTeamId: string;
    teamId: string;
    teamName: string;
    description?: string | undefined;
    reservedMinutes: number;
    determiningGrantTypeName?: string | undefined;
    uncoveredGrantTypeNames: string[];
    allowLaterTimeChoice: boolean;
    availableTimes: VisitationTimeModel[];
    overbookableMeetings: VisitationTimeModel[];
}

export interface VisitationTimeModel {
    visitationScheduleId: string;
    meetingStartAt: Date | string;
    meetingEndAt: Date | string;
    startAt: Date | string;
    endAt: Date | string;
    isOverbooked: boolean;
    location?: string | undefined;
}

export interface AppealFormModel {
    citizen?: AppealFormCitizen | undefined;
    sender?: AppealFormSender | undefined;
    subjectAreas?: AppealFormSubjectArea[] | undefined;
    dates?: AppealFormDates | undefined;
    deadlineCompliance?: AppealFormDeadlineCompliance | undefined;
    receivedForm: ComplaintReceivedForm;
    reassessmentOutcome?: ReassessmentOutcome | undefined;
    complaintSubjectRemark?: string | undefined;
    reassessmentReasoning?: string | undefined;
}

export interface AppealFormCitizen {
    fullName?: string | undefined;
    cpr?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AppealFormSender {
    name?: string | undefined;
    cvr?: string | undefined;
    caseWorkerName?: string | undefined;
    caseWorkerEmail?: string | undefined;
    caseWorkerPhoneNumber?: string | undefined;
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    suiteIdentifier?: string | undefined;
    postCode?: string | undefined;
    district?: string | undefined;
    openingHours?: string | undefined;
}

export interface AppealFormSubjectArea {
    grantTypeName?: string | undefined;
    lawReference?: string | undefined;
    lawReferenceDisplayName?: string | undefined;
    paragraph?: string | undefined;
    subsection?: number | undefined;
    articleNumber?: number | undefined;
}

export interface AppealFormDates {
    rulingDecidedAt?: Date | string | undefined;
    complaintReceivedAt: Date | string;
    reassessmentDecidedAt?: Date | string | undefined;
    forwardedToAppealsBoardAt?: Date | string | undefined;
}

export interface AppealFormDeadlineCompliance {
    complaintDeadline?: Date | string | undefined;
    receivedAfterComplaintDeadline: boolean;
    reassessmentDeadline: Date | string;
    reassessmentWithinDeadline?: boolean | undefined;
}

export interface CommonCitizenContext {
    citizenId: string;
    firstName: string;
    middleName?: string | undefined;
    lastName: string;
    fullName: string;
    cpr: string;
    responsibleMunicipality?: string | undefined;
    payingMunicipality?: string | undefined;
    restrictedCases?: CitizenRestrictedCases[] | undefined;
    isAnonymous: boolean;
    preferredName?: string | undefined;
}

export interface AuthorityCitizenContext extends CommonCitizenContext {
    citizenNotFound: boolean;
    cprStatusCode: PersonCivilRegistrationStatusCodeType;
    jobcenterDifferentFromTenant?: string | undefined;
    hasAnyCases: boolean;
    generalCitizenInfo?: GeneralCitizenInfo | undefined;
    address?: string | undefined;
    telephoneNumber?: string | undefined;
    mobileNumber?: string | undefined;
    age?: number | undefined;
    targetGroup?: string | undefined;
    caseTypeName?: string | undefined;
    targetGroupName?: string | undefined;
    targetGroupId?: string | undefined;
    targetGroupCode?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    approvedForFlexJobDate?: Date | string | undefined;
    primaryUserName?: string | undefined;
    caseStatus?: CaseStatus2 | undefined;
    caseId?: string | undefined;
    attentionNotes?: AttentionNote[] | undefined;
    informalNote?: string | undefined;
    municipality?: string | undefined;
    hideCaseLink?: boolean | undefined;
    primarySocialCase?: CitizenPrimaryCaseInfo | undefined;
}

export enum PersonCivilRegistrationStatusCodeType {
    RegistreretMedBopaelIDanskFolkeregister = "registreretMedBopaelIDanskFolkeregister",
    RegistreretMedHoejVejkodeIDanskFolkeRegister = "registreretMedHoejVejkodeIDanskFolkeRegister",
    RegistreretMedBopaelIGroenlandskFolkeregister = "registreretMedBopaelIGroenlandskFolkeregister",
    RegistreretMedHoejVejkodeIGroenlandskFolkeregister = "registreretMedHoejVejkodeIGroenlandskFolkeregister",
    RegistreretUdenBopaelIDanskGroenlandskFolkeRegister = "registreretUdenBopaelIDanskGroenlandskFolkeRegister",
    AnnulleretPersonnummer = "annulleretPersonnummer",
    SlettetPersonnummer = "slettetPersonnummer",
    AendretPersonnummer = "aendretPersonnummer",
    Forsvundet = "forsvundet",
    Udrejst = "udrejst",
    Doed = "doed",
}

export interface GeneralCitizenInfo {
    citizenId: string;
    currentCitizenId?: string | undefined;
    cprHistory?: GeneralCprHistoryEntry[] | undefined;
    existsInDfdg: boolean;
}

export interface GeneralCprHistoryEntry {
    cpr?: string | undefined;
    citizenId?: string | undefined;
}

export enum CaseStatus2 {
    Active = "active",
    Finished = "finished",
    NeedsToBeTerminated = "needsToBeTerminated",
}

export interface AttentionNote {
    id: string;
    severity?: AttentionNoteIcon | undefined;
    value?: string | undefined;
    author?: string | undefined;
    date?: Date | string | undefined;
    expiresOn?: Date | string | undefined;
    priority?: number | undefined;
}

export enum AttentionNoteIcon {
    Warning = "warning",
    Info = "info",
}

export interface CitizenPrimaryCaseInfo {
    caseId: string;
    caseTypeName?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    caseStatus: CaseStatus2;
    primaryUserName?: string | undefined;
    targetGroupName?: string | undefined;
    targetGroupId?: string | undefined;
    targetGroupCode?: string | undefined;
    hideCaseLink: boolean;
}

export interface CitizenRestrictedCases {
    caseDisplayName?: string | undefined;
    caseRestrictionName?: string | undefined;
}

export interface DueDateItem {
    text?: string | undefined;
    dueDate: Date | string;
}

export interface CitizenHeader {
    citizenId: string;
    firstName: string;
    middleName?: string | undefined;
    lastName: string;
    fullName: string;
    cpr: string;
    cprStatusCode: PersonCivilRegistrationStatusCodeType;
    jobcenterDifferentFromTenant?: string | undefined;
    hasAnyCases: boolean;
    generalCitizenInfo?: GeneralCitizenInfo | undefined;
    address?: string | undefined;
    telephoneNumber?: string | undefined;
    mobileNumber?: string | undefined;
    age?: number | undefined;
    targetGroup?: string | undefined;
    caseTypeName?: string | undefined;
    targetGroupName?: string | undefined;
    targetGroupId?: string | undefined;
    targetGroupCode?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    primaryUserName?: string | undefined;
    caseStatus?: CaseStatus2 | undefined;
    caseId?: string | undefined;
    attentionNotes?: AttentionNote[] | undefined;
    informalNote?: string | undefined;
    municipality?: string | undefined;
    preferredName?: string | undefined;
}

export interface LatestInterviewViewModel {
    latestInterviewTime?: Date | string | undefined;
    latestInterviewType?: string | undefined;
}

export interface LatestCompanyActivityViewModel {
    offerCategory?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
}

export interface SicknessBenefitViewModel {
    sicknessBenefitDurationDate?: Date | string | undefined;
    benefitExtensionReason?: string | undefined;
    benefitExtensionStartDate?: Date | string | undefined;
}

export interface CitizenExemptionsViewModel {
    exemptions?: CitizenExemptionViewModel[] | undefined;
}

export interface CitizenExemptionViewModel {
    exemption?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
}

export interface CaseSummaryDetailsModel {
    caseStatus?: CaseStatus | undefined;
    endDate?: Date | string | undefined;
    firstDayOfAbsence?: Date | string | undefined;
}

export interface PersonGroupMarkingSummaryViewModel {
    id: string;
    name?: string | undefined;
    isActive: boolean;
}

export interface SocialProviderCitizenContext extends CommonCitizenContext {
    serviceProviderUnits?: SocialProviderUnitDto2[] | undefined;
}

export interface SocialProviderUnitDto2 {
    id: string;
    externalId: string;
    name: string;
    description?: string | undefined;
    companyId: string;
    prefersAssignmentsAsLetter: boolean;
    departmentUuid?: string | undefined;
    contactPointId?: string | undefined;
    abbreviation?: string | undefined;
    eanNumber?: string | undefined;
    eMailAddress?: string | undefined;
    eMailNotification?: boolean | undefined;
    sorCode?: string | undefined;
}

export interface SocialProviderCitizenHeader {
    citizenId: string;
    firstName: string;
    middleName?: string | undefined;
    lastName: string;
    fullName: string;
    cpr: string;
    cprStatusCode: PersonCivilRegistrationStatusCodeType;
    generalCitizenInfo?: GeneralCitizenInfo | undefined;
    address?: string | undefined;
    telephoneNumber?: string | undefined;
    mobileNumber?: string | undefined;
    age?: number | undefined;
    attentionNotes?: AttentionNote[] | undefined;
    informalNote?: string | undefined;
    serviceProviderCitizenNote?: string | undefined;
    municipality?: string | undefined;
    responsibleMunicipality?: string | undefined;
    payingMunicipality?: string | undefined;
    assessmentZone?: TrafficLightZone | undefined;
    redZoneSummary?: TrafficLightRedZoneSummary | undefined;
    preferredName?: string | undefined;
}

export interface TrafficLightRedZoneSummary {
    whatHelps?: string | undefined;
    staffShouldDo?: string | undefined;
    staffShouldAvoid?: string | undefined;
    safetyMeasures?: string | undefined;
}

export interface JobcenterPlanViewModel {
    id: string;
    name?: string | undefined;
    alternativHeadlineForPlanDescription?: string | undefined;
    description?: string | undefined;
    caseWorkerName?: string | undefined;
    status: Status;
    templateFieldHeadline?: string | undefined;
    templateFieldContent?: string | undefined;
    educationGoals?: GoalViewModel[] | undefined;
    jobGoals?: GoalViewModel[] | undefined;
    freeTextGoals?: GoalViewModel[] | undefined;
    showFollowupDateInUI: boolean;
    showGoalsForPlanInUI: boolean;
    showContentTemplateFieldInUI: boolean;
    isJobGoalsMandatory: boolean;
    jobcenterAgreement?: JobcenterAgreementViewModel | undefined;
    unemploymentFundAgreement?: UnemploymentFundAgreementViewModel | undefined;
    jobSearchDefinition?: JobSearchDefinitionViewModel | undefined;
    educationPlanViewModel?: EducationPlanViewModel | undefined;
    danishGoalName?: string | undefined;
    hasContract: boolean;
    showUnemploymentJobSearchDefinition: boolean;
    showPlanDescriptionFromConfig: boolean;
    showJobcenterJobSearchDefinition: boolean;
    showUnemploymentFundAgreementConfig: boolean;
}

export enum Status {
    Published = "published",
    Draft = "draft",
    Active = "active",
    NoPlanAtDFDG = "noPlanAtDFDG",
    NoPlanInFasit = "noPlanInFasit",
}

export interface GoalViewModel {
    description?: string | undefined;
}

export interface JobcenterAgreementViewModel {
    agreementDescription?: string | undefined;
    caseWorkerFullName?: string | undefined;
    interviewTime: Date | string;
}

export interface UnemploymentFundAgreementViewModel {
    agreementDescription?: string | undefined;
    caseWorkerFullName?: string | undefined;
    interviewTime: Date | string;
}

export interface JobSearchDefinitionViewModel {
    jobAreas?: string[] | undefined;
    locations?: string[] | undefined;
    otherExpectations?: string | undefined;
    organizationName?: string | undefined;
}

export interface EducationPlanViewModel {
    educationCurrentStep: number;
    educationStepDeadlineDate?: Date | string | undefined;
    educations?: EducationViewModel2[] | undefined;
    educationRetentions?: string[] | undefined;
}

export interface EducationViewModel2 {
    name?: string | undefined;
    locationName?: string | undefined;
    occupationTargetName?: string | undefined;
    applicationDeadlineDate?: Date | string | undefined;
    startDate?: Date | string | undefined;
    sortOrder: number;
    applicationStatus?: string | undefined;
}

export interface PlanTypeListItemViewModel {
    id: string;
    name?: string | undefined;
    isEducationPlanType: boolean;
    isPreferred: boolean;
}

export interface JobcenterContractViewModel {
    contractMetaData?: ContractMetaDataViewModel | undefined;
    danishQualifications?: DanishQualificationsViewModel | undefined;
    citizenData?: CitizenDataViewModel | undefined;
    qualifications?: QualificationsViewModel | undefined;
    healthAssessment?: HealthAssessmentViewModel | undefined;
    reasonForResidencePermit?: string | undefined;
    comment?: string | undefined;
    visitationCategoryName?: string | undefined;
    maritalStatusName?: string | undefined;
    citizenshipName?: string | undefined;
    guidanceText?: string | undefined;
}

export interface ContractMetaDataViewModel {
    firstSigningDate?: Date | string | undefined;
    programStartDate?: Date | string | undefined;
    programEndDate?: Date | string | undefined;
    contractEndDate?: Date | string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    latestPublishDate?: Date | string | undefined;
}

export interface DanishQualificationsViewModel {
    danishGoal?: string | undefined;
    lastModifiedInformedAboutMissingDanishQualifications?: Date | string | undefined;
    lastModifiedInformedAboutMissingDanishQualificationsRegardingBenefits?: Date | string | undefined;
    lastModifiedDanishGoal?: Date | string | undefined;
}

export interface CitizenDataViewModel {
    nationality?: string | undefined;
    maritalStatus?: string | undefined;
    numberOfChildren?: number | undefined;
    familyCircumstances?: string | undefined;
    otherCircumstances?: string | undefined;
    statementAboutCitizenshipDate?: Date | string | undefined;
}

export interface QualificationsViewModel {
    latestGuidedRegardingExistingEducation?: Date | string | undefined;
    educationEvaluationCaseStatus?: string | undefined;
    languageSkills?: LanguageSkillViewModel[] | undefined;
}

export interface LanguageSkillViewModel {
    name?: string | undefined;
    experienceWithLanguage?: string | undefined;
    readProficiency?: string | undefined;
    spokenProficiency?: string | undefined;
    understandSpokenProficiency?: string | undefined;
    writtenProficiency?: string | undefined;
    id?: string | undefined;
}

export interface HealthAssessmentViewModel {
    currentHealthCondition?: string | undefined;
    healthAssessmentHasBeenOffered?: boolean | undefined;
    healthAssessmentResult?: string | undefined;
    initiatedTreatmentDK?: string | undefined;
    otherHealthIssues?: string | undefined;
    coordinatingMunicipalAdministrationUnit?: string | undefined;
    needForHealthAssessment?: boolean | undefined;
}

export interface DanishGoalEditModel {
    id?: string | undefined;
    name?: string | undefined;
}

export interface JobcenterContractEditModel {
    contractMetaData?: ContractMetaDataViewModel | undefined;
    danishQualifications?: DanishQualificationsEditModel | undefined;
    citizenData?: CitizenDataViewModel | undefined;
    qualifications?: QualificationsEditModel | undefined;
    healthAssessment?: HealthAssessmentViewModel | undefined;
    status: ContractStatusDto;
    reasonForResidencePermit?: ResidenceReason | undefined;
    comment?: string | undefined;
}

export interface DanishQualificationsEditModel {
    danishGoal?: DanishGoalEditModel | undefined;
    lastModifiedInformedAboutMissingDanishQualifications?: Date | string | undefined;
    lastModifiedInformedAboutMissingDanishQualificationsRegardingBenefits?: Date | string | undefined;
    lastModifiedDanishGoal?: Date | string | undefined;
}

export interface QualificationsEditModel {
    latestGuidedRegardingExistingEducation?: Date | string | undefined;
    educationEvaluationCaseStatus?: EducationEvaluationCaseStatus | undefined;
    languageSkills?: LanguageSkillEditModel[] | undefined;
}

export enum EducationEvaluationCaseStatus {
    Open = "open",
    Started = "started",
    Closed = "closed",
}

export interface LanguageSkillEditModel {
    name?: string | undefined;
    experienceWithLanguage?: string | undefined;
    readProficiency?: ProficiencyLevel | undefined;
    spokenProficiency?: ProficiencyLevel | undefined;
    understandSpokenProficiency?: ProficiencyLevel | undefined;
    writtenProficiency?: ProficiencyLevel | undefined;
    languageId?: string | undefined;
    id?: string | undefined;
}

export enum ProficiencyLevel {
    IngenKendskab = "ingenKendskab",
    Begynder = "begynder",
    Oevet = "oevet",
    FlydendeModersmaal = "flydendeModersmaal",
}

export enum ContractStatusDto {
    Legal = "legal",
    Draft = "draft",
    Terminated = "terminated",
}

export enum ResidenceReason {
    Fugitive = "fugitive",
    FamilyReunification = "familyReunification",
    OtherFamilyReunification = "otherFamilyReunification",
    Immigrant = "immigrant",
}

export interface PlanEditViewModel {
    planId?: string | undefined;
    planTypeInfo?: PlanTypeInfo | undefined;
    caseworkerId?: string | undefined;
    followupDate?: Date | string | undefined;
    status: Status;
    goals?: GoalEditViewModel[] | undefined;
    templateFieldContent?: string | undefined;
    description?: string | undefined;
    currentStep?: string | undefined;
    applicationDeadlineDate?: Date | string | undefined;
}

export interface PlanTypeInfo {
    id: string;
    name?: string | undefined;
    amuGoalsAllowed: boolean;
    dunGoalsAllowed: boolean;
    escoGoalsAllowed: boolean;
    customGoalsAllowed: boolean;
    isEducationPlan: boolean;
    planDescriptionAllowed: boolean;
    showTemplateField: boolean;
    isGoalMandatory: boolean;
}

export interface GoalEditViewModel {
    goalType: GoalType;
    goalCodeId?: string | undefined;
    description?: string | undefined;
}

export enum GoalType {
    DUN = "dun",
    AMU = "amu",
    Custom = "custom",
    ESCO = "esco",
}

export interface GoalDto {
    goalType: GoalTypeDto;
    goalCodeId?: string | undefined;
    description?: string | undefined;
}

export interface CompanyName {
    id: string;
    name?: string | undefined;
}

export interface GeographicalAreaModel {
    id: number;
    name?: string | undefined;
    externalIdentifier: number;
}

export interface LanguageItem {
    id: string;
    name?: string | undefined;
    isActive: boolean;
}

export interface MunicipalityModel {
    id: string;
    name?: string | undefined;
    externalId?: string | undefined;
}

export interface OccupationModel2 {
    id: string;
    name?: string | undefined;
    externalIdentifierEsco?: string | undefined;
    aliasIdentifier?: string | undefined;
}

export interface JobcenterPlanInfoViewModel {
    versionNumber?: number | undefined;
    isValid?: boolean | undefined;
    lastPublished?: Date | string | undefined;
    followupDeadline?: Date | string | undefined;
    seenByUserOnJobnet?: Date | string | undefined;
    updatedBy?: string | undefined;
    planTypeName?: string | undefined;
    hasDraft?: boolean | undefined;
    hasContractDraft: boolean;
    isTransferredFromAnotherJobcenter: boolean;
    lastJobcenterName?: string | undefined;
}

export interface PlanVersion {
    number: number;
    identifier: string;
    createdDate: Date | string;
    caseworkerFullName?: string | undefined;
    events?: string[] | undefined;
}

export interface IncomeViewModel {
    cpr?: string | undefined;
    records?: IncomeRecordViewModel[] | undefined;
}

export interface IncomeRecordViewModel {
    salaryPeriodStart?: Date | string | undefined;
    salaryPeriodEnd?: Date | string | undefined;
    companyCvr?: string | undefined;
    companyPNumber?: string | undefined;
    companyName?: string | undefined;
    companyId?: string | undefined;
    companyIndustryArea?: string | undefined;
    correctionStatus?: string | undefined;
    incomeType?: string | undefined;
    assessedIncomeMonth?: Date | string | undefined;
    workHours?: number | undefined;
    hasWageSubsidy?: string | undefined;
}

export enum CaseTargetGroupType {
    Other = "other",
    ResourceforloebOrFlexjobOrFoertidspension = "resourceforloebOrFlexjobOrFoertidspension",
    Jobafklaring = "jobafklaring",
}

export interface CitizenCaseMedicalModel {
    caseId: string;
    caseName?: string | undefined;
    isPrimaryCase: boolean;
    isPrimarySocialCase: boolean;
}

export interface DoctorCorrespondenceReceiverModel {
    sorCode?: string | undefined;
    name?: string | undefined;
    canReceiveCorrespondence: boolean;
}

export interface DoctorInfo {
    clinicName?: string | undefined;
    doctorName?: string | undefined;
    doctorAddress?: DoctorAddress | undefined;
    locationNumber?: string | undefined;
    sorCode?: string | undefined;
}

export interface DoctorAddress {
    region?: string | undefined;
    streetAndNumber?: string | undefined;
    city?: string | undefined;
    municipalityCode?: string | undefined;
    postalCode?: string | undefined;
}

export interface HospitalStay {
    hospitalStayIdentifier: string;
    status: HospitalStayStatus;
    admissionStart?: Date | string | undefined;
    dischargeEnd?: Date | string | undefined;
    serviceProviderIdentifier?: string | undefined;
    serviceProviderName?: string | undefined;
    serviceProviderParentName?: string | undefined;
    deceasedOn?: Date | string | undefined;
    leaveStart?: Date | string | undefined;
    lastChangedOn?: Date | string | undefined;
    notifications: HospitalNotification[];
}

export enum HospitalStayStatus {
    Ukendt = "ukendt",
    Indlagt = "indlagt",
    IndlagtAkut = "indlagtAkut",
    PaaOrlov = "paaOrlov",
    Udskrevet = "udskrevet",
    Afgaaet = "afgaaet",
    Annulleret = "annulleret",
}

export interface HospitalNotification {
    messageIdentifier: string;
    type: HospitalNotificationType;
    intent: HospitalNotificationIntent;
    supersededBy?: HospitalNotificationIntent | undefined;
    admissionStart?: Date | string | undefined;
    dischargeEnd?: Date | string | undefined;
    leaveStart?: Date | string | undefined;
    leaveEnd?: Date | string | undefined;
    serviceProviderIdentifier?: string | undefined;
    serviceProviderName?: string | undefined;
    serviceProviderParentName?: string | undefined;
    occurredOn: Date | string;
    receivedOn: Date | string;
}

export enum HospitalNotificationType {
    Ukendt = "ukendt",
    StartSygehusopholdIndlagt = "startSygehusopholdIndlagt",
    StartSygehusopholdAkutAmbulant = "startSygehusopholdAkutAmbulant",
    StartOrlov = "startOrlov",
    SlutOrlov = "slutOrlov",
    SlutSygehusophold = "slutSygehusophold",
    Doed = "doed",
}

export enum HospitalNotificationIntent {
    Original = "original",
    Rettelse = "rettelse",
    Annullering = "annullering",
}

export interface PatientInfo {
    givenName?: string | undefined;
    middleName?: string | undefined;
    surName?: string | undefined;
    healthInsuranceGroup?: number | undefined;
    address?: PatientAddress | undefined;
}

export interface PatientAddress {
    streetAndNumber?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryIdentificationCode?: CountryIdentification | undefined;
}

export interface CountryIdentification {
    scheme: number;
    value?: string | undefined;
}

export interface CorrespondenceMessage {
    id: string;
    messageDirection: MedicalMessageDirection;
    sorId?: string | undefined;
    locationNumber?: string | undefined;
    doctorName?: string | undefined;
    clinicName?: string | undefined;
    citizenId: string;
    caseId?: string | undefined;
    caseDisplayName?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    messageDate: Date | string;
    priority: CorrespondencePriority;
    externalCorrespondenceStatusTypeDisplayName?: string | undefined;
    processed?: boolean | undefined;
    processedByUser?: string | undefined;
    processedByUserName?: string | undefined;
    processedDate?: Date | string | undefined;
    attachments?: CorrespondenceAttachment[] | undefined;
}

export enum MedicalMessageDirection {
    Out = "out",
    In = "in",
}

export interface CorrespondenceAttachment {
    id: string;
    contentReference?: string | undefined;
    fileName?: string | undefined;
    fileSizeInBytes: number;
    contentType?: string | undefined;
}

export interface MedicalRequestViewModel {
    medicalRequestId: string;
    caseId?: string | undefined;
    caseDisplayName?: string | undefined;
    medicalRequestCode?: string | undefined;
    medicalRequestDisplayName?: string | undefined;
    createdDate: Date | string;
    receiverName?: string | undefined;
    contactPersonName?: string | undefined;
    shipmentStatusTypeCode: ShipmentStatusTypeCode;
    shipmentStatusTypeDisplayName?: string | undefined;
    medicalResponseTypeDisplayName?: string | undefined;
    createdBy?: string | undefined;
    requestFormDocumentReference?: string | undefined;
    citizenLetterShipped: boolean;
    citizenLetterShippedDate?: Date | string | undefined;
    processed?: boolean | undefined;
    simulationEnabled: boolean;
    serviceProviderUnitId?: string | undefined;
}

export interface MedicalRequestItemViewModel {
    id: string;
    flowId?: string | undefined;
    caseId?: string | undefined;
    caseDisplayName?: string | undefined;
    serviceProviderUnitId?: string | undefined;
    requestTypeId?: string | undefined;
    medicalRequestCode?: string | undefined;
    medicalRequestDisplayName?: string | undefined;
    createdDate: Date | string;
    shipmentStatusTypeCode: ShipmentStatusTypeCode;
    shipmentStatusTypeDisplayName?: string | undefined;
    externalErrorReasonDisplayName?: string | undefined;
    externalRejectionReasonDisplayName?: string | undefined;
    externalErrorOrRejectionDate?: Date | string | undefined;
    createdBy?: string | undefined;
    informationRequestReason?: string | undefined;
    informationRequestRestriction?: InformationRequestRestrictionType | undefined;
    sorCode?: string | undefined;
    locationNumber?: string | undefined;
    eanLocationNumber?: string | undefined;
    orderNumber?: string | undefined;
    requestFormDocumentReference?: string | undefined;
    requestFormDocumentFileName?: string | undefined;
    medicalResponseItemViewModel?: MedicalResponseItemViewModel | undefined;
    receiverName?: string | undefined;
    receiverCanReceiveCorrespondence: boolean;
    citizenPhoneNumber?: string | undefined;
    contactPersonId?: string | undefined;
    secondaryContactPersonId?: string | undefined;
    contactPersonName?: string | undefined;
    contactPersonPosition?: string | undefined;
    contactPersonAvailabilityPeriod?: string | undefined;
    contactpersonPhoneNumber?: string | undefined;
    secondaryContactPersonName?: string | undefined;
    secondaryContactPersonPosition?: string | undefined;
    secondaryContactPersonAvailabilityPeriod?: string | undefined;
    secondaryContactPersonPhoneNumber?: string | undefined;
    personReference?: string | undefined;
    requisitionNumber?: string | undefined;
    treatmentPeriod_101_111?: string | undefined;
    treatmentDepartment_101?: string | undefined;
    treatmentReason_101_111_221?: string | undefined;
    refugeeLanguage_141f?: string | undefined;
    healthAssessmentType_261?: HealthAssessmentType | undefined;
    caseIdentifier_261?: string | undefined;
    futureGoals_261?: string | undefined;
    employmentSituation_261?: string | undefined;
    socialSituation_261?: string | undefined;
    healthSituation_261?: string | undefined;
    otherCircumstances_261_281?: string | undefined;
    healthCoordinatorName?: string | undefined;
    healthCoordinatorPhoneNumber?: string | undefined;
    healthCoordinatorAvailabilityPeriod?: string | undefined;
    healthCoordinatorMailAddress?: string | undefined;
    examinationType_271?: ExaminationType | undefined;
    examinationName_271?: string | undefined;
    examinationForCaseRegarding_271?: string | undefined;
    caseworkerNotificationAfterWeeks_271?: string | undefined;
    referralReason_271?: string | undefined;
    firstAbsenceDay_221_281?: Date | string | undefined;
    consultationBefore_281?: Date | string | undefined;
    latestFollowUpDate_281?: Date | string | undefined;
    workFunctionImpactAccordingToCitizen_281?: string | undefined;
    workFunctionImpactAccordingToEmployer_281?: string | undefined;
    illnessPeriodImpactAccordingToCitizen_281?: string | undefined;
    illnessPeriodImpactAccordingToEmployer_281?: string | undefined;
    workAdaptationAccordingToCitizen_281?: string | undefined;
    workAdaptationAccordingToEmployer_281?: string | undefined;
    workFunctionImpact_281?: string | undefined;
    illnessPeriodImpact_281?: string | undefined;
    workAdaptation_281?: string | undefined;
    regarding_221?: string | undefined;
    workType_221?: string | undefined;
    citizenLetterShipped: boolean;
    citizenLetterShippedDate?: Date | string | undefined;
    doctorResponseDeadline?: Date | string | undefined;
    medicalNotification?: MedicalNotificationViewModel | undefined;
}

export interface MedicalResponseItemViewModel {
    id: string;
    medicalResponseTypeId: string;
    medicalResponseTypeCode?: string | undefined;
    medicalResponseTypeDisplayName?: string | undefined;
    registeredOn?: Date | string | undefined;
    createdOn: Date | string;
    createdBy: string;
    modifiedOn: Date | string;
    modifiedBy?: string | undefined;
    responseFormDocumentReference?: string | undefined;
    responseFormDocumentFileName?: string | undefined;
    accumulatedAssessment?: string | undefined;
    newlyArrivedRefugeeOrSimilar?: boolean | undefined;
    doctorReturnedDueToMissingInfo?: boolean | undefined;
    doctorTenureWithPatient?: string | undefined;
    doctorInformation?: string | undefined;
    doctorDateAndSignature?: string | undefined;
    processed?: boolean | undefined;
    processedBy?: string | undefined;
    processedByUserName?: string | undefined;
    processedDate?: Date | string | undefined;
    processedRemark?: string | undefined;
    responseFormAttachmentReferences?: ResponseFormAttachmentModel[] | undefined;
}

export interface ResponseFormAttachmentModel {
    contentReference?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
}

export interface MedicalNotificationViewModel {
    createResponseReceivedTask: boolean;
    responseReceivedTaskUserId?: string | undefined;
    responseReceivedTaskUserName?: string | undefined;
    mailNotification: boolean;
    mailNotificationTo?: string | undefined;
}

export interface MedicalRequestTypeModel {
    medicalRequestTypeId: string;
    medicalRequestCode?: string | undefined;
    medicalRequestCodeName?: string | undefined;
    medicalRequestDisplayName?: string | undefined;
}

export interface SorNodeViewModel {
    id: string;
    name: string;
    address?: string | undefined;
    sorCode: string;
    sorLocationNumber?: string | undefined;
    sorUnitType?: string | undefined;
    sorOrganizationalLevelName?: string | undefined;
    ancestorPath?: string | undefined;
    hasChildren: boolean;
    canReceiveCorrespondence: boolean;
    isTunnelmail: boolean;
}

export interface SorSearchResultViewModel {
    id: string;
    displayName?: string | undefined;
    name?: string | undefined;
    sorCode?: string | undefined;
    canReceiveCorrespondence: boolean;
}

export interface AttachmentToValidateDto {
    fileName?: string | undefined;
    extension?: string | undefined;
    sizeInBytes: number;
}

export interface JournalNoteCaseModel {
    caseId: string;
    caseName?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    isPrimaryCase: boolean;
}

export interface JournalNoteModel {
    id: string;
    title?: string | undefined;
    sourceName?: string | undefined;
    contentTypeName?: string | undefined;
    createdByName?: string | undefined;
    createdAt: Date | string;
    eventDate: Date | string;
    caseId?: string | undefined;
    caseName?: string | undefined;
    hasAttachments?: string | undefined;
    attachments?: JournalNoteAttachmentModel[] | undefined;
    content?: string | undefined;
    isCancelled: boolean;
    letterDate?: Date | string | undefined;
    createdByTeamName?: string | undefined;
    createByTeamName?: string | undefined;
    revisionNote?: string | undefined;
    sendingStatus?: string | undefined;
    sendingStatusNote?: string | undefined;
    templateCodeName?: string | undefined;
    templateMappingName?: string | undefined;
    caseUrl?: string | undefined;
    journalNoteUrl?: string | undefined;
    relatedEntityInfo?: EntityInfo | undefined;
    isRead?: boolean | undefined;
}

export interface JournalNoteAttachmentModel {
    id: string;
    title?: string | undefined;
    fileName?: string | undefined;
    owner?: string | undefined;
    documentIdentifier?: string | undefined;
    mimeType?: string | undefined;
    fileSizeInBytes: number;
    titleWithFileSize?: string | undefined;
}

export interface EntityInfo {
    entityId: string;
    entityName?: string | undefined;
}

export interface ExcludedAttachment {
    id: string;
    journalNoteId: string;
    journalNoteTitle?: string | undefined;
    title?: string | undefined;
    mimetype?: string | undefined;
    filename?: string | undefined;
    exclusionReason: ExclusionReason;
}

export enum ExclusionReason {
    FileFormat = "fileFormat",
    JournalReport = "journalReport",
}

export enum JournalReportDateField {
    RegistrationDate = "registrationDate",
    EventDate = "eventDate",
}

export interface JournalReportProgressDto {
    id: string;
    citizenId: string;
    journalReportJobStatus: JournalReportJobStatusDto;
    createdBy: string;
    createdOn: Date | string;
    journalReportId?: string | undefined;
    errorMessage?: string | undefined;
}

export enum JournalReportJobStatusDto {
    Enqueued = "enqueued",
    InProgress = "inProgress",
    Completed = "completed",
    Failed = "failed",
}

export interface JournalNoteScanResult {
    citizenId: string;
    journalNoteId: string;
    journalNoteTitle?: string | undefined;
    journalNoteContentMatchResults?: JournalNoteContentMatchResult[] | undefined;
    attachmentContentMatchResults?: AttachmentContentMatchResult[] | undefined;
}

export interface JournalNoteContentMatchResult {
    match?: string | undefined;
    matchWithSuroundingText?: string | undefined;
    hasMatch: boolean;
    isRevision: boolean;
}

export interface AttachmentContentMatchResult {
    attachmentId: string;
    fileName?: string | undefined;
    title?: string | undefined;
    titleWithSize?: string | undefined;
    match?: string | undefined;
    status: ScanResultStatus;
    matchWithSuroundingText?: string | undefined;
    pageNumber: number;
    confidence: number;
}

export enum ScanResultStatus {
    NoData = "noData",
    NoMatch = "noMatch",
    Match = "match",
}

export interface CitizenCaseViewModelBFF {
    id?: string | undefined;
    name?: string | undefined;
    isPrimaryCase?: boolean | undefined;
    caseStatus?: CaseLookupStatus | undefined;
}

export interface TargetGroup {
    sustenanceTeamId?: string | undefined;
}

export interface SystemUserModel {
    id: string;
    displayName: string;
    name: string;
    email: string;
}

export interface JournalNoteContentTypeModel {
    name: string;
    id: string;
    isActive: boolean;
    applicableToJournalNoteOptics?: string[] | undefined;
    noteTypes?: JournalNoteContentTypeNoteType2[] | undefined;
}

export enum JournalNoteContentTypeNoteType2 {
    Journal = "journal",
    Diary = "diary",
}

export interface JournalNoteListItemModel {
    id: string;
    title?: string | undefined;
    sourceName?: string | undefined;
    contentTypeName?: string | undefined;
    createdByName?: string | undefined;
    createdAt: Date | string;
    eventDate: Date | string;
    caseId?: string | undefined;
    caseName?: string | undefined;
    hasAttachments?: string | undefined;
    isCancelled: boolean;
    isRead?: boolean | undefined;
}

export interface CountResponse {
    withCurrentFilters: number;
    withNoFilters: number;
}

export interface FilterResponse {
    contentTypes: KeyValuePair[];
    createdBy: KeyValuePair[];
    cases: KeyValuePair[];
    sources: KeyValuePair[];
    hasAttachments: KeyValuePair[];
    hasMessagesToBenefitsCenter: boolean;
}

export interface KeyValuePair {
    key: string;
    value: string;
}

export interface PageRequest {
    pageSize: number;
    pageNumber: number;
}

export interface SortRequest {
    sortBy: SortBy;
    sortOrder: SortOrder;
}

export enum SortBy {
    EventDate = "eventDate",
    CreatedAt = "createdAt",
}

export enum SortOrder {
    Descending = "descending",
    Ascending = "ascending",
}

export interface FilterRequest {
    filterStatus: FilterStatus;
    title?: string | undefined;
    contentTypes: KeyValuePair[];
    createdBy: KeyValuePair[];
    cases: KeyValuePair[];
    sources: KeyValuePair[];
    hasAttachments: KeyValuePair[];
}

export enum FilterStatus {
    All = "all",
    OnlyActive = "onlyActive",
    OnlyCancelled = "onlyCancelled",
    OnlyMessagesToBenefitsCenter = "onlyMessagesToBenefitsCenter",
    OnlyActiveSocialNotes = "onlyActiveSocialNotes",
}

export interface JournalReportModel {
    citizenId: string;
    title: string;
    id: string;
    creationDate: Date | string;
    createdById: string;
    createdByName?: string | undefined;
    files?: JournalReportFileModel[] | undefined;
    comment?: string | undefined;
    showOnCitizenPortal: boolean;
}

export interface JournalReportFileModel {
    id: string;
    fileName: string;
    mimeType: string;
    fileSize: number;
    creationDate: Date | string;
    pageCount: number;
}

export enum JournalReportJobStatus {
    Unknown = "unknown",
    Enqueued = "enqueued",
    Scheduled = "scheduled",
    Processing = "processing",
    Succeeded = "succeeded",
    Failed = "failed",
}

export interface JournalNoteForLookupModel {
    id: string;
    title?: string | undefined;
    eventDate: Date | string;
    contentTypeName?: string | undefined;
    caseName?: string | undefined;
}

export interface DocumentAttachmentSimple {
    contentReference?: string | undefined;
    owner?: string | undefined;
}

export interface DocumentViewModel {
    id?: string | undefined;
    citizenId: string;
    caseId?: string | undefined;
    assignmentId?: string | undefined;
    serviceProviderUnitId?: string | undefined;
    title?: string | undefined;
    deadline?: Date | string | undefined;
    content?: string | undefined;
    comment?: string | undefined;
    isFinished: boolean;
    templateName: string;
    templateMappingCode: string;
    followupDate?: Date | string | undefined;
    responsibleWorker: ResponsibleWorkerViewModel;
    createdOn?: Date | string | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedOn?: Date | string | undefined;
    modifiedByName?: string | undefined;
    caseName?: string | undefined;
    attachments?: DocumentAttachmentViewModel[] | undefined;
}

export interface ResponsibleWorkerViewModel {
    name: string;
    id: string;
    email?: string | undefined;
}

export interface DocumentListItemModel {
    id: string;
    caseId?: string | undefined;
    title?: string | undefined;
    deadline?: Date | string | undefined;
    comment?: string | undefined;
    status?: string | undefined;
    isFinished: boolean;
    followupDate?: Date | string | undefined;
    responsibleName?: string | undefined;
    createdOn: Date | string;
    createdByName?: string | undefined;
    modifiedOn?: Date | string | undefined;
    modifiedByName?: string | undefined;
    caseName?: string | undefined;
    caseUrl?: string | undefined;
    serviceProviderUnitId?: string | undefined;
    assignmentId?: string | undefined;
}

export interface DocumentTemplatesViewModel {
    codeName?: string | undefined;
    label?: string | undefined;
    name?: string | undefined;
    value?: DocumentTemplateItem | undefined;
}

export interface DocumentTemplateItem {
    templateId: number;
    variantId?: number | undefined;
}

export interface HeaderFooterInfo {
    enabled: boolean;
    height: number;
    templateCode: string;
}

export interface Attachment {
    id?: string | undefined;
    name?: string | undefined;
    fileFormat?: string | undefined;
    fileName?: string | undefined;
    mimeType?: string | undefined;
    content?: string | undefined;
    stringContent?: string | undefined;
    groupKey?: string | undefined;
    isSupportedMimeType: boolean;
}

export interface DocumentArchiveDocumentModel {
    id: string;
    documentId: string;
    shelf: string;
    title: string;
    name: string;
    added: string;
    aliasId?: string | undefined;
    size: string;
    sizeInBytes: number;
    mime: string;
    externalOwner?: string | undefined;
    blobReference?: string | undefined;
}

export interface JournalNoteCreateModel {
    title: string;
    contentType: string;
    source: number;
    content: string;
    citizenId: string;
    eventDate: Date | string;
    caseId?: string | undefined;
    receivingCaseWorkerId?: string | undefined;
    receivingCaseWorkerIds?: string[] | undefined;
    receivingTeamId?: string | undefined;
    attachments?: JournalNoteAttachmentCreateModel[] | undefined;
    createAdvis: boolean;
    advisIsOnlyForCaseWorker?: boolean | undefined;
    receiverType?: ReceiverType | undefined;
    letterDate?: Date | string | undefined;
}

export interface JournalNoteAttachmentCreateModel {
    title: string;
    owner: string;
    documentIdentifier: string;
}

export enum ReceiverType {
    Jobcenter = "jobcenter",
    Ydelsescenter = "ydelsescenter",
}

export interface MissingPartialsInfo2 {
    missingPartialsCount: number;
    totalPartialsCount: number;
}

export enum JournalNoteSummaryStatus {
    FullSummary = "fullSummary",
    PartialSummary = "partialSummary",
    NoSummary = "noSummary",
}

export interface CompanyRecruitmentLookUpDetailsViewModel {
    companyRecruitmentId: string;
    title?: string | undefined;
    internalReferenceNumber: number;
    startDate?: Date | string | undefined;
    occupationId?: string | undefined;
    offerTypeId?: string | undefined;
    jobDescription?: string | undefined;
    weeklyHours?: number | undefined;
    weeklyWorkTimeType?: number | undefined;
    company?: JrCompanyViewModel | undefined;
}

export interface CompanyRecruitmentLookupViewModel {
    companyRecruitmentId: string;
    title?: string | undefined;
    internalReferenceNumber: number;
    companyId: string;
    companyName?: string | undefined;
}

export interface OfferTypeCodeListDto2 {
    id: string;
    name?: string | undefined;
    isActive: boolean;
}

export interface ChangeJobcenterViewModel {
    userSubjobcenter?: SubjobcenterModel | undefined;
    municipalitySubjobcenters?: SubjobcenterModel[] | undefined;
    jobcenters?: JobcenterModel[] | undefined;
}

export interface SubjobcenterModel {
    id: string;
    externalId?: string | undefined;
    name?: string | undefined;
}

export interface JobcenterModel {
    id: string;
    externalId?: string | undefined;
    name?: string | undefined;
}

export interface EnrollmentViewModel {
    enrollmentId: string;
    citizenId: string;
    enrollmentDate: Date | string;
    clientCategoryType: string;
    currentUnemploymentStatusType: CurrentUnemploymentStatusType;
    authorityType?: string | undefined;
    isEnrollmentConfirmed?: boolean | undefined;
    removalDate?: Date | string | undefined;
    removalCauseType?: string | undefined;
}

export interface EnrollmentRemovalCauseItem {
    id: string;
    name?: string | undefined;
}

export interface DfdgProfession2 {
    conceptUriDa?: string | undefined;
    aliasIdentifier?: string | undefined;
    hasEducation: boolean;
    yearLastUsed?: number | undefined;
    monthsOfExperience?: number | undefined;
    nameEsco?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
}

export interface ClientCategoryType2 extends CodeListItem {
    externalId?: string | undefined;
    stateCode: number;
}

export interface EnrollmentCurrentUnemploymentStatusType {
    currentUnemploymentStatusType: CurrentUnemploymentStatusType;
    displayName?: string | undefined;
}

export interface EnrollmentCvJobSearchViewModel {
    enrollmentId: string;
    enrollmentDate: Date | string;
    clientCategoryType?: string | undefined;
    authorityType?: string | undefined;
    removalDate?: Date | string | undefined;
    removalCauseType?: string | undefined;
    createdOn: Date | string;
}

export interface ContactGroupCitizenDetailsViewModel {
    contactGroupId: string;
    citizenId: string;
    contactGroupTypeId: string;
    contactGroupType?: string | undefined;
    authorityType?: string | undefined;
    eventDate?: Date | string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    createdOn: Date | string;
    createdByUserId?: string | undefined;
    createdBy?: string | undefined;
}

export interface BenefitViewModel {
    benefitDecisionId: string;
    citizenId: string;
    kyBenefitIdentifier?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    kyKey?: string | undefined;
    lawReference?: string | undefined;
    contactGroupType?: CodelistViewModel | undefined;
    benefitDecisionType?: CodelistViewModel | undefined;
    benefitRateLevelType?: CodelistViewModel | undefined;
}

export interface CodelistViewModel {
    codelistId?: string | undefined;
    codelistName?: string | undefined;
    codelistExternalId?: string | undefined;
}

export interface JoblogEntryForOverview {
    id: string;
    documents?: string | undefined;
    joblogEntryType: JoblogEntryCategoryType;
    createdDate: Date | string;
    lastModifiedDate: Date | string;
    jobSearchStatus?: JobSearchStatus | undefined;
    company?: string | undefined;
    joblogDetailsLink?: string | undefined;
    submissionDate?: Date | string | undefined;
    title?: string | undefined;
    jobApplicationSourceIdentifier?: JobApplicationSourceType | undefined;
    typeOfSubmission?: JoblogEntryTypeOfSubmissionType | undefined;
    submissionDeadlineDate?: Date | string | undefined;
    weeklyWorkTimeType: WeeklyWorkTimeType2;
    cvJobConditionType: CvJobConditionType;
    companyAddressStreet?: string | undefined;
    companyPostCodeIdentifier?: string | undefined;
    companyTown?: string | undefined;
    companyCountry?: string | undefined;
    companyContactPerson?: string | undefined;
    companyPhone?: string | undefined;
    companyEmail?: string | undefined;
}

export enum JoblogEntryCategoryType {
    Jobsoegning = "jobsoegning",
    AndenAktivitet = "andenAktivitet",
}

export interface JobSearchStatus {
    jobSearchStatusType: JobSeekingStatusType;
    registrationDate: Date | string;
}

export enum JobSeekingStatusType {
    IkkeSoegt = "ikkeSoegt",
    Soegt = "soegt",
    Samtale = "samtale",
    FikJobbet_DEPRECATED = "fikJobbet_DEPRECATED",
    Afslag_DEPRECATED = "afslag_DEPRECATED",
    IkkeAngivet_DEPRECATED = "ikkeAngivet_DEPRECATED",
}

export enum JobApplicationSourceType {
    Uopfordret = "uopfordret",
    OpslaaetStilling = "opslaaetStilling",
    GennemNetvaerk = "gennemNetvaerk",
    BlevKontaktet_DEPRECATED = "blevKontaktet_DEPRECATED",
    IkkeAngivet_DEPRECATED = "ikkeAngivet_DEPRECATED",
}

export enum JoblogEntryTypeOfSubmissionType {
    EmailEllerBrev_DEPRECATED = "emailEllerBrev_DEPRECATED",
    Telefon = "telefon",
    Personligt = "personligt",
    Facebook_DEPRECATED = "facebook_DEPRECATED",
    Kontaktet_DEPRECATED = "kontaktet_DEPRECATED",
    Andet_DEPRECATED = "andet_DEPRECATED",
    Webansoegning_DEPRECATED = "webansoegning_DEPRECATED",
    PersonligtNetvaerk_DEPRECATED = "personligtNetvaerk_DEPRECATED",
    Digitalt = "digitalt",
}

export enum WeeklyWorkTimeType2 {
    Fuldtid = "fuldtid",
    Deltid = "deltid",
    IkkeAngivet_DEPRECATED = "ikkeAngivet_DEPRECATED",
}

export enum CvJobConditionType {
    WillingToUseOwnCar = "willingToUseOwnCar",
    FullTimeEmployment = "fullTimeEmployment",
    PartTimeEmployment = "partTimeEmployment",
    StartAsSoonAsPossible = "startAsSoonAsPossible",
    StartAsAgreedOn = "startAsAgreedOn",
    PermanentJobPosition = "permanentJobPosition",
    TemporaryJobPosition = "temporaryJobPosition",
    StandardJobConditions = "standardJobConditions",
    EarlyRetirementConditions = "earlyRetirementConditions",
    DisabilityPensionerConditions = "disabilityPensionerConditions",
}

export interface JoblogDocumentMetadataForOverview {
    externalDocumentIdentifier?: string | undefined;
    documentTitle?: string | undefined;
    joblogDocumentType: JoblogDocumentType;
}

export enum JoblogDocumentType {
    Jobannoncer = "jobannoncer",
    Jobansoegninger = "jobansoegninger",
    Cv = "cv",
}

export interface BookingForCaseV2ViewModel {
    id: string;
    scheduledStartTime: Date | string;
    caseworkerName?: string | undefined;
    interviewTypeName?: string | undefined;
    interviewFormType?: InterviewFormType | undefined;
}

export interface BookingViewModel extends BookingViewModelBase {
    id: string;
    createdOn: Date | string;
    modifiedOn: Date | string;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    status: BookingStatus;
    createdInDfdg?: Date | string | undefined;
    caseworker?: CaseworkerModel | undefined;
}

export enum BookingStatus {
    Draft = "draft",
    Booked = "booked",
    Cancelled = "cancelled",
    Completed = "completed",
}

export interface CaseworkerModel {
    userIdentifier: string;
    caseWorkerFullName?: string | undefined;
    userEmail?: string | undefined;
    phone?: string | undefined;
    teamName?: string | undefined;
    teamId?: string | undefined;
}

export interface BookingLetterContentViewModel {
    citizenId: string;
    interviewTypeCode?: number | undefined;
    caseworkerId?: string | undefined;
    interviewContactType?: KeyValuePairOfSamtaleformTypeAndCodeListItem | undefined;
    scheduledDate?: Date | string | undefined;
    scheduledStartTime?: TimeOfDay | undefined;
    scheduledEndTime?: TimeOfDay | undefined;
    cancellationPossible: boolean;
    cancellationDeadlineDate?: Date | string | undefined;
    cancellationDeadlineTime?: TimeOfDay | undefined;
    reBookingPossible: boolean;
    reBookingDeadlineDate?: Date | string | undefined;
    reBookingDeadlineTime?: TimeOfDay | undefined;
    address?: Address | undefined;
    contactDetailsDigitalContact?: string | undefined;
    contactDetailsPhoneNumber?: string | undefined;
    caller?: Caller | undefined;
    listOfOtherParticipants?: InterviewParticipantViewModel[] | undefined;
    meetingDescription?: string | undefined;
}

export interface KeyValuePairOfSamtaleformTypeAndCodeListItem {
    key: SamtaleformType;
    value?: CodeListItem6 | undefined;
}

export interface CodeListItem6 {
    description?: string | undefined;
    deprecated: boolean;
    code: number;
    type?: string | undefined;
    name?: string | undefined;
}

export interface BookingForSchedule {
    bookingId: string;
    startDate: Date | string;
    endDate: Date | string;
    isCompleted: boolean;
    interviewType: InterviewType;
    interviewTypeName?: string | undefined;
}

export interface BookingTableRowViewModel {
    bookingTime?: BookingTimeDisplayModel | undefined;
    interviewId?: string | undefined;
    interviewContactType?: SamtaleformType | undefined;
    interviewTypeName?: string | undefined;
    interviewTypeUnion?: InterviewTypeUnion | undefined;
    caseworker?: CaseworkerTableRowViewModel | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    id: string;
    status?: BookingStatus | undefined;
    cancellationType?: CancellationType | undefined;
}

export interface BookingTimeDisplayModel {
    bookingTime?: TimeOfDay | undefined;
    bookingDate?: Date | string | undefined;
}

export interface CaseworkerTableRowViewModel {
    caseworkerName?: string | undefined;
    externalCaseworker: boolean;
}

export interface BookingForNuphViewModel {
    externalId: string;
    interviewType: InterviewType;
    scheduledStartTime: Date | string;
}

export interface KeyValuePairOfInterviewTypeAndCodeListItem {
    key: InterviewType;
    value?: CodeListItem6 | undefined;
}

export interface MeetingLocationDetails {
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    postCodeIdentifier?: string | undefined;
    districtName?: string | undefined;
    floorIdentifier?: string | undefined;
    suiteIdentifier?: string | undefined;
    countryIdentificationCode?: string | undefined;
    room?: string | undefined;
}

export interface InterviewBookingConfigurationV2 {
    interviewTypeCode: number;
    cancellationPossible: boolean;
    cancellationOffset?: number | undefined;
    reBookingPossible: boolean;
    reBookingOffset?: number | undefined;
}

export interface InterviewExemption {
    start: Date | string;
    end?: Date | string | undefined;
    type: ExemptionType;
}

export enum ExemptionType {
    Activation = "activation",
    Attendance = "attendance",
    TJOBCV = "tjobcv",
    SelfBooking = "selfBooking",
    Offer = "offer",
    JobLogCV = "jobLogCV",
    Interview = "interview",
    Enrollment = "enrollment",
    CV = "cv",
    JobReferralCV = "jobReferralCV",
    Sickness = "sickness",
}

export interface Booking {
    id: string;
    externalId?: string | undefined;
    interviewId?: string | undefined;
    meetingTitle?: string | undefined;
    meetingDescription?: string | undefined;
    cancellationCauseTypeCodeListValue?: string | undefined;
    cancellationCauseType?: CancellationCauseType | undefined;
    cancellationType?: CancellationType | undefined;
    cancellationDeadline?: Date | string | undefined;
    cancellationPossible: boolean;
    contactDetailsDigitalContact?: string | undefined;
    contactDetailsPhoneNumber?: string | undefined;
    correctionComment?: string | undefined;
    externalCaseworkerId?: string | undefined;
    externalCaseworkerFirstName?: string | undefined;
    externalCaseworkerMiddleName?: string | undefined;
    externalCaseworkerLastName?: string | undefined;
    caseworkerId?: string | undefined;
    showCaseworkerNameForCitizen?: boolean | undefined;
    companyId?: string | undefined;
    privateContactPersonId?: string | undefined;
    interviewFormType?: InterviewFormType | undefined;
    reBookingDeadline?: Date | string | undefined;
    reBookingPossible: boolean;
    scheduledStartTime?: Date | string | undefined;
    scheduledEndTime?: Date | string | undefined;
    selfBooked: boolean;
    interviewContactType?: SamtaleformType | undefined;
    interviewType?: InterviewType | undefined;
    interviewTypeCode?: number | undefined;
    caller?: Caller | undefined;
    organizationCode?: number | undefined;
    organizationType?: OrganisationType | undefined;
    status: BookingStatus;
    bookingAccepted: boolean;
    bookingAcceptedOn?: Date | string | undefined;
    citizenId: string;
    caseId?: string | undefined;
    caseTypeId?: string | undefined;
    targetGroupId?: string | undefined;
    createdByUserId?: string | undefined;
    createdOn: Date | string;
    modifiedByUserId?: string | undefined;
    modifiedOn: Date | string;
    createdInDfdg?: Date | string | undefined;
    letter?: Letter | undefined;
    address?: Address | undefined;
    template?: Template | undefined;
    attachments?: BookingAttachment[] | undefined;
    participants?: BookingParticipant[] | undefined;
    participationChoices?: BookingParticipationChoice[] | undefined;
    letterOtherRecipients?: LetterOtherRecipient[] | undefined;
    journalNoteComment?: string | undefined;
    groupId?: string | undefined;
    groupOwnerSystem?: EjersystemType | undefined;
    isMedComVdxMeeting?: boolean | undefined;
    medComVdxMeetingLinkForHost?: string | undefined;
}

export interface BookingAttachment {
    id: string;
    attachmentId: string;
    attachmentType: BookingAttachmentType;
}

export interface BookingParticipant {
    id: string;
    name?: string | undefined;
    externalAuthorityParticipantId?: string | undefined;
    participantType: ParticipantType;
    contactDetails?: string | undefined;
    contactType: SamtaleformType;
}

export interface BookingParticipationChoice {
    id: string;
    participationType: DeltagelsesvalgType;
    participating: boolean;
    modifiedOn: Date | string;
    accepted: boolean;
    acceptedOn?: Date | string | undefined;
}

export enum DeltagelsesvalgType {
    AlleJobsamtaler = "alleJobsamtaler",
    FoersteJobsamtale = "foersteJobsamtale",
}

export interface LetterOtherRecipient {
    id: string;
    recipientType: LetterOtherRecipientType;
    recipientId: string;
    name?: string | undefined;
    address?: string | undefined;
    attention?: string | undefined;
    contactPersonId?: string | undefined;
    contactPersonName?: string | undefined;
    outgoingDocumentTypeId?: string | undefined;
}

export enum EjersystemType {
    Andet = "andet",
    KMDOpera_DEPRECATED = "kmdOpera_DEPRECATED",
    KMDWorkbase_DEPRECATED = "kmdWorkbase_DEPRECATED",
    KMDMomentum = "kmdMomentum",
    SchultzFasit = "schultzFasit",
    NetcompanyModulusAkasseSystem = "netcompanyModulusAkasseSystem",
    KMDWinnieAkasseSystem = "kmdWinnieAkasseSystem",
    FaciliaAkasseSystem = "faciliaAkasseSystem",
    FOAFIKSAkasseSystem = "foafiksAkasseSystem",
    FrieFunktionaererAkasseSystem = "frieFunktionaererAkasseSystem",
    ASEAkasseSystem = "aseAkasseSystem",
    UddannelsesOgForskningsstyrelsen = "uddannelsesOgForskningsstyrelsen",
    KombitServiceplatformen = "kombitServiceplatformen",
    KombitMitSygefravaer = "kombitMitSygefravaer",
    KombitKY = "kombitKY",
    KombitKSD = "kombitKSD",
    STAREOES = "stareoes",
    STARVitas = "starVitas",
    STARJobbing_DEPRECATED = "starJobbing_DEPRECATED",
    STARMitJobkompas_DEPRECATED = "starMitJobkompas_DEPRECATED",
    EdoraWFP = "edoraWFP",
    RydbergFrontDesk = "rydbergFrontDesk",
    KMDYdelsessystem = "kmdYdelsessystem",
    KMDSygedagpenge_DEPRECATED = "kmdSygedagpenge_DEPRECATED",
    Internetkompagniet = "internetkompagniet",
    SKSApplikationsservice = "sksApplikationsservice",
    ImmensoQuickMatch = "immensoQuickMatch",
    KOMLISledelsesvaerktoej = "komliSledelsesvaerktoej",
    KMDOpusLis = "kmdOpusLis",
    DFDG = "dfdg",
    JobcenterPlanner_DEPRECATED = "jobcenterPlanner_DEPRECATED",
    Jobnet = "jobnet",
    JobKon = "jobKon",
    JobAG = "jobAG",
    JoblogAKAIT = "joblogAKAIT",
    JoblogAnkiro = "joblogAnkiro",
    JoblogKrifa = "joblogKrifa",
    JoblogNetcompany = "joblogNetcompany",
    KnowledgeCubeIOMS = "knowledgeCubeIOMS",
    KnowledgeCubeLTAS = "knowledgeCubeLTAS",
    KnowledgeCubeUM = "knowledgeCubeUM",
    KnowledgeCubeKAS = "knowledgeCubeKAS",
    KnowledgeCubeFMRS = "knowledgeCubeFMRS",
    STARJobserviceDanmark = "starJobserviceDanmark",
    SonneOgNielsenSeek = "sonneOgNielsenSeek",
    SchultzConnect = "schultzConnect",
    KiaPro = "kiaPro",
    KiaTec = "kiaTec",
    VisionFactoryFokus = "visionFactoryFokus",
    MermaidLetAsyl = "mermaidLetAsyl",
    UIMservicebus = "uiMservicebus",
    CBrain = "cBrain",
    EGKommuneinformation = "egKommuneinformation",
    SchultzBooking = "schultzBooking",
    UnoITUnoUng = "unoITUnoUng",
    MarselisborgITJobmatch = "marselisborgITJobmatch",
    UdbetalingDanmark = "udbetalingDanmark",
    Uddannelsesinstitutionssystem = "uddannelsesinstitutionssystem",
    EdoraJobTech = "edoraJobTech",
    MarselisborgITVirego = "marselisborgITVirego",
    MarselisborgITForecast = "marselisborgITForecast",
    EdoraLeverandoerplatformen = "edoraLeverandoerplatformen",
    Candeno = "candeno",
    SchultzConnectAkasse = "schultzConnectAkasse",
    ModulusAJKS = "modulusAJKS",
    ModulusSLA = "modulusSLA",
    ModulusLAKA = "modulusLAKA",
    ModulusDFH = "modulusDFH",
    ModulusDM = "modulusDM",
    ModulusNNF = "modulusNNF",
    ModulusFAK = "modulusFAK",
    ModulusHKA = "modulusHKA",
    ModulusMIA = "modulusMIA",
    ModulusLederne = "modulusLederne",
    ModulusKrifa = "modulusKrifa",
    ModulusBUPL = "modulusBUPL",
    ModulusAKA = "modulusAKA",
    ModulusMA = "modulusMA",
    ModulusFTFA = "modulusFTFA",
    ModulusCA = "modulusCA",
    LH = "lh",
    Emini = "emini",
    AKasseSelvbetjeningsystemSTARtest_DEPRECATED = "aKasseSelvbetjeningsystemSTARtest_DEPRECATED",
    KommuneSelvbetjeningsystemSTARtest_DEPRECATED = "kommuneSelvbetjeningsystemSTARtest_DEPRECATED",
    CarelinkSelvbetjening = "carelinkSelvbetjening",
    CandenoSelvbetjening = "candenoSelvbetjening",
    CapacitySelvbetjening = "capacitySelvbetjening",
}

export interface InterviewCompanyModel {
    id: string;
    name?: string | undefined;
    industry?: string | undefined;
    pNummer?: string | undefined;
    address?: InterviewCompanyAddressModel | undefined;
}

export interface InterviewCompanyAddressModel {
    streetAddress?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
}

export interface ICitizenInfo {
    id: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    isCitizenDead: boolean;
    currentAddress?: string | undefined;
    postalCode?: string | undefined;
    countryCode?: string | undefined;
    civilRegistrationIdentifier?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    emailAddress?: string | undefined;
}

export interface CompanyContactPersonModel {
    id: string;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export interface PrivateContactPersonModel {
    id: string;
    name?: string | undefined;
    address?: PrivateContactPersonAddressModel | undefined;
}

export interface PrivateContactPersonAddressModel {
    streetAddress?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
}

export interface InterviewOutgoingDocumentTypeModel {
    name?: string | undefined;
    id: string;
}

export interface KeyValuePairOfCancellationCauseTypeAndCodeListItem {
    key: CancellationCauseType;
    value?: CodeListItem6 | undefined;
}

export interface CitizenBasic {
    citizenId: string;
    cpr?: string | undefined;
    fullName?: string | undefined;
    birthDate?: Date | string | undefined;
}

export enum PersonCategoryType {
    Jobklar_DEPRECATED = "jobklar_DEPRECATED",
    Indsatsklar_DEPRECATED = "indsatsklar_DEPRECATED",
    Midlertidigtpassiv_DEPRECATED = "midlertidigtpassiv_DEPRECATED",
    Jobparat = "jobparat",
    Aktivitetsparat = "aktivitetsparat",
    AabenlystUddannelsesparat = "aabenlystUddannelsesparat",
    Uddannelsesparat = "uddannelsesparat",
    IkkeVisiteret = "ikkeVisiteret",
    Visitationskategori1 = "visitationskategori1",
    Visitationskategori2 = "visitationskategori2",
    Visitationskategori3 = "visitationskategori3",
    Sygedagpengekategorisering1_DEPRECATED = "sygedagpengekategorisering1_DEPRECATED",
    Sygedagpengekategorisering2_DEPRECATED = "sygedagpengekategorisering2_DEPRECATED",
    Sygedagpengekategorisering3_DEPRECATED = "sygedagpengekategorisering3_DEPRECATED",
    Jobafklaring_DEPRECATED = "jobafklaring_DEPRECATED",
}

export interface DialogSupportPrompts {
    interviewAgreementEvaluationPrompt?: string | undefined;
    interviewJournalNoteTranscriptionSummaryPrompt?: string | undefined;
    interviewAgreementTranscriptionSummaryPrompt?: string | undefined;
    interviewJournalNoteEvaluationPrompt?: string | undefined;
}

export interface Language {
    id: string;
    name?: string | undefined;
}

export interface InterpreterContactForm {
    id: string;
    name?: string | undefined;
}

export interface GetInterviewCorrectableStatusResponse2 {
    journalNoteId?: string | undefined;
    status: JournalNoteIdStatus;
    isCorrectable: boolean;
}

export enum JournalNoteIdStatus {
    InterviewIsCreatedInThePast = "interviewIsCreatedInThePast",
    InterviewIsCreatedToday = "interviewIsCreatedToday",
    InterviewIsCreatedInTheFuture = "interviewIsCreatedInTheFuture",
}

export interface GetInterviewCorrectableStatusRequest {
    interviewId: string;
}

export interface GetInterviewOverviewStatResponse2 {
    interviewOverviewStats?: InterviewOverviewStatDto | undefined;
}

export interface InterviewOverviewStatDto {
    lastInterviewForCase?: Date | string | undefined;
    interviewTypeStats?: InterviewTypeStatDto[] | undefined;
}

export interface InterviewTypeStatDto {
    interviewTypeUnion?: InterviewTypeUnion | undefined;
    numberOfInterviewForCase?: number | undefined;
    numberOfInterviewForVisitationYear?: number | undefined;
    numberOfInterviewPerCaseYear?: number | undefined;
    interviewDate?: Date | string | undefined;
    numberOfInterviewForFirstPeriod?: number | undefined;
    numberOfInterviewLeftForFirstPeriod?: number | undefined;
    numberOfInterviewForOngoingPeriod?: number | undefined;
    numberOfInterviewLeftForOngoingPeriod?: number | undefined;
}

export interface GetInterviewCitizenStatisticsResponse {
    lastDayForFirstPeriod?: Date | string | undefined;
    lastDayForOngoingPeriod?: Date | string | undefined;
    estimatedEndDateForUnemploymentBenefit?: Date | string | undefined;
}

export interface InterviewDisplayViewModel {
    interviewTime?: Date | string | undefined;
    interviewContactType?: SamtaleformType | undefined;
    citizenId: string;
    citizenName?: string | undefined;
    interviewTypeUnion?: InterviewTypeUnion | undefined;
    targetGroupName?: string | undefined;
    caseName?: string | undefined;
    caseworkerName?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    id: string;
    status?: InterviewStatus | undefined;
    createdByDisplayName?: string | undefined;
    modifiedByDisplayName?: string | undefined;
    authorityName?: string | undefined;
    modifiedOn?: Date | string | undefined;
    originatesFromDfdg: boolean;
}

export enum InterviewStatus {
    Draft = "draft",
    PendingDfdgCreate = "pendingDfdgCreate",
    Done = "done",
}

export interface InterviewSummaryPeriods {
    targetGroupId: string;
    firstPeriod?: InterviewSummarySinglePeriod | undefined;
    ongoingPeriod?: InterviewSummarySinglePeriod | undefined;
}

export interface InterviewSummarySinglePeriod {
    lastDay?: Date | string | undefined;
    interviews?: InterviewSummaryInterviewType[] | undefined;
}

export interface InterviewSummaryInterviewType {
    interviewTypeUnion?: InterviewTypeUnion | undefined;
    numberOfInterviewsForPeriod?: number | undefined;
    numberOfInterviewsLeftForPeriod?: number | undefined;
}

export interface InterviewSummaryDetails {
    activationDate?: Date | string | undefined;
    deadlineDate?: Date | string | undefined;
    deadlineStatus?: InterviewDeadlineStatusType | undefined;
    currentPersonCategoryType?: PersonCategoryType | undefined;
    lastInterviewForCase?: Date | string | undefined;
    interpreterNeeded?: boolean | undefined;
    activitySupplementRequestDate?: Date | string | undefined;
    readWriteMathTestDetails?: InterviewSummaryReadWriteMathTestDetails | undefined;
    followupDesired?: YesNoAnswer | undefined;
}

export interface InterviewSummaryReadWriteMathTestDetails {
    needReadWriteMathTest?: boolean | undefined;
}

export interface InterviewSummaryUnemployment {
    interviewSummaryJobCounts?: InterviewSummaryJobCount[] | undefined;
    halfYearBenefitReachedDate?: Date | string | undefined;
    estimatedBenefitEndDate?: Date | string | undefined;
}

export interface InterviewSummaryJobCount {
    interviewTypeUnion?: InterviewTypeUnion | undefined;
    numberOfInterviews: number;
    heldBy: OrganisationType;
}

export interface ConductedInterview {
    id: string;
    start: Date | string;
    type?: CodeListItem6 | undefined;
    responsibleCaseWorker?: string | undefined;
    responsibleAuthority?: string | undefined;
    agreementDescription?: string | undefined;
    correctionComment?: string | undefined;
    interviewParticipantList?: string[] | undefined;
    interviewContactType?: CodeListItem6 | undefined;
    externalAuthorityParticipationStatus?: CodeListItem6 | undefined;
}

export interface PlannedInterview {
    id?: string | undefined;
    start?: Date | string | undefined;
    end?: Date | string | undefined;
    meetingDescription?: string | undefined;
    interviewLocation?: string | undefined;
    isCancellationPossible: boolean;
    isRebookingPossible: boolean;
    cancellationDeadline?: Date | string | undefined;
    phoneNumber?: string | undefined;
    correctionComment?: string | undefined;
    digitalContact?: string | undefined;
    responsibleCaseWorker?: string | undefined;
    interviewParticipantList?: string[] | undefined;
    status?: CodeListItem6 | undefined;
    interviewContactType?: CodeListItem6 | undefined;
    cancellationCause?: CodeListItem6 | undefined;
    type?: CodeListItem6 | undefined;
    cancellationPossible: boolean;
    responsibleAuthority?: string | undefined;
}

export interface MedComVdxMeetingSettings {
    medComVdxMeetingIsDefault: boolean;
}

export interface PrimaryCaseInfo {
    caseTargetGroupCode?: string | undefined;
    caseStatusCode: CaseStatus3;
}

export enum CaseStatus3 {
    Aktiv = "aktiv",
    Afsluttet = "afsluttet",
    Skalafsluttes = "skalafsluttes",
}

export interface InterviewPreparationInfo {
    enabled: boolean;
    url?: string | undefined;
}

export interface PersonCategoryConfigurationType {
    id: number;
    dfdgId: number;
    name?: string | undefined;
    visitationCategory: number;
    crmVisitationCategoryId?: string | undefined;
    enrollment?: string | undefined;
}

export interface RankedCaseInfo {
    caseId: string;
    caseTypeId: string;
    caseTypeName?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    rank: number;
    importance: Importance;
    targetGroupId?: string | undefined;
}

export enum Importance {
    High = "high",
    Medium = "medium",
    Low = "low",
}

export interface PartialTranscriptionDto {
    id: string;
    order: number;
    status?: string | undefined;
    transcriptionText?: string | undefined;
    createdAt: Date | string;
}

export interface AbsenceModel {
    id: string;
    absenceType?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
}

export interface ExemptionModel {
    id: string;
    exemption?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
}

export interface NegativeEventModel {
    id: string;
    evenDate?: Date | string | undefined;
    type?: string | undefined;
    status?: string | undefined;
    sanction?: string | undefined;
}

export interface ActivityWithAbsenceModel {
    id: string;
    activityName?: string | undefined;
    activityStartDate: Date | string;
    activityEndDate?: Date | string | undefined;
    sickDays: number;
}

export interface VacationAbsenceModel extends AbsenceModel {
    durationInDays: number;
}

export interface JournalNoteModel2 {
    id: string;
    title?: string | undefined;
    eventDate?: Date | string | undefined;
    contentType?: string | undefined;
    note?: string | undefined;
    caseName?: string | undefined;
    documents?: JournalNoteDocumentModel[] | undefined;
}

export interface JournalNoteDocumentModel {
    id: string;
    title?: string | undefined;
    url?: string | undefined;
}

export interface InterviewPreparationConfiguration {
    latestConfigurationGroupChangeCount: number;
    recentPlacementsMonthCount: number;
    latestSicknessAbsenceCount: number;
    journalNoteConfiguration?: InterviewPreparationJournalNoteConfiguration | undefined;
    instructionsConfiguration?: { [key: string]: string[]; } | undefined;
}

export interface InterviewPreparationJournalNoteConfiguration {
    daysToLookBack: number;
    maxCount?: number | undefined;
    journalNoteTypes?: number[] | undefined;
}

export interface JobGoalModel {
    id: string;
    externalId?: string | undefined;
    name?: string | undefined;
    hasEducation: boolean;
    hasExperience: boolean;
    relinkAssessment?: RelinkAssessment | undefined;
    experience?: string | undefined;
    relevantQualifications?: string[] | undefined;
    suggestedJobOffers?: JobOfferModel[] | undefined;
}

export interface RelinkAssessment {
    type: RelinkAssessmentType;
    description?: string | undefined;
}

export enum RelinkAssessmentType {
    Keep = "keep",
    Suggest = "suggest",
    Discard = "discard",
}

export interface JobOfferModel {
    id: string;
    title?: string | undefined;
    company?: string | undefined;
    type?: string | undefined;
    url?: string | undefined;
}

export interface SuggestedQualificationModel {
    id: string;
    experience?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    qualifications?: string[] | undefined;
}

export interface EducationModel {
    name?: string | undefined;
    description?: string | undefined;
    date?: Date | string | undefined;
    educationType: EducationType;
}

export enum EducationType {
    Formeluddannelse = "formeluddannelse",
    Kursus = "kursus",
    Certificering = "certificering",
}

export interface CvGaps {
    hasGaps: boolean;
    foundWithinLatestXYears: number;
    gaps?: DateInterval[] | undefined;
}

export interface DateInterval {
    from: Date | string;
    to: Date | string;
    lengthInDays: number;
}

export interface HeaderInfoModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    cpr?: string | undefined;
    age?: number | undefined;
    importantNotes?: ImportantNoteInfo[] | undefined;
}

export interface ImportantNoteInfo {
    note?: string | undefined;
    author?: string | undefined;
    date?: Date | string | undefined;
    expiresOn?: Date | string | undefined;
}

export interface RehabilitationInfoModel {
    hasRehabilitationCase: boolean;
    rehabilitationCaseStatus?: string | undefined;
    dateForNextBookingWithRehabiliationTeam?: Date | string | undefined;
}

export interface VacationAbsenceInfoModel {
    totalVacationDays: number;
    isAllowedForVacation: boolean;
}

export interface CitizenEducationPlanModel {
    hasProfessionalEducation: boolean;
    eduCurrentStep?: number | undefined;
    eduCurrentDueDate?: Date | string | undefined;
    isCitizenUnder30: boolean;
    hasEducationPlan: boolean;
}

export interface InterpretationNeedsModel {
    citizenNeedsInterpretation: boolean;
    language?: string | undefined;
}

export interface ContactInfoModel {
    email?: string | undefined;
    mobileNumber?: string | undefined;
    phoneNumber?: string | undefined;
    temporaryAddress?: string | undefined;
}

export interface ContactPersonModel {
    email?: string | undefined;
    mobileNumber?: string | undefined;
    phoneNumber?: string | undefined;
    role?: string | undefined;
    name?: string | undefined;
}

export interface InterviewStat {
    period: Period;
    numberOfInterviews?: number | undefined;
    numberOfInterviewsLeft?: number | undefined;
    lastDate?: Date | string | undefined;
}

export enum Period {
    First = "first",
    Ongoing = "ongoing",
}

export interface InterviewStatUnemploymentBenefit {
    jobCounts?: InterviewJobModel[] | undefined;
    halfYearBenefitReachedDate?: Date | string | undefined;
    estimatedBenefitEndDate?: Date | string | undefined;
}

export interface InterviewJobModel {
    interviewTypeUnion?: InterviewTypeUnion | undefined;
    numberOfInterviews: number;
}

export interface LatestActivityModel {
    offerCategory: number;
    activityName?: string | undefined;
    endDate?: Date | string | undefined;
    caseId?: string | undefined;
}

export interface MyPlanModel {
    name?: string | undefined;
}

export interface ActivityModel {
    id: string;
    caseId?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    hoursPerWeek?: number | undefined;
}

export interface InterviewAgreementModel {
    interviewType: InterviewType;
    interviewDate: Date | string;
    caseworkerDisplayName?: string | undefined;
    agreement?: string | undefined;
    caseId?: string | undefined;
}

export interface JobReadyFeatureModel {
    isIntelligentMatchCitizenFeatureEnabled: boolean;
    isDisseminationOfSupportedJobsFeatureEnabled: boolean;
    isForumEnabled: boolean;
}

export interface JobSearchModel {
    totalJobLogs: number;
    averageJobLogs?: number | undefined;
    maxDistance?: number | undefined;
    averageDistance?: number | undefined;
    submissionTypes?: SubmissionTypeModel[] | undefined;
    status?: SubmissionStatusModel[] | undefined;
    appliedJobs?: AppliedJobsModel[] | undefined;
}

export interface SubmissionTypeModel {
    submissionType: JoblogEntryTypeOfSubmissionType2;
    count: number;
}

export enum JoblogEntryTypeOfSubmissionType2 {
    EmailEllerBrev_DEPRECATED = "emailEllerBrev_DEPRECATED",
    Telefon = "telefon",
    Personligt = "personligt",
    Facebook_DEPRECATED = "facebook_DEPRECATED",
    Kontaktet_DEPRECATED = "kontaktet_DEPRECATED",
    Andet_DEPRECATED = "andet_DEPRECATED",
    Webansoegning_DEPRECATED = "webansoegning_DEPRECATED",
    PersonligtNetvaerk_DEPRECATED = "personligtNetvaerk_DEPRECATED",
    Digitalt = "digitalt",
}

export interface SubmissionStatusModel {
    statusType: JobSeekingStatusType2;
    count: number;
}

export enum JobSeekingStatusType2 {
    IkkeSoegt = "ikkeSoegt",
    Soegt = "soegt",
    Samtale = "samtale",
    FikJobbet_DEPRECATED = "fikJobbet_DEPRECATED",
    Afslag_DEPRECATED = "afslag_DEPRECATED",
    IkkeAngivet_DEPRECATED = "ikkeAngivet_DEPRECATED",
}

export interface AppliedJobsModel {
    created: Date | string;
    title?: string | undefined;
    companyName?: string | undefined;
    distance?: number | undefined;
}

export interface CitizenProgressSummaryModel {
    isDagpengeModtager: boolean;
    primaryCaseStartDate?: Date | string | undefined;
    totalAvailability?: number | undefined;
    benefitsExpiryDate?: Date | string | undefined;
}

export interface CvModel {
    cvLastModifyDate?: Date | string | undefined;
    cvStatus?: string | undefined;
    jobGoals?: JobGoalModel[] | undefined;
    isMissingJobGoalsInCv?: boolean | undefined;
    hasCv: boolean;
    cvGaps?: CvGaps | undefined;
    educations?: EducationModel[] | undefined;
    useAdvancedJobGoalTemplate: boolean;
    suggestedQualifications?: SuggestedQualificationModel[] | undefined;
    hasUsedSixWeeksEducation?: boolean | undefined;
    relinkErrorMessage?: string | undefined;
    cvUrl?: string | undefined;
}

export interface AbsenceExemptionsModel {
    currentAbsences?: AbsenceInfoModel[] | undefined;
    exemptions?: ExemptionInfoModel[] | undefined;
    negativeEvents?: NegativeEventInfoModel[] | undefined;
    latestTwoSicknessAbsencesForCurrentCase?: AbsenceInfoModel[] | undefined;
    absencesForActivitiesInCurrentCase?: AbsenceInfoModel[] | undefined;
    hasLongTermSickness: boolean;
    hasMuchSicknessDuringPlacement: boolean;
    sicknessLatestThirtyDays?: SicknessInfoModel | undefined;
    numberOfDaysInLongestSickLeave: number;
}

export interface AbsenceInfoModel {
    name?: string | undefined;
    activityName?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    absenceType?: string | undefined;
    sickDays: number;
}

export interface ExemptionInfoModel {
    exemption?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
}

export interface NegativeEventInfoModel {
    evenDate?: Date | string | undefined;
    type?: string | undefined;
    status?: string | undefined;
    sanction?: string | undefined;
}

export interface SicknessInfoModel {
    sickDays: number;
    sickLeaves: number;
}

export interface JobReadyJournalNoteConfigurationModel {
    showInJobSearch: boolean;
    showInCitizenProgress: boolean;
    showInAbsenceExemptions: boolean;
    showInScreening: boolean;
}

export interface ForumAppUsageModel {
    firstUseDate?: Date | string | undefined;
    lastSeenDate?: Date | string | undefined;
}

export interface CandidateReferralViewModel {
    citizenId: string;
    mediatingDate?: Date | string | undefined;
    status: number;
    comment?: string | undefined;
    companyName?: string | undefined;
    title?: string | undefined;
    startDate?: Date | string | undefined;
    dueDate?: Date | string | undefined;
    companyRecruitmentCandidateId: string;
    companyRecruitmentId: string;
}

export interface SelfScreeningOverviewModel {
    screeningDate: Date | string;
    screeningCategory?: string | undefined;
}

export interface JournalNoteModel3 {
    id: string;
    caseId?: string | undefined;
    title?: string | undefined;
    eventDate: Date | string;
    contentType?: string | undefined;
    note?: string | undefined;
    caseName?: string | undefined;
    attachments?: JournalNoteAttachmentModel[] | undefined;
}

export interface CaseDurationModel {
    caseDuration?: string | undefined;
    targetGroupName?: string | undefined;
}

export interface ContactGroupChangeModel {
    id: string;
    name?: string | undefined;
    startDate: Date | string;
}

export interface PlanModel {
    overallPlanDescription?: OverallPlanDescription | undefined;
    goalsOnPlan?: PlanGoalModel | undefined;
    integrationContractUrl?: string | undefined;
    activePlanUrl?: string | undefined;
}

export interface OverallPlanDescription {
    headline?: string | undefined;
    description?: string | undefined;
    planId: string;
    integrationContractId?: string | undefined;
    showEducationInformation: boolean;
    eduCurrentDueDate?: Date | string | undefined;
    eduCurrentStep?: number | undefined;
}

export interface PlanGoalModel {
    jobGoals?: GoalModel[] | undefined;
    otherGoals?: GoalModel[] | undefined;
    educationGoals?: EducationGoalModel[] | undefined;
}

export interface GoalModel {
    goalId: string;
    name?: string | undefined;
}

export interface EducationGoalModel extends GoalModel {
    educations?: string[] | undefined;
}

export interface InterviewStatisticsModel {
    resettingInterviewsStatistics?: ResettingInterviewsStatisticModel | undefined;
    otherInterviewStatistics?: OtherInterviewsStatisticsModel | undefined;
}

export interface ResettingInterviewsStatisticModel {
    interviewType?: string | undefined;
    count: number;
    average: number;
}

export interface OtherInterviewsStatisticsModel {
    count: number;
    average: number;
}

export interface PlacementsOverviewModel {
    activePlacements?: PlacementModel[] | undefined;
    recentMonthsCompanyRelatedPlacements?: PlacementModel[] | undefined;
    activeUnpublishedPlacements?: PlacementModel[] | undefined;
    recentMonthsNonCompanyRelatedPlacements?: PlacementModel[] | undefined;
    recentMonthsCancelledCompanyRelatedPlacementsInfo?: RecentMonthsCancelledPlacementsInfoModel | undefined;
    recentMonthsCancelledNonCompanyRelatedPlacementsInfo?: RecentMonthsCancelledPlacementsInfoModel | undefined;
}

export interface PlacementModel {
    id: string;
    name?: string | undefined;
    offerType?: string | undefined;
    startDate: Date | string;
    actualDurationInDays?: number | undefined;
    isAborted: boolean;
    statusCausedBy?: string | undefined;
    accountName?: string | undefined;
    hoursPerWeek?: number | undefined;
    daysUntilEndDate?: number | undefined;
    offerCategory?: string | undefined;
    url?: string | undefined;
}

export interface RecentMonthsCancelledPlacementsInfoModel {
    count: number;
    latestStatusCausedBy?: string | undefined;
}

export interface InterviewAgreementModel2 {
    activeCaseStartDate?: Date | string | undefined;
    interviewAgreementStatistics?: InterviewStatisticsModel | undefined;
    latestInterviewAgreements?: InterviewPreparationInterviewModel[] | undefined;
}

export interface InterviewPreparationInterviewModel {
    interviewTime?: Date | string | undefined;
    agreementDescription?: string | undefined;
    interviewType?: string | undefined;
    interviewId?: string | undefined;
    caseId?: string | undefined;
    interviewAgreementUrl?: string | undefined;
}

export interface CitizenProgressViewModel {
    contactGroupShift: number;
    placementActivitiesForCurrentOpenCase?: PlacementActivitiesViewModel[] | undefined;
    companyInternShip?: string | undefined;
    placements?: PlacementViewModel[] | undefined;
    interview?: InterviewViewModel2 | undefined;
    followUpInterview?: InterviewViewModel2 | undefined;
    plan?: PlanViewModel | undefined;
}

export interface PlacementActivitiesViewModel {
    offerCategoryName?: string | undefined;
    activityName?: string | undefined;
    statusDescription?: string | undefined;
}

export interface PlacementViewModel {
    id: string;
    name?: string | undefined;
    type?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    hoursPerWeek?: number | undefined;
    url?: string | undefined;
}

export interface InterviewViewModel2 {
    interviewTime?: Date | string | undefined;
    agreementDescription?: string | undefined;
    interviewType?: string | undefined;
    id: string;
    url?: string | undefined;
}

export interface PlanViewModel {
    planDescription?: string | undefined;
    jobGoals?: string | undefined;
}

export interface InformationFormXmlModel {
    general?: GeneralXmlModel | undefined;
    yourDisease?: YourDiseaseXmlModel | undefined;
    workAndPersonalInjury?: WorkAndPersonalInjuryXmlModel | undefined;
    treatment?: TreatmentXmlModel | undefined;
    workplaceAndWorkFunctions?: WorkplaceAndWorkFunctionsXmlModel | undefined;
    followup?: FollowupXmlModel | undefined;
    contact?: ContactXmlModel | undefined;
    consent?: ConsentXmlModel | undefined;
    person?: PersonXmlModel | undefined;
}

export interface GeneralXmlModel {
    sentDate: Date | string;
}

export interface YourDiseaseXmlModel {
    diagnosis?: string | undefined;
    diagnosisDescription?: string | undefined;
    stillSick: YesNoAnswer;
    lastSickDate?: Date | string | undefined;
    standby?: YesNoUnknownAnswer | undefined;
    expectedRecover?: YesNoUnknownAnswer | undefined;
}

export interface WorkAndPersonalInjuryXmlModel {
    workInjury: YesNoUnknownAnswer;
    reportedToAes?: YesNoUnknownAnswer | undefined;
    causedByOtherPerson?: YesNoUnknownAnswer | undefined;
}

export interface TreatmentXmlModel {
    inTreatment?: YesNoUnknownAnswer | undefined;
    specialistDoctor?: string | undefined;
}

export interface WorkplaceAndWorkFunctionsXmlModel {
    sicknessInfluence?: string | undefined;
    stillEmployed?: YesNoAnswer | undefined;
    lastEmploymentDate?: Date | string | undefined;
    workplaceConditions?: YesNoUnknownAnswer | undefined;
    workplaceConditionsDescription?: string | undefined;
    hasResumed?: YesNoUnknownAnswer | undefined;
    hasNotResumed?: string | undefined;
    resumedPlan?: string | undefined;
}

export interface FollowupXmlModel {
    followupDesired?: YesNoAnswer | undefined;
}

export interface ContactXmlModel {
    leaderContact?: string | undefined;
}

export interface ConsentXmlModel {
    consentGiven?: YesNoAnswer | undefined;
}

export interface PersonXmlModel {
    phoneNumber?: string | undefined;
}

export interface MedicalJournalNoteModel {
    id: string;
    caseId?: string | undefined;
    title?: string | undefined;
    eventDate?: Date | string | undefined;
    contentType?: string | undefined;
    note?: string | undefined;
    caseName?: string | undefined;
    documents?: JournalNoteDocumentModel2[] | undefined;
}

export interface JournalNoteDocumentModel2 {
    id: string;
    title?: string | undefined;
    url?: string | undefined;
}

export interface PersonalConditionsViewModel {
    personStatus?: string | undefined;
    cprAddress?: string | undefined;
    civilStatus?: string | undefined;
    citizenship?: string | undefined;
    entryDate?: Date | string | undefined;
    residencePermitDate?: Date | string | undefined;
    residencePermitReason?: string | undefined;
    citizenPhoneNumber?: string | undefined;
    citizenMobileNumber?: string | undefined;
    accountId?: string | undefined;
    employer?: string | undefined;
    employerUrl?: string | undefined;
    contactPerson?: string | undefined;
    cvrNumber?: string | undefined;
    pNumber?: string | undefined;
    phoneNumber?: string | undefined;
    aKasse?: string | undefined;
    insuranceCategory?: string | undefined;
    unemploymentBenefitsPeriodStart?: Date | string | undefined;
    unemploymentBenefitsPeriodEnd?: Date | string | undefined;
    endDateMeaning?: string | undefined;
    numberOfUnemploymentPeriods: number;
    mostRecentUnemploymentStartDate?: Date | string | undefined;
    mostRecentUnemploymentEndDate?: Date | string | undefined;
    isCurrentlyEmployed: boolean;
}

export interface SicknessBenefitCaseOverviewViewModel {
    caseStatus: CaseStatus;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    firstAbsenceDate?: Date | string | undefined;
    reevaluationDate?: Date | string | undefined;
    sicknessBenefitDurationDate?: Date | string | undefined;
    salaryFreezeDate?: Date | string | undefined;
    contactGroup?: string | undefined;
    diagnosis?: string | undefined;
    absenceOverview?: AbsenceOverviewViewModel | undefined;
    extensionOverview?: ExtensionOverviewViewModel | undefined;
    missingParticipationOverview?: MissingParticipationOverviewViewModel | undefined;
    partialHealthRecoveryOverview?: PartialHealthRecoveryOverviewViewModel | undefined;
    informationFormOverview?: InformationFormOverviewViewModel | undefined;
    caseId: string;
    interviewSicknessPreparationDeadline?: DeadlineViewModel | undefined;
    interviewSicknessPreparationVacation?: VacationViewModel | undefined;
    citizenLinks?: LinkViewModel | undefined;
}

export interface AbsenceOverviewViewModel {
    mostRecentAbsenceId?: string | undefined;
    recentAbsencesCount?: number | undefined;
    absencesCount?: number | undefined;
    mostRecentStartDate?: Date | string | undefined;
    mostRecentEndDate?: Date | string | undefined;
}

export interface ExtensionOverviewViewModel {
    extensionEvaluationsCount?: number | undefined;
    mostRecentDate?: Date | string | undefined;
    reason?: string | undefined;
    isExtensionGranted: boolean;
}

export interface MissingParticipationOverviewViewModel {
    missingParticipationCount?: number | undefined;
    mostRecentStatus?: string | undefined;
    mostRecentResult?: string | undefined;
    mostRecentResultedInSanction: boolean;
    incidentType?: string | undefined;
    mostRecentHasBeenCompleted: boolean;
}

export interface PartialHealthRecoveryOverviewViewModel {
    recentHealthRecoveriesCount?: number | undefined;
    mostRecentStartDate?: Date | string | undefined;
    mostRecentEndDate?: Date | string | undefined;
    weeklyWorkHourCount?: number | undefined;
}

export interface InformationFormOverviewViewModel {
    informationForm?: number | undefined;
    expectedRecover?: YesNoUnknownAnswer | undefined;
    followupDesired?: YesNoAnswer | undefined;
}

export interface DeadlineViewModel {
    date: Date | string;
    type: DeadlineType;
    showAsWarning: boolean;
}

export enum DeadlineType {
    RehabilitationTeam = "rehabilitationTeam",
    HealthCoordinator = "healthCoordinator",
}

export interface VacationViewModel {
    vacationAbsenceDaysWithinCaseYear: number;
}

export interface LinkViewModel {
    mostRecentAbsenceUrl?: string | undefined;
    caseUrl?: string | undefined;
    planHistoryUrl?: string | undefined;
    myPlanUrl?: string | undefined;
    sustenanceHistoryUrl?: string | undefined;
    cvUrl?: string | undefined;
}

export interface GuideLinkModel {
    id: string;
    url?: string | undefined;
    tooltip?: string | undefined;
    linkHeading?: string | undefined;
}

export enum GuideLinkGuideId {
    Afslutsag = "afslutsag",
    Masseindkaldelsetilsamtaler = "masseindkaldelsetilsamtaler",
    Oprethenvisning = "oprethenvisning",
    Opretjobafklaringssag = "opretjobafklaringssag",
    Opretsag = "opretsag",
    Opretsygedagpengesag = "opretsygedagpengesag",
    Opretkontanthjlpssag = "opretkontanthjlpssag",
    GennemfrCVsamtale = "gennemfrCVsamtale",
    Gennemfropflgningssamtale = "gennemfropflgningssamtale",
    Gennemfrsamtale = "gennemfrsamtale",
    Indkaldtilsamtale = "indkaldtilsamtale",
    Gennemfrjobsamtale = "gennemfrjobsamtale",
    Gennemfrandensamtale = "gennemfrandensamtale",
    Sletfravr = "sletfravr",
    Asyldata = "asyldata",
    Retjobcentertilknytning = "retjobcentertilknytning",
    FrigivCV = "frigivCV",
    Nytdokument = "nytdokument",
    Udsteduddannelsesplg = "udsteduddannelsesplg",
    Skiftvirksomhed = "skiftvirksomhed",
    AnnullrAAhenvisning = "annullrAAhenvisning",
    Fristforselvbooking = "fristforselvbooking",
    Findjob = "findjob",
    Danaktindsigt = "danaktindsigt",
    Registrrborgerskvittering = "registrrborgerskvittering",
    GenaktivrMinplan = "genaktivrMinplan",
    UdskrivMinplan = "udskrivMinplan",
    Nytjournalnotat = "nytjournalnotat",
    Srligeforhold = "srligeforhold",
    Godkendafvisplacering = "godkendafvisplacering",
    Findledigperiode = "findledigperiode",
    Annullrkandidatformidling = "annullrkandidatformidling",
    Bninysgning = "bninysgning",
    Danbreve = "danbreve",
    Kravtiljbsgning = "kravtiljbsgning",
}

export interface BenefitTypeFFB extends CodeListItem {
    shortName?: string | undefined;
    description?: string | undefined;
    externalId: string;
    stateCode: number;
    type: FFBType;
    isSelectable: boolean;
}

export enum FFBType {
    TargetGroup = "targetGroup",
    Benefit = "benefit",
    Offer = "offer",
}

export interface BenefitTypeDST extends CodeListItem {
    paragraph?: string | undefined;
    description?: string | undefined;
    externalId?: string | undefined;
    stateCode: number;
}

export interface GrantCaseModel {
    caseId: string;
    startDate: Date | string;
    caseTypeName?: string | undefined;
    isSocialAllowed: boolean;
}

export interface CaseGrantModel {
    id: string;
    grantType?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    status: GrantStatus;
    followUpDate?: Date | string | undefined;
    description?: string | undefined;
}

export interface GrantTypeModel {
    grantTypeId: string;
    grantCategory: GrantCategory;
    name?: string | undefined;
    description?: string | undefined;
    allowedBenefitTypesFFB?: BenefitTypeFFB[] | undefined;
    allowedBenefitTypesDST?: BenefitTypeDST[] | undefined;
    socialOffer?: BenefitTypeFFB | undefined;
    reportGrantAs?: ReportSocialGrantAs | undefined;
    isMandatoryOfferSelection: boolean;
    isMandatoryPriceCalculation: boolean;
    offerSelectionMode: GrantOfferSelectionMode;
    displayName?: string | undefined;
    processingDeadlineDays?: number | undefined;
    lawReference?: string | undefined;
    paragraph?: string | undefined;
    subsection?: number | undefined;
    articleNumber?: number | undefined;
    requiresHearing?: boolean | undefined;
    requiresAssessment?: boolean | undefined;
    canBeGrantedByServiceProvider?: boolean | undefined;
}

export enum GrantCategory {
    Social = "social",
    Employment = "employment",
}

export enum ReportSocialGrantAs {
    Manual = "manual",
    SocialFfb = "socialFfb",
    SocialDst = "socialDst",
}

export enum GrantOfferSelectionMode {
    AllOffers = "allOffers",
    ListOnly = "listOnly",
}

export interface OfferForGrantSelectionModel {
    offerId: string;
    offerNumber?: number | undefined;
    title?: string | undefined;
    category?: string | undefined;
    type?: string | undefined;
    companyName?: string | undefined;
    socialProviderUnitName?: string | undefined;
    internalDescription?: string | undefined;
    availableSeats?: number | undefined;
    priceModel?: PriceModel | undefined;
    unitPrice?: number | undefined;
    initialRate?: number | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
}

export interface CitizenFlow {
    grantId: string;
    rulingId?: string | undefined;
    title?: string | undefined;
    subtitle?: string | undefined;
    isFromRulingGuide: boolean;
    attention: FlowAttention;
    statusText?: string | undefined;
    steps?: CitizenFlowStep[] | undefined;
    nextStep?: CitizenFlowNextStep | undefined;
    followUpDate?: Date | string | undefined;
}

export enum FlowAttention {
    Action = "action",
    Soon = "soon",
    InProgress = "inProgress",
    Ok = "ok",
}

export interface CitizenFlowStep {
    kind: FlowStepKind;
    state: FlowStepState;
    label?: string | undefined;
    detail?: string | undefined;
    explanation?: string | undefined;
}

export enum FlowStepKind {
    Ruling = "ruling",
    Grant = "grant",
    FollowUp = "followUp",
}

export enum FlowStepState {
    Done = "done",
    InProgress = "inProgress",
    Missing = "missing",
    Soon = "soon",
    Planned = "planned",
    NotApplicable = "notApplicable",
    Pending = "pending",
}

export interface CitizenFlowNextStep {
    text?: string | undefined;
    target: FlowTarget;
}

export enum FlowTarget {
    Grant = "grant",
    Ruling = "ruling",
}

export interface DfdgEducationEvent {
    educationEventIdentifier: string;
    educationDropoutReason?: EducationDropoutReasons | undefined;
    socialSecurityNumber?: string | undefined;
    cvrUnitId?: string | undefined;
    atRiskOfDropoutDate?: Date | string | undefined;
    eventDate: Date | string;
    institutionAddress?: string | undefined;
    institutionName?: string | undefined;
    institutionNumber: number;
    postalCode?: string | undefined;
    cityName?: string | undefined;
    contactInformation?: string | undefined;
    pNumber?: string | undefined;
    registrationTime: Date | string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    educationCourseStatus: EducationCourseStatuses;
    eventIdentifier?: string | undefined;
    designation?: string | undefined;
    educationCode?: string | undefined;
    cosaPurposeVersion?: number | undefined;
    cosaPurposeSpecialty?: string | undefined;
    educationLevel: EducationLevels;
    educationCourseIdentifier?: string | undefined;
    note?: string | undefined;
    educationEventType: EducationEventTypes;
    finishedEducationLevel?: FinishedEducationLevels | undefined;
    eguEducationCertificate?: boolean | undefined;
}

export enum EducationDropoutReasons {
    UkendtIkkeOplyst = "ukendtIkkeOplyst",
    Fravar = "fravar",
    Sygdom = "sygdom",
    UddannelsenIkkePaabegyndt = "uddannelsenIkkePaabegyndt",
    AendretUddannelse = "aendretUddannelse",
    SkiftetSkole = "skiftetSkole",
    SkiftetSkoleOgAendretUddannelse = "skiftetSkoleOgAendretUddannelse",
    FagligeKrav = "fagligeKrav",
    Andet = "andet",
    Ukendt = "ukendt",
    UddannelsesaftaleOphaevet = "uddannelsesaftaleOphaevet",
    Doed = "doed",
    IkkePraktikpladssoegende = "ikkePraktikpladssoegende",
    GennemfoertGF2fortsoetterEj = "gennemfoertGF2fortsoetterEj",
    IkkeBestaaetAfsluttendeEksamen = "ikkeBestaaetAfsluttendeEksamen",
    FuldfoertAnsoegningsForloebFortsaetterEj = "fuldfoertAnsoegningsForloebFortsaetterEj",
    EjMoedt = "ejMoedt",
    FagligeKrav102 = "fagligeKrav102",
    PrivateAarsager = "privateAarsager",
    IkkeBestaaetProeve = "ikkeBestaaetProeve",
    Bortvist = "bortvist",
    ElevenKanIkkeKontaktes = "elevenKanIkkeKontaktes",
    UddannelsesSkift = "uddannelsesSkift",
    UddannelseFortsaettesPaaAndenInstitution = "uddannelseFortsaettesPaaAndenInstitution",
    FuldfoertGF1 = "fuldfoertGF1",
    FuldfoertGF2 = "fuldfoertGF2",
    AfbrudtUdvekslingsstudent = "afbrudtUdvekslingsstudent",
    Orlov = "orlov",
    Fuldfoert = "fuldfoert",
    ElevAfgaaetVedDoeden = "elevAfgaaetVedDoeden",
    LaereforholdOphoert = "laereforholdOphoert",
}

export enum EducationCourseStatuses {
    Gennemfort = "gennemfort",
    Afbrudt = "afbrudt",
    IGang = "iGang",
    RisikoForFrafald = "risikoForFrafald",
}

export enum EducationLevels {
    Grundforloeb = "grundforloeb",
    Hovedforloeb = "hovedforloeb",
    Irrelevant = "irrelevant",
}

export enum EducationEventTypes {
    HaendelseFraGammelUDB = "haendelseFraGammelUDB",
    Optaget = "optaget",
    Gennemfoert = "gennemfoert",
    Afbrudt = "afbrudt",
    RisikoForFrafald = "risikoForFrafald",
    Annullering = "annullering",
}

export enum FinishedEducationLevels {
    IngenAfsluttetUddannelse = "ingenAfsluttetUddannelse",
    KompetencegivendeUddannelse = "kompetencegivendeUddannelse",
    ErhvervskompetencegivendeUddannelse = "erhvervskompetencegivendeUddannelse",
}

export interface EducationSubscription {
    hasSubscription: boolean;
    subscriptionStartDate?: Date | string | undefined;
    dfdgRegistrationDate?: Date | string | undefined;
    udbRegistrationDate?: Date | string | undefined;
    dfdgUnregistrationDate?: Date | string | undefined;
    udbUnregistrationDate?: Date | string | undefined;
    subscriptionTerminationReason?: SubscriptionTerminationReason | undefined;
}

export enum SubscriptionTerminationReason {
    BorgerHarAfsluttetUddannelsenSomPaalaeggetVedroerer = "borgerHarAfsluttetUddannelsenSomPaalaeggetVedroerer",
    BorgerErAfmeldtFraUddannelsesinstitutionen = "borgerErAfmeldtFraUddannelsesinstitutionen",
    BorgerHarSkiftetUddannelse = "borgerHarSkiftetUddannelse",
    BorgerensKontaktgruppeErLukket = "borgerensKontaktgruppeErLukket",
    BorgerErBlevet30aar = "borgerErBlevet30aar",
    Fejloprettelse = "fejloprettelse",
    KontaktGruppeSkift = "kontaktGruppeSkift",
    PlanTypeSkift = "planTypeSkift",
    Andet = "andet",
    OvergaarTilUddannelse = "overgaarTilUddannelse",
    GennemfoertUddannelse = "gennemfoertUddannelse",
}

export interface DiaryNoteModel {
    id: string;
    title?: string | undefined;
    sourceName?: string | undefined;
    contentTypeName?: string | undefined;
    createdByName?: string | undefined;
    createdAt: Date | string;
    eventDate: Date | string;
    assignmentId?: string | undefined;
    assignmentName?: string | undefined;
    serviceProviderUnitId?: string | undefined;
    createdByTeamName?: string | undefined;
    hasAttachments?: string | undefined;
    attachments?: JournalNoteAttachmentModel[] | undefined;
    content?: string | undefined;
    isCancelled: boolean;
    letterDate?: Date | string | undefined;
    createByTeamName?: string | undefined;
    revisionNote?: string | undefined;
    sendingStatus?: string | undefined;
    sendingStatusNote?: string | undefined;
    templateCodeName?: string | undefined;
    templateMappingName?: string | undefined;
    diaryNoteUrl?: string | undefined;
    relatedEntityInfo?: EntityInfo | undefined;
    isRead?: boolean | undefined;
}

export interface DiaryNoteCountResponse {
    withCurrentFilters: number;
    withNoFilters: number;
}

export interface DiaryNoteFilterResponse {
    contentTypes: KeyValuePair[];
    createdBy: KeyValuePair[];
    assignments: KeyValuePair[];
    sources: KeyValuePair[];
    hasAttachments: KeyValuePair[];
}

export interface DiaryNotePageRequest {
    pageSize: number;
    pageNumber: number;
}

export interface DiaryNoteSortRequest {
    sortBy: DiaryNoteSortBy;
    sortOrder: DiaryNoteSortOrder;
}

export enum DiaryNoteSortBy {
    EventDate = "eventDate",
    CreatedAt = "createdAt",
}

export enum DiaryNoteSortOrder {
    Descending = "descending",
    Ascending = "ascending",
}

export interface DiaryNoteFilterRequest {
    filterStatus: FilterStatus;
    title?: string | undefined;
    contentTypes: KeyValuePair[];
    createdBy: KeyValuePair[];
    assignments: KeyValuePair[];
    sources: KeyValuePair[];
    hasAttachments: KeyValuePair[];
}

export interface DiaryNoteCreateModel {
    title: string;
    contentType: string;
    source: number;
    content: string;
    citizenId: string;
    eventDate: Date | string;
    serviceProviderUnitId: string;
    assignmentId?: string | undefined;
    attachments?: JournalNoteAttachmentCreateModel[] | undefined;
    letterDate?: Date | string | undefined;
}

export interface MissingPartialsInfo3 {
    missingPartialsCount: number;
    totalPartialsCount: number;
}

export enum DiaryNoteSummaryStatus {
    FullSummary = "fullSummary",
    PartialSummary = "partialSummary",
    NoSummary = "noSummary",
}

export interface CitizenMessageModel {
    citizenMessageId: string;
    createdOn: Date | string;
    createdBy?: string | undefined;
    title?: string | undefined;
    replyDeadline?: Date | string | undefined;
    text?: string | undefined;
    viewedBy?: MessageMarkingStatusTypeViewModel[] | undefined;
    shipmentChannel?: ShipmentChannelTypeViewModel | undefined;
    messageContext?: MessageContextTypeViewModel | undefined;
    status?: MessageStatusTypeViewModel | undefined;
    citizenMessageReplies?: CitizenMessageReplyModel[] | undefined;
    citizenMessageAttachments?: CitizenMessageAttachmentModel[] | undefined;
}

export interface MessageMarkingStatusTypeViewModel {
    enumValue: BeskedMarkeringsstatusType;
    name?: string | undefined;
    description?: string | undefined;
}

export enum BeskedMarkeringsstatusType {
    BorgerLaest = "borgerLaest",
    BorgerVist = "borgerVist",
    ArbejdsgiverLaest = "arbejdsgiverLaest",
    SagsbehandlerLaest = "sagsbehandlerLaest",
}

export interface ShipmentChannelTypeViewModel {
    enumValue: AfsendelsesKanalType;
    name?: string | undefined;
    description?: string | undefined;
}

export enum AfsendelsesKanalType {
    SMS = "sms",
    Mail = "mail",
    JobnetBeskedbakke = "jobnetBeskedbakke",
    MyndighedTilMyndighed = "myndighedTilMyndighed",
    Notifikation = "notifikation",
    ArbejdsgiverBeskedbakke = "arbejdsgiverBeskedbakke",
    STARBulk = "starBulk",
}

export interface MessageContextTypeViewModel {
    enumValue: BeskedIndholdsType;
    name?: string | undefined;
    description?: string | undefined;
}

export enum BeskedIndholdsType {
    AlmenOrientering = "almenOrientering",
    Udkast_DEPRECATED = "udkast_DEPRECATED",
    Jobformidling = "jobformidling",
    ArrangementInvitation = "arrangementInvitation",
    Arbejdsgiver = "arbejdsgiver",
    Kampagne = "kampagne",
    Supportbesked = "supportbesked",
    Kvittering = "kvittering",
    Uddannelsesplan = "uddannelsesplan",
    Afgoerelse = "afgoerelse",
    Tilbud = "tilbud",
    AntruffetKontrolaktion = "antruffetKontrolaktion",
    KostOgLogi = "kostOgLogi",
}

export interface MessageStatusTypeViewModel {
    enumValue: BorgerBeskedStatusType;
    name?: string | undefined;
    description?: string | undefined;
}

export enum BorgerBeskedStatusType {
    Aktiv = "aktiv",
    Lukket = "lukket",
    Fejloprettet = "fejloprettet",
}

export interface CitizenMessageReplyModel {
    messageReplyId: string;
    createdOn: Date | string;
    createdBy?: string | undefined;
    text?: string | undefined;
    viewedBy?: MessageMarkingStatusTypeViewModel[] | undefined;
    status?: MessageStatusTypeViewModel | undefined;
    messageAttachments?: CitizenMessageAttachmentModel[] | undefined;
}

export enum CvAvailabilityType {
    TilgaengeligForSoegning = "tilgaengeligForSoegning",
    IkkeTilgaengeligForSoegning = "ikkeTilgaengeligForSoegning",
}

export enum CvStatusType {
    KlarTilGodkendelse = "klarTilGodkendelse",
    CvGodkendt = "cvGodkendt",
    CvEjGodkendt = "cvEjGodkendt",
    EjKravOmCv = "ejKravOmCv",
    IkkeFyldestGoerende = "ikkeFyldestGoerende",
    Paabegyndt = "paabegyndt",
}

export interface CvStatusInformation {
    lastUpdateByCitizen?: Date | string | undefined;
    cvStatusType?: CvStatusInformationCodeListItem | undefined;
    lastStatusUpdate?: Date | string | undefined;
    statusUpdateComment?: string | undefined;
    availability?: CvStatusInformationCodeListItem | undefined;
}

export interface CvStatusInformationCodeListItem {
    id: number;
    name?: string | undefined;
}

export interface CitizenExemptionOverview {
    cv?: Exemption | undefined;
    jobReferral?: Exemption | undefined;
    joblog?: Exemption | undefined;
    enrollment?: Exemption | undefined;
    offer?: Exemption | undefined;
}

export interface Exemption {
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
}

export interface CvSearchOption {
    optionId: string;
    optionName?: string | undefined;
}

export interface CvSearchMunicipality {
    name?: string | undefined;
    externalIdentifier?: string | undefined;
}

export interface CvSearchResultDto {
    pageNumber: number;
    resultCount: number;
    citizenCvItems?: CitizenCvItem[] | undefined;
    jobWishes?: CvMatchOptionDto[] | undefined;
    qualifications?: CvMatchOptionDto[] | undefined;
    languages?: CvMatchOptionDto[] | undefined;
    educations?: CvMatchOptionDto[] | undefined;
    locations?: CvMatchOptionDto[] | undefined;
    driverslicenses?: CvMatchOptionDto[] | undefined;
    employmentTerms?: CvMatchOptionDto[] | undefined;
    employmentStart?: CvMatchOptionDto[] | undefined;
    weeklyHours?: CvMatchOptionDto[] | undefined;
    employmentForm?: CvMatchOptionDto[] | undefined;
}

export interface CitizenCvItem {
    citizenId: string;
    citizenCpr?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    hasNameAndAddressProtection: boolean;
    municipalityNumber?: number | undefined;
    jobWishes?: JobWishDto[] | undefined;
    educations?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    jobcenterId?: number | undefined;
    unemploymentFundCode?: number | undefined;
    contactGroup?: string | undefined;
    personCategory?: PersonCategory | undefined;
    cvIsSearchable: boolean;
    cvStatus?: CvStatus | undefined;
    cvRequirement?: CvRequirement | undefined;
}

export interface JobWishDto {
    jobWish?: string | undefined;
    jobWishCode?: string | undefined;
    hasEducation: boolean;
    latestYearActive?: number | undefined;
    numberOfMonthsExperience?: number | undefined;
}

export enum PersonCategory {
    JobReady = "jobReady",
    ActivityReady = "activityReady",
    TemporarilyPassive = "temporarilyPassive",
    ReadyForWork = "readyForWork",
    ReadyForActivity = "readyForActivity",
    ObviouslyEducationReady = "obviouslyEducationReady",
    EducationReady = "educationReady",
    NotAssessed = "notAssessed",
    AssessmentCategory1 = "assessmentCategory1",
    AssessmentCategory2 = "assessmentCategory2",
    AssessmentCategory3 = "assessmentCategory3",
    SicknessBenefitCategory1 = "sicknessBenefitCategory1",
    SicknessBenefitCategory2 = "sicknessBenefitCategory2",
    SicknessBenefitCategory3 = "sicknessBenefitCategory3",
    JobClarification = "jobClarification",
}

export enum CvStatus {
    ReadyForApproval = "readyForApproval",
    Approved = "approved",
    NotApproved = "notApproved",
    JobcenterRecommendsUpdate = "jobcenterRecommendsUpdate",
    Started = "started",
}

export enum CvRequirement {
    NoCvRequired = "noCvRequired",
    CvRequired = "cvRequired",
    CvRequiredAndSearchable = "cvRequiredAndSearchable",
}

export interface CvMatchOptionDto {
    numberOfResults?: number | undefined;
    title?: string | undefined;
}

export interface CvSearchRequestDto {
    pageNumber: number;
    pageSize: number;
    showOnlyJobReady: boolean;
    showOnlyFlexjobVisitated: boolean;
    showOnlyJobcenter: boolean;
    jobTitles?: string[] | undefined;
    qualifications?: string[] | undefined;
    searchString?: string | undefined;
    freeSearchEducations?: string[] | undefined;
    freeSearchQualifications?: string[] | undefined;
    freeSearchJobTitles?: string[] | undefined;
    languages?: string[] | undefined;
    driversLicenses?: DriverLicense[] | undefined;
    postalCode?: string | undefined;
    searchRadius?: number | undefined;
    qualificationStatus: QualificationStatus;
    educationStatus: EducationStatus;
}

export enum DriverLicense {
    LK = "lk",
    AM = "am",
    A1 = "a1",
    A2 = "a2",
    A = "a",
    B = "b",
    BE = "be",
    C1 = "c1",
    C1E = "c1E",
    C = "c",
    CE = "ce",
    D1 = "d1",
    D1E = "d1E",
    D = "d",
    DE = "de",
    TM = "tm",
}

export enum QualificationStatus {
    NotSpecified = "notSpecified",
    Without = "without",
    With = "with",
    With2Years = "with2Years",
    With5Years = "with5Years",
}

export enum EducationStatus {
    NotSpecified = "notSpecified",
    Without = "without",
    With = "with",
}

export interface CounselingInquiryExistingSocialCase {
    caseId: string;
    caseTypeName?: string | undefined;
    startDate: Date | string;
}

export interface CounselingInquiryListItemModel {
    id: string;
    inquiryDate: Date | string;
    status: CounselingInquiryStatus;
    completedOn?: Date | string | undefined;
    outcome?: CounselingInquiryOutcome | undefined;
    administration: CounselingInquiryAdministration;
    otherAdministrationName?: string | undefined;
    recommendedGrantTypeName?: string | undefined;
    focusAreas?: string | undefined;
    caseId?: string | undefined;
}

export enum CounselingInquiryStatus {
    Draft = "draft",
    Completed = "completed",
    Completing = "completing",
}

export interface CounselingInquiryDto {
    id: string;
    citizenId: string;
    status: CounselingInquiryStatus;
    createdOn: Date | string;
    createdBy: string;
    modifiedOn: Date | string;
    completedOn?: Date | string | undefined;
    completedBy?: string | undefined;
    caseId?: string | undefined;
    completion?: CounselingInquiryCompletion | undefined;
    content: CounselingInquiryContent;
}

export interface CounselingInquiryCompletion {
    case: CounselingInquiryCompletionCase;
    journalNoteId?: string | undefined;
    rulingId?: string | undefined;
    grantId?: string | undefined;
    activityId?: string | undefined;
    assignmentId?: string | undefined;
    interventionObjectiveAdded: boolean;
    interventionObjectiveIds?: string[] | undefined;
    assignmentSent: boolean;
    lastFailure?: string | undefined;
}

export interface CounselingInquiryCompletionCase {
    existingCaseId?: string | undefined;
    caseTypeId?: string | undefined;
    targetGroupId?: string | undefined;
    contactReasonId?: string | undefined;
    startDate?: Date | string | undefined;
    responsibleTeamId?: string | undefined;
    responsibleCaseworkerId?: string | undefined;
}

export interface CaseTypeModel {
    caseTypeId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    targetGroupId: string;
    targetGroupName?: string | undefined;
    isActive: boolean;
    automaticInformationLetter?: string | undefined;
    maximumDaysToReopen?: number | undefined;
    closingTimeLimit?: number | undefined;
    isLabCaseType: boolean;
    reportAs?: number | undefined;
}

export interface TemporaryHomeSupportOffer {
    offerId: string;
    title?: string | undefined;
    companyName?: string | undefined;
}

export interface LetterFillField {
    id: number;
    type?: string | undefined;
    instruction?: string | undefined;
    text?: string | undefined;
    skipped: boolean;
    reason?: string | undefined;
    source?: string | undefined;
    sourceJournalNoteId?: string | undefined;
    anchorText?: string | undefined;
    placement?: string | undefined;
}

export interface CitizenCase {
    caseId: string;
    startDate?: Date | string | undefined;
    name?: string | undefined;
    isPrimaryCase?: boolean | undefined;
    isPrimarySocialCase?: boolean | undefined;
}

export interface CompanyListItemViewModel {
    label: string;
    value: string;
    name?: string | undefined;
    address?: string | undefined;
}

export interface PrivateContactPersonListItemViewModel {
    label?: string | undefined;
    value: string;
    name?: string | undefined;
    address?: string | undefined;
}

export interface CompanyContactPersonListItemViewModel {
    label?: string | undefined;
    value: string;
    name?: string | undefined;
    email?: string | undefined;
}

export interface OutgoingDocumentTypeViewModel2 {
    id: string;
    name: string;
    isActive: boolean;
}

export interface StandardAppendixModel {
    id: string;
    name?: string | undefined;
    code?: string | undefined;
    documentIds?: string[] | undefined;
}

export interface AttachmentModel {
    id?: string | undefined;
    documentId?: string | undefined;
    title?: string | undefined;
    name?: string | undefined;
    size?: string | undefined;
    sizeInBytes: number;
    aliasId?: string | undefined;
    mime?: string | undefined;
    added?: string | undefined;
}

export interface ClarificationRightListModel {
    id: string;
    caseId?: string | undefined;
    clarificationDate: Date | string;
    assessment?: string | undefined;
    isDeleted: boolean;
    deletionComment?: string | undefined;
    registeringAuthorityName?: string | undefined;
    registeringUserName?: string | undefined;
    dfdgRegisteredAt?: Date | string | undefined;
    createdBy?: string | undefined;
    createdOn: Date | string;
    modifiedBy?: string | undefined;
    modifiedOn: Date | string;
}

export interface CitizenCase2 {
    caseDescription?: string | undefined;
    caseId: string;
    isPrimaryCase: boolean;
}

export interface CitizenTaskMetaData {
    id: string;
    title?: string | undefined;
    dueDate?: Date | string | undefined;
    responsibleCaseWorkerId?: string | undefined;
    responsibleCaseWorkerName?: string | undefined;
    responsibleTeamId?: string | undefined;
    responsibleTeamName?: string | undefined;
    taskType?: string | undefined;
    taskCategory?: string | undefined;
    taskStatus?: string | undefined;
    caseType?: string | undefined;
    caseId?: string | undefined;
}

export interface CitizenTaskFilter {
    allTasks: boolean;
}

export interface AlertBox {
    hasContactGroupDiscrepancy: boolean;
    isMissingFutureInterview: boolean;
    isMissingEnrollment: boolean;
    hasUnemploymentBenefitProcess: boolean;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    expectedJobResumptions?: ExpectedJobResumptionModel[] | undefined;
    hasUnprocessedNegativeEvents: boolean;
    employmentEffortPauses?: EmploymentEffortPauseModel[] | undefined;
}

export interface EmploymentEffortPauseModel {
    startDate: Date | string;
    endDate: Date | string;
}

export interface CitizenOverviewBox {
    deliveryMethod?: string | undefined;
    personGroupMarkings?: string[] | undefined;
}

export interface ExcemptionsBox {
    excemptions?: string[] | undefined;
}

export interface DueDatesBox {
    dueDates?: DueDate[] | undefined;
}

export interface DueDate {
    text?: string | undefined;
    date: Date | string;
}

export interface InterviewBox {
    latestInterview?: LatestInterview | undefined;
    isMissingFutureInterview: boolean;
}

export interface LatestInterview {
    latestInterviewTime?: Date | string | undefined;
    latestInterviewType?: string | undefined;
}

export interface CvAndJobsearchBox {
    openEnrollment?: string | undefined;
    isMissingEnrollment: boolean;
    showAsWarning: boolean;
}

export interface UnemploymentBenefitBox {
    grossBenefitWeeks?: number | undefined;
    hasUnemploymentBenefitProcess: boolean;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    hoursConsumed?: number | undefined;
    hoursRemaining?: number | undefined;
    inventoryPaymentYear?: number | undefined;
    inventoryPaymentMonth?: number | undefined;
}

export interface PrimaryCaseBox {
    additionalCaseWorker?: CaseWorker[] | undefined;
    showClarificationDate: boolean;
    latestClarificationDate?: Date | string | undefined;
}

export interface CaseWorker {
    id: string;
    role?: string | undefined;
    fullname?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export interface SocialCasesBox {
    socialCases?: SocialCaseDto[] | undefined;
}

export interface SocialCaseDto {
    caseId: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    caseTypeName?: string | undefined;
    caseGroupName?: string | undefined;
    caseWorkers?: CaseWorker[] | undefined;
}

export interface LatestAssessmentBox {
    assessmentId: string;
    createdOn: Date | string;
    primaryAssessmentTopicName?: string | undefined;
    secondaryAssessmentTopicNames?: string[] | undefined;
    guardianType?: string | undefined;
    representationType?: string | undefined;
    status?: string | undefined;
    citizenAssessmentPurposeInfo?: string | undefined;
    citizenAssessmentPurposeInfoRichText?: string | undefined;
}

export interface SupplementaryCasesBox {
    supplementaryCases?: SupplementaryCase[] | undefined;
}

export interface SupplementaryCase {
    id: string;
    startDate: Date | string;
    caseTypeName?: string | undefined;
}

export interface SicknessBenefitCaseBox {
    companyId?: string | undefined;
    companyName?: string | undefined;
    firstDayOfAbsence?: Date | string | undefined;
    reevaluationDate?: Date | string | undefined;
    sicknessBenefitDurationDate?: Date | string | undefined;
    salaryFreezeDate?: Date | string | undefined;
    expectedRecover?: YesNoUnknownAnswer | undefined;
    informationForm?: number | undefined;
    actualDuationWeeks?: number | undefined;
    actualDurationDays?: number | undefined;
    benefitExtentionReason?: string | undefined;
    resumedWork?: ResumedWorkModel | undefined;
    expectedJobResumptions?: ExpectedJobResumptionModel[] | undefined;
}

export interface PlanAndActivitiesBox {
    latestCompanyActivity?: LatestCompanyActivity | undefined;
    planTypeName?: string | undefined;
    activityTotalHoursAndMinutes?: ActivityTotalHoursAndMinutesDto | undefined;
    activationLevel?: ActivationLevelDto | undefined;
    citizenIncomeLast3Months?: CitizenIncomeLast3MonthsSummary | undefined;
}

export interface LatestCompanyActivity {
    offerCategory?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
}

export interface ActivityTotalHoursAndMinutesDto {
    hours: number;
    minutes: number;
}

export interface CitizenIncomeLast3MonthsSummary {
    hasAnyRecords: boolean;
    totalWorkHours?: number | undefined;
    hasRecordsWithoutHours: boolean;
}

export interface ForumAppUsageBox {
    firstUseDate?: Date | string | undefined;
    lastSeenDate?: Date | string | undefined;
    isForumEnabled: boolean;
}

export interface CurrentActivitiesBox {
    currentActivities?: CurrentActivity[] | undefined;
}

export interface CurrentActivity {
    activityId: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    offerTypeName?: string | undefined;
    hours: number;
    minutes: number;
    title?: string | undefined;
    offerCategoryName?: string | undefined;
    flexJobType?: FlexJobType | undefined;
    efficientHoursPerWeek?: number | undefined;
    efficientMinutesPerWeek?: number | undefined;
    coPayments?: ActivityCoPayment[] | undefined;
}

export enum FlexJobType {
    Temporary = "temporary",
    Permanent = "permanent",
    OldArrangement = "oldArrangement",
    TemporaryOwnedCorporation = "temporaryOwnedCorporation",
    OldArrangementOwnedCorporation = "oldArrangementOwnedCorporation",
}

export interface ActivityCoPayment {
    coPaymentId: string;
    coPaymentTypeName?: string | undefined;
    amount: number;
    amountType: CoPaymentAmountType;
    billingType: BillingType;
    startDate: Date | string;
    endDate: Date | string;
    isUpcoming: boolean;
    isEndingSoon: boolean;
    endingExplanation?: string | undefined;
}

export interface CurrentSocialGrantsBox {
    currentSocialGrants?: GrantModel[] | undefined;
}

export interface GrantModel {
    id: string;
    caseId: string;
    citizenId: string;
    grantTypeName?: string | undefined;
    status?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    followUpDate?: Date | string | undefined;
    description?: string | undefined;
    activities?: ActivityModel2[] | undefined;
    primaryAssessmentTopicName?: string | undefined;
    additionalAssessmentTopicIds?: string[] | undefined;
    benefitTypeNames?: string[] | undefined;
}

export interface ActivityModel2 {
    id: string;
    title?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    offerTypeName?: string | undefined;
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
    companyName?: string | undefined;
    state?: string | undefined;
    approvalState?: string | undefined;
    contactPersonName?: string | undefined;
}

export interface CurrentAssignmentsBox {
    currentAssignments?: AssignmentOverviewModel[] | undefined;
}

export interface AssignmentOverviewModel {
    assignmentId: string;
    activityId: string;
    name?: string | undefined;
    serviceProviderUnitName?: string | undefined;
    startDate?: Date | string | undefined;
    followUpDate?: Date | string | undefined;
    receivedBy?: AssignmentReceivedByUserModel | undefined;
    receivedDate?: Date | string | undefined;
    latestDiaryNoteDate?: Date | string | undefined;
    interventionObjectives?: InterventionObjectiveOverviewModel[] | undefined;
    assignedResources?: AssignedResourceOverviewModel[] | undefined;
}

export interface AssignmentReceivedByUserModel {
    id: string;
    fullname?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export interface InterventionObjectiveOverviewModel {
    title?: string | undefined;
    type?: string | undefined;
}

export interface AssignedResourceOverviewModel {
    name?: string | undefined;
    allocatedHoursPerWeek: number;
    allocatedMinutesPerWeek: number;
}

export interface RelevantContactPersonsBox {
    contactPersons?: CitizenPersonContactViewModel[] | undefined;
}

export interface CitizenPersonContactViewModel {
    id: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    contactName?: string | undefined;
    caseworkerComment?: string | undefined;
    combinedTelephoneNumber?: string | undefined;
    showContactPersonInJobnet: boolean;
    role?: string | undefined;
    responsibleAuthority?: string | undefined;
    address?: string | undefined;
    citizenCprNumber?: string | undefined;
    citizenDisplayName?: string | undefined;
    highlightOnOptics?: string[] | undefined;
}

export interface RulingsBox {
    rulingsInProgress?: RulingInProgress[] | undefined;
    continuationsInProgress?: ContinuationInProgress[] | undefined;
    latestDecidedRuling?: LatestDecidedRuling | undefined;
    latestCompletedContinuation?: LatestCompletedContinuation | undefined;
}

export interface RulingInProgress {
    rulingId: string;
    statusDisplayName?: string | undefined;
    progressStep: number;
    progressStepCount: number;
    concerning?: string | undefined;
    createdAt: Date | string;
    responsibleName?: string | undefined;
    grantTypeNames?: string[] | undefined;
    isBasedOnLatestAssessment: boolean;
    deadline?: OverviewDeadline | undefined;
    processingDeadline?: Date | string | undefined;
    hearingSubmissionDeadline?: Date | string | undefined;
}

export interface OverviewDeadline {
    label?: string | undefined;
    date: Date | string;
    state: DeadlineState;
    explanation?: string | undefined;
}

export enum DeadlineState {
    None = "none",
    Soon = "soon",
    Overdue = "overdue",
}

export interface ContinuationInProgress {
    continuationId: string;
    rulingId: string;
    statusDisplayName?: string | undefined;
    progressStep: number;
    progressStepCount: number;
    concerning?: string | undefined;
    createdAt: Date | string;
    intakePlannedAt?: Date | string | undefined;
    responsibleName?: string | undefined;
}

export interface LatestDecidedRuling {
    rulingId: string;
    decidedAt: Date | string;
    resultDisplayName?: string | undefined;
    concerning?: string | undefined;
}

export interface LatestCompletedContinuation {
    continuationId: string;
    rulingId: string;
    completedAt: Date | string;
    nextFollowUpDate?: Date | string | undefined;
    concerning?: string | undefined;
}

export interface CasePrimaryCaseWorker {
    caseId: string;
    caseTypeName?: string | undefined;
    isSocialCase?: boolean | undefined;
    primaryCaseWorker?: CaseWorker | undefined;
}

export interface PartialObjectivesBox {
    interventionObjectives?: InterventionObjectiveBoxModel[] | undefined;
}

export interface InterventionObjectiveBoxModel {
    name?: string | undefined;
    partialObjectives?: PartialObjectiveBoxModel[] | undefined;
}

export interface PartialObjectiveBoxModel {
    id: string;
    name?: string | undefined;
    progression?: number | undefined;
    rank?: number | undefined;
    latestFollowup?: Date | string | undefined;
    status: PartialObjectiveStatusType;
}

export interface DayViewModel {
    year: number;
    month: number;
    day: number;
    sustenanceHistoryDomainShortName?: string[] | undefined;
    sustenanceHistoryDomainName?: string[] | undefined;
    sustenanceHistoryCategoryName?: string[] | undefined;
    color1?: string | undefined;
    color2?: string | undefined;
    isActualMonth: boolean;
}

export interface YearViewModel {
    year: number;
    citizenId: string;
    sustenanceHistory?: MonthViewModel[] | undefined;
}

export interface MonthViewModel {
    year: number;
    month: number;
    day: number;
    sustenanceHistoryDomainShortName?: string[] | undefined;
    sustenanceHistoryDomainName?: string[] | undefined;
    sustenanceHistoryCategoryName?: string[] | undefined;
    color1?: string | undefined;
    color2?: string | undefined;
    isActualMonth: boolean;
}

export interface PersonGroupMarkingViewModel {
    id: string;
    dfdgId: string;
    name?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    citizenId: string;
    personGroupId: string;
    createdByName?: string | undefined;
    createdOn: Date | string;
    modifiedByName?: string | undefined;
    modifiedOn: Date | string;
    isActive: boolean;
}

export interface PersonGroupMarkingStatisticsViewModel {
    isTeamDisabled?: boolean | undefined;
    hasOpenPersonGroupMarkings?: boolean | undefined;
    endDateOfLatestPersonGroupMarking?: Date | string | undefined;
}

export interface PersonGroupViewModel {
    id: string;
    personGroupTypeId: string;
    personGroupTypeName?: string | undefined;
    name?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    isShownInInterview: boolean;
    isRelevantInterMunicipality: boolean;
    isGovernmentPersonGroup: boolean;
    dfdgId: string;
    teamId?: string | undefined;
    createdOn: Date | string;
    isActive: boolean;
}

export interface FamilyMemberViewModel {
    birthDate: Date | string;
    birthdayEighteenYears?: string | undefined;
    residenceCountry?: string | undefined;
}

export interface ColumnHeaderModel {
    name?: string | undefined;
    dataType?: string | undefined;
}

export interface CitizenPersonContactEditModel {
    caseworkerId?: string | undefined;
    contactPersonId?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    role?: PersonContactType | undefined;
    citizenComment?: string | undefined;
    caseworkerComment?: string | undefined;
    telephoneNumber?: string | undefined;
    mobileNumber?: string | undefined;
    email?: string | undefined;
    showContactPersonInJobnet: boolean;
    responsibleAuthority?: string | undefined;
    journalNoteId?: string | undefined;
    highlightOnOptics?: string[] | undefined;
}

export interface PersonContactType extends StandardCodeList {
}

export interface CitizenAddressHistoryViewModel {
    isCurrent: boolean;
    isForeign: boolean;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    postalAddress?: ContactInfoPostalAddress | undefined;
}

export interface ReasonForReadWriteMathTest extends BusinessConfigurationItem {
    elaborationOfReasonRequired?: boolean | undefined;
}

export interface CitizenCoreViewModel {
    readOnlyFields?: CitizenCoreReadOnlyFields | undefined;
    editableFields?: CitizenCoreEditableFields | undefined;
}

export interface CitizenCoreReadOnlyFields {
    temporaryAddressStartDate?: string | undefined;
    temporaryAddressEndDate?: string | undefined;
    temporaryAddress?: string | undefined;
    jobcenter?: string | undefined;
    subjobcenter?: string | undefined;
    municipality?: string | undefined;
    relocationDate?: string | undefined;
    personCprStatus?: string | undefined;
    familyStatusCode?: string | undefined;
    birthDay?: string | undefined;
    genderCode?: string | undefined;
    citizenship?: string | undefined;
    nordicCitizen?: YesNo | undefined;
    entryDate?: string | undefined;
}

export interface ContactInfoCountryViewModel {
    code?: string | undefined;
    name?: string | undefined;
}

export interface CitizenChangeLogQueryViewModel {
    id: string;
    userName?: string | undefined;
    changes?: ChangeV2Dto[] | undefined;
    correlationIdentifier?: string | undefined;
    operation?: string | undefined;
    timestamp: Date | string;
    postType?: string | undefined;
    postId?: string | undefined;
}

export interface AssociateUser {
    id: string;
    caseWorkerName?: string | undefined;
    displayName?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    role?: string | undefined;
    description?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    caseWorkerId: string;
}

export interface CaseClosureReason extends BusinessConfigurationItem {
    description?: string | undefined;
    removalCauseTypeIds?: string[] | undefined;
}

export interface CaseContactReason extends BusinessConfigurationItem {
    description?: string | undefined;
}

export interface CaseGroup extends BusinessConfigurationItem {
    description?: string | undefined;
}

export interface CaseRestriction extends BusinessConfigurationItem {
    caseRestrictionFKAId?: string | undefined;
}

export interface CasesListViewModel {
    caseId: string;
    caseTypeName?: string | undefined;
    caseTypeId?: string | undefined;
    targetGroupName?: string | undefined;
    targetGroupId?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    citizenId: string;
    caseStatus: CaseStatus;
    responsibleCaseworkerName?: string | undefined;
    responsibleCaseworkerId?: string | undefined;
    grantStartDate?: Date | string | undefined;
    grantEndDate?: Date | string | undefined;
    personCategoryName?: string | undefined;
    personCategoryId?: string | undefined;
}

export interface CaseValidationValues {
    hasActiveCase: boolean;
    currentPrimaryActiveCaseTypeName?: string | undefined;
    hasActiveCaseWithContactGroup: boolean;
    hasReopenableSocialSecurityCases: boolean;
    hasActiveSicknessBenefitContactGroup: boolean;
    hasActiveJobClarificationContactGroup: boolean;
    hasNoActiveContactGroupButLatestWasJobClarification: boolean;
    age: number;
    caseHasOffsettingPlacements: boolean;
    caseHasOpenAdviceOrTasks: boolean;
    caseHasOpenAppointments: boolean;
    caseHasPlacements: boolean;
    caseType?: string | undefined;
    caseTypeId?: string | undefined;
    closureReasonId?: string | undefined;
    hasCaseInApplicableTargetGroup: boolean;
    hasActiveSicknessAbsence: boolean;
    hasLoentilskudPlacement: boolean;
    hasFlexjobPlacement: boolean;
    offsettingPlacementType?: string | undefined;
    targetGroupId?: string | undefined;
    isCitizenDeceased: boolean;
    hasProfessionalEducation: boolean;
    allowTargetGroupChange: boolean;
    supportsChangeToSicknessBenefit: boolean;
    citizenBelongToAnotherJobcenter: boolean;
    targetGroupSupportReEnrollement: boolean;
    hasActiveEnrollment: boolean;
    isLatestContactGroupJobclarification: boolean;
    hasActiveSicknessAbsenceNemrefusionsId: boolean;
    hasActiveSicknessAbsenceEmployerId: boolean;
    hasHistoricRegistration: boolean;
    hasOpenRehabCase: boolean;
    hasAnyMissingParticipationUnderPartyHearing?: boolean | undefined;
    hasAnyBenefitExtensionAssessments?: boolean | undefined;
}

export interface EffortGroup extends BusinessConfigurationItem {
    description?: string | undefined;
    typicalEffortDescription?: string | undefined;
}

export interface InterviewCalculationsStartDateConfigurationModel {
    interviewCalculationsStartDateActive: boolean;
    excludedTargetGroups?: string[] | undefined;
}

export interface Municipality extends CodeListItem {
    externalId?: string | undefined;
    jobcenterId?: string | undefined;
    stateCode?: number | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    region: MunicipalityRegion;
}

export enum MunicipalityRegion {
    Denmark = "denmark",
    Greenland = "greenland",
}

export interface CaseModelSimple {
    caseId: string;
    caseStatus: CaseStatus;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    caseTypeId?: string | undefined;
    targetGroupId?: string | undefined;
    caseGroupId?: string | undefined;
    responsibleTeamId?: string | undefined;
    responsibleCaseworkerId?: string | undefined;
    responsibleExternalOperatorTeamId?: string | undefined;
    responsibleExternalOperatorCaseworkerId?: string | undefined;
    interviewCalculationsStartDate?: Date | string | undefined;
    approvedForFlexJobDate?: Date | string | undefined;
}

export interface PrimaryCaseContent {
    otherCases?: CaseModelForPrimaryCaseBoxViewModel[] | undefined;
    primaryCase: PrimaryCaseForPrimaryCaseBox;
    companyName?: string | undefined;
    caseWorkers?: PrimaryCaseContentCaseWorker[] | undefined;
}

export interface CaseModelForPrimaryCaseBoxViewModel {
    caseId: string;
    startDate: Date | string;
    caseTypeName?: string | undefined;
    companyName?: string | undefined;
    companyId?: string | undefined;
}

export interface PrimaryCaseForPrimaryCaseBox {
    caseId: string;
    endDate?: Date | string | undefined;
    caseStatus: CaseStatus;
    firstDayOfAbsence?: Date | string | undefined;
    sicknessBenefitDurationDate?: Date | string | undefined;
    companyId?: string | undefined;
}

export interface PrimaryCaseContentCaseWorker {
    id: string;
    fullname: string;
    role: string;
    email: string;
    phone: string;
}

export interface RehabilitationProcessStatusTypeModel {
    code: number;
    name?: string | undefined;
    description?: string | undefined;
}

export interface SelfScreeningModel {
    citizenId: string;
    screeningCreatedOn: Date | string;
    screeningResultCategoryId?: string | undefined;
}

export interface HearingType extends CodeListItem {
    externalIdentifier?: string | undefined;
}

export interface SicknessBenefitVisitationModel {
    id: string;
    citizenId: string;
    caseId: string;
    visitationDate: Date | string;
    status: SicknessBenefitVisitationStatus;
    justification?: string | undefined;
    followUpTaskRequested: boolean;
    followUpDate?: Date | string | undefined;
}

export interface CodeListItem7 {
    id: string;
    name?: string | undefined;
    isActive: boolean;
}

export interface StandardCodeList2 extends CodeListItem7 {
    description?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    externalId?: string | undefined;
    stateCode: number;
}

export interface AbsenceCauseType extends StandardCodeList2 {
}

export interface AbsenceHistoryModel {
    registrationMetadata: RegistrationMetadataModel;
    absenceHistoryDetail: AbsenceHistoryDetailModel;
}

export interface RegistrationMetadataModel {
    changedByCaseworkerFullName?: string | undefined;
    changedByAuthorityName: string;
    changedByAuthorityCode: string;
    registrationDate: Date | string;
    isDeleted: boolean;
}

export interface AbsenceHistoryDetailModel {
    startDate: Date | string;
    endDate?: Date | string | undefined;
    absenceTypeName: string;
    absenceCauseTypeName?: string | undefined;
    absenceComment?: string | undefined;
    correctionComment?: string | undefined;
    absenceHistoryCompany?: AbsenceHistoryCompanyModel | undefined;
    isActive?: boolean | undefined;
}

export interface AbsenceHistoryCompanyModel {
    cvrNumberIdentifier: string;
    productionUnitIdentifier?: string | undefined;
}

export interface AbsenceViewModel {
    absenceId: string;
    citizenId: string;
    isActive?: boolean | undefined;
    absenceTypeName?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    notificationDate?: Date | string | undefined;
    sickLeaveInSubscription?: boolean | undefined;
    absenceCauseTypeName?: string | undefined;
    isDeleted?: boolean | undefined;
}

export interface AbsenceSimpleModel {
    absenceId: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    citizenId: string;
    absenceTypeId: string;
    absenceTypeName: string;
    externalIdentifier: number;
    isJobcenterSpecific: boolean;
    comment?: string | undefined;
}

export interface BusinessConfigurationItem2 {
    id: string;
    name?: string | undefined;
    isActive: boolean;
}

export interface AbsenceType extends BusinessConfigurationItem2 {
    createNotification?: boolean | undefined;
    description?: string | undefined;
    endDate?: Date | string | undefined;
    endDateNoOfDaysInPast?: number | undefined;
    externalId?: string | undefined;
    isEndDateRequired?: boolean | undefined;
    kmdActiveDescription?: string | undefined;
    kmdActiveExternalId?: string | undefined;
    maximumDurationInDays?: number | undefined;
    startDate?: Date | string | undefined;
    startDateNoOfDaysInPast?: number | undefined;
    stateOnChangeToSicknessBenefit?: number | undefined;
    absenceTypeCode?: string | undefined;
    jobcenterSpecificAbsenceType?: boolean | undefined;
    stateCode?: number | undefined;
    absenceTypeIds?: string[] | undefined;
    filterExcludedIds?: string[] | undefined;
    filterIncludedIds?: string[] | undefined;
}

export interface AssessmentDetailsModel {
    id: string;
    citizenId: string;
    createdOn: Date | string;
    eventType: EventType;
    status: AssessmentStatus;
    decisionLetterCreationDate?: Date | string | undefined;
    relevance: AssessmentRelevance;
    sanction: boolean;
    reasonableCauseType?: ReasonableCauseType | undefined;
    sanctionRequestText?: string | undefined;
    comments?: string | undefined;
    deadlineForPartyReply?: Date | string | undefined;
    caseWorkerId?: string | undefined;
    sendAsAgterskrivelse?: boolean | undefined;
    hearing?: Hearing | undefined;
}

export interface EventType extends CodeListItem7 {
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    externalId?: string | undefined;
    dfdgCodeList?: number | undefined;
    internalId?: string | undefined;
    lawReferenceAvailability?: string | undefined;
    lawReferenceSanction?: string | undefined;
    kyName?: string | undefined;
    isNuph?: boolean | undefined;
    canBeRelatedToAPlacement?: boolean | undefined;
    collectToOneAvailabilityAssessment?: boolean | undefined;
    sanctioningTextForCitizen?: string | undefined;
    sanctioning?: string | undefined;
    stateCode?: number | undefined;
    targetGroupIds?: string[] | undefined;
    textForDecision?: string | undefined;
}

export interface ReasonableCauseType extends StandardCodeList2 {
}

export interface Hearing {
    isReplyReceived?: boolean | undefined;
    receivedDate?: Date | string | undefined;
    citizenComment?: string | undefined;
    assessment?: string | undefined;
    hearingStartDate: Date | string;
}

export interface AssessmentViewModel {
    assessmentId: string;
    created: Date | string;
    deadlineForPartyReply?: Date | string | undefined;
    sanction: boolean;
    targetGroupName?: string | undefined;
    eventType: EventType;
    status: AssessmentStatus;
    relevance: AssessmentRelevance;
}

export interface AvailabilityOverviewModel {
    currentIllness?: CurrentIllnessModel | undefined;
    unresolvedNegativeEventCount: number;
    ongoingAvailabilityAssessmentCount: number;
    negativeEventsThatCausedSanctioningLastThreeMonths: NegativeEventGroupModel[];
    overviewExemptions: OverviewExemption[];
}

export interface CurrentIllnessModel {
    employerInfo?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
}

export interface NegativeEventGroupModel {
    name: string;
    count: number;
}

export interface OverviewExemption {
    exemptionType: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
}

export interface CompanyContactPersonModel2 {
    id: string;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export interface NegativeEventViewModel {
    id: string;
    citizenId: string;
    eventDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    negativeEventType: EventType;
    isRelevant: boolean;
    negativeEventStatus: EventStatus;
    comment?: string | undefined;
    assessment?: AssessmentSimpleViewModel | undefined;
    unemploymentFundInfo?: UnemploymentFundInfoViewModel | undefined;
    targetGroup?: TargetGroupViewModel2 | undefined;
    activity?: ActivityViewModel | undefined;
}

export enum EventStatus {
    Undefined = "undefined",
    Ubehandlet = "ubehandlet",
    SendtTilAkasse = "sendtTilAkasse",
    Behandlet = "behandlet",
    RaadighedsVurderetAkasse = "raadighedsVurderetAkasse",
    UnderPartshoering = "underPartshoering",
    RaadighedsVurderingAfsluttet = "raadighedsVurderingAfsluttet",
}

export interface AssessmentSimpleViewModel {
    created: Date | string;
    deadlineForPartyReply?: Date | string | undefined;
    sanction: boolean;
}

export interface UnemploymentFundInfoViewModel {
    name?: string | undefined;
    availabilityAssessmentCode?: string | undefined;
    availabilityAssessmentDate?: Date | string | undefined;
    comment?: string | undefined;
}

export interface TargetGroupViewModel2 {
    id: string;
    name: string;
    code: string;
}

export interface ActivityViewModel {
    id: string;
    name: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
}

export interface NegativeEventForAssessmentModel {
    id: string;
    eventDate: Date | string;
    eventEndDate?: Date | string | undefined;
    eventTypeName: string;
    isRelevant: boolean;
    negativeEventStatus: EventStatus;
    activityId?: string | undefined;
    activityName?: string | undefined;
}

export interface PrivateContactPersonModel2 {
    id: string;
    name?: string | undefined;
    address?: PrivateContactPersonAddressModel2 | undefined;
}

export interface PrivateContactPersonAddressModel2 {
    streetAddress?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
}

export interface CodeListItem8 {
    description?: string | undefined;
    deprecated: boolean;
    code: number;
    type?: string | undefined;
    name?: string | undefined;
}

export interface CvFiles {
    cv: File;
    attachments: File[];
}

export interface File {
    name: string;
    mimeType: string;
    contents: string;
}

export interface DanishTestResultDto {
    lastTestDate?: Date | string | undefined;
    latestDanishTestResult?: boolean | undefined;
    incomeSubsidyForDanishEducationRemitted?: Date | string | undefined;
}

export interface DfdgTransition {
    date: Date | string;
    municipality?: string | undefined;
}

export interface MunicipalityItem {
    municipalityCode?: string | undefined;
    municipalityName?: string | undefined;
}

export interface TransitionDto {
    asylumTransitionDate: Date | string;
    earlyCvTransitionDate?: Date | string | undefined;
    earlyIntegrationContractTransitionDate?: Date | string | undefined;
    transitionMunicipality: string;
    transitionMunicipalityName?: string | undefined;
}

export interface AssignmentModel {
    assignmentId: AssignmentId;
    activityId: ActivityId;
    citizenId: CitizenId;
    isDeleted: boolean;
    createdByServiceProvider: boolean;
    receivedBy?: AssignmentReceivedByUserModel2 | undefined;
    receivedDate?: Date | string | undefined;
    messageToAuthority?: string | undefined;
    shareSupportAssessment: boolean;
    sharedSupportAssessmentId?: string | undefined;
    supportAssessmentSharing?: SupportAssessmentSharingModel | undefined;
    createdOn: Date | string;
    createdBy: UserId;
    modifiedOn: Date | string;
    modifiedBy?: UserId | undefined;
    status: AssignmentStatusType;
    closingRemarks?: string | undefined;
    backgroundInformation: BackgroundInformationModel;
    coordinationDetails: CoordinationDetailsModel;
    assessmentInformation: AssessmentInformationModel;
    commissionedIntervention: CommissionedInterventionModel;
}

export interface AssignmentReceivedByUserModel2 {
    id: string;
    fullname?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export interface SupportAssessmentSharingModel {
    canShare: boolean;
    supportAssessmentId?: string | undefined;
    completionDate?: Date | string | undefined;
}

export interface BackgroundInformationModel {
    name: string;
    companyId: CompanyId;
    serviceProviderUnitName?: string | undefined;
    serviceProviderUnitId?: ServiceProviderUnitId | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    responsibleUserId?: UserId | undefined;
    responsibleTeamId?: TeamId | undefined;
    citizenMedicalDiagnoses?: string | undefined;
    citizenMedicalDiagnosesRichText?: string | undefined;
    specialInformationAboutCitizen?: string | undefined;
    specialInformationAboutCitizenRichText?: string | undefined;
    hasGuardian?: boolean | undefined;
    guardianType?: GuardianTypeModel | undefined;
    guardianDetails?: string | undefined;
    isRepresented?: boolean | undefined;
    representationType?: RepresentationTypeModel | undefined;
    powersOfAttorney?: string | undefined;
}

export interface ServiceProviderUnitAssignmentCount {
    serviceProviderUnitId: string;
    currentAssignmentCount: number;
    historicAssignmentCount: number;
}

export interface IdentifierOfAssignment {
    value: string;
}

export interface AssignmentId2 extends IdentifierOfAssignment {
}

export interface CaseAssignmentModel {
    assignmentId: string;
    activityId: string;
    activityTitle?: string | undefined;
    name?: string | undefined;
    serviceProviderUnitName?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    status: AssignmentStatusType;
    createdByServiceProvider: boolean;
}

export interface GrantTypeOfferCombinationModel {
    grantTypeId: string;
    grantTypeName?: string | undefined;
    offerId: string;
    offerTitle?: string | undefined;
    offerNumber?: number | undefined;
    availableSeats?: number | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    allowOverbooking: boolean;
    socialOfferFfbId?: string | undefined;
}

export interface InitialAssignmentModel {
    backgroundInformation: InitialBackgroundInformationModel;
    coordinationDetails: CoordinationDetailsModel;
    assessmentInformation: AssessmentInformationModel;
    commissionedIntervention: CommissionedInterventionModel;
    supportAssessmentSharing?: SupportAssessmentSharingModel | undefined;
    shareSupportAssessment?: boolean | undefined;
}

export interface InitialBackgroundInformationModel {
    name?: string | undefined;
    companyId?: CompanyId | undefined;
    serviceProviderUnitName?: string | undefined;
    serviceProviderUnitId?: ServiceProviderUnitId | undefined;
    responsibleUserId?: UserId | undefined;
    responsibleTeamId?: TeamId | undefined;
    citizenMedicalDiagnoses?: string | undefined;
    citizenMedicalDiagnosesRichText?: string | undefined;
    specialInformationAboutCitizen?: string | undefined;
    specialInformationAboutCitizenRichText?: string | undefined;
    hasGuardian?: boolean | undefined;
    guardianType?: GuardianTypeModel | undefined;
    guardianDetails?: string | undefined;
    isRepresented?: boolean | undefined;
    representationType?: RepresentationTypeModel | undefined;
    powersOfAttorney?: string | undefined;
}

export interface InterventionObjectiveModel {
    interventionObjectiveId?: InterventionObjectiveId | undefined;
    assignmentId?: AssignmentId | undefined;
    title?: string | undefined;
    description?: string | undefined;
    interventionObjectiveType: InterventionObjectiveType;
    functionalAbilityCatalogId: string;
    functionalAbilityCatalogName?: string | undefined;
    currentFunctionalAbilityCatalogRating: number;
    expectedFunctionalAbilityCatalogRating: number;
    followUpDate?: Date | string | undefined;
    otherFunctionalAbilityCatalogIds?: string[] | undefined;
    copiedFromAssessmentInterventionObjectiveId?: string | undefined;
    createdOn: Date | string;
    createdBy?: UserId | undefined;
    modifiedOn: Date | string;
    modifiedBy?: UserId | undefined;
}

export interface AssignmentListModel {
    assignmentId: AssignmentId;
    name: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    status: AssignmentStatusType;
    grantTypeName?: string | undefined;
    primaryAssessmentTopic?: string | undefined;
    responsibleUserName?: string | undefined;
    receivedBy?: string | undefined;
    representationType?: RepresentationTypeModel | undefined;
    guardianType?: GuardianTypeModel | undefined;
    createdByServiceProvider: boolean;
}

export interface AssignmentLookupModel {
    assignmentId: AssignmentId;
    name: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    serviceProviderUnitName?: string | undefined;
    serviceProviderUnitId?: ServiceProviderUnitId | undefined;
}

export interface AssignmentListModel2 {
    assignmentId: AssignmentId;
    name: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    status: AssignmentStatusType;
    createdByServiceProvider: boolean;
}

export interface PartialObjectiveModel {
    id?: PartialObjectiveId | undefined;
    interventionObjectiveId?: InterventionObjectiveId | undefined;
    title?: string | undefined;
    description?: string | undefined;
    methodType?: string | undefined;
    progression: number;
    rank?: number | undefined;
    status: PartialObjectiveStatusType;
    statusRemark?: string | undefined;
}

export interface PartialObjectiveFollowupModel {
    id?: PartialObjectiveFollowupId | undefined;
    partialObjectiveId?: PartialObjectiveId | undefined;
    progression: number;
    description?: string | undefined;
    eventDate: Date | string;
    methodType?: string | undefined;
}

export interface AssessmentInterventionObjectiveModel {
    id: string;
    assessmentId: string;
    title?: string | undefined;
    description?: string | undefined;
    interventionObjectiveType: InterventionObjectiveType2;
    functionalAbilityCatalogId: string;
    functionalAbilityCatalogName?: string | undefined;
    currentFunctionalAbilityCatalogRating: number;
    expectedFunctionalAbilityCatalogRating: number;
    followUpDate?: Date | string | undefined;
    otherFunctionalAbilityCatalogIds?: string[] | undefined;
    otherFunctionalAbilityCatalogNames?: string[] | undefined;
    createdOn: Date | string;
    createdBy: string;
    modifiedOn: Date | string;
    modifiedBy?: string | undefined;
}

export interface AssessmentGenerationFieldDto {
    fieldName?: string | undefined;
    fieldDescription?: string | undefined;
    fieldType?: string | undefined;
    promptInstructions?: string | undefined;
    hasCustomPrompt: boolean;
    usesFollowupAnalysis: boolean;
    validValues?: AssessmentSelectOptionDto[] | undefined;
}

export interface AssessmentSelectOptionDto {
    key?: string | undefined;
    description?: string | undefined;
}

export interface GroupPromptDefaultsDto {
    groupId?: string | undefined;
    groupDisplayName?: string | undefined;
    fields?: FieldPromptDefaultDto[] | undefined;
}

export interface FieldPromptDefaultDto {
    fieldName?: string | undefined;
    fieldDescription?: string | undefined;
    defaultPromptInstructions?: string | undefined;
}

export interface CaseSupportAssessmentModel {
    assessmentId: string;
    createdOn: Date | string;
    createdBy?: string | undefined;
    status: AssessmentStatusDto;
    completionDate?: Date | string | undefined;
}

export interface PartialAssesmentTranscriptionDto {
    id: string;
    order: number;
    status?: string | undefined;
    transcriptionText?: string | undefined;
    createdAt: Date | string;
}

export interface FunctionalAbilityCatalogItem extends CodeListItem {
    mainTheme: MainTheme;
    mainThemeDescription?: string | undefined;
    subThemeDescription?: string | undefined;
    externalId: string;
}

export enum MainTheme {
    PhysicalFunctions = "physicalFunctions",
    MentalFunctions = "mentalFunctions",
    SocialRelations = "socialRelations",
    HealthRelations = "healthRelations",
    Surroundings = "surroundings",
    Relations = "relations",
    SocietalLife = "societalLife",
    Communication = "communication",
    PracticalTasks = "practicalTasks",
    SelfCare = "selfCare",
    Mobility = "mobility",
}

export interface AgendaPointModel {
    id: string;
    text: string;
    sortOrder: number;
    isGenerated: boolean;
    reasoning: string;
    agreementQuote: string;
    sources: string[];
    references: AgendaReferenceModel[];
}

export interface AgendaDataGapModel {
    kind: AgendaDataGapKind;
    description: string;
}

export enum AgendaDataGapKind {
    Truncated = "truncated",
    Unavailable = "unavailable",
    NotImplemented = "notImplemented",
}

export interface AgendaDataSourceModel {
    key: string;
    label: string;
}

export interface PlannedConversationModel {
    bookingId: string;
    label: string;
    state: AgendaConversationState;
}

export enum AgendaConversationState {
    Planned = "planned",
    Held = "held",
    Cancelled = "cancelled",
}

export interface SavedAgendaModel {
    id: string;
    bookingId: string;
    state: AgendaConversationState;
    isReadOnly: boolean;
    points: AgendaPointModel[];
}

export interface ResourceAction {
    resourceOperation?: string | undefined;
    resourceType?: string | undefined;
}

export interface ResourceAccess {
    resourceAction?: string | undefined;
    resourceType?: string | undefined;
}

export interface ResourceAccessCriteria {
    dataType?: string | undefined;
    dataIdentifier?: string | undefined;
    dataIdentifierType?: string | undefined;
}

export interface AttendanceParsingError {
    row: number;
    cpr?: string | undefined;
    citizenName?: string | undefined;
    errorMessage: string;
}

export interface CourseDtoEx extends CourseDto {
    companyName?: string | undefined;
    teamName?: string | undefined;
}

export interface CitizenAttendanceNoteModel {
    text?: string | undefined;
    modifiedOn: Date | string;
    modifiedBy: string;
    modifiedByName?: string | undefined;
}

export interface CitizenAttendanceStatisticsSummaryDto {
    onTimeCount: number;
    notOnTimeCount: number;
    notShownCount: number;
    absenceWithReasonCount: number;
    notRelevantCount: number;
    noShowFullDayCount: number;
    totalExpectedTimeInMinutes: number;
    totalActualTimeInMinutes: number;
}

export interface CitizenAttendanceStatisticsLessonModel {
    lessonId: string;
    courseId: string;
    courseName?: string | undefined;
    beginAt: Date | string;
    endAt: Date | string;
    category?: AttendanceStateDto | undefined;
    expectedTimeInMinutes: number;
    actualTimeInMinutes: number;
    startCheck?: AttendanceCheckpointModel | undefined;
    endCheck?: AttendanceCheckpointModel | undefined;
    isStartCheckEnabled: boolean;
    isEndCheckEnabled: boolean;
    hasDeviation: boolean;
    deviationComment?: string | undefined;
}

export interface AttendanceCheckpointModel {
    state: AttendanceStateDto;
    checkInTime?: Date | string | undefined;
    registeredBy: string;
    registeredByName?: string | undefined;
    registeredOn: Date | string;
    comment?: string | undefined;
}

export interface CitizenLessonDto {
    citizenLessonId: string;
    lessonId: string;
    courseEnrollmentId: string;
    citizenId: string;
    isDeleted: boolean;
}

export interface ClassroomDtoEx extends ClassroomDto {
    companyName?: string | undefined;
}

export interface CourseAttendanceStatisticsLessonModel {
    lessonId: string;
    courseId: string;
    courseName?: string | undefined;
    beginAt: Date | string;
    endAt: Date | string;
    expectedTimeInMinutes: number;
    actualTimeInMinutes: number;
}

export interface CourseEnrollmentActivityDto {
    activityId: string;
    title?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    caseId?: string | undefined;
    offerId?: string | undefined;
}

export interface CourseEnrollmentListDto {
    courseEnrollmentId: string;
    courseId: string;
    citizenId: string;
    caseId: string;
    beginAt: Date | string;
    endAt: Date | string;
    isActive: boolean;
    courseName: string;
}

export interface CourseEnrollmentLessonDto {
    courseEnrollmentId: string;
    caseId: string;
    lessonId: string;
    courseId: string;
    classroomName?: string | undefined;
    beginAt: Date | string;
    endAt: Date | string;
    courseName: string;
    lessonState: LessonStateDto;
    activityAddress?: ActivityAddressDto | undefined;
    attendanceSheetState?: AttendanceSheetStateDto | undefined;
    startCheck?: AttendanceCheckpointDto | undefined;
    endCheck?: AttendanceCheckpointDto | undefined;
}

export interface ActivityAddressDto {
    activityId: string;
    streetName: string;
    streetNumber: string;
    floor?: string | undefined;
    side?: string | undefined;
    zipCode: string;
    city: string;
}

export interface AttendanceCheckpointDto {
    state: AttendanceStateDto;
    checkInTime?: Date | string | undefined;
    registeredBy: string;
    registeredOn: Date | string;
    comment?: string | undefined;
}

export interface CourseListDto {
    courseId: string;
    companyId: string;
    offerId?: string | undefined;
    responsibleCaseworkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
    educatorIds: string[];
    educatorNames: string[];
    classroomId?: string | undefined;
    classroomName?: string | undefined;
    name: string;
    capacity?: number | undefined;
    isCompleted: boolean;
    hasCurrentLessons?: boolean | undefined;
    enrolledCount?: number | undefined;
    availableSeats?: number | undefined;
    lessonCount?: number | undefined;
}

export interface CourseListDtoEx extends CourseListDto {
    caseworkerName?: string | undefined;
    teamName?: string | undefined;
    offerTitle?: string | undefined;
}

export interface CourseOverviewDto extends CourseListDtoEx {
    companyName?: string | undefined;
}

export enum CourseFilterDto {
    Active = "active",
    All = "all",
    WithoutCurrentLessons = "withoutCurrentLessons",
    Mine = "mine",
}

export interface ConnectCourse {
    courseId: string;
    name: string;
    companyPNumber?: string | undefined;
    active: boolean;
}

export interface EducatorDtoEx extends EducatorDto {
    companyName?: string | undefined;
}

export interface LessonOccupancyDto {
    lessonId: string;
    beginAt: Date | string;
    endAt: Date | string;
    capacity: number;
    occupiedSeats: number;
}

export interface OccupiedDate {
    startDate: Date | string;
    endDate: Date | string;
    name?: string | undefined;
    occupationType: OccupationType;
}

export enum OccupationType {
    Holiday = "holiday",
    Lesson = "lesson",
    CenterClosedDay = "centerClosedDay",
}

export interface RegistrationCounterDetailsDto {
    registrationCounterId: string;
    name: string;
    companyId: string;
    externalReference?: string | undefined;
    isActivated: boolean;
    hasActivationKey: boolean;
}

export interface RegistrationCounterListDto {
    registrationCounterId: string;
    name: string;
    companyId: string;
    isActivated: boolean;
    lastRegistration?: Date | string | undefined;
    rejectedRegistrations: number;
    acceptedRegistrations: number;
    lastOnline?: Date | string | undefined;
    hasActivationKey: boolean;
    deviceId?: string | undefined;
    isDeleted: boolean;
    createdBy: string;
    createdOn: Date | string;
    externalReference?: string | undefined;
}

export interface RegistrationCounterListDtoEx extends RegistrationCounterListDto {
    companyName?: string | undefined;
    pUnit?: string | undefined;
    createdBy?: string | undefined;
}

export interface CitizenLessonAttendanceModel {
    citizenId: string;
    citizenName?: string | undefined;
    birthDate?: Date | string | undefined;
    primaryCaseworkerName?: string | undefined;
    lessonId: string;
    citizenEnrollmentId: string;
    startRegistration?: AttendanceRegistrationDto | undefined;
    endRegistration?: AttendanceRegistrationDto | undefined;
    lessonDeviationBeginAt?: Date | string | undefined;
    lessonDeviationEndAt?: Date | string | undefined;
    hasLessonDeviation: boolean;
    citizenLessonDeviationId?: string | undefined;
    lessonDeviationComment?: string | undefined;
    requiresStartCheck: boolean;
    requiresEndCheck: boolean;
    hasAbsence: boolean;
    absences?: AbsenceInLessonPeriodModel[] | undefined;
    hasInterview: boolean;
    interviews?: InterviewInLessonPeriodModel[] | undefined;
    internalNote?: CitizenAttendanceNoteModel | undefined;
}

export interface AbsenceInLessonPeriodModel {
    absenceTypeName?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    comment?: string | undefined;
}

export interface InterviewInLessonPeriodModel {
    interviewTypeName?: string | undefined;
    startDate: Date | string;
    endDate: Date | string;
}

export interface AiStandardQuestionDto {
    id: string;
    title?: string | undefined;
    topic?: string | undefined;
    area?: number | undefined;
    question?: string | undefined;
    isDraft?: boolean | undefined;
}

export enum CitationContentType {
    UserGuide = "userGuide",
    IaDocument = "iaDocument",
    LegalDocument = "legalDocument",
    MunicipalityAssistantDocuments = "municipalityAssistantDocuments",
}

export interface PromptExecutionSettingsDto {
    chatSystemPrompt?: string | undefined;
    temperature?: number | undefined;
    frequencyPenalty?: number | undefined;
    presencePenalty?: number | undefined;
    topP?: number | undefined;
    maxRagDocuments?: number | undefined;
    documentScoreThreshold?: number | undefined;
    modelType?: ModelType | undefined;
    autoInvokeFunctions?: boolean | undefined;
}

export enum ModelType {
    Default = "default",
    Large = "large",
}

export interface LanguageAssistResult {
    text: string;
    htmlMarkedTextChanges: string;
    changes: LanguageAssistTextChange[];
}

export interface LanguageAssistTextChange {
    modification: string;
    reason: string;
    reference: string;
}

export interface SmartGoalCriterion {
    criterion?: string | undefined;
    explanation?: string | undefined;
}

export interface LanguageInfo {
    code?: string | undefined;
    displayName?: string | undefined;
    locale?: string | undefined;
    voiceName?: string | undefined;
    nativeName?: string | undefined;
    englishName?: string | undefined;
    danishName?: string | undefined;
}

export interface TranslationProblem {
    name?: string | undefined;
    passage?: string | undefined;
}

export interface NotificationLogEntry {
    id: string;
    sentAt: Date | string;
    citizenId: string;
    cpr?: string | undefined;
    fullName?: string | undefined;
    app: NotificationApp;
    platform: NotificationPlatform;
    notificationType: NotificationType2;
    status: NotificationDeliveryStatus;
    failureReason?: string | undefined;
}

export enum NotificationApp {
    Forum = "forum",
    Sag = "sag",
    Viktor = "viktor",
}

export enum NotificationPlatform {
    Android = "android",
    Ios = "ios",
}

export enum NotificationType2 {
    ChatMessage = "chatMessage",
    News = "news",
    Survey = "survey",
}

export enum NotificationDeliveryStatus {
    Sent = "sent",
    RejectedByFirebase = "rejectedByFirebase",
    TechnicalError = "technicalError",
    NoRegisteredDevice = "noRegisteredDevice",
    AppDeletedOrTokenInvalid = "appDeletedOrTokenInvalid",
    NotificationsDisabled = "notificationsDisabled",
}

export interface ConfigurationChangeLogViewModel {
    configurationLogId: string;
    createdBy?: string | undefined;
    createdOn: Date | string;
    entity?: string | undefined;
    name?: string | undefined;
    entityId: string;
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export interface GetConfigurationChangelogsRequest2 {
    resultCount: number;
    fromDate?: Date | string | undefined;
    toDate?: Date | string | undefined;
    entity?: string | undefined;
}

export interface OtherCprInfo {
    cpr?: string | undefined;
    citizenId?: string | undefined;
}

export enum CitizenDeletionOrderStatus {
    Created = "created",
    SentToApproval = "sentToApproval",
    Approved = "approved",
    Completed = "completed",
    Cancelled = "cancelled",
    Processing = "processing",
    CompletedWithErrors = "completedWithErrors",
    CompletedWithWarnings = "completedWithWarnings",
    CancelledByCircuitBreaker = "cancelledByCircuitBreaker",
}

export interface CitizenDeletionOrderCitizen {
    id: string;
    citizenId: string;
    status: CitizenDeletionOrderItemStatus;
    errorMessage?: string | undefined;
    cpr?: string | undefined;
    fullName?: string | undefined;
}

export enum CitizenDeletionOrderItemStatus {
    Unprocessed = "unprocessed",
    Deleted = "deleted",
    Failed = "failed",
    NotFound = "notFound",
    Blocked = "blocked",
}

export interface CitizenDeletionOrderListItem {
    orderId: string;
    title?: string | undefined;
    status: CitizenDeletionOrderStatus;
    createdByFullname?: string | undefined;
    createdOn: Date | string;
    approvedByFullname?: string | undefined;
    approvedOn?: Date | string | undefined;
    citizensCount: number;
    isArchived: boolean;
}

export interface CitizenForDeletion {
    citizenId: string;
    cpr?: string | undefined;
    fullName?: string | undefined;
}

export interface GetAuditLogsResponse2 {
    auditLogs?: AuditLogModel[] | undefined;
}

export interface AuditLogModel {
    id: string;
    auditTime: Date | string;
    correlationIdentifier?: string | undefined;
    userId: string;
    userName: string;
    userIdentityFK?: string | undefined;
    operation: string;
    area?: string | undefined;
    message: string;
    additionalData?: string | undefined;
    citizens?: AuditCitizenModel[] | undefined;
    companies?: AuditCompanyModel[] | undefined;
    organizationalUnits?: AuditOrganizationalUnit[] | undefined;
    team?: AuditTeam | undefined;
    citizenAccessJustification?: string | undefined;
}

export interface AuditCitizenModel {
    id: string;
    cpr?: string | undefined;
    fullName?: string | undefined;
}

export interface AuditCompanyModel {
    id: string;
    cvr?: string | undefined;
    name?: string | undefined;
}

export interface AuditOrganizationalUnit {
    id: string;
    name?: string | undefined;
    rank: number;
}

export interface AuditTeam {
    id: string;
    name?: string | undefined;
}

export interface WhitelistedUser {
    userId: string;
    name?: string | undefined;
    email?: string | undefined;
    teamName?: string | undefined;
}

export interface OrganizationalUnit {
    id: string;
    name: string;
}

export interface SelectableTeam {
    teamId: string;
    name: string;
    mainTeamName?: string | undefined;
}

export interface SelectableGrantType {
    grantTypeId: string;
    name: string;
    categoryName: string;
    isActive: boolean;
}

export interface VisitationTeamListItem {
    id: string;
    teamId: string;
    name: string;
    mainTeamName?: string | undefined;
    grantTypeCount: number;
    nextMeetingStartAt?: Date | string | undefined;
    isActive: boolean;
}

export interface EditableUserDto {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    title?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    teamId?: string | undefined;
    teamName?: string | undefined;
    externalCompanyId?: string | undefined;
    hasJobEjerRole: boolean;
    hasFormidlingsansvarligRole: boolean;
    hasPlaceringsgodkenderRole: boolean;
    exemptFromAutomaticDeactivation: boolean;
    userIdentitySchultz?: string | undefined;
    userIdentityAdfs?: string | undefined;
    userIdentityFK?: string | undefined;
    userIdentityNemlogin?: string | undefined;
    latestLoginAt?: Date | string | undefined;
    lastActivatedAt?: Date | string | undefined;
    lastDeactivatedAt?: Date | string | undefined;
    mainTeamName: string;
    subjocenterName?: string | undefined;
    subjobcenterExternalId?: string | undefined;
    isActive: boolean;
    isRobotUser: boolean;
    latestLoginDetails?: string | undefined;
    isSystemUser: boolean;
    robotUserUserProfile?: string | undefined;
    nemLoginUserProfileId?: string | undefined;
    userIdentityNemloginCvr?: string | undefined;
    cpr?: string | undefined;
}

export interface ExternalOperatorCompanyViewModel {
    id: string;
    companyName?: string | undefined;
}

export interface UserDto {
    id: string;
    fullName: string;
    teamName: string;
    mainTeamName: string;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    latestLoginAt?: Date | string | undefined;
    isActive: boolean;
    userJobTitle?: string | undefined;
    userIdentitySchultz?: string | undefined;
    userIdentityAdfs?: string | undefined;
    userIdentityFk?: string | undefined;
    userIdentityNemlogin?: string | undefined;
    cpr?: string | undefined;
}

export interface UserPageRequestDto {
    pageSize: number;
    pageNumber: number;
}

export interface UserSortRequestDto {
    sortBy: string;
    sortDirection: string;
}

export interface UserFilterRequestDto {
    nameFilter?: string | undefined;
    teamNameFilter?: string | undefined;
    emailFilter?: string | undefined;
    phoneFilter?: string | undefined;
    titleFilter?: string | undefined;
    isActiveFilter?: boolean | undefined;
    identitySchultzFilter?: string | undefined;
    identityAdfsFilter?: string | undefined;
    identityFkFilter?: string | undefined;
    identityNemloginFilter?: string | undefined;
}

export interface UserProfileViewModel {
    id: string;
    adGroup?: string | undefined;
    displayName?: string | undefined;
    roles?: UserProfileRoleViewModel[] | undefined;
}

export interface QuestionnaireInitialData {
    pseudoFasitEntityTypes?: PseudoFasitEntityDiscriminatorViewModel[] | undefined;
    questionnaireTypes?: QuestionnaireTypeViewModel[] | undefined;
    questionTypes?: QuestionTypeViewModel[] | undefined;
    yesNoLayouts?: YesNoLayoutViewModel[] | undefined;
}

export interface QuestionnaireListViewItem {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    questionnaireType?: QuestionnaireTypeViewModel | undefined;
    pseudoFasitEntityDiscriminator?: PseudoFasitEntityDiscriminatorViewModel | undefined;
    numberOfCitizensSentTo: number;
    numberOfCitizensAnswered: number;
    isActive: boolean;
}

export interface GetSubJobcenterCodeListItem {
    id: string;
    externalCode?: string | undefined;
}

export interface GetSubJobcenterDetailsViewModel {
    id: string;
    name?: string | undefined;
    subJobcenterCodeListItem?: GetSubJobcenterCodeListItem | undefined;
    externalCode?: string | undefined;
    isActive: boolean;
    hasMainTeam: boolean;
    physicalAddress?: AddressViewModel | undefined;
    webAddress?: string | undefined;
    introductionText?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    physicalOpeningHoursMonday?: SubJobcenterOpeningHoursViewModel | undefined;
    physicalOpeningHoursTuesday?: SubJobcenterOpeningHoursViewModel | undefined;
    physicalOpeningHoursWednesday?: SubJobcenterOpeningHoursViewModel | undefined;
    physicalOpeningHoursThursday?: SubJobcenterOpeningHoursViewModel | undefined;
    physicalOpeningHoursFriday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursMonday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursTuesday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursWednesday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursThursday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursFriday?: SubJobcenterOpeningHoursViewModel | undefined;
    closedDays?: SubJobcenterClosedDayModel[] | undefined;
    holidays?: HolidayViewModel[] | undefined;
}

export interface AddressViewModel {
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    suiteIdentifier?: string | undefined;
    postCodeIdentifier?: string | undefined;
    districtName?: string | undefined;
    country?: CountryViewModel | undefined;
}

export interface SubJobcenterOpeningHoursViewModel {
    from?: string | undefined;
    to?: string | undefined;
    alsoFrom?: string | undefined;
    alsoTo?: string | undefined;
}

export interface HolidayViewModel {
    date: Date | string;
    name?: string | undefined;
}

export interface GetSubJobcenterModel {
    id: string;
    name?: string | undefined;
    isActive: boolean;
    externalCode?: string | undefined;
}

export interface CreateSubJobcenterModel {
    name?: string | undefined;
    codeListSubJobcenterId: string;
    physicalAddress?: AddressViewModel | undefined;
    webAddress?: string | undefined;
    introductionText?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    physicalOpeningHoursMonday?: SubJobcenterOpeningHoursViewModel | undefined;
    physicalOpeningHoursTuesday?: SubJobcenterOpeningHoursViewModel | undefined;
    physicalOpeningHoursWednesday?: SubJobcenterOpeningHoursViewModel | undefined;
    physicalOpeningHoursThursday?: SubJobcenterOpeningHoursViewModel | undefined;
    physicalOpeningHoursFriday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursMonday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursTuesday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursWednesday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursThursday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursFriday?: SubJobcenterOpeningHoursViewModel | undefined;
}

export interface UpdateSubJobcenterModel {
    id: string;
    name?: string | undefined;
    codeListSubJobcenterId: string;
    physicalAddress?: AddressViewModel | undefined;
    webAddress?: string | undefined;
    introductionText?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    physicalOpeningHoursMonday?: SubJobcenterOpeningHoursViewModel | undefined;
    physicalOpeningHoursTuesday?: SubJobcenterOpeningHoursViewModel | undefined;
    physicalOpeningHoursWednesday?: SubJobcenterOpeningHoursViewModel | undefined;
    physicalOpeningHoursThursday?: SubJobcenterOpeningHoursViewModel | undefined;
    physicalOpeningHoursFriday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursMonday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursTuesday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursWednesday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursThursday?: SubJobcenterOpeningHoursViewModel | undefined;
    telephoneOpeningHoursFriday?: SubJobcenterOpeningHoursViewModel | undefined;
}

export interface UpdateSubJobcenterStateModel {
    id: string;
    isActive: boolean;
}

export interface ActivationTypeCodeListModel {
    id: string;
    name?: string | undefined;
}

export interface AssociateUserRoleCodeListModel {
    associateUserRoleId?: string | undefined;
    name?: string | undefined;
}

export interface AdminTargetGroupModel {
    id: string;
    targetGroupNumber?: number | undefined;
    name?: string | undefined;
    contactGroupName?: string | undefined;
}

export interface CourseTypeCodeListModel {
    id: string;
    name?: string | undefined;
}

export interface DebitorAccountTypeOption {
    id: string;
    name?: string | undefined;
}

export interface JobcenterLookupModel {
    jobcenterId: string;
    name?: string | undefined;
    isActive: boolean;
    externalIdentifier?: string | undefined;
}

export interface MetadataEntityCodeListModel {
    id: string;
    name?: string | undefined;
    active: boolean;
    entityLogicalName?: string | undefined;
}

export interface OfferTypeCodeListModel {
    id: string;
    name?: string | undefined;
    allowReimbursement?: boolean | undefined;
    allowTransportReimbursementOption?: number | undefined;
    applicableForPlacements?: boolean | undefined;
    applicableForSicknessBenefit?: boolean | undefined;
    category?: number | undefined;
    codeListHealthActivityTypeId?: string | undefined;
    codeListMentorId?: string | undefined;
    codeListSocialActivityTypeId?: string | undefined;
    courseTypeId?: string | undefined;
    daysBeforePlacementEndDate?: number | undefined;
    includeInWeeklyPlacementHours?: boolean | undefined;
    isEmployerTypeRequired?: boolean | undefined;
    placementPurposeRequiredOnPlacement?: boolean | undefined;
    placementPurposeRequiredOnRecruitmentRequ?: boolean | undefined;
    typeCode?: number | undefined;
    stateCode?: number | undefined;
    activationTypeIdentifier?: string | undefined;
}

export interface DfdgPlanTypeModel {
    id: string;
    name?: string | undefined;
}

export interface PurposeOfCompanyInternshipTypeCodeListModel {
    id: string;
    name?: string | undefined;
}

export interface RemovalCauseTypeLookupModel {
    id: string;
    name?: string | undefined;
    isActive: boolean;
}

export interface ResponsibilityAreaModel {
    responsibilityAreaId: string;
    name?: string | undefined;
    description?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface StandardAppendixLookupModel {
    standardAppendixId: string;
    name?: string | undefined;
}

export interface TargetGroupCodeListModel {
    id: string;
    name?: string | undefined;
    contactGroup?: string | undefined;
    number?: number | undefined;
}

export interface TaskCategoryCodeListModel {
    id: string;
    name?: string | undefined;
    active: boolean;
    entityLogicalName?: string | undefined;
}

export interface TaskConfigurationCodeListModel {
    id: string;
    name?: string | undefined;
    active: boolean;
    entityName?: string | undefined;
}

export interface ObservationTypeModel {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    category: ObservationCategory;
    dataType: ObservationDataType;
    unit?: string | undefined;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    reflectionFieldMode: ObservationFieldMode;
    timeFieldMode: ObservationFieldMode;
    standardTexts?: string[] | undefined;
    serviceProviderUnitIds?: string[] | undefined;
    isActive: boolean;
    createdOn: Date | string;
    createdBy: string;
    createdByDisplayName?: string | undefined;
    modifiedOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedByDisplayName?: string | undefined;
}

export interface MethodTypeViewModel {
    id?: string | undefined;
    name?: string | undefined;
    isActive: boolean;
    description?: string | undefined;
    abbreviation?: string | undefined;
    classification?: string | undefined;
    classificationCode?: string | undefined;
    createdOn: Date | string;
    createdByDisplayName?: string | undefined;
    createdBy: string;
    modifiedOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedByDisplayName?: string | undefined;
}

export interface JournalNoteContentTypeListModelV3 {
    journalNoteContentTypeId: string;
    name: string;
    code?: number | undefined;
    isActive: boolean;
    noteTypes: JournalNoteContentTypeNoteType[];
    applicableToJournalNoteOptics?: string[] | undefined;
    municipalitySpecific?: boolean | undefined;
    createdOn: Date | string;
    createdByDisplayName?: string | undefined;
    modifiedOn?: Date | string | undefined;
    modifiedByDisplayName?: string | undefined;
}

export interface InterviewTypeModel {
    id?: string | undefined;
    name?: string | undefined;
    isActive: boolean;
    description?: string | undefined;
    createdOn: Date | string;
    modifiedOn?: Date | string | undefined;
    createdBy: string;
    createdByDisplayName?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedByDisplayName?: string | undefined;
    interviewTypeCode: number;
    templateMappingName?: string | undefined;
    reportAsDfdgSamtaleTypeCode?: number | undefined;
    journalNoteContentTypeId?: string | undefined;
    isDfdgSamtaleType: boolean;
    caseTypeListItems?: CaseTypeListItemModel[] | undefined;
}

export interface JournalNoteContentTypeViewModel {
    id: string;
    isActive: boolean;
    name?: string | undefined;
    identification: number;
}

export interface GrantTypesInitialData {
    categories?: GrantTypeCategoryViewModel[] | undefined;
    reportAs?: GrantTypeReportAsViewModel[] | undefined;
    benefitTypesFFB?: BenefitTypeFFB[] | undefined;
    benefitTypesDST?: BenefitTypeDST[] | undefined;
    offerSelectionModes?: OfferSelectionModeViewModel[] | undefined;
    lawReferences?: GrantTypeLawReferenceViewModel[] | undefined;
    validFfbOfferBenefitCombinations?: FfbOfferBenefitCombination[] | undefined;
}

export interface FfbOfferBenefitCombination {
    offerExternalId: string;
    benefitExternalIds?: string[] | undefined;
}

export interface GrantTypeListViewItem {
    grantTypeId: string;
    name?: string | undefined;
    category?: GrantTypeCategoryViewModel | undefined;
    isActive: boolean;
    socialOffer?: GrantTypeSocialOfferFFBViewModel | undefined;
    benefitTypes?: GrantTypeBenefitTypeViewModel[] | undefined;
    reportAs?: GrantTypeReportAsViewModel | undefined;
    createdOn: Date | string;
    createdBy?: string | undefined;
    modifiedOn?: Date | string | undefined;
    modifiedBy?: string | undefined;
    displayName?: string | undefined;
    processingDeadlineDays?: number | undefined;
    lawReference?: GrantTypeLawReferenceViewModel | undefined;
    paragraph?: string | undefined;
    subsection?: number | undefined;
    articleNumber?: number | undefined;
    requiresHearing?: boolean | undefined;
    requiresAssessment?: boolean | undefined;
    canBeGrantedByServiceProvider?: boolean | undefined;
}

export interface OfferListViewItem {
    offerId: string;
    offerNumber?: number | undefined;
    title?: string | undefined;
    type?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
}

export interface AdminCoPaymentCitizenModel {
    cprNumber?: string | undefined;
    citizenName?: string | undefined;
}

export interface AdminReceivableDetailsModel {
    receivable?: AdminReceivableSummaryModel | undefined;
    financeDocuments?: AdminFinanceDocumentDetailModel[] | undefined;
    dispatchAttempts?: AdminDebitorRegistrationTransactionModel[] | undefined;
}

export interface AdminReceivableSummaryModel {
    id: string;
    coPaymentId: string;
    activityId: string;
    receivableIdentifier?: string | undefined;
    cprNumber?: string | undefined;
    citizenName?: string | undefined;
    month?: string | undefined;
    billableFrom: Date | string;
    startDate: Date | string;
    endDate: Date | string;
    dueDate?: Date | string | undefined;
    originationDate?: Date | string | undefined;
    receivableAmount: number;
    firstBillingAdjustment?: number | undefined;
    lastBillingAdjustment?: number | undefined;
    description?: string | undefined;
    debitorAccountIdentifier?: string | undefined;
    dispatchStatus?: string | undefined;
    coPaymentType?: string | undefined;
    template?: string | undefined;
    billingType?: string | undefined;
    billingPrinciple?: string | undefined;
    receivableType?: string | undefined;
    debitorAccountType?: string | undefined;
    adjustedByAdjustmentId?: string | undefined;
}

export interface AdminFinanceDocumentDetailModel {
    id: string;
    period?: string | undefined;
    bookingDate: Date | string;
    status?: string | undefined;
    postings?: AdminFinancePostingModel[] | undefined;
    deliveryStatuses?: AdminFinanceDeliveryStatusModel[] | undefined;
    currentTransactionId?: string | undefined;
    isAwaitingReceipt: boolean;
    hasReceipt: boolean;
    canRedeliver: boolean;
}

export interface AdminFinancePostingModel {
    id: string;
    coPaymentReceivableId: string;
    receivableSortOrder: number;
    side?: string | undefined;
    amount: number;
    valueDate: Date | string;
    servicePeriodStart: Date | string;
    servicePeriodEnd: Date | string;
    text?: string | undefined;
    receivableReference?: string | undefined;
    account?: string | undefined;
    art?: string | undefined;
    ownership?: string | undefined;
}

export interface AdminFinanceDeliveryStatusModel {
    status?: string | undefined;
    occurredAt: Date | string;
    explanation?: string | undefined;
    statusApplied: boolean;
    errors?: string[] | undefined;
}

export enum CoPaymentDispatchBucket {
    ReadyForDispatch = "readyForDispatch",
    Failed = "failed",
    Future = "future",
    All = "all",
}

export interface AdminCoPaymentOverviewItemModel {
    coPaymentId: string;
    activityId: string;
    coPaymentTypeId: string;
    cprNumber?: string | undefined;
    citizenName?: string | undefined;
    description?: string | undefined;
    startDate: Date | string;
    endDate: Date | string;
    amount: number;
    billingPrinciple?: BillingPrinciple | undefined;
}

export interface AdminDebitorRegistrationContentModel {
    transactionId: string;
    transactionIdentifier: string;
    registrationXml?: string | undefined;
}

export interface AdminFinanceDeliveryContentModel {
    transactionId: string;
    sequenceNumber: number;
    dataFileName?: string | undefined;
    deliveryContent?: string | undefined;
    receipts?: AdminFinanceReceiptContentModel[] | undefined;
}

export interface AdminFinanceReceiptContentModel {
    kind?: string | undefined;
    fileName?: string | undefined;
    receivedAt: Date | string;
    content?: string | undefined;
}

export interface AssessmentPromptForAdmin {
    fieldName: string;
    fieldDescription: string;
    defaultPrompt: string;
    customPrompt?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedOn?: Date | string | undefined;
    version?: string | undefined;
    perspective: string;
    generationSource: string;
    appliedRules: string;
}

export interface DialogSupportInstructionPrompt {
    id: string;
    name?: string | undefined;
    content?: string | undefined;
    isActive: boolean;
    createdOn: Date | string;
    modifiedOn: Date | string;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
}

export interface DialogSupportConfigurationMetadata {
    createdOn?: Date | string | undefined;
    createdByName?: string | undefined;
    modifiedOn?: Date | string | undefined;
    modifiedByName?: string | undefined;
}

export interface DialogPromptTargetGroup {
    id: string;
    name?: string | undefined;
}

export interface DialogPromptInterviewType {
    code: number;
    name?: string | undefined;
    isActive: boolean;
}

export interface UserDefinedPrompt {
    id: string;
    name?: string | undefined;
    targetGroupId: string;
    interviewType: number;
    content?: string | undefined;
    isActive: boolean;
    createdOn: Date | string;
    modifiedOn: Date | string;
    modifiedByName?: string | undefined;
}

export interface DefaultPrompt {
    name?: string | undefined;
    content?: string | undefined;
    targetGroupId: string;
    interviewType: number;
}

export interface InterviewConfiguration {
    id: string;
    targetGroupId: string;
    interviewType: number;
    disableJournalNoteSummary: boolean;
    createdOn: Date | string;
    modifiedOn: Date | string;
    modifiedByName?: string | undefined;
}

export interface DefaultTerm {
    term?: string | undefined;
    explanation?: string | undefined;
    category: number;
    doNotTranslate: boolean;
}

export interface MunicipalityTerm {
    id: string;
    term?: string | undefined;
    explanation?: string | undefined;
    category: number;
    doNotTranslate: boolean;
    isActive: boolean;
}

export interface MunicipalityAssistantDocumentModel {
    id: string;
    title?: string | undefined;
    description?: string | undefined;
    identifier?: string | undefined;
    mimeType?: string | undefined;
    fileName?: string | undefined;
    createdAt: Date | string;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedAt?: Date | string | undefined;
    modifiedBy?: string | undefined;
    modifiedByName?: string | undefined;
    deletedOn?: Date | string | undefined;
}

export interface QueuePartialTranscriptionRequestV2 {
    audioBytes?: string | undefined;
    sessionId?: string | undefined;
    order: number;
    language?: string | undefined;
}

export interface CreateQuestionnaireForFasitEntityRequest {
    questionnaireId: string;
    fasitEntityId: string;
    pseudoFasitEntityDiscriminator: PseudoFasitEntityDiscriminator;
}

export interface AttachUseOfForceReportActionPlanRequest {
    serviceProviderUnitId: string;
    reportId: string;
    citizenId: string;
    file: UseOfForceUploadedFile;
}

export interface CreateUseOfForceReportRequest {
    serviceProviderUnitId: string;
    header: UseOfForceReportHeaderModel;
    incidentIds: string[];
}

export interface DeleteUseOfForceReportDraftRequest {
    serviceProviderUnitId: string;
    reportId: string;
}

export interface RegisterUseOfForceReportSendingRequest {
    serviceProviderUnitId: string;
    reportId: string;
    sentToSupervisionAt?: Date | string | undefined;
    operatorInformedAt?: Date | string | undefined;
}

export interface RemoveUseOfForceReportActionPlanRequest {
    serviceProviderUnitId: string;
    reportId: string;
    actionPlanId: string;
}

export interface UpdateUseOfForceReportRequest {
    serviceProviderUnitId: string;
    reportId: string;
    header: UseOfForceReportHeaderModel;
    incidentIds: string[];
}

export interface CancelServiceProviderUnitCalendarEventRequest {
    serviceProviderUnitId: string;
    eventId: string;
    comment?: string | undefined;
    consumedMinutes?: number | undefined;
}

export interface CancelServiceProviderUnitCalendarSeriesOccurrenceRequest {
    serviceProviderUnitId: string;
    seriesId: string;
    occurrenceStartAt: Date | string;
    comment?: string | undefined;
    consumedMinutes?: number | undefined;
}

export interface CreateServiceProviderUnitCalendarEventRequest {
    serviceProviderUnitId: string;
    title: string;
    locationAddress: string;
    responsibleUserId?: string | undefined;
    startAt: Date | string;
    endAt: Date | string;
    allDay: boolean;
    content?: string | undefined;
    recurrence?: RecurrencePatternModel | undefined;
    noteTypeId?: string | undefined;
}

export interface DeleteServiceProviderUnitCalendarEventRequest {
    serviceProviderUnitId: string;
    eventId: string;
}

export interface DeleteServiceProviderUnitCalendarSeriesOccurrenceRequest {
    serviceProviderUnitId: string;
    seriesId: string;
    occurrenceStartAt: Date | string;
}

export interface MarkServiceProviderUnitCalendarEventDoneRequest {
    serviceProviderUnitId: string;
    eventId: string;
    comment?: string | undefined;
    consumedMinutes?: number | undefined;
}

export interface MarkServiceProviderUnitCalendarSeriesOccurrenceDoneRequest {
    serviceProviderUnitId: string;
    seriesId: string;
    occurrenceStartAt: Date | string;
    comment?: string | undefined;
    consumedMinutes?: number | undefined;
}

export interface UnmarkServiceProviderUnitCalendarEventRequest {
    serviceProviderUnitId: string;
    eventId: string;
}

export interface UpdateServiceProviderUnitCalendarEventRequest {
    serviceProviderUnitId: string;
    eventId: string;
    title: string;
    locationAddress: string;
    responsibleUserId?: string | undefined;
    startAt: Date | string;
    endAt: Date | string;
    allDay: boolean;
    content?: string | undefined;
    consumedMinutes?: number | undefined;
    recurrence?: RecurrencePatternModel | undefined;
    noteTypeId?: string | undefined;
}

export interface UpdateServiceProviderUnitCalendarSeriesOccurrenceRequest {
    serviceProviderUnitId: string;
    seriesId: string;
    occurrenceStartAt: Date | string;
    title: string;
    locationAddress: string;
    responsibleUserId?: string | undefined;
    startAt: Date | string;
    endAt: Date | string;
    allDay: boolean;
    content?: string | undefined;
    consumedMinutes?: number | undefined;
}

export interface CancelOutboxItemsRequest {
    outboxItems?: OutboxItemEntityInfoUpdateModel[] | undefined;
    reason: string;
}

export interface ManuallySentOutboxItemsRequest {
    outboxItems?: OutboxItemEntityInfoUpdateModel[] | undefined;
}

export interface ResendOutboxItemsRequest {
    outboxItems?: OutboxItemEntityInfoUpdateModel[] | undefined;
    citizenIds?: string[] | undefined;
}

export interface CreateTeamRequest {
    team?: TeamCreateModel | undefined;
}

export interface SetTeamStateRequest {
    teamId: string;
    isActive: boolean;
}

export interface UpdateTeamRequest {
    team?: TeamUpdateModel | undefined;
}

export interface CreateCoPaymentRequest {
    activityId: string;
    coPaymentTypeId: string;
    description?: string | undefined;
    amount: number;
    billingType: BillingType;
    billingPrinciple?: BillingPrinciple | undefined;
    startDate: Date | string;
    endDate: Date | string;
    firstBillingAdjustment: number;
    lastBillingAdjustment: number;
    precedingCoPaymentId?: string | undefined;
    paragraph107?: CreateCoPaymentParagraph107Request | undefined;
    paragraph108?: CreateCoPaymentParagraph108Request | undefined;
}

export interface RectifyCoPaymentRequest {
    coPaymentId: string;
    fingerprint?: string | undefined;
    payload?: CoPaymentRectificationPayload | undefined;
}

export interface AddCitizenToWaitingListRequest {
    offerId: string;
    citizenId: string;
    caseId: string;
}

export interface ApproveActivityRequest {
    activityId: string;
    citizenId: string;
}

export interface AssignResponsibleCaseworkerRequest {
    offerIds?: string[] | undefined;
    responsibleUserId?: string | undefined;
    responsibleTeamId: string;
}

export interface AttachVitasAllocationRequest {
    activityId: string;
    citizenId: string;
    vitasAllocationId: string;
}

export interface CancelActivityRequest {
    activityId: string;
    citizenId: string;
    activityStatusTypeIdentifier: number;
    endDate?: Date | string | undefined;
    activityStatusCauseType?: ActivityStatusCauseTypeModel | undefined;
    negativeEventTypeIdentifier?: string | undefined;
    causeRemark?: string | undefined;
    commentForResponsibleCaseworker?: string | undefined;
    targetGroupId?: string | undefined;
    reject: boolean;
}

export interface CitizenJobcenterTransferRequest {
    citizenId: string;
}

export interface CreateActivationLevelRequest {
    citizenId: string;
    activationLevel?: ActivationLevelModel | undefined;
}

export interface CreateActivityRequest extends CreateActivityRequestBase {
}

export interface CreateActivityPriceCorrectionRequest {
    activityId: string;
    amount: number;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    note?: string | undefined;
}

export interface CreateEvaluationRequest {
    activityId: string;
    evaluationText?: string | undefined;
    type: number;
    citizenId: string;
}

export interface CreateOfferRequest extends CreateOfferRequestBase {
}

export interface CreateOfferGroupRequest {
    offerGroupIdentifier?: string | undefined;
    name?: string | undefined;
    active: boolean;
}

export interface CreateOfferResourceRequest {
    offerId: string;
    organizationUserId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    weeklyCapacityHours: number;
    weeklyCapacityMinutes: number;
}

export interface CreateReimbursementRequest {
    activityId: string;
    citizenId: string;
    title?: string | undefined;
    startDate: Date | string;
    endDate: Date | string;
    reimbursementType: number;
    periodic: boolean;
    prePayed: boolean;
    amount?: number | undefined;
    description?: string | undefined;
    isExpenseDueToDisability?: boolean | undefined;
    isTransportReimbursementManualEntered?: boolean | undefined;
    isIncludingFerry?: boolean | undefined;
    dailyTransportInKilometers?: number | undefined;
    workDays?: number | undefined;
    actualExpense?: number | undefined;
    totalReimbursement?: number | undefined;
}

export interface DeleteActivationLevelRequest {
    citizenId: string;
    activationLevelId: string;
    comment: string;
}

export interface DeleteActivityRequest {
    activityId: string;
    citizenId: string;
}

export interface DeleteActivityPriceCorrectionRequest {
    activityId: string;
    activityPriceCorrectionId: string;
}

export interface DeleteEvaluationRequest {
    evaluationId: string;
    activityId: string;
    citizenId: string;
    correctionComment?: string | undefined;
}

export interface DeleteOfferDraftByIdRequest {
    offerId: string;
}

export interface DeleteOfferResourceRequest {
    offerId: string;
    offerResourceId: string;
}

export interface DeleteReimbursementRequest {
    reimbursementId: string;
    activityId: string;
    citizenId: string;
}

export interface DeleteUpcomingOfferPriceRequest {
    request?: DeleteUpcomingOfferPriceRequestModel | undefined;
}

export interface SendActivityLetterRequest {
    activityLetterCitizenRequest?: SendActivityLetterCitizenRequest | undefined;
    acitivityCompanyLetterRequest?: SendAcitivityCompanyLetterRequest | undefined;
}

export interface UpsertActivityResourceAllocationsRequest {
    activityId: string;
    allocations?: ActivityResourceAllocationItem[] | undefined;
}

export interface UpdateActivationLevelRequest {
    activationLevel?: ActivationLevelDto | undefined;
}

export interface UpdateActivityRequest extends UpdateActivityRequestBase {
}

export interface UpdatePlacementPriceRequest {
    request?: UpdatePlacementPriceRequestModel | undefined;
}

export interface UpdateActivityPriceCorrectionRequest {
    activityId: string;
    activityPriceCorrectionId: string;
    amount: number;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    note?: string | undefined;
}

export interface UpdateEvaluationRequest {
    evaluationId: string;
    activityId: string;
    evaluationText?: string | undefined;
    citizenId: string;
    correctionComment?: string | undefined;
}

export interface UpdateOfferRequest extends UpdateOfferRequestBase {
}

export interface UpdateOfferGroupRequest {
    offerGroupId: string;
    offerGroupIdentifier?: string | undefined;
    name?: string | undefined;
    active: boolean;
}

export interface UpdateOfferPriceRequest {
    request?: UpdateOfferPriceRequestModel | undefined;
}

export interface UpdateOfferResourceRequest {
    offerId: string;
    offerResourceId: string;
    organizationUserId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    weeklyCapacityHours: number;
    weeklyCapacityMinutes: number;
    isActive?: boolean | undefined;
}

export interface UpdateOfferStatusRequest {
    offerId: string;
    offerStatus: number;
}

export interface UpdateReimbursementRequest {
    reimbursementId: string;
    activityId: string;
    citizenId: string;
    startDate: Date | string;
    endDate: Date | string;
    periodic: boolean;
    prePayed: boolean;
    amount?: number | undefined;
    actualExpense?: number | undefined;
    description?: string | undefined;
    isExpenseDueToDisability?: boolean | undefined;
    isTransportReimbursementManualEntered?: boolean | undefined;
    isIncludingFerry?: boolean | undefined;
    dailyTransportInKilometers?: number | undefined;
    workDays?: number | undefined;
    totalReimbursement?: number | undefined;
}

export interface UpdateReimbursementEndDatesRequest {
    citizenId: string;
    activityId: string;
    reimbursementIds?: string[] | undefined;
    endDate: Date | string;
}

export interface UpdateUpcomingOfferPriceRequest {
    request?: UpdateUpcomingOfferPriceRequestModel | undefined;
}

export interface UpdateWaitingListSeatRequest {
    citizenId: string;
    waitingListSeatId: string;
    addedOn: Date | string;
    addedBy: string;
    status: WaitingListSeatStatus;
    comment?: string | undefined;
}

export interface JournalizeIncomingMailByCitizenRequest {
    taskId: string;
    caseId?: string | undefined;
    serviceProviderUnitId?: string | undefined;
    assignmentId?: string | undefined;
    citizenId: string;
    content?: string | undefined;
    eventDate: Date | string;
    title?: string | undefined;
    documents?: JobcenterTaskDocumentForIncomingMail[] | undefined;
    sentDate?: string | undefined;
}

export interface JournalizeIncomingMailByCompanyRequest {
    taskId: string;
    companyId: string;
    contactPersonId?: string | undefined;
    title?: string | undefined;
    note?: string | undefined;
    dueDate: Date | string;
    documents?: string[] | undefined;
}

export interface RejectedIncomingMailTaskRequest {
    taskId: string;
}

export interface CompleteGeneralTaskRequest {
    taskId: string;
}

export interface JournalizeGeneralTaskOnCitizenRequest {
    citizenId: string;
    taskId: string;
    caseId?: string | undefined;
    content?: string | undefined;
    eventDate: Date | string;
    title?: string | undefined;
    sentDate?: string | undefined;
}

export interface JournalizeGeneralTaskOnCompanyRequest {
    taskId: string;
    content?: string | undefined;
    eventDate: Date | string;
    title?: string | undefined;
    contactPersonId?: string | undefined;
    companyId: string;
}

export interface ReopenGeneralTaskRequest {
    taskId: string;
}

export interface UpdateGeneralTaskRequest {
    taskId: string;
    title?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | string | undefined;
    responsibleCaseWorkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
}

export interface CompleteTasksRequest {
    taskIds?: string[] | undefined;
}

export interface ReassignTasksRequest {
    taskIds?: string[] | undefined;
    responsibleTeamId?: string | undefined;
    responsibleCaseWorkerId?: string | undefined;
}

export interface CloseJobAdRequestV2 {
    externalJobAdId: string;
}

export interface CreateJobAdRequestV2 {
    jobAd?: JobAdEditViewModelV2 | undefined;
}

export interface DeleteJobAdRequestV2 {
    externalJobAdId: string;
}

export interface UpdateJobAdRequestV2 {
    jobAd?: JobAdEditViewModelV2 | undefined;
}

export interface AddChatRequest {
    title?: string | undefined;
    citizenExternalId: string;
    contactExternalIds?: string[] | undefined;
    caseId: string;
    initialMessageContent?: string | undefined;
    isConfidential: boolean;
    attachments?: NewChatAttachmentModel[] | undefined;
}

export interface AddNewsItemRecipientsRequest {
    newsItemId: string;
    citizenIds?: string[] | undefined;
}

export interface CloseChatRequest {
    chatId: string;
    citizenId: string;
}

export interface CloseNewsItemRequest {
    newsItemId: string;
}

export interface CreateCaseworkerAbsenceRequest {
    startDate: Date | string;
    endDate?: Date | string | undefined;
    text?: string | undefined;
    caseworkerId?: string | undefined;
}

export interface CreateChatMessageRequest {
    chatId: string;
    citizenId: string;
    content?: string | undefined;
    attachment?: ChatMessageAttachmentModel | undefined;
}

export interface CreateNewsItemRequest {
    title?: string | undefined;
    content?: string | undefined;
    url?: string | undefined;
    showFromDate: Date | string;
    expirationDate?: Date | string | undefined;
    showToAll: boolean;
    journalize: boolean;
    enableShowInterest: boolean;
    attachments?: NewsAttachmentUploadModel[] | undefined;
}

export interface DeleteCaseworkerAbsenceRequest {
    absenceId: string;
    caseworkerId?: string | undefined;
}

export interface DeleteChatMessageRequest {
    chatId: string;
    messageId: string;
    citizenId: string;
}

export interface DeleteNewsItemRequest {
    newsItemId: string;
}

export interface JournalizeChatRequest {
    chatId: string;
    citizenId: string;
}

export interface NudgeCitizensWithQuestionnaireRequest {
    citizenIds?: string[] | undefined;
    questionnaireId: string;
    pseudoFasitEntityDiscriminator: PseudoFasitEntityDiscriminatorEnum;
    fasitEntityId?: string | undefined;
}

export interface RenameChatMessageAttachmentRequest {
    chatId: string;
    messageId: string;
    citizenId: string;
    filename?: string | undefined;
}

export interface UpdateCaseworkerAbsenceRequest {
    absenceId: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    text?: string | undefined;
    caseworkerId?: string | undefined;
}

export interface UpdateChatTitleRequest {
    chatId: string;
    citizenId: string;
    title?: string | undefined;
}

export interface UpdateCitizenCanCreateChatsRequest {
    citizenId: string;
    canCreateChats: boolean;
}

export interface UpdateNewsItemRequest {
    newsItemId: string;
    title?: string | undefined;
    content?: string | undefined;
    url?: string | undefined;
    showFromDate: Date | string;
    expirationDate?: Date | string | undefined;
    existingAttachmentIds?: string[] | undefined;
    attachments?: NewsAttachmentUploadModel[] | undefined;
}

export interface UpdateNewsItemRecipientsRequest {
    newsItemId: string;
    citizenIds?: string[] | undefined;
}

export interface ActivateOrDeactivateExternalOperatorCompanyRequest {
    externalOperatorCompanyId: string;
    isActive: boolean;
}

export interface CancelReferralRequest {
    cancelReason: string;
    referralId: string;
}

export interface CreateAgreementRequest {
    agreementModel?: CreateAgreementModel | undefined;
}

export interface CreateExternalOperatorCompanyRequest {
    companyId: string;
    cvrNumber?: string | undefined;
    pNumber?: string | undefined;
    teamId: string;
}

export interface CreateReferralRequest {
    referralModel?: CreateReferralModel | undefined;
    letterInformation?: LetterInformation | undefined;
    createFromActivity: boolean;
}

export interface UpdateAgreementRequest {
    agreementModel?: AgreementModel | undefined;
}

export interface UpdateAgreementCompanyRequest {
    agreementId: string;
    externalOperatorCompanyId: string;
    comment: string;
}

export interface UpdateAgreementResponsibilityAreasRequest {
    agreementId: string;
    responsibilityAreaIds?: string[] | undefined;
}

export interface UpdateExternalOperatorCompanyRequest {
    externalOpreatorCompanyId: string;
    teamId: string;
}

export interface UpdateReferralRequest {
    referral?: ReferralModel | undefined;
}

export interface ShipFilingDeliveryRequest {
    filingDeliveryId: string;
}

export interface StartFilingDeliveryRequest {
    filingType: FilingType;
}

export interface DeleteTradeCodesRequest {
    companyId: string;
    origin: TradeCodeOrigin;
    tradeCodes?: string[] | undefined;
}

export interface UpsertTradeCodesRequest {
    companyId: string;
    origin: TradeCodeOrigin;
    tradeCodes?: string[] | undefined;
}

export interface DeleteTagRequest {
    id: string;
}

export interface UpsertTagRequest {
    tag: UpsertTagModel;
}

export interface UpsertTagsRequest {
    companyIds?: string[] | undefined;
    tag?: UpsertTagsModel | undefined;
}

export interface DeleteSpecialCircumstanceRequest {
    id: string;
}

export interface DeleteSpecialCircumstanceTargetGroupRequest {
    id: string;
}

export interface UpsertTaskSpecialCircumstanceRequest {
    upsertedSpecialCircumstance?: SpecialCircumstanceDto | undefined;
    temporaryFileIds?: string[] | undefined;
    secondaryTargetGroupIds?: string[] | undefined;
}

export interface UpsertSpecialCircumstanceTargetGroupRequest {
    specialCircumstanceTargetGroup?: SpecialCircumstanceTargetGroupDto | undefined;
}

export interface UpsertSpecialCircumstanceTargetGroupsRequest {
    specialCircumstanceTargetGroup?: SpecialCircumstanceTargetGroupDto[] | undefined;
}

export interface LinkCompanyNoteToJournalNoteRequest {
    companyNoteId: string;
    journalNoteId: string;
    citizenId: string;
}

export interface QueueCompanyDialogPartialTranscriptionRequest {
    audioBytes?: string | undefined;
    sessionId: string;
    order: number;
    language?: string | undefined;
    companyId: string;
}

export interface UpsertCompanyContactPersonRequest {
    contactPersonDto?: CompanyContactPersonDetailsDto | undefined;
}

export interface UpsertPrivateContactPersonRequest {
    contactPersonDto?: PrivateContactPersonDetailsDto | undefined;
}

export interface CompleteCompanyTaskRequest {
    taskId: string;
}

export interface CompleteCompanyTasksRequest {
    taskIds?: string[] | undefined;
}

export interface CreateCompanyTaskRequest {
    title?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | string | undefined;
    companyId: string;
    responsibleCaseWorkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
    caseId?: string | undefined;
    relatedCitizenId?: string | undefined;
    repetition?: Repetition | undefined;
}

export interface JournalizeCompanyTaskOnCitizenRequest {
    citizenId: string;
    taskId: string;
    caseId?: string | undefined;
    content?: string | undefined;
    eventDate: Date | string;
    title?: string | undefined;
    sentDate?: string | undefined;
}

export interface JournalizeCompanyTaskOnCompanyRequest {
    taskId: string;
    content?: string | undefined;
    eventDate: Date | string;
    title?: string | undefined;
    contactPersonId?: string | undefined;
    companyId: string;
}

export interface ReassignCompanyTasksRequest {
    taskIds?: string[] | undefined;
    responsibleTeamId?: string | undefined;
    responsibleCaseWorkerId?: string | undefined;
}

export interface ReopenCompanyTaskRequest {
    taskId: string;
}

export interface UpdateCompanyTaskRequest {
    taskId: string;
    title?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | string | undefined;
    responsibleCaseWorkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
    caseId?: string | undefined;
    repetition?: Repetition | undefined;
}

export interface SendLetterToCompaniesRequest {
    companyIds: string[];
    templateId: number;
    variantId?: number | undefined;
    outgoingDocumentTypeId?: string | undefined;
    outgoingDocumentTypeName?: string | undefined;
    attachments?: string[] | undefined;
    letterTitle: string;
    letterContent: string;
    journalNote?: string | undefined;
    caseWorkerId: string;
    interactionResultId?: string | undefined;
    interactionPurposeResultId?: string | undefined;
}

export interface SendCompanyLetterRequest {
    templateId: number;
    outgoingDocumentTypeId?: string | undefined;
    outgoingDocumentTypeName?: string | undefined;
    attachments?: string[] | undefined;
    letterHeadline?: string | undefined;
    letterContent?: string | undefined;
    contactPersonId?: string | undefined;
    companyNoteTitle?: string | undefined;
    companyNote?: string | undefined;
    interactionResultId?: string | undefined;
    interactionPurposeId?: string | undefined;
    caseWorkerId?: string | undefined;
    caseWorkerAdvis: boolean;
    recipientCompanyId: string;
    recipientName?: string | undefined;
    recipientAddress?: string | undefined;
    recipientPostalCode?: string | undefined;
    recipientCountryCode?: string | undefined;
    recipientCity?: string | undefined;
    recipientCvrNumber?: string | undefined;
    recipientAttention?: string | undefined;
    renderTemplateVariables?: RenderTemplateVariablesDto | undefined;
}

export interface DeleteAssociatedCaseWorkerForCompanyRequest {
    id: string;
    companyId: string;
}

export interface UpsertAssociatedCaseWorkerRequest {
    id?: string | undefined;
    caseWorkerId: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    description?: string | undefined;
    role?: string | undefined;
    isResponsibleCaseworker: boolean;
    companyId: string;
}

export interface BulkCompleteAppointmentsRequest {
    appointmentIds?: string[] | undefined;
}

export interface AssignCaseWorkerToCompanyAppointmentsRequest {
    appointmentIds?: string[] | undefined;
    responsibleTeamId?: string | undefined;
    responsibleCaseWorkerId?: string | undefined;
}

export interface CreateAttachmentsRequest {
    recruitmentId: string;
    companyRecruitmentAttachments?: CompanyRecruitmentDetailsAttachment[] | undefined;
}

export interface CreateCandidateRequest {
    candidateId: string;
    recruitmentId: string;
    candidateUrl?: string | undefined;
    comment?: string | undefined;
    name?: string | undefined;
    personCivilRegistrationIdentifier?: string | undefined;
}

export interface CreateCandidateReferralsRequest {
    citizenId: string;
    companyRecruitmentRequestIds?: string[] | undefined;
}

export interface CreateCandidatesFromSmartMatchRequest {
    recruitmentId: string;
    candidateCollection?: CreateCandidateListItem[] | undefined;
}

export interface CreateCompanyRecruitmentRequest {
    companyInformation?: CompanyInformation | undefined;
    basicInformationJobOffer?: BasicInformationJobOffer | undefined;
    jobPositionResponsibility?: JobPositionResponsibility | undefined;
    responsibleJobcenter?: JobcenterInfoDto | undefined;
    showRecruitmentRequestOnCitizenPortal: boolean;
}

export interface DeleteAttachmentsRequest {
    companyRecruitmentAttachmentIds?: string[] | undefined;
}

export interface SynchronizeCompanyRecruitmentFromDfdgRequest {
    companyRecruitmentId: string;
}

export interface UpdateCandidateRequest {
    id: string;
    comment?: string | undefined;
    url?: string | undefined;
    status: number;
    correctionComment?: string | undefined;
}

export interface UpdateCandidatesRequest {
    candidateCollection?: UpdateCandidateRequestItem[] | undefined;
}

export interface UpdateCompanyRecruitmentRequest {
    model?: CompanyRecruitmentDetailsViewModel | undefined;
}

export interface CreateCitizenRequest {
    cpr?: string | undefined;
}

export interface CreateCompanyRequest {
    productionUnitIdentifier?: string | undefined;
}

export interface CreateDashboardRequest {
    name?: string | undefined;
    description?: string | undefined;
    sections?: DashboardSection[] | undefined;
    tags?: string[] | undefined;
    dashboardCategory?: SavedDashboardCategory | undefined;
}

export interface CreateWorklistAccessControlRequest {
    worklistAccessControls?: WorklistAccessControl[] | undefined;
}

export interface DeleteDashboardRequest {
    savedDashboardId: string;
}

export interface DeleteWorklistAccessControlRequest {
    worklistAccessControlsToDelete?: WorklistAccessControlToDelete[] | undefined;
}

export interface DeleteWorklistElementsRequest {
    elements?: WorklistElementToDelete[] | undefined;
}

export interface HandleFavoriteDashboardRequest {
    savedDashboardId: string;
    isFavorite: boolean;
}

export interface UpdateDashboardRequest {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    tags?: string[] | undefined;
    sections?: DashboardSection[] | undefined;
    dashboardCategory?: SavedDashboardCategory | undefined;
}

export interface UpdateDashboardStartpageRequest {
    savedDashboardId: string;
}

export interface UpdateFavoriteDashboardRequest {
    savedDashboardId: string;
}

export interface UpdateSavedChartOwnerRequest {
    savedChartId: string;
    newOwnerId: string;
}

export interface UpdateSavedDashboardOwnerRequest {
    savedDashboardId: string;
    newOwnerId: string;
}

export interface UpdateSavedQueryOwnerRequest {
    savedQueryId: string;
    newOwnerId: string;
}

export interface UpdateWorklistAccessControlRequest {
    worklistAccessControlsToUpdate?: WorklistAccessControlToUpdate[] | undefined;
}

export interface CreateClosedSdpCaseAnalysisRequest {
    caseId: string;
    analysisResult?: string | undefined;
    wasInputCondensed: boolean;
    modelDeploymentName?: string | undefined;
}

export interface GrantUseOfForceAuthorizationRequestRequest {
    citizenId: string;
    requestId: string;
    periodFrom: Date | string;
    periodTo: Date | string;
}

export interface RegisterUseOfForceAuthorizationRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    authorizationType: UseOfForceAuthorizationType;
    periodFrom: Date | string;
    periodTo: Date | string;
}

export interface RejectUseOfForceAuthorizationRequestRequest {
    citizenId: string;
    requestId: string;
}

export interface RevokeUseOfForceAuthorizationRequest {
    citizenId: string;
    authorizationId: string;
}

export interface AssessUseOfForceFormRequest {
    citizenId: string;
    assessmentId: string;
    remarks: string;
    requiresDecisionChange: boolean;
}

export interface CreateNuphRequest {
    nuph?: NuphModel | undefined;
}

export interface CreateNuphDocumentsRequest {
    nuphId: string;
    citizenId: string;
    documents?: DocumentArchiveDocument[] | undefined;
}

export interface CreateNuphFollowUpRequest {
    additionalRequestResponseType: NuphAdditionalRequestResponseType;
    citizenId: string;
    nuphId: string;
    additionalRequestText?: string | undefined;
}

export interface UpdateCitizenParticipationChoiceCommand {
    citizenId: string;
    citizenWantUnemploymentFundParticipation: boolean;
}

export interface UpdateNuphRequest {
    nuph?: NuphModel | undefined;
}

export interface UpdateUnemploymentParticipationFirstInterviewCommand {
    citizenId: string;
    citizenWantUnemploymentFundParticipationInFirstJobInterview: boolean;
}

export interface WithdrawNuphRequest {
    citizenId: string;
    nuphId: string;
    correctionComment?: string | undefined;
}

export interface WithdrawNuphDocumentRequest {
    citizenId: string;
    nuphDocumentId: string;
    correctionComment?: string | undefined;
}

export interface CancelScreeningRequest {
    citizenId: string;
    screeningId: string;
    reason?: string | undefined;
}

export interface StartScreeningRequest {
    citizenId: string;
    screeningConfigurationId: string;
}

export interface CloseProgressionSurveyRequest {
    surveyId: string;
    citizenId: string;
}

export interface GetHoiPrimaryTeamForCitizenRequest {
    citizenId: string;
}

export interface GetHoiActivitiesForCitizenRequest {
    citizenId: string;
}

export interface GetHoiTeamByUserIdRequest {
    userId: string;
}

export interface ExecuteNexusImportRequest {
    citizenId: string;
    caseId: string;
    selectedReferenceIds?: number[] | undefined;
    selectedContacts?: NexusContactSelectionModel[] | undefined;
}

export interface ExecuteNexusServiceProviderImportRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    assignmentId?: string | undefined;
    selectedReferenceIds?: number[] | undefined;
    partialObjectiveSelections?: NexusPartialObjectiveSelectionModel[] | undefined;
}

export interface StartHoiRequest {
    citizenId: string;
    citizenConsent?: CitizenConsentDto | undefined;
    citizenCurrentSituation?: CitizenCurrentSituationDto | undefined;
    assessment?: AssessmentDto | undefined;
    jobCenterInformation?: JobCenterInformationDto | undefined;
    hoiCaseLetter?: HoiCaseLetterDto | undefined;
}

export interface CreatePartialRecoveryRequest {
    partialRecovery?: CreatePartialRecoveryModel | undefined;
}

export interface DeletePartialRecoveryRequest {
    partialRecoveryId: string;
    citizenId: string;
    comment?: string | undefined;
}

export interface UpdatePartialRecoveryRequest {
    partialRecovery?: PartialRecoveryModel | undefined;
}

export interface CancelMissingParticipationRequest {
    missingParticipationId: string;
    cancellationReason?: string | undefined;
}

export interface CreateMissingParticipationRequest {
    citizenId: string;
    missingParticipation?: MissingParticipationCreateModel | undefined;
    letterInformation?: LetterInformation2 | undefined;
    renderTemplateVariables?: RenderTemplateVariables | undefined;
    templateCode?: string | undefined;
}

export interface FinishMissingParticipationRequest {
    citizenId: string;
    missingParticipation?: MissingParticipationModel | undefined;
    letterInformation?: LetterInformation2 | undefined;
    renderTemplateVariables?: RenderTemplateVariables | undefined;
    templateCode?: string | undefined;
}

export interface SendMissingParticipationNotificationToKsdRequest {
    missingParticipationId: string;
    paymentStopDate: Date | string;
}

export interface CreateExpectedJobResumptionRequest {
    expectedJobResumption?: CreateExpectedJobResumptionModel | undefined;
}

export interface DeleteExpectedJobResumptionRequest {
    expectedJobResumptionId: string;
    citizenId: string;
    comment?: string | undefined;
}

export interface UpdateExpectedJobResumptionRequest {
    expectedJobResumption?: UpdateExpectedJobResumptionModel | undefined;
}

export interface SyncSicknessBenefitInformationsRequest {
    caseId: string;
}

export interface CancelBenefitExtensionAssessmentRequest {
    benefitExtensionAssessmentId: string;
    citizenId: string;
    cancellationReason?: string | undefined;
}

export interface CreateAssessmentRequest_ {
    citizenId: string;
    benefitExtensionAssessmentId: string;
    extensionReasonId: string;
}

export interface CreateBenefitExtensionAssessmentRequest {
    model?: CreateBenefitExtensionAssessmentModel | undefined;
}

export interface FinishBenefitExtensionAssessmentHearingRequest {
    citizenId: string;
    benefitExtensionAssessmentId: string;
    isHearingReplyReceived: boolean;
    hearingReplyDate?: Date | string | undefined;
    commentFromCitizen?: string | undefined;
    assessmentAfterHearingReply?: string | undefined;
    maintainDecision: boolean;
}

export interface StartBenefitExtensionAssessmentHearingRequest {
    citizenId: string;
    benefitExtensionAssessmentId: string;
    deadlineForPartyReplyDate: Date | string;
    hearingStartDate: Date | string;
}

export interface UpdateBenefitExtensionAssessmentRequest {
    benefitExtensionAssessmentId: string;
    caseworkerId: string;
    followupDate?: Date | string | undefined;
    extensionStartDate: Date | string;
    isRetired: boolean;
    employerGetsReimbursement: boolean;
    extensionReasonId?: string | undefined;
    description?: string | undefined;
    comment?: string | undefined;
    isSicknessPeriodExtended?: boolean | undefined;
}

export interface ApproveUseOfForceHygieneRestraintLogRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    logId: string;
}

export interface ApproveUseOfForceIncidentRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    incidentId: string;
    leaderSection: UseOfForceLeaderSectionModel;
}

export interface ApproveUseOfForceSummaryRegistrationRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    registrationId: string;
    draft: UseOfForceSummaryRegistrationDraftModel;
}

export interface AttachUseOfForceCitizenStatementRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    incidentId: string;
    file: UseOfForceUploadedFile;
}

export interface AttachUseOfForceSummaryRegistrationCitizenStatementRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    registrationId: string;
    file: UseOfForceUploadedFile;
}

export interface CancelUseOfForceIncidentRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    incidentId: string;
    reason: string;
}

export interface CorrectUseOfForceHygieneRestraintRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    logId: string;
    restraintId: string;
    startedAt: Date | string;
    endedAt: Date | string;
    employeeName: string;
}

export interface CreateUseOfForceAuthorizationRequestRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface CreateUseOfForceIncidentRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    assignmentId?: string | undefined;
}

export interface CreateUseOfForceSummaryRegistrationRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    authorizationId: string;
}

export interface DeleteUseOfForceAuthorizationRequestDraftRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    requestId: string;
}

export interface DeleteUseOfForceIncidentDraftRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    incidentId: string;
}

export interface DeleteUseOfForceSummaryRegistrationDraftRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    registrationId: string;
}

export interface RegisterServiceProviderUseOfForceAuthorizationRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    authorizationType: UseOfForceAuthorizationType;
    periodFrom: Date | string;
    periodTo: Date | string;
}

export interface RegisterUseOfForceAuthorizationRequestDecisionRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    requestId: string;
    granted: boolean;
    periodFrom?: Date | string | undefined;
    periodTo?: Date | string | undefined;
}

export interface RegisterUseOfForceAuthorizationRequestMunicipalitySendingRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    requestId: string;
    sentAt: Date | string;
}

export interface RegisterUseOfForceHygieneRestraintRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    startedAt: Date | string;
    endedAt: Date | string;
    employeeName: string;
}

export interface RegisterUseOfForceHygieneRestraintLogMunicipalitySendingRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    logId: string;
    sentAt: Date | string;
}

export interface RegisterUseOfForceRelativesInformationRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    incidentId: string;
    informedOn?: Date | string | undefined;
    notInformed: boolean;
}

export interface RegisterUseOfForceResponsibleMunicipalitySendingRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    incidentId: string;
    sentAt: Date | string;
}

export interface RegisterUseOfForceSummaryRegistrationMunicipalitySendingRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    registrationId: string;
    sentAt: Date | string;
}

export interface RegisterUseOfForceSummaryRegistrationOperatorInformationRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    registrationId: string;
    informedOn: Date | string;
}

export interface RegisterUseOfForceSummaryRegistrationRelativesInformationRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    registrationId: string;
    informedOn?: Date | string | undefined;
    notInformed: boolean;
}

export interface RegisterUseOfForceSummaryRegistrationSupervisionSendingRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    registrationId: string;
    sentAt: Date | string;
}

export interface RemoveUseOfForceCitizenStatementRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    incidentId: string;
    statementId: string;
}

export interface RemoveUseOfForceHygieneRestraintRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    logId: string;
    restraintId: string;
}

export interface RemoveUseOfForceSummaryRegistrationCitizenStatementRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    registrationId: string;
    statementId: string;
}

export interface ReturnUseOfForceIncidentRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    incidentId: string;
    comment: string;
}

export interface RevokeServiceProviderUseOfForceAuthorizationRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    authorizationId: string;
}

export interface SendUseOfForceAuthorizationRequestRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    requestId: string;
    draft: UseOfForceAuthorizationRequestDraftModel;
}

export interface SubmitUseOfForceIncidentRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    incidentId: string;
    draft: UseOfForceIncidentDraftModel;
}

export interface UpdateUseOfForceAuthorizationRequestDraftRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    requestId: string;
    draft: UseOfForceAuthorizationRequestDraftModel;
}

export interface UpdateUseOfForceIncidentDraftRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    incidentId: string;
    draft: UseOfForceIncidentDraftModel;
}

export interface UpdateUseOfForceIncidentLeaderSectionRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    incidentId: string;
    leaderSection: UseOfForceLeaderSectionModel;
}

export interface UpdateUseOfForceSummaryRegistrationDraftRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    registrationId: string;
    draft: UseOfForceSummaryRegistrationDraftModel;
}

export interface UpsertTrafficLightAssessmentRequest {
    citizenId?: CitizenId | undefined;
    serviceProviderUnitId?: ServiceProviderUnitId | undefined;
    zone: TrafficLightZone;
    observation?: string | undefined;
}

export interface UpsertTrafficLightCitizenInvolvementRequest {
    citizenId: CitizenId;
    serviceProviderUnitId: ServiceProviderUnitId;
    citizenInvolved: boolean;
    citizenWishesAndStrategies?: string | undefined;
}

export interface UpsertTrafficLightGreenZoneRequest {
    citizenId: CitizenId;
    serviceProviderUnitId: ServiceProviderUnitId;
    citizenIndicators?: string | undefined;
    whatHelps?: string | undefined;
    staffShouldDo?: string | undefined;
    staffShouldAvoid?: string | undefined;
}

export interface UpsertTrafficLightRedZoneRequest {
    citizenId: CitizenId;
    serviceProviderUnitId: ServiceProviderUnitId;
    citizenIndicators?: string | undefined;
    whatHelps?: string | undefined;
    staffShouldDo?: string | undefined;
    staffShouldAvoid?: string | undefined;
    typicalTriggers?: string | undefined;
    safetyMeasures?: string | undefined;
    whoToContact?: string | undefined;
    debrief?: string | undefined;
}

export interface UpsertTrafficLightYellowZoneRequest {
    citizenId: CitizenId;
    serviceProviderUnitId: ServiceProviderUnitId;
    citizenIndicators?: string | undefined;
    whatHelps?: string | undefined;
    staffShouldDo?: string | undefined;
    staffShouldAvoid?: string | undefined;
    typicalTriggers?: string | undefined;
}

export interface SendMessageToAuthorityRequest {
    assignmentId?: AssignmentId | undefined;
    messageToAuthority?: string | undefined;
}

export interface CreateActivityForAssignmentRequest {
    citizenId: string;
    offerId: string;
    serviceProviderUnitId?: string | undefined;
    companyId?: string | undefined;
    serviceProviderUnitName?: string | undefined;
}

export interface CreateAssignmentAsServiceProviderRequest {
    assignment?: CreateAssignmentAsServiceProviderModel | undefined;
    activityOfferId?: string | undefined;
    citizenCpr?: string | undefined;
}

export interface CreateServiceProviderAssignmentRequest {
    citizenId: string;
    activityId: string;
    assignment: CreateAssignmentAsServiceProviderModel;
}

export interface EnsureCitizenForAssignmentRequest {
    citizenCpr: string;
}

export interface ReceiveAssignmentRequest {
    assignmentId?: AssignmentId | undefined;
    receivedByUserId?: UserId | undefined;
    receivedAt: Date | string;
    citizenDescription?: string | undefined;
    distributionStatus?: AssignmentDistributionStatus | undefined;
    messageToAuthority?: string | undefined;
}

export interface CreateObservationRequest {
    citizenId: string;
    assignmentId?: string | undefined;
    serviceProviderUnitId: string;
    observationTypeId: string;
    observedOn: Date | string;
    observedByUserId: string;
    numericValue?: number | undefined;
    booleanValue?: boolean | undefined;
    textValue?: string | undefined;
    reflection?: string | undefined;
    problemAreaCodes?: ProblemAreaCode[] | undefined;
}

export interface DeleteObservationRequest {
    observationId: string;
}

export interface UpdateObservationRequest {
    observationId: string;
    observedOn: Date | string;
    observedByUserId: string;
    numericValue?: number | undefined;
    booleanValue?: boolean | undefined;
    textValue?: string | undefined;
    reflection?: string | undefined;
    problemAreaCodes?: ProblemAreaCode[] | undefined;
}

export interface ApproveDoubleControlRequest {
    citizenId: string;
    administrationId: string;
}

export interface ApproveMedicineInventoryMovementDoubleControlRequest {
    citizenId: string;
    movementId: string;
}

export interface ChangeMedicineInventoryPackageStatusRequest {
    citizenId: string;
    packageId: string;
    targetStatus: PackageStatus;
    reason?: string | undefined;
}

export interface CountMedicineInventoryRequest {
    citizenId: string;
    drugMedicationId: string;
    unit: MedicineUnit;
    countedPackages: CountedPackage[];
    reason?: string | undefined;
    awaitingDoubleControl: boolean;
    controlledBy?: string | undefined;
    declarationConfirmed: boolean;
}

export interface DiscardFromMedicineInventoryPackageRequest {
    citizenId: string;
    packageId: string;
    quantity: number;
    reason?: string | undefined;
    awaitingDoubleControl: boolean;
    controlledBy?: string | undefined;
    declarationConfirmed: boolean;
}

export interface RecordPnEffectAssessmentRequest {
    citizenId: string;
    administrationId: string;
    assessmentText?: string | undefined;
}

export interface RegisterMedicineAdministrationRequest {
    citizenId: string;
    drugMedicationId: string;
    status: MedicineAdministrationStatus;
    actualTime: Date | string;
    unit: MedicineUnit;
    plannedTime?: string | undefined;
    actualDose?: number | undefined;
    waste?: number | undefined;
    deviationReason?: string | undefined;
    pnReason?: string | undefined;
    fmkOverrideReason?: string | undefined;
    awaitingDoubleControl: boolean;
    controlledBy?: string | undefined;
    declarationConfirmed: boolean;
    sevenRightsConfirmed: boolean;
    preferredPackageId?: string | undefined;
    packageDeviationReason?: string | undefined;
    otherSourceReason?: string | undefined;
}

export interface RegisterMedicineInventoryControlSheetDownloadRequest {
    citizenId: string;
    drugMedicationId: string;
    unit: MedicineUnit;
    fromDay: string;
    toDay: string;
    packageId?: string | undefined;
}

export interface ReturnFromMedicineInventoryPackageRequest {
    citizenId: string;
    packageId: string;
    quantity: number;
    reason?: string | undefined;
    returnedTo?: string | undefined;
    awaitingDoubleControl: boolean;
    controlledBy?: string | undefined;
    declarationConfirmed: boolean;
}

export interface SetMedicineInventoryPackageBatchAndExpiryRequest {
    citizenId: string;
    packageId: string;
    batchNumber?: string | undefined;
    expiryYear: number;
    expiryMonth: number;
}

export interface SetMedicineInventoryPackageLocationRequest {
    citizenId: string;
    packageId: string;
    location?: string | undefined;
}

export interface AddOtcMedicationRequest {
    citizenId: string;
    drugName: string;
    strength?: string | undefined;
    form?: string | undefined;
    indication?: string | undefined;
    atcCode?: string | undefined;
    activeSubstance?: string | undefined;
    articleNumber?: string | undefined;
    dosageText?: string | undefined;
    medicineType: MedicineType;
    administrationPeriods: AdministrationPeriodViewModel[];
    dispensingForm?: DispensingForm | undefined;
    depotQuantity: number;
    depotUnit: MedicineUnit;
}

export interface CreateMedicineCardForCitizenRequest {
    citizenId: string;
    privacyConsentDeclared: boolean;
    registeredFromUnitId?: string | undefined;
    consentGivenBy?: PrivacyConsentGivenBy | undefined;
    consentForm?: PrivacyConsentForm | undefined;
}

export interface DeleteMedicineCardForCitizenRequest {
    citizenId: string;
}

export interface RegisterMedicineCardPrivacyConsentRequest {
    citizenId: string;
    registeredFromUnitId?: string | undefined;
    givenBy?: PrivacyConsentGivenBy | undefined;
    form?: PrivacyConsentForm | undefined;
}

export interface RevokeMedicineCardPrivacyConsentRequest {
    citizenId: string;
    note: string;
}

export interface SeponerOtcMedicationRequest {
    citizenId: string;
    drugMedicationId?: string | undefined;
    reason?: string | undefined;
}

export interface SynchronizeMedicineCardFromFmkRequest {
    citizenId: string;
    serviceProviderUnitId?: string | undefined;
}

export interface UpdateOperationalDetailsRequest {
    citizenId: string;
    drugMedicationId: string;
    administrationPeriods: AdministrationPeriodViewModel[];
    pnInstruction?: string | undefined;
    dispensingForm?: DispensingForm | undefined;
    markedForDoubleCheck?: boolean | undefined;
}

export interface CreateInterventionObjectiveStatusRequest {
    citizenId: CitizenId;
    assignmentId: AssignmentId;
    interventionObjectiveId?: InterventionObjectiveId | undefined;
    statusText: string;
    statusRichText: string;
    shouldContinue: boolean;
    recommendNewAssessment: boolean;
    recommendationRemarks: string;
    functionalAbilityIds?: string[] | undefined;
}

export interface AssessHealthConditionRequest {
    citizenId: CitizenId;
    serviceProviderUnitId: ServiceProviderUnitId;
    code: HealthConditionCode;
    status: HealthConditionStatus;
    assessmentDate: Date | string;
    assessmentText?: string | undefined;
    followUpDate?: Date | string | undefined;
    concurrencyStamp?: string | undefined;
}

export interface AssessProblemAreaRequest {
    citizenId: CitizenId;
    serviceProviderUnitId: ServiceProviderUnitId;
    code: ProblemAreaCode;
    status: ProblemAreaStatus;
    assessmentDate: Date | string;
    assessmentText?: string | undefined;
    followUpDate?: Date | string | undefined;
    concurrencyStamp?: string | undefined;
}

export interface SetAssignmentDistributionRequest {
    assignmentId?: AssignmentId | undefined;
    activityId: string;
    distributionStatus: AssignmentDistributionStatus;
    isFullyAllocated: boolean;
    allocations?: AllocationItem[] | undefined;
}

export interface UpdateServiceProviderCitizenNotesRequest {
    citizenId: CitizenId;
    serviceProviderUnitId: ServiceProviderUnitId;
    note?: string | undefined;
    obsNote1?: string | undefined;
    obsNote1ExpiresOn?: Date | string | undefined;
    obsNote2?: string | undefined;
    obsNote2ExpiresOn?: Date | string | undefined;
}

export interface SetServiceProviderCitizenDescriptionRequest {
    citizenId: string;
    serviceProviderCitizenDescription?: string | undefined;
}

export interface CancelServiceProviderCalendarEventRequest {
    citizenId: string;
    eventId: string;
    comment?: string | undefined;
    consumedMinutes?: number | undefined;
}

export interface CancelServiceProviderCalendarSeriesOccurrenceRequest {
    citizenId: string;
    seriesId: string;
    occurrenceStartAt: Date | string;
    comment?: string | undefined;
    consumedMinutes?: number | undefined;
}

export interface CreateServiceProviderCalendarEventRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    title: string;
    locationAddress: string;
    startAt: Date | string;
    endAt: Date | string;
    allDay: boolean;
    content?: string | undefined;
    responsibleUserId?: string | undefined;
    consumedMinutes?: number | undefined;
    partialObjectiveId?: string | undefined;
    recurrence?: RecurrencePatternModel | undefined;
    noteTypeId?: string | undefined;
    observationTypeId?: string | undefined;
}

export interface CreateServiceProviderFollowupFromEventRequest {
    citizenId: string;
    eventId: string;
    progression: number;
    description?: string | undefined;
    methodType?: string | undefined;
}

export interface DeleteServiceProviderCalendarEventRequest {
    citizenId: string;
    eventId: string;
}

export interface DeleteServiceProviderCalendarSeriesOccurrenceRequest {
    citizenId: string;
    seriesId: string;
    occurrenceStartAt: Date | string;
}

export interface MarkServiceProviderCalendarEventDoneRequest {
    citizenId: string;
    eventId: string;
    comment?: string | undefined;
    consumedMinutes?: number | undefined;
}

export interface MarkServiceProviderCalendarSeriesOccurrenceDoneRequest {
    citizenId: string;
    seriesId: string;
    occurrenceStartAt: Date | string;
    comment?: string | undefined;
    consumedMinutes?: number | undefined;
}

export interface UnmarkServiceProviderCalendarEventRequest {
    citizenId: string;
    eventId: string;
}

export interface UpdateServiceProviderCalendarEventRequest {
    citizenId: string;
    eventId: string;
    title: string;
    locationAddress: string;
    startAt: Date | string;
    endAt: Date | string;
    allDay: boolean;
    content?: string | undefined;
    responsibleUserId: string;
    consumedMinutes?: number | undefined;
    recurrence?: RecurrencePatternModel | undefined;
    noteTypeId?: string | undefined;
}

export interface UpdateServiceProviderCalendarSeriesOccurrenceRequest {
    citizenId: string;
    seriesId: string;
    occurrenceStartAt: Date | string;
    title: string;
    locationAddress: string;
    startAt: Date | string;
    endAt: Date | string;
    allDay: boolean;
    content?: string | undefined;
    responsibleUserId?: string | undefined;
    consumedMinutes?: number | undefined;
}

export interface AddPartialObjectiveFollowupFromStoryRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    partialObjectiveId: string;
    progression: number;
    description: string;
    eventDate: Date | string;
}

export interface RegisterAppealsBoardReplyRequest {
    rulingId: string;
    complaintId: string;
    decision: AppealsBoardDecision;
    receivedAt: Date | string;
    appealsBoardReplyJournalNoteId: string;
}

export interface RegisterComplaintRequest {
    rulingId: string;
    complaintGrantIds?: string[] | undefined;
    complaintSubjectRemark?: string | undefined;
    receivedAt: Date | string;
    receivedForm: ComplaintReceivedForm;
    citizenComplaintJournalNoteId: string;
}

export interface RegisterForwardToAppealsBoardRequest {
    rulingId: string;
    complaintId: string;
    forwardedAt: Date | string;
}

export interface RegisterReassessmentOutcomeRequest {
    rulingId: string;
    complaintId: string;
    outcome: ReassessmentOutcome;
    decidedAt: Date | string;
    reasoning?: string | undefined;
}

export interface RegisterWithdrawalRequest {
    rulingId: string;
    complaintId: string;
    withdrawnAt: Date | string;
}

export interface CancelRulingContinuationRequest {
    rulingId: string;
    continuationId: string;
}

export interface CancelRulingVisitationBookingRequest {
    rulingId: string;
}

export interface CompleteHearingRequest {
    rulingId: string;
    hearingSubmissionReceived: HearingSubmissionReceivedOptions;
    hearingSubmissionReceivedAt?: Date | string | undefined;
    hearingSubmissionJournalNoteIds?: string[] | undefined;
    hearingCitizenComment?: string | undefined;
}

export interface CompleteRulingContinuationRequest {
    rulingId: string;
    continuationId: string;
    followUpPerformedAt?: Date | string | undefined;
    followUpSummary?: string | undefined;
    followUpSummaryPlainText?: string | undefined;
    nextFollowUpDate?: Date | string | undefined;
}

export interface CreateRecommendationRequest {
    rulingId: string;
    recommendation: string;
    recommendationPlainText?: string | undefined;
    grantIds: string[];
    intakeUserId?: string | undefined;
    intakeTeamId?: string | undefined;
    intakePlannedAt?: Date | string | undefined;
    internalRecommendation?: string | undefined;
    visitationBooking?: VisitationBookingTargetModel | undefined;
}

export interface CreateRulingContinuationRequest {
    rulingId: string;
}

export interface CreatingRulingRequest {
    newRuling?: CreateRulingDto | undefined;
}

export interface DecideRulingRequest {
    rulingId: string;
    applicationOrRulingConcerning?: string | undefined;
    overallRulingResult?: string | undefined;
    grantResult?: GrantResultOptions | undefined;
    rulingDecidedAt?: Date | string | undefined;
    rulingReasoning?: string | undefined;
    rulingReasoningPlainText?: string | undefined;
    grantIds?: string[] | undefined;
}

export interface MoveRulingVisitationBookingRequest {
    rulingId: string;
    target: VisitationBookingTargetModel;
}

export interface RegisterContinuationVisitationAssessmentRequest {
    rulingId: string;
    continuationId: string;
    visitationAssessment: VisitationDecision;
    visitationComment?: string | undefined;
}

export interface SetContinuationLetterSentRequest {
    rulingId: string;
    continuationId: string;
}

export interface SetRulingDecisionLetterSentRequest {
    rulingId: string;
}

export interface SetRulingHearingLetterSentRequest {
    rulingId: string;
}

export interface SetRulingNotificationLetterSentRequest {
    rulingId: string;
}

export interface StartHearingRequest {
    rulingId: string;
    hearingStartedAt: Date | string;
    hearingSubmissionDeadlineAt: Date | string;
    hearingDecisionRemark?: string | undefined;
    grantIds?: string[] | undefined;
}

export interface SubmitContinuationToVisitationRequest {
    rulingId: string;
    continuationId: string;
    intakeUserId?: string | undefined;
    intakeTeamId?: string | undefined;
    intakePlannedAt?: Date | string | undefined;
}

export interface TerminateRulingRequest {
    rulingId: string;
    reasonForTermination: ReasonForTerminationOptions;
    terminationExplanation?: string | undefined;
}

export interface UpdateRulingRequest {
    ruling?: UpdateRulingDto | undefined;
}

export interface UpdateRulingContinuationRequest {
    rulingId: string;
    continuationId: string;
    followUpPerformedAt?: Date | string | undefined;
    followUpSummary?: string | undefined;
    followUpSummaryPlainText?: string | undefined;
    relevantJournalNoteIds?: string[] | undefined;
    relevantDocumentIds?: string[] | undefined;
    followUpInterviewId?: string | undefined;
    continuationProposal?: string | undefined;
    continuationProposalPlainText?: string | undefined;
    intakeUserId?: string | undefined;
    intakeTeamId?: string | undefined;
    intakePlannedAt?: Date | string | undefined;
    nextFollowUpDate?: Date | string | undefined;
}

export interface ValidateRulingFunctionRequest {
    rulingId: string;
    rulingFunctionValidationType: RulingFunctionValidationType;
}

export interface CreateJobSearchDefinitionRequest {
    citizenId: string;
    jobSearchDefinition: JobSearchDefinitionModel;
}

export interface PublishEducationImpositionRequest {
    citizenId: string;
    currentStep: EducationStepDto;
    educationGoals?: EducationGoalDto[] | undefined;
    deadline?: Date | string | undefined;
    educationRetentions?: EducationRetentionTypeDto[] | undefined;
    comment?: string | undefined;
}

export interface TerminateContractRequest {
    citizenId: string;
}

export interface TransferLetAsylDataRequest {
    citizenId: string;
}

export interface CancelMedicalRequestRequest {
    citizenId: string;
    requestFormId: string;
}

export interface CancelMedicalRequestForMedicalCollaboratorRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    medicalRequestId: string;
}

export interface ChangeMedicalRequestStatusRequest {
    citizenId: string;
    requestFormId: string;
    shipmentStatusTypeCode: ShipmentStatusTypeCode;
}

export interface ChangeMedicalRequestStatusForMedicalCollaboratorRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    medicalRequestId: string;
    shipmentStatusTypeCode: ShipmentStatusTypeCode;
}

export interface CreateCorrespondenceMessageRequest {
    citizenId: string;
    caseId?: string | undefined;
    sorId?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    priority: CorrespondencePriority;
    replyToCorrespondenceMessageId?: string | undefined;
    attachmentDocumentIds?: string[] | undefined;
}

export interface CreateCorrespondenceMessageForServiceProviderRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    sorId?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    priority: CorrespondencePriority;
    replyToCorrespondenceMessageId?: string | undefined;
    attachmentDocumentIds?: string[] | undefined;
}

export interface CreateMedicalCollaborationCitizenRequest {
    citizenCpr?: string | undefined;
}

export interface CreateMedicalRequestRequest {
    citizenId: string;
    createMedicalRequestInput?: CreateMedicalRequestInput | undefined;
}

export interface CreateMedicalRequestForMedicalCollaboratorRequest {
    citizenId: string;
    socialProviderUnitId: string;
    createMedicalRequestInput?: CreateMedicalRequestInput | undefined;
}

export interface GenerateMedicalRequestAttachmentPdfRequest {
    citizenId: string;
    requestFormId: string;
    templateCode?: string | undefined;
    documentTitle?: string | undefined;
}

export interface SetCitizenLetterShippedRequest {
    citizenId: string;
    requestFormId: string;
}

export interface SimulateRejectRequest {
    medicalRequestId: string;
}

export interface SimulateResponseRequest {
    medicalRequestId: string;
}

export interface UpdateCorrespondenceOptionsRequest {
    citizenId: string;
    correspondenceMessageId: string;
    caseId?: string | undefined;
    process?: CorrespondenceProcessInput | undefined;
}

export interface UpdateMedicalOptionsRequest {
    citizenId: string;
    requestFormId: string;
    caseId?: string | undefined;
    medicalNotification?: MedicalNotificationInput2 | undefined;
    medicalProcess?: MedicalProcessInput | undefined;
    doctorResponseDeadline?: Date | string | undefined;
}

export interface CreateJournalReportRequest {
    citizenId: string;
    includedJournalNoteIds?: string[] | undefined;
    omittedJournalNoteIds?: string[] | undefined;
    createAsTask: boolean;
    showOnCitizenPortal?: boolean | undefined;
}

export interface DeleteDocumentRequest {
    documentId: string;
    citizenId?: string | undefined;
}

export interface OpenFinishedDocumentForEditingRequest {
    documentId: string;
    citizenId: string;
}

export interface SaveDraftDocumentRequest {
    document?: DocumentModel | undefined;
}

export interface SaveFinishedDocumentRequest {
    document?: DocumentModel | undefined;
}

export interface UploadDraftAttachmentRequest {
    citizenId: string;
    fileName: string;
    mimeType: string;
    content: string;
    title: string;
}

export interface MarkJournalNotesAsReadRequest {
    journalNoteIds: string[];
}

export interface ReviseJournalNoteRequest {
    journalNoteId: string;
    citizenId: string;
    revisionNote: string;
}

export interface ReviseStatusJournalNoteRequest {
    journalNoteId: string;
    citizenId: string;
    revisionType: RevisionType;
    revisionNote: string;
}

export interface UpdateJournalNoteMetadataRequest {
    journalNoteId: string;
    citizenId: string;
    caseId: string;
    contentType: string;
    source: number;
}

export interface UpdateJournalReportDetailsRequest {
    citizenId: string;
    journalReportId: string;
    comment?: string | undefined;
    showOnCitizenPortal?: boolean | undefined;
}

export interface GetCitizenIdByJobReferralIdRequest {
    jobReferralId: string;
}

export interface GetJobReferralRequest {
    jobReferralId: string;
    citizenId: string;
}

export interface GetJobReferralsRequest {
    citizenId: string;
}

export interface CancelJobReferralRequest {
    citizenId: string;
    cancelDescription?: string | undefined;
    jobReferralId: string;
}

export interface CreateFollowUpJobReferralRequest {
    citizenId: string;
    jobReferralId: string;
    followUpDate: Date | string;
    jobReferralStatus: number;
    description?: string | undefined;
    monthlySalary?: number | undefined;
}

export interface CreateJobReferralRequest {
    citizenId: string;
    companyRecruitmentId?: string | undefined;
    offerTypeId?: string | undefined;
    occupationId?: string | undefined;
    responsibleCaseworkerId: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    referralDate: Date | string;
    meetingDate: Date | string;
    meetingTime?: TimeOfDay | undefined;
    followupDate?: Date | string | undefined;
    hoursPerWeek: number;
    description?: string | undefined;
    weeklyWorkTimeType: number;
    referralType: number;
    company?: JrCompany | undefined;
}

export interface MarkJobReferralSentRequest {
    jobReferralId: string;
    citizenId: string;
}

export interface CreateCredentialsRequest {
    citizenId: string;
}

export interface UpdateJobcenterAssociationRequest {
    citizenId: string;
    jobcenterId?: string | undefined;
    subjobcenterId?: string | undefined;
}

export interface CancelEnrollmentRequest {
    citizenId: string;
    removalCauseType: string;
    removalDate: Date | string;
}

export interface CreateEnrollmentRequest {
    citizenId: string;
    clientCategoryType?: ClientCategoryType | undefined;
    currentUnemploymentStatusType: CurrentUnemploymentStatusType;
    dfdgProfessions?: DfdgProfession[] | undefined;
}

export interface CreateContactGroupRequest {
    citizenId: string;
    contactGroup?: ContactGroupEditingModel | undefined;
}

export interface UpdateContactGroupRequest {
    citizenId: string;
    contactGroup?: ContactGroupEditingModel | undefined;
}

export interface AbortInterviewGuideDraftRequest {
    citizenId: string;
    interviewId: string;
    dialogSupportId?: string | undefined;
}

export interface CancelBookingRequest {
    citizenId: string;
    bookingId: string;
    comment?: string | undefined;
    cancellationType: CancellationType;
    cancellationCauseType?: CancellationCauseType | undefined;
}

export interface CancelBookingsForCaseRequest {
    citizenId: string;
    caseId: string;
    bookingIds?: string[] | undefined;
}

export interface CompleteBookingRequest {
    booking?: BookingCreateUpdateViewModel | undefined;
}

export interface CompleteCrowdBookingRequest {
    citizenSchedules?: CrowdBookingCitizenScheduleModel[] | undefined;
    bookingInfo?: CrowdBookingInfoModel | undefined;
    templateInfo?: CrowdBookingTemplateInfoModel | undefined;
    meetingAddress?: CrowdBookingMeetingAddressModel | undefined;
}

export interface CompleteInterviewRequest {
    interview?: InterviewCompleteViewModel | undefined;
}

export interface CreateCvAttachmentRequest {
    citizenId: string;
}

export interface CreateNextInterviewReminderRequest {
    dueDate: Date | string;
    taskConfigurationName?: string | undefined;
    citizenId: string;
    interviewType: InterviewType;
}

export interface CreatePersonCategoryRequest {
    citizenId: string;
    incidentDate: Date | string;
    personCategory: number;
    previousPersonCategory?: number | undefined;
    matchReason?: string | undefined;
}

export interface DeleteBookingDraftRequest {
    bookingId: string;
    citizenId: string;
}

export interface DeleteInterviewDraftRequest {
    citizenId: string;
    interviewId: string;
}

export interface EvaluateSummaryRequest {
    transcription?: string | undefined;
    summary?: string | undefined;
    instructions?: string | undefined;
    citizenId: string;
    dialogSupportId?: string | undefined;
}

export interface ImportBookingsFromDfdgRequest {
    citizenId: string;
}

export interface MassReassignBookingsRequest {
    bookingIds?: string[] | undefined;
    newCaseworkerId: string;
}

export interface QueuePartialTranscriptionRequest {
    audioBytes?: string | undefined;
    sessionId?: string | undefined;
    order: number;
    language?: string | undefined;
    citizenId: string;
    dialogSupportId?: string | undefined;
}

export interface SetBookingRequest {
    booking?: BookingCreateUpdateViewModel | undefined;
}

export interface SetInterviewRequest {
    interview?: InterviewViewModel | undefined;
}

export interface SetInterviewBookingDeadlineRequest {
    citizenId: string;
    deadlineDate: Date | string;
    activationDate: Date | string;
    interviewType?: InterviewType | undefined;
}

export interface StartInterpretingSessionRequest {
    citizenId: string;
    dialogSupportId?: string | undefined;
    interviewerLanguage?: string | undefined;
    intervieweeLanguage?: string | undefined;
}

export interface TranscriptionSummaryRequest {
    transcription?: string | undefined;
    instructions?: string | undefined;
    citizenId: string;
    dialogSupportId?: string | undefined;
    recordedSeconds: number;
}

export interface UpdateBookingRequest {
    citizenId: string;
    booking?: BookingUpdateViewModel | undefined;
}

export interface UpdateInterviewRequest {
    citizenId: string;
    updateInterview?: UpdateInterviewRequest2 | undefined;
}

export interface UpdateInterviewDeadlineRequest {
    citizenId: string;
    interviewDeadlineStatusType: InterviewDeadlineStatusType;
    correctionComment?: string | undefined;
}

export interface CreateGrantRequest {
    grant?: CreateGrantDto | undefined;
}

export interface DeleteGrantRequest {
    grantId: string;
    comment?: string | undefined;
}

export interface ExtendGrantRequest {
    grantId: string;
    comment?: string | undefined;
    endDate: Date | string;
}

export interface TerminateGrantRequest {
    grantId: string;
    comment?: string | undefined;
    endDate: Date | string;
    terminateRelatedActivities: boolean;
}

export interface UpdateGrantRequest {
    grant?: GrantDto | undefined;
}

export interface CancelEducationSubscriptionRequest {
    citizenId: string;
}

export interface CreateEducationSubscriptionRequest {
    citizenId: string;
}

export interface MarkDiaryNotesAsReadRequest {
    diaryNoteIds: string[];
}

export interface ReviseDiaryNoteRequest {
    diaryNoteId: string;
    citizenId: string;
    revisionNote: string;
}

export interface ReviseStatusDiaryNoteRequest {
    diaryNoteId: string;
    citizenId: string;
    revisionType: RevisionType;
    revisionNote: string;
}

export interface UpdateDiaryNoteMetadataRequest {
    diaryNoteId: string;
    citizenId: string;
    assignmentId: string;
    contentType: string;
    source: number;
}

export interface CloseCitizenMessageRequest {
    citizenId: string;
    citizenMessageId: string;
}

export interface CreateUnemploymentFundCitizenMessageRequest {
    citizenId: string;
    citizenMessage?: CitizenMessageCreateModel | undefined;
}

export interface ReplyCitizenMessageRequest {
    citizenId: string;
    citizenMessageId: string;
    text?: string | undefined;
    attachments?: CitizenMessageAttachmentModel[] | undefined;
}

export interface UpdateCvStatusRequest {
    citizenId: string;
    comment?: string | undefined;
    cvStatus: CvStatusTypeCodeList;
}

export interface CompleteCounselingInquiryForCitizenRequest {
    citizenId: string;
    counselingInquiryId: string;
}

export interface CompleteCounselingInquiryWithCaseRequest {
    citizenId: string;
    counselingInquiryId: string;
    case?: CounselingInquiryCaseModel | undefined;
    existingCaseId?: string | undefined;
}

export interface CreateCounselingInquiryForCitizenRequest {
    citizenId: string;
    content?: CounselingInquiryContent | undefined;
}

export interface UpdateCounselingInquiryForCitizenRequest {
    citizenId: string;
    counselingInquiryId: string;
    content?: CounselingInquiryContent | undefined;
}

export interface SendLetterToCrowdRequest {
    citizenIds: string[];
    templateId: number;
    variantId?: number | undefined;
    renderTemplateVariables?: SendLetterRenderTemplateVariables | undefined;
    outgoingDocumentTypeId?: string | undefined;
    outgoingDocumentTypeName?: string | undefined;
    attachments?: string[] | undefined;
    letterTitle: string;
    letterContent: string;
    journalTitle?: string | undefined;
    journalNote?: string | undefined;
    caseWorkerId: string;
}

export interface CreateCvAttachmentRequest2 {
    citizenId: string;
}

export interface SendLetterToCitizenRequest {
    model?: SendLetterOfCitizenRecipient | undefined;
}

export interface SendLetterToCitizenAsMedicalCollaboratorRequest {
    model?: SendLetterOfCitizenRecipient | undefined;
    socialProviderUnitId: string;
}

export interface SendLetterToCitizenAsServiceProviderRequest {
    model?: SendLetterOfCitizenRecipient | undefined;
    assignmentId: string;
}

export interface SendLetterToCompanyRequest {
    model?: SendLetterOfCompanyRecipient | undefined;
}

export interface SendLetterToCompanyAsMedicalCollaboratorRequest {
    model?: SendLetterOfCompanyRecipient | undefined;
    socialProviderUnitId: string;
}

export interface SendLetterToCompanyAsServiceProviderRequest {
    model?: SendLetterOfCompanyRecipient | undefined;
    assignmentId: string;
}

export interface SendLetterToMultipleRecipientsRequest {
    model?: LetterRecipients | undefined;
}

export interface SendLetterToMultipleRecipientsAsMedicalCollaboratorRequest {
    model?: LetterRecipients | undefined;
    socialProviderUnitId: string;
}

export interface SendLetterToMultipleRecipientsAsServiceProviderRequest {
    model?: LetterRecipients | undefined;
    assignmentId: string;
}

export interface SendLetterToPrivatePersonRequest {
    model?: SendLetterOfPrivatePersonRecipient | undefined;
}

export interface SendLetterToPrivatePersonAsMedicalCollaboratorRequest {
    model?: SendLetterOfPrivatePersonRecipient | undefined;
    socialProviderUnitId: string;
}

export interface SendLetterToPrivatePersonAsServiceProviderRequest {
    model?: SendLetterOfPrivatePersonRecipient | undefined;
    assignmentId: string;
}

export interface SendLetterToSupplierPlatformRequest {
    model?: SendLetterOfSupplierPlatformRecipient | undefined;
}

export interface UploadFileAttachmentRequest {
    fileName: string;
    mimeType: string;
    content: string;
    title: string;
    convertToPdf: boolean;
}

export interface SyncCitizenInformationRequest {
    citizenId: string;
}

export interface CreateClarificationRightRequest {
    citizenId: string;
    caseId?: string | undefined;
    clarificationDate: Date | string;
    assessment?: string | undefined;
}

export interface DeleteClarificationRightRequest {
    clarificationRightId: string;
    citizenId: string;
    correctionComment?: string | undefined;
}

export interface UpdateClarificationRightRequest {
    clarificationRightId: string;
    citizenId: string;
    clarificationDate: Date | string;
    assessment?: string | undefined;
}

export interface GetCitizenTaskRequest {
    taskId: string;
}

export interface CompleteCitizenTaskRequest {
    taskId: string;
}

export interface CreateCitizenAdvisRequest {
    title?: string | undefined;
    description?: string | undefined;
    categoryId: string;
    dueDate?: Date | string | undefined;
    responsibleCaseWorkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
    caseId?: string | undefined;
    repetition?: CitizenTaskRepetition | undefined;
    citizenId: string;
}

export interface CreateCitizenTaskRequest {
    title?: string | undefined;
    description?: string | undefined;
    categoryId: string;
    dueDate?: Date | string | undefined;
    responsibleCaseWorkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
    caseId?: string | undefined;
    repetition?: CitizenTaskRepetition | undefined;
    citizenId: string;
}

export interface JournalizeCitizenTaskOnCitizenRequest {
    citizenId: string;
    taskId: string;
    caseId?: string | undefined;
    content?: string | undefined;
    eventDate: Date | string;
    title?: string | undefined;
    sentDate?: string | undefined;
}

export interface JournalizeCitizenTaskOnCompanyRequest {
    taskId: string;
    content?: string | undefined;
    eventDate: Date | string;
    title?: string | undefined;
    contactPersonId?: string | undefined;
    companyId: string;
    citizenId: string;
}

export interface ReopenCitizenTaskRequest {
    taskId: string;
}

export interface SetCitizenTaskStatusIgangRequest {
    taskId: string;
}

export interface SetCitizenTaskStatusPlanlagtRequest {
    taskId: string;
}

export interface UpdateCitizenTaskRequest {
    taskId: string;
    title?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | string | undefined;
    responsibleCaseWorkerId?: string | undefined;
    responsibleTeamId?: string | undefined;
    caseId?: string | undefined;
    repetition?: CitizenTaskRepetition | undefined;
}

export interface CreatePersonGroupRequest {
    name?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    isShownInInterview: boolean;
    isRelevantInterMunicipality: boolean;
}

export interface DeletePersonGroupRequest {
    id: string;
    dfdgId: string;
}

export interface UpdatePersonGroupRequest {
    name?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    isShownInInterview: boolean;
    isRelevantInterMunicipality: boolean;
    id: string;
    personGroupTypeId: string;
    dfdgId: string;
}

export interface UpdatePersonNotificationSettingsRequest {
    citizenId: string;
    personNotificationSettings?: PersonNotificationSettingsViewModel[] | undefined;
}

export interface CreateCitizenPersonContactRequest {
    citizenId: string;
    caseworkerId?: string | undefined;
    contactPersonId?: string | undefined;
    roleId: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    citizenComment?: string | undefined;
    caseworkerComment?: string | undefined;
    showContactPersonInJobnet: boolean;
    journalNoteId?: string | undefined;
    highlightOnOptics?: string[] | undefined;
}

export interface SyncMissingCitizenPersonContactsRequest {
    citizenId: string;
}

export interface UpdateCitizenPersonContactRequest {
    citizenId: string;
    citizenPersonContactId: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    citizenComment?: string | undefined;
    caseworkerComment?: string | undefined;
    showContactPersonInJobnet: boolean;
    journalNoteId?: string | undefined;
    highlightOnOptics?: string[] | undefined;
}

export interface VerifyAndSyncCitizenPersonContactWithDfdgRequest {
    citizenPersonContactId: string;
}

export interface CreateCitizenCommentRequest {
    citizenId: string;
    comment?: string | undefined;
}

export interface SaveCaveInformationRequest {
    citizenId: string;
    caveInformation?: string | undefined;
}

export interface SaveCitizenCoreEditableFieldsRequest {
    citizenId: string;
    editableFields?: CitizenCoreEditableFields | undefined;
}

export interface UpdateNotesRequest {
    citizenId: string;
    notes?: NotesViewModel | undefined;
}

export interface UpdateTemporaryAddressRequest {
    citizenId: string;
    temporaryAddress?: ContactInfoTemporaryAddressViewModel | undefined;
}

export interface CloseCaseRequest {
    caseId: string;
    endDate: Date | string;
    closeReasonId: string;
    closeReasonDescription?: string | undefined;
    isCausedByMunicipalityMove: boolean;
    removalCauseType?: RemovalCauseType | undefined;
    municipalityMoveDate?: Date | string | undefined;
    switchTargetGroup?: boolean | undefined;
    absenceCauseType?: AbsenceCauseTypeItem | undefined;
}

export interface CreateAndTerminateCaseRequest {
    caseModel?: CreateCaseModel | undefined;
    journalNote?: string | undefined;
    automaticInformationLetterId?: string | undefined;
    sendInformationLetter: boolean;
    closeReasonId: string;
    closeReasonDescription?: string | undefined;
}

export interface CreateAssociatedCaseWorkerRequest {
    associatedCaseWorkerModel?: AssociatedCaseWorkerModel | undefined;
}

export interface UpdateAssociatedCaseWorkerOnCasesRequest {
    associatedCaseWorkerModels?: AssociatedCaseWorkerModel[] | undefined;
    citizenIds?: string[] | undefined;
    caseStartEndChecked: boolean;
}

export interface CreateCaseRequest {
    caseModel?: CreateCaseModel | undefined;
    journalNote?: string | undefined;
    automaticInformationLetterId?: string | undefined;
    sendInformationLetter: boolean;
}

export interface DeleteAssociatedCaseWorkerRequest {
    associatedCaseWorker?: AssociatedCaseWorkerModel | undefined;
}

export interface DocumentRehabSendToDfdgRequest {
    documents?: RehabilitationDocument[] | undefined;
    caseId: string;
}

export interface GenerateAutomaticLetterByIdRequest {
    automaticInformationLetterId: string;
    citizenId: string;
}

export interface ReassignCasesRequest {
    caseIds?: string[] | undefined;
    caseWorkerId?: string | undefined;
    teamId: string;
}

export interface ReassignCasesSyncroneRequest {
    caseIds?: string[] | undefined;
    caseWorkerId?: string | undefined;
    teamId: string;
}

export interface ReassignCaseworkerOnCaseRequest {
    caseId: string;
    caseWorkerId?: string | undefined;
    teamId: string;
    citizenId: string;
}

export interface ReopenCaseRequest {
    caseId: string;
    journalNote?: string | undefined;
    automaticInformationLetterId?: string | undefined;
    sendInformationLetter: boolean;
}

export interface SaveSicknessBenefitVisitationRequest {
    citizenId: string;
    caseId: string;
    visitationDate: Date | string;
    status: SicknessBenefitVisitationStatus;
    justification?: string | undefined;
    followUpTaskRequested: boolean;
    followUpDate?: Date | string | undefined;
    aiStatus?: SicknessBenefitVisitationStatus | undefined;
    aiJustification?: string | undefined;
    aiRun?: SicknessBenefitVisitationAiRun | undefined;
}

export interface UpdateAssociatedCaseWorkerRequest {
    associatedCaseWorkerModel?: AssociatedCaseWorkerModel | undefined;
}

export interface UpdateCaseRequest {
    caseModel?: CaseModel | undefined;
    sicknessBenefitVisitation?: UpdateCaseSicknessBenefitVisitationModel | undefined;
}

export interface UpdateCaseRehabStatusRequest {
    rehabilitationProcessStatus?: number | undefined;
    existingRehabilitationProcessStatus?: number | undefined;
    rehabilitationProcessId?: string | undefined;
    caseId: string;
    citizenId: string;
}

export interface UpdateCaseTypeRequest {
    citizenId: string;
    caseId: string;
    caseTypeId: string;
}

export interface UpdateRehabCaseRequest {
    rehabilitationProcessId?: string | undefined;
    citizenId: string;
    rehabilitationProcessStatus?: number | undefined;
    caseId: string;
}

export interface CloseAvailabilityAssessmentRequest {
    assessmentSanction?: AssessmentSanctionsViewModel | undefined;
    relevantNegativeEventIds?: string[] | undefined;
}

export interface CreateAbsenceRequest {
    citizenId: string;
    absenceTypeId: string;
    absenceCauseTypeId?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    notificationDate: Date | string;
    comment?: string | undefined;
}

export interface CreateAssessmentRequest {
    citizenId: string;
    eventTypeId: string;
    relevance: AssessmentRelevance;
    sanction: boolean;
    caseWorkerId: string;
    comments?: string | undefined;
    deadlineForPartyReply?: Date | string | undefined;
    hearingStartDate?: Date | string | undefined;
    reasonableCauseTypeId?: string | undefined;
    sanctionRequestText?: string | undefined;
    sendAsPostscript: boolean;
    targetGroupId: string;
    negativeEventIds?: string[] | undefined;
    assessmentLetter?: AssessmentLetterDto | undefined;
    oralHearing?: boolean | undefined;
}

export interface CreateCitizenHealthLimitationRequest {
    citizenId: string;
    healthLimitation?: HealthLimitationCreateModel | undefined;
}

export interface CreateIllnessRequest {
    citizenId: string;
    absenceTypeId: string;
    absenceCauseTypeId?: string | undefined;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    notificationDate: Date | string;
    comment?: string | undefined;
    availabilityDegree?: number | undefined;
    cvrNumber?: string | undefined;
    pNumber?: string | undefined;
    employerAccountId?: string | undefined;
    nemRefusionId?: string | undefined;
    inSubscription?: boolean | undefined;
}

export interface CreateNegativeEventRequest {
    citizenId: string;
    eventTypeId: string;
    activityId?: string | undefined;
    activityName?: string | undefined;
    eventDate: Date | string;
    eventEndDate?: Date | string | undefined;
    isRelevant: boolean;
    note?: string | undefined;
    uph: boolean;
}

export interface DeleteAbsenceRequest {
    citizenId: string;
    absenceId: string;
    correctionComment?: string | undefined;
}

export interface DeleteCitizenHealthLimitationRequest {
    citizenId: string;
    correctionComment?: string | undefined;
    healthLimitationDescription?: string | undefined;
    dfdgIdentifier: string;
}

export interface UpdateAbsenceRequest {
    absenceId: string;
    correctionComment?: string | undefined;
    absence?: AbsenceEditModel | undefined;
}

export interface UpdateAssessmentDecisionLetterCreatedRequest {
    citizenId: string;
    assessmentId: string;
    decisionLetterCreated: Date | string;
}

export interface UpdateCitizenHealthLimitationRequest {
    citizenId: string;
    healthLimitation?: HealthLimitationViewUpdateModel | undefined;
}

export interface UpdateIllnessRequest {
    absenceId: string;
    correctionComment?: string | undefined;
    absence?: AbsenceEditModel | undefined;
}

export interface UpdateNegativeEventRequest {
    negativeEventId: string;
    citizenId: string;
    eventTypeId: string;
    activityId?: string | undefined;
    activityName?: string | undefined;
    eventDate: Date | string;
    eventEndDate?: Date | string | undefined;
    isRelevant: boolean;
    comment?: string | undefined;
}

export interface SaveDanishTestSettingRequest {
    citizenId: string;
    danishTestSetting?: DanishTestSettingDto | undefined;
    integrationInfoResponsibilityAcquisitionDate?: Date | string | undefined;
    remark?: string | undefined;
}

export interface SaveEducationFollowUpRequest {
    citizenId: string;
    responsibilityAcquisitionDate?: Date | string | undefined;
    remark?: string | undefined;
    educationFollowUp?: EducationFollowUpDto | undefined;
    educationData?: EducationDataDto | undefined;
}

export interface SaveEducationStartRequest {
    citizenId: string;
    responsibilityAcquisitionDate?: Date | string | undefined;
    remark?: string | undefined;
    educationData?: EducationDataDto | undefined;
}

export interface SaveEmploymentFollowUpRequest {
    citizenId: string;
    employmentFollowUp?: EmploymentFollowUpDto | undefined;
    integrationInfoResponsibilityAcquisitionDate: Date | string;
}

export interface SaveEmploymentStartRequest {
    citizenId: string;
    employmentStart?: EmploymentStartDto | undefined;
    integrationInfoResponsibilityAcquisitionDate: Date | string;
}

export interface SaveIntegrationInfoRequest {
    citizenId: string;
    integrationInfo?: IntegrationInfoDto | undefined;
}

export interface CopyAssessmentInterventionObjectivesRequest {
    assignmentId?: AssignmentId | undefined;
    assessmentInterventionObjectiveIds?: string[] | undefined;
}

export interface CopyAssignmentRequest {
    assignmentId?: AssignmentId | undefined;
}

export interface CopyCurrentAssignmentRequest {
    activityId?: ActivityId | undefined;
}

export interface CreateAssignmentRequest {
    assignment?: CreateAssignmentModel | undefined;
}

export interface CreateInterventionObjectiveRequest {
    interventionObjective?: CreateInterventionObjectiveModel | undefined;
}

export interface DeleteAssignmentRequest {
    assignmentId?: AssignmentId | undefined;
}

export interface DeleteInterventionObjectiveRequest {
    interventionObjectiveId?: InterventionObjectiveId | undefined;
}

export interface EndCurrentAssignmentsForActivityRequest {
    activityId?: ActivityId | undefined;
    endDate: Date | string;
    closingRemarks?: string | undefined;
}

export interface SetAssignmentStatusRequest {
    assignmentId?: AssignmentId | undefined;
    status: AssignmentStatusType;
    closingRemarks?: string | undefined;
}

export interface UpdateAssignmentRequest {
    assignment?: UpdateAssignmentModel | undefined;
}

export interface UpdateInterventionObjectiveRequest {
    interventionObjective?: UpdateInterventionObjectiveModel | undefined;
}

export interface UpdateServiceProviderObjectiveInfoRequest {
    citizenId?: CitizenId | undefined;
    interventionObjectives?: UpsertPartialObjectivesModel[] | undefined;
}

export interface CopyAssessmentRequest {
    assessmentId: string;
}

export interface CopyCurrentAssessmentRequest {
    caseId: string;
}

export interface CreateAssessmentInterventionObjectiveRequest {
    assessmentInterventionObjective?: CreateAssessmentInterventionObjectiveModel | undefined;
}

export interface CreateAssessmentInterventionObjectiveForDraftRequest {
    assessmentInterventionObjective?: CreateAssessmentInterventionObjectiveModel | undefined;
}

export interface DeleteAssessmentRequest {
    assessmentId: string;
}

export interface FinalizeAssessmentRequest {
    assessment?: SupportAssessmentDto | undefined;
    journalNoteComment?: string | undefined;
}

export interface FinalizeAssessmentVersionedRequest {
    assessment?: SupportAssessmentDto | undefined;
    journalNoteComment?: string | undefined;
}

export interface QueuePartialAssessmentTranscriptionRequest {
    audioBytes?: string | undefined;
    sessionId?: string | undefined;
    order: number;
    language?: string | undefined;
    citizenId: string;
}

export interface ReopenAssessmentRequest {
    assessment?: SupportAssessmentDto | undefined;
}

export interface SaveAssessmentRequest {
    assessment?: SupportAssessmentDto | undefined;
}

export interface UpdateAssessmentInterventionObjectiveRequest {
    assessmentInterventionObjective?: UpdateAssessmentInterventionObjectiveModel | undefined;
}

export interface UpdateAssessmentInterventionObjectiveForDraftRequest {
    assessmentInterventionObjective?: UpdateAssessmentInterventionObjectiveModel | undefined;
}

export interface SaveAgendaForCitizenRequest {
    citizenId: string;
    agendaId?: string | undefined;
    bookingId: string;
    points?: AgendaPointInputModel[] | undefined;
}

export interface AddAttendanceRegistrationRequest {
    createAttendanceRegistrations?: CreateAttendanceRegistrationDto[] | undefined;
}

export interface ApproveAttendanceProtocolRequest {
    lessonId: string;
}

export interface DeleteAttendanceRegistrationRequest {
    attendanceRegistrationId: string;
}

export interface RegisterNoShowsRequest {
    lessonId: string;
}

export interface SubmitAttendanceProtocolRequest {
    lessonId: string;
}

export interface UpdateAttendanceRegistrationRequest {
    updateAttendanceRegistration?: AttendanceRegistrationDto | undefined;
}

export interface AddAndRemoveCourseEducatorsCommandRequest {
    courseIds?: string[] | undefined;
    educatorIdsToAdd?: string[] | undefined;
    educatorIdsToRemove?: string[] | undefined;
    includeFutureLessons: boolean;
}

export interface AddAndRemoveLessonEducatorsCommandRequest {
    lessonIds?: string[] | undefined;
    educatorIdsToAdd?: string[] | undefined;
    educatorIdsToRemove?: string[] | undefined;
}

export interface AdjustCourseCapacitiesByOfferIdCommandRequest {
    offerId: string;
    capacity: number;
}

export interface AssignResponsibleCaseworkerToCoursesRequest {
    courseids?: string[] | undefined;
    caseWorkerId?: string | undefined;
    teamId?: string | undefined;
}

export interface AttendanceImportRequest {
    citizens?: CitizenAttendanceDto[] | undefined;
}

export interface CancelCourseEnrollmentRequest {
    courseEnrollmentId: string;
}

export interface CancelLessonRequest {
    lessonId: string;
    cancellationReason?: string | undefined;
}

export interface CancelLessonsCommandRequest {
    lessonIds?: string[] | undefined;
    cancellationReason?: string | undefined;
}

export interface ChangeCourseClassroomCommandRequest {
    courseIds?: string[] | undefined;
    classroomId: string;
    includeFutureLessons: boolean;
}

export interface ChangeLessonClassroomCommandRequest {
    lessonIds?: string[] | undefined;
    classroomId: string;
}

export interface CreateCitizenLessonDeviationRequest {
    lessonDeviation?: CreateLessonDeviationDto | undefined;
}

export interface CreateCitizenScheduleLetterAttachmentRequest {
    citizenId: string;
    startDate: Date | string;
    endDate: Date | string;
    displayMode: ScheduleDisplayMode;
    includeAbsences: boolean;
    includeInterviews: boolean;
}

export interface CreateClassRoomRequest {
    classroom?: CreateClassroomDto | undefined;
}

export interface CreateCourseRequest {
    course?: CreateCourseDto | undefined;
}

export interface CreateCourseEnrollmentRequest {
    courseEnrollment?: CreateCourseEnrollmentDto | undefined;
}

export interface CreateCourseEnrollmentsRequest {
    courseEnrollments?: CreateCourseEnrollmentDto[] | undefined;
}

export interface CreateEducatorRequest {
    educatorDto?: CreateEducatorDto | undefined;
}

export interface CreateLessonRequest {
    lesson?: CreateLessonDto | undefined;
}

export interface CreateRegistrationCounterRequest {
    registrationCounter?: CreateRegistrationCounterDto | undefined;
}

export interface CreateReoccuringLessonsRequest {
    lesson?: CreateLessonDto | undefined;
    reoccuringLessonEndDate: Date | string;
    reoccuringLessonStartDate: Date | string;
    weekdays?: string[] | undefined;
    skipClosedDays: boolean;
}

export interface DeleteCitizenAttendanceNoteRequest {
    citizenId: string;
}

export interface DeleteCitizenLessonDeviationRequest {
    citizenLessonDeviationId: string;
}

export interface DeleteCourseRequest {
    courseId: string;
}

export interface DeleteCourseEnrollmentRequest {
    courseEnrollmentId: string;
}

export interface DeleteEducatorRequest {
    educatorId: string;
}

export interface DeleteLessonCommandRequest {
    lessonId: string;
}

export interface DeleteLessonsCommandRequest {
    lessonIds?: string[] | undefined;
}

export interface DeleteRegistrationCounterRequest {
    registrationCounterId: string;
}

export interface GenerateActivationKeyRequest {
    registrationCounterId: string;
}

export interface GenerateEducatorActivationKeyRequest {
    educatorId: string;
}

export interface PublishLessonCommandRequest {
    lessonId: string;
}

export interface PublishLessonsCommandRequest {
    lessonIds?: string[] | undefined;
}

export interface RevokeEducatorActivationKeyRequest {
    educatorId: string;
}

export interface SaveCitizenAttendanceNoteRequest {
    citizenId: string;
    text?: string | undefined;
}

export interface UpdateCitizenLessonDeviationRequest {
    lessonDeviation?: CitizenLessonDeviationDto | undefined;
}

export interface UpdateClassRoomRequest {
    classroom?: ClassroomDto | undefined;
}

export interface UpdateCourseRequest {
    course?: CourseDto | undefined;
    updateFutureLessons: boolean;
}

export interface UpdateCourseEnrollmentRequest {
    courseEnrollment?: CourseEnrollmentDto | undefined;
}

export interface UpdateCoursesRequestStatus {
    courseIds?: string[] | undefined;
    isCompleted: boolean;
}

export interface UpdateCourseRequestStatus {
    courseId: string;
    isCompleted: boolean;
}

export interface UpdateEducatorRequest {
    educatorDto?: EducatorDto | undefined;
}

export interface UpdateLessonRequest {
    lesson?: LessonDto | undefined;
}

export interface UpdateRegistrationCounterRequest {
    registrationCounter?: RegistrationCounterDto | undefined;
}

export interface CreateOrUpdateUserChatMessageRequest {
    userChatMessageDto?: CreateUserChatMessageDto | undefined;
}

export interface ReportSpeechUsageRequest {
    dialogSupportId?: string | undefined;
    translationSeconds: number;
    transcriptionSeconds: number;
    synthesizedCharacters: number;
    sequenceNumber: number;
}

export interface ApproveCitizenDeletionOrderRequest {
    orderId: string;
}

export interface ArchiveCitizenDeletionOrderRequest {
    orderId: string;
}

export interface CancelCitizenDeletionOrderRequest {
    orderId: string;
}

export interface CreateCitizenDeletionOrderRequest {
    title: string;
    description?: string | undefined;
    worklistQuery: string;
    citizens: string[];
}

export interface DeleteCitizenRequest {
    citizenId: string;
    comment?: string | undefined;
    archivingAcknowledged: boolean;
}

export interface DryRunDeleteCitizenRequest {
    citizenId: string;
}

export interface SendCitizenDeletionOrderToApprovalRequest {
    orderId: string;
}

export interface UpdateCitizenDeletionOrderRequest {
    orderId: string;
    title?: string | undefined;
    description?: string | undefined;
}

export interface GenerateReportRequest extends AuditLogQueryRequest {
}

export interface CreateVisitationTeamRequest {
    teamId: string;
    description?: string | undefined;
}

export interface UpdateVisitationTeamRequest {
    visitationTeam: VisitationTeamDetails;
}

export interface ActivateUsersRequest {
    userIds?: string[] | undefined;
}

export interface CreateUserRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    title?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    teamId?: string | undefined;
    externalCompanyId?: string | undefined;
    hasJobEjerRole: boolean;
    hasFormidlingsansvarligRole: boolean;
    hasPlaceringsgodkenderRole: boolean;
    exemptFromAutomaticDeactivation: boolean;
    userIdentitySchultz?: string | undefined;
    userIdentityAdfs?: string | undefined;
    userIdentityFK?: string | undefined;
    userIdentityNemlogin?: string | undefined;
    nemLoginUserProfileId?: string | undefined;
    userIdentityNemloginCvr?: string | undefined;
}

export interface DeactivateUsersRequest {
    userIds?: string[] | undefined;
}

export interface EditUserRequest {
    userId: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    title?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    teamId: string;
    externalCompanyId?: string | undefined;
    hasJobEjerRole: boolean;
    hasFormidlingsansvarligRole: boolean;
    hasPlaceringsgodkenderRole: boolean;
    exemptFromAutomaticDeactivation: boolean;
    userIdentitySchultz?: string | undefined;
    userIdentityAdfs?: string | undefined;
    userIdentityFK?: string | undefined;
    userIdentityNemlogin?: string | undefined;
    nemLoginUserProfileId?: string | undefined;
    userIdentityNemloginCvr?: string | undefined;
}

export interface SetUserAtaTimeRequest {
    userId: string;
    weeklyAtaMinutes?: number | undefined;
}

export interface SetUserCprRequest {
    userId: string;
    cpr?: string | undefined;
}

export interface CreateUserProfileRequest {
    userProfile?: UserProfileCreateModel | undefined;
}

export interface DeleteUserProfileRequest {
    id?: string | undefined;
}

export interface UpdateUserProfileRequest {
    userProfile?: UserProfileUpdateModel | undefined;
}

export interface CreateQuestionnaireRequest {
    questionnaireDetails?: QuestionnaireDetails | undefined;
}

export interface DeactivateQuestionnaireRequest {
    questionnaireId: string;
}

export interface UpdateQuestionnaireRequest {
    questionnaireDetails?: QuestionnaireDetails | undefined;
}

export interface SaveSubJobcenterClosedDaysRequest {
    subJobcenterId: string;
    added?: SubJobcenterClosedDayModel[] | undefined;
    deletedDates?: Date | string[] | undefined;
}

export interface CreateObservationTypeRequest {
    observationType?: ObservationTypeCreateModel | undefined;
}

export interface UpdateObservationTypeRequest {
    observationType?: ObservationTypeUpdateModel | undefined;
}

export interface CreateMethodTypeRequest {
    methodTypeCreateModel?: MethodTypeCreateModel | undefined;
}

export interface UpdateMethodTypeRequest {
    methodTypeUpdateModel?: MethodTypeUpdateModel | undefined;
}

export interface CreateJournalNoteContentTypeRequest {
    journalNoteContentType?: JournalNoteContentTypeCreateModelV3 | undefined;
}

export interface UpdateJournalNoteContentTypeRequest {
    journalNoteContentType?: JournalNoteContentTypeUpdateModelV3 | undefined;
}

export interface CreateInterviewTypeRequest {
    interviewTypeCreateModel?: InterviewTypeCreateModel | undefined;
}

export interface UpdateInterviewTypeRequest {
    interviewTypeUpdateModel?: InterviewTypeUpdateModel | undefined;
}

export interface CreateGrantTypeRequest {
    grantType?: GrantTypeDetails | undefined;
}

export interface UpdateGrantTypeRequest {
    grantType?: GrantTypeDetails | undefined;
}

export interface AdjustReceivableRequest {
    receivableId: string;
    amount: number;
}

export interface CreateCoPaymentDebitorRunRequest {
    dryRun?: boolean | undefined;
    simulatedRunDate?: Date | string | undefined;
    cprNumber?: string | undefined;
    coPaymentTypeId?: string | undefined;
    serviceMonthFrom?: string | undefined;
    serviceMonthTo?: string | undefined;
}

export interface CreateFinanceTestReceiptRequest {
    transactionId: string;
    receipt?: FinanceTestReceiptSpec | undefined;
}

export interface DeleteCoPaymentGroupFromDebitorRunRequest {
    coPaymentDebitorRunId: string;
    coPaymentId: string;
}

export interface DeleteReceivablesRequest {
    receivableIds?: string[] | undefined;
}

export interface DispatchCoPaymentDebitorRunRequest {
    coPaymentDebitorRunId: string;
}

export interface DispatchReceivablesRequest {
    receivableIds?: string[] | undefined;
    adjustmentIds?: string[] | undefined;
    processingInstructions?: ProcessingInstructionInput[] | undefined;
}

export interface RedeliverReceivablesToFinanceRequest {
    receivableIds?: string[] | undefined;
}

export interface RetryCoPaymentDebitorRunDispatchRequest {
    coPaymentDebitorRunId: string;
    coPaymentIds?: string[] | undefined;
}

export interface SetCoPaymentGroupProcessingInstructionRequest {
    coPaymentDebitorRunId: string;
    coPaymentId: string;
    processingXml?: string | undefined;
}

export interface ChangeAiStandardQuestionsStatusRequest {
    ids?: string[] | undefined;
    status?: AiStandardQuestionStatus | undefined;
}

export interface CopyAiStandardQuestionsAsDraftsRequest {
    ids?: string[] | undefined;
}

export interface CreateAccountGroupsForAdminUiRequest {
    createdAccountGroup?: AccountGroupModel | undefined;
}

export interface CreateAccountInteractionPurposesForAdminUiRequest {
    createdAccountInteractionPurpose?: AccountInteractionPurposeModel | undefined;
}

export interface CreateAccountInteractionResultsForAdminUiRequest {
    createdAccountInteractionResult?: AccountInteractionResultModel | undefined;
}

export interface CreateAccountSpecialCircumstancesTypesForAdminUiRequest {
    createdAccountSpecialCircumstancesType?: AccountSpecialCircumstancesTypeModel | undefined;
}

export interface CreateAccountTagTypesForAdminUiRequest {
    createdAccountTagType?: AccountTagTypeModel | undefined;
}

export interface CreateAdminAbsenceTypeRequest {
    absenceType?: AdminAbsenceTypeModel | undefined;
}

export interface CreateAdminCaseTypeRequest {
    caseType?: AdminCaseTypeModel | undefined;
}

export interface CreateAdminPlanTypeRequest {
    planType?: AdminPlanTypeModel | undefined;
}

export interface CreateAiStandardQuestionForAdminUiRequest {
    standardQuestion?: AiStandardQuestionModel | undefined;
}

export interface CreateAssociateUserRoleRequest {
    createdAssociatedUserRole?: AssociateUserRoleModel | undefined;
}

export interface CreateCaseClosureReasonRequest {
    caseClosureReason?: CaseClosureReasonModel | undefined;
}

export interface CreateCaseContactReasonRequest {
    caseContactReason?: CaseContactReasonModel | undefined;
}

export interface CreateCaseGroupsForAdminUiRequest {
    createdCaseGroup?: CaseGroupModel | undefined;
}

export interface CreateCaseRestrictionsForAdminUiRequest {
    createCaseRestriction?: AdminCaseRestrictionModel | undefined;
}

export interface CreateClosureCausesForAdminUiRequest {
    createdClosureCause?: ClosureCauseModel | undefined;
}

export interface CreateCoPaymentTypeForAdminUiRequest {
    coPaymentType?: AdminCoPaymentTypeModel | undefined;
}

export interface CreateExternalOperatorResponsibilityAreaRequest {
    createExternalOperatorResponsibilityAreaModel?: ExternalOperatorResponsibilityAreaModel | undefined;
}

export interface CreateFollowUpRulesForAdminUiRequest {
    createdFollowUpRule?: FollowUpRuleModel | undefined;
}

export interface CreateGuideLinkRequest {
    guideLink?: AdminGuideLinkModel | undefined;
}

export interface CreateOutgoingDocumentTypesForAdminUiRequest {
    createdOutgoingDocumentType?: OutgoingDocumentTypeModel | undefined;
}

export interface CreatePlacementPurposeRequest {
    createdPlacementPurposeRole?: PlacementPurposeModel | undefined;
}

export interface CreateReasonForReadWriteMathTestsForAdminUiRequest {
    createdReasonForReadWriteMathTest?: ReasonForReadWriteMathTestModel | undefined;
}

export interface CreateRecruitmentCollaborationRequest {
    createRecruitmentCollaboration?: RecruitmentCollaborationModel | undefined;
}

export interface CreateRecruitmentRequestInformationTypeRequest {
    createRecruitmentRequestInformationType?: RecruitmentRequestInformationTypeModel | undefined;
}

export interface CreateServiceTargetTypesForAdminUiRequest {
    createdServiceTargetType?: ServiceTargetTypeModel | undefined;
}

export interface CreateSocialProviderUnitRequest {
    createdSocialProviderUnit?: SocialProviderUnitModel | undefined;
}

export interface CreateStandardAppendixRequest {
    standardAppendix?: AdminStandardAppendixModel | undefined;
}

export interface CreateStandardAppendixRuleRequest {
    standardAppendixRule?: StandardAppendixRuleModel | undefined;
}

export interface CreateStandardPhraseRequest {
    standardPhrase?: AdminStandardPhraseModel | undefined;
}

export interface CreateTaskConfigurationRequest {
    taskConfiguration?: AdminTaskConfigurationModel | undefined;
}

export interface DeleteAiStandardQuestionsRequest {
    ids?: string[] | undefined;
}

export interface DeleteStandardPhraseRequest {
    standardPhraseId: string;
}

export interface UpdateAccountGroupRequest {
    updateAccountGroups?: AccountGroupModel[] | undefined;
}

export interface UpdateAccountInteractionPurposeRequest {
    updateAccountInteractionPurposes?: AccountInteractionPurposeModel[] | undefined;
}

export interface UpdateAccountInteractionResultRequest {
    updateAccountInteractionResults?: AccountInteractionResultModel[] | undefined;
}

export interface UpdateAccountSpecialCircumstancesTypeRequest {
    updateAccountSpecialCircumstancesTypes?: AccountSpecialCircumstancesTypeModel[] | undefined;
}

export interface UpdateAccountTagTypeRequest {
    updateAccountTagTypes?: AccountTagTypeModel[] | undefined;
}

export interface UpdateAdminAbsenceTypeRequest {
    absenceType?: AdminAbsenceTypeModel | undefined;
}

export interface UpdateAdminPlanTypeRequest {
    planType?: AdminPlanTypeModel | undefined;
}

export interface UpdateAiStandardQuestionForAdminUiRequest {
    updateAiStandardQuestion?: AiStandardQuestionModel | undefined;
}

export interface UpdateAiStandardQuestionRequest {
    aiStandardQuestions?: AiStandardQuestionModel[] | undefined;
}

export interface UpdateCaseContactRequest {
    associateUserRoles?: AssociateUserRoleModel[] | undefined;
}

export interface UpdateCaseClosureReasonRequest {
    caseClosureReasonModels?: CaseClosureReasonModel[] | undefined;
}

export interface UpdateCaseContactRequest2 {
    caseContactReasons?: CaseContactReasonModel[] | undefined;
}

export interface UpdateCaseGroupRequest {
    updateCaseGroups?: CaseGroupModel[] | undefined;
}

export interface UpdateCaseRestrictionsRequest {
    updateCaseRestrictions?: AdminCaseRestrictionModel[] | undefined;
}

export interface UpdateAdminCaseTypeRequest {
    caseType?: AdminCaseTypeModel | undefined;
}

export interface UpdateClosureCauseRequest {
    updateClosureCauses?: ClosureCauseModel[] | undefined;
}

export interface UpdateCoPaymentTypeForAdminUiRequest {
    coPaymentType?: AdminCoPaymentTypeModel | undefined;
}

export interface UpdateExternalOperatorResponsibilityAreaRequest {
    updateExternalOperatorResponsibilityAreaModels?: ExternalOperatorResponsibilityAreaModel[] | undefined;
}

export interface UpdateFollowUpRulesForAdminUiRequest {
    updateFollowUpRules?: FollowUpRuleModel[] | undefined;
}

export interface UpdateGuideLinkRequest {
    guideLink?: AdminGuideLinkModel | undefined;
}

export interface UpdateOutgoingDocumentTypesForAdminUiRequest {
    updatedOutgoingDocumentTypes?: OutgoingDocumentTypeModel[] | undefined;
}

export interface UpdateCaseContactRequest3 {
    placementPurposes?: PlacementPurposeModel[] | undefined;
}

export interface UpdateReasonForReadWriteMathTestRequest {
    updateReasonForReadWriteMathTests?: ReasonForReadWriteMathTestModel[] | undefined;
}

export interface UpdateRecruitmentCollaborationRequest {
    updateRecruitmentCollaborations?: RecruitmentCollaborationModel[] | undefined;
}

export interface UpdateRecruitmentRequestInformationTypeRequest {
    updateRecruitmentRequestInformationTypes?: RecruitmentRequestInformationTypeModel[] | undefined;
}

export interface UpdateServiceTargetTypeRequest {
    updateServiceTargetTypes?: ServiceTargetTypeModel[] | undefined;
}

export interface UpdateSocialProviderUnitRequest {
    updatedSocialProviderUnit?: SocialProviderUnitModel | undefined;
}

export interface UpdateStandardAppendixRequest {
    standardAppendix?: AdminStandardAppendixModel | undefined;
}

export interface UpdateStandardAppendixRuleRequest {
    standardAppendixRule?: StandardAppendixRuleModel | undefined;
}

export interface UpdateStandardPhraseRequest {
    standardPhrase?: AdminStandardPhraseModel | undefined;
}

export interface UpdateTaskConfigurationRequest {
    taskConfigurations?: AdminTaskConfigurationModel[] | undefined;
}

export interface CreateGlossaryTermRequest {
    term?: string | undefined;
    explanation?: string | undefined;
    category: number;
    doNotTranslate: boolean;
    isActive: boolean;
}

export interface CreateMunicipalityAssistantDocumentRequest {
    title: string;
    description?: string | undefined;
    draftDocumentReference: string;
    mimeType: string;
    fileName: string;
    draftDocumentContentOwner: string;
}

export interface DeleteDialogSupportPromptRequest {
    promptId: string;
}

export interface DeleteGlossaryTermRequest {
    termId: string;
}

export interface DeleteMunicipalityAssistantDocumentRequest {
    id: string;
}

export interface SaveAssessmentPromptRequest {
    fieldName: string;
    content?: string | undefined;
    expectedVersion?: string | undefined;
}

export interface SaveDialogSupportInstructionRequest {
    targetGroupId: string;
    interviewTypeCode: number;
    disableJournalNoteSummary: boolean;
    prompts?: InstructionPromptToSave[] | undefined;
}

export interface UpdateGlossaryTermRequest {
    idToUpdate: string;
    term?: string | undefined;
    explanation?: string | undefined;
    category: number;
    doNotTranslate: boolean;
    isActive: boolean;
}

export interface UpdateMunicipalityAssistantDocumentRequest {
    id: string;
    title?: string | undefined;
    description?: string | undefined;
}

export interface UploadDraftMunicipalityDocumentRequest {
    fileName: string;
    mimeType: string;
    content: string;
}

export interface UpsertMunicipalityAssistantDocumentRequest {
    title: string;
    description?: string | undefined;
    draftDocumentReference: string;
    mimeType: string;
    fileName: string;
    draftDocumentContentOwner: string;
}

export interface GetTranscriptionRequest {
    sessionId?: string | undefined;
}

export interface GetTranscriptionStatusRequest {
    sessionId?: string | undefined;
}

export interface GetTransactionLogItemDetailsRequest {
    transactionId?: string | undefined;
    externalSystemType: ExternalSystemType;
}

export interface SearchTransactionLogRequest {
    resultCount: number;
    fromDate?: Date | string | undefined;
    toDate?: Date | string | undefined;
    cpr?: string | undefined;
    transactionId?: string | undefined;
    correlationId?: string | undefined;
    messageType?: string | undefined;
    contentSearchString?: string | undefined;
    externalRequestFailed?: boolean | undefined;
    externalSystemTypes?: ExternalSystemType[] | undefined;
}

export interface GetQuestionnairesForOfferIdRequest {
    offerId: string;
}

export interface GetUseOfForceIncidentsForServiceProviderUnitRequest {
    serviceProviderUnitId: string;
}

export interface GetUseOfForceReportActionPlanRequest {
    serviceProviderUnitId: string;
    reportId: string;
    actionPlanId: string;
}

export interface GetUseOfForceReportForServiceProviderUnitRequest {
    serviceProviderUnitId: string;
}

export interface GetUseOfForceReportPdfRequest {
    serviceProviderUnitId: string;
    reportId: string;
}

export interface GetResourceUtilizationRequest {
    date: Date | string;
}

export interface AnalyzeServiceProviderUnitPatternsRequest {
    serviceProviderUnitId: string;
}

export interface GetServiceProviderUnitOverviewRequest {
    serviceProviderUnitId: string;
}

export interface GetServiceProviderUnitCalendarEventsRequest {
    serviceProviderUnitId: string;
    fromDate: Date | string;
    toDate: Date | string;
}

export interface GetAttachmentsRequest {
    shelfId?: string | undefined;
    attachments?: string | undefined;
    outboxItemTitle?: string | undefined;
    outboxItemCreatedDate?: Date | string | undefined;
    citizenId?: string | undefined;
    mainDocumentId?: string | undefined;
}

export interface GetCitizenOutboxItemsRequest {
    status: OutboxItemStatus;
    citizenId: string;
}

export interface GetCitizenOutboxItemsForMedicalCollaboratorRequest {
    status: OutboxItemStatus;
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetCitizenOutboxItemsForServiceProviderRequest {
    status: OutboxItemStatus;
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetCompanyOutboxItemsRequest {
    status: OutboxItemStatus;
    companyId: string;
}

export interface GetDocumentContentRequest {
    id: string;
    citizenId?: string | undefined;
    outboxItemTitle?: string | undefined;
    outboxItemCreatedDate?: Date | string | undefined;
}

export interface GetOutboxItemsRequest {
    status: OutboxItemStatus;
}

export interface GetTeamByIdRequest {
    teamId: string;
}

export interface GetTeamInformationFromFkoRequest {
    fkoTeamId: string;
}

export interface GetTeamNameFromFkoRequest {
    fkoTeamId: string;
}

export interface GetTeamUsersRequest {
    teamId: string;
}

export interface GetUserByIdRequest {
    userId: string;
}

export interface CalculateReimbursementRequest {
    activityId: string;
    dailyTransportInKilometers: number;
    workDays: number;
    isIncludingFerry: boolean;
}

export interface GetActivationLevelByCitizenIdRequest {
    citizenId: string;
}

export interface GetActivitiesAggregatedByCompanyIdRequest {
    companyId: string;
    filterType: ActivityFilterType;
}

export interface GetActivitiesBasicInfoRequest {
    activityIds?: string[] | undefined;
    citizenIds?: string[] | undefined;
}

export interface GetActivitiesByCitizenIdRequest {
    citizenId: string;
    filterType: CitizenActivityFilterType;
}

export interface GetActivitiesByCompanyIdRequest {
    companyId: string;
    pageRequest?: ActivityPageRequest | undefined;
    sortRequest?: ActivitySortRequest | undefined;
    filterRequest?: ActivityFilterRequest | undefined;
}

export interface GetActivitiesByGrantIdRequest {
    citizenId: string;
    grantId: string;
}

export interface GetActivitiesForNegativeEventRequest {
    citizenId: string;
    eventDate: Date | string;
}

export interface GetActivitiesForNuphRequest {
    citizenId: string;
    eventDate: Date | string;
}

export interface GetActivitiesSummaryBoxDataRequest {
    citizenId: string;
}

export interface GetActivityApprovalRejectDetailsRequest {
    activityId: string;
}

export interface GetActivityBasicInfoRequest {
    activityId: string;
}

export interface GetActivityForCommunicationRequest {
    activityId: string;
}

export interface GetActivityDetailsByIdRequest {
    activityId: string;
}

export interface GetActivityDetailsByOfferIdRequest {
    offerId: string;
}

export interface GetActivityListByCitizenIdRequest {
    citizenId: string;
}

export interface GetActivityPdfFormSubmittedRequest {
    systemSessionGroupId: string;
    entityId: string;
}

export interface GetActivityPeriodTotalPriceRequest {
    activityId?: string | undefined;
    startDate: Date | string;
    endDate: Date | string;
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
    priceModel: number;
    priceModelInitialRate?: number | undefined;
    priceModelInitialRateCorrection?: number | undefined;
    unitPrice: number;
    unitPriceCorrection?: number | undefined;
}

export interface GetActivityPriceCalculationHistoryRequest {
    activityId: string;
}

export interface GetActivityPriceCorrectionsRequest {
    activityId: string;
}

export interface GetActivityResourcesRequest {
    activityId: string;
}

export interface GetActivityTotalPlacementHoursRequest {
    startDate: Date | string;
    endDate: Date | string;
    hoursPerWeek?: number | undefined;
    minutesPerWeek?: number | undefined;
}

export interface GetCalculatedEndDateByStartDateRequest {
    offerId: string;
    startDate: Date | string;
}

export interface GetCitizenGrantListRequest {
    citizenId: string;
    offerId?: string | undefined;
    caseId?: string | undefined;
}

export interface GetCitizenHeaderInfoRequest {
    citizenId: string;
}

export interface GetCompanyContactPersonsByCompanyIdForActivityRequest {
    companyId: string;
}

export interface GetCompanyContactPersonsByCompanyIdForOfferRequest {
    companyId: string;
}

export interface GetCompanyInfoByIdRequest {
    companyId: string;
}

export interface GetSpecialCircumstanceByCompanyIdRequest {
    companyId: string;
}

export interface GetCreateOfferCompanyByIdRequest {
    companyId: string;
}

export interface GetDfdgActivitiesByCitizenIdRequest {
    citizenId: string;
}

export interface GetDfdgActivityByIdRequest {
    dfdgActivityId: string;
    citizenId: string;
}

export interface GetEvaluationRequest {
    evaluationId: string;
}

export interface GetEvaluationsByActivityIdRequest {
    activityId: string;
}

export interface GetMissingWorkDutyHoursRequest {
    citizenId: string;
    offerCategory: number;
}

export interface GetOccupationsByLookupRequest {
    query?: string | undefined;
}

export interface GetOfferByIdRequest {
    offerId: string;
}

export interface GetOfferDetailsByIdRequest {
    offerId: string;
}

export interface GetOfferDetailsForActivityByIdRequest {
    offerId: string;
}

export interface GetOfferSimpleDetailsByOfferIdRequest {
    offerId: string;
}

export interface GetOfferGroupByIdRequest {
    offerGroupId: string;
}

export interface GetOfferHasAvailableSeatsOnDateRequest {
    wishedStartDate: Date | string;
    wishedEndDate?: Date | string | undefined;
    offerId: string;
}

export interface GetOfferIdByOfferResourceIdRequest {
    offerResourceId: string;
}

export interface GetOfferIdsByGrantIdRequest {
    grantId: string;
}

export interface GetOfferPriceGuideInfoRequest {
    offerId: string;
}

export interface GetOfferPricesRequest {
    offerId: string;
}

export interface GetOfferResourceByIdRequest {
    offerId: string;
    offerResourceId: string;
}

export interface GetOfferResourcesByOfferIdRequest {
    offerId: string;
}

export interface GetOffersByCompanyIdRequest {
    companyId: string;
}

export interface GetOffersEarmarkedToCitizenRequest {
    citizenId: string;
}

export interface GetReimbursementRequest {
    reimbursementId: string;
    activityId: string;
}

export interface GetReimbursementsByActivityIdRequest {
    activityId: string;
}

export interface GetReimbursementOfferCategoryRequest {
    reimbursementId: string;
}

export interface GetSchultzConnectUrlRequest {
    activityId: string;
    citizenId: string;
}

export interface GetSuggestedVitasDataForCancelActivityRequest {
    activityId: string;
}

export interface GetSuggestNextAvailablePeriodsRequest {
    offerId: string;
    startDate: Date | string;
    activityDuration: number;
    maximumDeviation: number;
}

export interface GetTeamByUserIdRequest {
    userId: string;
}

export interface GetWaitingListActivityValidationRequest {
    offerId: string;
    citizenId: string;
}

export interface GetWaitingListSeatByIdRequest {
    citizenId: string;
    waitingListSeatId: string;
}

export interface GetWaitingListSeatRoutingInfoByIdRequest {
    waitingListSeatId: string;
}

export interface GetWaitingListSeatsByCitizenIdRequest {
    citizenId: string;
}

export interface GetWaitingListSeatsByOfferIdRequest {
    offerId: string;
}

export interface GetWizardDataForCancelActivityRequest {
    activityId: string;
}

export interface GetWizardDataForReimbursementRequest {
    activityId: string;
}

export interface HasActiveActivityByOfferCategoryRequest {
    citizenId: string;
    offerCategory: number;
}

export interface IsCreateEvaluationAvailableRequest {
    activityId: string;
}

export interface IsReimbursementAvailableRequest {
    activityId: string;
}

export interface ValidateCreateActivityRequest extends CreateActivityRequestBase {
}

export interface ValidateCreateOfferRequest extends CreateOfferRequestBase {
}

export interface ValidateUpdateActivityRequest extends UpdateActivityRequestBase {
}

export interface ValidateUpdateOfferRequest extends UpdateOfferRequestBase {
}

export interface CalculateCoPaymentParagraph107Request {
    monthlyIncomeBasis: number;
    monthlyCostBasedCoPayment?: number | undefined;
    necessaryExpenses?: number | undefined;
    desiredMonthlyDisposableAmount?: number | undefined;
}

export interface CalculateCoPaymentParagraph108Request {
    annualIncomeBasis: number;
    startDate: Date | string;
    monthlyCostBasedCoPayment?: number | undefined;
    desiredMonthlyDisposableAmount?: number | undefined;
    monthlyElectricityCost: number;
    monthlyHeatingCost: number;
}

export interface CalculateCoPaymentParagraph108IncomeBasisRequest {
    startYear: number;
    personalIncome: number;
    capitalIncome: number;
    annualDeduction: number;
    isSinglePerson?: boolean | undefined;
}

export interface ClassifyCoPaymentRectificationRequest {
    coPaymentId: string;
    payload?: CoPaymentRectificationPayload | undefined;
}

export interface GetCoPaymentByIdRequest {
    coPaymentId: string;
}

export interface GetCoPaymentInitialDataRequest {
    activityId: string;
}

export interface GetCoPaymentPdfRequest {
    coPaymentId: string;
    citizenId: string;
    templateCode?: string | undefined;
}

export interface GetCoPaymentReceivablesRequest {
    coPaymentId: string;
}

export interface GetCoPaymentRedirectPropertiesRequest {
    coPaymentId: string;
}

export interface GetCoPaymentsByActivityIdRequest {
    activityId: string;
}

export interface GetCoPaymentTypesByOfferTypeRequest {
    offerTypeId: string;
}

export interface GetInterventionCostsRequest {
    step: number;
}

export interface GetInterventionLadderRequest {
    period: InterventionLadderPeriod;
}

export interface GetInterventionLengthsRequest {
    step: number;
    courses: InterventionLengthCourses;
}

export interface GetTeamUsersByLookupQueryRequest {
    query?: string | undefined;
    teamId: string;
    includeInactiveUsers: boolean;
}

export interface GetUserByIdRequest2 {
    userId: string;
}

export interface GetUsersByLookupQueryRequest {
    query?: string | undefined;
    includeInactiveUsers: boolean;
}

export interface GetTeamByIdRequest2 {
    teamId: string;
}

export interface GetTeamsByLookupQueryRequest {
    query?: string | undefined;
    includeInactiveTeams: boolean;
}

export interface GetOfferByIdRequest2 {
    offerId: string;
}

export interface GetOfferLookupOptionsRequest {
    query?: string | undefined;
    companyId?: string | undefined;
    offerTypeId?: string | undefined;
    validOfferIds?: string[] | undefined;
    allowedCategories?: number[] | undefined;
    excludeOffersWithExceededDeadline: boolean;
}

export interface GetOffersByLookupQueryRequest {
    query?: string | undefined;
    offerTypeId?: string | undefined;
    validOfferIds?: string[] | undefined;
    companyId?: string | undefined;
}

export interface GetOffersForOfferTypeByLookupQueryRequest {
    query?: string | undefined;
    offerTypeId?: string | undefined;
    companyId?: string | undefined;
}

export interface GetContactPersonByIdRequest {
    contactPersonId: string;
}

export interface GetContactPersonsByLookupQueryRequest {
    query?: string | undefined;
    companyId?: string | undefined;
    maxResultSize?: number | undefined;
}

export interface GetCompaniesByLookupQueryRequest {
    query?: string | undefined;
}

export interface GetCompanyByIdRequest {
    companyId: string;
}

export interface GetCompanyByIdForLookupRequest {
    companyId: string;
}

export interface GetCitizenLookupByIdRequest {
    citizenId: string;
}

export interface GetCitizensByLookupQueryRequest {
    query?: string | undefined;
}

export interface GetCitizenCasesLookupRequest {
    citizenId: string;
}

export interface GetCompanyNoteJournalizationIdRequest {
    referenceId: string;
}

export interface GetJournalizationIdRequest {
    referenceId: string;
}

export interface GetTaskContextRequest {
    id: string;
}

export interface DownloadIncomingMailTaskAttachmentRequest {
    id: string;
}

export interface GetIncomingMailTaskRequest {
    id: string;
}

export interface GetIncomingMailAttachmentsRequest {
    id: string;
}

export interface GetGeneralTaskRequest {
    taskId: string;
}

export interface GetCompanyMunicipalityByCompanyIdRequest {
    companyId: string;
}

export interface GetExternalJobAdIdRequest {
    jobAdId: string;
}

export interface GetJobAdRequestV2 {
    externalJobAdId: string;
}

export interface GetCaseworkerAbsencesRequest {
    caseworkerId?: string | undefined;
}

export interface GetChatActivityRequest {
    impersonatedCaseworkerId?: string | undefined;
    chatFilter?: ChatFilterType[] | undefined;
}

export interface GetChatAttachmentRequest {
    chatId: string;
    attachmentId: string;
    citizenId: string;
}

export interface GetChatByIdRequest {
    chatId: string;
    citizenId: string;
    messageLimit?: number | undefined;
}

export interface GetChatCountRequest {
    impersonatedCaseworkerId?: string | undefined;
    userId?: string | undefined;
    chatFilter?: ChatFilterType[] | undefined;
}

export interface GetChatCreationOptionsRequest {
    citizenId: string;
}

export interface GetChatMessageDeleteInfoRequest {
    chatId: string;
    messageId: string;
    citizenId: string;
}

export interface GetChatsPaginatedRequest {
    impersonatedCaseworkerId?: string | undefined;
    userId?: string | undefined;
    pageLimit?: number | undefined;
    currentPage?: number | undefined;
    chatSort?: ChatSort | undefined;
    chatFilter?: ChatFilterType[] | undefined;
}

export interface GetCitizenByExternalIdRequest {
    externalId: string;
}

export interface GetCitizenContextRequest {
    citizenId: string;
}

export interface GetCitizensAppStatusRequest {
    citizenIds?: string[] | undefined;
}

export interface GetNewChatMessagesRequest {
    chatId: string;
    citizenId: string;
    afterMessageId?: string | undefined;
}

export interface GetNewsItemRequest {
    newsItemId: string;
}

export interface GetNewsItemAttachmentRequest {
    newsItemId: string;
    documentId: string;
}

export interface GetNewsItemRecipientsRequest {
    newsItemId: string;
}

export interface GetNewsItemsForCitizenRequest {
    citizenId: string;
}

export interface GetNewsItemStatisticsRequest {
    newsItemId: string;
}

export interface GetNudgeCitizensRequest {
    citizenIds?: string[] | undefined;
}

export interface GetNudgeQuestionnaireOffersRequest {
    questionnaireId: string;
}

export interface GetAgreementByIdRequest {
    agreementId: string;
}

export interface GetInitialCaseWorkerIdForCreateReferralRequest {
    citizenId: string;
}

export interface GetLetterContentForExternalOperatorReferralRequest {
    citizenId: string;
    caseWorkerId: string;
    agreementId: string;
    justification?: string | undefined;
    startDate: Date | string;
    endDate: Date | string;
}

export interface GetLetterPreviewForExternalOperatorReferralRequest {
    citizenId: string;
    caseWorkerId: string;
    agreementId: string;
    startDate: Date | string;
    endDate: Date | string;
    justification?: string | undefined;
    letterInformation?: LetterInformation | undefined;
}

export interface GetReferralByIdRequest {
    referralId: string;
}

export interface GetReferralsByAgreementForListViewRequest {
    agreementId: string;
}

export interface GetReferralsForListViewRequest {
    citizenId: string;
}

export interface DynamicLinksRequest {
    resourceType?: string | undefined;
    resourceId?: string | undefined;
}

export interface GetPostRequestParametersRequest {
    citizenId: string;
    postRequestTypes?: PostRequestType[] | undefined;
}

export interface DownloadGeneratedFileRequest {
    filingDeliveryId: string;
}

export interface GetFilingDeliveryRequest {
    filingDeliveryId: string;
}

export interface GetHandicapDeliveryRequest {
    filingDeliveryId: string;
}

export interface GetTradeCodesRequest {
    companyId: string;
}

export interface GetCompanyIdByTagIdRequest {
    id: string;
}

export interface GetTagRequest {
    id: string;
}

export interface GetTagsRequest {
    companyId: string;
}

export interface CheckSpecialCircumstanceForOverlapRequest {
    companyId: string;
}

export interface GetCompanyIdBySpecialCircumstanceIdRequest {
    id: string;
}

export interface GetSpecialCircumstanceRequest {
    id: string;
}

export interface GetSpecialCircumstanceDocumentsFromDocumentArchiveRequest {
    documentIds?: string[] | undefined;
}

export interface GetSpecialCircumstanceDocumentsFromShelfInDocumentArchiveRequest {
    shelfId: string;
}

export interface GetSpecialCircumstancesRequest {
    companyId: string;
}

export interface GetSpecialCircumstanceTargetGroupRequest {
    id: string;
}

export interface GetSpecialCircumstanceTargetGroupsRequest {
    specialCircumstanceId: string;
}

export interface ValidateCircumstanceForOverlapRequest {
    companyId: string;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    circumstanceTypeCode: CircumstanceTypeCode;
}

export interface GetCompaniesBasicRequest {
    companyIds?: string[] | undefined;
}

export interface GetCompanyAttentionNotesRequest {
    companyId: string;
}

export interface GetCompanyBasicRequest {
    companyId?: string | undefined;
    productionUnitId?: string | undefined;
}

export interface GetCompanyIdByAssociatedCaseWorkerIdRequest {
    id: string;
}

export interface GetCompanyIdByLabourNeedIdRequest {
    id: string;
}

export interface GetCompanyCrmFeatureSettingRequest {
    featureName?: string | undefined;
}

export interface DraftCompanyDialogCitizenNoteRequest {
    transcription?: string | undefined;
    companyId: string;
    dialogSupportId: string;
    citizenName?: string | undefined;
    citizenId?: string | undefined;
    instructions?: string | undefined;
}

export interface EvaluateCompanyDialogDraftRequest {
    transcription?: string | undefined;
    draft?: string | undefined;
    instructions?: string | undefined;
    companyId: string;
    dialogSupportId: string;
}

export interface ExtractCompanyDialogTasksRequest {
    transcription?: string | undefined;
    companyId: string;
    dialogSupportId: string;
    instructions?: string | undefined;
}

export interface GetAppointmentByIdForNoteRequest {
    appointmentId: string;
}

export interface GetCompanyByCompanyNoteIdRequest {
    id: string;
}

export interface GetCompanyDialogCitizenSuggestionsRequest {
    companyId: string;
}

export interface GetCompanyDialogTranscriptionBySessionIdRequest {
    sessionId: string;
    companyId: string;
    dialogSupportId?: string | undefined;
}

export interface GetCompanyNoteDataRequest {
    id: string;
}

export interface GetCompanyInteractionNotesRequest {
    companyId: string;
}

export interface GetCompanyNoteDispatchStatusRequest {
    companyNoteId: string;
}

export interface GetCompanyNoteDocumentsFromShelfInDocumentArchiveRequest {
    shelfId: string;
}

export interface GetCompanyNoteTitleRequest {
    companyNoteId: string;
}

export interface GetCopanyNoteDocumentsFromDocumentArchiveRequest {
    documentIds?: string[] | undefined;
}

export interface GetNoteFormDataRequest {
    companyId: string;
    existingInteractionPurposeId?: string | undefined;
    existingInteractionResultId?: string | undefined;
    existingSecondaryInteractionResultIds?: string[] | undefined;
}

export interface SummarizeCompanyDialogRequest {
    transcription?: string | undefined;
    companyId: string;
    dialogSupportId: string;
    instructions?: string | undefined;
}

export interface DeleteCompanyInteractionNoteRequest {
    id: string;
}

export interface UpsertCompanyInteractionNoteRequest {
    companyInteractionNoteDto?: CompanyInteractionNoteDto | undefined;
    temporaryFileIds?: string[] | undefined;
}

export interface GetFvdbContactsRequest {
    companyId: string;
}

export interface GetCompanyDetailsByIdRequest {
    companyId: string;
}

export interface GetCompanyNoteRequest {
    companyId: string;
}

export interface GetEmploymentOverviewRequest {
    companyId: string;
}

export interface GetLabourNeedByIdRequest {
    companyLabourNeedsId: string;
}

export interface GetLabourNeedsForCompanyRequest {
    companyId: string;
}

export interface GetLatestAccountNoteRequest {
    companyId: string;
}

export interface GetNextAppointmentRequest {
    companyId: string;
}

export interface GetNumberOfActiveSickLeaveAbsencesRequest {
    companyId: string;
}

export interface GetPrimaryCompanyContactPersonRequest {
    companyId: string;
}

export interface DeleteLabourNeedRequest {
    labourNeedId: string;
    companyId: string;
}

export interface SetPrimaryCompanyContactPersonRequest {
    companyId: string;
    contactPersonId?: string | undefined;
}

export interface UpsertCompanyNoteRequest {
    companyNote?: ComapnyNoteModel | undefined;
}

export interface UpsertLabourNeedsRequest {
    id?: string | undefined;
    companyId: string;
    startdate?: Date | string | undefined;
    enddate?: Date | string | undefined;
    occupationId?: string | undefined;
    numberToFill?: number | undefined;
    jobcenterParticipationWanted?: boolean | undefined;
    occupationQualifications?: string[] | undefined;
    targetGroups?: string[] | undefined;
    tradeCodes?: string[] | undefined;
}

export interface UpsertResponsibleCaseWorkerOrTeamRequest {
    companyIds?: string[] | undefined;
    responsibleCaseWorkerId?: string | undefined;
    responsibleTeamId: string;
}

export interface GetCompanyContactPersonDetailsByIdRequest {
    contactPersonId?: string | undefined;
    companyId: string;
}

export interface GetCompanyContactPersonsForOverviewRequest {
    companyId: string;
}

export interface GetCompanyIdByCompanyContactPersonIdRequest {
    id: string;
}

export interface GetPrivateContactPersonDetailsByIdRequest {
    contactPersonId?: string | undefined;
}

export interface GetPrivateContactPersonsByEmailOrPhoneRequest {
    email?: string | undefined;
    phone?: string | undefined;
}

export interface GetCompanyVisitActivitiesRequest {
    companyId: string;
}

export interface GetCompanyVisitCompanyInfoExtendedRequest {
    companyId: string;
}

export interface GetCompanyVisitRecruitmentsRequest {
    companyId: string;
}

export interface CompanyVisitPreparationHighlightOverviewRequest {
    companyId: string;
}

export interface GetNotesAndTasksOverviewRequest {
    companyId: string;
}

export interface FindCitizenCasesRequest {
    searchTerm?: string | undefined;
}

export interface GetCompanyTaskRequest {
    taskId: string;
}

export interface GetCompanyTasksMetaDataRequest {
    companyId: string;
    filter?: CompanyTaskFilter | undefined;
}

export interface LoadCitizenCaseRequest {
    caseId: string;
}

export interface GetEditableContentRequest {
    templateId: number;
    variantId?: number | undefined;
    renderTemplateVariables?: RenderTemplateVariables | undefined;
}

export interface GetCompanyInfoRequest {
    companyId: string;
}

export interface GetCompanyPdfFormLinkRequest {
    companyId: string;
    systemSessionGroupId: string;
}

export interface GetCompanyPdfFormSubmittedRequest {
    systemSessionGroupId?: string | undefined;
    entityId: string;
}

export interface GetContactPersonsCompanyRequest {
    companyId: string;
}

export interface GetCompanyEditableContentForPdfFormsRequest {
    renderTemplateVariables?: RenderTemplateVariables | undefined;
    companyNameAndAdress?: string | undefined;
}

export interface GetGeneratedPdfRequest {
    templateId: number;
    variantId?: number | undefined;
    content?: string | undefined;
    address?: string | undefined;
    attention?: string | undefined;
    name?: string | undefined;
    renderTemplateVariables?: RenderTemplateVariablesDto | undefined;
}

export interface GetStandardAttachmentsForCompanyRequest {
    templateCodeName?: string | undefined;
    recipientType: number;
    recipientId: string;
}

export interface GetCompanyCrowdLetterPreviewAsPdfRequest {
    templateId: number;
    variantId?: number | undefined;
    content?: string | undefined;
    renderTemplateVariables?: RenderTemplateVariables | undefined;
    recipientEnvelopeAddress?: RecipientEnvelopeAddress | undefined;
}

export interface GetCompanyChangeLogsByQueryRequest {
    from?: Date | string | undefined;
    to?: Date | string | undefined;
    operations?: ChangeOperationV2[] | undefined;
    postTypes?: string[] | undefined;
    userId?: string | undefined;
    companyId: string;
    postId?: string | undefined;
    rows: number;
    sortColumns?: SortColumnV2[] | undefined;
}

export interface GetAbsencesForCompanyRequest {
    companyId: string;
}

export interface GetAssociatedCaseWorkerForCompanyRequest {
    associatedCaseWorkerId: string;
    companyId: string;
}

export interface GetAssociatedCaseWorkersForCompanyRequest {
    companyId: string;
}

export interface GetResponsibleCaseWorkerForCompanyRequest {
    companyId: string;
}

export interface GetAppointmentByIdRequest {
    id: string;
}

export interface GetAppointmentFormDataRequest {
    companyId: string;
    existingInteractionPurposeId?: string | undefined;
}

export interface GetAppointmentsForListViewRequest {
    companyId: string;
    onlyPlanned: boolean;
}

export interface GetCompanyByAppointmentIdRequest {
    id: string;
}

export interface DeleteCompanyAppointmentRequest {
    id: string;
}

export interface UpsertCompanyAppointmentRequest {
    appointment?: CompanyAppointmentModel | undefined;
}

export interface GetCalculatedDueDateRequest {
    companyNoteCreateDate: Date | string;
    numberOfWorkDaysToAdd: number;
}

export interface GetCitizenHasTargetGroupThatSupportJobReferralsRequest {
    citizenId: string;
}

export interface GetCompaniesInfoRequest {
    query?: string | undefined;
    maxResultCount: number;
}

export interface GetCompanyContactPersonsRequest {
    companyId: string;
}

export interface GetCompanyInfoRequest2 {
    companyId: string;
}

export interface GetCompanyNotesRequest {
    companyId: string;
}

export interface GetCompanyRecruitmentCandidateRequest {
    id: string;
}

export interface GetCompanyRecruitmentDetailsRequest {
    companyRecruitmentId: string;
}

export interface GetCompanyRecruitmentJobMatchesRequest {
    citizenId: string;
}

export interface GetCompanyRecruitmentPdfRequest {
    companyRecruitmentId: string;
}

export interface GetCompanyRecruitmentsByCompanyIdRequest {
    companyId: string;
}

export interface GetCompanyRecruitmentsForCandidateReferralRequest {
    query?: string | undefined;
}

export interface GetCompanyRecruitmentsFromSkillsRelinkRequest {
    citizenId: string;
    distance: number;
}

export interface GetCompetenciesRecommendationRequest {
    occupation?: string | undefined;
    jobDescription?: string | undefined;
}

export interface GetDocumentsFromDocumentArchiveForCompanyRecruitmentRequest {
    documentIds?: string[] | undefined;
}

export interface GetNumberOfCandidatesRequest {
    occupation?: string | undefined;
    competencies?: string[] | undefined;
}

export interface GetOfferInfoForNewRecruitmentRequest {
    offerId: string;
}

export interface GetQualificationRecommendationRequest {
    citizenId: string;
    companyRecruitmentRequestId: string;
}

export interface GetRecruitmentCompanyInformationRequest {
    recruitmentRequestId: string;
}

export interface GetSmartMatchCvSuggestionsRequest {
    occupationName?: string | undefined;
    occupationNameWeight: number;
    occupationEducationWeight: number;
    occupationExperienceWeight: number;
    competenceNames?: string[] | undefined;
    competencesWeight: number;
    postalCode?: string | undefined;
    cityRange: number;
    showOnlyEnrolled: boolean;
    showOnlyJobcenter: boolean;
    showOnlyFlexjobReady: boolean;
    occupationExpericeType: OccupationExpericeType;
}

export interface GetTargetGroupByCitizenIdRequest {
    citizenId: string;
}

export interface GetApplicationAreasRequest {
    universe?: string | undefined;
    resultType?: string | undefined;
}

export interface SavedQueryRequestBody {
    savedQueryId: string;
    savedQueryName?: string | undefined;
    sortColumns?: SortColumn2[] | undefined;
    columnFilters?: SearchColumnFilter[] | undefined;
}

export interface SearchDownloadRequest {
    universe: string;
    usePreviewVersion: boolean;
    queryType?: string | undefined;
    query: string;
    dslVersion?: string | undefined;
    resultType?: string | undefined;
    columns: SearchColumn[];
    sortColumns?: SortColumn2[] | undefined;
    embeddedResultType?: string | undefined;
    embeddedColumns?: SearchColumn[] | undefined;
    embeddedSortColumns?: SortColumn2[] | undefined;
    resultTypeMaximumRows?: number | undefined;
    embeddedMaximumRows?: number | undefined;
    columnFilters?: SearchColumnFilter[] | undefined;
}

export interface GetAllPermissionsRequest {
    filterRequest?: SharedPermissionFilterRequest | undefined;
    sortRequests?: SharedPermissionSortRequest[] | undefined;
    pageRequest?: SharedPermissionPageRequest | undefined;
}

export interface GetCitizenByCprRequest {
    citizenCpr?: string | undefined;
}

export interface GetCitizenFromDfdgRequest {
    citizenCpr?: string | undefined;
}

export interface GetCompanyByProductionUnitIdentifierRequest {
    productionUnitIdentifier?: string | undefined;
}

export interface GetCompanyFromCvrByProductionUnitIdentifierRequest {
    productionUnitIdentifier?: string | undefined;
}

export interface GetDashboardByIdRequest {
    savedDashboardId: string;
}

export interface GetDashboardCompositionRequest {
    dashboardId: string;
}

export interface GetDashboardsRequest {
    take: number;
    skip: number;
    query?: string | undefined;
}

export interface GetEmbeddedSearchRequest {
    query?: any | undefined;
    parentId: string;
    queryId?: string | undefined;
}

export interface GetUrlsFromFasitCrmUserFormBaseRequest {
    id: string;
}

export interface GetWorklistElementUsageRequest {
    objectType: ObjectType;
    objectId: string;
}

export interface GetWorklistUsageOverviewRequest {
    page: number;
    pageSize: number;
    view?: string | undefined;
    interval?: string | undefined;
    objectType?: ObjectType | undefined;
    sort?: WorklistUsageSort[] | undefined;
    filters?: WorklistUsageFilter[] | undefined;
    filterLinkOperator?: string | undefined;
}

export interface RankedSearchDslConfigurationNameRequest {
    universe?: string | undefined;
}

export interface GetRankedSearchRequest {
    documentTypes: string[];
    universe: string;
    queryString: string;
    page: number;
    selectedFilters?: RankedSearchDocumentTypesFilter[] | undefined;
}

export interface GetWorklistAccessControlRequest {
    savedEntityId: string;
}

export interface AnalyzeClosedSdpCaseStreamingRequest {
    caseId: string;
}

export interface GetCaseEmployerRequest {
    caseId: string;
}

export interface GetStoredCaseAnalysisRequest {
    caseId: string;
}

export interface GetVisitationAssistantRequest {
    caseId: string;
}

export interface GetReceivedUseOfForceAuthorizationRequestPdfRequest {
    citizenId: string;
    requestId: string;
}

export interface GetReceivedUseOfForceAuthorizationRequestsRequest {
    citizenId: string;
}

export interface GetUseOfForceAuthorizationsForCitizenRequest {
    citizenId: string;
}

export interface GetUseOfForceAssessmentFormPdfRequest {
    citizenId: string;
    assessmentId: string;
}

export interface GetUseOfForceAssessmentsForCitizenRequest {
    citizenId: string;
}

export interface DownloadNuphDocumentRequest {
    citizenId: string;
    nuphDocumentId: string;
    type: NuphDocumentType;
}

export interface GetAccountInfoRequest {
    citizenId: string;
}

export interface GetCitizenAndNuphIdByNuphResponseIdRequest {
    nuphResponseId: string;
}

export interface GetCitizenIdByNuphIdRequest {
    nuphId: string;
}

export interface GetNuphRequest {
    citizenId: string;
    nuphId: string;
}

export interface GetNuphAdditionalInformationRequest {
    nuphId: string;
    citizenId: string;
}

export interface GetNuphDocumentsRequest {
    nuphId: string;
    citizenId: string;
}

export interface GetNuphResponsesRequest {
    nuphId: string;
    citizenId: string;
}

export interface GetNuphsRequest {
    citizenId: string;
}

export interface GetPayoutsRequest {
    citizenId: string;
}

export interface GetUnemploymentFundRequest {
    citizenId: string;
}

export interface GetUnemploymentSummaryDetailsRequest {
    citizenId: string;
}

export interface GetTimelineDataByCitizenIdRequest {
    citizenId: string;
    filterTypes?: TimelineItemType[] | undefined;
    showAll: boolean;
    authorityOptic?: string | undefined;
}

export interface GetCitizenSurveysRequest {
    citizenId: string;
    type: ScreeningType;
}

export interface GetScreeningValidationValuesRequest {
    citizenId: string;
    screeningConfigurationId: string;
}

export interface GetAnsweredProgressionSurveysRequest {
    citizenId: string;
}

export interface GetForumFeedbackSurveysRequest {
    citizenId: string;
}

export interface GetStandardPhrasesRequest {
    target?: string | undefined;
}

export interface GetHoiCaseMainDataRequest {
    citizenId: string;
}

export interface GetHoiCompanyContactPersonsRequest {
    companyId: string;
}

export interface GetHoiDataRequest {
    citizenId: string;
}

export interface GetHoiLetterEditableContentRequest {
    hoiLetterContentViewModel?: HoiLetterContentViewModel | undefined;
}

export interface GetHoiLetterPdfPreviewRequest {
    content?: string | undefined;
    hoiLetterContentViewModel?: HoiLetterContentViewModel | undefined;
    recipientEnvelopeAddress?: RecipientEnvelopeAddress | undefined;
}

export interface GetHoiPrivateContactPersonsRequest {
    query?: string | undefined;
    maxResultSize: number;
}

export interface GetHoiSummaryRequest {
    citizenId: string;
}

export interface GetNexusCitizenExistsRequest {
    citizenId: string;
}

export interface GetNexusImportDocumentRequest {
    citizenId: string;
    nexusReferenceId: number;
    parentPathwayId: number;
}

export interface GetNexusImportEntryContentRequest {
    citizenId: string;
    nexusFormDataId: number;
}

export interface GetNexusImportLetterRequest {
    citizenId: string;
    nexusLetterId: number;
}

export interface GetNexusImportPreviewRequest {
    citizenId: string;
}

export interface GetNexusImportProgressRequest {
    citizenId: string;
    progressId: string;
}

export interface GetNexusServiceProviderImportPreviewRequest {
    citizenId: string;
}

export interface GetCitizenIdFromResumedWorkIdRequest {
    resumedWorkId: string;
}

export interface GetResumedWorkByCaseIdRequest {
    caseId: string;
}

export interface GetActiveSicknessAbsenceByCitizenIdRequest {
    citizenId: string;
}

export interface GetCloseCaseGuideDataRequest {
    citizenId: string;
    caseId: string;
}

export interface GetContactGroupByCitizenIdRequest {
    citizenId: string;
}

export interface GetSicknessAbsenceByCitizenIdRequest {
    citizenId: string;
}

export interface SicknessBenefitVisitationRequest {
    citizenId: string;
    caseId: string;
}

export interface GetPartialRecoveriesByAbsenceIdRequest {
    absenceId: string;
}

export interface GetPartialRecoveriesByCaseIdRequest {
    caseId: string;
}

export interface GetPartialRecoveryByIdRequest {
    partialRecoveryId: string;
}

export interface GetLetterContentForMissingParticipationRequest {
    templateCode?: string | undefined;
    renderTemplateVariables?: RenderTemplateVariables | undefined;
}

export interface GetLetterPreviewForMissingParticipationRequest {
    letterInformation?: LetterInformation2 | undefined;
    renderTemplateVariables?: RenderTemplateVariables | undefined;
    templateCode?: string | undefined;
}

export interface GetMissingParticipationByIdRequest {
    missingParticipationId: string;
}

export interface GetMissingParticipationInStatusUnderPartyHearingByCaseIdRequest {
    caseId: string;
}

export interface GetMissingParticipationsByCaseIdRequest {
    caseId: string;
}

export interface GetExpectedJobResumptionByIdRequest {
    expectedJobResumptionId: string;
}

export interface GetExpectedJobResumptionsListRequest {
    citizenId: string;
    caseId?: string | undefined;
    absenceId?: string | undefined;
}

export interface GetBenefitExtensionAssessmentByCaseIdRequest {
    caseId: string;
}

export interface GetBenefitExtensionAssessmentDataRequest {
    benefitExtensionAssessmentId: string;
}

export interface GetOpenBenefitExtensionAssessmentIdRequest {
    citizenId: string;
    caseId: string;
}

export interface GetUseOfForceAssignmentOptionsRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetUseOfForceAuthorizationRequestRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    requestId: string;
}

export interface GetUseOfForceAuthorizationRequestPdfRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    requestId: string;
}

export interface GetUseOfForceAuthorizationRequestsForCitizenRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetUseOfForceAuthorizationsForServiceProviderUnitRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetUseOfForceCitizenStatementRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    incidentId: string;
    statementId: string;
}

export interface GetUseOfForceHygieneRestraintLogPdfRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    logId: string;
}

export interface GetUseOfForceHygieneRestraintLogsForCitizenRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetUseOfForceIncidentRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    incidentId: string;
}

export interface GetUseOfForceIncidentPdfRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    incidentId: string;
}

export interface GetUseOfForceIncidentsForCitizenRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetUseOfForceSummaryRegistrationRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    registrationId: string;
}

export interface GetUseOfForceSummaryRegistrationCitizenStatementRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    registrationId: string;
    statementId: string;
}

export interface GetUseOfForceSummaryRegistrationPdfRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    registrationId: string;
}

export interface GetUseOfForceSummaryRegistrationsForCitizenRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetTrafficLightRequest {
    citizenId: CitizenId;
    serviceProviderUnitId: ServiceProviderUnitId;
}

export interface GetTrafficLightHistoryRequest {
    citizenId?: CitizenId | undefined;
    serviceProviderUnitId?: ServiceProviderUnitId | undefined;
}

export interface GetSpLinkAvailabilityRequest {
    serviceProviderUnitId: string;
}

export interface GetSpLinkUrlRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetCitizenFromFasitOrExternalSourceRequest {
    citizenCpr?: string | undefined;
}

export interface GetServiceProviderUnitRequest {
    serviceProviderUnitId?: ServiceProviderUnitId | undefined;
}

export interface GenerateSummaryForFollowupTranscriptionRequest {
    citizenId: string;
    transcriptionSessionId?: string | undefined;
}

export interface GetObservationTypeRequest {
    observationTypeId: string;
}

export interface GetObservationsRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetMedicinePackageDetailsRequest {
    detailsPath: string;
}

export interface SearchMedicinePackagesRequest {
    searchTerm?: string | undefined;
    searchType: MedicineSearchType;
}

export interface GetCountDoubleControlDeclarationRequest {
    citizenId: string;
    colleagueId: string;
    drugMedicationId: string;
    unit: MedicineUnit;
}

export interface GetDisposalDoubleControlDeclarationRequest {
    citizenId: string;
    colleagueId: string;
    packageId: string;
    quantity: number;
}

export interface GetDoubleControlDeclarationRequest {
    citizenId: string;
    colleagueId: string;
    actualTime: Date | string;
}

export interface GetLatestPnAdministrationRequest {
    citizenId: string;
    drugMedicationId: string;
}

export interface GetMedicineAdministrationsAwaitingDoubleControlRequest {
    citizenId: string;
}

export interface GetMedicineAdministrationsForPeriodRequest {
    citizenId: string;
    fromDay: string;
    toDay: string;
}

export interface GetMedicineInventoryControlSheetRequest {
    citizenId: string;
    drugMedicationId: string;
    unit: MedicineUnit;
    fromDay: string;
    toDay: string;
    packageId?: string | undefined;
}

export interface GetMedicineInventoryForCitizenRequest {
    citizenId: string;
}

export interface GetMedicineInventoryMovementsAwaitingDoubleControlRequest {
    citizenId: string;
}

export interface GetReturnDoubleControlDeclarationRequest {
    citizenId: string;
    colleagueId: string;
    packageId: string;
    quantity: number;
    returnedTo?: string | undefined;
}

export interface GetDoseDispensingCardPdfRequest {
    citizenId: string;
    serviceProviderUnitId?: string | undefined;
}

export interface GetMedicineCardForCitizenRequest {
    citizenId: string;
}

export interface GetMedicineCardPrintPdfRequest {
    citizenId: string;
    serviceProviderUnitId?: string | undefined;
}

export interface GenerateInterventionObjectiveStatusDraftRequest {
    citizenId?: CitizenId | undefined;
    serviceProviderUnitId?: ServiceProviderUnitId | undefined;
    assignmentId?: AssignmentId | undefined;
    interventionObjectiveId?: InterventionObjectiveId | undefined;
}

export interface GetInterventionObjectiveStatusByStatusIdRequest {
    citizenId?: CitizenId | undefined;
    statusId?: ServiceProviderInterventionObjectiveStatusId | undefined;
}

export interface GetInterventionObjectiveStatusesByAssignmentIdRequest {
    citizenId?: CitizenId | undefined;
    assignmentId?: AssignmentId | undefined;
}

export interface GetHealthConditionHistoryRequest {
    citizenId: CitizenId;
    serviceProviderUnitId: ServiceProviderUnitId;
    code: HealthConditionCode;
}

export interface GetHealthOverviewRequest {
    citizenId: CitizenId;
    serviceProviderUnitId: ServiceProviderUnitId;
}

export interface GetProblemAreaHistoryRequest {
    citizenId: CitizenId;
    serviceProviderUnitId: ServiceProviderUnitId;
    code: ProblemAreaCode;
}

export interface GetAssignmentDistributionRequest {
    assignmentId?: AssignmentId | undefined;
}

export interface GetServiceProviderCitizenNotesRequest {
    citizenId: CitizenId;
    serviceProviderUnitId: ServiceProviderUnitId;
}

export interface GetServiceProviderCitizenDescriptionRequest {
    citizenId: string;
}

export interface GetServiceProviderCitizenCalendarEventsRequest {
    citizenId: string;
    fromDate: Date | string;
    toDate: Date | string;
}

export interface Request {
    citizenId: string;
    fromDate: Date | string;
    toDate: Date | string;
}

export interface GenerateServiceProviderCitizenBriefRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetStoryRemindersRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface ProposeRegistrationsFromStoryRequest {
    citizenId: string;
    serviceProviderUnitId: string;
    text?: string | undefined;
}

export interface ScreenCitizenDiaryForUseOfForceRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetAssessmentDataForRecommendationRequest {
    assessmentId?: string | undefined;
}

export interface GetAssessmentDataForRulingImportRequest {
    assessmentId: string;
}

export interface GetAssessmentsForRulingRequest {
    citizenId: string;
}

export interface GetCasesForRulingRequest {
    citizenId: string;
}

export interface GetCitizenPersonContactsForRulingRequest {
    citizenId: string;
}

export interface GetConductedInterviewsForRulingContinuationRequest {
    citizenId: string;
    caseId: string;
    followUpInterviewId?: string | undefined;
}

export interface GetDocumentsForRulingRequest {
    citizenId: string;
}

export interface GetGrantsForRulingRequest {
    citizenId: string;
}

export interface GetJournalNotesForRulingRequest {
    citizenId: string;
}

export interface GetRulingRequest {
    rulingId: string;
}

export interface GetRulingsForCaseRequest {
    citizenId: string;
    caseId: string;
}

export interface GetRulingVisitationBookingRequest {
    rulingId: string;
}

export interface GetRulingVisitationBookingOptionsRequest {
    rulingId: string;
    grantTypeIds: string[];
}

export interface GetAppealFormRequest {
    rulingId: string;
    complaintId: string;
}

export interface GetAuthorityCitizenContextRequest {
    citizenId: string;
}

export interface GetByCprRequest {
    citizenCpr?: string | undefined;
}

export interface GetByIdsRequest {
    citizenIds?: string[] | undefined;
}

export interface GetCitizenDfdgWarningInfoRequest {
    citizenId: string;
}

export interface GetCitizenDueDatesRequest {
    citizenId: string;
}

export interface GetCitizenHeaderRequest {
    citizenId: string;
}

export interface GetCitizenOverviewSummaryRequest {
    citizenId: string;
}

export interface GetCrmCitizenOverviewUrlRequest {
    citizenId: string;
}

export interface GetExternalOperatorReferralTeamIdByCitizenIdRequest {
    citizenId: string;
}

export interface GetMedicalCollaboratorCitizenContextRequest {
    citizenId: string;
}

export interface GetMedicalCollaboratorCitizenHeaderRequest {
    citizenId: string;
}

export interface GetOrAddCitizenRequest {
    citizenCpr?: string | undefined;
}

export interface GetRestrictedFromPrimaryCaseRequest {
    citizenId: string;
}

export interface GetSocialProviderCitizenContextRequest {
    citizenId: string;
}

export interface GetSocialProviderCitizenHeaderRequest {
    citizenId: string;
    serviceProviderUnitId?: string | undefined;
}

export interface DownloadPlanPdfPreviewRequest {
    citizenId: string;
}

export interface GetActivePlanRequest {
    citizenId: string;
}

export interface GetAllowedPlanTypesRequest {
    citizenId: string;
}

export interface GetCitizenIdByContractIdRequest {
    contractId: string;
}

export interface GetCitizenIdByPlanIdRequest {
    planId: string;
}

export interface GetContactForCitizenRequest {
    citizenId: string;
}

export interface GetContractRequest {
    citizenId: string;
}

export interface GetEditableContractRequest {
    citizenId: string;
}

export interface GetEditablePlanRequest {
    citizenId: string;
}

export interface GetEducationImpositionRequest {
    citizenId: string;
}

export interface GetJobSearchDefinitionRequest {
    citizenId: string;
}

export interface GetLetAsylPdfDataRequest {
    citizenId: string;
}

export interface GetPlanInfoRequest {
    citizenId: string;
}

export interface GetPlanVersionPdfRequest {
    citizenId: string;
    versionIdentifier: string;
}

export interface GetPlanVersionsRequest {
    citizenId: string;
}

export interface GetSelectableGoalsRequest {
    planTypeId: string;
}

export interface HasLegalContractRequest {
    citizenId: string;
}

export interface MayEditPlanRequest {
    citizenId: string;
}

export interface MayRegisterJobSearchDefinitionRequest {
    citizenId: string;
}

export interface GetCitizenIncomeRequest {
    citizenId: string;
    showOnlyRelevant: boolean;
}

export interface GetCitizenIncomeLiveDataRequest {
    citizenId: string;
}

export interface ChangePlanTypeRequest {
    citizenId: string;
    newPlanTypeId: string;
}

export interface PrintMyPlanRequest {
    citizenId: string;
    journalNoteComment?: string | undefined;
}

export interface PublishContractRequest {
    citizenId: string;
    contract?: JobcenterContractEditModel | undefined;
}

export interface PublishPlanRequest {
    citizenId: string;
    plan?: PlanEditViewModel | undefined;
}

export interface ReactivatePlanRequest {
    citizenId: string;
    reason?: string | undefined;
}

export interface SaveContractDraftRequest {
    citizenId: string;
    contract?: JobcenterContractEditModel | undefined;
}

export interface SaveDraftEducationPlanRequest {
    citizenId: string;
    plan?: PlanEditViewModel | undefined;
}

export interface SavePlanDraftRequest {
    citizenId: string;
    plan?: PlanEditViewModel | undefined;
}

export interface SendMyPlanAsLetterRequest {
    citizenId: string;
    journalNoteComment?: string | undefined;
}

export interface DownloadCorrespondenceDocumentRequest {
    citizenId: string;
    correspondenceMessageId: string;
    documentReference?: string | undefined;
}

export interface DownloadCorrespondenceDocumentForServiceProviderRequest {
    citizenId: string;
    correspondenceMessageId: string;
    documentReference?: string | undefined;
}

export interface DownloadMedicalDocumentRequest {
    citizenId: string;
    medicalRequestId: string;
    documentReference?: string | undefined;
}

export interface DownloadMedicalDocumentForMedicalCollaboratorRequest {
    citizenId: string;
    medicalRequestId: string;
    documentReference?: string | undefined;
}

export interface GetCaseTargetGroupTypeRequest {
    caseId: string;
}

export interface GetCitizenCasesMedicalRequest {
    citizenId: string;
}

export interface GetCitizenContactInfoRequest {
    citizenId: string;
}

export interface GetCitizenDoctorAsCorrespondenceReceiverRequest {
    citizenId: string;
}

export interface GetCitizenDoctorInfoRequest {
    citizenId: string;
}

export interface GetCitizenFormCodeRequest {
    requestFormCode?: string | undefined;
}

export interface GetCitizenForMedicalCollaborationRequest {
    citizenCpr?: string | undefined;
}

export interface GetCitizenHospitalStaysRequest {
    citizenId: string;
}

export interface GetCitizenIdByCorrespondenceMessageIdRequest {
    correspondenceMessageId: string;
}

export interface GetCitizenIdByRequestFormIdRequest {
    requestFormId: string;
}

export interface GetCitizenLetterJournalNoteRequest {
    citizenId: string;
    requestFormId: string;
}

export interface GetCitizenPatientInfoRequest {
    citizenId: string;
}

export interface GetContactShortNameRequest {
    contactName?: string | undefined;
    maxLength: number;
}

export interface GetCorrespondenceMessageRequest {
    citizenId: string;
    correspondenceMessageId: string;
}

export interface GetCorrespondenceMessageForServiceProviderRequest {
    citizenId: string;
    correspondenceMessageId: string;
}

export interface GetCorrespondenceMessagesRequest {
    citizenId: string;
}

export interface GetCorrespondenceMessagesForServiceProviderRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetCorrespondenceMessageSignatureRequest {
    serviceProviderUnitId?: string | undefined;
}

export interface GetDoctorResponseDeadlineEnabledRequest {
    requestFormCode?: string | undefined;
}

export interface GetMedicalCollaboratorMedicalRequestsRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetMedicalRequestRequest {
    citizenId: string;
    medicalRequestId: string;
}

export interface GetMedicalRequestForMedicalCollaboratorRequest {
    citizenId: string;
    medicalRequestId: string;
}

export interface GetMedicalRequestsRequest {
    citizenId: string;
}

export interface GetRequestFormCodeByRequestFormIdRequest {
    requestFormId: string;
}

export interface GetSorNodesQueryRequest {
    parentNode?: string | undefined;
}

export interface GetSorSearchResultByLookupQueryRequest {
    query?: string | undefined;
    forceCanReceiveCorrespondence: boolean;
}

export interface GetSorTreeSearchResultByLookupQueryRequest {
    query?: string | undefined;
    forceCanReceiveCorrespondence: boolean;
}

export interface ValidateCorrespondenceAttachmentsRequest {
    attachments?: AttachmentToValidateDto[] | undefined;
}

export interface GetInitalDataForJournalReportRequest {
    citizenId: string;
}

export interface GetJournalNotesByCaseIdsAndPeriodRequest {
    citizenId: string;
    caseIds?: string[] | undefined;
    fromDate: Date | string;
    toDate: Date | string;
    includeJournalNotesWithoutCase: boolean;
    dateField?: JournalReportDateField | undefined;
}

export interface GetJournalReportProgressByIdRequest {
    progressId: string;
    citizenId: string;
}

export interface GetScannedJournalNoteResultsRequest {
    citizenId: string;
    journalNoteIds?: string[] | undefined;
}

export interface DownloadDocumentFromBffRequest {
    documentIdentifier?: string | undefined;
}

export interface DownloadDocumentFromDocumentArchiveRequest {
    documentIdentifier?: string | undefined;
}

export interface DownloadJournalNoteAttachmentRequest {
    attachmentId: string;
    citizenId: string;
}

export interface DownloadJournalReportFileRequest {
    fileId: string;
    citizenId: string;
    journalReportId: string;
}

export interface GetCasesForCitizenRequest {
    citizenId: string;
}

export interface GetCaseTargetGroupRequest {
    citizenId: string;
    caseId: string;
}

export interface GetCaseworkerRequest {
    citizenId: string;
    caseId: string;
}

export interface GetCitizenIdByJournalNoteIdRequest {
    journalNoteId: string;
}

export interface GetCrmFeatureSettingRequest {
    featureName?: string | undefined;
}

export interface GetJournalNoteRequest {
    journalNoteId: string;
    citizenId: string;
}

export interface GetJournalNoteDetailsForCitizenIdRequest {
    citizenId: string;
    journalNoteIds: string[];
}

export interface GetJournalNotePageForCitizenIdRequest {
    citizenId: string;
    pageRequest: PageRequest;
    sortRequest: SortRequest;
    filterRequest: FilterRequest;
    opticId?: string | undefined;
}

export interface GetJournalNotesForCitizenIdRequest {
    citizenId: string;
    pageRequest: PageRequest;
    sortRequest: SortRequest;
    filterRequest: FilterRequest;
    opticId?: string | undefined;
}

export interface GetJournalReportByIdRequest {
    journalReportId: string;
    citizenId: string;
}

export interface GetJournalReportJobStatusRequest {
    citizenId: string;
    journalReportJobId?: string | undefined;
}

export interface GetJournalReportLinkRequest {
    citizenId: string;
}

export interface GetJournalReportsForCitizenIdRequest {
    citizenId: string;
}

export interface SearchJournalNotesForCitizenPersonContactRequest {
    citizenId: string;
    titleSearch?: string | undefined;
    isSocialOptic: boolean;
    opticId?: string | undefined;
}

export interface DownloadDocumentAttachmentRequest {
    attachmentId: string;
    citizenId: string;
}

export interface GetCitizenCasesRequest {
    citizenId: string;
}

export interface GetCitizenCvRequest {
    citizenId: string;
}

export interface GetCitizenIdByDocumentIdRequest {
    documentId: string;
}

export interface GetDocumentAsPdfRequest {
    attachments?: DocumentAttachmentSimple[] | undefined;
    documentContent?: string | undefined;
    citizenId: string;
}

export interface GetDocumentByIdRequest {
    documentId: string;
    citizenId: string;
}

export interface Request2 {
    documentId: string;
    citizenId: string;
}

export interface GetDocumentsForCitizenIdRequest {
    citizenId: string;
    filterBySocialCases?: boolean | undefined;
}

export interface GetDocumentTemplatesRequest {
    citizenId: string;
    caseId?: string | undefined;
}

export interface GetRenderedTemplateRequest {
    templateId: number;
    variantId?: number | undefined;
    variantExternalKey?: string | undefined;
    attachments?: Attachment[] | undefined;
    citizenId: string;
    renderTemplateVariables?: RenderTemplateVariables | undefined;
}

export interface GetServiceProviderDocumentsForCitizenIdRequest {
    citizenId: string;
}

export interface GetStandardAttachmentDocumentsRequest {
    standardAttachmentIds?: string[] | undefined;
}

export interface CreateJournalNoteRequest {
    journalNoteCreateModel?: JournalNoteCreateModel | undefined;
}

export interface GenerateSummaryForJournalNoteTranscriptionRequest {
    citizenId: string;
    transcriptionSessionId?: string | undefined;
}

export interface RemoveJournalReportRequest {
    citizenId: string;
    journalReportId: string;
}

export interface UpdateJournalReportCommentRequest {
    citizenId: string;
    journalReportId: string;
    comment?: string | undefined;
}

export interface CitizenAllowJobReferralsRequest {
    citizenId: string;
}

export interface GetCompanyRecruitmentForJobReferralRequest {
    companyRecruitmentId: string;
}

export interface GetCompanyRecruitmentsByLookupQueryRequest {
    query?: string | undefined;
    citizenId: string;
}

export interface GetCompanyContactPersonsByCompanyIdForJobReferralRequest {
    companyId: string;
}

export interface GetTargetGroupCodeByCitizenIdRequest {
    citizenId: string;
}

export interface GetActiveEnrollmentRequest {
    citizenId: string;
}

export interface GetEnrollmentByIdRequest {
    enrollmentId: string;
    citizenId: string;
}

export interface GetEnrollmentCancellationDataRequest {
    citizenId: string;
}

export interface GetEnrollmentCreationDataRequest {
    citizenId: string;
}

export interface GetEnrollmentsForCitizenRequest {
    citizenId: string;
}

export interface GetCitizenIdByContactGroupIdRequest {
    contactGroupId: string;
}

export interface GetContactGroupCreateDataRequest {
    citizenId: string;
}

export interface GetContactGroupEditViewDataRequest {
    contactGroupId: string;
}

export interface GetContactGroupsForCitizenRequest {
    citizenId: string;
}

export interface GetBenefitDecisionsForCitizenRequest {
    citizenId: string;
}

export interface GetJoblogDocumentRequest {
    citizenId: string;
    joblogDocumentIdentifier: string;
}

export interface GetJoblogEntriesRequest {
    citizenId: string;
}

export interface GetJoblogEntryRequest {
    citizenId: string;
    joblogSearchId: string;
}

export interface GetActiveBookingsForCaseRequest {
    citizenId: string;
    caseId: string;
}

export interface GetBookingRequest {
    bookingId: string;
}

export interface GetBookingLetterEditableContentRequest {
    templateId: number;
    variantId?: number | undefined;
    bookingLetterContentViewModel?: BookingLetterContentViewModel | undefined;
}

export interface GetBookingsByCitizenIdRequest {
    citizenId: string;
}

export interface GetBookingsForCitizenRequest {
    citizenId: string;
}

export interface GetBookingsForNuphRequest {
    citizenId: string;
}

export interface GetBookInterviewGuideDataRequest {
    citizenId: string;
    bookingId?: string | undefined;
    caseworkerId?: string | undefined;
    opticId?: string | undefined;
}

export interface GetCaseworkerMeetingLocationDetailsRequest {
    caseworkerId: string;
}

export interface GetCompaniesRequest {
    query?: string | undefined;
    maxResultSize: number;
}

export interface GetConductInterviewGuideDataRequest {
    interviewId?: string | undefined;
    bookingId?: string | undefined;
    citizenId: string;
    dialogSupportId?: string | undefined;
}

export interface GetContactPersonsForCompanyRequest {
    companyId: string;
}

export interface GetCrowdBookingGuideDataRequest {
    citizenIds?: string[] | undefined;
}

export interface GetCurrentPersonCategoryRequest {
    citizenId: string;
}

export interface GetDialogSupportInterviewConfigurationRequest {
    interviewType: number;
    targetGroupId: string;
    dialogSupportId?: string | undefined;
}

export interface GetDialogSupportPromptsRequest {
    interviewType: number;
    targetGroupId?: string | undefined;
    dialogSupportId?: string | undefined;
}

export interface GetDocumentsForAliasesFromDocumentArchiveRequest {
    documentAliasIds?: number[] | undefined;
}

export interface GetDocumentsFromDocumentArchiveRequest {
    documentIds?: string[] | undefined;
}

export interface GetInterpreterDataForConductingInterviewRequest {
    citizenId: string;
    interviewTypeCode: number;
    dialogSupportId?: string | undefined;
}

export interface GetInterviewRequest {
    interviewId: string;
    dialogSupportId?: string | undefined;
}

export interface GetInterviewAgreementTemplateRequest {
    citizenId: string;
    interviewTypeUnion?: InterviewTypeUnion | undefined;
    dialogSupportId?: string | undefined;
}

export interface GetInterviewBookingDeadlineRequest {
    citizenId: string;
}

export interface GetJournalNoteIdRequest {
    request?: GetInterviewCorrectableStatusRequest | undefined;
}

export interface GetInterviewOverviewStatRequest {
    citizenId: string;
}

export interface GetInterviewsForCitizenRequest {
    citizenId: string;
}

export interface GetInterviewSummaryRequest {
    citizenId: string;
}

export interface GetInterviewTypesForTargetGroupRequest {
    targetGroupId?: string | undefined;
    citizenId?: string | undefined;
    opticId?: string | undefined;
}

export interface GetInterviewUnemploymentForCitizenRequest {
    citizenId: string;
}

export interface GetNextInterviewDataRequest {
    citizenId: string;
}

export interface GetOverviewMenuActionDataRequest {
    citizenId: string;
}

export interface GetPdfPreviewRequest {
    templateId: number;
    variantId?: number | undefined;
    content?: string | undefined;
    bookingLetterContentViewModel?: BookingLetterContentViewModel | undefined;
    recipientEnvelopeAddress?: RecipientEnvelopeAddress | undefined;
}

export interface GetPersonCategoryGuideDataRequest {
    citizenId: string;
}

export interface GetPreviousInterviewAgreementRequest {
    citizenId: string;
    interviewTypeUnion?: InterviewTypeUnion | undefined;
    dialogSupportId?: string | undefined;
}

export interface GetPrivateContactPersonsRequest {
    query?: string | undefined;
    maxResultSize: number;
}

export interface GetRankedCasesForInterviewJournalizationRequest {
    citizenId: string;
    selectedInterviewTypeCode: number;
    dialogSupportId?: string | undefined;
}

export interface GetStandardAttachmentDocumentsFromArchiveRequest {
    standardAttachmentIds?: string[] | undefined;
}

export interface GetTranscriptionBySessionIdRequest {
    sessionId?: string | undefined;
    citizenId: string;
    dialogSupportId?: string | undefined;
}

export interface IsCitizenCprActiveRequest {
    citizenId: string;
}

export interface IsCitizenInTargetGroupRequest {
    citizenId: string;
}

export interface RecalculateInterviewOverviewRequest {
    recalculateDates?: Date | string[] | undefined;
}

export interface GetAbsenceOverviewRequest {
    citizenId: string;
}

export interface GetCvOverviewRequest {
    citizenId: string;
}

export interface GetHeaderOverviewRequest {
    citizenId: string;
}

export interface GetHighlightOverviewRequest {
    citizenId: string;
}

export interface GetJobReadyCitizenProgressOverviewRequest {
    citizenId: string;
}

export interface GetJobReadyInformationRequest {
    citizenId: string;
}

export interface GetJobReadySelfScreeningOverviewRequest {
    citizenId: string;
}

export interface GetJournalNotesRequest {
    citizenId: string;
    configurationName?: string | undefined;
    section: number;
}

export interface GetProgressOverviewRequest {
    citizenId: string;
}

export interface GetCitizenProgressOverviewRequest {
    citizenId: string;
}

export interface GetInformationFormRequest {
    citizenId: string;
    caseId?: string | undefined;
}

export interface GetMedicalJournalNotesRequest {
    citizenId: string;
}

export interface GetPersonalConditionsRequest {
    citizenId: string;
}

export interface GetSicknessBenefitCaseOverviewRequest {
    citizenId: string;
}

export interface GetGuideLinksRequest {
    citizenId?: string | undefined;
    guideIdentifier: GuideLinkGuideId;
}

export interface GetCasesForGrantRequest {
    citizenId: string;
    grantId?: string | undefined;
}

export interface GetCitizenIdByGrantIdRequest {
    grantId: string;
}

export interface GetGrantByIdRequest {
    grantId: string;
}

export interface GetGrantsByCaseIdRequest {
    caseId: string;
}

export interface GetOfferByIdForGrantSelectionRequest {
    offerId: string;
}

export interface GetOffersForGrantSelectionRequest {
    grantTypeId?: string | undefined;
}

export interface GetCitizenFlowOverviewRequest {
    citizenId: string;
}

export interface GetEducationEventsByCitizenIdRequest {
    citizenId: string;
}

export interface GetEducationSubscriptionByCitizenIdRequest {
    citizenId: string;
}

export interface DownloadDiaryNoteAttachmentRequest {
    attachmentId: string;
    citizenId: string;
}

export interface GetDiaryNoteRequest {
    diaryNoteId: string;
    citizenId: string;
}

export interface GetDiaryNotesForCitizenIdRequest {
    citizenId: string;
    serviceProviderUnitId?: string | undefined;
    pageRequest: DiaryNotePageRequest;
    sortRequest: DiaryNoteSortRequest;
    filterRequest: DiaryNoteFilterRequest;
}

export interface HasUnreadDiaryNotesRequest {
    citizenId: string;
    serviceProviderUnitId?: string | undefined;
}

export interface CreateDiaryNoteRequest {
    diaryNoteCreateModel?: DiaryNoteCreateModel | undefined;
}

export interface GenerateSummaryForDiaryNoteTranscriptionRequest {
    citizenId: string;
    transcriptionSessionId?: string | undefined;
}

export interface GetCitizenMessageAttachmentRequest {
    attachmentId: string;
    citizenId: string;
}

export interface GetCitizenMessageByIdRequest {
    citizenId: string;
    messageId: string;
}

export interface GetCitizenMessagesRequest {
    citizenId: string;
}

export interface GetUnemploymentFundMessagesRequest {
    citizenId: string;
}

export interface GetCandidateReferralsByCitizenIdRequest {
    citizenId: string;
}

export interface GetCitizenCvAsPdfRequest {
    citizenId: string;
}

export interface GetCitizenCvBasicRequest {
    citizenId: string;
}

export interface GetCitizenCvJobTargetsRequest {
    citizenId: string;
}

export interface GetCitizenCvStatusRequest {
    citizenId: string;
}

export interface GetCitizenCvStatusInfoRequest {
    citizenId: string;
}

export interface GetCitizenExemptionRequest {
    citizenId: string;
}

export interface GetCitizenIdRequest {
    recordId: string;
    cvSubArea?: string | undefined;
}

export interface GetCitizenJobMatchLinkRequest {
    citizenId: string;
}

export interface GetSmartMatchCitizenCvAsPdfByCprRequest {
    citizenCpr?: string | undefined;
}

export interface GetCvAsPdfByCprNumberRequest {
    citizenCpr?: string | undefined;
}

export interface PerformCvSearchRequest {
    cvSearchRequest?: CvSearchRequestDto | undefined;
}

export interface GetActiveSocialCasesForCounselingInquiryRequest {
    citizenId: string;
}

export interface GetCompletedCounselingInquiriesForServiceProviderRequest {
    citizenId: string;
}

export interface GetCompletedCounselingInquiryForServiceProviderRequest {
    citizenId: string;
    counselingInquiryId: string;
}

export interface GetCounselingInquiriesForCitizenRequest {
    citizenId: string;
}

export interface GetCounselingInquiryForCitizenRequest {
    citizenId: string;
    counselingInquiryId: string;
}

export interface GetCounselingInquiryPdfRequest {
    citizenId: string;
    counselingInquiryId: string;
}

export interface GetTemporaryHomeSupportReuseForCaseRequest {
    citizenId: string;
    caseId: string;
}

export interface GetCitizenInterviewBookingTemplatesRequest {
    reportAsDfdgSamtaleTypeName?: string | undefined;
    targetGroupCategoryCode?: string | undefined;
    templateMappingName?: string | undefined;
}

export interface GetCitizenInterviewCrowdBookingTemplatesRequest {
    reportAsDfdgSamtaleTypeName?: string | undefined;
    templateMappingName?: string | undefined;
    targetGroupCategoryCodes?: string[] | undefined;
}

export interface GetCitizenTemplatesRequest {
    caseId: string;
}

export interface GetEditableContentRequest2 {
    templateId: number;
    variantId?: number | undefined;
    renderTemplateVariables?: RenderTemplateVariables | undefined;
}

export interface GetPdfRequest {
    templateId: number;
    variantId?: number | undefined;
    content?: string | undefined;
    renderTemplateVariables?: RenderTemplateVariables | undefined;
    recipientEnvelopeAddress?: RecipientEnvelopeAddress | undefined;
}

export interface GetServiceProviderDocumentTemplatesRequest {
    serviceProviderId: string;
}

export interface GetServiceProviderLetterTemplatesRequest {
    serviceProviderId: string;
}

export interface GetTemplateByTemplateCodeRequest {
    templateCode?: string | undefined;
}

export interface GetTemplatesByCategoriesRequest {
    categories?: string[] | undefined;
    caseId?: string | undefined;
}

export interface GetTemplatesByCategoryRequest {
    category?: string | undefined;
}

export interface FillLetterUserInputsRequest {
    citizenId: string;
    letterHtml?: string | undefined;
}

export interface GetCitizenCasesRequest2 {
    citizenId: string;
}

export interface GetCitizenCompaniesRequest {
    citizenId: string;
    caseId: string;
}

export interface GetCitizenCompaniesForLookupRequest {
    citizenId: string;
    caseId: string;
}

export interface GetCitizenInfoRequest {
    citizenId: string;
}

export interface GetCitizenPrivateContactPersonsRequest {
    citizenId: string;
}

export interface GetCitizensPrimaryOrLatestCaseRequest {
    citizenId: string;
}

export interface GetCompaniesRequest2 {
    query?: string | undefined;
    maxResultSize: number;
}

export interface GetCompanyRequest {
    companyId: string;
}

export interface GetCompanyContactPersonsRequest2 {
    companyId: string;
}

export interface GetDocumentsForAliasesFromDocumentArchiveRequest2 {
    documentAliasIds?: number[] | undefined;
}

export interface GetDocumentsFromDocumentArchiveRequest2 {
    documentIds?: string[] | undefined;
}

export interface GetEditableContentForPdfFormsRequest {
    citizenId: string;
    renderTemplateVariables?: RenderTemplateVariables | undefined;
}

export interface GetHeaderRequest {
    citizenId: string;
}

export interface GetIsPrivateContactPersonCprEmptyRequest {
    id: string;
}

export interface GetMedicalRequestPdfFormLinkRequest {
    citizenId: string;
    systemSessionGroupId: string;
    medicalRequestId: string;
}

export interface GetPdfFormActivityLinkRequest {
    activityId: string;
    systemSessionGroupId: string;
}

export interface GetPdfFormLinkRequest {
    citizenId: string;
    systemSessionGroupId: string;
}

export interface GetPdfFormSubmittedRequest {
    systemSessionGroupId?: string | undefined;
    entityId: string;
}

export interface GetPreviewPdfFormRequest {
    citizenId: string;
    content?: string | undefined;
    companyId?: string | undefined;
    letterRecipientType?: number | undefined;
    caseId?: string | undefined;
    isSocialOptic?: boolean | undefined;
}

export interface GetPrivateContactPersonsRequest2 {
    query?: string | undefined;
    maxResultSize: number;
}

export interface GetStandardAttachmentDocumentsFromArchiveRequest2 {
    standardAttachmentIds?: string[] | undefined;
}

export interface GetStandardAttachmentsRequest {
    templateCodeName?: string | undefined;
    recipientType: number;
    recipientId: string;
}

export interface PreviewFileAttachmentAsPdfRequest {
    fileName?: string | undefined;
    mimeType?: string | undefined;
    content?: string | undefined;
}

export interface GetCrowdLetterPreviewAsPdfRequest {
    templateId: number;
    variantId?: number | undefined;
    content?: string | undefined;
    renderTemplateVariables?: RenderTemplateVariables | undefined;
    recipientEnvelopeAddress?: RecipientEnvelopeAddress | undefined;
}

export interface GetClarificationRightByIdRequest {
    clarificationRightId: string;
}

export interface GetClarificationRightsListRequest {
    citizenId: string;
    caseId?: string | undefined;
}

export interface GetCitizenCasesRequest3 {
    citizenId: string;
}

export interface GetCitizenTaskCreationDataRequest {
    citizenId: string;
    caseworkerId?: string | undefined;
}

export interface GetCitizenTasksMetaDataRequest {
    citizenId: string;
    filter?: CitizenTaskFilter | undefined;
}

export interface CompleteCitizenTasksRequest {
    citizenId: string;
    taskIds?: string[] | undefined;
}

export interface ReassignCitizenTasksRequest {
    citizenId: string;
    taskIds?: string[] | undefined;
    responsibleTeamId?: string | undefined;
    responsibleCaseWorkerId?: string | undefined;
}

export interface GetCitizenOverviewDataRequest {
    citizenId: string;
}

export interface GetCitizenOverviewDataForBeskaeftigelseRequest {
    citizenId: string;
}

export interface GetCitizenOverviewDataForServiceProviderRequest {
    citizenId: string;
    serviceProviderUnitId: string;
}

export interface GetCitizenOverviewDataForSocialRequest {
    citizenId: string;
}

export interface GetYouthEffortAsPdfRequest {
    citizenId: string;
}

export interface GetSustenanceHistoryMonthRequest {
    citizenId: string;
    year: number;
    month: number;
}

export interface GetSustenanceHistoryYearRequest {
    citizenId: string;
}

export interface GetCitizenIdFromPersonGroupMarkingIdRequest {
    personGroupMarkingId: string;
}

export interface GetPersonGroupMarkingsForCitizenRequest {
    citizenId: string;
}

export interface GetPersonGroupMarkingStatisticsRequest {
    personGroupId: string;
    personGroupTeamId: string;
}

export interface CreatePersonGroupMarkingRequest {
    startDate: Date | string;
    endDate?: Date | string | undefined;
    citizenId: string;
    personGroupId: string;
}

export interface DeletePersonGroupMarkingRequest {
    id: string;
    dfdgId: string;
    citizenId: string;
}

export interface UpdatePersonGroupMarkingRequest {
    id: string;
    startDate: Date | string;
    endDate?: Date | string | undefined;
    citizenId: string;
}

export interface GetParticularitiesDataRequest {
    citizenId: string;
}

export interface GetDfdgHistoryRequest {
    citizenId: string;
    historyServiceName?: string | undefined;
}

export interface GetDfdgHistoryNamesRequest {
    includeSchultzOnlyHistories?: boolean | undefined;
}

export interface GetCitizenIdForCitizenPersonContactRequest {
    citizenPersonContactId: string;
}

export interface GetCitizenPersonContactsForOverviewRequest {
    citizenId: string;
}

export interface GetCitizenPersonContactsForPrivateContactPersonRequest {
    privateContactPersonId: string;
}

export interface GetEditableCitizenPersonContactRequest {
    citizenId: string;
    citizenPersonContactId: string;
}

export interface GetCaveInformationByCitizenIdRequest {
    citizenId: string;
}

export interface GetCitizenAddressHistoryRequest {
    citizenId: string;
}

export interface GetCitizenCommentsRequest {
    citizenId: string;
}

export interface GetCitizenCoreViewModelByCitizenIdRequest {
    citizenId: string;
}

export interface GetNotesForCitizenRequest {
    citizenId: string;
}

export interface GetTemporaryAddressGuideDataRequest {
    citizenId: string;
}

export interface GetCitizenChangeLogsByQueryRequest {
    from?: Date | string | undefined;
    to?: Date | string | undefined;
    operations?: ChangeOperationV2[] | undefined;
    postTypes?: string[] | undefined;
    userId?: string | undefined;
    citizenId: string;
    postId?: string | undefined;
    rows: number;
    sortColumns?: SortColumnV2[] | undefined;
}

export interface AnalyzeSicknessBenefitVisitationStreamingRequest {
    citizenId: string;
}

export interface GetActiveSicknessAbsenceByCitizenIdRequest2 {
    citizenId: string;
}

export interface GetAssociatedCaseWorkerRequest {
    associatedCaseWorkerId: string;
}

export interface GetAssociateUsersByCaseIdRequest {
    caseId: string;
}

export interface GetCaseDetailsByIdRequest {
    caseId: string;
}

export interface GetCaseClosureReasonsFilterOnCaseTypeRequest {
    caseTypeId: string;
    selectedCaseClosureReasonId?: string | undefined;
}

export interface GetCaseContactReasonsFilterOnCaseTypeRequest {
    caseTypeId: string;
    selectedCaseContactReasonId?: string | undefined;
}

export interface GetCaseGroupsFilterOnCaseTypeRequest {
    caseTypeId: string;
    selectedCaseGroupId?: string | undefined;
}

export interface GetCaseInfoForLinkRequest {
    caseId: string;
}

export interface GetCasesRequest {
    citizenId: string;
}

export interface GetCaseTypeByCaseIdRequest {
    citizenId: string;
    caseId: string;
}

export interface GetCaseTypeByIdRequest {
    citizenId: string;
    caseTypeId: string;
    targetGroupId?: string | undefined;
}

export interface GetCaseTypesByTargetGroupIdRequest {
    targetGroupId: string;
    reportAs?: number | undefined;
}

export interface GetCaseTypeValidationValuesRequest {
    citizenId: string;
    caseId?: string | undefined;
}

export interface GetEffortGroupByIdRequest {
    effortGroupId: string;
}

export interface GetHasActiveAbsenceByCitizenIdRequest {
    citizenId: string;
}

export interface GetHasActiveContactPersonRequest {
    citizenId: string;
}

export interface GetHasActiveEnrollmentsRequest {
    citizenId: string;
}

export interface GetHasActivitiesByCitizenIdRequest {
    citizenId: string;
}

export interface GetHasContactGroupDiscrepancyRequest {
    citizenId: string;
}

export interface GetHasHistoricRegistrationRequest {
    citizenId: string;
}

export interface GetMinAndMAxDateFromCasesRequest {
    caseIds?: string[] | undefined;
}

export interface GetMostRelevantSocialCaseRequest {
    citizenId: string;
}

export interface GetOpenCasesRequest {
    citizenId: string;
}

export interface GetPayingAndResponsibleMunicipalityInfoRequest {
    citizenId: string;
}

export interface GetPersonCategoryNameByIdRequest {
    personCategoryId: string;
}

export interface GetPrimaryCaseSummaryBoxDataRequest {
    citizenId: string;
}

export interface GetScreeningPdfByCitizenIdRequest {
    citizenId: string;
}

export interface GetSdpCaseDetailsByCitizenIdRequest {
    citizenId: string;
}

export interface GetSelfScreeningRequest {
    citizenId: string;
}

export interface GetSicknessBenefitVisitationRequest {
    citizenId: string;
    caseId: string;
}

export interface GetTargetGroupByCaseIdRequest {
    caseId: string;
}

export interface HasAnyActiveCasesRequest {
    citizenId: string;
}

export interface HasAnyOpenRehabCasesRequest {
    citizenId: string;
}

export interface HasAnyOpenSicknessBenifitOrJobClarificationCasesRequest {
    citizenId: string;
}

export interface GetAbsenceRequest {
    citizenId: string;
    absenceId: string;
}

export interface GetAbsenceCauseTypesFilteredByAbsenceTypeRequest {
    absenceTypeId: string;
}

export interface GetAbsenceHistoryRequest {
    citizenId: string;
}

export interface GetAbsencesRequest {
    citizenId: string;
}

export interface GetAbsencesSimpleByCitizenIdRequest {
    citizenId: string;
}

export interface GetAbsenceTypesFilteredByCitizensContractGroupAndVisitationCategoryRequest {
    citizenId: string;
}

export interface GetAbsenceUrlRequest {
    recordId: string;
}

export interface GetAssessmentCaseWorkerCommentTemplateRequest {
    citizenId: string;
}

export interface GetAssessmentDetailsRequest {
    citizenId: string;
    assessmentId: string;
}

export interface GetAssessmentsRequest {
    citizenId: string;
}

export interface GetAssessmentUrlRequest {
    recordId: string;
}

export interface GetAvailabilityOverviewRequest {
    citizenId: string;
}

export interface GetCaseRelatedIllnessAbsencesRequest {
    citizenId: string;
    caseId: string;
}

export interface GetCitizenHealthLimitationRequest {
    citizenId: string;
    dfdgId: string;
}

export interface GetCitizenHealthLimitationsRequest {
    citizenId: string;
}

export interface GetCompanyContactPersonsRequest3 {
    companyId: string;
}

export interface GetEventTypesRequest {
    citizenId: string;
}

export interface GetNegativeEventRequest {
    citizenId: string;
    negativeEventId: string;
}

export interface GetNegativeEventsRequest {
    citizenId: string;
}

export interface GetNegativeEventsForAssessmentRequest {
    assessmentId: string;
    citizenId: string;
}

export interface GetNegativeEventUrlRequest {
    recordId: string;
}

export interface GetPrimaryCaseWorkerRequest {
    citizenId: string;
}

export interface GetPrivateContactPersonsRequest3 {
    query?: string | undefined;
    maxResultSize: number;
}

export interface GetRelatedNegativeEventsRequest {
    citizenId: string;
    negativeEventId: string;
}

export interface GetServiceConfigurationRequest {
    key?: string | undefined;
}

export interface GetAsylumCvFilesRequest {
    citizenId: string;
}

export interface GetAsylumDataRequest {
    citizenId: string;
}

export interface GetBasicSubsidyReportRequest {
    year: number;
    fromMonth: number;
    toMonth: number;
    highSubsidyStartDate: Date | string;
    basicSubsidyRate: number;
    basicSubsidyRateForUnaccompanied: number;
    highSubsidyRate: number;
    highSubsidyEndDate: Date | string;
}

export interface GetDfdgTransitionRequest {
    citizenId: string;
}

export interface GetOverviewRequest {
    citizenId: string;
}

export interface GetResultSubsidyReportRequest {
    year: number;
    fromMonth: number;
    toMonth: number;
    subsidyRateForEmploymentHigh: number;
    subsidyRateForEducationHigh: number;
    subsidyRateForEducation: number;
    subsidyRateForEmployment: number;
    subsidyRateForDanishEducation: number;
}

export interface SaveDanishTestResultRequest {
    citizenId: string;
    danishTestSetting?: DanishTestSettingDto | undefined;
    danishTestResult?: DanishTestResultDto | undefined;
    integrationInfoResponsibilityAcquisitionDate?: Date | string | undefined;
    remark?: string | undefined;
}

export interface TransferCvFromAsylumOperatorRequest {
    citizenId: string;
}

export interface TransferIntegrationResponsibilityRequest {
    citizenId: string;
    municipalityCode?: string | undefined;
    takeoverDate: Date | string;
}

export interface GetAssignmentRequest {
    assignmentId?: AssignmentId | undefined;
}

export interface GetAssignmentCountsPerServiceProviderUnitRequest {
    citizenId: string;
}

export interface GetAssignmentHtmlRequest {
    assignmentId?: AssignmentId | undefined;
    citizenId?: CitizenId | undefined;
    companyId?: string | undefined;
}

export interface GetAssignmentIdFromInterventionObjectiveIdRequest {
    interventionObjectiveId?: InterventionObjectiveId2 | undefined;
}

export interface GetAssignmentPdfRequest {
    assignmentId?: AssignmentId | undefined;
    citizenId?: CitizenId | undefined;
    companyId?: string | undefined;
}

export interface GetAssignmentsForActivityRequest {
    activityId?: ActivityId | undefined;
}

export interface GetAssignmentsForCaseRequest {
    citizenId: string;
    caseId: string;
}

export interface GetDraftAssignmentForActivityRequest {
    activityId?: ActivityId | undefined;
}

export interface GetGrantTypeOfferCombinationsForCompanyRequest {
    companyId: string;
}

export interface GetInitialAssignmentDataRequest {
    activityId?: ActivityId | undefined;
    citizenId?: CitizenId | undefined;
}

export interface GetInterventionObjectiveRequest {
    interventionObjectiveId?: InterventionObjectiveId | undefined;
}

export interface GetInterventionObjectivesByAssignmentIdRequest {
    assignmentId?: AssignmentId | undefined;
}

export interface GetJournalNoteAttachmentIdByStatusNoteIdRequest {
    serviceProviderInterventionObjectiveStatusId?: ServiceProviderInterventionObjectiveStatusId | undefined;
}

export interface GetServiceProviderAssignmentsForCitizenRequest {
    citizenId?: CitizenId | undefined;
    serviceProviderUnitId?: ServiceProviderUnitId | undefined;
}

export interface GetServiceProviderByPartialObjectiveIdRequest {
    partialObjectiveId?: PartialObjectiveId | undefined;
}

export interface GetServiceProviderByStatusNoteIdRequest {
    serviceProviderInterventionObjectiveStatusId?: ServiceProviderInterventionObjectiveStatusId | undefined;
}

export interface GetServiceProviderLookupAssignmentsRequest {
    citizenId?: CitizenId | undefined;
}

export interface GetServiceProviderObjectiveInfoRequest {
    citizenId?: CitizenId | undefined;
    serviceProviderUnitId?: ServiceProviderUnitId | undefined;
}

export interface GetServiceProviderPartialObjectiveRequest {
    citizenId: string;
    partialObjectiveId: string;
}

export interface GetServiceProviderUnitRequest2 {
    citizenId?: CitizenId | undefined;
    serviceProviderUnitId?: ServiceProviderUnitId | undefined;
}

export interface GetServiceProviderUnitsRequest {
    citizenId?: CitizenId | undefined;
}

export interface GetSharedSupportAssessmentRequest {
    assignmentId?: AssignmentId | undefined;
}

export interface RewriteAssignmentForProviderRequest {
    citizenId?: CitizenId | undefined;
    medicalDiagnoses?: string | undefined;
    specialInformationAboutCitizen?: string | undefined;
    guardianDetails?: string | undefined;
    powersOfAttorney?: string | undefined;
    descriptionOfOtherInterventions?: string | undefined;
    agreementsBetweenCitizenAndRelatives?: string | undefined;
    assessmentSummary?: string | undefined;
    citizenSupportNeedsAssessment?: string | undefined;
    citizenPerspective?: string | undefined;
    citizenResources?: string | undefined;
    challengesAndNeeds?: string | undefined;
    citizenFutureAspirations?: string | undefined;
    effortPurpose?: string | undefined;
}

export interface GenerateAssessmentFollowupAnalysisRequest {
    groupId?: string | undefined;
    caseworkerRemarks?: { [key: string]: string; } | undefined;
    transcription?: string | undefined;
    systemPromptOverride?: string | undefined;
    fieldPromptOverrides?: { [key: string]: string; } | undefined;
    existingFieldValues?: { [key: string]: string; } | undefined;
}

export interface GenerateAssessmentGroupFieldsRequest {
    groupId?: string | undefined;
    transcription?: string | undefined;
    systemPromptOverride?: string | undefined;
    fieldPromptOverrides?: { [key: string]: string; } | undefined;
    existingFieldValues?: { [key: string]: string; } | undefined;
}

export interface GenerateAssessmentGroupSummaryRequest {
    groupId?: string | undefined;
    transcription?: string | undefined;
}

export interface GetAssessmentByIdRequest {
    assessmentId: string;
}

export interface GetAssessmentInterventionObjectiveRequest {
    assessmentInterventionObjectiveId: string;
}

export interface GetAssessmentInterventionObjectivesByAssessmentIdRequest {
    assessmentId: string;
}

export interface GetAssessmentsByCaseIdRequest {
    caseId: string;
}

export interface GetAssessmentTranscriptionBySessionIdRequest {
    sessionId?: string | undefined;
    citizenId: string;
}

export interface GetCurrentAssessmentInterventionObjectivesByActivityIdRequest {
    activityId?: ActivityId | undefined;
}

export interface GetDraftAssessmentForCaseRequest {
    caseId: string;
}

export interface GenerateAgendaForCitizenRequest {
    citizenId: string;
    bookingId?: string | undefined;
    dataSourceKeys?: string[] | undefined;
}

export interface GetAgendaOptionsRequest {
    citizenId: string;
}

export interface GetSavedAgendaForCitizenRequest {
    citizenId: string;
    bookingId?: string | undefined;
    interviewId?: string | undefined;
}

export interface GetAuthorizationResultRequest {
    resourceAccess?: ResourceAccess | undefined;
    resourceAccessCriteria?: ResourceAccessCriteria | undefined;
}

export interface GetSystemTestEndpointQueryUrlRequest {
    citizenId: string;
}

export interface AttendanceCsvParserRequest {
    content: string;
}

export interface GetActiveCoursesRequest {
    activityId?: string | undefined;
}

export interface GetCitizenAttendanceNoteRequest {
    citizenId: string;
}

export interface GetCitizenAttendanceStatisticsRequest {
    citizenId: string;
    from: Date | string;
    to: Date | string;
    courseIds?: string[] | undefined;
    includeFutureLessons: boolean;
}

export interface GetCitizenAttendanceStatisticsPdfRequest {
    citizenId: string;
    from: Date | string;
    to: Date | string;
    courseIds?: string[] | undefined;
    includeFutureLessons: boolean;
}

export interface GetCitizenLessonByIdRequest {
    citizenLessonId: string;
}

export interface GetCitizenLessonDeviationByIdRequest {
    citizenLessonDeviationId: string;
}

export interface GetCitizenSchedulePdfRequest {
    citizenId: string;
    startDate: Date | string;
    endDate: Date | string;
    displayMode: ScheduleDisplayMode;
    includeAbsences: boolean;
    includeInterviews: boolean;
}

export interface GetClassRoomByIdRequest {
    classroomId: string;
}

export interface GetClassRoomsByCompanyIdRequest {
    companyId: string;
}

export interface GetCourseAttendanceStatisticsRequest {
    courseId: string;
    from: Date | string;
    to: Date | string;
    includeFutureLessons: boolean;
}

export interface GetCourseAttendanceStatisticsPdfRequest {
    courseId: string;
    from: Date | string;
    to: Date | string;
    includeFutureLessons: boolean;
}

export interface GetCourseByIdRequest {
    courseId: string;
}

export interface GetCourseDeletabilityRequest {
    courseId: string;
}

export interface GetCourseEnrollmentByIdRequest {
    courseEnrollmentId: string;
}

export interface GetCourseEnrollmentContextRequest {
    citizenId: string;
    offerId?: string | undefined;
    enrolledActivityId?: string | undefined;
}

export interface GetCourseEnrollmentsByCitizenIdRequest {
    citizenId: string;
}

export interface GetCourseEnrollmentsByCourseIdRequest {
    courseId: string;
}

export interface GetCourseEnrollmentLessonsByCitizenIdRequest {
    citizenId: string;
    from?: Date | string | undefined;
    to?: Date | string | undefined;
}

export interface GetCoursesRequest {
    filter: CourseFilterDto;
}

export interface GetCoursesByCompanyIdRequest {
    companyId: string;
}

export interface GetCoursesByOfferIdRequest {
    offerId: string;
}

export interface GetEducatorByIdRequest {
    educatorId: string;
}

export interface GetEducatorIdByCourseEducatorIdRequest {
    courseEducatorId: string;
}

export interface GetEducatorIdByLessonEducatorIdRequest {
    lessonEducatorId: string;
}

export interface GetEducatorsByCompanyIdRequest {
    companyId: string;
}

export interface GetLessonByIdRequest {
    lessonId: string;
}

export interface GetLessonsByCourseIdRequest {
    courseId: string;
}

export interface GetLessonsDateRangeByOfferIdRequest {
    offerId: string;
}

export interface GetLessonsWithoutFreeSeatsRequest {
    courseId: string;
    beginAt: Date | string;
    endAt: Date | string;
    excludedCourseEnrollmentId?: string | undefined;
}

export interface GetOccupiedDatesRequest {
    courseId: string;
    from?: Date | string | undefined;
    to?: Date | string | undefined;
}

export interface GetOfferPeriodByOfferIdRequest {
    offerId: string;
}

export interface GetRegistrationCounterByIdRequest {
    registrationCounterId: string;
}

export interface GetAttendanceProtocolPdfRequest {
    lessonId: string;
    includeCpr: boolean;
}

export interface GetCitizenLessonAttendancesByLessonIdRequest {
    lessonId: string;
}

export interface GetLessonsForAttendanceProtocolRequest {
    courseId: string;
}

export interface GetAiStandardQuestionsRequest {
    aiStandardQuestionArea?: number | undefined;
}

export interface GetCitizenAssistantPromptRequest {
    sessionId?: string | undefined;
    citizenId: string;
    content?: string | undefined;
    customPromptSettings?: PromptExecutionSettingsDto | undefined;
    standardQuestionId?: string | undefined;
    previewModel?: string | undefined;
}

export interface GetInterpretingAssistanceCitizenGuideRequest {
    languageCode?: string | undefined;
    dialogSupportId?: string | undefined;
}

export interface GetInterpretingRecognitionHintsRequest {
    citizenId: string;
}

export interface GetLanguageAssistRequest {
    text?: string | undefined;
}

export interface GetLegalDocumentFileByIdentifierRequest {
    documentId: string;
}

export interface GetMunicipalityAssistantDocumentFileByIdentifierRequest {
    documentId: string;
}

export interface GetPromptRequest {
    sessionId?: string | undefined;
    content?: string | undefined;
    contentTypes?: CitationContentType[] | undefined;
    customPromptSettings?: PromptExecutionSettingsDto | undefined;
    standardQuestionId?: string | undefined;
}

export interface GetPromptRequest2 {
    template?: string | undefined;
    arguments?: { [key: string]: any; } | undefined;
}

export interface GetSmartGoalSuggestionRequest {
    goalText?: string | undefined;
    interventionObjectiveTitle?: string | undefined;
    interventionObjectiveDescription?: string | undefined;
}

export interface GetTranslateTokenRequest {
    dialogSupportId?: string | undefined;
}

export interface GetTranslationReviewRequest {
    citizenId?: string | undefined;
    targetLanguage?: string | undefined;
    sourceLanguage?: string | undefined;
    transcription?: string | undefined;
    initialTranslation?: string | undefined;
    dialogSupportId?: string | undefined;
}

export interface RewriteLetterToneRequest {
    letterHtml?: string | undefined;
}

export interface GetNotificationLogRequest {
    status?: NotificationDeliveryStatus | undefined;
    from?: Date | string | undefined;
    to?: Date | string | undefined;
    app?: NotificationApp | undefined;
    cpr?: string | undefined;
    pageNumber: number;
    pageSize: number;
}

export interface GetNotificationLogSummaryRequest {
    from?: Date | string | undefined;
    to?: Date | string | undefined;
}

export interface GetConfigurationChangelogsRequest extends GetConfigurationChangelogsRequest2 {
}

export interface GetCitizenDeletionEligibilityRequest {
    citizenId: string;
}

export interface GetCitizenDeletionOrderRequest {
    orderId: string;
}

export interface GetCitizenDeletionOrdersRequest {
    archivedOnly: boolean;
}

export interface GetCitizenForDeletionRequest {
    cpr?: string | undefined;
}

export interface GetAuditLogsRequest extends AuditLogQueryRequest {
}

export interface GetReportRequest {
    reportId: string;
}

export interface GetVisitationTeamDetailsRequest {
    visitationTeamId: string;
}

export interface GetEditableUserRequest {
    userId: string;
}

export interface GetUserAtaTimeRequest {
    userId: string;
}

export interface ListUsersRequest {
    pageRequest?: UserPageRequestDto | undefined;
    sortRequest?: UserSortRequestDto | undefined;
    filterRequest?: UserFilterRequestDto | undefined;
}

export interface GetQuestionnaireDetailsRequest {
    questionnaireId: string;
}

export interface GetQuestionnaireRepliesAsExcelRequest {
    questionnaireId: string;
}

export interface GetSubJobcenterRequest {
    id: string;
}

export interface CreateSubJobcenterRequest {
    subJobcenter?: CreateSubJobcenterModel | undefined;
}

export interface UpdateSubJobcenterRequest {
    subJobcenter?: UpdateSubJobcenterModel | undefined;
}

export interface UpdateSubJobcenterStateRequest {
    subJobcenterState?: UpdateSubJobcenterStateModel | undefined;
}

export interface GetDocumentsFromDocumentArchiveRequest3 {
    documentIds?: string[] | undefined;
}

export interface GetDocumentTemplatesByCategoryRequest {
    category?: string | undefined;
}

export interface GetStandardPhrasesRequest2 {
    target?: string | undefined;
}

export interface GetGrantTypeDetailsRequest {
    grantTypeId: string;
}

export interface GetGrantTypeOfferDetailsRequest {
    offerIds?: string[] | undefined;
}

export interface GetAdjustmentDetailsRequest {
    adjustmentId: string;
}

export interface GetCoPaymentDebitorRunRequest {
    coPaymentDebitorRunId: string;
}

export interface GetCoPaymentReceivablesByDispatchStateRequest {
    bucket: CoPaymentDispatchBucket;
}

export interface GetDebitorRegistrationContentRequest {
    transactionId: string;
}

export interface GetFinanceDeliveryContentRequest {
    transactionId: string;
}

export interface GetFinanceDeliveryDataFileRequest {
    transactionId: string;
}

export interface GetReceivableDetailsRequest {
    receivableId: string;
}

export interface GetReceivableDispatchAttemptsRequest {
    receivableId: string;
}

export interface CheckExistingMunicipalityDocumentFilesRequest {
    fileNames?: string[] | undefined;
}

export interface GetDialogSupportInstructionForAdminRequest {
    targetGroupId: string;
    interviewType: number;
}

export interface GetTranscriptionResponse {
    overallStatus?: string | undefined;
    fullTranscription?: string | undefined;
}

export interface GetTranscriptionStatusResponse {
    overallStatus?: string | undefined;
}

export interface GetAllQuestionnairesResponse {
    questionnaireListItems?: QuestionnaireListItem[] | undefined;
}

export interface GetQuestionnairesForOfferIdResponse {
    feedbackViewModels?: FeedbackViewModel[] | undefined;
}

export interface AttachUseOfForceReportActionPlanResponse {
    report: UseOfForceReportModel;
}

export interface CreateUseOfForceReportResponse {
    report: UseOfForceReportModel;
}

export interface DeleteUseOfForceReportDraftResponse {
    citizenIds: string[];
}

export interface RegisterUseOfForceReportSendingResponse {
    report: UseOfForceReportModel;
}

export interface RemoveUseOfForceReportActionPlanResponse {
    report: UseOfForceReportModel;
}

export interface UpdateUseOfForceReportResponse {
    report: UseOfForceReportModel;
}

export interface GetUseOfForceIncidentsForServiceProviderUnitResponse {
    canAdminister: boolean;
    awaitingApproval: UseOfForceUnitOverviewItemModel[];
    awaitingReport: UseOfForceUnitOverviewItemModel[];
    myRegistrations: UseOfForceUnitOverviewItemModel[];
    awaitingSummaryRegistration: UseOfForceUnitOverviewAuthorizationItemModel[];
}

export interface GetUseOfForceReportForServiceProviderUnitResponse {
    draft?: UseOfForceReportModel | undefined;
    latestHeader?: UseOfForceReportHeaderModel | undefined;
    sent: UseOfForceReportModel[];
}

export interface CreateServiceProviderUnitCalendarEventResponse {
    eventId: string;
}

export interface GetServiceProviderUnitCalendarEventsResponse {
    calendarEvents?: ServiceProviderUnitCalendarEventModel[] | undefined;
}

export interface CancelOutboxItemsResponse {
    errors?: ValidationErrorOfGuid[] | undefined;
}

export interface ManuallySentOutboxItemsResponse {
    errors?: ValidationErrorOfGuid[] | undefined;
}

export interface ResendOutboxItemsResponse {
    errors?: ValidationErrorOfGuid[] | undefined;
}

export interface GetAttachmentsResponse {
    documents?: Document[] | undefined;
}

export interface GetCitizenOutboxItemsResponse {
    outboxItems?: OutboxViewModel[] | undefined;
}

export interface GetCitizenOutboxItemsForMedicalCollaboratorResponse {
    outboxItems?: OutboxViewModel[] | undefined;
}

export interface GetCitizenOutboxItemsForServiceProviderResponse {
    outboxItems?: OutboxViewModel[] | undefined;
}

export interface GetCompanyOutboxItemsResponse {
    outboxItems?: OutboxViewModel[] | undefined;
}

export interface GetDocumentContentResponse {
    content?: string | undefined;
}

export interface GetOutboxItemsResponse {
    outboxItems?: OutboxViewModel[] | undefined;
}

export interface UpdateTeamResponse {
    requiresReindex: boolean;
    mainTeamNameReindexQueued: boolean;
}

export interface GetCountriesResponse {
    countries?: CountryViewModel[] | undefined;
}

export interface GetSelectableSubJobcentersResponse {
    subJobcenters?: SubJobcenterListItemViewModel[] | undefined;
}

export interface GetTeamByIdResponse {
    team?: OrganizationTeamModel | undefined;
}

export interface GetTeamFkoConfigurationResponse {
    synchronizeActiveStatusEnabled: boolean;
    synchronizeAddressEnabled: boolean;
    synchronizeEmailEnabled: boolean;
    synchronizeTelephoneEnabled: boolean;
    synchronizeWebsiteEnabled: boolean;
    synchronizeAttendenceAddressEnabled: boolean;
}

export interface GetTeamInformationFromFkoResponse {
    teamFound: boolean;
    teamFromFko?: TeamFromFkoViewModel | undefined;
}

export interface GetTeamNameFromFkoResponse {
    teamName?: string | undefined;
}

export interface GetTeamsResponse {
    teams?: TeamWithUserViewModel[] | undefined;
}

export interface GetTeamUsersResponse {
    usersInTeam?: TeamUserViewModel[] | undefined;
}

export interface GetUserByIdResponse {
    user?: OrganizationUserModel | undefined;
}

export interface CreateCoPaymentResponse {
    coPaymentId: string;
}

export interface RectifyCoPaymentResponse {
    tier: CoPaymentRectificationTier;
    resultingCoPaymentId: string;
}

export interface CalculateCoPaymentParagraph107Response {
    defaultDesiredMonthlyDisposableAmount?: number | undefined;
    monthlyCoPaymentReduction?: number | undefined;
    monthlyAmount?: number | undefined;
}

export interface CalculateCoPaymentParagraph108Response {
    monthlyIncomeBasedCoPayment: number;
    calculatedMonthlyCoPayment?: number | undefined;
    defaultDesiredMonthlyDisposableAmount?: number | undefined;
    monthlyCoPaymentReduction?: number | undefined;
    amount?: number | undefined;
}

export interface CalculateCoPaymentParagraph108IncomeBasisResponse {
    incomeProjection: number;
    singlePersonDeduction?: number | undefined;
    projectedIncome: number;
    calculatedIncomeBasis?: number | undefined;
}

export interface ClassifyCoPaymentRectificationResponse {
    tier: CoPaymentRectificationTier;
    fingerprint?: string | undefined;
    amountIncreased: boolean;
    receivablesToCancelCount: number;
    receivablesToReverseCount: number;
    receivablesToReverseTotalAmount: number;
    correctedCopyStartDate: Date | string;
    correctedCopyEndDate: Date | string;
}

export interface GetCoPaymentByIdResponse {
    id: string;
    coPaymentTypeId: string;
    coPaymentTemplate: CoPaymentTemplate;
    description?: string | undefined;
    amount: number;
    amountType: CoPaymentAmountType;
    billingType: BillingType;
    billingPrinciple?: BillingPrinciple | undefined;
    startDate: Date | string;
    endDate: Date | string;
    firstBillingAdjustment: number;
    lastBillingAdjustment: number;
    precedingCoPayment?: PrecedingCoPaymentSummary | undefined;
    revisions?: CoPaymentRevisionsSummary | undefined;
    paragraph107?: CoPaymentParagraph107Dto | undefined;
    paragraph108?: CoPaymentParagraph108Dto | undefined;
    status: CoPaymentStatus;
    statusChangedOn?: Date | string | undefined;
    correctedByName?: string | undefined;
    receivablesCancelledOn?: Date | string | undefined;
}

export interface GetCoPaymentConfigurationResponse {
    paragraph108?: CoPaymentParagraph108Configuration | undefined;
}

export interface GetCoPaymentDocumentTemplatesResponse {
    templates?: TemplateListItemViewModel[] | undefined;
}

export interface GetCoPaymentEnumOptionsResponse {
    coPaymentTemplates?: CoPaymentTemplateEnumDto[] | undefined;
    coPaymentAmountTypes?: CoPaymentAmountTypeEnumDto[] | undefined;
    billingPrinciples?: BillingPrincipleEnumDto[] | undefined;
    billingTypes?: BillingTypeEnumDto[] | undefined;
    psrmReceivableTypes?: PsrmReceivableTypeEnumDto[] | undefined;
    financeAccounts?: FinanceClassificationValueDto[] | undefined;
    financeArts?: FinanceClassificationValueDto[] | undefined;
    financeOwnerships?: FinanceClassificationValueDto[] | undefined;
}

export interface GetCoPaymentInitialDataResponse {
    citizenId: string;
    activityStatus: number;
    offerTypeId?: string | undefined;
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
    activityTitle?: string | undefined;
    coPaymentTypes?: CoPaymentTypeViewModel[] | undefined;
}

export interface GetCoPaymentReceivablesResponse {
    receivables?: CoPaymentReceivableViewModel[] | undefined;
}

export interface GetCoPaymentRedirectPropertiesResponse {
    activityId?: string | undefined;
}

export interface GetCoPaymentsByActivityIdResponse {
    coPayments?: CoPaymentListItemDto[] | undefined;
}

export interface GetCoPaymentTypesByOfferTypeResponse {
    coPaymentTypes?: CoPaymentTypeViewModel[] | undefined;
}

export interface GetDebitorRegistrationErrorCodesResponse {
    errorCodes?: DebitorRegistrationErrorCodeDto[] | undefined;
}

export interface AddCitizenToWaitingListResponse {
    waitingListSeatId: string;
}

export interface AssignResponsibleCaseworkerResponse {
    isValid: boolean;
}

export interface CancelActivityResponse {
    success: boolean;
}

export interface CitizenJobcenterTransferResponse {
    success: boolean;
}

export interface CreateActivationLevelResponse {
    activationLevel?: ActivationLevelModel | undefined;
}

export interface CreateActivityResponse {
    activityId: string;
    isValid: boolean;
    validationMessages?: ValidationMessage[] | undefined;
}

export interface CreateActivityPriceCorrectionResponse {
    success: boolean;
}

export interface CreateEvaluationResponse {
    evaluationId: string;
}

export interface CreateOfferResponse {
    offerId: string;
}

export interface CreateOfferGroupResponse {
    isValid: boolean;
}

export interface CreateOfferResourceResponse {
    offerResourceId: string;
}

export interface CreateReimbursementResponse {
    reimbursementId: string;
}

export interface DeleteActivityPriceCorrectionResponse {
    success: boolean;
}

export interface DeleteEvaluationResponse {
    success: boolean;
}

export interface DeleteOfferDraftByIdResponse {
    offerId: string;
    success: boolean;
}

export interface DeleteOfferResourceResponse {
    success: boolean;
}

export interface DeleteUpcomingOfferPriceResponse {
    success: boolean;
}

export interface SendActivityLetterResponse {
    ok: boolean;
}

export interface UpdateActivationLevelResponse {
    activationLevel?: ActivationLevelDto | undefined;
}

export interface UpdateActivityResponse {
    isValid: boolean;
    activityStatus?: number | undefined;
    validationMessages?: ValidationMessage[] | undefined;
    correlationIdentifier?: string | undefined;
}

export interface UpdatePlacementPriceResponse {
    response?: UpdatePlacementPriceResponseModel | undefined;
}

export interface UpdateActivityPriceCorrectionResponse {
    success: boolean;
}

export interface UpdateEvaluationResponse {
    success: boolean;
}

export interface UpdateOfferGroupResponse {
    isValid: boolean;
}

export interface UpdateOfferPriceResponse {
    response?: UpdateOfferPriceResponseModel | undefined;
}

export interface UpdateOfferResourceResponse {
    success: boolean;
}

export interface UpdateReimbursementResponse {
    isValid: boolean;
    validationMessages?: ValidationMessage2[] | undefined;
}

export interface UpdateUpcomingOfferPriceResponse {
    success: boolean;
}

export interface CalculateReimbursementResponse {
    totalReimbursement: number;
}

export interface CanApproveActivityResponse {
    canApprove: boolean;
}

export interface GetActivationLevelByCitizenIdResponse {
    activationLevel?: ActivationLevelModel | undefined;
}

export interface GetActiveMethodTypesResponse {
    methodTypes?: MethodTypeModel[] | undefined;
}

export interface GetActivitiesAggregatedByCompanyIdResponse {
    activities?: CompanyActivityListItemViewModel[] | undefined;
}

export interface GetActivitiesBasicInfoResponse {
    activities?: GetActivitiesBasicInfoDto[] | undefined;
}

export interface GetActivitiesByCitizenIdResponse {
    activities?: ActivityListItemViewModel[] | undefined;
}

export interface GetActivitiesByCompanyIdResponse {
    activities?: CompanyActivityListItemViewModel[] | undefined;
    totalCount: number;
    isValid: boolean;
    errorMessage?: string | undefined;
}

export interface GetActivitiesByGrantIdResponse {
    activities?: GrantActivityListItem[] | undefined;
}

export interface GetActivitiesForNegativeEventResponse {
    activities?: ActivityForNegativeEventDto[] | undefined;
}

export interface GetActivitiesForNuphResponse {
    activities?: ActivityForNuphDto[] | undefined;
}

export interface GetActivitiesSummaryBoxDataResponse {
    activities?: ActivitySummaryBoxModel[] | undefined;
}

export interface GetActivityApprovalRejectDetailsResponse {
    activityApprovalRejectDetails?: ActivityApprovalRejectViewModel | undefined;
}

export interface GetActivityBasicInfoResponse {
    activityId: string;
    citizenId: string;
    caseId?: string | undefined;
    title?: string | undefined;
}

export interface GetActivityForCommunicationResponse {
    activity?: CommunicationActivityViewModel | undefined;
}

export interface GetActivityDetailsByIdResponse {
    activity?: ActivityDetailsViewModel | undefined;
}

export interface GetActivityDetailsByOfferIdResponse {
    activities?: ActivityListItemViewModel2[] | undefined;
}

export interface GetActivityListByCitizenIdResponse {
    activities?: PrecedingActivityViewModel[] | undefined;
}

export interface GetActivityPdfFormsResponse {
    activityPdfForms?: ActivityPdfFormModel[] | undefined;
}

export interface GetActivityPdfFormSubmittedResponse {
    pdfForms?: PdfFormAttachmentModel[] | undefined;
}

export interface GetActivityPeriodTotalPriceResponse {
    periodTotalPrice?: number | undefined;
}

export interface GetActivityPriceCalculationHistoryResponse {
    entries?: GetActivityPriceCalculationHistoryEntryViewModel[] | undefined;
    currentValues?: GetActivityPriceCalculationHistoryCurrentValuesViewModel | undefined;
}

export interface GetActivityPriceCorrectionsResponse {
    priceCorrections: ActivityPriceCorrectionViewModel[];
}

export interface GetActivityResourcesResponse {
    activityResources?: ActivityResourceViewModel[] | undefined;
}

export interface GetActivityTotalPlacementHoursResponse {
    totalPlacementHours?: number | undefined;
}

export interface GetGetApprovalUsersResponse {
    users?: UserWithApplicationRoleModel[] | undefined;
}

export interface GetCalculatedEndDateByStartDateResponse {
    endDate?: Date | string | undefined;
}

export interface GetCitizenGrantListResponse {
    grantList?: GrantViewModel[] | undefined;
}

export interface GetCitizenHeaderInfoResponse {
    citizenHeaderInfo?: CitizenHeaderInfoViewModel | undefined;
}

export interface GetCompanyContactPersonsByCompanyIdForActivityResponse {
    contactPersons?: ContactPersonViewModel[] | undefined;
}

export interface GetCompanyContactPersonsByCompanyIdForOfferResponse {
    contactPersons?: ContactPersonViewModel[] | undefined;
}

export interface GetCompanyInfoByIdResponse {
    company?: CompanyViewModel | undefined;
}

export interface GetSpecialCircumstanceByCompanyIdResponse {
    specialCircumstances?: CompanySpecialCircumstanceViewModel[] | undefined;
}

export interface GetCreateOfferCompanyByIdResponse {
    createOfferCompany?: CreateOfferCompanyViewModel | undefined;
}

export interface GetDfdgActivitiesByCitizenIdResponse {
    citizenActivities?: CitizenActivityViewModel[] | undefined;
}

export interface GetDfdgActivityByIdResponse {
    dfdgActivity?: DfdgActivityViewModel | undefined;
}

export interface GetEvaluationResponse {
    evaluation?: GetEvaluationViewModel | undefined;
}

export interface GetEvaluationsByActivityIdResponse {
    evaluations?: EvaluationListItemViewModel[] | undefined;
}

export interface GetMissingWorkDutyHoursResponse {
    missingWorkDutyHours?: MissingWorkDutyHoursModel | undefined;
}

export interface GetOccupationsByLookupResponse {
    occupations?: OccupationViewModel[] | undefined;
}

export interface GetOfferAndActivityConfigurationResponse {
    configuration?: OfferAndActivityConfiguration | undefined;
}

export interface GetOfferByIdResponse {
    offer?: OfferViewModel | undefined;
}

export interface GetOfferDetailsByIdResponse {
    offer?: OfferDetailsViewModel | undefined;
}

export interface GetOfferDetailsCodeListDataResponse {
    offerTypes?: OfferTypeCodeListDto[] | undefined;
    countries?: CountryCodeListDto[] | undefined;
    targetGroups?: TargetGroupCodeListDto[] | undefined;
    placementPurposes?: PlacementPurposeCodeListDto[] | undefined;
    driversLicenses?: DriversLicenseCodeListDto[] | undefined;
    amuCodes?: AmuCodeListDto[] | undefined;
    dunCodes?: DunCodeListDto[] | undefined;
    courseTypes?: CourseTypeListDto[] | undefined;
    courseAllocationTypes?: CourseAllocationCodeListDto[] | undefined;
    kyOfferTypes?: KyOfferCodeListDto[] | undefined;
    jobAllocationTypes?: JobAllocationCodeListDto[] | undefined;
    jobOrderPriceHourTypes?: JobOrderPriceHourCodeListDto[] | undefined;
    purposeOfCompanyInternshipTypes?: PurposeOfCompanyInternshipCodeListDto[] | undefined;
    jobOrderTypes?: JobOrderCodeListDto[] | undefined;
    activityStatusCauseCodes?: ActivityStatusCauseCodeListDto[] | undefined;
    mentorTypes?: MentorTypeListDto[] | undefined;
    helpingDeviceTypes?: HelpingDeviceCodeListDto[] | undefined;
    jobOfferTypes?: JobOfferTypeCodeListDto[] | undefined;
    authorityAreaTypes?: AuthorityAreaTypeCodeListDto[] | undefined;
    jobOfferTypesAuthorityAreaTypes?: JobOfferTypeAuthorityAreaTypeCodeListDto[] | undefined;
    jobOfferTypesJobAllocationTypes?: JobOfferTypeJobAllocationTypeCodeListDto[] | undefined;
    socialProviderUnits?: SocialProviderUnitLookupDto[] | undefined;
}

export interface GetOfferDetailsForActivityByIdResponse {
    offerDetailsForActivity?: OfferDetailsForActivityViewModel | undefined;
}

export interface GetOfferSimpleDetailsByOfferIdResponse {
    offer?: OfferSimpleDetailsDto | undefined;
}

export interface GetOfferGroupByIdResponse {
    offerGroup: OfferGroupViewModel;
}

export interface GetOfferGroupsResponse {
    offerGroups?: OfferGroupListItemViewModel[] | undefined;
}

export interface GetOfferGroupsForAdministrationResponse {
    offerGroups?: OfferGroupListItemViewModel[] | undefined;
}

export interface GetOfferHasAvailableSeatsOnDateResponse {
    offerHasAvailableSeats: boolean;
}

export interface GetOfferIdByOfferResourceIdResponse {
    offerId: string;
}

export interface GetOfferIdsByGrantIdResponse {
    offerIds?: string[] | undefined;
}

export interface GetOfferPriceGuideInfoResponse {
    offerPriceGuideInfo?: OfferPriceGuideInfoViewModel | undefined;
}

export interface GetOfferPriceModelsResponse {
    priceModels?: OptionValue2[] | undefined;
}

export interface GetOfferPricesResponse {
    offerPrices?: OfferPriceViewModel[] | undefined;
}

export interface GetOfferResourceByIdResponse {
    offerResource: OfferResourceViewModel;
}

export interface GetOfferResourcesByOfferIdResponse {
    offerResources?: OfferResourceViewModel[] | undefined;
}

export interface GetOffersByCompanyIdResponse {
    offers?: OfferListItemViewModel[] | undefined;
}

export interface GetOffersEarmarkedToCitizenResponse {
    offers?: OfferListItemViewModel[] | undefined;
}

export interface GetOfferTypesResponse {
    offerTypes?: OfferTypeViewModel[] | undefined;
}

export interface GetPersonalAssistanceTypesResponse {
    personalAssistanceTypes?: PersonalAssistanceTypeDto[] | undefined;
}

export interface GetReimbursementResponse {
    reimbursement?: ReimbursementViewModel | undefined;
    citizenId: string;
}

export interface GetReimbursementsByActivityIdResponse {
    reimbursements?: ReimbursementListItemViewModel[] | undefined;
}

export interface GetReimbursementsRedirectPropertiesResponse {
    offerCategory?: number | undefined;
    activityId?: string | undefined;
}

export interface GetSchultzConnectUrlResponse {
    schultzConnectUrl?: string | undefined;
}

export interface GetSuggestedVitasDataForCancelActivityResponse {
    suggestedVitasFieldsForCancelActivityViewModel?: SuggestedVitasFieldsForCancelActivityViewModel | undefined;
}

export interface GetSuggestNextAvailablePeriodsResponse {
    success: boolean;
    failure: boolean;
    errorMessage?: string | undefined;
    result?: SuggestedDatesAndDuration[] | undefined;
    firstAvailableDate?: Date | string | undefined;
    gracePeriodInDaysBetweenActivities?: number | undefined;
}

export interface GetTeamByUserIdResponse {
    team?: OaTeamViewModel | undefined;
}

export interface GetWaitingListActivityValidationResponse {
    validation?: WaitingListActivityValidationViewModel | undefined;
}

export interface GetWaitingListSeatByIdResponse {
    waitingListSeat?: WaitingListSeatDetailViewModel | undefined;
}

export interface GetWaitingListSeatRoutingInfoByIdResponse {
    offerId: string;
    citizenId: string;
}

export interface GetWaitingListSeatsByCitizenIdResponse {
    waitingListSeats?: CitizenWaitingListSeatViewModel[] | undefined;
}

export interface GetWaitingListSeatsByOfferIdResponse {
    waitingListSeats?: WaitingListSeatViewModel[] | undefined;
}

export interface GetWizardDataForCancelActivityResponse {
    targetGroupCode?: string | undefined;
    targetGroupId?: string | undefined;
    defaultActivityStatusType: number;
    citizenHeaderInfo?: CitizenHeaderInfoViewModel | undefined;
    citizenId: string;
    category?: CategoryDto | undefined;
    startDate: Date | string;
    activityStatusCauseTypes?: ActivityStatusCauseCodeListDto[] | undefined;
    negativeEventTypes?: NegativeEventTypeViewModel[] | undefined;
    currentUserName?: string | undefined;
    activityNameWithDates?: string | undefined;
}

export interface GetWizardDataForReimbursementResponse {
    citizenId: string;
    activityTitle?: string | undefined;
    activityStartDate: Date | string;
    activityEndDate?: Date | string | undefined;
    isReimbursementAvailable: boolean;
    isReimbursementWorkDutyAvailable: boolean;
    isTransportReimbursementAvailable: boolean;
    hasNoBenefitSystemTransfer: boolean;
    transportReimbursementSettingsAsJson?: string | undefined;
}

export interface HasActiveActivityByOfferCategoryResponse {
    hasActiveActivity: boolean;
}

export interface IsActivityDraftEnabledResponse {
    isActivityDraftEnabled: boolean;
}

export interface IsCreateEvaluationAvailableResponse {
    isCreateEvaluationAvailable: boolean;
}

export interface IsReimbursementAvailableResponse {
    isReimbursementAvailable: boolean;
}

export interface ValidateCreateActivityResponse {
    validationResult?: ValidationResult | undefined;
}

export interface ValidateCreateOfferResponse {
    validationResult?: ValidationResult | undefined;
}

export interface ValidateUpdateActivityResponse {
    validationResult?: ValidationResult | undefined;
}

export interface ValidateUpdateOfferResponse {
    validationResult?: ValidationResult | undefined;
}

export interface JournalizeIncomingMailByCitizenResponse {
    externalIdForJournalNote: string;
}

export interface JournalizeIncomingMailByCompanyResponse {
    companyNoteId: string;
}

export interface GetIncomingMailTaskResponse {
    incomingMailTask?: IncomingMailTask | undefined;
}

export interface GetIncomingMailAttachmentsResponse {
    incomingMailAttachments?: IncomingMailAttachment[] | undefined;
}

export interface JournalizeGeneralTaskOnCitizenResponse {
    externalReferenceIdForJournalNote: string;
}

export interface JournalizeGeneralTaskOnCompanyResponse {
    companyNoteId: string;
}

export interface GetGeneralTaskResponse {
    task?: GeneralTask | undefined;
}

export interface GetCompanyNoteJournalizationIdResponse {
    companyNoteId?: string | undefined;
    companyId: string;
}

export interface GetJournalizationIdResponse {
    journalNoteId?: string | undefined;
}

export interface GetTaskContextResponse {
    taskContext?: TaskContext | undefined;
}

export interface CreateJobAdResponseV2 {
    jobAdId: string;
}

export interface GetCompanyMunicipalityByCompanyIdResponse {
    municipality?: JobAdsMunipalityModel | undefined;
}

export interface GetCountriesResponse2 {
    countries?: JobAdsCountryModel[] | undefined;
}

export interface GetExternalJobAdIdResponse {
    externalJobAdId?: string | undefined;
}

export interface GetJobAdResponseV2 {
    jobAd?: JobAdEditViewModelV2 | undefined;
}

export interface GetMunicipalitiesResponse {
    municipalities?: JobAdsMunipalityModel[] | undefined;
}

export interface AddChatResponse {
    chatId: string;
}

export interface AddNewsItemRecipientsResponse {
    addedCount: number;
    alreadyRecipientCount: number;
    failedCount: number;
}

export interface CreateCaseworkerAbsenceResponse {
    absenceId: string;
}

export interface CreateNewsItemResponse {
    newsItemId: string;
}

export interface JournalizeChatResponse {
    journalizationDate?: Date | string | undefined;
}

export interface NudgeCitizensWithQuestionnaireResponse {
    results?: QuestionnaireNudgeResultModel[] | undefined;
}

export interface RenameChatMessageAttachmentResponse {
    attachment?: AttachmentMetaDataModel | undefined;
}

export interface GetCaseworkerAbsencesResponse {
    absences?: CaseworkerAbsenceModel[] | undefined;
}

export interface GetChatActivityResponse {
    count: number;
    latestActivityDate?: Date | string | undefined;
}

export interface GetChatAttachmentResponse {
    attachment?: ChatAttachmentModel | undefined;
}

export interface GetChatByIdResponse {
    chat?: ChatModel | undefined;
}

export interface GetChatCountResponse {
    count: number;
}

export interface GetChatCreationOptionsResponse {
    cases?: SelectableItemModel[] | undefined;
    contacts?: SelectableItemModel[] | undefined;
}

export interface GetChatMessageDeleteInfoResponse {
    wasJournalizedAfterMessage: boolean;
}

export interface GetChatsPaginatedResponse {
    chats?: ChatModel[] | undefined;
}

export interface GetCitizenByExternalIdResponse {
    citizen?: CitizenModel | undefined;
}

export interface GetCitizenContextResponse {
    citizenContext?: CitizenContextModel | undefined;
}

export interface GetCitizensAppStatusResponse {
    citizens?: CitizenAppStatusModel[] | undefined;
}

export interface GetContextResponse {
    context?: UserContextModel | undefined;
    canAdministerNews: boolean;
    canRenameChatAttachments: boolean;
    canDeleteChatMessages: boolean;
    canManageAbsenceOfOtherCaseworkers: boolean;
}

export interface GetForumCaseworkersResponse {
    caseworkers?: ForumCaseworkerModel[] | undefined;
}

export interface GetNewChatMessagesResponse {
    chatMessages?: ChatMessageModel[] | undefined;
}

export interface GetNewsItemResponse {
    newsItem?: NewsItemModel | undefined;
    journalize: boolean;
    enableShowInterest: boolean;
}

export interface GetNewsItemAttachmentResponse {
    attachment?: NewsAttachmentModel | undefined;
}

export interface GetNewsItemRecipientsResponse {
    showToAll: boolean;
    recipients?: NewsCitizenModel[] | undefined;
}

export interface GetNewsItemsResponse {
    newsItems?: NewsItemModel[] | undefined;
}

export interface GetNewsItemsForCitizenResponse {
    newsItems?: NewsItemModel[] | undefined;
}

export interface GetNewsItemStatisticsResponse {
    receivedBy: number;
    readBy: number;
    interestBy: number;
    readers?: NewsCitizenModel[] | undefined;
    interested?: NewsCitizenModel[] | undefined;
}

export interface GetNudgeCitizensResponse {
    citizens?: NudgeCitizenModel[] | undefined;
}

export interface GetNudgeQuestionnaireOffersResponse {
    offers?: NudgeQuestionnaireOfferModel[] | undefined;
}

export interface GetNudgeQuestionnairesResponse {
    questionnaires?: NudgeQuestionnaireModel[] | undefined;
}

export interface ActivateOrDeactivateExternalOperatorCompanyResponse {
    externalOperatorCompanyId: string;
}

export interface CancelReferralResponse {
    referralId: string;
}

export interface CreateAgreementResponse {
    agreementId?: string | undefined;
}

export interface CreateReferralResponse {
    referralId?: string | undefined;
}

export interface UpdateAgreementResponse {
    agreementModel?: AgreementModel | undefined;
}

export interface UpdateAgreementCompanyResponse {
    agreementId: string;
}

export interface UpdateExternalOperatorCompanyResponse {
    externalOpreatorCompanyId: string;
}

export interface UpdateReferralResponse {
    referral?: ReferralModel | undefined;
}

export interface GetAgreementByIdResponse {
    agreement?: AgreementModel | undefined;
}

export interface GetExternalOperatorAgreementsResponse {
    externalOperatorAgreements?: ExternalOperatorAgreementViewModel[] | undefined;
}

export interface GetExternalOperatorAgreementsForListViewResponse {
    agreementsForListView?: AgreementForListViewModel[] | undefined;
}

export interface GetExternalOperatorAgreementsForReferralResponse {
    agreements?: AgreementForReferralModel[] | undefined;
}

export interface GetExternalOperatorCompaniesResponse {
    externalOperatorCompanies?: ExternalOperatorCompany[] | undefined;
}

export interface GetInitialCaseWorkerIdForCreateReferralResponse {
    caseWorkerId: string;
}

export interface GetLetterContentForExternalOperatorReferralResponse {
    content?: string | undefined;
}

export interface GetOutgoingDocumentTypesForExternalOperatorReferralResponse {
    outgoingDocumentTypes?: OutgoingDocumentType[] | undefined;
}

export interface GetReferralByIdResponse {
    referral?: ReferralModel | undefined;
}

export interface GetReferralsByAgreementForListViewResponse {
    referralsForListView: ReferralForListViewModel[];
}

export interface GetReferralsForListViewResponse {
    referralsForListView?: ReferralForListViewModel[] | undefined;
}

export interface GetResponsibilityAreasResponse {
    responsibilityAreas?: ResponsibilityArea[] | undefined;
}

export interface StartFilingDeliveryResponse {
    startInfo?: FilingStartInfo | undefined;
}

export interface GetFilingDeliveriesResponse {
    filingDeliveries?: FilingDeliveryDetails[] | undefined;
}

export interface GetFilingDeliveryResponse {
    filingDeliveryDetails?: FilingDeliveryDetails | undefined;
}

export interface GetHandicapDeliveryResponse {
    handicapDelivery?: HandicapDelivery | undefined;
}

export interface DeleteTradeCodesResponse {
    companyId: string;
}

export interface UpsertTradeCodesResponse {
    companyId: string;
}

export interface GetTradeCodeOptionsResponse {
    options?: TradeCodeOptionModel[] | undefined;
}

export interface GetTradeCodesResponse {
    companyId: string;
    tradeCodes?: TradeCodeModel[] | undefined;
}

export interface DeleteTagResponse {
    id: string;
}

export interface UpsertTagResponse {
    id: string;
}

export interface UpsertTagsResponse {
    companyIds?: string[] | undefined;
}

export interface GetCompanyIdByTagIdResponse {
    companyId?: string | undefined;
}

export interface GetTagResponse {
    tag?: TagModel | undefined;
}

export interface GetTagsResponse {
    tags?: TagModel[] | undefined;
}

export interface GetTagTypeOptionsResponse {
    options?: TagTypeOptionModel[] | undefined;
}

export interface DeleteSpecialCircumstanceResponse {
    id: string;
}

export interface DeleteSpecialCircumstanceTargetGroupResponse {
    id: string;
}

export interface UpsertTaskSpecialCircumstanceResponse {
    id: string;
}

export interface UpsertSpecialCircumstanceTargetGroupResponse {
    id: string;
}

export interface UpsertSpecialCircumstanceTargetGroupsResponse {
    ids?: string[] | undefined;
}

export interface CheckSpecialCircumstanceForOverlapResponse {
    overlappingCircumstances?: { [key in keyof typeof CircumstanceTypeCode]?: string[]; } | undefined;
}

export interface GetCompanyIdBySpecialCircumstanceIdResponse {
    companyId?: string | undefined;
}

export interface GetCrmHostResponse {
    crmHost?: string | undefined;
}

export interface GetSpecialCircumstanceResponse {
    specialCircumstance?: SpecialCircumstanceDto | undefined;
    secondaryTargetGroups?: string[] | undefined;
}

export interface GetSpecialCircumstanceContactGroupAndTargetGroupOptionsResponse {
    targetGroupOptions?: { [key: string]: string; } | undefined;
    specialCircumstancesTypes?: { [key: string]: string; } | undefined;
}

export interface GetSpecialCircumstanceDocumentsFromDocumentArchiveResponse {
    attachments?: DocumentArchiveDocument[] | undefined;
}

export interface GetSpecialCircumstanceDocumentsFromShelfInDocumentArchiveResponse {
    attachments?: DocumentArchiveDocument[] | undefined;
}

export interface GetSpecialCircumstancesResponse {
    specialCircumstances?: SpecialCircumstanceDto[] | undefined;
}

export interface GetSpecialCircumstanceTargetGroupResponse {
    specialCircumstanceTargetGroup?: SpecialCircumstanceTargetGroupDto | undefined;
}

export interface GetSpecialCircumstanceTargetGroupsResponse {
    specialCircumstanceTargetGroup?: SpecialCircumstanceTargetGroupDto[] | undefined;
}

export interface ValidateCircumstanceForOverlapResponse {
    overlappingSpecialCircumstances?: SpecialCircumstanceDto[] | undefined;
}

export interface DraftCompanyDialogCitizenNoteResponse {
    value?: string | undefined;
}

export interface EvaluateCompanyDialogDraftResponse {
    value?: string | undefined;
}

export interface ExtractCompanyDialogTasksResponse {
    tasks?: CompanyDialogTaskDto[] | undefined;
    modelAnswerWasUnreadable: boolean;
}

export interface GetAppointmentByIdForNoteResponse {
    appointmentData?: CompanyAppointmentData | undefined;
}

export interface GetCompanyByCompanyNoteIdResponse {
    companyId?: string | undefined;
}

export interface GetCompanyDialogCitizenSuggestionsResponse {
    suggestions?: CompanyDialogCitizenSuggestion[] | undefined;
}

export interface GetCompanyDialogPromptResponse {
    defaultPrompt?: string | undefined;
    defaultTaskPrompt?: string | undefined;
    defaultCitizenPrompt?: string | undefined;
}

export interface GetCompanyDialogTranscriptionBySessionIdResponse {
    sessionId: string;
    overallStatus?: string | undefined;
    totalCount: number;
    fullTranscription?: string | undefined;
    partials?: CompanyDialogPartialTranscriptionDto[] | undefined;
}

export interface GetCompanyNoteDataResponse {
    companyInteractionNoteDto?: CompanyInteractionNoteDto | undefined;
}

export interface GetCompanyInteractionNotesResponse {
    notes?: CompanyInteractionNoteListItemDto[] | undefined;
}

export interface GetCompanyNoteDispatchStatusResponse {
    sentStatus?: string | undefined;
    statusMessage?: string | undefined;
}

export interface GetCompanyNoteDocumentsFromShelfInDocumentArchiveResponse {
    attachments?: DocumentArchiveDocument[] | undefined;
}

export interface GetCompanyNoteTitleResponse {
    companyNoteTitle?: string | undefined;
}

export interface GetCopanyNoteDocumentsFromDocumentArchiveResponse {
    attachments?: DocumentArchiveDocument[] | undefined;
}

export interface GetNoteFormDataResponse {
    crmHost?: string | undefined;
    noteContactTypes?: { [key: string]: string; } | undefined;
    noteInteractionPurposeTypes?: { [key: string]: string; } | undefined;
    noteInteractionResultTypes?: { [key: string]: string; } | undefined;
    contactPersons?: CompanyContactPersonDto[] | undefined;
    wysiwygEditorEnabled: boolean;
    isInteractionResultRequired: boolean;
    isContactPersonRequired: boolean;
}

export interface GetWysiwygEditorTemplateContentResponse {
    wysiwygTemplate?: string | undefined;
}

export interface SummarizeCompanyDialogResponse {
    value?: string | undefined;
}

export interface UpsertCompanyInteractionNoteResponse {
    id: string;
}

export interface UpsertCompanyContactPersonResponse {
    contactPersonId: string;
}

export interface UpsertPrivateContactPersonResponse {
    contactPersonId: string;
}

export interface GetCompanyContactPersonDetailsByIdResponse {
    countriesCodeList?: ContactPersonCountryCodeListDto[] | undefined;
    contactPerson?: CompanyContactPersonDetailsDto | undefined;
}

export interface GetCompanyContactPersonsForOverviewResponse {
    contactPersons?: CompanyContactPersonListItemDto[] | undefined;
}

export interface GetCompanyIdByCompanyContactPersonIdResponse {
    companyId?: string | undefined;
}

export interface GetPrivateContactPersonDetailsByIdResponse {
    countriesCodeList?: ContactPersonCountryCodeListDto[] | undefined;
    contactPerson?: PrivateContactPersonDetailsDto | undefined;
}

export interface GetPrivateContactPersonsByEmailOrPhoneResponse {
    contactPersons?: PrivateContactPersonSearchResultDto[] | undefined;
}

export interface GetPrivateContactPersonsForOverviewResponse {
    contactPersons?: PrivateContactPersonListItemDto[] | undefined;
}

export interface JournalizeCompanyTaskOnCitizenResponse {
    externalReferenceIdForJournalNote: string;
}

export interface JournalizeCompanyTaskOnCompanyResponse {
    companyNoteId: string;
}

export interface FindCitizenCasesResponse {
    searchResults?: CitizenCaseSearchResult[] | undefined;
}

export interface GetCompanyTaskResponse {
    task?: CompanyTask | undefined;
}

export interface GetCompanyTasksMetaDataResponse {
    companyTasksMetaData?: CompanyTaskMetaData[] | undefined;
}

export interface LoadCitizenCaseResponse {
    itemText?: string | undefined;
}

export interface SendCompanyLetterResponse {
    outboxId: string;
}

export interface GetAccountInteractionPurposeResponse {
    accountInteractionPurposeTypes: AccountInteractionPurposeViewModel[];
}

export interface GetCompanyInfoResponse {
    companyLetterAddress?: CompanyLetterAddressViewModel | undefined;
}

export interface GetCompanyPdfFormLinkResponse {
    url?: string | undefined;
}

export interface GetCompanyPdfFormsResponse {
    pdfForms?: PdfFormModel[] | undefined;
}

export interface GetCompanyPdfFormSubmittedResponse {
    pdfForms?: PdfFormAttachmentModel[] | undefined;
}

export interface GetContactPersonsCompanyResponse {
    contactPersons?: CompanyContactPersonDto[] | undefined;
}

export interface GetCompanyEditableContentForPdfFormsResponse {
    content?: string | undefined;
    untypedVariables?: string | undefined;
    mainTeamId?: string | undefined;
    templateId: number;
    variantId?: number | undefined;
}

export interface GetInteractionResultResponse {
    interactionResults: InteractionResultViewModel[];
}

export interface GetOutgoingDocumentTypesResponse {
    outgoingDocumentTypes: OutgoingDocumentTypeViewModel[];
}

export interface GetStandardAttachmentsForCompanyResponse {
    attachmentModel?: AttachmentModelForCompany[] | undefined;
}

export interface DeleteAssociatedCaseWorkerForCompanyResponse {
    deleteSuccess: boolean;
}

export interface UpsertAssociatedCaseWorkerResponse {
    associatedCaseWorkerId: string;
}

export interface GetAssociatedCaseWorkerForCompanyResponse {
    associatedCaseWorker: AssociatedCaseWorkerTableModel;
}

export interface GetAssociatedCaseWorkersForCompanyResponse {
    associatedCaseWorkerTableData?: AssociatedCaseWorkerTableModel[] | undefined;
}

export interface GetAssociateUserRolesCompanyResponse {
    associateUserCompanyRoles?: AssociateUserRole[] | undefined;
}

export interface GetResponsibleCaseWorkerForCompanyResponse {
    responsibleCaseWorkerName?: string | undefined;
    teamName?: string | undefined;
}

export interface GetAppointmentByIdResponse {
    appointment?: CompanyAppointmentModel | undefined;
}

export interface GetAppointmentFormDataResponse {
    noteContactTypes?: { [key: string]: string; } | undefined;
    noteInteractionPurposeTypes?: { [key: string]: string; } | undefined;
    contactPersons?: CompanyContactPersonDto[] | undefined;
}

export interface GetAppointmentsForListViewResponse {
    appointments?: CompanyAppointmentListViewModel[] | undefined;
}

export interface GetCompanyByAppointmentIdResponse {
    companyId?: string | undefined;
}

export interface UpsertCompanyAppointmentResponse {
    appointmentId: string;
}

export interface CreateAttachmentsResponse {
    success: boolean;
}

export interface CreateCandidateResponse {
    isValid: boolean;
    errorMessage?: string | undefined;
    recruitmentCandidate?: RecruitmentCandidateListItem | undefined;
    requestStatus?: number | undefined;
}

export interface CreateCandidateReferralsResponse {
    isValid: boolean;
    failedReferrals?: CompanyRecruitmentReferralViewModel[] | undefined;
    errorMessages?: { [key: string]: string; } | undefined;
    createdReferrals?: CompanyRecruitmentReferralViewModel[] | undefined;
}

export interface CreateCandidatesFromSmartMatchResponse {
    isValid: boolean;
    failedCandidates?: FailedCandidateResponseItem[] | undefined;
    addedCandidates?: RecruitmentCandidateListItem[] | undefined;
    requestStatus: number;
}

export interface CreateCompanyRecruitmentResponse {
    companyRecruitmentId?: string | undefined;
    isValid: boolean;
    errorMessage?: string | undefined;
}

export interface DeleteAttachmentsResponse {
    success: boolean;
}

export interface SynchronizeCompanyRecruitmentFromDfdgResponse {
    companyRecruitmentId: string;
    errorMessage?: string | undefined;
    hasError: boolean;
}

export interface UpdateCandidateResponse {
    isValid: boolean;
    errorMessage?: string | undefined;
    recruitmentCandidate?: RecruitmentCandidateListItem | undefined;
    requestStatus: number;
}

export interface UpdateCandidatesResponse {
    isValid: boolean;
    candidateCollection?: UpdateCandidateResponseItem[] | undefined;
    requestStatus: number;
}

export interface UpdateCompanyRecruitmentResponse {
    success: boolean;
}

export interface GetActiveClosureCausesResponse {
    closureCauses?: ClosureCause[] | undefined;
}

export interface GetAttachmentSettingsForCompanyRecruitmentResponse {
    attachmentSettings?: AttachmentSettings | undefined;
}

export interface GetCalculatedDueDateResponse {
    calculatedDueDate: Date | string;
}

export interface GetCitizenHasTargetGroupThatSupportJobReferralsResponse {
    hasTargetGroupThatSupportJobReferrals: boolean;
}

export interface GetCompaniesInfoResponse {
    companiesInfo?: CompanyInfo[] | undefined;
}

export interface GetCompanyContactPersonsResponse {
    contactPersons?: ContactPersonInfo[] | undefined;
}

export interface GetCompanyInfoResponse2 {
    companyInfo?: CompanyDto | undefined;
}

export interface GetCompanyNotesResponse {
    companyNotes?: CompanyNoteDto2[] | undefined;
}

export interface GetCompanyRecruitmentCandidateResponse {
    candidate?: RecruitmentCandidateDetailsViewModel | undefined;
}

export interface GetCompanyRecruitmentDetailsResponse {
    companyRecruitmentDetailsViewModel?: CompanyRecruitmentDetailsViewModel | undefined;
}

export interface GetCompanyRecruitmentJobMatchesResponse {
    companyRecruitmentJobMatches?: CompanyRecruitmentJobMatchViewModel[] | undefined;
}

export interface GetCompanyRecruitmentsByCompanyIdResponse {
    companyRecruitments?: CompanyRecruitmentViewModel[] | undefined;
}

export interface GetCompanyRecruitmentsForCandidateReferralResponse {
    companyRecruitments?: CompanyRecruitmentSearchResultDto[] | undefined;
}

export interface GetCompanyRecruitmentsFromSkillsRelinkResponse {
    citizenInfo?: CitizenIntelligentMatchInfo | undefined;
    recruitmentRequests?: RecruitmentRequestFromSkillsViewModel[] | undefined;
    jobAds?: RelinkJobAdViewModel[] | undefined;
}

export interface GetCompetenciesRecommendationResponse {
    competencies?: Competence[] | undefined;
}

export interface GetCrmHostResponse2 {
    crmHost?: string | undefined;
}

export interface GetDocumentsFromDocumentArchiveForCompanyRecruitmentResponse {
    attachments?: DocumentArchiveDocumentForCompanyRecruitment[] | undefined;
}

export interface GetJobcentersResponse {
    jobcenters?: CompanyRecruitmentsJobcenter[] | undefined;
}

export interface GetNumberOfCandidatesResponse {
    numberOfCandidates: number;
}

export interface GetOccupationsResponse {
    occupations?: CompanyRecruitmentsOccupationDto[] | undefined;
}

export interface GetOfferInfoForNewRecruitmentReponse {
    newRecruitmentOfferInfo?: NewRecruitmentFromOfferViewModel | undefined;
}

export interface GetOfferTypesResponse2 {
    offerTypes?: OfferTypeDto3[] | undefined;
}

export interface GetPlacementPurposeTypesResponse {
    placementPurposeTypes?: PlacementPurposeTypeDto2[] | undefined;
}

export interface GetQualificationRecommendationResponse {
    jobSkills?: CandidateJobSkill[] | undefined;
}

export interface GetQualificationsResponse {
    qualifications?: QualificationDto[] | undefined;
}

export interface GetRecruitmentCollaborationsResponse {
    recruitmentCollaborations?: RecruitmentCollaborationDto[] | undefined;
}

export interface GetRecruitmentCompanyInformationResponse {
    companyInfo?: RecruitmentRequestCompanyModel | undefined;
}

export interface GetRecruitmentInformationTypesResponse {
    recruitmentInformationTypes?: RecruitmentInformationType2[] | undefined;
}

export interface GetSearchInOwnCitizensUrlResponse {
    url?: string | undefined;
}

export interface GetServiceTargetTypesResponse {
    serviceTargetTypes?: ServiceTargetType[] | undefined;
}

export interface GetSettingsResponse {
    settings?: CompanyRecruitmentSettings | undefined;
}

export interface GetSmartMatchCvSuggestionsResponse {
    searchResultItems?: WeightedCvSearchResultItem[] | undefined;
}

export interface GetTargetGroupByCitizenIdResponse {
    targetGroupId?: string | undefined;
}

export interface GetTargetGroupsResponse {
    targetGroups?: TargetGroupDto[] | undefined;
}

export interface GetTeamsWithUsersHavingFormidlingsansvarligRoleResponse {
    teams?: Team2[] | undefined;
}

export interface GetTeamsWithUsersHavingJobEjerRoleResponse {
    teams?: Team2[] | undefined;
}

export interface GetTenantJobcenterResponse {
    jobcenterInfo?: JobcenterInfoDto2 | undefined;
}

export interface GetUnemploymentFundsResponse {
    unemploymentFunds?: CompanyRecruitmentUnemploymentFund[] | undefined;
}

export interface GetUsersWithFormidlingsansvarligRoleResponse {
    users?: User[] | undefined;
}

export interface GetUsersWithJobEjerRoleResponse {
    users?: User[] | undefined;
}

export interface CreateCitizenResponse {
    citizenId: string;
}

export interface CreateCompanyResponse {
    companyId: string;
}

export interface CreateDashboardResponse {
    savedDashboard?: SavedDashboardModel | undefined;
}

export interface DeleteDashboardResponse {
    success: boolean;
}

export interface DeleteFavoriteDashboardResponse {
    success: boolean;
}

export interface DeleteWorklistElementsResponse {
    results?: DeleteWorklistElementResult[] | undefined;
}

export interface HandleFavoriteDashboardResponse {
    success: boolean;
}

export interface UpdateDashboardResponse {
    savedDashboard?: SavedDashboardModel | undefined;
}

export interface UpdateDashboardStartpageResponse {
    success: boolean;
}

export interface UpdateFavoriteDashboardResponse {
    success: boolean;
}

export interface GetApplicationAreasResponse {
    applicationAreas?: ApplicationArea[] | undefined;
}

export interface GetAllDashboardCategoriesResponse {
    savedDashboardCategories?: SavedDashboardCategory[] | undefined;
}

export interface GetAllDashboardsResponse {
    savedDashboards?: SavedDashboardFormatted[] | undefined;
}

export interface GetAllDashboardTagsResponse {
    tags?: string[] | undefined;
}

export interface GetAllPermissionsResponse {
    accessControlsViewModel?: AccessControlViewModel[] | undefined;
    totalCount: number;
}

export interface GetCitizenByCprResponse {
    isAuthorized: boolean;
    citizen?: RankedSearchModel[] | undefined;
}

export interface GetCitizenFromDfdgResponse {
    citizen?: RankedSearchModel[] | undefined;
}

export interface GetCompanyByProductionUnitIdentifierResponse {
    company?: RankedSearchModel[] | undefined;
}

export interface GetCompanyFromCvrByProductionUnitIdentifierResponse {
    companies?: RankedSearchModel[] | undefined;
}

export interface GetDashboardByIdResponse {
    id: string;
    ownerId: string;
    name?: string | undefined;
    description?: string | undefined;
    sections: DashboardSection[];
    tags?: string[] | undefined;
    savedDashboardCategory?: SavedDashboardCategory | undefined;
    type: WorklistSavedType;
    accessRole?: Access | undefined;
}

export interface GetDashboardCompositionResponse {
    dashboardId: string;
    name?: string | undefined;
    items?: DashboardCompositionRow[] | undefined;
}

export interface GetDashboardsResponse {
    savedDashboards?: SavedDashboardModel[] | undefined;
}

export interface GetDashboardStartPageIdResponse {
    startPageId?: string | undefined;
}

export interface GetEmbeddedSearchResponse {
    searchResponse?: SearchResponse2 | undefined;
}

export interface GetUrlsFromFasitCrmUserFormBaseResponse {
    urls?: string[] | undefined;
}

export interface GetWorklistElementUsageResponse {
    objectType: ObjectType;
    objectId: string;
    name?: string | undefined;
    firstUsedAt?: Date | string | undefined;
    lastUsedAt?: Date | string | undefined;
    lastUsedByUserId?: string | undefined;
    lastUsedByName?: string | undefined;
    totalCount: number;
    distinctUserCount: number;
    monthlyCounts?: MonthlyUsageCount[] | undefined;
    sourceCounts?: SourceUsageCount[] | undefined;
    users?: UserUsageRow[] | undefined;
    referencedByDashboards?: WorklistElementReference[] | undefined;
    referencedByCharts?: WorklistElementReference[] | undefined;
}

export interface GetWorklistUsageOverviewResponse {
    statisticsSince?: Date | string | undefined;
    totalCount: number;
    items?: WorklistUsageOverviewRow[] | undefined;
}

export interface RankedSearchDslConfigurationNameResponse {
    rankedDocumentTypes?: RankedDocumentTypeModel[] | undefined;
}

export interface GetRankedSearchResponse {
    rankedSearchResult?: RankedSearchModel[] | undefined;
    totalHits: number;
    affectedIds?: string[] | undefined;
    hasMoreResults: boolean;
    filterFields?: RankedSearchFilterField[] | undefined;
    documentType?: string | undefined;
}

export interface GetWorklistAccessControlResponse {
    worklistAccessControls?: WorklistAccessControlPrincipal[] | undefined;
}

export interface CreateClosedSdpCaseAnalysisResponse {
    succeeded: boolean;
    reason?: string | undefined;
}

export interface GetCaseEmployerResponse {
    companyId?: string | undefined;
    employerName?: string | undefined;
}

export interface GetStoredCaseAnalysisResponse {
    analysisFound: boolean;
    analysisResult?: string | undefined;
    wasInputCondensed: boolean;
}

export interface GetVisitationAssistantResponse {
    isEnabled: boolean;
}

export interface GetVisitationGuideResponse {
    isVisitationDoneInGuide: boolean;
}

export interface GrantUseOfForceAuthorizationRequestResponse {
    request: ReceivedUseOfForceAuthorizationRequestModel;
}

export interface RegisterUseOfForceAuthorizationResponse {
    authorization: UseOfForceAuthorizationModel;
}

export interface RejectUseOfForceAuthorizationRequestResponse {
    request: ReceivedUseOfForceAuthorizationRequestModel;
}

export interface RevokeUseOfForceAuthorizationResponse {
    authorization: UseOfForceAuthorizationModel;
}

export interface GetReceivedUseOfForceAuthorizationRequestsResponse {
    requests: ReceivedUseOfForceAuthorizationRequestModel[];
}

export interface GetUseOfForceAuthorizationsForCitizenResponse {
    authorizations: UseOfForceAuthorizationModel[];
    serviceProviderUnits: UseOfForceServiceProviderUnitModel[];
}

export interface AssessUseOfForceFormResponse {
    assessment: UseOfForceAssessmentModel;
}

export interface GetUseOfForceAssessmentsForCitizenResponse {
    assessments: UseOfForceAssessmentModel[];
}

export interface GetAccountInfoResponse extends UnemploymentBenefitsAccountinfoModel {
}

export interface GetCitizenAndNuphIdByNuphResponseIdResponse {
    citizenId: string;
    nuphId: string;
}

export interface GetCitizenIdByNuphIdResponse {
    citizenId: string;
}

export interface GetNuphResponse {
    nuph?: NuphModel | undefined;
}

export interface GetNuphAdditionalInformationResponse {
    nuphAdditionalRequestResponses?: NuphAdditionalRequestResponseModel[] | undefined;
}

export interface GetNuphDocumentsResponse {
    nuphDocuments?: NuphDocumentModel[] | undefined;
}

export interface GetNuphResponsesResponse {
    nuphResponses?: NuphResponseModel[] | undefined;
}

export interface GetNuphsResponse {
    nuphs?: NuphModel[] | undefined;
}

export interface GetNuphTypesResponse {
    nuphTypes?: NuphType[] | undefined;
}

export interface GetPayoutsResponse extends CitizenPayoutsModel {
}

export interface GetUnemploymentFundResponse extends UnemploymentFundModel {
}

export interface GetUnemploymentSummaryDetailsResponse {
    completedJoinedInterviews?: number | undefined;
    citizenWantUnemploymentFundForFirstInterviewInJobcenter: boolean;
    citizenDoesNotWantUnemploymentFundParticipation: boolean;
    latestJobInterviewAtFund?: Date | string | undefined;
    nextInterviewAtFund?: Date | string | undefined;
}

export interface CancelScreeningResponse {
    isCancelled: boolean;
}

export interface StartScreeningResponse {
    screeningStarted: boolean;
}

export interface GetAvailableScreeningsResponse {
    screenings?: ScreeningListModel[] | undefined;
}

export interface GetCitizenSurveysResponse {
    surveys?: SurveyListDto[] | undefined;
}

export interface GetScreeningValidationValuesResponse {
    hasActiveScreening: boolean;
}

export interface GetAnsweredProgressionSurveysResponse {
    surveys?: AnsweredProgressionSurveyViewModel[] | undefined;
}

export interface GetHoiPrimaryTeamForCitizenResponse {
    primaryTeam?: string | undefined;
}

export interface GetHoiActivitiesForCitizenResponse {
    hoiActivities?: HoiActivity[] | undefined;
}

export interface GetHoiTeamByUserIdResponse {
    primaryTeam?: string | undefined;
}

export interface ExecuteNexusImportResponse {
    progressId: string;
}

export interface ExecuteNexusServiceProviderImportResponse {
    persistedChanges: boolean;
    items?: NexusImportResultItemModel[] | undefined;
}

export interface GetHoiCaseMainDataResponse {
    caseWorkerName?: string | undefined;
    caseStartDate?: Date | string | undefined;
}

export interface GetHoiCompanyContactPersonsResponse {
    hoiCompanyContactPersons?: HoiCompanyContactPersonModel[] | undefined;
}

export interface GetHoiDataResponse {
    citizenInfo?: CitizenHoiInfo | undefined;
    dummy?: string | undefined;
}

export interface GetHoiGuideConfigurationResponse {
    latestNetworkEffortOptions?: string[] | undefined;
    currentAssistanceOptions?: string[] | undefined;
}

export interface GetHoiLetterEditableContentResponse {
    content?: string | undefined;
}

export interface GetHoiPrivateContactPersonsResponse {
    privateContactPersons?: HoiPrivateContactPersonModel[] | undefined;
}

export interface GetHoiSummaryResponse {
    vumStatus?: VumStatus | undefined;
    effortCount: number;
    latestCreateAssessmentDate?: Date | string | undefined;
    is_KUI_Young: boolean;
    externalIntegrationSystemText?: string | undefined;
}

export interface GetNexusCitizenExistsResponse {
    citizenExistsInNexus: boolean;
}

export interface GetNexusImportDocumentResponse {
    nexusDocumentId: number;
    name?: string | undefined;
    originalFileName?: string | undefined;
    fileType?: string | undefined;
    notes?: string | undefined;
    status?: string | undefined;
    uploadedAt?: Date | string | undefined;
    relevantFrom?: Date | string | undefined;
    canBeDownloaded: boolean;
}

export interface GetNexusImportEntryContentResponse {
    nexusFormDataId: number;
    formDefinitionId?: number | undefined;
    title?: string | undefined;
    status?: string | undefined;
    pathwayName?: string | undefined;
    createdAt?: Date | string | undefined;
    updatedAt?: Date | string | undefined;
    observedAt?: Date | string | undefined;
    fields?: NexusFormContentFieldModel[] | undefined;
}

export interface GetNexusImportLetterResponse {
    nexusLetterId: number;
    subject?: string | undefined;
    text?: string | undefined;
    sentAt?: Date | string | undefined;
    direction?: string | undefined;
    statusName?: string | undefined;
    senderName?: string | undefined;
    recipientName?: string | undefined;
    templateName?: string | undefined;
    pathwayName?: string | undefined;
}

export interface GetNexusImportPreviewResponse {
    pathwayFilterId: number;
    entries?: NexusImportPreviewEntryModel[] | undefined;
    caseworkers?: NexusImportCaseworkerModel[] | undefined;
    contacts?: NexusImportContactModel[] | undefined;
    noteTypeWarnings?: NexusImportNoteTypeWarningModel[] | undefined;
}

export interface GetNexusImportProgressResponse {
    status: NexusImportJobStatus;
    errorMessage?: string | undefined;
    persistedChanges: boolean;
    createdAssessmentId?: string | undefined;
    items?: NexusImportResultItemModel[] | undefined;
}

export interface GetNexusServiceProviderImportPreviewResponse {
    entries?: NexusImportPreviewEntryModel[] | undefined;
    noteTypeWarnings?: NexusImportNoteTypeWarningModel[] | undefined;
}

export interface CreatePartialRecoveryResponse {
    partialRecoveryId: string;
}

export interface GetPartialRecoveriesByAbsenceIdResponse {
    partialRecoveries?: PartialRecoveryListModel[] | undefined;
}

export interface GetPartialRecoveriesByCaseIdResponse {
    partialRecoveries?: PartialRecoveryListModel[] | undefined;
}

export interface GetPartialRecoveryByIdResponse {
    partialRecovery?: PartialRecoveryModel | undefined;
    caseName?: string | undefined;
    partialRecoveryCaseModels?: PartialRecoveryCaseModel[] | undefined;
}

export interface CancelMissingParticipationResponse {
    missingParticipationId: string;
}

export interface CreateMissingParticipationResponse {
    missingParticipationId: string;
}

export interface FinishMissingParticipationResponse {
    missingParticipationId: string;
}

export interface GetLetterContentForMissingParticipationResponse {
    content?: string | undefined;
}

export interface GetMissingParticipationByIdResponse {
    missingParticipation?: MissingParticipationModel | undefined;
}

export interface GetMissingParticipationConfigurationsResponse {
    offsetDays: number;
}

export interface GetMissingParticipationInStatusUnderPartyHearingByCaseIdResponse {
    missingParticipation?: MissingParticipationModel | undefined;
}

export interface GetMissingParticipationsByCaseIdResponse {
    missingParticipations?: MissingParticipationListModel[] | undefined;
}

export interface GetMissingParticipationTypesResponse {
    missingParticipationTypes?: MissingParticipationType[] | undefined;
}

export interface GetOutgoingDocumentTypesResponse2 {
    outgoingDocumentTypes?: OutgoingDocumentType[] | undefined;
}

export interface CreateExpectedJobResumptionResponse {
    expectedJobResumptionId: string;
}

export interface GetExpectedJobResumptionByIdResponse {
    expectedJobResumption?: ExpectedJobResumptionModel | undefined;
    caseName?: string | undefined;
    expectedJobResumptionCaseModels?: ExpectedJobResumptionCaseModel[] | undefined;
}

export interface GetExpectedJobResumptionsListResponse {
    expectedJobResumptions?: ExpectedJobResumptionListModel[] | undefined;
}

export interface GetActiveSicknessAbsenceByCitizenIdResponse {
    absence?: AvailabilityAbsenceModel | undefined;
}

export interface GetCloseCaseGuideDataResponse {
    absenceCauseTypeItems?: AbsenceCauseTypeItem[] | undefined;
    hasAnyOpenFlexJobCases: boolean;
    hasMissingParticipations: boolean;
    hasBenefitExtensionAssessments: boolean;
    targetGroupChangedByCaseName?: string | undefined;
    hasActiveAbsence: boolean;
    hasActivities: boolean;
    hasAnyOpenSicknessBenifitOrJobClarificationCases: boolean;
    removalCauseTypes?: RemovalCauseType2[] | undefined;
    hasActiveEnrollments: boolean;
    hasAnyOpenCasesThatIsNotOtherOrSicknessBenefit: boolean;
    hasGrants: boolean;
}

export interface GetContactGroupByCitizenIdResponse {
    contactGroupList?: ContactGroupItem[] | undefined;
    contactGroup?: ContactGroupModel | undefined;
}

export interface GetSicknessAbsenceByCitizenIdResponse {
    absences?: AvailabilityAbsenceModel[] | undefined;
}

export interface SicknessBenefitVisitationResponse {
    status?: SicknessBenefitVisitationStatus | undefined;
    justification?: string | undefined;
}

export interface CreateBenefitExtensionAssessmentResponse {
    benefitExtensionAssessmentId: string;
    createdOn: Date | string;
}

export interface GetBenefitExtensionAssessmentByCaseIdResponse {
    benefitExtensionAssessments?: BenefitExtensionAssessmentViewModel[] | undefined;
}

export interface GetBenefitExtensionAssessmentDataResponse {
    model?: BenefitExtensionAssessmentEditModel | undefined;
}

export interface GetGuideDataResponse {
    benefitExtensionReasonItems?: BenefitExtensionReason[] | undefined;
    tilRaadighedForArbejdsmarkedetInden26UgerBenefitExtensionReasonId: string;
    maxWaitTimeOnInputFromCitizenForBenefitExtensionAssessmentInDays: number;
}

export interface GetOpenBenefitExtensionAssessmentIdResponse {
    benefitExtensionAssessmentId?: string | undefined;
}

export interface ApproveUseOfForceHygieneRestraintLogResponse {
    log: UseOfForceHygieneRestraintLogModel;
}

export interface ApproveUseOfForceIncidentResponse {
    incident: UseOfForceIncidentModel;
}

export interface ApproveUseOfForceSummaryRegistrationResponse {
    registration: UseOfForceSummaryRegistrationModel;
}

export interface AttachUseOfForceCitizenStatementResponse {
    incident: UseOfForceIncidentModel;
}

export interface AttachUseOfForceSummaryRegistrationCitizenStatementResponse {
    registration: UseOfForceSummaryRegistrationModel;
}

export interface CancelUseOfForceIncidentResponse {
    incident: UseOfForceIncidentModel;
}

export interface CorrectUseOfForceHygieneRestraintResponse {
    log: UseOfForceHygieneRestraintLogModel;
}

export interface CreateUseOfForceAuthorizationRequestResponse {
    request: UseOfForceAuthorizationRequestModel;
}

export interface CreateUseOfForceIncidentResponse {
    incident: UseOfForceIncidentModel;
}

export interface CreateUseOfForceSummaryRegistrationResponse {
    registration: UseOfForceSummaryRegistrationModel;
}

export interface RegisterServiceProviderUseOfForceAuthorizationResponse {
    authorization: UseOfForceAuthorizationModel;
}

export interface RegisterUseOfForceAuthorizationRequestDecisionResponse {
    request: UseOfForceAuthorizationRequestModel;
}

export interface RegisterUseOfForceAuthorizationRequestMunicipalitySendingResponse {
    request: UseOfForceAuthorizationRequestModel;
}

export interface RegisterUseOfForceHygieneRestraintResponse {
    log: UseOfForceHygieneRestraintLogModel;
}

export interface RegisterUseOfForceHygieneRestraintLogMunicipalitySendingResponse {
    log: UseOfForceHygieneRestraintLogModel;
}

export interface RegisterUseOfForceRelativesInformationResponse {
    incident: UseOfForceIncidentModel;
}

export interface RegisterUseOfForceResponsibleMunicipalitySendingResponse {
    incident: UseOfForceIncidentModel;
}

export interface RegisterUseOfForceSummaryRegistrationMunicipalitySendingResponse {
    registration: UseOfForceSummaryRegistrationModel;
}

export interface RegisterUseOfForceSummaryRegistrationOperatorInformationResponse {
    registration: UseOfForceSummaryRegistrationModel;
}

export interface RegisterUseOfForceSummaryRegistrationRelativesInformationResponse {
    registration: UseOfForceSummaryRegistrationModel;
}

export interface RegisterUseOfForceSummaryRegistrationSupervisionSendingResponse {
    registration: UseOfForceSummaryRegistrationModel;
}

export interface RemoveUseOfForceCitizenStatementResponse {
    incident: UseOfForceIncidentModel;
}

export interface RemoveUseOfForceHygieneRestraintResponse {
    log?: UseOfForceHygieneRestraintLogModel | undefined;
}

export interface RemoveUseOfForceSummaryRegistrationCitizenStatementResponse {
    registration: UseOfForceSummaryRegistrationModel;
}

export interface ReturnUseOfForceIncidentResponse {
    incident: UseOfForceIncidentModel;
}

export interface RevokeServiceProviderUseOfForceAuthorizationResponse {
    authorization: UseOfForceAuthorizationModel;
}

export interface SendUseOfForceAuthorizationRequestResponse {
    request: UseOfForceAuthorizationRequestModel;
}

export interface SubmitUseOfForceIncidentResponse {
    incident: UseOfForceIncidentModel;
}

export interface UpdateUseOfForceAuthorizationRequestDraftResponse {
    request: UseOfForceAuthorizationRequestModel;
}

export interface UpdateUseOfForceIncidentDraftResponse {
    incident: UseOfForceIncidentModel;
}

export interface UpdateUseOfForceIncidentLeaderSectionResponse {
    incident: UseOfForceIncidentModel;
}

export interface UpdateUseOfForceSummaryRegistrationDraftResponse {
    registration: UseOfForceSummaryRegistrationModel;
}

export interface GetUseOfForceAssignmentOptionsResponse {
    assignments: UseOfForceAssignmentOptionModel[];
}

export interface GetUseOfForceAuthorizationRequestResponse {
    request: UseOfForceAuthorizationRequestModel;
}

export interface GetUseOfForceAuthorizationRequestsForCitizenResponse {
    canAdminister: boolean;
    requests: UseOfForceAuthorizationRequestModel[];
}

export interface GetUseOfForceAuthorizationsForServiceProviderUnitResponse {
    authorizations: UseOfForceAuthorizationModel[];
    canAdminister: boolean;
    canRegister: boolean;
}

export interface GetUseOfForceHygieneRestraintLogsForCitizenResponse {
    logs: UseOfForceHygieneRestraintLogModel[];
    currentUserName: string;
    canAdminister: boolean;
}

export interface GetUseOfForceIncidentResponse {
    incident: UseOfForceIncidentModel;
}

export interface GetUseOfForceIncidentsForCitizenResponse {
    incidents: UseOfForceIncidentModel[];
}

export interface GetUseOfForceSummaryRegistrationResponse {
    registration: UseOfForceSummaryRegistrationModel;
}

export interface GetUseOfForceSummaryRegistrationsForCitizenResponse {
    canAdminister: boolean;
    registrations: UseOfForceSummaryRegistrationModel[];
}

export interface GetTrafficLightResponse {
    trafficLight?: TrafficLightModel | undefined;
}

export interface GetTrafficLightHistoryResponse {
    events?: TrafficLightHistoryEventModel[] | undefined;
}

export interface CreateActivityForAssignmentResponse {
    activityId: string;
}

export interface CreateAssignmentAsServiceProviderResponse {
    assignmentId?: AssignmentId | undefined;
    activityId?: ActivityId | undefined;
}

export interface CreateServiceProviderAssignmentResponse {
    assignmentId?: AssignmentId | undefined;
}

export interface EnsureCitizenForAssignmentResponse {
    citizenId: string;
}

export interface GetCitizenFromFasitOrExternalSourceResponse {
    citizen?: CitizenDto | undefined;
    noExistingAssignments: boolean;
    serviceProviderUnits?: ServiceProviderUnitDto[] | undefined;
}

export interface GetServiceProviderUnitResponse {
    serviceProviderUnit?: ServiceProviderUnitModel | undefined;
}

export interface CreateObservationResponse {
    observationId: string;
}

export interface GetObservationsResponse {
    observations: ServiceProviderObservationModel[];
}

export interface ChangeMedicineInventoryPackageStatusResponse {
    medicineInventory: MedicineInventoryViewModel;
}

export interface CountMedicineInventoryResponse {
    medicineInventory: MedicineInventoryViewModel;
}

export interface DiscardFromMedicineInventoryPackageResponse {
    medicineInventory: MedicineInventoryViewModel;
}

export interface RecordPnEffectAssessmentResponse {
    latest?: LatestPnAdministrationViewModel | undefined;
}

export interface RegisterMedicineAdministrationResponse {
    medicineInventory: MedicineInventoryViewModel;
}

export interface ReturnFromMedicineInventoryPackageResponse {
    medicineInventory: MedicineInventoryViewModel;
}

export interface SetMedicineInventoryPackageBatchAndExpiryResponse {
    medicineInventory: MedicineInventoryViewModel;
}

export interface SetMedicineInventoryPackageLocationResponse {
    medicineInventory: MedicineInventoryViewModel;
}

export interface GetCountDoubleControlDeclarationResponse {
    declaration: string;
}

export interface GetDisposalDoubleControlDeclarationResponse {
    declaration: string;
}

export interface GetDoubleControlDeclarationResponse {
    declaration: string;
}

export interface GetLatestPnAdministrationResponse {
    latest?: LatestPnAdministrationViewModel | undefined;
}

export interface GetMedicineAdministrationsAwaitingDoubleControlResponse {
    administrations: MedicineAdministrationViewModel[];
}

export interface GetMedicineAdministrationsForPeriodResponse {
    administrations: MedicineAdministrationViewModel[];
}

export interface GetMedicineInventoryControlSheetResponse {
    controlSheet: MedicineInventoryControlSheetViewModel;
}

export interface GetMedicineInventoryForCitizenResponse {
    medicineInventory?: MedicineInventoryViewModel | undefined;
}

export interface GetMedicineInventoryMovementsAwaitingDoubleControlResponse {
    movements: MedicineInventoryMovementAwaitingDoubleControlViewModel[];
}

export interface GetReturnDoubleControlDeclarationResponse {
    declaration: string;
}

export interface AddOtcMedicationResponse {
    medicineCard: MedicineCardViewModel;
}

export interface CreateMedicineCardForCitizenResponse {
    medicineCard?: MedicineCardViewModel | undefined;
}

export interface RegisterMedicineCardPrivacyConsentResponse {
    consent: MedicineCardPrivacyConsentViewModel;
    medicineCard?: MedicineCardViewModel | undefined;
}

export interface RevokeMedicineCardPrivacyConsentResponse {
    consent: MedicineCardPrivacyConsentViewModel;
    medicineCard?: MedicineCardViewModel | undefined;
}

export interface SeponerOtcMedicationResponse {
    medicineCard?: MedicineCardViewModel | undefined;
}

export interface SynchronizeMedicineCardFromFmkResponse {
    medicineCard: MedicineCardViewModel;
    appliedChanges: AppliedFmkChangesViewModel;
}

export interface UpdateOperationalDetailsResponse {
    medicineCard: MedicineCardViewModel;
    markedForDoubleCheckChange?: MarkedForDoubleCheckChangeViewModel | undefined;
}

export interface GetMedicineCardForCitizenResponse {
    medicineCard?: MedicineCardViewModel | undefined;
}

export interface CreateInterventionObjectiveStatusResponse {
    status: InterventionObjectiveStatusModel;
}

export interface GenerateInterventionObjectiveStatusDraftResponse {
    draftText?: string | undefined;
    warnings?: string[] | undefined;
}

export interface GetInterventionObjectiveStatusByStatusIdResponse {
    status?: InterventionObjectiveStatusModel | undefined;
}

export interface GetInterventionObjectiveStatusesByAssignmentIdResponse {
    statuses?: InterventionObjectiveStatusModel[] | undefined;
}

export interface GetHealthConditionHistoryResponse {
    entries: HealthConditionHistoryEntryModel[];
}

export interface GetHealthOverviewResponse {
    healthOverview: HealthOverviewModel;
}

export interface GetProblemAreaHistoryResponse {
    entries: ProblemAreaHistoryEntryModel[];
}

export interface GetAssignmentDistributionResponse {
    distributionStatus?: AssignmentDistributionStatus | undefined;
    activityId: string;
    offerId?: string | undefined;
    activityHoursPerWeek: number;
    activityMinutesPerWeek: number;
    maxActiveResourcesPerActivity?: number | undefined;
    allocations?: ActivityResourceViewModel[] | undefined;
}

export interface GetServiceProviderCitizenNotesResponse {
    citizenNotes?: ServiceProviderCitizenNotesModel | undefined;
}

export interface SetServiceProviderCitizenDescriptionResponse {
    serviceProviderCitizenDescription?: string | undefined;
}

export interface GetServiceProviderCitizenDescriptionResponse {
    serviceProviderCitizenDescription?: string | undefined;
}

export interface CreateServiceProviderCalendarEventResponse {
    eventId: string;
}

export interface GetServiceProviderCitizenCalendarEventsResponse {
    calendarEvents?: CalendarEventModel[] | undefined;
}

export interface Response {
    nexusEvents: NexusCalendarEventModel[];
}

export interface GenerateServiceProviderCitizenBriefResponse {
    brief: ServiceProviderCitizenBriefModel;
}

export interface GetStoryRemindersResponse {
    reminders: StoryRemindersModel;
}

export interface ProposeRegistrationsFromStoryResponse {
    registrations: StoryRegistrationsModel;
}

export interface ScreenCitizenDiaryForUseOfForceResponse {
    screening: UseOfForceScreeningModel;
}

export interface RegisterComplaintResponse {
    complaintId: string;
}

export interface GetAppealFormResponse {
    appealForm?: AppealFormModel | undefined;
}

export interface CreateRulingContinuationResponse {
    continuationId: string;
}

export interface CreatingRulingResponse {
    rulingId: string;
}

export interface UpdateRulingResponse {
    rulingId: string;
}

export interface ValidateRulingFunctionResponse {
    validationResults?: RulingFunctionValidationResult[] | undefined;
}

export interface GetAssessmentDataForRecommendationResponse {
    formattedText?: string | undefined;
}

export interface GetAssessmentDataForRulingImportResponse {
    status: AssessmentStatusDto;
    assessmentSummary?: string | undefined;
    assessmentSummaryRichText?: string | undefined;
    citizenAssessmentPurposeInfo?: string | undefined;
    citizenAssessmentPurposeInfoRichText?: string | undefined;
    reasonForDecision?: string | undefined;
    reasonForDecisionRichText?: string | undefined;
    primaryAssessmentTopicId?: string | undefined;
    additionalAssessmentTopicIds: string[];
}

export interface GetAssessmentsForRulingResponse {
    assessments?: RulingAssessmentModel[] | undefined;
}

export interface GetCasesForRulingResponse {
    cases?: RulingCaseInfo[] | undefined;
}

export interface GetCitizenPersonContactsForRulingResponse {
    personContacts?: RulingPersonContactModel[] | undefined;
}

export interface GetConductedInterviewsForRulingContinuationResponse {
    interviews?: ConductedInterviewModel[] | undefined;
}

export interface GetDocumentsForRulingResponse {
    documents?: RulingDocumentModel[] | undefined;
}

export interface GetGrantsForRulingResponse {
    grants?: RulingGrantModel[] | undefined;
}

export interface GetJournalNotesForRulingResponse {
    journalNotes?: RulingJournalNoteModel[] | undefined;
}

export interface GetRulingResponse {
    ruling?: GetRulingResponse2 | undefined;
}

export interface GetRulingsForCaseResponse {
    rulings?: RulingDto[] | undefined;
}

export interface GetRulingVisitationBookingResponse {
    booking?: RulingVisitationBookingModel | undefined;
}

export interface GetRulingVisitationBookingOptionsResponse {
    visitationTeams: VisitationTeamOptionModel[];
}

export interface GetActivePlanResponse {
    plan: JobcenterPlanViewModel;
    shouldChangePlanType: boolean;
}

export interface GetAllowedPlanTypesResponse {
    planTypes?: PlanTypeListItemViewModel[] | undefined;
}

export interface GetCitizenIdByContractIdResponse {
    citizenId?: string | undefined;
}

export interface GetCitizenIdByPlanIdResponse {
    citizenId?: string | undefined;
}

export interface GetContactForCitizenResponse {
    hasContactPersonForEducationPlan: boolean;
}

export interface GetContractResponse {
    contract: JobcenterContractViewModel;
}

export interface GetDanishGoalsResponse {
    danishGoals: DanishGoalEditModel[];
}

export interface GetEditableContractResponse {
    contract: JobcenterContractEditModel;
    hasLegalContract: boolean;
    hasAsylumTransitionDate: boolean;
}

export interface GetEditablePlanResponse {
    plan: PlanEditViewModel;
    shouldChangePlanType: boolean;
}

export interface GetEducationImpositionResponse {
    currentStep?: EducationStepDto | undefined;
    educationGoals?: EducationGoalDto[] | undefined;
    deadline?: Date | string | undefined;
    educationRetentions?: EducationRetentionTypeDto[] | undefined;
    selectableGoals?: GoalDto[] | undefined;
    allowedGoalTypes?: GoalTypeDto[] | undefined;
    companyNames?: CompanyName[] | undefined;
}

export interface GetGeographicalAreasResponse {
    geographicalAreas: GeographicalAreaModel[];
}

export interface GetJobSearchDefinitionResponse {
    jobSearchDefinition?: JobSearchDefinitionModel | undefined;
}

export interface GetLanguagesResponse {
    languages: LanguageItem[];
}

export interface GetMunicipalitiesResponse2 {
    municipalities: MunicipalityModel[];
}

export interface GetOccupationsResponse2 {
    occupations: OccupationModel2[];
}

export interface GetPlanInfoResponse {
    planInfo: JobcenterPlanInfoViewModel;
}

export interface GetPlanVersionsResponse {
    planVersions?: PlanVersion[] | undefined;
}

export interface GetSelectableGoalsResponse {
    goals: GoalEditViewModel[];
}

export interface HasLegalContractResponse {
    hasContract: boolean;
}

export interface MayEditPlanResponse {
    mayEditPlan: boolean;
}

export interface MayRegisterJobSearchDefinitionResponse {
    mayRegister: boolean;
}

export interface PublishPlanResponse {
    status?: string | undefined;
}

export interface ReactivatePlanResponse {
    status?: string | undefined;
}

export interface SaveContractDraftResponse {
    status: boolean;
}

export interface SaveDraftEducationPlanResponse {
    status: boolean;
}

export interface SavePlanDraftResponse {
    status: boolean;
}

export interface SendMyPlanAsLetterResponse {
    status?: string | undefined;
}

export interface CreateMedicalCollaborationCitizenResponse {
    citizenId: string;
}

export interface CreateMedicalRequestResponse {
    isSuccess: boolean;
    errorMessage?: string | undefined;
    requestFormId?: string | undefined;
    validationErrors?: string[] | undefined;
}

export interface CreateMedicalRequestForMedicalCollaboratorResponse {
    isSuccess: boolean;
    errorMessage?: string | undefined;
    requestFormId?: string | undefined;
    validationErrors?: string[] | undefined;
}

export interface GenerateMedicalRequestAttachmentPdfResponse {
    documentId: string;
    fileName?: string | undefined;
    mimeType?: string | undefined;
    businessUnitId: string;
}

export interface DownloadCorrespondenceDocumentResponse {
    documentBytes?: string | undefined;
}

export interface DownloadCorrespondenceDocumentForServiceProviderResponse {
    documentBytes?: string | undefined;
}

export interface DownloadMedicalDocumentResponse {
    documentBytes?: string | undefined;
}

export interface DownloadMedicalDocumentForMedicalCollaboratorResponse {
    documentBytes?: string | undefined;
}

export interface GetAllowedCorrespondenceAttachmentExtensionsResponse {
    extensions?: string[] | undefined;
}

export interface GetCaseTargetGroupTypeResponse {
    targetGroupType: CaseTargetGroupType;
}

export interface GetCitizenCasesMedicalResponse {
    citizenCases?: CitizenCaseMedicalModel[] | undefined;
}

export interface GetCitizenContactInfoResponse {
    addressCoLine?: string | undefined;
    addressLine?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    citizenPhone?: string | undefined;
    citizenMobilePhone?: string | undefined;
    interpreterLanguage?: string | undefined;
}

export interface GetCitizenDoctorAsCorrespondenceReceiverResponse {
    receiver?: DoctorCorrespondenceReceiverModel | undefined;
}

export interface GetCitizenDoctorInfoResponse {
    citizenDoctorInfo?: DoctorInfo | undefined;
}

export interface GetCitizenFormCodeResponse {
    citizenFormCode?: string | undefined;
    citizenFormCodeNeeded: boolean;
    letterTemplateCode?: string | undefined;
    attachmentTemplateCode?: string | undefined;
}

export interface GetCitizenForMedicalCollaborationResponse {
    citizen?: CitizenDto | undefined;
    foundOnlyInExternalSource: boolean;
    serviceProviderUnits?: SocialProviderUnitDto2[] | undefined;
}

export interface GetCitizenHospitalStaysResponse {
    isCurrentlyAdmitted: boolean;
    activeStay?: HospitalStay | undefined;
    stays: HospitalStay[];
}

export interface GetCitizenIdByCorrespondenceMessageIdResponse {
    citizenId: string;
}

export interface GetCitizenIdByRequestFormIdResponse {
    citizenId: string;
}

export interface GetCitizenLetterJournalNoteResponse {
    journalNoteId?: string | undefined;
    title?: string | undefined;
    createdAt?: Date | string | undefined;
}

export interface GetCitizenPatientInfoResponse {
    patientInfo?: PatientInfo | undefined;
}

export interface GetContactShortNameResponse {
    shortName?: string | undefined;
}

export interface GetCorrespondenceMessageResponse {
    message?: CorrespondenceMessage | undefined;
}

export interface GetCorrespondenceMessageForServiceProviderResponse {
    message?: CorrespondenceMessage | undefined;
}

export interface GetCorrespondenceMessagesResponse {
    messages?: CorrespondenceMessage[] | undefined;
}

export interface GetCorrespondenceMessagesForServiceProviderResponse {
    messages?: CorrespondenceMessage[] | undefined;
}

export interface GetCorrespondenceMessageSignatureResponse {
    fullName?: string | undefined;
    jobTitle?: string | undefined;
    phoneNumber?: string | undefined;
    unitName?: string | undefined;
}

export interface GetDoctorResponseDeadlineEnabledResponse {
    enabled: boolean;
    doctorResponseDeadlineDays?: number | undefined;
}

export interface GetMedicalCollaboratorMedicalRequestsResponse {
    medicalRequests?: MedicalRequestViewModel[] | undefined;
    showActionColumn: boolean;
}

export interface GetMedicalRequestResponse {
    medicalRequest?: MedicalRequestItemViewModel | undefined;
}

export interface GetMedicalRequestForMedicalCollaboratorResponse {
    medicalRequest?: MedicalRequestItemViewModel | undefined;
}

export interface GetMedicalRequestsResponse {
    medicalRequests?: MedicalRequestViewModel[] | undefined;
    showActionColumn: boolean;
}

export interface GetMedicalRequestTypesResponse {
    medicalRequestTypes: MedicalRequestTypeModel[];
}

export interface GetRequestFormCodeByRequestFormIdResponse {
    requestFormCode?: string | undefined;
}

export interface GetSorNodesQueryResponse {
    nodes: SorNodeViewModel[];
}

export interface GetSorSearchResultByLookupQueryResponse {
    results?: SorSearchResultViewModel[] | undefined;
}

export interface GetSorTreeSearchResultByLookupQueryResponse {
    results?: SorSearchResultViewModel[] | undefined;
}

export interface ValidateCorrespondenceAttachmentsResponse {
    messages?: string[] | undefined;
}

export interface CreateJournalReportResponse {
    progressId: string;
}

export interface GetInitalDataForJournalReportResponse {
    journalNoteCases?: JournalNoteCaseModel[] | undefined;
}

export interface GetJournalNotesByCaseIdsAndPeriodResponse {
    journalNotes?: JournalNoteModel[] | undefined;
    excludedAttachment?: ExcludedAttachment[] | undefined;
}

export interface GetJournalReportProgressByIdResponse {
    journalReportProgress?: JournalReportProgressDto | undefined;
}

export interface GetScannedJournalNoteResultsResponse {
    journalNoteScanResults?: JournalNoteScanResult[] | undefined;
}

export interface SaveDraftDocumentResponse {
    documentId: string;
    attachments?: DocumentAttachmentModel[] | undefined;
}

export interface SaveFinishedDocumentResponse {
    documentId: string;
}

export interface UploadDraftAttachmentResponse {
    attachment?: DocumentAttachmentViewModel | undefined;
}

export interface GetCitizenCasesResponse {
    cases?: CitizenCaseViewModelBFF[] | undefined;
}

export interface GetCitizenCvResponse {
    cvAttachment?: DocumentAttachmentViewModel | undefined;
}

export interface GetCitizenIdByDocumentIdResponse {
    citizenId: string;
    documentId: string;
}

export interface GetDocumentByIdResponse {
    document?: DocumentViewModel | undefined;
}

export interface GetDocumentsForCitizenIdResponse {
    documents?: DocumentListItemModel[] | undefined;
}

export interface GetDocumentTemplatesResponse {
    templates?: DocumentTemplatesViewModel[] | undefined;
}

export interface GetPDFConversionSettingResponse {
    isFeatureEnabled: boolean;
}

export interface GetRenderedTemplateResponse {
    html?: string | undefined;
    header?: HeaderFooterInfo | undefined;
    footer?: HeaderFooterInfo | undefined;
}

export interface GetServiceProviderDocumentsForCitizenIdResponse {
    documents?: DocumentListItemModel[] | undefined;
}

export interface GetStandardAttachmentDocumentsResponse {
    attachments?: DocumentArchiveDocumentModel[] | undefined;
}

export interface GetAttachmentSettingsResponse {
    isFeatureEnabled: boolean;
}

export interface UpdateJournalReportDetailsResponse {
    journalReportId: string;
}

export interface GetCasesForCitizenResponse {
    casesForCitizen?: CitizenCaseViewModelBFF[] | undefined;
}

export interface GetCaseTargetGroupResponse {
    caseTargetGroup?: TargetGroup | undefined;
}

export interface GetCaseworkerResponse {
    responsibleCaseworker?: SystemUserModel | undefined;
}

export interface GetCitizenIdByJournalNoteIdResponse {
    citizenId: string;
}

export interface GetContentTypesResponse {
    contentTypes: JournalNoteContentTypeModel[];
}

export interface GetCrmFeatureSettingResponse {
    isFeatureEnabled: boolean;
}

export interface GetJournalNoteResponse {
    journalNote: JournalNoteModel;
}

export interface GetJournalNoteDetailsForCitizenIdResponse {
    journalNotes: JournalNoteModel[];
}

export interface GetJournalNotePageForCitizenIdResponse {
    journalNotes: JournalNoteListItemModel[];
    countResponse?: CountResponse | undefined;
    filterResponse?: FilterResponse | undefined;
}

export interface GetJournalNoteReadMarkingConfigurationResponse {
    enableJournalNoteReadMarking: boolean;
}

export interface GetJournalNotesForCitizenIdResponse {
    journalNotes?: JournalNoteModel[] | undefined;
    countResponse?: CountResponse | undefined;
    filterResponse?: FilterResponse | undefined;
}

export interface GetJournalReportByIdResponse {
    journalReport?: JournalReportModel | undefined;
}

export interface GetJournalReportJobStatusResponse {
    status: JournalReportJobStatus;
    statusDisplayName?: string | undefined;
    statusMessage?: string | undefined;
    progressPercent?: string | undefined;
    errorMessage?: string | undefined;
    queueCount: number;
    createdJournalReportId?: string | undefined;
}

export interface GetJournalReportLinkResponse {
    url?: string | undefined;
}

export interface GetJournalReportsForCitizenIdResponse {
    journalReports?: JournalReportModel[] | undefined;
}

export interface GetSourcesResponse {
    sources: KeyValuePair[];
}

export interface SearchJournalNotesForCitizenPersonContactResponse {
    journalNotes?: JournalNoteForLookupModel[] | undefined;
}

export interface CreateJournalNoteResponse {
    journalNoteId: string;
}

export interface GenerateSummaryForJournalNoteTranscriptionResponse {
    summary?: string | undefined;
    partialSummaryDetails?: MissingPartialsInfo2 | undefined;
    summaryStatus: JournalNoteSummaryStatus;
}

export interface UpdateJournalReportCommentResponse {
    journalReportId: string;
}

export interface GetCitizenIdByJobReferralIdResponse {
    citizenId: string;
}

export interface GetJobReferralResponse {
    jobReferralViewModel?: JobReferralViewModel | undefined;
}

export interface GetJobReferralsResponse {
    jobReferralViewModel?: JobReferralListItemViewModel[] | undefined;
}

export interface CreateJobReferralResponse {
    jobReferralId: string;
}

export interface CitizenAllowJobReferralsResponse {
    allowJobReferrals: boolean;
}

export interface GetCompanyRecruitmentForJobReferralResponse {
    companyRecruitmentLookupDetailsViewModel?: CompanyRecruitmentLookUpDetailsViewModel | undefined;
}

export interface GetCompanyRecruitmentsByLookupQueryResponse {
    companyRecruitments?: CompanyRecruitmentLookupViewModel[] | undefined;
}

export interface GetCompanyContactPersonsByCompanyIdForJobReferralResponse {
    contactPersons?: ContactPersonViewModel[] | undefined;
}

export interface GetJobReferralCodeListDataResponse {
    offerTypes?: OfferTypeCodeListDto2[] | undefined;
}

export interface GetTargetGroupCodeByCitizenIdResponse {
    targetGroupCode?: string | undefined;
}

export interface CreateCredentialsResponse {
    username?: string | undefined;
    password?: string | undefined;
}

export interface GetChangeJobcenterDataResponse {
    changeJobcenterViewModel?: ChangeJobcenterViewModel | undefined;
}

export interface GetActiveEnrollmentResponse {
    enrollmentModel?: EnrollmentViewModel | undefined;
}

export interface GetEnrollmentByIdResponse {
    enrollmentId: string;
    enrollmentDate: Date | string;
    clientCategoryType?: string | undefined;
    currentUnemploymentStatusType?: string | undefined;
    citizenEmail?: string | undefined;
    isEnrollmentConfirmed?: boolean | undefined;
    removalDate?: Date | string | undefined;
    removalCauseType?: string | undefined;
}

export interface GetEnrollmentCancellationDataResponse {
    removalCauseTypes?: EnrollmentRemovalCauseItem[] | undefined;
}

export interface GetEnrollmentCreationDataResponse {
    dfdgProfessions?: DfdgProfession2[] | undefined;
    selectableDfdgProfessions?: DfdgProfession2[] | undefined;
    selectableClientCategoryTypes?: ClientCategoryType2[] | undefined;
    selectableCurrentUnemploymentStatusTypes?: EnrollmentCurrentUnemploymentStatusType[] | undefined;
    emailAddress?: string | undefined;
}

export interface GetEnrollmentsForCitizenResponse {
    enrollmentCvJobSearchViewModels?: EnrollmentCvJobSearchViewModel[] | undefined;
}

export interface GetCitizenIdByContactGroupIdResponse {
    citizenId: string;
}

export interface GetContactGroupCreateDataResponse {
    contactGroupList?: ContactGroupItem[] | undefined;
    contactGroup?: ContactGroupEditingModel | undefined;
}

export interface GetContactGroupEditViewDataResponse {
    contactGroupList?: ContactGroupItem[] | undefined;
    contactGroup?: ContactGroupEditingModel | undefined;
    isEditable: boolean;
}

export interface GetContactGroupsForCitizenResponse {
    contactGroupCitizenDetailsViewModels?: ContactGroupCitizenDetailsViewModel[] | undefined;
}

export interface CompleteBookingResponse {
    recoverableError?: CompleteBookingRecoverableError | undefined;
}

export interface CreateCvAttachmentResponse {
    createdAttachment?: DocumentArchiveDocument | undefined;
}

export interface CreatePersonCategoryResponse {
    success: boolean;
    messageIdentifier: string;
}

export interface EvaluateSummaryResponse {
    value?: string | undefined;
}

export interface MassReassignBookingsResponse {
    enqueuedCount: number;
}

export interface SetBookingResponse {
    bookingId?: string | undefined;
    hasMedComHandlingFailed: boolean;
}

export interface SetInterviewResponse {
    interviewId: string;
}

export interface SetInterviewBookingDeadlineResponse {
    interviewDeadlineIdentifier: string;
    success: boolean;
}

export interface TranscriptionSummaryResponse {
    value?: string | undefined;
}

export interface UpdateBookingResponse {
    hasMedComHandlingFailed: boolean;
}

export interface UpdateInterviewResponse {
    updateInterview?: UpdateInterviewResponse2 | undefined;
}

export interface UpdateInterviewDeadlineResponse {
    success: boolean;
}

export interface GetActiveBookingsForCaseResponse {
    bookings?: BookingForCaseV2ViewModel[] | undefined;
}

export interface GetAttachmentSettingsResponse2 {
    attachmentSettings?: AttachmentSettings | undefined;
}

export interface GetBookingResponse {
    booking?: BookingViewModel | undefined;
}

export interface GetBookingLetterEditableContentResponse {
    content?: string | undefined;
}

export interface GetBookingsByCitizenIdResponse {
    bookings?: BookingForSchedule[] | undefined;
}

export interface GetBookingsForCitizenResponse {
    bookings?: BookingTableRowViewModel[] | undefined;
}

export interface GetBookingsForNuphResponse {
    bookings?: BookingForNuphViewModel[] | undefined;
}

export interface GetBookInterviewGuideDataResponse {
    booking?: BookingViewModel | undefined;
    interviewTypes?: InterviewTypeUnion[] | undefined;
    interviewContactTypes?: KeyValuePairOfSamtaleformTypeAndCodeListItem[] | undefined;
    selfBookedInterviewType?: KeyValuePairOfInterviewTypeAndCodeListItem | undefined;
    caseworker?: CaseworkerModel | undefined;
    meetingLocationDetails?: MeetingLocationDetails | undefined;
    interviewBookingConfigurations?: InterviewBookingConfigurationV2[] | undefined;
    interviewExemptions?: InterviewExemption[] | undefined;
    nextBookingDate: Date | string;
    futureBookings?: Booking[] | undefined;
    citizenCompanies?: InterviewCompanyModel[] | undefined;
    citizenInfo?: ICitizenInfo | undefined;
    company?: InterviewCompanyModel | undefined;
    companyContactPersons?: CompanyContactPersonModel[] | undefined;
    privateContactPerson?: PrivateContactPersonModel | undefined;
    targetGroupCode?: string | undefined;
    templateType?: TemplateListItemViewModel | undefined;
    outgoingDocumentTypes?: InterviewOutgoingDocumentTypeModel[] | undefined;
    defaultOutgoingDocumentType?: InterviewOutgoingDocumentTypeModel | undefined;
}

export interface GetCancellationCauseTypesResponse {
    cancellationCauseTypes?: KeyValuePairOfCancellationCauseTypeAndCodeListItem[] | undefined;
}

export interface GetCaseworkerMeetingLocationDetailsResponse {
    meetingLocationDetails?: MeetingLocationDetails | undefined;
}

export interface GetCompaniesResponse {
    companies?: InterviewCompanyModel[] | undefined;
}

export interface GetConductInterviewGuideDataResponse {
    interview?: InterviewViewModel | undefined;
    targetGroupId: string;
    hasVisitationCategory: boolean;
    canGetPersonCategory: boolean;
    dialogSupportEnabled: boolean;
}

export interface GetContactPersonsForCompanyResponse {
    contactPersons?: CompanyContactPersonModel[] | undefined;
}

export interface GetCrowdBookingGuideDataResponse {
    citizens?: CitizenBasic[] | undefined;
    targetGroupCodes?: string[] | undefined;
    interviewTypes?: InterviewTypeUnion[] | undefined;
    interviewFormTypes?: KeyValuePairOfInterviewFormTypeAndCrowdBookingCodeListItem[] | undefined;
    contactTypes?: KeyValuePairOfSamtaleformTypeAndCrowdBookingCodeListItem[] | undefined;
    recipientEnvelopeAddress?: RecipientEnvelopeAddress | undefined;
}

export interface GetCurrentPersonCategoryResponse {
    currentPersonCategory?: number | undefined;
    currentPersonCategoryType?: PersonCategoryType | undefined;
}

export interface GetDialogSupportInterviewConfigurationResponse {
    isJournalNoteSummaryEnabled: boolean;
}

export interface GetDialogSupportPromptsResponse {
    dialogSupportPrompts?: DialogSupportPrompts | undefined;
}

export interface GetDocumentsForAliasesFromDocumentArchiveResponse {
    attachments?: DocumentArchiveDocument[] | undefined;
}

export interface GetDocumentsFromDocumentArchiveResponse {
    attachments?: DocumentArchiveDocument[] | undefined;
}

export interface GetInterpreterDataForConductingInterviewResponse {
    isInterpreterSupportedByInterviewType: boolean;
    isInterpreterNeeded: boolean;
    interpreterLanguageId?: string | undefined;
    languages?: Language[] | undefined;
    interpreterContactForms?: InterpreterContactForm[] | undefined;
    digitalInterpreterContactFormId?: string | undefined;
}

export interface GetInterviewResponse {
    interviewIsSent: boolean;
    interview?: InterviewViewModel | undefined;
    caseName?: string | undefined;
    caseStartDate?: Date | string | undefined;
    caseEndDate?: Date | string | undefined;
}

export interface GetInterviewAgreementTemplateResponse {
    interviewAgreementTemplate?: string | undefined;
}

export interface GetInterviewBookingDeadlineResponse {
    activationDate?: Date | string | undefined;
    deadlineDate?: Date | string | undefined;
    deadlineStatus?: InterviewDeadlineStatusType | undefined;
    deadlineStatusText?: string | undefined;
    interviewTypeUnion?: InterviewTypeUnion | undefined;
    targetGroupId?: string | undefined;
}

export interface GetInterviewContactTypesResponse {
    interviewContactTypes?: KeyValuePairOfSamtaleformTypeAndCodeListItem[] | undefined;
}

export interface GetInterviewCorrectableStatusResponse {
    response?: GetInterviewCorrectableStatusResponse2 | undefined;
}

export interface GetInterviewOverviewStatResponse {
    targetGroupId: string;
    getGetInterviewOverviewStatResponse?: GetInterviewOverviewStatResponse2 | undefined;
    getInterviewCitizenStatistics?: GetInterviewCitizenStatisticsResponse | undefined;
}

export interface GetInterviewsForCitizenResponse {
    interviews?: InterviewDisplayViewModel[] | undefined;
}

export interface GetInterviewSummaryResponse {
    isDagpengemodtager: boolean;
    periods?: InterviewSummaryPeriods | undefined;
    details?: InterviewSummaryDetails | undefined;
    unemploymentDetails?: InterviewSummaryUnemployment | undefined;
}

export interface GetInterviewTypesForTargetGroupResponse {
    interviewTypeUnions?: InterviewTypeUnion[] | undefined;
}

export interface GetInterviewUnemploymentForCitizenResponse {
    interviews?: ConductedInterview[] | undefined;
    bookings?: PlannedInterview[] | undefined;
}

export interface GetMedComVdxSettingsResponse {
    medComVdxMeetingSettings?: MedComVdxMeetingSettings | undefined;
}

export interface GetNextInterviewDataResponse {
    nextInterviewTypeUnion?: InterviewTypeUnion | undefined;
    interviewTypeUnions?: InterviewTypeUnion[] | undefined;
    daysOffset?: number | undefined;
    isBookingDeadlineEnabled: boolean;
    isReminderEnabled: boolean;
    taskConfigurationName?: string | undefined;
    interviewContactTypes?: KeyValuePairOfSamtaleformTypeAndCodeListItem[] | undefined;
    nextBookingDate: Date | string;
    nextSelfBookingDate: Date | string;
    nextSelfBookingActivation: Date | string;
    lastInterviewTime?: Date | string | undefined;
}

export interface GetOverviewMenuActionDataResponse {
    canGetPersonCategory: boolean;
    canGetInterviewType: boolean;
    hasVisitationCategory: boolean;
    targetGroupId?: string | undefined;
    primaryCaseInfo?: PrimaryCaseInfo | undefined;
    interviewPreparationInfo?: InterviewPreparationInfo | undefined;
}

export interface GetPersonCategoryGuideDataResponse {
    currentPersonCategory?: number | undefined;
    possiblePersonCategories?: PersonCategoryConfigurationType[] | undefined;
    isCitizenEnrolled: boolean;
}

export interface GetPreviousInterviewAgreementResponse {
    agreement?: string | undefined;
    caseworkerDisplayName?: string | undefined;
    createdOn?: Date | string | undefined;
}

export interface GetPrivateContactPersonsResponse {
    privateContactPersons?: PrivateContactPersonModel[] | undefined;
}

export interface GetRankedCasesForInterviewJournalizationResponse {
    cases?: RankedCaseInfo[] | undefined;
}

export interface GetStandardAttachmentDocumentsFromArchiveResponse {
    attachments?: DocumentArchiveDocument[] | undefined;
}

export interface GetTranscriptionBySessionIdResponse {
    sessionId?: string | undefined;
    overallStatus?: string | undefined;
    totalCount: number;
    fullTranscription?: string | undefined;
    partials?: PartialTranscriptionDto[] | undefined;
}

export interface IsCitizenCprActiveResponse {
    isActive: boolean;
}

export interface IsCitizenInTargetGroupResponse {
    isCitizenInTargetGroup: boolean;
    canHaveInterviewBookingDeadline: boolean;
}

export interface RecalculateInterviewOverviewResponse {
    message?: string | undefined;
}

export interface CreateGrantResponse {
    grant?: GrantDto | undefined;
}

export interface DeleteGrantResponse {
    grant?: GrantDto | undefined;
}

export interface ExtendGrantResponse {
    grant?: GrantDto | undefined;
}

export interface TerminateGrantResponse {
    grant?: GrantDto | undefined;
    terminatedActivities?: TerminatedActivityDto[] | undefined;
}

export interface UpdateGrantResponse {
    grant?: GrantDto | undefined;
}

export interface GetBenefitFFBTypesResponse {
    benefitTypes?: BenefitTypeFFB[] | undefined;
}

export interface GetBenefitTypesResponse {
    benefitTypesFfb?: BenefitTypeFFB[] | undefined;
    benefitTypesDst?: BenefitTypeDST[] | undefined;
}

export interface GetCasesForGrantResponse {
    cases?: GrantCaseModel[] | undefined;
}

export interface GetCitizenIdByGrantIdResponse {
    citizenId: string;
}

export interface GetGrantByIdResponse {
    grant?: GrantDto | undefined;
}

export interface GetGrantsByCaseIdResponse {
    grants?: CaseGrantModel[] | undefined;
}

export interface GetGrantTypesResponse {
    grantTypes?: GrantTypeModel[] | undefined;
}

export interface GetOfferByIdForGrantSelectionResponse {
    offer?: OfferForGrantSelectionModel | undefined;
}

export interface GetOffersForGrantSelectionResponse {
    offers?: OfferForGrantSelectionModel[] | undefined;
}

export interface GetEducationEventsByCitizenIdResponse {
    educationEvents?: DfdgEducationEvent[] | undefined;
}

export interface GetEducationSubscriptionByCitizenIdResponse {
    educationSubscription?: EducationSubscription | undefined;
}

export interface GetDiaryNoteResponse {
    diaryNote: DiaryNoteModel;
}

export interface GetDiaryNotesForCitizenIdResponse {
    diaryNotes?: DiaryNoteModel[] | undefined;
    countResponse?: DiaryNoteCountResponse | undefined;
    filterResponse?: DiaryNoteFilterResponse | undefined;
}

export interface HasUnreadDiaryNotesResponse {
    message?: string | undefined;
}

export interface CreateDiaryNoteResponse {
    diaryNoteId: string;
}

export interface GenerateSummaryForDiaryNoteTranscriptionResponse {
    summary?: string | undefined;
    partialSummaryDetails?: MissingPartialsInfo3 | undefined;
    summaryStatus: DiaryNoteSummaryStatus;
}

export interface GetCitizenMessageByIdResponse {
    message?: CitizenMessageModel | undefined;
}

export interface GetCitizenMessagesResponse {
    messages?: CitizenMessageModel[] | undefined;
}

export interface GetUnemploymentFundMessagesResponse {
    messages?: CitizenMessageModel[] | undefined;
}

export interface GetCandidateReferralsByCitizenIdResponse {
    candidates?: CandidateReferralViewModel[] | undefined;
}

export interface GetCitizenCvBasicResponse {
    jobTargets?: string[] | undefined;
    cvAvailabilityType?: CvAvailabilityType | undefined;
    cvAvailabilityText?: string | undefined;
    cvStatusType?: CvStatusType | undefined;
    cvStatusTypeText?: string | undefined;
}

export interface GetCitizenCvJobTargetsResponse {
    jobTargets?: string[] | undefined;
}

export interface GetCitizenCvStatusResponse {
    cvAvailabilityType: CvAvailabilityType;
    cvAvailabilityText?: string | undefined;
    cvStatusType?: CvStatusType | undefined;
    cvStatusTypeText?: string | undefined;
}

export interface GetCitizenCvStatusInfoResponse {
    statusInformation?: CvStatusInformation | undefined;
}

export interface GetCitizenExemptionResponse {
    citizenExemptionOverview?: CitizenExemptionOverview | undefined;
}

export interface GetCitizenIdResponse {
    citizenId: string;
}

export interface GetCitizenJobMatchLinkResponse {
    url?: string | undefined;
}

export interface CompleteCounselingInquiryWithCaseResponse {
    caseId: string;
    rulingId?: string | undefined;
    grantId?: string | undefined;
    activityId?: string | undefined;
    assignmentId?: string | undefined;
}

export interface CreateCounselingInquiryForCitizenResponse {
    counselingInquiryId: string;
}

export interface GetActiveSocialCasesForCounselingInquiryResponse {
    cases?: CounselingInquiryExistingSocialCase[] | undefined;
}

export interface GetCompletedCounselingInquiriesForServiceProviderResponse {
    counselingInquiries?: CounselingInquiryListItemModel[] | undefined;
}

export interface GetCompletedCounselingInquiryForServiceProviderResponse {
    id: string;
    completedOn?: Date | string | undefined;
    content?: CounselingInquiryContent | undefined;
    recommendedGrantTypeName?: string | undefined;
}

export interface GetCounselingInquiriesForCitizenResponse {
    counselingInquiries?: CounselingInquiryListItemModel[] | undefined;
}

export interface GetCounselingInquiryForCitizenResponse {
    counselingInquiry?: CounselingInquiryDto | undefined;
}

export interface GetCounselingInquiryCaseDefaultsResponse {
    caseContactReasonName?: string | undefined;
    responsibleTeamId?: string | undefined;
}

export interface GetSocialCaseTypesForCounselingInquiryResponse {
    caseTypes?: CaseTypeModel[] | undefined;
}

export interface GetTemporaryHomeSupportOptionsResponse {
    grantTypeId?: string | undefined;
    grantTypeName?: string | undefined;
    sendsAssignment: boolean;
    offer?: TemporaryHomeSupportOffer | undefined;
    offerProblem?: string | undefined;
}

export interface GetTemporaryHomeSupportReuseForCaseResponse {
    reusesGrant: boolean;
    reusesActivity: boolean;
    reusesAssignment: boolean;
}

export interface CreateCvAttachmentResponse2 {
    createdAttachment?: DocumentArchiveDocument | undefined;
}

export interface SendLetterToCitizenResponse {
    response?: string | undefined;
}

export interface SendLetterToCitizenAsMedicalCollaboratorResponse {
    response?: string | undefined;
}

export interface SendLetterToCitizenAsServiceProviderResponse {
    response?: string | undefined;
}

export interface SendLetterToCompanyResponse {
    response?: string | undefined;
}

export interface SendLetterToCompanyAsMedicalCollaboratorResponse {
    response?: string | undefined;
}

export interface SendLetterToCompanyAsServiceProviderResponse {
    response?: string | undefined;
}

export interface SendLetterToMultipleRecipientsResponse {
    response?: string | undefined;
}

export interface SendLetterToMultipleRecipientsAsMedicalCollaboratorResponse {
    response?: string | undefined;
}

export interface SendLetterToMultipleRecipientsAsServiceProviderResponse {
    response?: string | undefined;
}

export interface SendLetterToPrivatePersonResponse {
    response?: string | undefined;
}

export interface SendLetterToPrivatePersonAsMedicalCollaboratorResponse {
    response?: string | undefined;
}

export interface SendLetterToPrivatePersonAsServiceProviderResponse {
    response?: string | undefined;
}

export interface SendLetterToSupplierPlatformResponse {
    response?: string | undefined;
}

export interface UploadFileAttachmentResponse {
    documentId: string;
    title?: string | undefined;
    fileName?: string | undefined;
    mimeType?: string | undefined;
    fileSize: number;
    blobReference?: string | undefined;
    owner?: string | undefined;
}

export interface FillLetterUserInputsResponse {
    fields?: LetterFillField[] | undefined;
}

export interface GetAttachmentSettingsResponse3 {
    disableLocalFileAttachment: boolean;
    standardBilagEnabled: boolean;
    crmHost?: string | undefined;
}

export interface GetCitizenCasesResponse2 {
    citizenCases?: CitizenCase[] | undefined;
}

export interface GetCitizenCompaniesResponse {
    companies: CompanyListItemViewModel[];
}

export interface GetCitizenCompaniesForLookupResponse {
    companies: CompanyModel[];
}

export interface GetCitizenInfoResponse {
    citizenInfo?: CitizenInfo | undefined;
}

export interface GetCitizenPrivateContactPersonsResponse {
    privateContactPersons: PrivateContactPersonListItemViewModel[];
}

export interface GetCitizensPrimaryOrLatestCaseResponse {
    citizenCase?: CitizenCase | undefined;
}

export interface GetCompaniesResponse2 {
    companies: CompanyListItemViewModel[];
}

export interface GetCompanyResponse {
    company: CompanyListItemViewModel;
}

export interface GetCompanyContactPersonsResponse2 {
    contactPersons?: CompanyContactPersonListItemViewModel[] | undefined;
}

export interface GetCaseworkersResponse {
    userIdentifier: string;
    caseWorkerFullName?: string | undefined;
    userEmail?: string | undefined;
    phone?: string | undefined;
    teamName?: string | undefined;
    teamId?: string | undefined;
}

export interface GetDocumentsForAliasesFromDocumentArchiveResponse2 {
    attachments?: DocumentArchiveDocument[] | undefined;
}

export interface GetDocumentsFromDocumentArchiveResponse2 {
    attachments?: DocumentArchiveDocument[] | undefined;
}

export interface GetEditableContentForPdfFormsResponse {
    content?: string | undefined;
    untypedVariables?: string | undefined;
    mainTeamId?: string | undefined;
    templateId: number;
    variantId?: number | undefined;
}

export interface GetHeaderResponse {
    response?: string | undefined;
}

export interface GetIsPrivateContactPersonCprEmptyResponse {
    isCprEmpty: boolean;
}

export interface GetMedicalRequestPdfFormLinkResponse {
    url?: string | undefined;
}

export interface GetOutgoingDocumentTypesResponse3 {
    outgoingDocumentTypes: OutgoingDocumentTypeViewModel2[];
}

export interface GetPdfFormResponse {
    pdfForms?: PdfFormModel[] | undefined;
}

export interface GetPdfFormActivityResponse {
    pdfForms?: PdfFormModel[] | undefined;
}

export interface GetPdfFormActivityLinkResponse {
    url?: string | undefined;
}

export interface GetPdfFormLinkResponse {
    url?: string | undefined;
}

export interface GetPdfFormSubmittedResponse {
    pdfForms?: PdfFormAttachmentModel[] | undefined;
}

export interface GetPrivateContactPersonsResponse2 {
    privateContactPersons: PrivateContactPersonListItemViewModel[];
}

export interface GetServiceProviderUnitsForCurrentUserResponse {
    serviceProviderUnits?: SocialProviderUnitDto2[] | undefined;
}

export interface GetStandardAppendixResponse {
    attachments?: StandardAppendixModel[] | undefined;
}

export interface GetStandardAttachmentDocumentsFromArchiveResponse2 {
    attachments?: DocumentArchiveDocument[] | undefined;
}

export interface GetStandardAttachmentsResponse {
    attachmentModel?: AttachmentModel[] | undefined;
}

export interface GetSystemUserUrlResponse {
    url?: string | undefined;
}

export interface GetUserOutgoingDocumentTypeResponse {
    outgoingDocumentType?: OutgoingDocumentTypeViewModel2 | undefined;
}

export interface SyncCitizenInformationResponse {
    informationUpdated: boolean;
}

export interface CanViewCitizenIncomeFromDatabaseResponse {
    canView: boolean;
}

export interface GetAuthorityCitizenContextResponse {
    context?: AuthorityCitizenContext | undefined;
}

export interface GetByCprResponse {
    statusCode: number;
    response?: string | undefined;
}

export interface GetByIdsResponse {
    citizens?: CitizenDto[] | undefined;
}

export interface GetCitizenDfdgWarningInfoResponse {
    citizenBelongsToOtherJobcenterAndMunicipality: boolean;
    existsInDfdg: boolean;
}

export interface GetCitizenDueDatesResponse {
    dueDates?: DueDateItem[] | undefined;
}

export interface GetCitizenHeaderResponse {
    citizenHeader?: CitizenHeader | undefined;
}

export interface GetCitizenOverviewSummaryResponse {
    openEnrollmentCategory?: string | undefined;
    targetGroupId?: string | undefined;
    latestInterview?: LatestInterviewViewModel | undefined;
    interviewDeadlineDate?: Date | string | undefined;
    latestCompanyActivity?: LatestCompanyActivityViewModel | undefined;
    latestDeliveryChannelName?: string | undefined;
    sicknessBenefit?: SicknessBenefitViewModel | undefined;
    grossBenefitWeeks?: number | undefined;
    citizenExemptions?: CitizenExemptionsViewModel | undefined;
    resumedWork?: ResumedWorkModel | undefined;
    absence?: AvailabilityAbsenceModel | undefined;
    caseDetails?: CaseSummaryDetailsModel | undefined;
    personGroupMarkings?: PersonGroupMarkingSummaryViewModel[] | undefined;
    isMissingEnrollmentWarning?: boolean | undefined;
    isMissingInterviewDeadlineDateWarning?: boolean | undefined;
}

export interface GetCrmCitizenOverviewUrlResponse {
    url?: string | undefined;
}

export interface GetExternalOperatorReferralTeamIdByCitizenIdResponse {
    externalOperatorTeamId?: string | undefined;
}

export interface GetMedicalCollaboratorCitizenContextResponse {
    context?: SocialProviderCitizenContext | undefined;
}

export interface GetMedicalCollaboratorCitizenHeaderResponse {
    citizenHeader?: SocialProviderCitizenHeader | undefined;
}

export interface GetOrAddCitizenResponse {
    citizenId?: string | undefined;
}

export interface GetRestrictedFromPrimaryCaseResponse {
    isRestrictedFromPrimaryCase: boolean;
}

export interface GetSocialProviderCitizenContextResponse {
    context?: SocialProviderCitizenContext | undefined;
}

export interface GetSocialProviderCitizenHeaderResponse {
    citizenHeader?: SocialProviderCitizenHeader | undefined;
}

export interface IsCurrentUserSchultzUserResponse {
    isSchultzUser: boolean;
}

export interface CreateClarificationRightResponse {
    clarificationRightId: string;
}

export interface GetClarificationRightByIdResponse {
    clarificationRight?: ClarificationRightListModel | undefined;
}

export interface GetClarificationRightsListResponse {
    clarificationRights?: ClarificationRightListModel[] | undefined;
}

export interface GetCitizenTaskResponse {
    task?: CitizenTask | undefined;
}

export interface JournalizeCitizenTaskOnCitizenResponse {
    externalReferenceIdForJournalNote: string;
}

export interface JournalizeCitizenTaskOnCompanyResponse {
    companyNoteId: string;
}

export interface GetCitizenCasesResponse3 {
    citizenCases?: CitizenCase2[] | undefined;
}

export interface GetCitizenTaskCreationDataResponse {
    activeCaseId?: string | undefined;
    caseworkerTeamId?: string | undefined;
    taskCategories?: TaskCategory[] | undefined;
}

export interface GetCitizenTasksMetaDataResponse {
    citizenTasksMetaData?: CitizenTaskMetaData[] | undefined;
}

export interface GetCitizenIdFromPersonGroupMarkingIdResponse {
    citizenId?: string | undefined;
}

export interface GetPersonGroupMarkingsForCitizenResponse {
    personGroups?: PersonGroupMarkingViewModel[] | undefined;
}

export interface GetPersonGroupMarkingStatisticsResponse {
    personGroupMarkingStatistics?: PersonGroupMarkingStatisticsViewModel | undefined;
}

export interface GetPersonGroupsResponse {
    isNationalTagsFeatureEnabled: boolean;
    isInterviewPreparationFeatureEnabled: boolean;
    personGroups?: PersonGroupViewModel[] | undefined;
}

export interface GetParticularitiesDataResponse {
    familyMembers?: FamilyMemberViewModel[] | undefined;
    personNotificationSettings?: PersonNotificationSettingsViewModel[] | undefined;
}

export interface SyncMissingCitizenPersonContactsResponse {
    synchronizingStarted: boolean;
}

export interface VerifyAndSyncCitizenPersonContactWithDfdgResponse {
    dfdgSyncPerformed: boolean;
}

export interface GetCitizenIdForCitizenPersonContactResponse {
    citizenId?: string | undefined;
}

export interface GetCitizenPersonContactsForOverviewResponse {
    citizenPersonContactViewModels?: CitizenPersonContactViewModel[] | undefined;
}

export interface GetCitizenPersonContactsForPrivateContactPersonResponse {
    citizenPersonContactViewModels?: CitizenPersonContactViewModel[] | undefined;
}

export interface GetEditableCitizenPersonContactResponse {
    citizenPersonContactEditModel?: CitizenPersonContactEditModel | undefined;
}

export interface GetPersonContactTypesResponse {
    personContactTypes?: PersonContactType[] | undefined;
    personContactTypesAvailableForJobnet?: PersonContactType[] | undefined;
}

export interface CreateCitizenCommentResponse {
    createdComment?: CitizenCommentModel | undefined;
}

export interface SaveCaveInformationResponse {
    caveInformation?: string | undefined;
}

export interface GetCaveInformationByCitizenIdResponse {
    caveInformation?: string | undefined;
}

export interface GetCitizenAddressHistoryResponse {
    adresses?: CitizenAddressHistoryViewModel[] | undefined;
}

export interface GetCitizenCommentsResponse {
    comments?: CitizenCommentModel[] | undefined;
}

export interface GetCitizenCoreListsResponse {
    languages?: NativeLanguage[] | undefined;
    readWriteMathTestReasons?: ReasonForReadWriteMathTest[] | undefined;
}

export interface GetCitizenCoreViewModelByCitizenIdResponse {
    citizenCoreViewModel?: CitizenCoreViewModel | undefined;
}

export interface GetNotesForCitizenResponse {
    notes?: NotesViewModel | undefined;
}

export interface GetTemporaryAddressGuideDataResponse {
    temporaryAddress?: ContactInfoTemporaryAddressViewModel | undefined;
    countries?: ContactInfoCountryViewModel[] | undefined;
}

export interface CloseCaseResponse {
    caseId: string;
}

export interface CreateAndTerminateCaseResponse {
    caseId?: string | undefined;
    letterGeneratorFailed: boolean;
    automaticInformationLetterName?: string | undefined;
}

export interface CreateAssociatedCaseWorkerResponse {
    associatedCaseWorkerId: string;
}

export interface UpdateAssociatedCaseWorkerOnCasesResponse {
    inActiveCasesCount: number;
}

export interface CreateCaseResponse {
    caseId?: string | undefined;
    letterGeneratorFailed: boolean;
    automaticInformationLetterName?: string | undefined;
}

export interface DocumentRehabSendToDfdgResponse {
    success: boolean;
}

export interface GenerateAutomaticLetterByIdResponse {
    letterId?: string | undefined;
    didLetterCreationFailed: boolean;
}

export interface ReassignCasesResponse {
    success: boolean;
}

export interface ReassignCasesSyncroneResponse {
    success: boolean;
}

export interface ReassignCaseworkerOnCaseResponse {
    success: boolean;
}

export interface ReopenCaseResponse {
    caseId: string;
    letterGeneratorFailed: boolean;
    automaticInformationLetterName?: string | undefined;
}

export interface SaveSicknessBenefitVisitationResponse {
    visitationId: string;
    outcome: SaveSicknessBenefitVisitationOutcome;
}

export interface UpdateAssociatedCaseWorkerResponse {
    associatedCaseWorkerId: string;
}

export interface UpdateCaseResponse {
    caseModel?: CaseModel | undefined;
}

export interface UpdateCaseRehabStatusResponse {
    rehabilitationProcessId?: string | undefined;
    rehabilitationProcessStatus?: number | undefined;
}

export interface UpdateRehabCaseResponse {
    caseId?: string | undefined;
    dfdgErrorInfo?: DfdgErrorInfo | undefined;
}

export interface GetActiveSicknessAbsenceByCitizenIdResponse2 {
    hasSicknessAbsence: boolean;
}

export interface GetAssociatedCaseWorkerResponse {
    associatedCaseWorker?: AssociatedCaseWorkerModel | undefined;
}

export interface GetAssociateUserRolesResponse {
    associateUserRoles?: AssociateUserRole[] | undefined;
}

export interface GetAssociateUsersByCaseIdResponse {
    associateUsers?: AssociateUser[] | undefined;
}

export interface GetCaseDetailsByIdResponse {
    case?: CaseModel | undefined;
}

export interface GetCaseClosureReasonsResponse {
    caseClosureReasons?: CaseClosureReason[] | undefined;
}

export interface GetCaseClosureReasonsFilterOnCaseTypeResponse {
    caseClosureReasons?: CaseClosureReason[] | undefined;
}

export interface GetCaseContactReasonsResponse {
    caseContactReasons?: CaseContactReason[] | undefined;
}

export interface GetCaseContactReasonsFilterOnCaseTypeResponse {
    caseContactReasons?: CaseContactReason[] | undefined;
}

export interface GetCaseGroupsResponse {
    caseGroups?: CaseGroup[] | undefined;
}

export interface GetCaseGroupsFilterOnCaseTypeResponse {
    caseGroups?: CaseGroup[] | undefined;
}

export interface GetCaseInfoForLinkResponse {
    caseTypeId?: string | undefined;
    targetGroupId?: string | undefined;
    caseId?: string | undefined;
    citizenId?: string | undefined;
}

export interface GetCaseRestrictionOptionsResponse {
    caseRestrictionOptions?: CaseRestriction[] | undefined;
}

export interface GetCasesResponse {
    cases?: CasesListViewModel[] | undefined;
}

export interface GetCaseTypeByCaseIdResponse {
    caseType?: CaseTypeModel | undefined;
}

export interface GetCaseTypeByIdResponse {
    caseType?: CaseTypeModel | undefined;
}

export interface GetCaseTypesByTargetGroupIdResponse {
    caseTypes?: CaseTypeModel[] | undefined;
}

export interface GetCaseTypesForCreateCaseResponse {
    activeCaseTypes?: CaseTypeModel[] | undefined;
}

export interface GetCaseTypeValidationValuesResponse {
    caseTypeValidationValues?: CaseValidationValues | undefined;
}

export interface GetEffortGroupByIdResponse {
    effortGroup?: EffortGroup | undefined;
}

export interface GetHasActiveAbsenceByCitizenIdResponse {
    hasActiveAbsence: boolean;
}

export interface GetHasActiveContactPersonResponse {
    hasActiveContactPerson: boolean;
}

export interface GetHasActiveEnrollmentsResponse {
    hasActiveEnrollments: boolean;
}

export interface GetHasActivitiesByCitizenIdResponse {
    hasActivities: boolean;
}

export interface GetHasContactGroupDiscrepancyResponse {
    hasContactGroupDiscrepancy: boolean;
}

export interface GetHasHistoricRegistrationResponse {
    hasHistoricRegistration: boolean;
}

export interface GetInterviewCalculationsStartDateConfigurationResponse {
    interviewCalculationsStartDateConfiguration?: InterviewCalculationsStartDateConfigurationModel | undefined;
}

export interface GetMinAndMAxDateFromCasesResponse {
    minStartDate: Date | string;
    maxEndDate?: Date | string | undefined;
}

export interface GetMostRelevantSocialCaseResponse {
    caseId?: string | undefined;
}

export interface GetMunicipalitiesResponse3 {
    municipalities?: Municipality[] | undefined;
}

export interface GetOpenCasesResponse {
    cases?: CaseModelSimple[] | undefined;
}

export interface GetPayingAndResponsibleMunicipalityInfoResponse {
    responsibleMunicipalityId?: string | undefined;
    responsibleMunicipalityComment?: string | undefined;
    payingMunicipalityId?: string | undefined;
    payingMunicipalityComment?: string | undefined;
}

export interface GetPersonCategoryNameByIdResponse {
    personCategoryName?: string | undefined;
}

export interface GetPrimaryCaseSummaryBoxDataResponse {
    content?: PrimaryCaseContent | undefined;
}

export interface GetRehabilitationProcessStatusTypesResponse {
    rehabilitationProcessStatusTypes?: RehabilitationProcessStatusTypeModel[] | undefined;
}

export interface GetRemovalCauseTypeResponse {
    removalCauseTypes?: RemovalCauseType2[] | undefined;
}

export interface GetSdpCaseDetailsByCitizenIdResponse {
    diagnosis?: string | undefined;
    description?: string | undefined;
    treatment?: string | undefined;
    specialistDoctor?: string | undefined;
}

export interface GetSelfScreeningResponse {
    selfScreening?: SelfScreeningModel | undefined;
}

export interface GetSicknessBenefitOptionsResponse {
    hearingTypes?: HearingType[] | undefined;
}

export interface GetSicknessBenefitVisitationResponse {
    visitation?: SicknessBenefitVisitationModel | undefined;
}

export interface GetTargetGroupByCaseIdResponse {
    targetGroupId?: string | undefined;
}

export interface HasAnyActiveCasesResponse {
    hasAnyActiveCases: boolean;
}

export interface HasAnyOpenRehabCasesResponse {
    hasAnyOpenRehabCases: boolean;
}

export interface HasAnyOpenSicknessBenifitOrJobClarificationCasesResponse {
    hasAnyOpenSicknessBenifitOrJobClarificationCases: boolean;
}

export interface CreateAbsenceResponse {
    absenceId: string;
}

export interface CreateAssessmentResponse {
    assessmentId: string;
}

export interface CreateIllnessResponse {
    absenceId: string;
}

export interface CreateNegativeEventResponse {
    negativeEventId: string;
}

export interface GetAbsenceResponse {
    absence?: AvailabilityAbsenceModel | undefined;
}

export interface GetAbsenceCauseTypesFilteredByAbsenceTypeResponse {
    absenceCauseTypes?: AbsenceCauseType[] | undefined;
}

export interface GetAbsenceHistoryResponse {
    absenceHistoryItems?: AbsenceHistoryModel[] | undefined;
}

export interface GetAbsencesResponse {
    absences?: AbsenceViewModel[] | undefined;
}

export interface GetAbsencesSimpleByCitizenIdResponse {
    absences?: AbsenceSimpleModel[] | undefined;
}

export interface GetAbsenceTypesFilteredByCitizensContractGroupAndVisitationCategoryResponse {
    absenceTypes?: AbsenceType[] | undefined;
}

export interface GetAbsenceUrlResponse {
    absenceUrl?: string | undefined;
}

export interface GetAssessmentCaseWorkerCommentTemplateResponse {
    caseWorkerCommentTemplate?: string | undefined;
}

export interface GetAssessmentDetailsResponse {
    assessment?: AssessmentDetailsModel | undefined;
}

export interface GetAssessmentsResponse {
    assessments?: AssessmentViewModel[] | undefined;
}

export interface GetAssessmentUrlResponse {
    assessmentUrl?: string | undefined;
}

export interface GetAvailabilityOverviewResponse {
    allowNegativeEvent: boolean;
    allowCreateAbsence: boolean;
    availabilityOverview?: AvailabilityOverviewModel | undefined;
}

export interface GetCaseRelatedIllnessAbsencesResponse {
    absences?: AbsenceViewModel[] | undefined;
}

export interface GetCitizenHealthLimitationResponse {
    healthLimitation?: HealthLimitationViewUpdateModel | undefined;
}

export interface GetCitizenHealthLimitationsResponse {
    healthLimitations?: HealthLimitationViewUpdateModel[] | undefined;
}

export interface GetCompanyContactPersonsResponse3 {
    companyContactPersons?: CompanyContactPersonModel2[] | undefined;
}

export interface GetEventTypesResponse {
    eventTypes?: EventType[] | undefined;
}

export interface GetNegativeEventResponse {
    negativeEvent?: NegativeEventViewModel | undefined;
}

export interface GetNegativeEventsResponse {
    negativeEvents?: NegativeEventViewModel[] | undefined;
}

export interface GetNegativeEventsForAssessmentResponse {
    negativeEvents?: NegativeEventForAssessmentModel[] | undefined;
}

export interface GetNegativeEventUrlResponse {
    negativeEventUrl?: string | undefined;
}

export interface GetPrimaryCaseWorkerResponse {
    primaryCaseWorkerId?: string | undefined;
}

export interface GetPrivateContactPersonsResponse3 {
    privateContactPersons?: PrivateContactPersonModel2[] | undefined;
}

export interface GetReasonableCauseTypesResponse {
    reasonableCauseTypes?: ReasonableCauseType[] | undefined;
}

export interface GetRelatedNegativeEventsResponse {
    negativeEvents?: NegativeEventForAssessmentModel[] | undefined;
}

export interface GetServiceConfigurationResponse {
    value?: any | undefined;
}

export interface GetUnemploymentStatusesResponse {
    unemploymentStatuses?: CodeListItem8[] | undefined;
}

export interface GetAsylumCvFilesResponse {
    cvFiles?: CvFiles | undefined;
}

export interface GetAsylumDataResponse {
    integrationInfo?: IntegrationInfoDto | undefined;
    danishTestSetting?: DanishTestSettingDto | undefined;
    danishTestResult?: DanishTestResultDto | undefined;
    danishTestRemark?: string | undefined;
    educationData?: EducationDataDto | undefined;
    educationFollowUp?: EducationFollowUpDto | undefined;
    educationRemark?: string | undefined;
    employmentStart?: EmploymentStartDto | undefined;
    employmentFollowUp?: EmploymentFollowUpDto | undefined;
    employmentRemark?: string | undefined;
}

export interface GetBasicSubsidyReportResponse {
    basicSubsidyReportCsv?: string | undefined;
    subsidyForUnaccompaniedFugitiveReportCsv?: string | undefined;
    affectCitizenIds?: string[] | undefined;
}

export interface GetBasicSubsidyReportDefaultParamsResponse {
    year: number;
    month: number;
    highSubsidyStartDate: Date | string;
    basicSubsidyRate: number;
    basicSubsidyRateForUnaccompanied: number;
    highSubsidyRate: number;
    highSubsidyEndDate: Date | string;
}

export interface GetDfdgTransitionResponse {
    dfdgTransition?: DfdgTransition | undefined;
}

export interface GetMunicipalityListResponse {
    municipalityList?: MunicipalityItem[] | undefined;
}

export interface GetOverviewResponse {
    hasOrdinaryCv: boolean;
    hasCv: boolean;
    hasLegalContract: boolean;
    transitionInfo?: TransitionDto | undefined;
}

export interface GetResultSubsidyReportResponse {
    reportCsv?: string | undefined;
    affectedCitizenIds?: string[] | undefined;
}

export interface GetResultSubsidyReportDefaultParamsResponse {
    year: number;
    month: number;
    subsidyRateForEmploymentHigh: number;
    subsidyRateForEducationHigh: number;
    subsidyRateForEducation: number;
    subsidyRateForEmployment: number;
    subsidyRateForDanishEducation: number;
}

export interface CopyAssessmentInterventionObjectivesResponse {
    createdInterventionObjectiveIds?: InterventionObjectiveId[] | undefined;
}

export interface CopyAssignmentResponse {
    newAssignmentId?: AssignmentId | undefined;
}

export interface CopyCurrentAssignmentResponse {
    newAssignmentId?: AssignmentId | undefined;
}

export interface CreateAssignmentResponse {
    assignmentId?: AssignmentId | undefined;
}

export interface CreateInterventionObjectiveResponse {
    interventionObjectiveId?: InterventionObjectiveId2 | undefined;
}

export interface EndCurrentAssignmentsForActivityResponse {
    endedAssignmentIds?: AssignmentId[] | undefined;
}

export interface GetAssignmentResponse {
    assignment?: AssignmentModel | undefined;
}

export interface GetAssignmentCountsPerServiceProviderUnitResponse {
    serviceProviderUnitAssignmentCounts?: ServiceProviderUnitAssignmentCount[] | undefined;
}

export interface GetAssignmentHtmlResponse {
    html?: string | undefined;
}

export interface GetAssignmentIdFromInterventionObjectiveIdResponse {
    assignmentId?: AssignmentId2 | undefined;
}

export interface GetAssignmentsForActivityResponse {
    assignments?: AssignmentModel[] | undefined;
}

export interface GetAssignmentsForCaseResponse {
    assignments?: CaseAssignmentModel[] | undefined;
}

export interface GetDraftAssignmentForActivityResponse {
    draftAssignmentId?: AssignmentId | undefined;
}

export interface GetGrantTypeOfferCombinationsForCompanyResponse {
    combinations?: GrantTypeOfferCombinationModel[] | undefined;
}

export interface GetInitialAssignmentDataResponse {
    assignment?: InitialAssignmentModel | undefined;
}

export interface GetInterventionObjectiveResponse {
    interventionObjective?: InterventionObjectiveModel | undefined;
}

export interface GetInterventionObjectivesByAssignmentIdResponse {
    interventionObjectives?: InterventionObjectiveModel[] | undefined;
}

export interface GetJournalNoteAttachmentIdByStatusNoteIdResponse {
    journalNoteAttachmentId?: string | undefined;
}

export interface GetServiceProviderAssignmentsForCitizenResponse {
    assignments?: AssignmentListModel[] | undefined;
}

export interface GetServiceProviderByPartialObjectiveIdResponse {
    serviceProviderUnitId?: string | undefined;
}

export interface GetServiceProviderByStatusNoteIdResponse {
    serviceProviderUnitId?: string | undefined;
}

export interface GetServiceProviderLookupAssignmentsResponse {
    assignments?: AssignmentLookupModel[] | undefined;
}

export interface GetServiceProviderObjectiveInfoResponse {
    assignments?: AssignmentListModel2[] | undefined;
    interventionObjectives?: InterventionObjectiveModel[] | undefined;
    partialObjectives?: PartialObjectiveModel[] | undefined;
    partialObjectiveFollowups?: PartialObjectiveFollowupModel[] | undefined;
}

export interface GetServiceProviderPartialObjectiveResponse {
    title?: string | undefined;
    description?: string | undefined;
    status: PartialObjectiveStatusType;
    methodType?: string | undefined;
    interventionObjectiveTitle?: string | undefined;
    interventionObjectiveDescription?: string | undefined;
}

export interface GetSocialProviderUnitResponse {
    serviceProviderUnit?: ServiceProviderUnitModel | undefined;
}

export interface GetServiceProviderUnitsResponse {
    serviceProviderUnits?: ServiceProviderUnitModel[] | undefined;
}

export interface GetSharedSupportAssessmentResponse {
    assessment?: SupportAssessmentDto | undefined;
    interventionObjectives?: AssessmentInterventionObjectiveModel[] | undefined;
}

export interface RewriteAssignmentForProviderResponse {
    medicalDiagnoses?: string | undefined;
    specialInformationAboutCitizen?: string | undefined;
    guardianDetails?: string | undefined;
    powersOfAttorney?: string | undefined;
    descriptionOfOtherInterventions?: string | undefined;
    agreementsBetweenCitizenAndRelatives?: string | undefined;
    assessmentSummary?: string | undefined;
    citizenSupportNeedsAssessment?: string | undefined;
    citizenPerspective?: string | undefined;
    citizenResources?: string | undefined;
    challengesAndNeeds?: string | undefined;
    citizenFutureAspirations?: string | undefined;
    effortPurpose?: string | undefined;
}

export interface CopyAssessmentResponse {
    newAssessmentId: string;
}

export interface CopyCurrentAssessmentResponse {
    newAssessmentId: string;
}

export interface CreateAssessmentInterventionObjectiveResponse {
    assessmentInterventionObjectiveId: string;
}

export interface CreateAssessmentInterventionObjectiveForDraftResponse {
    assessmentInterventionObjectiveId: string;
}

export interface FinalizeAssessmentResponse {
    assessment?: SupportAssessmentDto | undefined;
}

export interface FinalizeAssessmentVersionedResponse {
    assessment?: SupportAssessmentDto | undefined;
}

export interface ReopenAssessmentResponse {
    assessment?: SupportAssessmentDto | undefined;
}

export interface SaveAssessmentResponse {
    assessment?: SupportAssessmentDto | undefined;
}

export interface GetAssessmentByIdResponse {
    assessment?: SupportAssessmentDto | undefined;
}

export interface GetAssessmentGenerationFieldsResponse {
    fields?: AssessmentGenerationFieldDto[] | undefined;
}

export interface GetAssessmentInterventionObjectiveResponse {
    assessmentInterventionObjective?: AssessmentInterventionObjectiveModel | undefined;
}

export interface GetAssessmentInterventionObjectivesByAssessmentIdResponse {
    assessmentInterventionObjectives?: AssessmentInterventionObjectiveModel[] | undefined;
}

export interface GetAssessmentPromptDefaultsResponse {
    defaultSystemPrompt?: string | undefined;
    groups?: GroupPromptDefaultsDto[] | undefined;
}

export interface GetAssessmentsByCaseIdResponse {
    assessments?: CaseSupportAssessmentModel[] | undefined;
}

export interface GetAssessmentTranscriptionBySessionIdResponse {
    sessionId?: string | undefined;
    overallStatus?: string | undefined;
    totalCount: number;
    fullTranscription?: string | undefined;
    partials?: PartialAssesmentTranscriptionDto[] | undefined;
}

export interface GetBenefitFFBTypesResponse2 {
    benefitTypes?: BenefitTypeFFB[] | undefined;
}

export interface GetCurrentAssessmentInterventionObjectivesByActivityIdResponse {
    assessmentInterventionObjectives?: AssessmentInterventionObjectiveModel[] | undefined;
}

export interface GetDraftAssessmentForCaseResponse {
    draftAssessmentId?: string | undefined;
}

export interface GetFunctionalAbilityCatalogItemsResponse {
    functionalAbilityCatalogItems?: FunctionalAbilityCatalogItem[] | undefined;
}

export interface SaveAgendaForCitizenResponse {
    agendaId: string;
}

export interface GenerateAgendaForCitizenResponse {
    points: AgendaPointModel[];
    sourcesUsed: string[];
    dataGaps: AgendaDataGapModel[];
}

export interface GetAgendaOptionsResponse {
    dataSources: AgendaDataSourceModel[];
    plannedConversations: PlannedConversationModel[];
}

export interface GetSavedAgendaForCitizenResponse {
    agenda?: SavedAgendaModel | undefined;
}

export interface AddAttendanceRegistrationResponse {
    citizenAttendanceRegistrationIds?: CitizenAttendanceRegistrationId[] | undefined;
}

export interface RegisterNoShowsResponse {
    registrations?: NoShowRegistrationDto[] | undefined;
}

export interface GetCitizenLessonAttendancesByLessonIdResponse {
    citizenLessonAttendances?: CitizenLessonAttendanceModel[] | undefined;
    courseId: string;
    courseName?: string | undefined;
    lesson?: LessonDto | undefined;
    requiresApproval: boolean;
    restrictedCitizenCount: number;
}

export interface GetCoursesForAttendanceProtocolResponse {
    courses?: CourseOverviewDto[] | undefined;
}

export interface GetLessonsForAttendanceProtocolResponse {
    lessons?: LessonDto[] | undefined;
}

export interface AddAndRemoveCourseEducatorsCommandResponse {
    updatedCourseCount: number;
    updatedLessonCount: number;
    skippedCourses?: SkippedCourse[] | undefined;
}

export interface AddAndRemoveLessonEducatorsCommandResponse {
    updatedLessonCount: number;
    skippedLessons?: SkippedLesson[] | undefined;
}

export interface AttendanceImportResponse {
    validationErrors?: AttendanceValidationError[] | undefined;
}

export interface ChangeCourseClassroomCommandResponse {
    updatedCourseCount: number;
    updatedLessonCount: number;
    skippedCourses?: SkippedCourse[] | undefined;
}

export interface ChangeLessonClassroomCommandResponse {
    updatedLessonCount: number;
    skippedLessons?: SkippedLesson[] | undefined;
}

export interface CreateCitizenLessonDeviationResponse {
    lessonDeviationId: string;
}

export interface CreateCitizenScheduleLetterAttachmentResponse {
    documentId: string;
}

export interface CreateCourseEnrollmentResponse {
    courseEnrollmentId: string;
}

export interface CreateCourseEnrollmentsResponse {
    citizenActivityIdsErrors?: CitizenActivity[] | undefined;
}

export interface GenerateActivationKeyResponse {
    activationKey?: string | undefined;
}

export interface GenerateEducatorActivationKeyResponse {
    activationKey?: string | undefined;
    expiresAt: Date | string;
}

export interface AttendanceCsvParserResponse {
    citizens?: CitizenAttendanceDto[] | undefined;
    errors?: AttendanceParsingError[] | undefined;
}

export interface GetActiveCoursesResponse {
    courses?: CourseDtoEx[] | undefined;
}

export interface GetCitizenAttendanceNoteResponse {
    citizenAttendanceNote?: CitizenAttendanceNoteModel | undefined;
}

export interface GetCitizenAttendanceStatisticsResponse {
    from: Date | string;
    to: Date | string;
    citizenId: string;
    summary?: CitizenAttendanceStatisticsSummaryDto | undefined;
    lessons?: CitizenAttendanceStatisticsLessonModel[] | undefined;
}

export interface GetCitizenLessonByIdResponse {
    citizenLesson?: CitizenLessonDto | undefined;
}

export interface GetCitizenLessonDeviationByIdResponse {
    citizenLessonDeviationDto?: CitizenLessonDeviationDto | undefined;
}

export interface GetClassRoomByIdResponse {
    classroom?: ClassroomDto | undefined;
}

export interface GetClassRoomsResponse {
    classRooms?: ClassroomDtoEx[] | undefined;
}

export interface GetClassRoomsByCompanyIdResponse {
    classRooms?: ClassroomDto[] | undefined;
}

export interface GetCourseAttendanceStatisticsResponse {
    from: Date | string;
    to: Date | string;
    courseId: string;
    summary?: CitizenAttendanceStatisticsSummaryDto | undefined;
    lessons?: CourseAttendanceStatisticsLessonModel[] | undefined;
}

export interface GetCourseByIdResponse {
    course?: CourseDto | undefined;
}

export interface GetCourseDeletabilityResponse {
    hasLessons: boolean;
    hasCourseEnrollments: boolean;
}

export interface GetCourseEnrollmentByIdResponse {
    courseEnrollment?: CourseEnrollmentDto | undefined;
}

export interface GetCourseEnrollmentContextResponse {
    activities?: CourseEnrollmentActivityDto[] | undefined;
    isSubjectToWorkDuty: boolean;
}

export interface GetCourseEnrollmentsByCitizenIdResponse {
    courseEnrollments?: CourseEnrollmentListDto[] | undefined;
}

export interface GetCourseEnrollmentsByCourseIdResponse {
    courseEnrollments?: CourseEnrollmentDto[] | undefined;
}

export interface GetCourseEnrollmentLessonsByCitizenIdResponse {
    citizenName?: string | undefined;
    lessons?: CourseEnrollmentLessonDto[] | undefined;
    deviations?: CitizenLessonDeviationDto[] | undefined;
}

export interface GetCoursesResponse {
    courses?: CourseOverviewDto[] | undefined;
}

export interface GetCoursesByCompanyIdResponse {
    courses?: CourseListDtoEx[] | undefined;
}

export interface GetCoursesByOfferIdResponse {
    courses?: CourseListDtoEx[] | undefined;
}

export interface GetCoursesFromConnectResponse {
    courses?: ConnectCourse[] | undefined;
}

export interface GetEducatorByIdResponse {
    educator?: EducatorDto | undefined;
}

export interface GetEducatorIdByCourseEducatorIdResponse {
    educatorId?: string | undefined;
}

export interface GetEducatorIdByLessonEducatorIdResponse {
    educatorId?: string | undefined;
}

export interface GetEducatorsResponse {
    educators?: EducatorDtoEx[] | undefined;
}

export interface GetEducatorsByCompanyIdResponse {
    educators?: EducatorDto[] | undefined;
}

export interface GetIncludeFutureLessonsTenantConfigurationResponse {
    includeFutureLessons: boolean;
}

export interface GetLessonByIdResponse {
    lesson?: LessonDto | undefined;
}

export interface GetLessonsByCourseIdResponse {
    lessons?: LessonDto[] | undefined;
}

export interface GetLessonsDateRangeByOfferIdResponse {
    earliestLessonDate?: Date | string | undefined;
    latestLessonDate?: Date | string | undefined;
}

export interface GetLessonsWithoutFreeSeatsResponse {
    lessons?: LessonOccupancyDto[] | undefined;
}

export interface GetOccupiedDatesResponse {
    occupiedDates?: OccupiedDate[] | undefined;
    centerClosedDaysMissing: boolean;
}

export interface GetOfferPeriodByOfferIdResponse {
    startDate?: Date | string | undefined;
    endDate?: Date | string | undefined;
}

export interface GetRegistrationCounterByIdResponse {
    registrationCounter?: RegistrationCounterDetailsDto | undefined;
}

export interface GetRegistrationCountersResponse {
    registrationCounters?: RegistrationCounterListDtoEx[] | undefined;
}

export interface GetAiStandardQuestionsResponse {
    standardQuestions?: AiStandardQuestionDto[] | undefined;
}

export interface GetAvailableCitationContentTypesForFasitAssistantResponse {
    availableContentTypes?: CitationContentType[] | undefined;
}

export interface GetInterpretingAssistanceCitizenGuideResponse {
    guide?: string | undefined;
    guideToReadAloud?: string | undefined;
    languageCode?: string | undefined;
    guideInDanish?: string | undefined;
}

export interface GetInterpretingRecognitionHintsResponse {
    hints?: string[] | undefined;
}

export interface GetLanguageAssistResponse {
    value?: LanguageAssistResult | undefined;
}

export interface GetSmartGoalSuggestionResponse {
    suggestedText?: string | undefined;
    criteria?: SmartGoalCriterion[] | undefined;
}

export interface GetSummaPreviewModelResponse {
    model?: string | undefined;
    displayName?: string | undefined;
}

export interface GetSupportedLanguagesResponse {
    languages?: LanguageInfo[] | undefined;
}

export interface GetTranslateTokenResponse {
    token?: string | undefined;
    expiresIn: number;
    region?: string | undefined;
}

export interface GetTranslationReviewResponse {
    initialTranslationQualityScore: number;
    initialTranslationFeedback?: string | undefined;
    initialTranslationAssessmentPoints?: string[] | undefined;
    initialTranslationProblems?: TranslationProblem[] | undefined;
    correctedTranslation?: string | undefined;
    correctedTranslationToReadAloud?: string | undefined;
    backTranslation?: string | undefined;
    isUncertain: boolean;
}

export interface GetUserApprovedAiProductsResponse {
    approvedAiProducts?: string[] | undefined;
}

export interface RewriteLetterToneResponse {
    rewrittenHtml?: string | undefined;
}

export interface CreateCitizenDeletionOrderResponse {
    orderId: string;
}

export interface DeleteCitizenResponse {
    steps?: DeletionStepResult[] | undefined;
}

export interface DryRunDeleteCitizenResponse {
    steps?: DeletionStepResult[] | undefined;
    requiresArchivingAcknowledgement: boolean;
    preservationWorthyCaseTypes?: string[] | undefined;
}

export interface GetCitizenDeletionEligibilityResponse {
    hasActiveCases: boolean;
    activeCaseCount: number;
    lastCaseClosedDate?: Date | string | undefined;
    totalCasesCount: number;
    journalNoteCount: number;
    latestJournalNoteDate?: Date | string | undefined;
    hasRecentJournalNotes: boolean;
    undispatchedReceivablesCount: number;
    otherCprNumbers?: OtherCprInfo[] | undefined;
}

export interface GetCitizenDeletionOrderResponse {
    title?: string | undefined;
    description?: string | undefined;
    status: CitizenDeletionOrderStatus;
    worklistQuery?: string | undefined;
    createdByFullname?: string | undefined;
    createdOn: Date | string;
    modifiedByFullname?: string | undefined;
    modifiedOn?: Date | string | undefined;
    approvedByFullname?: string | undefined;
    approvedOn?: Date | string | undefined;
    isArchived: boolean;
    citizens?: CitizenDeletionOrderCitizen[] | undefined;
}

export interface GetCitizenDeletionOrdersResponse {
    orders?: CitizenDeletionOrderListItem[] | undefined;
}

export interface GetCitizenForDeletionResponse {
    citizen?: CitizenForDeletion | undefined;
}

export interface GetAreasResponse {
    areas: { [key: string]: string; };
}

export interface GetAuditLogsResponse extends GetAuditLogsResponse2 {
}

export interface GetJustificationWhitelistResponse {
    whitelistedUsers?: WhitelistedUser[] | undefined;
}

export interface GetOperationsResponse {
    operations: { [key: string]: string; };
}

export interface GetOrganizationalUnitsResponse {
    organizationalUnits?: OrganizationalUnit[] | undefined;
}

export interface CreateVisitationTeamResponse {
    visitationTeamId: string;
}

export interface GetVisitationTeamDetailsResponse {
    visitationTeam: VisitationTeamDetails;
}

export interface GetVisitationTeamsInitialDataResponse {
    selectableTeams: SelectableTeam[];
    grantTypes: SelectableGrantType[];
}

export interface GetVisitationTeamsListResponse {
    visitationTeams: VisitationTeamListItem[];
}

export interface GetEditableUserResponse {
    editableUserDto?: EditableUserDto | undefined;
}

export interface GetExternalOperatorCompaniesForEditUserResponse {
    externalOperatorCompanies?: ExternalOperatorCompanyViewModel[] | undefined;
}

export interface GetUserAtaTimeResponse {
    weeklyAtaMinutes?: number | undefined;
}

export interface ListUsersResponse {
    users?: UserDto[] | undefined;
    totalCount: number;
}

export interface GetSelectableRolesResponse {
    selectableRoles?: UserProfileRoleViewModel[] | undefined;
}

export interface GetUserProfilesResponse {
    userProfiles?: UserProfileViewModel[] | undefined;
}

export interface DeactivateQuestionnaireResponse {
    closedSurveys: number;
}

export interface GetQuestionnaireDetailsResponse {
    questionnaireDetails?: QuestionnaireDetails | undefined;
    hasSurveys: boolean;
    numberOfOpenSurveys: number;
}

export interface GetQuestionnaireInitialDataResponse {
    initialData?: QuestionnaireInitialData | undefined;
}

export interface GetQuestionnairesResponse {
    questionnaireListItems?: QuestionnaireListViewItem[] | undefined;
}

export interface GetSubJobcenterCodeListItemsResponse {
    subJobcenterCodeListItems?: GetSubJobcenterCodeListItem[] | undefined;
}

export interface GetSubJobcenterResponse {
    subJobcenter?: GetSubJobcenterDetailsViewModel | undefined;
}

export interface GetSubJobcentersResponse {
    subJobcenters?: GetSubJobcenterModel[] | undefined;
}

export interface CreateSubJobcenterResponse {
    id: string;
}

export interface CreateObservationTypeResponse {
    id: string;
}

export interface GetObservationTypesResponse {
    observationTypes?: ObservationTypeModel[] | undefined;
}

export interface CreateMethodTypeResponse {
    id: string;
}

export interface GetMethodTypesResponse {
    methodTypes?: MethodTypeViewModel[] | undefined;
}

export interface GetJournalNoteContentTypesResponse {
    journalNoteContentTypes?: JournalNoteContentTypeListModelV3[] | undefined;
}

export interface CreateInterviewTypeResponse {
    id: string;
}

export interface GetInterviewTypesResponse {
    interviewTypes?: InterviewTypeModel[] | undefined;
    journalNoteContentTypes?: JournalNoteContentTypeViewModel[] | undefined;
}

export interface GetGrantTypeDetailsResponse {
    grantTypeDetails?: GrantTypeDetails | undefined;
}

export interface GetGrantTypeOfferDetailsResponse {
    offerDetails?: GrantTypeOfferListViewItem[] | undefined;
}

export interface GetGrantTypesInitialDataResponse {
    initialData?: GrantTypesInitialData | undefined;
}

export interface GetGrantTypesListResponse {
    grantTypeListItems?: GrantTypeListViewItem[] | undefined;
}

export interface GetOffersListResponse {
    offerListItems?: OfferListViewItem[] | undefined;
}

export interface CreateCoPaymentDebitorRunResponse {
    coPaymentDebitorRun?: AdminCoPaymentDebitorRunModel | undefined;
}

export interface CreateFinanceTestReceiptResponse {
    dataFileName?: string | undefined;
}

export interface DeleteReceivablesResponse {
    deletedReceivableCount: number;
}

export interface TriggerFinanceReceiptPollResponse {
    handledCount: number;
}

export interface GetActiveCoPaymentCitizensResponse {
    citizens?: AdminCoPaymentCitizenModel[] | undefined;
}

export interface GetAdjustmentDetailsResponse {
    details?: AdminReceivableDetailsModel | undefined;
}

export interface GetCoPaymentDebitorRunResponse {
    coPaymentDebitorRun?: AdminCoPaymentDebitorRunModel | undefined;
}

export interface GetCoPaymentDebitorRunsResponse {
    coPaymentDebitorRuns?: AdminCoPaymentDebitorRunModel[] | undefined;
}

export interface GetCoPaymentDispatchOverviewResponse {
    readyForDispatchCount: number;
    failedDispatchCount: number;
    futureDispatchCount: number;
    allReceivablesCount: number;
    activeCoPaymentCount: number;
    coPaymentsWithMissingReceivablesCount: number;
    missingReceivableMonthsCount: number;
    citizens?: AdminCoPaymentCitizenModel[] | undefined;
}

export interface GetCoPaymentReceivablesByDispatchStateResponse {
    receivables?: AdminCoPaymentReceivableModel[] | undefined;
}

export interface GetCoPaymentsForOverviewResponse {
    coPayments?: AdminCoPaymentOverviewItemModel[] | undefined;
}

export interface GetDebitorRegistrationContentResponse {
    content?: AdminDebitorRegistrationContentModel | undefined;
}

export interface GetFinanceDeliveryContentResponse {
    content?: AdminFinanceDeliveryContentModel | undefined;
}

export interface GetFinanceDeliveryDataFileResponse {
    dataFileName?: string | undefined;
    dataFileContent?: string | undefined;
}

export interface GetReceivableDetailsResponse {
    details?: AdminReceivableDetailsModel | undefined;
}

export interface GetReceivableDispatchAttemptsResponse {
    attempts?: AdminDebitorRegistrationTransactionModel[] | undefined;
}

export interface ChangeAiStandardQuestionsStatusResponse {
    result: boolean;
}

export interface CreateAccountGroupsForAdminUiResponse {
    result: boolean;
}

export interface CreateAccountInteractionPurposesForAdminUiResponse {
    result: boolean;
}

export interface CreateAccountInteractionResultsForAdminUiResponse {
    result: boolean;
}

export interface CreateAccountSpecialCircumstancesTypesForAdminUiResponse {
    result: boolean;
}

export interface CreateAccountTagTypesForAdminUiResponse {
    result: boolean;
}

export interface CreateAiStandardQuestionForAdminUiResponse {
    result: boolean;
}

export interface CreateAssociateUserRoleResponse {
    result: boolean;
}

export interface CreateCaseClosureReasonResponse {
    result: boolean;
}

export interface CreateCaseGroupsForAdminUiResponse {
    result: boolean;
}

export interface CreateCaseRestrictionsForAdminUiResponse {
    result: boolean;
}

export interface CreateClosureCausesForAdminUiResponse {
    result: boolean;
}

export interface CreateCoPaymentTypeForAdminUiResponse {
    result: boolean;
}

export interface CreateExternalOperatorResponsibilityAreaResponse {
    result: boolean;
}

export interface CreateFollowUpRulesForAdminUiResponse {
    result: boolean;
}

export interface CreateOutgoingDocumentTypesForAdminUiResponse {
    result: boolean;
}

export interface CreatePlacementPurposeResponse {
    result: boolean;
}

export interface CreateReasonForReadWriteMathTestsForAdminUiResponse {
    result: boolean;
}

export interface CreateServiceTargetTypesForAdminUiResponse {
    result: boolean;
}

export interface CreateSocialProviderUnitResponse {
    result: boolean;
}

export interface CreateStandardPhraseResponse {
    standardPhraseId: string;
}

export interface UpdateAccountGroupResponse {
    result: boolean;
}

export interface UpdateAccountInteractionPurposeResponse {
    result: boolean;
}

export interface UpdateAccountInteractionResultResponse {
    result: boolean;
}

export interface UpdateAccountSpecialCircumstancesTypeResponse {
    result: boolean;
}

export interface UpdateAccountTagTypeResponse {
    result: boolean;
}

export interface UpdateAiStandardQuestionForAdminUiResponse {
    result: boolean;
}

export interface UpdateAiStandardQuestionResponse {
    result: boolean;
}

export interface UpdateCaseGroupResponse {
    result: boolean;
}

export interface UpdateCaseRestrictionsResponse {
    result: boolean;
}

export interface UpdateClosureCauseResponse {
    result: boolean;
}

export interface UpdateCoPaymentTypeForAdminUiResponse {
    result: boolean;
}

export interface UpdateExternalOperatorResponsibilityAreaResponse {
    result: boolean;
}

export interface UpdateFollowUpRulesForAdminUiResponse {
    result: boolean;
}

export interface UpdateOutgoingDocumentTypesForAdminUiResponse {
    result: boolean;
}

export interface UpdateReasonForReadWriteMathTestResponse {
    result: boolean;
}

export interface UpdateRecruitmentCollaborationResponse {
    result: boolean;
}

export interface UpdateRecruitmentRequestInformationTypeResponse {
    result: boolean;
}

export interface UpdateServiceTargetTypeResponse {
    result: boolean;
}

export interface UpdateSocialProviderUnitResponse {
    result: boolean;
}

export interface GetAccountGroupResponse {
    accountGroups?: AccountGroupModel[] | undefined;
}

export interface GetAccountInteractionPurposeResponse2 {
    accountInteractionPurposes?: AccountInteractionPurposeModel[] | undefined;
}

export interface GetAccountInteractionResultResponse {
    accountInteractionResults?: AccountInteractionResultModel[] | undefined;
}

export interface GetAccountSpecialCircumstancesTypeResponse {
    accountSpecialCircumstancesTypes?: AccountSpecialCircumstancesTypeModel[] | undefined;
}

export interface GetAccountTagTypeResponse {
    accountTagTypes?: AccountTagTypeModel[] | undefined;
}

export interface GetActivationTypeCodeListResponse {
    activationType?: ActivationTypeCodeListModel[] | undefined;
}

export interface GetAdminAbsenceTypesResponse {
    absenceTypes?: AdminAbsenceTypeModel[] | undefined;
}

export interface GetAiStandardQuestionsResponse2 {
    aiStandardQuestions?: AiStandardQuestionModel[] | undefined;
}

export interface GetAssociatedUserRolesResponse {
    associateUserRole?: AssociateUserRoleModel[] | undefined;
}

export interface GetAssociatedUserRolesCodeListResponse {
    associateUserRoles?: AssociateUserRoleCodeListModel[] | undefined;
}

export interface GetCaseClosureReasonsResponse2 {
    caseClosureReasons?: CaseClosureReasonModel[] | undefined;
}

export interface CaseContactReasonResponse {
    caseContactReason?: CaseContactReasonModel[] | undefined;
}

export interface GetCaseGroupResponse {
    caseGroups?: CaseGroupModel[] | undefined;
}

export interface GetCaseRestrictionsResponse {
    caseRestrictions?: AdminCaseRestrictionModel[] | undefined;
}

export interface GetCaseTypesResponse {
    caseTypes?: AdminCaseTypeModel[] | undefined;
    templates?: TemplateListItemViewModel[] | undefined;
    targetGroups?: AdminTargetGroupModel[] | undefined;
}

export interface GetClosureCauseResponse {
    closureCauses?: ClosureCauseModel[] | undefined;
}

export interface GetCoPaymentTypesResponse {
    coPaymentTypes?: AdminCoPaymentTypeModel[] | undefined;
}

export interface GetCourseTypeCodeListResponse {
    courseType?: CourseTypeCodeListModel[] | undefined;
}

export interface GetDebitorAccountTypesResponse {
    debitorAccountTypes?: DebitorAccountTypeOption[] | undefined;
}

export interface GetDocumentsFromDocumentArchiveResponse3 {
    attachments?: DocumentArchiveDocument[] | undefined;
}

export interface GetDocumentTemplatesByCategoryResponse {
    templates?: TemplateListItemViewModel[] | undefined;
}

export interface GetExternalOperatorResponsibilityAreasResponse {
    externalOperatorResponsibilityAreas?: ExternalOperatorResponsibilityAreaModel[] | undefined;
}

export interface GetFollowUpRulesForAdminUiResponse {
    followUpRules?: FollowUpRuleModel[] | undefined;
}

export interface GetGuideLinksResponse {
    targetGroups?: AdminTargetGroupModel[] | undefined;
    guideLinks?: AdminGuideLinkModel[] | undefined;
}

export interface GetJobcentersResponse2 {
    jobcenters?: JobcenterLookupModel[] | undefined;
}

export interface GetMetadataEntityConfigurationResponse {
    metadataEntityConfiguration?: MetadataEntityCodeListModel[] | undefined;
}

export interface GetOfferTypeCodeListResponse {
    offerTypes?: OfferTypeCodeListModel[] | undefined;
}

export interface GetOutgoingDocumentTypesForAdminUiResponse {
    outgoingDocumentTypes?: OutgoingDocumentTypeModel[] | undefined;
}

export interface GetPlacementPurposeResponse {
    placementPurporse?: PlacementPurposeModel[] | undefined;
}

export interface GetPlanTypesResponse {
    targetGroups?: AdminTargetGroupModel[] | undefined;
    dfdgPlanTypes?: DfdgPlanTypeModel[] | undefined;
    planTemplates?: TemplateListItemViewModel[] | undefined;
    planTypes?: AdminPlanTypeModel[] | undefined;
}

export interface GetPurposeOfCompanyInternshipTypeCodeListResponse {
    taskConfiguration?: PurposeOfCompanyInternshipTypeCodeListModel[] | undefined;
}

export interface GetReasonForReadWriteMathTestResponse {
    reasonForReadWriteMathTests?: ReasonForReadWriteMathTestModel[] | undefined;
}

export interface GetRecruitmentCollaborationsResponse2 {
    recruitmentCollaborations?: RecruitmentCollaborationModel[] | undefined;
}

export interface GetRecruitmentRequestInformationTypesResponse {
    recruitmentRequestInformationTypes?: RecruitmentRequestInformationTypeModel[] | undefined;
}

export interface GetRemovalCauseTypesResponse {
    removalCauseTypes?: RemovalCauseTypeLookupModel[] | undefined;
}

export interface GetResponsibilityAreaResponse {
    responsibilityArea?: ResponsibilityAreaModel[] | undefined;
}

export interface GetServiceTargetTypeResponse {
    serviceTargetTypes?: ServiceTargetTypeModel[] | undefined;
}

export interface GetSocialProviderUnitsResponse {
    socialProviderUnits?: SocialProviderUnitModel[] | undefined;
}

export interface GetStandardAppendixesResponse {
    standardAppendixes?: AdminStandardAppendixModel[] | undefined;
}

export interface GetStandardAppendixesForLookupResponse {
    standardAppendixes?: StandardAppendixLookupModel[] | undefined;
}

export interface GetStandardAppendixRulesResponse {
    standardAppendixRules?: StandardAppendixRuleModel[] | undefined;
}

export interface GetStandardPhrasesResponse {
    standardPhrases?: AdminStandardPhraseModel[] | undefined;
}

export interface GetTargetGroupCodeListResponse {
    targetGroup?: TargetGroupCodeListModel[] | undefined;
}

export interface GetTaskCategoryCodeListResponse {
    taskCategory?: TaskCategoryCodeListModel[] | undefined;
}

export interface GetTaskConfigurationResponse {
    taskConfiguration?: AdminTaskConfigurationModel[] | undefined;
}

export interface GetTaskConfigurationCodeListResponse {
    taskConfiguration?: TaskConfigurationCodeListModel[] | undefined;
}

export interface CreateGlossaryTermResponse {
    id: string;
}

export interface CreateMunicipalityAssistantDocumentResponse {
    id: string;
    success: boolean;
}

export interface DeleteMunicipalityAssistantDocumentResponse {
    success: boolean;
}

export interface SaveAssessmentPromptResponse {
    saved: boolean;
}

export interface UpdateMunicipalityAssistantDocumentResponse {
    success: boolean;
}

export interface UploadDraftMunicipalityDocumentResponse {
    contentReference: string;
    fileName: string;
    fileSize: number;
    mimeType: string;
    draftDocumentContentOwner: string;
}

export interface UpsertMunicipalityAssistantDocumentResponse {
    id: string;
    wasUpdated: boolean;
    success: boolean;
}

export interface CheckExistingMunicipalityDocumentFilesResponse {
    existingFileNames?: string[] | undefined;
    newFileNames?: string[] | undefined;
}

export interface GetAssessmentPromptsForAdminResponse {
    fields: AssessmentPromptForAdmin[];
}

export interface GetDialogSupportInstructionForAdminResponse {
    exists: boolean;
    targetGroupName?: string | undefined;
    interviewTypeName?: string | undefined;
    configurationId?: string | undefined;
    isJournalNoteSummaryDisabled: boolean;
    prompts?: DialogSupportInstructionPrompt[] | undefined;
    configurationMetadata?: DialogSupportConfigurationMetadata | undefined;
}

export interface GetDialogSupportPromptOptionsResponse {
    targetGroups?: DialogPromptTargetGroup[] | undefined;
    interviewTypes?: DialogPromptInterviewType[] | undefined;
}

export interface GetDialogSupportPromptsForAdminResponse {
    userDefinedPrompts?: UserDefinedPrompt[] | undefined;
    defaultPrompts?: DefaultPrompt[] | undefined;
    interviewConfigurations?: InterviewConfiguration[] | undefined;
}

export interface GetGlossaryForAdminResponse {
    defaultTerms?: DefaultTerm[] | undefined;
    municipalityTerms?: MunicipalityTerm[] | undefined;
}

export interface GetMunicipalityAssistantDocumentsResponse {
    documents?: MunicipalityAssistantDocumentModel[] | undefined;
}

export interface GetTransactionLogItemDetailsResponse {
    details?: TransactionLogItemDetails | undefined;
}

export interface SearchTransactionLogResponse {
    result?: SearchResponse | undefined;
}

export interface GetEnabledTenantAddonConfigurationsResponse {
    extraConfigurations?: TenantAddonConfigurationValue[] | undefined;
}

export interface GetEnabledTenantAddonsResponse {
    enabledTenantAddons?: string[] | undefined;
}

export interface GetResourceUtilizationResponse {
    serviceProviderUnits: ResourceUtilizationServiceProviderUnit[];
    offers: ResourceUtilizationOffer[];
    grantTypes: ResourceUtilizationGrantType[];
    employees: ResourceUtilizationEmployee[];
    capacities: ResourceUtilizationCapacity[];
    allocations: ResourceUtilizationAllocation[];
}

export interface AnalyzeServiceProviderUnitPatternsResponse {
    lookbackDays: number;
    analyzedCitizenIds: string[];
    patterns: UnitPatternModel[];
}

export interface GetServiceProviderUnitOverviewResponse {
    lookbackDays: number;
    canReadUseOfForce: boolean;
    canReadPartialObjectives: boolean;
    citizens: ServiceProviderUnitCitizenModel[];
}

export interface GetInterventionCostsResponse {
    step: number;
    years: number[];
    paragraphs: InterventionCostParagraphModel[];
    totals: InterventionCostYearModel[];
}

export interface GetInterventionLadderResponse {
    steps: InterventionLadderStepModel[];
    total: InterventionLadderTotalModel;
    from: Date | string;
    to: Date | string;
    currentYear: number;
}

export interface GetInterventionLengthsResponse {
    step: number;
    unit?: InterventionLengthUnit | undefined;
    years: number[];
    paragraphs: InterventionLengthParagraphModel[];
}

export interface GetTeamUsersByLookupQueryResponse {
    users?: UserViewModel[] | undefined;
}

export interface GetUserByIdResponse2 {
    user?: UserViewModel | undefined;
}

export interface GetUsersByLookupQueryResponse {
    users?: UserViewModel[] | undefined;
}

export interface GetTeamByIdResponse2 {
    team?: TeamViewModel | undefined;
}

export interface GetTeamsByLookupQueryResponse {
    teams?: TeamViewModel[] | undefined;
}

export interface GetOfferByIdResponse2 {
    offer?: OfferLookupDto | undefined;
}

export interface GetOfferLookupOptionsResponse {
    offers?: OfferLookupDto[] | undefined;
    hasMore: boolean;
}

export interface GetOffersByLookupQueryResponse {
    offers?: OfferLookupDto[] | undefined;
}

export interface GetOffersForOfferTypeByLookupQueryResponse {
    offers?: OfferForOfferTypeLookupDto[] | undefined;
}

export interface GetContactPersonByIdResponse {
    contactPerson?: ContactPersonViewModel2 | undefined;
}

export interface GetContactPersonsByLookupQueryResponse {
    contactPersons?: ContactPersonViewModel2[] | undefined;
}

export interface GetCompaniesByLookupQueryResponse {
    companies?: CompanyModel[] | undefined;
}

export interface GetCompanyByIdResponse {
    company?: CompanyLookupModel | undefined;
}

export interface GetCompanyByIdForLookupResponse {
    company?: CompanyModel | undefined;
}

export interface GetCitizenLookupByIdResponse {
    citizen?: CitizenLookup | undefined;
}

export interface GetCitizensByLookupQueryResponse {
    citizens?: CitizenLookup[] | undefined;
}

export interface GetCitizenCasesLookupResponse {
    citizenCases?: CitizenCaseLookup[] | undefined;
}

export interface GetAllFeatureTogglesResponse {
    featureToggles?: { [key: string]: boolean; } | undefined;
}

export interface ConfiguredResourceTypesResponse {
    resourceTypes?: string[] | undefined;
}

export interface DynamicLinksResponse {
    dynamicLinks?: DynamicLink[] | undefined;
    mergeData?: MergeData[] | undefined;
}

export interface GetPostRequestParametersResponse {
    municipalityCvr?: string | undefined;
    municipalityOrganisationCode?: string | undefined;
    citizenCpr?: string | undefined;
    primaryCaseId?: string | undefined;
    candenoPassword?: string | undefined;
}

export interface GetAvailabilityTenantPropertiesResponse {
    citizenAvailabilityAssessmentsLetter?: string | undefined;
    maxWaitTimeOnInputFromCitizenForSanctionRequestInDays?: string | undefined;
}

export interface GetCrmHostUrlResponse {
    url?: string | undefined;
}

export interface GetCrTenantPropertiesResponse {
    companyRecruitmentTargetGroupsEnabled: boolean;
    prefillFieldsOnRecruitmentRequestsEnabled: boolean;
}

export interface GetDfdgMaintenanceModeStatusResponse {
    isReadClosureActive: boolean;
    isWriteClosureActive: boolean;
    additionalInformation?: string | undefined;
}

export interface GetDteUrlResponse {
    dteUrl?: string | undefined;
}

export interface GetFormbricksSystemWideDisableStatusResponse {
    disabled: boolean;
}

export interface GetIsAiDemoEmailDomainAllowedResponse {
    isAllowed: boolean;
}

export interface GetOaTenantPropertiesResponse {
    periodic: boolean;
    copyPlacementButtonEnabledForVitas: boolean;
}

export interface GetSchultzCaseConfigurationResponse {
    schultzSagUrl?: string | undefined;
}

export interface GetSystemConfigurationResponse {
    messageCenterMessages?: MessageCenterConfigurationModel[] | undefined;
}

export interface GetTenantConfigurationResponse {
    tenantDisplayName?: string | undefined;
    tenantName?: string | undefined;
    crmUrl?: string | undefined;
    caseWeb?: string | undefined;
    organizationCode?: string | undefined;
    apexGetLegacyCasesCaseTypeId?: string[] | undefined;
    apexGetLegacyCasesNotTheseTargetGroups?: string[] | undefined;
    messageCenterMessages?: MessageCenterConfigurationModel[] | undefined;
    uddEnvTermsPopUp?: boolean | undefined;
    showAllWorklistDefaultCvSearch?: string | undefined;
    enabledAssigmentActivityOfferCategories?: number[] | undefined;
    socialCaseConfiguration?: SocialCaseConfiguration | undefined;
    rulingConfiguration?: RulingConfiguration | undefined;
    authorityCitizenOpticSelection?: AuthorityCitizenOpticSelection | undefined;
    formbricksConfiguration?: FormbricksConfiguration | undefined;
    serviceProviderCalendarBusinessHours?: ServiceProviderCalendarBusinessHours[] | undefined;
    relevantSocialContactPersonRoles?: string[] | undefined;
    assessmentAutoSaveIntervalInSeconds?: number | undefined;
    assessmentVersioningCutoffDate?: Date | string | undefined;
    aiAccessControlEnabled?: boolean | undefined;
    hasAiDemoEmailDomainWhitelist?: boolean | undefined;
}

export interface GetTenantDisplayNameResponse {
    tenantDisplayName?: string | undefined;
}

export interface GetAccountGroupsResponse {
    accountGroups?: AccountGroup[] | undefined;
}

export interface GetCompaniesBasicResponse {
    companyBasicInfos?: CompanyBasicInfo[] | undefined;
}

export interface GetCompanyAttentionNotesResponse {
    attentionNotes?: CompanyAttentionNoteModel[] | undefined;
}

export interface GetCompanyBasicResponse extends CompanyBasicInfo {
}

export interface GetCompanyIdByAssociatedCaseWorkerIdResponse {
    companyId?: string | undefined;
}

export interface GetCompanyIdByLabourNeedIdResponse {
    companyId?: string | undefined;
}

export interface GetCompanyCrmFeatureSettingResponse {
    isFeatureEnabled: boolean;
}

export interface GetFvdbContactsResponse {
    fvdbContacts?: FvdbContactModel[] | undefined;
}

export interface GetCompanyDetailsByIdResponse {
    id: string;
    cvrNumberIdentifier?: string | undefined;
    productionUnitIdentifier?: string | undefined;
    administrativeUnitRegistrationNumber?: string | undefined;
    companyName?: string | undefined;
    districtName?: string | undefined;
    postcodeIdentifier?: string | undefined;
    streetName?: string | undefined;
    streetBuildingIdentifier?: string | undefined;
    floorIdentifier?: string | undefined;
    suiteIdentifier?: string | undefined;
    municipalityName?: string | undefined;
    primaryTradeCodeName?: string | undefined;
    primaryTradeCodeGroupName?: string | undefined;
    establishedYear: number;
    numberOfEmployees: number;
    numberOfEmployeesByCvrNumber: number;
    emailAddress?: string | undefined;
    telephoneNumberIdentifier?: string | undefined;
    faxNumberIdentifier?: string | undefined;
    status?: string | undefined;
    isIrrelevant: boolean;
    lastUpdated?: Date | string | undefined;
    createdOn?: Date | string | undefined;
}

export interface GetCompanyNoteResponse {
    companyNote?: CompanyNoteModel | undefined;
}

export interface GetEmploymentOverviewResponse {
    summaryOfActivities?: MonthActivitySummaryModel[] | undefined;
    summaryOfRecruitments?: MonthRecruitmentSummaryModel[] | undefined;
    openOffersInCurrentMonth?: CurrentMonthOfferSummaryModel | undefined;
    currentMonthOpenJobOffersViewModel?: CurrentMonthOpenJobOffersViewModel | undefined;
}

export interface GetLabourNeedByIdResponse {
    id?: string | undefined;
    startdate?: Date | string | undefined;
    enddate?: Date | string | undefined;
    occupationId?: string | undefined;
    numberToFill?: number | undefined;
    jobcenterParticipationWanted?: boolean | undefined;
    statuscode: number;
    createdOn?: Date | string | undefined;
    occupationQualifications?: string[] | undefined;
    targetGroups?: string[] | undefined;
    tradeCodes?: string[] | undefined;
}

export interface GetLabourNeedsForCompanyResponse {
    labourNeedModels?: CompanyLabourNeedModel[] | undefined;
}

export interface GetLatestAccountNoteResponse {
    accountNote?: AccountNoteModel | undefined;
}

export interface GetNextAppointmentResponse {
    appointment?: AppointmentModel | undefined;
}

export interface GetNumberOfActiveSickLeaveAbsencesResponse {
    numberOfActiveSickLeaveAbsences: number;
}

export interface GetOccupationListResponse {
    occupations?: OccupationModel[] | undefined;
}

export interface GetOccupationQualificationsListResponse {
    occupationQualifications?: OccupationQualificationModel[] | undefined;
}

export interface GetPrimaryCompanyContactPersonResponse {
    primaryContactPersonId?: string | undefined;
}

export interface GetTargetGroupListResponse {
    targetGroups?: TargetGroupModel[] | undefined;
}

export interface GetTradeCodeListResponse {
    tradeCodes?: TradeCodeModel2[] | undefined;
}

export interface DeleteLabourNeedResponse {
    deleteSuccess: boolean;
}

export interface UpsertCompanyNoteResponse {
    companyId: string;
}

export interface UpsertLabourNeedsResponse {
    id: string;
}

export interface UpsertResponsibleCaseWorkerOrTeamResponse {
    companyIds?: string[] | undefined;
}

export interface GetCompanyVisitActivitiesResponse {
    activitiesOverview?: CompanyActivitiesOverviewModel | undefined;
}

export interface GetCompanyVisitCompanyInfoExtendedResponse {
    companyVisitCompanyInfoExtended?: CompanyVisitCompanyInfoExtendedModel | undefined;
}

export interface GetCompanyVisitRecruitmentsResponse {
    recruitmentsOverview?: CompanyRecruitmentOverviewModel | undefined;
}

export interface CompanyVisitPreparationHighlightOverviewResponse {
    companyContact?: CompanyContactModel | undefined;
    companyDetails?: CompanyDetailModel | undefined;
    cooperationAgreements?: CompanySpecialCircumstanceModel[] | undefined;
}

export interface GetNotesAndTasksOverviewResponse {
    notesAndTasks?: NoteAndTaskModel[] | undefined;
    configuration?: NotesAndTasksOverviewConfiguration | undefined;
}

export interface GetCompanyCrowdLetterTemplatesResponse {
    templates?: TemplateListCompanyItemViewModel[] | undefined;
}

export interface GetCompanyTemplatesResponse {
    templates?: TemplateListItemCompanyViewModel[] | undefined;
}

export interface GetEditableContentResponse {
    content?: string | undefined;
}

export interface GetCompanyChangeLogsByQueryResponse {
    changeLogs?: CompanyChangeLogQueryViewModel[] | undefined;
}

export interface GetCompanyPostTypesResponse {
    postTypes?: string[] | undefined;
}

export interface GetAbsencesForCompanyResponse {
    absences?: CompanyAbsenceViewModel[] | undefined;
}

export interface GetTimelineDataByCitizenIdResponse {
    timelineItems?: TimelineItem[] | undefined;
    years: number;
}

export interface GetForumFeedbackSurveysResponse {
    surveys?: ForumFeedbackSurveyViewModel[] | undefined;
}

export interface GetStandardPhrasesResponse2 {
    standardPhrases?: StandardPhraseModel[] | undefined;
}

export interface GetCitizenIdFromResumedWorkIdResponse {
    citizenId: string;
}

export interface GetResumedWorkByCaseIdResponse {
    resumedWorks?: ResumedWorkModel[] | undefined;
}

export interface GetSpLinkAvailabilityResponse {
    isAvailable: boolean;
    missingPrerequisites?: string[] | undefined;
}

export interface GetSpLinkUrlResponse {
    url?: string | undefined;
}

export interface GenerateSummaryForFollowupTranscriptionResponse {
    summary?: string | undefined;
    partialSummaryDetails?: MissingPartialsInfo | undefined;
    summaryStatus: FollowupSummaryStatus;
}

export interface GetActiveMethodTypesResponse2 {
    methodTypes?: MethodTypeModel2[] | undefined;
}

export interface GetActiveObservationTypesResponse {
    observationTypes?: ServiceProviderObservationTypeModel[] | undefined;
}

export interface GetObservationTypeResponse {
    observationType?: ServiceProviderObservationTypeModel2 | undefined;
}

export interface GetMedicinePackageDetailsResponse {
    details?: MedicinePackageDetailsViewModel | undefined;
}

export interface SearchMedicinePackagesResponse {
    packages?: MedicinePackageViewModel[] | undefined;
}

export interface GetCitizenIncomeResponse {
    income?: IncomeViewModel | undefined;
    errorMessage?: string | undefined;
}

export interface GetCitizenIncomeLiveDataResponse {
    income?: IncomeViewModel | undefined;
    errorMessage?: string | undefined;
}

export interface GetBenefitDecisionsForCitizenResponse {
    benefitViewModels?: BenefitViewModel[] | undefined;
}

export interface GetJoblogEntriesResponse {
    joblogEntryCollection?: JoblogEntryForOverview[] | undefined;
}

export interface GetJoblogEntryResponse {
    joblogEntry?: JoblogEntryForOverview | undefined;
    joblogDocuments?: JoblogDocumentMetadataForOverview[] | undefined;
}

export interface GetAbsenceOverviewResponse {
    currentAbsences?: AbsenceModel[] | undefined;
    currentExemptions?: ExemptionModel[] | undefined;
    negativeEvents?: NegativeEventModel[] | undefined;
    latestSicknessAbsences?: AbsenceModel[] | undefined;
    activitiesWithAbsences?: ActivityWithAbsenceModel[] | undefined;
    vacationAbsences?: VacationAbsenceModel[] | undefined;
    journalNotes?: JournalNoteModel2[] | undefined;
    configuration?: InterviewPreparationConfiguration | undefined;
}

export interface GetCvOverviewResponse {
    jobGoals?: JobGoalModel[] | undefined;
    useAdvancedJobGoalTemplate: boolean;
    suggestedQualifications?: SuggestedQualificationModel[] | undefined;
    educations?: EducationModel[] | undefined;
    hasCv: boolean;
    cvGaps?: CvGaps | undefined;
    cvUrl?: string | undefined;
}

export interface GetHeaderOverviewResponse {
    headerOverview?: HeaderInfoModel | undefined;
}

export interface GetHighlightOverviewResponse {
    rehabilitationInfo?: RehabilitationInfoModel | undefined;
    relatedPersonGroupMarkings?: string[] | undefined;
    statusForLatestJournalNoteSentToRemotePrint?: string | undefined;
    vacationAbsenceInfo?: VacationAbsenceInfoModel | undefined;
    hasMuchSicknessDuringPlacement: boolean;
    hasLongTermSickness: boolean;
    latestInstructionSentDate?: Date | string | undefined;
    educationPlanInfo?: CitizenEducationPlanModel | undefined;
    interpretationNeeds?: InterpretationNeedsModel | undefined;
    contactInfo?: ContactInfoModel | undefined;
    contactPersons?: ContactPersonModel[] | undefined;
}

export interface GetJobReadyCitizenProgressOverviewResponse {
    contactGroupShift: boolean;
    interviewStat?: InterviewStat | undefined;
    interviewStatUnemploymentBenefit?: InterviewStatUnemploymentBenefit | undefined;
    latestActivitiesForCurrentOpenCase?: LatestActivityModel[] | undefined;
    myPlan?: MyPlanModel | undefined;
    activeActivities?: ActivityModel[] | undefined;
    pastActivities?: ActivityModel[] | undefined;
    interviewAgreements?: InterviewAgreementModel[] | undefined;
    personGroupMarkings?: string[] | undefined;
}

export interface GetJobReadyInformationResponse {
    features?: JobReadyFeatureModel | undefined;
    jobSearch?: JobSearchModel | undefined;
    citizenProgress?: CitizenProgressSummaryModel | undefined;
    cv?: CvModel | undefined;
    absenceExemptions?: AbsenceExemptionsModel | undefined;
    journalNoteConfiguration?: JobReadyJournalNoteConfigurationModel | undefined;
    forumAppUsage?: ForumAppUsageModel | undefined;
    candidateReferrals?: CandidateReferralViewModel[] | undefined;
}

export interface GetJobReadySelfScreeningOverviewResponse {
    selfScreening?: SelfScreeningOverviewModel | undefined;
}

export interface GetJournalNotesResponse {
    journalNotes?: JournalNoteModel3[] | undefined;
}

export interface GetProgressOverviewResponse {
    caseInformation?: CaseDurationModel | undefined;
    latestContactGroupChanges?: ContactGroupChangeModel[] | undefined;
    sustenanceHistoryUrl?: string | undefined;
    cvUrl?: string | undefined;
    activePlan?: PlanModel | undefined;
    interviewStatisticsForCurrentCaseYear?: InterviewStatisticsModel | undefined;
    configuration?: InterviewPreparationConfiguration | undefined;
    placementsOverview?: PlacementsOverviewModel | undefined;
    interviewAgreements?: InterviewAgreementModel2 | undefined;
}

export interface GetCitizenProgressOverviewResponse {
    citizenProgress?: CitizenProgressViewModel | undefined;
}

export interface GetInformationFormResponse {
    informationForm?: InformationFormXmlModel | undefined;
    questionMap?: { [key: string]: string; } | undefined;
}

export interface GetMedicalJournalNotesResponse {
    medicalJournalNotes?: MedicalJournalNoteModel[] | undefined;
}

export interface GetPersonalConditionsResponse {
    personalConditions?: PersonalConditionsViewModel | undefined;
}

export interface GetSicknessBenefitCaseOverviewResponse {
    progressOverview?: SicknessBenefitCaseOverviewViewModel | undefined;
}

export interface GetGuideLinksResponse2 {
    hasGuideLinks: boolean;
    headLine?: string | undefined;
    guideLinks?: GuideLinkModel[] | undefined;
}

export interface GetCitizenFlowOverviewResponse {
    isEnabled: boolean;
    flows?: CitizenFlow[] | undefined;
    actionCount: number;
    nextFollowUpDate?: Date | string | undefined;
}

export interface GetCvSearchOptionsResponse {
    occupations?: CvSearchOption[] | undefined;
    qualifications?: CvSearchOption[] | undefined;
    educations?: CvSearchOption[] | undefined;
    languages?: CvSearchOption[] | undefined;
}

export interface GetMunicipalitiesResponse4 {
    municipalities?: CvSearchMunicipality[] | undefined;
}

export interface PerformCvSearchResponse {
    cvSearchResult?: CvSearchResultDto | undefined;
}

export interface GetActivityTemplatesResponse {
    templates?: TemplateListItemViewModel[] | undefined;
}

export interface GetCrowdLetterTemplatesResponse {
    templates?: TemplateListItemViewModel[] | undefined;
}

export interface GetCitizenInterviewBookingTemplatesResponse {
    templates?: TemplateListItemViewModel[] | undefined;
}

export interface GetCitizenInterviewCrowdBookingTemplatesResponse {
    templates?: TemplateListItemViewModel[] | undefined;
}

export interface GetCitizenTemplatesResponse {
    templates?: TemplateListItemViewModel[] | undefined;
}

export interface GetEditableContentResponse2 {
    content?: string | undefined;
}

export interface GetServiceProviderDocumentTemplatesResponse {
    templates?: TemplateListItemViewModel[] | undefined;
}

export interface GetServiceProviderLetterTemplatesResponse {
    templates?: TemplateListItemViewModel[] | undefined;
}

export interface GetTemplateByTemplateCodeResponse {
    templates?: TemplateListItemViewModel[] | undefined;
}

export interface GetTemplatesByCategoriesResponse {
    templates?: TemplateListItemViewModel[] | undefined;
}

export interface GetTemplatesByCategoryResponse {
    templates?: TemplateListItemViewModel[] | undefined;
}

export interface GetCitizenOverviewDataResponse {
    alertBox?: AlertBox | undefined;
    citizenOverviewBox?: CitizenOverviewBox | undefined;
    excemptionsBox?: ExcemptionsBox | undefined;
    dueDatesBox?: DueDatesBox | undefined;
    interviewBox?: InterviewBox | undefined;
    cvAndJobsearchBox?: CvAndJobsearchBox | undefined;
    unemploymentBenefitBox?: UnemploymentBenefitBox | undefined;
    primaryCaseBox?: PrimaryCaseBox | undefined;
    socialCasesBox?: SocialCasesBox | undefined;
    latestAssessmentBox?: LatestAssessmentBox | undefined;
    supplementaryCasesBox?: SupplementaryCasesBox | undefined;
    sicknessBenefitCaseBox?: SicknessBenefitCaseBox | undefined;
    planAndActivitiesBox?: PlanAndActivitiesBox | undefined;
    forumAppUsageBox?: ForumAppUsageBox | undefined;
    currentActivitiesBox?: CurrentActivitiesBox | undefined;
    currentSocialGrantsBox?: CurrentSocialGrantsBox | undefined;
    currentAssignmentsBox?: CurrentAssignmentsBox | undefined;
    relevantContactPersonsBox?: RelevantContactPersonsBox | undefined;
    targetGroupId?: string | undefined;
}

export interface GetCitizenOverviewDataForBeskaeftigelseResponse {
    alertBox?: AlertBox | undefined;
    citizenOverviewBox?: CitizenOverviewBox | undefined;
    excemptionsBox?: ExcemptionsBox | undefined;
    dueDatesBox?: DueDatesBox | undefined;
    interviewBox?: InterviewBox | undefined;
    cvAndJobsearchBox?: CvAndJobsearchBox | undefined;
    unemploymentBenefitBox?: UnemploymentBenefitBox | undefined;
    primaryCaseBox?: PrimaryCaseBox | undefined;
    supplementaryCasesBox?: SupplementaryCasesBox | undefined;
    sicknessBenefitCaseBox?: SicknessBenefitCaseBox | undefined;
    planAndActivitiesBox?: PlanAndActivitiesBox | undefined;
    forumAppUsageBox?: ForumAppUsageBox | undefined;
    currentActivitiesBox?: CurrentActivitiesBox | undefined;
    latestAssessmentBox?: LatestAssessmentBox | undefined;
    rulingsBox?: RulingsBox | undefined;
    targetGroupId?: string | undefined;
}

export interface GetCitizenOverviewDataForServiceProviderResponse {
    currentAssignmentsBox?: CurrentAssignmentsBox | undefined;
    relevantContactPersonsBox?: RelevantContactPersonsBox | undefined;
    casePrimaryCaseWorkers?: CasePrimaryCaseWorker[] | undefined;
    partialObjectivesBox?: PartialObjectivesBox | undefined;
}

export interface GetCitizenOverviewDataForSocialResponse {
    citizenOverviewBox?: CitizenOverviewBox | undefined;
    interviewBox?: InterviewBox | undefined;
    unemploymentBenefitBox?: UnemploymentBenefitBox | undefined;
    sicknessBenefitCaseBox?: SicknessBenefitCaseBox | undefined;
    forumAppUsageBox?: ForumAppUsageBox | undefined;
    currentActivitiesBox?: CurrentActivitiesBox | undefined;
    latestAssessmentBox?: LatestAssessmentBox | undefined;
    rulingsBox?: RulingsBox | undefined;
    socialCasesBox?: SocialCasesBox | undefined;
    currentSocialGrantsBox?: CurrentSocialGrantsBox | undefined;
    currentAssignmentsBox?: CurrentAssignmentsBox | undefined;
    relevantContactPersonsBox?: RelevantContactPersonsBox | undefined;
    targetGroupId?: string | undefined;
}

export interface GetSustenanceHistoryMonthResponse {
    citizenId: string;
    month: Date | string;
    sustenanceHistory?: DayViewModel[] | undefined;
}

export interface GetSustenanceHistoryYearResponse {
    years?: YearViewModel[] | undefined;
}

export interface GetDfdgHistoryResponse {
    columnHeaders?: ColumnHeaderModel[] | undefined;
    sortingColumn?: string | undefined;
    jsonSerializedDataRows?: string | undefined;
}

export interface GetDfdgHistoryNamesResponse {
    dfdgHistoryNames?: string[] | undefined;
}

export interface GetCitizenChangeLogsByQueryResponse {
    changeLogs?: CitizenChangeLogQueryViewModel[] | undefined;
}

export interface GetCitizenPostTypesResponse {
    postTypes?: string[] | undefined;
}

export interface GetAllowedActionsResponse {
    allowedActions?: ResourceAction[] | undefined;
}

export interface GetAuthorizationResultResponse {
    isAuthorized: boolean;
}

export interface GetSystemTestEndpointQueryUrlResponse {
    url?: string | undefined;
}

export interface GetRoleThemesResponse {
    roleThemes?: string[] | undefined;
}

export interface GetNotificationLogResponse {
    entries?: NotificationLogEntry[] | undefined;
    totalCount: number;
}

export interface GetNotificationLogSummaryResponse {
    sentCount: number;
    failedCount: number;
}

export interface GetConfigurationChangelogsResponse {
    configurationLogs?: ConfigurationChangeLogViewModel[] | undefined;
    numberOfLogs: number;
}

export interface GetConfigurationLogEntitiesResponse {
    entities?: string[] | undefined;
}

export interface Parameters {
}

export interface Parameters2 {
}

async function handleResponse<TResponse>(request: Promise<AxiosResponse<TResponse>>): Promise<TResponse> {
  const response = await request;

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }

  throw new Error(response.statusText);
}

async function handleFileResponse(request: Promise<AxiosResponse<any>>): Promise<FileResponse> {
  const response = await request;

  if (response.status == 200 || response.status == 206) {
    const headers = { ...response?.headers };
    const contentDisposition = headers['content-disposition'];
    const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
    const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
    return { fileName: fileName, status: response.status, data: response.data as Blob, headers: headers };
  }

  throw new Error(response.statusText);
}

async function handleStreamResponse(request: Promise<AxiosResponse<any>>): Promise<NdjsonStreamResponse> {
  const response = await request;

  if (response.status >= 200 && response.status < 300) {
    return { data: response.data as ReadableStream<Uint8Array>, status: response.status, headers: { ...response?.headers } };
  }

  throw new Error(response.statusText);
}

export interface NdjsonStreamResponse {
    data: ReadableStream<Uint8Array>;
    status: number;
    headers?: { [name: string]: any };
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

// END NOSONAR
